(function() {
	'use strict';

	angular
		.module('app.sub-broker-customer', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.sub-broker-customer', {
				url: '/sub-broker-customer',
				views: {
					'content@app': {
						templateUrl: 'app/main/customers/sub-broker-customer/sub-broker-customer.html',
						controller: 'subBrokerCustomerController as vm'
					}
				}
			})
			.state('app.sub-broker-customer.customerhome', {
				url: '/customerhome',
				views: {
					'content@app': {
						templateUrl: 'app/main/customers/sub-broker-customer/addCustomer-index.html',
						controller: 'CustomerIndexController as vm'
					}
				}
			})
			.state('app.sub-broker-customer.customerhome.sub-broker-add-customer', {
				url: '/sub-broker-add-customer',
				templateUrl: 'app/main/customers/sub-broker-customer/sub-broker-add-customer.html',
				controller: 'subBrokerAddCustomerController as vm'	
			})
			.state('app.sub-broker-customer.customerhome.customer-personal-Details', {
				url: '/customer-personal-Details/:id',
				templateUrl: 'app/main/customers/sub-broker-customer/customerDetails/customer-personal-Details.html',
				controller: 'customerDetailsController as vm'
			
			})
			.state('app.sub-broker-customer.customerhome.customer-bank-Details', {
				url: '/customer-bank-Details',
				templateUrl: 'app/main/customers/sub-broker-customer/customerDetails/customer-bank-Details.html',
				controller: 'customerDetailsController as vm'
			
			})
		msNavigationServiceProvider.saveItem('customer.sub-broker-customer', {
			title: 'Sub Broker Customer List',
			icon: 'icon-tile-four',
			state: 'app.sub-broker-customer',
			weight: 10,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			}
		});
	}
})();

(function () {

    'use strict';
    // var createCustomerJson = require('./nseregistrationform.json');


    angular.module('app.sub-broker-customer').controller('customerDetailsController', customerDetailsController);

    /** @ngInject */
    function customerDetailsController($mdDialog, ServiceProxy, $window, $scope, $state, $rootScope, $stateParams, $filter, GlobalService, StorageService, $http) {
        var vm = this;

        function init() {
            // =================== XXXXXXXXXXXXXXXXXXXXX Declaration Of All variable XXXXXXXXXXXXXXXXXXX ====================================
            $scope.bankTypeData = [];
            $scope.taxStatusData = [];
            $scope.taxStatusData = [];
            $scope.idTypeData = [];
            $scope.sourceWealthData = [];
            $scope.occupationData = [];
            $scope.countryData = [];
            $scope.stateData = [];
            $scope.cityData = [];
            // $scope.pincodeData = [];
            $scope.accountTypeData = [];
            $scope.postJsonData = {};
            $scope.postFormData = {};
            $scope.customJsonData = {};
            $scope.customJsonData.searchCountryByName = '';
            $scope.customJsonData.searchStateByName = '';
            $scope.customJsonData.searchCityByName = '';
            $scope.holdingNatureData = [];
            $scope.taxsSelectedHoldingNatureData = [];
            $scope.currentStepBeforeSave = null;
            $scope.ifscCodeData = {};
            $scope.pincodeData = {};
            $scope.previousStateOfUserProfileUpdate = {};

            $scope.customJsonData = {};
            $scope.customJsonData.searchCountryByName = '';
            $scope.customJsonData.searchStateByName = '';
            $scope.customJsonData.searchCityByName = '';
            // $http.get('nseregistrationform.json').success(function (data){
            //     var createCustomerJson = data;
            // $scope.createCustomerPostJsonData = createCustomerJson;

            // });
            $scope.createCustomerPostJsonData ={
                "service_request":
                {
                    "title": "",
                    "inv_name": "",
                    "pan": "",
                    "valid_pan": "Y",
                    "exemption": "N",
                    "exempt_category": "",
                    "exempt_ref_no": "",
                    "dob": "",
                    "hold_nature": "",
                    "tax_status": "",
                    "kyc": "Y",
                    "occupation": "",
                    "mfu_can": "",
                    "dp_id": "",
                    "father_name": "",
                    "mother_name": "",
                    "trxn_acceptance": "OL",
                    "addr1": "",
                    "city": "",
                    "state": "",
                    "pincode": "",
                    "country": "",
                    "mobile_no": "",
                    "res_phone": "",
                    "off_phone": "",
                    "res_fax": "",
                    "off_fax": "",
                    "email": "",
                    "nri_addr1": "",
                    "nri_city": "",
                    "nri_state": "",
                    "nri_pincode": "",
                    "bank_name": "",
                    "acc_no": "",
                    "acc_type": "",
                    "ifsc_code": "",
                    "branch_name": "",
                    "branch_addr1": "",
                    "branch_addr2": "",
                    "branch_addr3": "",
                    "branch_city": "",
                    "branch_pincode": "",
                    "branch_country": "",
                    "jh1_name": "",
                    "jh1_pan": "",
                    "jh1_valid_pan": "",
                    "jh1_exemption": "",
                    "jh1_exempt_category": "",
                    "jh1_exempt_ref_no": "",
                    "jh1_dob": "",
                    "jh1_mobile_no": "",
                    "jh1_email": "",
                    "jh1_kyc": "",
                    "no_of_nominee": "",
                    "nominee1_type": "",
                    "nominee1_name": "",
                    "nominee1_dob": "",
                    "nominee1_addr1": "",
                    "nominee1_city": "",
                    "nominee1_state": "",
                    "nominee1_pincode": "",
                    "nominee1_relation": "",
                    "nominee1_percent": "",
                    "nominee1_guard_name": "",
                    "nominee1_guard_pan": "",
                    "guard_name": "",
                    "guard_pan": "",
                    "guard_valid_pan": "",
                    "guard_exemption": "",
                    "guard_exempt_category": "",
                    "guard_pan_ref_no": "",
                    "guard_dob": "",
                    "guard_kyc": ""
                }
            };

            $scope.relationArray = ['Father', 'Mother', 'Brother', 'Sister', 'Wife', 'Husband', 'Son', 'Daughter', 'Father-in-law', 'Mother-in-law', 'Son-in-law', 'Daughter-in-law', 'Uncle', 'Aunt', 'Niece', 'Nephew', 'Grand Father', 'Grand Mother', 'Other'];
            $scope.customJsonData.addressTypeData = [{
                'desc': 'Residential or Business',
                'code': '1'
            }, {
                'desc': 'Residential',
                'code': '2'
            }, {
                'desc': 'Business',
                'code': '3'
            }, {
                'desc': 'Registered Office',
                'code': '4'
            }, {
                'desc': 'Unspecified',
                'code': '5'
            }];
            $scope.customJsonData.taxResidencyData = [{
                'desc': 'Yes',
                'code': 'Y'
            }, {
                'desc': 'No',
                'code': 'N'
            }];
            $scope.customJsonData.app_income = {
                'APP_INCOME_CODE': '33',
                'APP_INCOME_DESC': '>5 <=10 Lacs'
            };
            $scope.customJsonData.source_wealth = {
                'CODE': '01',
                'SOURCE_OF_WEALTH': 'Salary'
            };
            $scope.customJsonData.addr_type = {
                'desc': 'Residential',
                'code': '2'
            };
            $scope.customJsonData.tax_residency = {
                'desc': 'No',
                'code': 'N'
            };
            $scope.customJsonData.acc_type = {
                'ACC_TYPE': 'SB',
                'DESCRIPTION': 'Savings Account'
            };
            $scope.customJsonData.country = {
                'COUNTRY_CODE': 'IND',
                'COUNTRY_NAME': 'India'
            };
            // $scope.customJsonData.ifscFlag = false;
            // $scope.customJsonData.ifscBankFlag = false;
            $scope.customJsonData.pincodeFlag = false;
            $scope.customJsonData.pincodeDataFlag = false;
            // $scope.postJsonData.no_of_nomineeShow = false;
            // $scope.postJsonData.nominee1_typeShow = false;
        }
        init();

        // occupation......................................
        var successCallbackOnOccupation = function (response) {
            $scope.occupationData = response.data;
        };
        var getOccupation = function () {
            ServiceProxy.getOccupation().then(successCallbackOnOccupation);
        };

        getOccupation();
        // ================================================= TaxData API Call ===================================================
        // ================================================= IncomeData API Call ===================================================
        var successCallbackOnApplicableIncome = function (response) {
            $scope.applicableIncomeData = response.data;
        };

        var getApplicableincome = function () {
            ServiceProxy.getApplicableincome().then(successCallbackOnApplicableIncome);
        };

        getApplicableincome();
        // ================================================= ID API Call ===================================================
        // ================================================= Source Wealth Data API Call ===================================================
        var successCallbackOnSourceWealth = function (response) {
            $scope.sourceWealthData = response.data;
        };

        var getSourceWealth = function () {
            ServiceProxy.getSourceWealth().then(successCallbackOnSourceWealth);
        };

        getSourceWealth();
        // ======================================== Search State ============================================
        $scope.stateSearch = function (query) {
            return query ? $scope.stateData.filter(stateSearchByname) : $scope.stateData;
        };

        var stateSearchByname = function (item) {
            return item.STATE_NAME.toLowerCase().indexOf($scope.customJsonData.searchStateByName.toLowerCase()) > -1;
        };
        // ======================================== Search State ============================================

        // ======================================== Search City ============================================
        $scope.citySearch = function (query) {
            return query ? $scope.cityData.filter(citySearchByname) : $scope.cityData;
        };

        var citySearchByname = function (item) {
            return item.CITY.toLowerCase().indexOf($scope.customJsonData.searchCityByName.toLowerCase()) > -1;
        };
        // ======================================== Search City ============================================
        // ================================================= State API Call ===================================================
        var successCallbackOnState = function (response) {
            $scope.stateData = response.data.Data.state_master;
        };
        var getState = function () {
            ServiceProxy.getState().then(successCallbackOnState);
        };

        getState();
        // ================================================= State API Call ===================================================
        // ======================================== Search Bank ============================================
        $scope.bankSearch = function (query) {
            $scope.postJsonData.branch_name = '';
            $scope.postJsonData.branch_addr1 = '';
            return query ? $scope.bankTypeData.filter(bakNameSearch) : $scope.bankTypeData;
        };

        var bakNameSearch = function (item) {
            return item.BANK_NAME.toLowerCase().indexOf($scope.customJsonData.searchBankByName.toLowerCase()) > -1;
        };
        // ======================================== Search Bank ============================================

        // ================================================= Account API Call ===================================================
        var successCallbackOnAccountType = function (response) {
            var tempArray = [];
            angular.forEach(response.data.Data.account_type, function (data) {
                if (data.ACC_TYPE !== 'CC') {
                    tempArray.push(data);
                }
            });
            $scope.accountTypeData = tempArray;
        };
        var getAccountType = function () {
            ServiceProxy.getAccountType().then(successCallbackOnAccountType);
        };

        getAccountType();
        // ================================================== IFSC CODE FETCH ============================================
        var sucessCbGetBankDetailsFrmIFSC = function (response) {
            $scope.ifscCodeData = response.data.responseString;            
            if ($scope.ifscCodeData && $scope.ifscCodeData.nseBankName) {
                $scope.customJsonData.ifscFlag = true;
                // angular.forEach($scope.bankTypeData, function (element) {
                //     if (element && element.BANK_CODE && element.BANK_NAME && element.BANK_NAME === $scope.ifscCodeData.nseBankName) {
                //         $scope.postJsonData.bank_name = {
                //             'BANK_NAME': element.BANK_NAME,
                //             'BANK_CODE': element.BANK_CODE
                //         };
                //     }
                // });
                                
                $scope.postJsonData.bank_name = {
                    'BANK_NAME': $scope.ifscCodeData.nseBankName,
                    'BANK_CODE': ''
                };

                $scope.postJsonData.branch_name = $scope.ifscCodeData.branch;
                $scope.postJsonData.branch_addr1 = $scope.ifscCodeData.address;
            } else {
                $scope.customJsonData.ifscFlag = false;
                $scope.customJsonData.ifscBankFlag = true;
            }
        };
        var errorCbGetBankDetailsFrmIFSC = function (response) {
            $scope.customJsonData.ifscFlag = false;
            $scope.customJsonData.ifscBankFlag = true;
            $scope.postJsonData.branch_name = '';
            $scope.postJsonData.branch_addr1 = '';
            $scope.customJsonData.searchBankByName = '';
        };
        $scope.getBankDetailsByIfsc = function () {
            if ($scope.postJsonData.ifsc_code && $scope.postJsonData.ifsc_code.length === 11) {
                ServiceProxy.getBankDetailsFrmIFSC($scope.postJsonData.ifsc_code).then(sucessCbGetBankDetailsFrmIFSC, errorCbGetBankDetailsFrmIFSC);
            }
        };
        $scope.removeIfscDetails = function () {
            $scope.customJsonData.ifscFlag = false;
            $scope.customJsonData.ifscBankFlag = true;
        };



        ///////////////////////////////////////////////end bank details available here///////////////////////////////////
        // // ================================================= State API Call ===================================================
        var successCallbackOnCity = function (response) {
            var tempArray = [];
            $scope.cityData = [];
            $scope.postJsonData.city = '';
            angular.forEach(response.data.Data.city_master, function (data) {
                if (tempArray.indexOf(data.CITY) === -1) {
                    tempArray.push(data.CITY);
                    $scope.cityData.push(data);
                }
            });
        };
        $scope.getCityByState = function (state) {
            if ($scope.postJsonData.city && $scope.postJsonData.city.CITY.length > 0) {
                $scope.postJsonData.city.CITY = '';
                $scope.postJsonData.city.STATE_CODE = '';
            }
            if (state && state.STATE_CODE) {
                ServiceProxy.getCity(state.STATE_CODE).then(successCallbackOnCity);
            }
        };
        // // ================================================= State API Call ===================================================

        $scope.nomineAvailavleCheck = function (checked) {
            var postData = StorageService.getSessionStorage('userDetails');
            // console.log(postData)
            if (checked || checked === 'true') {
                postData.rawData.nseDetails.nominee1_name = $scope.postJsonData.nominee1_name;
                postData.rawData.nseDetails.nominee1_relation = $scope.postJsonData.nominee1_relation;
                postData.rawData.nseDetails.no_of_nominee = true;
                $scope.postJsonData.no_of_nomineeShow = true;
                $scope.postJsonData.nominee1_typeShow = false;
            } else {
                $scope.postJsonData.nominee1_name = '';
                $scope.postJsonData.nominee1_relation = '';
                postData.rawData.nseDetails.no_of_nominee = false;
                $scope.postJsonData.no_of_nomineeShow = false;
                $scope.postJsonData.nominee1_typeShow = false;
                $scope.postJsonData.nominee1_dob = '';
                $scope.postJsonData.nominee1_guard_name = '';
                $scope.postJsonData.nominee1_guard_pan = '';
            }
        };
        $scope.nomineMinor = function (checked) {
            var postData = StorageService.getSessionStorage('userDetails');
            if (checked || checked === 'true') {
                postData.rawData.nseDetails.nominee1_dob = new Date($scope.postJsonData.nominee1_dob);
                postData.rawData.nseDetails.nominee1_dob = postData.rawData.nseDetails.nominee1_dob.setHours(0, 0, 0, 0);
                postData.rawData.nseDetails.nominee1_guard_name = $scope.postJsonData.nominee1_guard_name;
                postData.rawData.nseDetails.nominee1_guard_pan = $scope.postJsonData.nominee1_guard_pan;
                postData.rawData.nseDetails.nominee1_type = true;
                $scope.postJsonData.no_of_nomineeShow = true;
                $scope.postJsonData.nominee1_typeShow = true;
            } else {
                $scope.postJsonData.nominee1_dob = '';
                $scope.postJsonData.nominee1_guard_name = '';
                $scope.postJsonData.nominee1_guard_pan = '';
                $scope.postJsonData.no_of_nomineeShow = true;
                $scope.postJsonData.nominee1_typeShow = false;
                postData.rawData.nseDetails.nominee1_type = false;
            }
        };
        ///////////////////////////////////////////////////starts picode data here//////////////////////////////////////////////////////////////////////
        var sucessCbGetStateCityPincode = function (response) {
            $scope.pincodeData = response.data.data;
            if ($scope.pincodeData && $scope.pincodeData.countryCode === 'IND') {
                $scope.customJsonData.pincodeFlag = true;
                $scope.customJsonData.pincodeDataFlag = false;
                $scope.postJsonData.state = {
                    'STATE_CODE': $scope.pincodeData.stateCode,
                    'STATE_NAME': $scope.pincodeData.stateName
                };
                $scope.postJsonData.city = {
                    'CITY': $scope.pincodeData.cityName,
                    'STATE_CODE': $scope.pincodeData.stateCode
                };
            } else {
                $scope.customJsonData.pincodeFlag = false;
                $scope.customJsonData.pincodeDataFlag = true;
            }
        };
        var errorCbGetStateCityPincode = function (response) {
            $scope.customJsonData.pincodeFlag = false;
            $scope.customJsonData.pincodeDataFlag = true;
            $scope.postJsonData.state = '';
            $scope.postJsonData.city = '';
        };
        $scope.getStateCityByPincode = function () {

            if ($scope.postJsonData.pincode && $scope.postJsonData.pincode.length === 6) {
                var id = $stateParams.id;
                ServiceProxy.getStateCityDetailsPincode($scope.postJsonData.pincode, id).then(sucessCbGetStateCityPincode, errorCbGetStateCityPincode);
            }
        };
        $scope.removePincodeDetails = function () {
            $scope.customJsonData.pincodeFlag = false;
            $scope.customJsonData.pincodeDataFlag = true;
        };

        //*********************************display existing data*********************************/

        var mappNseformData = function() {
            if (StorageService.getSessionStorage('userDetails') && StorageService.getSessionStorage('userDetails').rawData)
            {
                $scope.nseSignupDetail = StorageService.getSessionStorage('userDetails').rawData;
            }
            
            //console.log(StorageService.getSessionStorage('userDetails'));
            if ($scope.nseSignupDetail && $scope.nseSignupDetail.nseDetails) {
                $scope.postJsonData = $scope.nseSignupDetail.nseDetails;
                if ($scope.nseSignupDetail.nseDetails.dob) {
                    $scope.nseSignupDetail.nseDetails.dob = new Date($scope.nseSignupDetail.nseDetails.dob);
                }
                if ($scope.nseSignupDetail.nseDetails.guard_dob) {
                    $scope.nseSignupDetail.nseDetails.guard_dob = new Date($scope.nseSignupDetail.nseDetails.guard_dob);
                }
                if ($scope.nseSignupDetail.nseDetails.nominee1_dob > 1) {
                    $scope.nseSignupDetail.nseDetails.nominee1_dob = new Date($scope.nseSignupDetail.nseDetails.nominee1_dob);
                }
                if ($scope.nseSignupDetail.nseDetails.no_of_nominee === '1') {
                    $scope.nseSignupDetail.nseDetails.no_of_nominee = '1';
                    $scope.postJsonData.no_of_nominee = '1';
                } else {
                    $scope.nseSignupDetail.nseDetails.no_of_nominee = '0';
                    $scope.postJsonData.no_of_nominee = '0';
                }
                if ($scope.nseSignupDetail.nseDetails.nominee1_type === 'Y') {
                    $scope.nseSignupDetail.nseDetails.nominee1_type = 'Y';
                    $scope.postJsonData.nominee1_type = 'Y';
                } else {
                    $scope.nseSignupDetail.nseDetails.nominee1_type = 'N';
                    $scope.postJsonData.nominee1_type = 'N';
                }
                if ($scope.nseSignupDetail.nseDetails.occupation && $scope.nseSignupDetail.nseDetails.occupation.OCCUPATION_DESC.length === 0) {
                    $scope.postJsonData.occupation = $scope.customJsonData.occupation;
                }
                if ($scope.nseSignupDetail.nseDetails.state) {
                    $scope.postJsonData.state = $scope.nseSignupDetail.nseDetails.state;
                }
                if ($scope.nseSignupDetail.nseDetails.city) {
                    $scope.postJsonData.city = $scope.nseSignupDetail.nseDetails.city;
                }
                if ($scope.nseSignupDetail.nseDetails.acc_type.ACC_TYPE.length === 0) {
                    $scope.postJsonData.acc_type = $scope.customJsonData.acc_type;
                }
                // if ($scope.nseSignupDetail.nseDetails.state) {
                //     ServiceProxy.getCity($scope.nseSignupDetail.nseDetails.state.STATE_CODE).then(successCallbackOnCityMappingBefore);
                // }
                // if ($scope.nseSignupDetail.nseDetails.state && $scope.nseSignupDetail.nseDetails.state.STATE_CODE.length > 0) {
                //     ServiceProxy.getCity($scope.nseSignupDetail.nseDetails.state.STATE_CODE).then(successCallbackOnCityMappingBefore);
                // }
            }
            if ($scope.nseSignupDetail && $scope.nseSignupDetail.fatcaDetails) {
                if ($scope.nseSignupDetail.fatcaDetails.addr_type && $scope.nseSignupDetail.fatcaDetails.addr_type.desc.length === 0) {
                    $scope.postJsonData.addr_type = $scope.customJsonData.addr_type;
                } else {
                    $scope.postJsonData.addr_type = $scope.nseSignupDetail.fatcaDetails.addr_type;
                }
                //app_income
                if ($scope.nseSignupDetail.fatcaDetails.app_income && $scope.nseSignupDetail.fatcaDetails.app_income.APP_INCOME_DESC.length === 0) {
                    $scope.postJsonData.app_income = $scope.customJsonData.app_income;
                } else {
                    $scope.postJsonData.app_income = $scope.nseSignupDetail.fatcaDetails.app_income;
                }
                //tax_residency
                if ($scope.nseSignupDetail.fatcaDetails.tax_residency && $scope.nseSignupDetail.fatcaDetails.tax_residency.desc.length === 0) {
                    $scope.postJsonData.tax_residency = $scope.customJsonData.tax_residency;
                } else {
                    $scope.postJsonData.tax_residency = $scope.nseSignupDetail.fatcaDetails.tax_residency;
                }
                //source_wealth
                if ($scope.nseSignupDetail.fatcaDetails.source_wealth && $scope.nseSignupDetail.fatcaDetails.source_wealth.SOURCE_OF_WEALTH.length === 0) {
                    $scope.postJsonData.source_wealth = $scope.customJsonData.source_wealth;
                } else {
                    $scope.postJsonData.source_wealth = $scope.nseSignupDetail.fatcaDetails.source_wealth;
                }
                $scope.postJsonData.country_of_birth = $scope.nseSignupDetail.fatcaDetails.country_of_birth;
                $scope.postJsonData.place_birth = $scope.nseSignupDetail.fatcaDetails.place_birth;
            }
        };

        mappNseformData();

        //$scope.postJsonData.father_name = 'yyyyy';


        //*********************************save & continue*********************************/
        // =========================== Go To Step ==============================================================
        $scope.goToStep = function (event, step) {
            var $target = $(event.currentTarget);
            if ($target.parent().hasClass('disabled')) {
                return false;
            }
            $target.parent().removeClass('disabled');
            $scope.currentStepBeforeSave = step;
            savenseFormData(step);
        };
        $scope.goToPrev = function (event, step) {
            $scope.currentStep = step;
        };
        // ==================================== Save Form Data =================================================
        var successNseSignUpFormDataSaveInDetails = function (response) {
            if (response.data.data) {
                // console.log("response.data.data", response.data.data.rawData)
                StorageService.setSessionStorage('userDetails', null);
                StorageService.setSessionStorage('userDetails', response.data.data);
                StorageService.setSessionStorage('userDetails1', response.data.data);
                var log = StorageService.getSessionStorage('userDetails')
                $state.go('app.sub-broker-customer.customerhome.customer-bank-Details')
            }

            $scope.currentStep = $scope.currentStepBeforeSave;
            $scope.currentStepBeforeSave = null;
        };
        var successNseSignUpFormDataRegister = function (response) {
            if (response.data.data) {
                
                //$state.go('app.sub-broker-customer')
                StorageService.setSessionStorage('userDetails', response.data.data);
                createCustomerNSE(response.data.data);
            }
        };

        //----------------- Create NSE User -------------------------
        var createCustomerNSE = function(rawData1) {
            var rawData=rawData1.rawData;
            $scope.createCustomerPostJsonData.service_request = JSON.parse(JSON.stringify(rawData.nseDetails));
            $scope.createCustomerPostJsonData.service_request.dob = changeDateFormate(rawData.nseDetails.dob);
            $scope.createCustomerPostJsonData.service_request.hold_nature = rawData.nseDetails.hold_nature.HOLD_NATURE_CODE || '';
            $scope.createCustomerPostJsonData.service_request.tax_status = rawData.nseDetails.tax_status.TAX_STATUS_CODE || '';
            $scope.createCustomerPostJsonData.service_request.occupation = rawData.nseDetails.occupation.OCCUPATION_CODE;
            $scope.createCustomerPostJsonData.service_request.city = rawData.nseDetails.city.CITY || $scope.postJsonData.city;
            $scope.createCustomerPostJsonData.service_request.state = rawData.nseDetails.state.STATE_CODE || $scope.postJsonData.state;
            $scope.createCustomerPostJsonData.service_request.country = rawData.nseDetails.country.COUNTRY_CODE || '';
            
            $scope.createCustomerPostJsonData.service_request.bank_name = rawData.nseDetails.bank_name.BANK_NAME;

            $scope.createCustomerPostJsonData.service_request.acc_type = rawData.nseDetails.acc_type.ACC_TYPE;
            if (rawData.nseDetails.guard_dob !== null) {
                $scope.createCustomerPostJsonData.service_request.guard_dob = changeDateFormate(rawData.nseDetails.guard_dob);
            }
            if (rawData.nseDetails.no_of_nominee === '1') {
                $scope.createCustomerPostJsonData.service_request.nominee1_dob = changeDateFormate(rawData.nseDetails.nominee1_dob);
                $scope.createCustomerPostJsonData.service_request.no_of_nominee = '1';
            } else {
                $scope.createCustomerPostJsonData.service_request.nominee1_dob = '';
                $scope.createCustomerPostJsonData.service_request.no_of_nominee = '0';
            }
            if (rawData.nseDetails.nominee1_type === 'Y') {
                $scope.createCustomerPostJsonData.service_request.nominee1_dob = changeDateFormate(rawData.nseDetails.nominee1_dob);
                $scope.createCustomerPostJsonData.service_request.nominee1_type = 'Y';
            } else {
                $scope.createCustomerPostJsonData.service_request.nominee1_dob = '';
                $scope.createCustomerPostJsonData.service_request.nominee1_type = 'N';
            }
            $scope.createCustomerPostJsonData.service_request.guard_exempt_category = '';
            $scope.createCustomerPostJsonData.service_request.guard_exemption = '';
            $scope.createCustomerPostJsonData.service_request.guard_pan_ref_no = '';
            $scope.createCustomerPostJsonData.service_request.guard_valid_pan = '';
            $scope.createCustomerPostJsonData.service_request.res_phone = '';
            $scope.createCustomerPostJsonData.service_request.fh_ckyc = '';
            $scope.createCustomerPostJsonData.service_request.kyc = 'Y';
            
            ServiceProxy.registerUserWithNse({
                'service_request': nullToDoubleQuote($scope.createCustomerPostJsonData.service_request)
            }).then(successCallbackOnCreateUser, errorCallbackOnCreateUser);
        };

        var successCallbackOnCreateUser = function(response) {
            $rootScope.signUpSteps = 4;
            StorageService.setSessionStorage('signUpSteps', 4);
            //Message.success('Successfully registered with NSE');
            alert('IIN created ' + response.data.IIN);
            var postData = {
                service_request: {
                    iin: response.data.IIN
                }
            };
            // setTimeout(function() {
            //     ServiceProxy.getIINDetails(postData).then(successIINDetailCallback, errorIINDetailCallback);
            // }, 1000);
            // ShareDataService.storeData('downloadPdf', true);
        };
        var errorCallbackOnCreateUser = function(response) {
            $scope.showErrorMessage = [];
            alert('Error ' + response.data.data);
            if (response.data.Data.length !== undefined) {
                $scope.showErrorMessage = response.data.Data;
            } else {
                $scope.showErrorMessage.push(response.data.Data);
            }
        };

        //---------------------------End Create Nse User --------------------


        var savenseFormData = function (step) {
            var height = $('#uploadSignature').height();
            var width = $('#uploadSignature').width();
            // console.log(step);
            // console.log(width);
            var postData = StorageService.getSessionStorage('userDetails');
            var postData1 = StorageService.getSessionStorage('userDetails1');
            if (step === 'registerToNSE') {
                //var postData = postData1;
            }
            if (step === 'step2') {
                //console.log(postData);
                postData.rawData.userDetails.state = 2;
                postData.rawData.nseDetails.title = 'Mr.';
                postData.rawData.nseDetails.inv_name = postData.userName;
                postData.rawData.nseDetails.mobile_no = postData.mobileNo;
                postData.rawData.nseDetails.email = postData.email;
                postData.rawData.nseDetails.pan = postData.pan;
                postData.rawData.nseDetails.dob = $scope.postJsonData.dob;
                if (postData.rawData.nseDetails.dob) {
                    postData.rawData.nseDetails.dob = new Date(postData.rawData.nseDetails.dob);
                    postData.rawData.nseDetails.dob = postData.rawData.nseDetails.dob.setHours(0, 0, 0, 0);
                }
                postData.rawData.nseDetails.hold_nature = {
                    'HOLD_NATURE_CODE': '',
                    'HOLD_NATURE_DESC': ''
                };
                postData.rawData.nseDetails.tax_status = {
                    'JOINTHOLDERS_FLAG': '',
                    'TAX_STATUS_CODE': '',
                    'TAX_STATUS_DESC': ''
                };


                postData.rawData.nseDetails.occupation = $scope.postJsonData.occupation || '';
                postData.rawData.nseDetails.father_name = $scope.postJsonData.father_name || '';
                postData.rawData.nseDetails.mother_name = $scope.postJsonData.mother_name || '';
                postData.rawData.nseDetails.guard_name = $scope.postJsonData.guard_name || '';
                postData.rawData.nseDetails.guard_pan = $scope.postJsonData.guard_pan || '';
                postData.rawData.nseDetails.guard_dob = $scope.postJsonData.guard_dob || '';
                if (postData.rawData.nseDetails.guard_dob) {
                    postData.rawData.nseDetails.guard_dob = new Date(postData.rawData.nseDetails.guard_dob);
                    postData.rawData.nseDetails.guard_dob = postData.rawData.nseDetails.guard_dob.setHours(0, 0, 0, 0);
                }
                postData.rawData.nseDetails.nominee1_dob = $scope.postJsonData.nominee1_dob || '';
                if (postData.rawData.nseDetails.nominee1_dob) {
                    postData.rawData.nseDetails.nominee1_dob = new Date($scope.postJsonData.nominee1_dob);
                    postData.rawData.nseDetails.nominee1_dob = postData.rawData.nseDetails.nominee1_dob.setHours(0, 0, 0, 0);
                }
                postData.rawData.nseDetails.country = $scope.postJsonData.country;
                postData.rawData.nseDetails.state = $scope.postJsonData.state;
                postData.rawData.nseDetails.city = $scope.postJsonData.city;
                postData.rawData.nseDetails.pincode = $scope.postJsonData.pincode;
                postData.rawData.nseDetails.addr1 = $scope.postJsonData.addr1;
                if ($scope.postJsonData.no_of_nominee === true) {
                    postData.rawData.nseDetails.no_of_nominee = '1';
                } else {
                    postData.rawData.nseDetails.no_of_nominee = '0';
                }
                postData.rawData.nseDetails.nominee1_name = $scope.postJsonData.nominee1_name || '';
                postData.rawData.nseDetails.nominee1_relation = $scope.postJsonData.nominee1_relation || '';
                postData.rawData.nseDetails.nominee1_percent = 100;
                postData.rawData.nseDetails.nominee1_guard_name = $scope.postJsonData.nominee1_guard_name || '';
                postData.rawData.nseDetails.nominee1_guard_pan = $scope.postJsonData.nominee1_guard_pan || '';
                if ($scope.postJsonData.nominee1_type === true) {
                    postData.rawData.nseDetails.nominee1_type = 'Y';
                } else {
                    postData.rawData.nseDetails.nominee1_type = 'N';
                }
                postData.rawData.nseDetails.nominee2_name = '';
                postData.rawData.nseDetails.nominee2_relation = '';
                postData.rawData.nseDetails.nominee2_percent = '';
                postData.rawData.nseDetails.nominee2_guard_name = '';
                postData.rawData.nseDetails.nominee2_guard_pan = '';
                postData.rawData.nseDetails.nominee2_type = '';
                postData.rawData.nseDetails.nominee2_dob = '';
                postData.rawData.nseDetails.nominee3_name = '';
                postData.rawData.nseDetails.nominee3_relation = '';
                postData.rawData.nseDetails.nominee3_percent = '';
                postData.rawData.nseDetails.nominee3_guard_name = '';
                postData.rawData.nseDetails.nominee3_guard_pan = '';
                postData.rawData.nseDetails.nominee3_type = '';
                postData.rawData.nseDetails.nominee3_dob = '';
                postData.rawData.nseDetails.nri_country = '';
                postData.rawData.nseDetails.nri_state = '';
                postData.rawData.nseDetails.nri_city = '';
                postData.rawData.nseDetails.jh1_pan = '';
                postData.rawData.nseDetails.jh2_pan = '';
                postData.rawData.nseDetails.jh1_name = '';
                postData.rawData.nseDetails.jh2_name = '';
                postData.rawData.nseDetails.jh1_dob = '';
                postData.rawData.nseDetails.jh2_dob = '';
                postData.rawData.nseDetails.jh1_mobile_no = '';
                postData.rawData.nseDetails.jh2_mobile_no = '';
                postData.rawData.nseDetails.jh1_email = '';
                postData.rawData.nseDetails.jh2_email = '';
                postData.rawData.fatcaDetails.app_income = $scope.postJsonData.app_income;
                postData.rawData.fatcaDetails.source_wealth = $scope.postJsonData.source_wealth;
                postData.rawData.fatcaDetails.addr_type = $scope.postJsonData.addr_type;
                postData.rawData.fatcaDetails.country_of_birth = $scope.postJsonData.country_of_birth;
                postData.rawData.fatcaDetails.place_birth = $scope.postJsonData.place_birth;
                postData.rawData.fatcaDetails.tax_residency = $scope.postJsonData.tax_residency;
                postData.rawData.nseDetails.acc_type = $scope.postJsonData.acc_type;
                postData.rawData.nseDetails.acc_no = $scope.postJsonData.acc_no;
                postData.rawData.nseDetails.branch_addr1 = $scope.postJsonData.branch_addr1;
                postData.rawData.nseDetails.ifsc_code = $scope.postJsonData.ifsc_code;
                postData.rawData.nseDetails.bank_name = $scope.postJsonData.bank_name;                
                postData.rawData.nseDetails.branch_name = $scope.postJsonData.branch_name;
            }
            if (step === 'registerToNSE') {
                // console.log("postData..", postData)

                if (postData.rawData.nseDetails.dob) {
                    postData.rawData.nseDetails.dob = new Date(postData.rawData.nseDetails.dob);
                    postData.rawData.nseDetails.dob = postData.rawData.nseDetails.dob.setHours(0, 0, 0, 0);
                }
                postData.rawData.nseDetails.hold_nature = {
                    'HOLD_NATURE_CODE': '',
                    'HOLD_NATURE_DESC': ''
                };
                postData.rawData.nseDetails.tax_status = {
                    'JOINTHOLDERS_FLAG': '',
                    'TAX_STATUS_CODE': '',
                    'TAX_STATUS_DESC': ''
                };

                postData.rawData.nseDetails.acc_type = $scope.postJsonData.acc_type;
                postData.rawData.nseDetails.acc_no = $scope.postJsonData.acc_no;
                postData.rawData.nseDetails.branch_addr1 = $scope.postJsonData.branch_addr1;
                postData.rawData.nseDetails.ifsc_code = $scope.postJsonData.ifsc_code;
                postData.rawData.nseDetails.bank_name = $scope.postJsonData.bank_name;
                postData.rawData.nseDetails.branch_name = $scope.postJsonData.branch_name;
                // console.log("postData..nse data", postData)

                ServiceProxy.nseSignupFormDataSave(nullToDoubleQuote(postData)).then(successNseSignUpFormDataRegister);

            } else {
                ServiceProxy.nseSignupFormDataSave(nullToDoubleQuote(postData)).then(successNseSignUpFormDataSaveInDetails);
            }
        };

        var nullToDoubleQuote = function (data) {
            if (Object.keys(data).length > 0) {
                for (var key in data) {
                    if (data[key] === null) {
                        data[key] = '';
                    }
                }
            }
            return data;
        };

        // =========================== Go To Step ==============================================================
        $scope.disableSubmitForCustomerDetails = function () {
            var commonField = null;
            if ($scope.customJsonData.ekycIsDone) {
                commonField = $scope.postJsonData.occupation && $scope.postJsonData.dob && $scope.postJsonData.addr1 && $scope.postJsonData.pincode && $scope.postJsonData.state && $scope.postJsonData.city && $scope.postJsonData.app_income && $scope.postJsonData.source_wealth;
            } else {
                commonField = $scope.postJsonData.occupation && $scope.postJsonData.dob && $scope.postJsonData.father_name && $scope.postJsonData.mother_name && $scope.postJsonData.mobile_no && $scope.postJsonData.addr1 && $scope.postJsonData.pincode && $scope.postJsonData.state && $scope.postJsonData.city && $scope.postJsonData.app_income && $scope.postJsonData.source_wealth;
            }
            if ($scope.postJsonData.no_of_nomineeShow && !$scope.postJsonData.nominee1_typeShow) {
                return !(commonField && $scope.postJsonData.nominee1_name && $scope.postJsonData.nominee1_relation);
            } else if ($scope.postJsonData.no_of_nomineeShow && $scope.postJsonData.nominee1_typeShow) {
                return !(commonField && $scope.postJsonData.nominee1_name && $scope.postJsonData.nominee1_relation && $scope.postJsonData.nominee1_guard_name && $scope.postJsonData.nominee1_guard_pan);
            } else {
                return !(commonField);
            }
        };

        $scope.disableSubmitBankdetails = function () {
            return !($scope.postJsonData.acc_type && $scope.postJsonData.acc_no && $scope.postJsonData.ifsc_code && $scope.postJsonData.bank_name && $scope.postJsonData.branch_name && $scope.postJsonData.branch_addr1);
        };

        function getStep(state) {
            if (state === 2) {
                return 'step2';
            } else {
                return 'step1';
            }
        }

        $scope.resetPlaceOfBirth = function () {
            if ($scope.postJsonData.country_of_birth.COUNTRY_NAME !== 'India') {
                $scope.customJsonData.searchsearchStateName = '';
            }
        };

        var changeDateFormate = function (dateData) {
            var result = $filter('date')(dateData, 'dd-MMM-yyyy');
            return result;

        };

        var nullToDoubleQuote = function (data) {
            if (Object.keys(data).length > 0) {
                for (var key in data) {
                    if (data[key] === null) {
                        data[key] = '';
                    }
                }
            }
            return data;
        };
        $scope.registerNSE = function () {
            // var data = document.getElementById('uploadSignature').files[0];
            savenseFormData('registerToNSE');
        };



    }
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard', [
            'chart.js',
            'nvd3'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'DASHBOARD::FEATURE';
        // State
        $stateProvider
            .state('app.dashboard', {
                abstract: true,
                url: '/dashboard',
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.dashboard.comparison', {
                url: '/comparison',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller: 'DashboardController as vm'
                    },
                    'itemdash@app.dashboard.comparison': {
                        templateUrl: 'app/main/dashboard/comparison/comparison.html',
                        controller: 'ComparisonController as vm'
                    }
                }
            })
            .state('app.dashboard.reports', {
                url: '/reports',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller: 'DashboardController as vm'
                    },
                    'itemdash@app.dashboard.reports': {
                        templateUrl: 'app/main/dashboard/reports/reports.html',
                        controller: 'ReportsController as vm'
                    }
                },
                resolve: {
                    DashboardData: function (msApi) {
                        return msApi.resolve('dashboard.project@get');
                    }
                }
            })
            .state('app.dashboard.employee', {
                url: '/employee',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller: 'DashboardController as vm'
                    },
                    'itemdash@app.dashboard.employee': {
                        templateUrl: 'app/main/dashboard/employee/employee.html',
                        controller: 'EmployeeController as vm'
                    }
                }
            })
            .state('app.dashboard.details', {
                url: '/details',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller: 'DashboardController as vm'
                    },
                    'itemdash@app.dashboard.details': {
                        templateUrl: 'app/main/dashboard/details/details.html',
                        controller: 'DetailsController as vm'
                    }
                }
            })
            .state('app.dashboard.employee.flagClosedDetail', {
                url: '/employeeFlag/:empViewId?from&to',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/flag-closed-detail/flag-closed-detail.html',
                        controller: 'FlagDetailsController as vm'
                    },
                    // 'itemdash@app.dashboard.flagClosedDetail': {
                    //     templateUrl: 'app/main/dashboard/flag-closed-detail/flag-closed-detail.html',
                    //     controller: 'FlagDetailsController as vm'
                    // }
                }
            })
            .state('app.dashboard.reports.schemeInvestment', {
                url: '/schemeinvestment',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/reports/customer-investment-report/customer-investment-report.html',
                        controller: 'CustomerInvestmentReportController as vm'
                    },
                    // 'itemdash@app.dashboard.flagClosedDetail': {
                    //     templateUrl: 'app/main/dashboard/flag-closed-detail/flag-closed-detail.html',
                    //     controller: 'FlagDetailsController as vm'
                    // }
                }
            });

        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);

        msNavigationServiceProvider.saveItem('DASHBOARD', {
            title: 'DASHBOARD',
            weight: 1,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }
        });

        msNavigationServiceProvider.saveItem('DASHBOARD.dashboard', {
            title: 'Organisation Dashboard',
            state: 'app.dashboard.details',
            icon: 'icon-tile-four',
            weight: 1,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                    return false;
                } else {
                    return true;
                }

            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('CustomerInvestmentReportController', CustomerInvestmentReportController);

    /** @ngInject */
    function CustomerInvestmentReportController($state,ShareDataService,Service,ServiceProxy) {
        var vm = this;
        function init() {
            vm.customers = ShareDataService.getData('schemeInvetsment');
            if (!vm.customers){
                $state.go('app.dashboard.reports')
            }
           vm.customerDetailFunction = customerDetailFunction;
        };
        init();


        function sucessCbUserProfile(response) {
            // response.data.data.baseUrl = vm.baseUrl;
            ShareDataService.storeData('customerDetail', response.data.data);
           
                $state.go('app.customers.customerhome.userDetail');

        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function customerDetailFunction(customer) {
            ServiceProxy.getUserProfile(customer._id).then(sucessCbUserProfile, errorGetUserProfile)
        };
         

    }
})();
(function() {
    'use strict';

    angular
        .module('app.blogs', [
            // 3rd Party Dependencies
            'textAngular'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'WEBSITE::MANAGEMENT';
        // State
        $stateProvider
            .state('app.blogs', {
                url: '/blogs',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/blogs/blogs.html',
                        controller: 'BlogsController as vm'
                    }
                },
                data: {
                    access: function() {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.blogDetail', {
                url: '/blogDetail/:blogId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/blogs/blogDetail.html',
                        controller: 'BlogsController as vm'
                    }
                },
                data: {
                    access: function() {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.createNewBlog', {
                url: '/createNewBlog/:blogId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/blogs/createNewBlog.html',
                        controller: 'CreateNewBlogController as vm'
                    }
                },
                data: {
                    access: function() {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/blogs');

        // Api
        // msApiProvider.register('blogs', ['app/data/blogs/blogs.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('WEBSITE', {
            title: 'WEBSITE',
            weight: 6,
            hidden: function() {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }
        });

        msNavigationServiceProvider.saveItem('WEBSITE.blogs', {
            title: 'Blogs',
            icon: 'icon-tile-four',
            state: 'app.blogs',
            weight: 4
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.blogs')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            // Set default values
            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date();

            // Add the note
            NotesService.addNote(angular.copy(MsNoteForm.note));

            // Reset the current note to an empty one
            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }

            // Update the note
            NotesService.updateNote(MsNoteForm.note);

            // Hide the dialog
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/blogs/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.blogs')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/blogs/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.blogs')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/blogs/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('app.uploadTransaction', []).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		var fId = 'TRANSACTION::CSV::UPLOAD';
		// State
		$stateProvider
			.state('app.uploadTransaction', {
				url: '/uploadTransaction',
				views: {
					'content@app': {
						templateUrl: 'app/main/uploadTransaction/uploadTransaction.html',
						controller: 'UploadTransactionController as vm'
					}
				},
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.uploadTransaction.list', {
				url: '/transactionlist/:type',
				views: {
					'content@app': {
						templateUrl: 'app/main/uploadTransaction/transaction-list/transaction-list.html',
						controller: 'TransactionListController as vm'
					}
				},
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.uploadTransaction.validateInvestor', {
				url: '/validateInvestor',
				views: {
					'content@app': {
						templateUrl: 'app/main/uploadTransaction/validate-list/validate-list.html',
						controller: 'ValidateInvestorController as vm'
					},
				}
			});

		// Translation
		// $translatePartialLoaderProvider.addPart('app/main/uploadTransaction');

		// Api
		// msApiProvider.register('sample', ['app/data/sample/sample.json']);

		// Navigation
		msNavigationServiceProvider.saveItem('TRANSACTION', {
			title: 'TRANSACTION',
			weight: 4,
			hidden: function() {
				if (
					JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
					(window.sessionStorage.getItem('feature') &&
						JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
				) {
					return false;
				} else {
					return true;
				}
			}
		});

		msNavigationServiceProvider.saveItem('TRANSACTION.uploadTransaction', {
			title: 'Upload Transaction',
			icon: 'icon-currency-inr',
			state: 'app.uploadTransaction',
			weight: 1
		});
	}
})();

(function () {
    'use strict';

    angular
        .module('app.uploadTransaction')
        .controller('ValidateInvestorController', ValidateInvestorController);

    /** @ngInject */
    function ValidateInvestorController($state, ShareDataService, Service, ServiceProxy) {
        var vm = this;

        function init() {
            vm.customers = ShareDataService.getData('validateInvestorData');
            if (!vm.customers) {
                $state.go('app.uploadTransaction')
            }
        };
        init();

    }
})();
(function () {
	'use strict';

	angular.module('app.uploadTransaction').controller('TransactionListController', TransactionListController);

	/** @ngInject */
	function TransactionListController(
		$scope,
		$document,
		$state,
		$stateParams,
		$rootScope,
		$mdDialog,
		ServiceProxy,
		$timeout,
		$mdToast,
		ShareDataService,
		StorageService
	) {
		var vm = this;

		function init() {
			var allowedTrxnType = [{
					type: 'cams',
					url: 'camsUploads'
				},
				{
					type: 'karvy',
					url: 'karvyData'
				},
				{
					type: 'franklin',
					url: 'franklinData'
				},
				{
					type: 'sundram',
					url: 'sundaramTrnx'
				}
			];
			var trxnIndex = allowedTrxnType.findIndex(function (item) {
				return item.type === $stateParams.type;
			});
			if (trxnIndex > -1) {
				vm.transactionType = allowedTrxnType[trxnIndex];
			} else {
				$state.go('app.uploadTransaction');
			}
			vm.pagination = {
				page: 1,
				limit: 25,
				pageSize: 25
			};
			vm.DynamicItems = function () {
				this.loadedPages = {};
				this.numItems = 0;
				this.PAGE_SIZE = 20;
				this.after = '';
				this.fetchNumItems_();
			};
			vm.DynamicItems.prototype.getItemAtIndex = function (index) {
				var pageNumber = Math.floor(index / this.PAGE_SIZE);
				var page = this.loadedPages[pageNumber];

				if (page) {
					return page[index % this.PAGE_SIZE];
				} else if (page !== null) {
					this.fetchPage_(pageNumber);
				}
			};
			vm.DynamicItems.prototype.getLength = function () {
				return this.numItems;
			};

			vm.DynamicItems.prototype.fetchPage_ = function (pageNumber) {
				if (vm.search) {
					return;
				}
				// Set the page to null so we know it is already being fetched.
				this.loadedPages[pageNumber] = null;

				this.loadedPages[pageNumber] = [];
				ServiceProxy.transactionListWithSearch(vm.transactionType.url, pageNumber + 1, this.PAGE_SIZE).then(
					function (response) {
						this.numItems = response.data.total;
						vm.totalTrxn = response.data.total;
						var items = response.data.data;

						for (var i in items) {
							this.loadedPages[pageNumber].push(items[i]);
						}
						this.after = 't3_' + items[this.loadedPages[pageNumber].length - 1]._id;
					}.bind(this),
					function (error) {
						if (error && error.data) {
							showDialog(error.data.responseString);
						}
					}
				);
			};

			vm.DynamicItems.prototype.fetchNumItems_ = function () {
				$timeout(angular.noop, 300).then(
					angular.bind(this, function () {
						this.numItems = vm.pagination.pageSize;
					})
				);
			};

			vm.dynamicItems = new vm.DynamicItems();
			// vm.customerCount = function(filter) {
			// 	vm.dynamicItems = new vm.DynamicItems();
			// };

			vm.deleteTransaction = deleteTransaction;
			vm.editTransaction = editTransaction;
			vm.searchTransaction = searchTransaction;
			vm.getAllData = getAllData;
		}
		init();

		function getAllData() {
			if (!vm.search) {
				vm.dynamicItems = new vm.DynamicItems();
			}
		}
		// functiuon to delete transaction

		function successCbDeleteTrxn(response) {
			// vm.totalTrxn--;
			vm.dynamicItems = new vm.DynamicItems();
			showToast(response.data.message);
		}

		function errorCbDeleteTrxn(response) {
			// errorDialog(response);
			showToast(response.data.responseString);
		}

		function deleteTransaction(trxn, index) {
			var confirm = $mdDialog
				.confirm()
				.title('Delete Transaction?')
				.textContent(
					'Transaction of ' + trxn.investorName + 'for sceheme ' + trxn.productName + 'of AMC ' + trxn.amcCode
				)
				.ariaLabel('Lucky day')
				// .targetEvent(ev)
				.ok('OK')
				.cancel('Cancel');

			$mdDialog.show(confirm).then(
				function () {
					ServiceProxy.deleteTransaction(vm.transactionType.url, trxn._id).then(
						successCbDeleteTrxn,
						errorCbDeleteTrxn
					);
				},
				function () {
					$scope.status = 'You decided to keep your debt.';
				}
			);
		}

		function showToast(msg) {
			// var pinTo = $scope.getToastPosition();
			var toast = $mdToast
				.simple()
				.textContent(msg)
				// .action('UNDO')
				.highlightAction(true)
				.highlightClass('md-accent') // Accent is used by default, this just demonstrates the usage.
				.position('top right');

			$mdToast.show(toast).then(function (response) {
				if (response == 'ok') {
					alert("You clicked the 'UNDO' action.");
				}
			});
		}

		// update transaction dialog

		function editTransaction(trxn) {
			$mdDialog
				.show({
					locals: {
						data: trxn
					},
					controller: UpdateTransactionController,
					templateUrl: 'app/main/uploadTransaction/update-transaction-dialog/update-transaction-dialog.html',
					parent: angular.element(document.body),
					targetEvent: trxn,
					clickOutsideToClose: true,
					controllerAs: 'vm'
					// fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
				})
				.then(
					function (answer) {
						console.log('answer: ', answer);
						updateTransactionData(trxn._id, answer);
						$scope.status = 'You said the information was "' + answer + '".';
					},
					function () {
						$scope.status = 'You cancelled the dialog.';
					}
				);
		}

		function successCbUpdateTrxnData(response) {
			vm.dynamicItems = new vm.DynamicItems();
			if (vm.search) {
				searchTransaction();
			}
			showToast(response.data.message);
		}

		function errorCbUpdateTrxnData(response) {
			// errorDialog(response);
			if (response && response.data && response.data.data) {
				showDialog(response.data.message);
			}
		}

		function updateTransactionData(_id, data) {
			ServiceProxy.updateTransaction(vm.transactionType.url, _id, data).then(
				successCbUpdateTrxnData,
				errorCbUpdateTrxnData
			);
		}

		// function errorDialog(response) {
		// 	console.log('response: ', response);
		// 	var message = '';
		// 	if (response.err_desc) {
		// 		message = response.err_desc;
		// 	} else if (response.responseString) {
		// 		message = response.responseString;
		// 	} else {
		// 		message = response;
		// 	}
		// 	var confirm = $mdDialog
		// 		.confirm()
		// 		.title('Upload Details')
		// 		.htmlContent('<b>' + message + '</b>')
		// 		.ariaLabel('delete contact')
		// 		.ok('OK');
		// 	$mdDialog.show(confirm).then(function () {});
		// }

		// transaction search
		function sucessCbSearchUser(response) {
			vm.dynamicItems.loadedPages = {};
			vm.dynamicItems.loadedPages[0] = response.data.data;
			vm.dynamicItems.numItems = response.data.total;
			vm.dynamicItems.PAGE_SIZE = response.data.total;
			vm.dynamicItems.after = 't3_' + response.data.data[response.data.total - 1]._id;
		}

		function errorCbSearchUser(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function searchTransaction() {
			ServiceProxy.searchTransaction(vm.transactionType.url, vm.search).then(
				sucessCbSearchUser,
				errorCbSearchUser
			);
		}
	}

	function UpdateTransactionController($mdDialog, $timeout, $mdToast, ServiceProxy, ShareDataService, data) {
		var vm = this;

		function init() {
			vm.transactionData = {
				investorPan: data.investorPan,
				iin: data.iin,
				folioNumber: data.folioNumber,
				transactionNumber: data.transactionNumber,
				type: data.type
			};
			vm.transactionTypes = [{
					name: 'Lumpsum Purchase',
					code: 'PUR'
				},
				{
					name: 'Systematic Purcahase',
					code: 'SIP'
				},
				{
					name: 'Switch IN',
					code: 'SWIN'
				},
				{
					name: 'Switch Out',
					code: 'SWOF'
				},
				{
					name: 'Redemption',
					code: 'RED'
				},
				{
					name: 'Reversal',
					code: 'RVS'
				},
				{
					name: 'Divident Payout',
					code: 'DIVP'
				},
				{
					name: 'Divident Reinvestment',
					code: 'DIVR'
				},
				{
					name: 'NFO Purchase',
					code: 'NFO'
				},
				{
					name: 'NFO Reversal',
					code: 'NFOR'
				},
				{
					name: 'External Switch In',
					code: 'ESWIN'
				},
				{
					name: 'External Switch Out',
					code: 'ESWOF'
				},
				{
					name: 'Not Consider',
					code: 'NC'
				}
			];
			vm.hide = function (data) {
				$mdDialog.hide(data);
			};

			vm.closeDialog = function () {
				var confirm = $mdDialog
					.confirm()
					.title('Cancel')
					.htmlContent('<b>Are you sure want to cancel ?</b>')
					.ariaLabel('delete contact')
					.ok('OK');
				$mdDialog.show(confirm).then(function () {});

			}
			vm.saveData = function () {
				vm.hide(vm.transactionData);
			};
		}
		init();
	}
})();
(function () {
	'use strict';

	angular.module('app.sipBook', []).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		var fId = 'SIP::INVESTMENT::BOOK::DASHBOARD';
		// State
		$stateProvider.state('app.sipBook', {
				url: '/sipBook',
				views: {
					'content@app': {
						templateUrl: 'app/main/sip-book/sip-book-main/sip-book-main.html',
						controller: 'SipBookController as vm'
					}
				},
				data: {
					access: function () {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.sipBook.schemeInvestment', {
				url: '/schemeInvestment',
				views: {
					'content@app': {
						templateUrl: 'app/main/sip-book/customerDetailsScheme/customerDetailsScheme.html',
						controller: 'CustomerSchemeWiseDetailSipBookController as vm'
					},
				}
			});

		// Translation
		// $translatePartialLoaderProvider.addPart('app/main/uploadTransaction');

		// Api
		// msApiProvider.register('sample', ['app/data/sample/sample.json']);

		// Navigation

		msNavigationServiceProvider.saveItem('DASHBOARD.sipBook', {
			title: 'SIP Book',
			icon: 'icon-tile-four',
			state: 'app.sipBook',
			weight: 5,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
					return false;
				} else {
					return true;
				}
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('app.sipBook').controller('SipBookController', SipBookController);

	/** @ngInject */
	function SipBookController($state, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;

		function init() {
			vm.investmentData = {};
			vm.customers = ShareDataService.getData('schemeInvetsment');
			vm.customerWiseDetials = customerWiseDetials;
			vm.selectTableRow = selectTableRow;
			getAumInvestmentReportSipBook();
			//getAumInvestmentReportsCustomerWiseSipBook();
			//getAumInvestmentReportsSchemeWiseSipBook();
		}
		init();

		////////////////////////////////////////Get AUM Investment details report starts here//////////////////////////////////
		function successGetInvestmentsREports(response) {
			vm.investmentData = response.data.data;
			vm.investmentDataCustomerData = response.data.data.customers;
			vm.investmentDataSchemeWise = response.data.data.schemes;
		}

		function errorGetInvestmentsReports(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAumInvestmentReportSipBook() {
			//ServiceProxy.getAumInvestmentReportSipBook().then(successGetInvestmentsREports, errorGetInvestmentsReports);
			ServiceProxy.getSipBookReport().then(successGetInvestmentsREports, errorGetInvestmentsReports);			
		}

		////////////////////////////////////////Get AUM Investment details report ends here//////////////////////////////////

		////////////////////////////////////////Get Customer Wise data starts here///////////////////////////////////////////
		function successGetInvestmentsREportsCustomer(response) {
			vm.investmentDataCustomerData = response.data.data.customers;
		}

		function errorGetInvestmentsReportsCustomer(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAumInvestmentReportsCustomerWiseSipBook() {
			ServiceProxy.getAumInvestmentReportsCustomerWiseSipBook().then(successGetInvestmentsREportsCustomer, errorGetInvestmentsReportsCustomer);
		}

		function sucessCbUserProfile(response) {
			ShareDataService.storeData('customerDetail', response.data.data);
			$state.go('app.customers.customerhome.userDetail');
		}

		function errorGetUserProfile(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function customerWiseDetials(customer) {
			ServiceProxy.getUserProfile(customer.investorId).then(sucessCbUserProfile, errorGetUserProfile)
		};

		////////////////////////////////////////Get Customer Wise data ends here///////////////////////////////////////////

		////////////////////////////////////////Get Scheme Wise data starts here///////////////////////////////////////////
		function successGetInvestmentsREportsScheme(response) {
			vm.investmentDataSchemeWise = response.data.data.schemes;
		}

		function errorGetInvestmentsReportsScheme(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAumInvestmentReportsSchemeWiseSipBook() {
			ServiceProxy.getAumInvestmentReportsSchemeWiseSipBook().then(successGetInvestmentsREportsScheme, errorGetInvestmentsReportsScheme);
		}

		function selectTableRow(index) {
			ShareDataService.storeData('schemeInvetsment', vm.investmentDataSchemeWise[index]);
			$state.go('app.sipBook.schemeInvestment')
		};

		////////////////////////////////////////Get Scheme Wise data ends here///////////////////////////////////////////


		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
	}
})();
(function () {
    'use strict';

    angular
        .module('app.sipBook')
        .controller('CustomerSchemeWiseDetailSipBookController', CustomerSchemeWiseDetailSipBookController);

    /** @ngInject */
    function CustomerSchemeWiseDetailSipBookController($state, ShareDataService, Service, ServiceProxy) {
        var vm = this;

        function init() {
            vm.customers = ShareDataService.getData('schemeInvetsment');
            if (!vm.customers) {
                $state.go('app.sipBook')
            }
            vm.customerDetailFunction = customerDetailFunction;
        };
        init();

        function sucessCbUserProfile(response) {
            ShareDataService.storeData('customerDetail', response.data.data);
            $state.go('app.customers.customerhome.userDetail');

        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function customerDetailFunction(customer) {
            ServiceProxy.getUserProfile(customer._id).then(sucessCbUserProfile, errorGetUserProfile)
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.serviceConfiguration', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'THIRD::PARTY::SERVER::CONFIG';
        // State
        $stateProvider
            .state('app.serviceConfiguration', {
                url: '/serviceConfiguration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/serviceConfiguration/serviceConfigurationList.html',
                        controller: 'ServiceConfigurationListController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.serviceConfiguration.updateServiceConfiguration1', {
                url: '/updateServiceConfiguration1/:updateId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/serviceConfiguration/serviceConfigurationUpdate/serviceConfigurationUpdate.html',
                        controller: 'ServiceConfigurationUpdateController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.serviceConfiguration.updateServiceConfiguration2', {
                url: '/updateServiceConfiguration2/:updateId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/serviceConfiguration/serviceConfigurationUpdate/serviceConfigurationUpdateAppVer.html',
                        controller: 'ServiceConfigurationUpdateAppVerController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.serviceConfiguration.updateServiceConfiguration3', {
                url: '/updateServiceConfiguration3/:updateId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/serviceConfiguration/serviceConfigurationUpdate/serviceConfigurationUpdateWatti.html',
                        controller: 'ServiceConfigurationUpdateWattiController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            });

        msNavigationServiceProvider.saveItem('CONFIGURATION', {
            title: 'CONFIGURATION',
            weight: 9,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }
        });

        msNavigationServiceProvider.saveItem('CONFIGURATION.serviceConfiguration', {
            title: 'Service Configuration',
            state: 'app.serviceConfiguration',
            icon: 'icon-star',
            weight: 3
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.serviceConfiguration')
        .controller('ServiceConfigurationUpdateWattiController', ServiceConfigurationUpdateWattiController);

    /** @ngInject */
    function ServiceConfigurationUpdateWattiController($rootScope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.userData = {};
            if ($stateParams.updateId) {
                vm.serviceConfigurationId = $stateParams.updateId;
                getServiceConfigurationById(vm.serviceConfigurationId);
            }
            vm.serviceName = sessionStorage.getItem('serviceName');
            vm.referralConfig = {
                signUp: {
                    active: false // Set a default value, or load from existing config
                }
            };
            vm.updateConfiguration = updateConfiguration;
            // Load initial value from session or API if needed
        }
        init();

         //////////////////////////////get service configuration by id starts here////////////////////////////////
         function successCbGetServiceConfigurationById(response) {
            if (response && response.data && response.data.data) {
                vm.buttonStatus = response.data.data.config.FLAG;
                vm.userData = response.data.data;
                vm.userData.config.ACCESS_EXPIARY_DATE = new Date(vm.userData.config.ACCESS_EXPIARY_DATE);
            }
        }

        function errorCbGetServiceConfigurationById(respone) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getServiceConfigurationById(_id) {
            ServiceProxy.getServiceConfigurationById(_id).then(successCbGetServiceConfigurationById, errorCbGetServiceConfigurationById)
        }
        //////////////////////////////get service configuration by id ends here////////////////////////////////

        ////////////////////////update service configuration data starts here//////////////////////////////////
        function successCbUpdateServiceConfiguration(response) {
            // Handle success, maybe show a toast or message
            $state.go('app.serviceConfiguration');
        }

        function errorCbUpdateServiceConfiguration(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function updateConfiguration() {
            // Prepare the data to send
            const dataToSend = {
                serviceName: vm.serviceName,
                FLAG: vm.buttonStatus
            };
            ServiceProxy.updateServiceConfiguration(dataToSend, vm.serviceConfigurationId).then(successCbUpdateServiceConfiguration, errorCbUpdateServiceConfiguration);
        }
        ////////////////////////update service configuration data ends here//////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();

(function() {
    'use strict';

    angular
        .module('app.serviceConfiguration')
        .controller('ServiceConfigurationUpdateAppVerController', ServiceConfigurationUpdateAppVerController);

    /** @ngInject */
    function ServiceConfigurationUpdateAppVerController($rootScope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.userData = {};
            if ($stateParams.updateId) {
                vm.serviceConfigurationId = $stateParams.updateId;
                getServiceConfigurationById(vm.serviceConfigurationId);
            }
            vm.serviceName = sessionStorage.getItem('serviceName');
            vm.updateConfiguration = updateConfiguration;
        };
        init();

         //////////////////////////////get service configuration by id starts here////////////////////////////////
         function successCbGetServiceConfigurationById(response) {
            if (response && response.data && response.data.data) {
                vm.userData = response.data.data;
                vm.userData.config.VERSION = vm.userData.config.VERSION;
                vm.userData.config.ACCESS_EXPIARY_DATE = new Date(vm.userData.config.ACCESS_EXPIARY_DATE);
            }
        }

        function errorCbGetServiceConfigurationById(respone) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getServiceConfigurationById(_id) {
            ServiceProxy.getServiceConfigurationById(_id).then(successCbGetServiceConfigurationById, errorCbGetServiceConfigurationById)
        }
        //////////////////////////////get service configuration by id ends here////////////////////////////////

        ////////////////////////update service configuration data starts here//////////////////////////////////
        function successCbUpdateServiceConfiguration(response) {
            $state.go('app.serviceConfiguration');
        }

        function errorCbUpdateServiceConfiguration(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function updateConfiguration() {
            vm.userData.config.serviceName = vm.serviceName;
            ServiceProxy.updateServiceConfiguration(vm.userData.config, vm.serviceConfigurationId).then(successCbUpdateServiceConfiguration, errorCbUpdateServiceConfiguration)
        }
        ////////////////////////update service configuration data ends here//////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    }
})();
(function() {
    'use strict';

    angular
        .module('app.serviceConfiguration')
        .controller('ServiceConfigurationUpdateController', ServiceConfigurationUpdateController);

    /** @ngInject */
    function ServiceConfigurationUpdateController($rootScope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;
        function init() {
            vm.userData = {};
            if ($stateParams.updateId) {
                vm.serviceConfigurationId = $stateParams.updateId;
                getServiceConfigurationById(vm.serviceConfigurationId);
            }
            vm.serviceName = sessionStorage.getItem('serviceName');
            vm.updateConfiguration = updateConfiguration;
        }
        init();

        vm.minDate = new Date();

        //////////////////////////////get service configuration by id starts here////////////////////////////////
        function successCbGetServiceConfigurationById(response) {
            if (response && response.data && response.data.data) {
                vm.userData = response.data.data;
                vm.userData.config.ACCESS_EXPIARY_DATE = new Date(vm.userData.config.ACCESS_EXPIARY_DATE);
            }
        }

        function errorCbGetServiceConfigurationById(respone) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getServiceConfigurationById(_id) {
            ServiceProxy.getServiceConfigurationById(_id).then(successCbGetServiceConfigurationById, errorCbGetServiceConfigurationById)
        }
        //////////////////////////////get service configuration by id ends here////////////////////////////////

        ////////////////////////update service configuration data starts here//////////////////////////////////
        function successCbUpdateServiceConfiguration(response) {
            $state.go('app.serviceConfiguration');
        }

        function errorCbUpdateServiceConfiguration(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function updateConfiguration() {
            
            vm.userData.config.serviceName = vm.serviceName;
            ServiceProxy.updateServiceConfiguration(vm.userData.config, vm.serviceConfigurationId).then(successCbUpdateServiceConfiguration, errorCbUpdateServiceConfiguration)
        }
        ////////////////////////update service configuration data ends here//////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    }
})();
(function () {
  'use strict';

  angular
    .module('app.schedular', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    //var fId = 'COMMUNICATION::EMAIL::NOTIFICATION';
    // State
    $stateProvider
      .state('app.schedular', {
        url: '/schedular',
        views: {
          'content@app': {
            templateUrl: 'app/main/schedular/schedular.html',
            controller: 'SchedularController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      })
      .state('app.schedular.createschedular', {
        url: '/create/:id/:comingstate/:type',
        views: {
          'content@app': {
            templateUrl: 'app/main/schedular/new-schedular/new-schedular.html',
            controller: 'NewSchedularController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      })
      .state('app.schedular.detail', {
        url: '/detail/:id ',
        views: {
          'content@app': {
            templateUrl: 'app/main/schedular/schedular-detail/schedular-detail.html',
            controller: 'DetailSchedularController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      });

    msNavigationServiceProvider.saveItem('communication.schedular', {
      title: 'Schedular',
      state: 'app.schedular',
      weight: 3,
      icon: 'icon-calendar-clock',
      hidden: function () {
        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
          return false;
        } else {
          return true;
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.schedular')
    .controller('DetailSchedularController', DetailSchedularController);

  /** @ngInject */
  function DetailSchedularController(
    $state,
    $sce,
    $stateParams,
    $mdDialog,
    ServiceProxy,
    ShareDataService
  ) {
    var vm = this;

    function init() {
      vm.trustedHtml = trustedHtml;
      vm.customerType = {
        1: 'Activated IIN',
        2: 'Not Active',
        3: 'No IIN',
        4: ' IIN Active But Zero Investment',
        5: ' SIP Purchased',
        6: ' All Customer',
        7: 'Custom'
      }
      if ($stateParams.id) {
        getSchedularByID($stateParams.id);
      } else {
        $state.go('app.schedular')
      }
    }
    init();

    function trustedHtml(attachment) {
      var string = '/api/notification-scheduler-image/' + attachment.file
      // var url = 'http://docs.google.com/gview?url=http://192.168.1.7:8080/api/notification-scheduler-image/' + attachment.file + '&embedded=true';
      return $sce.trustAsHtml(string);
    }

    function sucessCbGetSchedularByID(response) {

      vm.schedular = response.data.data;
    }

    function errorCbGetSchedularByID(response) {
      if (response && response.data) {
        showDialog(response.data.message);
      } else {
        showDialog('Please Try after sometime');
      }
    }

    function getSchedularByID(id) {
      ServiceProxy.getSchedularByID(id).then(sucessCbGetSchedularByID, errorCbGetSchedularByID)
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.schedular')
    .controller('NewSchedularController', NewSchedularController);

  /** @ngInject */
  function NewSchedularController(
    $state,
    $sce,
    $stateParams,
    $mdDialog,
    ServiceProxy,
    ShareDataService
  ) {
    var vm = this;

    function init() {
      vm.trustAsURL = trustAsURL;
      vm.deleteDialogForAttachment = deleteDialogForAttachment;
      vm.trustedHtml = trustedHtml;
      vm.ngFlowOptions = {
        // You can configure the ngFlow from here
        /*target                   : 'api/media/image',
         chunkSize                : 15 * 1024 * 1024,
         maxChunkRetries          : 1,
         simultaneousUploads      : 1,
         testChunks               : false,
         progressCallbacksInterval: 1000*/
      };

      vm.doc = {
        flow: {}
      }
      vm.docs = [];
      vm.fileAddedDoc = fileAddedDoc;
      vm.uploadDoc = uploadDoc;
      vm.fileSuccessDoc = fileSuccessDoc;
      vm.video = {
        flowObj: {}
      }
      vm.uploadVideo = uploadVideo;
      vm.schedular = {};
      vm.numList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      vm.minuteNumList = [];
      for (var i = 0; i < 60; i++) {
        vm.minuteNumList.push(i);
      }
      if ($state.params.id) {
        getSchedularByID($state.params.id);
      } else {
        vm.cDate = new Date();
        if (vm.cDate.getHours() >= 12) {
          if (vm.cDate.getHours() === 12) {
            vm.schedular.hour = JSON.stringify(vm.cDate.getHours());
          } else {
            vm.schedular.hour = JSON.stringify(vm.cDate.getHours() - 12);
          }

          vm.schedular.meridian = 'PM';
        } else {
          vm.schedular.hour = JSON.stringify(vm.cDate.getHours());
          vm.schedular.meridian = 'AM';
        }

        vm.schedular.minute = JSON.stringify(vm.cDate.getMinutes());
      }



      if ($state.params.comingstate === 'custom') {
        // vm.schedular.channel = $state.params.channel;
        if ($state.params.comingstate === 'custom') {
          vm.schedular = ShareDataService.getData('schedularData');
          if (ShareDataService.getData('selectedCustomer')) {
            vm.selectedCustomer = ShareDataService.getData('selectedCustomer');
          }

        }
      }
      vm.customerCount = customerCount;
      vm.saveSchedular = saveSchedular;
    }
    init();

    function trustAsURL(string) {
      var file = new Blob([string], {
        type: 'application/pdf'
      });
      var fileURL = URL.createObjectURL(file);
      return $sce.trustAsResourceUrl(string);
    }

    function trustedHtml(attachment) {
      var string = '/api/notification-scheduler-image/' + attachment.file
      // var url = 'http://docs.google.com/gview?url=http://192.168.1.7:8080/api/notification-scheduler-image/' + attachment.file + '&embedded=true';
      return $sce.trustAsHtml(string);
    }

    function customerCount(filter) {
      vm.schedular.filter = filter;
      if (vm.schedular.filter === 7) {
        ShareDataService.storeData('schedularData', vm.schedular);
        $state.go('app.communication.custom', {
          fromState: 'schedular'
        });
      }
    }
    ///////// schedular create start//////////////////////

    function sucessCbSaveSchedular(response) {

      if (vm.doc.flow.files.length > 0 && vm.schedular.channel !== 'SMS') {
        angular.forEach(vm.doc.flow.files, function (item) {
          uploadAttachments(response.data.data._id, item)
        })
      }

      $state.go('app.schedular');
    }

    function errorCbSaveSchedular(response) {
      if (response && response.data) {
        showDialog(response.data.message);
      } else {
        showDialog('Please Try after sometime');
      }
    }

    function saveSchedular() {
      if (!vm.schedular.filter) {
        return showDialog('Please Select Filter of Customers')
      }
      var sDate = new Date(vm.schedular.date);
      var data = {
        name: vm.schedular.name,
        date: sDate.getTime(),
        hour: null,
        minute: +vm.schedular.minute,
        channel: vm.schedular.channel,
        bodyContent: vm.schedular.bodyContent,
        filter: vm.schedular.filter
      };
      if (vm.schedular.meridian === 'AM' && +vm.schedular.hour === 12) {
        data.hour = 0;
      } else if (vm.schedular.meridian === 'PM' && +vm.schedular.hour < 12) {
        data.hour = +vm.schedular.hour + 12;
      } else {
        data.hour = +vm.schedular.hour;
      }
      if (vm.schedular.channel === 'EMAIL') {
        data.subject = vm.schedular.subject;
      }
      if (vm.schedular.filter === 7) {
        data.users = [];
        angular.forEach(vm.selectedCustomer, function (custmr) {
          data.users.push(custmr._id);
        });
      } else {
        data.users = [];
      }
      if (vm.schedular._id) {
        ServiceProxy.updateSchedular(vm.schedular._id, data).then(
          sucessCbSaveSchedular,
          errorCbSaveSchedular
        );
      } else {
        ServiceProxy.saveSchedular(data).then(
          sucessCbSaveSchedular,
          errorCbSaveSchedular
        );
      }

    }
    ///////// schedular create  end ///////////////////////
    function showDialog(response) {
      var confirm = $mdDialog
        .confirm()
        .title('!!Error!!')
        .textContent(response)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {}, function () {});
    }

    vm.deleteUser = function (index) {
      vm.selectedCustomer.splice(index, 1);
      if (vm.selectedCustomer.length === 0) {
        vm.selectedFlag = null;
      }
    };


    function sucessCbGetSchedularByID(response) {
      vm.schedular = response.data.data;
      if (vm.schedular.hour >= 12) {
        vm.schedular.hour = JSON.stringify(response.data.data.hour - 12);
        vm.schedular.meridian = 'PM'
      } else {
        vm.schedular.hour = JSON.stringify(response.data.data.hour);
        vm.schedular.meridian = 'AM'
      }
      vm.schedular.minute = JSON.stringify(response.data.data.minute);
      vm.schedular.date = new Date(vm.schedular.date);
      if (vm.schedular.filter === 7) {
        vm.selectedCustomer = response.data.data.users;
      } else {
        vm.selectedCustomer = [];
      }

      if ($state.params.type) {
        vm.schedular._id = null;
      }

    }

    function errorCbGetSchedularByID(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try after sometime');
      }
    }

    function getSchedularByID(id) {
      ServiceProxy.getSchedularByID(id).then(sucessCbGetSchedularByID, errorCbGetSchedularByID)
    }

    ///////////////////////video upload starts here////////////////////////////

    function uploadVideo() {
      var fileInput = document.getElementById('video');
      vm.fileUrl = window.URL.createObjectURL(fileInput.files[0]);
      // $(".video").attr("src", fileUrl);
    }

    /////////////////////////Document upload//////////////////////


    function uploadDoc() {

      // Set headers
      vm.doc.flow.opts.headers = {
        'X-Requested-With': 'XMLHttpRequest',
        //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
      };

      vm.doc.flow.upload();
    }

    function fileAddedDoc(file) {
      var format;
      var videoFormat = ['mp4', 'mov', 'mpg', '3gp', 'avi', 'wmv', 'webm', '3gpp'];
      var imageFormat = ['png', 'jpg', 'jpeg', 'tiff'];
      var currentDocType = file.name.split('.')[1];
      if (currentDocType === 'csv') {
        format = 'CSV'
      } else if (currentDocType === 'pdf') {
        format = 'PDF'
      } else if (currentDocType === 'xlsx' || currentDocType === 'xls') {
        format = 'EXCEL'
      } else if (videoFormat.indexOf(currentDocType) > -1) {
        format = 'VIDEO'
      } else if (imageFormat.indexOf(currentDocType) > -1) {
        format = 'IMAGE'
      }
      // Prepare the temp file data for media list
      var uploadingFile = {
        id: file.uniqueIdentifier,
        file: file,
        type: vm.docType,
        format: format
      };
      // Append it to the media list
      vm.docs.unshift(uploadingFile);
    }

    function fileSuccessDoc(file, message) {

      // Iterate through the media list, find the one we
      // are added as a temp and replace its data
      // Normally you would parse the message and extract
      // the uploaded file data from it
      angular.forEach(vm.docs, function (media, index) {
        if (media.id === file.uniqueIdentifier) {
          // Normally you would update the media item
          // from database but we are cheating here!
          var fileReader = new FileReader();
          fileReader.readAsDataURL(media.file.file);
          fileReader.onload = function (event) {
            media.url = event.target.result;
          };

          // Update the image type so the overlay can go away
          media.type = 'doc';
        }
      });
    }

    //////////// API for upload attachments///////////////

    function sucessCbUploadAttachments(response) {}

    function errorCbUploadAttachments(response) {}

    function uploadAttachments(id, data) {
      var format;
      var videoFormat = ['mp4', 'mov', 'mpg', '3gp', 'avi', 'wmv', 'webm', '3gpp'];
      var imageFormat = ['png', 'jpg', 'jpeg', 'tiff'];
      var currentDocType = data.name.split('.')[1];
      if (currentDocType === 'csv') {
        format = 'CSV'
      } else if (currentDocType === 'pdf') {
        format = 'PDF'
      } else if (currentDocType === 'xlsx' || currentDocType === 'xls') {
        format = 'EXCEL'
      } else if (videoFormat.indexOf(currentDocType) > -1) {
        format = 'VIDEO'
      } else if (imageFormat.indexOf(currentDocType) > -1) {
        format = 'IMAGE'
      }
      var formData = new FormData();
      formData.append("document", data.file);
      ServiceProxy.uploadAttachments(id, format, formData).then(sucessCbUploadAttachments, errorCbUploadAttachments)
    }


    // function to delete schedular attachments/////////

    function sucessCbDeleteSchedularAttachments(response, itemObj) {
      var index = vm.schedular.attachments.findIndex(function (item) {
        return item._id === itemObj._id
      })
      vm.schedular.attachments.splice(index, 1)
    }

    function errorCbDeleteSchedularAttachments(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try after sometime');
      }
    }

    function deleteSchedularAttachments(item) {
      var data = {
        "attachments": [{
          "_id": item._id,
          "type": item.type,
          "file": item.file
        }]
      }
      ServiceProxy.deleteSchedularAttachments($state.params.id, data).then(function (response) {
        sucessCbDeleteSchedularAttachments(response, item)
      }, errorCbDeleteSchedularAttachments)
    }

    function deleteDialogForAttachment(item) {
      var confirm = $mdDialog
        .confirm()
        .title('!!Error!!')
        .textContent('Do Youy want to delete this attachment?')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function (res) {
        if (res && item._id) {
          deleteSchedularAttachments(item);
        } else {
          var index = vm.doc.flow.files.findIndex(function (obj) {
            return obj.uniqueIdentifier === item.id
          });
          vm.doc.flow.files.splice(index, 1)
          var indexDocs = vm.docs.findIndex(function (obj) {
            return obj.id === item.id
          });
          vm.docs.splice(indexDocs, 1)
        }
      }, function () {});
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.referral', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    var fId = 'REFERRAL::CONFIG';
    // State
    $stateProvider
      .state('app.referral', {
        url: '/referralconfig',
        views: {
          'content@app': {
            templateUrl: 'app/main/referral/configuration/configuration.html',
            controller: 'ConfigurationController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      })
      .state('app.referraltransfers', {
        url: '/referraltransfers',
        views: {
          'content@app': {
            templateUrl: 'app/main/referral/referral-transfers/referral-transfers.html',
            controller: 'ReferralTransfersController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      })
      .state('app.referraltransfers.amount', {
        url: '/transferamount',
        views: {
          'content@app': {
            templateUrl: 'app/main/referral/transfer-amount/transfer-amount.html',
            controller: 'TransferAmountController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      })
      .state('app.referraltransfers.amount.detail', {
        url: '/referraldetail',
        views: {
          'content@app': {
            templateUrl: 'app/main/referral/referral-detail/referral-detail.html',
            controller: 'ReferralDetailController as vm'
          }
        }
      });

    msNavigationServiceProvider.saveItem('referral', {
      title: 'REFERRAL',
      weight: 9,
      hidden: function () {
        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
          return false;
        } else {
          return true;
        }
      }
    });

    // msNavigationServiceProvider.saveItem('referral.dashboard', {
    //   title: 'Dashboard',
    //   state: 'app.referraldashboard',
    //   icon: 'icon-people',
    //   weight: 1
    // });

    msNavigationServiceProvider.saveItem('referral.configuration', {
      title: 'Configuration',
      state: 'app.referral',
      icon: 'icon-people',
      weight: 1
    });

    msNavigationServiceProvider.saveItem('referral.transfers', {
      title: 'Transfers',
      state: 'app.referraltransfers',
      icon: 'icon-people',
      weight: 2
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('app.referral')
    .controller('TransferAmountController', TransferAmountController);

  /** @ngInject */
  function TransferAmountController($state, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
    var vm = this;

    function init() {
      vm.getHistory = getHistory;
      vm.toggleSidenav = toggleSidenav('rightHistory')
      vm.creditgReferralAmount = creditgReferralAmount;
      vm.getReferenceCodeDialog = getReferenceCodeDialog;
      vm.getReferralTransactionByStatus = getReferralTransactionByStatus;
      vm.getCompletedReferralTransaction = getCompletedReferralTransaction;
      vm.getReferralTransactionByStatus('PENDING');
    };
    init();

    function getHistory(user) {
      vm.activeUser = user;
      getReferralTransactionHistory(user.user._id)
    }

    function toggleSidenav(componentId) {
      return function () {
        $mdSidenav(componentId).toggle();
      };
    }

    function sucessCbGetReferralTransactionByStatus(response) {
      vm.usersData = response.data.data;
    }

    function errorCbGetReferralTransactionByStatus(response) {
      showDialog(response.data.responseString);
    }

    function getReferralTransactionByStatus(status) {
      ServiceProxy.getReferralTransactionByStatus(status).then(sucessCbGetReferralTransactionByStatus, errorCbGetReferralTransactionByStatus)
    }

    function sucessCbGetCompletedReferralTransaction(response) {
      vm.completedTransaction = response.data.data;
    }

    function errorCbGetCompletedReferralTransaction(response) {
      showDialog(response.data.responseString);
    }

    function getCompletedReferralTransaction() {
      ServiceProxy.getReferralTransactionByStatus('DONE').then(sucessCbGetCompletedReferralTransaction, errorCbGetCompletedReferralTransaction)
    }
    // API Call To credit Referral Amount
    function sucessCbCreditgReferralAmount(response) {
      vm.getReferralTransactionByStatus('PENDING');
    }

    function errorCbCreditgReferralAmount(response) {
      showDialog(response.data.responseString);
    }

    function creditgReferralAmount(transactionId, status, referenceCode) {
      var data;
      if (referenceCode) {
        data = {
          "transactionId": transactionId,
          "status": status,
          "remarks": 'Your Amazon Gift Code is "' + referenceCode + '"',
          "referenceCode": referenceCode
        };
      } else {
        data = {
          "transactionId": transactionId,
          "status": status,
          "remarks": "tranfred from sipfund",
        };
      }
      ServiceProxy.creditgReferralAmount(data).then(sucessCbCreditgReferralAmount, errorCbCreditgReferralAmount);
    }
    ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
    function showDialog(response) {
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {});
    };
    ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////


    // get reference code forn transfer amount dialog start
    function getReferenceCodeDialog(item) {
      var required = true;
      var confirm = $mdDialog.prompt()
        .title('Enter Reference Code of ' + item.user.userName)
        // .placeholder('Reference Code')
        // .ariaLabel('Reference Code')
        // .initialValue('')
        .ok('Submit')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function (result) {
        if (result) {
          creditgReferralAmount(item._id, 'DONE', result)
        } else {
          showDialog('Reference Code is required.')
        }
        // $scope.status = 'You decided to name your dog ' + result + '.';
      }, function () {
        // $scope.status = 'You didn\'t name your dog.';
      });
    }

    /////////////////get transaction history///////////

    function sucessCbGetReferralTransactionHistory(response) {
      vm.referralTransactionData = response.data.data;
      vm.toggleSidenav();
    }

    function errorCbGetReferralTransactionHistory(response) {}

    function getReferralTransactionHistory(userId) {
      ServiceProxy.getReferralTransactionHistory(userId).then(sucessCbGetReferralTransactionHistory, errorCbGetReferralTransactionHistory)
    }
  }
})();
(function() {
	'use strict';

	angular.module('app.referral').controller('ReferralDetailController', ReferralDetailController);

	/** @ngInject */
	function ReferralDetailController($state, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;

		function init() {
			// vm.infiniteItems = {
			//   numLoaded_: 0,
			//   toLoad_: 0,

			//   // Required.
			//   getItemAtIndex: function (index) {
			//     if (index > this.numLoaded_) {
			//       this.fetchMoreItems_(index);
			//       return null;
			//     }

			//     return index;
			//   },
			//   getLength: function () {
			//     return this.numLoaded_ + 5;
			//   },
			//   fetchMoreItems_: function (index) {
			//     // For demo purposes, we simulate loading more items with a timed
			//     // promise. In real code, this function would likely contain an
			//     // $http request.

			//     if (this.toLoad_ < index) {
			//       this.toLoad_ += 20;
			//       $timeout(angular.noop, 300).then(angular.bind(this, function () {
			//         this.numLoaded_ = this.toLoad_;
			//       }));
			//     }
			//   }
			// }
			vm.selectedFilter = selectedFilter;
			vm.allReferral = [];
			// for (var i = 0; i < 100; i++) {
			//   vm.allReferral.push(i);
			// }

			getAllReferralDetails();
		}
		init();

		function selectedFilter(type) {
			if (vm.filterType !== type) {
				vm.filterType = type;
				vm.allReferral = vm.referralData.users.filter(function(item) {
					return (
						item.rfdSignupAmountStatus === type ||
						item.rfySignupAmountStatus === type ||
						item.rfdIINAmountStatus === type ||
						item.rfyIINAmountStatus === type ||
						item.rfdActiveAmountStatus === type ||
						item.rfyActiveAmountStatus === type ||
						item.rfdInvestAmountStatus === type ||
						item.rfyInvestAmountStatus === type
					);
				});
			} else {
				vm.filterType = null;
				vm.allReferral = vm.referralData.users;
			}
		}

		function sucessCbGetAllReferralDetails(response) {
			vm.referralData = response.data.data;
			vm.allReferral = response.data.data.users;
		}

		function errorCbGetAllReferralDetails(response) {}

		function getAllReferralDetails() {
			ServiceProxy.getAllReferralDetails().then(sucessCbGetAllReferralDetails, errorCbGetAllReferralDetails);
		}

		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function() {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
	}
})();

(function () {
  'use strict';

  angular
    .module('app.referral')
    .controller('ReferralTransfersController', ReferralTransfersController);

  /** @ngInject */
  function ReferralTransfersController($state, $mdDialog, ShareDataService, ServiceProxy) {
    var vm = this;

    function init() {
      vm.goToPendingReferral = goToPendingReferral;
      getReferralConsilidatedData();
      getConsolidatedReferralStatus();
    };
    init();

    function goToPendingReferral() {
      $state.go('app.referraltransfers.amount');
    }

    // function to get coinsilidated report of referral
    function sucessCbGetReferralConsilidatedData(response) {
      vm.consilidatedReferralAmount = response.data.data;
    }

    function errorCbGetReferralConsilidatedData(response) {
      showDialog(response.data.responseString)
    }

    function getReferralConsilidatedData() {
      ServiceProxy.getReferralConsilidatedData().then(sucessCbGetReferralConsilidatedData, errorCbGetReferralConsilidatedData)
    }

    //// dashboard consolidated
    function sucessCbGetConsolidatedReferralStatus(response) {
      vm.data = response.data.data;
    }

    function errorCbGetConsolidatedReferralStatus(response) {
      showDialog(response.data.responseString);
    }

    function getConsolidatedReferralStatus() {
      ServiceProxy.getConsolidatedReferralStatus().then(sucessCbGetConsolidatedReferralStatus, errorCbGetConsolidatedReferralStatus)
    }

    ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
    function showDialog(response) {
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {});
    };
    ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
  }
})();
(function() {
	'use strict';

	angular.module('app.referral').controller('ConfigurationController', ConfigurationController);

	/** @ngInject */
	function ConfigurationController($state, $mdDialog, ShareDataService, ServiceProxy, $mdToast) {
		var vm = this;

		function init() {
			vm.referralConfig = {};
			getReferralConfig();
			vm.redemptionConditionKey = [
				{
					key: 'NO:CONDITION',
					value: 'No Condition'
				},
				{
					key: 'INVESTMENT',
					value: 'On First Time Investment'
				}
			];
			vm.referralConditionKey = [
				{
					key: 'NO:CONDITION',
					value: 'No Condition'
				},
				{
					key: 'INVESTMENT',
					value: 'On First Time Investment'
				},
				{
					key: 'ACTIVATION',
					value: 'On Account Activation'
				}
			];

			vm.setReferralConfig = setReferralConfig;
		}
		init();

		function sucessCbGetReferralConfig(response) {
			vm.referralConfig = response.data.data;
		}

		function errorCbGetReferralConfig(response) {
			showDialog(response.data.responseString);
		}

		function getReferralConfig() {
			ServiceProxy.getReferralConfig().then(sucessCbGetReferralConfig, errorCbGetReferralConfig);
		}

		// API To set referral data
		function sucessCbSetReferralConfig(response) {
			if (vm.saveMode) {
				vm.saveMode = !vm.saveMode;
			}
			$mdToast.show(
				$mdToast
					.simple()
					.textContent(response.data.responseString)
					.position('top right')
					.hideDelay(3000)
					.toastClass('success')
			);
		}

		function errorCbSetReferralConfig(response) {
			getReferralConfig();
			showDialog(response.data.responseString);
		}

		function setReferralConfig() {
			var postData = {
				signUp: {
					rfyAmount: vm.referralConfig.signUp.rfyAmount,
					rfdAmount: vm.referralConfig.signUp.rfdAmount,
					active: vm.referralConfig.signUp.active
				},
				createdIIN: {
					rfyAmount: vm.referralConfig.createdIIN.rfyAmount,
					rfdAmount: vm.referralConfig.createdIIN.rfdAmount,
					active: vm.referralConfig.createdIIN.active
				},
				activeIIN: {
					rfyAmount: vm.referralConfig.activeIIN.rfyAmount,
					rfdAmount: vm.referralConfig.activeIIN.rfdAmount,
					active: vm.referralConfig.activeIIN.active
				},
				investment: {
					rfyAmount: vm.referralConfig.investment.rfyAmount,
					rfdAmount: vm.referralConfig.investment.rfdAmount,
					active: vm.referralConfig.investment.active
				},
				active: vm.referralConfig.active,
				redemptionConditions: vm.referralConfig.redemptionConditions,
				referralConditions: vm.referralConfig.referralConditions,
				minimumSipAmount: vm.referralConfig.minimumSipAmount,
				minimumLumpsumAmount: vm.referralConfig.minimumLumpsumAmount
			};

			ServiceProxy.setReferralConfig(postData).then(sucessCbSetReferralConfig, errorCbSetReferralConfig);
		}

		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function() {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
	}
})();

(function () {
    'use strict';

    angular
        .module('app.pushNotification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'COMMUNICATION::EMAIL::NOTIFICATION';
        var fId2 = 'MESSAGE::SMS';
        // State
        $stateProvider
            .state('app.pushNotificationList', {
                url: '/pushNotificationList',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pushNotification/pushMsgNotification/pushMsgNotifaction.html',
                        controller: 'PushNotificationMsgController as vm'

                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                },
                bodyClass: 'profile'
            })
            .state('app.pushNotificationList.pushNotificationMsg', {
                url: '/pushNotificationMsg',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pushNotification/pushNotification.html',
                        controller: 'PushNotificationListController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                },
                bodyClass: 'profile'
            });

        // $translatePartialLoaderProvider.addPart('app/main/pushNotification');
        // Api
        // msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
        // msApiProvider.register('profile.about', ['app/data/profile/about.json']);
        // msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);

        // Navigation
         msNavigationServiceProvider.saveItem('communication', {
            title: 'COMMUNICATION',
            weight: 4,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && ((window.sessionStorage.getItem('feature').indexOf(fId) !== -1) || (window.sessionStorage.getItem('feature').indexOf(fId2) !== -1)))) {
                    return false;
                } else {
                    return true;
                }
            }

        });
      
        msNavigationServiceProvider.saveItem('communication.pushNotificationList', {
            title: 'Push Notification',
            icon: 'icon-border-color',
            state: 'app.pushNotificationList',
            weight: 1,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (window.sessionStorage.getItem('feature').indexOf(fId) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pushNotification')
        .controller('PushNotificationMsgController', PushNotificationMsgController);

    /** @ngInject */
    function PushNotificationMsgController($rootScope, $mdDialog, $scope, $state, $sce, $location, ServiceProxy, ShareDataService) {
        var vm = this;
        vm.imageFile = {
            flowObj: {}
        };

        function init() {
            vm.selected = [];
            if (ShareDataService.getData('selectedCustomerPushNotification')) {
                vm.selectedCustomer = ShareDataService.getData('selectedCustomerPushNotification');
                vm.selectedFilter = vm.selectedCustomer.length;
                if (vm.selectedCustomer.length > 0) {
                    vm.selectedFlag = 7;
                }
            }
            vm.pushNotificationSubmit = pushNotificationSubmit;
            vm.customerCount = customerCount;
            vm.uploadImageNotification = uploadImageNotification;
        };
        init();

        ////////////////////////////send email to customer api starts here/////////////////////////////
        function sucessCbGetAllPushEmail(response) {
            $state.go('app.pushNotificationList');
            vm.description = '';
            vm.sucessImgRes = '';
            vm.responseImage = '';
            vm.selectedFilter = [];
            vm.imageFile = {
                flowObj: {}
            };
            showDialogSucc(response.data.responseString);
        }

        function errorCbGetAllPushEmail(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function pushNotificationSubmit() {
            var postData = {
                description: vm.description,
                image: vm.sucessImgRes,
                userIds: []
            }
            angular.forEach(vm.selectedCustomer, function (item) {
                postData.userIds.push(item._id)
            })
            ServiceProxy.createNotificationEmail(postData, vm.selectedFlag).then(sucessCbGetAllPushEmail, errorCbGetAllPushEmail);
        }

        ////////////////////////////////////send email to customer api ends here//////////////////////////////

        ////////////////////////////////uploads image for notification starts here//////////////////////////
        function sucessCbGetImage(response) {
            vm.sucessImgRes = response.data.image;
            vm.responseImage = response.data.baseUrl + vm.sucessImgRes
        }

        function errorCbGetImage(response) {
            vm.sucessImgRes = null;
            vm.responseImage = null;
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function uploadImageNotification(imgData) {
            var data = new FormData();
            data.append("image", imgData);
            ServiceProxy.uploadImageNotification(data).then(sucessCbGetImage, errorCbGetImage);
        }
        /////////////////////////////////uploads image for notification ends here/////////////////

        // image upload
        $scope.processFile = function (files) {

            var fileReader = new FileReader();
            var image = new Image();
            var validExts = new Array(".jpeg", ".jpg", ".png");
            var fileExt = files[0].name;

            fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
            if (validExts.indexOf(fileExt) < 0) {
                showDialog("Invalid file selected, valid files are of " +
                    validExts.toString() + " types.");
                $(files[0]).val("");
                return false;
            };

            fileReader.readAsDataURL(files[0].file);
            uploadImageNotification(files[0].file)

        };


        //////////////////////////////delete the customer selected for msg starts here///////////////////////////
        vm.deleteUser = function (index) {
            vm.selectedCustomer.splice(index, 1);
            if (vm.selectedCustomer.length == 0) {
                vm.selectedFlag = null;
            }
            vm.selectedFilter = vm.selectedCustomer.length;
        }
        //////////////////////////////delete the customer selected for msg ends here///////////////////////////


        /// selected Filter
        function customerCount(filter, type) {
            if (filter === vm.selectedFlag) {
                vm.selectedFlag = null;
                vm.selectedFilter = null;
            } else {
                vm.selectedFlag = filter;
                vm.selectedFilter = type;
            }
            vm.selectedCustomer = [];
        }

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
    }
})();
(function () {
	'use strict';
	angular.module('app.products', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		var fId = 'THIRD::PARTY::SERVER::PRODUCT';

		$stateProvider
			.state('app.products', {
				url: '/products',
				views: {
					'content@app': {
						templateUrl: 'app/main/products/products.html',
						controller: 'ProductsController as vm'
					}
				},
				data: {
					access: function () {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.productsList', {
				url: '/productsList/:productsListID?amc=&newAmcCode=',
				views: {
					'content@app': {
						templateUrl: 'app/main/products/products-list/products-list.html',
						controller: 'ProductsListController as vm'
					}
				},
				data: {
					access: function () {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			});

		msNavigationServiceProvider.saveItem('SCHEMES', {
			title: 'SCHEMES MANAGEMENT',
			weight: 5,
			hidden: function () {
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
					return false;
				} else {
					return true;
				}
			}
		});

		msNavigationServiceProvider.saveItem('SCHEMES.products', {
			title: 'Schemes',
			state: 'app.products',
			icon: 'icon-tile-four',
			weight: 1,
			hidden: function () {
				if (
					JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
					(window.sessionStorage.getItem('feature') &&
						JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
				) {
					return false;
				} else {
					return true;
				}
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('app.products').controller('ProductsListController', ProductsListController);

	function ProductsListController(
		$scope,
		$mdSidenav,
		$stateParams,
		$mdDialog,
		ServiceProxy,
		ShareDataService,
		StorageService,
		$mdToast
	) {
		var vm = this;
		vm.editAmcSideNav = buildToggler('closeEventsDisabled');

		function init() {
			vm.displayCategory = [];
			vm.displaySubCategory = [];
			vm.product = {};
			vm.allSchemes = [];
			vm.selectedIndex = 0;
			vm.selectedTab = 'IN_ACTIVE';
			vm.getAllScheme = getAllScheme;
			vm.product_amc = $stateParams.amc;
			vm.newAmcCode = $stateParams.newAmcCode;
			if ($stateParams.productsListID) {
				vm.getAllScheme('ACTIVE');
			}
			vm.updateSchme = updateSchme;
			getProductDisplayCategory();
			getProductDisplaySubCategory();
			vm.startSyncing = startSyncing;
			vm.closeNFODialog = closeNFODialog;
			vm.updateISIN = true;
			vm.enableEditISIN = function () {
				vm.updateISIN = !vm.updateISIN;
			};
		}
		init();

		function buildToggler(componentId) {
			return function () {
				$mdSidenav(componentId).toggle();
			};
		}

		//////////////////////////////////////starts all scheme here//////////////////////////////////////////
		function sucessCbGetAllScheme(response) {
			if (response.data && response.data.data) {
				vm.allSchemes = [];
				vm.allSchemes = response.data.data;
				vm.activeData = [];
				vm.inactiveData = [];
				vm.activeNFO = [];
				vm.inActiveNFO = [];
				if (vm.selectedTab === 'IN_ACTIVE') {
					vm.inactiveData = response.data.data;
				} else if (vm.selectedTab === 'ACTIVE') {
					vm.activeData = response.data.data;
				} else if (vm.selectedTab === 'ACTIVE_NFO') {
					vm.activeNFO = response.data.data;
				} else if (vm.selectedTab === 'IN_ACTIVE_NFO') {
					vm.inActiveNFO = response.data.data;
				}
			}
		}

		function errorCbGetAllScheme(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAllScheme(filter) {
			vm.activeData = [];
			vm.inactiveData = [];
			vm.activeNFO = [];
			vm.inActiveNFO = [];
			vm.selectedTab = filter;
			ServiceProxy.getAllSchemeProductList($stateParams.productsListID, vm.selectedTab).then(
				sucessCbGetAllScheme,
				errorCbGetAllScheme
			);
		}

		vm.getSchemeDetails = function (item) {
			vm.product = JSON.parse(JSON.stringify(item));
			// vm.product.productName = item.productName;
			// vm.product.productISIN = item.productISIN;
			// vm.product.productDisplayName = item.productDisplayName || item.productName;
			// vm.product.productDisplayCategory = item.productDisplayCategory;
			// vm.product.exitLoad = item.exitLoad;
			// vm.product.minimumPurchaseAmount = item.minimumPurchaseAmount;
			// vm.product.NFO = item.NFO;
			// vm.product.active = item.active;
			vm.product.id = vm.product._id;
			// vm.product.nfoCloseDate = new Date(vm.product.nfoCloseDate);
			vm.product.nfoCloseDate = new Date();
		};

		function sucessCbUpdateAllScheme(response) {
			if (vm.product.active) {
				vm.selectedIndex = 0;
			} else {
				vm.selectedIndex = 1;
			}
			vm.editAmcSideNav();
			getAllScheme($stateParams.productsListID);
		}

		function errorCbUpdateAllScheme(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		// vm.updateSchme = function() {
		// 	ServiceProxy.updateAmcProduct(vm.product.id, vm.product).then(
		// 		sucessCbUpdateAllScheme,
		// 		errorCbUpdateAllScheme
		// 	);
		// };

		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

		// function to update scemes

		function successCbUpdateSceheme(response) {
			vm.product = null;
			vm.toggleSubCate = false;
			vm.toggleCat = false;
			vm.editAmcSideNav();
			getAllScheme(vm.selectedTab);
			getProductDisplaySubCategory();
			getProductDisplayCategory();
		}

		function errorCbUpdateSceheme(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}else{
				showDialog(response.data.responseString);
			}
		}

		function updateSchme() {
			if (vm.product.NFO && vm.product.nfoCloseDate) {
				vm.product.nfoCloseDate = new Date(vm.product.nfoCloseDate).getTime();
			} else {
				vm.product.nfoCloseDate = null;
			}

			ServiceProxy.updateSchems(vm.product.id, vm.product).then(successCbUpdateSceheme, errorCbUpdateSceheme);
		}

		//public get product display category
		function successCbDispCate(response) {
			vm.displayCategory = response.data.data;
		}

		function errorCbDispCate(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getProductDisplayCategory() {
			ServiceProxy.getProductCategory('CATEGORY').then(successCbDispCate, errorCbDispCate);
		}

		function successCbDispSubCate(response) {
			vm.displaySubCategory = response.data.data;
		}

		function errorCbDispSubCate(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getProductDisplaySubCategory() {
			ServiceProxy.getProductCategory('SUB_CATEGORY').then(successCbDispSubCate, errorCbDispSubCate);
		}

		function successStartSyncing(response) {
			$mdToast.show(
				$mdToast
				.simple()
				.textContent(response.data.message)
				.position('top right')
				.hideDelay(3000)
			);
		}

		function errorStartSyncing(response) {
			vm.disableBtn = false;
		}

		function successSyncSchemeFromNSE(response) {
			vm.disableBtn = false;
			$mdToast.show(
				$mdToast
				.simple()
				.textContent(response.data.message)
				.position('top right')
				.hideDelay(5000)
			);
			getAllScheme(vm.selectedTab);
		}

		function errorSyncSchemeFromNSE(response) {
			vm.disableBtn = false;
			if (response && response.data && response.data.message) {
				showDialog(response.data.message);
			}
		}

		function startSyncing() {
			vm.disableBtn = true;
			ServiceProxy.startSyncingOfSncing($stateParams.productsListID).then(successStartSyncing, errorStartSyncing);
			ServiceProxy.syncSchemeFromNSE($stateParams.productsListID, vm.newAmcCode).then(successSyncSchemeFromNSE, errorSyncSchemeFromNSE);
		}

		function successCbCloseNFO(response) {
			$mdToast.show(
				$mdToast
				.simple()
				.textContent(response.data.message)
				.position('top right')
				.hideDelay(3000)
			);
			getAllScheme(vm.selectedTab);
		}

		function errorCbCloseNFO(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function closeNFODialog(schm) {
			var nfoData = {
				NFO: false,
				nfoCloseDate: new Date().getTime()
			};
			var confirm = $mdDialog
				.confirm()
				// .title('Would you close the NFO?')
				.textContent('Would you close the NFO ' + schm.productName + ' ?')
				.ariaLabel('Lucky day')
				// .targetEvent(ev)
				.ok('Yes')
				.cancel('NO');

			$mdDialog.show(confirm).then(
				function () {
					ServiceProxy.closeNFO(schm.id, nfoData).then(successCbCloseNFO, errorCbCloseNFO);
				},
				function () {}
			);
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app.otherTransaction', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.otherTransaction', {
				url: '/othertransaction',
				views: {
					'content@app': {
						templateUrl: 'app/main/other-transaction/other-transaction.html',
						controller: 'otherTransactionController as vm'
					}
				}
			})
            
			.state('app.otherTransaction.validatesiptxrn', {
				url: '/otherTransaction/validatesiptxrn',
				views: {
					'content@app': {
						templateUrl: 'app/main/other-transaction/sip-trxn-validate-list/sip-txrn-validate-list.html',
						controller: 'validateSipTxrnController as vm'
					}
				}
			});


		msNavigationServiceProvider.saveItem('TRANSACTION.otherTransaction', {
			title: 'Other Transaction',
			icon: 'icon-tile-four',
			state: 'app.otherTransaction',
			weight: 1
		});
	}
})();

(function () {
    'use strict';

    angular
        .module('app.otherTransaction')
        .controller('validateSipTxrnController', validateSipTxrnController);

    /** @ngInject */
    function validateSipTxrnController($state, ShareDataService, Service, ServiceProxy) {
        var vm = this;

        function init() {
            vm.schemes = ShareDataService.getData('sipTrxnData');
            if (!vm.schemes) {
                $state.go('app.other-transaction')
            }
        };
        init();

    }
})();
(function () {

	'use strict';


	angular.module('app.sub-broker-customer').controller('subBrokerCustomerController', subBrokerCustomerController);
	

	/** @ngInject */
	function subBrokerCustomerController($mdDialog, ServiceProxy,$window, StorageService, $state) {
		var vm = this;
		
		function init() {
			vm.customers = {};
			vm.fromDate = null;
			vm.uptoDate = null;
			vm.disableSubmit = disableSubmit;
			vm.getCustomerList = getCustomerList;
			vm.editCustomer = editCustomer;
			getCustomerList();
			if (StorageService.getSessionStorage('userDetails'))
			{
				StorageService.setSessionStorage('userDetails', undefined);
			}
		}
		init();
		
		function disableSubmit() {
			return !(vm.investorName && vm.vm.contact);
		}

		function sucessCb(response) {
			//showDialogSucc(response.data.responseString);
			vm.customers = response.data.data;
        }

        function errorCb(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
		}
		
		function getCustomerList()
		{			
			var postData = {};
			postData.fromDate = vm.fromDate;
			postData.uptoDate = vm.uptoDate;
			ServiceProxy.getSubBrokerAssignedCustomer(postData).then(sucessCb, errorCb);
		}
		
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}
		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}

		function editCustomer(userDetail)
		{
			//console.log(userDetail.userId);
			if (userDetail.userId)
			{
				ServiceProxy.getUserProfile(userDetail.userId).then(profilesucessCb, profileerrorCb);
			}
			
		}

		function profilesucessCb(response)
		{
			StorageService.setSessionStorage('userDetails', response.data.data);
			$state.go('app.sub-broker-customer.customerhome.sub-broker-add-customer');
        }

        function profileerrorCb(response) {
            if (response && response.data && response.data.responseString) {
                //console.log(response.data.responseString);
            }
		}
	}
})();

(function () {

	'use strict';


	angular.module('app.sub-broker-customer').controller('subBrokerAddCustomerController', subBrokerAddCustomerController);


	/** @ngInject */
	function subBrokerAddCustomerController($mdDialog, ServiceProxy, $window, $scope, $state, StorageService) {
		var vm = this;
		vm.createCustomer = createCustomer;
		vm.updateCustomer = updateCustomer;
		vm.createButton = true;

		function init() {
			if (StorageService.getSessionStorage('userDetails'))
			{
				var userd = StorageService.getSessionStorage('userDetails');
				vm.user = userd;
				vm.createButton = false;
			}
		}
		init();

		function sucessCb(response) {
			//console.log("res..", response)
			showDialogSucc(response.data.responseString);
			vm.customers = response.data.data;
		}

		function errorCb(response) {
			if (response && response.data && response.data.responseString) {
				showDialog(response.data.responseString);
			}
		}

		function createCustomer() {
			vm.user.platform = "WEB"
			ServiceProxy.createUserDetails(vm.user).then(function (response) {
				if (response.data.validFlag == true) {
					alert(response.data.message)
					vm.user = undefined;
					var id = response.data.data;
					StorageService.setSessionStorage('userDetails', response.data.user);
					//console.log(response.data.user);
					$state.go('app.sub-broker-customer.customerhome.customer-personal-Details', ({ id: id }))

				} else {
					alert(response.data.message)
				}
			})
		}

		function updateCustomer() {
            var postFormData = {};
            postFormData.userName = vm.user.userName;
            postFormData.email = vm.user.email;
            postFormData.mobileNo = vm.user.mobileNo;
            postFormData.userid = vm.user._id;
			//console.log(vm.user._id);
            ServiceProxy.updateUserProfile(postFormData).then(function (response) {
				if (response.data.validFlag == true) {
					StorageService.setSessionStorage('userDetails', response.data.data);
					var id = response.data.data;
					//console.log(response.data.data);
					alert(response.data.responseString);
					$state.go('app.sub-broker-customer.customerhome.customer-personal-Details', ({ id: id }))
				}
			});
        };

	}
})();

(function() {
	'use strict';

	angular.module('app.sub-broker-customer').controller('CustomerIndexController', CustomerIndexController);

	/** @ngInject */
	function CustomerIndexController($rootScope, $state) {
		var vm = this;

		function init() {
			$rootScope.$on('$stateChangeStart', function(event, next, current) {
				var url = next.url.split('/')[1];
				// console.log("url...",url)

				if (url == 'sub-broker-add-customer') {
					vm.selectedTab = 0;
				} else if (url == 'customer-personal-Details') {
					vm.selectedTab = 1;
				} else if (url == 'customer-bank-Details') {
					vm.selectedTab = 2;
				} else if (url == 'callingHistory') {
					vm.selectedTab = 3;
				} else if (url == 'customerDetail') {
					vm.selectedTab = 4;
				}
			});
		}
		init();
	}
})();

(function() {
	'use strict';

	angular.module('app.customers', []).config(config);

	/** @ngInject */
	function config(
		$urlRouterProvider,
		$stateProvider,
		$translatePartialLoaderProvider,
		msApiProvider,
		msNavigationServiceProvider
	) {
		var fId = 'CUSTOMER::MANAGEMENT';
		// State
		$stateProvider
			.state('app.customers', {
				url: '/customers',
				views: {
					'content@app': {
						templateUrl: 'app/main/customers/customers.html',
						controller: 'CustomersController as vm'
					}
				},
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome', {
				url: '/customerhome',
				views: {
					'content@app': {
						templateUrl: 'app/main/customers/customer-index.html',
						controller: 'CustomerIndexController as vm'
					}
				},
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.userDetail', {
				url: '/userDetail',
				templateUrl: 'app/main/customers/userDetail.html',
				controller: 'UserDetailController as vm',
				data: {
					access: function() {
						return true;
						// if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
						//     return true;
						// } else {
						//     return false;
						// }
					}
				}
			})
			.state('app.customers.customerhome.customerEdit', {
				url: '/customerEdit/:id/:custId',
				templateUrl: 'app/main/customers/customerEdit.html',
				controller: 'CustomerEditController as vm',
				data: {
					access: function() {
						return true;
						// if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
						//     return true;
						// } else {
						//     return false;
						// }
					}
				}
			})
			.state('app.customers.customerhome.flags', {
				url: '/flags',
				templateUrl: 'app/main/customers/flags/flags.html',
				controller: 'FlagsController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.activity', {
				url: '/activity',
				templateUrl: 'app/main/customers/activity/activity.html',
				controller: 'ActivityController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.callingHistory', {
				url: '/callingHistory',
				templateUrl: 'app/main/customers/calling-history/calling-history.html',
				controller: 'CallingHistoryController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.customerDetail', {
				url: '/customerDetail',
				templateUrl: 'app/main/customers/eachCustomerDetail.html',
				controller: 'CustomerDetailController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.uploadDownloadForm', {
				url: '/uploadDownloadForm',
				templateUrl: 'app/main/customers/uploadDownloadForm.html',
				controller: 'UploadDownloadFormController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.insuranceList', {
				url: '/insuranceList/:id',
				templateUrl: 'app/main/customers/insurance/insurance-list.html',
				controller: 'InsuranceListController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.insuranceEdit', {
				url: '/insuranceedit/:id/:insId',
				templateUrl: 'app/main/customers/insurance/insurance-edit.html',
				controller: 'InsuranceEditController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.loanList', {
				url: '/loanlist/:id',
				templateUrl: 'app/main/customers/loan/loan-list.html',
				controller: 'LoanListController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.nps', {
				url: '/nps',
				templateUrl: 'app/main/customers/nps/nps.html',
				controller: 'NPSController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.sipDetail', {
				url: '/sipDetail',
				templateUrl: 'app/main/customers/sipDetails/sipDetails.html',
				controller: 'SipDetailController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.transactionHistory', {
				url: '/transactionHistory',
				templateUrl: 'app/main/customers/transactionHistory/transactionHistory.html',
				controller: 'TransactionHistoryController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.sipfundTransactions', {
				url :'/sipfundTransaction',
				templateUrl :'app/main/customers/transactionHistory/sipfundTransaction.html',
				controller : 'SIPFundTransactionController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.ACHMandateDetails', {
				url :'/ACHMandateDetails',
				templateUrl :'app/main/customers/ACHMandateDetails.html',
				controller : 'ACHMandateDetailsController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.Transaction', {
				url :'/Transaction',
				templateUrl :'app/main/customers/Transaction.html',
				controller : 'TransactionController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.PurchaseTransactionSIP', {
				url :'/PurchaseTransactionSIP',
				templateUrl :'app/main/customers/PurchaseTransactionSIP.html',
				controller : 'PurchaseTransactionSIPController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.PurchaseTransactionLUMP', {
				url :'/PurchaseTransactionLUMP',
				templateUrl :'app/main/customers/PurchaseTransactionLUMP.html',
				controller : 'PurchaseTransactionLUMPController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.RedemptionTransaction', {
				url :'/RedemptionTransaction',
				templateUrl :'app/main/customers/RedemptionTransaction.html',
				controller : 'RedemptionTransactionController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.SwitchTransaction', {
				url :'/SwitchTransaction',
				templateUrl :'app/main/customers/SwitchTransaction.html',
				controller : 'SwitchTransactionController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.stp', {
				url :'/stp',
				templateUrl :'app/main/customers/stp.html',
				controller : 'stpController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.swp', {
				url :'/swp',
				templateUrl :'app/main/customers/swp.html',
				controller : 'swpController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.pauseSip', {
				url :'/pauseSip',
				templateUrl :'app/main/customers/pauseSip.html',
				controller : 'pauseSipController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.ceaseSip', {
				url :'/ceaseSip',
				templateUrl :'app/main/customers/ceaseSip.html',
				controller : 'ceaseSipController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.AddBankDetail', {
				url :'/AddBankDetail',
				templateUrl :'app/main/customers/AddBankDetail.html',
				controller : 'AddBankDetailController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.fatcaKycUboReglink', {
				url :'/fatcaKycUboReglink',
				templateUrl :'app/main/customers/fatcaKycUboReglink.html',
				controller : 'fatcaKycUboReglinkController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.editCustomers', {
				url :'/Edit_Customers',
				templateUrl :'app/main/customers/editCustomers.html',
				controller : 'editCustomersController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.resendLink', {
				url :'/ResendLink',
				templateUrl :'app/main/customers/resendLink.html',
				controller : 'resendLinkController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.customers.customerhome.amcforekyc', {
				url :'/amcforekyc',
				templateUrl :'app/main/customers/amcforekyc.html',
				controller : 'amcforekycController as vm',
				data: {
					access: function() {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			});

		// Translation
		// $translatePartialLoaderProvider.addPart('app/main/customers');

		// Api
		// msApiProvider.register('customers', ['app/data/customers/customers.json']);
		//
		// msApiProvider.register('customerDetail', ['app/data/customers/customerDetail.json']);

		// Navigation
		msNavigationServiceProvider.saveItem('customer', {
			title: 'CUSTOMER',
			// group: true,
			weight: 2,
			hidden: function() {
				if (
					JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
					(window.sessionStorage.getItem('feature') &&
						JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
				) {
					return false;
				} else {
					return true;
				}
			}
		});

		msNavigationServiceProvider.saveItem('customer.customers', {
			title: 'Customers',
			icon: 'icon-people',
			state: 'app.customers',
			weight: 1
		});
	}
})();

(function() {
    'use strict';
    angular
        .module('app.customers')
        .controller('SipDetailController', SipDetailController);

    /** @ngInject */
    function SipDetailController($state, $mdDialog, ShareDataService, StorageService, ServiceProxy) {

        var vm = this;

        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                //CeaseDetail(vm.customerDetail.pan);
                //SipDetail(vm.customerDetail.pan);
                getAllDetail(vm.customerDetail.iin);
            } else {
                $state.go('app.customers');
            }
            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }
        }
        init();

        // function sucessCbSipDetail(response) {
        //     vm.SipDetail =[];
        //     var j =0;
        //     for(i=0; i<response.data.data.length; i++)
        //     {
        //         if(vm.SipDetail.length > 0)
        //         {
        //         for(j=0; j<vm.SipDetail.length; j++)
        //         {
        //             var codeexist = false;
        //             if(vm.SipDetail[j].sipReports.AMC_CODE == response.data.data[i].sipReports.AMC_CODE)
        //             {
        //                 codeexist = true;  
        //                 break;         
        //             }
        //         }
        //         if(codeexist == false)
        //         vm.SipDetail.push(response.data.data[i]);
        //         }
        //         else
        //         vm.SipDetail.push(response.data.data[i]);
        //     }
        // }

        function sucessCbAllDetail(response) {
            console.log('full data', response);
            vm.allData = response.data.data;
            vm.SipDetail = vm.allData.registrationReport;
            vm.CeaseDetail = vm.allData.cancellationReport;
        }

        function errorGetAllDetail(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllDetail(iin) {
            var postData = {
                "client_code": iin
            };
            ServiceProxy.getAllDetail(postData).then(sucessCbAllDetail, errorGetAllDetail)
        }

        function sucessCbSipDetail(response) {
            vm.SipDetail = response.data.data;

        }

        function errorGetSipDetail(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function SipDetail(pan) {
            ServiceProxy.getSipDetail(pan).then(sucessCbSipDetail, errorGetSipDetail)
        }

        function sucessCbCeaseDetail(response) {
           vm.CeaseDetail = response.data.data;          
        }

        function errorGetCeaseDetail(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function CeaseDetail(pan) {
            ServiceProxy.getCeaseDetail(pan).then(sucessCbCeaseDetail, errorGetCeaseDetail)
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    }
})();
(function () {
    'use strict';
    angular
        .module('app.customers')
        .controller('TransactionHistoryController', TransactionHistoryController);

    /** @ngInject */
    function TransactionHistoryController($state, $mdDialog, $filter, ShareDataService, StorageService, ServiceProxy) {

        var vm = this;

        function init() {
            console.log('customer detail', ShareDataService.getData('customerDetail'));
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                vm.customerName = vm.customerDetail.userName || vm.customerDetail.name || (vm.customerDetail.nseData && vm.customerDetail.nseData.INVESTOR_NAME) || 'NA';
                vm.iinStatus = (vm.customerDetail.nseData && vm.customerDetail.nseData.ACTIVATION_STATUS) || 'NA';
                if (vm.customerDetail && vm.customerDetail.nseData && vm.customerDetail.nseData.ACTIVATION_STATUS === 'YES') {
                    vm.cdate = $filter('date')(new Date(), 'dd-MMM-yyyy');
                    var today = new Date();
                    var thirtyDaysAgo = new Date();
                    thirtyDaysAgo.setDate(today.getDate() - 7);
                    vm.fromDate = thirtyDaysAgo;
                    vm.toDate = today;
                    vm.maxDate = today;
                    vm.folioReq = {};
                }
            } else {
                $state.go('app.customers');
            }
            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }
            vm.showButton = true;
            vm.transactionReport = [];
            vm.showTransactionDetails = showTransactionDetails;
        }
        init();

        ////////////////////////////get all transaction details starts here////////////////////////////////////////////////
        function errorCbGetTransaction(response) {
            console.log('error', response);
            if (response && response.data && response.data.error_remark) {
                showDialog(response.data.error_remark);
            } else {
                showDialog('Error occurred while fetching transaction details. Try Again!!');
            }
        }

        function successCbGetTransaction(response) {
            console.log('res', response);
            
            if (response && response.data && response.data.response_status === 'S') {
                if (response.data.report_data && angular.isArray(response.data.report_data)) {
                    vm.transactionReport = response.data.report_data;
                } else if (response.data.report_data) {
                    vm.transactionReport = [response.data.report_data];
                } else {
                    vm.transactionReport = [];
                    showDialog('No transaction data found for the selected date range.');
                    return;
                }
                
                // Update customer name from transaction data if not available
                if (vm.customerName === 'NA' && vm.transactionReport.length > 0 && vm.transactionReport[0].primary_holder_name) {
                    vm.customerName = vm.transactionReport[0].primary_holder_name;
                }
                
                // Process and format the data
                angular.forEach(vm.transactionReport, function (item) {
                    // Convert date string to timestamp for sorting
                    if (item.product_reg_datetime) {
                        var dateParts = item.product_reg_datetime.split(' ')[0].split('/');
                        var timeParts = item.product_reg_datetime.split(' ')[1];
                        // Convert DD/MM/YYYY to MM/DD/YYYY for proper Date parsing
                        var formattedDate = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2] + ' ' + timeParts;
                        item.DATE_OF_TRXN_REQUEST = new Date(formattedDate).getTime();
                    }
                    
                    // Clean up empty string fields
                    Object.keys(item).forEach(function(key) {
                        if (item[key] === ' ' || item[key] === '') {
                            item[key] = null;
                        }
                    });
                });
                
                // Sort by date (newest first)
                vm.transactionReport = $filter('orderBy')(vm.transactionReport, '-DATE_OF_TRXN_REQUEST');

            } else if (response && response.data && response.data.response_status === 'F' && response.data.error_remark) {
                showDialog(response.data.error_remark);
            } else {
                showDialog('Invalid response format or failed to fetch data.');
            }
        }

        function showTransactionDetails() {
            if (!vm.fromDate || !vm.toDate) {
                showDialog('Please select both From Date and To Date.');
                return;
            }
            
            vm.folioReq = {
                'iin': vm.customerDetail.iin,
                'from_date': $filter('date')(vm.fromDate, 'dd-MMM-yyyy'),
                'to_date': $filter('date')(vm.toDate, 'dd-MMM-yyyy')
            };
            
            console.log('req', vm.folioReq);
            ServiceProxy.postTransactionDetails(vm.folioReq).then(successCbGetTransaction, errorCbGetTransaction);
        }
        ////////////////////////////get all transaction details ends here////////////////////////////////////////////////

        ///////////////////////////////show dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
        
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        }
        ///////////////////////////////show dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
    'use strict';
    angular
        .module('app.customers')
        .controller('SIPFundTransactionController', SIPFundTransactionController);

    /** @ngInject */
    function SIPFundTransactionController($state, $scope, $mdDialog, $filter, ShareDataService, StorageService, ServiceProxy) {
        var vm = this;

        function init() {
            var dateOffset = (24*60*60*1000) * 6;
            var curr_date = new Date();
            var past_date = new Date();
            past_date.setTime(curr_date.getTime() - dateOffset);
            
            // Set default dates
            vm.toDate = new Date();
            vm.fromDate = past_date;
            vm.maxDate = new Date(); // Today's date as max

            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                
                if (vm.customerDetail && vm.customerDetail.nseData && vm.customerDetail.nseData.ACTIVATION_STATUS === 'YES') {
                    vm.cdate = $filter('date')(new Date(), 'dd-MMM-yyyy');
                    vm.folioReq = {};
                }
            } else {
                $state.go('app.customers');
            }

            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED", 
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)", 
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            };

            vm.showButton = true;
            vm.transactionReport = [];
            vm.showTransactionDetails = showTransactionDetails;
        }
        
        init();

        function errorCbGetTransaction(response) {
            console.log('error', response);
            if (response && response.data && response.data.responseData) {
                showDialog(response.data.responseData.error_remark);
            } else {
                showDialog('Error occurred while fetching transaction details. Try Again!!');
            }
        }

        function successCbGetTransaction(response) {
            console.log('Transaction response:', response);
            vm.showButton = false;
            
            if (response && response.data) {
                // Handle the new nested response structure
                if (response.data.Data && response.data.Data.response_status === 'S') {
                    if (response.data.Data.report_data && angular.isArray(response.data.Data.report_data)) {
                        vm.transactionReport = response.data.Data.report_data;
                    } else if (response.data.Data.report_data) {
                        vm.transactionReport = [response.data.Data.report_data];
                    } else {
                        vm.transactionReport = [];
                        showDialog('No transaction data found for the selected date range.');
                        return;
                    }
                } else if (response.data.Data && response.data.Data.NMFIISERVICES) {
                    // Handle old NMFII service response (backward compatibility)
                    if (response.data.Data.NMFIISERVICES.service_status.service_msg === 'Success') {
                        if (angular.isArray(response.data.Data.NMFIISERVICES.service_response)) {
                            vm.transactionReport = response.data.Data.NMFIISERVICES.service_response;
                        } else {
                            vm.transactionReport = [response.data.Data.NMFIISERVICES.service_response];
                        }
                    } else {
                        showDialog('Failed to fetch transaction data');
                        return;
                    }
                } else {
                    showDialog('Invalid response format or no data available');
                    return;
                }

                // Process and format the data
                angular.forEach(vm.transactionReport, function (item) {
                    // Handle date conversion for order_date (DD/MM/YYYY format)
                    if (item.order_date) {
                        var dateParts = item.order_date.split('/');
                        if (dateParts.length === 3) {
                            // Convert DD/MM/YYYY to proper date object
                            item.FORMATTED_DATE = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).getTime();
                        }
                    }

                    // Clean up empty fields (convert spaces to null)
                    Object.keys(item).forEach(function(key) {
                        if (item[key] === ' ' || item[key] === '') {
                            item[key] = null;
                        }
                    });
                });

                // Sort by date (newest first)
                vm.transactionReport = $filter('orderBy')(vm.transactionReport, '-FORMATTED_DATE');
                
            } else {
                showDialog('No data received from server');
            }
        }

        function showTransactionDetails() {
            if (!vm.fromDate || !vm.toDate) {
                showDialog('Please select both From Date and To Date.');
                return;
            }

            // Validate date range
            var diffTime = Math.abs(vm.toDate - vm.fromDate);
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            
            if (vm.toDate < vm.fromDate) {
                showDialog('To Date should not be less than From Date.');
                return;
            }
            
            if (diffDays > 60) {
                showDialog('Selected date difference should not exceed 60 days.');
                return;
            }

            // Prepare request payload
            vm.folioReq = {
                'from_date': $filter('date')(vm.fromDate, 'dd-MMM-yyyy'),
                'to_date': $filter('date')(vm.toDate, 'dd-MMM-yyyy'),
                'trans_type': 'ALL',
                'order_type': 'XSP', 
                'sub_order_type': 'ALL',
                'client_code': vm.customerDetail.iin || vm.customerDetail.client_code
            };
            ServiceProxy.rejectedTransactionNse(vm.folioReq).then(successCbGetTransaction, errorCbGetTransaction);
        }

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('NPSController', NPSController);

    /** @ngInject */
    function NPSController($rootScope, $state, $mdDialog, $location, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.createPran = createPran;
                vm.editPran = editPran;
                vm.deletePran = deletePran;
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                getPran();
            } else {
                $state.go('app.customers');
            }
            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }
        };
        init();

        function sucessCbPran(response) {
            vm.pranFlag = true;
            showDialogSucc(response.data.responseString);
        }

        function errorCbPran(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function createPran() {
            var postData = {
                pranNumber: vm.pranNumber
            }
            ServiceProxy.createPran(postData, vm.customerDetail._id).then(sucessCbPran, errorCbPran)
        }

        function editPran() {
            vm.pranFlag = false;
        }

        // function to get pran number

        function sucessCbGetPran(response) {
            if (response && response.data && response.data.responseString && response.data.responseString.npsData && response.data.responseString.npsData.pranNumber) {
                vm.pranNumber = response.data.responseString.npsData.pranNumber;
                vm.pranFlag = true;
            }
        }

        function errorCbGetPran(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getPran() {
            ServiceProxy.getPran(vm.customerDetail._id).then(sucessCbGetPran, errorCbGetPran)
        }

        function sucessCbDeletePran(response) {
            if (response.data.validFlag) {
                vm.pranFlag = false;
                vm.pranNumber = '';
            }
            vm.myForm.$setUntouched();
        }

        function errorCbDeletePran(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function deletePran() {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete PRAN Number ?')
                .ariaLabel('Lucky day')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                ServiceProxy.deletePran(vm.customerDetail._id).then(sucessCbDeletePran, errorCbDeletePran)
            });

        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('LoanListController', LoanListController);

    /** @ngInject */
    function LoanListController($window, $state, $stateParams, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;
        if (ShareDataService.getData('customerDetail')) {
            vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
        } else {
            $state.go('app.customers');
        }

        var userData = angular.copy(ShareDataService.getData('customerDetail'));

        function init() {
            vm.selected = [];
            vm.query = {
                order: 'name',
                limit: 50
            };
            getUserLoans();
            vm.goBack = goBack;
        }

        vm.eKyc = {
            "01": "UNDER_PROCESS",
            "02": "KYC REGISTERED",
            "03": "ON HOLD",
            "04": "KYC REJECTED",
            "05": "NOT AVAILABLE",
            "06": "Deactivate",
            "07": "KYC VALIDATED",
            "11": "UNDER_PROCESS(OLD record)",
            "12": "KYC REGISTERED(OLD record)",
            "13": "ON HOLD(OLD record)",
            "22": "CVL MF KYC"
        }
        vm.eKycType = {
            "0": "Paper Based",
            "1": "Through OTP",
            "2": "Through Biometric"
        }
        init();

        function sucess(res) {
            vm.userLoans = res.data.responseString.loans;
        }

        function error(res) {
            if (res && res.data && res.data.data) {
                showDialog(res.data.responseString);
            }

        }

        function getUserLoans() {
            ServiceProxy.getUserLoans(userData._id).then(sucess, error)
        }

        function goBack() {
            $window.history.back();
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(res) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.customers')
        .controller('FlagActivityController', FlagActivityController);

    /** @ngInject */
    function FlagActivityController($mdDialog, $timeout, ServiceProxy, data, key) {
        var vm = this;

        function init() {
            vm.cancleDialog = cancleDialog;
            vm.reviewedData = reviewedData;
            vm.key = key;
            vm.customerDetail = data;
            vm.callingHistory = {};
            vm.currentreviewPendingFlagDate = null;
            if (vm.customerDetail.monitoringFlags && vm.customerDetail.monitoringFlags.reviewPendingFlagDate) {
                vm.currentreviewPendingFlagDate = new Date(vm.customerDetail.monitoringFlags.reviewPendingFlagDate);
            }

            if (vm.key === 'reviewPendingFlag') {
                getCallingHistory(vm.customerDetail._id);
            }
        }


        init();

        function cancleDialog() {
            $mdDialog.hide()
        }
        /////////////////////////////////////////Starts reviewed here/////////////////////////////////////
        function sucessCbReviewdData(response) {
            $mdDialog.hide(response);
        }

        function errorCbReviewdData(response) {
            if (response && response.data.responseString) {
                vm.errorMsg = response.data.responseString
            } else {
                vm.errorMsg = "Try Again."
            }
            $timeout(function () {
                vm.errorMsg = null;
            }, 5000);
        }

        function reviewedData() {
            var data = {}
            data[vm.key] = false;
            data[vm.key + 'Comments'] = vm.description;
            if (vm.key === 'reviewPendingFlag') {
                data.reviewPendingFlagDate = new Date(vm.reviewPendingFlagDate);
                data.reviewPendingFlagDate = data.reviewPendingFlagDate.setHours(0, 0, 0, 0);
            }
            ServiceProxy.updateFlags(data, vm.customerDetail._id).then(sucessCbReviewdData, errorCbReviewdData)
        }
        /////////////////////////////////////////Ends reviewed here/////////////////////////////////////

        //////////////////////////////////////get all calling history starts here///////////////////////
        function sucessCbGetCallingHistory(response) {
            if (response.data.data.length > 0) {
                vm.callinglength = response.data.data.length;
                vm.callingHistory = response.data.data[0];
            }
        }

        function errorCbGetCallingHistory(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getCallingHistory(id) {
            ServiceProxy.getCallingHistory(id).then(sucessCbGetCallingHistory, errorCbGetCallingHistory)
        }
        //////////////////////////////////////get all calling history ends here///////////////////////

    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('InsuranceListController', InsuranceListController);

    /** @ngInject */
    function InsuranceListController($window, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            ShareDataService.storeData('insurancesUser', '');
            vm.goBack = goBack;
            // vm.userId = $stateParams.id;
            vm.selected = [];
            vm.query = {
                order: 'name',
                limit: 10
            };
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
            } else {
                $state.go('app.customers');
            }
            var userData = angular.copy(ShareDataService.getData('customerDetail'));
            vm.userId = userData._id;
            vm.editIsurance = editIsurance;
            vm.showDeleteDialog = showDeleteDialog;
            vm.downloadDocs = downloadDocs;
            getInsuranceByUserId();
            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }

        }
        init();

        function sucess(res) {
            vm.baseUrl = res.data.baseUrl;
            vm.insurancesUser = res.data.responseString;
            ShareDataService.storeData('insurancesUser', res.data);
        }

        function error(res) {
            if (res && res.data && res.data.data) {
                showDialog(res.data.responseString);
            }
        }

        function getInsuranceByUserId() {
            ServiceProxy.getInsuranceByUserId(vm.userId).then(sucess, error);
        }

        function goBack() {
            $window.history.back();
        }

        function editIsurance(insuranceDetail) {
            ShareDataService.storeData('insuranceDetail', insuranceDetail);
            $state.go('app.customers.customerhome.insuranceEdit', { id: vm.userId, insId: insuranceDetail._id });
        }

        function showDeleteDialog(insurance) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete selected Insurance?')
                .textContent('Insurance name is ' + insurance.productName)
                .ariaLabel('Lucky day')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                deleteInsurance(insurance._id);
            }, function() {
                // $scope.status = 'You decided to keep your debt.';
            });
        }

        function sucessCbDelete(res) {
            getInsuranceByUserId();
        }

        function errorCbDelete(res) {
            if (res && res.data && res.data.data) {
                showDialog(res.data.responseString);
            }
        }

        function deleteInsurance(insuranceId) {
            ServiceProxy.deleteInsurance(insuranceId).then(sucessCbDelete, errorCbDelete);
        }

        function downloadDocs() {
            vm.insurancesUser.insuranceDocuments.forEach(
                function functionName(element) {
                    var link = document.createElement('a');
                    link.setAttribute('download', element.fileName);
                    link.setAttribute('target', "_self");
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.setAttribute('href', vm.baseUrl + element.fileName);
                    link.click();
                    document.body.removeChild(link);
                }
            )
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(res) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('InsuranceEditController', InsuranceEditController);

    /** @ngInject */
    function InsuranceEditController($scope, $window, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.currentDate = new Date();
            vm.insurancesUser = ShareDataService.getData('insurancesUser');
            if ($stateParams.insId && ShareDataService.getData('insuranceDetail')) {
                vm.insurance = ShareDataService.getData('insuranceDetail');
                vm.insurance.startDate = new Date(vm.insurance.startDate);
                vm.insurance.renewalDate = new Date(vm.insurance.renewalDate);
                if (vm.insurance.document) {
                    angular.forEach(vm.insurancesUser.responseString.insuranceDocuments, function(obj) {
                        if (obj.fileName == vm.insurance.document) {
                            vm.selectedDocu = obj;
                        }
                    });
                }
            } else {
                vm.insurance = {}
            };
            vm.insurance.userId = $stateParams.id;
            vm.goBack = goBack;
            vm.createInsurance = createInsurance;
            vm.selectedDocument = selectedDocument;
            vm.disableSubmit = disableSubmit;

        }
        init();

        function goBack() {
            $window.history.back();
        }

        function sucessCbUpdateInsurance(res) {
            if (vm.selectedDocu !== undefined) {
                var postData = {
                    "insuranceId": res.config.data.insuranceId,
                    "document": vm.selectedDocu
                }
                mapDocument(postData);
            }
            vm.goBack()
        }

        function errorCbUpdateInsurance(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')

            $mdDialog.show(confirm);
        }

        function sucessCbCreateInsurance(res) {
            if (vm.selectedDocu !== undefined) {
                var postData = {
                    "insuranceId": res.data.docs._id,
                    "document": vm.selectedDocu
                }
                mapDocument(postData);
            }
            vm.goBack()
        }

        function errorCbCreateInsurance(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')

            $mdDialog.show(confirm);
        }

        function createInsurance() {
            var postData = {};
            vm.insurance.startDate = new Date(vm.insurance.startDate);
            vm.insurance.renewalDate = new Date(vm.insurance.renewalDate);
            if (vm.insurance._id) {
                if (vm.insurance.insuranceFrequency != undefined) {
                    vm.insurance.insuranceFrequency = parseInt(vm.insurance.insuranceFrequency);
                }
                vm.insurance.insuranceId = vm.insurance._id;
                ServiceProxy.updateInsurance(vm.insurance).then(sucessCbUpdateInsurance, errorCbUpdateInsurance)
            } else {
                if (vm.insurance.insuranceFrequency != undefined) {
                    vm.insurance.insuranceFrequency = parseInt(vm.insurance.insuranceFrequency);
                }
                postData = JSON.parse(JSON.stringify(vm.insurance));
                postData.startDate = vm.insurance.startDate.setHours(0, 0, 0, 0);
                postData.renewalDate = vm.insurance.renewalDate.setHours(0, 0, 0, 0);
                ServiceProxy.createInsurance(postData).then(sucessCbCreateInsurance, errorCbCreateInsurance)
            }
        }

        function disableSubmit() {
            return !(vm.insurance.insuranceFrequency && vm.selectedDocu && vm.insurance.typeOfInsurance && vm.insurance.productName && vm.insurance.startDate && vm.insurance.renewalDate);
        }

        function selectedDocument(doc) {
            vm.selectedDocu = doc;
        }

        function sucessCbmapDocument(response) {}

        function errorCbmapDocument(response) {
            showDialog(response.data.responseString);
        }

        function mapDocument(post) {
            ServiceProxy.mapDocumentImage(post, vm.insurancesUser.responseString._id).then(sucessCbmapDocument, errorCbmapDocument)
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
    'use strict';
    angular
        .module('app.customers')
        .controller('FlagsController', FlagsController);

    /** @ngInject */
    function FlagsController($state, $mdDialog, ShareDataService, StorageService, ServiceProxy) {

        var vm = this;

        function init() {
            vm.currentDate = new Date();
            vm.reviewedData = reviewedData;
            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }

            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));


                vm.allFlags = {
                    document: {
                        documentFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.documentFlag || false) : false,
                        documentFlagComments: ''
                    },
                    loan: {
                        loanFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.loanFlag || false) : false,
                        loanFlagComments: ''
                    },
                    insurance: {
                        insuranceFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.insuranceFlag || false) : false,
                        insuranceFlagComments: ''
                    },
                    sip: {
                        sipFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.sipFlag || false) : false,
                        sipFlagComments: ''
                    },
                    lumpsum: {
                        lumpsumFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.lumpsumFlag || false) : false,
                        lumpsumFlagComments: ''
                    },
                    signup: {
                        signupFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.signupFlag || false) : false,
                        signupFlagComments: ''
                    },
                    iinCreation: {
                        iinCreationFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.iinCreationFlag || false) : false,
                        iinCreationComments: ''
                    },
                    externalHolding: {
                        externalHoldingFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.externalHoldingFlag || false) : false,
                        externalHoldingComments: ''
                    },
                    reversal: {
                        reversalFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.reversalFlag || false) : false,
                        reversalFlagComments: ''
                    },
                    assigned: {
                        assignedFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.assignedFlag || false) : false,
                        assignedFlagComments: ''
                    },
                    iinActive: {
                        iinActiveFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.iinActiveFlag || false) : false,
                        iinActiveFlagComments: ''
                    },
                    fatcaKyc: {
                        fatcakycuboRegFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.fatcakycuboRegFlag || false) : false,
                        fatcakycuboRegFlagComments: ''
                    },
                    achMandate: {
                        achmandateRegFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.achmandateRegFlag || false) : false,
                        achmandateRegFlagComments: ''
                    },
                    review: {
                        reviewPendingFlag: vm.customerDetail.monitoringFlags ? (vm.customerDetail.monitoringFlags.reviewPendingFlag || false) : false,
                        currentreviewPendingFlagDate: vm.customerDetail.monitoringFlags ? (new Date(vm.customerDetail.monitoringFlags.reviewPendingFlagDate) || null) : null,
                        reviewPendingFlagComments: '',
                        reviewPendingFlagDate: null
                    }
                }
                getCallingHistory(vm.customerDetail._id);

            } else {
                $state.go('app.customers');
            }

        }
        init();

        /////////////////////////////////////////Starts reviewed here/////////////////////////////////////
        function sucessCbReviewdData(response) {
            if (response && response.data && response.data.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbReviewdData(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function reviewedData(data) {
            for (var key in data) {
                if (data[key] === true) {
                    data[key] = false
                }
            }
            data = JSON.parse(JSON.stringify(data));
            for (var key in data) {
                if (key === 'reviewPendingFlagDate') {
                    data[key] = new Date(data[key]);
                    data[key] = data[key].setHours(0, 0, 0, 0);
                }
            }
            ServiceProxy.updateFlags(data, vm.customerDetail._id).then(sucessCbReviewdData, errorCbReviewdData);
        }
        /////////////////////////////////////////Ends reviewed here/////////////////////////////////////

        //////////////////////////////////////get all calling history starts here///////////////////////
        function sucessCbGetCallingHistory(response) {
            vm.callingHistory = response.data.data;

        }

        function errorCbGetCallingHistory(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getCallingHistory(id) {
            ServiceProxy.getCallingHistory(id).then(sucessCbGetCallingHistory, errorCbGetCallingHistory)
        }
        //////////////////////////////////////get all calling history ends here///////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////

    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('SubBrokerDialogController', SubBrokerDialogController);

    /** @ngInject */
    function SubBrokerDialogController($mdDialog, $timeout, $mdToast, ServiceProxy, ShareDataService, data) {
        var vm = this;

        function init() {
            vm.customer = data;
            vm.cancleDialog = cancleDialog;
            vm.submitAssignedBroker = submitAssignedBroker;
            if (!ShareDataService.getData('SubBoker')) {
                getAllInternalUser();
            } else {
                vm.internalUser = ShareDataService.getData('SubBoker');
            }

        }
        init();

        function cancleDialog() {
            $mdDialog.hide()
        }
        ///////////////////////////////////get all internal user starts here//////////////////////////////////////
        function sucessCbGetAllInternalUser(response) {
            vm.internalUser = [];
            angular.forEach(response.data.data, function(internalUser) {
                if (internalUser.features.indexOf("CUSTOMER::MANAGEMENT") !== -1) {
                    vm.internalUser.push(internalUser)
                }
            })
        }

        function errorCbGetAllInternalUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllInternalUser() {
            ServiceProxy.getAllInternalUser().then(sucessCbGetAllInternalUser, errorCbGetAllInternalUser)
        }
        ///////////////////////////////////get all internal user ends here//////////////////////////////////////

        // Assign  to broker
        function sucessCbGetAssignSubBroker(response) {
            $mdDialog.hide(vm.subBroker);
            $mdToast.show(
                $mdToast.simple()
                .textContent(response.data.responseString)
                .position('top right')
                .hideDelay(3000)
                .toastClass('success')
            );
        }

        function errorCbGetAssignSubBroker(response) {
            if (response && response.data.responseString) {
                vm.errorMsg = response.data.responseString
            } else {
                vm.errorMsg = "Try Again."
            }
            $timeout(function() {
                vm.errorMsg = null;
            }, 5000);

        }

        function submitAssignedBroker() {
            var postdata = {
                assignedUserId: vm.subBroker._id,
                investorsIds: [vm.customer._id]
            }
            ServiceProxy.createAssignedCustomer(postdata).then(sucessCbGetAssignSubBroker, errorCbGetAssignSubBroker)
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('CallingHistoryController', CallingHistoryController);

    /** @ngInject */
    function CallingHistoryController($state, $mdToast, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.currentDate = new Date();
            vm.reviewedData = reviewedData;
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                vm.currentCallingDate = new Date(vm.customerDetail.monitoringFlags.reviewPendingFlagDate);
                getCallingHistory(vm.customerDetail._id);
            } else {
                $state.go('app.customers');
            }

            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                    "0": "Paper Based",
                    "1": "Through OTP",
                    "2": "Through Biometric"
                }
                // getCallingHistory()
        }
        init();


        function sucessCbGetCallingHistory(response) {
            vm.callingHistory = response.data.data;
        }

        function errorCbGetCallingHistory(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getCallingHistory(id) {
            ServiceProxy.getCallingHistory(id).then(sucessCbGetCallingHistory, errorCbGetCallingHistory)
        }
        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };


        function sucessToast(response) {
            $mdToast.show(
                $mdToast.simple()
                .textContent(response)
                .position('top right')
                .hideDelay(3000)
            );
        }
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        // change review date
        /////////////////////////////////////////Starts reviewed here/////////////////////////////////////
        function sucessCbReviewdData(response) {
            if (response && response.data && response.data.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbReviewdData(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function reviewedData() {
            var data = {
                "reviewPendingFlag": false,
                "reviewPendingFlagComments": "",
                "reviewPendingFlagDate": vm.currentCallingDate
            }
            data = JSON.parse(JSON.stringify(data));
            data.reviewPendingFlagDate = new Date(data.reviewPendingFlagDate);
            data.reviewPendingFlagDate = data.reviewPendingFlagDate.setHours(0, 0, 0, 0);
            ServiceProxy.updateFlags(data, vm.customerDetail._id).then(sucessCbReviewdData, errorCbReviewdData)
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.customers')
        .controller('ActivityController', ActivityController);

    /** @ngInject */
    function ActivityController($rootScope, $state, $mdDialog, $location, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.allActivity = [];
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                getActivityCustomer(vm.customerDetail._id);
            } else {
                $state.go('app.customers');
            }

            vm.activityDocument = {
                'DL': 'Driving License',
                'PC': 'PAN Card',
                'IP': 'IIN Physical Form',
                'PA': 'Passport',
                'AA': 'AADHAR Card',
                'KF': 'KRA Form',
                'CH': 'Cheque',
                'AC': 'ACH Form',
                'X': 'Transaction Image',
                'B': 'Bank Proof Image'
            };

            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }
            vm.allActivityFlagMapping = {
                'DOCUMENT': 'Document Flag',
                'LOAN': 'Loan Flag',
                'INSURANCE': 'Insurance Flag',
                'SIP': 'SIP Flag',
                'LUMPSUM': 'Lumpsum Flag',
                'SIGNUP': 'Signup Flag',
                'IIN_CREATION': 'IIN Creation Flag',
                'EXTERNAL_HOLDING': 'External Holding Flag',
                'REVERSAL': 'Reversal Flag',
                'ASSIGNED': 'Assigned Flag',
                'REVIEW_PENDING': 'Review Pending Flag',
                'IIN_ACTIVE': 'IIN Active Flag',
                'ACHMANDATE_REG': 'ACH Mandate Flag',
                'FATCA_KYC_UBO_REG': 'Fatca KYC Flag'
            }
            vm.assgnedtype = {
                'SUB::BROKER': 'Assigned To Sub Broker',
                'INTERNAL::USER': 'Assigned To Internal User'
            }
        };
        init();

        /////////////////////////////////get all activity customer details starts here////////////////////////////////////////
        function successCbGetActivity(response) {
            vm.allActivity = response.data.data;
            // if (activityName === "REVIEW_PENDING") {
            //     vm.calling = monitorUserName;
            // }
        }

        function errorCbGetActivity(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getActivityCustomer(id) {
            ServiceProxy.getActivityCustomer(id).then(successCbGetActivity, errorCbGetActivity);
        }
        /////////////////////////////////get all activity customer details ends here////////////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    }
})();
(function () {
    'use strict';

    angular
        .module('app.internalUser', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'INTERNAL::USERS::MANAGEMENT';
        // State
        $stateProvider
            .state('app.internalUser', {
                url: '/internalUser',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/internalUser/internalUserCreate/internalUser.html',
                        controller: 'InternalUserController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.internalUser.editInternalUser', {
                url: '/internalUser/:editId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/internalUser/internalUserCreate/internalUser.html',
                        controller: 'InternalUserController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.internalUser.internalUserList', {
                url: '/internalUserList',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/internalUser/internalUserList.html',
                        controller: 'InternalUserListController as vm'
                    }
                }
            })
            .state('app.internalUser.internalUserList.showDetails', {
                url: '/internalUserList/:userViewId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/internalUser/internaluser-details/internaluserDetails.html',
                        controller: 'InternalUserDetails as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('USER', {
            title: 'USER',
            weight: 8,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }
        });

        msNavigationServiceProvider.saveItem('USER.internalUser', {
            title: 'Internal User',
            state: 'app.internalUser.internalUserList',
            icon: 'icon-people',
            weight: 1
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.internalUser')
        .controller('InternalUserController', InternalUserController);

    /** @ngInject */
    function InternalUserController($rootScope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.imageFile = {
                flowObj: {}
            };
            vm.processFile = processFile;
            vm.dummyImage = 'assets/images/backgrounds/header-bg.png';
            vm.userNameReg = /^[a-zA-Z ]{2,50}$/;
            vm.contactNumberReg = /^[0-9]{10,10}$/;
            vm.emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            vm.userData = {};
            vm.createUser = {};
            vm.activeAssignFeature = false;
            vm.activeAssignMappingUser = false;
            vm.currentNavItem = '1';
            vm.getAssignFeature = getAssignFeature;
            vm.getAssignData = getAssignData;
            vm.internalUserSelectedFeatures = [];
            vm.setInternalUserMapping = setInternalUserMapping;
            vm.disableAssignfeature = disableAssignfeature;
            vm.navigateAssignFeature = navigateAssignFeature;
            vm.activeFalseAssignFeature = activeFalseAssignFeature;
            vm.userMappingData = userMappingData;
            vm.selectCustomer = getMappingCustomerDetails;
            vm.singleDeselect = singleDeselect;
            vm.allselected = false;
            vm.activeCustomerListFlag = false;
            vm.toggleAllCustomer = toggleAllCustomer;
            vm.deselectAll = deselectAll;
            vm.selectedCustomer = [];
            vm.singleCustomers = [];

            if ($stateParams.editId) {
                vm.internaluserId = $stateParams.editId;
                vm.createUser.id = vm.internaluserId;
                getAllAssignedUser(vm.internaluserId)
            }
            getTypeInternalUser();
            getAssignFeature();

        };
        init();

        //////////////////////////////get all internal user type starts here///////////////////////////////////////////
        function sucessCbGetAllTypeInternalUser(response) {
            vm.internalUserType = response.data.data;
        }

        function errorCbGetAllTypeInternalUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getTypeInternalUser() {
            ServiceProxy.getTypeInternalUser().then(sucessCbGetAllTypeInternalUser, errorCbGetAllTypeInternalUser)
        }
        //////////////////////////////get all internal user type ends here///////////////////////////////////////////

        //////////////////////////////get all internal user type starts here///////////////////////////////////////////
        function sucessCbGetAllAssignFeature(response) {
            vm.internalAssignFeature = response.data.data;
            if ($stateParams.editId) {
                getInternalUserById($stateParams.editId);
            }
        }

        function errorCbGetAllAssignFeature(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAssignFeature() {
            ServiceProxy.getAssignFeature().then(sucessCbGetAllAssignFeature, errorCbGetAllAssignFeature)
        }

        function getAssignData(feature) {
            var index = vm.internalUserSelectedFeatures.indexOf(feature.fId);
            if (index === -1) {
                vm.internalUserSelectedFeatures.push(feature.fId);
            } else {
                vm.internalUserSelectedFeatures.splice(index, 1)
            }
        }

        //////////////////////////////get all internal user type ends here///////////////////////////////////////////


        /////////////////////////////////////////////starts mapping customer here/////////////////////////////////////////////
        function sucessCbGetAllCreateUser(response) {
            vm.activeAssignMappingUser = true;
            // if (response.data && response.data.data && (response.data.data.features.indexOf('CUSTOMER::MANAGEMENT') !== -1)) {
            //     vm.activeCustomerListFlag = true;
            //     vm.createUser.id = response.data.data._id;
            //     getMappingCustomerDetails(1);
            // } else {
            //     vm.activeCustomerListFlag = false;

            // }

            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(response.statusText)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm)
                .then(goToList);
        }

        function goToList(){
            if (vm.imageFile.flowObj.files.length) {
                internalUserImageUpload(response.data.data._id);
            };
            $state.go('app.internalUser.internalUserList');
        }

        function errorCbGetAllCreateUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            } else {
                showDialog('Something went wrong.Please Try Again.');
            }
        }

        function setInternalUserMapping() {
            vm.userData.features = vm.internalUserSelectedFeatures;
            if (vm.internaluserId) {
                ServiceProxy.updateInternalUser(vm.userData, vm.internaluserId).then(sucessCbGetAllCreateUser, errorCbGetAllCreateUser)
            } else {
                ServiceProxy.createInternalUser(vm.userData).then(sucessCbGetAllCreateUser, errorCbGetAllCreateUser);
            }
        }
        /////////////////////////////////////////////ends mapping customer here/////////////////////////////////////////////

        ///////////////////////////get internal user by id starts here////////////////////////////
        function sucessCbGetInternalUserById(response) {
            if (response.data && response.data.baseUrl && response.data.data.image) {
                vm.dummyImage = response.data.baseUrl + response.data.data.image
            }
            if (response.data && response.data.data) {
                if (response.data.data.mobileNo) {
                    response.data.data.mobileNo = parseInt(response.data.data.mobileNo);
                }
                vm.userData = response.data.data;
                if (vm.userData && vm.userData.active) {
                    delete vm.userData.active;
                }
            }
            // if (vm.userData.features.length > 0) {
            //     if (response.data && response.data.data && (response.data.data.features.indexOf('CUSTOMER::MANAGEMENT') !== -1)) {
            //         vm.activeCustomerListFlag = true;

            //         getMappingCustomerDetails(1);
            //     }
            // }
            vm.internalUserSelectedFeatures = vm.userData.features;
            angular.forEach(vm.internalAssignFeature, function (featureItem) {
                if (vm.userData.features.indexOf(featureItem.fId) !== -1) {
                    featureItem.assignedFeature = true;
                } else {
                    featureItem.assignedFeature = false;
                }

            })
        }

        function errorCbGetInternalUserById(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getInternalUserById(id) {
            ServiceProxy.getInternalUserById(id).then(sucessCbGetInternalUserById, errorCbGetInternalUserById)
        }
        ///////////////////////////get internal user by id ends here////////////////////////////

        //////////////////////////get all internal customer mapping starts here//////////////////////
        function sucessCbGetAllMappingCustomer(response) {
            vm.mappingAllCustomer = angular.copy(response.data.data);
            angular.forEach(vm.mappingAllCustomer, function (item) {
                angular.forEach(vm.selectedCustomer, function (selectedItem) {
                    if (selectedItem._id === item._id) {
                        item.selected = angular.copy(true);
                    }

                })
            })
        }

        function errorCbGetAllMappingCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getMappingCustomerDetails(number) {
            ServiceProxy.getMappingCustomerDetails(number).then(sucessCbGetAllMappingCustomer, errorCbGetAllMappingCustomer)
        }

        //////////////////////////get all internal customer mapping ends here//////////////////////

        ///////////////////////////////select to checkboc and move to another side starts here//////////////
        function toggleAllCustomer() {
            if (vm.allselected) {
                vm.allDeselected = true;
                angular.forEach(vm.mappingAllCustomer, function (item) {
                    item.selected = true;
                })
                vm.selectedCustomer = angular.copy(vm.mappingAllCustomer);

            } else {
                deselectAll()
            }
        }

        function deselectAll() {
            vm.selectedCustomer = [];
            vm.allselected = false;
            vm.allDeselected = false;
            angular.forEach(vm.mappingAllCustomer, function (item) {
                item.selected = false;
            })
        }

        function singleDeselect(item, index) {
            if (item.assignedFlag) {
                return deassignedMappedCustomer(item, index);
            }
            if (item.selected) {
                var index = vm.selectedCustomer.findIndex(function (selecteditem) {
                    return selecteditem._id === item._id;
                })
                if (index === -1) {
                    vm.selectedCustomer.push(angular.copy(item));
                }

            } else {
                var mainindex = vm.mappingAllCustomer.findIndex(function (selecteditem) {
                    return selecteditem._id === item._id;
                })
                if (mainindex !== -1) {
                    vm.mappingAllCustomer[mainindex].selected = false;
                }

                var index = vm.selectedCustomer.findIndex(function (selecteditem) {
                    return selecteditem._id === item._id;
                })
                vm.selectedCustomer.splice(index, 1);
                vm.allselected = false;
            }
            if (vm.selectedCustomer.length > 0) {
                vm.allDeselected = true;
            } else {
                vm.allDeselected = false;
            }
        }
        ///////////////////////////////select to checkboc and move to another side ends here//////////////


        /////////////////////////////starts internal user mapping data here////////////////////////////
        function sucessCbGetAssignedCustomer(response) {
            $state.go('app.internalUser.internalUserList');
        }

        function errorCbGetAssignedCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function userMappingData() {
            var postData = {
                assignedUserId: vm.createUser.id,
                investorsIds: []
            }
            angular.forEach(vm.selectedCustomer, function (item) {
                if (!item.assignedFlag) {
                    postData.investorsIds.push(item._id)
                }

            })
            ServiceProxy.createAssignedCustomer(postData).then(sucessCbGetAssignedCustomer, errorCbGetAssignedCustomer)
        }
        /////////////////////////////ends internal user mapping data here////////////////////////////

        function sucessCbGetInternalUserDetaisl(response) {
            vm.showEachDetailMapping = response.data.data;
            vm.query.limit = vm.showEachDetailMapping.length;
        }

        function errorCbGetInternalUserDetaisl(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getInternalUserDetalsById(id) {
            ServiceProxy.getInternalUserDetalsById(id).then(sucessCbGetInternalUserDetaisl, errorCbGetInternalUserDetaisl)
        }

        // === === === === === Disable Internal user === === === ===
        function disableAssignfeature() {
            return !(vm.userData.userName && vm.userData.email && vm.userData.mobileNo && vm.userData.type || vm.userData.brokerCode || vm.userData.arnCode || vm.userData.euin);
        }

        function navigateAssignFeature() {
            vm.activeAssignFeature = true;
        }

        function activeFalseAssignFeature() {
            vm.activeAssignFeature = false;
            vm.activeAssignMappingUser = false;
        }


        vm.disablesetInternalUserMapping = function () {
            return !(vm.userData.userName && vm.userData.email && vm.userData.mobileNo && vm.userData.type && vm.internalUserSelectedFeatures.length > 0);
        }

        ////////////////////////////////////////////Get All Assigned USer Start////////////////////////////////////////////////////////////

        function sucessCbGetAllAssignedUser(response) {
            vm.selectedCustomer = response.data.data;
            if (vm.selectedCustomer.length > 0) {
                angular.forEach(vm.selectedCustomer, function (item) {
                    item.selected = true;
                    item.assignedFlag = true;
                })
                vm.allDeselected = true
            }

        }

        function errorCbGetAllAssignedUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllAssignedUser(id) {
            ServiceProxy.getAllAssignedUser(id).then(sucessCbGetAllAssignedUser, errorCbGetAllAssignedUser)
        }
        ////////////////////////////////////////////Get All Assigned USer End////////////////////////////////////////////////////////////

        /////////////////////////////starts internal user mapping dessigned data here////////////////////////////
        function sucessCbGetDeassignedCustomer(response) {
            vm.selectedCustomer.splice(vm.index, 1);
            vm.index = null;
            getMappingCustomerDetails(+vm.currentNavItem);
            if (vm.selectedCustomer.length > 0) {
                vm.allDeselected = true;
            } else {
                vm.allDeselected = false;
            }
        }

        function errorCbGetDeassignedCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function deassignedMappedCustomer(customerMapped, index) {
            vm.index = index;
            ServiceProxy.updateDeassignedCustomer(customerMapped._id).then(sucessCbGetDeassignedCustomer, errorCbGetDeassignedCustomer)
        }
        /////////////////////////////ends internal user mapping dessigned data here////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        // image upload
        function processFile(files) {

            var fileReader = new FileReader();
            var image = new Image();
            var validExts = new Array(".jpeg", ".jpg", ".png");
            var fileExt = files[0].name;

            fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
            if (validExts.indexOf(fileExt) < 0) {
                showDialog("Invalid file selected, valid files are of " +
                    validExts.toString() + " types.");
                $(files[0]).val("");
                return false;
            };

            fileReader.onload = function (event) {
                var uri = event.target.result;
                image.src = uri;
                image.onload = function () {
                    if (files[0].file.size > 204800) {
                        showDialog("file size should not be greater than 200 KB");
                        $scope.$apply(function () {
                            $scope.imageFile.flowObj.cancel();
                            files[0] = {};
                        });
                    } else {
                        // $scope.imageFiles.flowObj=files[0];
                    }
                }
            }

            fileReader.readAsDataURL(files[0].file);
        };

        /// internal user image upload
        function sucessCbInternalUserImageUpload(response) {}

        function errorCbInternalUserImageUpload(error) {}

        function internalUserImageUpload(id) {
            var data = new FormData();
            data.append('image', vm.imageFile.flowObj.files[0].file)
            ServiceProxy.internalUserImageUpload(data, id).then(sucessCbInternalUserImageUpload, errorCbInternalUserImageUpload)
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.internalUser')
        .controller('InternalUserController', InternalUserController);

    /** @ngInject */
    function InternalUserController($rootScope, $state, $mdDialog, $stateParams, $q, $timeout, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.imageFile = {
                flowObj: {}
            };
            vm.brokerDetail = angular.copy(ShareDataService.getData('brokerDetail'));
            vm.processFile = processFile;
            vm.dummyImage = 'assets/images/backgrounds/header-bg.png';
            vm.userNameReg = /^[a-zA-Z ]{2,50}$/;
            vm.contactNumberReg = /^[0-9]{10,10}$/;
            vm.emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            vm.userData = {};
            if(vm.brokerDetail!==undefined){
                vm.userData.email = vm.brokerDetail.personalDetails.email
                vm.userData.userName = vm.brokerDetail.personalDetails.firstName +" "+vm.brokerDetail.personalDetails.lastName
                vm.userData.mobileNo = vm.brokerDetail.personalDetails.phone
                vm.userData.arnCode = vm.brokerDetail.accountDetails.arnNo
            }
            
            vm.createUser = {};
            vm.activeAssignFeature = false;
            vm.activeAssignMappingUser = false;
            vm.currentNavItem = '1';
            vm.getAssignFeature = getAssignFeature;
            vm.getAssignData = getAssignData;
            vm.internalUserSelectedFeatures = [];
            vm.setInternalUserMapping = setInternalUserMapping;
            vm.disableAssignfeature = disableAssignfeature;
            vm.navigateAssignFeature = navigateAssignFeature;
            vm.activeFalseAssignFeature = activeFalseAssignFeature;
            vm.userMappingData = userMappingData;
            vm.selectCustomer = getMappingCustomerDetails;
            vm.singleDeselect = singleDeselect;
            vm.allselected = false;
            vm.activeCustomerListFlag = false;
            vm.toggleAllCustomer = toggleAllCustomer;
            vm.deselectAll = deselectAll;
            vm.selectedCustomer = [];
            vm.singleCustomers = [];

            vm.fetchoffice = fetchoffice;
            vm.fetchfinanceuser = fetchfinanceuser;
            vm.advisordata = advisordata;
            vm.selecttype = selecttype;

            if ($stateParams.editId) {
                vm.internaluserId = $stateParams.editId;
                vm.createUser.id = vm.internaluserId;
                getAllAssignedUser(vm.internaluserId)
            }
            getTypeInternalUser();
            getAssignFeature();

        };
        init();

        //////////////////////////////get all internal user type starts here///////////////////////////////////////////
        function sucessCbGetAllTypeInternalUser(response) {
            vm.internalUserType = response.data.data;
        }

        function errorCbGetAllTypeInternalUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getTypeInternalUser() {
            ServiceProxy.getTypeInternalUser().then(sucessCbGetAllTypeInternalUser, errorCbGetAllTypeInternalUser)
        }
        //////////////////////////////get all internal user type ends here///////////////////////////////////////////

        //////////////////////////////get all internal user type starts here///////////////////////////////////////////
        function sucessCbGetAllAssignFeature(response) {
            vm.internalAssignFeature = response.data.data;
            if ($stateParams.editId) {
                getInternalUserById($stateParams.editId);
            }
        }

        function errorCbGetAllAssignFeature(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAssignFeature() {
            ServiceProxy.getAssignFeature().then(sucessCbGetAllAssignFeature, errorCbGetAllAssignFeature)
        }

        function getAssignData(feature) {
            var index = vm.internalUserSelectedFeatures.indexOf(feature.fId);
            if (index === -1) {
                vm.internalUserSelectedFeatures.push(feature.fId);
            } else {
                vm.internalUserSelectedFeatures.splice(index, 1)
            }
        }

        //////////////////////////////get all internal user type ends here///////////////////////////////////////////


        /////////////////////////////////////////////starts mapping customer here/////////////////////////////////////////////
        function sucessCbGetAllCreateUser(response) {
            vm.activeAssignMappingUser = true;
            // if (response.data && response.data.data && (response.data.data.features.indexOf('CUSTOMER::MANAGEMENT') !== -1)) {
            //     vm.activeCustomerListFlag = true;
            //     vm.createUser.id = response.data.data._id;
            //     getMappingCustomerDetails(1);
            // } else {
            //     vm.activeCustomerListFlag = false;

            // }

            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(response.statusText)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm)
                .then(goToList);
        }

        function goToList(){
            if (vm.imageFile.flowObj.files.length) {
                internalUserImageUpload(response.data.data._id);
            };
            $state.go('app.internalUser.internalUserList');
        }

        function errorCbGetAllCreateUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            } else {
                showDialog('Something went wrong.Please Try Again.');
            }
        }

        // function setInternalUserMapping() {
        //     vm.userData.features = vm.internalUserSelectedFeatures;
        //     if (vm.internaluserId) {
        //         ServiceProxy.updateInternalUser(vm.userData, vm.internaluserId).then(sucessCbGetAllCreateUser, errorCbGetAllCreateUser)
        //     } else {
        //         ServiceProxy.createInternalUser(vm.userData).then(sucessCbGetAllCreateUser, errorCbGetAllCreateUser);
        //     }
        // }
        function setInternalUserMapping() {
            vm.userData.features = vm.internalUserSelectedFeatures;
            if(vm.financeuser==true){
                if(vm.userData.advisor){
                    vm.userData.advisor=vm.userData.advisor._id;
                    vm.usertik=true;
                }    
            }else{
                vm.userData.advisor=null;

            }
            if (vm.internaluserId) {
                ServiceProxy.updateInternalUser(vm.userData, vm.internaluserId).then(sucessCbGetAllCreateUser, errorCbGetAllCreateUser)
            } else {
                ServiceProxy.createInternalUser(vm.userData).then(sucessCbGetAllCreateUser, errorCbGetAllCreateUser);
               
            }
        }
        /////////////////////////////////////////////ends mapping customer here/////////////////////////////////////////////

        ///////////////////////////get internal user by id starts here////////////////////////////
        function sucessCbGetInternalUserById(response) {
            if (response.data && response.data.baseUrl && response.data.data.image) {
                vm.dummyImage = response.data.baseUrl + response.data.data.image
            }
            if (response.data && response.data.data) {
                if (response.data.data.mobileNo) {
                    response.data.data.mobileNo = parseInt(response.data.data.mobileNo);
                }
                vm.userData = response.data.data;
                
                if (vm.userData.advisor) {
                    vm.usertik = true;
                    vm.financeuser = true;
                } else {
                    if (vm.userData.type == "SUB::BROKER" || vm.userData.type == "FINANCE::USER") {
                        vm.usertik = false;
                    } else {
                        vm.usertik = true;
                    }
                }

                if (vm.userData && vm.userData.active) {
                    delete vm.userData.active;
                }
            }
            
            // if (vm.userData.features.length > 0) {
            //     if (response.data && response.data.data && (response.data.data.features.indexOf('CUSTOMER::MANAGEMENT') !== -1)) {
            //         vm.activeCustomerListFlag = true;

            //         getMappingCustomerDetails(1);
            //     }
            // }
            vm.internalUserSelectedFeatures = vm.userData.features;
            angular.forEach(vm.internalAssignFeature, function (featureItem) {
                if (vm.userData.features.indexOf(featureItem.fId) !== -1) {
                    featureItem.assignedFeature = true;
                } else {
                    featureItem.assignedFeature = false;
                }

            })
        }

        function errorCbGetInternalUserById(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getInternalUserById(id) {
            ServiceProxy.getInternalUserById(id).then(sucessCbGetInternalUserById, errorCbGetInternalUserById)
        }
        ///////////////////////////get internal user by id ends here////////////////////////////

        //////////////////////////get all internal customer mapping starts here//////////////////////
        function sucessCbGetAllMappingCustomer(response) {
            vm.mappingAllCustomer = angular.copy(response.data.data);
            angular.forEach(vm.mappingAllCustomer, function (item) {
                angular.forEach(vm.selectedCustomer, function (selectedItem) {
                    if (selectedItem._id === item._id) {
                        item.selected = angular.copy(true);
                    }

                })
            })
        }

        function errorCbGetAllMappingCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getMappingCustomerDetails(number) {
            ServiceProxy.getMappingCustomerDetails(number).then(sucessCbGetAllMappingCustomer, errorCbGetAllMappingCustomer)
        }

        //////////////////////////get all internal customer mapping ends here//////////////////////

        ///////////////////////////////select to checkboc and move to another side starts here//////////////
        function toggleAllCustomer() {
            if (vm.allselected) {
                vm.allDeselected = true;
                angular.forEach(vm.mappingAllCustomer, function (item) {
                    item.selected = true;
                })
                vm.selectedCustomer = angular.copy(vm.mappingAllCustomer);

            } else {
                deselectAll()
            }
        }

        function deselectAll() {
            vm.selectedCustomer = [];
            vm.allselected = false;
            vm.allDeselected = false;
            angular.forEach(vm.mappingAllCustomer, function (item) {
                item.selected = false;
            })
        }

        function singleDeselect(item, index) {
            if (item.assignedFlag) {
                return deassignedMappedCustomer(item, index);
            }
            if (item.selected) {
                var index = vm.selectedCustomer.findIndex(function (selecteditem) {
                    return selecteditem._id === item._id;
                })
                if (index === -1) {
                    vm.selectedCustomer.push(angular.copy(item));
                }

            } else {
                var mainindex = vm.mappingAllCustomer.findIndex(function (selecteditem) {
                    return selecteditem._id === item._id;
                })
                if (mainindex !== -1) {
                    vm.mappingAllCustomer[mainindex].selected = false;
                }

                var index = vm.selectedCustomer.findIndex(function (selecteditem) {
                    return selecteditem._id === item._id;
                })
                vm.selectedCustomer.splice(index, 1);
                vm.allselected = false;
            }
            if (vm.selectedCustomer.length > 0) {
                vm.allDeselected = true;
            } else {
                vm.allDeselected = false;
            }
        }
        ///////////////////////////////select to checkboc and move to another side ends here//////////////


        /////////////////////////////starts internal user mapping data here////////////////////////////
        function sucessCbGetAssignedCustomer(response) {
            $state.go('app.internalUser.internalUserList');
        }

        function errorCbGetAssignedCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function userMappingData() {
            var postData = {
                assignedUserId: vm.createUser.id,
                investorsIds: []
            }
            angular.forEach(vm.selectedCustomer, function (item) {
                if (!item.assignedFlag) {
                    postData.investorsIds.push(item._id)
                }

            })
            ServiceProxy.createAssignedCustomer(postData).then(sucessCbGetAssignedCustomer, errorCbGetAssignedCustomer)
        }
        /////////////////////////////ends internal user mapping data here////////////////////////////

        function sucessCbGetInternalUserDetaisl(response) {
            vm.showEachDetailMapping = response.data.data;
            vm.query.limit = vm.showEachDetailMapping.length;
        }

        function errorCbGetInternalUserDetaisl(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getInternalUserDetalsById(id) {
            ServiceProxy.getInternalUserDetalsById(id).then(sucessCbGetInternalUserDetaisl, errorCbGetInternalUserDetaisl)
        }

        // === === === === === Disable Internal user === === === ===
        function disableAssignfeature() {
            // Basic required fields for all user types
            if (!vm.userData.userName || !vm.userData.email || !vm.userData.mobileNo || !vm.userData.type || !vm.userData.office) {
                return true; // Disable button
            }

            // SUB::BROKER requires brokerCode, arnCode, euin
            if (vm.userData.type === 'SUB::BROKER') {
                return !(vm.userData.brokerCode && vm.userData.arnCode && vm.userData.euin);
            }

            // FINANCE::USER requires euin
            if (vm.userData.type === 'FINANCE::USER') {
                return !vm.userData.euin;
            }

            // Needs finance user selected when vm.financeuser===true
            if (vm.userData.type === 'SALES::USER' && vm.financeuser === true) {
                // finance user name (advisor) mandatory
                return !vm.userData.advisor;
            }

            // Otherwise, all checks passed
            return false;
        }

        function navigateAssignFeature() {
            vm.activeAssignFeature = true;
        }

        function activeFalseAssignFeature() {
            vm.activeAssignFeature = false;
            vm.activeAssignMappingUser = false;
        }


        vm.disablesetInternalUserMapping = function () {
            return !(vm.userData.userName && vm.userData.email && vm.userData.mobileNo && vm.userData.type && vm.internalUserSelectedFeatures.length > 0);
        }

        ////////////////////////////////////////////Get All Assigned USer Start////////////////////////////////////////////////////////////

        function sucessCbGetAllAssignedUser(response) {
            vm.selectedCustomer = response.data.data;
            if (vm.selectedCustomer.length > 0) {
                angular.forEach(vm.selectedCustomer, function (item) {
                    item.selected = true;
                    item.assignedFlag = true;
                })
                vm.allDeselected = true
            }

        }

        function errorCbGetAllAssignedUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllAssignedUser(id) {
            ServiceProxy.getAllAssignedUser(id).then(sucessCbGetAllAssignedUser, errorCbGetAllAssignedUser)
        }
        ////////////////////////////////////////////Get All Assigned USer End////////////////////////////////////////////////////////////

        /////////////////////////////starts internal user mapping dessigned data here////////////////////////////
        function sucessCbGetDeassignedCustomer(response) {
            vm.selectedCustomer.splice(vm.index, 1);
            vm.index = null;
            getMappingCustomerDetails(+vm.currentNavItem);
            if (vm.selectedCustomer.length > 0) {
                vm.allDeselected = true;
            } else {
                vm.allDeselected = false;
            }
        }

        function errorCbGetDeassignedCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function deassignedMappedCustomer(customerMapped, index) {
            vm.index = index;
            ServiceProxy.updateDeassignedCustomer(customerMapped._id).then(sucessCbGetDeassignedCustomer, errorCbGetDeassignedCustomer)
        }
        /////////////////////////////ends internal user mapping dessigned data here////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        // image upload
        function processFile(files) {

            var fileReader = new FileReader();
            var image = new Image();
            var validExts = new Array(".jpeg", ".jpg", ".png");
            var fileExt = files[0].name;

            fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
            if (validExts.indexOf(fileExt) < 0) {
                showDialog("Invalid file selected, valid files are of " +
                    validExts.toString() + " types.");
                $(files[0]).val("");
                return false;
            };

            fileReader.onload = function (event) {
                var uri = event.target.result;
                image.src = uri;
                image.onload = function () {
                    if (files[0].file.size > 204800) {
                        showDialog("file size should not be greater than 200 KB");
                        $scope.$apply(function () {
                            $scope.imageFile.flowObj.cancel();
                            files[0] = {};
                        });
                    } else {
                        // $scope.imageFiles.flowObj=files[0];
                    }
                }
            }

            fileReader.readAsDataURL(files[0].file);
        };

        /// internal user image upload
        function sucessCbInternalUserImageUpload(response) {}

        function errorCbInternalUserImageUpload(error) {}

        function internalUserImageUpload(id) {
            var data = new FormData();
            data.append('image', vm.imageFile.flowObj.files[0].file)
            ServiceProxy.internalUserImageUpload(data, id).then(sucessCbInternalUserImageUpload, errorCbInternalUserImageUpload)
        }

        // internal  user office and advisor mapping
        function fetchoffice() {
            ServiceProxy.fetchoffice({}).then(function (response, err) {
                vm.fetchcitydat = response.data.data;
            })
        }

        function fetchfinanceuser() {
            ServiceProxy.fetchfinanceuser({}).then(function (response, err) {
                vm.financeUserType = response.data.data;
            })
        }
        function selecttype(type) {
            if (type == "SALES::USER") {
                vm.usertik = true;
                vm.userData.brokerCode = undefined;
                vm.userData.arnCode = undefined;
                vm.userData.euin = undefined;

            } else {
                if (type == "SUB::BROKER") {
                    vm.usertik = false;
                    vm.financeuser = false;
                } else {
                    vm.userData.brokerCode = undefined;
                    vm.userData.arnCode = undefined;
                    vm.usertik = false;
                    vm.financeuser = false;
                }
            }
        }
        function advisordata(searchText) {
            var result = vm.financeUserType;
            var deferred;

            if (searchText) {
                deferred = $q.defer();

                $timeout(function () {
                    var states = vm.financeUserType.filter(function (state) {
                        var advisor = state.userName;
                        return (advisor ? advisor.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || advisor.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 : null);
                    });
                    deferred.resolve(states);
                }, 1500);

                return deferred.promise;
            } else {
                return result;
            }
        }
        ///
    }
})();
(function() {
    'use strict';

    angular
        .module('app.internalUser')
        .controller('InternalUserDetails', InternalUserDetails);

    /** @ngInject */
    function InternalUserDetails($rootScope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService, StorageService, $filter) {
        var vm = this;

        function init() {
            vm.role = StorageService.getSessionStorage('type');
            ShareDataService.storeData('customerDetail', '');
            vm.index = null;
            vm.query = {
                limit: 100
            };
            vm.deassignedMappedCustomer = deassignedMappedCustomer;
            if ($stateParams.userViewId) {
                vm.internaluserId = $stateParams.userViewId;
            }
            
            vm.allFeatures = [];
            vm.typerename = {
                'SUB::BROKER': 'Sub Broker',
                'INTERNAL::USER': 'Internal User'
            }
            getInternalUserById(vm.internaluserId);
            getInternalUserDetalsById(vm.internaluserId);
            vm.gotoFlags = gotoFlags;
            vm.customerDetailFunction = customerDetailFunction;
        };
        init();

        ///////////////////////////get internal user by id starts here////////////////////////////
        function sucessCbGetInternalUserById(response) {
            vm.showEachDetail = response.data.data;
            getAllFeatures();
        }

        function errorCbGetInternalUserById(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getInternalUserById(id) {
            ServiceProxy.getInternalUserById(id).then(sucessCbGetInternalUserById, errorCbGetInternalUserById)
        }
        ///////////////////////////get internal user by id ends here////////////////////////////

        // === === === === === ===  === Get All Features === === === === === === === === 
        function errorGetAllFeatures(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function successGetallFeatures(response) {
            vm.allFeatures = response.data.data;
            if (vm.allFeatures.length > 0) {
                vm.showEachDetail.featureName = [];
                angular.forEach(vm.showEachDetail.features, function(internalUserList) {
                    angular.forEach(vm.allFeatures, function(feature) {
                        if (feature.fId === internalUserList) {
                            vm.showEachDetail.featureName.push(feature.name)
                        }

                    })
                });
            }
        }

        function getAllFeatures() {
            ServiceProxy.getAssignFeature().then(successGetallFeatures, errorGetAllFeatures);
        }
        // === === === === === ===  === Get All Features === === === === === === === ===  

        ///////////////////////get internal user details by id starts here////////////////////////////////////
        function sucessCbGetInternalUserDetaisl(response) {
            angular.forEach(response.data.data, function(itemObj) {
                itemObj.flagLength = 0;
                if (itemObj.monitoringFlags) {
                    for (var key in itemObj.monitoringFlags) {
                        if (vm.role === 'SUPER::ADMIN') {
                            if (key == 'assignedFlag' && itemObj.monitoringFlags[key]) {
                                delete itemObj.monitoringFlags[key];
                            }
                        }
                        if (key == 'documentFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'loanFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'insuranceFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'sipFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'lumpsumFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'signupFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'iinCreationFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'externalHoldingFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'reversalFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'assignedFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'reviewPendingFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'iinActiveFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'fatcakycuboRegFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                        if (key == 'achmandateRegFlag' && itemObj.monitoringFlags[key]) {
                            itemObj.flagLength++;
                        }
                    }
                }

            })
            response.data.data = $filter('orderBy')(response.data.data, '-flagLength');
            vm.showEachDetailMapping = response.data.data;
            vm.query.limit = vm.showEachDetailMapping.length;
        }

        function errorCbGetInternalUserDetaisl(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getInternalUserDetalsById(id) {
            ServiceProxy.getInternalUserDetalsById(id).then(sucessCbGetInternalUserDetaisl, errorCbGetInternalUserDetaisl)
        }

        ///////////////////////get internal user details by id ends here////////////////////////////////////


        /////////////////////////////starts internal user mapping dessigned data here////////////////////////////
        function sucessCbGetDeassignedCustomer(response) {
            vm.showEachDetailMapping.splice(vm.index, 1);
            vm.index = null;
        }

        function errorCbGetDeassignedCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function deassignedMappedCustomer(customerMapped, index, event) {
            event.stopPropagation();
            vm.index = index;
            ServiceProxy.updateDeassignedCustomer(customerMapped.id).then(sucessCbGetDeassignedCustomer, errorCbGetDeassignedCustomer)
        }
        /////////////////////////////ends internal user mapping dessigned data here////////////////////////////


        /////////////////////////////=== === === === === === === === //////////////////////////////////////////
        // Customer Detail Start
        function sucessCbUserProfile(response) {
            response.data.data.baseUrl = vm.baseUrl;
            ShareDataService.storeData('customerDetail', response.data.data);
            if (vm.key === 'Flag') {
                $state.go('app.customers.customerhome.flags');
            } else {
                $state.go('app.customers.customerhome.userDetail');
            }
        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function customerDetailFunction(customer) {
            ServiceProxy.getUserProfile(customer._id).then(sucessCbUserProfile, errorGetUserProfile)
        }

        function gotoFlags(event, customer, key) {
            vm.key = key;
            event.preventDefault();
            customerDetailFunction(customer);
        }
        /////////////////////////////=== === === === === === === === //////////////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////

    }
})();
(function() {
	'use strict';

	angular
		.module('app.quotation', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		var fId = 'DASHBOARD::FEATURE';
		// State
		
		$stateProvider
			.state('app.quotation', {
				url: '/quotation',
				views: {
					'content@app': {
						templateUrl: 'app/main/insurance/quotation/quotation.html',
						controller: 'quotationController as vm'
					}
				},
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
			})

		msNavigationServiceProvider.saveItem('insurance.quotation', {
			title: 'Quotation',
			icon: 'icon-tile-four',
			state: 'app.quotation',
			weight: 10
		});
	}
})();

//const { V4MAPPED } = require("dns");

(function () {

	'use strict';

	angular.module('app.quotation').controller('quotationController', quotationController);
	
	/** @ngInject */
	function quotationController($state,$window, $stateParams, $q, StorageService, $scope, $filter, $timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		
    }
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('FlagDetailsController', FlagDetailsController);

    /** @ngInject */
    function FlagDetailsController($rootScope, $stateParams, $state, $mdDialog, ServiceProxy, ShareDataService, StorageService, $filter) {
        var vm = this;

        function init() {
            vm.gotoFlags = gotoFlags;
            vm.customerDetailFunction = customerDetailFunction;
            if ($stateParams.empViewId && $stateParams.from && $stateParams.to) {
                getByIdEmployeePerformanceRange($stateParams.empViewId, $stateParams.from, $stateParams.to);
            } else {
                getByIdEmployeePerformanceToday($stateParams.empViewId);
            }
            vm.flagClass = flagClass;
        };
        init();

        //////////////////////////////////////flag color change of monitoring flag history starts here//////////////////////////
        function flagClass(flag) {
            if (flag.activityName === 'DOCUMENT') {
                return 'bgColorMenu1DD';
            }
            if (flag.activityName === 'LOAN') {
                return 'bgColorMenu2DD';
            }
            if (flag.activityName === 'INSURANCE') {
                return 'bgColorMenu3DD';
            }
            if (flag.activityName === 'SIP') {
                return 'bgColorMenu4DD';
            }
            if (flag.activityName === 'LUMPSUM') {
                return 'bgColorMenu5DD';
            }
            if (flag.activityName === 'SIGNUP') {
                return 'bgColorMenu6DD';
            }
            if (flag.activityName === 'IIN_CREATION') {
                return 'bgColorMenu7DD';
            }
            if (flag.activityName === 'EXTERNAL_HOLDING') {
                return 'bgColorMenu8DD';
            }
            if (flag.activityName === 'REVERSAL') {
                return 'bgColorMenu9DD';
            }
            if (flag.activityName === 'ASSIGNED') {
                return 'bgColorMenu10DD';
            }
            if (flag.activityName === 'REVIEW_PENDING') {
                return 'bgColorMenu11DD';
            }
            if (flag.activityName === 'IIN_ACTIVE') {
                return 'bgColorMenu12DD';
            }
            if (flag.activityName === 'FATCA_KYC_UBO_REG') {
                return 'bgColorMenu13DD';
            }
            if (flag.activityName === 'ACHMANDATE_REG') {
                return 'bgColorMenu14DD';
            }
        }
        //////////////////////////////////////flag color change of monitoring flag history ends here//////////////////////////

        ///////////////////////////////////////Starts api integrated of today flag closed by id////////////////////////////
        function sucessCbGetByIdTodayFlagEmp(response) {
            vm.empPerformanceAllFlag = response.data.data;
        }

        function errorCbGetByIdTodayFlagEmp(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getByIdEmployeePerformanceToday(id) {
            ServiceProxy.getByIdEmployeePerformanceToday(id).then(sucessCbGetByIdTodayFlagEmp, errorCbGetByIdTodayFlagEmp)
        }
        ///////////////////////////////////////Ends api integrated of today flag closed by id////////////////////////////

        ///////////////////////////////////////Starts api integrated of Range flag closed by id////////////////////////////
        function getByIdEmployeePerformanceRange(id, from, to) {
            ServiceProxy.getByIdEmployeePerformanceRange(id, from, to).then(sucessCbGetByIdTodayFlagEmp, errorCbGetByIdTodayFlagEmp)
        }
        ///////////////////////////////////////Ends api integrated of Range flag closed by id////////////////////////////

        ////////////////////////////////////starts back to original page here/////////////////////////////////////////////
        function gotoFlags(event, item, key) {
            vm.key = key;
            event.preventDefault();
            employeeDateFilter(item);
        }
        ////////////////////////////////////Ends back to original page here/////////////////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        function sucessCbUserProfile(response) {
            // response.data.data.baseUrl = vm.baseUrl;
            ShareDataService.storeData('customerDetail', response.data.data);
           
                $state.go('app.customers.customerhome.userDetail');

        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function customerDetailFunction(customer) {
            ServiceProxy.getUserProfile(customer._id).then(sucessCbUserProfile, errorGetUserProfile)
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DetailsController', DetailsController);

    /** @ngInject */
    function DetailsController($rootScope, $state, $mdDialog, ServiceProxy, ShareDataService, StorageService, $filter) {
        var vm = this;

        function init() {
            vm.maxDate = new Date();
            vm.dashboardFilter = dashboardFilter;
            vm.role = StorageService.getSessionStorage('type');
            vm.currentNavItem = 'Details';
            vm.allDashboardDetails = {};
            vm.currentlyInvestedDisplay = false;
            vm.totalSIPDisplay = false;
            vm.totalLumpsumDisplay = false;
            vm.currentBothDisplay = false;
            dashboardFilter('INC');
            // getDashboardWithoutFilter();
            getAumInvestmentReports();
        };
        init();
        
        // Your controller for showing and displaying values
        vm.toggleVisibilityCurrentlyInvested = function() {
            vm.currentlyInvestedDisplay = !vm.currentlyInvestedDisplay;
        };
        vm.toggleVisibilityTotalSIP = function() {
            vm.totalSIPDisplay = !vm.totalSIPDisplay;
        }
        vm.toggleVisibilityTotalLumpsum = function() {
            vm.totalLumpsumDisplay = !vm.totalLumpsumDisplay;
        }
        vm.toggleVisibilityCurrentBoth = function() {
            vm.currentBothDisplay = !vm.currentBothDisplay;
        }

        //////////////////////////////////////show without filter details dashboard starts here////////////////////////////
        // function successGetDashboard(response) {
        //     vm.dashboardData = response.data.data;

        // }

        // function errorGetDashboard(response) {
        //     if (response && response.data && response.data.data) {
        //         showDialog(response.data.responseString);
        //     }
        // }

        // function getDashboardWithoutFilter() {
        //     ServiceProxy.getDashboardWithoutFilter().then(successGetDashboard, errorGetDashboard);
        // }

        function successGetInvestmentsREports(response) {
            vm.dashboardData = response.data.data;
        }

        function errorGetInvestmentsReports(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAumInvestmentReports() {
            //ServiceProxy.getAumInvestmentReports().then(successGetInvestmentsREports, errorGetInvestmentsReports);
            ServiceProxy.getAumReports().then(successGetInvestmentsREports, errorGetInvestmentsReports);
        }
        //////////////////////////////////////show without filter details dashboard ends here////////////////////////////

        /////////////////////////////////////////get all dashboards details starts here//////////////////////////////////
        function successGetAllDashboard(response) {
            vm.allDashboardDetails = response.data.data;
            vm.noInvstUser = vm.allDashboardDetails.activeUsers - vm.allDashboardDetails.investedUsers;
           // vm.assignedCustomer = vm.allDashboardDetails.totalUsers - vm.allDashboardDetails.unassignedUsers;
           vm.assignedCustomer = response.data.data.assignedUser;
           StorageService.setSessionStorage('IINActiveUser', vm.allDashboardDetails.activeOverallUsers);
        }

        function errorGetAllDashboard(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function dashboardFilter(filter) {
            vm.selectedFilterFlag = filter;
            if (filter === 'RNG') {
                filter = filter + '&&from=' + new Date(vm.orderDate.fromDate).setHours(0, 0, 0, 0) + '&&to=' + new Date(vm.orderDate.toDate).setHours(0, 0, 0, 0);
            }
            ServiceProxy.getDashboardDetails(filter).then(successGetAllDashboard, errorGetAllDashboard);
            // ServiceProxy.getDashboardInvestmentsDetails(filter).then(successGetAllDashboardInvestment, errorGetAllDashboardInvestment);
        }
        /////////////////////////////////////////////get all dashboards details ends here//////////////////////////////////

        ////////////////////////////////////////////show details of investments here//////////////////////////////////////
        // function successGetAllDashboardInvestment(response) {
        //     vm.allInternalInvestments = response.data.data;
        // }

        // function errorGetAllDashboardInvestment(response) {
        //     if (response && response.data && response.data.data) {
        //         showDialog(response.data.responseString);
        //     }
        // }


        //////////////////////////////////////////////ends details of investments here///////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
	'use strict';

	angular.module('app.dashboard').controller('ReportsController', ReportsController);

	/** @ngInject */
	function ReportsController(
		$rootScope,
		$state,
		$mdDialog,
		ServiceProxy,
		ShareDataService,
		StorageService,
		DashboardData
	) {
		var vm = this;

		function init() {
			vm.maxDate = new Date();
			vm.getBarGraphData = getBarGraphData;
			vm.selectedFilterFlag = 'INC';
			vm.getBarGraphData(vm.selectedFilterFlag);

			vm.piechartData = [];

			vm.dashboardData = DashboardData;
			vm.barChart = {
				labels: [],
				data: [],
				colors: [
					{
						backgroundColor: 'rgba(192,57,43, 1)',
						pointBackgroundColor: 'rgba(159,204,0, 1)',
						pointHoverBackgroundColor: 'rgba(159,204,0, 0.8)',
						borderColor: 'rgba(192,57,43, 1)',
						pointBorderColor: '#fff',
						pointHoverBorderColor: 'rgba(159,204,0, 1)'
					}
				],
				options: {
					scales: {
						xAxes: [
							{
								barThickness: 60
							}
						]
					}
				}
			};
			vm.barChart1 = {
				labels: [],
				series: ['IIN Activate'],
				data: [],
				colors: [
					{
						backgroundColor: 'rgba(0,0,255, 1)',
						pointBackgroundColor: 'rgba(159,204,0, 1)',
						pointHoverBackgroundColor: 'rgba(159,204,0, 0.8)',
						borderColor: 'rgba(0,0,255, 1)',
						pointBorderColor: '#fff',
						pointHoverBorderColor: 'rgba(159,204,0, 1)'
					}
				],
				options: {
					scales: {
						xAxes: [
							{
								barThickness: 60
							}
						]
					}
				}
			};

			vm.widget5 = {
				title: 'Graph of Investment',
				mainChart: {
					config: {
						refreshDataOnly: true,
						deepWatchData: true
					},
					options: {
						chart: {
							type: 'multiBarChart',
							color: ['#c0392b', '#0000ff'],
							height: 400,
							margin: {
								top: 80,
								right: 16,
								bottom: 32,
								left: 80
							},
							clipEdge: true,
							groupSpacing: 0.3,
							reduceXTicks: false,
							stacked: false,
							duration: 250,
							x: function(d) {
								return d.x;
							},
							y: function(d) {
								return d.y;
							},
							yAxis: {
								tickFormat: function(d) {
									return d;
								},
								axisLabel: 'Amount in Crore'
							},
							legend: {
								margin: {
									top: 8,
									bottom: 32
								}
							},
							controls: {
								margin: {
									top: 8,
									bottom: 32
								}
							},
							tooltip: {}
						}
					},
					data: []
				},
				supporting: {
					widgets: {
						created: {
							data: vm.dashboardData.widget5.supporting.created,
							chart: {
								data: []
							}
						},
						closed: {
							data: vm.dashboardData.widget5.supporting.closed,
							chart: {
								data: []
							}
						},
						reOpened: {
							data: vm.dashboardData.widget5.supporting.reOpened,
							chart: {
								data: []
							}
						},
						wontFix: {
							data: vm.dashboardData.widget5.supporting.wontFix,
							chart: {
								data: []
							}
						},
						needsTest: {
							data: vm.dashboardData.widget5.supporting.needsTest,
							chart: {
								data: []
							}
						},
						fixed: {
							data: vm.dashboardData.widget5.supporting.fixed,
							chart: {
								data: []
							}
						}
					},
					chart: {
						config: {
							refreshDataOnly: true,
							deepWatchData: true
						},
						options: {
							chart: {
								type: 'lineChart',
								color: ['#0000ff', '#c0392b'],
								height: 50,
								margin: {
									top: 8,
									right: 0,
									bottom: 0,
									left: 0
								},
								isArea: true,
								interpolate: 'cardinal',
								clipEdge: true,
								duration: 500,
								showXAxis: false,
								showYAxis: false,
								showLegend: false,
								useInteractiveGuideline: true,
								x: function(d) {
									return d.x;
								},
								y: function(d) {
									return d.y;
								},
								yDomain: [0, 9],
								xAxis: {
									tickFormat: function(d) {
										return vm.widget5.days[d];
									}
								},
								interactiveLayer: {
									tooltip: {}
								}
							}
						},
						data: []
					}
				},
				days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
				currentRange: '',
				changeRange: function(range) {
					vm.widget5.currentRange = range;
					angular.forEach(vm.dashboardData.widget5.mainChart, function(chartData, index) {
						vm.widget5.mainChart.data[index] = {
							key: chartData.key,
							values: chartData.values[range]
						};
					});

					angular.forEach(vm.dashboardData.widget5.supporting, function(widget, name) {
						vm.widget5.supporting.widgets[name].chart.data[0] = {
							key: widget.chart.key,
							values: widget.chart.values[range]
						};
					});
				},
				init: function() {
					vm.widget5.changeRange('TW');
				}
			};

			// Widget 8
			vm.widget8 = {
				mainChart: {
					options: {
						chart: {
							type: 'pieChart',
							color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
							height: 400,
							margin: {
								top: 0,
								right: 0,
								bottom: 0,
								left: 0
							},
							showLegend: false,
							labelType: 'percent',
							x: function(d) {
								return d.label;
							},
							y: function(d) {
								return d.value;
							},
							tooltip: {
								gravity: 's',
								classes: 'gravity-s'
							}
						}
					},
					data: vm.piechartData
				}
			};
		}
		init();

		///filter function
		function getBarGraphData(filter) {
			vm.selectedFilterFlag = filter;
			if (filter === 'RNG') {
				filter =
					filter +
					'&&from=' +
					new Date(vm.fromDate).setHours(0, 0, 0, 0) +
					'&&to=' +
					new Date(vm.toDate).setHours(0, 0, 0, 0);
			}
			getConsumerAcquisationData(filter);
			getIINActivateData(filter);
			getInvestmentData(filter);
			// getInvestmentProductData();
		}

		// function for acquisation data

		function sucessCbGetConsumerAcquisationData(response) {
			vm.barChart.data = response.data.data.data;
			vm.barChart.labels = response.data.data.labels;
		}

		function errorCbGetConsumerAcquisationData(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getConsumerAcquisationData(filter) {
			ServiceProxy.getConsumerAcquisationData(filter).then(
				sucessCbGetConsumerAcquisationData,
				errorCbGetConsumerAcquisationData
			);
		}

		// function for IIN activated data

		function sucessCbGetIINActivateData(response) {
			vm.barChart1.data = response.data.data.data;
			vm.barChart1.labels = response.data.data.labels;
		}

		function errorCbGetIINActivateData(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getIINActivateData(filter) {
			ServiceProxy.getIINActivateData(filter).then(sucessCbGetIINActivateData, errorCbGetIINActivateData);
		}

		// function to get investment data
		function sucessCbGetInvestmentData(response) {
			var lumpsumArray = [];
			var sipArray = [];
			angular.forEach(response.data.data.data, function(item, index) {
				var lx = {
					x: response.data.data.labels[index],
					y: item.l / 10000000
				};
				var sx = {
					x: response.data.data.labels[index],
					y: item.s / 10000000
				};
				lumpsumArray.push(lx);
				sipArray.push(sx);
			});
			vm.dashboardData.widget5.mainChart[0].values['TW'] = lumpsumArray;
			vm.dashboardData.widget5.mainChart[1].values['TW'] = sipArray;
			vm.widget5.changeRange('TW');
		}

		function errorCbGetInvestmentData(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getInvestmentData(filter) {
			ServiceProxy.getInvestmentData(filter).then(sucessCbGetInvestmentData, errorCbGetInvestmentData);
		}

		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function() {});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('app.send-app-link', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.send-app-link', {
				url: '/send-app-link',
				views: {
					'content@app': {
						templateUrl: 'app/main/communication/send-app-link/send-app-link.html',
						controller: 'sendAppLinkController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('customer.send-app-link', {
			title: 'Send App Link',
			icon: 'icon-tile-four',
			state: 'app.send-app-link',
			weight: 10
		});
	}
})();

(function () {

	'use strict';


	angular.module('app.send-app-link').controller('sendAppLinkController', sendAppLinkController);
	

	/** @ngInject */
	function sendAppLinkController($mdDialog, ServiceProxy,$window) {
		var vm = this;
		
		function init() {
			vm.customer = {};
			vm.customer.investors=[{}];
			vm.customer.investors.splice(0, 1);
			vm.add = add;
			vm.remove = remove;
			vm.disableSubmit = disableSubmit;
			vm.communicationSmsEmail = communicationSmsEmail;
		}
		init();
		function disableSubmit() {
			return !(vm.investorName && vm.vm.contact);
		}
		function add() {
			//Add the new item to the Array.
			var customer = {};
			customer.userName = vm.investorName;
			customer.mobileNo = vm.contact;
			customer.email = "";
			vm.customer.investors.push(customer);
			
			//Clear the TextBoxes.
			vm.investorName = "";
			vm.contact = "";
		}; 
		 
		function remove(index) {
			//Find the record using Index from Array.
			var name = vm.customer.investors[index].investorName;
			if ($window.confirm("Do you want to delete: " + name)) {
				//Remove the item from Array using Index.
				vm.customer.investors.splice(index, 1);
			}
		}

		function sucessCbCommunicationSmsEmail(response) {
			showDialogSucc(response.data.responseString);
			vm.customer.investors=[{}];
			vm.customer.investors.splice(0, 1);
        }

        function errorCbCommunicationSmsEmail(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
		}
		
		function communicationSmsEmail()
		{
			var service = "SMS";
			var postData = {
				"customers": vm.customer.investors,
			}
			ServiceProxy.communicationSmsEmail(postData,service).then(sucessCbCommunicationSmsEmail, errorCbCommunicationSmsEmail);
		}
		
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}
		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('EmployeeController', EmployeeController);

    /** @ngInject */
    function EmployeeController($rootScope, $state, $mdDialog, ServiceProxy, ShareDataService, StorageService, $filter) {
        var vm = this;

        function init() {
            vm.paramData = {};
            vm.selected = [];
            vm.maxDate = new Date();
            vm.assignSubBrokerDetails = assignSubBrokerDetails;
            vm.getRangeEmployeePerformance = getRangeEmployeePerformance;
            vm.employeeDateFilter = employeeDateFilter;
            vm.employeeDateFilter('TOD');
            vm.emp = {
                fromDate: null,
                toDate: null
            }
            vm.cancleDialog = cancleDialog;
            vm.goToFlagDetails = goToFlagDetails;
            vm.employeeFlagFilter = employeeFlagFilter;
        };
        init();

        function cancleDialog() {
            $mdDialog.hide()
        }

        //////////////////////////////////starts today managerial performance here/////////////////////////////
        function sucessCbGetTodayEmployeePerformance(response) {
            vm.employeePerformance = response.data.data;
        }

        function errorCbGetTodayEmployeePerformance(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function employeeDateFilter(filter) {
            vm.selectedFilterFlag = filter;
            if (filter === 'TOD') {
                vm.paramData = {};
                ServiceProxy.getTodayEmployeePerformance().then(sucessCbGetTodayEmployeePerformance, errorCbGetTodayEmployeePerformance);
            }
        }
        //////////////////////////////////Ends today managerial performance here/////////////////////////////

        /////////////////////////////////////starts employee performance range here/////////////////////////
        function getRangeEmployeePerformance() {
            if (vm.emp.fromDate && vm.emp.toDate) {
                var data = {
                    fromDate: new Date(vm.emp.fromDate).setHours(0, 0, 0, 0),
                    toDate: new Date(vm.emp.toDate).setHours(0, 0, 0, 0)
                }
                vm.paramData = data;
                ServiceProxy.getRangeEmployeePerformance(data).then(sucessCbGetTodayEmployeePerformance, errorCbGetTodayEmployeePerformance);
            }
        }
        /////////////////////////////////////////ends employee performance range here///////////////////////////

        /////////////////////////////////////////Starts assign sub broker details direct page/////////////////////////////////
        function assignSubBrokerDetails(evt, item) {
            evt.stopPropagation();
            if (item.assignedCustomers === 0) {
                $mdDialog.show({
                    controller: 'EmployeeController as vm',
                    templateUrl: 'app/main/dashboard/employee/dialogMsg.html',
                    parent: angular.element(document.body),
                    targetEvent: evt,
                    clickOutsideToClose: true,
                })
            } else {
                $state.go('app.internalUser.internalUserList.showDetails', { 'userViewId': item._id });
            }
        }
        /////////////////////////////////////////Ends assign sub broker details direct page/////////////////////////////////

        /////////////////////////////////////////Starts show flag details direct page//////////////////////////////////////////
        function goToFlagDetails(evt, item) {
            evt.stopPropagation();
            if (item.flagClosed === 0) {
                $mdDialog.show({
                    controller: 'EmployeeController as vm',
                    templateUrl: 'app/main/dashboard/employee/dialogMsgFlag.html',
                    parent: angular.element(document.body),
                    targetEvent: evt,
                    clickOutsideToClose: true,
                })
            } else {
                if (vm.paramData.fromDate && vm.paramData.toDate) {
                    $state.go('app.dashboard.employee.flagClosedDetail', { 'empViewId': item._id, 'from': vm.paramData.fromDate, 'to': vm.paramData.toDate });
                } else {
                    $state.go('app.dashboard.employee.flagClosedDetail', { 'empViewId': item._id });
                }
            }
        }
        /////////////////////////////////////////Ends show flag details direct page////////////////////////////////////////////

        ////////////////////////////////////flag distribution flag starts here//////////////////////////////////////////////
        function employeeFlagFilter(item) {
            if (item.length > 0) {
                ShareDataService.storeData('pendingflagcustomers', item);
                $state.go('app.customers');
            }
        }
        ///////////////////////////////////////flag distribution flag ends here/////////////////////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
	'use strict';

	angular
		.module('app.transaction-detailed-report', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		var fId = 'AUM::REPORT::DASHBOARD';
		$stateProvider
			.state('app.transaction-detailed-report', {
				url: '/transaction-detailed-report',
				views: {
					'content@app': {
                        templateUrl: 'app/main/communication/transaction-detailed-report/transaction-detailed-report.html',
                        controller: 'transactionDetailedReportController as vm'
                    }
				},
				data: {
					access: function () {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})

		msNavigationServiceProvider.saveItem('customer.transaction-detailed-report', {
			title: 'Transaction Detailed Report',
			icon: 'icon-tile-four',
			state: 'app.transaction-detailed-report',
			weight: 13,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			}
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('app.transaction-detailed-report')
        .controller('transactionDetailedReportController', transactionDetailedReportController);

    /** @ngInject */
    function transactionDetailedReportController($state, $location, $scope, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        // Initialize the controller
        function init() {
            // Transaction Type options based on API specification
            vm.transTypeArray = [
                { 'desc': 'Purchase', 'code': 'P' },
                { 'desc': 'Redemption', 'code': 'R' },
                { 'desc': 'All', 'code': 'ALL' }
            ];

            // Order Type options based on API specification
            vm.orderTypeArray = [
                { 'desc': 'All', 'code': 'ALL' },
                { 'desc': 'NRM', 'code': 'NRM' },
                { 'desc': 'SIP', 'code': 'SIP' },
                { 'desc': 'XSP', 'code': 'XSP' },
                { 'desc': 'STP', 'code': 'STP' }
            ];

            // Sub Order Type options based on API specification  
            vm.subOrderTypeArray = [
                { 'desc': 'All', 'code': 'ALL' },
                { 'desc': 'NRM', 'code': 'NRM' },
                { 'desc': 'SPOR', 'code': 'SPOR' },
                { 'desc': 'SWI', 'code': 'SWI' },
                { 'desc': 'STP', 'code': 'STP' }
            ];

            // Initialize default values
            vm.trans_type = 'ALL';
            vm.order_type = 'XSP';
            vm.sub_order_type = 'ALL';
            
            // Set default date range (last 7 days)
            var today = new Date();
            var sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(today.getDate() - 6);
            
            vm.from_date = sevenDaysAgo.toISOString().split('T')[0];
            vm.to_date = today.toISOString().split('T')[0];
            vm.maxDate = today.toISOString().split('T')[0];

            // Initialize arrays and functions
            vm.transactionReport = [];
            vm.searchCompleted = false;
            vm.getTransactionDetailedReport = getTransactionDetailedReport;
            vm.downloadTransactionReport = downloadTransactionReport;
            vm.validateDates = validateDates;
            vm.displayValue = displayValue;
        }
        init();

        // Display value function to handle null/empty values
        function displayValue(value) {
            if (value === null || value === undefined || value === '' || 
                (typeof value === 'object' && Object.keys(value).length === 0) || value === ' ') {
                return '-';
            }
            return value;
        }

        // Date validation function
        function validateDates() {
            if (vm.from_date && vm.to_date) {
                var fromDate = new Date(vm.from_date);
                var toDate = new Date(vm.to_date);

                // Check if the selected dates are within 7 days as per API specification
                var diffInTime = toDate - fromDate;
                var diffInDays = diffInTime / (1000 * 3600 * 24);

                if (diffInDays > 7) {
                    showDialog('Date range should not exceed 7 days as per API requirements.');
                    vm.to_date = null;
                    return false;
                }

                if (toDate > new Date()) {
                    showDialog('Future dates are not allowed.');
                    vm.to_date = null;
                    return false;
                }

                if (fromDate > toDate) {
                    showDialog('From date cannot be greater than To date.');
                    vm.to_date = null;
                    return false;
                }
            }
            return true;
        }

        // Success callback for getting transaction details
        function successGetTransactionReport(response) {
            console.log('Transaction response:', response);
            vm.searchCompleted = true;

            if (response && response.data) {
                // Handle nested response structure
                if (response.data.Data && response.data.Data.response_status === 'S') {
                    if (response.data.Data.report_data && angular.isArray(response.data.Data.report_data)) {
                        vm.transactionReport = response.data.Data.report_data;
                    } else if (response.data.Data.report_data) {
                        vm.transactionReport = [response.data.Data.report_data];
                    } else {
                        vm.transactionReport = [];
                        showDialog('No transaction data found for the selected criteria.');
                        return;
                    }
                } else {
                    vm.transactionReport = [];
                    showDialog('No transaction data found or invalid response format.');
                    return;
                }

                // Process and format the data
                angular.forEach(vm.transactionReport, function (item) {
                    // Handle date conversion for order_date (DD/MM/YYYY format)
                    if (item.order_date) {
                        var dateParts = item.order_date.split('/');
                        if (dateParts.length === 3) {
                            item.FORMATTED_DATE = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).getTime();
                        }
                    }

                    // Clean up empty fields
                    Object.keys(item).forEach(function(key) {
                        if (item[key] === ' ' || item[key] === '') {
                            item[key] = null;
                        }
                    });
                });

                // Sort by date (newest first)
                vm.transactionReport = vm.transactionReport.sort(function(a, b) {
                    return (b.FORMATTED_DATE || 0) - (a.FORMATTED_DATE || 0);
                });

                if (vm.transactionReport.length === 0) {
                    showDialog('No transaction records found for the selected criteria.');
                }
            } else {
                vm.transactionReport = [];
                showDialog('No data received from server');
            }
        }

        // Error callback for getting transaction details
        function errorGetTransactionReport(response) {
            console.log('error', response);
            vm.searchCompleted = true;
            vm.transactionReport = [];
            
            if (response && response.data && response.data.message) {
                showDialog(response.data.message);
            } else if (response && response.data && response.data.error_remark) {
                showDialog(response.data.error_remark);
            } else if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            } else {
                showDialog('Error occurred while fetching transaction details. Please try again.');
            }
        }

        // Main function to get transaction detailed report
        function getTransactionDetailedReport() {
            if (!validateDates()) {
                return;
            }

            // Format dates to DD-MMM-YYYY format as required by API
            var formatDateForAPI = function(dateString) {
                if (!dateString) return '';
                var date = new Date(dateString);
                var day = String(date.getDate()).padStart(2, '0');
                var month = date.toLocaleDateString('en-US', { month: 'short' });
                var year = date.getFullYear();
                return day + '-' + month + '-' + year;
            };

            var postData = {
                'from_date': formatDateForAPI(vm.from_date),
                'to_date': formatDateForAPI(vm.to_date),
                'trans_type': vm.trans_type || 'ALL',
                'order_type': vm.order_type || 'XSP',
                'sub_order_type': vm.sub_order_type || 'ALL',
                'client_code': vm.client_code || ''
            };

            console.log('Request payload:', postData);
            vm.searchCompleted = false;
            ServiceProxy.rejectedTransactionNse(postData).then(successGetTransactionReport, errorGetTransactionReport);
        }

        // CSV Download function - Updated to include ALL fields
        function downloadTransactionReport() {
            var reportData = vm.transactionReport;
            if (!reportData.length) {
                showDialog("No data available to download.");
                return;
            }

            // Dynamically extract ALL field names from the first record
            var allFields = Object.keys(reportData[0]);
            
            // Create headers array with proper labels (convert snake_case to Title Case)
            var headers = allFields.map(function(field) {
                return {
                    key: field,
                    label: field.split('_').map(function(word) {
                        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    }).join(' ')
                };
            });

            // Create CSV header row
            var csvContent = headers.map(function(h) { return h.label; }).join(',') + '\n';

            // Create CSV rows with ALL fields
            for (var i = 0; i < reportData.length; i++) {
                var row = headers.map(function(header) {
                    var value = reportData[i][header.key];
                    
                    // Handle null, undefined, empty values
                    if (value === null || value === undefined || value === '' || value === ' ') {
                        return '';
                    }
                    
                    // Clean special characters in member_remark and order_remark fields
                    if ((header.key === 'member_remark' || header.key === 'order_remark') && typeof value === 'string') {
                        value = value.replace(/\$/g, '');
                    }
                    
                    // Convert to string and escape commas and quotes
                    value = String(value);
                    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                        return '"' + value.replace(/"/g, '""') + '"';
                    }
                    
                    return value;
                });
                csvContent += row.join(',') + '\n';
            }

            // Create filename with timestamp
            var now = new Date();
            var timestamp = now.getFullYear() + 
                        String(now.getMonth() + 1).padStart(2, '0') + 
                        String(now.getDate()).padStart(2, '0') + '_' +
                        String(now.getHours()).padStart(2, '0') + 
                        String(now.getMinutes()).padStart(2, '0');
            
            var filename = 'Transaction_Detailed_Report_' + timestamp + '.csv';

            // Trigger download
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);

            showDialogSucc('CSV file downloaded successfully.');
        }

        // Error dialog function
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        // Success dialog function
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('ComparisonController', ComparisonController);

    /** @ngInject */
    function ComparisonController($rootScope, $state, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        function init() {
           
        };
        init();

   

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
	'use strict';

	angular
		.module('app.send-transaction-report', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.send-transaction-report', {
				url: '/send-transaction-report',
				views: {
					'content@app': {
						templateUrl: 'app/main/communication/send-transaction-report/send-transaction-report.html',
						controller: 'sendTransactionReportController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('customer.send-transaction-report', {
			title: 'Send Transaction Report ',
			icon: 'icon-tile-four',
			state: 'app.send-transaction-report',
			weight: 11,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			}
		});
	}
})();

(function () {

    'use strict';

    angular.module('app.send-transaction-report').controller('sendTransactionReportController', sendTransactionReportController);

    /** @ngInject */
    function sendTransactionReportController($mdDialog, ServiceProxy, $window) {
        var vm = this;

        vm.sendTransactionReport = sendTransactionReport;

        function sendTransactionReport() {
            var postData = {
                "IIN": vm.iin
            };

            ServiceProxy.sendTransactionReport(postData).then(successCbTransactionReport, errorCbTransactionReport);
        }

        function successCbTransactionReport(response) {
            showDialogSucc(response.data.responseString);
            // Additional success logic if needed
        }

        function errorCbTransactionReport(response) {
            if (response && response.data && response.data.message) {
                showDialog(response.data.message);
            }
        }

        function showDialog(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Sorry...!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('app.create-customers', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.create-customers', {
				url: '/create-customers',
				views: {
					'content@app': {
						templateUrl: 'app/main/communication/create-customers/create-customers.html',
						controller: 'createCustomersController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('customer.create-customers', {
			title: 'Create Customers',
			icon: 'icon-tile-four',
			state: 'app.create-customers',
			weight: 10
		});
	}
})();

(function () {
    'use strict';
    angular.module('app.create-customers').controller('createCustomersController', createCustomersController);

    /** @ngInject */
    function createCustomersController($mdDialog, ServiceProxy, $state, $scope, ShareDataService) {
        var vm = this;

        function init(){
            vm.mobileNo = '';
            vm.email = '';
            vm.pan = '';
            vm.password = '';
            vm.title = '';
            vm.name = '';
            vm.occupation = '';
            vm.dob = '';
            vm.fatherName = '';
            vm.motherName = '';
            vm.address = '';
            vm.addr1 = '';
            vm.addr2 = '';
            vm.pinCode = '';
            vm.city = '';
            vm.state = '';
            vm.emailRelation = '';
            vm.mobileRelation = '';
            vm.app_income = '';
            vm.source_wealth = '';
            vm.accountType = '';
            vm.accountNo = '';
            vm.ifscCode = '';
            vm.bankName = '';
            vm.bankcode = '';
            vm.branchName = '';
            vm.branchAddress = '';
            vm.branchAddress1 = '';
            vm.branchAddress2 = '';
            vm.wantToAddNominee = '';
            vm.nomineeName = '';
            vm.relationship = '';
            vm.nomineePan = '';
            vm.nomineeAadhar = '';
            vm.nomineePan = '';
            vm.isNomineeMinor = '';
            vm.guardianName = '';
            vm.guardianPan = '';
            vm.taxStatusCodeForBank = '01';
            vm.ekycIsDone = false;
            vm.camsKycData = '';
            vm.nameVerified = false;
            vm.panVerified = false;
            vm.ekycStatusCode = '';
            vm.countryCode = '';
            vm.stateCode = '';
            vm.nom1_country = '';
            vm.nom1_id_no = '';
            vm.nom1_mobile = '';
            vm.nom1_email = '';
            vm.nom1_id_type = '';
            vm.nominee_soa = '';
            vm.NOMINEE_OPTED = '';
            vm.no_of_nominee = '';
            vm.nominee1_name = '';
            vm.nominee1_dob = '';
            vm.NOM1_PAN = '';
            vm.nominee1_type = '';
            vm.nominee1_addr1 = '';
            vm.nominee1_addr2 = '';
            vm.nominee1_city = '';
            vm.nominee1_state = '';
            vm.nominee1_pincode = '';
            vm.nominee1_relation = '';
            vm.nominee1_percent = '';
            vm.nominee1_guard_pan = '';
            vm.nominee1_guard_relation = '';

            vm.mobileNoRegEx = /^[0-9]{10,10}$/;
            vm.aadharNoRegEx = /^[0-9]{4,4}$/;
            vm.panRegEx = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
            vm.nameRegEx = /^[a-zA-Z, . ]{2,50}$/;
            vm.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            vm.pinRegEx = /^[0-9]{6}$/;
            
            vm.titleData = ['Mr.', 'Mrs.', 'Ms.', 'M/s.'];
            vm.occupationData = [];
            vm.rseRelationshipData = [];
            vm.ApplicableincomeData = [];
            vm.sourceWealthData = [];
            vm.bankDetails = {};
            vm.addressDetails = [];
            vm.newAccountTypeData = [];
            vm.verifyCustomersData = {};
            vm.relationData = [];
            vm.guardianRelationData = [];
            vm.cityDetails = [];
            
            vm.isKycStatusVisible = false;

            vm.verifyCustomers = verifyCustomers;
            vm.createCustomers = createCustomers;
            vm.createAccount = createAccount;
            vm.getOccupation = getOccupation;
            vm.getNseRelationship = getNseRelationship;
            vm.getApplicableincome = getApplicableincome;
            vm.getSourceWealth = getSourceWealth;
            vm.getNewBankAccType = getNewBankAccType;
            vm.getGuardianRelation = getGuardianRelation;
            vm.getNomineeRelationship = getNomineeRelationship;
            vm.calculateAge = calculateAge;
            vm.getIINonPan = getIINonPan;
            vm.formatDOB = formatDOB;
            vm.customerId = 0;
            vm.successVerifyCustomersResponse = '';

        };
        init();

        function calculateAge(dob) {
            var dobDate = new Date(dob);
            var diff = Date.now() - dobDate.getTime();
            var ageDate = new Date(diff);
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }
        
        function formatDOB(dobTimestamp) {
            if (!dobTimestamp) return "";
            var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var dateObj = new Date(dobTimestamp);
            var day = dateObj.getDate();
            day = (day < 10 ? '0' + day : day); // padStart replacement
            var month = months[dateObj.getMonth()];
            var year = dateObj.getFullYear();
            return day + "-" + month + "-" + year;
        }

         var successCallbackOnOccupation = function (response) {
            vm.occupationData = response.data;
        };

        var getOccupation = function () {
            ServiceProxy.getOccupation().then(successCallbackOnOccupation);
        };

        getOccupation();

        var successgetNseRelationship = function(response) {
            vm.rseRelationshipData = response.data;
        }

        var getNseRelationship = function() {
            ServiceProxy.getNseRelationship().then(successgetNseRelationship);
        }

        getNseRelationship();

        var successgetApplicableincome = function(response) {
            vm.applicableincomeData = response.data;
        }

        var getApplicableincome = function() {
            ServiceProxy.getApplicableincome().then(successgetApplicableincome);
        }

        getApplicableincome();

        var successCallbackOnSourceWealth = function (response) {
            vm.sourceWealthData = response.data;
        };

        var getSourceWealth = function () {
            ServiceProxy.getSourceWealth().then(successCallbackOnSourceWealth);
        };

        getSourceWealth();

        var successGetBankDetailsFrmIFSC = function(response) {
            vm.bankDetails = response.data.responseString;
            vm.bankName = response.data.responseString.bankName;
            vm.bankcode = response.data.responseString.bankcode;
            vm.branchName = response.data.responseString.branch;
            vm.branchAddress = response.data.responseString.address;
        };

        var errorGetBankDetailsFrmIFSC = function(response) {
            showDialog(response.data.responseString);
        };

        vm.getBankDetailsFrmIFSC = function() {
            if (vm.ifscCode && vm.ifscCode.length === 11) {
                ServiceProxy.getBankDetailsFrmIFSC(vm.ifscCode).then(successGetBankDetailsFrmIFSC, errorGetBankDetailsFrmIFSC);
            }
        };

        var successgetNewBankAccType = function(response) {
            vm.newAccountTypeData = response.data.response;
        };

        var errorgetNewBankAccType = function(response) {
            showDialog(response.data);
        };

        var getNewBankAccType = function() {
            ServiceProxy.getNewBankAccType(vm.taxStatusCodeForBank).then(successgetNewBankAccType, errorgetNewBankAccType);
        };

        getNewBankAccType();
        
        var successGuardianRelation = function(response){
            vm.guardianRelationData = response.data.responseData;
        }

        var errorGuardianRelation = function(response){
            console.log('errorGuardianRelation',response);
        }

        var getGuardianRelation = function(){
            ServiceProxy.getGuardianRelation().then(successGuardianRelation, errorGuardianRelation);
        }

        getGuardianRelation();            

        var successNomineeRelationship = function(response){
            console.log('successNomineeRelationship', response);
            vm.relationData = response.data.responseData;

        }
        var errorNomineeRelationship = function(response){
            console.log('errorNomineeRelationship',response);
        }

        var getNomineeRelationship = function(){
            ServiceProxy.getNomineeRelationship().then(successNomineeRelationship, errorNomineeRelationship);
        }

        getNomineeRelationship();

        var successGetStateCityDetailsPinCodeNew = function(response) {
            vm.cityDetails = response.data[0];
            vm.city = response.data[0].cityName;
            vm.state = response.data[0].stateName;
            vm.countryCode = response.data[0].countryCode;
            vm.stateCode = response.data[0].stateCode;
        };

        var errorGetStateCityDetailsPinCodeNew = function(response) {
            showDialog(response.data.error);
        };

        vm.getStateCityDetailsPinCodeNew = function() {
            if (vm.pinCode && vm.pinCode.length === 6) {
                ServiceProxy.getStateCityDetailsPinCodeNew(vm.pinCode).then(successGetStateCityDetailsPinCodeNew, errorGetStateCityDetailsPinCodeNew);
            }
        };

        function sucessCbSyncInvestorIIN(response) {
            console.log('sucessCbSyncInvestorIIN:', response);
            showDialogSucc(response.data.responseString);
            
            // Clear the input fields
            vm.mobileNo = '';
            vm.email = '';
            vm.pan = '';
            vm.password = '';
            $state.go('app.create-customers', {}, { reload: true });
        }

        function errorCbSyncInvestorIIN(response) {
            console.log('errorCbSyncInvestorIIN', response);
        };

        function successserchUser(response) {
            console.log('successserchUser', response);
            var postData = {};
            postData._id = response.data.data[0]._id;
            postData.userIIN = vm.customerId;
            ServiceProxy.syncInvestorIIN(postData).then(sucessCbSyncInvestorIIN, errorCbSyncInvestorIIN)
        }

        function errorserchUser(response) {
            console.log('errorserchUser', response);
        }

        function successgetIinMapping(response) {
            console.log('successgetIinMapping', response);
            ServiceProxy.serchUser(vm.mobileNo).then(successserchUser, errorserchUser)
        }
        
        function errorgetIinMapping(response) {
            console.log('errorgetIinMapping', response);
        }

        function successgetIINonPan(response) {
            console.log('successgetIINonPan', response);
            vm.customerId = response.data.data[0].CUSTOMER_ID;
            ServiceProxy.getIinMapping(vm.customerId).then(successgetIinMapping, errorgetIinMapping);
        }
        
        function errorgetIINonPan(response) {
            console.log('errorgetIINonPan', response);
            // Original UI updates
            vm.verifyCustomersData = response.data;
            vm.isKycStatusVisible = true;
            vm.ekycIsDone = vm.verifyCustomersData.data.ekycIsDone;
            vm.name = vm.verifyCustomersData.data.name;
            vm.nameVerified = vm.verifyCustomersData.data.nameVerified;
            vm.panVerified = response.data.data.panVerified;
            vm.ekycStatusCode = vm.verifyCustomersData.data.camsKycStatus;
        }

        function getIINonPan(pan) {
            ServiceProxy.getIINonPan(pan).then(successgetIINonPan, errorgetIINonPan); 
        }

        function successVerifyCustomers(response) {
            console.log('successVerifyCustomers', response);
        
            // Wait for dialog "OK" click before calling getIINonPan
            showDialogSuccRE(response.data.responseString)
            // .then(function () {
            //     getIINonPan(response.data.data.pan);
            // });
        }
        
        function errorVerifyCustomers(response) {
            console.error('errorVerifyCustomers', response.data);
            showDialog(response.data.message);
        }
        
        function verifyCustomers() {
            vm.pan = vm.pan.toUpperCase();
            var postData = {
                mobileNo: vm.mobileNo,
                email: vm.email,
                pan: vm.pan,
                password: vm.password,
                platform: "WEB"
            };
            
            ServiceProxy.verifyCustomers(postData).then(successVerifyCustomers, errorVerifyCustomers);
        }

        function createAccount() {
            // Check Mobile Number
            if (!vm.mobileNo || !vm.mobileNoRegEx.test(vm.mobileNo)) {
                showDialog("Please enter a valid Mobile Number.");
                return;
            }
        
            // Check Email
            if (!vm.email || !vm.emailRegex.test(vm.email)) {
                showDialog("Please enter a valid Email.");
                return;
            }
        
            // Check PAN Number
            if (!vm.pan || !vm.panRegEx.test(vm.pan)) {
                showDialog("Please enter a valid PAN Number.");
                return;
            }
        
            // Check Password
            if (!vm.password || vm.password.length < 4) {
                showDialog("Please enter a valid Password with a minimum of 4 characters.");
                return;
            }
        
            // Check Title
            if (!vm.title) {
                showDialog("Please select a Title.");
                return;
            }
        
            // Check Name
            if (!vm.name || !vm.nameRegEx.test(vm.name)) {
                showDialog("Please enter a valid Name.");
                return;
            }
        
            // Check Occupation
            if (!vm.occupation) {
                showDialog("Please select an Occupation.");
                return;
            }
        
            // Check Date of Birth
            if (!vm.dob) {
                showDialog("Please select a Date of Birth.");
                return;
            }
        
            // Check Father Name
            if (!vm.fatherName || !vm.nameRegEx.test(vm.fatherName)) {
                showDialog("Please enter a valid Father's Name.");
                return;
            }
        
            // Check Mother Name
            if (!vm.motherName || !vm.nameRegEx.test(vm.motherName)) {
                showDialog("Please enter a valid Mother's Name.");
                return;
            }
        
            // Check Address
            if (!vm.address) {
                showDialog("Please enter an Address.");
                return;
            }
        
            // Check Pincode
            if (!vm.pinCode || !vm.pinRegEx.test(vm.pinCode)) {
                showDialog("Please enter a valid Pincode.");
                return;
            }
        
            // Check City
            if (!vm.city) {
                showDialog("Please enter a City.");
                return;
            }
        
            // Check State
            if (!vm.state) {
                showDialog("Please enter a State.");
                return;
            }
        
            // Check Email Relation
            if (!vm.emailRelation) {
                showDialog("Please select an Email Relation.");
                return;
            }
        
            // Check Mobile Relation
            if (!vm.mobileRelation) {
                showDialog("Please select a Mobile Relation.");
                return;
            }
        
            // Check Account Type
            if (!vm.accountType) {
                showDialog("Please select an Account Type.");
                return;
            }
        
            // Check Account Number
            if (!vm.accountNo) {
                showDialog("Please enter an Account Number.");
                return;
            }
        
            // Check IFSC Code
            if (!vm.ifscCode || vm.ifscCode.length !== 11) {
                showDialog("Please enter a valid IFSC Code.");
                return;
            }
        
            // Check Bank Name
            if (!vm.bankName) {
                showDialog("Please enter a Bank Name.");
                return;
            }
        
            // Check Branch Name
            if (!vm.branchName) {
                showDialog("Please enter a Branch Name.");
                return;
            }
        
            // Check Branch Address
            if (!vm.branchAddress) {
                showDialog("Please enter a Branch Address.");
                return;
            }
        
            // Check Nominee Details (if applicable)
            if (vm.wantToAddNominee === 'yes') {

                if (!vm.nomineeName || !vm.nameRegEx.test(vm.nomineeName)) {
                    showDialog("Please enter a valid Nominee Name.");
                    return;
                }
        
                if (!vm.relationship) {
                    showDialog("Please select a Relationship for the Nominee.");
                    return;
                }

                if (!vm.nomineePan && !vm.nomineeAadhar) {
                    showDialog("Please enter a valid PAN or Aadhar Number for the Nominee.");
                    return;
                }

                if (vm.nom1_mobile && !vm.mobileNoRegEx.test(vm.nom1_mobile)) {
                    showDialog("Please enter a valid Nominee Mobile Number.");
                    return;
                }

                if (vm.nom1_email && !vm.emailRegex.test(vm.nom1_email)) {
                    showDialog("Please enter a valid Nominee Email.");
                    return;
                }

                if (!vm.nominee1_dob) {
                    showDialog("Please enter the Nominee's Date of Birth.");
                    return;
                }
        
                if(vm.isNomineeMinor === 'Y'){
        
                    var nomineeAge = calculateAge(vm.nominee1_dob);
                    if (nomineeAge >= 18) {
                        showDialog("Nominee's age should be less than 18 years.");
                        return;
                    }

                    if (!vm.guardianName || !vm.nameRegEx.test(vm.guardianName)) {
                        showDialog("Please enter a valid Guardian Name.");
                        return;
                    }

                    if(!vm.nominee1_guard_relation) {
                        showDialog("Please select a Guardian Relationship.");
                        return;
                    }

                    if (!vm.guardianPan || !vm.panRegEx.test(vm.guardianPan)) {
                        showDialog("Please enter a valid Guardian PAN.");
                        return;
                    }
                }
            }
        
            // If all checks pass, Then call create the customer
            createCustomers();
        }        

        function successCreateCustomers(response) {
            
            showDialogSucc(response.data.responseString);
        }

        function errorCreateCustomers(response) {
            
            showDialog(response.data.responseString);
        }

        function createCustomers() {

            if (vm.address.length >= 30) {
                vm.addr1 = vm.address.substring(0, 30); 
                vm.addr2 = vm.address.substring(30);
                
                vm.nominee1_addr1 = vm.address.substring(0, 30);
                vm.nominee1_addr2 = vm.address.substring(30);
            } else {
                vm.addr1 = vm.address; 
                vm.nominee1_addr1 = vm.address;
            }

            if (vm.branchAddress.length >= 30) {
                vm.branchAddress1 = vm.branchAddress.substring(0, 30); 
                vm.branchAddress2 = vm.branchAddress.substring(30);
            
            } else {
                vm.branchAddress1 = vm.branchAddress;
            }

            if(vm.wantToAddNominee == 'yes' ){
                vm.NOMINEE_OPTED = 'Y';
                vm.no_of_nominee = '1';
                vm.nominee1_name = vm.nomineeName;
                if (vm.nom1_id_type === '1') {   
                    vm.NOM1_PAN = vm.nomineePan.toUpperCase();
                    vm.nom1_id_no = vm.nomineePan.toUpperCase();
                }
                if (vm.nom1_id_type === '2') {
                    vm.nom1_id_no = vm.nomineeAadhar.toUpperCase();
                }
                vm.nominee1_addr1 = vm.nominee1_addr1;
                vm.nominee1_addr2 = vm.nominee1_addr2;
                vm.nominee1_city = vm.city;
                vm.nominee1_state = vm.stateCode;
                vm.nominee1_pincode = vm.pinCode;
                vm.nominee1_pincode = vm.nominee1_pincode.toString();
                vm.nominee1_relation = vm.relationship;
                vm.nominee1_percent = '100';
                vm.nom1_id_type = vm.nom1_id_type;
                vm.nominee_soa = 'Y';
                vm.nom1_country = 'IND';
                vm.nominee1_dob = formatDOB(vm.nominee1_dob);
                vm.nom1_mobile = vm.nom1_mobile;
                vm.nom1_email = vm.nom1_email;
            } else {
                vm.NOMINEE_OPTED = 'N';
                vm.no_of_nominee = '0';
                vm.nominee1_name = '';
                vm.NOM1_PAN = '';
                vm.nominee1_addr1 = '';
                vm.nominee1_addr2 = '';
                vm.nominee1_city = '';
                vm.nominee1_state = '';
                vm.nominee1_pincode = '';
                vm.nominee1_relation = '';
                vm.nominee1_percent = '';
                vm.nom1_id_type = '';
                vm.nominee_soa = '';
                vm.nom1_country = '';
                vm.nom1_id_no = '';
                vm.nominee1_dob = '';
                vm.nom1_mobile = '';
                vm.nom1_email = '';
            }

            if(vm.wantToAddNominee == 'yes' && vm.isNomineeMinor == 'Y'){
                vm.guardianName = vm.guardianName;
                vm.nominee1_guard_relation = '';
                vm.nominee1_guard_pan = vm.guardianPan.toUpperCase();
                vm.nominee1_type = vm.isNomineeMinor;
            } else {
                vm.guardianName = '';
                vm.nominee1_guard_relation = '';
                vm.guardianPan = '';
                vm.nominee1_type = 'N';
                vm.nominee1_guard_pan = '';
            }

            vm.pan = vm.pan.toUpperCase();
            if (typeof vm.dob === 'string') {
                // Convert string (if it's in a valid date format) to a Date object
                vm.dob = new Date(vm.dob);
            }
        
            // Ensure the date conversion was successful before calling getTime()
            if (vm.dob instanceof Date && !isNaN(vm.dob)) {
                vm.dob = vm.dob.getTime(); // Convert the date to milliseconds since 1970
            }

            var postData = {
                    userDetails:{
                        state: 2,
                        ekycIsDone: vm.ekycIsDone,
                        name: vm.name,
                        email: vm.email,
                        nameVerified: vm.nameVerified,
                        pan: vm.pan,
                        panVerified: vm.panVerified,
                        mobile: vm.mobileNo,
                        ekycStatusCode: vm.ekycStatusCode,
                        isNRIFlag: false
                    },
                    nseDetails:{
                        occupation: vm.occupation,
                        tax_status: {
                            JOINTHOLDERS_FLAG : "N",
                            TAX_STATUS_DESC : "Individual",
                            TAX_STATUS_CODE : "01"
                        },
                        hold_nature: {
                            HOLD_NATURE_CODE : "SI",
                            HOLD_NATURE_DESC : "Single"
                        },
                        country: {
                            COUNTRY_CODE : "IND",
                            COUNTRY_NAME : "INDIA"
                        },
                        state: {
                            STATE_CODE: vm.stateCode,
                            STATE_NAME: vm.state
                        },
                        city: vm.cityDetails,
                        bank_name: {
                            BANK_NAME : vm.bankName,
                            BANK_CODE : vm.bankcode
                        },
                        acc_type: vm.accountType,
                        title: vm.title,
                        inv_name: vm.name,
                        pan: vm.pan,
                        valid_pan: vm.panVerified,
                        exemption:'',
                        exempt_category:'',
                        exempt_ref_no:'',
                        email: vm.email,
                        mobileNo: vm.mobileNo,
                        Email_relation: vm.emailRelation.RelationKey,
                        Mobile_relation: vm.mobileRelation.RelationKey,
                        dob: formatDOB(vm.dob),
                        father_name: vm.fatherName,
                        mother_name: vm.motherName,
                        kyc: 'Y',
                        addr1: vm.addr1,
                        addr2: vm.addr2,
                        addr3:'',
                        pincode: vm.pinCode,
                        nri_addr2:'',
                        nri_addr3:'',
                        acc_no: vm.accountNo,
                        ifsc_code: vm.ifscCode,
                        branch_name: vm.branchName,
                        branch_addr1: vm.branchAddress1,
                        branch_addr2: vm.branchAddress2,
                        branch_addr3:'',
                        branch_city:'',
                        branch_pincode:'',
                        branch_country:'',
                        no_of_nominee: vm.no_of_nominee,
                        NOMINEE_OPTED: vm.NOMINEE_OPTED,
                        nominee1_name: vm.nominee1_name,
                        NOM1_PAN: vm.NOM1_PAN,
                        nominee1_type: vm.nominee1_type,
                        nominee1_dob: vm.nominee1_dob,
                        nominee1_addr1: vm.nominee1_addr1,
                        nominee1_addr2: vm.nominee1_addr2,
                        nominee1_addr3:'',
                        nominee1_city: vm.nominee1_city,
                        nominee1_state: vm.nominee1_state,
                        nominee1_pincode: vm.nominee1_pincode,
                        nominee1_relation: vm.nominee1_relation,
                        nominee1_percent: vm.nominee1_percent,
                        nominee1_guard_relation: vm.nominee1_guard_relation,
                        nominee1_guard_pan: vm.nominee1_guard_pan,
                        nominee1_guard_name: vm.guardianName,
                        nom1_country: vm.nom1_country,
                        nom1_id_no: vm.nom1_id_no,
                        nom1_mobile: vm.nom1_mobile,
                        nom1_email: vm.nom1_email,
                        nom1_id_type: vm.nom1_id_type,
                        nominee_soa: vm.nominee_soa
                    },
                    fatcaDetails:{
                        addr_type:{
                            desc:'Residential',
                            code:'2'
                        },
                        place_birth:{
                            STATE_CODE: vm.stateCode,
                            STATE_NAME: vm.state
                        },
                        country_of_birth:{
                            COUNTRY_CODE: vm.countryCode,
                            COUNTRY_NAME: 'INDIA'
                        },
                        app_income:{
                            APP_INCOME_CODE: vm.app_income.APP_INCOME_CODE,
                            APP_INCOME_DESC: vm.app_income.APP_INCOME_DESC
                        },
                        source_wealth:{
                            CODE: vm.source_wealth.CODE,
                            SOURCE_OF_WEALTH: vm.source_wealth.SOURCE_OF_WEALTH
                        },
                        pep:{
                            desc:'No',
                            code:'N'
                        },
                        tax_residency:{
                            desc:'No',
                            code:'N'
                        },
                        id1_type:{
                            DESCRIPTION:'',
                            VALUE:''
                        },
                        net_worth:'',
                        net_worth_date: 0,
                        tax_payer_identityno1:'',
                        tax_payer_identityno2:'',
                        tax_payer_identityno3:'',
                        tax_payer_identityno4:'',
                        aadhaar_rp:''
                    }
                };

                console.log('Data is:', postData);

                ServiceProxy.createCustomers(postData).then(successCreateCustomers, errorCreateCustomers);
        }

        function showDialog(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Sorry...!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }

        function showDialogSuccRE(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
        
            // This return is important!
            return $mdDialog.show(confirm);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.communication', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'COMMUNICATION::EMAIL::NOTIFICATION';

        var fId2 = 'MESSAGE::SMS'

        // State
        $stateProvider
            .state('app.communication', {
                url: '/communication',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/communication/communication-message.html',
                        controller: 'CommunicationMessageController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.communication.custom', {
                url: '/communicationCustom?fromState',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/communication/communication-custom/communication-custom.html',
                        controller: 'CommunicationCustomController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.communication.prospects', {
                url: '/communicationProspects',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/communication/communication-prospects/communication-prospects.html',
                        controller: 'CommunicationprospectsController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            });


        msNavigationServiceProvider.saveItem('communication', {
            title: 'COMMUNICATION',
            weight: 4,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && ((window.sessionStorage.getItem('feature').indexOf(fId) !== -1) || (window.sessionStorage.getItem('feature').indexOf(fId2) !== -1)))) {
                    return false;
                } else {
                    return true;
                }
            }
        });

        msNavigationServiceProvider.saveItem('communication.email', {
            title: 'EMAIL',
            state: 'app.communication',
            icon: 'icon-email',
            weight: 5,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (window.sessionStorage.getItem('feature').indexOf(fId) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }        
        });       
    }
})();
(function () {
    'use strict';

    angular
        .module('app.communication')
        .controller('CommunicationprospectsController', CommunicationprospectsController);

    /** @ngInject */
    function CommunicationprospectsController($rootScope, $state, $location, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            ShareDataService.storeData('customerDetail', '');
            vm.selected = [];
            vm.sendMessage = sendMessage;
            vm.customers = [];
            vm.customerCount = customerCount;
            getAllCustomerCommunication();
        };
        init();

        /////////////////////////////get all customer communication details starts here//////////////////////////////////
        function successGetCustomer(response) {
            vm.customers = response.data.data;
        }

        function errorGetCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllCustomerCommunication() {
            ServiceProxy.getAllProspectCommunication().then(successGetCustomer, errorGetCustomer);
        }

        /////////////////////////////////////select checkbox funcationality here/////////////////////////////////////////////
        vm.selectEntity = function (customer) {
            var index = vm.selected.findIndex(function (x) {
                return x._id === customer._id;
            });
            if (customer.isChecked) {
                if (index === -1) {
                    vm.selected.push(customer);
                }
            } else {
                if (index !== -1) {
                    vm.selected.splice(index, 1);
                }
            }
        };

        ////////////////////////////////////////////////ends checkbox funcationality here///////////////////////////

        function sendMessage() {
            var selectedCustomer = [];
            angular.forEach(vm.customers, function (obj) {
                if (obj.isChecked) {
                    selectedCustomer.push(obj);
                }
            });

            ShareDataService.storeData('selectedProspect', selectedCustomer);
            if (ShareDataService.getData('selectedCustomer'))
            {
                ShareDataService.storeData('selectedCustomer', null);
            }
            if ($state.params.fromState === 'schedular') {
                $state.go('app.schedular.createschedular', {
                    comingstate: 'custom'
                });
            } else {
                $state.go('app.communication');
            }

        };

        function customerCount() {
            if (vm.selected.length === 0) {
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = true;
                    vm.selected.push(item);
                })
            } else {
                vm.selected.length = 0;
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = false;
                })
            }
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
	'use strict';

	angular
		.module('app.fatca-retrigger-mail', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		var fId = 'AUM::REPORT::DASHBOARD';
		$stateProvider
			.state('app.fatca-retrigger-mail', {
				url: '/fatca-retrigger-mail',
				views: {
					'content@app': {
                        templateUrl: 'app/main/communication/fatca-retrigger-mail/fatca-retrigger-mail.html',
                        controller: 'fatcaretriggermailController as vm'
                    }
				},
				data: {
					access: function () {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})

		msNavigationServiceProvider.saveItem('customer.fatca-retrigger-mail', {
			title: 'Fatca Retrigger Mail',
			icon: 'icon-tile-four',
			state: 'app.fatca-retrigger-mail',
			weight: 14
		});
	}
})();

(function () {
    'use strict';

    angular
        .module('app.fatca-retrigger-mail')
        .controller('fatcaretriggermailController', fatcaretriggermailController);

    /** @ngInject */
    function fatcaretriggermailController($state, $location, $scope, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        // Initialize the controller
        function init() {
            vm.fatcaretriggermail = fatcaretriggermail;
            vm.validateFields = validateFields;
        }
        init();

        function successfatcaretriggermail(response) {
            //console.log('Success:', response);
            showDialogSucc('Fatca retrigger mail sent successfully.');
        }

        function errorfatcaretriggermail(response) {
            //console.log('Error:', response);
            showDialog('An error occurred while sending the mail.');
        }

        function fatcaretriggermail() {
            if (!validateFields()) {
                return; // Stop execution if validation fails
            }

            var postData = {
                "iin": vm.iin,
                "investor_email": vm.email,
                "pan": vm.pan
            };
            //console.log('Post Data:', postData);
            ServiceProxy.fatcaretriggermail(postData).then(successfatcaretriggermail, errorfatcaretriggermail);
        }

        function validateFields() {
            if (!vm.iin || vm.iin.trim() === '') {
                showDialog('IIN is required.');
                return false;
            }
            if (!vm.pan || vm.pan.trim() === '' || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(vm.pan)) {
                showDialog('Valid PAN is required.');
                return false;
            }
            if (!vm.email || vm.email.trim() === '' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(vm.email)) {
                showDialog('Valid Email is required.');
                return false;
            }
            return true;
        }

        function showDialog(message) {
            var confirm = $mdDialog.confirm()
                .title('Validation Error')
                .textContent(message)
                .ariaLabel('Validation Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        function showDialogSucc(message) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(message)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.communicationSMS', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'MESSAGE::SMS';
        var fId2 = 'COMMUNICATION::EMAIL::NOTIFICATION';
        // State
        $stateProvider
            .state('app.communicationSMS', {
                url: '/communicationSMS',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/communicationSMS/communication-message.html',
                        controller: 'CommunicationMessageSMSController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.communicationSMS.custom', {
                url: '/communicationCustomSMS?fromState',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/communicationSMS/communication-custom/communication-custom.html',
                        controller: 'CommunicationCustomSMSController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.communicationSMS.prospects', {
                url: '/communicationProspectsSMS',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/communicationSMS/communication-prospects/communication-prospects.html',
                        controller: 'CommunicationprospectsSMSController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            });

        // msNavigationServiceProvider.saveItem('communication', {
        //     title: 'SMS',
        //     state: 'app.communicationSMS',
        //     icon: 'icon-email',
        //     weight: 4,
        //     hidden: function () {
        //         if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
        //             return false;
        //         } else {
        //             return true;
        //         }
        //     }
        // });  
        
        msNavigationServiceProvider.saveItem('communication', {
            title: 'COMMUNICATION',
            weight: 4,
             hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && ((window.sessionStorage.getItem('feature').indexOf(fId) !== -1) || (window.sessionStorage.getItem('feature').indexOf(fId2) !== -1)))) {
                    return false;
                } else {
                    return true;
                }
            }
        });

        msNavigationServiceProvider.saveItem('communication.communicationSMS', {
            title: 'SMS',
            icon: 'icon-email',
            state: 'app.communicationSMS',
            weight: 3,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (window.sessionStorage.getItem('feature').indexOf(fId) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.communicationSMS')
        .controller('CommunicationprospectsSMSController', CommunicationprospectsSMSController);

    /** @ngInject */
    function CommunicationprospectsSMSController($rootScope, $state, $location, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            ShareDataService.storeData('customerDetail', '');
            vm.selected = [];
            vm.sendMessage = sendMessage;
            vm.customers = [];
            vm.customerCount = customerCount;
            getAllCustomerCommunication();
        };
        init();

        /////////////////////////////get all customer communication details starts here//////////////////////////////////
        function successGetCustomer(response) {
            vm.customers = response.data.data;
        }

        function errorGetCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllCustomerCommunication() {
            ServiceProxy.getAllProspectCommunication().then(successGetCustomer, errorGetCustomer);
        }

        /////////////////////////////////////select checkbox funcationality here/////////////////////////////////////////////
        vm.selectEntity = function (customer) {
            var index = vm.selected.findIndex(function (x) {
                return x._id === customer._id;
            });
            if (customer.isChecked) {
                if (index === -1) {
                    vm.selected.push(customer);
                }
            } else {
                if (index !== -1) {
                    vm.selected.splice(index, 1);
                }
            }
        };

        ////////////////////////////////////////////////ends checkbox funcationality here///////////////////////////

        function sendMessage() {
            var selectedCustomer = [];
            angular.forEach(vm.customers, function (obj) {
                if (obj.isChecked) {
                    selectedCustomer.push(obj);
                }
            });

            ShareDataService.storeData('selectedProspectSMS', selectedCustomer);
            if (ShareDataService.getData('selectedCustomerSMS'))
            {
                ShareDataService.storeData('selectedCustomerSMS', null);
            }
            if ($state.params.fromState === 'schedular') {
                $state.go('app.schedular.createschedular', {
                    comingstate: 'custom'
                });
            } else {
                $state.go('app.communicationSMS');
            }

        };

        function customerCount() {
            if (vm.selected.length === 0) {
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = true;
                    vm.selected.push(item);
                })
            } else {
                vm.selected.length = 0;
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = false;
                })
            }
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
	'use strict';

	angular
		.module('app.mark-interested', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.mark-interested', {
				url: '/mark-interested',
				views: {
					'content@app': {
						templateUrl: 'app/main/communication/mark-interested/mark-interested.html',
						controller: 'markInterestedController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('customer.mark-interested', {
			title: 'Mark Interested',
			icon: 'icon-tile-four',
			state: 'app.mark-interested',
			weight: 11
		});
	}
})();

(function () {
    'use strict';
    angular.module('app.mark-interested').controller('markInterestedController', markInterestedController);
    
    /** @ngInject */
    function markInterestedController($mdDialog, ServiceProxy, $window, ShareDataService, $state) {
        var vm = this;
        
        function init() {
            vm.userDetail = JSON.parse(window.sessionStorage.getItem('userDetail'));
            vm.userInfoListOnMobile = userInfoListOnMobile;
            vm.userNotInterestedUpdate = userNotInterestedUpdate;
            vm.customerData = '';
            vm.contact = "";
        }
        init();

        function sucessuserNotInterestedUpdate(response) {
            showDialogSucc(response.data.responseString);
            // Clear customer data to hide the table
            vm.customerData = '';
            // Clear the contact number textbox
            vm.contact = '';
            // Reset the form to pristine and untouched state (if needed)
            if (vm.wizardStep1) {
                vm.wizardStep1.$setPristine();
                vm.wizardStep1.$setUntouched();
            }
        }

        function erroruserNotInterestedUpdate(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }
        
        function userNotInterestedUpdate(data) {
            var postData = {
                "mobileNo": data
            };
            ServiceProxy.userNotInterestedUpdate(postData).then(sucessuserNotInterestedUpdate, erroruserNotInterestedUpdate);
        }

        function sucessuserInfoListOnMobile(response) {
            showDialogSucc(response.data.responseString);
            vm.customerData = response;
            console.log(vm.customerData);
        }

        function erroruserInfoListOnMobile(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }
        
        function userInfoListOnMobile() {
            var postData = {
                "mobileNo": vm.contact,
                "userId": vm.userDetail._id
            };
            ServiceProxy.userInfoListOnMobile(postData).then(sucessuserInfoListOnMobile, erroruserInfoListOnMobile);
        }
        
        function showDialog(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Sorry...!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.communication')
        .controller('CommunicationCustomController', CommunicationCustomController);

    /** @ngInject */
    function CommunicationCustomController($rootScope, $state, $location, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            ShareDataService.storeData('customerDetail', '');
            vm.selected = [];
            vm.sendMessage = sendMessage;
            vm.customers = [];
            vm.customerCount = customerCount;
            getAllCustomerCommunication();
        };
        init();

        /////////////////////////////get all customer communication details starts here//////////////////////////////////
        function successGetCustomer(response) {
            vm.customers = response.data.data;
        }

        function errorGetCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllCustomerCommunication() {
            ServiceProxy.getAllCustomerCommunication().then(successGetCustomer, errorGetCustomer);
        }

        /////////////////////////////////////select checkbox funcationality here/////////////////////////////////////////////
        vm.selectEntity = function (customer) {
            var index = vm.selected.findIndex(function (x) {
                return x._id === customer._id;
            });
            if (customer.isChecked) {
                if (index === -1) {
                    vm.selected.push(customer);
                }
            } else {
                if (index !== -1) {
                    vm.selected.splice(index, 1);
                }
            }
        };

        ////////////////////////////////////////////////ends checkbox funcationality here///////////////////////////

        function sendMessage() {
            var selectedCustomer = [];
            angular.forEach(vm.customers, function (obj) {
                if (obj.isChecked) {
                    selectedCustomer.push(obj);
                }
            });

            ShareDataService.storeData('selectedCustomer', selectedCustomer);
            if (ShareDataService.getData('selectedProspect'))
            {
                ShareDataService.storeData('selectedProspect', null);
            }
            if ($state.params.fromState === 'schedular') {
                $state.go('app.schedular.createschedular', {
                    comingstate: 'custom'
                });
            } else {
                $state.go('app.communication');
            }

        };

        function customerCount() {
            if (vm.selected.length === 0) {
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = true;
                    vm.selected.push(item);
                })
            } else {
                vm.selected.length = 0;
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = false;
                })
            }
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.communicationSMS')
        .controller('CommunicationCustomSMSController', CommunicationCustomSMSController);

    /** @ngInject */
    function CommunicationCustomSMSController($rootScope, $state, $location, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            ShareDataService.storeData('customerDetail', '');
            vm.selected = [];
            vm.sendMessage = sendMessage;
            vm.customers = [];
            vm.customerCount = customerCount;
            getAllCustomerCommunication();
        };
        init();

        /////////////////////////////get all customer communication details starts here//////////////////////////////////
        function successGetCustomer(response) {
            vm.customers = response.data.data;
        }

        function errorGetCustomer(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllCustomerCommunication() {
            ServiceProxy.getAllCustomerCommunication().then(successGetCustomer, errorGetCustomer);
        }

        /////////////////////////////////////select checkbox funcationality here/////////////////////////////////////////////
        vm.selectEntity = function (customer) {
            var index = vm.selected.findIndex(function (x) {
                return x._id === customer._id;
            });
            if (customer.isChecked) {
                if (index === -1) {
                    vm.selected.push(customer);
                }
            } else {
                if (index !== -1) {
                    vm.selected.splice(index, 1);
                }
            }
        };

        ////////////////////////////////////////////////ends checkbox funcationality here///////////////////////////

        function sendMessage() {
            var selectedCustomer = [];
            angular.forEach(vm.customers, function (obj) {
                if (obj.isChecked) {
                    selectedCustomer.push(obj);
                }
            });

            ShareDataService.storeData('selectedCustomerSMS', selectedCustomer);
            if (ShareDataService.getData('selectedProspectSMS'))
            {
                ShareDataService.storeData('selectedProspectSMS', null);
            }
            if ($state.params.fromState === 'schedular') {
                $state.go('app.schedular.createschedular', {
                    comingstate: 'custom'
                });
            } else {
                $state.go('app.communicationSMS');
            }

        };

        function customerCount() {
            if (vm.selected.length === 0) {
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = true;
                    vm.selected.push(item);
                })
            } else {
                vm.selected.length = 0;
                angular.forEach(vm.customers, function (item) {
                    item.isChecked = false;
                })
            }
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/auth/login');

    }

})();

(function() {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($state, $mdDialog, $mdToast, ServiceProxy, StorageService, UserFeature) {
        var vm = this;

        function init() {
            vm.form = {};
            vm.form.email = '';
            vm.form.password = '';
            vm.login = login;
            vm.forgotPassword = forgotPassword;
            vm.resetNewPassword = resetNewPassword;
        }
        init();

        var successCbAuth = function(response) {
            StorageService.setSessionStorage("access_token", response.data.access_token);
            getAllAmc();
            getCategories();
            UserFeature.getUserProfile();
        }

        var errorCbAuth = function(response) {
            vm.errorAuthMsg = response.data.error_description;
            $mdDialog.show(
                $mdDialog.alert({
                    title: '!!Error!!',
                    textContent: vm.errorAuthMsg,
                    ok: 'Try again'
                })
            );
        }

        function redirectBasedOnUserType() {
            // Get user type from session storage (same way as in your routing examples)
            var userType = window.sessionStorage.getItem('type');
            var userFeatures = window.sessionStorage.getItem('feature');
            
            if (userType) {
                userType = JSON.parse(userType);
            }

            console.log('User Type:', userType); // Debug log to see what user type is

            // Check for different user types based on your system
            // if (userType === 'SUPER::ADMIN' || userType === 'SUB::BROKER' || userType === 'SALES::USER' || userType === 'INTERNAL::USER' || userType === 'FINANCE::USER') {
            if (userType === 'SUB::BROKER') { 
                // Sub-broker redirect - CHANGE THIS to your desired page for sub-brokers
                $state.go('app.dashboard.details'); 
                
            } else if (userFeatures && userFeatures.indexOf('ADVISORY::USERS::DASHBOARD') !== -1) {
                // Users with advisory dashboard feature
                $state.go('app.dashboard.details');
                
            } else if (userFeatures && userFeatures.indexOf('DASHBOARD::FEATURE') !== -1) {
                // Users with regular dashboard feature
                $state.go('app.dashboard.details');
                
            } else {
                // Default redirect for other users
                $state.go('app.dashboard.details');
            }
        }

        function login() {
            vm.postdata = {};
            vm.postdata.grant_type = "password";
            vm.postdata.scope = "admin";
            vm.postdata.username = vm.form.email;
            vm.postdata.password = vm.form.password;

            ServiceProxy.authenticate(vm.postdata).then(successCbAuth, errorCbAuth);
        };

        // Get All AMC API Call Start
        function sucessCbGetAllAmc(response) {
            StorageService.setSessionStorage("amcData", response.data.Data.amc_master);
            redirectBasedOnUserType();
        };

        function errorCbGetAllAmc(response) {
            // Handle error if needed
        };

        function getAllAmc() {
            ServiceProxy.getAllAmc().then(sucessCbGetAllAmc, errorCbGetAllAmc);
        };
        // Get All AMC API Call End

        // Get all categories
        function sucessCategory(response) {
            StorageService.setSessionStorage("categoryData", response.data.data);
        };
        
        function errorCategory(response) {
            // Handle error if needed
        };
        
        function getCategories() {
            var postdata = {}
            postdata.flag = "CATEGORY"
            ServiceProxy.postNavCalData(postdata).then(sucessCategory, errorCategory);
        };

        // Reset password start
        function sucessCbForGotPassword(response) {
            $mdToast.show(
                $mdToast.simple()
                .textContent(response.data.message)
                .position('top right')
                .hideDelay(3000)
            );
        }

        function errorCbForGotPassword(response) {
            $mdDialog.show(
                $mdDialog.alert({
                    title: '!!Success!!',
                    textContent: response.data.responseString,
                    ok: 'OK'
                })
            );
        }

        function forgotPassword() {
            var data = {
                email: vm.resetData.email
            }
            ServiceProxy.forgotPassword(data).then(sucessCbForGotPassword, errorCbForGotPassword)
        }

        function sucessCbResetNewPassword(response) {
            vm.resetForm = !vm.resetForm;
            $mdToast.show(
                $mdToast.simple()
                .textContent(response.data.message)
                .position('top right')
                .hideDelay(3000)
            );
        }

        function errorCbResetNewPassword(response) {
            $mdDialog.show(
                $mdDialog.alert({
                    title: '!!Success!!',
                    textContent: response.data.responseString,
                    ok: 'OK'
                })
            );
        }

        function resetNewPassword() {
            vm.resetData.otp = +vm.resetData.otp
            ServiceProxy.resetNewPassword(vm.resetData).then(sucessCbResetNewPassword, errorCbResetNewPassword)
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.assignmentDashboard', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    var fId = 'ASSIGNMENT::USERS::DASHBOARD';
    // State
    $stateProvider
      .state('app.assignmentDashboard', {
        url: '/assignmentdashboard',
        views: {
          'content@app': {
            templateUrl: 'app/main/assignment-dashboard/assignment-dashboard.html',
            controller: 'AssignmentDashboardController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      })
      .state('app.assignmentDashboard.documentVerification', {
        url: '/documentVerification/:userId',
        views: {
          'content@app': {
            templateUrl: 'app/main/assignment-dashboard/document-verification/document-verification.html',
            controller: 'DocumentVerificationController as vm'
          }
        },
        data: {
          access: function () {
            return true;
            // if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
            //   return true;
            // } else {
            //   return false;
            // }
          }
        }
      });

    msNavigationServiceProvider.saveItem('DASHBOARD.assignmentdashboard', {
      title: 'Assignment Dashboard',
      state: 'app.assignmentDashboard',
      icon: 'icon-tile-four',
      weight: 2,
      hidden: function () {
        // return false;
        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
          return false;
        } else {
          return true;
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.assignmentDashboard')
    .controller('DocumentVerificationController', DocumentVerificationController);

  /** @ngInject */
  function DocumentVerificationController($state, $sce, $stateParams, $mdDialog, ServiceProxy, ShareDataService) {
    var vm = this;

    function init() {
      vm.userData = {};
      vm.showBaseUrl = {};
      vm.getImagePath = getImagePath;
      vm.trustSrc = trustSrc;
      if ($stateParams.userId) {
        getCustomerDetailById($stateParams.userId);
      } else {
        $state.go('app.assignmentDashboard')
      }
      vm.documentCategory = {
        "DL": "Driving License",
        "PC": "PAN Card",
        "IP": "IIN Physical Form",
        "PA": "Passport",
        "AA1": "AADHAR Card Front",
        "AA2": "AADHAR Card Back",
        "VID": "Video",
        "PIC": "User Profile Iamge",
        "KF": "KRA Form",
        "CH": "Cheque",
        "AC": "ACH Form",
        "X": "Transaction Image",
        "B": "Bank Proof Image"
      }
      vm.documentVerificationStatus = documentVerificationStatus;
    };
    init();

    function trustSrc(src) {
      return $sce.trustAsResourceUrl(src);
    }
    /// function to get customer detail
    function successCbGetCustomerDetailById(response) {
      vm.userData = response.data.data;
      vm.showBaseUrl = response.data.baseUrl;
    }

    function errorCbGetCustomerDetailById(response) {
      if (response.data && response.data.errors && response.data.errors.message) {
        showDialog(response.data.errors.message)
      } else if (response.data && response.data.responseString) {
        showDialog(response.data.responseString)
      } else {
        showDialog('Something went wrong please try again!')
      }
    }

    function getCustomerDetailById(id) {
      ServiceProxy.getUserProfile(id).then(successCbGetCustomerDetailById, errorCbGetCustomerDetailById)
    }

    function showDialog(response) {
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {

      }, function () {

      });
    };

    function sucessCbDocumentVErificationStatus(response, data) {

      getCustomerDetailById($stateParams.userId)
      if (data) {
        vm.userData.documents.comments = data.comments;
        vm.userData.documents.status = data.status;
      }
    }

    function errorCbDocumentVErificationStatus(response) {
      showDialog(response.data.responseString);
    }

    function documentVerificationStatus(docType, status) {

      var data = {
        userId: $stateParams.userId,
        docType: docType,
        status: status,
        comments: ""
      }
      if (status === 'CANCELED') {
        var confirm = $mdDialog.prompt()
          .title('Reason For Rejecting Document.')
          .placeholder('Enter Reason')
          .ariaLabel('Reason')
          .ok('Submit')
          .cancel('Cancle');

        $mdDialog.show(confirm).then(function (result) {
          if (result) {
            data.comments = result;
            ServiceProxy.documentVerificationStatus(data).then(function (response) {
              sucessCbDocumentVErificationStatus(response, data)
            }, errorCbDocumentVErificationStatus)
          }
        }, function () {
          // $scope.status = 'You didn\'t name your dog.';
        });
      } else {
        ServiceProxy.documentVerificationStatus(data).then(function (response) {
          sucessCbDocumentVErificationStatus(response, data)
        }, errorCbDocumentVErificationStatus)
      }
    }

    function getImagePath(doctype) {
      if (vm.userData.documents) {
        var returnObj = {};
        var index = vm.userData.documents.findIndex(function (item) {
          return item.docType === doctype;
        });
        if (index > -1 && vm.userData.documents[index].fileName) {
          returnObj = vm.userData.documents[index];
          // returnObj.url = '/api/user-documents/' + vm.userData.documents[index].fileName;
          returnObj.url = vm.showBaseUrl + vm.userData.documents[index].fileName;
          return returnObj;
        } else {
          returnObj.url = false;
          return returnObj;
        }
      }

    };

  }
})();
(function () {
	'use strict';

	angular.module('app.aumReport', []).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		var fId = 'AUM::REPORT::DASHBOARD';
		// State
		$stateProvider
			.state('app.aumReport', {
				url: '/aumReport',
				views: {
					'content@app': {
						templateUrl: 'app/main/aum-report/aum-report.html',
						controller: 'AUMReportController as vm'
					}
				},
				data: {
					access: function () {
						if (
							JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
							(window.sessionStorage.getItem('feature') &&
								JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
						) {
							return true;
						} else {
							return false;
						}
					}
				}
			})
			.state('app.aumReport.schemeInvestment', {
				url: '/schemeInvestment',
				views: {
					'content@app': {
						templateUrl: 'app/main/aum-report/customerDetailsScheme/customerDetailsScheme.html',
						controller: 'CustomerSchemeWiseDetailsController as vm'
					},
				}
			});


		// Translation
		// $translatePartialLoaderProvider.addPart('app/main/uploadTransaction');

		// Api
		// msApiProvider.register('sample', ['app/data/sample/sample.json']);

		// Navigation

		msNavigationServiceProvider.saveItem('DASHBOARD.aumReport', {
			title: 'AUM Report',
			icon: 'icon-tile-four',
			state: 'app.aumReport',
			weight: 6,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			  }
		});
	}
})();
(function () {
    'use strict';

    angular
        .module('app.aumReport')
        .controller('CustomerSchemeWiseDetailsController', CustomerSchemeWiseDetailsController);

    /** @ngInject */
    function CustomerSchemeWiseDetailsController($state, ShareDataService, Service, ServiceProxy) {
        var vm = this;

        function init() {
            vm.customers = ShareDataService.getData('schemeInvetsment');
            if (!vm.customers) {
                $state.go('app.aumReport')
            }
            vm.customerDetailFunction = customerDetailFunction;
        };
        init();

        function sucessCbUserProfile(response) {
            ShareDataService.storeData('customerDetail', response.data.data);
            $state.go('app.customers.customerhome.userDetail');

        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function customerDetailFunction(customer) {
            ServiceProxy.getUserProfile(customer.investorId).then(sucessCbUserProfile, errorGetUserProfile)
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fileModel', fileModel);

    /** @ngInject */
    function fileModel($parse) {
      return {
             restrict: 'A',
             link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function(){
                   scope.$apply(function(){
                      modelSetter(scope, element[0].files[0]);
                   });
                });
             }
          };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('ngFileModel', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var model = $parse(attrs.ngFileModel);
            var isMultiple = attrs.multiple;
            var modelSetter = model.assign;
            element.bind('change', function () {
                var values = [];
                angular.forEach(element[0].files, function (item) {
                    var value = {
                       // File Name
                        name: item.name,
                        //File Size
                        size: item.size,
                        //File URL to view
                        url: URL.createObjectURL(item),
                        // File Input Value
                        _file: item
                    };
                    values.push(value);
                });
                scope.$apply(function () {
                    if (isMultiple) {
                        modelSetter(scope, values);
                    } else {
                        modelSetter(scope, values[0]);
                    }
                });
            });
        }
    };
}]);
})();

(function () {
    'use strict';

    /**
     * Config
     */
    var moduleName = 'angularUtils.directives.dirPagination';
    var DEFAULT_ID = '__default';

    angular
        .module('app.core')
        .directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
        .directive('dirPaginateNoCompile', noCompileDirective)
        .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
        .filter('itemsPerPage', ['paginationService', itemsPerPageFilter])
        .service('paginationService', paginationService)
        .provider('paginationTemplate', paginationTemplateProvider)
        .run(['$templateCache', dirPaginationControlsTemplateInstaller]);

    /** @ngInject */
    function dirPaginateDirective($compile, $parse, paginationService) {

        return {
            terminal: true,
            multiElement: true,
            priority: 100,
            compile: dirPaginationCompileFn
        };

        function dirPaginationCompileFn(tElement, tAttrs) {

            var expression = tAttrs.dirPaginate;
            // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
            if (match[2].match(filterPattern) === null) {
                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
            }
            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
            var collectionGetter = $parse(itemsPerPageFilterRemoved);

            addNoCompileAttributes(tElement);

            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
            // dir-pagination-controls directives that may be looking for this ID.
            var rawId = tAttrs.paginationId || DEFAULT_ID;
            paginationService.registerInstance(rawId);

            return function dirPaginationLinkFn(scope, element, attrs) {

                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
                // potentially register a new ID if it evaluates to a different value than the rawId.
                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
                // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
                // before registering using paginationId
                paginationService.deregisterInstance(rawId);
                paginationService.registerInstance(paginationId);

                var repeatExpression = getRepeatExpression(expression, paginationId);
                addNgRepeatToElement(element, attrs, repeatExpression);

                removeTemporaryAttributes(element);
                var compiled = $compile(element);

                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);

                if (typeof attrs.totalItems !== 'undefined') {
                    paginationService.setAsyncModeTrue(paginationId);
                    scope.$watch(function () {
                        return $parse(attrs.totalItems)(scope);
                    }, function (result) {
                        if (0 <= result) {
                            paginationService.setCollectionLength(paginationId, result);
                        }
                    });
                } else {
                    paginationService.setAsyncModeFalse(paginationId);
                    scope.$watchCollection(function () {
                        return collectionGetter(scope);
                    }, function (collection) {
                        if (collection) {
                            var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
                            paginationService.setCollectionLength(paginationId, collectionLength);
                        }
                    });
                }

                // Delegate to the link function returned by the new compilation of the ng-repeat
                compiled(scope);

                // When the scope is destroyed, we make sure to remove the reference to it in paginationService
                // so that it can be properly garbage collected
                scope.$on('$destroy', function destroyDirPagination() {
                    paginationService.deregisterInstance(paginationId);
                });
            };
        }

        /**
         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
         *
         * @param expression
         * @param paginationId
         * @returns {*}
         */
        function getRepeatExpression(expression, paginationId) {
            var repeatExpression,
                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
            } else {
                repeatExpression = expression;
            }

            return repeatExpression;
        }

        /**
         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
         * appropriate multi-element ng-repeat to the first and last element in the range.
         * @param element
         * @param attrs
         * @param repeatExpression
         */
        function addNgRepeatToElement(element, attrs, repeatExpression) {
            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
                // using multiElement mode (dir-paginate-start, dir-paginate-end)
                attrs.$set('ngRepeatStart', repeatExpression);
                element.eq(element.length - 1).attr('ng-repeat-end', true);
            } else {
                attrs.$set('ngRepeat', repeatExpression);
            }
        }

        /**
         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
         * @param tElement
         */
        function addNoCompileAttributes(tElement) {
            angular.forEach(tElement, function (el) {
                if (el.nodeType === 1) {
                    angular.element(el).attr('dir-paginate-no-compile', true);
                }
            });
        }

        /**
         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
         * @param element
         */
        function removeTemporaryAttributes(element) {
            angular.forEach(element, function (el) {
                if (el.nodeType === 1) {
                    angular.element(el).removeAttr('dir-paginate-no-compile');
                }
            });
            element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
        }

        /**
         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
         * no current-page expression was specified.
         *
         * @param scope
         * @param attrs
         * @param paginationId
         * @returns {*}
         */
        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
            var currentPageGetter;
            if (attrs.currentPage) {
                currentPageGetter = $parse(attrs.currentPage);
            } else {
                // If the current-page attribute was not set, we'll make our own.
                // Replace any non-alphanumeric characters which might confuse
                // the $parse service and give unexpected results.
                // See https://github.com/michaelbromley/angularUtils/issues/233
                var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
                scope[defaultCurrentPage] = 1;
                currentPageGetter = $parse(defaultCurrentPage);
            }
            return currentPageGetter;
        }
    }

    /**
     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
     */
    function noCompileDirective() {
        return {
            priority: 5000,
            terminal: true
        };
    }

    function dirPaginationControlsTemplateInstaller($templateCache) {
        $templateCache.put('angularUtils.directives.dirPagination.template', '<ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
    }

    function dirPaginationControlsDirective(paginationService, paginationTemplate) {

        var numberRegex = /^\d+$/;

        var DDO = {
            restrict: 'AE',
            scope: {
                maxSize: '=?',
                onPageChange: '&?',
                paginationId: '=?',
                autoHide: '=?'
            },
            link: dirPaginationControlsLinkFn
        };

        // We need to check the paginationTemplate service to see whether a template path or
        // string has been specified, and add the `template` or `templateUrl` property to
        // the DDO as appropriate. The order of priority to decide which template to use is
        // (highest priority first):
        // 1. paginationTemplate.getString()
        // 2. attrs.templateUrl
        // 3. paginationTemplate.getPath()
        var templateString = paginationTemplate.getString();
        if (templateString !== undefined) {
            DDO.template = templateString;
        } else {
            DDO.templateUrl = function (elem, attrs) {
                return attrs.templateUrl || paginationTemplate.getPath();
            };
        }
        return DDO;

        function dirPaginationControlsLinkFn(scope, element, attrs) {

            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
            // no corresponding dir-paginate directive and wrongly throwing an exception.
            var rawId = attrs.paginationId || DEFAULT_ID;
            var paginationId = scope.paginationId || attrs.paginationId || DEFAULT_ID;

            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
                var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
                if (window.console) {
                    // console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
                }
            }

            if (!scope.maxSize) {
                scope.maxSize = 9;
            }
            scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

            var paginationRange = Math.max(scope.maxSize, 5);
            scope.pages = [];
            scope.pagination = {
                last: 1,
                current: 1
            };
            scope.range = {
                lower: 1,
                upper: 1,
                total: 1
            };

            scope.$watch('maxSize', function (val) {
                if (val) {
                    paginationRange = Math.max(scope.maxSize, 5);
                    generatePagination();
                }
            });

            scope.$watch(function () {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
                }
            }, function (length) {
                if (0 < length) {
                    generatePagination();
                }
            });

            scope.$watch(function () {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getItemsPerPage(paginationId));
                }
            }, function (current, previous) {
                if (current != previous && typeof previous !== 'undefined') {
                    goToPage(scope.pagination.current);
                }
            });

            scope.$watch(function () {
                if (paginationService.isRegistered(paginationId)) {
                    return paginationService.getCurrentPage(paginationId);
                }
            }, function (currentPage, previousPage) {
                if (currentPage != previousPage) {
                    goToPage(currentPage);
                }
            });

            scope.setCurrent = function (num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    num = parseInt(num, 10);
                    paginationService.setCurrentPage(paginationId, num);
                }
            };

            /**
             * Custom "track by" function which allows for duplicate "..." entries on long lists,
             * yet fixes the problem of wrongly-highlighted links which happens when using
             * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
             * @param id
             * @param index
             * @returns {string}
             */
            scope.tracker = function (id, index) {
                return id + '_' + index;
            };

            function goToPage(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    var oldPageNumber = scope.pagination.current;

                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = num;
                    updateRangeValues();

                    // if a callback has been set, then call it with the page number as the first argument
                    // and the previous page number as a second argument
                    if (scope.onPageChange) {
                        scope.onPageChange({
                            newPageNumber: num,
                            oldPageNumber: oldPageNumber
                        });
                    }
                }
            }

            function generatePagination() {
                if (paginationService.isRegistered(paginationId)) {
                    var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
                    scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = page;
                    scope.pagination.last = scope.pages[scope.pages.length - 1];
                    if (scope.pagination.last < scope.pagination.current) {
                        scope.setCurrent(scope.pagination.last);
                    } else {
                        updateRangeValues();
                    }
                }
            }

            /**
             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
             */
            function updateRangeValues() {
                if (paginationService.isRegistered(paginationId)) {
                    var currentPage = paginationService.getCurrentPage(paginationId),
                        itemsPerPage = paginationService.getItemsPerPage(paginationId),
                        totalItems = paginationService.getCollectionLength(paginationId);

                    scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
                    scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
                    scope.range.total = totalItems;
                }
            }

            function isValidPageNumber(num) {
                return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
            }
        }

        /**
         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
         * links used in pagination
         *
         * @param currentPage
         * @param rowsPerPage
         * @param paginationRange
         * @param collectionLength
         * @returns {Array}
         */
        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
            var pages = [];
            var totalPages = Math.ceil(collectionLength / rowsPerPage);
            var halfWay = Math.ceil(paginationRange / 2);
            var position;

            if (currentPage <= halfWay) {
                position = 'start';
            } else if (totalPages - halfWay < currentPage) {
                position = 'end';
            } else {
                position = 'middle';
            }

            var ellipsesNeeded = paginationRange < totalPages;
            var i = 1;
            while (i <= totalPages && i <= paginationRange) {
                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                    pages.push('...');
                } else {
                    pages.push(pageNumber);
                }
                i++;
            }
            return pages;
        }

        /**
         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
         *
         * @param i
         * @param currentPage
         * @param paginationRange
         * @param totalPages
         * @returns {*}
         */
        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
            var halfWay = Math.ceil(paginationRange / 2);
            if (i === paginationRange) {
                return totalPages;
            } else if (i === 1) {
                return i;
            } else if (paginationRange < totalPages) {
                if (totalPages - halfWay < currentPage) {
                    return totalPages - paginationRange + i;
                } else if (halfWay < currentPage) {
                    return currentPage - halfWay + i;
                } else {
                    return i;
                }
            } else {
                return i;
            }
        }
    }

    /**
     * This filter slices the collection into pages based on the current page number and number of items per page.
     * @param paginationService
     * @returns {Function}
     */
    function itemsPerPageFilter(paginationService) {

        return function (collection, itemsPerPage, paginationId) {
            if (typeof (paginationId) === 'undefined') {
                paginationId = DEFAULT_ID;
            }
            if (!paginationService.isRegistered(paginationId)) {
                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
            }
            var end;
            var start;
            if (angular.isObject(collection)) {
                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
                if (paginationService.isAsyncMode(paginationId)) {
                    start = 0;
                } else {
                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
                }
                end = start + itemsPerPage;
                paginationService.setItemsPerPage(paginationId, itemsPerPage);

                if (collection instanceof Array) {
                    // the array just needs to be sliced
                    return collection.slice(start, end);
                } else {
                    // in the case of an object, we need to get an array of keys, slice that, then map back to
                    // the original object.
                    var slicedObject = {};
                    angular.forEach(keys(collection).slice(start, end), function (key) {
                        slicedObject[key] = collection[key];
                    });
                    return slicedObject;
                }
            } else {
                return collection;
            }
        };
    }

    /**
     * Shim for the Object.keys() method which does not exist in IE < 9
     * @param obj
     * @returns {Array}
     */
    function keys(obj) {
        if (!Object.keys) {
            var objKeys = [];
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    objKeys.push(i);
                }
            }
            return objKeys;
        } else {
            return Object.keys(obj);
        }
    }

    /**
     * This service allows the various parts of the module to communicate and stay in sync.
     */
    function paginationService() {

        var instances = {};
        var lastRegisteredInstance;

        this.registerInstance = function (instanceId) {
            if (typeof instances[instanceId] === 'undefined') {
                instances[instanceId] = {
                    asyncMode: false
                };
                lastRegisteredInstance = instanceId;
            }
        };

        this.deregisterInstance = function (instanceId) {
            delete instances[instanceId];
        };

        this.isRegistered = function (instanceId) {
            return (typeof instances[instanceId] !== 'undefined');
        };

        this.getLastInstanceId = function () {
            return lastRegisteredInstance;
        };

        this.setCurrentPageParser = function (instanceId, val, scope) {
            instances[instanceId].currentPageParser = val;
            instances[instanceId].context = scope;
        };
        this.setCurrentPage = function (instanceId, val) {
            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
        };
        this.getCurrentPage = function (instanceId) {
            var parser = instances[instanceId].currentPageParser;
            return parser ? parser(instances[instanceId].context) : 1;
        };

        this.setItemsPerPage = function (instanceId, val) {
            instances[instanceId].itemsPerPage = val;
        };
        this.getItemsPerPage = function (instanceId) {
            return instances[instanceId].itemsPerPage;
        };

        this.setCollectionLength = function (instanceId, val) {
            instances[instanceId].collectionLength = val;
        };
        this.getCollectionLength = function (instanceId) {
            return instances[instanceId].collectionLength;
        };

        this.setAsyncModeTrue = function (instanceId) {
            instances[instanceId].asyncMode = true;
        };

        this.setAsyncModeFalse = function (instanceId) {
            instances[instanceId].asyncMode = false;
        };

        this.isAsyncMode = function (instanceId) {
            return instances[instanceId].asyncMode;
        };
    }

    /**
     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
     */
    function paginationTemplateProvider() {

        var templatePath = 'angularUtils.directives.dirPagination.template';
        var templateString;

        /**
         * Set a templateUrl to be used by all instances of <dir-pagination-controls>
         * @param {String} path
         */
        this.setPath = function (path) {
            templatePath = path;
        };

        /**
         * Set a string of HTML to be used as a template by all instances
         * of <dir-pagination-controls>. If both a path *and* a string have been set,
         * the string takes precedence.
         * @param {String} str
         */
        this.setString = function (str) {
            templateString = str;
        };

        this.$get = function () {
            return {
                getPath: function () {
                    return templatePath;
                },
                getString: function () {
                    return templateString;
                }
            };
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)//define scope i.e controller
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
            
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;
        // vm.waitVideoLoaded = waitVideoLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
 (function () {
    'use strict';

    angular
        .module('app.core')
        .directive('mdLightbox', mdLightbox);

    /** @ngInject */
    function mdLightbox($mdDialog) {
        return {
            link: function($scope, elem, attrs){

                elem.addClass('image-click');

                elem.on('click',function(){
                    var image = attrs.src;
                    var title = attrs.mdLightboxTitle;
                    showLightboxModal(image, title);

                });

                //Lightbox Modal
                function showLightboxModal(image, title) {
                    var confirm = $mdDialog.confirm({
                        templateUrl: 'app/core/directives/light-box/light-box.html',
                        clickOutsideToClose: true,
                        controller: lightboxController
                    });

                    $mdDialog.show(confirm);

                    function lightboxController($scope, $mdDialog) {
                        $scope.image = image;
                        $scope.title = title;

                        $scope.cancel = function() {
                            $mdDialog.cancel();
                        };

                    }

                }
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('whenScrolled', function () {
      return {

        restrict: 'A',
        link: function (scope, elem, attrs) {

          // we get a list of elements of size 1 and need the first element
          var raw = elem[0];
          // we load more elements when scrolled past a limit
          elem.bind("scroll", function () {

            if (raw.scrollTop + raw.offsetHeight + 5 >= raw.scrollHeight) {
              scope.loading = true;

              // we can give any function which loads more elements into the list
              scope.$apply(attrs.whenScrolled);
            }
          });
        }
      }
    });
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('backButton', function() {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    element.on('click', function() {
                        history.back();
                        scope.$apply();
                    });
                }
            };
        });
})();
(function () {
	'use strict';

	angular.module('app.uploadTransaction').controller('UploadTransactionController', UploadTransactionController);

	/** @ngInject */
	function UploadTransactionController(
		$scope,
		$document,
		$state,
		$stateParams,
		$rootScope,
		$mdDialog,
		$mdToast,
		ServiceProxy,
		ShareDataService,
		StorageService
	) {
		var vm = this;

		function init() {
			vm.token = StorageService.getSessionStorage('access_token');
			vm.uploadSundaramTransaction = uploadSundaramTransaction;
			vm.uploadCamsTrxn = uploadCamsTrxn;
			vm.uploadKarvyTrxn = uploadKarvyTrxn;
			vm.uploadFranklinTrxn = uploadFranklinTrxn;
			//Validate list
			vm.validateCamsList = validateCamsList;
			vm.validateKarvyList = validateKarvyList;
			vm.validateFranklinList = validateFranklinList;
			
			vm.camsFile = 'No File Selected';
			vm.karvyFile = 'No File Selected';
			vm.franklinFile = 'No File Selected';
			vm.sundaramFile = 'No File Selected';
			getSundramTrxn();
			getFranklinTrxn();
			getKarvyTrxn();
			getCamsTrxn();
			
			
			
		}
		init();

		function sucessCbUploadCamsTransaction(response) {
			$('#camsFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#camsFile').unwrap();
			vm.camsFile = 'No File Selected';
			//var responseData = JSON.parse(response);
			showToast(response.data.responseString);
			dialogOpenAddEmployee(response.data.responseString);
		}

		function errorCbUploadCamsTransaction(error) {
			$('#camsFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#camsFile').unwrap();
			vm.camsFile = 'No File Selected';
			if (typeof error.data.responseString === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data.responseString, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
		}

		function uploadCamsTrxn() {
			var data = new FormData();
			data.append('file', $('#camsFile').prop('files')[0]);
			ServiceProxy.uploadCamsTrxn(data).then(sucessCbUploadCamsTransaction, errorCbUploadCamsTransaction);
		}


		function sucessCbValidateCamsList(response) {
			if(response.data.responseString.length > 0){
				ShareDataService.storeData('validateInvestorData', response.data.responseString);
				$state.go('app.uploadTransaction.validateInvestor');
			}
			else
			{
				var  msg = "Data validate successfully."
				showDialogSucc(msg);
			}
        }

        function errorGetValidateCamsList(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }

		function validateCamsList() {
			var data = new FormData();
			data.append('file', $('#camsFile').prop('files')[0]);
			ServiceProxy.validateCamsList(data).then(sucessCbValidateCamsList, errorGetValidateCamsList);
		}


		function sucessCbUploadKarvyTrxn(response) {
			$('#karvyfile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#karvyfile').unwrap();
			vm.karvyFile = 'No File Selected';
			// var responseData = JSON.parse(response);
			showToast(response.data.responseString);
			// dialogOpenAddEmployee(responseData);
		}

		function errorCbUploadKarvyTrxn(error) {
			vm.karvyFile = 'No File Selected';
			$('#karvyfile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#karvyfile').unwrap();
			if (typeof error.data.responseString === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data.responseString, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
		}

		function uploadKarvyTrxn() {
			var data = new FormData();
			data.append('file', $('#karvyfile').prop('files')[0]);
			ServiceProxy.uploadKarvyTrxn(data).then(sucessCbUploadKarvyTrxn, errorCbUploadKarvyTrxn);
		}


		function sucessCbValidateKarvyList(response) {
			// $('#karvyfile')
			// 	.wrap('<form>')
			// 	.closest('form')
			// 	.get(0)
			// 	.reset();
			// $('#karvyfile').unwrap();
			// vm.karvyFile = 'No File Selected';
			// var responseData = JSON.parse(response);
			//showToast(response.data.responseString);
			if(response.data.responseString.length > 0){
				ShareDataService.storeData('validateInvestorData', response.data.responseString);
				$state.go('app.uploadTransaction.validateInvestor');
			}
			else
			{
				var  msg = "Data validate successfully."
				showDialogSucc(msg);
			}
            
        }

        function errorGetValidateKarvyList(response) {
			vm.karvyFile = 'No File Selected';
			$('#karvyfile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#karvyfile').unwrap();
			if (typeof error.data.responseString === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data.responseString, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
        }

		function validateKarvyList() {
			var data = new FormData();
			data.append('file', $('#karvyfile').prop('files')[0]);
			ServiceProxy.validateKarvyTransaction(data).then(sucessCbValidateKarvyList, errorGetValidateKarvyList);
		}

		function sucessCbUploadFranklinTrxn(response) {
			$('#franklinFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#franklinFile').unwrap();
			vm.franklinFile = 'No File Selected';
			// var responseData = JSON.parse(response);
			showToast(response.data.responseString);
			// dialogOpenAddEmployee(responseData);
		}

		function errorCbUploadFranklinTrxn(error) {
			vm.franklinFile = 'No File Selected';
			$('#franklinFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#franklinFile').unwrap();
			if (typeof error.data.responseString === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data.responseString, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
		}

		function uploadFranklinTrxn() {
			var data = new FormData();
			data.append('file', $('#franklinFile').prop('files')[0]);
			ServiceProxy.uploadFranklinTrxn(data).then(sucessCbUploadFranklinTrxn, errorCbUploadFranklinTrxn);
		}

		
		function sucessCbValidateFranklinList(response) {
			if(response.data.responseString.length > 0){
				ShareDataService.storeData('validateInvestorData', response.data.responseString);
				$state.go('app.uploadTransaction.validateInvestor');
			}
			else
			{
				var  msg = "Data validate successfully."
				showDialogSucc(msg);
			}
          
        }

        function errorGetValidateFranklinList(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }

		function validateFranklinList() {
			var data = new FormData();
			data.append('file', $('#franklinFile').prop('files')[0]);
			ServiceProxy.validateFranklinList(data).then(sucessCbValidateFranklinList, errorGetValidateFranklinList);
		}

		// function to upload sundaram transaction
		function sucessCbSundramTrxn(response) {
			vm.sundaramFile = 'No File Selected';
			$('#sundaramFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#sundaramFile').unwrap();
			showToast(response.data.responseString);
			// dialogOpenAddEmployee(response);
		}

		function errorCbSundramTrxn(error) {
			vm.sundaramFile = 'No File Selected';
			$('#sundaramFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#sundaramFile').unwrap();
			if (typeof error.data.responseString === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data.responseString, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
		}

		function uploadSundaramTransaction() {
			var data = new FormData();
			data.append('file', $('#sundaramFile').prop('files')[0]);
			ServiceProxy.uploadSundaramTransaction(data).then(sucessCbSundramTrxn, errorCbSundramTrxn);
		}


		function dialogOpenAddEmployee(response) {
			console.log('response ',response);
			var message = '';
			if (response.err_desc) {
				message = response.err_desc;
			} else if (response.responseString) {
				message = response.responseString;
			} else {
				message = response;
			}
			var confirm = $mdDialog
				.confirm()
				.title('Upload Details')
				.htmlContent('<b>' + message + '</b>')
				.ariaLabel('delete contact')
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}

		$scope.checkfile = checkfile;

		function checkfile(sender, type) {
			if (type === 'camsFile') {
				var docValue = document.getElementById('camsFile');
				vm.camsFile = docValue.files[0].name;
			} else if (type === 'karvyFile') {
				var docValue = document.getElementById('karvyfile');
				vm.karvyFile = docValue.files[0].name;
			} else if (type === 'franklinFile') {
				var docValue = document.getElementById('franklinFile');
				vm.franklinFile = docValue.files[0].name;
			} else if (type === 'sundaramFile') {
				var docValue = document.getElementById('sundaramFile');
				vm.sundaramFile = docValue.files[0].name;
			}
			$scope.$apply();
			var validExts = new Array('.csv');
			var fileExt = sender.value;
			fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
			if (validExts.indexOf(fileExt) < 0) {
				dialogOpenAddEmployee('Invalid file selected, valid files are of ' + validExts.toString() + ' types.');
				$(sender).val('');
				return false;
			} else return true;
		}

		function showToast(msg) {
			var toast = $mdToast
				.simple()
				.textContent(msg)
				.highlightAction(true)
				.highlightClass('md-accent')
				.position('top right');

			$mdToast.show(toast).then(function (response) {
				if (response == 'ok') {
					alert("You clicked the 'UNDO' action.");
				}
			});
		}

		function successCbGetCamsTrxn(response) {
			vm.camsData = response.data.data[0];
		}

		function errorCbGetCamsTrxn(response) {
			dialogOpenAddEmployee(response);
		}

		function getCamsTrxn() {
			ServiceProxy.getCamsTrxn(1, 1).then(successCbGetCamsTrxn, errorCbGetCamsTrxn);
		}

		function successCbGetKarvyTrxn(response) {
			vm.karvyData = response.data.data[0];
		}

		function errorCbGetKarvyTrxn(response) {
			dialogOpenAddEmployee(response);
		}

		function getKarvyTrxn() {
			ServiceProxy.getKarvyTrxn(1, 1).then(successCbGetKarvyTrxn, errorCbGetKarvyTrxn);
		}

		function successCbGetFranklinTrxn(response) {
			vm.franklinData = response.data.data[0];
		}

		function errorCbGetFranklinTrxn(response) {
			dialogOpenAddEmployee(response);
		}

		function getFranklinTrxn() {
			ServiceProxy.getFranklinTrxn(1, 1).then(successCbGetFranklinTrxn, errorCbGetFranklinTrxn);
		}

		// sundram trxn data
		function successCbGetSundramTrxn(response) {
			vm.sundramData = response.data.data[0];
		}

		function errorCbGetSundramTrxn(response) {
			dialogOpenAddEmployee(response);
		}

		function getSundramTrxn() {
			ServiceProxy.getSundramTrxn(1, 1).then(successCbGetSundramTrxn, errorCbGetSundramTrxn);
		}

		function showDialogSucc(response) {
			var confirm = $mdDialog.confirm()
			  .title('Success')
			  .textContent(response)
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK');
			$mdDialog.show(confirm).then(function () {});
		  }
		  
		  function showDialog(response) {
			var confirm = $mdDialog.confirm()
			  .title('!!Error!!')
			  .textContent(response)
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK');
			$mdDialog.show(confirm).then(function () {});
		  };
	}
})();
(function() {
	'use strict';

	angular
		.module('app.transactionLogs', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.transactionLogs', {
				url: '/transactionLogs',
				views: {
					'content@app': {
						templateUrl: 'app/main/transaction-logs/transaction-logs.html',
						controller: 'transactionLogsController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('DASHBOARD.transactionLogs', {
			title: 'Transaction Logs',
			icon: 'icon-tile-four',
			state: 'app.transactionLogs',
			weight: 7,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.transactionLogs').controller('transactionLogsController', transactionLogsController);

	/** @ngInject */
	function transactionLogsController($state,$scope,$filter,$timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;

		function init() {
			vm.postData = {}
			vm.fromDate = null
			vm.toDate = null
			vm.selected = null
			vm.reportType = null
			vm.enabled1 = false
			vm.iinRegex = /^[1-9]{1}[0-9]{9}$/
			vm.logData = []
			
		}
		init();

		var sucessTrnLog = function(response){
			console.log(response);
			vm.logData = response.data.data;
			
			if(vm.logData.length < 1){
				showDialog("No Data Found...!!!");
			}else{
				showDialogSucc(response.data.responseString)
			}
		}

		var errorTrnlog = function(response){
			console.log(response);
			
		}

		$scope.postTranLogs = function(){
			vm.postData.IinStatus = (vm.selected == 1 ? 'Yes' : 'No');
			vm.postData.reportType = (vm.reportType == 1 ? 'A' : 'I');
			vm.postData.Iin = vm.postData.iin ? vm.postData.iin : 0;
			vm.postData.Iin = vm.postData.Iin.toString();
			vm.postData.fromDate = $filter('date')(vm.fromDate, "dd/MM/yyyy") 
			vm.postData.toDate = $filter('date')(vm.toDate, "dd/MM/yyyy")
			console.log(vm.postData);
			ServiceProxy.postTrnLogs(vm.postData).then(sucessTrnLog, errorTrnlog);
		}

		$scope.disabtranLog = function(){
			if(vm.reportType == 1 && vm.selected || vm.reportType == 2 && vm.postData.iin ){
				vm.enabled1 = true;
			}else{
				vm.enabled1 = false;
			}
			return ( !vm.fromDate || !vm.toDate || !vm.enabled1 )
		}

		$scope.clearLogs = function (){
			init()
		}
				 

		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}


		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.syncing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'THIRD::PARTY::SERVER::CONFIG';
        // State
        $stateProvider
            .state('app.syncing', {
                url: '/syncing',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/syncing/syncing.html',
                        controller: 'SyncingController as vm'
                    }
                },
                data: {
                    access: function() {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.syncinginfo', {
                url: '/exemptedUsers',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/syncing/exemptedUsers.html',
                        controller: 'SyncingController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('CONFIGURATION.syncing', {
            title: 'Syncing',
            state: 'app.syncing',
            icon: 'icon-people',
            weight: 2
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.syncing')
        .controller('SyncingController', SyncingController);

    /** @ngInject */
    function SyncingController($rootScope, $state, $mdDialog, ServiceProxy,$q, $timeout, ShareDataService) {
        var vm = this;
        //vm.showdate=showdate;
        vm.fetch_internal_users = fetch_internal_users;
        vm.synexemptedcuser = synexemptedcuser;
        vm.getAllexempteduser = getAllexempteduser;
        vm.remove_exempted_user = remove_exempted_user;
        vm.save_exempted_user = save_exempted_user;
        vm.fetch_exempted_users = fetch_exempted_users;


        function init() {
            vm.getSyncNseUser = getSyncNseUser;
            vm.getSyncAchMandateFollowUpMail = getSyncAchMandateFollowUpMail;
            vm.btnDisable = true;
            vm.getbtnDisable = localStorage.getItem('btndisable');
            if (vm.getbtnDisable !== null) {
                var data = new Date().getTime();
                if ((data - vm.getbtnDisable) > (2 * 60 * 60 * 1000)) {
                    vm.btnDisable = false;
                }
            } else {
                vm.btnDisable = false;
            }
            vm.getSyncAumReport = getSyncAumReport;
            vm.getSyncSIPBookReport = getSyncSIPBookReport;
            vm.startAutoLeadAssignment = startAutoLeadAssignment;
            vm.stopAutoLeadAssignment = stopAutoLeadAssignment;
            vm.internalUserExemptList = internalUserExemptList;
            vm.add_exempted_users = add_exempted_users;
            //vm.getAutoLeadAssignmentStatus = getAutoLeadAssignmentStatus;
            vm.updateNAV = updateNAV;
            getAutoLeadAssignmentStatus();
            internalUserExemptList();
            vm.selectedFile = null;
            vm.uploading = false;
            vm.selectFile = selectFile;
            vm.onFileSelected = onFileSelected;
            vm.uploadCustomer = uploadCustomer;
            vm.getSIPDueReport = getSIPDueReport;
            vm.getOnBoardingReport = getOnBoardingReport;
            vm.getRedeemReport = getRedeemReport;
            vm.getCeaseReport = getCeaseReport;
            vm.openNewsletterDialog = openNewsletterDialog;
            vm.getTransferOutReport = getTransferOutReport;
        };
        init();

        ////////////////////////////////////////starts functionality of get syncing nse user/////////////////////////////////
        function successCbGetSyncingNseUser(response) {
            if (response && response.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbGetSyncingNseUser(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function getSyncNseUser() {
            var data = new Date().getTime();
            localStorage.setItem('btndisable', data);
            vm.btnDisable = true;
            ServiceProxy.getSyncingNseUser().then(successCbGetSyncingNseUser, errorCbGetSyncingNseUser)
        }
        ////////////////////////////////////////ends f functionality of get syncing nse user/////////////////////////////////

        function successCbGetAchMandateFollowUpMail(response) {
            if (response && response.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbAchMandateFollowUpMail(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }
        function getSyncAchMandateFollowUpMail() {
            ServiceProxy.getSyncAchMandateFollowUpMail().then(successCbGetAchMandateFollowUpMail, errorCbAchMandateFollowUpMail)
        }

        //////////////Start AUM Report Generation///////////////
        function getSyncAumReport(){
            ServiceProxy.getSyncAUMReport().then(successCbGetSyncAUMReport, errorCbGetSyncAUMReport)
        }

        function successCbGetSyncAUMReport(response){
            if (response && response.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbGetSyncAUMReport(response){
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }
        //////////////End Of AUM Report Generation///////////////

        //////////////Start SIP Report Generation///////////////
        function getSyncSIPBookReport(){
            ServiceProxy.getSyncSIPReport().then(successCbGetSyncSIPReport, errorCbGetSyncSIPReport)
        }

        function successCbGetSyncSIPReport(response){
            if (response && response.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbGetSyncSIPReport(response){
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }        
        //////////////End Of AUM Report Generation///////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////


        /////////// Start Auto Lead Assignment ////////////

        function startAutoLeadAssignment(){
            ServiceProxy.startAutoLeadAssignment().then(successCbStartAutoLeadAssignment, errorCbStartAutoLeadAssignment)
        }

        function successCbStartAutoLeadAssignment(response){
            if (response && response.data) {
                vm.disableAutoLead = true;
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbStartAutoLeadAssignment(response){
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }        
        ///////// End Auto Lead Assignment ////////////

        /////////// Stop Auto Lead Assignment ////////////

        function stopAutoLeadAssignment(){
            ServiceProxy.stopAutoLeadAssignment().then(successCbStopAutoLeadAssignment, errorCbStopAutoLeadAssignment)
        }

        function successCbStopAutoLeadAssignment(response){
            if (response && response.data) {
                vm.disableAutoLead = false;
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbStopAutoLeadAssignment(response){
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }        
        ///////// End Auto Lead Assignment ////////////

        ///////// Start Auto Lead Assignment Automation Status ///////////
        function getAutoLeadAssignmentStatus(){
            ServiceProxy.getAutoLeadAssignmentStatus().then(successCbAutoLeadAssignmentStatus, errorCbAutoLeadAssignmentStatus)
        }

        function successCbAutoLeadAssignmentStatus(response){
            if (response && response.data) {
                //showDialogSucc(response.data.responseString);
                if(response.data.responseString === 'running')
                    vm.disableAutoLead = true;
                else
                    vm.disableAutoLead = false;
            }
        }

        function errorCbAutoLeadAssignmentStatus(response){
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }    


        ///////// End Auto Lead Assignment ////////////



        /////// Start Exempted Users /////////////
        // function showdate(){
        //     vm.datee=new Date();
        // }
       
        function fetch_internal_users(){
            ServiceProxy.fetch_internal_users({}).then(function(response, err){
                vm.userdata=response.data.data;
            });
        }
       
        function synexemptedcuser(searchText) {
            var result = vm.userdata;
            var deferred;
      
            if (searchText) {
                deferred = $q.defer();
        
                $timeout(function () {
                    var states = vm.userdata.filter(function (state) {
                    var user=state.userName;
                    return (user ? user.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || user.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 : null);
                    });
                    deferred.resolve(states);
                }, 1500);
        
                return deferred.promise;

            } else {
                return result;
            }
      
        }

        function getAllexempteduser(data){
            vm.user=data;
        }  

        function remove_exempted_user(mid,id){
            ServiceProxy.remove_exempted_user({mid:mid,id:id}).then(function(response, err){
                if(response.data.validFlag==true){
                    vm.fetch_exempted_users();
                }
            });
        }

        function save_exempted_user(){
            if(vm.user.office){
                vm.user.office=vm.user.office.city;
            }
            ServiceProxy.save_exempted_user(vm.user).then(function(response, err){
                if(response.data.validFlag==true){
                    alert(response.data.responseString)
                    vm.user=undefined;
                    vm.selecteduser=undefined;
                    vm.fetch_exempted_users();
                }else{
                    if(response.data.validFlag==false){
                    alert(response.data.responseString)
                    }
                }   
            });
        }

        function fetch_exempted_users() {
            vm.userinfo = [];
            ServiceProxy.fetch_exempted_users({}).then(function (response) {
                console.log('11', response);
                var fetchuserdata = response.data.data;
        
                fetchuserdata.forEach(function (item) {
                    vm.id = item._id; // Store the current exempted ID if needed
                    vm.exemptedDate = item.exemptedDate; // Store the current exempted date if needed
        
                    item.users.forEach(function (user) {
                        // Add both user details and the exemptedDate to the user info array
                        vm.userinfo.push(
                            angular.extend({}, user, { exemptedDate: item.exemptedDate })
                        );
                    });
                });
        
                console.log('vm.userinfo', vm.userinfo);
            }).catch(function (err) {
                console.error("Error fetching exempted users:", err);
            });
        }            

        ////// End Exempted Users  ///////////////

        ////////////////////////////////////////starts functionality of NAV Update/////////////////////////////////
        function successCbUpdateNAV(response) {
            if (response && response.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbUpdateNAV(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function updateNAV() {
            var data = new Date().getTime();            
            vm.btnDisable = true;
            ServiceProxy.updateNAV().then(successCbUpdateNAV, errorCbUpdateNAV)
        }

        vm.minDate = new Date().toISOString().split('T')[0];  // Restrict past dates

        vm.formatFromDate = function() {
            if (vm.fromDate) {
                var dateObj = new Date(vm.fromDate);
                var year = dateObj.getFullYear();
                var month = (dateObj.getMonth() + 1); // Months are 0-based
                var day = dateObj.getDate();
        
                // Ensure two-digit format for month and day
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
        
                vm.fromDate = year + '-' + month + '-' + day;
            }
        };

        vm.formatToDate = function() {
            if (vm.toDate) {
                var dateObj = new Date(vm.toDate);
                var year = dateObj.getFullYear();
                var month = (dateObj.getMonth() + 1); // Months are 0-based
                var day = dateObj.getDate();
        
                // Ensure two-digit format for month and day
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
        
                vm.toDate = year + '-' + month + '-' + day;
            }
        };
       
        function add_exempted_users(transaction) {
        
            // Check if the transaction object is valid
            if (!transaction) {
                alert("No user to save.");
                return;
            }
            
            if(transaction.office){
                transaction.office=transaction.office.city;
            }

            if(vm.fromDate === undefined || vm.fromDate === null){
                alert('From Date is not selected');
                return;
            }

            if(vm.toDate === undefined || vm.toDate === null){
                alert('To Date is not selected');
                return;
            }

            transaction.fromdate = vm.fromDate;
            transaction.todate = vm.toDate;

            console.log("Transaction to save: ", transaction);

            ServiceProxy.save_exempted_user(transaction).then(function(response, err){
                if(response.data.validFlag==true){
                    showDialogSucc('User added in Exempted list.')
                    vm.user = undefined;
                    vm.selecteduser = undefined;
                    vm.fromDate = null;
                    vm.toDate = null;
                    vm.fetch_exempted_users();
                }else{
                    if(response.data.validFlag==false){
                        showDialog(response.data.responseString)
                    }
                }   
            });
        }

        function successinternalUserExemptList(response) {
            vm.internalUser = response.data.responseData;
            console.log('1', vm.internalUser);
        }

        function errorinternalUserExemptList(response) {
            console.log('2', response);
        }

        function internalUserExemptList() {
            ServiceProxy.internalUserExemptList().then(successinternalUserExemptList, errorinternalUserExemptList);
        }
        ////////////////////////////////////////ends functionality of get syncing nse user/////////////////////////////////

        function selectFile() {
            document.getElementById('customerFile').click();
        }

        // Function to handle file selection
        function onFileSelected(file) {
            if (file) {
                // Validate file type
                // if (!file.name.toLowerCase().endsWith('.csv')) {
                //     showDialog('Please select a CSV file only.');
                //     return;
                // }
                
                // Validate file size (optional - e.g., 5MB limit)
                // if (file.size > 5 * 1024 * 1024) {
                //     showDialog('File size should not exceed 5MB.');
                //     return;
                // }
                
                vm.selectedFile = file;
                // Trigger digest cycle to update UI
                if (!$rootScope.$$phase) {
                    $rootScope.$apply();
                }
            }
        }

        function uploadCustomer() {
            if (!vm.selectedFile) {
                showDialog('Please select a CSV file first.');
                return;
            }
            
            vm.uploading = true;
            
            // Create FormData object
            var formData = new FormData();
            formData.append('file', vm.selectedFile);
            ServiceProxy.uploadCustomer(formData).then(successuploadCustomer, erroruploadCustomer);
        }

        ////////// Shared date-range dialog for report downloads //////////
        function formatDateDMY(dateVal) {
            if (!dateVal) return '';
            var d = (dateVal instanceof Date) ? dateVal : new Date(dateVal);
            var day   = ('0' + d.getDate()).slice(-2);
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var year  = d.getFullYear();
            return day + '-' + month + '-' + year;
        }

        function openDateRangeDialog(title) {
            var template = [
                '<md-dialog aria-label="' + title + '" style="min-width:360px">',
                '<md-toolbar><div class="md-toolbar-tools"><h2>' + title + '</h2></div></md-toolbar>',
                '<md-dialog-content class="md-padding">',
                '<p style="font-size:12px;color:#888;margin-bottom:8px">Leave blank to fetch all records.</p>',
                '<md-input-container class="md-block"><label>From Date</label>',
                '<input type="date" ng-model="fromDate"></md-input-container>',
                '<md-input-container class="md-block"><label>To Date</label>',
                '<input type="date" ng-model="toDate"></md-input-container>',
                '</md-dialog-content>',
                '<md-dialog-actions layout="row" layout-align="end center">',
                '<md-button ng-click="cancel()">Cancel</md-button>',
                '<md-button class="md-raised md-primary" ng-click="submit()">Download</md-button>',
                '</md-dialog-actions></md-dialog>'
            ].join('');

            return $mdDialog.show({
                template: template,
                controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                    $scope.fromDate = '';
                    $scope.toDate = '';
                    $scope.cancel = function() { $mdDialog.cancel(); };
                    $scope.submit = function() {
                        $mdDialog.hide({ fromDate: $scope.fromDate, toDate: $scope.toDate });
                    };
                }],
                parent: angular.element(document.body),
                clickOutsideToClose: true
            }).then(function(result) {
                return {
                    from_date: result.fromDate ? formatDateDMY(result.fromDate) : '',
                    to_date:   result.toDate   ? formatDateDMY(result.toDate)   : ''
                };
            });
        }

        function getSIPDueReport() {
            openDateRangeDialog('SIP Due Report').then(function(payload) {
                console.log('Payload for SIP Due Report:', payload);
                ServiceProxy.getSIPDueReport(payload).then(
                    function(r) { if (r && r.data) showDialogSucc(r.data.responseString || r.data.servicemsg); },
                    function(r) { if (r && r.data) showDialog(r.data.responseString || r.data.servicemsg); }
                );
            });
        }

        function getOnBoardingReport() {
            openDateRangeDialog('On Boarding Report').then(function(payload) {
                ServiceProxy.getOnBoardingReport(payload).then(
                    function(r) { if (r && r.data) showDialogSucc(r.data.responseString || r.data.servicemsg); },
                    function(r) { if (r && r.data) showDialog(r.data.responseString || r.data.servicemsg); }
                );
            });
        }

        function getRedeemReport() {
            openDateRangeDialog('Redeem Report').then(function(payload) {
                ServiceProxy.getRedeemReport(payload).then(
                    function(r) { if (r && r.data) showDialogSucc(r.data.responseString || r.data.servicemsg); },
                    function(r) { if (r && r.data) showDialog(r.data.responseString || r.data.servicemsg); }
                );
            });
        }

        function getCeaseReport() {
            openDateRangeDialog('Cease Report').then(function(payload) {
                ServiceProxy.getCeaseReport(payload).then(
                    function(r) { if (r && r.data) showDialogSucc(r.data.responseString || r.data.servicemsg); },
                    function(r) { if (r && r.data) showDialog(r.data.responseString || r.data.servicemsg); }
                );
            });
        }

        ////////// SIPfund Newsletter (prompt for subject) //////////
        function openNewsletterDialog() {
            var prompt = $mdDialog.prompt()
                .title('SIPfund Newsletter')
                .placeholder('Enter email subject...')
                .ariaLabel('Subject')
                .ok('Send')
                .cancel('Cancel');
            $mdDialog.show(prompt).then(function(subject) {
                ServiceProxy.sendSIPFundNewsletter({ subject: subject }).then(
                    function(response) { if (response && response.data) showDialogSucc(response.data.responseString || response.data.servicemsg); },
                    function(response) { if (response && response.data) showDialog(response.data.responseString || response.data.servicemsg); }
                );
            });
        }

        function getTransferOutReport() {
            openDateRangeDialog('Transfer Out Report').then(function(payload) {
                ServiceProxy.getTransferOutReport(payload).then(
                    function(r) { if (r && r.data) showDialogSucc(r.data.responseString || r.data.servicemsg); },
                    function(r) { if (r && r.data) showDialog(r.data.responseString || r.data.servicemsg); }
                );
            });
        }

        function successuploadCustomer(response) {
            vm.uploading = false;
            vm.selectedFile = null;
            
            if (response && response.data) {
                showDialogSucc(response.data.responseString || 'Customer data uploaded successfully!');
            }
        }

        function erroruploadCustomer(response) {
            vm.uploading = false;
            
            if (response && response.data) {
                showDialog(response.data.responseString || 'Error uploading customer data.');
            } else {
                showDialog('Network error. Please try again.');
            }
        }

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

    }
})();
(function() {
	'use strict';

	angular.module('app.uploadNavs', []).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		var fId = 'TRANSACTION::CSV::UPLOAD';
		// State
		$stateProvider.state('app.uploadNavs', {
			url: '/uploadNavs',
			views: {
				'content@app': {
					templateUrl: 'app/main/uploadNavs/uploadNavs.html',
					controller: 'UploadNavsController as vm'
				}
			},
			data: {
				access: function() {
					if (
						JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
						(window.sessionStorage.getItem('feature') &&
							JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
					) {
						return true;
					} else {
						return false;
					}
				}
			}
		});

		// Translation
		// $translatePartialLoaderProvider.addPart('app/main/uploadNavs');

		// Api
		// msApiProvider.register('sample', ['app/data/sample/sample.json']);

		// Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		//     title : 'SAMPLE',
		//     group : true,
		//     weight: 2
		// });

		msNavigationServiceProvider.saveItem('TRANSACTION.uploadNavs', {
			title: 'Upload NAVs',
			icon: 'icon-file-multiple',
			state: 'app.uploadNavs',
			weight: 3
		});
	}
})();

(function() {
    'use strict';


    angular
        .module('app.uploadNavs')
        .controller('UploadNavsController', UploadNavsController);

    /** @ngInject */
    function UploadNavsController($scope, $document, $state, $stateParams, $rootScope, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            $scope.checkfile = checkfile;
            vm.navUpload = navUpload;
        }
        init();

        function navUpload() {
            var data = new FormData();
            data.append("file", $("#navFile").prop('files')[0]);
            var settings = {
                "async": true,
                "crossDomain": true,
                "url": "/api/camsNavUpload",
                "method": "POST",
                // "headers": {
                //   "cache-control": "no-cache",
                //   "postman-token": "2ae6d768-5f0f-ba25-4737-5b06b76a47ec"
                // },
                "processData": false,
                "contentType": false,
                "mimeType": "multipart/form-data",
                "data": data,
                beforeSend: function() {
                    $.loadingBlockShow({
                        imgPath: 'assets/images/preloader@2x.gif',
                        text: 'Loading Please Wait',
                        style: {
                            position: 'fixed',
                            width: '100%',
                            height: '100%',
                            background: 'rgba(0, 0, 0, .8)',
                            left: 0,
                            top: 0,
                            zIndex: 10000
                        }
                    });
                },
                complete: function() {
                    $.loadingBlockHide();
                }
            }

            $.ajax(settings).done(function(response) {
                var responseData = JSON.parse(response);
                dialogOpen(responseData);
            });
        };

        // Dialouge

        function dialogOpen(response) {
            var message = '';
            if (response.err_desc) {
                message = response.err_desc;
            } else {
                message = response.responseString;
            };
            var confirm = $mdDialog.confirm()
                .title('Upload Details')
                .htmlContent('<b>' + message + '</b>')
                .ariaLabel('delete contact')
                .ok('OK')
            $mdDialog.show(confirm).then(function() {});
        }

        function checkfile(sender) {
            var validExts = new Array(".csv");
            var fileExt = sender.value;
            fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
            if (validExts.indexOf(fileExt) == -1) {
                alert("Invalid file selected, valid files are of " +
                    validExts.toString() + " types.");
                $(sender).val("");
                return false;
            } else return true;
        }
    }
})();
(function () {
    'use strict';
  
    angular
      .module('app.subbroker', [])
      .config(config);
  
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
      var fId = 'INTERNAL::USERS::MANAGEMENT';
      // State
      $stateProvider
        .state('app.subbroker', {
          url: '/subbroker',
          views: {
            'content@app': {
              templateUrl: 'app/main/sub-broker/sub-broker.html',
              controller: 'SubBrokerController as vm'
            }
          },
          data: {
            access: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        })
      .state('app.subbroker.brokerDetail' ,{
        url : '/brokerDetail',
        views : {
            'content@app' :{
              templateUrl : 'app/main/sub-broker/brokerDetail.html',
              controller : 'BrokerDetailController as vm'
            }
        },
        data: {
          access: function () {
              if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                  return true;
              } else {
                  return false;
              }
          }
        }
      });

      msNavigationServiceProvider.saveItem('USER.subbroker', {
        title: 'Sub Broker',
        state: 'app.subbroker',
        icon: 'icon-people',
        weight: 3
    });

    }
  })();
(function () {
    'use strict';
  
    angular
      .module('app.subbroker')
      .controller('SubBrokerController', SubBrokerController);
  
    /** @ngInject */
    function SubBrokerController($window, $mdSidenav, $state, $mdToast, $mdDialog, ServiceProxy, ShareDataService) {
      var vm = this;

      function init(){
        vm.brokerDetailFunction = brokerDetailFunction
      }

      init();

      ServiceProxy.getSubBrokersData().then(successGetAllBrokerData , errorGetAllBrokerData);

      function successGetAllBrokerData(response) {
        vm.subBrokers = response.data.data;
        //console.log(vm.subBrokers);
      }

      function errorGetAllBrokerData(error) {
        console.log(error);
      }

      function successBrokerDetailData(response) {
        ShareDataService.storeData('brokerDetail', response.data.response);
        if (vm.key === 'Flag') {
          $state.go('app.subbroker');
          // vm.key = null;
        } else {
          $state.go('app.subbroker.brokerDetail');
        }      
      }

      function errorBrokerDetailData(error) {
        console.log(error)
      }

      function brokerDetailFunction(broker) {
        ServiceProxy.getBrokerProfile(broker._id).then(successBrokerDetailData , errorBrokerDetailData);
      }
    }
  })();
(function() {
    'use strict';

    angular
        .module('app.subbroker')
        .controller('BrokerDetailController', BrokerDetailController);

    /** @ngInject */
    function BrokerDetailController($scope, $state, $mdDialog, $location, $http, ShareDataService, StorageService, ServiceProxy) {
        var vm = this;
        vm.brokerDetailsMail = brokerDetailsMail;

        function init() {
            if (ShareDataService.getData('brokerDetail')) {
                vm.brokerDetail = angular.copy(ShareDataService.getData('brokerDetail'));
                if (vm.brokerDetail === null || vm.brokerDetail === undefined) {
                   // UserDetails(vm.brokerDetail._id);
                    $state.go('app.subbroker');
                } else {
                    vm.brokerDetail = vm.brokerDetail;
                    //console.log(vm.brokerDetail)
                }

            } else {
                //vm.brokerDetail = angular.copy(ShareDataService.getData('brokerDetail'));
                //console.log(vm.brokerDetail)
                //$state.go('app.subbroker.brokerDetail');

                $state.go('app.subbroker');
            }
            vm.getFile = getFile;
        };
        
        init();


        function sucessCbUserProfile(response) {
            vm.userDetail = response.data.data;
            ShareDataService.storeData('brokerDetail', response.data.data);
        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function UserDetails(id) {
            ServiceProxy.getUserProfile(id).then(sucessCbUserProfile, errorGetUserProfile)
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        function getFile(data) {
            var filename = data.replace(/^.*[\\\/]/, '');
            window.open('http://103.252.169.2:8084/api/registerbroker/downloadFile?fname=' + filename);
            //window.open('https://sipfund.com/api/registerbroker/downloadFile?fname=' + filename);
        }

        function brokerDetailsMail(brokerDetail) {
            vm.mailDetails = [];
            var data={};
            data.userName = brokerDetail.personalDetails.firstName;
            data.mobileNo = brokerDetail.personalDetails.phone;
            data.email = brokerDetail.personalDetails.email;
            data.pan = brokerDetail.accountDetails.pan;
            vm.mailDetails.push({userName:data.userName, mobileNo: data.mobileNo,email:data.email,pan:data.pan})
            ShareDataService.storeData('selectedCustomer', vm.mailDetails);
            if (vm.mailDetails) {
                $state.go('app.communication');
            }
        }

        // image upload
        $scope.processPAN = function (files) {
            alert('A');
            var fileReader = new FileReader();
            var image = new Image();
            var validExts = new Array(".jpeg", ".jpg", ".png");
            var fileExt = files[0].name;

            fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
            if (validExts.indexOf(fileExt) < 0) {
                showDialog("Invalid file selected, valid files are of " +
                    validExts.toString() + " types.");
                $(files[0]).val("");
                return false;
            };

            fileReader.onload = function (event) {
                var uri = event.target.result;
                image.src = uri;
                image.onload = function () {
                    if (files[0].file.size > 204800) {
                        showDialog("file size should not be greater than 200 KB");
                        $scope.$apply(function () {
                            $scope.imageFile.flowObj.cancel();
                            files[0] = {};
                        });
                    } else {
                        // $scope.imageFiles.flowObj=files[0];
                    }
                }
            }
            fileReader.readAsDataURL(files[0].file);
            //$scope.processFile(files)
        };

        $scope.processFile = function(files){
            var fileReader = new FileReader();
            var image = new Image();
            var validExts = new Array(".jpeg", ".jpg", ".png");
            var fileExt = files[0].name;

            fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
            if (validExts.indexOf(fileExt) < 0) {
                showDialog("Invalid file selected, valid files are of " +
                    validExts.toString() + " types.");
                $(files[0]).val("");
                return false;
            };

            fileReader.onload = function (event) {
                var uri = event.target.result;
                image.src = uri;
                image.onload = function () {
                    if (files[0].file.size > 204800) {
                        showDialog("file size should not be greater than 200 KB");
                        $scope.$apply(function () {
                            $scope.imageFile.flowObj.cancel();
                            files[0] = {};
                        });
                    } else {
                        // $scope.imageFiles.flowObj=files[0];
                    }
                }
            }
            fileReader.readAsDataURL(files[0].file);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.subbroker')
        .controller('BrokerDetailController', BrokerDetailController);

    /** @ngInject */
    function BrokerDetailController($state, $mdDialog, $location, $http, ShareDataService, StorageService, ServiceProxy,$scope) {
        var vm = this;
        vm.brokerDetailsMail = brokerDetailsMail;
        vm.brokerUploadImage = brokerUploadImage;
        vm.openEditModal = openEditModal;
        vm.closeModal = closeModal;
        vm.brokerUploadDetails = brokerUploadDetails;
        vm.imageFile = {
            flowObj: {}
        };

        function init() {
          
            if (ShareDataService.getData('brokerDetail')) {
                vm.brokerDetail = angular.copy(ShareDataService.getData('brokerDetail'));
                if (vm.brokerDetail === null || vm.brokerDetail === undefined) {
                   // UserDetails(vm.brokerDetail._id);
                    $state.go('app.subbroker');
                } else {
                    vm.brokerDetail = vm.brokerDetail;
                    //console.log(vm.brokerDetail)
                }

            } else {
                vm.brokerDetail = angular.copy(ShareDataService.getData('brokerDetail'));
                //console.log(vm.brokerDetail)
                $state.go('app.subbroker.brokerDetail');
            }
            vm.getFile = getFile;
        };
        
        init();

        function sucessCbUserProfile(response) {
            vm.userDetail = response.data.data;
            ShareDataService.storeData('brokerDetail', response.data.data);
        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function UserDetails(id) {
            ServiceProxy.getUserProfile(id).then(sucessCbUserProfile, errorGetUserProfile)
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };

        function showDialogSucc(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        }
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        function getFile(data) {
            var filename = data.replace(/^.*[\\\/]/, '');
            window.open('http://103.252.169.2:8084/api/registerbroker/downloadFile?fname=' + filename);
            //window.open('https://sipfund.com/api/registerbroker/downloadFile?fname=' + filename);
        }

        function brokerDetailsMail(brokerDetail) {
            vm.mailDetails = [];
            var data={};
            data.userName = brokerDetail.personalDetails.firstName;
            data.mobileNo = brokerDetail.personalDetails.phone;
            data.email = brokerDetail.personalDetails.email;
            data.pan = brokerDetail.accountDetails.pan;
            vm.mailDetails.push({userName:data.userName, mobileNo: data.mobileNo,email:data.email,pan:data.pan})
            ShareDataService.storeData('selectedCustomer', vm.mailDetails);
            if (vm.mailDetails) {
                $state.go('app.communication');
            }
        }

        $scope.processFile = function (files, value) {     
            var a = confirm('Do you want to upload document');
            if(a){
                if (value == "PAN") {
                    var urll = vm.brokerDetail.accountDetails.image;
                } else {
                    if (value == "AADHAAR") {
                        var urll = vm.brokerDetail.accountDetails.aadhaarImage;
                    } else {
                        if (value == "BANK") {
                            var urll = vm.brokerDetail.accountDetails.cancelCheckImage;
                        }
                    }
                }
                var fileReader = new FileReader();
                var image = new Image();
                var validExts = new Array(".jpeg", ".jpg", ".png");
                var fileExt = files[0].name;
    
                fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
                if (validExts.indexOf(fileExt) < 0) {
                    showDialog("Invalid file selected, valid files are of " +
                        validExts.toString() + " types.");
                    $(files[0]).val("");
                    return false;
                };
    
                fileReader.readAsDataURL(files[0].file);
                brokerUploadImage(files[0].file, value);
            }            
        };

        function brokerUploadImage(imgData, docType) {
            var reader = new FileReader();

            reader.onload = function (e) {
                var imageBase64Url = e.target.result;

               var data = new FormData();
                data.append("fileName", imgData.name);
                data.append("docType", docType);
                data.append("email", vm.brokerDetail.personalDetails.email);
                data.append("imageBase64Url", imageBase64Url);

                ServiceProxy.brokerUploadDocument(data).then(sucessCbBrokerUploadImage, errorCbBrokerUploadImage);
            };

            // Read file as DataURL (base64 with prefix)
            reader.readAsDataURL(imgData);
        }

       function sucessCbBrokerUploadImage(response) {
            const uploadResponse = response.data;
            
            // Check the flat structure with dot notation keys
            if (uploadResponse.updatedField["accountDetails.image"]) {
                vm.brokerDetail.accountDetails.image = uploadResponse.updatedField["accountDetails.image"];
            } else if (uploadResponse.updatedField["accountDetails.aadhaarImage"]) {
                vm.brokerDetail.accountDetails.aadhaarImage = uploadResponse.updatedField["accountDetails.aadhaarImage"];
            } else if (uploadResponse.updatedField["accountDetails.cancelCheckImage"]) {
                vm.brokerDetail.accountDetails.cancelCheckImage = uploadResponse.updatedField["accountDetails.cancelCheckImage"];
            }
                
            // Show success message
            showDialogSucc("Document uploaded successfully!").then(function() {
                location.reload();
            });
            
        }

        function errorCbBrokerUploadImage(response) {
            if (response && response.data) {
                showDialog(response.data.responseString || "Error uploading document");
            }
        }

        function openEditModal() {
            vm.editData = {
                isCompleted: vm.brokerDetail.isCompleted || true,
                personalDetails: angular.copy(vm.brokerDetail.personalDetails) || {},
                otherDetails: angular.copy(vm.brokerDetail.otherDetails) || {},
                skills: vm.brokerDetail.skills || '',
                accountDetails: angular.copy(vm.brokerDetail.accountDetails) || {}
            };

            $mdDialog.show({
                controller: function() { return vm; },
                controllerAs: 'vm',
                templateUrl: 'edit-broker-modal.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: true
            });
        }

        function closeModal() {
            $mdDialog.hide();
        }

        function brokerUploadDetails() {
            var updateData = {
                isCompleted: vm.editData.isCompleted,
                personalDetails: vm.editData.personalDetails,
                otherDetails: vm.editData.otherDetails,
                skills: vm.editData.skills,
                accountDetails: vm.editData.accountDetails
            };

            console.log("updateData", updateData);

            ServiceProxy.brokerUploadDetails(vm.brokerDetail._id, updateData).then(sucessCbBrokerUploadDetails, errorCbBrokerUploadDetails);
        }

        function sucessCbBrokerUploadDetails(response) {
            if (response && response.data) {
                showDialogSucc("Broker details updated successfully!");
                // Update the main broker detail object with new data
                vm.brokerDetail = angular.merge(vm.brokerDetail, vm.editData);
                ShareDataService.storeData('brokerDetail', vm.brokerDetail);
                closeModal();
            }
        }

        function errorCbBrokerUploadDetails(response) {
            if (response && response.data) {
                showDialog(response.data.responseString || "Error updating broker details");
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.serviceConfiguration')
        .controller('ServiceConfigurationListController', ServiceConfigurationListController);

    /** @ngInject */
    function ServiceConfigurationListController($rootScope, $state, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.allServiceConfiguration = [];
            vm.updateConfiguration = updateConfiguration;
            vm.morningStarAlert = '';
            getServiceConfiguration();
        };
        init();

        /////////////////////////get all service configuration data starts here//////////////////////////////////
        function successCbGetAllServiceConfiguration(respone) {
            vm.allServiceConfiguration = respone.data.data;
            if (vm.allServiceConfiguration.length > 0) {
                angular.forEach(vm.allServiceConfiguration, function(item) {
                    if (item.serviceName === 'MORNING_STAR_CONFIGURATION' && item.config) {
                        var expriyDate = new Date(item.config.ACCESS_EXPIARY_DATE).getTime();
                        var todayDate = new Date().getTime();
                        vm.morningStarAlert = ((expriyDate - todayDate) < (2 * 24 * 60 * 60 * 1000)) ? true : false;
                    }
                });
            }
        }

        function errorCbGetAllServiceConfiguration(respone) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getServiceConfiguration() {
            ServiceProxy.getServiceConfiguration().then(successCbGetAllServiceConfiguration, errorCbGetAllServiceConfiguration)
        }
        /////////////////////////get all service configuration data starts here/////////////////////////////////

        function updateConfiguration(serviceConfiguration) {
            var updateState = '';
        
            switch (serviceConfiguration.serviceName) {
                case 'MORNING_STAR_CONFIGURATION':
                    updateState = 'app.serviceConfiguration.updateServiceConfiguration1';
                    break;
                case 'APP_VERSION':
                    updateState = 'app.serviceConfiguration.updateServiceConfiguration2';
                    break;
                case 'WATTSAPP_MSG_FLAG':
                    updateState = 'app.serviceConfiguration.updateServiceConfiguration3';
                    break;
                default:
                    console.error('Unknown serviceName:', serviceConfiguration.serviceName);
            }
            sessionStorage.setItem('serviceName', serviceConfiguration.serviceName);
        
            $state.go(updateState, { updateId: serviceConfiguration._id });
        }
        
        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.revive-wellness-upload', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        var fId = 'INTERNAL::USERS::MANAGEMENT';

        $stateProvider
            .state('app.revive-wellness-upload', {
                url: '/revive-wellness-upload',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/revive-wellness-upload/revive-wellness-upload.html',
                        controller: 'ReviveWellnessUploadController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') ||
                            (window.sessionStorage.getItem('feature') &&
                             JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)) {
                            return true;
                        }
                        return false;
                    }
                }
            });

        msNavigationServiceProvider.saveItem('USER.revive-wellness-upload', {
            title: 'Revive Wellness Upload',
            icon: 'icon-file-excel',
            state: 'app.revive-wellness-upload',
            weight: 5
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.revive-wellness-upload')
        .controller('ReviveWellnessUploadController', ReviveWellnessUploadController);

    /** @ngInject */
    function ReviveWellnessUploadController($scope, ServiceProxy) {
        var vm = this;

        vm.selectedFile = null;
        vm.fileName     = '';
        vm.socCode      = '';
        vm.uploading    = false;
        vm.alertMsg     = '';
        vm.result       = null;
        vm.activeTab    = 'inserted';

        // ── Pagination ────────────────────────────────────────────────────────
        var PAGE_SIZE = 10;

        vm.pg = {
            inserted:   1,
            duplicates: 1,
            errors:     1
        };

        vm.getList = function (tab) {
            if (!vm.result) return [];
            if (tab === 'inserted')   return vm.result.insertedList  || [];
            if (tab === 'duplicates') return vm.result.duplicateList || [];
            if (tab === 'errors')     return vm.result.errorList     || [];
            return [];
        };

        vm.totalPages = function (tab) {
            return Math.ceil(vm.getList(tab).length / PAGE_SIZE) || 1;
        };

        vm.pageData = function (tab) {
            var start = (vm.pg[tab] - 1) * PAGE_SIZE;
            return vm.getList(tab).slice(start, start + PAGE_SIZE);
        };

        vm.goPage = function (tab, page) {
            var total = vm.totalPages(tab);
            if (page < 1 || page > total) return;
            vm.pg[tab] = page;
        };

        vm.pageRange = function (tab) {
            var total = vm.totalPages(tab);
            var cur   = vm.pg[tab];
            var start = Math.max(1, cur - 2);
            var end   = Math.min(total, start + 4);
            start     = Math.max(1, end - 4);
            var pages = [];
            for (var i = start; i <= end; i++) pages.push(i);
            return pages;
        };

        vm.showingInfo = function (tab) {
            var total = vm.getList(tab).length;
            if (total === 0) return '';
            var from = (vm.pg[tab] - 1) * PAGE_SIZE + 1;
            var to   = Math.min(vm.pg[tab] * PAGE_SIZE, total);
            return 'Showing ' + from + '–' + to + ' of ' + total;
        };

        // ── File selection ────────────────────────────────────────────────────
        vm.onFileChange = function (element) {
            var f = element.files[0];
            if (!f) return;
            if (!f.name.match(/\.xlsx$/i)) {
                vm.alertMsg = 'Please select a valid .xlsx file.';
                $scope.$apply();
                return;
            }
            vm.selectedFile = f;
            vm.fileName     = f.name + ' (' + (f.size / 1024).toFixed(1) + ' KB)';
            vm.alertMsg     = '';
            vm.result       = null;
            $scope.$apply();
        };

        // ── Upload ────────────────────────────────────────────────────────────
        vm.startUpload = function () {
            if (!vm.selectedFile) return;
            vm.uploading = true;
            vm.alertMsg  = '';
            vm.result    = null;
            vm.pg        = { inserted: 1, duplicates: 1, errors: 1 };

            var fd = new FormData();
            fd.append('excelFile', vm.selectedFile);
            if (vm.socCode && vm.socCode.trim()) {
                fd.append('SOCCODE', vm.socCode.trim().toUpperCase());
            }

            ServiceProxy.uploadWellnessData(fd).then(function (response) {
                vm.uploading = false;
                vm.result    = response.data;
                vm.activeTab = 'inserted';
                if (!response.data.validFlag) {
                    vm.alertMsg = response.data.message || 'Upload failed.';
                }
            }, function (err) {
                vm.uploading = false;
                vm.alertMsg  = 'Error: ' + (err.data && err.data.message ? err.data.message : 'Upload failed.');
            });
        };

        vm.setTab = function (tab) {
            vm.activeTab = tab;
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('app.schedular')
    .controller('SchedularController', SchedularController);

  /** @ngInject */
  function SchedularController($state, $sce, $stateParams, $mdDialog, ServiceProxy, ShareDataService) {
    var vm = this;

    function init() {
      vm.customerType = {
        1: 'Activated IIN',
        2: 'Not Active',
        3: 'No IIN',
        4: ' IIN Active But Zero Investment',
        5: ' SIP Purchased',
        6: ' All Customer',
        7: 'Custom'
      }
      vm.changeFilter = changeFilter;
      vm.editSchedular = editSchedular;
      vm.gotoSchedular = gotoSchedular;
      vm.deleteSchedularDialog = deleteSchedularDialog;
      getallSchedular();
    };
    init();

    function gotoSchedular(type) {
      $state.go('app.schedular.createschedular', {
        channel: type
      })
    }

    function sucessCbGetAllSchedular(response) {
      var cDate = new Date().getTime();
      var cHour = new Date().getHours();
      var cMinute = new Date().getMinutes();
      vm.schedulars = response.data.data;
      vm.changeFilter('EMAIL');
      vm.currentNavItem = 'EMAIL'
      // vm.pendingSchedular = [];
      // vm.completedSchedular = [];
      // angular.forEach(data, function (item) {
      //   if (item.date > cDate) {
      //     vm.pendingSchedular.push(item);
      //   } else {
      //     if (item.hour > cHour) {
      //       vm.pendingSchedular.push(item);
      //     } else if ((item.hour === cHour) && (item.minute > cMinute)) {
      //       vm.pendingSchedular.push(item);
      //     } else {
      //       vm.completedSchedular.push(item);
      //     }
      //   }
      // });
    }

    function errorCbGetAllSchedular(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try after sometime');
      }
    }

    function getallSchedular() {
      ServiceProxy.getallSchedular().then(sucessCbGetAllSchedular, errorCbGetAllSchedular)
    }

    function showDialog(response) {
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent(response)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {

      }, function () {

      });
    };

    function editSchedular(item, type) {
      if (type) {
        $state.go('app.schedular.createschedular', {
          channel: item.channel,
          id: item._id,
          type: type
        })
      } else {
        $state.go('app.schedular.createschedular', {
          channel: item.channel,
          id: item._id
        })
      }

    }

    function sucessCbDeleteSchedular(response) {
      getallSchedular();
    }

    function errorDeleteSchedular(response) {
      if (response && response.data && response.data.message) {
        showDialog(response.data.message.message);
      } else {
        showDialog('Please Try after sometime');
      }
    }

    function deleteSchedular(item) {
      ServiceProxy.deleteSchedular(item._id).then(sucessCbDeleteSchedular, errorDeleteSchedular)
    }

    function deleteSchedularDialog(item) {
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent('Do you want to delete ' + item.name + 'schedular?')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK')
        .cancel('Cancel');;
      $mdDialog.show(confirm).then(function (res) {
        if (res) {
          deleteSchedular(item);
        }
      }, function () {

      });
    };

    function changeFilter(filter) {
      vm.pendingFilter = filter
    }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('returnReportController', returnReportController);

    /** @ngInject */
    function returnReportController($state, $location,$scope, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        function init() {
           
                vm.totalInvestment = 0;
                vm.totalCurrentValue = 0;
                //declaring goal type
                vm.goalType=[];
                vm.sortedItems={};     
                vm.originalArr;
                vm.pan="";
                vm.userPan='';
                vm.csvString = 'PAN,IIN,Product ISIN, Product Key,Folio Number,AMC Name,Scheme Name,Total Units,Invested Amount,Current Value,Profit/Loss,Absolute Return (In %),Booked Profit/Loss,CAGR (In %),' + "\n";
                vm.csvStringNew = 'PAN,IIN,Product ISIN, Product Key,Folio Number,AMC Name,Scheme Name,Total Units,Invested Amount,Current Value,Profit/Loss,Absolute Return (In %),Booked Profit/Loss,CAGR (In %),' + "\n";
                vm.csvTranString = 'AMC Name,Scheme Name,PAN,IIN,Folio No,Transaction No,Transaction Date,Price/Unit,Units,Amount Invested,Transaction Nature,CAGR (in %),' + "\n";
                vm.totalValue = {};          
                          
                vm.calculateReportData = calculateReportData;
                vm.downloadReport = downloadReport;
                vm.downloadTranReport = downloadTranReport;
                vm.GenerateReportForPan = GenerateReportForPan;
                vm.GenerateReportFromArray =GenerateReportFromArray;
                vm.downloadTransactions =downloadTransactions;
                vm.totalpages ={};
                vm.AllData =[];
        };
      init();
      showTotalpages();
      function showTotalpages()
      {
        vm.numItems = StorageService.getSessionStorage('IINActiveUser');
        vm.pages = parseFloat(vm.numItems)/300;
        vm.pagesize = 300;
                for( i =0 ; i < vm.pages; i++  )
                {
                    vm.totalpages[i] = i+1;
                }
        vm.pages = i;
        // ServiceProxy.getCustmoerBySearch('ACTIVATED_IIN', 1, 500).then(
        //     function (response) {
        //         vm.numItems = response.data.total;
        //         vm.pages = response.data.pages;
        //         for( i =0 ; i < vm.pages; i++  )
        //         {
        //             vm.totalpages[i] = i+1;
        //         }
        //     }.bind(this)
        // );
      }
      function calculateReportData(pgno)
      {
            
            ServiceProxy.getCustmoerBySearch('ACTIVATED_IIN', pgno, vm.pagesize).then(
                function (response) {
                    this.numItems = response.data.total;
                    //vm.pages = response.data.pages;
                    vm.totalCustomer = response.data.total;
                    var items = response.data.data;

                    for (var i in items) {
                        vm.trxn_Data=[];
                
                        getHoldingData(items[i].pan);
                      //  this.loadedPages[pageNumber].push(items[i]);
                    }
                    //this.after = 't3_' + items[this.loadedPages[pageNumber].length - 1]._id;
                }.bind(this),
                function (error) {
                    if (error && error.data) {
                        showDialog(error.data.responseString);
                    }
                }
            );
            // vm.listofpan = ['AJPPN9997B','AHLPK2630C','BKYPM0823L','AFJPD2166A'];

            // for( i = 0; i < vm.listofpan.length; i++){
            //     vm.trxn_Data=[];
                
            //     getHoldingData(vm.listofpan[i]);
            //    // downloadSchemeList();
            // }
           // downloadReport();

           var confirm = $mdDialog.confirm()
                .title('!!Success!!')
                .textContent('Report generated')
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
      }
  function GenerateReportFromArray()
  {

    for(var i=0; i<vm.AllData.length;i++)
    {
        //console.log('value of units ' + vm.trxn_Data.responseString[i].units);
        for(var j=0; j<vm.AllData[i].length;j++)
    {
        if(parseFloat(vm.AllData[i][j].units).toFixed(2) > 0){
        vm.csvStringNew = vm.csvStringNew.concat(
        vm.AllData[i][j].trxnDetails[0].pan + "," 
        + vm.AllData[i][j].trxnDetails[0].iin + "," 
        + vm.AllData[i][j].nseSchemeDetails.productISIN + "," 
        + vm.AllData[i][j].nseSchemeDetails.productKey + "," 
        + vm.AllData[i][j].trxnDetails[0].folio_no + ","
        + vm.AllData[i][j].nseSchemeDetails.productAmcName + "," 
        + vm.AllData[i][j].scheme + "," 
        + parseFloat(vm.AllData[i][j].units).toFixed(2) + "," 
        + vm.AllData[i][j].investedAmt + ","                   
        + vm.AllData[i][j].currentValue + ","
        + vm.AllData[i][j].profitLoss + ","
        + vm.AllData[i][j].percentageProfitLoss + ","
        + vm.AllData[i][j].netProfit + ","
        + vm.AllData[i][j].cagr + ","
        );
        vm.csvStringNew = vm.csvStringNew + "\n";
        }
    }

     
    }

    var a = $('<a/>', {
        href:'data:application/octet-stream;base64,'+btoa(vm.csvStringNew),
        download:'schemelistalldata.csv'
    }).appendTo('body')
    a[0].click()
    a.remove();
   // getHoldingData(x);
  }
      
  function GenerateReportForPan(x)
  {
    vm.csvString = 'PAN,IIN,Product ISIN, Product Key,Folio Number,AMC Name,Scheme Name,Total Units,Invested Amount,Current Value,Profit/Loss,Absolute Return (In %),Booked Profit/Loss,CAGR (In %),' + "\n";
    getHoldingData(x); 
    
  }
        function downloadReport()
        {
            var a = $('<a/>', {
                href:'data:application/octet-stream;base64,'+btoa(vm.csvString),
                download:'schemelist.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
        }
        function downloadTranReport()
        {
            var a = $('<a/>', {
                href:'data:application/octet-stream;base64,'+btoa(vm.csvTranString),
                download:'transactionlist.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
        }
        function sucessCbGetHoldingData(response) {
            var amcData = StorageService.getSessionStorage("amcData");
            angular.forEach(amcData, function(amc) {
                angular.forEach(response.data.responseString, function(item) {
                    if (item.amc_code === amc.AMC_CODE) {
                        item.amcName = amc.LONG_NAME;
                    }
                })
            })
            vm.trxn_Data = response.data;

           

            angular.forEach(vm.trxn_Data.responseString, function(eachTrxn) {
                vm.totalInvestment += eachTrxn.investedAmt;
                vm.totalCurrentValue += eachTrxn.currentValue;
                vm.goalType.push(eachTrxn.trxnDetails[0].groupType)
            });
            trxnData();
            vm.originalArr = response.data.responseString
            angular.forEach(vm.originalArr , function(value, key){
                    if(value.hasOwnProperty('groupId') && value.hasOwnProperty('groupName')){
                        var INIT = value.groupName.split(" ");
                        value.newId = value.groupId + INIT[0].substring(0,1) + INIT[1].substring(0,1);
                    }
                    else if(value.hasOwnProperty('groupName') && value.groupId == "")
                    {
                        value.newId = value.groupName + 1;
                    }
                    else
                    {
                        value.newId = "ownfunds";
                    }
                })

            var groupBy = function(xs, key) {
                return xs.reduce(function(rv, x) {
                  (rv[x[key]] = rv[x[key]] || []).push(x);
                  return rv;
                }, {});
              };

            $scope.sortedItems = groupBy(vm.originalArr, 'newId'); 


             for(var i=0; i<vm.trxn_Data.responseString.length;i++)
            {
                //console.log('value of units ' + vm.trxn_Data.responseString[i].units);
                if(parseFloat(vm.trxn_Data.responseString[i].units).toFixed(2) > 0){
                vm.csvString = vm.csvString.concat(
                vm.trxn_Data.responseString[i].trxnDetails[0].pan + "," 
                + vm.trxn_Data.responseString[i].trxnDetails[0].iin + "," 
                + (vm.trxn_Data.responseString[i].nseSchemeDetails ? vm.trxn_Data.responseString[i].nseSchemeDetails.productISIN : '') + "," 
                + (vm.trxn_Data.responseString[i].nseSchemeDetails ? vm.trxn_Data.responseString[i].nseSchemeDetails.productKey : '') + "," 
                + vm.trxn_Data.responseString[i].trxnDetails[0].folio_no + ","
                //+ (vm.trxn_Data.responseString[i].nseSchemeDetails ? vm.trxn_Data.responseString[i].nseSchemeDetails.productAmcName : '') + "," 
                + vm.trxn_Data.responseString[i].amcName + "," 
                + vm.trxn_Data.responseString[i].scheme + "," 
                + parseFloat(vm.trxn_Data.responseString[i].units).toFixed(2) + "," 
                + vm.trxn_Data.responseString[i].investedAmt + ","                   
                + vm.trxn_Data.responseString[i].currentValue + ","
                + vm.trxn_Data.responseString[i].profitLoss + ","
                + vm.trxn_Data.responseString[i].percentageProfitLoss + ","
                + vm.trxn_Data.responseString[i].netProfit + ","
                + vm.trxn_Data.responseString[i].cagr + ","
                );
                vm.csvString = vm.csvString + "\n";
                }
            }

            vm.AllData.push(vm.trxn_Data.responseString);
            
        }

        function sucessCbGetHoldingTrancData(response) {   
            
            var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            var amcData = StorageService.getSessionStorage("amcData");
            angular.forEach(amcData, function(amc) {
                angular.forEach(response.data.responseString, function(item) {
                    if (item.amc_code === amc.AMC_CODE) {
                        item.amcName = amc.LONG_NAME;
                    }
                })
            })
            
            vm.trxn_Data = response.data;

            for(var i=0; i<vm.trxn_Data.responseString.length;i++)
            {
                //console.info('scheme number ' + i);
                for(var j=0; j<vm.trxn_Data.responseString[i].trxnDetails.length;j++)
                {
                    //console.info('transaction number ' + j);
                    //console.info('transaction value ' + vm.trxn_Data.responseString[i].trxnDetails[j].folio_no);

                    var d = new Date(vm.trxn_Data.responseString[i].trxnDetails[j].traddate);
                    var month = months[d.getMonth()];

                    vm.csvTranString = vm.csvTranString.concat(
                        vm.trxn_Data.responseString[i].amcName + "," 
                        + vm.trxn_Data.responseString[i].scheme + "," 
                        + vm.trxn_Data.responseString[i].trxnDetails[j].pan + ","                       
                        + vm.trxn_Data.responseString[i].trxnDetails[0].iin + "," 
                        + vm.trxn_Data.responseString[i].trxnDetails[j].folio_no + ","
                        + vm.trxn_Data.responseString[i].trxnDetails[j].trxnno + ","                   
                        //+ new Date(vm.trxn_Data.responseString[i].trxnDetails[j].traddate).toLocaleDateString() + ","
                        + d.getDate() + '-' + month + '-' + d.getFullYear() + ","
                        + vm.trxn_Data.responseString[i].trxnDetails[j].purprice + ","
                        + parseFloat(vm.trxn_Data.responseString[i].trxnDetails[j].units).toFixed(2) + ","
                        + vm.trxn_Data.responseString[i].trxnDetails[j].amount + ","
                        + vm.trxn_Data.responseString[i].trxnDetails[j].trxn_nature + ","
                        + vm.trxn_Data.responseString[i].trxnDetails[j].cagr + ","
                        );
                        vm.csvTranString = vm.csvTranString + "\n";
                }
            }
        }

        function errorCbGetHoldingData(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getHoldingData(data) {
            var postData = {
                "pan": data
            };
            vm.pan = data;
            ServiceProxy.getHoldingData(postData).then(sucessCbGetHoldingData, errorCbGetHoldingData)
        }
        function getHoldingTransactionData(data) {
            var postData = {
                "pan": data
            };
            vm.pan = data;
            ServiceProxy.getHoldingData(postData).then(sucessCbGetHoldingTrancData, errorCbGetHoldingData)
        }
        // transaction Data

        function trxnData() {
            var totalInvst = 0;
            var totalCurrent = 0;
            angular.forEach(vm.trxn_Data.responseString, function(data) {
                data.investedAmt = parseFloat(parseFloat(data.investedAmt).toFixed(2));
                data.currentValue = parseFloat(parseFloat(data.currentValue).toFixed(2));
                data.profitLoss = (data.currentValue - data.investedAmt).toFixed(2);
                data.percentageProfitLoss = ((data.profitLoss / data.investedAmt) * 100).toFixed(2) + " %";
                data.netProfit = parseFloat(parseFloat(data.netProfit).toFixed(2))
                totalInvst += data.investedAmt;
                totalCurrent += data.currentValue;
            });
            vm.totalValue.totalInvst = totalInvst;
            vm.totalValue.totalCurrent = totalCurrent;
            vm.customers = vm.trxn_Data;
        }


        function downloadTransactions() {
			

            console.log('transaction value for the customer');
            
           
            
            

            var items =['AABPZ2719E','AACPF4330Q','AAECM6862D','AAIPA9752B','AAMPD9886H','AANPR6472L','AAPPD1958D','AAQPB8268B','AAXPG5668H','AAYPI0844E','AAZPJ5853B','ABKPB1536F','ABKPW0742Q','ABLPW8711C','ABNPU1300R','ABOPL7212Q','ABOPO8116C','ACCPP7431J',
            'ACDPT2281K','ACMPB9139M','ACPPV8751Q','ACWPG0065D','ADKPV0390H','AEIPN7622M','AFGPV3397G','AFJPD2166A','AFJPD2166A','AFKPP9183N','AFSPM0332G','AFSPY0570N','AFWPL8035R','AFXPD5533M','AGGPG0235M','AGGPJ0230K','AGHPL3224G',
            'AGOPN8544J','AGQPS3682Q','AHBPN0302L','AHCPV7620C','AHEPA4792L','AHEPK6316Q','AHNPA2494A','AHWPJ7733J','AHXPM1293P','AHZPR0539B','AIGPA0464Q',
            'AIMPA8798F','AIPPM4019E','AIVPB4577E','AIWPV4400B','AJOPK3055C','AKBPK5109M','AKBPR2587E','AKKPT6419L','AKSPM3953A','AKTPG4400F'
            ,'AKVPG2277L','AKXPA1741R','ALAPS7064B','ALCPG4775B','ALJPM3027F','ALJPM7252J','AMAPN0761D','ANJPK3895R','ANPPR0019N','ANUPB6925E','ANVPD1286F',
            'AOEPG8954K','AOTPB6356D','APAPT4022L','APBPM9625B','APNPN6682D','APWPK7996N','APZPM0331G','AQKPC5955C','AQMPC2361E','AQXPV9422G','ARHPM1505G',
            'ARKPC4350Q','ARPPP3254R','ARTPR6585K','ATCPY0243Q','ATYPM9283E','AWBPC0463C','AWEPB2569F','AXGPS4234D','AXLPS6103J','AXOPP0589L','AYMPG3715E',
            'AYNPC1380N','AYWPC9114H','BAGPP5732B','BBEPS4846J','BBPPM3832D','BBWPA6357E','BCSPG0941B','BELPA4712F','BETPP9926A','BGJPK5015M','BGRPS6710B',
            'BHHPP7326M','BHKPD5511R','BIJPS9341A','BIUPS4492K','BJVPP0796B','BKGPP2047D','BKYPM0823L','BMUPM9381B','BMZPG9665F','BOBPS1602E','BOFPD8059A',
            'BPPPS7219C','BQEPD2506H','BULPD8816K','BWAPR5940P','BYBPP6450K','BYOPD9819H','CBBPB2043Q','CCMPG1582R','CEDPS6991D','CICPK3185L','CLZPM9974M',
            'CNEPK4510Q','COKPA0225D','CRIPK1361B','CRXPP0797B','CUDPD9895H','DEKPP2080E','DIGPS3926C','DRLPM0176A','DUEPS3744C','FKRPS7387J','FPNPS7447G',                
            'IYAPS9490G','JBBPS3014P'];

            for (var i in items) {
                vm.trxn_Data=[];
        
                getHoldingTransactionData(items[i]);
              //  this.loadedPages[pageNumber].push(items[i]);
           
          
        }
            // var a = $('<a/>', {
            //     href:'data:application/octet-stream;base64,'+btoa(csvString),
            //     download:'transactionlist.csv'
            // }).appendTo('body')
            // a[0].click()
            // a.remove();
		}
       
       
        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    }
})();
(function () {
    'use strict';

    angular
        .module('app.revive-pdf-manager', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        var fId = 'INTERNAL::USERS::MANAGEMENT';

        $stateProvider
            .state('app.revive-pdf-manager', {
                url: '/revive-pdf-manager',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/revive-pdf-manager/revive-pdf-manager.html',
                        controller:  'RevivePdfManagerController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') ||
                            (window.sessionStorage.getItem('feature') &&
                             JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)) {
                            return true;
                        }
                        return false;
                    }
                }
            });

        msNavigationServiceProvider.saveItem('USER.revive-pdf-manager', {
            title:  'Revive PDF Manager',
            icon:   'icon-file-pdf-box',
            state:  'app.revive-pdf-manager',
            weight: 6
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.revive-pdf-manager')
        .controller('RevivePdfManagerController', RevivePdfManagerController);

    /** @ngInject */
    function RevivePdfManagerController($scope, $timeout, ServiceProxy) {
        var vm = this;

        // ── Shared state ──────────────────────────────────────────────────────
        vm.socCode      = '';
        vm.alertMsg     = '';

        // ── Section 1: Search / Member Data ──────────────────────────────────
        vm.searching    = false;
        vm.memberResult = null;
        vm.searchPg     = 1;
        var PAGE = 10;

        vm.searchData = function () {
            if (!vm.socCode || !vm.socCode.trim()) {
                vm.alertMsg = 'Please enter a SOCCODE to search.';
                return;
            }
            vm.searching    = true;
            vm.alertMsg     = '';
            vm.memberResult = null;

            ServiceProxy.dataOnSoccode(vm.socCode.trim().toUpperCase())
                .then(function (res) {
                    vm.searching    = false;
                    vm.memberResult = res.data;
                    vm.searchPg     = 1;
                    if (!res.data.validFlag) vm.alertMsg = 'No data found for this SOCCODE.';
                }, function (err) {
                    vm.searching = false;
                    vm.alertMsg  = 'Search failed: ' + (err.data && err.data.message ? err.data.message : 'Check connection');
                });
        };

        // Pagination helpers for member table
        vm.memberPageData = function () {
            if (!vm.memberResult || !vm.memberResult.data) return [];
            var start = (vm.searchPg - 1) * PAGE;
            return vm.memberResult.data.slice(start, start + PAGE);
        };
        vm.memberTotalPages = function () {
            if (!vm.memberResult || !vm.memberResult.data) return 1;
            return Math.ceil(vm.memberResult.data.length / PAGE) || 1;
        };
        vm.memberPageRange = function () {
            var total = vm.memberTotalPages(), cur = vm.searchPg;
            var start = Math.max(1, Math.min(cur - 2, total - 4));
            var end   = Math.min(total, start + 4);
            var pages = [];
            for (var i = start; i <= end; i++) pages.push(i);
            return pages;
        };
        vm.memberGoPage = function (p) {
            if (p < 1 || p > vm.memberTotalPages()) return;
            vm.searchPg = p;
        };
        vm.memberShowingInfo = function () {
            if (!vm.memberResult || !vm.memberResult.data) return '';
            var total = vm.memberResult.data.length;
            var from  = (vm.searchPg - 1) * PAGE + 1;
            var to    = Math.min(vm.searchPg * PAGE, total);
            return 'Showing ' + from + '–' + to + ' of ' + total;
        };

        // Clear search results
        vm.clearList = function () {
            vm.memberResult = null;
            vm.searchPg     = 1;
            vm.socCode      = '';
            vm.alertMsg     = '';
        };

        // Open single PDF
        vm.openPdf = function (url) {
            if (url) window.open(url, '_blank');
        };

        // Bulk download all PDFs of a type as a ZIP via backend
        vm.zippingType = {};   // tracks which types are in-flight (disables button)
        vm.zipToasts   = [];   // floating toast notifications
        var _toastId   = 0;

        function _addToast(type, count) {
            var id    = ++_toastId;
            var label = type.charAt(0).toUpperCase() + type.slice(1);
            vm.zipToasts.push({ id: id, type: type, label: label, count: count, status: 'loading' });
            return id;
        }
        function _resolveToast(id, status) {
            vm.zipToasts.forEach(function (t) { if (t.id === id) t.status = status; });
            $timeout(function () {
                vm.zipToasts = vm.zipToasts.filter(function (t) { return t.id !== id; });
            }, 3500);
        }

        vm.downloadZip = function (type) {
            if (!vm.memberResult || !vm.memberResult.data) return;
            var items = [];
            vm.memberResult.data.forEach(function (m) {
                var url = m['insurancedoc_' + type];
                if (url) {
                    var parts = url.split('/');
                    var originalName = decodeURIComponent(parts[parts.length - 1].split('?')[0]);
                    if (!originalName || !originalName.toLowerCase().endsWith('.pdf')) {
                        originalName = (m.custId || m.mobileNo || 'file') + '_' + type + '.pdf';
                    }
                    items.push({ url: url, filename: originalName });
                }
            });
            if (!items.length) { vm.alertMsg = 'No ' + type + ' PDFs available for this SOCCODE.'; return; }

            vm.zippingType[type] = true;
            var toastId = _addToast(type, items.length);
            var socCode = vm.memberResult.SOCCODE || vm.socCode;
            var zipName = socCode + '_' + type + '_PDFs';

            ServiceProxy.downloadPdfsAsZip(items, zipName).then(function (res) {
                vm.zippingType[type] = false;
                _resolveToast(toastId, 'done');
                var blob = new Blob([res.data], { type: 'application/zip' });
                var dlUrl = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = dlUrl;
                a.download = zipName + '.zip';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(dlUrl);
            }, function () {
                vm.zippingType[type] = false;
                _resolveToast(toastId, 'error');
            });
        };

        // Download member list as Excel
        vm.downloadingExcel = false;

        vm.downloadExcel = function () {
            if (!vm.memberResult || !vm.memberResult.data || !vm.memberResult.data.length) return;
            vm.downloadingExcel = true;

            var workbook = new ExcelJS.Workbook();
            workbook.creator  = 'SIPFund Admin';
            workbook.modified = new Date();

            var sheet = workbook.addWorksheet('Members', { views: [{ state: 'frozen', ySplit: 1 }] });

            sheet.columns = [
                { header: '#',                key: 'sno',          width: 5  },
                { header: 'Cust ID',          key: 'custId',        width: 20 },
                { header: 'Name',             key: 'customerName',  width: 28 },
                { header: 'Mobile',           key: 'mobileNo',      width: 14 },
                { header: 'Password',         key: 'password',      width: 12 },
                { header: 'Society',          key: 'societyName',   width: 42 },
                { header: 'Life PDF URL',     key: 'lifeUrl',       width: 55 },
                { header: 'ACC PDF URL',      key: 'accUrl',        width: 55 },
                { header: 'Wellness PDF URL', key: 'wellnessUrl',   width: 55 },
                { header: 'Final PDF URL',    key: 'finalUrl',      width: 55 }
            ];

            // Style header row
            sheet.getRow(1).eachCell(function (cell) {
                cell.fill   = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1565C0' } };
                cell.font   = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
                cell.border = { bottom: { style: 'medium', color: { argb: 'FF0D47A1' } } };
            });

            vm.memberResult.data.forEach(function (m, i) {
                var row = sheet.addRow({
                    sno:          i + 1,
                    custId:       m.custId        || '',
                    customerName: m.customerName  || '',
                    mobileNo:     m.mobileNo      || '',
                    password:     m.password      || '',
                    societyName:  m.societyName   || '',
                    lifeUrl:      m.insurancedoc_life     || '',
                    accUrl:       m.insurancedoc_acc      || '',
                    wellnessUrl:  m.insurancedoc_wellness || '',
                    finalUrl:     m.insurancedoc_final    || ''
                });
                row.getCell('sno').alignment = { horizontal: 'center' };
                if (i % 2 === 1) {
                    row.eachCell(function (cell) {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF8FAFC' } };
                    });
                }
            });

            var socCode = vm.memberResult.SOCCODE || vm.socCode || 'members';
            workbook.xlsx.writeBuffer().then(function (buffer) {
                vm.downloadingExcel = false;
                var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var url  = window.URL.createObjectURL(blob);
                var a    = document.createElement('a');
                a.href   = url;
                a.download = socCode + '_members.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }).catch(function () {
                vm.downloadingExcel = false;
                vm.alertMsg = 'Excel export failed.';
            });
            $scope.$apply();
        };

        // ── Section 2: Upload COI PDFs ────────────────────────────────────────
        vm.coiFiles      = [];
        vm.coiFileNames  = [];
        vm.uploading     = false;
        vm.uploadResult  = null;
        vm.uploadPg      = { success: 1, skipped: 1, failed: 1 };

        vm.clearUpload = function () {
            vm.uploadResult  = null;
            vm.coiFiles      = [];
            vm.coiFileNames  = [];
            vm.uploadPg      = { success: 1, skipped: 1, failed: 1 };
            vm.alertMsg      = '';
            var inp = document.getElementById('coi-file-input');
            if (inp) inp.value = '';
        };

        vm.onCoiFileChange = function (element) {
            var files = Array.prototype.slice.call(element.files);
            var valid = files.filter(function (f) {
                return f.name.toLowerCase().endsWith('.pdf');
            });
            if (valid.length !== files.length) {
                vm.alertMsg = 'Only .pdf files are accepted. Non-PDF files were ignored.';
            }
            vm.coiFiles     = valid;
            vm.coiFileNames = valid.map(function (f) { return f.name; });
            $scope.$apply();
        };

        vm.uploadCoiPdfs = function () {
            if (!vm.coiFiles.length) return;
            vm.uploading    = true;
            vm.uploadResult = null;
            vm.alertMsg     = '';

            var fd = new FormData();
            vm.coiFiles.forEach(function (f) { fd.append('pdfFiles', f); });

            ServiceProxy.uploadCoiPdfs(fd).then(function (res) {
                vm.uploading    = false;
                vm.uploadResult = res.data;
                vm.uploadPg     = { success: 1, skipped: 1, failed: 1 };
            }, function (err) {
                vm.uploading = false;
                vm.alertMsg  = 'Upload failed: ' + (err.data && err.data.message ? err.data.message : 'Server error');
            });
        };

        // Upload list pagination
        vm.uploadListPage = function (list, tab) {
            if (!list) return [];
            var p = vm.uploadPg[tab];
            return list.slice((p - 1) * PAGE, p * PAGE);
        };
        vm.uploadTotalPages = function (list, tab) {
            if (!list || list.length === 0) return 1;
            return Math.ceil(list.length / PAGE);
        };
        vm.uploadGoPage = function (tab, p) {
            var list = tab === 'success' ? (vm.uploadResult.successFileNames || []) :
                       tab === 'skipped' ? (vm.uploadResult.skippedFileNames || []) :
                       (vm.uploadResult.failedFileDetails || []);
            var total = vm.uploadTotalPages(list, tab);
            if (p < 1 || p > total) return;
            vm.uploadPg[tab] = p;
        };

        // ── Section 3: Generate Wellness PDF ─────────────────────────────────
        vm.wellnessSocCode    = '';
        vm.generatingWellness = false;
        vm.wellnessResult     = null;

        vm.wellnessPg = 1;

        vm.wellnessPageData = function () {
            if (!vm.wellnessResult || !vm.wellnessResult.results) return [];
            return vm.wellnessResult.results.slice((vm.wellnessPg - 1) * PAGE, vm.wellnessPg * PAGE);
        };
        vm.wellnessTotalPages = function () {
            if (!vm.wellnessResult || !vm.wellnessResult.results) return 1;
            return Math.ceil(vm.wellnessResult.results.length / PAGE) || 1;
        };
        vm.wellnessGoPage = function (p) {
            if (p < 1 || p > vm.wellnessTotalPages()) return;
            vm.wellnessPg = p;
        };

        vm.clearWellness = function () {
            vm.wellnessResult  = null;
            vm.wellnessSocCode = '';
            vm.wellnessPg      = 1;
            vm.alertMsg        = '';
        };

        vm.generateWellness = function () {
            if (!vm.wellnessSocCode.trim()) { vm.alertMsg = 'Enter SOCCODE for Wellness PDF.'; return; }
            vm.generatingWellness = true;
            vm.wellnessResult     = null;
            vm.alertMsg           = '';

            ServiceProxy.generateWellnessPdf(vm.wellnessSocCode.trim().toUpperCase())
                .then(function (res) {
                    vm.generatingWellness = false;
                    vm.wellnessResult     = res.data;
                    vm.wellnessPg         = 1;
                }, function (err) {
                    vm.generatingWellness = false;
                    vm.alertMsg = 'Wellness PDF error: ' + (err.data && err.data.message ? err.data.message : 'Server error');
                });
        };

        // ── Section 4: Generate Merge PDF ────────────────────────────────────
        vm.mergeSocCode    = '';
        vm.generatingMerge = false;
        vm.mergeResult     = null;

        vm.mergePg = 1;

        vm.mergePageData = function () {
            if (!vm.mergeResult || !vm.mergeResult.results) return [];
            return vm.mergeResult.results.slice((vm.mergePg - 1) * PAGE, vm.mergePg * PAGE);
        };
        vm.mergeTotalPages = function () {
            if (!vm.mergeResult || !vm.mergeResult.results) return 1;
            return Math.ceil(vm.mergeResult.results.length / PAGE) || 1;
        };
        vm.mergeGoPage = function (p) {
            if (p < 1 || p > vm.mergeTotalPages()) return;
            vm.mergePg = p;
        };

        vm.clearMerge = function () {
            vm.mergeResult  = null;
            vm.mergeSocCode = '';
            vm.mergePg      = 1;
            vm.alertMsg     = '';
        };

        vm.generateMerge = function () {
            if (!vm.mergeSocCode.trim()) { vm.alertMsg = 'Enter SOCCODE for Merge PDF.'; return; }
            vm.generatingMerge = true;
            vm.mergeResult     = null;
            vm.alertMsg        = '';

            ServiceProxy.generateMergePdf(vm.mergeSocCode.trim().toUpperCase())
                .then(function (res) {
                    vm.generatingMerge = false;
                    vm.mergeResult     = res.data;
                    vm.mergePg         = 1;
                }, function (err) {
                    vm.generatingMerge = false;
                    vm.alertMsg = 'Merge PDF error: ' + (err.data && err.data.message ? err.data.message : 'Server error');
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.pushNotification')
        .controller('PushNotificationListController', PushNotificationListController);

    /** @ngInject */
    function PushNotificationListController($rootScope, $mdDialog, $state, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            ShareDataService.storeData('customerDetail', '');
            vm.selected = [];
            vm.currentNavItem = 'All';

            vm.getAllUser = getAllUser;
            getAllUser();
            vm.customerCount = customerCount;
            vm.sendMessage = sendMessage;
            vm.selectedCustomersArray = [];
            vm.selectEntity = selectEntity;
        };
        init();


        ///////////////////////////get all customer details starts here//////////////////////////
        function sucessCbGetAllUser(response) {
            vm.customers = response.data.data;
            vm.allCustomersFull = angular.copy(response.data.data);
        }

        function errorCbGetAllUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllUser() {
            ServiceProxy.getAllCustomerWithDeviceId().then(sucessCbGetAllUser, errorCbGetAllUser);

        }
        ///////////////////////////get all customer details starts here//////////////////////////

        ///////////////////////////////////////////////////select checkbox funcationality here/////////////////////////////////////////////

        function selectEntity(customer) {
            if (customer.isChecked) {
                vm.selectedCustomersArray.push(customer);
            } else {
                var index = vm.selectedCustomersArray.findIndex(function(item) {
                    return item.userId === customer.userId;
                })
                vm.selectedCustomersArray.splice(index, 1);
            }
        };

        ////////////////////////////////////////////////ends checkbox funcationality here///////////////////////////

        /////////////////////////////customer count data starts here///////////////////////////////

        function sendMessage() {
            var selectedCustomer = [];
            angular.forEach(vm.customers, function(obj) {
                if (obj.isChecked) {
                    selectedCustomer.push(obj);
                }
            });
            ShareDataService.storeData('selectedCustomerPushNotification', selectedCustomer);
            $state.go('app.pushNotificationList');
        };



        function customerCount() {

            vm.selectedCustomersArray = [];
            if (!vm.selectedFlag) {
                vm.selectedFlag = 'ALL';
                angular.forEach(vm.customers, function(obj) {
                    obj.isChecked = true;
                    vm.selectedCustomersArray.push(obj);
                });
            } else {
                vm.selectedFlag = null;
                angular.forEach(vm.customers, function(obj) {
                    obj.isChecked = false;
                });
                vm.selectedCustomersArray = [];
            }
        }
        //////////////////////////////////ends the customer counts here////////////////////////////////////

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.recommendatePortFolio', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, $mdThemingProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'RECOMMENDED::SCHEMES';
        // State
        $stateProvider
            .state('app.recommendatePortFolio', {
                url: '/recommendatePortFolio',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/recommendatePortFolio/recommendatePortFolio.html',
                        controller: 'RecommendatePortFolioController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.recommendatePortFolio.addNewRecommendatePortFolio', {
                url: '/addNewRecommendatePortFolio/:recommendationID',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/recommendatePortFolio/addNewRecommendedPortFolio.html',
                        controller: 'AddNewRecommendatePortFolioController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })

        msNavigationServiceProvider.saveItem('WEBSITE.recommendatePortFolio', {
            title: 'Recommended Portfolio',
            icon: 'icon-tile-four',
            state: 'app.recommendatePortFolio',
            weight: 2
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.recommendatePortFolio')
        .controller('RecommendatePortFolioController', RecommendatePortFolioController);

    /** @ngInject */
    function RecommendatePortFolioController($timeout, $q, $state, $stateParams, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        function init() {
            vm.recommendedAllPortFolioSchemes = [];
            vm.editRecommendation = editRecommendation;
            vm.showDeleteDialog = showDeleteDialog;
            getAllRecommendedPortfolio();
        };
        init();


        /////////////////get all recommendation port folio starts here////////////////////////////////////
        function sucessCbGetAllRecommendation(response) {
            vm.recommendedAllPortFolioSchemes = response.data.responseString;
            angular.forEach(vm.recommendedAllPortFolioSchemes, function(item) {
                item.totalInvestment = 0;
                angular.forEach(item.schemeDetails, function(schmObj) {
                    item.totalInvestment += schmObj.amount;
                })
            })
        }

        function errorCbGetAllRecommendation(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllRecommendedPortfolio() {
            ServiceProxy.getAllRecommendedPortfolio().then(sucessCbGetAllRecommendation, errorCbGetAllRecommendation);
        }

        function editRecommendation(allSchemes) {
            ShareDataService.storeData('recommendation', allSchemes);
            $state.go('app.recommendatePortFolio.addNewRecommendatePortFolio', { recommendationID: allSchemes._id });
        }
        /////////////////get all recommendation port folio ends here////////////////////////////////////

        /////////////////delete recommendation port folio starts here////////////////////////////////////
        function showDeleteDialog(scheme) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete selected PortFolio?')
                .textContent(scheme.portFolioName)
                .ariaLabel('Lucky day')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                deleteRecommendedPortfolio(scheme);
            }, function() {

            });
        }

        function sucessCbDeleteRecommendation(response) {
            getAllRecommendedPortfolio();
        }

        function errorCbDeleteRecommendation(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function deleteRecommendedPortfolio(scheme) {
            ServiceProxy.deleteRecommendedPortfolio(scheme._id).then(sucessCbDeleteRecommendation, errorCbDeleteRecommendation)
        }
        /////////////////delete recommendation port folio ends here////////////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.recommendatePortFolio')
        .controller('AddNewRecommendatePortFolioController', AddNewRecommendatePortFolioController);

    /** @ngInject */
    function AddNewRecommendatePortFolioController($timeout, $q, $state, $stateParams, $mdDialog, $mdToast, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        function init() {
            vm.recommendation = {};
            vm.recommendation.schemeType = 'SIP';
            vm.recommendation.schemeDetail = {};
            vm.master = angular.copy(vm.recommendation.schemeDetail);
            vm.allSchemes = [];
            vm.getMatches = getMatches;
            vm.addSchemes = addSchemes;
            vm.deletScheme = deletScheme;
            // vm.edit = edit;
            vm.selectedSchemsIdArray = [];
            vm.showDeleteDialog = showDeleteDialog;
            // vm.validateformPlusIcon = validateformPlusIcon;
            vm.getSchemeMatches = getSchemeMatches;
            vm.createRecommendation = createRecommendation;
            vm.getAllScheme = getAllScheme;
            vm.amcs = StorageService.getSessionStorage("amcData");
            if ($stateParams.recommendationID != '' && ShareDataService.getData('recommendation')) {
                vm.recommendation = ShareDataService.getData('recommendation');

                showRecommendedData(vm.recommendation.schemeDetails);
            } else {
                $stateParams.recommendationID = '';
            }
            vm.chooseMode = chooseMode;

        }
        init();

        function getMatches(searchText) {
            var result = vm.amcs;
            var deferred;

            if (searchText) {
                deferred = $q.defer();

                $timeout(function() {
                    var states = vm.amcs.filter(function(state) {
                        return (state.LONG_NAME.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.AMC_CODE.toUpperCase().indexOf(searchText.toUpperCase()) !== -1);
                    });
                    deferred.resolve(states);
                }, 1500);

                return deferred.promise;
            } else {
                return result;
            }

        }

        function addSchemes() {
            if (vm.selectedSchemsIdArray.indexOf(vm.recommendation.schemeDetail.scheme.PRODUCT_CODE) === -1) {
                vm.selectedSchemsIdArray.push(vm.recommendation.schemeDetail.scheme.PRODUCT_CODE);
                vm.allSchemes.push(angular.copy(vm.recommendation.schemeDetail));
                vm.recommendation.schemeDetail = {};
                vm.wizardStep1.$setUntouched();
            } else {
                showDialog('Selected Scheme is already added.')
            }


        }

        function deletScheme(index) {
            vm.recommendation.allSchemes.splice(index, 1);
        }

        // function to get schems amc wise

        function sucessCbGetAllScheme(response) {

            vm.newSchemsArray = [];
            // vm.schemes = response.data.Data.product_master;
            angular.forEach(response.data.Data.product_master, function(scheme) {
                    if (scheme.ISIN || (scheme.ISIN !== '')) {
                        vm.schemes.push(scheme);
                        vm.newSchemsArray.push(scheme)
                    }
                })
                // vm.newSchemsArray = response.data.Data.product_master;

            chooseMode();
            if ($stateParams.recommendationID) {
                angular.forEach(vm.schemes, function(schmObj) {
                    if (schmObj.PRODUCT_CODE == vm.recommendation.productCode) {
                        vm.recommendation.scheme = schmObj;
                        return;
                    }
                });
            }
        };

        function errorCbGetAllScheme(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        };

        function getAllScheme(amc) {
            if (!amc) return;
            // if (!vm.recommendation.schemeType) return alert("Select Mode");
            vm.recommendation.schemeDetail.scheme = '';
            vm.schemes = [];
            ServiceProxy.getAllScheme(amc.AMC_CODE).then(sucessCbGetAllScheme, errorCbGetAllScheme);
        };

        // scheme matches

        function getSchemeMatches(searchText) {

            var deferred = $q.defer();

            $timeout(function() {
                var states = vm.schemes.filter(function(state) {
                    return (state.productDisplayName.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.PRODUCT_CODE.toUpperCase().indexOf(searchText.toUpperCase()) !== -1);
                });
                deferred.resolve(states);
            }, 1500);

            return deferred.promise;

        }

        function sucessCbCreateRecommendation(response) {
            $state.go('app.recommendatePortFolio');
        }

        function errorCbCreateRecommendation(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function createRecommendation() {
            var postData = {
                "portFolioName": vm.recommendation.portFolioName,
                "schemeType": vm.recommendation.schemeType,
                "description": vm.recommendation.description,
                "schemeDetails": []
            }
            angular.forEach(vm.allSchemes, function(item) {
                if (item.scheme.morningstarRating || item.scheme.crisilRating || item.scheme.valueResearchRating) {
                    var tempObj = {
                        "productKey": item.scheme.productKey,
                        "productISIN": item.scheme.ISIN || item.scheme.productISIN,
                        "trxn_nature": 'S',
                        "amc": item.amc.AMC_CODE,
                        "amc_name": item.amc.LONG_NAME,
                        "product_code": item.scheme.PRODUCT_CODE || item.scheme.product_code,
                        "product_name": item.scheme.productDisplayName || item.scheme.product_name,//item.scheme.PRODUCT_LONG_NAME || item.scheme.product_name,
                        "amount": item.amount,
                        "reinvest": item.scheme.REINVEST_TAG || item.scheme.reinvest,
                        "sip_dates": item.scheme.SIP_DATES || item.scheme.sip_dates,
                        "morningstarRating": item.scheme.morningstarRating,
                        "crisilRating": item.scheme.crisilRating,
                        "valueResearchRating": item.scheme.valueResearchRating
                    }
                } else {
                    var tempObj = {
                        "productKey": item.scheme.productKey,
                        "productISIN": item.scheme.ISIN || item.scheme.productISIN,
                        "trxn_nature": 'S',
                        "amc": item.amc.AMC_CODE,
                        "amc_name": item.amc.LONG_NAME,
                        "product_code": item.scheme.PRODUCT_CODE || item.scheme.product_code,
                        "product_name": item.scheme.productDisplayName || item.scheme.product_name, // item.scheme.PRODUCT_LONG_NAME || item.scheme.product_name,
                        "amount": item.amount,
                        "reinvest": item.scheme.REINVEST_TAG || item.scheme.reinvest,
                        "sip_dates": item.scheme.SIP_DATES || item.scheme.sip_dates,
                        "morningstarRating": item.morningstarRating,
                        "crisilRating": item.crisilRating,
                        "valueResearchRating": item.valueResearchRating
                    }
                }

                postData.schemeDetails.push(tempObj);
            })
            if (vm.recommendation._id) {
                postData._id = vm.recommendation._id;
                ServiceProxy.updateRecommendedPortfolio(postData).then(sucessCbCreateRecommendation, errorCbCreateRecommendation);
            } else {
                ServiceProxy.createRecommendedPortfolio(postData).then(sucessCbCreateRecommendation, errorCbCreateRecommendation);
            }

        }

        function chooseMode() {
            if (!vm.schemes) return;
            vm.recommendation.schemeDetail.scheme = '';
            var tempArray = [];


            if (vm.recommendation.schemeType === 'SIP') {
                angular.forEach(vm.newSchemsArray, function(item) {

                    if (item.PRODUCT_CATEGORY !== 'CE' && item.SIP_ALLOWED !== 'N' && item.SIP_DATES && item.SYSTEMATIC_FREQUENCIES && item.SYSTEMATIC_FREQUENCIES !== "-") {
                        tempArray.push(item);
                    }
                });
            } else {
                angular.forEach(vm.newSchemsArray, function(item) {
                    if (item.PRODUCT_CATEGORY !== 'CE') {
                        tempArray.push(item);
                    }
                })
            }
            vm.schemes = tempArray;
            var temptype = [];
            angular.forEach(vm.schemes, function(item) {
                if (temptype.indexOf(item.SIP_ALLOWED) === -1) {
                    temptype.push(item.SIP_ALLOWED);
                }
            })
        }

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {
                // $scope.status = 'You decided to get rid of your debt.';
            }, function() {
                // $scope.status = 'You decided to keep your debt.';
            });
        };

        function showRecommendedData(data) {
            angular.forEach(data, function(item) {
                vm.selectedSchemsIdArray.push(item.product_code);
                var getAmc = function() {
                    for (var i = 0; i < vm.amcs.length; i++) {
                        if (vm.amcs[i].LONG_NAME === item.amc_name) {
                            return vm.amcs[i];
                        }
                    }
                };

                var tempObj = {
                    amc: getAmc(),
                    scheme: item,
                    amount: item.amount
                };
                // tempObj.scheme = getTempScheme(tempObj.amc.AMC_CODE);
                vm.allSchemes.push(tempObj);
            })
        }

        function deletScheme(index) {
            vm.allSchemes.splice(index, 1);
        }




        ///////////////////////////////////////starts delete scheme here//////////////////////////////////////////////

        function showDeleteDialog(scheme, portfoLio, index) {
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete selected Scheme?')
                .textContent(scheme.scheme.product_name)
                .ariaLabel('Lucky day')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                deleteRecommendedPortfolioScheme(scheme, portfoLio, index);
            }, function() {

            });
        }

        function deleteRecommendedPortfolioScheme(scheme, portFolio, index) {
            if (vm.allSchemes.length > 1) {
                ServiceProxy.deleteRecommendedPortfolioScheme(portFolio._id, scheme.scheme._id).then(sucessCbDeleteRecommendationScheme, errorCbDeleteRecommendationScheme)
            } else {
                $mdToast.show({
                    template: '<h2 style="color:rgb(3,155,229);"><b>Minimum one scheme can be not deleted !</b></h2>',
                    hideDelay: 5000,
                    position: 'top right',
                    parent: '#content'
                });
            }

            function sucessCbDeleteRecommendationScheme(response) {
                vm.allSchemes.splice(index, 1);
            }

            function errorCbDeleteRecommendationScheme(response) {
                if (response && response.data && response.data.data) {
                    showDialog(response.data.responseString);
                }
            }

        }

        ///////////////////////////////////////Ends delete scheme here//////////////////////////////////////////////

    }
})();
(function () {
    'use strict';

    angular
        .module('app.recommendations', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, $mdThemingProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'RECOMMENDED::SCHEMES';
        // State
        $mdThemingProvider.theme('dark-orange').backgroundPalette('orange').dark();
        $mdThemingProvider.theme('dark-grey').backgroundPalette('grey').dark();
        $mdThemingProvider.theme('dark-blue').backgroundPalette('blue').dark();
        $stateProvider
            .state('app.recommendations', {
                url: '/recommendations',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/recommendations/recommendations.html',
                        controller: 'RecommendationsController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            })
            .state('app.createNewRecommendations', {
                url: '/createNewRecommendations/:recommendationID',
                views: {
                    'content@app': {
                        // templateUrl: 'app/main/recommendations/createNewRecommendation.html',
                        templateUrl: 'app/main/recommendations/createRecommendedschemes.html',
                        controller: 'CreateNewRecommendationsController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            });

        // Translation

        msNavigationServiceProvider.saveItem('WEBSITE.recommendations', {
            title: 'Recommended Scheme',
            icon: 'icon-tile-four',
            state: 'app.recommendations',
            weight: 1
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.recommendations')
        .controller('RecommendationsController', RecommendationsController);

    /** @ngInject */
    function RecommendationsController($state, $mdDialog, ShareDataService, ServiceProxy) {
        var vm = this;

        function init() {
            vm.editRecommendation = editRecommendation;
            vm.showDeleteDialog = showDeleteDialog;
            getAllRecommendation();
        };
        init();

        function sucessCbGetAllRecommendation(response) {
            vm.recommendedSchemes = response.data.responseString;
        }

        function errorCbGetAllRecommendation(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllRecommendation() {
            ServiceProxy.getAllRecommendation().then(sucessCbGetAllRecommendation, errorCbGetAllRecommendation);
        }
        // Edit Recommendation Function Start

        function editRecommendation(scheme) {
            ShareDataService.storeData('recommendation', scheme);
            $state.go('app.createNewRecommendations', { recommendationID: scheme._id });
        }
        // Edit Recommendation Function End

        // Data
        // vm.helloText = SampleData.data.helloText;


        // API Call To Delete Recommendation Start
        function showDeleteDialog(scheme) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete selected Category?')
                .textContent('Scheme name is ' + scheme.productName)
                .ariaLabel('Lucky day')
                .ok('Delete')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                deleteRecommendation(scheme);
            }, function() {
                // $scope.status = 'You decided to keep your debt.';
            });
        }

        function sucessCbDeleteRecommendation(response) {
            getAllRecommendation();
        }

        function errorCbDeleteRecommendation(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function deleteRecommendation(scheme) {
            var postData = {
                "productKey": scheme.productKey,
                "productAmcCode": scheme.productAmcCode,
                "productCode": scheme.productCode,
                "productISIN": scheme.productISIN,
                "priority": scheme.priority
            };
            var isin = scheme.productISIN;
            ServiceProxy.deleteRecommendation(postData, isin).then(sucessCbDeleteRecommendation, errorCbDeleteRecommendation)
        }
        // API Call To Delete Recommendation End

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
    }
})();
(function() {
    'use strict';

    angular
        .module('app.recommendations')
        .controller('CreateNewRecommendationsController', CreateNewRecommendationsController);

    /** @ngInject */
    function CreateNewRecommendationsController($timeout, $q, $state, $stateParams, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        function init() {
            vm.recommendation = {};
            // vm.selectSubCategory =selectSubCategory ;
            vm.getMatches = getMatches;
            vm.validateform = validateform;
            vm.getSchemeMatches = getSchemeMatches;
            vm.createRecommendation = createRecommendation;
            vm.getAllScheme = getAllScheme;
            vm.customCatagories = ['EQUITY', 'DEBT', 'HYBRID', 'TAX SAVER', 'NFO'];
            vm.amcs = StorageService.getSessionStorage("amcData");
            if ($stateParams.recommendationID != '' && ShareDataService.getData('recommendation')) {
                vm.recommendation = ShareDataService.getData('recommendation');
                // vm.subCategoryList =vm.recommendation.subCategoryList;
                // vm.schemes =vm.recommendation.schemes;
                showRecommendedData(vm.recommendation);

            } else {
                $stateParams.recommendationID = '';

            }
        };
        init();


        // Get All Scheme API Call Start
        function sucessCbGetAllScheme(response) {

            vm.schemes = response.data.Data.product_master;
            if ($stateParams.recommendationID) {
                angular.forEach(vm.schemes, function(schmObj) {
                    if (schmObj.PRODUCT_CODE == vm.recommendation.productCode) {
                        vm.recommendation.scheme = schmObj;
                        return;
                    }
                });
            }
        };

        function errorCbGetAllScheme(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        };

        function getAllScheme(amc) {

            vm.recommendation.scheme = '';
            vm.schemes = [];

            ServiceProxy.getAllScheme(amc.AMC_CODE).then(sucessCbGetAllScheme, errorCbGetAllScheme);
        };
        // Get All Scheme API Call End

        //function to show Recommended Scheme to update Start
        function showRecommendedData(data) {

            angular.forEach(vm.amcs, function(amcObj) {
                if (amcObj.AMC_CODE == data.productAmcCode) {
                    vm.recommendation.amc = amcObj;
                    return;
                }
            });
            getAllScheme(vm.recommendation.amc);
        }


        function sucessCbCreateRecommendation(response) {
            $state.go('app.recommendations');
        }

        function errorCbCreateRecommendation(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function createRecommendation() {

            var postData = {
                "productKey": vm.recommendation.scheme.productKey,
                "productISIN": vm.recommendation.scheme.ISIN,
                "productAmcCode": vm.recommendation.amc.AMC_CODE,
                "productAmcName": vm.recommendation.amc.LONG_NAME,
                "productCode": vm.recommendation.scheme.PRODUCT_CODE,
                "productName":  vm.recommendation.scheme.productDisplayName, //vm.recommendation.scheme.PRODUCT_LONG_NAME,
                "productMSCategory": vm.recommendation.scheme.productMSCategory,
                "description": vm.recommendation.description,
                "reinvest": vm.recommendation.scheme.REINVEST_TAG,
                "amount": vm.recommendation.amount ? vm.recommendation.amount : 1000,
                "productCustomCategory": vm.recommendation.productCustomCategory,
                "morningstarRating": vm.recommendation.morningstarRating,
                "crisilRating": vm.recommendation.crisilRating,
                "valueResearchRating": vm.recommendation.valueResearchRating,
                "customCategoryTab": vm.recommendation.customCategoryTab
                    // "priority":vm.recommendation.priority
            };
            if (vm.recommendation._id) {
                postData._id = vm.recommendation._id;
                ServiceProxy.updateRecommendation(postData).then(sucessCbCreateRecommendation, errorCbCreateRecommendation);
            } else {
                // postData.productAmcName = vm.recommendation.amc.LONG_NAME;
                // postData.productName = vm.recommendation.scheme.PRODUCT_LONG_NAME;
                ServiceProxy.createRecommendation(postData).then(sucessCbCreateRecommendation, errorCbCreateRecommendation);
            }

        }
        // function to create recommendation End

        //////////
        // error msg for image
        function showDialog(response) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {
                // $scope.status = 'You decided to get rid of your debt.';
            }, function() {
                // $scope.status = 'You decided to keep your debt.';
            });
        };

        // querySearchAmc Start
        // function querySearchAmc(searchtext) {
        //
        // }
        function getMatches(searchText) {
            var result = vm.amcs;
            var deferred;

            if (searchText) {
                deferred = $q.defer();

                $timeout(function() {
                    var states = vm.amcs.filter(function(state) {
                        return (state.LONG_NAME.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.AMC_CODE.toUpperCase().indexOf(searchText.toUpperCase()) !== -1);
                    });
                    deferred.resolve(states);
                }, 1500);

                return deferred.promise;
            } else {
                return result;
            }

        }

        function getSchemeMatches(searchText) {
            //

            var deferred = $q.defer();

            $timeout(function() {
                var states = vm.schemes.filter(function(state) {
                    return ((state.productDisplayName.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.PRODUCT_CODE.toUpperCase().indexOf(searchText.toUpperCase()) !== -1) && state.PURCHASE_ALLOWED === "Y");
                });
                deferred.resolve(states);
            }, 1500);

            return deferred.promise;

        }
        // querySearchAmc End
        // form validation
        function validateform() {
            return !(vm.recommendation.amc && vm.recommendation.scheme)

        }
    }
})();
(function() {
	'use strict';

	angular.module('app.products').controller('ProductsController', ProductsController);

	function ProductsController($scope, $state, $mdDialog, ServiceProxy, ShareDataService) {
		var vm = this;
		vm.allAmcData = [];
		vm.amcCode = '';

		function init() {
			getAllAmc();
		}
		init();

		////////////////////////////////// Get All AMc API Call Start////////////////////////////////////////////////
		function sucessCbGetAllAmc(response) {
			vm.allAmcData = response.data.data;
			vm.baseUrl = response.data.baseUrl;
			// vm.totalAmcData = response.data.data.amc_master.length;
		}

		function errorCbGetAllAmc(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAllAmc() {
			ServiceProxy.getAllAmcProducts().then(sucessCbGetAllAmc, errorCbGetAllAmc);
		}
		//////////////////////////////////////// Get All AMc API Call End/////////////////////////////////////////////

		////////////////////////////////////////image upload starts here//////////////////////////////////////////////
		function sucessUploadAmcmage(response) {
			// vm.baseUrl = response.data.baseUrl;
			getAllAmc();
		}

		function errorUploadAmcImage(response) {
			if (response && response.data) {
				showDialog(response.data.message);
			}
		}

		vm.uploadImageAmc = function(data) {
			vm.amcCode = data.amcCode;
			var link = document.getElementById('file-input');
			link.click.call(link);
		};

		$scope.fileNameChanged = function(ev) {
			var data = new FormData();
			data.append('image', ev.files[0]);
			ServiceProxy.uploadImageAmcProducts(data, vm.amcCode).then(sucessUploadAmcmage, errorUploadAmcImage);
		};

		/////////////////////////////////////////////image upload ends here//////////////////////////////////////////////

		//////////////////////////////////////////go to product list page starts here///////////////////////////////////
		vm.showScheme = function(amc) {
			// ShareDataService.storeData('selected_product_amc', amc.LONG_NAME);
			$state.go('app.productsList', {
				productsListID: amc.amcCode,
				amc: amc.longName,
				newAmcCode: amc.newAmcCode
			});
		};
		//////////////////////////////////////////go to product list page ends here/////////////////////////////////////

		///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function() {});
		}
		///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
	}
})();

(function() {
	'use strict';

	angular
		.module('app.offices', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.offices', {
				url: '/offices',
				views: {
					'content@app': {
						templateUrl: 'app/main/offices/office-chart.html',
						controller: 'officesController as vm'
					}
				}
			})
			.state('app.officeadd', {
				url: '/officesadd',
				views: {
					'content@app': {
						templateUrl: 'app/main/offices/offices.html',
						controller: 'officesController as vm'
					}
				}
			})
			.state('app.editofc', {
				url: '/offices/editofc/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/offices/editofc.html',
						controller: 'officesController as vm'
					}
				}
			});

		msNavigationServiceProvider.saveItem('CONFIGURATION.offices', {
			title: 'Offices',
			icon: 'icon-tile-four',
			state: 'app.offices',
			weight: 3
		});
	}
})();

(function () {
  'use strict';

  angular
    .module('app.offices')
    .controller('officesController', officesController);

  /** @ngInject */
  function officesController($window, $state, $scope, $mdToast, $mdDialog, $q, $timeout, ServiceProxy, $stateParams, StorageService) {
    var vm = this;
    var postData = {};
    vm.submitofficeinfo = submitofficeinfo;
    vm.fetchstate = fetchstate;
    vm.assignstate = assignstate;
    vm.removestate = removestate;
    vm.city_acc_state = city_acc_state;
    vm.fetchoffice = fetchoffice;
    vm.deleteoffice = deleteoffice;
    vm.editofc = editofc;
    vm.updateofficeinfo = updateofficeinfo;
    vm.citydata = citydata;

    function fetchstate() {
      ServiceProxy.fetchstate({}).then(function (response, err) {
        if (response.data.validFlag == true) {
          vm.statedata = response.data.data;
        }
      });
    }

    vm.states = [];
    function assignstate(name) {
      var stateName = name.stateName;
      var stateCode = name.stateCode;
      var state = stateCode + "::" + stateName;
      var indexxx = vm.states.indexOf(state);
      if (indexxx == -1) {
        vm.states.push(state);
      }
    }

    function removestate(indexxx) {
      vm.states.splice(indexxx, 1);
    }

    function submitofficeinfo() {
      var multiple = [];
      if (vm.states.length !== 0) {
        for (var i = 0; i < vm.states.length; i++) {
          multiple.push(vm.states[i])
        }
      }
      
      vm.office.multistate = multiple;
      ServiceProxy.submitofficeinfo(vm.office).then(function (response, err) {
        if (response.data.validFlag == true) {
          alert(response.data.responseString)
          vm.office = undefined;
          vm.states = undefined;
          $state.go("app.offices")
        } else {
          if (response.data.validFlag == false) {
            alert(response.data.responseString)
          }
        }
      });
    }

    function city_acc_state(state) {
      var state = state;
      ServiceProxy.city_acc_state({ state: state }).then(function (response, err) {
        vm.distdata = response.data.data;

      })
    }

    function citydata(searchText) {
      var result = vm.distdata;
      var deferred;
      if (searchText) {
        deferred = $q.defer();

        $timeout(function () {
          var states = vm.distdata.filter(function (state) {
            return (state ? state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 : null);
          });
          deferred.resolve(states);
        }, 1500);

        return deferred.promise;
      } else {
        return result;
      }
    }

    function fetchoffice() {
      ServiceProxy.fetchoffice({}).then(function (response, err) {        
        vm.officedata = response.data.data;
      })
    }

    function deleteoffice(id) {      
      ServiceProxy.deleteoffice({ id: id }).then(function (response, err) {        
        if (response.data.validFlag == true) {
          alert(response.data.responseString)
          vm.fetchoffice();
        } else {
          alert(response.data.responseString)
        }
      })
    }

    function editofc() {      
      var id = $stateParams.id;
      ServiceProxy.editofc({ id: id }).then(function (response, err) {
        if (response.data.data[0]) {
          vm.ofc = response.data.data[0];
          vm.edit = vm.ofc;
          vm.states = vm.ofc.assignedStates;
          vm.city_acc_state(vm.ofc.state)
        }
      })
    }

    function updateofficeinfo() {
      var multiple = [];
      if (vm.states.length !== 0) {
        for (var i = 0; i < vm.states.length; i++) {
          multiple.push(vm.states[i])
        }
      }
      vm.edit.multistate = multiple;
      ServiceProxy.updateofficeinfo(vm.edit).then(function (response, err) {
        if (response.data.validFlag == true) {
          alert(response.data.responseString)
          vm.edit = undefined;
          vm.states = undefined;
          $state.go("app.offices")
        } else {
          if (response.data.validFlag == false) {
            alert(response.data.responseString)
          }
        }
      });
    }
  }
})();
(function() {
	'use strict';

	angular
		.module('app.nav-list', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.nav-list', {
				url: '/nav-list',
				views: {
					'content@app': {
						templateUrl: 'app/main/nav-list/nav-list.html',
						controller: 'navListController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('DASHBOARD.nav-list', {
			title: 'NAV Download',
			icon: 'icon-tile-four',
			state: 'app.nav-list',
			weight: 8
		});
	}
})();

(function () {
	
	'use strict';

	angular.module('app.nav-list').controller('navListController', navListController);
	
	/** @ngInject */
	function navListController($state, $stateParams,$q, StorageService, $scope,$filter,$timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;

		function init() {
			vm.recommendation = {};
            vm.getMatches = getMatches;
			vm.getAllScheme = getAllScheme;
			vm.amcs = StorageService.getSessionStorage("amcData");
			vm.recommendation = ShareDataService.getData('recommendation');

            vm.getSchemeMatches = getSchemeMatches;
         
			
			vm.postData = {}
			vm.fromDate = null
			vm.toDate = null
			vm.selected = null
			vm.reportType = null
			vm.enabled1 = false
			vm.iinRegex = /^[1-9]{1}[0-9]{9}$/
			vm.logData = []

			vm.schemeType =1
			
		}
		init();

		// Get All Scheme API Call Start
        function sucessCbGetAllScheme(response) {

            vm.schemes = response.data.Data.product_master;
			angular.forEach(vm.schemes, function(schmObj) {
				if (schmObj.PRODUCT_CODE == vm.recommendation.productCode) {
					vm.recommendation.scheme = schmObj;
					return;
				}
			});
        };

        function errorCbGetAllScheme(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
		};
		
		
        function getAllScheme(amc) {

            vm.recommendation.scheme = '';
            vm.schemes = [];
			if(amc){
				if(vm.schemeType == 1){
					ServiceProxy.getAllScheme(amc.AMC_CODE + ',A').then(sucessCbGetAllScheme, errorCbGetAllScheme);
				}else{
					ServiceProxy.getAllScheme(amc.AMC_CODE).then(sucessCbGetAllScheme, errorCbGetAllScheme);
				}

			}
        };
		// Get All Scheme API Call End
		
		// match schemes
		function getSchemeMatches(searchText) {

            var deferred = $q.defer();

            $timeout(function() {
                var states = vm.schemes.filter(function(state) {
					if(state.PRODUCT_LONG_NAME)
                    return ((state.PRODUCT_LONG_NAME.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.PRODUCT_CODE.toUpperCase().indexOf(searchText.toUpperCase()) !== -1) && state.PURCHASE_ALLOWED === "Y");
                });
                deferred.resolve(states);
            }, 1500);

            return deferred.promise;

		}
		// match AMC
		function getMatches(searchText) {
            var result = vm.amcs;
            var deferred;

            if (searchText) {
                deferred = $q.defer();

                $timeout(function() {
                    var states = vm.amcs.filter(function(state) {
                        return (state.LONG_NAME.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.AMC_CODE.toUpperCase().indexOf(searchText.toUpperCase()) !== -1);
                    });
                    deferred.resolve(states);
                }, 1500);

                return deferred.promise;
            } else {
                return result;
            }

		}
		


		var sucessTrnLog = function(response){
			vm.logData = response.data.data;
			
			if(vm.logData.length < 1){
				showDialog("No Data Found...!!!");
			}else{
				showDialogSucc(response.data.responseString)
				var csvString = 'SCHEM_ENAME,ISIN,KEY,NAVDATE,NAVVALUE,' + "\n";
	        	for(var i=0; i<vm.logData.length;i++){
	        		
				csvString = csvString.concat(
					vm.recommendation.scheme.PRODUCT_LONG_NAME + "," 
					+ vm.logData[i].isin + "," 
					+ vm.logData[i].key + "," 
					+ $filter('date')(vm.logData[i].navDate, 'dMMMy') + "," 
					+ vm.logData[i].navValue + ","
					);
				csvString = csvString + "\n";
	        		
			    }
	         	var a = $('<a/>', {
		            href:'data:application/octet-stream;base64,'+btoa(csvString),
		            download:'navData_'+ $filter('date')(vm.fromDate, "dd-MMM-yyyy") + '-' +$filter('date')(vm.toDate, "dd-MMM-yyyy")  +'.csv'
		        }).appendTo('body')
		        a[0].click()
		        a.remove();
			}
		}

		var errorTrnlog = function(response){
			console.log(response);
			
		}

		$scope.postNavData = function(){
			vm.logData = []
			var date1 = new Date(vm.fromDate);
			var date2 = new Date(vm.toDate);
			var yearsDiff = date2.getFullYear() - date1.getFullYear();
			if(date1 > date2){
				showDialog("From Date must be less than To Date..!!");
				return
			}

			if(yearsDiff <= 5 ){
				vm.postData.isin = vm.recommendation.scheme.ISIN
				vm.postData.fromDate = $filter('date')(vm.fromDate, "dd/MMM/yyyy") 
				vm.postData.toDate = $filter('date')(vm.toDate, "dd/MMM/yyyy")
				console.log(vm.postData);
				ServiceProxy.postNavData(vm.postData).then(sucessTrnLog, errorTrnlog);
			}else{
				showDialog("Date should not be more than 5 years..!!");
			}
		}

		$scope.disabtranLog = function(){
			
			return ( !vm.fromDate || !vm.toDate || !vm.recommendation.amc)
		}

		$scope.clearLogs = function (){
			var type = vm.schemeType;
			init();
			vm.schemeType =type;
		}
				 

		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}


		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
	}
})();

(function () {

	'use strict';


	angular.module('app.otherTransaction').controller('otherTransactionController', otherTransactionController);
	

	/** @ngInject */
	function otherTransactionController($scope,
		$document,
		$state,
		$stateParams,
		$rootScope,
		$mdDialog,
		$mdToast,
		ServiceProxy,
		ShareDataService,
		StorageService) {
		var vm = this;
		
		function init() {
			vm.token = StorageService.getSessionStorage('access_token');
			vm.uploadSIPTrxn = uploadSIPTrxn;
			vm.uploadIINSyncTrxn = uploadIINSyncTrxn;
			vm.uploadAchTrxn = uploadAchTrxn;
			vm.sipFile = 'No File Selected';
			vm.iinsyncFile = 'No File Selected';
			vm.achFile = 'No File Selected';
			//Validate list
			vm.validateSIPTrxn = validateSIPTrxn;
			//vm.showAlert = showAlert();
			getSIPTrxn();
			getIInSync();
			getAchTrxn();
		}
		init();

		function successCbGetSIPTrxn(response) {
			vm.sipTrxnData = response.data.responseString;
			vm.sipTrxnData.transactionDate = response.data.responseString[0].lastUploadDate;
		}

		function errorCbGetSIPTrxn(response) {
			dialogOpenAddEmployee(response);
		}

		function getSIPTrxn() {
			ServiceProxy.getSIPTrxn().then(successCbGetSIPTrxn, errorCbGetSIPTrxn);
		}

		function successCbGetIINSync(response) {
			vm.iinSyncData = response.data.responseString;
			vm.iinSyncData.transactionDate = response.data.responseString[0].lastUploadDate;
		}

		function errorCbGetIINSync(response) {
			dialogOpenAddEmployee(response);
		}

		function getIInSync() {
			ServiceProxy.getIInSync().then(successCbGetIINSync, errorCbGetIINSync);
		}

        function sucessCbUploadSIPTransaction(response) {
			$('#sipFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#sipFile').unwrap();
			vm.sipFile = 'No File Selected';
			//var responseData = JSON.parse(response);
			showToast(response.data.responseString);
			showDialogSucc(response.data.responseString);
			//dialogOpenAddEmployee(responseData);
		}

		function errorCbUploadSIPTransaction(error) {
			$('#sipFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#sipFile').unwrap();
			vm.sipFile = 'No File Selected';
			if (typeof error.data === 'string') {
				dialogOpenAddEmployee(error.data);
			} else {
				var errString = [];
				angular.forEach(error.data, function (err) {
					errString.push(err.errorMessage);
				});
				
				dialogOpenAddEmployee(errString);				
			}
		}

		function uploadSIPTrxn() {
			var confirm = $mdDialog.confirm()
			  .title('Confirmation')
			  .textContent('Do you wants to upload SIP transaction file !')
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK')
			  .cancel('Cancel');
			$mdDialog.show(confirm).then(function () {
				var data = new FormData();
				data.append('file', $('#sipFile').prop('files')[0]);
				ServiceProxy.uploadSIPTrxn(data).then(sucessCbUploadSIPTransaction, errorCbUploadSIPTransaction);
			});
        }
		
		function sucessCbValidateSIPTrxn(response) {
			if(response.data.responseString.length > 0){
				ShareDataService.storeData('sipTrxnData', response.data.responseString);
				$state.go('app.otherTransaction.validatesiptxrn');
			}
			else
			{
				var  msg = "Data validate successfully."
				showDialogSucc(msg);
			}
        }

        function errorGetValidateSIPTrxn(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }

		function validateSIPTrxn() {
			var confirm = $mdDialog.confirm()
			  .title('Confirmation')
			  .textContent('Do you wants to validate SIP transaction file !')
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK')
			  .cancel('Cancel');
			$mdDialog.show(confirm).then(function () {
				var data = new FormData();
				data.append('file', $('#sipFile').prop('files')[0]);
				ServiceProxy.validateSIPTrxn(data).then(sucessCbValidateSIPTrxn, errorGetValidateSIPTrxn);
			});
		}

		function sucessCbUploadIINSyncTransaction(response) {
			$('#iinsyncfile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#iinsyncfile').unwrap();
			vm.iinsyncFile = 'No File Selected';
			//var responseData = JSON.parse(response);
			showToast(response.data.responseString);
			//dialogOpenAddEmployee(responseData);
			showDialogSucc(response.data.responseString);
		}

		function errorCbUploadIINSyncTransaction(error) {
			$('#iinsyncfile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#iinsyncfile').unwrap();
			vm.iinsyncFile = 'No File Selected';
			if (typeof error.data.responseString === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data.responseString, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
		}

		function uploadIINSyncTrxn() {
			var confirm = $mdDialog.confirm()
			  .title('Confirmation')
			  .textContent('Do you wants to upload IIN Syncing file !')
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK')
			  .cancel('Cancel');
			$mdDialog.show(confirm).then(function () {
				var data = new FormData();
				data.append('file', $('#iinsyncfile').prop('files')[0]);
				ServiceProxy.uploadIINSyncTrxn(data).then(sucessCbUploadIINSyncTransaction, errorCbUploadIINSyncTransaction);
			});
		}
		
		function successCbGetAch(response) {
			vm.achcData = response.data.responseString;
			vm.achcData.transactionDate = response.data.responseString[0].lastUploadDate
		}

		function errorCbGetAch(response) {
			dialogOpenAddEmployee(response);
		}

		function getAchTrxn() {
			ServiceProxy.getAchTrxn().then(successCbGetAch, errorCbGetAch);
		}

		function sucessCbUploadAchTransaction(response) {
			$('#achFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#achFile').unwrap();
			vm.achFile = 'No File Selected';
			// var responseData = response;
			showToast(response.data.responseString);
			showDialogSucc(response.data.responseString);
			//dialogOpenAddEmployee(responseData);
		}

		function errorCbUploadAchTransaction(error) {
			$('#achFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#achFile').unwrap();
			vm.achFile = 'No File Selected';
			if (typeof error.data === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
		}

		function uploadAchTrxn() {
			var confirm = $mdDialog.confirm()
			  .title('Confirmation')
			  .textContent('Do you wants to upload ACH file !')
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK')
			  .cancel('Cancel');
			$mdDialog.show(confirm).then(function () {
				var data = new FormData();
				data.append('file', $('#achFile').prop('files')[0]);
				ServiceProxy.uploadAchTrxn(data).then(sucessCbUploadAchTransaction, errorCbUploadAchTransaction);
			});
		}

		function showDialogSucc(response) {
			var confirm = $mdDialog.confirm()
			  .title('Success')
			  .textContent(response)
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}

		function showDialogConfirmation(response) {
			var confirm = $mdDialog.confirm()
			  .title('Confirmation')
			  .textContent(response)
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK')
			  .cancel('You wants cancel');
			$mdDialog.show(confirm).then(function () {});
		}

        function showToast(msg) {
			var toast = $mdToast
				.simple()
				.textContent(msg)
				.highlightAction(true)
				.highlightClass('md-accent')
				.position('top right');

			$mdToast.show(toast).then(function (response) {
				if (response == 'ok') {
					alert("You clicked the 'UNDO' action.");
				}
			});
        }
        
		function dialogOpenAddEmployee(response) {
			var message = '';
			if (response.err_desc) {
				message = response.err_desc;
			} else if (response.responseString) {
				message = response.responseString;
			} else {
				message = response;
			}

			if(message.length === 0)
				message = 'Data Uploaded Successfully';

			if(message.indexOf('502') != -1)
				message = 'Data Uploaded Successfully';
			
			if(message.indexOf('504') != -1)
				message = 'Data Uploaded Successfully';
			
			var confirm = $mdDialog
				.confirm()
				.title('Upload Details')
				.htmlContent('<b>' + message + '</b>')
				.ariaLabel('delete contact')
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}

		function showDialogSucc(response) {
			var confirm = $mdDialog.confirm()
			  .title('Success')
			  .textContent(response)
			  .ariaLabel('Lucky day')
			  .clickOutsideToClose(true)
			  .parent(angular.element(document.body))
			  .ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}


        $scope.checkfile = checkfile;

		function checkfile(sender, type) {
			if (type === 'sipFile') {
				var docValue = document.getElementById('sipFile');
				vm.sipFile = docValue.files[0].name;
			} 
			else if (type === 'iinsyncfile') {
				var docValue = document.getElementById('iinsyncfile');
				vm.iinsyncFile = docValue.files[0].name;
			} 
			else if (type === 'achFile') {
				var docValue = document.getElementById('achFile');
				vm.achFile = docValue.files[0].name;
			} 
			$scope.$apply();
			var validExts = new Array('.csv');
			var fileExt = sender.value;
			fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
			if (validExts.indexOf(fileExt) < 0) {
				dialogOpenAddEmployee('Invalid file selected, valid files are of ' + validExts.toString() + ' types.');
				$(sender).val('');
				return false;
			} else return true;
		}

	}
})();

(function() {
	'use strict';

	angular.module('app.noisinscheme', []).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		var fId = 'SCHEME::MANAGEMENT';
		// State
		$stateProvider.state('app.noisinscheme', {
			url: '/noisinscheme',
			views: {
				'content@app': {
					templateUrl: 'app/main/no-isin-scheme/no-isin-scheme.html',
					controller: 'NoIsinSchemeController as vm'
				}
			},
			data: {
				access: function() {
					if (
						JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
						(window.sessionStorage.getItem('feature') &&
							JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
					) {
						return true;
					} else {
						return false;
					}
				}
			}
		});

		msNavigationServiceProvider.saveItem('SCHEMES.noisinscheme', {
			title: 'No ISIN Scheme',
			state: 'app.noisinscheme',
			icon: 'icon-people',
			weight: 2
		});
	}
})();

(function() {
	'use strict';

	angular.module('app.noisinscheme').controller('NoIsinSchemeController', NoIsinSchemeController);

	/** @ngInject */
	function NoIsinSchemeController($rootScope, $state, $mdDialog, ServiceProxy, ShareDataService) {
		var vm = this;

		function init() {
			vm.currentNavItem = 'WITHOUT_ISIN';
			vm.editISINDialog = editISINDialog;
			vm.getNOIsinSchems = getNOIsinSchems;
			vm.markMorningStarDialog = markMorningStarDialog;
			getNOIsinSchems(vm.currentNavItem);
		}
		init();

		function successCbGetNOIsinSchems(response) {
			vm.noIsinScheme = response.data.data;
		}
		function errorCbGetNOIsinSchems(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}
		function getNOIsinSchems(type) {
			ServiceProxy.getNOIsinSchems(type).then(successCbGetNOIsinSchems, errorCbGetNOIsinSchems);
		}
		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function() {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

		///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Confirm')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function() {});
		}
		///////////////////////////////show success dialog message starts here//////////////////////////////////////////////

		function editISINDialog(schm) {
			$mdDialog
				.show({
					locals: { data: schm },
					controller: IsinDialogController,
					templateUrl: 'app/main/no-isin-scheme/isin-dialog.html',
					parent: angular.element(document.body),
					targetEvent: schm,
					clickOutsideToClose: true,
					controllerAs: 'vm'
					// fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
				})
				.then(
					function(data) {
						updateISIN(schm._id, data);
						// $scope.status = 'You said the information was "' + answer + '".';
					},
					function() {
						// $scope.status = 'You cancelled the dialog.';
					}
				);
		}

		function successCbUpdateISIN(response) {
			// vm.dynamicItems = new vm.DynamicItems();
			getNOIsinSchems(vm.currentNavItem);
		}
		function errorCbUpdateISIN(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}
		function updateISIN(id, isin) {
			var data = {
				productISIN: isin
			};
			ServiceProxy.updateSchems(id, data).then(successCbUpdateISIN, errorCbUpdateISIN);
		}

		// mark morning star aade function and dialog

		function markMorningStarDialog(schm) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent('Is Scheme ' + schm.productName + ' added in morning star?')
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK')
				.cancel('Close');
			$mdDialog.show(confirm).then(function() {
				markAddedMorning(schm._id);
			});
		}

		function successMarkAddedMorning(response) {
			getNOIsinSchems(vm.currentNavItem);
		}
		function errorMarkAddedMorning(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}
		function markAddedMorning(id) {
			var data = {
				morningStarFlag: true
			};
			ServiceProxy.markAddedMorning(id, data).then(successMarkAddedMorning, errorMarkAddedMorning);
		}
	}

	function IsinDialogController($mdDialog, $timeout, $mdToast, ServiceProxy, data) {
		var vm = this;
		function init() {
			vm.schmData = data;
			vm.hide = function(data) {
				$mdDialog.hide(data);
			};
			vm.saveData = function() {
				vm.hide(vm.isin);
			};
		}
		init();
	}
})();

(function() {
	'use strict';

	angular
		.module('app.nav-rating', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.nav-rating', {
				url: '/nav-rating',
				views: {
					'content@app': {
						templateUrl: 'app/main/nav-rating/nav-rating.html',
						controller: 'navRatingController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('DASHBOARD.nav-rating', {
			title: 'Fund Rating',
			icon: 'icon-tile-four',
			state: 'app.nav-rating',
			weight: 10
		});
	}
})();

(function () {

	'use strict';

	angular.module('app.nav-rating').controller('navRatingController', navRatingController)
		.directive("limitTo", [function () {
			return {
				restrict: "A",
				link: function (scope, elem, attrs) {
					var limit = parseInt(attrs.limitTo);
					angular.element(elem).on("keypress", function (e) {
						if (parseInt(this.value) == limit) e.preventDefault();
					});
				}
			}
		}]);


	/** @ngInject */
	function navRatingController($state, $stateParams, $q, StorageService, $scope, $filter, $timeout, $mdSidenav, $mdDialog,ShareDataService, ServiceProxy) {
		var vm = this;
		var self = this;

		// Firefox does not implement <input type="month">, so the month list is built
		// here instead. Each value is `new Date(yyyy, MM, 1)` -- local midnight on the
		// 1st, exactly what AngularJS' input[month] parser produced -- so the payload
		// posted to algo-ranking/listDetails is unchanged.
		function buildMonthPickerOptions() {
			var monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
				'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			var now = new Date();
			var options = [];
			for (var i = 0; i < 72; i++) {
				// A negative month rolls the year back on its own.
				var d = new Date(now.getFullYear(), now.getMonth() - i, 1);
				options.push({
					label: monthLabels[d.getMonth()] + ' ' + d.getFullYear(),
					value: d
				});
			}
			return options;
		}

		function init() {
			vm.isincount = 0;
			vm.amcName = '';
			vm.prodName = '';
			vm.recommendation = {};
			vm.getProductData = getProductData;
			vm.getAllCategory = getAllCategory;
			vm.getCategory = getCategory;
			vm.amcs = StorageService.getSessionStorage("amcData");
			vm.recommendation = ShareDataService.getData('recommendation');

			vm.postData = {}
			
			vm.selected = null
			vm.reportType = null
			vm.enabled1 = false
			vm.shDate = null
			vm.monthPickerOptions = buildMonthPickerOptions();

			vm.month = null;
			vm.month1 = null;
			vm.month2 = null;
			vm.month3 = null;
			vm.month4 = null;
			vm.month5 = null;
			vm.month6 = null;
			vm.month7 = null;
			vm.month8 = null;
			vm.month9 = null;
			vm.month10 = null;
			vm.month11 = null;
			vm.month12 = null;
			
			vm.year = null;
			vm.year2 = null;
			vm.year3 = null;
			vm.index = null;
			vm.type = null;

			self.simulateQuery = false;
			self.isDisabled = false;

			// category autocomplete vars
			//self.categories = StorageService.getSessionStorage("categoryData");
			self.selectedItem = null;
			self.searchText = null;
			// category autocomplete vars ends

			vm.model = {};
			vm.model.allItemsSelected = false;
			vm.model.productData = [];
			vm.checkActRec = []
			//date input
			vm.selectedOption = null;
			vm.options = ['3', '5', '10'];
			vm.asonDate = null
			//save to download params
			vm.upsite
			vm.downsite			
			vm.rollingValidate
			vm.sortino
			vm.reInfoData
			vm.fundtypeall =[{Name:'Debt',Value:'Debt'},{Name:'Equity',Value:'Equity'}];
			// get productFund match
			vm.getMatches = getMatches;
			vm.getRank = getRank;
			vm.getRankAll = getRankAll;
			vm.download = download;
			vm.filteredItems;
			vm.NoDataFound ='';
			vm.EquityData = [];
			vm.DebtData =[];
			vm.monthyearArray =[];
		}
		init();

		$scope.disabtranLog = function () {
			return (!vm.asonDate || !vm.selectedOption || !vm.postData.rollInt)
		}

		$scope.clearLogs = function () {
			vm.isincount = 0;
			vm.checkActRec = []
			init()
		}



		var sucessProdData = function (response) {
			vm.checkActRec = []
			vm.model.productData = response.data.data;
			if(!vm.model.productData.length)
			vm.NoDataFound = 'Data is not available for selected date.'
			else
			vm.NoDataFound ='';
		}
		var errorProdData = function (response) {
			console.log(response);
		}
		function getRankAll()
		{
			for(i=0;i<vm.model.productData.length; i++)
			{
				getRank(vm.model.productData[i],4,i);				
			}
		}
		function getRank(selected,type,index){
			console.log(selected);
			vm.index = index;
			vm.type = type;
			var SelectedDate = null
			if(type == 1)
			SelectedDate = selected.curDate;
			else if(type == 2)
			SelectedDate = selected.preMonthDate;
			else if(type ==3 )
			SelectedDate = selected.prepreMonthDate;
			else
			SelectedDate = vm.NewDate;

			if(SelectedDate != undefined ){
			var data = {
				'Category' : vm.fundType,			   
				'Date':new Date(SelectedDate),
				'Fund_Type' : vm.selectedItem,
				'ISIN': selected._id,
				'Index':vm.index,
				'Type':vm.type
			};
	
			// jQuery('.tab_content .fund_block .fund_detail').removeClass('active');
			// jQuery('.faq-tabs .tab_'+id).addClass('active');
	
			
			ServiceProxy.getRanking(data).then(successgetRanking,errorgetRanking);

		}
	}

		var successgetRanking = function (response) {
			console.log(response);

			// var rankdiv = document.getElementById('divrank1_'+vm.index);
			// rankdiv.innerText = response.data.response[0]['Final Rank'];
			// rankdiv.innerHTML = response.data.response[0]['Final Rank'];
			var finalRank = null;
			if(response.data.Index != undefined) 
			vm.index = response.data.Index;
			if(response.data.Type != undefined) 
			vm.type = response.data.Type;
			if(response.data.response[0] != undefined)
			finalRank =response.data.response[0]['Final Rank'];
			else
			finalRank ='NA'
			if(vm.type == 1)
			vm.model.productData[vm.index].rank = finalRank; 
			else if(vm.type == 2)
			vm.model.productData[vm.index].rank1 =finalRank; 
			else if(vm.type == 3)
			vm.model.productData[vm.index].rank2 =finalRank;   
			else
			vm.model.productData[vm.index].rank3 =finalRank;    
			
			//alert(response.data.response[0]['Final Rank']);
			
		}
		var errorgetRanking = function (response) {
			console.log(response);
		}
		//productFund data
		function getProductData() {

			var date = new Date();
			var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
						'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			// Without this, no month selected threw a TypeError on .getMonth() below
			// and the Show button silently did nothing at all.
			if (!vm.shDate) {
				vm.model.productData = [];
				vm.NoDataFound = 'Please select a month.';
				return;
			}
			vm.month = monthNames[vm.shDate.getMonth()];
			vm.year = vm.shDate.getFullYear();
			var monthVal = new Date(vm.shDate).getMonth() + 1;
			if(monthVal )
			//var monthArray = Array.from({ length: 12 }, (_, i) => ((monthVal + i) % 12) + 1);
			var monthArray =[];
			for(i=0;i<12; i++)
			{
				monthArray.push(((monthVal + i) % 12) + 1);
			}
			console.log(monthArray);
			//var monthArray = [3,4,5,6,7,8,9,10,11,12,1,2];
			vm.monthyearArray =[];
			for(i=0;i<monthArray.length; i++)
			{
				if(monthArray[i]> monthVal) 
				vm.monthyearArray.push(monthNames[monthArray[i]-1]+' '+(vm.year-1));
				else
				vm.monthyearArray.push(monthNames[monthArray[i]-1]+' '+vm.year);
			}

			console.log("month array "+ vm.monthyearArray);
			vm.month1 = monthNames[monthArray[0]-1];
			vm.month2 = monthNames[monthArray[1]-1];
			vm.month3 = monthNames[monthArray[2]-1];
			vm.month4 = monthNames[monthArray[3]-1];
			vm.month5 = monthNames[monthArray[4]-1];
			vm.month6 = monthNames[monthArray[5]-1];
			vm.month7 = monthNames[monthArray[6]-1];
			vm.month8 = monthNames[monthArray[7]-1];
			vm.month9 = monthNames[monthArray[8]-1];
			vm.month10 = monthNames[monthArray[9]-1];
			vm.month11 = monthNames[monthArray[10]-1];
			vm.month12 = monthNames[monthArray[11]-1];
			var productMSCategory = vm.selectedItem;
			if (productMSCategory != undefined) {
				// vm.model.productData = [];
				// vm.postData.flag = "PRODUCT";
				// vm.postData.productMSCategory = productMSCategory;
				// ServiceProxy.postNavCalData(vm.postData).then(sucessProdData, errorProdData);
				var keys1 = vm.fundType;			
			// if (keys1 == 'Equity') {
			// 	callSchemesEquity(productMSCategory);       
			// } else {
			// 	callSchemesDebt(productMSCategory);  
			// }
			var data = {
				'Category' :keys1,
			    // 'Month' : monthNames[vm.shDate.getMonth()],
				// // 'Month' : 'Mar',
				// 'Year' :vm.shDate.getFullYear(),
				'Date':vm.shDate,
				'Fund_Type' : productMSCategory
			};
	
			// jQuery('.tab_content .fund_block .fund_detail').removeClass('active');
			// jQuery('.faq-tabs .tab_'+id).addClass('active');
	
			
			ServiceProxy.getCategoryDetails(data).then(successEquityDetails,errorEquityDetails);			
	
			$scope.heading = productMSCategory;
			}
		}



		// function callSchemesEquity(data_id) {
		// 	console.log(data_id);
			

		// 	var data = {
		// 		'Category' :'Equity',
		// 	    // 'Month' : monthNames[vm.shDate.getMonth()],
		// 		// // 'Month' : 'Mar',
		// 		// 'Year' :vm.shDate.getFullYear(),
		// 		'Date':vm.shDate,
		// 		'Fund_Type' : data_id
		// 	};
	
		// 	// jQuery('.tab_content .fund_block .fund_detail').removeClass('active');
		// 	// jQuery('.faq-tabs .tab_'+id).addClass('active');
	
			
		// 	ServiceProxy.getCategoryDetails(data).then(successEquityDetails,errorEquityDetails);			
	
		// 	$scope.heading = data_id;
		// };
	
		
	
		// function callSchemesDebt(data_id) {
		// 	console.log(data_id);
		// 	var date = new Date();
		// 	var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		// 				'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
		// 				vm.month = monthNames[vm.shDate.getMonth()];						
		// 				vm.year = vm.shDate.getFullYear();
						

		// 				var preMonthDate = new Date(new Date(vm.shDate).setMonth(new Date(vm.shDate).getMonth() - 1)).toString();
		// 				vm.month2 = monthNames[new Date(preMonthDate).getMonth()];
		// 				vm.year2 = new Date(preMonthDate).getFullYear();
						
		// 	var data = {
		// 		'Category' :'Debt',
		// 		// 'Month' : monthNames[vm.shDate.getMonth()],
		// 		// //'Month' : 'Jan',
		// 		// 'Year' :year,
		// 		'Date':vm.shDate,
		// 		'Fund_Type' : data_id
		// 	};
			
		// 	ServiceProxy.getCategoryDetails(data).then(successEquityDetails,errorEquityDetails);
			
		// 	$scope.heading = data_id;
		// };
	
		
	
		var successEquityDetails = function(response) {
			console.log('Product Data ', response);
			// $scope.fetchedApiData = true;
			// $scope.detailsObject = response.data.output;
			vm.model.productData = response.data.output;
		// if(response.data.output != undefined)
		// {

		
		// 	for(i=0;i<response.data.output.length; i++)
		// 	{
		// 		getRank(response.data.output[i],2,i);
		// 		getRank(response.data.output[i],3,i);
		// 		//response.data.output[i].preMonthDate = new Date(response.data.output[i].preMonthDate);
		// 		response.data.output[i].curDate = new Date(response.data.output[i].curDate);
		// 	}
		// 	vm.model.productData = response.data.output;
		// 	console.log('the datas that are coming is ', vm.model.productData);
		// }
		// else
		// {
		// 	vm.model.productData =[];
		// 	vm.NoDataFound = response.data.message;
		// }
		  
		};
	
		var errorEquityDetails = function(error) {
			console.log(error);
		};

		function getAllCategory(Fundtype) {
			self.searchText ="";
			self.selectedItem ="";		
			vm.fundType = Fundtype;	
			ServiceProxy.getAllCategory().then(successCallBackData, errorCallbackData);		
		};
		function getCategory(Fundtype) {
			self.searchText ="";
			self.selectedItem ="";		
			vm.fundType = Fundtype;	
			var keys1 = vm.fundType;			
			if (keys1 == 'Equity') {
				vm.categories =  vm.EquityData;       
			} else {
				vm.categories = vm.DebtData;
			}	
		};
		var successCallBackData = function(response) {
			console.log('The response is', response);
			var tele = response.data.response;
			vm.EquityData = tele[1]['Equity'];
			vm.DebtData = tele[0]['Debt'];
			var keys1 = vm.fundType;			
			if (keys1 == 'Equity') {
				vm.categories =  tele[1]['Equity'];       
			} else {
				vm.categories = tele[0]['Debt'];
			}
			vm.model.productData = [];
			//getMatches(self.searchText);
		};
	
		var errorCallbackData = function(error) {
			console.log(error);
		};

		getAllCategory("Equity");

		// match Categories/funds
		function getMatches(searchText) {
			//var result = self.categories;
			var result = vm.categories;
			var deferred;

			if (searchText) {
				deferred = $q.defer();

				$timeout(function () {
					var states = self.categories.filter(function (state) {
						return (state ? state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 : null);

						//return (state ? (state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 && state.toUpperCase().indexOf(vm.fundType.toUpperCase()) !== -1) : null);
					});
					deferred.resolve(states);
				}, 1500);

				return deferred.promise;
			} else {
				return result;
			}

		}


		function download() {
			
			var csvString = 'Fund Name,Category,3 Yr Return,Rating,'+vm.monthyearArray[0]+','+ vm.monthyearArray[1]+','+vm.monthyearArray[2] +','+ vm.monthyearArray[3]+','+vm.monthyearArray[4] +','+ vm.monthyearArray[5] +','+vm.monthyearArray[6] +','+vm.monthyearArray[7] +','+vm.monthyearArray[8] +','+vm.monthyearArray[9] +','+vm.monthyearArray[10] +','+vm.monthyearArray[11] + "\n";

            console.log('transaction value for the customer');
            //console.log(JSON.stringify(vm.trxn_Data.responseString));

            for(var i=0; i<vm.model.productData.length;i++)
            {
               var fundname = vm.model.productData[i].productData[0].productName == null ? vm.model.productData[i]['Fund Name'] : vm.model.productData[i].productData[0].productName
                csvString = csvString.concat(
					//vm.model.productData[i].productData[0].productName + "," 
					fundname +","
                + vm.model.productData[i].Fund_Type + "," 
                + parseFloat(vm.model.productData[i].productData[0].product3YearReturnValue).toFixed(1) + "," 
                + vm.model.productData[i].Rating + ","                   
                + vm.model.productData[i].rankarray[0] + ","
                + vm.model.productData[i].rankarray[1] + ","
                + vm.model.productData[i].rankarray[2] + ","
                + vm.model.productData[i].rankarray[3] + "," 
				+ vm.model.productData[i].rankarray[4] + "," 
				+ vm.model.productData[i].rankarray[5] + "," 
				+ vm.model.productData[i].rankarray[6] + "," 
				+ vm.model.productData[i].rankarray[7] + "," 
				+ vm.model.productData[i].rankarray[8] + "," 
				+ vm.model.productData[i].rankarray[9] + "," 
				+ vm.model.productData[i].rankarray[10] + "," 
				+ vm.model.productData[i].rankarray[11] + ","             
                );
                csvString = csvString + "\n";
            }

            var a = $('<a/>', {
                href:'data:application/octet-stream;base64,'+btoa(csvString),
                download:'fundrating.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
		}

	}
})();

(function () {
    'use strict';

    angular
        .module('app.internalUserMapping', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'TRANSACTION::CSV::UPLOAD';
        // State
        $stateProvider
            .state('app.internalUserMapping', {
                url: '/internalUserMapping',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/internalUserMapping/internalUserMapping.html',
                        controller: 'InternalUserMappingController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            });



        msNavigationServiceProvider.saveItem('USER.internalUserMapping', {
            title: 'Internal User Mapping',
            state: 'app.internalUserMapping',
            icon: 'icon-people',
            weight: 2
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.internalUserMapping')
        .controller('InternalUserMappingController', InternalUserMappingController);

    /** @ngInject */
    function InternalUserMappingController($rootScope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.uploadCsvFiles = uploadCsvFiles;
            vm.downloadsCsvFiles = downloadsCsvFiles;
        };
        init();

        //////////////////////////////////////////////upload csv file of internal user starts here///////////////////////////
        function successCbGetUpload(response) {
            if (response && response.data) {
                showDialogSucc(response.data.responseString);
            }

        }

        function errorCbGetUpload(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function uploadCsvFiles() {
            var data = new FormData();
            data.append("file", $("#csvfile").prop('files')[0]);
            ServiceProxy.uploadCSVFile(data).then(successCbGetUpload, errorCbGetUpload);
        }
        //////////////////////////////////////////////upload csv file of internal user ends here///////////////////////////

        //////////////////////////////////////////////download csv file of internal user starts here///////////////////////////
        function successCbGetDownloads(response) {
            var blob = new Blob([response.data], {
                type: 'text/csv'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'investorsassign.csv';
            link.click();

        }

        function errorCbGetDownloads(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function downloadsCsvFiles() {
            ServiceProxy.downloadCSVFile().then(successCbGetDownloads, errorCbGetDownloads);
        }
        //////////////////////////////////////////////download csv file of internal user ends here///////////////////////////


        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////

    }
})();
(function() {
	'use strict';

	angular
		.module('app.nav-calculate', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.nav-calculate', {
				url: '/nav-calculate',
				views: {
					'content@app': {
						templateUrl: 'app/main/nav-calculate/nav-calculate.html',
						controller: 'navCalculateController as vm'
					}
				}
			})

		// msNavigationServiceProvider.saveItem('DASHBOARD.nav-calculate', {
		// 	title: 'Fund Analysis',
		// 	icon: 'icon-tile-four',
		// 	state: 'app.nav-calculate',
		// 	weight: 9
		// });
	}
})();

(function () {

	'use strict';

	angular.module('app.nav-calculate').controller('navCalculateController', navCalculateController)
		.directive("limitTo", [function () {
			return {
				restrict: "A",
				link: function (scope, elem, attrs) {
					var limit = parseInt(attrs.limitTo);
					angular.element(elem).on("keypress", function (e) {
						if (parseInt(this.value) == limit) e.preventDefault();
					});
				}
			}
		}]);


	/** @ngInject */
	function navCalculateController($state, $stateParams, $q, StorageService, $scope, $filter, $timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;
		var self = this;

		function init() {
			vm.isincount = 0;
			vm.amcName = '';
			vm.prodName = '';
			vm.recommendation = {};
			vm.getProductData = getProductData;
			vm.getAlpha = getAlpha;
			vm.Calculate = Calculate;
			vm.downloadData = downloadData
			vm.downloadInfo = downloadInfo
			vm.selectEntity = selectEntity;
			vm.selectAll = selectAll;
			vm.amcs = StorageService.getSessionStorage("amcData");
			vm.recommendation = ShareDataService.getData('recommendation');

			vm.postData = {}
			vm.fromDate = null
			vm.toDate = null
			vm.selected = null
			vm.reportType = null
			vm.enabled1 = false
			vm.iinRegex = /^[1-9]{1}[0-9]{9}$/

			self.simulateQuery = false;
			self.isDisabled = false;

			// category autocomplete vars
			self.categories = StorageService.getSessionStorage("categoryData");
			self.selectedItem = null;
			self.searchText = null;
			// category autocomplete vars ends

			vm.model = {};
			vm.model.allItemsSelected = false;
			vm.model.productData = [];
			vm.checkActRec = []
			//date input
			vm.selectedOption = null;
			vm.options = ['3', '5', '10'];
			vm.asonDate = null
			//save to download params
			vm.upsite
			vm.downsite
			vm.getDatefn = getDatefn
			vm.rollingValidate
			vm.sortino
			vm.reInfoData

			// get productFund match
			vm.getMatches = getMatches;
			vm.filteredItems
		}
		init();

		$scope.disabtranLog = function () {
			return (!vm.asonDate || !vm.selectedOption || !vm.postData.rollInt)
		}

		$scope.clearLogs = function () {
			vm.isincount = 0;
			vm.checkActRec = []
			init()
		}



		var sucessProdData = function (response) {
			vm.checkActRec = []
			vm.model.productData = response.data.data;

		}
		var errorProdData = function (response) {
			console.log(response);
		}

		//productFund data
		function getProductData(productMSCategory) {
			if (productMSCategory != undefined) {
				// vm.model.productData = [];
				vm.postData.flag = "PRODUCT";
				vm.postData.productMSCategory = productMSCategory;
				ServiceProxy.postNavCalData(vm.postData).then(sucessProdData, errorProdData);
			}
		}

		// match Categories/funds
		function getMatches(searchText) {
			var result = self.categories;
			var deferred;

			if (searchText) {
				deferred = $q.defer();

				$timeout(function () {
					var states = self.categories.filter(function (state) {
						return (state ? state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 : null);
					});
					deferred.resolve(states);
				}, 1500);

				return deferred.promise;
			} else {
				return result;
			}

		}

		//get start and end date
		function getDatefn(option) {
			if (vm.asonDate && option) {
				vm.selectedOption = parseInt(option)
				var changedDate = vm.asonDate
				// vm.asonDate.setDate(vm.asonDate.getDate() - 1);
				var date1 = new Date(changedDate.setFullYear(changedDate.getFullYear() - vm.selectedOption));
				var date2 = new Date(changedDate.setFullYear(changedDate.getFullYear() + vm.selectedOption));
				//set fromDate minus to one day
				date1.setDate(date1.getDate() - 1);
				vm.postData.fromDate = $filter('date')(date1, "dd/MMM/yyyy")
				vm.postData.toDate = $filter('date')(date2, "dd/MMM/yyyy")
				if (vm.selectedOption == 1) {
					vm.postData.rollInt = 1 * 365;
					vm.rollingValidate = vm.postData.rollInt
				} else if (vm.selectedOption == 3) {
					//	vm.postData.rollInt = 3*365;
					vm.rollingValidate = vm.postData.rollInt
				} else if (vm.selectedOption == 5) {
					//	vm.postData.rollInt = 5*365;
					vm.rollingValidate = vm.postData.rollInt
				} else if (vm.selectedOption == 10) {
					//	vm.postData.rollInt = 10*365;
					vm.rollingValidate = vm.postData.rollInt
				}
					vm.postData.rollInt = 250;
			}
		}


		// get ALPHA
		function getAlpha() {
			// validate Interval
			if (vm.postData.rollInt > vm.rollingValidate) {
				showDialog('Interval should not be more than ' + vm.rollingValidate)
				return
			}

			// validate date
			var todaysDate = new Date()
			var date2 = new Date(vm.asonDate);

			if (todaysDate < date2) {
				showDialog("As-On Date should not be greater than current Date..!!");
				return
			}

			// start getting alpha
			var productISIN = '';

			productISIN = vm.checkActRec[vm.isincount].productISIN;
			vm.amcName = vm.checkActRec[vm.isincount].productAmcName
			vm.prodName = vm.checkActRec[vm.isincount].productName

			if (productISIN != undefined) {
				// vm.postData.flag = "NAV";
				vm.postData.productISIN = productISIN;
				// ServiceProxy.postNavCalData(vm.postData).then(sucessProdNavData, errorProdNavData);
				$('#loading-indicator').show();
				var settings = {
					"async": true,
					"crossDomain": true,
					//"url": "http://192.168.1.169:8084" + "/api/proxy/morningstar/v2/service/mf/r5soaer67qpg88tr/isin/" + productISIN + "/accesscode/",
					"url": "https://sipfund.com" + "/api/proxy/morningstar/v2/service/mf/r5soaer67qpg88tr/isin/" + productISIN + "/accesscode/",
					"method": "GET",
					"headers": {
						"cache-control": "no-cache",
						"postman-token": "31fa9f86-4b6d-281b-7d66-4336ac38223b"
					}
				}

				$.ajax(settings).done(function (response) {
					// var responseData = JSON.parse(response);

					vm.schemeDetail = response.data;
					if (vm.selectedOption == 1) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha1Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside1Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside1Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio1Yr"] : 0
					}

					else if (vm.selectedOption == 3) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha3Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside3Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside3Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio3Yr"] : 0

					}
					else if (vm.selectedOption == 5) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha5Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside5Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside5Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio5Yr"] : 0

					}
					else if (vm.selectedOption == 10) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha10Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside10Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside10Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio10Yr"] : 0

					}
					vm.fperformance1 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-CategoryReturn1Yr"] : 0;
					vm.fperformance3 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-CategoryReturn3Yr"] : 0;
					vm.fperformance5 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-DP-CategoryReturn5Yr"] : 0;
					vm.fperformance10 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-CategoryReturn10Yr"] : 0;

					//call calculate here
					Calculate(productISIN)
				}).fail(function (response) {
					showDialog("Error Occurred..!!..Timeout from api morningstar");
				});
			}
		}


		// check list elements and select
		function selectEntity(pObj) {
			// If any entity is not checked, then uncheck the "allItemsSelected" checkbox
			for (var i = 0; i < vm.model.productData.length; i++) {
				if (!vm.model.productData[i].isChecked) {
					console.log(pObj)
					if (pObj.isChecked) {
						vm.checkActRec.push(pObj)
					} else {
						var index = vm.checkActRec.indexOf(pObj);
						if (index > -1) {
							vm.checkActRec.splice(index, 1);
						}
					}
					if (vm.checkActRec.length > 0) {
						//vm.getAlpha(vm.checkActRec[0].productISIN);
						vm.checkActRec.filter(function(item, index) { vm.checkActRec.indexOf(item) === index})
						vm.checkActRec.filter(function (e) { return e.isChecked !== false })
						vm.model.allItemsSelected = false;
						return;
					}
				}
			}
		};

		function selectAll(val) {
			// Loop through all the entities and set their isChecked property
			for (var i = 0; i < vm.filteredItems.length; i++) {
				vm.filteredItems[i].isChecked = vm.model.allItemsSelected;
			}
			
			if (val)
				vm.checkActRec = vm.filteredItems
			else
				vm.checkActRec = []
		};
		// check list elements and select ends

		function sucessSaveNavCalcData(respone) {
			console.log(respone);
			if (!(vm.isincount === vm.checkActRec.length - 1)) {
				vm.isincount = vm.isincount + 1;
				vm.getAlpha(vm.isincount);
				vm.downloadInfo();
			}
			else {
				vm.isincount = 0;
				vm.downloadInfo();
				vm.downloadData();
				alert('Records Downloaded Successfully...!!!');
			}
		}

		function errSaveNavCalcData(respone) {
			console.log(respone);

		}

		//save navCalc as excel
		function saveNavCalcData() {
			var trnxBody = {}
			trnxBody.flag = 'SAVERATING';
			trnxBody.trandate = $filter('date')(new Date(), "dd/MMM/yyyy");
			trnxBody.trantime = new Date().getTime();
			trnxBody.isin = vm.postData.productISIN;
			trnxBody.fromdate = vm.postData.fromDate;
			trnxBody.uptodate = vm.postData.toDate;
			trnxBody.rollinginterval = vm.postData.rollInt;

			//api from morning star
			trnxBody.alpha = vm.postData.alpha;
			trnxBody.upsite = vm.upsite;
			trnxBody.downsite = vm.downsite;
			trnxBody.fperformance1 = vm.fperformance1;
			trnxBody.fperformance3 = vm.fperformance3;
			trnxBody.fperformance5 = vm.fperformance5;
			trnxBody.fperformance10 = vm.fperformance10;
			trnxBody.productAmcName = vm.amcName;
			trnxBody.productName = vm.prodName;
			trnxBody.sortino = vm.sortino;
			//from calculate flag responce
			if (vm.model.productNavCalData && vm.model.productNavCalData.code == '1') {
				trnxBody.errmsg = vm.model.productNavCalData.errmsg;
				trnxBody.returnranking = vm.model.productNavCalData.returnranking;
				trnxBody.ratioranking = vm.model.productNavCalData.ratioranking;
				trnxBody.hurst = vm.model.productNavCalData.Hrust;//vm.model.productNavCalData.hurst;
				trnxBody.rollingreturn = vm.model.productNavCalData.XIRR;
				trnxBody.stddaviation = vm.model.productNavCalData.StandardDeviation;
				trnxBody.volatility = vm.model.productNavCalData.Volatility;
				trnxBody.riskrating = '';
				trnxBody.skew = vm.model.productNavCalData.Skew;
				trnxBody.kurt = vm.model.productNavCalData.kurt;
				trnxBody.xaxis = vm.model.productNavCalData.LogX;
				trnxBody.yaxis = vm.model.productNavCalData.LogY;
				trnxBody.rsquare = vm.model.productNavCalData.RSquare;
				trnxBody.datapoint = vm.model.productNavCalData.DataPoints;
				trnxBody.return = vm.model.productNavCalData.Return;
				trnxBody.risk = vm.model.productNavCalData.Risk;
				trnxBody.ratio = vm.model.productNavCalData.Ratio;
				trnxBody.downsiderisk = vm.model.productNavCalData.DownsideRiskCalculation;
				trnxBody.totalrecord = vm.model.productNavCalData.TotalRecord;
				trnxBody.minrr = vm.model.productNavCalData.MinRR;
				trnxBody.maxrr = vm.model.productNavCalData.MaxRR;
				trnxBody.aarr = vm.model.productNavCalData.AARR;
				trnxBody.totrre = vm.model.productNavCalData.TotRRE;
				trnxBody.interval = vm.model.productNavCalData.Interval;
				// trnxBody.deleteflag = vm.isincount == 0 ? 'Y' : 'N';
				trnxBody.sumclose = vm.model.productNavCalData.sumclose;


			}
			else {
				trnxBody.errmsg = vm.model.productNavCalData.errmsg;
				trnxBody.returnranking = "";
				trnxBody.ratioranking = '';
				trnxBody.hurst = ''//vm.model.productNavCalData.hurst;
				trnxBody.rollingreturn = '';
				trnxBody.stddaviation = '';
				trnxBody.volatility = '';
				trnxBody.riskrating = '';
				trnxBody.skew = '';
				trnxBody.kurt = '';
				trnxBody.xaxis = '';
				trnxBody.yaxis = '';
				trnxBody.rsquare = '';
				trnxBody.datapoint = '';
				trnxBody.return = '';
				trnxBody.risk = '';
				trnxBody.ratio = '';
				trnxBody.downsiderisk = '';
				trnxBody.totalrecord = '';
				trnxBody.minrr = '';
				trnxBody.maxrr = '';
				trnxBody.aarr = '';
				trnxBody.totrre = '';
				trnxBody.interval = '';
				// trnxBody.deleteflag = vm.isincount == 0 ? 'Y' : 'N';
			}
			ServiceProxy.postNavCalData(trnxBody).then(sucessSaveNavCalcData, errSaveNavCalcData);


		}

		var sucessCalculate = function (response) {
			vm.model.productNavCalData = response.data.data;
			vm.reInfoData = response.data.data.reinfo;
			if (vm.checkActRec.length == 1 && vm.model.productNavCalData.code == '0') {
				showDialog(vm.model.productNavCalData.errmsg)
				return
			}
			saveNavCalcData()
		}
		var errorCalculate = function (response) {
			console.log(response);
		}

		//calculate flag
		function Calculate(productISIN) {

			if (productISIN != undefined) {
				vm.postData.flag = "CALCULATE";
				vm.postData.productISIN = productISIN;
				vm.postData.alpha = vm.rAlpha ? vm.rAlpha : 0;
				vm.postData.rollinginterval = vm.postData.rollInt;
				vm.postData.productName = vm.prodName

				ServiceProxy.postNavCalData(vm.postData).then(sucessCalculate, errorCalculate);

			}
		}

		function downloadInfo() {
			

			var k = 0; 
			var n = 0;

			var dpcount = 0;

			// 	"date , value, rolling interval," + '\n'
			////////////////dpvalues header
			var csvString2 ="";
			while (dpcount != undefined) {
				csvString2 = csvString2.concat(
					vm.model.productNavCalData.dpvalues[k][n].split(':')[0] + ','
				);
				n++;
				dpcount = vm.model.productNavCalData.dpvalues[k][n];
			}

			csvString2 = csvString2 + "date," + "rolling interval," + "\n"
			///////////////// dpvalues header ends
			var dpValueCount = 0
			var l = 0;
			var h = 0;
			var dpValueCountString = []
			var valuestring = ""
			while (dpValueCount != undefined) {
				var arr = []
				for(var  t =0; t < vm.model.productNavCalData.dpvalues[l][h].split(" ").length; t++){
					if(t > 2){
					valuestring = (vm.model.productNavCalData.dpvalues[l][h].split(" ")[t]);
					if(valuestring && valuestring.length !== 1){
						arr.push(valuestring);
					}
					
					}
				}
				dpValueCountString.push(arr)
				h++;
				dpValueCount = vm.model.productNavCalData.dpvalues[l][h];
			}
			///////////////////dpvalues ends
			//add reinfo data
			var count = 0;
			var j = 0;
			var i = 0;
			var infoarr1 = [];
			var infoarr2 = [];

			// while (count != undefined) {
			// 	infoarr1.push(vm.reInfoData[j][i].split(',')[0])
			// 	infoarr2.push(vm.reInfoData[j][i].split(',')[2])
			// 	i++;
			// 	count = vm.reInfoData[j][i];
			// }
			// dpValueCountString.push(infoarr1)
			// dpValueCountString.push(infoarr2)
			// //add reinfo data ends

			// // main arraystring of data
			var sampleString ="";// csvString2;
			// for(var x = 0; x < dpValueCountString[dpValueCountString.length-1].length; x++){
			// 	for(var y = 0; y< dpValueCountString.length; y++){
			// 		sampleString += (dpValueCountString[y][x] == undefined ?"":dpValueCountString[y][x]) +  ",";
			// 	}
			// 	sampleString += "\n"
			// }

			///////////////////

			////ovearll string 
			// var a = $('<a/>', {
			// 	href: 'data:application/octet-stream;base64,' + btoa(sampleString),
			// 	download: vm.postData.productName + '.csv'
			// }).appendTo('body')
			// a[0].click()
			// a.remove();
		}


		/**download excel */
		function sucessdownloadData(response) {
			console.log(response);
			var csvString =
				"Amc Name,Scheme Name,Hurst,Rolling Return,Standard Daviation,Volatility,Downside,Data Point,Total Record,Min Err,Max Err,AARR,TRRE,Interval,Alpha,Return,Return Ranking,Risk,Risk Rating,Ratio,Ratio Ranking,Skew,Kurt,R-Squared,Sortino,Upsite,Downsite,SumClose,1 Year Performance,3 Year Performance,5 Year Performance,10 Year Performance,LogX,LogY,Error Massage," + "\n"

			for (var i = 0; i < response.data.data.length; i++) {
				csvString = csvString.concat(
					response.data.data[i].productAmcName + ","
					+ response.data.data[i].productName + ","
					+ response.data.data[i].hurst + ","
					+ response.data.data[i].rollingreturn + ","
					+ response.data.data[i].stddaviation + ","
					+ response.data.data[i].volatility + ","
					+ response.data.data[i].downsiderisk + ","
					+ response.data.data[i].datapoint + ","
					+ response.data.data[i].totalrecord + ","
					+ response.data.data[i].minrr + ","
					+ response.data.data[i].maxrr + ","
					+ response.data.data[i].aarr + ","
					+ response.data.data[i].totrre + ","
					+ response.data.data[i].interval + ","
					+ response.data.data[i].alpha + ","
					+ response.data.data[i].return + ","
					+ response.data.data[i].returnranking + ","
					+ response.data.data[i].risk + ","
					+ response.data.data[i].riskrating + ","
					+ response.data.data[i].ratio + ","
					+ response.data.data[i].ratioranking + ","
					+ response.data.data[i].skew + ","
					+ response.data.data[i].kurt + ","
					+ response.data.data[i].rsquare + ","
					+ response.data.data[i].sortino + ","
					+ response.data.data[i].upsite + ","
					+ response.data.data[i].downsite + ","
					+ response.data.data[i].sumclose + ","
					+ response.data.data[i].fperformance1 + ","
					+ response.data.data[i].fperformance3 + ","
					+ response.data.data[i].fperformance5 + ","
					+ response.data.data[i].fperformance10 + ","
					+ response.data.data[i].xaxis.trim() + ","
					+ response.data.data[i].yaxis.trim() + ","
					+ response.data.data[i].errmsg + ","
				);
				csvString = csvString + "\n";

			}
			var a = $('<a/>', {
				href: 'data:application/octet-stream;base64,' + btoa(csvString),
				download: 'fund-Analysis' + '.csv'
			}).appendTo('body')
			a[0].click()
			a.remove();

			

		}
		function errordownloadData(response) {
			console.log(response);
		}

		function downloadData() {
			// var date1 = new Date(vm.asonDate.setFullYear(vm.asonDate.getFullYear() - vm.selectedOption));
			// var date2 = new Date(vm.asonDate.setFullYear(vm.asonDate.getFullYear() + vm.selectedOption));
			// vm.postData.fromDate = $filter('date')(date1, "dd/MMM/yyyy")
			// vm.postData.toDate = $filter('date')(date2, "dd/MMM/yyyy")
			vm.postData.flag = "GETRATING";
			var test = "";
			if (vm.checkActRec.length > 0) {
				for (var i = 0; i < vm.checkActRec.length; i++) {
					test += vm.checkActRec[i].productISIN+',';
				}
			}
			vm.postData.productISIN = test;
			ServiceProxy.postNavCalData(vm.postData).then(sucessdownloadData, errordownloadData);
			//}
		}

		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}

		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}


	}
})();

(function () {

	'use strict';

	angular.module('app.nav-calculate').controller('navCalculateController', navCalculateController)
		.directive("limitTo", [function () {
			return {
				restrict: "A",
				link: function (scope, elem, attrs) {
					var limit = parseInt(attrs.limitTo);
					angular.element(elem).on("keypress", function (e) {
						if (parseInt(this.value) == limit) e.preventDefault();
					});
				}
			}
		}]);


	/** @ngInject */
	function navCalculateController($state, $stateParams, $q, StorageService, $scope, $filter, $timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;
		var self = this;

		function init() {
			vm.isincount = 0;
			vm.amcName = '';
			vm.prodName = '';
			vm.recommendation = {};
			vm.getProductData = getProductData;
			vm.getAlpha = getAlpha;
			vm.Calculate = Calculate;
			vm.downloadData = downloadData
			vm.downloadInfo = downloadInfo
			vm.selectEntity = selectEntity;
			vm.selectAll = selectAll;
			vm.amcs = StorageService.getSessionStorage("amcData");
			vm.recommendation = ShareDataService.getData('recommendation');

			vm.postData = {}
			vm.fromDate = null
			vm.toDate = null
			vm.selected = null
			vm.reportType = null
			vm.enabled1 = false
			vm.iinRegex = /^[1-9]{1}[0-9]{9}$/

			self.simulateQuery = false;
			self.isDisabled = false;

			// category autocomplete vars
			self.categories = StorageService.getSessionStorage("categoryData");
			self.selectedItem = null;
			self.searchText = null;
			// category autocomplete vars ends

			vm.model = {};
			vm.model.allItemsSelected = false;
			vm.model.productData = [];
			vm.checkActRec = []
			//date input
			vm.selectedOption = null;
			vm.options = ['3', '5', '10'];
			vm.asonDate = null
			//save to download params
			vm.upsite
			vm.downsite
			vm.getDatefn = getDatefn
			vm.rollingValidate
			vm.sortino
			vm.reInfoData

			// get productFund match
			vm.getMatches = getMatches;
			vm.filteredItems
		}
		init();

		$scope.disabtranLog = function () {
			return (!vm.asonDate || !vm.selectedOption || !vm.postData.rollInt)
		}

		$scope.clearLogs = function () {
			vm.isincount = 0;
			vm.checkActRec = []
			init()
		}



		var sucessProdData = function (response) {
			vm.checkActRec = []
			vm.model.productData = response.data.data;

		}
		var errorProdData = function (response) {
			console.log(response);
		}

		//productFund data
		function getProductData(productMSCategory) {
			if (productMSCategory != undefined) {
				// vm.model.productData = [];
				vm.postData.flag = "PRODUCT";
				vm.postData.productMSCategory = productMSCategory;
				ServiceProxy.postNavCalData(vm.postData).then(sucessProdData, errorProdData);
			}
		}

		// match Categories/funds
		function getMatches(searchText) {
			var result = self.categories;
			var deferred;

			if (searchText) {
				deferred = $q.defer();

				$timeout(function () {
					var states = self.categories.filter(function (state) {
						return (state ? state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 : null);
					});
					deferred.resolve(states);
				}, 1500);

				return deferred.promise;
			} else {
				return result;
			}

		}

		//get start and end date
		function getDatefn(option) {
			if (vm.asonDate && option) {
				vm.selectedOption = parseInt(option)
				var changedDate = vm.asonDate
				// vm.asonDate.setDate(vm.asonDate.getDate() - 1);
				var date1 = new Date(changedDate.setFullYear(changedDate.getFullYear() - vm.selectedOption));
				var date2 = new Date(changedDate.setFullYear(changedDate.getFullYear() + vm.selectedOption));
				//set fromDate minus to one day
				date1.setDate(date1.getDate() - 1);
				vm.postData.fromDate = $filter('date')(date1, "dd/MMM/yyyy")
				vm.postData.toDate = $filter('date')(date2, "dd/MMM/yyyy")
				if (vm.selectedOption == 1) {
					vm.postData.rollInt = 1 * 365;
					vm.rollingValidate = vm.postData.rollInt
				} else if (vm.selectedOption == 3) {
					//	vm.postData.rollInt = 3*365;
					vm.rollingValidate = vm.postData.rollInt
				} else if (vm.selectedOption == 5) {
					//	vm.postData.rollInt = 5*365;
					vm.rollingValidate = vm.postData.rollInt
				} else if (vm.selectedOption == 10) {
					//	vm.postData.rollInt = 10*365;
					vm.rollingValidate = vm.postData.rollInt
				}
					vm.postData.rollInt = 250;
			}
		}


		// get ALPHA
		function getAlpha() {
			// validate Interval
			if (vm.postData.rollInt > vm.rollingValidate) {
				showDialog('Interval should not be more than ' + vm.rollingValidate)
				return
			}

			// validate date
			var todaysDate = new Date()
			var date2 = new Date(vm.asonDate);

			if (todaysDate < date2) {
				showDialog("As-On Date should not be greater than current Date..!!");
				return
			}

			// start getting alpha
			var productISIN = '';

			productISIN = vm.checkActRec[vm.isincount].productISIN;
			vm.amcName = vm.checkActRec[vm.isincount].productAmcName
			vm.prodName = vm.checkActRec[vm.isincount].productName

			if (productISIN != undefined) {
				// vm.postData.flag = "NAV";
				vm.postData.productISIN = productISIN;
				// ServiceProxy.postNavCalData(vm.postData).then(sucessProdNavData, errorProdNavData);
				$('#loading-indicator').show();
				var settings = {
					"async": true,
					"crossDomain": true,
					//"url": "http://192.168.1.169:8084" + "/api/proxy/morningstar/v2/service/mf/r5soaer67qpg88tr/isin/" + productISIN + "/accesscode/",
					"url": "https://sipfund.com" + "/api/proxy/morningstar/v2/service/mf/r5soaer67qpg88tr/isin/" + productISIN + "/accesscode/",
					"method": "GET",
					"headers": {
						"cache-control": "no-cache",
						"postman-token": "31fa9f86-4b6d-281b-7d66-4336ac38223b"
					}
				}

				$.ajax(settings).done(function (response) {
					// var responseData = JSON.parse(response);

					vm.schemeDetail = response.data;
					if (vm.selectedOption == 1) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha1Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside1Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside1Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio1Yr"] : 0
					}

					else if (vm.selectedOption == 3) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha3Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside3Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside3Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio3Yr"] : 0

					}
					else if (vm.selectedOption == 5) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha5Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside5Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside5Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio5Yr"] : 0

					}
					else if (vm.selectedOption == 10) {
						vm.rAlpha = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryAlpha10Yr"] : 0,
							vm.upsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioUpside10Yr"] : 0,
							vm.downsite = vm.schemeDetail ? vm.schemeDetail[0].api["RMC-CategoryCaptureRatioDownside10Yr"] : 0,
							vm.sortino = vm.schemeDetail ? vm.schemeDetail[0].api["RM-SortinoRatio10Yr"] : 0

					}
					vm.fperformance1 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-CategoryReturn1Yr"] : 0;
					vm.fperformance3 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-CategoryReturn3Yr"] : 0;
					vm.fperformance5 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-DP-CategoryReturn5Yr"] : 0;
					vm.fperformance10 = vm.schemeDetail ? vm.schemeDetail[0].api["DP-CategoryReturn10Yr"] : 0;

					//call calculate here
					Calculate(productISIN)
				}).fail(function (response) {
					showDialog("Error Occurred..!!..Timeout from api morningstar");
				});
			}
		}


		// check list elements and select
		function selectEntity(pObj) {
			// If any entity is not checked, then uncheck the "allItemsSelected" checkbox
			for (var i = 0; i < vm.model.productData.length; i++) {
				if (!vm.model.productData[i].isChecked) {
					console.log(pObj)
					if (pObj.isChecked) {
						vm.checkActRec.push(pObj)
					} else {
						var index = vm.checkActRec.indexOf(pObj);
						if (index > -1) {
							vm.checkActRec.splice(index, 1);
						}
					}
					if (vm.checkActRec.length > 0) {
						//vm.getAlpha(vm.checkActRec[0].productISIN);
						vm.checkActRec.filter(function(item, index) { vm.checkActRec.indexOf(item) === index})
						vm.checkActRec.filter(function (e) { return e.isChecked !== false })
						vm.model.allItemsSelected = false;
						return;
					}
				}
			}
		};

		function selectAll(val) {
			// Loop through all the entities and set their isChecked property
			for (var i = 0; i < vm.filteredItems.length; i++) {
				vm.filteredItems[i].isChecked = vm.model.allItemsSelected;
			}
			
			if (val)
				vm.checkActRec = vm.filteredItems
			else
				vm.checkActRec = []
		};
		// check list elements and select ends

		function sucessSaveNavCalcData(respone) {
			console.log(respone);
			if (!(vm.isincount === vm.checkActRec.length - 1)) {
				vm.isincount = vm.isincount + 1;
				vm.getAlpha(vm.isincount);
				vm.downloadInfo();
			}
			else {
				vm.isincount = 0;
				vm.downloadInfo();
				vm.downloadData();
				alert('Records Downloaded Successfully...!!!');
			}
		}

		function errSaveNavCalcData(respone) {
			console.log(respone);

		}

		//save navCalc as excel
		function saveNavCalcData() {
			var trnxBody = {}
			trnxBody.flag = 'SAVERATING';
			trnxBody.trandate = $filter('date')(new Date(), "dd/MMM/yyyy");
			trnxBody.trantime = new Date().getTime();
			trnxBody.isin = vm.postData.productISIN;
			trnxBody.fromdate = vm.postData.fromDate;
			trnxBody.uptodate = vm.postData.toDate;
			trnxBody.rollinginterval = vm.postData.rollInt;

			//api from morning star
			trnxBody.alpha = vm.postData.alpha;
			trnxBody.upsite = vm.upsite;
			trnxBody.downsite = vm.downsite;
			trnxBody.fperformance1 = vm.fperformance1;
			trnxBody.fperformance3 = vm.fperformance3;
			trnxBody.fperformance5 = vm.fperformance5;
			trnxBody.fperformance10 = vm.fperformance10;
			trnxBody.productAmcName = vm.amcName;
			trnxBody.productName = vm.prodName;
			trnxBody.sortino = vm.sortino;
			//from calculate flag responce
			if (vm.model.productNavCalData && vm.model.productNavCalData.code == '1') {
				trnxBody.errmsg = vm.model.productNavCalData.errmsg;
				trnxBody.returnranking = vm.model.productNavCalData.returnranking;
				trnxBody.ratioranking = vm.model.productNavCalData.ratioranking;
				trnxBody.hurst = vm.model.productNavCalData.Hrust;//vm.model.productNavCalData.hurst;
				trnxBody.rollingreturn = vm.model.productNavCalData.XIRR;
				trnxBody.stddaviation = vm.model.productNavCalData.StandardDeviation;
				trnxBody.volatility = vm.model.productNavCalData.Volatility;
				trnxBody.riskrating = '';
				trnxBody.skew = vm.model.productNavCalData.Skew;
				trnxBody.kurt = vm.model.productNavCalData.kurt;
				trnxBody.xaxis = vm.model.productNavCalData.LogX;
				trnxBody.yaxis = vm.model.productNavCalData.LogY;
				trnxBody.rsquare = vm.model.productNavCalData.RSquare;
				trnxBody.datapoint = vm.model.productNavCalData.DataPoints;
				trnxBody.return = vm.model.productNavCalData.Return;
				trnxBody.risk = vm.model.productNavCalData.Risk;
				trnxBody.ratio = vm.model.productNavCalData.Ratio;
				trnxBody.downsiderisk = vm.model.productNavCalData.DownsideRiskCalculation;
				trnxBody.totalrecord = vm.model.productNavCalData.TotalRecord;
				trnxBody.minrr = vm.model.productNavCalData.MinRR;
				trnxBody.maxrr = vm.model.productNavCalData.MaxRR;
				trnxBody.aarr = vm.model.productNavCalData.AARR;
				trnxBody.totrre = vm.model.productNavCalData.TotRRE;
				trnxBody.interval = vm.model.productNavCalData.Interval;
				// trnxBody.deleteflag = vm.isincount == 0 ? 'Y' : 'N';
				trnxBody.sumclose = vm.model.productNavCalData.sumclose;


			}
			else {
				trnxBody.errmsg = vm.model.productNavCalData.errmsg;
				trnxBody.returnranking = "";
				trnxBody.ratioranking = '';
				trnxBody.hurst = ''//vm.model.productNavCalData.hurst;
				trnxBody.rollingreturn = '';
				trnxBody.stddaviation = '';
				trnxBody.volatility = '';
				trnxBody.riskrating = '';
				trnxBody.skew = '';
				trnxBody.kurt = '';
				trnxBody.xaxis = '';
				trnxBody.yaxis = '';
				trnxBody.rsquare = '';
				trnxBody.datapoint = '';
				trnxBody.return = '';
				trnxBody.risk = '';
				trnxBody.ratio = '';
				trnxBody.downsiderisk = '';
				trnxBody.totalrecord = '';
				trnxBody.minrr = '';
				trnxBody.maxrr = '';
				trnxBody.aarr = '';
				trnxBody.totrre = '';
				trnxBody.interval = '';
				// trnxBody.deleteflag = vm.isincount == 0 ? 'Y' : 'N';
			}
			ServiceProxy.postNavCalData(trnxBody).then(sucessSaveNavCalcData, errSaveNavCalcData);


		}

		var sucessCalculate = function (response) {
			vm.model.productNavCalData = response.data.data;
			vm.reInfoData = response.data.data.reinfo;
			if (vm.checkActRec.length == 1 && vm.model.productNavCalData.code == '0') {
				showDialog(vm.model.productNavCalData.errmsg)
				return
			}
			saveNavCalcData()
		}
		var errorCalculate = function (response) {
			console.log(response);
		}

		//calculate flag
		function Calculate(productISIN) {

			if (productISIN != undefined) {
				vm.postData.flag = "CALCULATE";
				vm.postData.productISIN = productISIN;
				vm.postData.alpha = vm.rAlpha ? vm.rAlpha : 0;
				vm.postData.rollinginterval = vm.postData.rollInt;
				vm.postData.productName = vm.prodName

				ServiceProxy.postNavCalData(vm.postData).then(sucessCalculate, errorCalculate);

			}
		}

		function downloadInfo() {
			

			var k = 0; 
			var n = 0;

			var dpcount = 0;

			// 	"date , value, rolling interval," + '\n'
			////////////////dpvalues header
			var csvString2 ="";
			while (dpcount != undefined) {
				csvString2 = csvString2.concat(
					vm.model.productNavCalData.dpvalues[k][n].split(':')[0] + ','
				);
				n++;
				dpcount = vm.model.productNavCalData.dpvalues[k][n];
			}

			csvString2 = csvString2 + "date," + "rolling interval," + "\n"
			///////////////// dpvalues header ends
			var dpValueCount = 0
			var l = 0;
			var h = 0;
			var dpValueCountString = []
			var valuestring = ""
			while (dpValueCount != undefined) {
				var arr = []
				for(var  t =0; t < vm.model.productNavCalData.dpvalues[l][h].split(" ").length; t++){
					if(t > 2){
					valuestring = (vm.model.productNavCalData.dpvalues[l][h].split(" ")[t]);
					if(valuestring && valuestring.length !== 1){
						arr.push(valuestring);
					}
					
					}
				}
				dpValueCountString.push(arr)
				h++;
				dpValueCount = vm.model.productNavCalData.dpvalues[l][h];
			}
			///////////////////dpvalues ends
			//add reinfo data
			var count = 0;
			var j = 0;
			var i = 0;
			var infoarr1 = [];
			var infoarr2 = [];

			while (count != undefined) {
				infoarr1.push(vm.reInfoData[j][i].split(',')[0])
				infoarr2.push(vm.reInfoData[j][i].split(',')[2])
				i++;
				count = vm.reInfoData[j][i];
			}
			dpValueCountString.push(infoarr1)
			dpValueCountString.push(infoarr2)
			//add reinfo data ends

			// main arraystring of data
			var sampleString = csvString2;
			for(var x = 0; x < dpValueCountString[dpValueCountString.length-1].length; x++){
				for(var y = 0; y< dpValueCountString.length; y++){
					sampleString += (dpValueCountString[y][x] == undefined ?"":dpValueCountString[y][x]) +  ",";
				}
				sampleString += "\n"
			}

			///////////////////

			//ovearll string 
			var a = $('<a/>', {
				href: 'data:application/octet-stream;base64,' + btoa(sampleString),
				download: vm.postData.productName + '.csv'
			}).appendTo('body')
			a[0].click()
			a.remove();
		}


		/**download excel */
		function sucessdownloadData(response) {
			console.log(response);
			var csvString =
				"Amc Name,Scheme Name,Hurst,Rolling Return,Standard Daviation,Volatility,Downside,Data Point,Total Record,Min Err,Max Err,AARR,TRRE,Interval,Alpha,Return,Return Ranking,Risk,Risk Rating,Ratio,Ratio Ranking,Skew,Kurt,R-Squared,Sortino,Upsite,Downsite,SumClose,1 Year Performance,3 Year Performance,5 Year Performance,10 Year Performance,LogX,LogY,Error Massage," + "\n"

			for (var i = 0; i < response.data.data.length; i++) {
				csvString = csvString.concat(
					response.data.data[i].productAmcName + ","
					+ response.data.data[i].productName + ","
					+ response.data.data[i].hurst + ","
					+ response.data.data[i].rollingreturn + ","
					+ response.data.data[i].stddaviation + ","
					+ response.data.data[i].volatility + ","
					+ response.data.data[i].downsiderisk + ","
					+ response.data.data[i].datapoint + ","
					+ response.data.data[i].totalrecord + ","
					+ response.data.data[i].minrr + ","
					+ response.data.data[i].maxrr + ","
					+ response.data.data[i].aarr + ","
					+ response.data.data[i].totrre + ","
					+ response.data.data[i].interval + ","
					+ response.data.data[i].alpha + ","
					+ response.data.data[i].return + ","
					+ response.data.data[i].returnranking + ","
					+ response.data.data[i].risk + ","
					+ response.data.data[i].riskrating + ","
					+ response.data.data[i].ratio + ","
					+ response.data.data[i].ratioranking + ","
					+ response.data.data[i].skew + ","
					+ response.data.data[i].kurt + ","
					+ response.data.data[i].rsquare + ","
					+ response.data.data[i].sortino + ","
					+ response.data.data[i].upsite + ","
					+ response.data.data[i].downsite + ","
					+ response.data.data[i].sumclose + ","
					+ response.data.data[i].fperformance1 + ","
					+ response.data.data[i].fperformance3 + ","
					+ response.data.data[i].fperformance5 + ","
					+ response.data.data[i].fperformance10 + ","
					+ response.data.data[i].xaxis.trim() + ","
					+ response.data.data[i].yaxis.trim() + ","
					+ response.data.data[i].errmsg + ","
				);
				csvString = csvString + "\n";

			}
			var a = $('<a/>', {
				href: 'data:application/octet-stream;base64,' + btoa(csvString),
				download: 'fund-Analysis' + '.csv'
			}).appendTo('body')
			a[0].click()
			a.remove();

			

		}
		function errordownloadData(response) {
			console.log(response);
		}

		function downloadData() {
			// var date1 = new Date(vm.asonDate.setFullYear(vm.asonDate.getFullYear() - vm.selectedOption));
			// var date2 = new Date(vm.asonDate.setFullYear(vm.asonDate.getFullYear() + vm.selectedOption));
			// vm.postData.fromDate = $filter('date')(date1, "dd/MMM/yyyy")
			// vm.postData.toDate = $filter('date')(date2, "dd/MMM/yyyy")
			vm.postData.flag = "GETRATING";
			var test = "";
			if (vm.checkActRec.length > 0) {
				for (var i = 0; i < vm.checkActRec.length; i++) {
					test += vm.checkActRec[i].productISIN+',';
				}
			}
			vm.postData.productISIN = test;
			ServiceProxy.postNavCalData(vm.postData).then(sucessdownloadData, errordownloadData);
			//}
		}

		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}

		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}


	}
})();

(function() {
	'use strict';
	angular.module('app.minorTransaction', []).config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		var fId = 'TRANSACTION::CSV::UPLOAD';

		$stateProvider.state('app.minorTransaction', {
			url: '/minortransaction',
			views: {
				'content@app': {
					templateUrl: 'app/main/minor-transaction/minor-transaction.html',
					controller: 'MinorTransactionController as vm'
				}
			},
			data: {
				access: function() {
					if (
						JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
						(window.sessionStorage.getItem('feature') &&
							JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
					) {
						return true;
					} else {
						return false;
					}
				}
			}
		});

		msNavigationServiceProvider.saveItem('TRANSACTION.minorTransaction', {
			title: 'Minor Transactions',
			state: 'app.minorTransaction',
			icon: 'icon-tile-four',
			weight: 2,
			hidden: function() {
				if (
					JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN' ||
					(window.sessionStorage.getItem('feature') &&
						JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1)
				) {
					return false;
				} else {
					return true;
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.minorTransaction').controller('MinorTransactionController', MinorTransactionController);

	function MinorTransactionController($scope, $state, $mdDialog, ServiceProxy, $mdToast, ShareDataService) {
		var vm = this;

		function init() {
			vm.updatePanDialog = updatePanDialog;
			vm.customFilter = customFilter;
			getAllMinorTransactions();
		}
		init();

		function successCbGetAllMinorTransaction(response) {
			vm.allTrxns = response.data.data;
		}

		function errorCbGetAllMinorTransaction(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAllMinorTransactions() {
			ServiceProxy.minorTrasaction().then(successCbGetAllMinorTransaction, errorCbGetAllMinorTransaction);
		}

		function customFilter(search) {
			return function(item) {
				if (!search) return true;
				search = search.toLowerCase();
				return item.investorName && item.investorName.toLowerCase().includes(search) ||
					   item.investorPan && item.investorPan.toLowerCase().includes(search) ||
					   item.iin && item.iin.toLowerCase().includes(search) ||
					   item.transactionNumber && item.transactionNumber.toLowerCase().includes(search) ||
					   item.productName && item.productName.toLowerCase().includes(search) ||
					   item.folioNumber && item.folioNumber.toLowerCase().includes(search);
			};
		}

		function updatePanDialog(user) {
			$mdDialog
				.show({
					locals: {
						data: user
					},
					controller: PanDialogController,
					templateUrl: 'app/main/minor-transaction/minor-transaction-dialog.html',
					parent: angular.element(document.body),
					targetEvent: user,
					clickOutsideToClose: true,
					controllerAs: 'vm'
				})
				.then(
					function (data) {
						console.log('data: ', data);
						if (data) {
							updateTrxnPan(user._id, data);
						}
					},
					function () {}
				);
		}

		function successUpdateTrxnPan(response) {
			showToast(response.data.message);
			getAllMinorTransactions();
		}

		function errorUpdateTrxnPan(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function updateTrxnPan(_id, investorPan) {
			var data = {
				investorPan: investorPan
			};
			ServiceProxy.updateTrxnPan(_id, data).then(successUpdateTrxnPan, errorUpdateTrxnPan);
		}

		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}

		function showToast(msg) {
			var toast = $mdToast
				.simple()
				.textContent(msg)
				.highlightAction(true)
				.highlightClass('md-accent')
				.position('top right');

			$mdToast.show(toast).then(function (response) {
				if (response == 'ok') {
					alert("You clicked the 'UNDO' action.");
				}
			});
		}
	}

	function PanDialogController($mdDialog, $timeout, $mdToast, ServiceProxy, data) {
		var vm = this;

		function init() {
			
			vm.user = data;
			vm.userPan = {
				investorPan: data.investorPan
			};
			vm.hide = function (data) {
				$mdDialog.hide(data);
			};
			vm.saveData = function () {
				vm.hide(vm.userPan.investorPan);
			};
		}
		init();
	}
})();

(function () {
    'use strict';

    angular
        .module('app.assignmentreport', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'INTERNAL::USERS::MANAGEMENT';
        // State
        $stateProvider
            .state('app.assignmentreport', {
                url: '/assignmentreport',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/internaluesr-assignentreport/assignmentreport.html',
                        controller: 'assignmentreportController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                           return false;
                        }
                    }
                }
            });

        // Translation
        // msApiProvider.register('customers', ['app/data/customers/customers.json']);


        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'SAMPLE',
        //     group : true,
        //     weight: 2
        // });

        msNavigationServiceProvider.saveItem('USER.assignmentreport', {
            title: 'Assignment Report',
            icon: 'icon-comment-account',
            state: 'app.assignmentreport',
            weight: 4
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.assignmentreport')
    .controller('assignmentreportController', assignmentreportController);

  /** @ngInject */
  function assignmentreportController($window, $state, $scope, $mdToast, $mdDialog, $q, $timeout, ServiceProxy, $stateParams, StorageService, $filter) {
    var vm = this;
    var postData = {};
    vm.fetchreport = [];
    vm.genrateassignreport = genrateassignreport;
    vm.datereport = datereport;
    vm.downloadReport = downloadReport;
    vm.getrmlist = getrmlist;
    vm.downloadCallHistory = downloadCallHistory;
    vm.downloadDate = new Date();
    vm.eKyc = {
      "01": "UNDER_PROCESS",
      "02": "KYC REGISTERED",
      "03": "ON HOLD",
      "04": "KYC REJECTED",
      "05": "NOT AVAILABLE",
      "06": "Deactivate",
      "07": "KYC VALIDATED",
      "11": "UNDER_PROCESS(OLD record)",
      "12": "KYC REGISTERED(OLD record)",
      "13": "ON HOLD(OLD record)",
      "22": "CVL MF KYC"
    }

    // Retrieve and parse userDetail
    vm.userDetail = JSON.parse(window.sessionStorage.getItem('userDetail'));
    getrmlist();

    function errorGetRmList(response){
      console.log('resErrorGetRmList',response);
    }

    function successGetRmList(response){
      vm.internalUser = response.data.data;
      vm.userDetail.userName = 'ALL';
      vm.internalUser.push(vm.userDetail);
      vm.selectedOption = vm.userDetail;
    }

    function getrmlist(){
        ServiceProxy.getrmlist().then(successGetRmList, errorGetRmList);
    }

    function genrateassignreport() {
      vm.fetchreport = [];
      vm.assign = { toDate: $scope.assign.toDate, fromDate: $scope.assign.fromDate }      
      ServiceProxy.genrateassignreport(vm.assign).then(function (response, err) {        
        vm.fetchreport = response.data.data;

        if(vm.selectedOption.userName !== 'ALL'){
          vm.fetchreport = vm.fetchreport.filter(function (item) {
            return item.assignedDetails.userId === vm.selectedOption._id;
          });
        }
      });
    }

    function datereport() {
      vm.fetchreport = [];
      $scope.assign = {};
      vm.userDetail.userName = 'ALL';
      var datee = new Date();
      $scope.assign.toDate = new Date();
      var fromDate = new Date(datee.setDate(datee.getDate() - 1))
      $scope.assign.fromDate = fromDate;
      vm.assign = { toDate: $scope.assign.toDate, fromDate: $scope.assign.fromDate }      
      ServiceProxy.genrateassignreport(vm.assign).then(function (response, err) {        
        vm.fetchreport = response.data.data;
      });
    }

    function downloadReport() {
      vm.fetchreport = [];
      vm.assign = { toDate: $scope.assign.toDate, fromDate: $scope.assign.fromDate }      
      ServiceProxy.genrateassignreport(vm.assign).then(function (response, err) {        
        vm.fetchreport = response.data.data;
        
        if(vm.selectedOption.userName !== 'ALL'){
          vm.fetchreport = vm.fetchreport.filter(function (item) {
            return item.assignedDetails.userId === vm.selectedOption._id;
          });
        }
        
        if(!vm.fetchreport && vm.fetchreport.length < 1){
          showDialog("No Data Found...!!!");
        }else{
          
          var csvString = 'Name,Mobile,IIN,PAN,KYC Status,Address,Created Date,Report Download Date,Assigned Date, First Call Date, Assigned To,Comments,Platform,' + "\n";
          for(var i=0; i < vm.fetchreport.length; i++){

            var callDateFormatted = (vm.fetchreport[i].callSchedule && vm.fetchreport[i].callSchedule.atDate && !isNaN(new Date(vm.fetchreport[i].callSchedule.atDate).getTime()))
                    ? $filter('date')(new Date(vm.fetchreport[i].callSchedule.atDate), 'dd-MM-yyyy') + ' at ' +
                      (vm.fetchreport[i].callSchedule.atHour > 12 ? (vm.fetchreport[i].callSchedule.atHour - 12) : vm.fetchreport[i].callSchedule.atHour) + ':' +
                      (vm.fetchreport[i].callSchedule.atMinute < 10 ? '0' + vm.fetchreport[i].callSchedule.atMinute : vm.fetchreport[i].callSchedule.atMinute) +
                      (vm.fetchreport[i].callSchedule.atHour > 11 ? ' PM' : ' AM')
                    : "";
                
              csvString = csvString.concat(
                  (vm.fetchreport[i].userName !== undefined  ? vm.fetchreport[i].userName : "") + "," 
                  + vm.fetchreport[i].mobileNo + "," 
                  + vm.fetchreport[i].iin + "," 
                  + (vm.fetchreport[i].pan !== undefined  ? vm.fetchreport[i].pan : "") + ","                   
                  + (vm.fetchreport[i].camsKycStatus !== undefined  ? vm.eKyc[vm.fetchreport[i].camsKycStatus]: "NA") + ","
                  + (vm.fetchreport[i].nseData !== undefined ? vm.fetchreport[i].nseData.CITY : "Not Available")  + ","
                  + $filter('date')(new Date(vm.fetchreport[i].createdAt),'dd-MM-yyyy') + ","
                  + $filter('date')(new Date(),'dd-MM-yyyy') + ","
                  + $filter('date')(new Date(vm.fetchreport[i].assignedDetails.assignedDate),'dd-MM-yyyy') + ","
                  + callDateFormatted + ","
                  + vm.fetchreport[i].assignedDetails.userName + ","
                  + (vm.fetchreport[i].callSchedule && vm.fetchreport[i].callSchedule.comments !== null ? vm.fetchreport[i].callSchedule.comments : "") + ","
                  + vm.fetchreport[i].platform + ","
                  );
              csvString = csvString + "\n";                
            }
            var a = $('<a/>', {
              href:'data:application/octet-stream;base64,'+btoa(unescape(encodeURIComponent(csvString))),
              download:'AssignmentReport.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
        }
      });
    }

    function downloadCallHistory() {
      vm.assign = { toDate: $scope.assign.toDate, fromDate: $scope.assign.fromDate }      
      ServiceProxy.getCallHistory(logDetails.mobileNo).then(function (response, err) {        
        vm.fetchreportHistory = response.data.data;
        
        if(!vm.fetchreportHistory && vm.fetchreportHistory.length < 1){
          showDialog("No Data Found...!!!");
        }else{
          
          var csvString = 'Name,Mobile,IIN,PAN,KYC Status,Address,Created Date,Report Download Date,Assigned Date, First Call Date, Assigned To,Comments,' + "\n";
          for(var i=0; i < vm.fetchreportHistory.length; i++){
                
              csvString = csvString.concat(
                  (vm.fetchreportHistory[i].userName !== undefined  ? vm.fetchreportHistory[i].userName : "") + "," 
                  + vm.fetchreportHistory[i].mobileNo + "," 
                  + vm.fetchreportHistory[i].iin + "," 
                  + (vm.fetchreportHistory[i].pan !== undefined  ? vm.fetchreportHistory[i].pan : "") + ","                   
                  + (vm.fetchreportHistory[i].camsKycStatus !== undefined  ? vm.eKyc[vm.fetchreportHistory[i].camsKycStatus]: "NA") + ","
                  + (vm.fetchreportHistory[i].nseData !== undefined ? vm.fetchreportHistory[i].nseData.CITY : "Not Available")  + ","
                  + $filter('date')(new Date(vm.fetchreportHistory[i].createdAt),'dd-MM-yyyy') + ","
                  + $filter('date')(new Date(),'dd-MM-yyyy') + ","
                  + $filter('date')(new Date(vm.fetchreportHistory[i].assignedDetails.assignedDate),'dd-MM-yyyy \'at\' h:mma') + ","
                  + $filter('date')(new Date(vm.fetchreportHistory[i].callSchedule), 'dd-MM-yyyy') + ' at ' + (vm.fetchreportHistory[i].nextAtHour > 12 ? (vm.fetchreportHistory[i].nextAtHour - 12) : vm.fetchreportHistory[i].nextAtHour) + ':' + (vm.fetchreportHistory[i].nextAtMinute < 10 ? '0' + vm.fetchreportHistory[i].nextAtMinute : vm.fetchreportHistory[i].nextAtMinute) + (vm.fetchreportHistory[i].nextAtHour > 11 ? ' PM' : ' AM') + ","
                  + vm.fetchreportHistory[i].assignedDetails.userName + ","
                  + (vm.fetchreportHistory[i].callSchedule && vm.fetchreportHistory[i].callSchedule.comments !== null ? vm.fetchreportHistory[i].callSchedule.comments : "") + ","
                  );
              csvString = csvString + "\n";                
            }
            var a = $('<a/>', {
              href:'data:application/octet-stream;base64,'+btoa(unescape(encodeURIComponent(csvString))),
              download:'AssignmentReport.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
        }
      });
    }

    vm.showDetails = function(logDetails) {
      ServiceProxy.getCallHistory(logDetails.mobileNo).then(successgetCallHistory, errorgetCallHistory);

      function errorgetCallHistory(response){
        console.log('errorgetCallHistory',response);
      }

      function successgetCallHistory(response) {
        var userName = response.data.data[0].userName;
        var logDetails = response.data.data[0].callSchedules;
        console.log('1',response.data.data[0].callSchedules.length);
        if(response.data.data[0].callSchedules.length < 0){
          showDialog("No Data Found...!!!");
        }
    
        $mdDialog.show({
          controller: DialogController,
          template: 
            '<md-dialog aria-label="Log Details" style="max-width: 800px; width: 100%;">' +
              '<md-dialog-content>' +
                '<h4 style="margin-top: 0;">Call History of:{{userName || ""}}</h4>' + 
                '<table style="width: 100%; border-collapse: collapse;">' +
                  '<thead>' +
                    '<tr>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Calling Date</th>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Comment</th>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Next Date</th>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Called By</th>' +
                    '</tr>' +
                  '</thead>' +
                  '<tbody>' +
                    '<tr ng-repeat="log in logDetails">' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{log.atDate | date:"mediumDate"}} at {{log.atHour > 12 ? (log.atHour - 12):log.atHour }}:{{log.atMinute}} {{log.atHour > 11 ? "PM":"AM"}}</td>' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{ log.comments }}</td>' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{log.nextAtDate | date:"mediumDate"}} at {{log.nextAtHour > 12 ? (log.nextAtHour - 12):log.nextAtHour}}:{{log.nextAtMinute }} {{log.nextAtHour > 11 ? "PM":"AM"}}</td>' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{ log.createdBy.userName }}</td>' +
                    '</tr>' +
                  '</tbody>' +
                '</table>' +
              '</md-dialog-content>' +
              '<md-dialog-actions layout="row">' +
                '<md-button class="md-raised md-accent" ng-click="downloadCallHistory(logDetails)" style="color:#fff !important;">' +
                  '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon> Download Call History' +
                '</md-button>' +
                '<md-button ng-click="closeDialog()" class="md-primary">' +
                  'Close' +
                '</md-button>' +
              '</md-dialog-actions>' +
            '</md-dialog>',
          locals: {
              logDetails: logDetails,
              userName: userName
          },
          clickOutsideToClose: true,
          parent: angular.element(document.body),
          controllerAs: 'vm'
        });        
      }
      
      // Dialog Controller
      function DialogController($scope, $mdDialog, logDetails, userName) {
        $scope.logDetails = logDetails;
        $scope.userName = userName;
        
        $scope.closeDialog = function() {
            $mdDialog.hide();
        };

        $scope.downloadCallHistory = function(log) {
          console.log('1',log);

          if(!log && log.length < 1){
            showDialog("No Data Found...!!!");
          }else{
            var csvString = 'Calling Date, Comment, Next Date, Called By,' + "\n";
              for (var i = 0; i < log.length; i++) { 
                var atDateFormatted = $filter('date')(new Date(log[i].atDate), 'dd-MM-yyyy') + 
                    ' at ' + (log[i].atHour > 12 ? (log[i].atHour - 12) : log[i].atHour) + ':' + 
                    (log[i].atMinute < 10 ? '0' + log[i].atMinute : log[i].atMinute) + 
                    (log[i].atHour > 11 ? ' PM' : ' AM');
            
                var nextAtDateFormatted = $filter('date')(new Date(log[i].nextAtDate), 'dd-MM-yyyy') + 
                    ' at ' + (log[i].nextAtHour > 12 ? (log[i].nextAtHour - 12) : log[i].nextAtHour) + ':' + 
                    (log[i].nextAtMinute < 10 ? '0' + log[i].nextAtMinute : log[i].nextAtMinute) + 
                    (log[i].nextAtHour > 11 ? ' PM' : ' AM');
            
                csvString = csvString.concat(
                    atDateFormatted + ',' +
                    (log[i].comments ? log[i].comments : "") + ',' +
                    nextAtDateFormatted + ',' +
                    (log[i].createdBy && log[i].createdBy.userName ? log[i].createdBy.userName : "") + ','
                );
                csvString = csvString + "\n";                
            }
            var a = $('<a/>', {
              href:'data:application/octet-stream;base64,'+btoa(unescape(encodeURIComponent(csvString))),
              download:'DownloadCallHistory.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          };
        }
      } 
		};

    function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
  }
})();
(function() {
    'use strict';

    angular
        .module('app.logout', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.logout', {
                url: '/logout',
                views: {
                    'content@app': {
                        controller: 'LogoutController as vm'
                    }
                }
            });


        msNavigationServiceProvider.saveItem('SETTING.LOGOUT', {
            title: 'Logout',
            icon: 'icon-logout',
            state: 'app.logout',
            weight: 2
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.logout')
        .controller('LogoutController', LogoutController);

    /** @ngInject */
    function LogoutController($scope, $state, $window, ShareDataService) {
        var vm = this;
        // $window.sessionStorage.removeItem('access_token');
        $window.sessionStorage.clear();
        $state.go('app.auth_login');
        ShareDataService.storeData('allCustomer', null);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.customers')
        .controller('UserDetailController', UserDetailController);

    /** @ngInject */
    function UserDetailController($state, $mdDialog, ShareDataService, StorageService, ServiceProxy) {
        var vm = this;

        function init() {
            vm.StatusCheck = StatusCheck;
            vm.SendIINActivationLink = SendIINActivationLink;
            vm.syncInvestorIIN = syncInvestorIIN;
            vm.kycStatusUpdate = kycStatusUpdate;
            vm.sendResetPassLink = sendResetPassLink;
            vm.resetPassToPan = resetPassToPan;
			vm.customerDetailFunction = customerDetailFunction;
            vm.resetPassLink = resetPassLink;
            vm.sendRelationshipStatusRetrigger = sendRelationshipStatusRetrigger;
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                if (vm.customerDetail === null || vm.customerDetail === undefined) {
                    UserDetails(vm.customerDetail._id);
                } else {
                    vm.userDetail = vm.customerDetail;
                }

            } else {
                $state.go('app.customers');
            }
            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }

            vm.incomeRange = {
                "31": "Below 1 Lakh",
                "32": "> 1 <=5 Lacs",
                "33": ">5 <=10 Lacs",
                "34": ">10 <= 25 Lacs",
                "35": "> 25 Lacs < = 1 Crore",
                "36": "Above 1 Crore"
            }
            vm.accountType = {
                "CC": "Cash/Credit",
                "CA": "Current Account",
                "FCNR": "Foreign Currency Non Resident",
                "NRE": "Non Resident External Account",
                "NRO": "Non Resident Ordinary",
                "OD": "Overdraft Account",
                "PSB": "Post Office Savings Bank Account",
                "SB": "Savings Account"
            }
            vm.residenceType = {
                "1": "Residential or Business",
                "2": "Residential",
                "3": "Business",
                "4": "Registered office",
                "5": "Unspecified"
            }
            vm.placeOfBirth = {
                "WB": "West Bengal",
                "TR": "Tripura",
                "SI": "Sikkim",
                "RA": "Rajasthan",
                "UR": "Uttarakhand",
                "PU": "Punjab",
                "PO": "Puducherry",
                "NA": "Nagaland",
                "GO": "Goa",
                "OT": "Others",
                "DN": "Dadra and Nagar Haveli",
                "OD": "ODISHA",
                "KE": "Kerala",
                "MI": "Mizoram",
                "BH": "Bihar",
                "CH": "Chandigarh",
                "AR": "Arunachal Pradesh",
                "AN": "Andaman and Nicobar Islands",
                "TN": "Tamil Nadu",
                "DD": "Daman and Diu",
                "MP": "Madhya Pradesh",
                "CG": "Chhattisgarh",
                "KA": "Karnataka",
                "AP": "Andhra Pradesh",
                "AS": "Assam",
                "MA": "Maharashtra",
                "GU": "Gujarat",
                "HA": "Haryana",
                "UP": "Uttar Pradesh",
                "HP": "Himachal Pradesh",
                "KR": "Jammu and Kashmir",
                "JD": "Jharkhand",
                "TE": "Telangana",
                "ND": "New Delhi",
                "MN": "Manipur",
                "ME": "Meghalaya"
            }
            vm.getEditEnable = JSON.parse(window.sessionStorage.getItem('feature'));

            if (vm.getEditEnable.length > 0) {
                vm.getEditEnable.forEach(function (element) {
                    if (element == 'INTERNAL::USERS::DASHBOARD') {
                        vm.editEnable = true
                    }
                });
            } else {
                vm.editEnable = false
            }

            vm.getUserType = JSON.parse(window.sessionStorage.getItem('type'));
            if (vm.getUserType == "SUPER::ADMIN") {
                vm.editEnable = true
            }
            bankDetails();
        };

        init();

        function sucessCbUserProfile(response) {
            vm.userDetail = response.data.data;
            ShareDataService.storeData('customerDetail', response.data.data);
            ShareDataService.storeData('baseUrl', response.data.baseUrl);
        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function UserDetails(id) {
            ServiceProxy.getUserProfile(id).then(sucessCbUserProfile, errorGetUserProfile)
        }

        function StatusCheck(iin) {
            ServiceProxy.getActivationStatus(iin).then(sucessCbStatusCheck, errorGetStatusCheck);
        };

        function sucessCbStatusCheck(response) {
            var data = response.data.data;
            if (Array.isArray(data)) {
                vm.kycmatch = 'KYC_NAME_MATCH_STATUS : ' + data[0].KYC_NAME_MATCH_STATUS;
                vm.bankmatch = 'BANK_NAME_MATCH_STATUS : ' + data[0].BANK_NAME_MATCH_STATUS;
                vm.remidation = 'REMIDATION_ACTION : ' + data[0].REMIDATION_ACTION;
            }
            else if (data.Status_Desc) {
                vm.statusval = data.Status_Desc;
            }
        }

        function errorGetStatusCheck(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function SendIINActivationLink(iin) {
            var postData = {
                iin: iin
            }
            ServiceProxy.sendIINActivationLink(postData).then(sucessCbSendIINActivationLink, errorSendIINActivationLink);
        }

        function sucessCbSendIINActivationLink(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function errorSendIINActivationLink(response) {
            if (response && response.data) {
                showDialog(response.data.responseString);
            }
        }

        function sucessgetBankAccount(response) {
            vm.Bank = response.data.data;
        }

        function errorgetBankAccount(response) {
            console.log('Error When Loading the Bank List:', response);
        }

        function bankDetails() {
            ServiceProxy.getBankAccount(vm.customerDetail.iin).then(sucessgetBankAccount, errorgetBankAccount);
        }

        function sendRelationshipStatusRetrigger() {
            var postData = {
                customer_id: vm.customerDetail.iin
            }
            ServiceProxy.sendRelationshipStatusRetrigger(postData).then(sucessCbsendRelationshipStatusRetrigger, errorsendRelationshipStatusRetrigger);
        }

        function sucessCbsendRelationshipStatusRetrigger(response) {
            showDialogSucc(response.data.responseString);

        }

        function errorsendRelationshipStatusRetrigger(response) {
            showDialog(response.data.responseString);
        }

        function syncInvestorIIN() {

            var postData = {};
            postData._id = vm.customerDetail._id;
            postData.userIIN = vm.customerDetail.iin;
            ServiceProxy.syncInvestorIIN(postData).then(sucessCbSyncInvestorIIN, errorCbSyncInvestorIIN)

        };

        function sucessCbSyncInvestorIIN(res) {
            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK');
            
            $mdDialog.show(confirm).then(function() {
                customerDetailFunction();
            });
        }

        function sucessCbUserProfile(response) {
            response.data.baseUrl = vm.baseUrl;
            ShareDataService.storeData('customerDetail', response.data.data);
            if (vm.key === 'Flag') {
                $state.go('app.customers.customerhome.flags');
            } else {
                $state.go('app.customers.customerhome.userDetail');
            }
        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function customerDetailFunction() {
            ServiceProxy.getUserProfile(vm.customerDetail._id).then(sucessCbUserProfile, errorGetUserProfile);
        }

        function errorCbSyncInvestorIIN(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
            $mdDialog.show(confirm);
        };

        function kycStatusUpdate() {
            var postData = {
                pan: vm.customerDetail.pan
            }
            ServiceProxy.kycStatusUpdate(postData).then(sucesskycStatusUpdate, errorkycStatusUpdate);
        }

        function sucesskycStatusUpdate(response) {
            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(response.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK');
            
            $mdDialog.show(confirm).then(function() {
                customerDetailFunction();
            });

        }

        function errorkycStatusUpdate(response) {
            console.log('responseerr', response);
            showDialog(response.data.responseString);
        }

        vm.showDetails = function () {
            ServiceProxy.getrmlist().then(successGetRmList, errorGetRmList);
        
            function errorGetRmList(response) {
                console.log('resErrorGetRmList', response);
            }
        
            function successGetRmList(response) {
                vm.internalUser = response.data.data;
        
                $mdDialog.show({
                    controller: DialogController,
                    template:
                        '<md-dialog aria-label="Log Details" style="max-width: 700px; width: 100%;">' +
                        '<md-dialog-content>' +
                            '<h4 style="margin-top: 0; margin-bottom: 30px">Reassign To:</h4>' +
                            '<md-input-container class="md-block" style="margin: 20px 0">' +
                                '<label>Select An RM Name</label>' +
                                '<md-select ng-model="selectedOption" placeholder="Select An RM Name" ng-change="genrateassignreport()">' +
                                    '<md-option ng-repeat="val in internalUser" ng-value="val">{{ val.userName }}</md-option>' +
                                '</md-select>' +
                            '</md-input-container>' +
                        '</md-dialog-content>' +
                        '<md-dialog-actions layout="row">' +
                            '<md-button class="md-raised md-accent" ng-click="rmReasign()" style="color:#fff !important;">Reassign</md-button>' +
                            '<md-button ng-click="closeDialog()" class="md-primary">Close</md-button>' +
                        '</md-dialog-actions>' +
                        '</md-dialog>',
                    locals: {
                        internalUser: vm.internalUser
                    },
                    clickOutsideToClose: true,
                    parent: angular.element(document.body),
                    controllerAs: 'vm'
                });
            }
        
            function DialogController($scope, $mdDialog, internalUser, ServiceProxy) {
                $scope.internalUser = internalUser;
        
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
        
                $scope.rmReasign = function () {
                    if (!$scope.selectedOption || !$scope.selectedOption._id) {
                        console.log('Error: No valid RM selected or rmUserId is undefined');
                        return;
                    }
        
                    var postData = {
                        mobileNo: vm.customerDetail.mobileNo,
                        RmUserId: $scope.selectedOption._id
                    };
                    ServiceProxy.rmReasign(postData).then(sucessrmReasign, errorrmReasign);
                };
        
                function sucessrmReasign(response) {
                    $scope.closeDialog();
                    console.log('responsesucc', response);
                
                    var confirm = $mdDialog.confirm()
                        .title('Success')
                        .textContent(response.data.responseString)
                        .ariaLabel('Success')
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .ok('OK');
                
                    $mdDialog.show(confirm).then(function() {
                        location.reload();
                    }, function() {
                        console.log('Dialog dismissed');
                    });
                }
        
                function errorrmReasign(response) {
                    $scope.closeDialog();
                    console.log('responseerr', response);
                    showDialog(response.data.responseString);
                }
            }
        };

        function sendResetPassLink() {
            var postData = {
                email: vm.customerDetail.email
            }
            ServiceProxy.forgotPassword(postData).then(sucessforgotPassword, errorforgotPassword);
        }

        function sucessforgotPassword(response) {
            showDialogSucc(response.data.message);

        }

        function errorforgotPassword(response) {
            showDialog(response.data.message);
        }

        function resetPassLink() {
            $mdDialog.show({
                template: '<md-dialog>' +
                            '<md-dialog-content style="padding: 20px;">' +
                                '<h3>Reset Password Options</h3>' +
                                '<p>Please choose an option:</p>' +
                                '<div layout="column" layout-align="center center">' +
                                    '<md-button class="md-raised md-accent" ng-click="sendResetPassLink()" style="color:#fff !important; margin: 10px;">' +
                                        '<md-icon md-font-icon="icon-plus" style="color:#fff;"></md-icon>Send Reset Password Link' +
                                    '</md-button>' +
                                    '<md-button class="md-raised md-accent" ng-click="resetPassToPan()" style="color:#fff !important; margin: 10px;">' +
                                        '<md-icon md-font-icon="icon-plus" style="color:#fff;"></md-icon>Reset Password To PanNo' +
                                    '</md-button>' +
                                '</div>' +
                            '</md-dialog-content>' +
                            '<md-dialog-actions>' +
                                '<md-button ng-click="cancel()" class="md-primary">' +
                                    'Cancel' +
                                '</md-button>' +
                            '</md-dialog-actions>' +
                        '</md-dialog>',
                controller: function($scope, $mdDialog) {
                    $scope.cancel = function() {
                        $mdDialog.hide();
                    };
                    $scope.sendResetPassLink = function() {
                        $mdDialog.hide('send');
                    };
                    $scope.resetPassToPan = function() {
                        $mdDialog.hide('reset');
                    };
                }
            }).then(function(action) {
                if (action === 'send') {
                    vm.sendResetPassLink();
                } else if (action === 'reset') {
                    vm.resetPassToPan();
                }
            });
        }

        function resetPassToPan() {
            $mdDialog.show({
                template: '<md-dialog>' +
                        '<md-dialog-content style="padding: 20px;">' +
                            'Are you sure you want to reset the password to PAN number?' +
                        '</md-dialog-content>' +
                        '<md-dialog-actions>' +
                            '<md-button ng-click="cancel()" class="md-primary">' +
                                'No' +
                            '</md-button>' +
                            '<md-button ng-click="ok()" class="md-primary">' +
                                'Yes' +
                            '</md-button>' +
                        '</md-dialog-actions>' +
                    '</md-dialog>',
                controller: function($scope, $mdDialog) {
                    $scope.cancel = function() {
                        $mdDialog.hide(false);
                    };
                    $scope.ok = function() {
                        $mdDialog.hide(true);
                    };
                }
            }).then(function(confirmed) {
                if (confirmed) {
                    var postData = {
                        mobileNo: vm.customerDetail.mobileNo,
                        password: vm.customerDetail.pan
                    };
                    
                    ServiceProxy.setPasswordasPan(postData).then(sucesssetPasswordasPan, errorsetPasswordasPan);
                }
            });
        }

        function sucesssetPasswordasPan(response) {
            showDialogSucc(response.data.message);
        }

        function errorsetPasswordasPan(response) {
            showDialog(response.data.message);
        }

        vm.openIinStatusDialog = function(ev) {
            $mdDialog.show({
                controller: function($scope, $mdDialog) {
                    $scope.status = null;

                    $scope.cancel = function() {
                        $mdDialog.cancel();
                    };

                    $scope.save = function() {
                        $mdDialog.hide($scope.status);
                    };
                },
                template:
                    '<md-dialog aria-label="Update IIN Status">' +
                        '<form>' +
                            '<md-toolbar>' +
                                '<div class="md-toolbar-tools">' +
                                    '<h2>Update IIN Status</h2>' +
                                '</div>' +
                            '</md-toolbar>' +
                            '<md-dialog-content style="padding:20px;">' +
                                '<p style="margin-bottom: 15px; font-size: 13px; color: #555;">' +
                                    'Please ensure on the NSE portal whether the UCC is <br>activated. If it is active, mark the status as YES.<br> If it is not active, first activate it on NSE and<br> then mark the status as YES.' +
                                '</p>' +
                                '<p>&nbsp;</p>' +
                                '<md-input-container class="md-block">' +
                                    '<label>Select Status</label>' +
                                    '<md-select ng-model="status" placeholder="Choose Yes or No">' +
                                        '<md-option value="YES">YES</md-option>' +
                                        '<md-option value="NO">NO</md-option>' +
                                    '</md-select>' +
                                '</md-input-container>' +
                            '</md-dialog-content>' +
                            '<md-dialog-actions layout="row">' +
                                '<span flex></span>' +
                                '<md-button ng-click="cancel()">Cancel</md-button>' +
                                '<md-button class="md-primary" ng-click="save()" ng-disabled="!status">' +
                                    'Update' +
                                '</md-button>' +
                            '</md-dialog-actions>' +
                        '</form>' +
                    '</md-dialog>',
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function(selectedStatus) {
                if (selectedStatus) {
                    updateIinStatus(selectedStatus);
                }
            });
        };

       function successUpdateIinStatus(response){
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response.data.message)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            
            $mdDialog.show(confirm).then(function() {
                customerDetailFunction();
            });
        }


        function errorUpdateIinStatus(response){
            showDialog(response.data.responseString)
        }

        function updateIinStatus(selectedStatus){
            var postData = {
                client_code: vm.customerDetail.iin,
                status: selectedStatus
            }
            ServiceProxy.updateIinStatus(postData).then(successUpdateIinStatus, errorUpdateIinStatus)
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    }
})();
(function () {
    'use strict';
    angular
        .module('app.customers')
        .controller('UploadDownloadFormController', UploadDownloadFormController);

    /** @ngInject */
    function UploadDownloadFormController($scope, $sce, $state, $location, ServiceProxy, ShareDataService, StorageService, $mdDialog) {
        var vm = this;
        $scope.imageFile = {
            flowObj: {}
        };

        function init() {
            vm.trustSrc = trustSrc;
            vm.documentVerificationStatus = documentVerificationStatus;
            vm.SendemailToNSE = SendemailToNSE;
            
            vm.eKyc = {
                "01": "UNDER_PROCESS",
                "02": "KYC REGISTERED",
                "03": "ON HOLD",
                "04": "KYC REJECTED",
                "05": "NOT AVAILABLE",
                "06": "Deactivate",
                "07": "KYC VALIDATED",
                "11": "UNDER_PROCESS(OLD record)",
                "12": "KYC REGISTERED(OLD record)",
                "13": "ON HOLD(OLD record)",
                "22": "CVL MF KYC"
            }
            vm.eKycType = {
                "0": "Paper Based",
                "1": "Through OTP",
                "2": "Through Biometric"
            }

            vm.userDetail = angular.copy(ShareDataService.getData('customerDetail'));
            if (ShareDataService.getData('baseUrl'))
            {
                //vm.userDetail.baseUrl = ShareDataService.getData('baseUrl');
            }
            if (ShareDataService.getData('customerDetail') == undefined) {
                $state.go('app.customers');
            } else {
                vm.uploadDocument = uploadDocument;
                vm.downloadAll = downloadAll;
                vm.getImagePath = getImagePath;
            }

        };
        init();

        // Image Upload
        $scope.processFile = function (files) {
            var fileReader = new FileReader();
            var validExts = [".jpeg", ".jpg", ".PNG", ".png"];
            
            if (files.length > 1) {
                showDialog("Multiple file selection not allowed!");
                $scope.$apply(function () {
                    $scope.imageFile.flowObj.cancel();
                    $scope.imageFile.flowObj.files = [];
                });
                return false;
            }

            var fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();
            
            // Validate File Extension
            if (validExts.indexOf(fileExt) === -1) {
                showDialog("Invalid file selected, valid files are of " + validExts.toString() + " types.");
                $scope.imageFile.flowObj.cancel();
                $scope.imageFile.flowObj.files = [];
                return false;
            }

            // Validate File Size
            if (files[0].size >= 5242880) {
                showDialog("File size should not be greater than 5MB.");
                $scope.$apply(function () {
                    $scope.imageFile.flowObj.cancel();
                    $scope.imageFile.flowObj.files = [];
                });
                return false;
            }

            // Read and preview the image file (optional)
            fileReader.readAsDataURL(files[0].file);
        };

        // error msg for image
        function showDialog(response) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };

        function showDialogSucc(response) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {});
        };

        // function To upload Blog Image Start
        function sucessUploadDocument(response) {
            showDialogSucc('File uploaded Successfully');
            var newImg = true;
            angular.forEach(vm.userDetail.documents, function (obj) {
                if (obj.docType == response.data.documents.docType) {
                    newImg = false;
                    obj.fileName = response.data.baseUrl + response.data.documents.fileName;
                }
            });
            if (newImg) {
                var tempObj = {};
                tempObj.fileName = response.data.baseUrl + response.data.documents.fileName;
                tempObj.docType = response.data.documents.docType;
                vm.userDetail.documents.push(tempObj);
            }
            $scope.imageFile.flowObj.cancel();
            files[0] = {};
        }

        function errorUploadDocument(response) {
            if (response.data == null) {
                showDialog('File size is too large!');
            } else {
                showDialog(response.data.responseString);
            }
        }

        //  method for document uplaoding
        function uploadDocument(userId) {
            var data = new FormData();
            angular.forEach($scope.imageFile.flowObj.files, function (doc) {
                data.append("document", doc.file);
            });
            ServiceProxy.uploadDocumentImage(data, userId, vm.user.docType).then(sucessUploadDocument, errorUploadDocument);
        }

        // download all file // <a target="_self" href={{docu}} download>
        function downloadAll(urls) {
            var link = document.createElement('a');
            link.setAttribute('target', "_self");
            link.style.display = 'none';
            document.body.appendChild(link);

            for (var i = 0; i < urls.length; i++) {
                link.setAttribute('download', urls[i].docType);
                link.setAttribute('href', urls[i].fileName);
                link.click();
            }

            document.body.removeChild(link);
        }

        //function to document verification     

        function trustSrc(src) {
            return $sce.trustAsResourceUrl(src);
        }

        ///documnet status update api

        function sucessCbDocumentVErificationStatus(response, data) {
            if (data) {
                var docIndex = vm.userDetail.documents.findIndex(function (item) {
                    return item.docType === data.docType
                })

                vm.userDetail.documents[docIndex].comments = data.comments;
                vm.userDetail.documents[docIndex].status = data.status;
            }
        }

        function errorCbDocumentVErificationStatus(response) {
            showDialog(response.data.responseString);
        }
        
        function errorCbUploadDocumenttoNSE(response) {
            // showDialogSucc('Inside Error');
            // showDialog(response.msg);
            showDialog('Broker Custid Mapping Failed');
            // showDialog(response.msg);
        }

        function sucessUploadDocumenttoNSE(data,response) {
            showDialogSucc('File uploaded Successfully');

            // ServiceProxy.documentVerificationStatus(data).then(function (response) {
            //     sucessCbDocumentVErificationStatus(response, data)
            // }, errorCbDocumentVErificationStatus)
        }
        function documentVerificationStatus(docType, status) {
            var data = {
                userId: vm.userDetail._id,
                docType: docType,
                status: status,
                comments: "",
                document:"",
                IIN: vm.userDetail.iin,
                userName: vm.userDetail.userName
            }
            if (status === 'SUBMITTONSE') {  
                // showDialogSucc('Inside SUBMITTONSE');
                //var data = new FormData();
                // angular.forEach($scope.imageFile.flowObj.files, function (doc) {
                //     data.append("document", doc.file);
                // });
                data.document = getImagePath(docType);
                ServiceProxy.uploadDocumentToNSE(data).then(sucessUploadDocumenttoNSE(data), errorCbUploadDocumenttoNSE);

            }
            else if (status === 'CANCELED') {
                var confirm = $mdDialog.prompt()
                    .title('Reason For Rejecting Document.')
                    .placeholder('Enter Reason')
                    .ariaLabel('Reason')
                    .ok('Submit!')
                    .cancel('Cancle');

                $mdDialog.show(confirm).then(function (result) {
                    if (result) {
                        data.comments = result;
                        ServiceProxy.documentVerificationStatus(data).then(function (response) {
                            sucessCbDocumentVErificationStatus(response, data)
                        }, errorCbDocumentVErificationStatus)
                    }
                }, function () {
                    // $scope.status = 'You didn\'t name your dog.';
                });
            } else {
                ServiceProxy.documentVerificationStatus(data).then(function (response) {
                    sucessCbDocumentVErificationStatus(response, data)
                }, errorCbDocumentVErificationStatus)
            }
        }

        function getImagePath(doctype) {
            var returnObj = {};
            var index = vm.userDetail.documents.findIndex(function (item) {
                return item.docType === doctype;
            });
            if (index > -1 && vm.userDetail.documents[index].fileName) {
                returnObj = vm.userDetail.documents[index];
                returnObj.url = vm.userDetail.baseUrl + vm.userDetail.documents[index].fileName;
                //returnObj.url = 'https://sipfund.sfo2.digitaloceanspaces.com/user-docs/' + vm.userDetail.documents[index].fileName;
                // returnObj.url = '/api/user-documents/' + vm.userDetail.documents[index].fileName;
                return returnObj;
            } else {
                returnObj.url = false;
                return returnObj;
            }
        };

        // Send Email to NSE
        function SendemailToNSE(){
            
            var postData = {
                IIN: vm.userDetail.iin,
                userName: vm.userDetail.userName
            }
            ServiceProxy.emailToNSE(postData).then(sucessCbSendemailToNSE, errorSendemailToNSE);
        }

        function sucessCbSendemailToNSE(response) {
            if (response && response.data) {
                // showDialog(response.msg);
                showDialogSucc('Email sent Successfully');
            }
        }

        function errorSendemailToNSE(response) {
            if (response && response.data) {
                // showDialog(response.msg);
                showDialog('Please send email again');
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('swpController', swpController);

        /** @ngInject */
        function swpController($state, $mdDialog, ServiceProxy, ShareDataService, $scope) {
            var vm = this;
    
            function init() {
                if (ShareDataService.getData('customerDetail')) {
                    vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                    vm.transactions = [];
                    vm.allHoldings = [];
                    vm.schemeList = [];
                    vm.frequencyArray = [];
                    vm.sipDateArray = [];
                    vm.instrm_amount = 0;
                    vm.folioList = [];
                    investorHoldings(vm.customerDetail.pan);
                    vm.sip_amount = '';
                } else {
                    $state.go('app.customers');
                }
            }
            init();
            
            vm.onCheckChange = function(holding) {
                if (vm.transactions.length >= 10) {
                    showDialog('You cannot add more than 10 transactions.');
                    return;
                }

                if (holding.isChecked) {
                    holding.redemptionType = 'AMOUNT';
                    for (var i = 0; i < vm.allHoldings.length; i++) {
                        var h = vm.allHoldings[i];
                        if (h !== holding) {
                            h.isChecked = false;
                            h.schemeList = [];
                        }
                    }
                    vm.getAllScheme(holding.AMC_CODE);
                } else {
                    holding.schemeList = [];
                }
            };    

            function successgetAllScheme(response) {
                for (var i = 0; i < vm.allHoldings.length; i++) {
                    var holding = vm.allHoldings[i];
                    if (holding.isChecked) {
                        holding.schemeList = response.data.Data.product_master;
                        break;
                    }
                }
            }
        
            function errorgetAllScheme(response) {
                console.error(response.data.message);
            }
        
            vm.getAllScheme = function(id) {
                ServiceProxy.getAllScheme(id).then(successgetAllScheme, errorgetAllScheme);
            };

            function successinvestorHoldings(response) {
                console.log('res', response.data.responseString);
                vm.allHoldings = response.data.responseString
                .map(function(item) {
                        item.splitSwpDates = item.nseSchemeDetails.swpDates ? item.nseSchemeDetails.swpDates.split(',') : [];
                        item.splitSystematicFrequencies = item.nseSchemeDetails.systematicFrequencies ? item.nseSchemeDetails.systematicFrequencies.split(',') : [];
                        return item;
                    });
                    
                console.log('vm.allHoldings', vm.allHoldings);
            }        

            function errorinvestorHoldings(response) {
                showDialog(response.data.msg);
            }

            function investorHoldings(postData) {
                var postData = {
                    'pan': postData
                }
                ServiceProxy.investorHoldings(postData).then(successinvestorHoldings, errorinvestorHoldings);
            }
    
            vm.selectScheme = function(id) {
                vm.reinvest = id.REINVEST_TAG;

                if (id.SIP_DATES) {
                    vm.sipDatesArray = id.SIP_DATES.split(',');
    
                    vm.sipDateArray = [];
    
                    for (var i = 0; i < vm.sipDatesArray.length; i++) {
                        var sipDate = vm.sipDatesArray[i];
    
                        vm.sipDateArray.push(sipDate);
                    }

                } else {
                    vm.sipDateArray = [];
                }
    
                if (id.SYSTEMATIC_FREQUENCIES) {
    
                    vm.sysFreqArray = id.SYSTEMATIC_FREQUENCIES.split(',');
    
                    vm.frequencyArray = [];
    
                    angular.forEach(vm.freqDataArray, function(data) {
                        angular.forEach(vm.sysFreqArray, function(freqCode) {
                            if (data.code === freqCode) {
                                if (data.code === 'OM') {
                                    vm.sip_freq = data;
                                }
                                vm.frequencyArray.push(data);
                            }
                        });
                    });

                } else {
                    vm.frequencyArray = [];
                }
            };

            vm.formatDateToCustom = function(dateString) {
                var date = new Date(dateString);
                
                if (isNaN(date)) {
                    return '';
                }

                var day = ('0' + date.getDate()).slice(-2);
                var monthNames = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
                var month = monthNames[date.getMonth()];
                var year = date.getFullYear();
            
                return day + '/' + month + '/' + year;
            };
    
            vm.addTransaction = function(scheme) {

                if (vm.transactions.length === 10) {
                    showDialog('Can not add more then 10 schemes.');
                    return;
                }

                if(scheme.amount_unit > scheme.CURRENT_VALUE){
                    showDialog('Can not add more amount\'s then you have.');
                    return;
                }

                if(scheme.perpetual_flag){
                    scheme.to_date = '31-Dec-2099';
                    scheme.start_date = vm.formatDateToCustom(scheme.start_date);
                    scheme.perpetual_flag = 'Y';
                } else {
                    scheme.to_date = vm.formatDateToCustom(scheme.to_date);
                    scheme.start_date = vm.formatDateToCustom(scheme.start_date);
                    scheme.perpetual_flag = 'N';
                }

                var folioExists = vm.transactions.some(function(transaction) {
                    scheme.redemptionType = 'AMOUNT';
                    return transaction.folio_no === scheme.FOLIO_NO;
                });

                if (folioExists) {
                    showDialog('This scheme is already selected.');
                    return;
                }

                var transformedFrequency = {
                    'OM': 'MONTHLY',
                    'Q': 'QUARTERLY',
                    'OW': 'WEEKLY',
                    'BZ': 'DAILY',
                    'SP': 'DAILY',
                    'WD': 'DAILY',
                    'SM': 'MONTHLY',
                    'D': 'DAILY',
                    'H': 'SEMI-ANNUALLY',
                    'Y': 'ANNUALLY',
                    'TW': 'MONTHLY'
                }[scheme.selectedFrequency] || scheme.selectedFrequency;

                var withdrawalCount = {
                    'WEEKLY': '52',
                    'MONTHLY': '12',
                    'QUARTERLY': '4',
                    'SEMI-ANNUALLY': '2',
                    'ANNUALLY': '1',
                    'DAILY': ''
                }[transformedFrequency] || '';

                var transaction = {
                    sourceSchemeName: scheme.scheme,
                    client_code: vm.customerDetail.iin,
                    scheme_code: scheme.nseProdcode,
                    productAmcName: scheme.nseSchemeDetails.productAmcName,
                    amc: scheme.AMC_CODE,
                    folio_no: scheme.folio_no,
                    product_code: scheme.newSchemeCode,
                    first_order_today: scheme.first_order_today,
                    amt_unit_type: "Amount",
                    installmenamount: scheme.amount_unit,
                    start_date: scheme.start_date,
                    frequency_type: transformedFrequency,
                    period_day: scheme.selectedDate,
                    perpetual_flag: scheme.perpetual_flag,
                    account_no: vm.customerDetail.nseData.AC_NO,
                    no_of_withdrawals: withdrawalCount,    
                    installment_units: ""
                };

                vm.transactions.push(transaction);
                vm.clearForm(scheme);
            };

            vm.deleteTransaction = function(index) {
                var deletedTransaction = vm.transactions[index];
                vm.transactions.splice(index, 1);
                vm.instrm_amount -= deletedTransaction.amount;
            };;
    
            vm.clearForm = function(scheme) {
                scheme.redemptionType = 'AMOUNT';
                scheme.selectedFrequency = '';
                scheme.amount_unit = '';
                scheme.selectedDate = '';
                scheme.start_date = '';
                scheme.to_date = '';
                scheme.perpetual_flag = '';
                scheme.first_order_today = '';
            };

            $scope.isButtonDisabled = function(x) {
                return !(x.amount_unit > 0 && x.selectedFrequency && x.selectedDate && x.start_date);
            };            
            
            // Enhanced function to handle mixed success/failure responses for SWP registration
            function handleSwpRegistrationResponse(response, headerTitle) {
                console.log('Response received:', response);
                
                var data = response && response.data ? response.data : {};
                var rows = data && data.responseData && Array.isArray(data.responseData.reg_data)
                    ? data.responseData.reg_data
                    : [];

                if (!rows || rows.length === 0) {
                    showDialog('No data received from server. Please try again later.');
                    return;
                }

                // Show unified dialog with the provided header
                showSwpRegistrationResultsDialog(rows, headerTitle || 'Success');
                vm.transactions = [];
            }

            // Updated error handler - now handles mixed responses
            function errorsystematicRegistration(response) {
                console.error('Error response:', response);
                
                // Check if this is a server error (non-200 status) or application error
                if (response.status !== 200) {
                    // For status 500, still handle as mixed response if data exists
                    if (response.data && response.data.responseData) {
                        handleSwpRegistrationResponse(response, 'Error');
                    } else {
                        showDialog('Server error occurred. Please try again later.');
                    }
                    return;
                }
                
                // If status is 200, handle as mixed response with Error header
                handleSwpRegistrationResponse(response, 'Error');
            }

            // Updated success handler - now handles mixed responses  
            function successsystematicRegistration(response) {
                console.log('Success response:', response);
                handleSwpRegistrationResponse(response, 'Success');
            }

            // Unified dialog function showing all results with conditional formatting
            function showSwpRegistrationResultsDialog(rows, header) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    locals: {
                        rows: rows || [],
                        header: header || 'Success'
                    },
                    controller: ['$scope', '$mdDialog', 'rows', 'header', function($scope, $mdDialog, rows, header) {
                        $scope.header = header;
                        $scope.rows = rows || [];
                        $scope.close = function() { $mdDialog.hide(); };
                    }],
                    template:
                        '<md-dialog aria-label="SWP Registration Results" style="min-width: 450px;">' +
                        '  <md-dialog-title>' +
                        '    <h4 style="padding: 5px; color: #000000ff; margin: 0;">' +
                        '      {{header}}' +
                        '    </h4>' +
                        '  </md-dialog-title>' +
                        '  <md-dialog-content style="max-height: 400px; overflow-y: auto;">' +
                        '    <div ng-if="!rows.length" style="padding: 16px; text-align: center;">' +
                        '      <p>No details available.</p>' +
                        '    </div>' +
                        '    <md-list ng-if="rows.length">' +
                        '      <md-list-item ng-repeat="r in rows track by $index" style="border-bottom: 1px solid #eee;">' +
                        '        <div style="margin: 8px 0; word-break: break-word; width: 100%;">' +
                        '          <div ng-if="r.reg_status === \'REG_SUCCESS\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
                        '            SWP: {{r.scheme_code || "N/A"}} Success: {{r.reg_remark || "NA"}}' +
                        '          </div>' +
                        '          <div ng-if="r.reg_status === \'REG_FAILED\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
                        '            SWP: {{r.scheme_code || "N/A"}} Error: {{r.reg_remark || "Unknown error"}}' +
                        '          </div>' +
                        '          <div style="font-size: 12px; color: #999; margin-top: 2px;">' +
                        '            Folio: {{r.folio_no || "N/A"}} | Withdrawals: {{r.no_of_withdrawals || "N/A"}} | Start: {{r.start_date || "N/A"}}' +
                        '          </div>' +
                        '        </div>' +
                        '      </md-list-item>' +
                        '    </md-list>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions layout="row" layout-align="end center">' +
                        '    <md-button class="md-primary" ng-click="close()">OK</md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>'
                });
            }
    
            vm.swp = function() {
                vm.purchaseJson = {
                    "reg_data": vm.transactions
                };
                ServiceProxy.systematicRegistrationSwp(vm.purchaseJson).then(successsystematicRegistration, errorsystematicRegistration);
            };
    
            function showDialog(response) {
                var confirm = $mdDialog.confirm()
                    .title('!!Error!!')
                    .textContent(response)
                    .ariaLabel('Error')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm);
            }
    
            function showDialogSucc(response) {
                var confirm = $mdDialog.confirm()
                    .title('Success')
                    .textContent(response)
                    .ariaLabel('Success')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm);
            }
        }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('stpController', stpController);

        /** @ngInject */
        function stpController($state, $mdDialog, ServiceProxy, ShareDataService, $scope) {
            var vm = this;
    
            function init() {
                if (ShareDataService.getData('customerDetail')) {
                    vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                    vm.transactions = [];
                    vm.allHoldings = [];
                    vm.schemeList = [];
                    vm.frequencyArray = [];
                    vm.sipDateArray = [];
                    vm.instrm_amount = 0;
                    vm.folioList = [];
                    investorHoldings(vm.customerDetail.pan);
                    vm.sip_amount = '';
                } else {
                    $state.go('app.customers');
                }
            }
            init();
            
            vm.onCheckChange = function(holding) {
                if (vm.transactions.length >= 10) {
                    showDialog('You cannot add more than 10 transactions.');
                    return;
                }

                if (holding.isChecked) {
                    holding.redemptionType = 'AMOUNT';
                    for (var i = 0; i < vm.allHoldings.length; i++) {
                        var h = vm.allHoldings[i];
                        if (h !== holding) {
                            h.isChecked = false;
                            h.schemeList = [];
                        }
                    }
                    vm.getAllScheme(holding.amc_code);
                } else {
                    holding.schemeList = [];
                }
            };    

            function successgetAllScheme(response) {
                for (var i = 0; i < vm.allHoldings.length; i++) {
                    var holding = vm.allHoldings[i];
                    if (holding.isChecked) {
                        holding.schemeList = response.data.Data.product_master;
                        break;
                    }
                }
            }
        
            function errorgetAllScheme(response) {
                console.error(response.data.message);
            }
        
            vm.getAllScheme = function(id) {
                ServiceProxy.getAllScheme(id).then(successgetAllScheme, errorgetAllScheme);
            };

            function successinvestorHoldings(response) {
                vm.allHoldings = response.data.responseString
                .map(function(item) {
                        item.splitStpDates = item.nseSchemeDetails.stpDates ? item.nseSchemeDetails.stpDates.split(',') : [];
                        item.splitSystematicFrequencies = item.nseSchemeDetails.systematicFrequencies ? item.nseSchemeDetails.systematicFrequencies.split(',') : [];
                        return item;
                    });
            }        

            function errorinvestorHoldings(response) {
                showDialog(response.data.msg);
            }

            function investorHoldings(postData) {
                var postData = {
                    'pan': postData
                }
                ServiceProxy.investorHoldings(postData).then(successinvestorHoldings, errorinvestorHoldings);
            }
    
            vm.selectScheme = function(id) {
                vm.reinvest = id.REINVEST_TAG;

                if (id.SIP_DATES) {
                    vm.sipDatesArray = id.SIP_DATES.split(',');
    
                    vm.sipDateArray = [];
    
                    for (var i = 0; i < vm.sipDatesArray.length; i++) {
                        var sipDate = vm.sipDatesArray[i];
    
                        vm.sipDateArray.push(sipDate);
                    }

                } else {
                    vm.sipDateArray = [];
                }
    
                if (id.SYSTEMATIC_FREQUENCIES) {
    
                    vm.sysFreqArray = id.SYSTEMATIC_FREQUENCIES.split(',');
    
                    vm.frequencyArray = [];
    
                    angular.forEach(vm.freqDataArray, function(data) {
                        angular.forEach(vm.sysFreqArray, function(freqCode) {
                            if (data.code === freqCode) {
                                if (data.code === 'OM') {
                                    vm.sip_freq = data;
                                }
                                vm.frequencyArray.push(data);
                            }
                        });
                    });

                } else {
                    vm.frequencyArray = [];
                }
            };

            vm.formatDateToCustom = function(dateString) {
                var date = new Date(dateString);
                
                if (isNaN(date)) {
                    return '';
                }

                var day = ('0' + date.getDate()).slice(-2);
                var monthNames = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
                var month = monthNames[date.getMonth()];
                var year = date.getFullYear();
            
                return day + '/' + month + '/' + year;
            };
    
            vm.addTransaction = function(scheme) {

                if (vm.transactions.length === 10) {
                    showDialog('Can not add more then 10 schemes.');
                    return;
                }

                if(scheme.amount_unit > scheme.CURRENT_VALUE){
                    showDialog('Can not add more amount\'s then you have.');
                    return;
                }

                if(scheme.perpetual_flag){
                    //scheme.to_date = vm.formatDateToCustom(scheme.to_date);
                    scheme.start_date = vm.formatDateToCustom(scheme.start_date);
                    scheme.perpetual_flag = 'Y';
                } else {
                    //scheme.to_date = vm.formatDateToCustom(scheme.to_date);
                    scheme.start_date = vm.formatDateToCustom(scheme.start_date);
                    scheme.perpetual_flag = 'N';
                }

                var folioExists = vm.transactions.some(function(transaction) {
                    scheme.redemptionType = 'AMOUNT';
                    return transaction.folio_no === scheme.FOLIO_NO;
                });

                if (folioExists) {
                    showDialog('This scheme is already selected.');
                    return;
                }

                var transformedFrequency = {
                    'OM': 'MONTHLY',
                    'Q': 'QUARTERLY',
                    'OW': 'WEEKLY',
                    'BZ': 'DAILY',
                    'SP': 'DAILY',
                    'WD': 'DAILY',
                    'SM': 'MONTHLY',
                    'D': 'DAILY',
                    'H': 'SEMI-ANNUALLY',
                    'Y': 'ANNUALLY',
                    'TW': 'MONTHLY'
                }[scheme.selectedFrequency] || scheme.selectedFrequency;

                var withdrawalCount = {
                    'WEEKLY': '52',
                    'MONTHLY': '12',
                    'QUARTERLY': '4',
                    'SEMI-ANNUALLY': '2',
                    'ANNUALLY': '1',
                    'DAILY': ''
                }[transformedFrequency] || '';

                var transaction = {
                    sourceSchemeName: scheme.scheme,
                    client_code: vm.customerDetail.iin,
                    scheme_code: scheme.nseSchemeDetails.newSchemeCode,
                    from_scheme_code: scheme.nseSchemeDetails.newSchemeCode,
                    productAmcName: scheme.nseSchemeDetails.productAmcName,
                    amc: scheme.AMC_CODE,
                    folio_no: scheme.folio_no,
                    product_code: scheme.newSchemeCode,
                    first_order_today: scheme.first_order_today,
                    amt_unit_type: "Amount",
                    installment_amount: scheme.amount_unit,
                    start_date: scheme.start_date,
                    frequency_type: transformedFrequency,
                    period_day: scheme.selectedDate,
                    perpetual_flag: scheme.perpetual_flag,
                    account_no: vm.customerDetail.nseData.AC_NO,
                    no_of_withdrawals: withdrawalCount,    
                    installment_units: "",
                    buy_sell_type: "FRESH",
                    to_date: '',
                    to_scheme_code: scheme.toProdcode.transfersProductCode,
                    transfersSchemeName: scheme.toProdcode.transfersProductLongName,
                    euin_declaration: "N"
                };

                console.log('Adding transaction:', transaction);

                vm.transactions.push(transaction);
                vm.clearForm(scheme);
            };

            vm.deleteTransaction = function(index) {
                var deletedTransaction = vm.transactions[index];
                vm.transactions.splice(index, 1);
                vm.instrm_amount -= deletedTransaction.amount;
            };;
    
            vm.clearForm = function(scheme) {
                scheme.redemptionType = 'AMOUNT';
                scheme.selectedFrequency = '';
                scheme.amount_unit = '';
                scheme.selectedDate = '';
                scheme.start_date = '';
                scheme.to_date = '';
                scheme.perpetual_flag = '';
                scheme.first_order_today = '';
                scheme.toProdcode = '';
            };

            $scope.isButtonDisabled = function(x) {
                return !(x.amount_unit > 0 && x.selectedFrequency && x.selectedDate && x.start_date);
            };
            
            function handleStpRegistrationResponse(response, headerTitle) {
                console.log('Response received:', response);
                
                var data = response && response.data ? response.data : {};
                var rows = data && data.responseData && Array.isArray(data.responseData.reg_data)
                    ? data.responseData.reg_data
                    : [];

                if (!rows || rows.length === 0) {
                    showDialog('No data received from server. Please try again later.');
                    return;
                }

                showStpRegistrationResultsDialog(rows, headerTitle || 'Success');
                vm.transactions = [];
            }

            function errorsystematicRegistration(response) {
                console.error('Error response:', response);
                
                if (response.status !== 200) {
                    if (response.data && response.data.responseData) {
                        handleStpRegistrationResponse(response, 'Error');
                    } else {
                        showDialog('Server error occurred. Please try again later.');
                    }
                    return;
                }
                
                handleStpRegistrationResponse(response, 'Error');
            }

            function successsystematicRegistration(response) {
                console.log('Success response:', response);
                handleStpRegistrationResponse(response, 'Success');
            }

            function showStpRegistrationResultsDialog(rows, header) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    locals: {
                        rows: rows || [],
                        header: header || 'Success'
                    },
                    controller: ['$scope', '$mdDialog', 'rows', 'header', function($scope, $mdDialog, rows, header) {
                        $scope.header = header;
                        $scope.rows = rows || [];
                        $scope.close = function() { $mdDialog.hide(); };
                    }],
                    template:
                        '<md-dialog aria-label="STP Registration Results" style="min-width: 450px;">' +
                        '  <md-dialog-title>' +
                        '    <h4 style="padding: 5px; color: #000000ff; margin: 0;">' +
                        '      {{header}}' +
                        '    </h4>' +
                        '  </md-dialog-title>' +
                        '  <md-dialog-content style="max-height: 400px; overflow-y: auto;">' +
                        '    <div ng-if="!rows.length" style="padding: 16px; text-align: center;">' +
                        '      <p>No details available.</p>' +
                        '    </div>' +
                        '    <md-list ng-if="rows.length">' +
                        '      <md-list-item ng-repeat="r in rows track by $index" style="border-bottom: 1px solid #eee;">' +
                        '        <div style="margin: 8px 0; word-break: break-word; width: 100%;">' +
                        '          <div ng-if="r.reg_status === \'REG_SUCCESS\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
                        '            STP: {{r.from_scheme_code || "N/A"}} → {{r.to_scheme_code || "N/A"}} Success: {{r.reg_remark || "NA"}}' +
                        '          </div>' +
                        '          <div ng-if="r.reg_status === \'REG_FAILED\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
                        '            STP: {{r.from_scheme_code || "N/A"}} → {{r.to_scheme_code || "N/A"}} Error: {{r.reg_remark || "Unknown error"}}' +
                        '          </div>' +
                        '          <div style="font-size: 12px; color: #999; margin-top: 2px;">' +
                        '            Folio: {{r.folio_no || "N/A"}} | Amount: {{r.installment_amount || "N/A"}} | Start: {{r.start_date || "N/A"}}' +
                        '          </div>' +
                        '        </div>' +
                        '      </md-list-item>' +
                        '    </md-list>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions layout="row" layout-align="end center">' +
                        '    <md-button class="md-primary" ng-click="close()">OK</md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>'
                });
            }
    
            vm.stp = function() {
                vm.purchaseJson = {
                    "reg_data": vm.transactions
                };
                ServiceProxy.systematicRegistrationStp(vm.purchaseJson).then(successsystematicRegistration, errorsystematicRegistration);
            };
    
            function showDialog(response) {
                var confirm = $mdDialog.confirm()
                    .title('!!Error!!')
                    .textContent(response)
                    .ariaLabel('Error')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm);
            }
    
            function showDialogSucc(response) {
                var confirm = $mdDialog.confirm()
                    .title('Success')
                    .textContent(response)
                    .ariaLabel('Success')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm);
            }
        }
})();
(function () {
    'use strict';

    angular
        .module('app.customers')
        .controller('resendLinkController', resendLinkController);

    /** @ngInject */
    function resendLinkController($state, $mdDialog, ServiceProxy, ShareDataService, $scope, $mdSidenav) {
        var vm = this;

        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                vm.shortUrlList = [];
                vm.resendLink = resendLink;
                getShortUrlMaster();
            } else {
                $state.go('app.customers');
            }
        }
        init();

        function successGetShortUrlMaster(response) {
            vm.shortUrlList = response.data.response || [];
            console.log('resSuccess', vm.shortUrlList);
        }

        function errorGetShortUrlMaster(response) {
            console.log('resError', response);
            showDialog('Failed to load product types. Please try again.');
        }

        function getShortUrlMaster() {
            ServiceProxy.getShortUrlMaster().then(successGetShortUrlMaster, errorGetShortUrlMaster);
        }

        function successResendLink(response) {
            console.log('successResendLink', response);
            var message = (response.data && response.data.message) ? response.data.message : 'Resend link sent successfully!';
            showDialogSucc(message);
        }

        function errorResendLink(response) {
            console.log('errorResendLink', response);
            var message = (response.data && response.data.responseString) ? response.data.responseString : 'Failed to resend link. Please try again later.';
            showDialog(message);
        }

        function resendLink() {
            if (!vm.productType) {
                return showDialog('Please select a product type.');
            }
            if (!vm.productRefId) {
                return showDialog('Please Enter a Product Ref Id')
            }
            console.log('product type', vm.productType)
            var postData = {
                productType: vm.productType.productType,
                productRefId: vm.productRefId,
                client_code: vm.customerDetail.iin
            };
            ServiceProxy.resendLink(postData).then(successResendLink, errorResendLink);
        }

         function showDialog(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Sorry...!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog
                .confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () { });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('app.customers')
    .controller('pauseSipController', pauseSipController);

  /** @ngInject */
  function pauseSipController($state, $mdDialog, ServiceProxy, ShareDataService, $scope) {
    var vm = this;

    vm.transactions = [];
    vm.SipDetail = [];

    function init() {
      var cd = ShareDataService.getData('customerDetail');
      if (cd) {
        vm.customerDetail = angular.copy(cd);
        vm.pauseMasterData = [
          { id: 'Y', reason: 'Pause next two installments' },
          { id: 'N', reason: 'Resume from existing pause' }
        ]; 
        getAllDetail(vm.customerDetail.iin);
      } else {
        $state.go('app.customers');
      }
    }
    init();

    function sucessCbAllDetail(response) {
      vm.SipDetail =
        response &&
        response.data &&
        response.data.data &&
        response.data.data.registrationReport
          ? response.data.data.registrationReport
          : [];
    }

    function errorGetAllDetail() {
      showDialog('Unable to fetch SIP details.');
    }

    function getAllDetail(iin) {
      var postData = { client_code: iin };
      ServiceProxy.getAllDetail(postData).then(sucessCbAllDetail, errorGetAllDetail);
    }

    function formatDateYMD(val) {
      if (!val) return '';
      if (angular.isString(val) && /^\d{2}\/\d{2}\/\d{4}$/.test(val)) return val;

      var d = null;

      if (angular.isDate(val)) {
        d = new Date(val.getFullYear(), val.getMonth(), val.getDate());
      } else if (angular.isString(val)) {
        var mYMD = val.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (mYMD) d = new Date(+mYMD[1], +mYMD[2] - 1, +mYMD[3]);

        if (!d) {
          var mDMY = val.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
          if (mDMY) d = new Date(+mDMY[3], +mDMY[2] - 1, +mDMY[1]);
        }

        if (!d) {
          var p = new Date(val);
          if (!isNaN(p)) d = p;
        }
      } else if (typeof val === 'number') {
        var ts = new Date(val);
        if (!isNaN(ts)) d = ts;
      }

      if (!d || isNaN(d)) return '';

      var dd = String(d.getDate()).padStart(2, '0');
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var yyyy = d.getFullYear();
      return dd + '/' + mm + '/' + yyyy;
    }

    vm.addTransaction = function(sip) {
      if (vm.transactions.length === 10) {
        showDialog('Can not add more then 10 schemes.');
        return;
      }

      var sipRegNo = sip.xsip_registration_no || sip.sip_reg_no || '';
      if (!sipRegNo) {
        showDialog('Registration number not available for this SIP.');
        return;
      }

      var eff = formatDateYMD(sip.effective_date);
      if (!eff) {
        showDialog('Please select a valid Effective Date.');
        return;
      }

      if (!sip.pause_flag) {
        showDialog('Please select a valid Pause reason.');
        return;
      }

      var exists = vm.transactions.some(function(t) {
        return t.sip_reg_no === sipRegNo;
      });
      if (exists) {
        showDialog('This SIP is already selected.');
        return;
      }

      var t = {
        scheme_name: sip.scheme_name || '',
        folio_number: sip.folio_number || '',
        sip_reg_no: sipRegNo,
        effective_date: eff,
        remarks: (sip.remarksVal || '').toString().trim(),
        pause_flag: sip.pause_flag || ''
      };

      vm.transactions.push(t);
      sip.effective_date = null;
      sip.remarksVal = '';
      sip.pause_flag = null;
    };

    vm.deleteTransaction = function(index) {
      vm.transactions.splice(index, 1);
    };

    function handlePauseSipResponse(response) {
      var data = response && response.data ? response.data : {};
      var rows = data && data.Data && Array.isArray(data.Data.pause_data) ? data.Data.pause_data : [];

      if (!rows || rows.length === 0) {
        showDialog('No data received from server. Please try again later.');
        return;
      }

      showPauseResultsDialog(rows, 'Success');
      vm.transactions = [];
    }

    function errorsendPauseSipEntry(response) {
      if (response.status !== 200) {
        showDialog('Server Error occurred. Please try again later.');
        return;
      }
      
      handlePauseSipResponse(response);
    }
 
    function successsendPauseSipEntry(response) {
      handlePauseSipResponse(response);
    }

    function showPauseResultsDialog(rows, header) {
      $mdDialog.show({
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          rows: rows || [],
          header: header || 'Success'
        },
        controller: ['$scope', '$mdDialog', 'rows', 'header', function($scope, $mdDialog, rows, header) {
          $scope.header = header;
          $scope.rows = rows || [];
          $scope.close = function() { $mdDialog.hide(); };
        }],
        template:
          '<md-dialog aria-label="Pause SIP Results" style="min-width: 400px;">' +
          '  <md-dialog-title>' +
          '    <h4 style="padding: 5px; color: #000000ff; margin: 0;">' +
          '      {{header}}' +
          '    </h4>' +
          '  </md-dialog-title>' +
          '  <md-dialog-content style="max-height: 400px; overflow-y: auto;">' +
          '    <div ng-if="!rows.length" style="padding: 16px; text-align: center;">' +
          '      <p>No details available.</p>' +
          '    </div>' +
          '    <md-list ng-if="rows.length">' +
          '      <md-list-item ng-repeat="r in rows track by $index" style="border-bottom: 1px solid #eee;">' +
          '        <div style="margin: 8px 0; word-break: break-word; width: 100%;">' +
          '          <div ng-if="r.pause_status === \'SUCCESS\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
          '            SIP: {{r.sip_reg_no || "N/A"}} Success: {{r.pause_remark || "NA"}}' +
          '          </div>' +
          '          <div ng-if="r.pause_status === \'FAILED\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
          '            SIP: {{r.sip_reg_no || "N/A"}} Error: {{r.pause_remark || "Unknown error"}}' +
          '          </div>' +
          '        </div>' +
          '      </md-list-item>' +
          '    </md-list>' +
          '  </md-dialog-content>' +
          '  <md-dialog-actions layout="row" layout-align="end center">' +
          '    <md-button class="md-primary" ng-click="close()">OK</md-button>' +
          '  </md-dialog-actions>' +
          '</md-dialog>'
      });
    }

    vm.pauseSip = function() {
      if (!vm.transactions.length) {
        showDialog('Please add at least one SIP to pause.');
        return;
      }

      var payload = {
        pause_data: vm.transactions.map(function(t) {
          return {
            sip_reg_no: t.sip_reg_no,
            effective_date: t.effective_date,
            pause_flag: t.pause_flag,
            remarks: t.remarks || ''
          };
        })
      };
      ServiceProxy.sendPauseSipEntry(payload).then(successsendPauseSipEntry, errorsendPauseSipEntry);
    };

    function showDialog(message) {
      var confirm = $mdDialog
        .confirm()
        .title('!!Error!!')
        .textContent(message)
        .ariaLabel('Error')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm);
    }

    function showDialogSucc(message) {
      var confirm = $mdDialog
        .confirm()
        .title('Success')
        .textContent(message)
        .ariaLabel('Success')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm);
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('fatcaKycUboReglinkController', fatcaKycUboReglinkController);

        /** @ngInject */
        function fatcaKycUboReglinkController($state, $mdDialog, ServiceProxy, ShareDataService, $scope) {
            var vm = this;
    
            // Initialize the controller
            function init() {
                if (ShareDataService.getData('customerDetail')) {
                    vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));

                    vm.app_income;
                    vm.source_wealth;
                    vm.pep;
                    vm.occupation;
                    vm.data_src;
                    vm.email;
                    vm.countryOfBirth;
                    vm.placeOfBirth;
                    vm.countryTaxRasidency

                    vm.tax_payer_identityno1;
                    vm.id1_type;

                    vm.applicableincomeData;
                    vm.sourceWealthData;
                    vm.occupationData;
                    vm.CountryData;
                    vm.dataSourceData;

                    vm.taxResidency = 'N';
                    vm.id1_type = 'C';
                    vm.countryTaxRasidency = 'IND';
                    vm.taxResidency = 'N';
                    vm.countryOfBirth = 'IND';
                    vm.data_src = 'E';

                    // Initialize the field with the value from customer data or set it empty
                    vm.email = vm.customerDetail && vm.customerDetail.email
                    ? vm.customerDetail.email
                    : '';

                    vm.tax_payer_identityno1 = vm.customerDetail && vm.customerDetail.pan
                    ? vm.customerDetail.pan
                    : '';

                    vm.pepData = [
                        { value: 'Y', description: 'PEP - Yes' },
                        { value: 'N', description: 'If Not PEP - No' },
                        { value: 'R', description: 'Related to PEP' }
                    ];

                    vm.addrTypeData = [
                        { value: '1', description: 'Residential or Business' },
                        { value: '2', description: 'Residential' },
                        { value: '3', description: 'Business' },
                        { value: '4', description: 'Registered office' },
                        { value: '5', description: 'Unspecified' }
                    ];

                    vm.dentificationTypeData = [
                        { value: 'A', description: 'Passport' },
                        { value: 'B', description: 'Election ID Card' },
                        { value: 'C', description: 'PAN Card' },
                        { value: 'D', description: 'ID Card' },
                        { value: 'E', description: 'Driving License' },
                        { value: 'G', description: 'UIDIA / Aadhar letter' },
                        { value: 'H', description: 'NREGA Job Card' },
                        { value: 'O', description: 'Others' },
                        { value: 'X', description: 'Not categorized' },
                        { value: 'T', description: 'TIN [Tax Payer Identification Number]' },
                        { value: 'C1', description: 'Company Identification Number' },
                        { value: 'G1', description: 'US GIIN' },
                        { value: 'E1', description: 'Global Entity Identification Number' }
                    ];

                    vm.countryData = [
                        {value: 'IND', description: 'India'}
                    ];

                    vm.dataSourceData = [
                        {value: 'E', description: 'Email'}
                    ];

                    vm.taxResidencyData = [
                        {value: 'Y', description: 'Yes'},
                        {value: 'N', description: 'No'}
                    ];

                    vm.placeOfBirthData = [
                        { value: "AN", description: "Andaman and Nicobar Islands" },
                        { value: "AP", description: "Andhra Pradesh" },
                        { value: "AR", description: "Arunachal Pradesh" },
                        { value: "AS", description: "Assam" },
                        { value: "BH", description: "Bihar" },
                        { value: "CH", description: "Chandigarh" },
                        { value: "CG", description: "Chhattisgarh" },
                        { value: "DD", description: "Daman and Diu" },
                        { value: "DN", description: "Dadra and Nagar Haveli" },
                        { value: "GO", description: "Goa" },
                        { value: "GU", description: "Gujarat" },
                        { value: "HA", description: "Haryana" },
                        { value: "HP", description: "Himachal Pradesh" },
                        { value: "JD", description: "Jharkhand" },
                        { value: "KR", description: "Jammu and Kashmir" },
                        { value: "KA", description: "Karnataka" },
                        { value: "KE", description: "Kerala" },
                        { value: "LD", description: "Ladakh" },
                        { value: "LP", description: "Lakshadweep" },
                        { value: "MA", description: "Maharashtra" },
                        { value: "MN", description: "Manipur" },
                        { value: "ME", description: "Meghalaya" },
                        { value: "MI", description: "Mizoram" },
                        { value: "NA", description: "Nagaland" },
                        { value: "ND", description: "New Delhi" },
                        { value: "OD", description: "ODISHA" },
                        { value: "OT", description: "Others" },
                        { value: "PU", description: "Punjab" },
                        { value: "RA", description: "Rajasthan" },
                        { value: "SI", description: "Sikkim" },
                        { value: "TE", description: "Telangana" },
                        { value: "TN", description: "Tamil Nadu" },
                        { value: "TR", description: "Tripura" },
                        { value: "UP", description: "Uttar Pradesh" },
                        { value: "UR", description: "Uttarakhand" },
                        { value: "WB", description: "West Bengal" }
                    ];
                    
                    vm.sendfatcaKycUboReglink = sendfatcaKycUboReglink;
                    
                    //vm.getApplicableincome = getApplicableincome;
                    //console.log('Customer Detail:', vm.customerDetail);

                    getApplicableincome();
                } else {
                    $state.go('app.customers');
                }
            }
            init();

            function errorgetApplicableincome(response) {
                
            }

            function successgetApplicableincome(response) {
                vm.applicableincomeData = response.data;
            }
    
            function getApplicableincome() {
                ServiceProxy.getApplicableincome().then(successgetApplicableincome, errorgetApplicableincome);
            }

            var successCallbackOnSourceWealth = function (response) {
                vm.sourceWealthData = response.data;
            };
    
            var getSourceWealth = function () {
                ServiceProxy.getSourceWealth().then(successCallbackOnSourceWealth);
            };
    
            getSourceWealth();

            var successCallbackOnOccupation = function (response) {
                vm.occupationData = response.data;
            };
    
            var getOccupation = function () {
                ServiceProxy.getOccupation().then(successCallbackOnOccupation);
            };
    
            getOccupation();
        
            function successsendfatcaKycUboReglink(response) {
                //console.log(response)
                showDialogSucc(response.data.service_response.Status_Desc);
            }
    
            function errorsendfatcaKycUboReglink(response) {
                //console.log(response)
                showDialog(response.data.service_response.Status_Desc);
            }
    
            function sendfatcaKycUboReglink(){

                // Check Income
                if (!vm.app_income) {
                    showDialog("Please select youe Applicable income.");
                    return;
                }

                // Check wealth
                if (!vm.source_wealth) {
                    showDialog("Please select your Source of Wealth.");
                    return;
                }

                // Check PEP
                if (!vm.pep) {
                    showDialog("Please select youe PEP status.");
                    return;
                }
                
                // Check Occupation
                if (!vm.occupation) {
                    showDialog("Please select an Occupation.");
                    return;
                }

                // Check Data Source
                if (!vm.data_src) {
                    showDialog("Please select an Data Source.");
                    return;
                }

                // Check Data Source
                if (!vm.placeOfBirth) {
                    showDialog("Please select an Place Of Birth.");
                    return;
                }
    
                var postData = {
                    "service_request": {
                        "appln_id": "",
                        "password": "",
                        "broker_code": "",
                        "pan": vm.customerDetail.nseData.FH_PAN_NO,
                        "tax_status": vm.customerDetail.nseData.TAX_STATUS_CODE,
                        "investor_name": vm.customerDetail.nseData.INVESTOR_NAME,
                        "chkExempIndValid": "N",
                        "editor_id": "",
                        "ubo_applicable_count": "0",
                        "iin": vm.customerDetail.nseData.CUSTOMER_ID,
                        "Modification_flag": "Y",
                        "KYC": {
                            "app_income_code": vm.app_income,
                            "net_worth_sign": "",
                            "net_worth": "",
                            "net_worth_date": "",
                            "pep": vm.pep,
                            "occ_code": vm.occupation,
                            "source_wealth": "03",
                            "corp_servs": "01"
                        },
                        "Fatca": {
                            "dob": vm.customerDetail.nseData.DATE_OF_BIRTH,
                            "addr_type": vm.addr_type,
                            "data_src": "E",
                            "log_name": vm.email,
                            "country_of_birth": vm.countryOfBirth,
                            "place_birth": vm.placeOfBirth,
                            "tax_residency": vm.taxResidency,
                            "country_tax_residency1": vm.countryTaxRasidency,
                            "tax_payer_identityno1": vm.tax_payer_identityno1,
                            "id1_type": vm.id1_type,
                            "country_tax_residency2": "",
                            "tax_payer_identityno2": "",
                            "id2_type": "",
                            "country_tax_residency3": "",
                            "tax_payer_identityno3": "",
                            "id3_type": "",
                            "country_tax_residency4": "",
                            "tax_payer_identityno4": "",
                            "id4_type": "",
                            "ffi_drnfe": "N",
                            "nffe_catg": "N",
                            "nature_bus": "",
                            "act_nfe_subcat": "",
                            "stock_exchange": "",
                            "listed_company": "",
                            "us_person": "N",
                            "exemp_code": "",
                            "giin_applicable": "N",
                            "giin": "",
                            "giin_exem_cat": "",
                            "sponcer_availability": "",
                            "sponcer_entity": "",
                            "giin_not_app": "N"
                        },
                        "ubo": {
                            "ubo_applicable": "",
                            "ubo_add1": "",
                            "ubo_add2": "",
                            "ubo_add3": "",
                            "ubo_master_codes": "",
                            "ubo_pan_no": "",
                            "ubo_name": "",
                            "ubo_country_tax_residency": "",
                            "ubo_cob": "",
                            "ubo_cocn": "",
                            "ubo_country": "",
                            "ubo_dob": "",
                            "ubo_father_nam": "",
                            "ubo_gender": "",
                            "ubo_holding_perc": "",
                            "ubo_occ_code": "",
                            "ubo_tel_no": "",
                            "ubo_mobile": "",
                            "ubo_pincode": "",
                            "ubo_city": "",
                            "ubo_state": "",
                            "ubo_add_type": "",
                            "ubo_id_type": "",
                            "ubo_tin_no": "",
                            "ubo_exchange": "",
                            "ubo_isin": "",
                            "ubo_company_name": "",
                            "ubo_category": "",
                            "ubo_pep_flag": "",
                            "ubo_email": "",
                            "ubo_smo_designation": "",
                            "ubo_pob": ""
                        },
                        "npo": {
                            "npo_dcl": "",
                            "npo_rgno": ""
                        }
                    }
                }
    
                console.log('postData', postData);
    
                ServiceProxy.sendfatcaKycUboReglink(postData).then(successsendfatcaKycUboReglink, errorsendfatcaKycUboReglink);
            }
    
            function showDialog(response) {
                var confirm = $mdDialog.confirm()
                    .title('!!Error!!')
                    .textContent(response)
                    .ariaLabel('Error')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm);
            }
    
            function showDialogSucc(response) {
                var confirm = $mdDialog.confirm()
                    .title('Success')
                    .textContent(response)
                    .ariaLabel('Success')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm);
            }
        }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('editCustomersController', editCustomersController);

        /** @ngInject */
        function editCustomersController($state, $mdDialog, ServiceProxy, ShareDataService, $scope, $mdSidenav) {
            var vm = this;

            function init(){
                if (ShareDataService.getData('customerDetail')) {
                    vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                    console.log('vm.customerDetail', vm.customerDetail);
                    vm.mobileNoRegEx = /^[0-9]{10,10}$/;
                    vm.panRegEx = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
                    vm.nameRegEx = /^[a-zA-Z, . ]{2,50}$/;
                    vm.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                    vm.pinRegEx = /^[0-9]{6}$/;
                    vm.stateData = {
                        "AN": "Andaman and Nicobar Islands",
                        "AP": "Andhra Pradesh",
                        "AR": "Arunachal Pradesh",
                        "AS": "Assam",
                        "BH": "Bihar",
                        "CH": "Chandigarh",
                        "CG": "Chhattisgarh",
                        "DD": "Daman and Diu",
                        "DN": "Dadra and Nagar Haveli",
                        "GO": "Goa",
                        "GU": "Gujarat",
                        "HA": "Haryana",
                        "HP": "Himachal Pradesh",
                        "JD": "Jharkhand",
                        "KR": "Jammu and Kashmir",
                        "KA": "Karnataka",
                        "KE": "Kerala",
                        "LD": "Ladakh",
                        "LP": "Lakshadweep",
                        "MA": "Maharashtra",
                        "MN": "Manipur",
                        "ME": "Meghalaya",
                        "MI": "Mizoram",
                        "NA": "Nagaland",
                        "ND": "New Delhi",
                        "OD": "ODISHA",
                        "OT": "Others",
                        "PU": "Punjab",
                        "RA": "Rajasthan",
                        "SI": "Sikkim",
                        "TE": "Telangana",
                        "TN": "Tamil Nadu",
                        "TR": "Tripura",
                        "UP": "Uttar Pradesh",
                        "UR": "Uttarakhand",
                        "WB": "West Bengal"
                    };

                    vm.showCustomerDetails = true;
                    vm.showContactDetails = false;
                    vm.showBankDetails = false;
                    vm.showNomineeDetails = false;

                    /*Customer Details Values Start*/
                    vm.title = (vm.customerDetail.nseData.TITLE && typeof vm.customerDetail.nseData.TITLE === 'string' && vm.customerDetail.nseData.TITLE.trim() !== '') ? vm.customerDetail.nseData.TITLE.trim() : '';
                    vm.name = (vm.customerDetail.nseData.INVESTOR_NAME && typeof vm.customerDetail.nseData.INVESTOR_NAME === 'string' && vm.customerDetail.nseData.INVESTOR_NAME.trim() !== '') ? vm.customerDetail.nseData.INVESTOR_NAME.trim() : '';
                    vm.pan = (vm.customerDetail.nseData.FH_PAN_NO && typeof vm.customerDetail.nseData.FH_PAN_NO === 'string' && vm.customerDetail.nseData.FH_PAN_NO.trim() !== '') ? vm.customerDetail.nseData.FH_PAN_NO.trim() : '';
                    vm.exemption = false;
                    vm.exemptionCategory = '';
                    vm.validPan = (vm.customerDetail.nseData.FH_VALID_PAN && typeof vm.customerDetail.nseData.FH_VALID_PAN === 'string' && vm.customerDetail.nseData.FH_VALID_PAN.trim() !== '') ? vm.customerDetail.nseData.FH_VALID_PAN.trim() : '';
                    vm.panReferanceNo = '';
                    vm.dob = '';
                    vm.showDob = (vm.customerDetail.nseData.DATE_OF_BIRTH && typeof vm.customerDetail.nseData.DATE_OF_BIRTH === 'string' && vm.customerDetail.nseData.DATE_OF_BIRTH.trim() !== '') ? vm.customerDetail.nseData.DATE_OF_BIRTH.trim() : '';
                    vm.holdingNature = (vm.customerDetail.nseData.HOLD_NATURE_DESC && typeof vm.customerDetail.nseData.HOLD_NATURE_DESC === 'string' && vm.customerDetail.nseData.HOLD_NATURE_DESC.trim() !== '') ? vm.customerDetail.nseData.HOLD_NATURE_DESC.trim() : '';
                    vm.taxStatus = (vm.customerDetail.nseData.TAX_STATUS_DESC && typeof vm.customerDetail.nseData.TAX_STATUS_DESC === 'string' && vm.customerDetail.nseData.TAX_STATUS_DESC.trim() !== '') ? vm.customerDetail.nseData.TAX_STATUS_DESC.trim() : '';
                    vm.occupation = (vm.customerDetail.nseData.OCCUPATION_CODE && typeof vm.customerDetail.nseData.OCCUPATION_CODE === 'string' && vm.customerDetail.nseData.OCCUPATION_CODE.trim() !== '') ? vm.customerDetail.nseData.OCCUPATION_CODE.trim() : '';
                    vm.kyc = (vm.customerDetail.nseData.KYC_STATUS && typeof vm.customerDetail.nseData.KYC_STATUS === 'string' && vm.customerDetail.nseData.KYC_STATUS.trim() !== '') ? vm.customerDetail.nseData.KYC_STATUS.trim() : '';
                    vm.dpId = '';
                    vm.investorCkycStat = '';
                    vm.investorCkycReferNo = '';
                    vm.fatherName = (vm.customerDetail.nseData.FATHER_NAME && typeof vm.customerDetail.nseData.FATHER_NAME === 'string' && vm.customerDetail.nseData.FATHER_NAME.trim() !== '') ? vm.customerDetail.nseData.FATHER_NAME.trim() : '';
                    vm.motherName = (vm.customerDetail.nseData.MOTHER_NAME && typeof vm.customerDetail.nseData.MOTHER_NAME === 'string' && vm.customerDetail.nseData.MOTHER_NAME.trim() !== '') ? vm.customerDetail.nseData.MOTHER_NAME.trim() : '';
                    vm.trxnMode = '';
                    vm.iinActivMode = '';
    
                    vm.titleData = ['Mr.', 'Mrs.', 'Ms.', 'M/s.'];
                    vm.exemptionCategoryData;
                    vm.holdingNatureData;
                    vm.taxStatusData;
                    vm.occupationData = [];
                    vm.kycData = [
                        { "CODE": "Y", "DESC": "Yes" },
                        { "CODE": "N", "DESC": "No" }
                    ];
                    /*Customer Details Values End*/
    
                    /*Contact Details Values Start*/
                    vm.address1 = (vm.customerDetail.nseData.ADDRESS1 && typeof vm.customerDetail.nseData.ADDRESS1 === 'string' && vm.customerDetail.nseData.ADDRESS1.trim() !== '') ? vm.customerDetail.nseData.ADDRESS1.trim() : '';
                    vm.address2 = (vm.customerDetail.nseData.ADDRESS2 && typeof vm.customerDetail.nseData.ADDRESS2 === 'string' && vm.customerDetail.nseData.ADDRESS2.trim() !== '') ? vm.customerDetail.nseData.ADDRESS2.trim() : '';
                    vm.address3 = (vm.customerDetail.nseData.ADDRESS3 && typeof vm.customerDetail.nseData.ADDRESS3 === 'string' && vm.customerDetail.nseData.ADDRESS3.trim() !== '') ? vm.customerDetail.nseData.ADDRESS3.trim() : '';
                    vm.pinCode = (vm.customerDetail.nseData.PINCODE && typeof vm.customerDetail.nseData.PINCODE === 'string' && vm.customerDetail.nseData.PINCODE.trim() !== '') ? vm.customerDetail.nseData.PINCODE.trim() : '';
                    vm.city = (vm.customerDetail.nseData.CITY && typeof vm.customerDetail.nseData.CITY === 'string' && vm.customerDetail.nseData.CITY.trim() !== '') ? vm.customerDetail.nseData.CITY.trim() : '';
                    vm.state = (vm.stateData[vm.customerDetail.nseData.STATE] && typeof vm.stateData[vm.customerDetail.nseData.STATE] === 'string' && vm.stateData[vm.customerDetail.nseData.STATE].trim() !== '') ? vm.stateData[vm.customerDetail.nseData.STATE].trim() : '';
                    vm.mobileNo = (vm.customerDetail.nseData.MOBILE_NO && typeof vm.customerDetail.nseData.MOBILE_NO === 'string' && vm.customerDetail.nseData.MOBILE_NO.trim() !== '') ? vm.customerDetail.nseData.MOBILE_NO.trim() : '';
                    vm.email = (vm.customerDetail.nseData.EMAIL && typeof vm.customerDetail.nseData.EMAIL === 'string' && vm.customerDetail.nseData.EMAIL.trim() !== '') ? vm.customerDetail.nseData.EMAIL.trim() : '';

                    vm.nseRelationship = [
                        { "RelationKey": "DC", "RelationValue": "Dependent Children" },
                        { "RelationKey": "PO", "RelationValue": "POA" },
                        { "RelationKey": "SP", "RelationValue": "Spouse" },
                        { "RelationKey": "PM", "RelationValue": "PMS" },
                        { "RelationKey": "DP", "RelationValue": "Dependent Parents" },
                        { "RelationKey": "GD", "RelationValue": "Guardian" },
                        { "RelationKey": "CD", "RelationValue": "Custodian" },
                        { "RelationKey": "SE", "RelationValue": "Self" },
                        { "RelationKey": "DS", "RelationValue": "Dependent Siblings" }
                    ];
                    
                    vm.getRelationKey = getRelationKey;
                    
                    // Function to find and return RelationKey based on RelationValue
                    function getRelationKey(value, relationshipData) {
                        var relation = relationshipData.find(function(rel) {
                            return rel.RelationValue === value;
                        });
                        return relation ? relation.RelationKey : ''; // Return the RelationKey if found, else an empty string
                    }

                    // Set vm.mobileRelation (RelationKey based on MOBILE_REL)
                    if (vm.customerDetail.nseData.MOBILE_REL && typeof vm.customerDetail.nseData.MOBILE_REL === 'string' && vm.customerDetail.nseData.MOBILE_REL.trim() !== '') {
                        var mobileRelValue = vm.customerDetail.nseData.MOBILE_REL.trim();
                        vm.mobileRelation = getRelationKey(mobileRelValue, vm.nseRelationship);
                    } else {
                        vm.mobileRelation = ''; // Default to empty if MOBILE_REL is invalid or empty
                    }

                    // Set vm.emailRelation (RelationKey based on EMAIL_REL)
                    if (vm.customerDetail.nseData.EMAIL_REL && typeof vm.customerDetail.nseData.EMAIL_REL === 'string' && vm.customerDetail.nseData.EMAIL_REL.trim() !== '') {
                        var emailRelValue = vm.customerDetail.nseData.EMAIL_REL.trim();
                        vm.emailRelation = getRelationKey(emailRelValue, vm.nseRelationship);
                    } else {
                        vm.emailRelation = ''; // Default to empty if EMAIL_REL is invalid or empty
                    }

                    vm.rseRelationshipData = [];
                    /*Contact Details Values End*/
    
                    /*Bank Details Values Start*/
                    vm.taxStatusCodeForBank = '01';
                    vm.accountType = (vm.customerDetail.nseData.AC_TYPE && typeof vm.customerDetail.nseData.AC_TYPE === 'string' && vm.customerDetail.nseData.AC_TYPE.trim() !== '') ? vm.customerDetail.nseData.AC_TYPE.trim() : '';
                    vm.accountNo = (vm.customerDetail.nseData.AC_NO && typeof vm.customerDetail.nseData.AC_NO === 'string' && vm.customerDetail.nseData.AC_NO.trim() !== '') ? vm.customerDetail.nseData.AC_NO.trim() : '';
                    vm.ifscCode = (vm.customerDetail.nseData.IFSC_CODE && typeof vm.customerDetail.nseData.IFSC_CODE === 'string' && vm.customerDetail.nseData.IFSC_CODE.trim() !== '') ? vm.customerDetail.nseData.IFSC_CODE.trim() : '';
                    vm.bankName = (vm.customerDetail.nseData.BANK_NAME && typeof vm.customerDetail.nseData.BANK_NAME === 'string' && vm.customerDetail.nseData.BANK_NAME.trim() !== '') ? vm.customerDetail.nseData.BANK_NAME.trim() : '';
                    vm.branchName = (vm.customerDetail.nseData.BRANCH_NAME && typeof vm.customerDetail.nseData.BRANCH_NAME === 'string' && vm.customerDetail.nseData.BRANCH_NAME.trim() !== '') ? vm.customerDetail.nseData.BRANCH_NAME.trim() : '';
                    vm.branchAddress1 = (vm.customerDetail.nseData.BRANCH_ADDRESS1 && typeof vm.customerDetail.nseData.BRANCH_ADDRESS1 === 'string' && vm.customerDetail.nseData.BRANCH_ADDRESS1.trim() !== '') ? vm.customerDetail.nseData.BRANCH_ADDRESS1.trim() : '';
                    vm.branchAddress2 = (vm.customerDetail.nseData.BRANCH_ADDRESS2 && typeof vm.customerDetail.nseData.BRANCH_ADDRESS2 === 'string' && vm.customerDetail.nseData.BRANCH_ADDRESS2.trim() !== '') ? vm.customerDetail.nseData.BRANCH_ADDRESS2.trim() : '';
                    vm.branchAddress3 = (vm.customerDetail.nseData.BRANCH_ADDRESS3 && typeof vm.customerDetail.nseData.BRANCH_ADDRESS3 === 'string' && vm.customerDetail.nseData.BRANCH_ADDRESS3.trim() !== '') ? vm.customerDetail.nseData.BRANCH_ADDRESS3.trim() : '';
                    vm.branchCity = (vm.customerDetail.nseData.BRANCH_CITY && typeof vm.customerDetail.nseData.BRANCH_CITY === 'string' && vm.customerDetail.nseData.BRANCH_CITY.trim() !== '') ? vm.customerDetail.nseData.BRANCH_CITY.trim() : '';
                    vm.branchPincode = (vm.customerDetail.nseData.BRANCH_PINCODE && typeof vm.customerDetail.nseData.BRANCH_PINCODE === 'string' && vm.customerDetail.nseData.BRANCH_PINCODE.trim() !== '') ? vm.customerDetail.nseData.BRANCH_PINCODE.trim() : '';
                    /*Bank Details Values End*/
    
                    /*Nominee Details Value Start*/
                    // Map the NOMINEE_OPTED value to match the CODE in the dropdown
                    vm.wantToAddNominee = (vm.customerDetail.nseData.NOMINEE_OPTED && typeof vm.customerDetail.nseData.NOMINEE_OPTED === 'string' && vm.customerDetail.nseData.NOMINEE_OPTED.trim() !== '') ? (vm.customerDetail.nseData.NOMINEE_OPTED.trim() === 'Yes' ? 'Y' : 'N') : '';
                    //vm.wantToAddNominee = (vm.customerDetail.nseData.NOMINEE_OPTED && typeof vm.customerDetail.nseData.NOMINEE_OPTED === 'string' && vm.customerDetail.nseData.NOMINEE_OPTED.trim() !== '') ? vm.customerDetail.nseData.NOMINEE_OPTED.trim() : '';
                    vm.no_of_nominee = (vm.customerDetail.nseData.NOMINEE_COUNT && typeof vm.customerDetail.nseData.NOMINEE_COUNT === 'string' && vm.customerDetail.nseData.NOMINEE_COUNT.trim() !== '') ? vm.customerDetail.nseData.NOMINEE_COUNT.trim() : '';
                    vm.nominee1_type = (vm.customerDetail.nseData.NOM1TYPE && typeof vm.customerDetail.nseData.NOM1TYPE === 'string' && vm.customerDetail.nseData.NOM1TYPE.trim() !== '') ? vm.customerDetail.nseData.NOM1TYPE.trim() : '';
                    vm.nominee1_name = (vm.customerDetail.nseData.NOM1_NAME && typeof vm.customerDetail.nseData.NOM1_NAME === 'string' && vm.customerDetail.nseData.NOM1_NAME.trim() !== '') ? vm.customerDetail.nseData.NOM1_NAME.trim() : '';
                    vm.nominee1_dob = '';
                    vm.nominee1_showDob = (vm.customerDetail.nseData.NOM1_DATE_OF_BIRTH && typeof vm.customerDetail.nseData.NOM1_DATE_OF_BIRTH === 'string' && vm.customerDetail.nseData.NOM1_DATE_OF_BIRTH.trim() !== '') ? vm.customerDetail.nseData.NOM1_DATE_OF_BIRTH.trim() : '';
                    vm.nominee1_addr1 = (vm.customerDetail.nseData.NOM1_ADDRESS1 && typeof vm.customerDetail.nseData.NOM1_ADDRESS1 === 'string' && vm.customerDetail.nseData.NOM1_ADDRESS1.trim() !== '') ? vm.customerDetail.nseData.NOM1_ADDRESS1.trim() : '';
                    vm.nominee1_addr2 = (vm.customerDetail.nseData.NOM1_ADDRESS2 && typeof vm.customerDetail.nseData.NOM1_ADDRESS2 === 'string' && vm.customerDetail.nseData.NOM1_ADDRESS2.trim() !== '') ? vm.customerDetail.nseData.NOM1_ADDRESS2.trim() : '';
                    vm.nominee1_addr3 = (vm.customerDetail.nseData.NOM1_ADDRESS3 && typeof vm.customerDetail.nseData.NOM1_ADDRESS3 === 'string' && vm.customerDetail.nseData.NOM1_ADDRESS3.trim() !== '') ? vm.customerDetail.nseData.NOM1_ADDRESS3.trim() : '';
                    vm.NOM1_PAN = (vm.customerDetail.nseData.NOM1_PAN && typeof vm.customerDetail.nseData.NOM1_PAN === 'string' && vm.customerDetail.nseData.NOM1_PAN.trim() !== '') ? vm.customerDetail.nseData.NOM1_PAN.trim() : '';
                    vm.nominee1_city = (vm.customerDetail.nseData.NOM1_CITY && typeof vm.customerDetail.nseData.NOM1_CITY === 'string' && vm.customerDetail.nseData.NOM1_CITY.trim() !== '') ? vm.customerDetail.nseData.NOM1_CITY.trim() : '';
                    vm.nominee1_state = (vm.stateData[vm.customerDetail.nseData.NOM1_STATE] && typeof vm.stateData[vm.customerDetail.nseData.NOM1_STATE] === 'string' && vm.stateData[vm.customerDetail.nseData.NOM1_STATE].trim() !== '') ? vm.stateData[vm.customerDetail.nseData.NOM1_STATE].trim() : '';
                    vm.nominee1_pincode = (vm.customerDetail.nseData.NOM1_PINCODE && typeof vm.customerDetail.nseData.NOM1_PINCODE === 'string' && vm.customerDetail.nseData.NOM1_PINCODE.trim() !== '') ? vm.customerDetail.nseData.NOM1_PINCODE.trim() : '';
                    vm.nominee1_relation = (vm.customerDetail.nseData.NOM1_RELATION && typeof vm.customerDetail.nseData.NOM1_RELATION === 'string' && vm.customerDetail.nseData.NOM1_RELATION.trim() !== '') ? vm.customerDetail.nseData.NOM1_RELATION.trim() : '';
                    vm.nominee1_percent = (vm.customerDetail.nseData.NOM1_PERCENTAGE && typeof vm.customerDetail.nseData.NOM1_PERCENTAGE === 'string' && vm.customerDetail.nseData.NOM1_PERCENTAGE.trim() !== '') ? vm.customerDetail.nseData.NOM1_PERCENTAGE.trim() : '';
                    vm.nominee1_guard_pan = (vm.customerDetail.nseData.NOM1_GUARDIANPAN && typeof vm.customerDetail.nseData.NOM1_GUARDIANPAN === 'string' && vm.customerDetail.nseData.NOM1_GUARDIANPAN.trim() !== '') ? vm.customerDetail.nseData.NOM1_GUARDIANPAN.trim() : '';
                    vm.nominee1_guard_name = (vm.customerDetail.nseData.NOM1_GUARDIAN && typeof vm.customerDetail.nseData.NOM1_GUARDIAN === 'string' && vm.customerDetail.nseData.NOM1_GUARDIAN.trim() !== '') ? vm.customerDetail.nseData.NOM1_GUARDIAN.trim() : '';
                    vm.nominee1_guard_relation = (vm.customerDetail.nseData.NOM1_GUARD_REL && typeof vm.customerDetail.nseData.NOM1_GUARD_REL === 'string' && vm.customerDetail.nseData.NOM1_GUARD_REL.trim() !== '') ? vm.customerDetail.nseData.NOM1_GUARD_REL.trim() : '';
                    /*Nominee Details Value End*/
                
                    vm.bankDetails = {};
                    vm.addressDetails = [];
                    vm.newAccountTypeData = [];
                    vm.verifyCustomersData = {};
                    vm.relationData = [];
                    vm.guardianRelationData = [];
                    vm.cityDetails = [];
                    vm.no_of_nomineeData = [1,2,3];
                    vm.wantToAddNomineeData = [
                        { "CODE": "Y", "DESC": "Yes" },
                        { "CODE": "N", "DESC": "No" }
                    ];
                    
                    //vm.isKycStatusVisible = false;
    
                    vm.calculateAge = calculateAge;
                    vm.getOccupation = getOccupation;
                    vm.getNseRelationship = getNseRelationship;
                    vm.getNewBankAccType = getNewBankAccType;
                    vm.getGuardianRelation = getGuardianRelation;
                    vm.getNomineeRelationship = getNomineeRelationship;
                    vm.editCustomers = editCustomers;
                    vm.openContactDetails = openContactDetails;
                    vm.openBankDetails = openBankDetails;
                    vm.openNomineeDetails = openNomineeDetails;
                    vm.openCustomerDetails = openCustomerDetails;
                    
                } else {
                    $state.go('app.customers');
                }
            };
            init();

            vm.onDateSelected = function () {
                if (vm.dob) {
                    vm.showDob = '';
                }
            };
            
            vm.onDobNomSelected = function () {
                if (vm.nominee1_dob) {
                    vm.nominee1_showDob = ''; // or null, depending on your preference
                }
            };

            vm.formatDate = function(from_date) {
                var dateObj = new Date(from_date);
                var year = dateObj.getFullYear();
                var monthIndex = dateObj.getMonth(); // Months are 0-based
                var day = dateObj.getDate();
            
                // Array of month abbreviations
                var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            
                // Ensure two-digit format for day
                if (day < 10) {
                    day = '0' + day;
                }
            
                // Return date in the format: DD-Mon-YYYY
                return day + '-' + monthNames[monthIndex] + '-' + year;
            };  

            function openCustomerDetails(){
                vm.showCustomerDetails = true;
                vm.showContactDetails = false;
                vm.showBankDetails = false;
                vm.showNomineeDetails = false;
            }

            function openContactDetails(){
                vm.showCustomerDetails = false;
                vm.showContactDetails = true;
                vm.showBankDetails = false;
                vm.showNomineeDetails = false;
            }

            function openBankDetails(){
                vm.showCustomerDetails = false;
                vm.showContactDetails = false;
                vm.showBankDetails = true;
                vm.showNomineeDetails = false;
            }

            function openNomineeDetails(){
                vm.showCustomerDetails = false;
                vm.showContactDetails = false;
                vm.showBankDetails = false;
                vm.showNomineeDetails = true;
            }
    
            function calculateAge(dob) {
                var dobDate = new Date(dob);
                var diff = Date.now() - dobDate.getTime();
                var ageDate = new Date(diff);
                return Math.abs(ageDate.getUTCFullYear() - 1970);
            }

            function getKeyFromValue(obj, value) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key) && obj[key] === value) {
                        return key;
                    }
                }
                return null; // Return null if the value is not found
            }
    
            var successCallbackOnOccupation = function (response) {
                vm.occupationData = response.data;
            };
    
            var getOccupation = function () {
                ServiceProxy.getOccupation().then(successCallbackOnOccupation);
            };
    
            getOccupation();
    
            var successgetNseRelationship = function(response) {
                vm.rseRelationshipData = response.data;
            }
    
            var getNseRelationship = function() {
                ServiceProxy.getNseRelationship().then(successgetNseRelationship);
            }
    
            getNseRelationship();
    
            var successGetBankDetailsFrmIFSC = function(response) {
                console.log('response', response);
                vm.bankDetails = response.data.responseString;
                vm.bankName = response.data.responseString.bankName;
                vm.bankcode = response.data.responseString.bankcode;
                vm.branchName = response.data.responseString.branch;
                vm.branchAddress = response.data.responseString.address;
            };
    
            var errorGetBankDetailsFrmIFSC = function(response) {
                showDialog(response.data.responseString);
            };
    
            vm.getBankDetailsFrmIFSC = function() {
                if (vm.ifscCode && vm.ifscCode.length === 11) {
                    ServiceProxy.getBankDetailsFrmIFSC(vm.ifscCode).then(successGetBankDetailsFrmIFSC, errorGetBankDetailsFrmIFSC);
                }
            };
    
            var successgetNewBankAccType = function(response) {
                
                vm.newAccountTypeData = response.data.response;
            };
    
            var errorgetNewBankAccType = function(response) {
                console.log('vm.newAccountTypeData', response)
            };
    
            var getNewBankAccType = function() {
                ServiceProxy.getNewBankAccType(vm.taxStatusCodeForBank).then(successgetNewBankAccType, errorgetNewBankAccType);
            };
    
            getNewBankAccType();
            
            var successGuardianRelation = function(response){
                vm.guardianRelationData = response.data.responseData;
            }
    
            var errorGuardianRelation = function(response){
                console.log('errorGuardianRelation',response);
            }
    
            var getGuardianRelation = function(){
                ServiceProxy.getGuardianRelation().then(successGuardianRelation, errorGuardianRelation);
            }
    
            getGuardianRelation();            
    
            var successNomineeRelationship = function(response){
                vm.relationData = response.data.responseData;
    
            }
            var errorNomineeRelationship = function(response){
                console.log('errorNomineeRelationship',response);
            }
    
            var getNomineeRelationship = function(){
                ServiceProxy.getNomineeRelationship().then(successNomineeRelationship, errorNomineeRelationship);
            }
    
            getNomineeRelationship();
    
            var successGetStateCityDetailsPinCodeNew = function(response) {
                vm.cityDetails = response.data[0];
                vm.city = response.data[0].cityName;
                vm.state = response.data[0].stateName;
                vm.countryCode = response.data[0].countryCode;
                vm.stateCode = response.data[0].stateCode;
            };
    
            var errorGetStateCityDetailsPinCodeNew = function(response) {
                showDialog(response.data.error);
            };
    
            vm.getStateCityDetailsPinCodeNew = function() {
                if (vm.pinCode && vm.pinCode.length === 6) {
                    ServiceProxy.getStateCityDetailsPinCodeNew(vm.pinCode).then(successGetStateCityDetailsPinCodeNew, errorGetStateCityDetailsPinCodeNew);
                }
            };

            var successGetStateCityDetailsPinCodeNewBank = function(response) {
                vm.branchCity = response.data[0].cityName;
            };
    
            var errorGetStateCityDetailsPinCodeNewBank = function(response) {
                showDialog(response.data.error);
            };
    
            vm.getStateCityDetailsPinCodeNewBank = function() {
                if (vm.pinCode && vm.pinCode.length === 6) {
                    ServiceProxy.getStateCityDetailsPinCodeNew(vm.pinCode).then(successGetStateCityDetailsPinCodeNewBank, errorGetStateCityDetailsPinCodeNewBank);
                }
            };

            var successGetStateCityDetailsPinCodeNewNOM1 = function(response) {
                vm.cityDetails = response.data[0];
                vm.nominee1_city = response.data[0].cityName;
                vm.nominee1_state = response.data[0].stateName;
                vm.nominee1_country_code = response.data[0].countryCode;
                vm.nominee1_state_code = response.data[0].stateCode;
            };
    
            var errorGetStateCityDetailsPinCodeNewNOM1 = function(response) {
                showDialog(response.data.error);
            };

            vm.getStateCityDetailsPinCodeNewNOM1 = function(){
                if (vm.nominee1_pincode && vm.nominee1_pincode.length === 6) {
                    ServiceProxy.getStateCityDetailsPinCodeNew(vm.nominee1_pincode).then(successGetStateCityDetailsPinCodeNewNOM1, errorGetStateCityDetailsPinCodeNewNOM1);
                }
            }

            function getStateCode(input, stateData) {
                // Normalize the input to compare (case insensitive)
                var normalizedInput = input.trim().toLowerCase();
            
                // Check if input is a state code
                if (stateData[normalizedInput.toUpperCase()]) {
                    return normalizedInput.toUpperCase();
                }
            
                // Check if input is a state name
                for (var code in stateData) {
                    if (stateData.hasOwnProperty(code)) {
                        if (stateData[code].toLowerCase() === normalizedInput) {
                            return code;
                        }
                    }
                }
            
                // Return null if no match is found
                return null;
            }            
    
            function successEditCustomer(response) {
                console.log('successEditCustomer', response);
            
                if (response && response.data && response.data.service_response) {
                    var serviceResponse = response.data.service_response;
            
                    // Check if service_response is an array
                    if (Array.isArray(serviceResponse)) {
                        // Extract all return_msg values if it's an array
                        var messages = serviceResponse.map(function (item) {
                            return item.return_msg;
                        });
                        console.log('Extracted Messages (Array):', messages);
                        showDialogSucc(messages.join('\n'));
                    } else if (typeof serviceResponse === 'object') {
                        // Handle the case where service_response is an object
                        var singleMessage = serviceResponse.return_msg;
                        console.log('Extracted Message (Object):', singleMessage);
                        showDialogSucc(singleMessage);
                    } else {
                        console.error('Unexpected service_response structure');
                    }
                } else {
                    console.error('Invalid response structure');
                }
            }            
    
            function errorEditCustomer(response) {
                
                showDialog(response.data.service_response);
            }
    
            function editCustomers() {
    
                vm.pan = vm.pan.toUpperCase();
                vm.NOM1_PAN = vm.NOM1_PAN.toUpperCase()
                if (vm.dob == '') {
                    vm.dob = vm.showDob;
                } else {
                    vm.dob = vm.formatDate(vm.dob);
                }

                if (vm.nominee1_dob == '') {
                    vm.nominee1_dob = vm.nominee1_showDob;
                } else {
                    vm.nominee1_dob = vm.formatDate(vm.nominee1_dob);
                }
    
                var postData = {
                    "service_request": {
                       "appln_id": "",
                       "password": "",
                       "broker_code": "",
                       "iin": vm.customerDetail.nseData.CUSTOMER_ID,
                       "title": vm.title,
                       "inv_name": vm.name,
                       "dob": vm.dob,
                       "occupation": vm.occupation,
                       "mfu_can": "",
                       "dp_id": vm.dpId,
                       "father_name": vm.fatherName,
                       "mother_name": vm.motherName,
                       "addr1": vm.address1,
                       "addr2": vm.address2,
                       "addr3": vm.address3,
                       "city": vm.city,
                       "state": getKeyFromValue(vm.stateData, vm.state),
                       "pincode": vm.pinCode,
                       "country": vm.customerDetail.nseData.COUNTRY,
                       "mobile_no": vm.mobileNo,
                       "res_phone": "",
                       "off_phone": "",
                       "res_fax": "",
                       "off_fax": "",
                       "email": vm.email,
                       "jh1_email": "",
                       "jh1_mobile_no": "",
                       "jh2_email": "",
                       "jh2_mobile_no": "",
                       "nri_addr1": "",
                       "nri_addr2": "",
                       "nri_addr3": "",
                       "nri_city": "",
                       "nri_state": "",
                       "nri_pincode": "",
                       "nri_country": "",
                       "bank_name": vm.bankName,
                       "acc_no": vm.accountNo,
                       "acc_type": vm.accountType,
                       "ifsc_code": vm.ifscCode,
                       "branch_name": vm.branchName,
                       "branch_addr1": vm.branchAddress1,
                       "branch_addr2": vm.branchAddress2,
                       "branch_addr3": vm.branchAddress3,
                       "branch_city": vm.branchCity,
                       "branch_pincode": vm.branchPincode,
                       "branch_country": "IND",
                       "no_of_nominee": vm.no_of_nominee,
                       "nominee1_type": vm.nominee1_type,
                       "nominee1_name": vm.nominee1_name,
                       "nominee1_dob": vm.nominee1_dob,
                       "nominee1_addr1": vm.nominee1_addr1,
                       "nominee1_addr2": vm.nominee1_addr2,
                       "nominee1_addr3": vm.nominee1_addr3,
                       "nominee1_city": vm.nominee1_city,
                       "nominee1_state": getStateCode(vm.nominee1_state, vm.stateData),
                       "nominee1_pincode": vm.nominee1_pincode,
                       "nominee1_relation": vm.nominee1_relation,
                       "nominee1_percent": 100,
                       "nominee1_guard_name": vm.nominee1_guard_name,
                       "nominee1_guard_pan": vm.nominee1_guard_pan,
                       "nominee2_type": "",
                       "nominee2_name": "",
                       "nominee2_dob": "",
                       "nominee2_relation": "",
                       "nominee2_percent": "",
                       "nominee2_guard_name": "",
                       "nominee2_guard_pan": "",
                       "nominee3_type": "",
                       "nominee3_Name": "",
                       "nominee3_dob": "",
                       "nominee3_relation": "",
                       "nominee3_percent": "",
                       "nominee3_guard_name": "",
                       "nominee3_guard_pan": "",
                       "micr_no": "",
                       "guardian_relation": "",
                       "mobile_relation": vm.mobileRelation,
                       "email_relation": vm.emailRelation,
                       "NOM1_PAN": "",
                       "NOM2_PAN": "",
                       "NOM3_PAN": "",
                       "NOMINEE_OPTED": vm.wantToAddNominee,
                       "JH1_MOBILE_RELATION": "",
                       "JH1_EMAIL_RELATION": "",
                       "JH2_MOBILE_RELATION": "",
                       "JH2_EMAIL_RELATION": "",
                       "NOM1_GUARDIAN_RELATION": vm.nominee1_guard_relation,
                       "NOM2_GUARDIAN_RELATION": "",
                       "NOM3_GUARDIAN_RELATION": "",
                       "jh1_dob": "",
                       "jh2_dob": "",
                       "ACC_RELATION": ""
                    }
                }

                //console.log('postData', postData)
                ServiceProxy.editCustomer(postData).then(successEditCustomer, errorEditCustomer);
            }
    
            function showDialog(response) {
                var confirm = $mdDialog
                    .confirm()
                    .title('Sorry...!!')
                    .textContent(response)
                    .ariaLabel('Lucky day')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm).then(function () { });
            }
    
            function showDialogSucc(response) {
                var confirm = $mdDialog
                    .confirm()
                    .title('Success')
                    .textContent(response)
                    .ariaLabel('Lucky day')
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('OK');
                $mdDialog.show(confirm).then(function () { });
            }

        }
})();

(function () {
	'use strict';

	angular.module('app.customers').controller('CustomersController', CustomersController);
	/** @ngInject */
	function CustomersController($state, $mdDialog, ServiceProxy, ShareDataService, StorageService, $timeout) {
		var vm = this;

		function init() {
			// Data
			vm.role = StorageService.getSessionStorage('type');
			vm.features = StorageService.getSessionStorage('feature');
			vm.selected = [];
			vm.currentNavItem = 'INVESTED_CUSTOMER';
			vm.showCAGR = false;
			vm.customerDetailFunction = customerDetailFunction;
			vm.customerDetailFunctioncagr = customerDetailFunctioncagr;
			vm.baseUrl = '';
			vm.gotoFlags = gotoFlags;
			vm.totalCustomer = 0;
			vm.searchText = null;
			vm.eKyc = {
				'01': 'UNDER_PROCESS',
				'02': 'KYC REGISTERED',
				'03': 'ON HOLD',
				'04': 'KYC REJECTED',
				'05': 'NOT AVAILABLE',
				'06': 'Deactivate',
				"07": "KYC VALIDATED",
				'11': 'UNDER_PROCESS(OLD record)',
				'12': 'KYC REGISTERED(OLD record)',
				'13': 'ON HOLD(OLD record)',
				'22': 'CVL MF KYC'
			};
			vm.eKycType = {
				'0': 'Paper Based',
				'1': 'Through OTP',
				'2': 'Through Biometric'
			};
			vm.pagination = {
				page: 1,
				limit: 25,
				pageSize: 25
			};
			// getAllUser();
			vm.serchUser = serchUser;
			// virtual scrolling starts
			vm.DynamicItems = function () {
				this.loadedPages = {};
				this.numItems = 0;
				this.PAGE_SIZE = 25;
				this.after = '';
				this.fetchNumItems_();
			};
			vm.DynamicItems.prototype.getItemAtIndex = function (index) {
				var pageNumber = Math.floor(index / this.PAGE_SIZE);
				var page = this.loadedPages[pageNumber];

				if (page) {
					return page[index % this.PAGE_SIZE];
				} else if (page !== null) {
					this.fetchPage_(pageNumber);
				}
			};
			vm.DynamicItems.prototype.getLength = function () {
				return this.numItems;
			};

			vm.DynamicItems.prototype.fetchPage_ = function (pageNumber) {
				if (vm.search) {
					return;
				}
				// Set the page to null so we know it is already being fetched.
				this.loadedPages[pageNumber] = null;

				this.loadedPages[pageNumber] = [];
				ServiceProxy.getCustmoerBySearch(vm.currentNavItem, pageNumber + 1, this.PAGE_SIZE).then(
					function (response) {
						this.numItems = response.data.total;
						vm.totalCustomer = response.data.total;

						// this.numItems = response.data.data[0].totalCount[0].count;
						// vm.totalCustomer = response.data.data[0].totalCount[0].count;
						
						var items = response.data.data;
						//var items = response.data.data[0].data;

						for (var i in items) {
							this.loadedPages[pageNumber].push(items[i]);
						}
						this.after = 't3_' + items[this.loadedPages[pageNumber].length - 1]._id;
					}.bind(this),
					function (error) {
						if (error && error.data) {
							showDialog(error.data.responseString);
						}
					}
				);
			};

			vm.DynamicItems.prototype.fetchNumItems_ = function () {
				$timeout(angular.noop, 300).then(
					angular.bind(this, function () {
						this.numItems = vm.pagination.pageSize;
					})
				);
			};

			vm.dynamicItems = new vm.DynamicItems();
			vm.customerCount = function (filter) {
				vm.search= null;
				vm.currentNavItem = filter;
				if(filter === 'CAGR_L6')
					vm.showCAGR = true;
				vm.dynamicItems = new vm.DynamicItems();
			};
			vm.downloadUserDetails = downloadUserDetails;	
			vm.getUserType = JSON.parse(window.sessionStorage.getItem('type'));
            if(vm.getUserType == "SUPER::ADMIN"){
                vm.editEnable = true
			}
					
		}
		init();

		// Get All USer Detail Start
		function sucessCbGetAllUser(response) {
			vm.totalCustomer = response.data.total;
			vm.pagination.pageSize = response.data.pages;
			vm.customers = [];
			vm.customers = response.data.data;
			vm.baseUrl = response.data.baseUrl;
		}

		function errorCbGetAllUser(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAllUser() {
			// vm.customers = []
			ServiceProxy.getCustmoerBySearch(vm.currentNavItem, vm.pagination.page, vm.pagination.limit).then(
				sucessCbGetAllUser,
				errorCbGetAllUser
			);
		}

		// Customer Detail Start
		function sucessCbUserProfile(response) {
			response.data.baseUrl = vm.baseUrl;
			ShareDataService.storeData('customerDetail', response.data.data);
			if (vm.key === 'Flag') {
				$state.go('app.customers.customerhome.flags');
				// vm.key = null;
			} else {
				$state.go('app.customers.customerhome.userDetail');
			}
		}

		function errorGetUserProfile(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function customerDetailFunction(customer) {
			ServiceProxy.getUserProfile(customer._id).then(sucessCbUserProfile, errorGetUserProfile);
		}
		function customerDetailFunctioncagr(customer) {
			ServiceProxy.getUserProfile(customer.user._id).then(sucessCbUserProfile, errorGetUserProfile);
		}
		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

		///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
		///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
		function sucessCbSearchUser(response) {
			vm.dynamicItems.loadedPages[0] = response.data.data;
			vm.dynamicItems.numItems = response.data.total;
			vm.dynamicItems.PAGE_SIZE = response.data.total;
			vm.dynamicItems.after = 't3_' + response.data.data[response.data.total - 1]._id;
		}

		function errorCbSearchUser(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function serchUser() {
			vm.currentNavItem = 'ALL_CUSTOMER';
			ServiceProxy.serchUser(vm.search).then(sucessCbSearchUser, errorCbSearchUser);
		}

		function gotoFlags(event, customer, key) {
			vm.key = key;
			event.preventDefault();
			customerDetailFunction(customer);
		}

		function downloadUserDetails() {
			ServiceProxy.downlaodCustDetails(vm.currentNavItem, vm.pagination.page, vm.pagination.limit).then(
				sucessCbDownloadUserDetails,
				errorCbDownloadUserDetails
			);
		}

		function sucessCbDownloadUserDetails(response) {
			vm.logData = response.data.data;
			
			if(vm.logData.length < 1){
				showDialog("No Data Found...!!!");
			}else{
				showDialogSucc(response.data.responseString)
				

				if(vm.currentNavItem != 'CAGR_L6')
				{
					var csvString = 'Name,IIN,UMRN Status,Running SIP,RM Name,Mobile No, Email,CAGR' + "\n";
	        	for(var i=0; i<vm.logData.length;i++){
				// var sipamount;
	        	// if (vm.logData[i].sipbookreportData.length != 0)
				// 	sipamount = vm.logData[i].sipbookreportData[0].customers.sipAmount;
				// else 
				// 	sipamount = 0;
				// sipamount = vm.logData[i].sipAmount;
				
				csvString = csvString.concat(
					vm.logData[i].userName + "," 
					+ vm.logData[i].iin + "," 
					+ (vm.logData[i].achmandateRegFlag ? 'Yes' : 'No') + "," 
					+ vm.logData[i].sipAmount + ","  
					+ vm.logData[i].assignedDetails.userName + ","
					+ vm.logData[i].mobileNo + ","
					+ vm.logData[i].email + ","
					+ vm.logData[i].cagr + ","
					);
				csvString = csvString + "\n";
	        		
			    }
				}
				else{
					var csvString = 'Name,IIN,UMRN Status,Running SIP,RM Name,Mobile No, Email,CAGR' + "\n";
					for(var i=0; i<vm.logData.length;i++){
						// var sipamount;
						// sipamount = vm.logData[i].sipAmount;
						
						csvString = csvString.concat(
							vm.logData[i].user.userName + "," 
							+ vm.logData[i].user.iin + "," 
							+ (vm.logData[i].achmandateRegFlag ? 'Yes' : 'No') + "," 
							+ vm.logData[i].sipAmount + ","  
							+ vm.logData[i].user.assignedDetails.userName + ","
							+ vm.logData[i].user.mobileNo + ","
							+ vm.logData[i].user.email + ","
							+ vm.logData[i].customers.currentCAGR+","
							);
						csvString = csvString + "\n";
							
						}

				}
	         	var a = $('<a/>', {
		            href:'data:application/octet-stream;base64,'+btoa(csvString),
		            download:'userData.csv'
		        }).appendTo('body')
		        a[0].click()
		        a.remove();
			}
		}

		function errorCbDownloadUserDetails(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('CustomerDetailController', CustomerDetailController);

    /** @ngInject */
    function CustomerDetailController($state, $location,$scope, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        function init() {
            // Data
            if (ShareDataService.getData('customerDetail')) {
                vm.tableRowExpanded = false;
                vm.externaltableRowExpanded = false;
                vm.totalInvestment = 0;
                vm.totalCurrentValue = 0;
                vm.tableRowIndexExpandedCurr = "";
                vm.externaltableRowIndexExpandedCurr = "";
                vm.storeIdExpanded = "";
                vm.externalstoreIdExpanded = "";
                vm.tableRowIndexExpandedPrev = "";
                vm.externaltableRowIndexExpandedPrev = "";
                vm.dtInstance = {};
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                vm.nseData = vm.customerDetail.nseData;
                //declaring goal type
                vm.goalType=[];
                vm.sortedItems={};
                vm.goalarr=[];
                vm.planarr=[];
                vm.toparr=[];
                vm.ownplanarr=[];
                vm.otherArr=[];
                vm.originalArr;
                // vm.columnIndex;
                vm.checkPos=false;
                vm.previousParentIndex;

                if (vm.customerDetail && vm.customerDetail.pan && vm.nseData && vm.nseData.ACTIVATION_STATUS === 'YES') {
                    getHoldingData(vm.customerDetail.pan);
                    getExternalHolding();
                    getexternalfoliodata();
                }

                vm.eKyc = {
                    "01": "UNDER_PROCESS",
                    "02": "KYC REGISTERED",
                    "03": "ON HOLD",
                    "04": "KYC REJECTED",
                    "05": "NOT AVAILABLE",
                    "06": "Deactivate",
                    "07": "KYC VALIDATED",
                    "11": "UNDER_PROCESS(OLD record)",
                    "12": "KYC REGISTERED(OLD record)",
                    "13": "ON HOLD(OLD record)",
                    "22": "CVL MF KYC"
                }
                vm.eKycType = {
                    "0": "Paper Based",
                    "1": "Through OTP",
                    "2": "Through Biometric"
                }

                vm.totalValue = {};
                vm.selectTableRow = selectTableRow;
                // vm.selectRowColumn = selectRowColumn;
                vm.selectexternalHoldingTableRow = selectexternalHoldingTableRow;
                vm.updateEHolding = updateEHolding;
                vm.toggleCurVal = true
                
                vm.downloadSchemeList = downloadSchemeList;
                vm.getExcelReport = getExcelReport;
                vm.downloadTransactions = downloadTransactions;
                // vm.getlivePortfolioReportDetailsById = getlivePortfolioReportDetailsById;
                // vm.getlivePortfolioReportSummaryById = getlivePortfolioReportSummaryById;
                // vm.getLivePfReportByDate = getLivePfReportByDate;
                vm.downloadExternalHoldingsData = downloadExternalHoldingsData;
                vm.getCapitalGainReport = getCapitalGainReport;
                vm.getCapitalGainReportExcel = getCapitalGainReportExcel;
                vm.getReport = getReport;
                vm.downloadReportDetails = '';
                vm.downloadReportSummary = '';
                vm.downloadPDFReport = '';
                vm.openDialog = openDialog;
                vm.mfCentral = {};
                vm.externalHoldingsList = [];
                // Add image to the worksheet (top of the header)
                vm.myBase64Image = "data:image/png;base64,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";
            } else {
                $state.go('app.customers');
            }
        };
        init();

        function sucessgetlivePortfolioReportDetailsById(response) {
            vm.downloadReportDetails = response.data.path;
            if (vm.downloadReportDetails) {
                window.open(vm.downloadReportDetails, '_blank');
                vm.closeDialog();
            } else {
                console.error('No report URL found in vm.downloadReportDetails');
            }
        }

        function errorgetlivePortfolioReportDetailsById(response) {
            console.log(response.data.responseString)
            showDialog(response.data.responseString);
        }

        function sucessgetlivePortfolioReportSummaryById(response) {
            vm.downloadReportSummary = response.data.path;
            if (vm.downloadReportSummary) {
                window.open(vm.downloadReportSummary, '_blank');
                vm.closeDialog();
            } else {
                console.error('No report URL found in vm.downloadReportSummary');
            }
        }

        function errorgetlivePortfolioReportSummaryById(response) {
            console.log(response.data.responseString)
            showDialog(response.data.responseString);
        }

        
        function successgetLivePfReportByDateTD(response) {
            vm.downloadPDFReport = response.data.path;
            if (vm.downloadPDFReport) {
                window.open(vm.downloadPDFReport, '_blank');
                vm.closeDialog();
            } else {
                console.error('No report URL found in vm.downloadPDFReport');
            }
        }

        function errorgetLivePfReportByDateTD(response) {
            console.log(response.data.responseString)
            showDialog(response.data.responseString);
        }

        function successgetLivePfReportByDateTS(response) {
            vm.downloadPDFReport = response.data.path;
            if (vm.downloadPDFReport) {
                window.open(vm.downloadPDFReport, '_blank');
                vm.closeDialog();
            } else {
                console.error('No report URL found in vm.downloadPDFReport');
            }
        }

        function errorgetLivePfReportByDateTS(response) {
            console.log(response.data.responseString)
            showDialog(response.data.responseString);
        }

        // function errorgetLivePfReportByDateTS(response) {
        //     console.log(response.data.responseString)
        //     showDialog(response.data.responseString);
        // }

        // function getlivePortfolioReportDetailsById() {
        //     vm.id = vm.customerDetail._id;
        //     ServiceProxy.getlivePortfolioReportDetailsById(vm.id).then(sucessgetlivePortfolioReportDetailsById, errorgetlivePortfolioReportDetailsById);
        // }

        // function getlivePortfolioReportSummaryById() {
        //     vm.id = vm.customerDetail._id
        //     ServiceProxy.getlivePortfolioReportSummaryById(vm.id).then(sucessgetlivePortfolioReportSummaryById, errorgetlivePortfolioReportSummaryById);
        // }

        // function getLivePfReportByDate(val){
        //     console.log('from_date:', vm.from_date, 'to_date:', vm.to_date, 'val:', val);
        //     vm.id = vm.customerDetail._id;
        //     var postData = {'from_date' : formatDate(vm.from_date), 'to_date' : formatDate(vm.to_date)}
        //     if(val === 'TD'){
        //         ServiceProxy.getLivePfReportByDateTD(vm.id, postData).then(successgetLivePfReportByDateTD, errorgetLivePfReportByDateTD);
        //     }
        //     if(val === 'TS'){
        //         ServiceProxy.getLivePfReportByDateTS(vm.id, postData).then(successgetLivePfReportByDateTS, errorgetLivePfReportByDateTS);
        //     }
        // }

        function getReport(type) {
            vm.id = vm.customerDetail._id;

            const hasDateRange = vm.from_date && vm.to_date;
            const postData = {
                from_date: formatDate(vm.from_date),
                to_date: formatDate(vm.to_date)
            };

            if (hasDateRange) {
                // Date range entered — call date-based APIs
                if (type === 'TD') {
                    ServiceProxy.getLivePfReportByDateTD(vm.id, postData).then(successgetLivePfReportByDateTD, errorgetLivePfReportByDateTD);
                } else if (type === 'TS') {
                    ServiceProxy.getLivePfReportByDateTS(vm.id, postData).then(successgetLivePfReportByDateTS, errorgetLivePfReportByDateTS);
                }
            } else {
                // No date range — call normal APIs
                if (type === 'TD') {
                    ServiceProxy.getlivePortfolioReportDetailsById(vm.id).then(sucessgetlivePortfolioReportDetailsById, errorgetlivePortfolioReportDetailsById);
                } else if (type === 'TS') {
                    ServiceProxy.getlivePortfolioReportSummaryById(vm.id).then(sucessgetlivePortfolioReportSummaryById, errorgetlivePortfolioReportSummaryById);
                }
            }
        }

        vm.clearDates = function() {
            vm.from_date = null;
            vm.to_date = null;
        };

        function getExcelReport(type) {
            vm.id = vm.customerDetail._id;

            const hasDateRange = vm.from_date && vm.to_date;
            const postData = {
                from_date: formatDate(vm.from_date),
                to_date: formatDate(vm.to_date)
            };

            if (hasDateRange) {
                // Date range entered — call date-based Excel APIs
                if (type === 'TD') {
                    ServiceProxy.getLiveExcelReportByDateTD(vm.id, postData).then(successGetLiveExcelReportByDateTD, errorGetLiveExcelReportByDateTD);
                } else if (type === 'TS') {
                    ServiceProxy.getLiveExcelReportByDateTS(vm.id, postData).then(successGetLiveExcelReportByDateTS, errorGetLiveExcelReportByDateTS);
                }
            } else {
                if (type === 'TD') {
                    downloadTransactions();
                } else if (type === 'TS') {
                    downloadSchemeList();
                }
            }
        }

        // Transaction Details Excel
        function successGetLiveExcelReportByDateTD(response) {
            const link = response.excelLink || response.data.excelLink;
            if (!link) return;

            // Force download without showing preview
            const a = document.createElement('a');
            a.href = link;
            a.download = ''; // This forces download instead of preview
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        // Summary Excel
        function successGetLiveExcelReportByDateTS(response) {
            const link = response.excelLink || response.data.excelLink;
            if (!link) return;

            // Force download without showing preview
            const a = document.createElement('a');
            a.href = link;
            a.download = ''; // This forces download instead of preview
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        function errorGetLiveExcelReportByDateTD(error) {
            console.error('Error downloading transaction details Excel:', error);
            showDialog(error.data.responseString || 'Failed to download transaction details report');
        }

        function errorGetLiveExcelReportByDateTS(error) {
            console.error('Error downloading summary Excel:', error);
            showDialog(error.data.responseString || 'Failed to download summary report');
        }

        function downloadSchemeList() {
            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet('Scheme List');
            
            // Adding an image to the sheet
            var imageId = workbook.addImage({
                base64: vm.myBase64Image,
                extension: 'png',
            });
            
            worksheet.addImage(imageId, {
                tl: { col: 7.8, row: 0 },  // Adjust the placement of the image
                ext: { width: 200, height: 100 }  // Adjust the size of the image
            });
            
            // Header rows data
            var headerRows = [
                [vm.nseData.INVESTOR_NAME + ' (' + vm.nseData.FH_PAN_NO + ')', '', '', '', 'SIPFUND.com', '', ''],
                [typeof vm.nseData.ADDRESS1 === 'object' || !vm.nseData.ADDRESS1 ? '' : vm.nseData.ADDRESS1, '', '', '', 'AMFI-Registered Mutual Fund Distributor', '', ''],
                [typeof vm.nseData.ADDRESS2 === 'object' || !vm.nseData.ADDRESS2 ? '' : vm.nseData.ADDRESS2, '', '', '', 'Office Address: Unit L2-09&10, 1st Floor, Splendid Plaza, Wheelers Road, Cox Town, Bangalore 560005, Karnataka, India', '', ''],
                [typeof vm.nseData.ADDRESS3 === 'object' || !vm.nseData.ADDRESS3 ? '' : vm.nseData.ADDRESS3, '', '', '', 'Tel. No.: 9513355661', '', ''],
                ['Mob: ' + (vm.nseData.MOBILE_NO || ''), '', '', '', 'Email: info@sipfund.com', '', ''],
                ['Email: ' + (vm.nseData.EMAIL || ''), '', '', '', '', '', '']
            ];
            
            // Adding the header rows to the worksheet
            for (var index = 0; index < headerRows.length; index++) {
                var row = headerRows[index];
                var addedRow = worksheet.addRow(row);
            
                // Merging cells for specific parts of the row
                worksheet.mergeCells('A' + (index + 1) + ':B' + (index + 1));  // Merge columns A and B
                worksheet.mergeCells('C' + (index + 1) + ':G' + (index + 1));  // Merge columns C through G
            
                // Set the content explicitly in column C before merging
                addedRow.getCell(3).value = row[4];  // Set the value for the merged cells (this will be displayed in C, D, E, F, G)
            
                // Set alignment for merged cells
                addedRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };   // Left-aligned
                addedRow.getCell(3).alignment = { horizontal: 'center', vertical: 'middle' }; // Center-aligned for the middle content
            
                // Applying bold fonts for specific rows/cells
                if (index === 0) {  // First row (Investor name and PAN)
                    addedRow.getCell(1).font = { bold: true };  // Bold for the left content
                    addedRow.getCell(3).font = { bold: true };  // Bold for the right content (SIPFUND.com)
                } else if (index === 1) {  // Second row (Address)
                    addedRow.getCell(3).font = { bold: true };
                }
            }         

            // Add the data headers manually in row 7
            var headerOfExcl = worksheet.getRow(8);
            headerOfExcl.values = [
                'AMC Name', 'Scheme Name', 'Total Units', 'Invested Amount', 'Current Value', 
                'Profit/Loss', 'Absolute Return (In %)', 'Booked Profit/Loss', 'CAGR (In %)'
            ];
        
            // Make headers bold and give a blue background color
            for (var i = 1; i <= 9; i++) { 
                var cell = headerOfExcl.getCell(i);
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb:'FF4AC1E8'},
                    bgColor:{argb:'FF4AC1E8'}
                };
            }
        
            // Adjust column widths
            worksheet.columns = [
                { key: 'amcName', width: 30 },
                { key: 'scheme', width: 30 },
                { key: 'units', width: 25 },
                { key: 'investedAmt', width: 25 },
                { key: 'currentVal', width: 25 },
                { key: 'profitLoss', width: 25 },
                { key: 'absoluteReturn', width: 25 },
                { key: 'bookedProfitLoss', width: 25 },
                { key: 'cagr', width: 25 },
            ];

            // Add the scheme data rows starting from row 9
            for (var index = 0; index < vm.trxn_Data.responseString.length; index++) {
                var data = vm.trxn_Data.responseString[index];
                var rowIndex = 9 + index; // Calculate the current row index
                var row = worksheet.getRow(rowIndex);

                // Set values for the row
                row.values = [
                    data.amcName,
                    data.scheme,
                    parseFloat(data.units).toFixed(2),
                    data.investedAmt,
                    data.currentValue,
                    data.profitLoss,
                    data.percentageProfitLoss,
                    data.netProfit,
                    data.cagr
                ];

                // Alternate row colors: white for even rows and blue for odd rows
                var fillColor = (index % 2 === 0) ? 'FFFFFFFF' : 'FFADD8E6';

                for (var colIndex = 1; colIndex <= 9; colIndex++) {
                    var cell = row.getCell(colIndex);
            
                    // Set background color
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor },  // Set foreground color
                        bgColor: { argb: fillColor }   // Set background color
                    };
            
                    // Right-align numeric data (columns 3 to 9 are numbers)
                    if (colIndex >= 3) {
                        cell.alignment = { horizontal: 'right' };
                    }
                }

                row.commit(); // Commit the row changes
            }

            // Create a buffer for the Excel file
            workbook.xlsx.writeBuffer().then(function (buffer) {
                var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = 'Investment_Report.xlsx';
                a.click();
                URL.revokeObjectURL(url);
            });
            vm.closeDialog();
        }
        
        function downloadTransactions() {
            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet('Transaction List');
        
            // Add the image to the worksheet
            var imageId = workbook.addImage({
                base64: vm.myBase64Image,
                extension: 'png',
            });
        
            worksheet.addImage(imageId, {
                tl: { col: 8.8, row: 0 },
                ext: { width: 200, height: 100 }
            });
        
            // Add header rows for investor info
            var headerRows = [
                [vm.nseData.INVESTOR_NAME + ' (' + vm.nseData.FH_PAN_NO + ')', '', '', '', 'SIPFUND.com', '', '', ''],
                [typeof vm.nseData.ADDRESS1 === 'object' || !vm.nseData.ADDRESS1 ? '' : vm.nseData.ADDRESS1, '', '', '', 'AMFI-Registered Mutual Fund Distributor', '', '', ''],
                [typeof vm.nseData.ADDRESS2 === 'object' || !vm.nseData.ADDRESS2 ? '' : vm.nseData.ADDRESS2, '', '', '', 'Office Address: Unit L2-09&10, 1st Floor, Splendid Plaza, Wheelers Road, Cox Town, Bangalore 560005, Karnataka, India', '', '', ''],
                [typeof vm.nseData.ADDRESS3 === 'object' || !vm.nseData.ADDRESS3 ? '' : vm.nseData.ADDRESS3, '', '', '', 'Tel. No. : 9513355661', '', '', ''],
                ['Mob: ' + (vm.nseData.MOBILE_NO || ''), '', '', '', 'Email: info@sipfund.com', '', '', ''],
                ['Email: ' + (vm.nseData.EMAIL || ''), '', '', '', '', '', '', '']
            ];
        
            // Adding the header rows to the worksheet
            for (var index = 0; index < headerRows.length; index++) {
                var row = headerRows[index];
                var addedRow = worksheet.addRow(row);

                // Merging cells for specific parts of the row
                worksheet.mergeCells('A' + (index + 1) + ':B' + (index + 1));  // Merge columns A and B
                worksheet.mergeCells('C' + (index + 1) + ':H' + (index + 1));  // Merge columns C through G
            
                // Set the content explicitly in column C before merging
                addedRow.getCell(3).value = row[4];  // Set the value for the merged cells (this will be displayed in C, D, E, F, G)
            
                // Set alignment for merged cells
                addedRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };   // Left-aligned
                addedRow.getCell(3).alignment = { horizontal: 'center', vertical: 'middle' }; // Center-aligned for the middle content
        
                if (index === 0) { 
                    addedRow.getCell(1).font = { bold: true };
                    addedRow.getCell(3).font = { bold: true };
                } else if (index === 1) {
                    addedRow.getCell(3).font = { bold: true };
                } 
            }
        
            // Create the transaction header row
            var transactionHeaderRow = worksheet.getRow(8);
            transactionHeaderRow.values = [
                'AMC Name', 'Scheme Name', 'Folio No', 'PAN', 'Transaction No', 
                'Transaction Date', 'Price/Unit', 'Units', 'Amount Invested', 
                'Transaction Nature', 'CAGR (in %)'
            ];
        
            // Make transaction header bold and give it a background color
            for (var i = 1; i <= 11; i++) { 
                var cell = transactionHeaderRow.getCell(i);
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb:'FF4AC1E8'},
                    bgColor:{argb:'FF4AC1E8'}
                };
            }
        
            // Adjust the width for transaction columns if needed
            worksheet.columns = [
                { key: 'amcName', width: 30 },
                { key: 'scheme', width: 30 },
                { key: 'folio_no', width: 20 },
                { key: 'pan', width: 20 },
                { key: 'trxn_no', width: 20 },
                { key: 'traddate', width: 20 },
                { key: 'purprice', width: 20 },
                { key: 'units', width: 15 },
                { key: 'amount', width: 20 },
                { key: 'trxn_nature', width: 25 },
                { key: 'cagr', width: 15 },
            ];
        
                       // Create an array to store sorted and grouped transactions
            var sortedAndGroupedTransactions = [];
        
            // Iterate through the response data
            for (var i = 0; i < vm.trxn_Data.responseString.length; i++) {
                var amcName = vm.trxn_Data.responseString[i].amcName;
                var scheme = vm.trxn_Data.responseString[i].scheme;
        
                for (var j = 0; j < vm.trxn_Data.responseString[i].trxnDetails.length; j++) {
                    var transaction = vm.trxn_Data.responseString[i].trxnDetails[j];
                    transaction.amcName = amcName; // Add AMC Name to the transaction
                    transaction.scheme = scheme;   // Add Scheme Name to the transaction
                    sortedAndGroupedTransactions.push(transaction);
                }
            }
        
            // Sort the transactions by traddate
            sortedAndGroupedTransactions.sort(function(a, b) {
                var dateA = new Date(a.traddate);
                var dateB = new Date(b.traddate);
                return dateB - dateA;
            });
        
            // Group the transactions by AMC Name, Scheme Name, and Folio No
            var groupedTransactions = {};
        
            for (var k = 0; k < sortedAndGroupedTransactions.length; k++) {
                var amcName = sortedAndGroupedTransactions[k].amcName;
                var scheme = sortedAndGroupedTransactions[k].scheme;
                var folio_no = sortedAndGroupedTransactions[k].folio_no;
        
                if (!groupedTransactions[amcName]) {
                    groupedTransactions[amcName] = {};
                }
        
                if (!groupedTransactions[amcName][scheme]) {
                    groupedTransactions[amcName][scheme] = {};
                }
        
                if (!groupedTransactions[amcName][scheme][folio_no]) {
                    groupedTransactions[amcName][scheme][folio_no] = [];
                }
        
                groupedTransactions[amcName][scheme][folio_no].push(sortedAndGroupedTransactions[k]);
            }
            // Add data rows with alternating colors
            var dataStartRowIndex = 9; // Start from row 9 for data
            var rowIndex = dataStartRowIndex;

            for (var amc in groupedTransactions) {
                for (var scheme in groupedTransactions[amc]) {
                    for (var folio in groupedTransactions[amc][scheme]) {
                        for (var l = 0; l < groupedTransactions[amc][scheme][folio].length; l++) {
                            var transaction = groupedTransactions[amc][scheme][folio][l];

                            var formattedDate = new Date(transaction.traddate).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            });

                            // Create a new row with appropriate values
                            var row = worksheet.getRow(rowIndex);
                            row.values = {
                                amcName: amc,
                                scheme: scheme,
                                folio_no: transaction.folio_no,
                                pan: transaction.pan,
                                trxn_no: transaction.trxnno,
                                traddate: formattedDate, // Ensure this is formatted as needed
                                purprice: transaction.purprice,
                                units: parseFloat(transaction.units).toFixed(2),
                                amount: transaction.amount,
                                trxn_nature: transaction.trxn_nature,
                                cagr: transaction.cagr
                            };

                            // Alternate row colors: white for even rows and blue for odd rows
                            var fillColor = (rowIndex % 2 === 0) ? 'FFFFFFFF' : 'FFADD8E6';

                            for (var colIndex = 1; colIndex <= 11; colIndex++) {
                                var cell = row.getCell(colIndex);
                        
                                // Set background color
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: fillColor },  // Set foreground color
                                    bgColor: { argb: fillColor }   // Set background color
                                };
                        
                                // Right-align numeric data (columns 3 to 9 are numbers)
                                if (colIndex >= 3) {
                                    cell.alignment = { horizontal: 'right' };
                                }
                            }

                            row.commit(); // Commit the row changes
                            rowIndex++; // Move to the next row
                        }
                    }
                }
            }
        
            // Create a buffer for the Excel file
            workbook.xlsx.writeBuffer().then(function (buffer) {
                var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = 'transactionlist.xlsx';
                a.click();
                URL.revokeObjectURL(url);
            });
            vm.closeDialog();
        }

        // function downloadTransactions() {
		// 	var csvString = 'AMC Name,Scheme Name,PAN,Folio No,Transaction No,Transaction Date,Price/Unit,Units,Amount Invested,Transaction Nature,CAGR (in %),' + "\n";

        //     console.log('transaction value for the customer');
            
        //     var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];



        //     for(var i=0; i<vm.trxn_Data.responseString.length;i++)
        //     {
        //         //console.info('scheme number ' + i);
        //         for(var j=0; j<vm.trxn_Data.responseString[i].trxnDetails.length;j++)
        //         {
        //             //console.info('transaction number ' + j);
        //             //console.info('transaction value ' + vm.trxn_Data.responseString[i].trxnDetails[j].folio_no);

        //             var d = new Date(vm.trxn_Data.responseString[i].trxnDetails[j].traddate);
        //             var month = months[d.getMonth()];

        //             csvString = csvString.concat(
        //                 vm.trxn_Data.responseString[i].amcName + "," 
        //                 + vm.trxn_Data.responseString[i].scheme + "," 
        //                 + vm.trxn_Data.responseString[i].trxnDetails[j].pan + ","
        //                 + vm.trxn_Data.responseString[i].trxnDetails[j].folio_no + ","
        //                 + vm.trxn_Data.responseString[i].trxnDetails[j].trxnno + ","                   
        //                 //+ new Date(vm.trxn_Data.responseString[i].trxnDetails[j].traddate).toLocaleDateString() + ","
        //                 + d.getDate() + '-' + month + '-' + d.getFullYear() + ","
        //                 + vm.trxn_Data.responseString[i].trxnDetails[j].purprice + ","
        //                 + parseFloat(vm.trxn_Data.responseString[i].trxnDetails[j].units).toFixed(2) + ","
        //                 + vm.trxn_Data.responseString[i].trxnDetails[j].amount + ","
        //                 + vm.trxn_Data.responseString[i].trxnDetails[j].trxn_nature + ","
        //                 + vm.trxn_Data.responseString[i].trxnDetails[j].cagr + ","
        //                 );
        //             csvString = csvString + "\n";
        //         }
        //     }

        //     var a = $('<a/>', {
        //         href:'data:application/octet-stream;base64,'+btoa(csvString),
        //         download:'transactionlist.csv'
        //     }).appendTo('body')
        //     a[0].click()
        //     a.remove();
		// }
        
        // function downloadTransactions() {
        //     // Create an array to store sorted and grouped transactions
        //     var sortedAndGroupedTransactions = [];
        
        //     // Iterate through the response data
        //     for (var i = 0; i < vm.trxn_Data.responseString.length; i++) {
        //         var amcName = vm.trxn_Data.responseString[i].amcName;
        //         var scheme = vm.trxn_Data.responseString[i].scheme;
        
        //         for (var j = 0; j < vm.trxn_Data.responseString[i].trxnDetails.length; j++) {
        //             var transaction = vm.trxn_Data.responseString[i].trxnDetails[j];
        //             transaction.amcName = amcName; // Add AMC Name to the transaction
        //             transaction.scheme = scheme;   // Add Scheme Name to the transaction
        //             sortedAndGroupedTransactions.push(transaction);
        //         }
        //     }
        
        //     // Sort the transactions by traddate
        //     sortedAndGroupedTransactions.sort(function(a, b) {
        //         var dateA = new Date(a.traddate);
        //         var dateB = new Date(b.traddate);
        //         return dateB - dateA;
        //     });
        
        //     // Group the transactions by folio_no
        //     var groupedTransactions = {};
        //     for (var k = 0; k < sortedAndGroupedTransactions.length; k++) {
        //         var folio_no = sortedAndGroupedTransactions[k].folio_no;
        //         if (!groupedTransactions[folio_no]) {
        //             groupedTransactions[folio_no] = [];
        //         }
        //         groupedTransactions[folio_no].push(sortedAndGroupedTransactions[k]);
        //     }
        
        //     // Create the CSV string with the sorted and grouped data
        //     var csvString = 'AMC Name,Scheme Name,PAN,Folio No,Transaction No,Transaction Date,Price/Unit,Units,Amount Invested,Transaction Nature,CAGR (in %)\n';
        //     var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        //     for (var folio in groupedTransactions) {
        //         for (var l = 0; l < groupedTransactions[folio].length; l++) {
        //             var transaction = groupedTransactions[folio][l];
        //             var d = new Date(transaction.traddate);
        //             var month = months[d.getMonth()];
        
        //             csvString += (
        //                 transaction.amcName + ',' +
        //                 transaction.scheme + ',' +
        //                 transaction.pan + ',' +
        //                 transaction.folio_no + ',' +
        //                 transaction.trxnno + ',' +
        //                 d.getDate() + '-' + month + '-' + d.getFullYear() + ',' +
        //                 transaction.purprice + ',' +
        //                 parseFloat(transaction.units).toFixed(2) + ',' +
        //                 transaction.amount + ',' +
        //                 transaction.trxn_nature + ',' +
        //                 transaction.cagr + '\n'
        //             );
        //         }
        //     }

        //         var a = $('<a/>', {
        //         href: 'data:application/octet-stream;base64,' + btoa(csvString),
        //         download: 'transactionlist.csv'
        //     }).appendTo('body');
        //     a[0].click();
        //     a.remove();
        // }
        
        // function downloadTransactions() {
        //     // Create an array to store sorted and grouped transactions
        //     var sortedAndGroupedTransactions = [];
        
        //     // Iterate through the response data
        //     for (var i = 0; i < vm.trxn_Data.responseString.length; i++) {
        //         var amcName = vm.trxn_Data.responseString[i].amcName;
        //         var scheme = vm.trxn_Data.responseString[i].scheme;
        
        //         for (var j = 0; j < vm.trxn_Data.responseString[i].trxnDetails.length; j++) {
        //             var transaction = vm.trxn_Data.responseString[i].trxnDetails[j];
        //             transaction.amcName = amcName; // Add AMC Name to the transaction
        //             transaction.scheme = scheme;   // Add Scheme Name to the transaction
        //             sortedAndGroupedTransactions.push(transaction);
        //         }
        //     }
        
        //     // Sort the transactions by traddate
        //     sortedAndGroupedTransactions.sort(function(a, b) {
        //         var dateA = new Date(a.traddate);
        //         var dateB = new Date(b.traddate);
        //         return dateB - dateA;
        //     });
        
        //     // Group the transactions by AMC Name, Scheme Name, and Folio No
        //     var groupedTransactions = {};
        
        //     for (var k = 0; k < sortedAndGroupedTransactions.length; k++) {
        //         var amcName = sortedAndGroupedTransactions[k].amcName;
        //         var scheme = sortedAndGroupedTransactions[k].scheme;
        //         var folio_no = sortedAndGroupedTransactions[k].folio_no;
        
        //         if (!groupedTransactions[amcName]) {
        //             groupedTransactions[amcName] = {};
        //         }
        
        //         if (!groupedTransactions[amcName][scheme]) {
        //             groupedTransactions[amcName][scheme] = {};
        //         }
        
        //         if (!groupedTransactions[amcName][scheme][folio_no]) {
        //             groupedTransactions[amcName][scheme][folio_no] = [];
        //         }
        
        //         groupedTransactions[amcName][scheme][folio_no].push(sortedAndGroupedTransactions[k]);
        //     }
        
        //     // Create the CSV string with the sorted and grouped data
        //     var csvString = 'AMC Name,Scheme Name,Folio No,PAN,Transaction No,Transaction Date,Price/Unit,Units,Amount Invested,Transaction Nature,CAGR (in %)\n';
        //     var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        
        //     for (var amc in groupedTransactions) {
        //         for (var scheme in groupedTransactions[amc]) {
        //             for (var folio in groupedTransactions[amc][scheme]) {
        //                 for (var l = 0; l < groupedTransactions[amc][scheme][folio].length; l++) {
        //                     var transaction = groupedTransactions[amc][scheme][folio][l];
        //                     var d = new Date(transaction.traddate);
        //                     var month = months[d.getMonth()];
        
        //                     csvString += (
        //                         amc + ',' +
        //                         scheme + ',' +
        //                         folio + ',' +
        //                         transaction.pan + ',' +
        //                         transaction.trxnno + ',' +
        //                         d.getDate() + '-' + month + '-' + d.getFullYear() + ',' +
        //                         transaction.purprice + ',' +
        //                         parseFloat(transaction.units).toFixed(2) + ',' +
        //                         transaction.amount + ',' +
        //                         transaction.trxn_nature + ',' +
        //                         transaction.cagr + '\n'
        //                     );
        //                 }
        //             }
        //         }
        //     }
        
        //     var a = $('<a/>', {
        //         href: 'data:application/octet-stream;base64,' + btoa(csvString),
        //         download: 'transactionlist.csv'
        //     }).appendTo('body');
        //     a[0].click();
        //     a.remove();
        // }
        
        function sucessCbGetHoldingData(response) {
            var amcData = StorageService.getSessionStorage("amcData");
            angular.forEach(amcData, function(amc) {
                angular.forEach(response.data.responseString, function(item) {
                    if (item.amc_code === amc.AMC_CODE) {
                        item.amcName = amc.LONG_NAME;
                    }
                })
            })
            vm.trxn_Data = response.data;
            angular.forEach(vm.trxn_Data.responseString, function(eachTrxn) {
                vm.totalInvestment += eachTrxn.investedAmt;
                vm.totalCurrentValue += eachTrxn.currentValue;
                vm.goalType.push(eachTrxn.trxnDetails[0].groupType)
            });
            trxnData();
            vm.originalArr = response.data.responseString
            angular.forEach(vm.originalArr , function(value, key){
                    if(value.hasOwnProperty('groupId') && value.hasOwnProperty('groupName')){
                        var INIT = value.groupName.split(" ");
                        value.newId = value.groupId + INIT[0].substring(0,1) + INIT[1].substring(0,1);
                    }
                    else if(value.hasOwnProperty('groupName') && value.groupId == "")
                    {
                        value.newId = value.groupName + 1;
                    }
                    else
                    {
                        value.newId = "ownfunds";
                    }
                })

            var groupBy = function(xs, key) {
                return xs.reduce(function(rv, x) {
                  (rv[x[key]] = rv[x[key]] || []).push(x);
                  return rv;
                }, {});
              };

            $scope.sortedItems = groupBy(vm.originalArr, 'newId'); 
        }

        function errorCbGetHoldingData(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getHoldingData(data) {
            var postData = {
                "pan": data
            };
            ServiceProxy.getHoldingData(postData).then(sucessCbGetHoldingData, errorCbGetHoldingData)
        }

        // transaction Data

        function trxnData() {
            var totalInvst = 0;
            var totalCurrent = 0;
            angular.forEach(vm.trxn_Data.responseString, function(data) {
                data.investedAmt = parseFloat(parseFloat(data.investedAmt).toFixed(2));
                data.currentValue = parseFloat(parseFloat(data.currentValue).toFixed(2));
                data.profitLoss = (data.currentValue - data.investedAmt).toFixed(2);
                data.percentageProfitLoss = ((data.profitLoss / data.investedAmt) * 100).toFixed(2) + " %";
                data.netProfit = parseFloat(parseFloat(data.netProfit).toFixed(2))
                totalInvst += data.investedAmt;
                totalCurrent += data.currentValue;
            });
            vm.totalValue.totalInvst = totalInvst;
            vm.totalValue.totalCurrent = totalCurrent;
            vm.customers = vm.trxn_Data;
        }

        // selectTableRow Start

        function dayDataCollapseFn() {
            vm.dayDataCollapse = [];
            vm.dayDataArray=[]

            angular.forEach($scope.sortedItems, function(eachObject){
                vm.dayDataArray=[]
                angular.forEach(eachObject, function(){
                    vm.dayDataArray.push(false)
                })
                vm.dayDataCollapse.push(vm.dayDataArray);
            })
        };

        function selectTableRow(key, parentIndex, index, storeId) {
            if (typeof vm.dayDataCollapse === 'undefined') {
                dayDataCollapseFn();
            }
        
            console.log('Key:', key, 'ParentIndex:', parentIndex, 'Index:', index, 'StoreID (Prodcode):', storeId);
        
            if (vm.tableRowExpanded === false && vm.tableRowIndexExpandedCurr === "" && vm.storeIdExpanded === "") {
                vm.tableRowIndexExpandedPrev = "";
                vm.tableRowExpanded = true;
                vm.tableRowIndexExpandedCurr = index;
                vm.storeIdExpanded = storeId;
                vm.previousParentIndex = parentIndex;
                vm.dayDataCollapse[parentIndex][index] = true;
                vm.checkPos = index;
                vm.txnData = getTransactionDetails($scope.sortedItems[key], storeId);
            } else if (vm.tableRowExpanded === true) {
                if (vm.tableRowIndexExpandedCurr === index && vm.storeIdExpanded === storeId) {
                    vm.tableRowExpanded = false;
                    vm.tableRowIndexExpandedCurr = "";
                    vm.storeIdExpanded = "";
                    vm.previousParentIndex = null;
                    // vm.dayDataCollapse[index] = false; 
                    vm.dayDataCollapse[parentIndex][index] = false;
                    vm.checkPos = index;
                    vm.txnData = [];
                } else {
                    vm.tableRowIndexExpandedPrev = vm.tableRowIndexExpandedCurr;
                    vm.tableRowIndexExpandedCurr = index;
                    vm.storeIdExpanded = storeId;
                    vm.dayDataCollapse[vm.previousParentIndex][vm.tableRowIndexExpandedPrev] = false;
                    vm.dayDataCollapse[parentIndex][vm.tableRowIndexExpandedCurr] = true;
                    vm.previousParentIndex = parentIndex;
                    vm.checkPos = index;
                    vm.txnData = getTransactionDetails($scope.sortedItems[key], storeId);
                }
            }
        }
        
        function getTransactionDetails(items, storeId) {
            // Using a traditional for loop to find the matching prodcode
            for (var i = 0; i < items.length; i++) {
                //console.info("prodcode",items[i].prodcode,storeId);
                //console.info("productKey",items[i].productKey,storeId);
                //  if (items[i].prodcode === storeId) {
                //      return items[i].trxnDetails || [];
                //  }
                if (items[i].productKey === storeId) {
                    return items[i].trxnDetails || [];
                }
            }
            return []; // Return an empty array if no match is found
        }            

        // function to get external holding
        function sucessCbGetExternalHolding(response) {
            vm.externalHoldings = response.data.externalTrnx;
            vm.externaltotalInvestment = 0;
            vm.externaltotalCurrentValue = 0;
            angular.forEach(vm.externalHoldings, function(eachTrxn) {
                vm.externaltotalInvestment += eachTrxn.investedAmt;
                vm.externaltotalCurrentValue += eachTrxn.currentValue;
            });
            externalTrxnData();
        }

        function errorGetExternalHolding(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getExternalHolding() {
            var postData = {
                "pan": vm.customerDetail.pan,
                "userId": vm.customerDetail._id
            }
            ServiceProxy.getExternalHolding(postData).then(sucessCbGetExternalHolding, errorGetExternalHolding)
        }
        // selectTableRow End

        function externalTrxnData() {
            var totalInvst = 0;
            var totalCurrent = 0;
            angular.forEach(vm.externalHoldings, function(data) {
                data.investedAmt = parseFloat(parseFloat(data.investedAmt).toFixed(2));
                data.currentValue = parseFloat(parseFloat(data.currentValue).toFixed(2));
                data.profitLoss = (data.currentValue - data.investedAmt).toFixed(2);
                data.percentageProfitLoss = ((data.profitLoss / data.investedAmt) * 100).toFixed(2) + " %";
                data.netProfit = parseFloat(parseFloat(data.netProfit).toFixed(2))
                totalInvst += data.investedAmt;
                totalCurrent += data.currentValue;
            });
        }

        function successupdateHolding(response) {
            console.log('successresponse', response);
            $state.go('app.customers.customerhome.customerDetail', {}, { reload: true });
            showDialogSucc(response.data.responseString);
        }
        
        

        function errorupdateHolding(response) {
            console.log('errorresponse', response);
            showDialog(response.data.responseString);
        }

        function updateEHolding(item) {
            console.log('item', item);
            var postData = {
                "pan": vm.customerDetail.pan,
                "folio": item.folio,
                "isin": item.isin
            };
        
            console.log('postData', postData);
        
            // Show confirmation dialog before proceeding
            var confirm = $mdDialog.confirm()
                .title('Confirm Action')
                .textContent('The External Holdings will be removed permanently. Still you want to proceed?')
                .ariaLabel('Confirm scheme removal')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes')
                .cancel('No');
        
            $mdDialog.show(confirm).then(function () {
                // User clicked "Yes", proceed with the update
                ServiceProxy.updateHolding(postData).then(successupdateHolding, errorupdateHolding);
            }, function () {
                // User clicked "No" or closed the dialog, do nothing or log cancellation
                console.log('Scheme removal canceled.');
            });
        }

        function selectexternalHoldingTableRow(index, storeId) {
            if (typeof vm.externalDataCollapse === 'undefined') {
                externalDataCollapseFn();
            };
            if (vm.externaltableRowExpanded === false && vm.externaltableRowIndexExpandedCurr === "" && vm.externalstoreIdExpanded === "") {
                vm.externaltableRowIndexExpandedPrev = "";
                vm.externaltableRowExpanded = true;
                vm.externaltableRowIndexExpandedCurr = index;
                vm.externalstoreIdExpanded = storeId;
                vm.externalDataCollapse[index] = true;
                vm.externaltxnData = vm.externalHoldings[index].trxnDetails;
            } else if (vm.externaltableRowExpanded === true) {
                if (vm.externaltableRowIndexExpandedCurr === index && vm.externalstoreIdExpanded === storeId) {
                    vm.externaltableRowExpanded = false;
                    vm.externaltableRowIndexExpandedCurr = "";
                    vm.externalstoreIdExpanded = "";
                    vm.externalDataCollapse[index] = false;
                } else {
                    vm.externaltableRowIndexExpandedPrev = vm.externaltableRowIndexExpandedCurr;
                    vm.externaltableRowIndexExpandedCurr = index;
                    vm.externalstoreIdExpanded = storeId;
                    vm.externalDataCollapse[vm.externaltableRowIndexExpandedPrev] = false;
                    vm.externalDataCollapse[vm.externaltableRowIndexExpandedCurr] = true;
                    vm.externaltxnData = vm.externalHoldings[index].trxnDetails;
                }
            }
        }

        function externalDataCollapseFn() {
            vm.externalDataCollapse = [];
            for (var i = 0; i < vm.externalHoldings.length; i += 1) {
                vm.externalDataCollapse.push(false);
            }
        }

        function openDialog(option) {
            // Show the appropriate dialog based on the selected option
            $mdDialog.show({
                template: getDialogTemplate(option),
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                scope: $scope, // Use the current scope for this dialog
                preserveScope: true // Preserve scope to avoid creating a new controller
            });
            vm.selectedOption = '';
        };

        function getDialogTemplate(option) {
            if (option === 'pdf') {
                return '' +
                   '<md-dialog aria-label="Download PDF" style="max-width: 500px; width: 100%;">' +
                    '<md-dialog-content layout="column" layout-align="center center" style="padding: 24px;">' +
                        '<h4 style="text-align:center; margin-bottom: 20px;">Download PDF Report</h4>' +

                        '<div layout="row" layout-align="space-between center" style="width:100%; margin-bottom: 16px;">' +
                        '<md-input-container flex="45">' +
                            '<label>Start Date</label>' +
                            '<input type="date" ng-model="vm.from_date" max="{{vm.today}}">' +
                        '</md-input-container>' +
                        '<md-input-container flex="45">' +
                            '<label>End Date</label>' +
                            '<input type="date" ng-model="vm.to_date" max="{{vm.today}}" min="{{vm.from_date}}">' +
                        '</md-input-container>' +
                        '</div>' +

                        '<div layout="row" layout-align="center center" style="margin-bottom: 16px;">' +
                        '<md-button class="md-raised md-primary" ng-click="vm.clearDates()" ' +
                        'ng-show="vm.from_date || vm.to_date" ' +
                        'style="background-color:#03A9F4; color:white;">CLEAR DATES</md-button>' +
                        '</div>' +

                    '</md-dialog-content>' +

                    '<md-dialog-actions layout="row" layout-align="center center" style="padding-bottom: 20px;">' +
                        '<md-button class="md-raised md-primary" ng-click="vm.getReport(\'TS\')" ' +
                        'style="color:white; background-color:#2196F3; margin:0 8px;">' +
                        '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon> Summary (PDF)' +
                        '</md-button>' +
                        '<md-button class="md-raised md-primary" ng-click="vm.getReport(\'TD\')" ' +
                        'style="color:white; background-color:#2196F3; margin:0 8px;">' +
                        '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon> Transactions (PDF)' +
                        '</md-button>' +
                        '<md-button ng-click="vm.closeDialog()" class="md-primary" style="margin:0 8px;">CLOSE</md-button>' +
                    '</md-dialog-actions>' +
                    '</md-dialog>';
            } else if (option === 'excel') {
                return '' +
            '<md-dialog aria-label="Download Excel" style="max-width: 500px; width: 100%;">' +
                '<md-dialog-content layout="column" layout-align="center center" style="padding: 24px;">' +
                    '<h4 style="text-align:center; margin-bottom: 20px;">Download Excel Report</h4>' +
                    '<div layout="row" layout-align="space-between center" style="width:100%; margin-bottom: 16px;">' +
                    '<md-input-container flex="45">' +
                        '<label>Start Date</label>' +
                        '<input type="date" ng-model="vm.from_date" max="{{vm.today}}">' +
                    '</md-input-container>' +
                    '<md-input-container flex="45">' +
                        '<label>End Date</label>' +
                        '<input type="date" ng-model="vm.to_date" max="{{vm.today}}" min="{{vm.from_date}}">' +
                    '</md-input-container>' +
                    '</div>' +
                    '<div layout="row" layout-align="center center" style="margin-bottom: 16px;">' +
                    '<md-button class="md-raised md-primary" ng-click="vm.clearDates()" ' +
                    'ng-show="vm.from_date || vm.to_date" ' +
                    'style="background-color:#03A9F4; color:white;">CLEAR DATES</md-button>' +
                    '</div>' +
                '</md-dialog-content>' +
                '<md-dialog-actions layout="row" layout-align="center center" style="padding-bottom: 20px;">' +
                    '<md-button class="md-raised md-accent" ng-click="vm.getExcelReport(\'TS\')" ' +
                    'style="color:#fff !important; background-color:#2196F3; margin:0 8px;">' +
                        '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon> Summary (Excel)' +
                    '</md-button>' +
                    '<md-button class="md-raised md-accent" ng-click="vm.getExcelReport(\'TD\')" ' +
                    'style="color:#fff !important; background-color:#2196F3; margin:0 8px;">' +
                        '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon> Transactions (Excel)' +
                    '</md-button>' +
                    '<md-button ng-click="vm.closeDialog()" class="md-primary" style="margin:0 8px;">CLOSE</md-button>' +
                '</md-dialog-actions>' +
            '</md-dialog>';
            } else if (option === 'externalExcel') {
                return '' +
                    '<md-dialog aria-label="Download Excel" style="max-width: 500px; width: 100%;">' +
                        '<md-dialog-content>' +
                            '<h4>Download Excel Report</h4>' +
                        '</md-dialog-content>' +
                        '<md-dialog-actions>' +
                            '<md-button class="md-raised md-accent" ng-click="vm.downloadExternalHoldingsData()" style="float:right; color:#fff !important;">' +
                                '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon>Summary(csv) ' +
                            '</md-button>' +
                            '<md-button ng-click="vm.closeDialog()" class="md-primary">Close</md-button>' +
                        '</md-dialog-actions>' +
                    '</md-dialog>';
            } else if (option === 'capital-gain') {
                  return '' +
                    '<md-dialog aria-label="Download Capital Gain Report" style="max-width: 500px; width: 100%;">' +
                        '<md-dialog-content>' +
                            '<h4>Download Report</h4>' +
                        '</md-dialog-content>' +
                        '<md-dialog-actions>' +
                            '<md-button class="md-raised md-accent" ng-click="vm.getCapitalGainReport()" style="color:#fff !important; margin:0 8px;">' +
                                '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon>Download PDF' +
                            '</md-button>' +
                            '<md-button class="md-raised md-accent" ng-click="vm.getCapitalGainReportExcel()" style="color:#fff !important; margin:0 8px;">' +
                                '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon>Download Excel' +
                            '</md-button>' +
                            '<md-button ng-click="vm.closeDialog()" class="md-primary">Close</md-button>' +
                        '</md-dialog-actions>' +
                    '</md-dialog>';
            }
        }        

        // Main Controller Function to Open Dialog
        vm.selectValueForDialog = function(){
            var selectedOption = vm.selectedOption;
            openDialog(selectedOption);
        }

        vm.closeDialog = function() {
            vm.from_date = null;
            vm.to_date = null;
            $mdDialog.hide();
        };

        // Initialize today's date in yyyy-MM-dd format
        vm.today = formatToISODate(new Date());
        console.log('Today:', vm.today);

        vm.formatFromDate = function() {
            vm.from_date = formatToISODate(vm.from_date);
        };

        vm.formatToDate = function() {
            vm.to_date = formatToISODate(vm.to_date);
        };

        // Helper function to format dates to yyyy-MM-dd
        function formatToISODate(date) {
            var d = new Date(date);
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2); // Add leading zero to month
            var day = ('0' + d.getDate()).slice(-2); // Add leading zero to day
            return year + '-' + month + '-' + day;
        }

        function formatDate(date) {
            if (!date) return '';
        
            // Check if the date is in yyyy-MM-dd format
            if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
                var parts = date.split('-'); // Split the yyyy-MM-dd string
                var year = parts[0];
                var month = parseInt(parts[1], 10) - 1; // Convert to zero-based index
                var day = parts[2];
                date = new Date(year, month, day); // Convert to a Date object
            }
        
            // Manually format the date to dd-Mon-yyyy
            var day = ('0' + date.getDate()).slice(-2);
            var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var month = monthNames[date.getMonth()];
            var year = date.getFullYear();
        
            return day + '-' + month + '-' + year;
        }        
    
        // Assign formatDate as a method of vm
        // function formatDate(date) {
        //     if (!date) return '';
        
        //     // Check if the date is in yyyy-MM-dd format
        //     if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        //         var [year, month, day] = date.split('-'); // Split the yyyy-MM-dd string
        //         date = new Date(year, month - 1, day); // Convert to a Date object
        //     }
        
        //     // Format the date to dd-Mon-yyyy
        //     var options = { day: '2-digit', month: 'short', year: 'numeric' };
        //     return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
        // }

        function successgetexternalfoliodata(response){

            vm.mfCentral = response;
        
            // Use forEach to iterate over response data
            vm.mfCentral.data.responseString.data.forEach(function(items) {
                // Extract the productAMCImage from the summary section for this item
                var productAMCImage = items.summary[0].productAMCImage;
        
                // Iterate through schemes array and push each item to externalHoldingsList
                items.schemes.forEach(function(item) {
                    // Add productAMCImage to each scheme item
                    item.productAMCImage = productAMCImage;
                    vm.externalHoldingsList.push(item);
                });
            });

            //console.log('vm.externalHoldingsList', vm.externalHoldingsList);

            //vm.updateHoldings('ALL');
        
            //console.log('val', $scope.externalHoldingsList);
        }

        function errorgetexternalfoliodata(response){
            console.log('errorRes', response);
        }

        function getexternalfoliodata(){
            console.log('vm.customer', vm.customerDetail);
            var postData = {
                "pan": vm.customerDetail.pan || vm.customerDetail.rawData.nseDetails.pan
            }
            ServiceProxy.getexternalfoliodata(postData).then(successgetexternalfoliodata, errorgetexternalfoliodata);
        }

        function downloadExternalHoldingsData() {
            //console.log('$scope.externalHoldingsList',$scope.externalHoldingsList);
            //console.log('$scope.mfCentral',$scope.mfCentral);
            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet('Scheme List');
            
            // Adding an image to the sheet
            var imageId = workbook.addImage({
                base64: vm.myBase64Image,
                extension: 'png',
            });
            
            worksheet.addImage(imageId, {
                tl: { col: 7.8, row: 0 },  // Adjust the placement of the image
                ext: { width: 200, height: 100 }  // Adjust the size of the image
            });
            
            // Header rows data
            var headerRows = [
                [vm.mfCentral.data.responseString.investorDetails.investorName + ' (' + vm.mfCentral.data.responseString.pan + ')', '', '', '', 'SIPFUND.com', '', ''],
                [typeof vm.mfCentral.data.responseString.investorDetails.address.line1 === 'object' || !vm.mfCentral.data.responseString.investorDetails.address.line1 ? '' : vm.mfCentral.data.responseString.investorDetails.address.line1+','+vm.mfCentral.data.responseString.investorDetails.address.line2+','+vm.mfCentral.data.responseString.investorDetails.address.line3, '', '', '', 'AMFI-Registered Mutual Fund Distributor', '', ''],
                [typeof vm.mfCentral.data.responseString.investorDetails.address.pincode === 'object' || !vm.mfCentral.data.responseString.investorDetails.address.pincode ? '' : vm.mfCentral.data.responseString.investorDetails.address.city+'-'+ vm.mfCentral.data.responseString.investorDetails.address.pincode, '', '', '', 'Office Address: Unit L2-09&10, 1st Floor, Splendid Plaza, Wheelers Road, Cox Town, Bangalore 560005, Karnataka, India', '', ''],
                [typeof vm.mfCentral.data.responseString.investorDetails.address.state === 'object' || !vm.mfCentral.data.responseString.investorDetails.address.state ? '' : vm.mfCentral.data.responseString.investorDetails.address.state+','+vm.mfCentral.data.responseString.investorDetails.address.country, '', '', '', 'Tel. No.: 9513355661', '', ''],
                ['Mob: ' + (vm.mfCentral.data.responseString.mobile || ''), '', '', '', 'Email: info@sipfund.com', '', ''],
                ['Email: ' + (vm.mfCentral.data.responseString.investorDetails.email || ''), '', '', '', '', '', ''],
                ['Disclaimer: The external holdings data displayed on this website is sourced from mf-central API and is for informational purposes only. We do not guarantee its accuracy, completeness, or reliability. Users should verify the data independently before making any decisions. We are not liable for any losses or damages arising from its use.', '', '', '', '', '', ''],
            ];
            
           // Adding the header rows to the worksheet
            for (var index = 0; index < headerRows.length; index++) {
                var row = headerRows[index];
                var addedRow = worksheet.addRow(row);
                var rowIndex = addedRow.number; // Get the actual row number in the sheet

                // Check if it's the last row (disclaimer)
                if (index === headerRows.length - 1) {
                    worksheet.mergeCells('A' + rowIndex + ':I' + rowIndex); // Merge across columns A to G for disclaimer
                    addedRow.getCell(1).value = row[0]; // Assign disclaimer text to first cell
                    addedRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }; // Center align
                } else {
                    // Merge cells for all other rows
                    worksheet.mergeCells('A' + rowIndex + ':B' + rowIndex);  // Merge columns A and B
                    worksheet.mergeCells('C' + rowIndex + ':G' + rowIndex);  // Merge columns C through G              

                    // Set the content explicitly in column C before merging
                    addedRow.getCell(3).value = row[4];  // Set the value for merged cells (C, D, E, F, G)

                    // Set alignment for merged cells
                    addedRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };   // Left-aligned
                    addedRow.getCell(3).alignment = { horizontal: 'center', vertical: 'middle' }; // Center-aligned

                    // Applying bold fonts for specific rows/cells
                    if (index === 0) {  // First row (Investor name and PAN)
                        addedRow.getCell(1).font = { bold: true };  // Bold for the left content
                        addedRow.getCell(3).font = { bold: true };  // Bold for the right content (SIPFUND.com)
                    } else if (index === 1) {  // Second row (Address)
                        addedRow.getCell(3).font = { bold: true };
                    }
                }
            }

            // Add the data headers manually in row 8
            var headerOfExcl = worksheet.getRow(9);
            headerOfExcl.values = [
                'AMC Name', 'Scheme Name', 'Asset Type', 'Folio No', 'Total Units', 'Invested Amount', 'Current Value', 
                'Profit/Loss', 'Absolute Return (In %)'
            ];
        
            // Make headers bold and give a blue background color
            for (var i = 1; i <= 9; i++) { 
                var cell = headerOfExcl.getCell(i);
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor: {argb:'FF4AC1E8'},
                    bgColor:{argb:'FF4AC1E8'}
                };
            }
        
            // Adjust column widths
            worksheet.columns = [
                { key: 'amcName', width: 30 },
                { key: 'schemeName', width: 30 },
                { key: 'assetType', width: 25 },
                { key: 'folio', width: 25 },
                { key: 'lienEligibleUnits', width: 25 },
                { key: 'costValue', width: 25 },
                { key: 'currentMktValue', width: 25 },
                { key: 'gainLoss', width: 25 },
                { key: 'gainLossPercentage', width: 25 },
            ];

            // Add the scheme data rows starting from row 9
            for (var index = 0; index < vm.externalHoldingsList.length; index++) {
                var data = vm.externalHoldingsList[index];
                var rowIndex = 10 + index; // Calculate the current row index
                var row = worksheet.getRow(rowIndex);

                // Set values for the row
                row.values = [
                    data.amcName,
                    data.schemeName,
                    data.schemeType,
                    data.folio,
                    parseFloat(data.lienEligibleUnits).toFixed(2),
                    data.costValue,
                    data.currentMktValue,
                    data.gainLoss,
                    data.gainLossPercentage
                ];

                // Alternate row colors: white for even rows and blue for odd rows
                var fillColor = (index % 2 === 0) ? 'FFFFFFFF' : 'FFADD8E6';

                for (var colIndex = 1; colIndex <= 9; colIndex++) {
                    var cell = row.getCell(colIndex);
            
                    // Set background color
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor },  // Set foreground color
                        bgColor: { argb: fillColor }   // Set background color
                    };
            
                    // Right-align numeric data (columns 3 to 9 are numbers)
                    if (colIndex >= 3) {
                        cell.alignment = { horizontal: 'right' };
                    }
                }

                row.commit(); // Commit the row changes
            }

            // Create a buffer for the Excel file
            workbook.xlsx.writeBuffer().then(function (buffer) {
                var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = 'External_Holdings.xlsx';
                a.click();
                URL.revokeObjectURL(url);
            });
        };

        function successgetCapitalGainReport(response){
            vm.downloadPDFReport = response.data;
            if (vm.downloadPDFReport.validFlag) {
                window.open(vm.downloadPDFReport.path, '_blank');
                vm.closeDialog();
            } 
            if(!response.data.status){
                showDialogSucc(response.data.message);
            }
        }

        function errorgetCapitalGainReport(response){
            console.log(response);
            showDialog(response.data.responseString);
        }

        function getCapitalGainReport(){
            console.log('vm.customerDetail._id', vm.customerDetail._id);
            vm.id = vm.customerDetail._id;
            ServiceProxy.getCapitalGainReport(vm.id).then(successgetCapitalGainReport, errorgetCapitalGainReport);
        }

        function successgetCapitalGainReportExcel(response){
            var downloadLink = response.excelLink || (response.data && (response.data.excelLink || response.data.path));
            if (downloadLink) {
                var a = document.createElement('a');
                a.href = downloadLink;
                a.download = '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                vm.closeDialog();
            }
            if (response.data && !response.data.status) {
                showDialogSucc(response.data.message);
            }
        }

        function errorgetCapitalGainReportExcel(response){
            console.log(response);
            showDialog(response.data.responseString);
        }

        function getCapitalGainReportExcel(){
            vm.id = vm.customerDetail._id;
            ServiceProxy.getCapitalGainReportExcel(vm.id).then(successgetCapitalGainReportExcel, errorgetCapitalGainReportExcel);
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };

        function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
        ///////////////////////////////show success dialog message ends here//////////////////////////////////////////////

    }
})();
(function () {
    'use strict';

    angular.module('app.customers').controller('CustomerIndexController', CustomerIndexController);

    /** @ngInject */
    function CustomerIndexController($rootScope, $state) {
        var vm = this;

        function init() {
            $rootScope.$on('$stateChangeStart', function (event, next, current) {
                var url = next.url.split('/')[1];
                if (url === 'userDetail') {
                    vm.selectedTab = 0;
                } else if (url === 'flags') {
                    vm.selectedTab = 1;
                } else if (url === 'activity') {
                    vm.selectedTab = 2;
                } else if (url === 'callingHistory') {
                    vm.selectedTab = 3;
                } else if (url === 'customerDetail') {
                    vm.selectedTab = 4;
                } else if (url === 'uploadDownloadForm') {
                    vm.selectedTab = 5;
                } else if (url === 'insuranceList') {
                    vm.selectedTab = 6;
                } else if (url === 'Transaction') {
                    vm.selectedTab = 7;
                } else if (url === 'loanList') {
                    vm.selectedTab = 8;
                } else if (url === 'nps') {
                    vm.selectedTab = 9;
                } else if (url === 'sipDetail') {
                    vm.selectedTab = 10;
                } else if (url === 'transactionHistory') {
                    vm.selectedTab = 11;
                } else if (url === 'sipfundTransactions') {
                    vm.selectedTab = 12;
                } else if (url === 'ACHMandateDetails') {
                    vm.selectedTab = 13;
                }
            });
        }
        init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('CustomerEditController', CustomerEditController)
        .directive("panRegex", function() {
            var regexp;
            return {
                restrict: "A",
                link: function($scope, elem, attrs) {
                    //regexp = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/;
                    regexp = /^([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([0-9]([0-9]([0-9]([0-9]([a-zA-Z])?)?)?)?)?)?)?)?)?)?$/;
                    var char;
                    elem.bind("keypress", function(event) {
                        char = String.fromCharCode(event.which)
                        if(!regexp.test(elem.val() + char))
                            event.preventDefault();
                    })
                }
            }
        })
        .directive("numericRegex", function() {
            var regexp;
            return {
                restrict: "A",
                link: function(scope, elem, attrs) {
                    regexp = /^([0-9]){0,10}$/;
                    var char;
                    elem.bind("keypress", function(event) {
                        char = String.fromCharCode(event.which)
                        if(!regexp.test(elem.val() + char))
                            event.preventDefault();
                    })
                }
            }
        
        })
        .directive('capitalize', function() {
            return {
              require: 'ngModel',
              link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                  if (inputValue == undefined) inputValue = '';
                  var capitalized = inputValue.toUpperCase();
                  if (capitalized !== inputValue) {
                    // see where the cursor is before the update so that we can set it back
                    var selection = element[0].selectionStart;
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                    // set back the cursor after rendering
                    element[0].selectionStart = selection;
                    element[0].selectionEnd = selection;
                  }
                  return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]); // capitalize initial value
              }
            };
          })
        .directive("limitTo", [function() {
            return {
                restrict: "A",
                link: function(scope, elem, attrs) {
                    var limit = parseInt(attrs.limitTo);
                    angular.element(elem).on("keypress", function(e) {
                        if (this.value.length == limit) e.preventDefault();
                    });
                }
            }
        }]);

    /** @ngInject */
    function CustomerEditController($state,$scope, $window, $mdDialog,$stateParams, ShareDataService, StorageService, ServiceProxy) {
        var vm = this;

      
        function init() {
            if ($stateParams.id && ShareDataService.getData('customerDetail')) {
                vm.customer = ShareDataService.getData('customerDetail');
                vm.contact_no = parseInt(vm.customer.mobileNo);
                vm.iin_no = parseInt(vm.customer.iin);
                if(vm.customer.nseData){
                    vm.acc_no = vm.customer.nseData.AC_NO
                    vm.ifsc_no = vm.customer.nseData.IFSC_CODE
                }
                vm.pan_no = vm.customer.pan
                vm.email = vm.customer.email
                // vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                if (vm.customer === null || vm.customer === undefined) {
                    UserDetails(vm.customer._id);
                } else {
                    vm.userDetail = vm.customer;
                }

            } else {
                $state.go('app.customers');
            }
            vm.disableSubmit = disableSubmit;
            vm.editCustomer = editCustomer;
            vm.syncInvestorIIN = syncInvestorIIN;
            vm.ifsc
            vm.panNum
            vm.selectBankType
            
            vm.goBack = goBack;
            
        };
        init();

        $scope.checkIFSC = function() {
            var ifsc = vm.ifsc_no;
            if (ifsc && ifsc.length === 11) {
                getBankDetailsFrmIFSC(ifsc);
            }
        };

        function successCallbackOnBankType (response) {
            // Message.success('Data Successfully retrieved.');
            $scope.bankTypeData = response.data.Data.bank_master;
            if(vm.ifsc_no){
                getBankDetailsFrmIFSC(vm.ifsc_no);
            }
        };
        function errorCallbackOnBankType (response) {
            if (response.data) {
                showDialog(response.data.message);
            } else {
                showDialog('Something went wrong.Please refresh the page.');
            }
        };

        function getBankType () {
            ServiceProxy.getBankType().then(successCallbackOnBankType, errorCallbackOnBankType);
        };
        getBankType();

        // API Call To get Bank Detail Start
        function sucessCbGetBankDetailsFrmIFSC(response) {

            if (response.data.validFlag && response.data.responseString.nseBankName !== '') {
                angular.forEach($scope.bankTypeData, function(selectedBank) {
                    if (selectedBank.BANK_NAME === response.data.responseString.nseBankName) {
                        vm.selectBankType = selectedBank;
                    }
                });
            } else {
                $scope.ifscFlag = true;
                $scope.hideBankDetail = true;
            }

        }

        function errorCbGetBankDetailsFrmIFSC(response) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(response.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
            $mdDialog.show(confirm);
        }

        function getBankDetailsFrmIFSC (postData) {
            ServiceProxy.getBankDetailsFrmIFSC(postData).then(sucessCbGetBankDetailsFrmIFSC, errorCbGetBankDetailsFrmIFSC);
        };

        function goBack() {
            // $window.history.back();
            $state.go('app.customers');
        }

        function disableSubmit() {
            return !(vm.contact_no);
        }


        function sucessCbEditCustomer(res) {
            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm)
                .then(goBack);
        }

        function errorCbEditCustomer(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
        }

        function errorCbEditIFSC(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
        }

        function editCustomer() {
            // if(!vm.ifsc_no){
            //     return errorCbEditIFSC('IFSC is required')
            // }
            // if(vm.ifsc_no){
            // vm.ifsc = /^[A-Za-z]{4}\d{7}$/.test(vm.ifsc_no)
            // if (!vm.ifsc) {
            //     return errorCbEditIFSC('wrong IFSC')
            // }
            // }

            if(vm.pan_no){
            vm.panNum = /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/.test(vm.pan_no)
            if(!vm.panNum){
                return errorCbEditIFSC('wrong PAN')
            }
            }

            if (vm.iin_no) {
                vm.iin = /^[1-9]{1}[0-9]{9}$/.test(vm.iin_no)
                if (!vm.iin) {
                    return errorCbEditIFSC('wrong IIN')
                }
            }
            
            var postData = {};
            postData._id = vm.customer._id //vm.customerDetail._id
            postData.acc_no = vm.acc_no ? vm.acc_no : ''
            postData.email = vm.email
            postData.mobileNo = vm.contact_no
            postData.pan = vm.pan_no
            postData.iin = vm.iin_no
            // vm.customer.IFSC_CODE = vm.ifsc_no
            // if(vm.customer.nseData){
            // if(vm.customer.nseData.FH_PAN_NO){
            // vm.customer.nseData.FH_PAN_NO = vm.pan_no
            // }
            
            
            postData.nseData = vm.customer.nseData
            if(postData.nseData){
                postData.nseData.FH_PAN_NO = vm.pan_no
            }
            
            if(vm.ifsc_no && vm.acc_no){
                postData.nseData.IFSC_CODE = vm.ifsc_no
                postData.nseData.AC_NO = vm.acc_no
            }
            // else if((vm.ifsc_no && !vm.acc_no) || (!vm.ifsc_no && vm.acc_no)){
            //     return errorCbEditIFSC('Please Enter Bank Account and IFSC Code')
            // }

            postData.nseData.IFSC_CODE = vm.ifsc_no
            postData.nseData.AC_NO = vm.acc_no
            
            
            if(vm.customer.nseData && typeof (postData.nseData.BANK_NAME) == 'string' && vm.selectBankType){
                postData.nseData.BANK_NAME = vm.selectBankType.BANK_CODE
            }else if(vm.customer.nseData && typeof (postData.nseData.bank_name) == 'object' && vm.selectBankType){
                postData.nseData.bank_name.BANK_NAME = vm.selectBankType.BANK_NAME
                postData.nseData.bank_name.BANK_CODE = vm.selectBankType.BANK_CODE
            }else if(vm.selectBankType){
                postData.nseData.bank_name = {}
                postData.nseData.bank_name.BANK_NAME = vm.selectBankType.BANK_NAME
                postData.nseData.bank_name.BANK_CODE = vm.selectBankType.BANK_CODE
            }
                // postData.nseData = vm.customer.nseData
            // }

            if(vm.customer.rawData){
                if(vm.customer.rawData.userDetails){
                    vm.customer.rawData.userDetails.pan = vm.pan_no;
                }
                if(vm.customer.rawData.nseDetails){
                vm.customer.rawData.nseDetails.pan = vm.pan_no
                vm.customer.rawData.nseDetails.valid_pan = vm.pan_no
                vm.customer.rawData.nseDetails.ifsc_code = vm.ifsc_no
                vm.customer.rawData.nseDetails.acc_no = vm.acc_no
                if(typeof (vm.customer.rawData.nseDetails.BANK_NAME) == 'string' && vm.selectBankType){
                    vm.customer.rawData.BANK_NAME = vm.selectBankType.BANK_CODE
                }else if(typeof (vm.customer.rawData.nseDetails.bank_name) == 'object' && vm.selectBankType){
                    vm.customer.rawData.nseDetails.bank_name.BANK_NAME = vm.selectBankType.BANK_NAME
                    vm.customer.rawData.nseDetails.bank_name.BANK_CODE = vm.selectBankType.BANK_CODE
                }
                }
                
                postData.rawData = vm.customer.rawData
            }

            if(vm.customer.camsKycData){
                if(vm.customer.camsKycData.APP_PAN_NO){
                    vm.customer.camsKycData.APP_PAN_NO =  vm.pan_no
                }
                postData.camsKycData = vm.customer.camsKycData
            }
            
            
            if (vm.customer._id) {
                ServiceProxy.updateCustomer(postData).then(sucessCbEditCustomer, errorCbEditCustomer)
            } 
        }
        //prevent user to write 10 digit only contact no.
        // $scope.keyPress = function(event) {
        //     const pattern = /[0-9\+\-\ ]/;
        
        //     let inputChar = String.fromCharCode(event.charCode);
        //     var num = vm.customer.mobileNo.toString();
        //     if (num.length > 9) {//event.keyCode != 8 && !pattern.test(inputChar)
        //       event.preventDefault();
        //     }
        //   }

        //   regexp = /^([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([0-9]([0-9]([0-9]([0-9]([a-zA-Z])?)?)?)?)?)?)?)?)?)?$/;



        function sucessCbUserProfile(response) {
            vm.userDetail = response.data.data;
            ShareDataService.storeData('customerDetail', response.data.data);
        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function UserDetails(id) {
            ServiceProxy.getUserProfile(id).then(sucessCbUserProfile, errorGetUserProfile)
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////


        //Sync IIN
        function syncInvestorIIN() {
            if ($window.confirm("Do you wants to confirm for sync IIN?")) {
                var postData = {};
                postData._id = vm.customer._id; //vm.customerDetail._id
                postData.userIIN = vm.iin_no;
                if (vm.customer._id) {
                    ServiceProxy.syncInvestorIIN(postData).then(sucessCbSyncInvestorIIN, errorCbSyncInvestorIIN)
                }
            }
            else {
                showDialog('You clicked Cancel.');
            }
        };

        function sucessCbSyncInvestorIIN(res) {
            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm)
                .then(goBack);
        };

        function errorCbSyncInvestorIIN(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('CustomerEditController', CustomerEditController)
        .directive("panRegex", function() {
            var regexp;
            return {
                restrict: "A",
                link: function($scope, elem, attrs) {
                    //regexp = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/;
                    regexp = /^([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([0-9]([0-9]([0-9]([0-9]([a-zA-Z])?)?)?)?)?)?)?)?)?)?$/;
                    var char;
                    elem.bind("keypress", function(event) {
                        char = String.fromCharCode(event.which)
                        if(!regexp.test(elem.val() + char))
                            event.preventDefault();
                    })
                }
            }
        })
        .directive("numericRegex", function() {
            var regexp;
            return {
                restrict: "A",
                link: function(scope, elem, attrs) {
                    regexp = /^([0-9]){0,10}$/;
                    var char;
                    elem.bind("keypress", function(event) {
                        char = String.fromCharCode(event.which)
                        if(!regexp.test(elem.val() + char))
                            event.preventDefault();
                    })
                }
            }
        
        })
        .directive('capitalize', function() {
            return {
              require: 'ngModel',
              link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                  if (inputValue == undefined) inputValue = '';
                  var capitalized = inputValue.toUpperCase();
                  if (capitalized !== inputValue) {
                    // see where the cursor is before the update so that we can set it back
                    var selection = element[0].selectionStart;
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                    // set back the cursor after rendering
                    element[0].selectionStart = selection;
                    element[0].selectionEnd = selection;
                  }
                  return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]); // capitalize initial value
              }
            };
          })
        .directive("limitTo", [function() {
            return {
                restrict: "A",
                link: function(scope, elem, attrs) {
                    var limit = parseInt(attrs.limitTo);
                    angular.element(elem).on("keypress", function(e) {
                        if (this.value.length == limit) e.preventDefault();
                    });
                }
            }
        }]);

    /** @ngInject */
    function CustomerEditController($state,$scope, $window, $mdDialog,$stateParams, ShareDataService, StorageService, ServiceProxy) {
        var vm = this;

      
        function init() {
            if ($stateParams.id && ShareDataService.getData('customerDetail')) {
                vm.customer = ShareDataService.getData('customerDetail');
                vm.contact_no = parseInt(vm.customer.mobileNo);
                vm.iin_no = angular.isNumber(vm.customer.iin) ? parseInt(vm.customer.iin) : vm.customer.iin;
                if(vm.customer.nseData){
                    vm.acc_no = vm.customer.nseData.AC_NO
                    vm.ifsc_no = vm.customer.nseData.IFSC_CODE
                }
                vm.pan_no = vm.customer.pan
                vm.email = vm.customer.email
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                if (vm.customer === null || vm.customer === undefined) {
                    UserDetails(vm.customer._id);
                } else {
                    vm.userDetail = vm.customer;
                }

            } else {
                $state.go('app.customers');
            }
            vm.disableSubmit = disableSubmit;
            vm.editCustomer = editCustomer;
            vm.syncInvestorIIN = syncInvestorIIN;
            vm.ifsc
            vm.panNum
            vm.selectBankType
            
            vm.goBack = goBack;
            
            getBankType(vm.customerDetail.iin);
        };
        init();

        $scope.checkIFSC = function() {
            var ifsc = vm.ifsc_no;
            if (ifsc && ifsc.length === 11) {
                getBankDetailsFrmIFSC(ifsc);
            }
        };

        function successCallbackOnBankType(response) {
            vm.selectBankType = response.data.data.filter(function(bank) {
                return bank.STATUS === "ACTIVE";
            });

            console.log('Filtered active banks:', vm.selectBankType);
        }

        function errorCallbackOnBankType (response) {
            if (response.data) {
                showDialog(response.data.servicemsg);
            } else {
                showDialog('Something went wrong.Please refresh the page.');
            }
        };

        function getBankType (iin) {
            ServiceProxy.getBankAccount(iin).then(successCallbackOnBankType, errorCallbackOnBankType);
        };

        function sucessCbGetBankDetailsFrmIFSC(response) {

            if (response.data.validFlag && response.data.responseString.nseBankName !== '') {
                angular.forEach($scope.bankTypeData, function(selectedBank) {
                    if (selectedBank.BANK_NAME === response.data.responseString.nseBankName) {
                        vm.selectBankType = selectedBank;
                    }
                });
            } else {
                $scope.ifscFlag = true;
                $scope.hideBankDetail = true;
            }

        }

        function errorCbGetBankDetailsFrmIFSC(response) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(response.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
            $mdDialog.show(confirm);
        }

        function getBankDetailsFrmIFSC (postData) {
            ServiceProxy.getBankDetailsFrmIFSC(postData).then(sucessCbGetBankDetailsFrmIFSC, errorCbGetBankDetailsFrmIFSC);
        };

        function goBack() {
            // $window.history.back();
            $state.go('app.customers');
        }

        function disableSubmit() {
            return !(vm.contact_no);
        }


        function sucessCbEditCustomer(res) {
            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm)
                .then(goBack);
        }

        function errorCbEditCustomer(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
        }

        function errorCbEditIFSC(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
        }

        function editCustomer() {
            // if(!vm.ifsc_no){
            //     return errorCbEditIFSC('IFSC is required')
            // }
            // if(vm.ifsc_no){
            // vm.ifsc = /^[A-Za-z]{4}\d{7}$/.test(vm.ifsc_no)
            // if (!vm.ifsc) {
            //     return errorCbEditIFSC('wrong IFSC')
            // }
            // }

            if(vm.pan_no){
                vm.panNum = /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/.test(vm.pan_no)
                if(!vm.panNum){
                    return errorCbEditIFSC('wrong PAN')
                }
            }
            
            var postData = {};
            postData._id = vm.customer._id //vm.customerDetail._id
            postData.acc_no = vm.acc_no ? vm.acc_no : ''
            postData.email = vm.email
            postData.mobileNo = vm.contact_no
            postData.pan = vm.pan_no
            postData.iin = vm.iin_no
            if (vm.customer.pan === vm.pan_no)
            {
                postData.panedit = false
            }
            else
            {
                postData.panedit = true
            }
            // vm.customer.IFSC_CODE = vm.ifsc_no
            // if(vm.customer.nseData){
            // if(vm.customer.nseData.FH_PAN_NO){
            // vm.customer.nseData.FH_PAN_NO = vm.pan_no
            // }
            
            
            postData.nseData = vm.customer.nseData
            if(postData.nseData){
                postData.nseData.FH_PAN_NO = vm.pan_no
            }
            
            if(vm.ifsc_no && vm.acc_no){
                postData.nseData.IFSC_CODE = vm.ifsc_no
                postData.nseData.AC_NO = vm.acc_no
            }
            // else if((vm.ifsc_no && !vm.acc_no) || (!vm.ifsc_no && vm.acc_no)){
            //     return errorCbEditIFSC('Please Enter Bank Account and IFSC Code')
            // }

            postData.nseData.IFSC_CODE = vm.ifsc_no
            postData.nseData.AC_NO = vm.acc_no
            
            
            if(vm.customer.nseData && typeof (postData.nseData.BANK_NAME) == 'string' && vm.selectBankType){
                postData.nseData.BANK_NAME = vm.selectBankType.BANK_CODE
            }else if(vm.customer.nseData && typeof (postData.nseData.bank_name) == 'object' && vm.selectBankType){
                postData.nseData.bank_name.BANK_NAME = vm.selectBankType.BANK_NAME
                postData.nseData.bank_name.BANK_CODE = vm.selectBankType.BANK_CODE
            }else if(vm.selectBankType){
                postData.nseData.bank_name = {}
                postData.nseData.bank_name.BANK_NAME = vm.selectBankType.BANK_NAME
                postData.nseData.bank_name.BANK_CODE = vm.selectBankType.BANK_CODE
            }
                // postData.nseData = vm.customer.nseData
            // }

            if(vm.customer.rawData){
                if(vm.customer.rawData.userDetails){
                    vm.customer.rawData.userDetails.pan = vm.pan_no;
                }
                if(vm.customer.rawData.nseDetails){
                vm.customer.rawData.nseDetails.pan = vm.pan_no
                vm.customer.rawData.nseDetails.valid_pan = vm.pan_no
                vm.customer.rawData.nseDetails.ifsc_code = vm.ifsc_no
                vm.customer.rawData.nseDetails.acc_no = vm.acc_no
                if(typeof (vm.customer.rawData.nseDetails.BANK_NAME) == 'string' && vm.selectBankType){
                    vm.customer.rawData.BANK_NAME = vm.selectBankType.BANK_CODE
                }else if(typeof (vm.customer.rawData.nseDetails.bank_name) == 'object' && vm.selectBankType){
                    vm.customer.rawData.nseDetails.bank_name.BANK_NAME = vm.selectBankType.BANK_NAME
                    vm.customer.rawData.nseDetails.bank_name.BANK_CODE = vm.selectBankType.BANK_CODE
                }
                }
                
                postData.rawData = vm.customer.rawData
            }

            if(vm.customer.camsKycData){
                if(vm.customer.camsKycData.APP_PAN_NO){
                    vm.customer.camsKycData.APP_PAN_NO =  vm.pan_no
                }
                postData.camsKycData = vm.customer.camsKycData
            }
            
            
            if (vm.customer._id) {
                ServiceProxy.updateCustomer(postData).then(sucessCbEditCustomer, errorCbEditCustomer)
            } 
        }
        //prevent user to write 10 digit only contact no.
        // $scope.keyPress = function(event) {
        //     const pattern = /[0-9\+\-\ ]/;
        
        //     let inputChar = String.fromCharCode(event.charCode);
        //     var num = vm.customer.mobileNo.toString();
        //     if (num.length > 9) {//event.keyCode != 8 && !pattern.test(inputChar)
        //       event.preventDefault();
        //     }
        //   }

        //   regexp = /^([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([a-zA-Z]([0-9]([0-9]([0-9]([0-9]([a-zA-Z])?)?)?)?)?)?)?)?)?)?$/;



        function sucessCbUserProfile(response) {
            vm.userDetail = response.data.data;
            ShareDataService.storeData('customerDetail', response.data.data);
        }

        function errorGetUserProfile(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function UserDetails(id) {
            ServiceProxy.getUserProfile(id).then(sucessCbUserProfile, errorGetUserProfile)
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////


        //Sync IIN
        function syncInvestorIIN() {
            if ($window.confirm("Do you wants to confirm for sync IIN?")) {
                var postData = {};
                postData._id = vm.customer._id; //vm.customerDetail._id
                postData.userIIN = vm.iin_no;
                if (vm.customer._id) {
                    ServiceProxy.syncInvestorIIN(postData).then(sucessCbSyncInvestorIIN, errorCbSyncInvestorIIN)
                }
            }
            else {
                showDialog('You clicked Cancel.');
            }
        };

        function sucessCbSyncInvestorIIN(res) {
            var confirm = $mdDialog.confirm()
                .title('Success !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm)
                .then(goBack);
        };

        function errorCbSyncInvestorIIN(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res.data.responseString)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('ceaseSipController', ceaseSipController);

    /** @ngInject */
    function ceaseSipController($state, $mdDialog, ServiceProxy, ShareDataService, $scope) {
        var vm = this;
        vm.transactions = [];
        vm.SipDetail = [];

        function init() {
            var cd = ShareDataService.getData('customerDetail');
            if (cd) {
                vm.customerDetail = angular.copy(cd);
                vm.ceaseMasterData = [];
                getAllDetail(vm.customerDetail.iin);
                ceasemasterdata();
            } else {
                $state.go('app.customers');
            }
        }
        init();

        function sucessCbceasemasterdata(response) {
            console.log('Cease Master Data response:', response);
            vm.ceaseMasterData = response.data.response;
        }

        function errorGetceasemasterdata(response) {
            console.log('Unable to fetch Cease Master Data.', response);
        }

        function ceasemasterdata() {
            ServiceProxy.ceasemasterdata().then(sucessCbceasemasterdata, errorGetceasemasterdata);
        }

        function sucessCbAllDetail(response) {
            vm.SipDetail =
                response &&
                response.data &&
                response.data.data &&
                response.data.data.registrationReport
                ? response.data.data.registrationReport
                : [];
        }

        function errorGetAllDetail() {
            showDialog('Unable to fetch SIP details.');
        }

        function getAllDetail(iin) {
            var postData = { client_code: iin };
            ServiceProxy.getAllDetail(postData).then(sucessCbAllDetail, errorGetAllDetail);
        }

        vm.addTransaction = function(sip) {
            console.log('Adding SIP:', sip);
            if (vm.transactions.length === 10) {
                showDialog('Can not add more then 10 schemes.');
                return;
            }

            var sipRegNo = sip.xsip_registration_no;
            if (!sipRegNo) {
                showDialog('Registration number not available for this SIP.');
                return;
            }

            var exists = vm.transactions.some(function(t) {
                return t.sip_reg_no === sipRegNo;
            });
            if (exists) {
                showDialog('This SIP is already selected.');
                return;
            }

            var t = {
                client_code: sip.client_code,
                sip_reg_no: sipRegNo,
                remarks: sip.remarksVal,
                scheme_name: sip.scheme_name || '',
                folio_number: sip.folio_number || ''
            };

            vm.transactions.push(t);
            console.log('Current transactions:', vm.transactions);
            sip.remarksVal = '';
        };

        vm.deleteTransaction = function(index) {
            vm.transactions.splice(index, 1);
        };

        function handleCeaseSipResponse(response) {
            console.log('Response received:', response);
            
            var data = response && response.data ? response.data : {};
            var rows = data && data.Data && Array.isArray(data.Data.can_data) ? data.Data.can_data : [];

            if (!rows || rows.length === 0) {
                showDialog('No data received from server. Please try again later.');
                return;
            }
            showCeaseResultsDialog(rows, 'Success');
            vm.transactions = [];
        }

        function errorsendCeaseSipEntry(response) {
            console.error('Error response:', response);
            if (response.status !== 200) {
                showDialog('Server error occurred. Please try again later.');
                return;
            }
            handleCeaseSipResponse(response);
        }

        function successsendCeaseSipEntry(response) {
            console.log('Success response:', response);
            handleCeaseSipResponse(response);
        }

        function showCeaseResultsDialog(rows, header) {
            $mdDialog.show({
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    rows: rows || [],
                    header: header || 'Success'
                },
                controller: ['$scope', '$mdDialog', 'rows', 'header', function($scope, $mdDialog, rows, header) {
                    $scope.header = header;
                    $scope.rows = rows || [];
                    $scope.close = function() { $mdDialog.hide(); };
                }],
                template:
                    '<md-dialog aria-label="Cease SIP Results" style="min-width: 400px;">' +
                    '  <md-dialog-title>' +
                    '    <h4 style="padding: 5px; color: #000000ff; margin: 0;">' +
                    '      {{header}}' +
                    '    </h4>' +
                    '  </md-dialog-title>' +
                    '  <md-dialog-content style="max-height: 400px; overflow-y: auto;">' +
                    '    <div ng-if="!rows.length" style="padding: 16px; text-align: center;">' +
                    '      <p>No details available.</p>' +
                    '    </div>' +
                    '    <md-list ng-if="rows.length">' +
                    '      <md-list-item ng-repeat="r in rows track by $index" style="border-bottom: 1px solid #eee;">' +
                    '        <div style="margin: 8px 0; word-break: break-word; width: 100%;">' +
                    '          <div ng-if="r.can_status === \'CAN_SUCCESS\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
                    '            SIP: {{r.xsip_reg_no || "N/A"}} Success: {{r.can_remark || "NA"}}' +
                    '          </div>' +
                    '          <div ng-if="r.can_status === \'CAN_FAILED\'" style="font-weight: bold; color: #767676ff; margin-bottom: 4px;">' +
                    '            SIP: {{r.xsip_reg_no || "N/A"}} Error: {{r.can_remark || "Unknown error"}}' +
                    '          </div>' +
                    '        </div>' +
                    '      </md-list-item>' +
                    '    </md-list>' +
                    '  </md-dialog-content>' +
                    '  <md-dialog-actions layout="row" layout-align="end center">' +
                    '    <md-button class="md-primary" ng-click="close()">OK</md-button>' +
                    '  </md-dialog-actions>' +
                    '</md-dialog>'
            });
        }

        vm.ceaseSip = function() {
            if (!vm.transactions.length) {
                showDialog('Please add at least one SIP to cease.');
                return;
            }

            var payload = {
                can_data: vm.transactions.map(function(t) {
                   return {
                        xsip_reg_no: t.sip_reg_no,
                        remarks: t.remarks,
                        client_code: t.client_code
                    };
                })
            };
            ServiceProxy.sendCeaseSipEntry(payload).then(successsendCeaseSipEntry, errorsendCeaseSipEntry);
        };

        function showDialog(message) {
            var confirm = $mdDialog
                .confirm()
                .title('!!Error!!')
                .textContent(message)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        function showDialogSucc(message) {
            var confirm = $mdDialog
                .confirm()
                .title('Success')
                .textContent(message)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('amcforekycController', amcforekycController);

    /** @ngInject */
    function amcforekycController($state, $scope, $mdDialog, ShareDataService, ServiceProxy) {
        var vm = this;

        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
            } else {
                $state.go('app.customers');
            }

            vm.amcforekyc = amcforekyc;
            getamcforekyc();
        }

        init();

        function sucessamcforekyc(response) {
            showDialogSucc('E-KYC request send.');
        }

        function erroramcforekyc(response) {
            //console.error('Error:', response);
            showDialog('An error occurred while processing the eKYC request.');
        }

        function amcforekyc() {
            var postData = {
                'pan': vm.customerDetail.pan,
                'amc_code': vm.selectedAmc,
                'investor_email': vm.customerDetail.email,
                'investor_mobile_no': vm.customerDetail.mobileNo,
                'return_flag': 'Y',
                'client_callback_url': 'https://sipfund.com/SIP-Login/build/app/index.html#/estatus'
            };

            if (!postData.pan) {
                alert('PAN is not available');
                return;
            }
            if (!postData.amc_code) {
                alert('AMC code is not available');
                return;
            }
            if (!postData.investor_email) {
                alert('Investor email is not available');
                return;
            }
            if (!postData.investor_mobile_no) {
                alert('Investor mobile number is not available');
                return;
            }

            ServiceProxy.sendamcforekyc(postData).then(sucessamcforekyc, erroramcforekyc);
        }

        function getamcforekyc() {
            ServiceProxy.getamcforekyc().then(successgetamcforekyc, errorgetamcforekyc);
        }

        function successgetamcforekyc(response) {
            vm.amcList = response.data.response;
        }

        function errorgetamcforekyc(response) {
            //console.error('Get AMC Error:', response);
            showDialog('Failed to fetch AMC data.');
        }

        function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}

        function showDialog(message) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(message)
                .ariaLabel('Error Dialog')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');

            $mdDialog.show(confirm).then(function() {
                // Handle dialog close action if necessary
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('TransactionController', TransactionController);

    /** @ngInject */
    function TransactionController($state, $mdDialog, ShareDataService, StorageService, ServiceProxy) {

        var vm = this;

        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));    
            } else {
                $state.go('app.customers');
            }
           
        }
        init();


        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('SwitchTransactionController', SwitchTransactionController);

    /** @ngInject */
    function SwitchTransactionController($state, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        // Initialize the controller
        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                vm.transactions = [];
                vm.allHoldings = [];
                vm.schemeList = [];
                vm.frequencyArray = [];
                vm.sipDateArray = [];
                vm.instrm_amount = 0;
                vm.folioList = [];
                vm.sip_amount = '';
                investorHoldings(vm.customerDetail.pan);
                console.log('Customer Detail:', vm.customerDetail);
            } else {
                $state.go('app.customers');
            }
        }
        init();

        // Single declaration of getAllScheme success callback
        function successgetAllScheme(response) {
            console.log('getAllScheme response:', response);
            
            var filteredSchemes = response.data.Data.product_master.filter(function(item) {
                return item.PURCHASE_ALLOWED === "Y";
            });

            // Update the scheme list for the currently checked holding
            for (var i = 0; i < vm.allHoldings.length; i++) {
                var holding = vm.allHoldings[i];
                if (holding.isChecked) {
                    holding.schemeList = filteredSchemes;
                    break;
                }
            }
            vm.searchTextSch = '';
        }

        // Single declaration of getAllScheme error callback
        function errorgetAllScheme(response) {
            vm.schemeList = [];
            console.error('getAllScheme error:', response);
            showDialog(response.data.message || response.data.msg || 'Error loading schemes');
        }

        // Single declaration of getAllScheme function
        vm.getAllScheme = function(id) {
            console.log('getAllScheme called with AMC_CODE:', id);
            if (!id) {
                console.error('AMC_CODE is required');
                return;
            }
            ServiceProxy.getAllScheme(id).then(successgetAllScheme, errorgetAllScheme);
        };

        // Handle checkbox change
        vm.onCheckChange = function(holding) {
            if (vm.transactions.length >= 10) {
                showDialog('You cannot add more than 10 transactions.');
                holding.isChecked = false; // Reset checkbox
                return;
            }

            if (holding.isChecked) {
                holding.redemptionType = 'AMOUNT';
                
                // Uncheck other holdings and clear their data
                for (var i = 0; i < vm.allHoldings.length; i++) {
                    var h = vm.allHoldings[i];
                    if (h !== holding) {
                        h.isChecked = false;
                        h.schemeList = [];
                        h.targetScheme = '';
                        h.amount_unit = '';
                    }
                }
                
                // Load schemes for selected holding using amc_code
                if (holding.amc_code) {
                    vm.getAllScheme(holding.amc_code);
                } else {
                    console.error('amc_code not found for holding:', holding);
                }
            } else {
                holding.schemeList = [];
                holding.targetScheme = '';
                holding.amount_unit = '';
            }
        };

        // Handle target scheme change (called from HTML)
        vm.onTargetSchemeChange = function(scheme) {
            console.log('Target scheme changed:', scheme);
            // Add any additional logic if needed
        };

        // Get investor holdings success callback
        function successinvestorHoldings(response) {
            console.log('Holdings response:', response.data.responseString);
            vm.allHoldings = response.data.responseString || [];
            console.log('vm.allHoldings:', vm.allHoldings);
        }

        // Get investor holdings error callback
        function errorinvestorHoldings(response) {
            showDialog(response.data.msg || 'Error loading holdings');
        }

        // Get investor holdings function
        function investorHoldings(postData) {
            var requestData = {
                'pan': postData
            };
            ServiceProxy.investorHoldings(requestData).then(successinvestorHoldings, errorinvestorHoldings);
        }

        // Select scheme function (keep for compatibility)
        vm.selectScheme = function(id) {
            console.log('Selected Scheme:', id);
            vm.reinvest = id.REINVEST_TAG;
            
            // Handle SIP_DATES
            if (id.SIP_DATES) {
                vm.sipDatesArray = id.SIP_DATES.split(',');
                vm.sipDateArray = [];

                for (var i = 0; i < vm.sipDatesArray.length; i++) {
                    var sipDate = vm.sipDatesArray[i];
                    vm.sipDateArray.push(sipDate);
                }
                console.log('Filtered SIP Dates:', vm.sipDateArray);
            } else {
                vm.sipDateArray = [];
            }

            if (id.SYSTEMATIC_FREQUENCIES) {
                vm.sysFreqArray = id.SYSTEMATIC_FREQUENCIES.split(',');
                vm.frequencyArray = [];

                if (vm.freqDataArray) {
                    angular.forEach(vm.freqDataArray, function(data) {
                        angular.forEach(vm.sysFreqArray, function(freqCode) {
                            if (data.code === freqCode) {
                                if (data.code === 'OM') {
                                    vm.sip_freq = data;
                                }
                                vm.frequencyArray.push(data);
                            }
                        });
                    });
                }
                console.log('Filtered Frequency Array:', vm.frequencyArray);
            } else {
                vm.frequencyArray = [];
            }
        };

        // Add transaction to the list - Updated for API format
        vm.addTransaction = function(scheme) {
            if (vm.transactions.length >= 10) {
                showDialog('Cannot add more than 10 schemes.');
                return;
            }

            // Validation for required fields
            if (!scheme.targetScheme) {
                showDialog('Please select a target scheme.');
                return;
            }

            // Validation for UNIT type using new field names
            if (scheme.redemptionType === 'UNIT') {
                if (scheme.amount_unit > scheme.units) {
                    showDialog('Cannot add more units than you have (' + scheme.units + ' available).');
                    return;
                }
            }

            // Validation for AMOUNT type using new field names
            if (scheme.redemptionType === 'AMOUNT') {
                if (scheme.amount_unit > scheme.currentValue) {
                    showDialog('Cannot add more amount than you have (₹' + scheme.currentValue.toFixed(2) + ' available).');
                    return;
                }
            }

            // Validate amount/unit input for non-All_UNIT types
            if ((scheme.redemptionType === 'AMOUNT' || scheme.redemptionType === 'UNIT') && 
                (!scheme.amount_unit || scheme.amount_unit <= 0)) {
                showDialog('Please enter a valid amount/unit.');
                return;
            }

            // Handle redemption type and all_units
            var finalRedemptionType = scheme.redemptionType;
            var allUnits = '';
            var amountUnit = scheme.amount_unit;

            if (scheme.redemptionType === 'All_UNIT') {
                allUnits = 'Y';
                finalRedemptionType = 'UNIT';
                amountUnit = '';
            }

            // Check for duplicate folio using new field name
            var folioExists = vm.transactions.some(function(transaction) {
                return transaction.folio_no === scheme.folio_no;
            });

            if (folioExists) {
                showDialog('This scheme is already selected.');
                return;
            }

            // Create a new transaction based on the API expected format
            var transaction = {
                // API required fields
                from_scheme_code: scheme.prodcode, // Source scheme code from holdings data
                to_scheme_code: scheme.targetScheme.productCode, // Target scheme code from selected dropdown
                client_code: vm.customerDetail.client_code || vm.customerDetail.iin, // Client identifier
                amount: finalRedemptionType === 'AMOUNT' ? amountUnit.toString() : '', // Amount for AMOUNT type
                units: finalRedemptionType === 'UNIT' ? amountUnit.toString() : '', // Units for UNIT type
                all_units: allUnits, // 'Y' for all units, 'N' for specific amount/units
                folio_no: scheme.folio_no, // Folio number from holdings
                
                // Additional fields for display purposes in the table
                sourceSchemeName: scheme.scheme,
                targetSchemeName: scheme.targetScheme.productLongName,
                amt_unit_type: finalRedemptionType,
                amt_unit: amountUnit,
                folio: scheme.folio_no // For backward compatibility with HTML template
            };

            // Add the transaction
            vm.transactions.push(transaction);
            console.log('Transaction added:', transaction);

            // Clear the form after adding the transaction
            vm.clearForm(scheme);
        };

        // Delete a specific transaction
        vm.deleteTransaction = function(index) {
            if (index >= 0 && index < vm.transactions.length) {
                var deletedTransaction = vm.transactions[index];
                vm.transactions.splice(index, 1);
                
                // Update total amount if needed
                var deletedAmount = parseFloat(deletedTransaction.amount) || parseFloat(deletedTransaction.units) || 0;
                if (deletedAmount > 0) {
                    vm.instrm_amount -= deletedAmount;
                }
                console.log('Transaction deleted. Remaining:', vm.transactions.length);
            }
        };

        // Clear form function
        vm.clearForm = function(scheme) {
            scheme.redemptionType = 'AMOUNT';
            scheme.amount_unit = '';
            scheme.targetScheme = '';
            scheme.isChecked = false;
            scheme.schemeList = [];
            console.log('Form reset for scheme:', scheme.scheme);
        };

        // Switch transaction success callback
        function successswitchTransaction(response) {
            console.log('Switch Transaction Response:', response);
            
            if (response.data.validFlag === true) {
                // Handle successful transaction
                var successMessage = response.data.message || 'Switch Transaction successful';
                
                // Add email notification if present
                if (response.data.emailNotification) {
                    successMessage += '\n\n' + response.data.emailNotification.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1'); // Clean markdown formatting
                }
                
                showDialogSucc(successMessage);
                
                // Reset transactions and form state
                vm.transactions = [];
                clearForm();
                
                // Refresh holdings data
                investorHoldings(vm.customerDetail.pan);
            } 
            else if (response.data.validFlag === false) {
                // Handle failed transaction
                var errorMessage = response.data.responseString || 'Switch Transaction failed';
                
                // Extract detailed errors from transaction_details if available
                if (response.data.responseData && 
                    response.data.responseData.transaction_details && 
                    response.data.responseData.transaction_details.length > 0) {
                    
                    var failedTransactions = [];
                    var transactionDetails = response.data.responseData.transaction_details;
                    
                    for (var i = 0; i < transactionDetails.length; i++) {
                        var transaction = transactionDetails[i];
                        if (transaction.trxn_status === 'TRXN FAILED') {
                            var errorDetail = 'Scheme ' + transaction.from_scheme_code + ' → ' + transaction.to_scheme_code + ': ' + transaction.trxn_remark;
                            failedTransactions.push(errorDetail);
                        }
                    }
                    
                    if (failedTransactions.length > 0) {
                        errorMessage += '\n\nFailed Transactions:\n• ' + failedTransactions.join('\n• ');
                    }
                }
                
                showDialog(errorMessage);
            } 
            else {
                // Handle unexpected response format
                showDialog('Unexpected response format from server. Please try again or contact support.');
            }
        }

        // Switch transaction error callback - For HTTP/Network errors
        function errorswitchTransaction(response) {
            console.error('Switch Transaction HTTP Error:', response);
            
            var errorMessage = 'Network or server error occurred';
            
            // Extract error message from response if available
            if (response.data) {
                if (response.data.error) {
                    errorMessage = response.data.error;
                } else if (response.data.message) {
                    errorMessage = response.data.message;
                } else if (response.data.responseString) {
                    errorMessage = response.data.responseString;
                }
            } else if (response.statusText) {
                errorMessage = 'Server Error: ' + response.statusText;
            }
            
            showDialog(errorMessage + '\n\nPlease check your connection and try again.');
        }
        // Execute switch transaction
        vm.switchTransaction = function() {
            if (vm.transactions.length === 0) {
                showDialog('Please add at least one transaction before switching.');
                return;
            }

            // Prepare transactions array with only API required fields
            var apiTransactions = vm.transactions.map(function(transaction) {
                return {
                    from_scheme_code: transaction.from_scheme_code,
                    to_scheme_code: transaction.to_scheme_code,
                    client_code: transaction.client_code,
                    amount: transaction.amount,
                    units: transaction.units,
                    all_units: transaction.all_units,
                    folio_no: transaction.folio_no
                };
            });

            vm.purchaseJson = {
                "transaction_details": apiTransactions
            };
            ServiceProxy.switchTransaction(vm.purchaseJson).then(successswitchTransaction, errorswitchTransaction);
        };

        // Error dialog function
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('Error')
                .textContent(response)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        // Success dialog function
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('RedemptionTransactionController', RedemptionTransactionController);

    /** @ngInject */
    function RedemptionTransactionController($state, $mdDialog, ServiceProxy, $scope, ShareDataService) {
        var vm = this;

        // Initialize the controller
        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                vm.transactions = [];
                vm.allHoldings = [];
                vm.schemeList = [];
                vm.frequencyArray = [];
                vm.sipDateArray = [];
                vm.instrm_amount = 0;
                vm.folioList = [];
                investorHoldings(vm.customerDetail.pan);
                vm.sip_amount = '';
                getexternalfoliodata(vm.customerDetail.pan);
                vm.regularSchemes = [];
                vm.externlTransactions = [];
                vm.showInternalExternal = 'internal';
            } else {
                $state.go('app.customers');
            }
        }
        init();

        vm.showInternal = function() {
            vm.showInternalExternal = 'internal';
        }

        vm.showExternal = function() {
            vm.showInternalExternal = 'external';
        }

        function successinvestorHoldings(response) {
            console.log('res', response.data.responseString);
            vm.allHoldings = response.data.responseString
                
            console.log('vm.allHoldings', vm.allHoldings);
        }        

        function errorinvestorHoldings(response) {
            showDialog(response.data.msg);
        }

        function investorHoldings(postData) {
            var postData = {
                'pan': postData
            }
            ServiceProxy.investorHoldings(postData).then(successinvestorHoldings, errorinvestorHoldings);
        }

        vm.selectScheme = function(id) {
            // console.log('Selected Scheme:', id);
            vm.reinvest = id.REINVEST_TAG;
            // Handle SIP_DATES
            if (id.SIP_DATES) {
                vm.sipDatesArray = id.SIP_DATES.split(',');

                vm.sipDateArray = [];

                for (var i = 0; i < vm.sipDatesArray.length; i++) {
                    var sipDate = vm.sipDatesArray[i];

                    // Logic for handling SIP_DATES (can customize based on your needs)
                    vm.sipDateArray.push(sipDate);
                }

                // console.log('Filtered SIP Dates:', vm.sipDateArray);
            } else {
                vm.sipDateArray = [];
            }

            if (id.SYSTEMATIC_FREQUENCIES) {

                vm.sysFreqArray = id.SYSTEMATIC_FREQUENCIES.split(',');

                vm.frequencyArray = [];

                angular.forEach(vm.freqDataArray, function(data) {
                    angular.forEach(vm.sysFreqArray, function(freqCode) {
                        if (data.code === freqCode) {
                            if (data.code === 'OM') {
                                vm.sip_freq = data;
                            }
                            vm.frequencyArray.push(data);
                        }
                    });
                });
        
                // console.log('Filtered Frequency Array:', vm.frequencyArray);
            } else {
                vm.frequencyArray = [];
            }

        };

        // Method to add a transaction to the list
        vm.addTransaction = function (scheme) {

            if (vm.transactions.length === 10) {
                showDialog('Can not add more then 10 schemes.');
                return;
            }

            if (scheme.redemptionType === 'UNIT') {
                if (scheme.amount_unit > scheme.units) {
                    showDialog('Can not add more unit\'s then you have.');
                    return;
                }
            }

            if (scheme.redemptionType === 'AMOUNT') {
                if (scheme.amount_unit > scheme.currentValue) {
                    showDialog('Can not add more amount\'s then you have.');
                    return;
                }
            }

            // Handle redemption type and all_units flag
            if (scheme.redemptionType === 'All_UNIT') {
                scheme.all_units = 'Y';
                scheme.amount_unit = '';
            } else {
                scheme.all_units = 'N';
            }

            // Check for duplicate folio
            var folioExists = vm.transactions.some(function (transaction) {
                return transaction.folio_no === scheme.folio_no;
            });

            if (folioExists) {
                showDialog('This scheme is already selected.');
                return; // Exit the function if the folio already exists
            }

            // Prepare transaction object
            var transaction = {
                scheme: scheme.scheme,
                amcName: scheme.nseSchemeDetails.productAmcName,
                amc: scheme.amc_code,
                folio_no: scheme.folio_no,
                buy_sell_type: 'FRESH',
                scheme_code: scheme.nseSchemeDetails.newSchemeCode,
                ft_acc_no: '',
                amt_unit_type: scheme.redemptionType === 'All_UNIT' ? 'UNIT' : scheme.redemptionType,
                amt_unit: scheme.amount_unit,
                all_units: scheme.all_units,
                input_ref_no: '',
                client_code: vm.customerDetail.iin,
                account_no: vm.customerDetail.nseData.AC_NO,

                // ✅ Set order_amount & redemption_units based on redemptionType
                order_amount: scheme.redemptionType === 'AMOUNT' ? scheme.amount_unit : '',
                redemption_units: scheme.redemptionType === 'UNIT' ? scheme.amount_unit : ''
            };

            // Add the transaction
            vm.transactions.push(transaction);

            // Clear the form after adding the transaction
            vm.clearForm(scheme);
        };
     
        // Method to delete a specific transaction
        vm.deleteTransaction = function(index) {
            var deletedTransaction = vm.transactions[index];
            vm.transactions.splice(index, 1);
            vm.instrm_amount -= deletedTransaction.amount;
            // console.log('Total instrm_amount:', vm.instrm_amount);
        };

        vm.deleteTransactionArray = function() {
            vm.transactions = [];
            vm.instrm_amount = 0;
        };

        vm.clearForm = function(scheme) {
            // Reset scheme-specific data
            scheme.redemptionType = null;
            scheme.amount_unit = null;
            
            // You can also reset other form states if needed (e.g., pristine/untouched)
            // console.log('Form reset for scheme', scheme);
        };

        function errorredemptionTransaction(response) {
            console.log('errorredemptionTransaction', response);

            // Clear previous success or error messages (if you have them stored on vm)
            vm.successMessage = '';
            vm.errorMessage = [];

            // Handle NSE API error format (service_response array)
            if (response.data && response.data.service_response) {
                var transactions = response.data.service_response;
                for (var i = 0; i < transactions.length; i++) {
                    if (transactions[i].Status_Desc || transactions[i].return_msg) {
                        vm.errorMessage.push({
                            Status_Desc: transactions[i].Status_Desc || transactions[i].return_msg,
                            scheme_code: transactions[i].scheme_code,
                            folio_no: transactions[i].folio_no,
                            order_amount: transactions[i].order_amount
                        });
                    }
                }
            }
            // Handle generic error (response.data.error)
            else if (response.data && response.data.error) {
                vm.errorMessage.push({
                    Status_Desc: response.data.error
                });
            }
            // Handle general error string
            else if (response.data && response.data.responseString) {
                vm.errorMessage.push({
                    Status_Desc: response.data.responseString
                });
            }

            // Show dialog with combined messages
            var finalMessage = vm.errorMessage.map(function (err) {
                return err.Status_Desc;
            }).join('\n');

            showDialog(finalMessage || 'Something went wrong during redemption.');
            vm.deleteTransactionArray(wizardStep1);
        }

        function successredemptionTransaction(response) {
            console.log('successredemptionTransaction', response);
            // Clear previous error messages
            vm.errorMessage = [];
            vm.successMessage = '';

            if (response.data.validFlag) {
                // ✅ SUCCESS
                vm.successMessage = response.data.message || 'Transaction successful';
                vm.deleteTransactionArray();
                showDialogSucc(vm.successMessage);
            } else {
                // ❌ FAILURE – fallback to error logic
                handleRedemptionErrors(response);
                vm.deleteTransactionArray();
            }
        }

        function errorredemptionTransaction(response) {
            console.log('errorredemptionTransaction', response);
            vm.successMessage = '';
            vm.errorMessage = [];
            handleRedemptionErrors(response);
            vm.deleteTransactionArray();
        }

        // 🔧 Centralized error handler (like redeemFundErrorCallback)
        function handleRedemptionErrors(response) {
            vm.errorMessage = [];

            if (response.data && response.data.responseData && response.data.responseData.transaction_details) {
                var transactions = response.data.responseData.transaction_details;
                for (var i = 0; i < transactions.length; i++) {
                    if (transactions[i].trxn_remark) {
                        vm.errorMessage.push({
                            Status_Desc: transactions[i].trxn_remark,
                            scheme_code: transactions[i].scheme_code,
                            folio_no: transactions[i].folio_no,
                            order_amount: transactions[i].order_amount,
                            redemption_units: transactions[i].redemption_units,
                            all_units: transactions[i].all_units
                        });
                    }
                }
            }
            else if (response.data && response.data.responseString) {
                vm.errorMessage.push({
                    Status_Desc: response.data.responseString
                });
            }
            else if (response.data && response.data.error) {
                vm.errorMessage.push({
                    Status_Desc: response.data.error
                });
            }

            // Combine all messages
            var finalMessage = vm.errorMessage.map(function (err) {
                return (err.scheme_code ? '['+err.scheme_code +']' : '') + err.Status_Desc;
            }).join('\n');

            showDialog(finalMessage || 'Something went wrong during redemption.');
        }

        vm.redemptionTransaction = function() {

            var purchaseJson = {
                'transaction_details': vm.transactions
            };
            ServiceProxy.redemptionTransaction(purchaseJson).then(successredemptionTransaction, errorredemptionTransaction);
        };

        function successgetexternalfoliodata(response){

            vm.mfCentral = response;
            vm.externalHoldingsList = [];
            vm.regularSchemes = [];
            
            // Check if response structure exists as expected
            if (vm.mfCentral.data && vm.mfCentral.data.responseString && vm.mfCentral.data.responseString.data) {
                vm.mfCentral.data.responseString.data.forEach(function(items) {
                    if (items.schemes && angular.isArray(items.schemes)) {
                        items.schemes.forEach(function(item) {
                            vm.externalHoldingsList.push(item);
                        });
                    }
                });
            }
            
            vm.regularSchemes = vm.externalHoldingsList.filter(function(scheme) {
                return scheme.planMode === "R" || scheme.planMode === "REGULAR" || scheme.planMode === "Regular";
            });
            console.log('regularSchemes', vm.regularSchemes);
        }

        //External holdings Redemption
        function errorgetexternalfoliodata(response){
            console.log('errorRes', response);
        }

        function getexternalfoliodata(data){
            var postData = {
                "pan": data
            }
            console.log('postData', postData);
            ServiceProxy.getexternalfoliodata(postData).then(successgetexternalfoliodata, errorgetexternalfoliodata);
        }

        vm.selectExternalScheme = function(id) {
            // console.log('Selected Scheme:', id);
            vm.reinvest = id.REINVEST_TAG;
            // Handle SIP_DATES
            if (id.SIP_DATES) {
                vm.sipDatesArray = id.SIP_DATES.split(',');

                vm.sipDateArray = [];

                for (var i = 0; i < vm.sipDatesArray.length; i++) {
                    var sipDate = vm.sipDatesArray[i];

                    // Logic for handling SIP_DATES (can customize based on your needs)
                    vm.sipDateArray.push(sipDate);
                }

                // console.log('Filtered SIP Dates:', vm.sipDateArray);
            } else {
                vm.sipDateArray = [];
            }

            if (id.SYSTEMATIC_FREQUENCIES) {

                vm.sysFreqArray = id.SYSTEMATIC_FREQUENCIES.split(',');

                vm.frequencyArray = [];

                angular.forEach(vm.freqDataArray, function(data) {
                    angular.forEach(vm.sysFreqArray, function(freqCode) {
                        if (data.code === freqCode) {
                            if (data.code === 'OM') {
                                vm.sip_freq = data;
                            }
                            vm.frequencyArray.push(data);
                        }
                    });
                });
        
                // console.log('Filtered Frequency Array:', vm.frequencyArray);
            } else {
                vm.frequencyArray = [];
            }

        };

        // Method to add a transaction to the list
        vm.addExternalTransaction = function(scheme) {

            if (vm.externlTransactions.length === 10) {
                showDialog('Can not add more then 10 schemes.');
                return;
            }

            if(scheme.redemptionType === 'UNIT') {
                if(scheme.amount_unit > scheme.availableUnits){
                    showDialog('Can not add more unit\'s then you have.');
                    return;
                }
            }

            if(scheme.redemptionType === 'AMOUNT') {
                if(scheme.amount_unit > scheme.availableAmount){
                    showDialog('Can not add more amount\'s then you have.');
                    return;
                }
            }

            // Handle redemption type and all_units
            if (scheme.redemptionType === 'All_UNIT') {
                scheme.all_units = 'Y';
                scheme.redemptionType = 'UNIT';
                scheme.amount_unit = '';
            } else {
                scheme.all_units = 'N';
                if (scheme.redemptionType === 'UNIT') {
                    scheme.redemptionType = 'UNIT';
                } else {
                    scheme.redemptionType = 'AMOUNT';
                }
            }

            // Check for duplicate folio
            var folioExists = vm.externlTransactions.some(function(transaction) {
                return transaction.folio === scheme.folio;
            });

            if (folioExists) {
                showDialog('This scheme is already selected.');
                return; // Exit the function if the folio already exists
            }
        
            // Create a new transaction based on the scheme data
            var transaction = {
                productAmcName: scheme.amcName,
                schemeName: scheme.schemeName,
                amcName: scheme.amcName,
                amc: scheme.amc,
                folio: scheme.folio,
                product_code: scheme.schemeCode,
                ft_acc_no: '',
                amt_unit_type: scheme.redemptionType,
                amt_unit: scheme.amount_unit,
                all_units: scheme.all_units,
                input_ref_no: ''
            };
        
            // Add the transaction
            vm.externlTransactions.push(transaction);
            // console.log('2',vm.externlTransactions);
        
            // Clear the form after adding the transaction
            vm.clearExternalForm(scheme);
        };        

        // Method to delete a specific transaction
        vm.deleteExternalTransaction = function(index) {
            var deletedTransaction = vm.externlTransactions[index];
            vm.externlTransactions.splice(index, 1);
            vm.instrm_amount -= deletedTransaction.amount;
            // console.log('Total instrm_amount:', vm.instrm_amount);
        };

        vm.deleteExternalTransactionArray = function(wizardStep1) {
            vm.externlTransactions = [];
            vm.instrm_amount = 0;
            vm.clearExternalForm(wizardStep1);
        };

        vm.clearExternalForm = function(scheme) {
            // Reset scheme-specific data
            scheme.redemptionType = null;
            scheme.amount_unit = null;
            
            // You can also reset other form states if needed (e.g., pristine/untouched)
            // console.log('Form reset for scheme', scheme);
        };                

        function errorredemptionExternalTransaction(response){
            console.log('errorredemptionTransaction', response);
            showDialog(response.data.error);
            vm.deleteExternalTransactionArray(wizardStep1);
        }

        function successredemptionExternalTransaction(response) {
            var serviceStatus = response.data.service_status;
            var serviceResponseList = response.data.service_response;
        
            if (serviceStatus && serviceStatus.service_return_code === "0") {
                // Success
                showDialogSucc('Check your email/sms to complete the Redemption process.');
                vm.deleteExternalTransactionArray(wizardStep1);
            } else {
                // Failure - collect error messages
                var errorMessages = '';
                for (var i = 0; i < serviceResponseList.length; i++) {
                    var msg = serviceResponseList[i].Status_Desc || serviceResponseList[i].return_msg;
                    if (msg) {
                        errorMessages += msg + '\n';
                    }
                }
        
                if (!errorMessages) {
                    errorMessages = 'Something went wrong during redemption.';
                }
        
                showDialog(errorMessages);
            }
        }        
        
        vm.redemptionExternalTransaction = function() {

            var purchaseJson = {
                'service_request': {
                    "appln_id": "",
                    "password": "",
                    "broker_code": "",
                    "iin": vm.customerDetail.iin,
                    "poa": "N",
                    "poa_bank_trxn_type": "",
                    "trxn_acceptance": "OL",
                    "dp_id": "",
                    "acc_no": vm.customerDetail.nseData.AC_NO,
                    "bank_name": vm.customerDetail.nseData.BANK_NAME,
                    "ifsc_code": vm.customerDetail.nseData.IFSC_CODE,
                    "remarks": "",
                    "trxn_initiator": "",
                    "trans_count": vm.externlTransactions.length,
                    "investor_auth_log": ""
                },
                'childtrans': vm.externlTransactions
            };
            //console.log('1', purchaseJson);
            ServiceProxy.redemptionTransaction(purchaseJson).then(successredemptionExternalTransaction, errorredemptionExternalTransaction);
        };

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('PurchaseTransactionSIPController', PurchaseTransactionSIPController);

    /** @ngInject */
    function PurchaseTransactionSIPController($state, $location, $scope, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                console.log('vm.customerDetail',vm.customerDetail);
                vm.transactions = [];
                vm.allAmc = [];
                vm.schemeList = [];
                vm.frequencyArray = [];
                vm.sipDateArray = [];
                vm.instrm_amount = 0;
                vm.folioList = [];
                getAllAmc();
                vm.processResponse = processResponse;
                achMandateDetails(vm.customerDetail.iin); 
                vm.freqDataArray = [
                    { 'desc': 'MONTHLY', 'code': 'OM' },
                    { 'desc': 'QUARTERLY', 'code': 'Q' },
                    { 'desc': 'WEEKLY', 'code': 'OW' },
                    { 'desc': 'DAILY', 'code': 'BZ' },
                    { 'desc': 'DAILY', 'code': 'SP' },
                    { 'desc': 'DAILY', 'code': 'WD' },
                    { 'desc': 'DAILY', 'code': 'D' },
                    { 'desc': 'SEMI-ANNUALLY', 'code': 'H' },
                    { 'desc': 'ANNUALLY', 'code': 'Y' },
                ];
                vm.customPayModeData = [{
                    'PAYMENT_MECHANISM': 'TR',
                    'PAYMENT_MECH_DESC': 'RTGS/NEFT'
                }, {
                    'PAYMENT_MECHANISM': 'OL',
                    'PAYMENT_MECH_DESC': 'ONLINE'
                }, {
                    'PAYMENT_MECHANISM': 'UPI',
                    'PAYMENT_MECH_DESC': 'UPI'
                }];
                vm.sip_amount = '';
            } else {
                $state.go('app.customers');
            }
        }
        init();

        function sucessachMandateDetails(response) {
            vm.umrnOptions = [];
            vm.selectedUmrn = '';
        
            if (angular.isArray(response.data.data)) {
                vm.umrnOptions = response.data.data.filter(function(data) {
                    return data.UMRN_NO !== 'PENDING' && data.ACH_MANDATE_STATUS === 'SUCCESS';
                });
            } else if (response.data.Data.UMRN_NO !== 'PENDING' && response.data.Data.ACH_MANDATE_STATUS === 'SUCCESS') {
                vm.umrnOptions = [response.data.data];
            }
        
            // // Automatically select the first UMRN if available
            // if (vm.umrnOptions.length > 0) {
            //     vm.selectedUmrn = vm.umrnOptions[0];
            //     vm.customPayModeData = [
            //         { 'PAYMENT_MECHANISM': 'TR', 'PAYMENT_MECH_DESC': 'RTGS/NEFT' },
            //         { 'PAYMENT_MECHANISM': 'OL', 'PAYMENT_MECH_DESC': 'ONLINE' },
            //         { 'PAYMENT_MECHANISM': 'UPI', 'PAYMENT_MECH_DESC': 'UPI' },
            //         { 'PAYMENT_MECHANISM': 'M', 'PAYMENT_MECH_DESC': 'Debit Mandate' }
            //     ];
            // } else {
            //     vm.customPayModeData = [
            //         { 'PAYMENT_MECHANISM': 'TR', 'PAYMENT_MECH_DESC': 'RTGS/NEFT' },
            //         { 'PAYMENT_MECHANISM': 'OL', 'PAYMENT_MECH_DESC': 'ONLINE' },
            //         { 'PAYMENT_MECHANISM': 'UPI', 'PAYMENT_MECH_DESC': 'UPI' }
            //     ];
            // }
        
            // Update ACH Amount display
            vm.updateAchAmount();
        };

        vm.updateAchAmount = function() {
            if (vm.selectedUmrn) {
                vm.achAmount = vm.selectedUmrn.AMOUNT || '';
            } else {
                vm.achAmount = '';
            }
        };

        function errorachMandateDetails(response) {
            vm.umrnOptions = [];
            vm.selectedUmrn = '';
            if (response && response.data && response.data) {
                showDialog(response.data.msg);
            }
        }

        function achMandateDetails(iin) {
            ServiceProxy.achMandateDetails(iin).then(sucessachMandateDetails, errorachMandateDetails)
        }

        function successgetAllAmc(response) {
            vm.allAmc = response.data.Data.amc_master;
            vm.searchTextAmc = '';  
        }

        function errorgetAllAmc(response) {
            showDialog(response.data.message);
        }

        function getAllAmc() {
            ServiceProxy.getAllAmc().then(successgetAllAmc, errorgetAllAmc);
        }

        function successgetAllScheme(response) {
            vm.schemeList = response.data.Data.product_master;
            vm.searchTextSch = '';
        }

        function errorgetAllScheme(response) {
            vm.schemeList = [];
            showDialog(response.data.message);
        }

        function successgetfoliodata(response) {
            vm.folioList = [];
            vm.folioList = response.data.folioNumbers;
        }

        function errorgetfoliodata(response) {
            vm.folioList = [];
        }

        vm.getAllScheme = function(id, val) {
            vm.amcName = val;
            ServiceProxy.getAllScheme(id).then(successgetAllScheme, errorgetAllScheme);

            var postData = {
                'iin' : vm.customerDetail.iin,
                'AMC_CODE': id
            }
            ServiceProxy.getfoliodata(postData).then(successgetfoliodata, errorgetfoliodata);

        };

        vm.selectScheme = function(id) {
            vm.reinvest = id.REINVEST_TAG;
            if (id.SIP_DATES) {
                vm.sipDatesArray = id.SIP_DATES.split(',');
                vm.sipDateArray = [];

                for (var i = 0; i < vm.sipDatesArray.length; i++) {
                    var sipDate = vm.sipDatesArray[i];
                    vm.sipDateArray.push(sipDate);
                }
            } else {
                vm.sipDateArray = [];
            }

            if (id.SYSTEMATIC_FREQUENCIES) {

                vm.sysFreqArray = id.SYSTEMATIC_FREQUENCIES.split(',');
                vm.frequencyArray = [];

                angular.forEach(vm.freqDataArray, function(data) {
                    angular.forEach(vm.sysFreqArray, function(freqCode) {
                        if (data.code === freqCode) {
                            if (data.code === 'OM') {
                                vm.sip_freq = data;
                            }
                            vm.frequencyArray.push(data);
                        }
                    });
                });
            } else {
                vm.frequencyArray = [];
            }

        };

        vm.sipStart_SipEnd = function(sip_period_day) {
            if (!sip_period_day || isNaN(parseInt(sip_period_day))) {
                console.error('Invalid SIP period day:', sip_period_day);
                return;
            }
            
            var today = new Date();
            var startDay = parseInt(sip_period_day);

            var startDate = new Date(today);
            startDate.setDate(startDate.getDate() + 30);

            if (startDate.getDate() !== startDay) {
                startDate.setMonth(startDate.getMonth() + (startDay < startDate.getDate() ? 1 : 0));
                startDate.setDate(startDay);
            }
        
            vm.sip_from_date = formatDate(startDate);

            var endDate = new Date(startDate);
            endDate.setFullYear(endDate.getFullYear() + 30);
            vm.sip_end_date = formatDate(endDate);
        };

        function formatDate(date) {
            var day = date.getDate().toString().padStart(2, '0');
            var monthNames = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
            var month = monthNames[date.getMonth()];
            var year = date.getFullYear();
            return day+'/'+month+'/'+year;
        }               

        vm.addTransaction = function(wizardStep1) {

            if (vm.transactions.length === 10) {
                showDialog('Can not add more then 10 schemes.');
                return;
            }
            
            if(vm.folio === undefined || vm.folio === null){
                vm.folio = '';
            }else {
                vm.folio = vm.folio;
            }
            
            var transaction = {
                schemeNature : 'S',
                productAmcName: vm.selectedFund.longName,
                amc: vm.selectedFund.amcCode,
                amc_code: vm.product_code.newAmcCode,
                folio: vm.folio,
                schemeName: vm.product_code.productDisplayName,
                product_code: vm.product_code.newSchemeCode,
                sch_code: vm.product_code.newSchemeCode,
                reinvest: vm.reinvest,
                sip_freq: vm.sip_freq,
                sip_period_day: vm.sip_period_day,
                sip_from_date: vm.sip_from_date,
                sip_end_date: vm.sip_end_date,
                amount: vm.amount,
                sip_amount: vm.amount,
                client_code: vm.customerDetail.iin,
                start_date: vm.sip_from_date,
                frequency_type: vm.sip_freq,
                installment_amount: vm.amount,
                first_order_today: vm.first_order_today,
                folio_no: vm.folio,
                member_code: '',
                xsip_mandate_id: vm.selectedUmrn.MANDATE_ID,
                isip_mandate: '',
                step_up_required: 'N'
            };

            if (!transaction.amc || !transaction.product_code || !transaction.reinvest || !transaction.sip_freq || !transaction.sip_period_day || !transaction.sip_from_date || !transaction.sip_end_date || !transaction.sip_amount || !transaction.first_order_today) {
                showDialog("Please fill in all required fields for SIP.");
                return;
            }

            vm.transactions.push(transaction);
            vm.instrm_amount += transaction.amount;
            vm.clearForm(wizardStep1);
        };

        vm.deleteTransaction = function(index) {
            var deletedTransaction = vm.transactions[index];
            vm.transactions.splice(index, 1);
            vm.instrm_amount -= deletedTransaction.amount;
        };

        vm.deleteTransactionArray = function(wizardStep1) {
            vm.transactions = [];
            vm.instrm_amount = 0;
            vm.clearForm(wizardStep1);
        };

        vm.clearForm = function(form) {
            vm.selectedFund = null;
            vm.folio = null;
            vm.product_code = null;
            vm.sip_freq = null;
            vm.sip_period_day = null;
            vm.sip_from_date = null;
            vm.sip_end_date = null;
            vm.amount = null;
            vm.sip_amount = null;
            vm.payMode = null;
            vm.rtgs_code = null;
            vm.useExistingUmrn = null;
            vm.selectedUmrn = null;
            vm.first_order_today = null;

            vm.folioList = [];
            vm.schemeList = [];
            vm.frequencyArray = [];
            vm.sipDateArray = []

            if (form) {
                form.$setPristine();
                form.$setUntouched();
            }
        };

        function errorpurchaseTransaction(response){
            showDialog(response.data.responseString);
            vm.deleteTransactionArray(wizardStep1);
        }

        function successpurchaseTransaction(response){
            if(response.data && response.data.service_status && response.data.service_status.service_msg === "Failure"){
                openDialog(processResponse(response));
            }
            if(response.data && response.data.message){
                showDialogSucc(response.data.message);
            }
            vm.deleteTransactionArray(wizardStep1);
        }

        function getDialogTemplate(option) {
            return '' +
                '<md-dialog style="max-width: 800px; width: 100%;">' +
                    '<md-dialog-header>' +
                        '<h3 style="margin: 15px">!Error!</h3>' +
                    '</md-dialog-header>' +
                    '<md-dialog-content>' +
                        '<h5>'+option+'</h5>' +
                    '</md-dialog-content>' +
                    '<md-dialog-actions>' +
                        '<md-button ng-click="vm.closeDialog()" class="md-primary">Close</md-button>' +
                    '</md-dialog-actions>' +
                '</md-dialog>';
            
        }    

        function openDialog(option) {
            $mdDialog.show({
                template: getDialogTemplate(option),
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true
            });
            vm.selectedOption = '';
        };

        vm.closeDialog = function() {
            vm.from_date = null;
            vm.to_date = null;
            $mdDialog.hide();
        };

        function processResponse(response) {
            var returnMessages = "";

            if (Array.isArray(response.data.service_response)) {
                for (var i = 0; i < response.data.service_response.length; i++) {
                    var currentMsg = response.data.service_response[i].return_msg;
                    returnMessages += currentMsg + "<br>";
                }
            } else if (response.data.service_response && typeof response.data.service_response === 'object') {
                var currentMsg = response.data.service_response.return_msg;
                returnMessages += currentMsg + "<br>";
            }
        
            return returnMessages;
        }        

        vm.handlePayment = function() {
            if (vm.payMode === 'TR') {
                vm.rtgs_code = vm.customerDetail.nseData.IFSC_CODE;
            } else {
                vm.rtgs_code = '';
            }
        }
        
        vm.purchaseTransaction = function() {
        
            vm.purchaseJson = {
                'reg_data': vm.transactions,
            }
            ServiceProxy.sysTransaction(vm.purchaseJson).then(successpurchaseTransaction, errorpurchaseTransaction);
        };

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('PurchaseTransactionLUMPController', PurchaseTransactionLUMPController);

    /** @ngInject */
    function PurchaseTransactionLUMPController($state, $location, $scope, $mdDialog, $sce, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        // Initialize the controller
        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                vm.transactions = [];
                vm.allAmc = [];
                vm.schemeList = [];
                vm.instrm_amount = 0;
                vm.folioList = [];
                vm.processResponse = processResponse;
                achMandateDetails(vm.customerDetail.iin);
                getAllAmc();
                vm.selectedTN = 'N';
                
                vm.customPayModeData = [{
                    'PAYMENT_MECHANISM': 'TR',
                    'PAYMENT_MECH_DESC': 'RTGS/NEFT'
                }, {
                    'PAYMENT_MECHANISM': 'OL',
                    'PAYMENT_MECH_DESC': 'ONLINE'
                }, {
                    'PAYMENT_MECHANISM': 'UPI',
                    'PAYMENT_MECH_DESC': 'UPI'
                }];

                // console.log('Customer Detail:', vm.customerDetail);
            } else {
                $state.go('app.customers');
            }
        }
        init();

        function sucessachMandateDetails(response) {
            vm.umrnOptions = [];
            vm.selectedUmrn = '';
        
            if (angular.isArray(response.data.data)) {
                vm.umrnOptions = response.data.data.filter(function(data) {
                    return data.UMRN_NO !== 'PENDING' && data.ACH_MANDATE_STATUS === 'ACCEPTED';
                });
            } else if (response.data.Data.UMRN_NO !== 'PENDING' && response.data.Data.ACH_MANDATE_STATUS === 'ACCEPTED') {
                vm.umrnOptions = [response.data.data];
            }
            console.log('vm.umrnOptions.length', vm.umrnOptions.length);
        
            // Automatically select the first UMRN if available
            if (vm.umrnOptions.length > 0) {
                vm.selectedUmrn = vm.umrnOptions[0];
                vm.customPayModeData = [
                    { 'PAYMENT_MECHANISM': 'TR', 'PAYMENT_MECH_DESC': 'RTGS/NEFT' },
                    { 'PAYMENT_MECHANISM': 'OL', 'PAYMENT_MECH_DESC': 'ONLINE' },
                    { 'PAYMENT_MECHANISM': 'UPI', 'PAYMENT_MECH_DESC': 'UPI' },
                    { 'PAYMENT_MECHANISM': 'M', 'PAYMENT_MECH_DESC': 'Debit Mandate' }
                ];
            } else {
                vm.customPayModeData = [
                    { 'PAYMENT_MECHANISM': 'TR', 'PAYMENT_MECH_DESC': 'RTGS/NEFT' },
                    { 'PAYMENT_MECHANISM': 'OL', 'PAYMENT_MECH_DESC': 'ONLINE' },
                    { 'PAYMENT_MECHANISM': 'UPI', 'PAYMENT_MECH_DESC': 'UPI' }
                ];
            }
        
            // Update ACH Amount display
            vm.updateAchAmount();
        };
            
        // Function to update ACH Amount based on selected UMRN
        vm.updateAchAmount = function() {
            if (vm.selectedUmrn) {
                vm.achAmount = vm.selectedUmrn.AMOUNT || '';
            } else {
                vm.achAmount = '';
            }
        };

        function errorachMandateDetails() {
            vm.umrnOptions = [];
            vm.selectedUmrn = '';
            if (response && response.data ) {
                showDialog(response.data.msg);
            }
        }

        function achMandateDetails(iin) {
            ServiceProxy.achMandateDetails(iin).then(sucessachMandateDetails, errorachMandateDetails)
        }

        function successgetAllAmc(response) {
            vm.allAmc = response.data.Data.amc_master;
            vm.searchTextAmc = '';  
        }
        
        function errorgetAllAmc(response) {
            showDialog(response.data.message);
        }
        
        function getAllAmc() {
            ServiceProxy.getAllAmc().then(successgetAllAmc, errorgetAllAmc);
        }
        
        function successgetAllScheme(response) {
            vm.schemeList = response.data.Data.product_master.filter(function(item) {
                return item.PURCHASE_ALLOWED === "Y";
            });
            vm.searchTextSch = '';
        }
        
        function errorgetAllScheme(response) {
            vm.schemeList = [];
            showDialog(response.data.message);
        }
        
        function successgetfoliodata(response) {
            vm.folioList = [];
            vm.folioList = response.data.folioNumbers;
        }
        
        function errorgetfoliodata(response) {
            vm.folioList = [];
        }
        
        vm.getAllScheme = function(id, val) {
            vm.amcName = val;
            ServiceProxy.getAllScheme(id).then(successgetAllScheme, errorgetAllScheme);
        
            var postData = {
                'iin' : vm.customerDetail.iin,
                'AMC_CODE': id
            };
        
            ServiceProxy.getfoliodata(postData).then(successgetfoliodata, errorgetfoliodata);
        };        

        vm.selectScheme = function(id) {
            vm.reinvest = id.REINVEST_TAG;
        };

        // Method to add a transaction to the list
        vm.addTransaction = function(wizardStep1) {

            if (vm.transactions.length === 10) {
                showDialog('Can not add more then 10 schemes.');
                return;
            }
            
            if(vm.folio === undefined || vm.folio === null){
                vm.folio = '';
                vm.buy_sell_type = "FRESH"
            } else {
                vm.folio = vm.folio;
                vm.buy_sell_type = "ADDITIONAL";
            }

            var transaction = {
                productAmcName: vm.selectedFund.longName,
                schemeName: vm.product_code.productDisplayName,
                scheme_code: vm.product_code.newSchemeCode,
                buy_sell_type: vm.buy_sell_type,
                client_code: vm.customerDetail.iin,
                order_amount: vm.amount,
                folio_no: vm.folio,
                account_no: vm.customerDetail.nseData.AC_NO
            };

            if (!transaction.scheme_code || !transaction.order_amount ) {
                showDialog("Please fill in all required fields for Lumpsum.");
                return;
            }

            vm.transactions.push(transaction);
            vm.instrm_amount += transaction.amount;
            vm.clearForm(wizardStep1);
        };

        // Method to delete a specific transaction
        vm.deleteTransaction = function(index) {
            var deletedTransaction = vm.transactions[index];
            vm.transactions.splice(index, 1);
            vm.instrm_amount -= deletedTransaction.amount;
        };

        vm.deleteTransactionArray = function(wizardStep1) {
            vm.transactions = [];
            vm.instrm_amount = 0;
            vm.clearForm(wizardStep1);
        };

        vm.clearForm = function(form) {
            vm.selectedFund = null;
            vm.folio = null;
            vm.product_code = null;
            vm.amount = null;

            vm.folioList = [];
            vm.schemeList = [];

            if (form) {
                form.$setPristine();
            }
        };        

        function errorpurchaseTransaction(response){
            openDialog(processResponse(response));
            vm.deleteTransactionArray(wizardStep1);
        }

        function successpurchaseTransaction(response){
            showDialogSucc(response.data.message);
            vm.deleteTransactionArray(wizardStep1);
        }

        function getDialogTemplate(option) {
            return '' +
                '<md-dialog style="max-width: 800px; width: 100%;">' +
                    '<md-dialog-header>' +
                        '<h3 style="margin: 15px">!Error!</h3>' +
                    '</md-dialog-header>' +
                    '<md-dialog-content>' +
                        '<h5>'+option+'</h5>' +
                    '</md-dialog-content>' +
                    '<md-dialog-actions>' +
                        '<md-button ng-click="vm.closeDialog()" class="md-primary">Close</md-button>' +
                    '</md-dialog-actions>' +
                '</md-dialog>';
        }    

        function openDialog(option) {
            $mdDialog.show({
                template: getDialogTemplate(option),
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                scope: $scope,
                preserveScope: true
            });
            vm.selectedOption = '';
        };

        vm.closeDialog = function() {
            vm.from_date = null;
            vm.to_date = null;
            $mdDialog.hide();
        };

        function processResponse(response) {
            var returnMessages = "";
            if (Array.isArray(response.data.responseData.transaction_details)) {
                for (var i = 0; i < response.data.responseData.transaction_details.length; i++) {
                    var currentMsg = response.data.responseData.transaction_details[i].trxn_remark;
                    returnMessages += currentMsg + "<br>";
                }
            } else if (response.data.responseData.transaction_details && typeof response.data.responseData.transaction_details === 'object') {
                var currentMsg = response.data.responseData.transaction_details.trxn_remark;
                returnMessages += currentMsg + "<br>";
            }
        
            return returnMessages;
        }

        vm.purchaseTransaction = function() {
            
            vm.purchaseJson = {
                'transaction_details': vm.transactions
            };
            ServiceProxy.purchaseTransaction(vm.purchaseJson).then(successpurchaseTransaction, errorpurchaseTransaction);
        };

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent($sce.trustAsHtml(response))
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('AddBankDetailController', AddBankDetailController);

    /** @ngInject */
    function AddBankDetailController($state, $location, $scope, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;

        // Initialize the controller
        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                getNewBankAccType();
                vm.accTypeList = [];
                vm.AddBankDetail = AddBankDetail;
                vm.defaultBank = 'N';
            } else {
                $state.go('app.customers');
            }
        }
        init();

        function successgetNewBankAccType(response) {
            if (response && response.data && response.data.response) {
                vm.accTypeList = response.data.response;
            } else {
                vm.accTypeList = [];
            }
        }

        function errorgetNewBankAccType(response) {
            console.log('reserr', response);
            vm.accTypeList = [];
            showDialog(response.data.message);
        }

        function getNewBankAccType() {
            ServiceProxy.getNewBankAccType('01').then(successgetNewBankAccType, errorgetNewBankAccType);
        };

        function AddBankDetail() {
            var postData = {
                "client_code": vm.customerDetail.iin,
                "action_type": "ADD",
                "account_type": vm.accType,
                "account_no": vm.acc_no,
                "micr_no": "",
                "ifsc_code": vm.ifsc,
                "default_bank_flag": vm.defaultBank
            };

            console.log("Final postData:", postData);
            ServiceProxy.addbankdetail(postData).then(successAddBankDetail, errorAddBankDetail);
        }

        function successAddBankDetail(response) {
            // Handle both HTTP success and API-level success/failure
            if (response && response.data) {
                // Check if the API response indicates success
                if (response.data.validFlag === true || response.data.statuscode === 200) {
                    // Success case
                    var successMessage = response.data.message || 'Bank detail added successfully';
                    showDialogSucc(successMessage);
                } else {
                    // API-level error (validFlag: false or statuscode: 400, etc.)
                    var errorMessage = response.data.message || 'Failed to add bank detail';
                    
                    // If there's detailed error information in Data array
                    if (response.data.Data && response.data.Data.length > 0) {
                        var errorDetail = response.data.Data;
                        if (errorDetail.error_remark) {
                            errorMessage = errorDetail.error_remark;
                        }
                    }
                    
                    showDialog(errorMessage);
                }
            } else {
                showDialog('Unexpected response format');
            }
        }

        function errorAddBankDetail(response) {
            // Handle HTTP-level errors (network issues, 500 errors, etc.)
            var errorMessage = 'An error occurred while processing your request';
            
            if (response && response.data) {
                if (response.data.message) {
                    errorMessage = response.data.message;
                } else if (response.data.error) {
                    errorMessage = response.data.error;
                }
            }
            
            showDialog(errorMessage);
        }

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('Error')
                .textContent(response)
                .ariaLabel('Error')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }

        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Success')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customers')
        .controller('ACHMandateDetailsController', ACHMandateDetailsController);

    /** @ngInject */
    function ACHMandateDetailsController($state, $mdDialog, ShareDataService, StorageService, ServiceProxy) {

        var vm = this;

        function init() {
            if (ShareDataService.getData('customerDetail')) {
                vm.customerDetail = angular.copy(ShareDataService.getData('customerDetail'));
                achMandateDetails(vm.customerDetail.iin);             
            } else {
                $state.go('app.customers');
            }
           
        }
        init();

        function sucessachMandateDetails(response) {
            console.log('1',response);
           vm.MandateDetail = response.data.data;          
        }

        function errorachMandateDetails(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function achMandateDetails(iin) {
            ServiceProxy.achMandateDetails(iin).then(sucessachMandateDetails, errorachMandateDetails)
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
    }
})();
(function () {
  'use strict';

  angular.module('app.countries', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
 
    $stateProvider
      .state('app.countries', {
        url: '/countries',
        views: {
          'content@app': {
            templateUrl: 'app/main/countries/countries.html',
            controller: 'countries as vm'
          }
        }
      })
      .state('app.countries.editcountries', {
        url: '/editcountries',
        views: {
          'content@app': {
            templateUrl: 'app/main/countries/editcountries.html',
            controller: 'editcountries as vm'
          }
        }
      })
      .state('app.countries.addcountries', {
        url: '/addcountries',
        views: {
          'content@app': {
            templateUrl: 'app/main/countries/addcountries.html',
            controller: 'addcountries as vm'
          }
        }
      });


    msNavigationServiceProvider.saveItem('CONFIGURATION.countries', {
      title: 'Countries',
      state: 'app.countries',
      icon: 'icon-tile-four',
      weight: 15
    });
  }
})();
(function () {
    'use strict';
  
    angular.module('app.countries').controller('editcountries', editcountries);
  
    /** @ngInject */
    function editcountries($rootScope, $mdSidenav, $scope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
      var vm = this;
  
      // Copy the country object from ShareDataService
      vm.country = angular.copy(ShareDataService.getData('country'));
  
      // Function to edit a country
      vm.editedCountry = function() {
        var countryName = vm.country.CountryName;
        var countryCode = vm.country.CountryCode;
        var callingCode = vm.country.CallingCode;
        var countryCallingCode = vm.country.CountryCallingCode;
        var isVisible ;
        console.log('edit country checkbox',vm.country.IsVisible);
        if(vm.country.IsVisible === true){
          isVisible = true;
        }else{
          isVisible = false;
        }
        
        // Check if all fields are filled
        if (!countryName || !countryCode || !callingCode || !countryCallingCode ) {
          console.log("Please fill in all fields");
          return;
        }
  
        var editCountry = {
          CountryName: countryName,
          CountryCode: countryCode,
          CallingCode: callingCode,
          CountryCallingCode: countryCallingCode,
          IsVisible: isVisible
        };
  
        console.log('s1', editCountry);
        ServiceProxy.editCountry(editCountry).then(successeditedCountry, erroreditedCountry);
      };
  
      // Success callback for editing country
      function successeditedCountry(response) {
        console.log('Success editing country:', response);
        $state.go('app.countries');
      }
      
      // Error callback for editing country
      function erroreditedCountry(response) {
        console.log('Error editing country:', response);
        $state.go('app.countries');
      }
  
    }
  })();
  
(function () {
  'use strict';

  angular.module('app.countries').controller('countries', countries);

  /** @ngInject */
  function countries($rootScope, $mdSidenav, $scope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
    var vm = this;

    function init(){
      getAllCallingCodes();
    }
    init();

    vm.addCountry = function(){
      
      $state.go('app.countries.addcountries');
    }

    vm.editedCountry = function(country) {
			ShareDataService.storeData('country', country);
			$state.go('app.countries.editcountries');
    }

    function getAllCallingCodes() {
      ServiceProxy.getCallingCodes().then(successgetCallingCodes, errorgetCallingCodes);
    }

    function successgetCallingCodes(response){
      console.log('success Getting Country:', response);
    
      vm.Countries = response.data.map(function(entry) {
        return {
          CountryName: entry.CountryName,
          CountryCode: entry.CountryCode,
          CallingCode: entry.CallingCode,
          CountryCallingCode: entry.CountryCallingCode,
          IsVisible: entry.IsVisible
        };
      });
    
    }

    function errorgetCallingCodes(response){
      console.log('error Getting Country:', response);
    }

    vm.toggleVisibility = function(country) {
      country.IsVisible = !country.IsVisible;
  
      console.log('The value going inside editCountry',country);
      ServiceProxy.editCountry(country).then(successUpdateVisibility, errorUpdateVisibility);
    };
    
    function successUpdateVisibility(response) {
      console.log('Success updating visibility:', response);
    }
    
    function errorUpdateVisibility(response) {
      console.log('Error updating visibility:', response);
    }

  }
})();

(function () {
    'use strict';
  
    angular.module('app.countries').controller('addcountries', addcountries);
  
    /** @ngInject */
    function addcountries($rootScope, $mdSidenav, $scope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
      var vm = this;

      vm.addCountry = function(){
        
        var countryName = vm.newCountryName;
        var countryCode = vm.newCountryCode;
        var callingCode = vm.newCallingCode;
        var countryCallingCode = vm.newCountryCallingCode;
        
        console.log('add country checkbox',vm.newIsVisible);
        var isVisible ;
        if(vm.newIsVisible  === true){
          isVisible = true;
        }else{
          isVisible = false;
        }
  
        if (!countryName || !countryCode || !callingCode || !countryCallingCode ) {
            console.log("Please fill in all fields");
            return;
        }
  
        var newCountry = {
            CountryName: countryName,
            CountryCode: countryCode,
            CallingCode: callingCode,
            CountryCallingCode: countryCallingCode,
            IsVisible: isVisible
        };
        console.log('r1',newCountry)
        ServiceProxy.setCallingCode(newCountry).then(successsetCallingCode, errorsetCallingCode);
      }
  
      function successsetCallingCode(response) {
        console.log('success Adding Country:', response);
        $state.go('app.countries');
      }
  
      function errorsetCallingCode(response) {
        console.log('error Adding Country:', response);
        $state.go('app.countries');
      }
  
    }
  })();
  
(function() {
    'use strict';

    angular
        .module('app.internalUser')
        .controller('InternalUserListController', InternalUserListController);

    /** @ngInject */
    function InternalUserListController($rootScope, $state, $mdDialog, $stateParams, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.selected = [];
            vm.currentNavItem = 'Activated_user';
            vm.internalUserCount = internalUserCount;
            vm.activated = activated;
            vm.editUser = editUser;
            vm.viewUser = viewUser;
            vm.allFeatures = [];
            getAllInternalUser();
            vm.typerename = {
                'SUB::BROKER': 'Sub Broker',
                'INTERNAL::USER': 'Internal User'
            }
        };
        init();

        function editUser(internalUser) {
            $state.go('app.internalUser.editInternalUser', { editId: internalUser.id });
        }

        function viewUser(internalUser) {
            $state.go('app.internalUser.internalUserList.showDetails', { 'userViewId': internalUser.id });
        }

        ///////////////////////////////////get all internal user starts here//////////////////////////////////////
        function sucessCbGetAllInternalUser(response) {
            vm.allInternalUser = angular.copy(response.data.data);
            vm.internalUser = response.data.data;
            getAllFeatures();
            internalUserCount('Activated_user');
        }

        function errorCbGetAllInternalUser(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllInternalUser() {
            ServiceProxy.getAllInternalUser().then(sucessCbGetAllInternalUser, errorCbGetAllInternalUser)
        }
        ///////////////////////////////////get all internal user ends here//////////////////////////////////////

        // === === === === === ===  === Get All Features === === === === === === === === 
        function errorGetAllFeatures(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function successGetallFeatures(response) {
            vm.allFeatures = response.data.data;
            if (vm.allFeatures.length > 0) {
                angular.forEach(vm.internalUser, function(internalUserList) {
                    if (internalUserList.features.length > 0) {
                        internalUserList.featuresData = [];
                        angular.forEach(internalUserList.features, function(featureItem, index) {
                            angular.forEach(vm.allFeatures, function(obj) {
                                if (featureItem === obj.fId) {
                                    internalUserList.featuresData.push(obj.name);
                                }
                            });
                        });
                    }
                });
            }
        }

        function getAllFeatures() {
            ServiceProxy.getAssignFeature().then(successGetallFeatures, errorGetAllFeatures);
        }
        // === === === === === ===  === Get All Features === === === === === === === ===         

        /////////////////////////////starts internal user activated and deactivated show in tabs here////////////////////////
        function internalUserCount(data) {
            if (data == 'Activated_user') {
                var tempArray = [];
                angular.forEach(vm.allInternalUser, function(obj) {
                    if (obj.active == true) {
                        tempArray.push(obj);
                    }
                });
                vm.internalUser = tempArray;
            } else if (data == 'Deactivated_user') {
                var tempArray = [];
                angular.forEach(vm.allInternalUser, function(obj) {
                    if (obj.active == false) {
                        tempArray.push(obj);
                    }
                });
                vm.internalUser = tempArray;
            }
        }
        /////////////////////////////ends internal user activated and deactivated show in tabs  here////////////////////////

        ///////////////////////////Starts internal user activated & deactivated api here/////////////////////////////
        function sucessCbGetAllActivated(response, user) {
            var index = vm.internalUser.findIndex(function(item) {
                return item.id === user.id;
            })
            var mainIndex = vm.allInternalUser.findIndex(function(item) {
                return item.id === user.id;
            })
            vm.allInternalUser[mainIndex].active = response.data.data.active
            vm.internalUser.splice(index, 1);

            if (response && response.data && response.data.data) {
                showDialogSucc(response.data.responseString);
            }
        }

        function errorCbGetAllActivated(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function activated(internalUser) {
            var postData = {
                active: !internalUser.active
            }
            ServiceProxy.activatedInternalUser(internalUser.id, postData).then(function(response) { sucessCbGetAllActivated(response, internalUser) }, errorCbGetAllActivated)
        }
        ///////////////////////////Ends internal user activated & deactivated api here/////////////////////////////

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////

    }
})();
(function() {
	'use strict';

	angular
		.module('app.insurance', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		var fId = 'DASHBOARD::FEATURE';
        
        $stateProvider
        .state('app.insurance', {
            abstract: true,
            url: '/insurance',
            data: {
                access: function () {
                    if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        })
        .state('app.insurance.quotation', {
            url: '/quotation',
            views: {
                'content@app': {
                    templateUrl: 'app/main/insurance/insurance.html',
                    controller: 'insuranceController as vm'
                }
            }
        })


        msNavigationServiceProvider.saveItem('insurance', {
            title: 'INSURANCE',
            weight: 1,
            hidden: function () {
                if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                    return false;
                } else {
                    return true;
                }
            }
        });
        // msNavigationServiceProvider.saveItem('CUSTOMER-ENGAGEMENT.goalchart', {
        //     title: 'Goal Chart',
        //     state: 'app.customer-engagement.goalchart',
        //     icon: 'icon-tile-four',
        //     weight: 1,
        //     hidden: function () {
        //         if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
        //             return false;
        //         } else {
        //             return true;
        //         }

        //     }
        // });
	}
})();

(function () {

	'use strict';


	angular.module('app.insurance').controller('insuranceController', insuranceController);
	

	/** @ngInject */
	function insuranceController($state,$window, $stateParams, $q, StorageService, $scope, $filter, $timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;
        function init() {
            vm.goalChart = {};
            vm.goalChart.items=[{}];
            vm.goalChart.items.splice(0, 1);
            // category autocomplete vars
			self.categories = StorageService.getSessionStorage("categoryData");
			self.selectedItem = null;
			self.searchText = null;
			// category autocomplete vars ends
            vm.getMatches = getMatches;
            vm.add = add;
            vm.remove = remove;
            vm.disableSubmit = disableSubmit;
            vm.saveGoalChart = saveGoalChart;
            vm.updateGoalChart = updateGoalChart;
            if (ShareDataService.getData('goalchart')) {
               var goalChartList  = ShareDataService.getData('goalchart');
                showGaolChartData(goalChartList);
            } else {
                $stateParams.goalChartId = '';
            }
        }
        init();
        
        function disableSubmit() {
			return !(vm.goal && vm.selectedItem);
		}
        // match Categories/funds
		function getMatches(searchText) {
			var result = self.categories;
			var deferred;

			if (searchText) {
				deferred = $q.defer();

				$timeout(function () {
					var states = self.categories.filter(function (state) {
						return (state ? state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 : null);
					});
					deferred.resolve(states);
				}, 1500);

				return deferred.promise;
			} else {
				return result;
			}

        }
        
        function showGaolChartData(goalChartList){
            var goalChart =  [];
            vm.goal = goalChartList.Goal;
            vm.goalId = goalChartList._id;
            for( var i = 0 ; i < goalChartList.Categories.length ; i++)
            {
                var goalChart1 =  {};
                goalChart1.id = goalChartList.Categories[i]._id;
                goalChart1.goal = goalChartList.Goal;
                goalChart1.category = goalChartList.Categories[i].category;
                goalChart1.indicative = goalChartList.Categories[i].indicative;
                goalChart1.y1 = goalChartList.Categories[i].Y1;
                goalChart1.y2 = goalChartList.Categories[i].Y2;
                goalChart1.y3 = goalChartList.Categories[i].Y3;
                goalChart1.y4 = goalChartList.Categories[i].Y4;
                goalChart1.y5 = goalChartList.Categories[i].Y5;
                goalChart1.y6 = goalChartList.Categories[i].Y6;
                goalChart1.y7 = goalChartList.Categories[i].Y7;
                goalChart1.y8 = goalChartList.Categories[i].Y8;
                goalChart1.y9 = goalChartList.Categories[i].Y9;
                goalChart1.y10 = goalChartList.Categories[i].Y10;
                goalChart1.y11 = goalChartList.Categories[i].Y11;
                goalChart1.y12 = goalChartList.Categories[i].Y12;
                goalChart1.y13 = goalChartList.Categories[i].Y13;
                goalChart1.y14 = goalChartList.Categories[i].Y14;
                goalChart1.y15 = goalChartList.Categories[i].Y15;
                goalChart1.y16 = goalChartList.Categories[i].Y16;
                goalChart1.y17 = goalChartList.Categories[i].Y17;
                goalChart1.y18 = goalChartList.Categories[i].Y18;
                goalChart1.y19 = goalChartList.Categories[i].Y19;
                goalChart1.y20 = goalChartList.Categories[i].Y20;
                goalChart1.y21 = goalChartList.Categories[i].Y21;
                goalChart1.y22 = goalChartList.Categories[i].Y22;
                goalChart1.y23 = goalChartList.Categories[i].Y23;
                goalChart1.y24 = goalChartList.Categories[i].Y24;
                goalChart1.y25 = goalChartList.Categories[i].Y25;
                goalChart1.y26 = goalChartList.Categories[i].Y26;
                goalChart1.y27 = goalChartList.Categories[i].Y27;
                goalChart1.y28 = goalChartList.Categories[i].Y28;
                goalChart1.y29 = goalChartList.Categories[i].Y29;
                goalChart1.y30 = goalChartList.Categories[i].Y30;
                goalChart1.y31 = goalChartList.Categories[i].Y31;
                goalChart1.y32 = goalChartList.Categories[i].Y32;
                goalChart1.y33 = goalChartList.Categories[i].Y33;
                goalChart1.y34 = goalChartList.Categories[i].Y34;
                goalChart1.y35 = goalChartList.Categories[i].Y35;
                goalChart1.y36 = goalChartList.Categories[i].Y36;
                goalChart1.y37 = goalChartList.Categories[i].Y37;
                goalChart1.y38 = goalChartList.Categories[i].Y38;
                goalChart1.y39 = goalChartList.Categories[i].Y39;
                goalChart1.y40 = goalChartList.Categories[i].Y40;
                goalChart1.y41 = goalChartList.Categories[i].Y41;
                goalChart1.y42 = goalChartList.Categories[i].Y42;
                goalChart1.y43 = goalChartList.Categories[i].Y43;
                goalChart1.y44 = goalChartList.Categories[i].Y44;
                goalChart1.y45 = goalChartList.Categories[i].Y45;
                goalChart1.y46 = goalChartList.Categories[i].Y46;
                goalChart1.y47 = goalChartList.Categories[i].Y47;
                goalChart1.y48 = goalChartList.Categories[i].Y48;
                goalChart1.y49 = goalChartList.Categories[i].Y49;
                goalChart1.y50 = goalChartList.Categories[i].Y50;
                vm.goalChart.items.push(goalChart1);
            }
        }
        function add() {
			//Add the new item to the Array.
			var goalChart = {};
			goalChart.goal = vm.goal;
			goalChart.category = vm.selectedItem;
            goalChart.indicative = vm.indicative;
            goalChart.y1 = vm.y1;
            goalChart.y2 = vm.y2;
            goalChart.y3 = vm.y3;
            goalChart.y4 = vm.y4;
            goalChart.y5 = vm.y5;
            goalChart.y6 = vm.y6;
            goalChart.y7 = vm.y7;
            goalChart.y8 = vm.y8;
            goalChart.y9 = vm.y9;
            goalChart.y10 = vm.y10;
            goalChart.y11 = vm.y11;
            goalChart.y12 = vm.y12;
            goalChart.y13 = vm.y13;
            goalChart.y14 = vm.y14;
            goalChart.y15 = vm.y15;
            goalChart.y16 = vm.y16;
            goalChart.y17 = vm.y17;
            goalChart.y18 = vm.y18;
            goalChart.y19 = vm.y19;
            goalChart.y20 = vm.y20;
            goalChart.y21 = vm.y21;
            goalChart.y22 = vm.y22;
            goalChart.y23 = vm.y23;
            goalChart.y24 = vm.y24;
            goalChart.y25 = vm.y25;
            goalChart.y26 = vm.y26;
            goalChart.y27 = vm.y27;
            goalChart.y28 = vm.y28;
            goalChart.y29 = vm.y29;
            goalChart.y30 = vm.y30;
            goalChart.y31 = vm.y31;
            goalChart.y32 = vm.y32;
            goalChart.y33 = vm.y33;
            goalChart.y34 = vm.y34;
            goalChart.y35 = vm.y35;
            goalChart.y36 = vm.y36;
            goalChart.y37 = vm.y37;
            goalChart.y38 = vm.y38;
            goalChart.y39 = vm.y39;
            goalChart.y40 = vm.y40;
            goalChart.y41 = vm.y41;
            goalChart.y42 = vm.y42;
            goalChart.y43 = vm.y43;
            goalChart.y44 = vm.y44;
            goalChart.y45 = vm.y45;
            goalChart.y46 = vm.y46;
            goalChart.y47 = vm.y47;
            goalChart.y48 = vm.y48;
            goalChart.y49 = vm.y49;
            goalChart.y50 = vm.y50;
			vm.goalChart.items.push(goalChart);
			clear();
			//Clear the TextBoxes.
			
        }; 
        
        function clear()
        {
            vm.investorName = "";
            vm.contact = "";
            vm.selectedItem = "";
            vm.indicative = "";
            vm.y1 = "";
            vm.y2 = "";
            vm.y3 = "";
            vm.y4 = "";
            vm.y5 = "";
            vm.y6 = "";
            vm.y7 = "";
            vm.y8 = "";
            vm.y5 = "";
            vm.y6 = "";
            vm.y7 = "";
            vm.y8 = "";
            vm.y9 = "";
            vm.y10 = "";
            vm.y11 = "";
            vm.y12 = "";
            vm.y13 = "";
            vm.y14 = "";
            vm.y15 = "";
            vm.y16 = "";
            vm.y17 = "";
            vm.y18 = "";
            vm.y19 = "";
            vm.y20 = "";
            vm.y21 = "";
            vm.y22 = "";
            vm.y23 = "";
            vm.y24 = "";
            vm.y25 = "";
            vm.y26 = "";
            vm.y27 = "";
            vm.y28 = "";
            vm.y29 = "";
            vm.y30 = "";
            vm.y31 = "";
            vm.y32 = "";
            vm.y33 = "";
            vm.y34 = "";
            vm.y35 = "";
            vm.y36 = "";
            vm.y37 = "";
            vm.y38 = "";
            vm.y39 = "";
            vm.y40 = "";
            vm.y41 = "";
            vm.y42 = "";
            vm.y43 = "";
            vm.y44 = "";
            vm.y45 = "";
            vm.y46 = "";
            vm.y47 = "";
            vm.y48 = "";
            vm.y49 = "";
            vm.y50 = "";
        }

        function sucessCbCRemoveustomerEngagementGoalChart(response) {
            showDialogSucc(response.data.responseString);
			vm.goalChart.items=[{}];
            vm.goalChart.items.splice(0, 1);
            $state.go('app.goalchart');
        }

        function errorCbRemoveCustomerEngagementGoalChart(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }


        function remove(category , index) {
            //Find the record using Index from Array.
            var goalName =  vm.goalChart.items[index].goal;
            var categoryName =  vm.goalChart.items[index].category;
			if ($window.confirm("Do you want to remove " + categoryName + " category" )) {
                var categoryId = category.id;
                if(categoryId !=null || categoryId != undefined)
                {
                    var postData = {
                        "Goal": goalName,
                        "CategoryId": categoryId
                    }
                    ServiceProxy.DeleteGoalChartCategory(postData).then(sucessCbCRemoveustomerEngagementGoalChart, errorCbRemoveCustomerEngagementGoalChart);
                }
                else
                {
                    //Remove the item from Array using Index.
                    vm.goalChart.items.splice(index, 1);
                }
				
			}
        }
        
        function sucessCbCustomerEngagementGoalChart(response) {
			showDialogSucc(response.data.responseString);
			vm.goalChart.items=[{}];
            vm.goalChart.items.splice(0, 1);
            $state.go('app.goalchart');
        }

        function errorCbCustomerEngagementGoalChart(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }
        
        function saveGoalChart()
		{
            var postData = {
                "Goal": vm.goal,
                "Categories": []
            }
            angular.forEach(vm.goalChart.items, function(item) {
                if(item.goal !="" && item.category !="")
                {
                    var tempObj = {
                        "category": item.category,
                        "indicative": item.indicative,
                        "Y1": item.y1 !=undefined? item.y1 : 0 ,
                        "Y2": item.y2 !=undefined? item.y2 : 0 ,
                        "Y3": item.y3 !=undefined? item.y3 : 0 ,
                        "Y4": item.y4 !=undefined? item.y4 : 0 ,
                        "Y5": item.y5 !=undefined? item.y5 : 0 ,
                        "Y6": item.y6 !=undefined? item.y6 : 0 ,
                        "Y7": item.y7 !=undefined? item.y7 : 0 ,
                        "Y8": item.y8 !=undefined? item.y8 : 0 ,
                        "Y9": item.y9 !=undefined? item.y9 : 0 ,
                        "Y10": item.y10 !=undefined? item.y10 : 0 ,
                        "Y11": item.y11 !=undefined? item.y11 : 0 ,
                        "Y12": item.y12 !=undefined? item.y12 : 0 ,
                        "Y13": item.y13 !=undefined? item.y13 : 0 ,
                        "Y14": item.y14 !=undefined? item.y14 : 0 ,
                        "Y15": item.y15 !=undefined? item.y15 : 0 ,
                        "Y16": item.y16 !=undefined? item.y16 : 0 ,
                        "Y17": item.y17 !=undefined? item.y17 : 0 ,
                        "Y18": item.y18 !=undefined? item.y18 : 0 ,
                        "Y19": item.y19 !=undefined? item.y19 : 0 ,
                        "Y20": item.y20 !=undefined? item.y20 : 0 ,
                        "Y21": item.y21 !=undefined? item.y21 : 0 ,
                        "Y22": item.y22 !=undefined? item.y22 : 0 ,
                        "Y23": item.y23 !=undefined? item.y23 : 0 ,
                        "Y24": item.y24 !=undefined? item.y24 : 0 ,
                        "Y25": item.y25 !=undefined? item.y25 : 0 ,
                        "Y26": item.y26 !=undefined? item.y26 : 0 ,
                        "Y27": item.y27 !=undefined? item.y27 : 0 ,
                        "Y28": item.y28 !=undefined? item.y28 : 0 ,
                        "Y29": item.y29 !=undefined? item.y29 : 0 ,
                        "Y30": item.y30 !=undefined? item.y30 : 0 ,
                        "Y31": item.y31 !=undefined? item.y31 : 0 ,
                        "Y32": item.y32 !=undefined? item.y32 : 0 ,
                        "Y33": item.y33 !=undefined? item.y33 : 0 ,
                        "Y34": item.y34 !=undefined? item.y34 : 0 ,
                        "Y35": item.y35 !=undefined? item.y35 : 0 ,
                        "Y36": item.y36 !=undefined? item.y36 : 0 ,
                        "Y37": item.y37 !=undefined? item.y37 : 0 ,
                        "Y38": item.y38 !=undefined? item.y38 : 0 ,
                        "Y39": item.y39 !=undefined? item.y39 : 0 ,
                        "Y40": item.y40 !=undefined? item.y40 : 0 ,
                        "Y41": item.y41 !=undefined? item.y41 : 0 ,
                        "Y42": item.y42 !=undefined? item.y42 : 0 ,
                        "Y43": item.y43 !=undefined? item.y43 : 0 ,
                        "Y44": item.y44 !=undefined? item.y44 : 0 ,
                        "Y45": item.y45 !=undefined? item.y45 : 0 ,
                        "Y46": item.y46 !=undefined? item.y46 : 0 ,
                        "Y47": item.y47 !=undefined? item.y47 : 0 ,
                        "Y48": item.y48 !=undefined? item.y48 : 0 ,
                        "Y49": item.y49 !=undefined? item.y49 : 0 ,
                        "Y50": item.y50 !=undefined? item.y50 : 0 ,
                    }
                }
                postData.Categories.push(tempObj);
            })
			ServiceProxy.CreatecustomerEngagementGoalChart(postData).then(sucessCbCustomerEngagementGoalChart, errorCbCustomerEngagementGoalChart);
        }


        function sucessCbUpdateCustomerEngagementGoalChart(response) {
            showDialogSucc(response.data.responseString);
            clear();
            $state.go('app.goalchart');
        }

        function errorCbUpdateCustomerEngagementGoalChart(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }

        function updateGoalChart()
        {
            var postData = {
                "Goal": vm.goal,
                "Categories": []
            }
            angular.forEach(vm.goalChart.items, function(item) {
                if(item.goal !="" && item.category !="")
                {
                    var tempObj = {
                        "category": item.category,
                        "indicative": item.indicative,
                        "Y1": item.y1 !=undefined? item.y1 : 0 ,
                        "Y2": item.y2 !=undefined? item.y2 : 0 ,
                        "Y3": item.y3 !=undefined? item.y3 : 0 ,
                        "Y4": item.y4 !=undefined? item.y4 : 0 ,
                        "Y5": item.y5 !=undefined? item.y5 : 0 ,
                        "Y6": item.y6 !=undefined? item.y6 : 0 ,
                        "Y7": item.y7 !=undefined? item.y7 : 0 ,
                        "Y8": item.y8 !=undefined? item.y8 : 0 ,
                        "Y9": item.y9 !=undefined? item.y9 : 0 ,
                        "Y10": item.y10 !=undefined? item.y10 : 0 ,
                        "Y11": item.y11 !=undefined? item.y11 : 0 ,
                        "Y12": item.y12 !=undefined? item.y12 : 0 ,
                        "Y13": item.y13 !=undefined? item.y13 : 0 ,
                        "Y14": item.y14 !=undefined? item.y14 : 0 ,
                        "Y15": item.y15 !=undefined? item.y15 : 0 ,
                        "Y16": item.y16 !=undefined? item.y16 : 0 ,
                        "Y17": item.y17 !=undefined? item.y17 : 0 ,
                        "Y18": item.y18 !=undefined? item.y18 : 0 ,
                        "Y19": item.y19 !=undefined? item.y19 : 0 ,
                        "Y20": item.y20 !=undefined? item.y20 : 0 ,
                        "Y21": item.y21 !=undefined? item.y21 : 0 ,
                        "Y22": item.y22 !=undefined? item.y22 : 0 ,
                        "Y23": item.y23 !=undefined? item.y23 : 0 ,
                        "Y24": item.y24 !=undefined? item.y24 : 0 ,
                        "Y25": item.y25 !=undefined? item.y25 : 0 ,
                        "Y26": item.y26 !=undefined? item.y26 : 0 ,
                        "Y27": item.y27 !=undefined? item.y27 : 0 ,
                        "Y28": item.y28 !=undefined? item.y28 : 0 ,
                        "Y29": item.y29 !=undefined? item.y29 : 0 ,
                        "Y30": item.y30 !=undefined? item.y30 : 0 ,
                        "Y31": item.y31 !=undefined? item.y31 : 0 ,
                        "Y32": item.y32 !=undefined? item.y32 : 0 ,
                        "Y33": item.y33 !=undefined? item.y33 : 0 ,
                        "Y34": item.y34 !=undefined? item.y34 : 0 ,
                        "Y35": item.y35 !=undefined? item.y35 : 0 ,
                        "Y36": item.y36 !=undefined? item.y36 : 0 ,
                        "Y37": item.y37 !=undefined? item.y37 : 0 ,
                        "Y38": item.y38 !=undefined? item.y38 : 0 ,
                        "Y39": item.y39 !=undefined? item.y39 : 0 ,
                        "Y40": item.y40 !=undefined? item.y40 : 0 ,
                        "Y41": item.y41 !=undefined? item.y41 : 0 ,
                        "Y42": item.y42 !=undefined? item.y42 : 0 ,
                        "Y43": item.y43 !=undefined? item.y43 : 0 ,
                        "Y44": item.y44 !=undefined? item.y44 : 0 ,
                        "Y45": item.y45 !=undefined? item.y45 : 0 ,
                        "Y46": item.y46 !=undefined? item.y46 : 0 ,
                        "Y47": item.y47 !=undefined? item.y47 : 0 ,
                        "Y48": item.y48 !=undefined? item.y48 : 0 ,
                        "Y49": item.y49 !=undefined? item.y49 : 0 ,
                        "Y50": item.y50 !=undefined? item.y50 : 0 ,
                    }
                }
                postData.Categories.push(tempObj);
            })
			ServiceProxy.UpdateCustomerEngagementGoalChart(postData).then(sucessCbUpdateCustomerEngagementGoalChart, errorCbUpdateCustomerEngagementGoalChart);
        }

        function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
        }
        function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}
    }
})();

(function() {
	'use strict';

	angular
		.module('app.ifscCode', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.ifscCode', {
				url: '/ifsc',
				views: {
					'content@app': {
						templateUrl: 'app/main/ifsc/ifsc.html',
						controller: 'IfscController as vm'
					}
				}
			})
			.state('app.ifscCodeList', {
				url: '/ifsc/list',
				views: {
					'content@app': {
						templateUrl: 'app/main/ifsc/ifsc-list.html',
						controller: 'IfscListController as vm'
					}
				}
			});

		msNavigationServiceProvider.saveItem('SETTING.IFSC', {
			title: 'IFSC Code',
			icon: 'icon-tile-four',
			state: 'app.ifscCode',
			weight: 3
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('app.ifscCode')
        .controller('IfscListController', IfscListController);

    /** @ngInject */
    function IfscListController($window, $state,$scope, $mdToast, $mdDialog, ServiceProxy) {
        var vm = this;

        function init() {
            vm.goBack = goBack;
        };

        init();

        getIFSClist();
		
		function getIFSClist(){
			ServiceProxy.getIFSClist().then(sucessIFSClist, errorIFSClist);
        }
       

		function sucessIFSClist(response) {
			vm.ifscList = response.data.responseString
			
        }
        
        function goBack() {
            $window.history.back();
            // $state.go('app.ifscCode');
		}

		function errorIFSClist(res) {
			var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
			
		}

        function showToast(msg) {
			var toast = $mdToast
				.simple()
				.textContent(msg)
				.highlightAction(true)
				.highlightClass('md-accent')
				.position('top right');

			$mdToast.show(toast).then(function (response) {
				if (response == 'ok') {
					alert("You clicked the 'UNDO' action.");
				}
			});
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('app.ifscCode')
        .controller('IfscController', IfscController);

    /** @ngInject */
    function IfscController($window, $state,$scope, $mdToast, $mdDialog, ServiceProxy) {
        var vm = this;

        function init() {
            vm.uploadifsc = uploadifsc
			vm.camsFile = 'No File Selected';
			// vm.scrollToTable = scrollToTable;
			vm.getIFSClist = getIFSClist;
        };
        init();

        function sucessCbUploadCamsTransaction(response) {
			$('#camsFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#camsFile').unwrap();
			vm.camsFile = 'No File Selected';
			var responseData = JSON.parse(response);
			showToast(response.data.responseString);
			dialogOpenAddEmployee(responseData);
		}

		function errorCbUploadCamsTransaction(error) {
			$('#camsFile')
				.wrap('<form>')
				.closest('form')
				.get(0)
				.reset();
			$('#camsFile').unwrap();
			vm.camsFile = 'No File Selected';
			if (typeof error.data.responseString === 'string') {
				dialogOpenAddEmployee(error.data.responseString);
			} else {
				var errString = [];
				angular.forEach(error.data.responseString, function (err) {
					errString.push(err.errorMessage);
				});
				dialogOpenAddEmployee(errString);
			}
		}

        function uploadifsc() {
			var data = new FormData();
			data.append('file', $('#camsFile').prop('files')[0]);
			// ServiceProxy.uploadCamsTrxn(data).then(sucessCbUploadCamsTransaction, errorCbUploadCamsTransaction);
        }
        
        function dialogOpenAddEmployee(response) {
			var message = '';
			if (response.err_desc) {
				message = response.err_desc;
			} else if (response.responseString) {
				message = response.responseString;
			} else {
				message = response;
			}
			var confirm = $mdDialog
				.confirm()
				.title('Upload Details')
				.htmlContent('<b>' + message + '</b>')
				.ariaLabel('delete contact')
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}

		$scope.checkfile = checkfile;

		function checkfile(sender, type) {
			if (type === 'camsFile') {
				var docValue = document.getElementById('camsFile');
				vm.camsFile = docValue.files[0].name;
			} else if (type === 'karvyFile') {
				var docValue = document.getElementById('karvyfile');
				vm.karvyFile = docValue.files[0].name;
			} else if (type === 'franklinFile') {
				var docValue = document.getElementById('franklinFile');
				vm.franklinFile = docValue.files[0].name;
			} else if (type === 'sundaramFile') {
				var docValue = document.getElementById('sundaramFile');
				vm.sundaramFile = docValue.files[0].name;
			}
			$scope.$apply();
			var validExts = new Array('.csv');
			var fileExt = sender.value;
			fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
			if (validExts.indexOf(fileExt) < 0) {
				dialogOpenAddEmployee('Invalid file selected, valid files are of ' + validExts.toString() + ' types.');
				$(sender).val('');
				vm.camsFile = 'No File Selected';
				return false;
			} else {
				return true;
			}
		}

		// function scrollToTable(){
		// 	document.getElementById('panel').scrollIntoView({ behavior: 'smooth'})
		// }

		function getIFSClist(){
			// ServiceProxy.getIFSClist().then(sucessIFSClist, errorIFSClist);
			$state.go('app.ifscCodeList');

		}

		// function sucessIFSClist(response) {
		// 	vm.ifscList = response.data.responseString
		// 	$state.go('app.ifscCodeList');
		// }

		function errorIFSClist(res) {
			var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
			
		}

        function showToast(msg) {
			var toast = $mdToast
				.simple()
				.textContent(msg)
				.highlightAction(true)
				.highlightClass('md-accent')
				.position('top right');

			$mdToast.show(toast).then(function (response) {
				if (response == 'ok') {
					alert("You clicked the 'UNDO' action.");
				}
			});
		}
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($rootScope, $state, $mdDialog, ServiceProxy, ShareDataService, StorageService) {
        var vm = this;
        function init() {
            vm.dashBoard = dashBoard;
                var url = $state.current.url.split('/')[1];
                if (url == 'reports'){
                    vm.currentNavItem = 'Reports'
                }else if (url == 'comparison'){
                    vm.currentNavItem = 'Comparison';
                }else if (url == 'employee'){
                    vm.currentNavItem = 'Employees_performance';
                }else{
                    vm.currentNavItem = 'Details';
                }
        };
        init();

        function dashBoard(state) {
            $state.go(state)
        }

         

    }
})();
(function() {
    'use strict';

    angular
        .module('app.communication')
        .controller('CommunicationMessageController', CommunicationMessageController);

    /** @ngInject */
    function CommunicationMessageController($scope, $rootScope, $state, $location, ServiceProxy, ShareDataService, $mdDialog) {
        var vm = this;
        $scope.imageFile = {
            flowObj: {}
        };

        function init() {
            vm.attachment = false;
            vm.selected = [];
            vm.selectedFlag = null;

            if (ShareDataService.getData('selectedCustomer')) {
                vm.selectedCustomer = ShareDataService.getData('selectedCustomer');
                if (vm.selectedCustomer.length > 0) {
                    vm.selectedFlag = 7;
                }
            }
            
            if (ShareDataService.getData('selectedProspect')) {
                vm.selectedCustomer = ShareDataService.getData('selectedProspect');
                if (vm.selectedCustomer.length > 0) {
                    vm.selectedFlag = 8;
                }
            }

            vm.customerCount = customerCount;

        };
        init();

        /////////////////////////////////////////////sms api starts here////////////////////////////////////////////
        function sucessCbCreateSMS(response) {
            showDialogSucc(response.data.responseString);
            vm.subject = null;
            vm.message = null;
        }

        function errorCbCreateSMS(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        vm.createEmail = function(msgType) {
                var postData = {
                    "subject": vm.subject,
                    "body": vm.message
                }
                if (vm.attachment) {
                    uploadAttachment();
                } else {
                    if (msgType === 'SMS') {
                        postData.mobileNumbers = [];
                        if (vm.selectedFlag === 7 || vm.selectedFlag === 8) {
                            angular.forEach(vm.selectedCustomer, function(custmr) {
                                postData.mobileNumbers.push(custmr.mobileNo);
                            })
                        }
                    } else if (msgType === 'EMAIL') {
                        postData.emailIds = [];
                        if (vm.selectedFlag === 7 || vm.selectedFlag === 8) {
                            angular.forEach(vm.selectedCustomer, function(custmr) {
                                postData.emailIds.push(custmr.email);
                            })
                        }
                    } else if (msgType === 'BOTH') {
                        postData.mobileNumbers = [];
                        postData.emailIds = [];
                        if (vm.selectedFlag === 7 || vm.selectedFlag === 8) {
                            angular.forEach(vm.selectedCustomer, function(custmr) {
                                postData.mobileNumbers.push(custmr.mobileNo);
                                postData.emailIds.push(custmr.email);
                            })
                        }
                    }

                    ServiceProxy.createCommunicationSMS(postData, msgType, vm.attachment ? 'YES' : 'NO', vm.selectedFlag).then(sucessCbCreateSMS, errorCbCreateSMS);
                }
            }
            /////////////////////////////////////////////sms api end here////////////////////////////////////////////

        ///////////////////////////////customer filter count starts here//////////////////////////////////////////
        function customerCount(filter) {
            if (vm.selectedFlag === null) {
                vm.selectedFlag = filter;
            } else {
                vm.selectedFlag = null;
            }
        }
        ///////////////////////////////customer filter count ends here//////////////////////////////////////////


        ////////////////////////////////////disabled starts here/////////////////////////////////////////////////
        vm.disabledEmail = function() {
            return !(vm.subject && vm.message);
        };

        vm.disabledSMS = function() {
            var fId = 'MESSAGE::SMS';
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
            return !((vm.subject && vm.message) && !vm.attachment);
            }
            else
            return true;
        };

        vm.disabledBoth = function() {
            var fId = 'MESSAGE::SMS';
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
            return !((vm.subject && vm.message) && !vm.attachment);
            }
            else
            return true;
        };

        ////////////////////////////////////disabled end here/////////////////////////////////////////////////


        vm.deleteUser = function(index) {
            vm.selectedCustomer.splice(index, 1);
            if (vm.selectedCustomer.length === 0) {
                vm.selectedFlag = null;
            }
        }

        // attachment
        $scope.processFile = function(files) {
            var fileReader = new FileReader();
            var image = new Image();
            var fileSize = 0;

            angular.forEach(files, function(eachFile) {
                fileSize += eachFile.file.size;
            });

            if (fileSize > 10485760) {
                showDialog("file size should not be greater than 10 MB");
                $scope.$apply(function() {
                    $scope.imageFile.flowObj.cancel();
                    imageFile.flowObj.files = [];
                });
                vm.attachment = false;
                $scope.imageFile = {
                    flowObj: {}
                };
            } else {
                vm.attachment = true;
            }
            fileReader.readAsDataURL(files[0].file);
        };


        // function To upload file
        function sucessUploadAttachment(response) {
            var postData = {
                "subject": vm.subject,
                "body": vm.message
            }
            postData.emailIds = [];
            angular.forEach(vm.selectedCustomer, function(custmr) {
                postData.emailIds.push(custmr.email);
            })
            postData.attachments = [];
            postData.attachments = response.data.documents;
            ServiceProxy.createCommunicationEmail(postData, 'EMAIL', vm.attachment ? 'YES' : 'NO', vm.selectedFlag).then(sucessCbCreateSMS, errorCbCreateSMS);
        }

        function errorUploadAttachment(response) {
            if (response.data == null) {
                showDialog('File size is too large!');
            } else {
                showDialog(response.data.responseString);
            }
        }

        //  method for attachment uplaoding
        function uploadAttachment() {
            var data = new FormData();
            angular.forEach($scope.imageFile.flowObj.files, function(doc) {
                data.append("attachments", doc.file);
            });
            ServiceProxy.uploadDocumentAttachment(data).then(sucessUploadAttachment, errorUploadAttachment);
        }

        vm.removeAttachment = function(index) {
            $scope.imageFile.flowObj.files.splice(index, 1);
            if ($scope.imageFile.flowObj.files.length == 0) {
                vm.attachment = false;
            }
        }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
    }
})();
(function () {
  'use strict';

  angular
    .module('app.customersales', [
      'ui.calendar'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    var fId = 'SALES::USERS::DASHBOARD';
    // State
    $stateProvider
      .state('app.customersales', {
        url: '/customersales',
        views: {
          'content@app': {
            templateUrl: 'app/main/customers-sales/customers-sales.html',
            controller: 'CustomersSalesController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      });


    msNavigationServiceProvider.saveItem('DASHBOARD.customersSales', {
      title: 'Sales Dashboard',
      state: 'app.customersales',
      icon: 'icon-tile-four',
      weight: 3,
      hidden: function () {
        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
          return false;
        } else {
          return true;
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.customersales')
    .controller('CustomersSalesController', CustomersSalesController);

  /** @ngInject */
  function CustomersSalesController($rootScope, $mdSidenav, $scope, $state, $mdDialog, $stateParams, $filter, ServiceProxy, ShareDataService) {
    var vm = this;

    function init() {
      ///calendar start here
      var date = new Date();
      var d = date.getDate();
      var m = date.getMonth();
      var y = date.getFullYear();
      vm.events = [
        []
      ];
      vm.calendarUiConfig = {
        calendar: {
          height: '400px',
          editable: true,
          eventLimit: true,
          header: '',
          handleWindowResize: false,
          aspectRatio: 1,
          dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          viewRender: function (view) {
            vm.calendarView = view;
            vm.calendar = vm.calendarView.calendar;
            vm.currentMonthShort = vm.calendar.getDate().format('MMM');
          },
          columnFormat: {
            month: 'ddd',
            week: 'ddd D',
            day: 'ddd M'
          },
          eventClick: filetrDataByCallingDate,
          selectable: true,
          selectHelper: true,
          select: select
        }
      };
      vm.addEvent = addEvent;
      vm.next = next;
      vm.prev = prev;



      vm.selectedFilter = selectedFilter;
      vm.toggleSidenav = toggleSidenav('closeEventsDisabled');
      vm.changeHour = changeHour;
      vm.changeDetect = changeDetect;
      vm.changeNextHour = changeNextHour;
      vm.changeNextDetect = changeNextDetect;
      vm.openSidenav = openSidenav;
      vm.openDialogNotInterested = openDialogNotInterested;
      vm.toggleCalender = toggleSidenav('right');
      vm.createCall = createCall;
      vm.filterData = filterData;
      vm.callingDetail = {};
      vm.callingDetail.atHour = 0;
      vm.callingDetail.atMinute = 0;
      vm.callingDetail.nextAtHour = 0;
      vm.callingDetail.nextAtMinute = 0;
      vm.eKyc = {
        "01": "UNDER_PROCESS",
        "02": "KYC REGISTERED",
        "03": "ON HOLD",
        "04": "KYC REJECTED",
        "05": "NOT AVAILABLE",
        "06": "Deactivate",
        "07": "KYC VALIDATED",
        "11": "UNDER_PROCESS(OLD record)",
        "12": "KYC REGISTERED(OLD record)",
        "13": "ON HOLD(OLD record)",
        "22": "CVL MF KYC"
      };
      vm.commentStrings = ['Not Picking Call', 'Not Reachable', 'Wrong Number', 'Re Schedule', 'Other']
      // vm.loadMore = loadMore;
      vm.items = ["1. Scroll the list to load more"];
      vm.loading = true;
      vm.setNotInterested = setNotInterested;
      vm.filterType = 'All';
      vm.currentNavItem = 'ALL';
      vm.clearCalendarFilter = clearCalendarFilter;
      // getCustomerListForSales();
      // getUserCountForSales();
      // getCalenderData();
      resetData();
      // toggleSidenav('right')
      vm.openHistorySidenav = openHistorySidenav;
      getAllInternalUser();
      vm.assignInternalUser = assignInternalUser;
    };
    init();

    //////////////////////////////   Start of Internal User Assignment  //////////////////////////////
    function getAllInternalUser() {
      ServiceProxy.getAllInternalUser().then(sucessCbGetAllInternalUser, errorCbGetAllInternalUser)
    }

    function sucessCbGetAllInternalUser(response) {
      vm.overAllUser = response.data.data;
      vm.allInternalUsers = response.data.data;
      vm.placeholder = 'Assign Customer Support';
      vm.allInternalUsers = vm.overAllUser.filter(function (item) {
        return (item.type === 'SALES::USER' ||item.type === 'FINANCE::USER' );
      })
    }

    function errorCbGetAllInternalUser(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function assignInternalUser(user) {
      var data = {
        assignedUserId: user.assignedUser._id,
        investorsIds: [user._id]
      }
      ServiceProxy.assignToInternalUser(data).then(function (response) {
        sucessCbAssignToInternalUser(user, response)
      }, errorCbAssignToInternalUser)
    }

    function sucessCbAssignToInternalUser(user, response) {
      resetData();
    }

    function errorCbAssignToInternalUser(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    //////////////////////////////   End Of Assignment     //////////////////////////////

    function openHistorySidenav(component, user) {
      $mdSidenav(component).toggle()
      vm.callHistory = user;
      // return function () {
      //   $mdSidenav(component).toggle()
      // };
    }
    /**
     * Go to next on current view (week, month etc.)
     */
    function next() {
      vm.calendarView.calendar.next();
    }

    /**
     * Go to previous on current view (week, month etc.)
     */
    function prev() {
      var currentMonth = new Date().getMonth();
      var prevMonth = new Date($('[ui-calendar]').fullCalendar('getDate')._d).getMonth() - 1;

      if (currentMonth <= prevMonth) {
        vm.calendarView.calendar.prev();
      }
    }

    function addEvent(e) {
      var start = new Date(),
        end = new Date();

      // showEventFormDialog('add', false, start, end, e);
    }

    // function eventDetail(calendarEvent, e) {
    //   // showEventDetailDialog(calendarEvent, e);
    // }

    function select(start, end, e) {
      // showEventFormDialog('add', false, start, end, e);
    }

    function openSidenav(user, type) {
      vm.activeUser = user;
      if (type === 'last') {
        vm.callingDetail = user.callSchedules[0];
        vm.callingDetail.scheduleId = user.callSchedules[0]._id;
        vm.callingDetail.atDate = new Date(vm.callingDetail.atDate);
        vm.callingDetail.nextAtDate = new Date(vm.callingDetail.nextAtDate);
        if (vm.commentStrings.indexOf(vm.callingDetail.comments) === -1) {
          vm.callingDetail.other = vm.callingDetail.comments
          vm.callingDetail.comments = vm.commentStrings[vm.commentStrings.length - 1];
        }
      } else if (type === 'new') {
        vm.callingDetail = {};

        vm.callingDetail.nextAtHour = 0;
        vm.callingDetail.nextAtMinute = 0;
        vm.callingDetail.atDate = new Date();
        vm.callingDetail.atHour = new Date().getHours();
        vm.callingDetail.atMinute = new Date().getMinutes();
      }
      vm.toggleSidenav(user._id);
    }

    function toggleSidenav(componentId) {

      return function () {
        $mdSidenav(componentId).toggle().then(function () {
          if (componentId === 'right') {
            $('[ui-calendar]').fullCalendar('changeView', 'month');
            // $('#calendarView').fullCalendar('refetchEvents')
          }
        });
      };
    }


    function sucessCbGetCustomerListForSales(response) {
      vm.salesCustomerList = response.data.data;
      vm.filteredCustomer = response.data.data;
      vm.filterData(vm.currentNavItem)
    }

    function errorCbGetCustomerListForSales(error) {
      if (error.data && error.data.responseString) {
        showDialog(error.data.responseString)
      } else {
        showDialog('Something went wrong.Please Try again.')
      }
    }

    function getCustomerListForSales() {
      ServiceProxy.customerListForSales().then(sucessCbGetCustomerListForSales, errorCbGetCustomerListForSales);
    }
    ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
    function showDialog(response) {
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {});
    };
    ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
    function showDialogSucc(response) {
      var confirm = $mdDialog.confirm()
        .title('Success')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {});
    };
    ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////


    ////////////////////////////////sety user not interested///////////////////////////////
    function openDialogNotInterested() {
      // if (!vm.notInterested) {
      //   return;
      // }
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent('Do You really want to set user ' + vm.activeUser.userName + ' as not Interested?')
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK')
        .cancel('Cancel');;
      $mdDialog.show(confirm).then(function (res) {
        if (res) {
          setNotInterested(vm.activeUser)
        }
      }, function () {
        vm.notInterested = false;
      });
    };

    function sucessCbSetNotInterested(response) {
      vm.activeUser = null;
      vm.callingDetail = {};
      vm.callingDetail.atHour = 0;
      vm.callingDetail.atMinute = 0;
      vm.callingDetail.nextAtHour = 0;
      vm.callingDetail.nextAtMinute = 0;
      showDialogSucc('Customer marked as not interested.');
      $mdSidenav('closeEventsDisabled').close();
      // getUserCountForSales();
      resetData();
    }

    function errorCbSetNotInterested(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function setNotInterested(user) {
      // evt.stopPropagation();
      var data = {
        "notInterestedFlag": true
      };
      ServiceProxy.setNotInterested(user._id, data).then(sucessCbSetNotInterested, errorCbSetNotInterested)
    }

    ///get user count API

    function sucessCbGetUserCount(response) {
      vm.countData = response.data.data
      // resetData();
    }

    function errorCbGetUserCount(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function getUserCountForSales() {
      ServiceProxy.getUserCountForSales().then(sucessCbGetUserCount, errorCbGetUserCount)
    }

    //////////function for time

    function changeHour(type, growth) {
      if (type === 'hour') {
        if (growth === 'plus' && +vm.callingDetail.atHour < 23) {
          vm.callingDetail.atHour++;
        } else if (growth === 'minus' && +vm.callingDetail.atHour > 0) {
          vm.callingDetail.atHour--;
        } else {
          return;
        }
      } else if (type === 'minute') {
        if (growth === 'plus' && +vm.callingDetail.atMinute < 59) {
          vm.callingDetail.atMinute++;
        } else if (growth === 'minus' && +vm.callingDetail.atMinute > 0) {
          vm.callingDetail.atMinute--;
        } else {
          return;
        }
      }
    }

    function changeDetect(type) {
      if (type === 'hour') {
        if (+vm.callingDetail.atHour < 0) {
          vm.callingDetail.atHour = 0
        } else if (vm.callingDetail.atHour > 23) {
          vm.callingDetail.atHour = 23;
        }
        vm.callingDetail.atHour = Math.floor(+vm.callingDetail.atHour);
      } else if (type === 'minute') {
        if (+vm.callingDetail.atMinute < 0) {
          vm.callingDetail.atMinute = 0
        } else if (vm.callingDetail.atMinute > 59) {
          vm.callingDetail.atMinute = 59;
        }
        vm.callingDetail.atMinute = Math.floor(+vm.callingDetail.atMinute);
      }
    }

    //////////function for Next time

    function changeNextHour(type, growth) {
      if (type === 'hour') {
        if (growth === 'plus' && +vm.callingDetail.nextAtHour < 23) {
          vm.callingDetail.nextAtHour++;
        } else if (growth === 'minus' && +vm.callingDetail.nextAtHour > 0) {
          vm.callingDetail.nextAtHour--;
        } else {
          return;
        }
      } else if (type === 'minute') {
        if (growth === 'plus' && +vm.callingDetail.nextAtMinute < 59) {
          vm.callingDetail.nextAtMinute++;
        } else if (growth === 'minus' && +vm.callingDetail.nextAtMinute > 0) {
          vm.callingDetail.nextAtMinute--;
        } else {
          return;
        }
      }
    }

    function changeNextDetect(type) {
      if (type === 'hour') {
        if (+vm.callingDetail.nextAtHour < 0) {
          vm.callingDetail.nextAtHour = 0
        } else if (vm.callingDetail.nextAtHour > 23) {
          vm.callingDetail.nextAtHour = 23;
        }
        vm.callingDetail.nextAtHour = Math.floor(+vm.callingDetail.nextAtHour);
      } else if (type === 'minute') {
        if (+vm.callingDetail.nextAtMinute < 0) {
          vm.callingDetail.nextAtMinute = 0
        } else if (vm.callingDetail.nextAtMinute > 59) {
          vm.callingDetail.nextAtMinute = 59;
        }
        vm.callingDetail.nextAtMinute = Math.floor(+vm.callingDetail.nextAtMinute);
      }
    }
    //////////////////////////Record Call Function//////////////////////
    function sucessCbCreateCall(response) {
      if (vm.notInterested) {
        //vm.openDialogNotInterested()
        setNotInterested(vm.activeUser);
      }
      // vm.activeUser = null;
      vm.callingDetail = {};
      vm.callingDetail.atHour = 0;
      vm.callingDetail.atMinute = 0;
      vm.callingDetail.nextAtHour = 0;
      vm.callingDetail.nextAtMinute = 0;
      $mdSidenav('closeEventsDisabled').close()
      // getUserCountForSales();
      // if (vm.notInterested) {
      //   vm.openDialogNotInterested()
      // }
      //resetData();
      vm.selectedFilter(vm.filterType);

    }

    function errorCbCreateCall(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function createCall() {
      if (vm.callingDetail.comments === 'Other') {
        vm.callingDetail.comments = vm.callingDetail.other;
      }
      vm.callingDetail.atDate = vm.callingDetail.atDate.setHours(0, 0, 0, 0);
      if (vm.callingDetail.nextAtDate) {
        vm.callingDetail.nextAtDate = vm.callingDetail.nextAtDate.setHours(0, 0, 0, 0);
      }

      if (vm.callingDetail.scheduleId) {
        ServiceProxy.updateCallSchedule(vm.activeUser._id, vm.callingDetail).then(sucessCbCreateCall, errorCbCreateCall)
      } else {
        ServiceProxy.createCall(vm.activeUser._id, vm.callingDetail).then(sucessCbCreateCall, errorCbCreateCall)
      }

    }

    ////////////////////get customer calling list for today///////////////////////////
    function sucessCbGetCustomerListForToday(response) {
      vm.salesCustomerList = response.data.data;
      vm.filteredCustomer = response.data.data;
      vm.filterData(vm.currentNavItem)
      // resetData();
    }

    function errorCbGetCustomerListForToday(error) {
      if (error.data && error.data.responseString) {
        showDialog(error.data.responseString)
      } else {
        showDialog('Something went wrong.Please Try again.')
      }
    }

    function getCustomerListForToday() {
      ServiceProxy.getCustomerListForToday().then(sucessCbGetCustomerListForToday, errorCbGetCustomerListForToday);
    }

    ////////////////////get Reassigned Customer List///////////////////////////
    function sucessCbGetReassignedCustomer(response) {
      vm.salesCustomerList = response.data.data;
      vm.filteredCustomer = response.data.data;
      vm.filterData(vm.currentNavItem)
    }

    function errorCbGetReassignedCustomer(error) {
      if (error.data && error.data.responseString) {
        showDialog(error.data.responseString)
      } else {
        showDialog('Something went wrong.Please Try again.')
      }
    }

    function getReassignedCustomer() {
      ServiceProxy.getReassignedCustomer().then(sucessCbGetReassignedCustomer, errorCbGetReassignedCustomer);
    }

    ///////////////////////////filter selection///////////////

    function selectedFilter(type) {
     // getUserCountForSales();
      vm.filterType = type;
      if (vm.filterType == 'All') {
        getCustomerListForSales();
      } else if (vm.filterType === 'TodayCall') {
        getCustomerListForToday();
      } else if (vm.filterType === 'Reassign') {
        getReassignedCustomer();
      }
    }

    $scope.downloadCallHistory = function(log) {

      if(!log && log.length < 1){
        showDialog("No Data Found...!!!");
      }else{
        var csvString = 'Calling Date, Comment, Next Date, Called By,' + "\n";
          for (var i = 0; i < log.length; i++) { 
            var atDateFormatted = $filter('date')(new Date(log[i].atDate), 'dd-MM-yyyy') + 
                ' at ' + (log[i].atHour > 12 ? (log[i].atHour - 12) : log[i].atHour) + ':' + 
                (log[i].atMinute < 10 ? '0' + log[i].atMinute : log[i].atMinute) + 
                (log[i].atHour > 11 ? ' PM' : ' AM');
        
            var nextAtDateFormatted = $filter('date')(new Date(log[i].nextAtDate), 'dd-MM-yyyy') + 
                ' at ' + (log[i].nextAtHour > 12 ? (log[i].nextAtHour - 12) : log[i].nextAtHour) + ':' + 
                (log[i].nextAtMinute < 10 ? '0' + log[i].nextAtMinute : log[i].nextAtMinute) + 
                (log[i].nextAtHour > 11 ? ' PM' : ' AM');
        
            csvString = csvString.concat(
                atDateFormatted + ',' +
                (log[i].comments ? log[i].comments : "") + ',' +
                nextAtDateFormatted + ',' +
                (log[i].createdBy && log[i].createdBy.userName ? log[i].createdBy.userName : "") + ','
            );
            csvString = csvString + "\n";                
        }
        var a = $('<a/>', {
          href:'data:application/octet-stream;base64,'+btoa(unescape(encodeURIComponent(csvString))),
          download:'DownloadCallHistory.csv'
        }).appendTo('body')
        a[0].click()
        a.remove();
      };
    }

    /////////////////// function for local filtering of data////////////////////////////////
    function filterData(type) {
      vm.calendarText = '';
      vm.filteredCustomer = [];
      if (type === 'PARTIAL') {
        vm.filteredCustomer = vm.salesCustomerList.filter(function (item) {
          if (item.documentUploadStatus) {
            return item.documentUploadStatus === type;
          }
        })
      } else if (type === 'PENDING') {
        vm.filteredCustomer = vm.salesCustomerList.filter(function (item) {
          if (item.documentUploadStatus) {
            return item.documentUploadStatus === type;
          } else if (!item.documentUploadStatus) {
            return item;
          }
        })
      } else if (type === 'NOCALL') {
        vm.filteredCustomer = vm.salesCustomerList.filter(function (item) {
          if (item.callSchedules) {
            return item.callSchedules.length === 0;
          } else if (!item.callSchedules) {
            return item;
          }
        })
      } else if (type === 'NOCALLSchedule') {
        vm.filteredCustomer = vm.salesCustomerList.filter(function (item) {
          if (item.callSchedules.length > 0) { 
            return !item.callSchedules[0].nextAtDate;
          } else {
            return item;
          }
        })
      } else if (type === 'COMPLETE') {
        vm.filteredCustomer = vm.salesCustomerList.filter(function (item) {
          if (item.documentUploadStatus) {
            return item.documentUploadStatus === type;
          }
        })
      } else if (type === 'TODAY') {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
    
        vm.filteredCustomer = vm.salesCustomerList.filter(function (item) {
            if (item.callSchedule && item.callSchedule.nextAtDate && item.callSchedules.nextAtDate > 0) {
                var nextCallDate = new Date(item.callSchedule.nextAtDate);
                nextCallDate.setHours(0, 0, 0, 0);
                
                return nextCallDate.getTime() === today.getTime();
            }
            return item; 
        })
      } else if (type === 'ALL') {
        vm.filteredCustomer = vm.salesCustomerList;
      }
    }

    function filetrDataByCallingDate(date) {
      $mdSidenav('right').close();
      vm.calendarText = "Calls on " + new Date(date.nextAtDate).toDateString();
      vm.currentNavItem = 'Call';
      vm.filteredCustomer = []
      vm.filteredCustomer = vm.salesCustomerList.filter(function (item) {
        if (item.callSchedules.length > 0) {
          return item.callSchedules[0].nextAtDate === new Date(date.nextAtDate).setHours(0, 0, 0, 0);
        }
      })
    }


    /////////////////////////////get data for calender/////////////////////////////////////////
    function sucessCbGetCalenderData(response) {
      vm.calenderCallData = response.data.data;
      var tempArray = []
      angular.forEach(vm.calenderCallData, function (item, index) {
        var obj = {
          id: index + 1,
          nextAtDate: new Date(item.year, item.month - 1, item.day),
          title: item.count + ' Call',
          start: new Date(item.year, item.month - 1, item.day),
          end: null
        };
        tempArray.push(obj)
      })
      vm.events[0] = tempArray;

    }

    function errorCbGetCalenderData(error) {
      if (error.data && error.data.responseString) {
        showDialog(error.data.responseString)
      } else {
        showDialog('Something went wrong.Please Try again.')
      }
    }

    function getCalenderData() {
      ServiceProxy.getCalenderData().then(sucessCbGetCalenderData, errorCbGetCalenderData);
    }

    function resetData() {
      // getCustomerListForSales();
      getUserCountForSales();
      getCalenderData();
      vm.selectedFilter(vm.filterType);
    }


    function clearCalendarFilter() {
      vm.calendarText = '';
      filterData('ALL');
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app.communicationSMS')
        .controller('CommunicationMessageSMSController', CommunicationMessageSMSController);

    /** @ngInject */
    function CommunicationMessageSMSController($scope, $rootScope, $state, $location, ServiceProxy, ShareDataService, $mdDialog) {
        var vm = this;
        $scope.imageFile = {
            flowObj: {}
        };

        function init() {
            vm.attachment = false;
            vm.selected = [];
            vm.selectedFlag = null;
            vm.getAllScheme = getAllScheme;
            vm.showTemplateDetails =showTemplateDetails;
            vm.SMSTemplate = null;
            if (ShareDataService.getData('selectedCustomerSMS')) {
                vm.selectedCustomer = ShareDataService.getData('selectedCustomerSMS');
                if (vm.selectedCustomer.length > 0) {
                    vm.selectedFlag = 7;
                }
            }
            
            if (ShareDataService.getData('selectedProspectSMS')) {
                vm.selectedCustomer = ShareDataService.getData('selectedProspectSMS');
                if (vm.selectedCustomer.length > 0) {
                    vm.selectedFlag = 8;
                }
            }

            vm.customerCount = customerCount;

        };
        init();

        /////////////////////////////////////////////sms api starts here////////////////////////////////////////////
        function sucessCbCreateSMS(response) {
            showDialogSucc(response.data.responseString);
            vm.subject = null;
            vm.message = null;
        }
        // Get All Scheme API Call Start
        function sucessCbGetAllScheme(response) {
            vm.AllTempltate = response.data.data;
        };

        function errorCbGetAllScheme(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        };

        function getAllScheme() {
            vm.AllTempltate = [];

            ServiceProxy.getAllSMSTemplates().then(sucessCbGetAllScheme, errorCbGetAllScheme);
        };

        vm.getAllScheme();
        // Get All Scheme API Call End

        function showTemplateDetails(templateId)
        {
            var postData = {
                "templatename": templateId
            }
            ServiceProxy.getSMSTemplatesDetails(templateId).then(sucessCbGetTemplate, errorCbGetGetTemplate);

        } 
        function sucessCbGetTemplate(response) {
            vm.message  = response.data.data.templatedetails;
        };

        function errorCbGetGetTemplate(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        };

        function errorCbCreateSMS(response) {
            if (response && response.data && response.data.responseString) {
                showDialog(response.data.responseString);
            }
        }

        vm.createEmail = function(msgType) {
                var postData = {
                    "subject": vm.subject,
                    "body": vm.message,
                    "templatename":vm.SMSTemplate
                }
               
                    if (msgType === 'SMS') {
                        postData.mobileNumbers = [];
                        if (vm.selectedFlag === 7 || vm.selectedFlag === 8) {
                            angular.forEach(vm.selectedCustomer, function(custmr) {
                                postData.mobileNumbers.push(custmr.mobileNo);
                            })
                        }
                    }

                    ServiceProxy.createCommunicationSMS(postData, msgType, 'NO', vm.selectedFlag).then(sucessCbCreateSMS, errorCbCreateSMS);
               
            }
            /////////////////////////////////////////////sms api end here////////////////////////////////////////////

        ///////////////////////////////customer filter count starts here//////////////////////////////////////////
        function customerCount(filter) {
            if (vm.selectedFlag === null) {
                vm.selectedFlag = filter;
            } else {
                vm.selectedFlag = null;
            }
        }
        ///////////////////////////////customer filter count ends here//////////////////////////////////////////


        ////////////////////////////////////disabled starts here/////////////////////////////////////////////////
        vm.disabledEmail = function() {
            return !(vm.subject && vm.message);
        };

        vm.disabledSMS = function() {
            // var fId = 'MESSAGE::SMS';
            // if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
            // return !((vm.subject && vm.message) && !vm.attachment);
            // }
            // else
            //return true;

            return false;
        };

        vm.disabledBoth = function() {
            var fId = 'MESSAGE::SMS';
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
            return !((vm.subject && vm.message) && !vm.attachment);
            }
            else
            return true;
        };

        ////////////////////////////////////disabled end here/////////////////////////////////////////////////


        vm.deleteUser = function(index) {
            vm.selectedCustomer.splice(index, 1);
            if (vm.selectedCustomer.length === 0) {
                vm.selectedFlag = null;
            }
        }

        // attachment
        $scope.processFile = function(files) {
            var fileReader = new FileReader();
            var image = new Image();
            var fileSize = 0;

            angular.forEach(files, function(eachFile) {
                fileSize += eachFile.file.size;
            });

            if (fileSize > 10485760) {
                showDialog("file size should not be greater than 10 MB");
                $scope.$apply(function() {
                    $scope.imageFile.flowObj.cancel();
                    imageFile.flowObj.files = [];
                });
                vm.attachment = false;
                $scope.imageFile = {
                    flowObj: {}
                };
            } else {
                vm.attachment = true;
            }
            fileReader.readAsDataURL(files[0].file);
        };


        // function To upload file
        // function sucessUploadAttachment(response) {
        //     var postData = {
        //         "subject": vm.subject,
        //         "body": vm.message
        //     }
        //     postData.emailIds = [];
        //     angular.forEach(vm.selectedCustomer, function(custmr) {
        //         postData.emailIds.push(custmr.email);
        //     })
        //     postData.attachments = [];
        //     postData.attachments = response.data.documents;
        //     ServiceProxy.createCommunicationEmail(postData, 'EMAIL', vm.attachment ? 'YES' : 'NO', vm.selectedFlag).then(sucessCbCreateSMS, errorCbCreateSMS);
        // }

        // function errorUploadAttachment(response) {
        //     if (response.data == null) {
        //         showDialog('File size is too large!');
        //     } else {
        //         showDialog(response.data.responseString);
        //     }
        // }

        // //  method for attachment uplaoding
        // function uploadAttachment() {
        //     var data = new FormData();
        //     angular.forEach($scope.imageFile.flowObj.files, function(doc) {
        //         data.append("attachments", doc.file);
        //     });
        //     ServiceProxy.uploadDocumentAttachment(data).then(sucessUploadAttachment, errorUploadAttachment);
        // }

        // vm.removeAttachment = function(index) {
        //     $scope.imageFile.flowObj.files.splice(index, 1);
        //     if ($scope.imageFile.flowObj.files.length == 0) {
        //         vm.attachment = false;
        //     }
        // }

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
        function showDialogSucc(response) {
            var confirm = $mdDialog.confirm()
                .title('Success')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show success dialog message starts here//////////////////////////////////////////////
    }
})();
(function() {
	'use strict';

	angular.module('app.changepassword', []).config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.changepassword', {
			url: '/changepassword',
			views: {
				'content@app': {
					templateUrl: 'app/main/change-password/change-password.html',
					controller: 'ChangePasswordController as vm'
				}
			}
		});

		//  msApiProvider.register('customers', ['app/data/customers/customers.json']);

		msNavigationServiceProvider.saveItem('SETTING', {
			title: 'SETTING',
			//  group: true,
			weight: 14
		});

		msNavigationServiceProvider.saveItem('SETTING.Change Password', {
			title: 'Change Password',
			icon: 'icon-lock-unlocked',
			state: 'app.changepassword',
			weight: 1
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('app.changepassword')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($window, $state, $mdToast, $mdDialog, ServiceProxy) {
        var vm = this;

        function init() {
            vm.resetPassword = resetPassword;
        };
        init();

        function sucessCbResetPassword(response) {
            $mdToast.show(
                $mdToast.simple()
                .textContent(response.data.responseString)
                .position('top right')
                .hideDelay(3000)
                .toastClass('success')
            );
            $window.sessionStorage.clear();
            $state.go('app.auth_login');
        }

        function errorCbResetPassword(response) {
            if (response.data && response.data.responseString) {
                showDialog(response.data.responseString)
            } else {
                showDialog("Please Try After Sometime.")
            }

        }

        function resetPassword() {
            ServiceProxy.resetPassword(vm.form).then(sucessCbResetPassword, errorCbResetPassword)
        }

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.blogs')
        .controller('CreateNewBlogController', CreateNewBlogController);

    /** @ngInject */
    function CreateNewBlogController($scope, $state, $stateParams, $mdDialog, $sce, ServiceProxy, ShareDataService) {
        var vm = this;
        $scope.imageFile = {
            flowObj: {}
        };
        // Data
        function init() {
            vm.toggleImageVideoFlag = true;
            vm.uploadVideo = uploadVideo;
            vm.showVideo = showVideo;
            $scope.showImage = showImage;
            vm.newBlog = {};
            vm.createBlog = createBlog;
            vm.updateBlog = updateBlog;
            vm.patternWild = /^[0-9a-zA-Z-\s]+$/;
            vm.dummyImage = 'assets/images/backgrounds/header-bg.png';
            vm.blogDetail = angular.copy(ShareDataService.getData('blogDetail'));
            vm.blogServiceData = angular.copy(ShareDataService.getData('blogDetail'));
            if ($stateParams.blogId != '' && vm.blogDetail) {
                if (vm.blogDetail.blogVideoUrl != "") {
                    vm.uploadVideo();
                };
                // showVideo();
                var blogLogoBaseUrl = ShareDataService.getData('blogLogoBaseUrl');
                vm.newBlog = vm.blogDetail;
                if (vm.newBlog.blogImage && vm.newBlog.blogImage.indexOf(undefined) == -1) {
                    vm.dummyImage = blogLogoBaseUrl + vm.newBlog.blogImage;
                }
            };
            vm.goBack = goBack;
        };
        init();
        // Methods
        // Function Tocreate Blog Start

        function sucessCreateBlog(response) {
            if ($scope.imageFile.flowObj.files.length != 0) {
                uploadBlogImage(response.data.blogId);
            }
            $state.go('app.blogs');
        }

        function errorCreateBlog(response) {
            showDialog();
        }

        function createBlog() {
            ServiceProxy.createBlog(vm.newBlog).then(sucessCreateBlog, errorCreateBlog)
        }
        // Function Tocreate Blog End

        // Function To Update Blog Start

        function sucessUpdateBlog(response) {
            if ($scope.imageFile.flowObj.files.length != 0) {
                uploadBlogImage(vm.newBlog._id);
            }
            $state.go('app.blogs')
        }

        function errorUpdateBlog(response) {
            showDialog();
        }

        function updateBlog() {
            var postData = {
                "blogId": vm.newBlog._id,
                "blogUrl": vm.newBlog.blogUrl,
                "title": vm.newBlog.title,
                "description": vm.newBlog.description,
                "authorName": vm.newBlog.authorName,
                "blogVideoUrl": vm.newBlog.blogVideoUrl
            }
            ServiceProxy.updateBlog(postData).then(sucessUpdateBlog, errorUpdateBlog)
        }
        // Function To Update Blog End

        // function To upload Blog Image Start
        function sucessUploadBlogImage(response) {}

        function errorUploadBlogImage(response) {
            showDialog(response.data.responseString);
        }

        function uploadBlogImage(blogId) {
            var data = new FormData();
            data.append("image", $scope.imageFile.flowObj.files[0].file);
            ServiceProxy.uploadBlogImage(data, blogId).then(sucessUploadBlogImage, errorUploadBlogImage);
        }

        function goBack() {
            if ($stateParams.blogId != '') {
                ShareDataService.storeData('blogDetail', vm.blogServiceData);
                $state.go('app.blogDetail', {
                    blogId: vm.blogServiceData._id
                });
            } else {
                $state.go('app.blogs');
            }
        }
        // function Goback End
        //////////

        // image upload
        $scope.processFile = function (files) {
            vm.newBlog.blogVideoUrl = '';
            var fileReader = new FileReader();
            var image = new Image();
            var validExts = new Array(".jpeg", ".jpg", ".png");
            var fileExt = files[0].name;

            fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
            if (validExts.indexOf(fileExt) < 0) {
                showDialog("Invalid file selected, valid files are of " +
                    validExts.toString() + " types.");
                $(files[0]).val("");
                return false;
            };

            fileReader.onload = function (event) {
                var uri = event.target.result;
                image.src = uri;
                image.onload = function () {
                    if (files[0].file.size > 204800) {
                        showDialog("file size should not be greater than 200 KB");
                        $scope.$apply(function () {
                            $scope.imageFile.flowObj.cancel();
                            files[0] = {};
                        });
                    } else {
                        // $scope.imageFiles.flowObj=files[0];
                    }
                }
            }

            fileReader.readAsDataURL(files[0].file);
        };

        // error msg for image
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {
                $scope.status = 'You decided to get rid of your debt.';
            }, function () {
                $scope.status = 'You decided to keep your debt.';
            });
        };

        //uploadVideo
        function uploadVideo() {
            vm.toggleImageVideoFlag = false;

        }
        // showVideo
        function showVideo(htmlString) {
            return $sce.trustAsHtml(htmlString);
        }
        //vm.showImage
        function showImage() {
            vm.toggleImageVideoFlag = true;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.blogs')
        .controller('BlogsController', BlogsController);

    /** @ngInject */
    function BlogsController($scope, $timeout, $sce, $document, $state, $location, $stateParams, $filter, $mdDialog, ServiceProxy, ShareDataService) {
        var vm = this;

        function init() {
            vm.viewBlogDetail = viewBlogDetail;
            vm.trustedHtml = trustedHtml;
            vm.editBlog = editBlog;
            vm.deleteBlog = deleteBlog;
            if ($location.path() === '/blogs') {
                getAllBlogs();
            }
            vm.openSearchToolbar = openSearchToolbar;
            vm.closeSearchToolbar = closeSearchToolbar;
            if ($stateParams.blogId != '') {
                vm.blogDetailView = angular.copy(ShareDataService.getData('blogDetail'));
                vm.blogLogoBaseUrl = angular.copy(ShareDataService.getData('blogLogoBaseUrl'));;
            }
        };
        init();

        function trustedHtml(htmlString) {
            return $sce.trustAsHtml(htmlString);
        }
        // get All Blogs Start

        function sucessGetAllBlogs(response) {
            vm.blogLogoBaseUrl = response.data.blogLogoBaseUrl;
            vm.blogsData = response.data.responseString;
            vm.fullBlogData = angular.copy(response.data.responseString);
            angular.forEach(vm.blogsData, function (blog) {
                blog.title = blog.title.substr(0, 25) + ' ....';
                blog.description = blog.description.replace(/(<([^>]+)>)/ig, "").substr(0, 100) + ' ....';
                if ((!blog.blogSourceFlag) && blog.blogImage && blog.blogImage.indexOf(undefined) == -1) {
                    blog.image = vm.blogLogoBaseUrl + blog.blogImage;
                } else {
                    blog.image = ''
                };
                blog.author = blog.authorName;
                blog.date = $filter('date')(blog.createdAt, 'fullDate');
            });
        }

        function errorGetAllBlogs(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function getAllBlogs() {
            ServiceProxy.getAllBlogs().then(sucessGetAllBlogs, errorGetAllBlogs)
        }

        function viewBlogDetail(blogData) {
            var blogDetail = {};
            angular.forEach(vm.fullBlogData, function (blog) {
                if (blog._id == blogData._id) {
                    blogDetail = blog;
                }
            });
            ShareDataService.storeData('blogDetail', blogDetail);
            ShareDataService.storeData('blogLogoBaseUrl', vm.blogLogoBaseUrl);
            $state.go('app.blogDetail', {
                blogId: blogDetail._id
            });
        }


        function openSearchToolbar() {
            vm.searchToolbar = true;

            $timeout(function () {
                angular.element($document.find('#search-notes-input')).trigger('focus');

            });

            $document.on('keyup', escKeyEvent);
        }

        function closeSearchToolbar() {
            $scope.$evalAsync(function () {
                vm.searchToolbar = false;
                vm.search = '';
            });

            $document.off('keyup', escKeyEvent);
        }

        function escKeyEvent(e) {
            if (e.keyCode === 27) {
                closeSearchToolbar();
            }
        }

        function editBlog() {
            ShareDataService.storeData('blogDetail', vm.blogDetailView);
            ShareDataService.storeData('blogLogoBaseUrl', vm.blogLogoBaseUrl);
            $state.go('app.createNewBlog', {
                blogId: vm.blogDetailView._id
            });
        }

        function sucessDeleteBlog(response) {
            $state.go("app.blogs");
        }

        function errorDeleteBlog(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }

        function deleteBlog() {
            ServiceProxy.deleteBlog(vm.blogDetailView._id).then(sucessDeleteBlog, errorDeleteBlog)
        }

        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function () {
                $scope.status = 'You decided to get rid of your debt.';
            }, function () {
                $scope.status = 'You decided to keep your debt.';
            });
        };


    }
})();
(function () {
    'use strict';

    angular
        .module('app.ceaseRequest', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        var fId = 'CEASE::REQUEST';
        // State
        $stateProvider
            .state('app.ceaseRequest', {
                url: '/ceaseRequest',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ceaseRequest/ceaseRequest.html',
                        controller: 'CeaseRequestController as vm'
                    }
                },
                data: {
                    access: function () {
                        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            });

        // Translation
        // msApiProvider.register('customers', ['app/data/customers/customers.json']);


        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'SAMPLE',
        //     group : true,
        //     weight: 2
        // });

        msNavigationServiceProvider.saveItem('customer.ceaseRequest', {
            title: 'Cease Request',
            icon: 'icon-comment-account',
            state: 'app.ceaseRequest',
            weight: 2,
            hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			}
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.ceaseRequest')
        .controller('CeaseRequestController', CeaseRequestController);

    /** @ngInject */
    function CeaseRequestController(ServiceProxy, $scope, $mdDialog) {
        var vm = this;

        function init() {
            getCeaseInfo();
        };
        init();

        function sucessCbGetCeaseInfo(response) {
            vm.ceaseData = response.data.data;
        };

        function errorCbGetCeaseInfo(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }

        };

        function getCeaseInfo() {
            ServiceProxy.getCeaseInfo().then(sucessCbGetCeaseInfo, errorCbGetCeaseInfo)
        }

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        $scope.items = [];

        vm.collapseAll = function(data) {
            for (var i in vm.ceaseData) {
                if (vm.ceaseData[i] !== data) {
                    vm.ceaseData[i].expanded = false;
                }
            }
            data.expanded = !data.expanded;
        };

        ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
        function showDialog(response) {
            var confirm = $mdDialog.confirm()
                .title('!!Error!!')
                .textContent(response)
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('OK');
            $mdDialog.show(confirm).then(function() {});
        };
        ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.common', [])
        .config(config);

        // .service('Message', [Message])
        // .service('Service', ['$http', '$location', '$q', '$injector','StorageService', 'GlobalService', 'Message', Service])
        // .service('ServiceProxy', ['Service', '$q', ServiceProxy])
        // .service('StorageService', [StorageService])
        // .service('GlobalService', [GlobalService])
        // .service('ChangeLossPreventer', ['$rootScope', '$q', '$state',ChangeLossPreventer])
    /** @ngInject */
    function config($httpProvider)
    {
      $httpProvider.interceptors.push('LoadingInterceptor');
    }

})();
// var loading = require('./loading.interceptor');
// var Message = require('./message');
// var Service = require('./service');
// var ServiceProxy = require('./service.proxy');
// var StorageService = require('./storage.service');
// var GlobalService = require('./global.service');
// var ChangeLossPreventer = require('./changeLossPreventer');
// var common = angular.module('common', [loading.name]);
//
// common
//     .config(['$httpProvider', function($httpProvider) {
//         $httpProvider.interceptors.push('LoadingInterceptor');
//     }])
//     .service('Message', [Message])
//     .service('Service', ['$http', '$location', '$q', '$injector','StorageService', 'GlobalService', 'Message', Service])
//     .service('ServiceProxy', ['Service', '$q', ServiceProxy])
//     .service('StorageService', [StorageService])
//     .service('GlobalService', [GlobalService])
//     .service('ChangeLossPreventer', ['$rootScope', '$q', '$state',ChangeLossPreventer])
//
//
// module.exports = common;

(function () {
    'use strict';

    angular
        .module('app.common')
        .service('UserFeature', UserFeature);

    /** @ngInject */
    function UserFeature($state, $mdToast, ServiceProxy, StorageService) {
        var self = this;
        this.changePassword = false;
        this.userData;
        this.getUserProfile = function () {
            getUserProfile();
        };

        this.allState = [{
                fId: 'DASHBOARD::FEATURE',
                state: 'app.dashboard.details'
            },
            {
                fId: 'CUSTOMER::MANAGEMENT',
                state: 'app.customers'
            },
            {
                fId: 'COMMUNICATION::EMAIL::NOTIFICATION',
                state: 'app.communication'
            },
            {
                fId: 'MESSAGE::SMS',
                state: 'app.communicationSMS'
            },
            {
                fId: 'TRANSACTION::CSV::UPLOAD',
                state: 'app.uploadTransaction'
            },
            {
                fId: 'WEBSITE::MANAGEMENT',
                state: 'app.blogs'
            },
            {
                fId: 'RECOMMENDED::SCHEMES',
                state: 'app.recommendations'
            },
            {
                fId: 'THIRD::PARTY::SERVER::CONFIG',
                state: 'app.serviceConfiguration'
            },
            {
                fId: 'INTERNAL::USERS::MANAGEMENT',
                state: 'app.internalUser'
            }, {
                fId: 'REFERRAL::CONFIG',
                state: 'app.referral'
            }, {
                fId: 'ASSIGNMENT::USERS::DASHBOARD',
                state: 'app.assignmentDashboard'
            }, {
                fId: 'SALES::USERS::DASHBOARD',
                state: 'app.customersales'
            }, {
                fId: 'ADVISORY::USERS::DASHBOARD',
                state: 'app.advisoryDashboard'
            }, {
                fId: 'CEASE::REQUEST',
                state: 'app.ceaseRequest'
            },
        ]
        // Get User Profile Start
        function sucessCbGetUserProfile(response) {

            if (response.data.data.changePasswordFlag || response.data.data.type === 'SUPER::ADMIN') {
                StorageService.setSessionStorage('feature', response.data.data.features)
                StorageService.setSessionStorage('type', response.data.data.type)
                self.userData = response.data.data;
                if (response.data.data.type === 'SUPER::ADMIN') {
                    $state.go('app.dashboard.details');
                } else {

                    for (var i = 0; i < self.allState.length; i++) {
                        if (self.allState[i].fId === response.data.data.features[0]) {
                            $state.go(self.allState[i].state);
                            break;
                        }
                    }
                }

            } else {
                $state.go('app.changepassword')
            }

        }

        function errorCbGetUserProfile(response) {
            $mdToast.show({
                template: '<h4 style="color:#c0392b; text-align:right; margin-right:15px;">' + response.data.responseString + '</h4>',
                hideDelay: 3000,
                position: 'top right',
                parent: '#content'
            });
        }

        function getUserProfile() {
            ServiceProxy.getUserProfileInfo().then(sucessCbGetUserProfile, errorCbGetUserProfile);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.common')
        .service('StorageService', StorageService);

    /** @ngInject */
    function StorageService() {
        this.setSessionStorage = function(key, value) {
            if (window && window.sessionStorage) {
                window.sessionStorage[key] = JSON.stringify(value);
            } else if (sessionStorage) {
                sessionStorage[key] = JSON.stringify(value);
            }
        };
        this.getSessionStorage = function(key) {
            if (window && window.sessionStorage && window.sessionStorage[key]) {
                return JSON.parse(window.sessionStorage[key]);
            } else if (sessionStorage && sessionStorage[key]) {
                return JSON.parse(sessionStorage[key]);
            } else {
                return null;
            }
        };

    }

})();

(function() {
    'use strict';

    angular
        .module('app.common')
        .service('ShareDataService', ShareDataService);

    /** @ngInject */
    function ShareDataService() {

        var data = {};
        this.storeData = function(key, value){
          data[key] = value;
        }
        this.getData = function(key){
          return data[key];
        }
    }

})();

(function () {
	'use strict';

	angular.module('app.common').service('ServiceProxy', ServiceProxy);

	/** @ngInject */
	function ServiceProxy(Service, $q) {
		var getData = function (obj) {
			var deferred = $q.defer();
			Service.makeServiceCall(
				'api',
				obj.method,
				obj.serviceMethod,
				obj.params,
				obj.postData,
				obj.requestForErrorHandling
			).then(
				function (response) {
					deferred.resolve(response);
				},
				function (response) {
					deferred.reject(response);
				}
			);
			return deferred.promise;
		};
		this.authenticate = function (postData) {
			var obj = {};
			obj.method = 'token';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllAmc = function () {
			var obj = {};
			obj.method = 'apiData/Amc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllScheme = function (postData) {
			var obj = {};
			obj.method = 'apiData/Product?AMCCODE=' + postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadCamsTrxn = function (postData) {
			var obj = {};
			obj.method = 'camsUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadKarvyTrxn = function (postData) {
			var obj = {};
			obj.method = 'karvyData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadFranklinTrxn = function (postData) {
			var obj = {};
			obj.method = 'franklinData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getHoldingData = function (postData) {
			var obj = {};
			obj.method = 'retrieveData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		// this.deletePickup = function(postData) {
		// 	var obj = {};
		// 	obj.method = 'feedback?email=' + postData;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		// this.getAllPickupDetail = function() {
		// 	var obj = {};
		// 	obj.method = 'feedback';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getAllBlogs = function () {
			var obj = {};
			obj.method = 'blogs';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createBlog = function (postData) {
			var obj = {};
			obj.method = 'blogs';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateBlog = function (postData) {
			var obj = {};
			obj.method = 'blogs';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteBlog = function (postData) {
			var obj = {};
			obj.method = 'blogs?blogId=' + postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadBlogImage = function (postData, blogId) {
			var obj = {};
			obj.method = 'blogs/upload?blogId=' + blogId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllRecommendation = function () {
			var obj = {};
			obj.method = 'recommendedSchemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createRecommendation = function (postData) {
			var obj = {};
			obj.method = 'recommendedSchemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteRecommendation = function (postData, isin) {
			var obj = {};
			obj.method = 'recommendedSchemes?productISIN=' + isin;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateRecommendation = function (postData) {
			var obj = {};
			obj.method = 'recommendedSchemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadSundaramTransaction = function (postData) {
			var obj = {};
			obj.method = 'sundaramTrnx';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getExternalHolding = function (postData) {
			var obj = {};
			obj.method = 'retrieveData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadDocumentImage = function (postData, UserId, doctype) {
			var obj = {};
			obj.method = 'documents/uploads?userId=' + UserId + '&docType=' + doctype;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createInsurance = function (postData) {
			var obj = {};
			obj.method = 'insurance';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getInsuranceByUserId = function (userId) {
			var obj = {};
			obj.method = 'insurance?userId=' + userId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateInsurance = function (postData) {
			var obj = {};
			obj.method = 'insurance';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.deleteInsurance = function (insuranceId) {
			var obj = {};
			obj.method = 'insurance?insuranceId=' + insuranceId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getUserLoans = function (userId) {
			var obj = {};
			obj.method = 'loan?userId=' + userId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createRecommendedPortfolio = function (postData) {
			var obj = {};
			obj.method = 'recommendedPortfolio';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateRecommendedPortfolio = function (postData) {
			var obj = {};
			obj.method = 'recommendedPortfolio/' + postData._id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllRecommendedPortfolio = function () {
			var obj = {};
			obj.method = 'recommendedPortfolio';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteRecommendedPortfolio = function (id) {
			var obj = {};
			obj.method = 'recommendedPortfolio/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createPran = function (postData, id) {
			var obj = {};
			obj.method = 'nps/pran/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getPran = function (id) {
			var obj = {};
			obj.method = 'nps/pran/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deletePran = function (id) {
			var obj = {};
			obj.method = 'nps/pran/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteRecommendedPortfolioScheme = function (id, schemeId) {
			var obj = {};
			obj.method = 'recommendedPortfolio/' + id + '?schemeId=' + schemeId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createCommunicationSMS = function (postData, serviceType, attachment, number) {
			var obj = {};
			obj.method = 'email-sms?service=' + serviceType + '&&attachments=' + attachment + '&&filter=' + number;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createCommunicationEmail = function (postData, serviceType, attachment, number) {
			var obj = {};
			obj.method = 'email-sms?service=' + serviceType + '&&attachments=' + attachment + '&&filter=' + number;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadDocumentAttachment = function (postData) {
			var obj = {};
			obj.method = 'mail-attachments';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.mapDocumentImage = function (postData, id) {
			var obj = {};
			obj.method = 'insurance/mapInsuranceDocument?userId=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getUserProfile = function (id) {
			var obj = {};
			obj.method = 'investors/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSipDetail = function (pan) {
			var obj = {};
			obj.method = 'sip?pan=' + pan + '&&type=START';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCeaseDetail = function (pan) {
			var obj = {};
			obj.method = 'sip?pan=' + pan + '&&type=CEASED';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCeaseInfo = function () {
			var obj = {};
			obj.method = 'sip/ceased';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllInternalUser = function () {
			var obj = {};
			obj.method = 'internal-users';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.activatedInternalUser = function (id, data) {
			var obj = {};
			obj.method = 'internal-users/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getTypeInternalUser = function () {
			var obj = {};
			obj.method = 'internal-users/access-control/types';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAssignFeature = function () {
			var obj = {};
			obj.method = 'features';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createInternalUser = function (postData) {
			var obj = {};
			obj.method = 'internal-users';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateInternalUser = function (postData, id) {
			var obj = {};
			obj.method = 'internal-users/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getInternalUserById = function (id) {
			var obj = {};
			obj.method = 'internal-users/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCustmoerBySearch = function (filter, page, limit) {
			var obj = {};
			obj.method = 'investors?filter=' + filter + '&&page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getMappingCustomerDetails = function (number) {
			var obj = {};
			obj.method = 'investors/assign-to-internaluser?filter=' + number;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createAssignedCustomer = function (postData) {
			var obj = {};
			obj.method = 'investors/assign-to-internaluser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateDeassignedCustomer = function (id) {
			var obj = {};
			obj.method = 'investors/assign-to-internaluser/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getInternalUserDetalsById = function (id) {
			var obj = {};
			obj.method = 'investors/all/' + id + '?page=1&limit=100000';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.resetPassword = function (data) {
			var obj = {};
			obj.method = 'internal-users-password/change-password';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.forgotPassword = function (data) {
			var obj = {};
			obj.method = 'internal-users-password/otp';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.resetNewPassword = function (data) {
			var obj = {};
			obj.method = 'internal-users-password/create-password';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getUserProfileInfo = function () {
			var obj = {};
			obj.method = 'internal-users/profile/info';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createNotificationEmail = function (postData, filter) {
			var obj = {};
			obj.method = 'notifications?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadImageNotification = function (postData) {
			var obj = {};
			obj.method = 'notifications/upload/image';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateFlags = function (data, id) {
			var obj = {};
			obj.method = 'investors/monitoring/flags/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getServiceConfiguration = function () {
			var obj = {};
			obj.method = 'configurations';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getServiceConfigurationById = function (id) {
			var obj = {};
			obj.method = 'configurations/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateServiceConfiguration = function (postData, id) {
			var obj = {};
			obj.method = 'configurations/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSyncingNseUser = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=IAUFN';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllAssignedUser = function (id) {
			var obj = {};
			obj.method = 'investors/all/' + id + '?page=1&limit=100000';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllCustomerWithDeviceId = function () {
			var obj = {};
			obj.method = 'investors/all/inceptionnotification';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllinvestorslist = function (filter, page, limit) {
			var obj = {};
			obj.method = 'investors/allinvestorslist/notificationnew?filter=' + filter + '&&page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllCustomerCommunication = function () {
			var obj = {};
			obj.method = 'investors/all/inception';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCallingHistory = function (id) {
			var obj = {};
			obj.method = 'investors/monitoring/history/' + id + '?filter=REVIEW_PENDING';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getActivityCustomer = function (id) {
			var obj = {};
			obj.method = 'investors/monitoring/history/' + id + '?activityType=CUSTOM';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.downloadCSVFile = function () {
			var obj = {};
			obj.method = 'investors-internal-user-csv';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadCSVFile = function (postData) {
			var obj = {};
			obj.method = 'investors-internal-user-csv';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.postTransactionDetails = function (postData) {
			var obj = {};
			obj.method = 'apiData/TRXNREVERSEFEED';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getTodayEmployeePerformance = function () {
			var obj = {};
			obj.method = 'dashboard/employees_performance?filter=TOD';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getRangeEmployeePerformance = function (data) {
			var obj = {};
			obj.method = 'dashboard/employees_performance?filter=RNG&from=' + data.fromDate + '&to=' + data.toDate;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getByIdEmployeePerformanceToday = function (id) {
			var obj = {};
			obj.method = 'dashboard/employees_performance/closed_flags_details?filter=TOD&&internalUserId=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getByIdEmployeePerformanceRange = function (id, fromDate, toDate) {
			var obj = {};
			obj.method =
				'dashboard/employees_performance/closed_flags_details?filter=RNG&from=' +
				fromDate +
				'&to=' +
				toDate +
				'&&internalUserId=' +
				id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getDashboardDetails = function (filter) {
			var obj = {};
			obj.method = 'dashboard/details?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		// this.getDashboardInvestmentsDetails = function(filter) {
		// 	var obj = {};
		// 	obj.method = 'dashboard/details_investments?filter=' + filter;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getDashboardWithoutFilter = function () {
			var obj = {};
			obj.method = 'dashboard/details_investments';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getConsumerAcquisationData = function (filter) {
			var obj = {};
			obj.method = 'dashboard/reports_consumer_acquisation?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getIINActivateData = function (filter) {
			var obj = {};
			obj.method = 'dashboard/reports_graph_iin_activate?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getInvestmentData = function (filter) {
			var obj = {};
			obj.method = 'dashboard/reports_graph_investment?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getInvestmentProductData = function () {
			var obj = {};
			obj.method = 'dashboard/reports_products_investments';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralConfig = function () {
			var obj = {};
			obj.method = 'referral-config';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setReferralConfig = function (data) {
			var obj = {};
			obj.method = 'referral-config';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralConsilidatedData = function () {
			var obj = {};
			obj.method = 'user-transactions/consolidate-details/status-wise';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getConsolidatedReferralStatus = function () {
			var obj = {};
			obj.method = 'user-transactions/consolidate-details/activity-wise';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralTransactionByStatus = function (status) {
			var obj = {};
			obj.method = 'user-transactions?status=' + status;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.creditgReferralAmount = function (data) {
			var obj = {};
			obj.method = 'user-transactions';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.internalUserImageUpload = function (data, id) {
			var obj = {};
			obj.method = 'internal-users/image/upload?userId=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.customerListForSales = function () {
			var obj = {};
			obj.method = 'sales-users/list';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllReferralDetails = function () {
			var obj = {};
			obj.method = 'user-transactions/referral-details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.documentVerificationStatus = function (data) {
			var obj = {};
			obj.method = 'documents/verify';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAndroidAppInstalledUser = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/device';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getNewLeadUser = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/lead';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/rm';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.notInterestedCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/notInterested';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getOldUnAssignedCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/old';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUserCount = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/count';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.saveSchedular = function (data) {
			var obj = {};
			obj.method = 'notificationscheduler';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getallSchedular = function () {
			var obj = {};
			obj.method = 'notificationscheduler';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.assignToInternalUser = function (data) {
			var obj = {};
			obj.method = 'assignment-dashboard/users';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setNotInterested = function (id, data) {
			var obj = {};
			obj.method = 'flags/interested/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUnVerifiedCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/document';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSchedularByID = function (id) {
			var obj = {};
			obj.method = 'notificationscheduler/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateSchedular = function (id, data) {
			var obj = {};
			obj.method = 'notificationscheduler/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.deleteSchedular = function (id) {
			var obj = {};
			obj.method = 'notificationscheduler/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadAttachments = function (id, type, data) {
			var obj = {};
			obj.method = 'notificationscheduler/upload/attachment?nsid=' + id + '&&type=' + type;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUserCountForSales = function () {
			var obj = {};
			obj.method = 'sales-users/count';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.createCall = function (id, data) {
			var obj = {};
			obj.method = 'sales-users/call/schedules/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCustomerListForToday = function () {
			var obj = {};
			obj.method = 'sales-users/today_call';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReassignedCustomer = function () {
			var obj = {};
			obj.method = 'sales-users/re_assigned';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateCallSchedule = function (id, data) {
			var obj = {};
			obj.method = 'sales-users/call/schedules/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCalenderData = function () {
			var obj = {};
			obj.method = 'sales-users/calendar';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.deleteSchedularAttachments = function (nsid, data) {
			var obj = {};
			obj.method = 'notificationscheduler/upload/attachment?nsid=' + nsid;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralTransactionHistory = function (uid) {
			var obj = {};
			obj.method = 'user-transactions/reference-transactions/' + uid;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryAssignedCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/newly_assigned';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryInvestingCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/investing';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryNonInvestingCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/not_investing';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryReviewTodayCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/review_today';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryFollowUpCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/followup_today';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryDashboardCount = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/count';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setReviewDate = function (id, data) {
			var obj = {};
			obj.method = 'investors/monitoring/flags/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setPotentialScale = function (id, data) {
			var obj = {};
			obj.method = 'advisory-dashboard/potential/scale/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.resetPriorityFlag = function (id, data) {
			var obj = {};
			obj.method = 'flags/priority/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryCalendarData = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/calendar';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryReviewCallData = function (date) {
			var obj = {};
			obj.method = 'advisory-dashboard/calendar_review?date=' + date;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryFollowupCallData = function (date) {
			var obj = {};
			obj.method = 'advisory-dashboard/calendar_followup?date=' + date;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.closeEnquiryFlag = function (id, data) {
			var obj = {};
			obj.method = 'request-static/enquiry/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.reviewCallHistory = function (id) {
			var obj = {};
			obj.method = 'advisory-dashboard/old/reviewcall/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadImageAmcProducts = function (data, AMC_CODE) {
			var obj = {};
			obj.method = 'product/upload/image?AMCCODE=' + AMC_CODE;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateAmcProduct = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllSchemeProductList = function (amcCode, filter) {
			var obj = {};
			obj.method = 'product/list/data?amcCode=' + amcCode + '&&filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.serchUser = function (serachStrng) {
			var obj = {};
			obj.method = 'investors?search=' + serachStrng;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCamsTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'camsUploads?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getKarvyTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'karvyData?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getFranklinTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'franklinData?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSundramTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'sundaramTrnx?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.transactionListWithSearch = function (url, page, limit) {
			var obj = {};
			obj.method = url + '?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.deleteTransaction = function (url, id) {
			var obj = {};
			obj.method = url + '/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateTransaction = function (url, id, data) {
			var obj = {};
			obj.method = url + '/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.searchTransaction = function (url, serachStrng) {
			var obj = {};
			obj.method = url + '?search=' + serachStrng;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateSchems = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getProductCategory = function (type) {
			var obj = {};
			obj.method = 'product/category/list?type=' + type;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllAmcProducts = function () {
			var obj = {};
			obj.method = 'product/amc/list';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.startSyncingOfSncing = function (amcCode) {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=PSAFN&&amcCode=' + amcCode;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.syncSchemeFromNSE = function (amcCode, newAmcCode) {
			var obj = {};
			obj.method = 'product/sync/schemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = { amcCode: amcCode, newAmcCode: newAmcCode || '' };
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.closeNFO = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getNOIsinSchems = function (type) {
			var obj = {};
			obj.method = 'product/activescheme/list?type=' + type;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.markAddedMorning = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.minorTrasaction = function () {
			var obj = {};
			obj.method = 'minorTransactions';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateTrxnPan = function (id, data) {
			var obj = {};
			obj.method = 'camsUploads/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReports = function () {
			var obj = {};
			obj.method = 'aum_reports/investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsCustomerWise = function () {
			var obj = {};
			obj.method = 'aum_reports/investors_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsSchemeWise = function () {
			var obj = {};
			obj.method = 'aum_reports/scheme_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumReports = function () {
			var obj = {};
			obj.method = 'aum_reports/aum_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportSipBook = function () {
			var obj = {};
			obj.method = 'sip_book/investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsCustomerWiseSipBook = function () {
			var obj = {};
			obj.method = 'sip_book/investors_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsSchemeWiseSipBook = function () {
			var obj = {};
			obj.method = 'sip_book/scheme_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSipBookReport = function () {
			var obj = {};
			obj.method = 'sip_book/sipbook_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		//vikrant
		this.updateCustomer = function (postData) {
			var obj = {};
			obj.method = 'investors/save-invester-staticdata/'+postData._id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		// this.getBankDetailsFrmIFSC = function(postData) {
		// 	var obj = {};
		// 	obj.method = 'ifsc?code=' + postData;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };

		this.getBankType = function() {
			var obj = {};
			obj.method = 'apiData/Bank';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIFSClist = function(){
			var obj = {};
			obj.method = 'Ifsc/getIfscList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.postTrnLogs = function(postData){
			var obj = {};
			obj.method = 'investors/save-paytrn-log';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.postNavData = function(postData){
			var obj = {};
			obj.method = 'investors/nav-list';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.postNavCalData = function(postData){
			var obj = {};
			obj.method = 'investors/ratingSummary';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.syncInvestorIIN = function (postData) {
			var obj = {};
			obj.method = 'investors/sync-invester-iin/'+postData._id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getInvestorsReportsSchemeWise = function (postData) {
			var obj = {};
			obj.method = 'aum_reports/schemewise_investments_details/'+postData.productISIN;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getBanklist = function(){
			var obj = {};
			obj.method = 'Ifsc/getBankList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getBranchlist = function(postData){
			var obj = {};
			obj.method = 'Ifsc/getBranchDetials?bankName='+postData.bankName;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateBankDetails = function (postData) {
			var obj = {};
			obj.method = 'Ifsc/updateIfsc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.validateKarvyTransaction = function (postData) {
			var obj = {};
			obj.method = 'karvyData/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.validateFranklinList = function (postData) {
			var obj = {};
			obj.method = 'franklinData/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.validateCamsList = function (postData) {
			var obj = {};
			obj.method = 'camsUploads/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSyncAchMandateFollowUpMail = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=AMDRFR';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getProductDisplaySubCategory = function (postData) {
			var obj = {};
			obj.method = 'recommendedSchemes/displaySubCategory';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
			
		};
		this.communicationSmsEmail = function (postData,serviceType) {
			var obj = {};
			//obj.method = "linkUser?service='" + serviceType+ "'";
			//'email-sms?service=' + serviceType + '&&attachments=' + attachment + '&&filter=' + number;
			obj.method = 'linkUser?service=' + serviceType;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		// this.getSIPTrxn = function (page, limit) {
		// 	var obj = {};
		// 	obj.method = 'otherUploads?page=' + page + '&&limit=' + limit;;//'camsUploads?page=' + page + '&&limit=' + limit;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		
		this.uploadSIPTrxn = function (postData) {
			var obj = {};
			obj.method = 'sipUploads';//'camsUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.validateSIPTrxn = function (postData) {
			var obj = {};
			obj.method = 'sipUploads/validateTransaction';//'camsUploads/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSIPTrxn = function () {
			var obj = {};
			obj.method = 'sipUploads';//'camsUploads?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadIINSyncTrxn = function (postData) {
			var obj = {};
			obj.method = 'iinUploads';//'camsUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIInSync = function () {
			var obj = {};
			obj.method = 'iinUploads';//'camsUploads?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadAchTrxn = function (postData) {
			var obj = {};
			obj.method = 'achUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAchTrxn = function () {
			var obj = {};
			obj.method = 'achUploads';//'camsUploads/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllSchemeReport = function () {
			var obj = {};
			obj.method = 'scheme-report/getSchemeList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSchemeActiveReport = function () {
			var obj = {};
			obj.method = 'scheme-report/getSchemesActive';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSchemeInActiveReport = function () {
			var obj = {};
			obj.method = 'scheme-report/getSchemesInActive';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.CreatecustomerEngagementGoalChart = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.Goalchart = function () {
			var obj = {};
			obj.method = 'customerEngagementGoalChart';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.UpdateCustomerEngagementGoalChart = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalChartCategory = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart/'+ postData.Goal + '&&categoryId='+postData.CategoryId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalChart = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart/'+ postData.Goal + '&&GoalId='+postData.GoalId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.CreatecustomerEngagementGoalFund = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.GoalFundList = function () {
			var obj = {};
			obj.method = 'customerEngagementGoalFund';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalFundScheme = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund/'+ postData.category + '&&schemeId='+postData.schemeId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalFund = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund/'+ postData.Category + '&&CategoryId='+postData.CategoryId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.UpdateGoalFund = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSubBrokerAssignedCustomer = function (postData) {
			var obj = {};
			obj.method = 'subBroker/assigned-investors/';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};		
		
		this.getActivationStatus = function (id) {
			var obj = {};
			obj.method = 'investors/activationstatus/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCustomerAchMandateList = function (iin) {
			var obj = {};
			obj.method = 'achMandate/' + iin;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.registerCustomerAchMandate = function (postData) {
			var obj = {};
			obj.method = 'achMandate/registerCustMandate';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.sendIINActivationLink = function(postData) {
			var obj = {};
			obj.method = 'investors/send-iin-activation-link';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}
		this.downlaodCustDetails = function (filter, page, limit) {
			var obj = {};
			obj.method = 'investors/download-details?filter=' + filter + '&&page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSyncAUMReport = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=AUMGEN';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSyncSIPReport = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=SIPGEN';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.startAutoLeadAssignment = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=ALASTA';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.stopAutoLeadAssignment = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=ALASTP';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAutoLeadAssignmentStatus = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=ALASTU';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSubBrokersData = function(){
			var obj = {};
			obj.method = 'getBrokerDetails';//get all subbrokers
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj)
		}

		this.getBrokerProfile = function(id){
			var obj = {};
			obj.method = 'getBrokerDetails/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}
		//Office
		this.submitofficeinfo = function (postData) {
			var obj = {};
			obj.method = 'office';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;			
			return getData(obj);
		};  

		this.city_acc_state = function (postData) {
			var obj = {};
			obj.method = 'state/city';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;			
			return getData(obj);
		};

		this.fetchoffice = function () {
			var obj = {};
			obj.method = 'office/fetchoffice';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};  
		this.deleteoffice = function (postData) {
			var obj = {};
			obj.method = 'office/deleteofc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};  

		this.editofc = function (postData) {
			var obj = {};
			obj.method = 'office/editofc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.updateofficeinfo = function (postData) {
			var obj = {};
			obj.method = 'office/updateofficeinfo';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 

		this.fetchstate = function () {
			var obj = {};
			obj.method = 'state';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		//Assignment Report
		this.genrateassignreport = function (postData) {
			var obj = {};
			obj.method = 'internal-users-assreport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 

		//Exempted Users
		this.fetch_internal_users = function () {
			var obj = {};
			obj.method = 'exempteduser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};	
		this.save_exempted_user = function (postData) {
			var obj = {};
			obj.method = 'exempteduser/saveexempteduser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.fetch_exempted_users = function () {
			var obj = {};
			obj.method = 'exempteduser/fetchexempted';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.remove_exempted_user = function (postData) {
			var obj = {};
			obj.method = 'exempteduser/removeuser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.fetchfinanceuser = function () {
			var obj = {};
			obj.method = 'internal-users/internal/fetchfinanceuser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		//END

		this.updateNAV = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=PCNFM';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.brokerUploadDocument = function (postData) {
			var obj = {};			
			obj.method = 'getBrokerDetails/uploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};		

		///****************** Create User From Admin ****************************/
		this.createUserDetails = function (postData) {
			var obj = {};
			obj.method = 'signin';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		// this.getOccupation = function() {
		// 	var obj = {};
		// 	obj.method = 'nseApiData/Occupation';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getOccupation = function() {
			var obj = {};
			obj.method = 'customer/getOccupation';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getNseRelationship = function() {
			var obj = {};
			obj.method = 'customer/getNseRelationship';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		// this.getApplicableIncome = function() {
		// 	var obj = {};
		// 	obj.method = 'nseApiData/ApplicableIncome';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getApplicableincome = function() {
			var obj = {};
			obj.method = 'customer/getapplicableincome';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		// this.getSourceWealth = function() {
		// 	var obj = {};
		// 	obj.method = 'nseApiData/SourceWealth';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getSourceWealth = function() {
			var obj = {};
			obj.method = 'customer/getSourceWealth';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getStateCityDetailsPincode = function(postData,id) {
			var obj = {};
			obj.method = 'nseApiData/Pincode?pinCode='+ postData+'/'+id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getStateCityDetailsPinCodeNew = function(postData) {
			var obj = {};
			obj.method = 'customer/getStateCityOnPin?pinCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getState = function() {
			var obj = {};
			obj.method = 'nseApiData/State';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getCity = function(postData) {
			var obj = {};
			obj.method = 'nseApiData/City?StateCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getAccountType = function() {
			var obj = {};
			obj.method = 'nseApiData/AccountType';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		// this.getBankDetailsFrmIFSC = function(postData) {
		// 	var obj = {};
		// 	obj.method = 'ifsc?code='+ postData;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getBankDetailsFrmIFSC = function(postData) {
			var obj = {};
			obj.method = 'customer/getifscdetails?ifscCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getNewBankAccType = function(postData) {
			var obj = {};
			obj.method = 'customer/accounttypelist?taxStatusCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.nseSignupFormDataSave = function (postData) {
			var obj = {};
			obj.method = 'user/rawData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.verifyCustomers = function(postData) {
			var obj = {};
			obj.method = 'customer/verifyCustomer';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createCustomers = function(postData) {
			var obj = {};
			obj.method = 'customer/createCustomer';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.registerUserWithNse = function(postData) {
			var obj = {};
			obj.method = 'nseApiData/CREATECUSTOMER';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateUserProfile = function(postData) {
			var obj = {};
			obj.method = 'user/profile';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUserProfileUser = function(postData) {
			var obj = {};
			obj.method = 'user/profile?userId=' + postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		///*******************************end****************************/

		this.getAllProspectCommunication = function () {
			var obj = {};
			obj.method = 'investors/prospects/x';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.rejectedTransactionNse = function(postData) {	
			var obj = {};	
			postData  = postData.service_request	
			obj.method = 'nse_rejected_transactions/' + postData.iin;	
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;	
			obj.params = null;	
			obj.postData = postData;	
			obj.requestForErrorHandling = false;	
			return getData(obj);	
		};

		this.getAllCategory = function() {
			var obj = {};
			obj.method = 'algo-ranking/allcategory';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCategoryDetails = function(postData) {
			var obj = {};
			obj.method = 'algo-ranking/listDetails';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getRanking = function(postData) {
			var obj = {};
			obj.method = 'algo-ranking/getRanking';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadDocumentToNSE = function (postData, UserId, doctype) {
			var obj = {};
			obj.method = 'documents/uploadtonse';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.emailToNSE = function (postData) {
			var obj = {};
			obj.method = 'documents/emailtonse';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllSMSTemplates = function () {
			var obj = {};
			obj.method = '/email-sms/sms/gelalltemplate';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSMSTemplatesDetails = function (postData) {
			var obj = {};
			obj.method = 'email-sms/sms/getbytemplatename?templatename='+postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};	
		this.sendTransactionReport = function (postData) {
			var obj = {};
			obj.method = 'investors/invtransmail';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCallingCodes = function() {
			var obj = {};
			obj.method = 'callingcode/getCallingCode';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCallingCode = function(postData) {
			var obj = {};
			obj.method = 'callingcode/getSingleCallingCode?CountryCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.setCallingCode = function(postData) {
			var obj = {};
			obj.method = 'callingcode/addCallingCode';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.editCountry = function(postData) {
			var obj = {};
			obj.method = 'callingcode/editCallingCode';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getBankAccount = function(postData) {
			var obj = {};
			obj.method = 'user/custbanklist?iin='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getNomineeRelationship = function() {
			var obj = {};
			obj.method = 'customer/getNomineeRelationship';
			obj.serviceMethod =  angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}
	
		this.getGuardianRelation = function() {
			var obj = {};
			obj.method = 'customer/getMinorGuardianRelationship';
			obj.serviceMethod =  angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.achMandateDetails = function(postData) {
			var obj = {};
			obj.method = 'user/achmandatedetails?iin='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.achmandatereport = function(postData) { 
			var obj = {};
			obj.method = 'user/achmandatereport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.sendamcforekyc = function(postData) { 
			var obj = {};
			obj.method = 'amcforekyc/ekyc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}
	   
		this.getamcforekyc = function() {
			var obj = {};
			obj.method = 'amcforekyc/details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.getlivePortfolioReportDetailsById = function (id) {
			var obj = {};
			obj.method = 'reports/live-portfolio-report-details/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.getlivePortfolioReportSummaryById = function (id) {
			var obj = {};
			obj.method = 'reports/live-portfolio-report-summary/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.purchaseTransaction = function(postData) { 
			var obj = {};
			obj.method = 'customer/purchaselink';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.getfoliodata = function(postData) { 
			var obj = {};
			obj.method = 'customer/getfoliodata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.getholdingdatabyiin = function(postData) {
			var obj = {};
			obj.method = 'customer/getholdingdata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.redemptionTransaction = function(postData) { 
			var obj = {};
			obj.method = 'customer/redemptionlink';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}
		
		this.switchTransaction = function(postData) { 
			var obj = {};
			obj.method = 'customer/switchlink';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.internalUserExemptList = function() {
			var obj = {};
			obj.method = 'customer/internalUserExemptList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.getCallHistory = function (id) {
			var obj = {};
			obj.method = 'customer/getcallhistory?mobileNo=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.systematicRegistration = function(postData) { 
			var obj = {};
			obj.method = 'customer/systematicRegistrationlink';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.getLivePfReportByDate = function (id, postData) {
			var obj = {};
			obj.method = 'reports/live-portfolio-report-details/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.gettranxdetailsreport = function (postData) {
			var obj = {};
			obj.method = 'user/gettranxdetailsreport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.proofofacctlist = function () {
			var obj = {};
			obj.method = 'customer/proofofacctlist';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.addbankdetail = function (postData) {
			var obj = {};
			obj.method = 'customer/addbankdetail';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendRelationshipStatusRetrigger = function (postData) {
			var obj = {};
			obj.method = 'customer/relationshipStatusRetrigger';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.fatcaretriggermail = function (postData) {
			var obj = {};
			obj.method = 'amcforekyc/fatcaretriggermail';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendfatcaKycUboReglink = function (postData) {
			var obj = {};
			obj.method = 'customer/fatcaKycUboReg';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendPauseSipEntry = function (postData) {
			var obj = {};
			obj.method = 'customer/pauseSipEntry';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.ceasemasterdata = function () {
			var obj = {};
			obj.method = 'customer/ceasemasterdata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendCaseSipEntry = function (postData) {
			var obj = {};
			obj.method = 'customer/ceaseSipEntry';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.editCustomer = function (postData) {
			var obj = {};
			obj.method = 'customer/editCustomer';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getexternalfoliodata = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getexternalfoliodata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getrmsiweexternalfoliodata = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getrmsiweexternalfoliodata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getrmcallinghistory = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getrmcallinghistory';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getrmlist = function () {
			var obj = {};
			obj.method = 'mfcentral/getrmlist';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getmfcetralusageonpan = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getmfcetralusageonpan';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.kycStatusUpdate = function (postData) {
			var obj = {};
			obj.method = 'customer/kycstatusupdate';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.userInfoListOnMobile = function (postData) {
			var obj = {};
			obj.method = 'customer/userinfolistonmobile';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.userNotInterestedUpdate = function (postData) {
			var obj = {};
			obj.method = 'customer/usernotinterestedupdate';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.rmReasign = function (postData) {
			var obj = {};
			obj.method = 'customer/rmreasign';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setPasswordasPan = function (postData) {
			var obj = {};
			obj.method = 'password/setpasswordaspan';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.forgotPassword = function (postData) {
			var obj = {};
			obj.method = 'password/forgotPassword';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateHolding = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/UpdateExternalFlag';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIINonPan = function (pan) {
			var obj = {};
			obj.method = 'customer/getIINonPAN?pan=' + pan;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIinMapping = function (iin) {
			var obj = {};
			obj.method = 'customer/setIINmapping?iin=' + iin;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.brokerUploadDetails = function (id, postData) {
			var obj = {};
			obj.method = 'getBrokerDetails/updatebrokerinfo/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadCustomer= function (postData) {
			var obj = {};
			obj.method = 'customer/uploadcustomer';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

	}
})();
(function () {
	'use strict';

	angular.module('app.common').service('ServiceProxy', ServiceProxy);

	/** @ngInject */
	function ServiceProxy(Service, $q, $http) {
		var getData = function (obj) {
			var deferred = $q.defer();
			Service.makeServiceCall(
				'api',
				obj.method,
				obj.serviceMethod,
				obj.params,
				obj.postData,
				obj.requestForErrorHandling
			).then(
				function (response) {
					deferred.resolve(response);
				},
				function (response) {
					deferred.reject(response);
				}
			);
			return deferred.promise;
		};
		this.authenticate = function (postData) {
			var obj = {};
			obj.method = 'token';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllAmc = function () {
			var obj = {};
			obj.method = 'apiData/Amc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllScheme = function (postData) {
			var obj = {};
			obj.method = 'apiData/Product?AMCCODE=' + postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadCamsTrxn = function (postData) {
			var obj = {};
			obj.method = 'camsUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadKarvyTrxn = function (postData) {
			var obj = {};
			obj.method = 'karvyData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadFranklinTrxn = function (postData) {
			var obj = {};
			obj.method = 'franklinData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getHoldingData = function (postData) {
			var obj = {};
			obj.method = 'retrieveData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		// this.deletePickup = function(postData) {
		// 	var obj = {};
		// 	obj.method = 'feedback?email=' + postData;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		// this.getAllPickupDetail = function() {
		// 	var obj = {};
		// 	obj.method = 'feedback';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getAllBlogs = function () {
			var obj = {};
			obj.method = 'blogs';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createBlog = function (postData) {
			var obj = {};
			obj.method = 'blogs';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateBlog = function (postData) {
			var obj = {};
			obj.method = 'blogs';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteBlog = function (postData) {
			var obj = {};
			obj.method = 'blogs?blogId=' + postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadBlogImage = function (postData, blogId) {
			var obj = {};
			obj.method = 'blogs/upload?blogId=' + blogId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllRecommendation = function () {
			var obj = {};
			obj.method = 'recommendedSchemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createRecommendation = function (postData) {
			var obj = {};
			obj.method = 'recommendedSchemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteRecommendation = function (postData, isin) {
			var obj = {};
			obj.method = 'recommendedSchemes?productISIN=' + isin;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateRecommendation = function (postData) {
			var obj = {};
			obj.method = 'recommendedSchemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadSundaramTransaction = function (postData) {
			var obj = {};
			obj.method = 'sundaramTrnx';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getExternalHolding = function (postData) {
			var obj = {};
			obj.method = 'retrieveData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadDocumentImage = function (postData, UserId, doctype) {
			var obj = {};
			obj.method = 'documents/uploads?userId=' + UserId + '&docType=' + doctype;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createInsurance = function (postData) {
			var obj = {};
			obj.method = 'insurance';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getInsuranceByUserId = function (userId) {
			var obj = {};
			obj.method = 'insurance?userId=' + userId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateInsurance = function (postData) {
			var obj = {};
			obj.method = 'insurance';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.deleteInsurance = function (insuranceId) {
			var obj = {};
			obj.method = 'insurance?insuranceId=' + insuranceId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getUserLoans = function (userId) {
			var obj = {};
			obj.method = 'loan?userId=' + userId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createRecommendedPortfolio = function (postData) {
			var obj = {};
			obj.method = 'recommendedPortfolio';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateRecommendedPortfolio = function (postData) {
			var obj = {};
			obj.method = 'recommendedPortfolio/' + postData._id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllRecommendedPortfolio = function () {
			var obj = {};
			obj.method = 'recommendedPortfolio';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteRecommendedPortfolio = function (id) {
			var obj = {};
			obj.method = 'recommendedPortfolio/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createPran = function (postData, id) {
			var obj = {};
			obj.method = 'nps/pran/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getPran = function (id) {
			var obj = {};
			obj.method = 'nps/pran/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deletePran = function (id) {
			var obj = {};
			obj.method = 'nps/pran/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.deleteRecommendedPortfolioScheme = function (id, schemeId) {
			var obj = {};
			obj.method = 'recommendedPortfolio/' + id + '?schemeId=' + schemeId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createCommunicationSMS = function (postData, serviceType, attachment, number) {
			var obj = {};
			obj.method = 'email-sms?service=' + serviceType + '&&attachments=' + attachment + '&&filter=' + number;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createCommunicationEmail = function (postData, serviceType, attachment, number) {
			var obj = {};
			obj.method = 'email-sms?service=' + serviceType + '&&attachments=' + attachment + '&&filter=' + number;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadDocumentAttachment = function (postData) {
			var obj = {};
			obj.method = 'mail-attachments';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.mapDocumentImage = function (postData, id) {
			var obj = {};
			obj.method = 'insurance/mapInsuranceDocument?userId=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getUserProfile = function (id) {
			var obj = {};
			obj.method = 'investors/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSipDetail = function (pan) {
			var obj = {};
			obj.method = 'sip?pan=' + pan + '&&type=START';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCeaseDetail = function (pan) {
			var obj = {};
			obj.method = 'sip?pan=' + pan + '&&type=CEASED';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCeaseInfo = function () {
			var obj = {};
			obj.method = 'sip/ceased';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllInternalUser = function () {
			var obj = {};
			obj.method = 'internal-users';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.activatedInternalUser = function (id, data) {
			var obj = {};
			obj.method = 'internal-users/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getTypeInternalUser = function () {
			var obj = {};
			obj.method = 'internal-users/access-control/types';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAssignFeature = function () {
			var obj = {};
			obj.method = 'features';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createInternalUser = function (postData) {
			var obj = {};
			obj.method = 'internal-users';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateInternalUser = function (postData, id) {
			var obj = {};
			obj.method = 'internal-users/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getInternalUserById = function (id) {
			var obj = {};
			obj.method = 'internal-users/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCustmoerBySearch = function (filter, page, limit) {
			var obj = {};
			obj.method = 'investors?filter=' + filter + '&&page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getMappingCustomerDetails = function (number) {
			var obj = {};
			obj.method = 'investors/assign-to-internaluser?filter=' + number;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createAssignedCustomer = function (postData) {
			var obj = {};
			obj.method = 'investors/assign-to-internaluser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateDeassignedCustomer = function (id) {
			var obj = {};
			obj.method = 'investors/assign-to-internaluser/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getInternalUserDetalsById = function (id) {
			var obj = {};
			obj.method = 'investors/all/' + id + '?page=1&limit=100000';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.resetPassword = function (data) {
			var obj = {};
			obj.method = 'internal-users-password/change-password';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.forgotPassword = function (data) {
			var obj = {};
			obj.method = 'internal-users-password/otp';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.resetNewPassword = function (data) {
			var obj = {};
			obj.method = 'internal-users-password/create-password';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getUserProfileInfo = function () {
			var obj = {};
			obj.method = 'internal-users/profile/info';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createNotificationEmail = function (postData, filter) {
			var obj = {};
			obj.method = 'notifications?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadImageNotification = function (postData) {
			var obj = {};
			obj.method = 'notifications/upload/image';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateFlags = function (data, id) {
			var obj = {};
			obj.method = 'investors/monitoring/flags/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getServiceConfiguration = function () {
			var obj = {};
			obj.method = 'configurations';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getServiceConfigurationById = function (id) {
			var obj = {};
			obj.method = 'configurations/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.updateServiceConfiguration = function (postData, id) {
			var obj = {};
			obj.method = 'configurations/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSyncingNseUser = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=IAUFN';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllAssignedUser = function (id) {
			var obj = {};
			obj.method = 'investors/all/' + id + '?page=1&limit=100000';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllCustomerWithDeviceId = function () {
			var obj = {};
			obj.method = 'investors/all/inceptionnotification';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllinvestorslist = function (filter, page, limit) {
			var obj = {};
			obj.method = 'investors/allinvestorslist/notificationnew?filter=' + filter + '&&page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllCustomerCommunication = function () {
			var obj = {};
			obj.method = 'investors/all/inception';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCallingHistory = function (id) {
			var obj = {};
			obj.method = 'investors/monitoring/history/' + id + '?filter=REVIEW_PENDING';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getActivityCustomer = function (id) {
			var obj = {};
			obj.method = 'investors/monitoring/history/' + id + '?activityType=CUSTOM';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.downloadCSVFile = function () {
			var obj = {};
			obj.method = 'investors-internal-user-csv';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadCSVFile = function (postData) {
			var obj = {};
			obj.method = 'investors-internal-user-csv';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.postTransactionDetails = function (postData) {
			var obj = {};
			// obj.method = 'apiData/TRXNREVERSEFEED';
			obj.method = 'nserevamp/orderlifecycle';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getTodayEmployeePerformance = function () {
			var obj = {};
			obj.method = 'dashboard/employees_performance?filter=TOD';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getRangeEmployeePerformance = function (data) {
			var obj = {};
			obj.method = 'dashboard/employees_performance?filter=RNG&from=' + data.fromDate + '&to=' + data.toDate;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getByIdEmployeePerformanceToday = function (id) {
			var obj = {};
			obj.method = 'dashboard/employees_performance/closed_flags_details?filter=TOD&&internalUserId=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getByIdEmployeePerformanceRange = function (id, fromDate, toDate) {
			var obj = {};
			obj.method =
				'dashboard/employees_performance/closed_flags_details?filter=RNG&from=' +
				fromDate +
				'&to=' +
				toDate +
				'&&internalUserId=' +
				id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getDashboardDetails = function (filter) {
			var obj = {};
			obj.method = 'dashboard/details?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		// this.getDashboardInvestmentsDetails = function(filter) {
		// 	var obj = {};
		// 	obj.method = 'dashboard/details_investments?filter=' + filter;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getDashboardWithoutFilter = function () {
			var obj = {};
			obj.method = 'dashboard/details_investments';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getConsumerAcquisationData = function (filter) {
			var obj = {};
			obj.method = 'dashboard/reports_consumer_acquisation?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getIINActivateData = function (filter) {
			var obj = {};
			obj.method = 'dashboard/reports_graph_iin_activate?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getInvestmentData = function (filter) {
			var obj = {};
			obj.method = 'dashboard/reports_graph_investment?filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getInvestmentProductData = function () {
			var obj = {};
			obj.method = 'dashboard/reports_products_investments';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralConfig = function () {
			var obj = {};
			obj.method = 'referral-config';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setReferralConfig = function (data) {
			var obj = {};
			obj.method = 'referral-config';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralConsilidatedData = function () {
			var obj = {};
			obj.method = 'user-transactions/consolidate-details/status-wise';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getConsolidatedReferralStatus = function () {
			var obj = {};
			obj.method = 'user-transactions/consolidate-details/activity-wise';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralTransactionByStatus = function (status) {
			var obj = {};
			obj.method = 'user-transactions?status=' + status;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.creditgReferralAmount = function (data) {
			var obj = {};
			obj.method = 'user-transactions';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.internalUserImageUpload = function (data, id) {
			var obj = {};
			obj.method = 'internal-users/image/upload?userId=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.customerListForSales = function () {
			var obj = {};
			obj.method = 'sales-users/list';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllReferralDetails = function () {
			var obj = {};
			obj.method = 'user-transactions/referral-details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.documentVerificationStatus = function (data) {
			var obj = {};
			obj.method = 'documents/verify';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAndroidAppInstalledUser = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/device';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getNewLeadUser = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/lead';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/rm';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.notInterestedCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/notInterested';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getOldUnAssignedCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/old';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUserCount = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/count';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.saveSchedular = function (data) {
			var obj = {};
			obj.method = 'notificationscheduler';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getallSchedular = function () {
			var obj = {};
			obj.method = 'notificationscheduler';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.assignToInternalUser = function (data) {
			var obj = {};
			obj.method = 'assignment-dashboard/users';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setNotInterested = function (id, data) {
			var obj = {};
			obj.method = 'flags/interested/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUnVerifiedCustomer = function () {
			var obj = {};
			obj.method = 'assignment-dashboard/document';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSchedularByID = function (id) {
			var obj = {};
			obj.method = 'notificationscheduler/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateSchedular = function (id, data) {
			var obj = {};
			obj.method = 'notificationscheduler/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.deleteSchedular = function (id) {
			var obj = {};
			obj.method = 'notificationscheduler/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadAttachments = function (id, type, data) {
			var obj = {};
			obj.method = 'notificationscheduler/upload/attachment?nsid=' + id + '&&type=' + type;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUserCountForSales = function () {
			var obj = {};
			obj.method = 'sales-users/count';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.createCall = function (id, data) {
			var obj = {};
			obj.method = 'sales-users/call/schedules/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCustomerListForToday = function () {
			var obj = {};
			obj.method = 'sales-users/today_call';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReassignedCustomer = function () {
			var obj = {};
			obj.method = 'sales-users/re_assigned';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateCallSchedule = function (id, data) {
			var obj = {};
			obj.method = 'sales-users/call/schedules/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCalenderData = function () {
			var obj = {};
			obj.method = 'sales-users/calendar';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.deleteSchedularAttachments = function (nsid, data) {
			var obj = {};
			obj.method = 'notificationscheduler/upload/attachment?nsid=' + nsid;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getReferralTransactionHistory = function (uid) {
			var obj = {};
			obj.method = 'user-transactions/reference-transactions/' + uid;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryAssignedCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/newly_assigned';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryInvestingCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/investing';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryNonInvestingCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/not_investing';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryReviewTodayCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/review_today';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryFollowUpCustomer = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/followup_today';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryDashboardCount = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/count';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setReviewDate = function (id, data) {
			var obj = {};
			obj.method = 'investors/monitoring/flags/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setPotentialScale = function (id, data) {
			var obj = {};
			obj.method = 'advisory-dashboard/potential/scale/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.resetPriorityFlag = function (id, data) {
			var obj = {};
			obj.method = 'flags/priority/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAdvisoryCalendarData = function () {
			var obj = {};
			obj.method = 'advisory-dashboard/calendar';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryReviewCallData = function (date) {
			var obj = {};
			obj.method = 'advisory-dashboard/calendar_review?date=' + date;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAdvisoryFollowupCallData = function (date) {
			var obj = {};
			obj.method = 'advisory-dashboard/calendar_followup?date=' + date;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.closeEnquiryFlag = function (id, data) {
			var obj = {};
			obj.method = 'request-static/enquiry/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.reviewCallHistory = function (id) {
			var obj = {};
			obj.method = 'advisory-dashboard/old/reviewcall/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadImageAmcProducts = function (data, AMC_CODE) {
			var obj = {};
			obj.method = 'product/upload/image?AMCCODE=' + AMC_CODE;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateAmcProduct = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllSchemeProductList = function (amcCode, filter) {
			var obj = {};
			obj.method = 'product/list/data?amcCode=' + amcCode + '&&filter=' + filter;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.serchUser = function (serachStrng) {
			var obj = {};
			obj.method = 'investors?search=' + serachStrng;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCamsTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'camsUploads?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getKarvyTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'karvyData?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getFranklinTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'franklinData?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSundramTrxn = function (page, limit) {
			var obj = {};
			obj.method = 'sundaramTrnx?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.transactionListWithSearch = function (url, page, limit) {
			var obj = {};
			obj.method = url + '?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.deleteTransaction = function (url, id) {
			var obj = {};
			obj.method = url + '/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateTransaction = function (url, id, data) {
			var obj = {};
			obj.method = url + '/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.searchTransaction = function (url, serachStrng) {
			var obj = {};
			obj.method = url + '?search=' + serachStrng;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateSchems = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getProductCategory = function (type) {
			var obj = {};
			obj.method = 'product/category/list?type=' + type;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllAmcProducts = function () {
			var obj = {};
			obj.method = 'product/amc/list';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.startSyncingOfSncing = function (amcCode) {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=PSAFN&&amcCode=' + amcCode;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.syncSchemeFromNSE = function (amcCode, newAmcCode) {
			var obj = {};
			obj.method = 'product/sync/schemes';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = { amcCode: amcCode, newAmcCode: newAmcCode || '' };
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.closeNFO = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getNOIsinSchems = function (type) {
			var obj = {};
			obj.method = 'product/activescheme/list?type=' + type;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.markAddedMorning = function (id, data) {
			var obj = {};
			obj.method = 'product/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.minorTrasaction = function () {
			var obj = {};
			obj.method = 'minorTransactions';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateTrxnPan = function (id, data) {
			var obj = {};
			obj.method = 'camsUploads/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = data;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReports = function () {
			var obj = {};
			obj.method = 'aum_reports/investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsCustomerWise = function () {
			var obj = {};
			obj.method = 'aum_reports/investors_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsSchemeWise = function () {
			var obj = {};
			obj.method = 'aum_reports/scheme_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumReports = function () {
			var obj = {};
			obj.method = 'aum_reports/aum_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportSipBook = function () {
			var obj = {};
			obj.method = 'sip_book/investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsCustomerWiseSipBook = function () {
			var obj = {};
			obj.method = 'sip_book/investors_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAumInvestmentReportsSchemeWiseSipBook = function () {
			var obj = {};
			obj.method = 'sip_book/scheme_investments_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSipBookReport = function () {
			var obj = {};
			obj.method = 'sip_book/sipbook_details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		//vikrant
		this.updateCustomer = function (postData) {
			var obj = {};
			obj.method = 'investors/save-invester-staticdata/'+postData._id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		// this.getBankDetailsFrmIFSC = function(postData) {
		// 	var obj = {};
		// 	obj.method = 'ifsc?code=' + postData;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };

		this.getBankType = function() {
			var obj = {};
			obj.method = 'apiData/Bank';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIFSClist = function(){
			var obj = {};
			obj.method = 'Ifsc/getIfscList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.postTrnLogs = function(postData){
			var obj = {};
			obj.method = 'investors/save-paytrn-log';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.postNavData = function(postData){
			var obj = {};
			obj.method = 'investors/nav-list';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.postNavCalData = function(postData){
			var obj = {};
			obj.method = 'investors/ratingSummary';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}

		this.syncInvestorIIN = function (postData) {
			var obj = {};
			obj.method = 'investors/sync-invester-iin/'+postData._id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getInvestorsReportsSchemeWise = function (postData) {
			var obj = {};
			obj.method = 'aum_reports/schemewise_investments_details/'+postData.productISIN;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getBanklist = function(){
			var obj = {};
			obj.method = 'Ifsc/getBankList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getBranchlist = function(postData){
			var obj = {};
			obj.method = 'Ifsc/getBranchDetials?bankName='+postData.bankName;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateBankDetails = function (postData) {
			var obj = {};
			obj.method = 'Ifsc/updateIfsc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.validateKarvyTransaction = function (postData) {
			var obj = {};
			obj.method = 'karvyData/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.validateFranklinList = function (postData) {
			var obj = {};
			obj.method = 'franklinData/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.validateCamsList = function (postData) {
			var obj = {};
			obj.method = 'camsUploads/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSyncAchMandateFollowUpMail = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=AMDRFR';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getProductDisplaySubCategory = function (postData) {
			var obj = {};
			obj.method = 'recommendedSchemes/displaySubCategory';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
			
		};
		this.communicationSmsEmail = function (postData,serviceType) {
			var obj = {};
			//obj.method = "linkUser?service='" + serviceType+ "'";
			//'email-sms?service=' + serviceType + '&&attachments=' + attachment + '&&filter=' + number;
			obj.method = 'linkUser?service=' + serviceType;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		// this.getSIPTrxn = function (page, limit) {
		// 	var obj = {};
		// 	obj.method = 'otherUploads?page=' + page + '&&limit=' + limit;;//'camsUploads?page=' + page + '&&limit=' + limit;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		
		this.uploadSIPTrxn = function (postData) {
			var obj = {};
			obj.method = 'sipUploads';//'camsUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.validateSIPTrxn = function (postData) {
			var obj = {};
			obj.method = 'sipUploads/validateTransaction';//'camsUploads/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSIPTrxn = function () {
			var obj = {};
			obj.method = 'sipUploads';//'camsUploads?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadIINSyncTrxn = function (postData) {
			var obj = {};
			obj.method = 'iinUploads';//'camsUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIInSync = function () {
			var obj = {};
			obj.method = 'iinUploads';//'camsUploads?page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadAchTrxn = function (postData) {
			var obj = {};
			obj.method = 'achUploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAchTrxn = function () {
			var obj = {};
			obj.method = 'achUploads';//'camsUploads/validateTransaction';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllSchemeReport = function () {
			var obj = {};
			obj.method = 'scheme-report/getSchemeList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSchemeActiveReport = function () {
			var obj = {};
			obj.method = 'scheme-report/getSchemesActive';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSchemeInActiveReport = function () {
			var obj = {};
			obj.method = 'scheme-report/getSchemesInActive';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.CreatecustomerEngagementGoalChart = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.Goalchart = function () {
			var obj = {};
			obj.method = 'customerEngagementGoalChart';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.UpdateCustomerEngagementGoalChart = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalChartCategory = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart/'+ postData.Goal + '&&categoryId='+postData.CategoryId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalChart = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalChart/'+ postData.Goal + '&&GoalId='+postData.GoalId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.CreatecustomerEngagementGoalFund = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.GoalFundList = function () {
			var obj = {};
			obj.method = 'customerEngagementGoalFund';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalFundScheme = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund/'+ postData.category + '&&schemeId='+postData.schemeId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.DeleteGoalFund = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund/'+ postData.Category + '&&CategoryId='+postData.CategoryId;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.DELETE;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.UpdateGoalFund = function (postData) {
			var obj = {};
			obj.method = 'customerEngagementGoalFund';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSubBrokerAssignedCustomer = function (postData) {
			var obj = {};
			obj.method = 'subBroker/assigned-investors/';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};		
		
		this.getActivationStatus = function (id) {
			var obj = {};
			obj.method = 'investors/activationstatus/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCustomerAchMandateList = function (iin) {
			var obj = {};
			obj.method = 'achMandate/' + iin;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.registerCustomerAchMandate = function (postData) {
			var obj = {};
			// obj.method = 'achMandate/registerCustMandate';
			obj.method = 'nserevamp/mandatereg';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.sendIINActivationLink = function(postData) {
			var obj = {};
			obj.method = 'investors/send-iin-activation-link';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}
		this.downlaodCustDetails = function (filter, page, limit) {
			var obj = {};
			obj.method = 'investors/download-details?filter=' + filter + '&&page=' + page + '&&limit=' + limit;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSyncAUMReport = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=AUMGEN';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSyncSIPReport = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=SIPGEN';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.startAutoLeadAssignment = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=ALASTA';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.stopAutoLeadAssignment = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=ALASTP';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAutoLeadAssignmentStatus = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=ALASTU';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSubBrokersData = function(){
			var obj = {};
			obj.method = 'getBrokerDetails';//get all subbrokers
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj)
		}

		this.getBrokerProfile = function(id){
			var obj = {};
			obj.method = 'getBrokerDetails/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}
		//Office
		this.submitofficeinfo = function (postData) {
			var obj = {};
			obj.method = 'office';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;			
			return getData(obj);
		};  

		this.city_acc_state = function (postData) {
			var obj = {};
			obj.method = 'state/city';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;			
			return getData(obj);
		};

		this.fetchoffice = function () {
			var obj = {};
			obj.method = 'office/fetchoffice';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};  
		this.deleteoffice = function (postData) {
			var obj = {};
			obj.method = 'office/deleteofc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};  

		this.editofc = function (postData) {
			var obj = {};
			obj.method = 'office/editofc';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.updateofficeinfo = function (postData) {
			var obj = {};
			obj.method = 'office/updateofficeinfo';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 

		this.fetchstate = function () {
			var obj = {};
			obj.method = 'state';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		//Assignment Report
		this.genrateassignreport = function (postData) {
			var obj = {};
			obj.method = 'internal-users-assreport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 

		//Exempted Users
		this.fetch_internal_users = function () {
			var obj = {};
			obj.method = 'exempteduser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};	
		this.save_exempted_user = function (postData) {
			var obj = {};
			obj.method = 'exempteduser/saveexempteduser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.fetch_exempted_users = function () {
			var obj = {};
			obj.method = 'exempteduser/fetchexempted';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.remove_exempted_user = function (postData) {
			var obj = {};
			obj.method = 'exempteduser/removeuser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.fetchfinanceuser = function () {
			var obj = {};
			obj.method = 'internal-users/internal/fetchfinanceuser';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		//END

		this.updateNAV = function () {
			var obj = {};
			obj.method = 'automations?accessCode=c2lwOnNpcEAxMjEy&type=PCNFM';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.brokerUploadDocument = function (postData) {
			var obj = {};			
			obj.method = 'getBrokerDetails/uploads';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};		

		///****************** Create User From Admin ****************************/
		this.createUserDetails = function (postData) {
			var obj = {};
			obj.method = 'signin';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		// this.getOccupation = function() {
		// 	var obj = {};
		// 	obj.method = 'nseApiData/Occupation';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getOccupation = function() {
			var obj = {};
			obj.method = 'customer/getOccupation';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getNseRelationship = function() {
			var obj = {};
			obj.method = 'customer/getNseRelationship';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		// this.getApplicableIncome = function() {
		// 	var obj = {};
		// 	obj.method = 'nseApiData/ApplicableIncome';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getApplicableincome = function() {
			var obj = {};
			obj.method = 'customer/getapplicableincome';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		// this.getSourceWealth = function() {
		// 	var obj = {};
		// 	obj.method = 'nseApiData/SourceWealth';
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getSourceWealth = function() {
			var obj = {};
			obj.method = 'customer/getSourceWealth';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getStateCityDetailsPincode = function(postData,id) {
			var obj = {};
			obj.method = 'nseApiData/Pincode?pinCode='+ postData+'/'+id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getStateCityDetailsPinCodeNew = function(postData) {
			var obj = {};
			obj.method = 'customer/getStateCityOnPin?pinCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getState = function() {
			var obj = {};
			obj.method = 'nseApiData/State';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getCity = function(postData) {
			var obj = {};
			obj.method = 'nseApiData/City?StateCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		this.getAccountType = function() {
			var obj = {};
			obj.method = 'nseApiData/AccountType';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		}; 
		// this.getBankDetailsFrmIFSC = function(postData) {
		// 	var obj = {};
		// 	obj.method = 'ifsc?code='+ postData;
		// 	obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
		// 	obj.params = null;
		// 	obj.postData = null;
		// 	obj.requestForErrorHandling = false;
		// 	return getData(obj);
		// };
		this.getBankDetailsFrmIFSC = function(postData) {
			var obj = {};
			obj.method = 'customer/getifscdetails?ifscCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getNewBankAccType = function(postData) {
			var obj = {};
			obj.method = 'customer/accounttypelist?taxStatusCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.nseSignupFormDataSave = function (postData) {
			var obj = {};
			obj.method = 'user/rawData';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.verifyCustomers = function(postData) {
			var obj = {};
			obj.method = 'customer/verifyCustomer';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.createCustomers = function(postData) {
			var obj = {};
			//obj.method = 'customer/createCustomer';
			obj.method = 'nserevamp/createuccadmin';
			//obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.registerUserWithNse = function(postData) {
			var obj = {};
			obj.method = 'nseApiData/CREATECUSTOMER';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateUserProfile = function(postData) {
			var obj = {};
			obj.method = 'user/profile';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.PUT;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getUserProfileUser = function(postData) {
			var obj = {};
			obj.method = 'user/profile?userId=' + postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		///*******************************end****************************/

		this.getAllProspectCommunication = function () {
			var obj = {};
			obj.method = 'investors/prospects/x';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.rejectedTransactionNse = function(postData) {	
			var obj = {};	
			//postData  = postData.service_request	
			//obj.method = 'nse_rejected_transactions/' + postData.iin;
			obj.method = 'nserevamp/orderstatus';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;	
			obj.params = null;	
			obj.postData = postData;	
			obj.requestForErrorHandling = false;	
			return getData(obj);	
		};

		this.getAllCategory = function() {
			var obj = {};
			obj.method = 'algo-ranking/allcategory';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCategoryDetails = function(postData) {
			var obj = {};
			obj.method = 'algo-ranking/listDetails';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getRanking = function(postData) {
			var obj = {};
			obj.method = 'algo-ranking/getRanking';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.uploadDocumentToNSE = function (postData, UserId, doctype) {
			var obj = {};
			obj.method = 'documents/uploadtonse';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.emailToNSE = function (postData) {
			var obj = {};
			obj.method = 'documents/emailtonse';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getAllSMSTemplates = function () {
			var obj = {};
			obj.method = '/email-sms/sms/gelalltemplate';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getSMSTemplatesDetails = function (postData) {
			var obj = {};
			obj.method = 'email-sms/sms/getbytemplatename?templatename='+postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};	
		this.sendTransactionReport = function (postData) {
			var obj = {};
			obj.method = 'investors/invtransmail';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCallingCodes = function() {
			var obj = {};
			obj.method = 'callingcode/getCallingCode';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getCallingCode = function(postData) {
			var obj = {};
			obj.method = 'callingcode/getSingleCallingCode?CountryCode='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.setCallingCode = function(postData) {
			var obj = {};
			obj.method = 'callingcode/addCallingCode';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.editCountry = function(postData) {
			var obj = {};
			obj.method = 'callingcode/editCallingCode';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getBankAccount = function(postData) {
			var obj = {};
			//obj.method = 'user/custbanklist?iin='+ postData;
			obj.method = 'nserevamp/banklist?iin='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		this.getNomineeRelationship = function() {
			var obj = {};
			obj.method = 'customer/getNomineeRelationship';
			obj.serviceMethod =  angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
	
		this.getGuardianRelation = function() {
			var obj = {};
			obj.method = 'customer/getMinorGuardianRelationship';
			obj.serviceMethod =  angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.achMandateDetails = function(postData) {
			var obj = {};
			// obj.method = 'user/achmandatedetails?iin='+ postData;
			// obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.method = 'nserevamp/mandatestatuslist?iin='+ postData;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.achmandatereport = function(postData) { 
			var obj = {};
			//obj.method = 'user/achmandatereport';
			obj.method = 'nserevamp/mandatestatus';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendamcforekyc = function(postData) { 
			var obj = {};
			//obj.method = 'amcforekyc/ekyc';
			obj.method = 'nserevamp/kycregister';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
	   
		this.getamcforekyc = function() {
			var obj = {};
			obj.method = 'amcforekyc/details';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getlivePortfolioReportDetailsById = function (id) {
			var obj = {};
			obj.method = 'reports/live-portfolio-report-details/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.getlivePortfolioReportSummaryById = function (id) {
			var obj = {};
			obj.method = 'reports/live-portfolio-report-summary/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.purchaseTransaction = function(postData) { 
			var obj = {};
			//obj.method = 'customer/purchaselink';
			obj.method = 'nserevamp/purchase';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sysTransaction = function(postData) { 
			var obj = {};
			obj.method = 'nserevamp/systranxreg';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateIinStatus = function(postData) { 
			var obj = {};
			obj.method = 'nserevamp/updateiinstatus';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};


		this.getfoliodata = function(postData) { 
			var obj = {};
			obj.method = 'customer/getfoliodata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getholdingdatabyiin = function(postData) {
			var obj = {};
			obj.method = 'customer/getholdingdata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.redemptionTransaction = function(postData) { 
			var obj = {};
			//obj.method = 'customer/redemptionlink';
			obj.method = 'nserevamp/redemption';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.switchTransaction = function(postData) { 
			var obj = {};
			// obj.method = 'customer/switchlink';
			obj.method = 'nserevamp/switchtranx';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getShortUrlMaster = function() {
			var obj = {};
			obj.method = 'nserevamp/shorturlmaster';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.internalUserExemptList = function() {
			var obj = {};
			obj.method = 'customer/internalUserExemptList';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCallHistory = function (id) {
			var obj = {};
			obj.method = 'customer/getcallhistory?mobileNo=' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.resendLink = function(postData) {
			var obj = {};
			obj.method = 'nserevamp/resendlink';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.systematicRegistrationSwp = function(postData) {
			var obj = {};
			// obj.method = 'customer/systematicRegistrationlink';
			obj.method = 'nserevamp/swp';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.systematicRegistrationStp = function(postData) {
			var obj = {};
			// obj.method = 'customer/systematicRegistrationlink';
			obj.method = 'nserevamp/stp';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getLivePfReportByDateTD = function (id, postData) {
			var obj = {};
			obj.method = 'reports/live-portfolio-report-details/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getLivePfReportByDateTS = function (id, postData) {
			var obj = {};
			obj.method = 'reports/live-portfolio-report-summary/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getLiveExcelReportByDateTS = function (id, postData) {
			var obj = {};
			obj.method = 'reports/livePortfolioReportExcel/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getLiveExcelReportByDateTD = function (id, postData) {
			var obj = {};
			obj.method = 'reports/livePortfolioAllDetailsReportExcel/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCapitalGainReport = function (id) {
			var obj = {};
			obj.method = 'reports/capital-gain-trxn-wise-report/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCapitalGainReportExcel = function (id) {
			var obj = {};
			obj.method = 'reports/capital-gain-trxn-wise-report-excel/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.gettranxdetailsreport = function (postData) {
			var obj = {};
			//obj.method = 'user/gettranxdetailsreport';
			obj.method = 'nserevamp/orderlifecycle';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.proofofacctlist = function () {
			var obj = {};
			obj.method = 'customer/proofofacctlist';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.addbankdetail = function (postData) {
			var obj = {};
			//obj.method = 'customer/addbankdetail';
			obj.method = 'nserevamp/addbank';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendRelationshipStatusRetrigger = function (postData) {
			var obj = {};
			obj.method = 'customer/relationshipStatusRetrigger';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.fatcaretriggermail = function (postData) {
			var obj = {};
			obj.method = 'amcforekyc/fatcaretriggermail';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendfatcaKycUboReglink = function (postData) {
			var obj = {};
			//obj.method = 'customer/fatcaKycUboReg';
			obj.method = 'nserevamp/fatcareg';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendPauseSipEntry = function (postData) {
			var obj = {};
			// obj.method = 'customer/pauseSipEntry';
			obj.method = 'nserevamp/pausesip';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.ceasemasterdata = function () {
			var obj = {};
			// obj.method = 'customer/ceasemasterdata';
			obj.method = 'nserevamp/ceasesipreason';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendCeaseSipEntry = function (postData) {
			var obj = {};
			// obj.method = 'customer/ceaseSipEntry';
			obj.method = 'nserevamp/ceasesip';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};
		
		this.editCustomer = function (postData) {
			var obj = {};
			obj.method = 'customer/editCustomer';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getexternalfoliodata = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getexternalfoliodata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getrmsiweexternalfoliodata = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getrmsiweexternalfoliodata';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getrmcallinghistory = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getrmcallinghistory';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getrmlist = function () {
			var obj = {};
			obj.method = 'mfcentral/getrmlist';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getmfcetralusageonpan = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/getmfcetralusageonpan';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.kycStatusUpdate = function (postData) {
			var obj = {};
			obj.method = 'customer/kycstatusupdate';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.userInfoListOnMobile = function (postData) {
			var obj = {};
			obj.method = 'customer/userinfolistonmobile';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.userNotInterestedUpdate = function (postData) {
			var obj = {};
			obj.method = 'customer/usernotinterestedupdate';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.rmReasign = function (postData) {
			var obj = {};
			obj.method = 'customer/rmreasign';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.setPasswordasPan = function (postData) {
			var obj = {};
			obj.method = 'password/setpasswordaspan';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.forgotPassword = function (postData) {
			var obj = {};
			obj.method = 'password/forgotPassword';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.updateHolding = function (postData) {
			var obj = {};
			obj.method = 'mfcentral/UpdateExternalFlag';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIINonPan = function (pan) {
			var obj = {};
			obj.method = 'customer/getIINonPAN?pan=' + pan;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getIinMapping = function (iin) {
			var obj = {};
			obj.method = 'customer/setIINmapping?iin=' + iin;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.GET;
			obj.params = null;
			obj.postData = null;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.brokerUploadDetails = function (id, postData) {
			var obj = {};
			obj.method = 'getBrokerDetails/updatebrokerinfo/' + id;
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.uploadCustomer= function (postData) {
			var obj = {};
			obj.method = 'customer/uploadcustomer';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getAllDetail = function (postData) {
			var obj = {};
			obj.method = 'nserevamp/sipdetails';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.investorHoldings = function (postData) {
			var obj = {};
			obj.method = 'nserevamp/investorholdings';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getSIPDueReport = function (postData) {
			var obj = {};
			obj.method = 'nserevamp/xsipdue';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getOnBoardingReport = function (postData) {
			var obj = {};
			obj.method = 'nserevamp/onboardingreport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getRedeemReport = function (postData) {
			var obj = {};
			obj.method = 'nserevamp/redeemreport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getCeaseReport = function (postData) {
			var obj = {};
			obj.method = 'nserevamp/ceasereport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.sendSIPFundNewsletter = function (postData) {
			var obj = {};
			obj.method = 'reports/sipfundnewsletter';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.getTransferOutReport = function (postData) {
			var obj = {};
			obj.method = 'nserevamp/transferoutreport';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = postData;
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		// ── Revive Report API ─────────────────────────────────────────────────

		// JSON endpoints — go through standard getData/makeServiceCall
		this.dataOnSoccode = function (socCode) {
			var obj = {};
			obj.method = 'reports/dataonsoccode';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = { SOCCODE: socCode };
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.generateWellnessPdf = function (socCode) {
			var obj = {};
			obj.method = 'reports/newpkpswellnesspdf';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = { 'pkpsData.SOCCODE': socCode };
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		this.generateMergePdf = function (socCode) {
			var obj = {};
			obj.method = 'reports/newpkpsmergepdf';
			obj.serviceMethod = angular.module('app.common').HttpRequestType.POST;
			obj.params = null;
			obj.postData = { 'pkpsData.SOCCODE': socCode };
			obj.requestForErrorHandling = false;
			return getData(obj);
		};

		// Special endpoints — FormData or binary, require $http directly
		this.uploadWellnessData = function (formData) {
			return $http.post(Service.getBaseUrl() + '/reports/userdataupload', formData, {
				transformRequest: angular.identity,
				headers: { 'Content-Type': undefined }
			});
		};

		this.uploadCoiPdfs = function (formData) {
			return $http.post(Service.getBaseUrl() + '/reports/uploadcoionserver', formData, {
				transformRequest: angular.identity,
				headers: { 'Content-Type': undefined }
			});
		};

		this.downloadPdfsAsZip = function (items, zipName) {
			return $http.post(
				Service.getBaseUrl() + '/reports/downloadpdfsaszip',
				{ items: items, zipName: zipName },
				{ responseType: 'arraybuffer' }
			);
		};

	}
})();
(function () {
	'use strict';

	angular.module('app.common').service('Service', Service);

	//enum to hold the http request types
	angular.module('app.common').HttpRequestType = (function () {
		var requestType = {
			GET: 'GET',
			POST: 'POST',
			PUT: 'PUT',
			DELETE: 'DELETE'
		};
		return requestType;
	})();

	var broadCastCallBack = function (data, status, headers, config, callback) {
		var response = {
			error: null,
			data: angular.fromJson(data)
		};

		//construct the error object
		if (data.error !== null && data.error !== undefined) {
			response.error.responseString = data.error.message.toString();
		} else {
			callback(response);
		}
	};
	var handleServiceInvocationError = function (data, status, headers, config) {
		throw 'Error in service invocation';
		//we can show some popup with the common error message for all request failure.
	};
	var getURLFromServiceName = function (serviceName) {
		// var service, remoteUrl, baseUrl;
		// for (var i = 0; i < app.Config.ServiceURLs.services.length; i++) {
		//     if (app.Config.ServiceURLs.services[i].name === serviceName) {
		//         service = app.Config.ServiceURLs.services[i];
		//         remoteUrl = service.remoteURL;
		//         break;
		//     }
		// }
		// for (var i = 0; i < app.Config.ServiceURLs.baseUrlList.length; i++) {
		//     if (app.Config.ServiceURLs.baseUrlList[i].key === service.baseUriKey) {
		//         baseUrl = app.Config.ServiceURLs.baseUrlList[i].uri;
		//         break;
		//     }
		// }
		
		//return 'http://192.168.1.158:9000' + '/api';
		//return 'http://localhost:9000' + '/api';
		//return 'http://192.168.1.79:8080' + '/api';
		//return 'http://143.244.136.83:8085' + '/api';
		//return 'http://127.0.0.1:8081' + '/api';

		//UAT
		//return 'http://159.65.145.3:8081' + '/api';


		//Production
		//return '' + '/api';
		//local 
		//return 'http://127.0.0.1:8081' + '/api';

		//nse revampbuat
		return 'https://nse-sipfund-nse-admin-backend.jl2bnu.easypanel.host' + '/api';

		//nse revampb prod
		//return 'https://nse-sipfund-prod-nse-admin-backend.jl2bnu.easypanel.host' + '/api';
		

	};
	var constructURL = function (url, params) {
		for (var key in params) {
			//url += '/' + encodeURIComponent(params[key]);
			url += '/' + params[key];
		}
		return url;
	};
	var handleError = function (response) {
		if (
			response &&
			(response.status == 401 || response.status == 403) &&
			response.data &&
			response.data.error_description &&
			response.data.error_description != 'Invalid refresh token'
		) {
			Message.error(response.data.error_description);
		} else if (
			response &&
			(response.status == 401 || response.status == 403) &&
			response.data &&
			response.data.error_description &&
			response.data.error &&
			response.data.error == 'invalid_grant' &&
			response.data.error_description == 'Invalid refresh token'
		) {
			var CommonFactory = $injector.get('CommonFactory');
			CommonFactory.logout();
		} else if (response && response.status == 400) {
			if (response.data && response.data.error_description) {
				Message.error(response.data.error_description);
			} else {
				Message.error(app.constants.error.fillDetails);
			}
		} else if (response && response.data && response.data.message) {
			Message.error(response.data.message);
		} else {
			Message.error(app.constants.error.unknownErr);
		}
	};

	/** @ngInject */
	function Service($http, $location, $q, $injector, StorageService, GlobalService, Message) {
		this.getBaseUrl = function () {
			return getURLFromServiceName('api');
		};
		this.makeServiceCall = function (
			serviceName,
			methodName,
			httpReuestType,
			urlParams,
			data,
			requestForErrorHandling
		) {
			try {
				if (serviceName !== undefined && serviceName !== null) {
					var url = getURLFromServiceName(serviceName);
					url += '/' + methodName;
					if (methodName === 'token') {
						$http.defaults.headers.common.Authorization = 'Basic ' + 'U2lwRnVuZC1JZDpTaXBGdW5kLVNlY3JldA==';
						// $http.defaults.headers.common.Authorization = 'Basic ' + 'Q2FyaW5nLUNvcnBvcmF0ZS1JZDpDYXJpbmctQ29ycG9yYXRlLVNlY3JldA====';
					} else if (
						(methodName != 'user' && methodName != 'password/forgotPassword') ||
						(methodName == 'user' && httpReuestType == angular.module('app.common').HttpRequestType.PUT) ||
						methodName == 'user'
					) {
						var userInfo = StorageService.getSessionStorage('access_token');
						if (!userInfo) {
							var state = $injector.get('$state');
							state.go('app.auth_login');
						}
						$http.defaults.headers.common.Authorization = 'Bearer ' + userInfo;
					}

					if (
						methodName.indexOf('internal-users/image/upload') != -1 ||
						methodName.indexOf('blogs/upload') != -1 ||
						methodName.indexOf('documents/uploads') != -1 ||
						methodName.indexOf('mail-attachments') != -1 ||
						methodName === 'notifications/upload/image' ||
						methodName === 'investors-internal-user-csv' ||
						methodName === 'camsUploads' ||
						methodName === 'karvyData' ||
						methodName === 'franklinData' ||
						methodName === 'sundaramTrnx' ||
						methodName === 'karvyData/validateTransaction' ||
						methodName === 'camsUploads/validateTransaction' ||
						methodName === 'franklinData/validateTransaction' ||
						methodName === 'sipUploads' ||
						methodName === 'achUploads' ||
						methodName === 'sipUploads/validateTransaction' ||
						methodName === 'iinUploads' ||
						methodName === 'getBrokerDetails/uploads' ||
						methodName === 'customer/uploadcustomer'
						
					) {
						$http.defaults.headers.post['Content-Type'] = undefined;
						$http.defaults.headers.post['mimeType'] = 'multipart/form-data';
					} else {
						$http.defaults.headers.post['Content-Type'] = 'application/json';
					}
					if (
						methodName.indexOf('notificationscheduler/upload/attachment') != -1 ||
						methodName.indexOf('product/upload/image') != -1
					) {
						$http.defaults.headers.put['Content-Type'] = undefined;
						$http.defaults.headers.put['mimeType'] = 'multipart/form-data';
					}
					var deferred = $q.defer();
					switch (httpReuestType) {
						case angular.module('app.common').HttpRequestType.GET:
							$http.get(constructURL(url, urlParams)).then(
								function (response) {
									deferred.resolve(response);
								},
								function (response) {
									if (requestForErrorHandling) {
										handleError(response);
									} else {
										deferred.reject(response);
									}
								}
							);
							break;

						case angular.module('app.common').HttpRequestType.POST:
							$http.post(constructURL(url, urlParams), data).then(
								function (response) {
									deferred.resolve(response);
								},
								function (response) {
									if (requestForErrorHandling) {
										handleError(response);
									} else {
										deferred.reject(response);
									}
								}
							);
							break;

						case angular.module('app.common').HttpRequestType.PUT:
							$http.put(constructURL(url, urlParams), data).then(
								function (response) {
									deferred.resolve(response);
								},
								function (response) {
									if (requestForErrorHandling) {
										handleError(response);
									} else {
										deferred.reject(response);
									}
								}
							);
							break;

						case angular.module('app.common').HttpRequestType.DELETE:
							$http.delete(constructURL(url, urlParams), data).then(
								function (response) {
									deferred.resolve(response);
								},
								function (response) {
									if (requestForErrorHandling) {
										handleError(response);
									} else {
										deferred.reject(response);
									}
								}
							);
							break;

						default:
							throw 'not supported';
					}
					return deferred.promise;
				}
			} catch (e) {
				throw e;
			}
		};
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.common')
        .service('Message', Message);

    /** @ngInject */
    function Message() {
        // $.notifyDefaults({
        //     delay: 1500,
        //     newest_on_top: true,
        //     allow_dismiss: true,
        //     showProgressbar: false,
        //     mouse_over: 'pause',
        //     animate: {
        //         enter: 'animated fadeInDown',
        //         exit: 'animated fadeOutUp'
        //     }
        // });
        // this.success = function(msg) {
        //     $.notify({
        //         icon: 'glyphicon glyphicon-ok-sign',
        //         message: msg
        //     }, {
        //         type: 'success',
        //         icon: 'glyphicon glyphicon-success-sign',
        //     });
        // };
        // this.error = function(msg) {
        //     $.notify({
        //         icon: 'glyphicon glyphicon-alert-sign',
        //         message: msg
        //     }, {
        //         type: 'danger',
        //     });
        // };
        // this.warning = function(msg) {
        //     $.notify({
        //         icon: 'glyphicon glyphicon-warning-sign',
        //         message: msg
        //     }, {
        //         type: 'warning',
        //     });
        // };
        // this.info = function(msg) {
        //     $.notify({
        //         icon: 'glyphicon glyphicon-info-sign',
        //         message: msg
        //     }, {
        //         type: 'info',
        //     });
        // };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.common')
        .factory('LoadingInterceptor', LoadingInterceptor);

    /** @ngInject */
    function LoadingInterceptor($injector, $q) {
        return {
            request: function(config) {
                // $('#loading-indicator').show();
                if (config.method == 'GET') {
                    $('#loading-indicator').show();
                }
                return config;
            },

            requestError: function(config) {
                $('#loading-indicator').hide();
                return $q.reject(config);
            },

            response: function(res) {
                $('#loading-indicator').hide();
                return res;
            },

            responseError: function(config) {
                var state = $injector.get('$state');
                if (config.status == 401) {
                    state.go('app.auth_login');
                }
                $('#loading-indicator').hide();
                return $q.reject(config);
            }
        };

    }

})();
/**
 * jQuery Loading Block
 *
 * demos / documentation: https://github.com/chan15/jquery-loading-block
 *
 * @author Chan
 */
;(function ($) {
    $.loadingBlockShow = function(opts) {
        var defaults = {
            imgPath: 'img/icon.gif',
            imgStyle: {
                width: 'auto',
                textAlign: 'center',
                marginTop: '20%'
            },
            text: 'loading...',
            style: {
                position: 'fixed',
                width: '100%',
                height: '100%',
                background: 'rgba(255, 255, 255, .8)',
                left: 0,
                top: 0,
                zIndex: 10000
            }
        };
        $.extend(defaults, opts);
        $.loadingBlockHide();

        var img = $('<div><img src="' + defaults.imgPath + '"><div>' + defaults.text + '</div></div>');
        var block = $('<div id="loading_block"></div>');

        block.css(defaults.style).appendTo('body');
        img.css(defaults.imgStyle).appendTo(block);
    };

    $.loadingBlockHide = function() {
        $('div#loading_block').remove();
    };
}(jQuery));

(function ()
{
    'use strict';

    angular
        .module('app.common')
        .service('GlobalService', GlobalService);

    /** @ngInject */
    function GlobalService() {

        this.showErrorMessage = "Hi";

    }

})();

var constants = {
	error : {
		noInternet: "No internet connectivity",
		unknownErr: "Please try again after some time, sorry for the inconvenience",
		cachedData: "Data is not updated due to unavailability of internet connection",
		fillDetails: "Please fill all the required details",
		noPermit: 'Your approval is pending, order cannot be placed'
	},
	text:{
		fav:'Favourites',
		nothing: 'Nothing here',
		addCart:'Please add some products to cart.'
	},
	success:{
		cartAddSuccess: 'Successfully added to the cart',
		orderPlacedSuccess: 'Order placed successfully'
	},
	placeHolder:{
		category: 'img/placeholder/category.jpg',
		product: 'img/placeholder/product.jpg',
		nothingHere: 'img/placeholder/nothing.jpg'
	}
};

(function() {
	'use strict';

	angular
		.module('app.bank-details', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.bank-details', {
				url: '/bank-details',
				views: {
					'content@app': {
						templateUrl: 'app/main/bank-details/bank-details.html',
						controller: 'bankdetailsController as vm'
					}
				}
			})

		msNavigationServiceProvider.saveItem('customer.bank-details', {
			title: 'IFSC details',
			icon: 'icon-tile-four',
			state: 'app.bank-details',
			weight: 10,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			}
		});
	}
})();

(function () {

	'use strict';


	angular.module('app.bank-details').controller('bankdetailsController', bankdetailsController);
	

	/** @ngInject */
	function bankdetailsController($state, $stateParams, $q, StorageService, $scope, $filter, $timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;
		
		function init() {
			vm.bank = {};
			// get ifscbank  match
			vm.getMatches = getMatches;
			vm.getBranchMatches = getBranchMatches;
			vm.getBranchData = getBranchData;
			   getBankData();
			var postData = {};
			 postData._id = vm.schemes._id
			 vm.clearFields=clearFields;
			 vm.disableSubmit = disableSubmit;
			 vm.editBankDetails = editBankDetails;
		}
		init();
	
		function disableSubmit() {
			return !(vm.schemes.bankName && vm.bank.branchschemes && vm.bank.branchschemes.ifscCode
				    && vm.bank.branchschemes.state && vm.bank.branchschemes.city);
				//  && vm.bank.branchschemes.nseBankName && vm.bank.branchschemes.address
				//  && vm.bank.branchschemes.contact && vm.bank.branchschemes.state
				//  && vm.bank.branchschemes.district && vm.bank.branchschemes.city);
		}
		//clear all fields when check box is checked
		function clearFields () {
			 if($scope.chkselct)
			 {
				vm.bank.branchschemes.ifscCode='';
				//vm.bank.branchschemes.nseBankName='';
				//vm.bank.nseBankName ='';
				vm.bank.branchschemes.address='';
				vm.bank.branchschemes.contact ='';
				vm.bank.branchschemes.state='';
				vm.bank.branchschemes.district='';
				vm.bank.branchschemes.city='';
				vm.bank.branchschemes.micrCode='';
				vm.bank.branchschemes='';
			}
			else
			window.location.reload();
        }
		// Get All Scheme API Call Start
		function sucessBankData(response) {
			vm.schemes = response.data.responseString;
		}
		function errorBankData(response) {
			if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
		}
		//productFund data
		function getBankData() {
			vm.bank.scheme = '';
			vm.schemes = [];
				ServiceProxy.getBanklist().then(sucessBankData, errorBankData);
		}

		function sucessBranchData(response) {
			vm.branchschemes = response.data.responseString;
			vm.bank.nseBankName =vm.branchschemes[0].nseBankName;
		}
		function errorBranchData(response) {
			if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
		}
		function getBranchData(bankName) {
			vm.branchschemes = [];
			if (bankName != undefined) {		
				ServiceProxy.getBranchlist(bankName).then(sucessBranchData, errorBranchData);
			}
		}
		// match bankname
		function getMatches(searchText) {
			var deferred;
			var result = vm.bankName;
			if (searchText) {
				deferred = $q.defer();

				$timeout(function () {
					var states =vm.schemes.filter(function (state) {
						if(state.bankName)
						return (state.bankName.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.bankName.toUpperCase().indexOf(searchText.toUpperCase()) !== -1);
					});
					deferred.resolve(states);
				}, 1500);

				return deferred.promise;
			} else {
				return result;
			}
        }
			// match bank branch name
			function getBranchMatches(searchBranch) {
				var deferred;
				var result = vm.branch;
				if (searchBranch) {
					deferred = $q.defer();
					$timeout(function () {
						var states =vm.branchschemes.filter(function (state) {
							if(state.branch)
							return (state.branch.toUpperCase().indexOf(searchBranch.toUpperCase()) !== -1 || state.branch.toUpperCase().indexOf(searchBranch.toUpperCase()) !== -1);
						});
						deferred.resolve(states);
					}, 1500);
					return deferred.promise;
				} else {
					return result;
				}
	
			}
		function editBankDetails() {
			
				if(vm.bank.branchschemes.ifscCode){
					vm.ifscCode = /^[A-Za-z]{4}\d{7}$/.test(vm.bank.branchschemes.ifscCode)
				if (!vm.ifscCode) {
					return errorCbEditIFSC('wrong IFSC')
				}
			} 
			if(vm.bank.Newbranchschemes ==undefined && vm.bank.branchschemes.branch ==undefined)
			{
				return errorCbEditIFSC('Please enter new branch name')
			}
			
			var postData = {};
             postData.bankName=	vm.schemes.bankName.bankName;
			 postData.ifscCode=	vm.bank.branchschemes.ifscCode;
			 postData.branch=vm.bank.branchschemes.branch ==undefined?vm.bank.Newbranchschemes:vm.bank.branchschemes.branch;
			 postData.address=vm.bank.branchschemes.address;
			 postData.contact=vm.bank.branchschemes.contact;
			 postData.state=vm.bank.branchschemes.state;
			 postData.district=vm.bank.branchschemes.district;
			 postData.city=vm.bank.branchschemes.city;
			 postData.nseBankName=vm.bank.nseBankName; //vm.bank.branchschemes.nseBankName;
			 postData.micrCode=vm.bank.branchschemes.micrCode;
			 postData.newBranch = vm.bank.branchschemes.branch ==undefined?true:false;
			 postData._id = vm.bank.branchschemes._id;

			 if (vm.bank.branchschemes.ifscCode) {
                ServiceProxy.updateBankDetails(postData).then(sucessCbUpdateBankDetais, errorCbUpdateBankDetais);
            } 
        }
        function sucessCbUpdateBankDetais(response) {
                showDialogSucc(response.data.responseString);
        }

        function errorCbUpdateBankDetais(response) {
            if (response && response.data && response.data.data) {
                showDialog(response.data.responseString);
            }
        }      	
		function errorCbEditIFSC(res) {
            var confirm = $mdDialog.confirm()
                .title('Error !!')
                .textContent(res)
                .ariaLabel('Lucky day')
                .ok('OK')
                $mdDialog.show(confirm);
        }
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}
		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () { });
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('app.assignmentDashboard')
    .controller('AssignmentDashboardController', AssignmentDashboardController)
    .directive('whenScrolled', function () {
      return function (scope, elm, attr) {
        var raw = elm[0];

        elm.bind('scroll', function () {
          if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
            scope.$apply(attr.whenScrolled);
          }
        });
      };
    });
  /** @ngInject */
  function AssignmentDashboardController($state, $timeout,$filter,$scope, $mdDialog, ShareDataService, ServiceProxy) {
    var vm = this;

    function init() {
      vm.setUserInterested = setUserInterested;
      vm.eKyc = {
        "01": "UNDER_PROCESS",
        "02": "KYC REGISTERED",
        "03": "ON HOLD",
        "04": "KYC REJECTED",
        "05": "NOT AVAILABLE",
        "06": "Deactivate",
        "07": "KYC VALIDATED",
        "11": "UNDER_PROCESS(OLD record)",
        "12": "KYC REGISTERED(OLD record)",
        "13": "ON HOLD(OLD record)",
        "22": "CVL MF KYC"
      }
      vm.selectedFilter = selectedFilter;
      $scope.items = [];

      vm.counter = 0;
      var mainHeight = document.getElementById('mainContent').clientHeight;
      var offsetHeight = document.getElementById('mainContent').offsetHeight;

      getAllInternalUser();
      getUserCount();
      vm.assignInternalUser = assignInternalUser;
      // getAllUser()
      vm.filterType = 'Unassigned';
      vm.excelDownloadData
      getNewLeadUser();

    };
    init();

 
    $scope.loadMore = function () {
      if (vm.counter >= vm.allUserForProcess.length) {
        return
      }
      var length = 20;
      if (vm.counter > 0) {

        for (var i = 0; i < length; i++) {
          if ((vm.counter + i + 1) < vm.allUserForProcess.length) {
            $scope.items.push(vm.allUserForProcess[vm.counter + i + 1]);
          }
        }
      } else {
        for (var i = 0; i < length; i++) {
          $scope.items.push(vm.allUserForProcess[vm.counter + i]);
        }
      }
      if ((vm.allUserForProcess.length - vm.counter) < length) {
        var diff = vm.allUserForProcess.length - vm.counter;
        vm.counter += +diff;
      } else {
        vm.counter += length;
      }
    };

    // function sucessCbGetAllUser(response) {
    //   vm.allcustomers = response.data.data;
    //   $scope.loadMore();
    // }

    // function errorCbGetAllUser(response) {
    // }

    // function getAllUser() {
    //   // vm.customers = []
    //   ServiceProxy.getCustmoerBySearch('', '100000', 1).then(sucessCbGetAllUser, errorCbGetAllUser);
    // }

    ////////////////////////////////get  User Count Start///////////////////////////////////////
    function sucessCbGetUserCount(response) {
      vm.countData = response.data.data;

    }

    function errorCbGetUserCount(response) {}

    function getUserCount() {
      // vm.customers = []
      ServiceProxy.getUserCount().then(sucessCbGetUserCount, errorCbGetUserCount);
    }

    ////////////////////////////////get User Count End///////////////////////////////////////


    //////////////////get new lead User Start////////////////////////////////////////////////
    function sucessCbGetNewLeadUser(response) {
      vm.allUserForProcess = response.data.data;
    }

    function errorCbGetNewLeadUser(response) {}

    function getNewLeadUser() {
      // vm.customers = []
      ServiceProxy.getNewLeadUser().then(sucessCbGetNewLeadUser, errorCbGetNewLeadUser);
    }
    //////////////////get new lead User End////////////////////////////////////////////////

    /////////////////////////////////// get Advisory(RM) customer start//////////////////////////////////////////////////
    function sucessCbGetAdvisoryCustomer(response) {
      vm.allUserForProcess = response.data.data;
    }

    function errorCbGetAdvisoryCustomer(response) {}

    function getAdvisoryCustomer() {
      // vm.customers = []
      ServiceProxy.getAdvisoryCustomer().then(sucessCbGetAdvisoryCustomer, errorCbGetAdvisoryCustomer);
    }
    /////////////////////////////////// get Advisory(RM) customer end//////////////////////////////////////////////////

    /////////////////////////////////// get Not Interested customer start//////////////////////////////////////////////////
    function sucessCbNotInterestedCustomer(response) {
      vm.allUserForProcess = response.data.data;
    }

    function errorCbNotInterestedCustomer(response) {}

    function notInterestedCustomer() {
      // vm.customers = []
      ServiceProxy.notInterestedCustomer().then(sucessCbNotInterestedCustomer, errorCbNotInterestedCustomer);
    }
    /////////////////////////////////// get Not Interested  customer end//////////////////////////////////////////////////

    /////////////////////////////////// get Old unassigned customer start//////////////////////////////////////////////////
    function sucessCbGetOldUnAssignedCustomer(response) {
      vm.allUserForProcess = response.data.data;
    }

    function errorCbGetOldUnAssignedCustomer(response) {}

    function getOldUnAssignedCustomer() {
      // vm.customers = []
      ServiceProxy.getOldUnAssignedCustomer().then(sucessCbGetOldUnAssignedCustomer, errorCbGetOldUnAssignedCustomer);
    }
    /////////////////////////////////// get old unassigned customer end//////////////////////////////////////////////////

    ///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
    function showDialog(response) {
      var confirm = $mdDialog.confirm()
        .title('!!Error!!')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {});
    };
    ///////////////////////////////show error dialog message ends here//////////////////////////////////////////////


    ///////////////////////////////////get all internal user starts here//////////////////////////////////////
    function sucessCbGetAllInternalUser(response) {
      vm.overAllUser = response.data.data;
      vm.allInternalUsers = response.data.data;
      vm.selectedFilter(vm.filterType);
      // vm.allInternalUser = angular.copy(response.data.data);
      // vm.internalUser = response.data.data;
      // getAllFeatures();
      // internalUserCount('Activated_user');
    }

    function errorCbGetAllInternalUser(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAllInternalUser() {
      ServiceProxy.getAllInternalUser().then(sucessCbGetAllInternalUser, errorCbGetAllInternalUser)
    }
    ///////////////////////////////////get all internal user ends here//////////////////////////////////////

    function selectedFilter(type) {
      vm.filterType = type;
      if (vm.filterType === 'NI') {
        notInterestedCustomer();
        // getAllUser();
      } else if (vm.filterType === 'Unassigned') {
        getNewLeadUser();
        vm.placeholder = 'Assign Customer Support';
        vm.allInternalUsers = vm.overAllUser.filter(function (item) {
          return item.type === 'SALES::USER';
        })
      } else if (vm.filterType === 'Advisory') {
        getAdvisoryCustomer();
        vm.placeholder = 'Assign Financial Advisor';
        vm.allInternalUsers = vm.overAllUser.filter(function (item) {
          return (item.type === 'FINANCE::USER' || item.type === 'SUB::BROKER');
        })
      } else if (vm.filterType === 'OLD') {
        getOldUnAssignedCustomer();
        vm.placeholder = 'Assign Customer Support';
        vm.allInternalUsers = vm.overAllUser.filter(function (item) {
          //return item.type === 'SALES::USER';
          return (item.type === 'SALES::USER' ||item.type === 'FINANCE::USER' );
        })
      } else if (vm.filterType === 'Document') {
        getUnVerifiedCustomer();
        vm.placeholder = 'Assign Financial Advisor';
        vm.allInternalUsers = vm.overAllUser.filter(function (item) {
          return item.type === 'FINANCE::USER' || item.type === 'SUB::BROKER';
        })
      }
    }

    /////////////////////////////////// get Old unassigned customer start//////////////////////////////////////////////////
    function sucessCbGetUnVerifiedCustomer(response) {
      vm.allUserForProcess = response.data.data;
    }

    function errorCbGetUnVerifiedCustomer(response) {}

    function getUnVerifiedCustomer() {
      // vm.customers = []
      ServiceProxy.getUnVerifiedCustomer().then(sucessCbGetUnVerifiedCustomer, errorCbGetUnVerifiedCustomer);
    }

    ////////////////////////////Internal user assignment to customer //////////////////////////////////
    function sucessCbAssignToInternalUser(user, response) {
      var index = vm.allUserForProcess.findIndex(function (ctr) {
        return ctr._id === user._id;
      })
      vm.allUserForProcess.splice(index, 1);
      vm.countData.userLeadCount -= 1;
      getUserCount();
      // vm.countData.advisoryCount += 1;
    }

    function errorCbAssignToInternalUser(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function assignInternalUser(user) {
      var data = {
        assignedUserId: user.assignedUser._id,
        investorsIds: [user._id]
      }
      ServiceProxy.assignToInternalUser(data).then(function (response) {
        sucessCbAssignToInternalUser(user, response)
      }, errorCbAssignToInternalUser)
    }


    //////////////////////set user as interested/////////////////////////////

    function sucessCbSetNotInterested(user, response) {
      var index = vm.allUserForProcess.findIndex(function (ctr) {
        return ctr._id === user._id;
      })
      vm.allUserForProcess.splice(index, 1);
      // vm.countData.notInterestedCount -= 1;
      getUserCount();
    }

    function errorCbSetNotInterested(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function setUserInterested(user) {
      // evt.stopPropagation();
      var data = {
        "notInterestedFlag": false
      };
      ServiceProxy.setNotInterested(user._id, data).then(function (response) {
        sucessCbSetNotInterested(user, response)
      }, errorCbSetNotInterested)
    }


    //new methods
    vm.downloadExcel = function () {
      var fileText
      console.log(vm.allUserForProcess);
      // var currentDate = new Date('1/1/2020');
      // currentDate.setHours(0, 0, 0, 0);
      // vm.excelDownloadData = vm.allUserForProcess.filter(function(item){
      //   return new Date(item.createdAt) <= currentDate;
      // })
      if (vm.filterType == 'Unassigned') {
        fileText = 'Sales_Unassigned_Customer'
      } else if (vm.filterType == 'Document') {
        fileText = 'Document_Unverified_Customer'
      } else if (vm.filterType == 'Advisory') {
        fileText = 'Advisory_Unassigned_Customer'
      }

      var timestamp = new Date()
      var filename = fileText + '_' + $filter('date')(timestamp, 'dMMMy') + '.csv'
      var table = document.getElementById("resultsTable");//.nextElementSibling;
      var csvString = '';
      // for (var i = 0; i < table.rows.length; i++) {
      //   var rowData = table.rows[i].cells;
      //   for (var j = 0; j < rowData.length; j++) {
      //     csvString = csvString + rowData[j].innerHTML + ",";
      //   }
      //   csvString = csvString.substring(0, csvString.length - 1);
      //   csvString = csvString + "\n";
      // }

      for (var i = 0; i < vm.allUserForProcess.length; i++) {
        var rowData = vm.allUserForProcess[i];
        if (i == 0) {
          csvString = "Name,Mobile,IIN,PAN,KYC Status,Address,Created Date,Download Date" + "\n";
        }
        csvString = csvString
          + (rowData.userName == undefined ? "" : rowData.userName) + ","
          + (rowData.mobileNo == undefined ? "" : rowData.mobileNo) + ","
          + (rowData.iin == undefined ? "" : rowData.iin) + ","
          + (rowData.pan == undefined ? "" : rowData.pan) + ","
          + (vm.eKyc[rowData.camsKycStatus] || 'NA') + ","
          + (rowData.nseData ? rowData.nseData.CITY : 'Not Available') + ","
          + (rowData.createdAt == undefined ? "" : $filter('date')(rowData.createdAt, 'dMMMy')) + ","
          + (rowData.createdAt == undefined ? "" : $filter('date')(timestamp, 'dMMMy'))

        // csvString = csvString.substring(0, csvString.length - 1);
        csvString = csvString + "\n";
      }

      // csvString = csvString.substring(0, csvString.length - 1);
      var a = $('<a/>', {
        style: 'display:none',
        href: 'data:application/octet-stream;base64,' + btoa(csvString),
        download: filename
      }).appendTo('body')
      a[0].click()
      a.remove();
    }

  }
})();
(function() {
	'use strict';

	angular
		.module('app.achMandateReport', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.achMandateReport', {
				url: '/achMandateReport',
				views: {
					'content@app': {
						templateUrl: 'app/main/ach-mandateReport/ach-mandateReport.html',
						controller: 'achMandateReportController as vm'
					}
				}
			}).state('app.achMandateReportDetails', {
				url: '/achMandateReport/achMandateReportDetails',
				views: {
					'content@app': {
						templateUrl: 'app/main/ach-mandateReport/ach-mandateReport-details.html',
						controller: 'achMandateReportDetailsController as vm'
					}
				},
				params: {
					logDetails: null
				}
			});

		msNavigationServiceProvider.saveItem('DASHBOARD.achMandateReport', {
			title: 'Ach Mandate Report',
			icon: 'icon-tile-four',
			state: 'app.achMandateReport',
			weight: 7,
			hidden: function () {
				// return false;
				if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
				  return false;
				} else {
				  return true;
				}
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.achMandateReport').controller('achMandateReportController', achMandateReportController);

	/** @ngInject */
	function achMandateReportController($state,$scope,$filter,$timeout, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;

		function init() {
			vm.postData = {};
			vm.fromDate = null;
			vm.toDate = null;
			vm.selected = null;
			vm.reportType = null;
			vm.enabled1 = false;
			vm.iinRegex = /^[1-9]{1}[0-9]{9}$/;
			vm.logData = [];
			vm.today = new Date();
			vm.statusData = [
				{ value: 'A', title: 'Accepted' },
				{ value: 'R', title: 'Rejected' },
				{ value: 'P', title: 'Pending / Scan Image not uploaded' },
				{ value: 'RE', title: 'Received by Exchange' },
				{ value: 'VF', title: 'Verification Failed' },
				{ value: 'VE', title: 'Verified by Exchange' },
				{ value: 'AA', title: 'Assigned to Agency' },
				{ value: 'C', title: 'Cancelled' }
			  ];
			
		}
		init();

		var sucessTrnLog = function(response){
			vm.logData = response.data.data;
			
			if(vm.logData.length < 1){
				showDialog("No Data Found...!!!");
			}else{
				showDialogSucc(response.data.msg)
			}
		}

		var errorTrnlog = function(response){
			vm.logData = response.data.data;
			if(vm.logData.length < 1){
				showDialog(response.data.servicemsg);
			}
		}

		$scope.postTranLogs = function(){
		
			vm.logData = [];
			// If validation passes, proceed with formatting dates and sending the request
			vm.postData.iin = vm.postData.iin != null ? vm.postData.iin.toString() : null ;
			vm.postData.status = vm.postData.status != null ? vm.postData.status : null ;
			vm.postData.ach_fromdate = $filter('date')(vm.fromDate, "dd-MMM-yyyy");
			vm.postData.ach_todate = $filter('date')(vm.toDate, "dd-MMM-yyyy");
		
			ServiceProxy.achmandatereport(vm.postData).then(sucessTrnLog, errorTrnlog);
		}
		

		$scope.clearLogs = function (){
			init()
		}

		$scope.downloadLogs = function () {
			// Check if there's any data to download
			if (vm.logData.length === 0) {
				alert("No data available to download.");
				return;
			}
			
			// Define the CSV headers
			var csvContent = 'Sr.No.,IIN,Name,Scheme Amount,Mandate ID,Bank Name,IFSC Code,Account No,Account Type,UMRN No,Unique Ref No,From Date,To Date,Debit Amount Type,Frequency,Mandate Amount,Rejection Remarks,Mandate Status,Bank Holder Name,Process Mode,eMandate Authorized,Expired Date Time\n';
		
			// Helper function to return 'NA' if value is missing or undefined, otherwise wrap the value in quotes
			function getValueOrNA(value) {
				if (value === null || value === undefined || value === '' || typeof value === 'object') {
					return '"NA"';  // Return 'NA' for null, undefined, or empty object values
				}
				var cleanedValue = value.toString().replace(/^-+/, ''); // Remove leading '-' characters
				return '"' + cleanedValue.replace(/"/g, '""') + '"';  // Escape double quotes within values
			}
		
			// Add the data rows using a for loop
			for (var index = 0; index < vm.logData.length; index++) {
				var log = vm.logData[index];
				var row = [
					index + 1,
					getValueOrNA(log.CUSTOMER_ID),
					getValueOrNA(log.INVESTOR_NAME),
					getValueOrNA(log.AMOUNT),
					getValueOrNA(log.MANDATE_ID),
					getValueOrNA(log.BANK_NAME),
					getValueOrNA(log.IFSC_CODE),
					getValueOrNA(log.ACCOUNT_NO),
					getValueOrNA(log.AC_TYPE),
					getValueOrNA(log.UMRN_NO),
					getValueOrNA(log.UNIQUE_REF_NO),
					getValueOrNA(log.FROM_DATE),
					getValueOrNA(log.TO_DATE),
					getValueOrNA(log.DEBIT_AMOUNT_TYPE),
					getValueOrNA(log.FREQUENCY),
					getValueOrNA(log.AMOUNT),
					getValueOrNA(log.REJECTION_REMARKS),
					getValueOrNA(log.ACH_MANDATE_STATUS),
					getValueOrNA(log.BANK_HOLDER_NAME),
					getValueOrNA(log.PROCESS_MODE),
					getValueOrNA(log.EMANDATE_AUTHORIZED),
					getValueOrNA(log.EXPIRED_DATE_TIME)
				].join(',');  // Join fields with commas
		
				csvContent += row + '\n';  // Add the row to the CSV string
			}
		
			// Create a Blob object
			var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		
			// Create a download link and trigger a download
			var link = document.createElement("a");
			if (link.download !== undefined) {  // Feature detection
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", "Ach_Mandate_Report.csv");
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		};		
				
		vm.showDetails = function(logDetails) {
			$mdDialog.show({
				controller: DialogController,
				template: 
					'<md-dialog aria-label="Log Details">' +
						'<md-dialog-content>' +
							'<div style="display: flex; justify-content: space-between;">' +
								'<div style="flex: 1; min-width: 200px; padding-right: 15px;">' +
									'<p><strong>Sr.No.:</strong> {{logDetails.CUSTOMER_ID}}</p>' +
									'<p><strong>Name:</strong> {{logDetails.INVESTOR_NAME}}</p>' +
									'<p><strong>Process Mode:</strong> {{logDetails.PROCESS_MODE}}</p>' +
									'<p><strong>IIN:</strong> {{logDetails.CUSTOMER_ID}}</p>' +
									'<p><strong>Scheme Amount:</strong> {{logDetails.AMOUNT}}</p>' +
									'<p><strong>IFSC Code:</strong> {{logDetails.IFSC_CODE}}</p>' +
									'<p><strong>UMRN No:</strong> {{logDetails.UMRN_NO}}</p>' +
									'<p><strong>Mandate Date:</strong> {{logDetails.MANDATE_DATE}}</p>' +
								'</div>' +
								'<div style="flex: 1; min-width: 200px; padding-right: 15px;">' +
									'<p><strong>Mandate ID:</strong> {{logDetails.MANDATE_ID}}</p>' +
									'<p><strong>Bank Name:</strong> {{logDetails.BANK_NAME}}</p>' +
									'<p><strong>Account No:</strong> {{logDetails.ACCOUNT_NO}}</p>' +
									'<p><strong>Account Type:</strong> {{logDetails.AC_TYPE}}</p>' +
									'<p><strong>eMandate Authorized:</strong> {{logDetails.EMANDATE_AUTHORIZED}}</p>' +
									'<p><strong>Mandate Status:</strong> {{logDetails.ACH_MANDATE_STATUS}}</p>' +
									'<p><strong>Mandate Amount:</strong> {{logDetails.AMOUNT}}</p>' +
								'</div>' +
								'<div style="flex: 1; min-width: 200px; padding-right: 15px;">' +
									'<p><strong>Unique Ref No:</strong> {{logDetails.UNIQUE_REF_NO}}</p>' +
									'<p><strong>From Date:</strong> {{logDetails.FROM_DATE}}</p>' +
									'<p><strong>To Date:</strong> {{logDetails.TO_DATE}}</p>' +
									'<p><strong>Debit Amount Type:</strong> {{logDetails.DEBIT_AMOUNT_TYPE}}</p>' +
									'<p><strong>Frequency:</strong> {{logDetails.FREQUENCY}}</p>' +
									'<p><strong>Rejection Remarks:</strong> {{logDetails.REJECTION_REMARKS}}</p>' +
									'<p><strong>Bank Holder Name:</strong> {{logDetails.BANK_HOLDER_NAME}}</p>' +
									'<p><strong>Expired Date Time:</strong> {{logDetails.EXPIRED_DATE_TIME}}</p>' +
								'</div>' +
							'</div>' +
						'</md-dialog-content>' +
						'<md-dialog-actions layout="row">' +
							'<md-button ng-click="closeDialog()" class="md-primary">' +
								'Close' +
							'</md-button>' +
						'</md-dialog-actions>' +
					'</md-dialog>',
				locals: {
					logDetails: logDetails
				},
				clickOutsideToClose: true,
				parent: angular.element(document.body),
				controllerAs: 'vm'
			});
		
		
			function DialogController($scope, $mdDialog, logDetails) {
				$scope.logDetails = logDetails;
		
				$scope.closeDialog = function() {
					$mdDialog.hide();
				};
			}
		};
		
		// $state.go('app.achMandateReportDetails', { logDetails: logDetails });
		
		function showDialogSucc(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Success')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}

		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('Sorry...!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
	}
})();
(function () {
	'use strict';

	angular.module('app.aumReport').controller('AUMReportController', AUMReportController);

	/** @ngInject */
	function AUMReportController($state, $mdSidenav, $mdDialog, ShareDataService, ServiceProxy) {
		var vm = this;

		function init() {
			vm.investmentData = {};
			vm.customers = ShareDataService.getData('schemeInvetsment');
			vm.customerWiseDetials = customerWiseDetials;
			vm.selectTableRow = selectTableRow;
			vm.downloadCustomerData = downloadCustomerData;
			vm.downloadSchemeData = downloadSchemeData;
			vm.investmentDataCustomerData;
			getAumInvestmentReports();
			//getAumInvestmentReportsCustomerWise();
			//getAumInvestmentReportsSchemeWise();
		}
		init();

		function downloadCustomerData(){
			if(vm.investmentDataCustomerData){
				var csvString = 'Customer Name,PAN,IIN,Scheme Count,Invested Amount,Current Amount,Absolute Returns,' + "\n";
				for(var i=0; i < vm.investmentDataCustomerData.length; i++){
						
					csvString = csvString.concat(
						(vm.investmentDataCustomerData[i].investorName !== undefined  ? vm.investmentDataCustomerData[i].investorName : "") + "," 
						+ vm.investmentDataCustomerData[i].pan + "," 
						+ vm.investmentDataCustomerData[i].iin + "," 
						+ vm.investmentDataCustomerData[i].numberOfSchemes + ","                   
						+ vm.investmentDataCustomerData[i].amount.toFixed(2) + ","
						+ vm.investmentDataCustomerData[i].currentValue.toFixed(2) + ","						
						+ vm.investmentDataCustomerData[i].absoluteReturn.toFixed(2) + ","
						);
					csvString = csvString + "\n";                
				}

				var a = $('<a/>', {
				href:'data:application/octet-stream;base64,'+btoa(unescape(encodeURIComponent(csvString))),
				download:'AUMCustomerReport.csv'
				}).appendTo('body')
				a[0].click()
				a.remove();
			}
		}

		function downloadSchemeData(){
			if(vm.investmentDataSchemeWise){
				var csvString = 'Scheme Name,Customer,Invested Amount,Current Amount,' + "\n";
				for(var i=0; i < vm.investmentDataSchemeWise.length; i++){						
					csvString = csvString.concat(
						(vm.investmentDataSchemeWise[i].schemeName !== undefined  ? vm.investmentDataSchemeWise[i].schemeName : "") + "," 
						+ vm.investmentDataSchemeWise[i].investors.length + "," 						
						+ vm.investmentDataSchemeWise[i].amountInvested.toFixed(2) + ","
						+ vm.investmentDataSchemeWise[i].currentValue.toFixed(2) + ","						
						);
					csvString = csvString + "\n";                
				}

				var a = $('<a/>', {
				href:'data:application/octet-stream;base64,'+btoa(unescape(encodeURIComponent(csvString))),
				download:'AUMSchemeReport.csv'
				}).appendTo('body')
				a[0].click()
				a.remove();
			}
		}

		////////////////////////////////////////Get AUM Investment details report starts here//////////////////////////////////
		function successGetInvestmentsREports(response) {
			vm.investmentData = response.data.data;
			vm.investmentDataCustomerData = response.data.data.customers;
			vm.investmentDataSchemeWise = response.data.data.schemes;
		}

		function errorGetInvestmentsReports(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAumInvestmentReports() {
			//ServiceProxy.getAumInvestmentReports().then(successGetInvestmentsREports, errorGetInvestmentsReports);
			ServiceProxy.getAumReports().then(successGetInvestmentsREports, errorGetInvestmentsReports);
		}

		////////////////////////////////////////Get AUM Investment details report ends here//////////////////////////////////

		////////////////////////////////////////Get Customer Wise data starts here///////////////////////////////////////////
		function successGetInvestmentsREportsCustomer(response) {
			vm.investmentDataCustomerData = response.data.data.customers;
		}

		function errorGetInvestmentsReportsCustomer(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAumInvestmentReportsCustomerWise() {
			ServiceProxy.getAumInvestmentReportsCustomerWise().then(successGetInvestmentsREportsCustomer, errorGetInvestmentsReportsCustomer);
		}

		function sucessCbUserProfile(response) {
			ShareDataService.storeData('customerDetail', response.data.data);
			$state.go('app.customers.customerhome.userDetail');
		}

		function errorGetUserProfile(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function customerWiseDetials(customer) {
			ServiceProxy.getUserProfile(customer.investorId).then(sucessCbUserProfile, errorGetUserProfile)
		};

		////////////////////////////////////////Get Customer Wise data ends here///////////////////////////////////////////

		////////////////////////////////////////Get Scheme Wise data starts here///////////////////////////////////////////
		function successGetInvestmentsREportsScheme(response) {
			vm.investmentDataSchemeWise = response.data.data.schemes;
		}

		function errorGetInvestmentsReportsScheme(response) {
			if (response && response.data && response.data.data) {
				showDialog(response.data.responseString);
			}
		}

		function getAumInvestmentReportsSchemeWise() {
			ServiceProxy.getAumInvestmentReportsSchemeWise().then(successGetInvestmentsREportsScheme, errorGetInvestmentsReportsScheme);
		}

		function selectTableRow(index) {
			ShareDataService.storeData('schemeInvetsment', vm.investmentDataSchemeWise[index]);
			$state.go('app.aumReport.schemeInvestment')
		};

		////////////////////////////////////////Get Scheme Wise data ends here///////////////////////////////////////////

		///////////////////////////////show error dialog message starts here//////////////////////////////////////////////
		function showDialog(response) {
			var confirm = $mdDialog
				.confirm()
				.title('!!Error!!')
				.textContent(response)
				.ariaLabel('Lucky day')
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ok('OK');
			$mdDialog.show(confirm).then(function () {});
		}
		///////////////////////////////show error dialog message ends here//////////////////////////////////////////////
	}
})();
(function () {
    'use strict';
  
    angular
      .module('app.rmCallingHistory', [
        'ui.calendar'
      ])
      .config(config);
  
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
      var fId = 'SALES::USERS::DASHBOARD';
      // State
      $stateProvider
        .state('app.rmCallingHistory', {
          url: '/rmCallingHistory',
          views: {
            'content@app': {
              templateUrl: 'app/main/Rm-callingHistory/rmCallingHistory.html',
              controller: 'rmCallingHistoryController as vm'
            }
          }
        });
  
        msNavigationServiceProvider.saveItem('DASHBOARD.rmCallingHistory', {
          title: 'Calling History',
          icon: 'icon-comment-account',
          state: 'app.rmCallingHistory',
          weight: 6,
          hidden: function () {
          return false;
          //   if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
          //     return false;
          //   } else {
          //     return true;
          //   }
          }
      });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.rmCallingHistory')
    .controller('rmCallingHistoryController', rmCallingHistoryController);

  /** @ngInject */
  function rmCallingHistoryController($window, ShareDataService, $state, $scope, $mdToast, $mdDialog, $q, $timeout, ServiceProxy, $stateParams, StorageService, $filter) {
    var vm = this;
    vm.downloadDate = new Date();
    vm.getrmsiweexternalfoliodata = getrmsiweexternalfoliodata;
    
    function init() {
      vm.getrmlist = getrmlist;
      vm.datereport = datereport;
      vm.downloadCallHistoryAll = downloadCallHistoryAll;
      vm.eKyc = {
        "01": "UNDER_PROCESS",
        "02": "KYC REGISTERED",
        "03": "ON HOLD",
        "04": "KYC REJECTED",
        "05": "NOT AVAILABLE",
        "06": "Deactivate",
        "07": "KYC VALIDATED",
        "11": "UNDER_PROCESS(OLD record)",
        "12": "KYC REGISTERED(OLD record)",
        "13": "ON HOLD(OLD record)",
        "22": "CVL MF KYC"
      }
      getrmlist();
  
      // Retrieve and parse userDetail
      vm.userDetail = JSON.parse(window.sessionStorage.getItem('userDetail'));
      datereport();
    };
    init();

    function errorGetRmList(response){
      console.log('resErrorGetRmList',response);
    }

    function successGetRmList(response){
      vm.internalUser = response.data.data;
      vm.userDetail.userName = 'ALL';
      vm.internalUser.push(vm.userDetail);
    }

    function getrmlist(){
        ServiceProxy.getrmlist().then(successGetRmList, errorGetRmList);
    }

    // Helper function to format dates as 'DD-MMM-YYYY'
    function formatDate(date) {
      var day = date.getDate().toString().padStart(2, '0');
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var month = monthNames[date.getMonth()];
      var year = date.getFullYear();
      return day+'-'+month+'-'+year;
    }

    function successrmcallinghistory(response) {
        console.log('res', response);
        vm.fetchreport = response.data.responseString;
    }

    function errorrmcallinghistory(response) {
        console.log('errorFoliodata', response);
        showDialog(response.data.responseString);
    }

    function getrmsiweexternalfoliodata() {
      vm.fetchreport = {};
  
      // Ensure userDetail is available before proceeding
      if (vm.userDetail.type === 'SUPER::ADMIN') {
          var id = vm.selectedOption._id;
          var type = vm.selectedOption.type;
      } else {
          var id = vm.userDetail._id;
          var type = vm.userDetail.type; 
      }
  
      var postData = { 
          "userId": id,
          "userType": type,
          "fromdate": formatDate(vm.fromDate),
          "todate": formatDate(vm.toDate)
      };
  
      ServiceProxy.getrmcallinghistory(postData).then(successrmcallinghistory, errorrmcallinghistory);
    }

    function datereport() {
      $scope.assign = {};
      vm.userDetail.userName = 'ALL';
      vm.selectedOption = vm.userDetail;
      var datee = new Date();
      vm.toDate = new Date();
      var fromDate = new Date(datee.setDate(datee.getDate() - 1))
      vm.fromDate = fromDate;
      vm.assign = { todate: formatDate(vm.toDate), fromdate: formatDate(vm.fromDate), userId: vm.userDetail._id, userType: vm.userDetail.type}
      ServiceProxy.getrmcallinghistory(vm.assign).then(successrmcallinghistory, errorrmcallinghistory);
    }

    function downloadCallHistoryAll() {
      if (vm.fetchreport && vm.fetchreport.length > 0) {
          console.log('1', vm.fetchreport);
  
          var csvString = 'Sr No., Name, Mobile, Email, IIN, PAN, KYC Status, Creation Date, Comments, Calling Date Time, Next Follow up Date Time, Advisors Name\n';
  
          for (var i = 0; i < vm.fetchreport.length; i++) { 
            var atDateFormatted = $filter('date')(new Date(vm.fetchreport[i].atDate), 'dd-MM-yyyy') + 
                ' at ' + (vm.fetchreport[i].atHour > 12 ? (vm.fetchreport[i].atHour - 12) : vm.fetchreport[i].atHour) + ':' + 
                (vm.fetchreport[i].atMinute < 10 ? '0' + vm.fetchreport[i].atMinute : vm.fetchreport[i].atMinute) + 
                (vm.fetchreport[i].atHour > 11 ? ' PM' : ' AM');
        
            var nextAtDateFormatted = $filter('date')(new Date(vm.fetchreport[i].nextAtDate), 'dd-MM-yyyy') + 
                ' at ' + (vm.fetchreport[i].nextAtHour > 12 ? (vm.fetchreport[i].nextAtHour - 12) : vm.fetchreport[i].nextAtHour) + ':' + 
                (vm.fetchreport[i].nextAtMinute < 10 ? '0' + vm.fetchreport[i].nextAtMinute : vm.fetchreport[i].nextAtMinute) + 
                (vm.fetchreport[i].nextAtHour > 11 ? ' PM' : ' AM');

            csvString += (i + 1) + ',' +
                (vm.fetchreport[i].userName ? vm.fetchreport[i].userName : "") + ',' +
                (vm.fetchreport[i].mobileNo ? vm.fetchreport[i].mobileNo : "") + ',' +
                (vm.fetchreport[i].email ? vm.fetchreport[i].email : "") + ',' +
                (vm.fetchreport[i].iin ? vm.fetchreport[i].iin : "") + ',' +
                (vm.fetchreport[i].pan ? vm.fetchreport[i].pan : "") + ',' +
                (vm.fetchreport[i].camsKycStatus ? vm.eKyc[vm.fetchreport[i].camsKycStatus] : "") + ',' +
                (vm.fetchreport[i].creationDate ? $filter('date')(new Date(vm.fetchreport[i].creationDate), 'yyyy-MM-dd HH:MM') : "") + ',' +
                (vm.fetchreport[i].comments ? vm.fetchreport[i].comments : "") + ',' +
                atDateFormatted + ',' +
                nextAtDateFormatted + ',' +
                (vm.fetchreport[i].assignedUserName ? vm.fetchreport[i].assignedUserName : "") + '\n';
          }
          
          var a = document.createElement("a");
          a.href = 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString)));
          a.download = 'CallHistory.csv';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);          
  
      } else {
          showDialog('No data found');
      }
    }  

    vm.showDetails = function(logDetails) {
      ServiceProxy.getCallHistory(logDetails.mobileNo).then(successgetCallHistory, errorgetCallHistory);

      function errorgetCallHistory(response){
        console.log('errorgetCallHistory',response);
      }

      function successgetCallHistory(response) {
        var userName = response.data.data[0].userName;
        var logDetails = response.data.data[0].callSchedules;
        console.log('1',response.data.data[0].callSchedules.length);
        if(response.data.data[0].callSchedules.length < 0){
          showDialog("No Data Found...!!!");
        }
    
        $mdDialog.show({
          controller: DialogController,
          template: 
            '<md-dialog aria-label="Log Details" style="max-width: 800px; width: 100%;">' +
              '<md-dialog-content>' +
                '<h4 style="margin-top: 0;">Call History of:{{userName || ""}}</h4>' + 
                '<table style="width: 100%; border-collapse: collapse;">' +
                  '<thead>' +
                    '<tr>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Calling Date</th>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Comment</th>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Next Date</th>' +
                      '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Called By</th>' +
                    '</tr>' +
                  '</thead>' +
                  '<tbody>' +
                    '<tr ng-repeat="log in logDetails">' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{log.atDate | date:"mediumDate"}} at {{log.atHour > 12 ? (log.atHour - 12):log.atHour }}:{{log.atMinute}} {{log.atHour > 11 ? "PM":"AM"}}</td>' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{ log.comments }}</td>' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{log.nextAtDate | date:"mediumDate"}} at {{log.nextAtHour > 12 ? (log.nextAtHour - 12):log.nextAtHour}}:{{log.nextAtMinute }} {{log.nextAtHour > 11 ? "PM":"AM"}}</td>' +
                      '<td style="padding: 15px; border-bottom: 1px solid #ddd;">{{ log.createdBy.userName }}</td>' +
                    '</tr>' +
                  '</tbody>' +
                '</table>' +
              '</md-dialog-content>' +
              '<md-dialog-actions layout="row">' +
                '<md-button class="md-raised md-accent" ng-click="downloadCallHistory(logDetails)" style="color:#fff !important;">' +
                  '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon> Download Call History' +
                '</md-button>' +
                '<md-button ng-click="closeDialog()" class="md-primary">' +
                  'Close' +
                '</md-button>' +
              '</md-dialog-actions>' +
            '</md-dialog>',
          locals: {
              logDetails: logDetails,
              userName: userName
          },
          clickOutsideToClose: true,
          parent: angular.element(document.body),
          controllerAs: 'vm'
        });        
      }
      
      // Dialog Controller
      function DialogController($scope, $mdDialog, logDetails, userName) {
        $scope.logDetails = logDetails;
        $scope.userName = userName;
        
        $scope.closeDialog = function() {
            $mdDialog.hide();
        };

        $scope.downloadCallHistory = function(log) {
          console.log('1',log);

          if(!log && log.length < 1){
            showDialog("No Data Found...!!!");
          }else{
            var csvString = 'Calling Date, Comment, Next Date, Called By,' + "\n";
              for (var i = 0; i < log.length; i++) { 
                var atDateFormatted = $filter('date')(new Date(log[i].atDate), 'dd-MM-yyyy') + 
                    ' at ' + (log[i].atHour > 12 ? (log[i].atHour - 12) : log[i].atHour) + ':' + 
                    (log[i].atMinute < 10 ? '0' + log[i].atMinute : log[i].atMinute) + 
                    (log[i].atHour > 11 ? ' PM' : ' AM');
            
                var nextAtDateFormatted = $filter('date')(new Date(log[i].nextAtDate), 'dd-MM-yyyy') + 
                    ' at ' + (log[i].nextAtHour > 12 ? (log[i].nextAtHour - 12) : log[i].nextAtHour) + ':' + 
                    (log[i].nextAtMinute < 10 ? '0' + log[i].nextAtMinute : log[i].nextAtMinute) + 
                    (log[i].nextAtHour > 11 ? ' PM' : ' AM');
            
                csvString = csvString.concat(
                    atDateFormatted + ',' +
                    (log[i].comments ? log[i].comments : "") + ',' +
                    nextAtDateFormatted + ',' +
                    (log[i].createdBy && log[i].createdBy.userName ? log[i].createdBy.userName : "") + ','
                );
                csvString = csvString + "\n";                
            }
            var a = $('<a/>', {
              href:'data:application/octet-stream;base64,'+btoa(unescape(encodeURIComponent(csvString))),
              download:'CallHistory.csv'
            }).appendTo('body')
            a[0].click()
            a.remove();
          };
        }
      } 
		};

    function showDialogSucc(response) {
      var confirm = $mdDialog
        .confirm()
        .title('Success')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () { });
    }
    
    function showDialog(response) {
      var confirm = $mdDialog
        .confirm()
        .title('!!Error!!')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {});
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.advisoryDashboard', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    var fId = 'ADVISORY::USERS::DASHBOARD';
    // State
    $stateProvider
      .state('app.advisoryDashboard', {
        url: '/advisorydashboard',
        views: {
          'content@app': {
            templateUrl: 'app/main/advisory-dashboard/advisory-dashboard.html',
            controller: 'AdvisoryDashboardController as vm'
          }
        },
        data: {
          access: function () {
            if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
              return true;
            } else {
              return false;
            }
          }
        }
      });
    // .state('app.assignmentDashboard.documentVerification', {
    //   url: '/documentVerification/:userId',
    //   views: {
    //     'content@app': {
    //       templateUrl: 'app/main/assignment-dashboard/document-verification/document-verification.html',
    //       controller: 'DocumentVerificationController as vm'
    //     }
    //   },
    //   data: {
    //     access: function () {
    //       return true;
    //       // if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
    //       //   return true;
    //       // } else {
    //       //   return false;
    //       // }
    //     }
    //   }
    // });

    msNavigationServiceProvider.saveItem('DASHBOARD.advisoryDashboard', {
      title: 'Advisory Dashboard',
      state: 'app.advisoryDashboard',
      icon: 'icon-tile-four',
      weight: 4,
      hidden: function () {
        // return false;
        if ((JSON.parse(window.sessionStorage.getItem('type')) === 'SUPER::ADMIN') || (window.sessionStorage.getItem('feature') && (JSON.parse(window.sessionStorage.getItem('feature').indexOf(fId)) !== -1))) {
          return false;
        } else {
          return true;
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.advisoryDashboard')
    .controller('AdvisoryDashboardController', AdvisoryDashboardController);

  /** @ngInject */
  function AdvisoryDashboardController($window, $mdSidenav, $state, $mdToast, $mdDialog, ServiceProxy, ShareDataService) {
    var vm = this;

    function init() {
      vm.toggleCalender = toggleSidenav('right');
      vm.events = [
        []
      ];
      vm.eKyc = {
        "01": "UNDER_PROCESS",
        "02": "KYC REGISTERED",
        "03": "ON HOLD",
        "04": "KYC REJECTED",
        "05": "NOT AVAILABLE",
        "06": "Deactivate",
        "07": "KYC VALIDATED",
        "11": "UNDER_PROCESS(OLD record)",
        "12": "KYC REGISTERED(OLD record)",
        "13": "ON HOLD(OLD record)",
        "22": "CVL MF KYC"
      }
      vm.calendarUiConfig = {
        calendar: {
          height: '400px',
          editable: true,
          eventLimit: true,
          header: '',
          handleWindowResize: false,
          aspectRatio: 1,
          dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          viewRender: function (view) {
            vm.calendarView = view;
            vm.calendar = vm.calendarView.calendar;
            vm.currentMonthShort = vm.calendar.getDate().format('MMM');
          },
          columnFormat: {
            month: 'ddd',
            week: 'ddd D',
            day: 'ddd M'
          },
          eventClick: eventDetail,
          selectable: true,
          selectHelper: true,
          select: select,
        }
      };
      vm.addEvent = addEvent;
      vm.next = next;
      vm.prev = prev;
      vm.commentStrings = ['Not Picking Call', 'Not Reachable', 'Wrong Number', 'Re Schedule', 'Other']
      vm.selectedFilter = selectedFilter;
      vm.selectedCustomFilter = selectedCustomFilter;
      vm.setReviewDate = setReviewDate;
      vm.setPotentialScale = setPotentialScale;
      vm.resetPriority = resetPriority;
      vm.openReviewSideNav = openReviewSideNav;
      vm.flagActivityDialog = flagActivityDialog;
      vm.openSidenav = openSidenav;
      vm.closeSidenav = closeSidenav;
      vm.changeNextHour = changeNextHour;
      vm.changeNextDetect = changeNextDetect;
      vm.createCall = createCall;
      vm.changeHour = changeHour
      vm.changeDetect = changeDetect;
      vm.goToCustomerDetail = goToCustomerDetail;
      vm.clearCalendarData = clearCalendarData;
      vm.filterCustomerByPotentialLevel = filterCustomerByPotentialLevel;
      vm.closeEnquiryFlag = closeEnquiryFlag;
      vm.closeEnquiryDialog = closeEnquiryDialog;
      vm.reviewCallHistory = reviewCallHistory;
      if (ShareDataService.getData('advisoryState')) {
        vm.filterType = ShareDataService.getData('advisoryState').categoryFilter || 'Assigned';
        vm.subFilter = ShareDataService.getData('advisoryState').subFilter || 'ALL';;
      } else {
        vm.filterType = 'Assigned';
        vm.subFilter = 'ALL';
      }
      getAdvisoryDashboardCount();
      vm.selectedFilter(vm.filterType);
      getAdvisoryCalendarData();
      vm.openHistorySidenav = openHistorySidenav;
      vm.openEnquirySideNav = openEnquirySideNav;
      vm.openEMandateSideNav = openEMandateSideNav;
      vm.disableEMandateSubmit = disableEMandateSubmit;
      vm.registerCustMandate = registerCustMandate;
      vm.bankname = '';
      vm.branchname = '';
      vm.ifsccode = ''; 
      vm.accno = '';
      vm.accounttype = '';
      vm.ach_amount = 0;
      
      vm.chanelList = [
        { id: 'NET', name: 'Net Banking' },
        { id: 'DC', name: 'Debit Card' }
      ];
      vm.selectedChanel = vm.chanelList[1]; //{ id: 'DC', name: 'Debit Card' };

      getAllInternalUser();
      vm.assignInternalUser = assignInternalUser;
    };
    init();

    //////////////////////////////   Start of Internal User Assignment  //////////////////////////////
    function getAllInternalUser() {
      ServiceProxy.getAllInternalUser().then(sucessCbGetAllInternalUser, errorCbGetAllInternalUser)
    }

    function sucessCbGetAllInternalUser(response) {
      vm.overAllUser = response.data.data;
      vm.allInternalUsers = response.data.data;
      vm.placeholder = 'Assign Customer Support';
      vm.allInternalUsers = vm.overAllUser.filter(function (item) {
        return (item.type === 'SALES::USER' ||item.type === 'FINANCE::USER' );
      })
    }

    function errorCbGetAllInternalUser(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function assignInternalUser(user) {
      var data = {
        assignedUserId: user.assignedUser._id,
        investorsIds: [user._id]
      }
      ServiceProxy.assignToInternalUser(data).then(function (response) {
        sucessCbAssignToInternalUser(user, response)
      }, errorCbAssignToInternalUser)
    }

    function sucessCbAssignToInternalUser(user, response) {
      resetData();
    }

    function errorCbAssignToInternalUser(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    //////////////////////////////   End Of Assignment     //////////////////////////////
    
    function openHistorySidenav(component, user) {
      $mdSidenav(component).toggle()
      vm.callHistory = user;
      // return function () {
      //   $mdSidenav(component).toggle()
      // };
    }    

    function openEnquirySideNav(component, user) {
      $mdSidenav(component).toggle()
      vm.userEnquiry = user;
      
    }
    

    /**
     * Go to next on current view (week, month etc.)
     */
    function next() {
      vm.calendarView.calendar.next();
    }

    /**
     * Go to previous on current view (week, month etc.)
     */
    function prev(evt) {
      var currentMonth = new Date().getMonth();
      var prevMonth = new Date($('[ui-calendar]').fullCalendar('getDate')._d).getMonth() - 1;

      if (currentMonth <= prevMonth) {
        vm.calendarView.calendar.prev();
      }

    }

    function addEvent(e) {
      var start = new Date(),
        end = new Date();

      // showEventFormDialog('add', false, start, end, e);
    }

    function eventDetail(calendarEvent, e) {
      vm.toggleCalender();
      if (calendarEvent.callType === 'followUp') {
        vm.calendarText = 'Followup Calls on ' + new Date(calendarEvent.dateData).toLocaleDateString();
        getAdvisoryFollowupCallData(calendarEvent.dateData);
      } else if (calendarEvent.callType === 'review') {
        vm.calendarText = 'Review Calls on ' + new Date(calendarEvent.dateData).toLocaleDateString();
        getAdvisoryReviewCallData(calendarEvent.dateData);
      }
    }

    function select(start, end, e) {
      // showEventFormDialog('add', false, start, end, e);
    }

    function toggleSidenav(componentId) {

      return function () {
        $mdSidenav(componentId).toggle().then(function () {
          if (componentId === 'right') {
            $('[ui-calendar]').fullCalendar('changeView', 'month');
            // $('#calendarView').fullCalendar('refetchEvents')
          }
        });
      };
    }

    function showDialog(response) {
      var confirm = $mdDialog.confirm()
       // .title('!!Error!!')
        .title('')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm);
    };


    ///////////////////aPI for Assigned Customer//////////////////////
    function sucessCbGetAdvisoryAssignedCustomer(response) {
      vm.advisoryAllCustomer = response.data.data;
      selectedCustomFilter();
      getAdvisoryDashboardCount()
    }

    function errorCbGetAdvisoryAssignedCustomer(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryAssignedCustomer() {
      vm.calendarText = '';
      ServiceProxy.getAdvisoryAssignedCustomer().then(sucessCbGetAdvisoryAssignedCustomer, errorCbGetAdvisoryAssignedCustomer)
    }

    ///////////////////aPI for Investing Customer//////////////////////
    function sucessCbGetAdvisoryInvestingCustomer(response) {
      vm.advisoryAllCustomer = response.data.data;
      selectedCustomFilter();
      getAdvisoryDashboardCount()
    }

    function errorCbGetAdvisoryInvestingCustomer(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryInvestingCustomer() {
      vm.calendarText = '';
      ServiceProxy.getAdvisoryInvestingCustomer().then(sucessCbGetAdvisoryInvestingCustomer, errorCbGetAdvisoryInvestingCustomer)
    }
    ///////////////////aPI for Non Investing Customer//////////////////////
    function sucessCbGetAdvisoryNonInvestingCustomer(response) {
      vm.advisoryAllCustomer = response.data.data;
      selectedCustomFilter();
      getAdvisoryDashboardCount()
    }

    function errorCbGetAdvisoryNonInvestingCustomer(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryNonInvestingCustomer() {
      vm.calendarText = '';
      ServiceProxy.getAdvisoryNonInvestingCustomer().then(sucessCbGetAdvisoryNonInvestingCustomer, errorCbGetAdvisoryNonInvestingCustomer)
    }

    ///////////////////aPI for Non Review Today Customer//////////////////////
    function sucessCbGetAdvisoryReviewTodayCustomer(response) {
      vm.advisoryAllCustomer = response.data.data;
      selectedCustomFilter();
      getAdvisoryDashboardCount()
    }

    function errorCbGetAdvisoryReviewTodayCustomer(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryReviewTodayCustomer() {
      vm.calendarText = '';
      ServiceProxy.getAdvisoryReviewTodayCustomer().then(sucessCbGetAdvisoryReviewTodayCustomer, errorCbGetAdvisoryReviewTodayCustomer)
    }

    ///////////////////aPI for FollowUp Customer//////////////////////
    function sucessCbGetAdvisoryFollowUpCustomer(response) {
      vm.advisoryAllCustomer = response.data.data;
      getAdvisoryDashboardCount();
      selectedCustomFilter();
    }

    function errorCbGetAdvisoryFollowUpCustomer(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryFollowUpCustomer() {
      vm.calendarText = '';
      ServiceProxy.getAdvisoryFollowUpCustomer().then(sucessCbGetAdvisoryFollowUpCustomer, errorCbGetAdvisoryFollowUpCustomer)
    }

    ///////////////////aPI for Dashboard Count//////////////////////
    function sucessCbGetAdvisoryDashboardCount(response) {
      vm.dashboardCount = response.data.data;
    }

    function errorCbGetAdvisoryDashboardCount(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryDashboardCount() {
      ServiceProxy.getAdvisoryDashboardCount().then(sucessCbGetAdvisoryDashboardCount, errorCbGetAdvisoryDashboardCount)
    }
    ///////////////////////////////filter function

    function selectedFilter(type) {
      vm.filterType = type;
      getAdvisoryDashboardCount();
      if (vm.filterType === 'Assigned') {
        getAdvisoryAssignedCustomer();
      } else if (vm.filterType === 'Investing') {
        getAdvisoryInvestingCustomer();
      } else if (vm.filterType === 'NonInvesting') {
        getAdvisoryNonInvestingCustomer();
      } else if (vm.filterType === 'ReviewToday') {
        getAdvisoryReviewTodayCustomer();
      } else if (vm.filterType === 'FollowUpToday') {
        getAdvisoryFollowUpCustomer();
      }
    }


    //////////////////filter customer base on sub filter
    function selectedCustomFilter() {
      vm.selectedCustomer = [];
      if (vm.subFilter === 'ALL') {
        vm.selectedCustomer = vm.advisoryAllCustomer;
      } else if (vm.subFilter === 'SIP') {
        vm.selectedCustomer = vm.advisoryAllCustomer.filter(function (item) {
          if (item.sipPurchaseFlag && !item.lumpsumPurchaseFlag) {
            return item.sipPurchaseFlag;
          }
        });
      } else if (vm.subFilter === 'LUMPSUM') {
        vm.selectedCustomer = vm.advisoryAllCustomer.filter(function (item) {
          if (!item.sipPurchaseFlag && item.lumpsumPurchaseFlag) {
            return item.lumpsumPurchaseFlag;
          }
        });
      } else if (vm.subFilter === 'BOTH') {
        vm.selectedCustomer = vm.advisoryAllCustomer.filter(function (item) {
          return item.lumpsumPurchaseFlag && item.sipPurchaseFlag;

        });
      } else if (vm.subFilter === 'PRIORITY') {
        vm.selectedCustomer = vm.advisoryAllCustomer.filter(function (item) {
          if (item.priorityFlag) {
            return item.priorityFlag;
          }

        });
      } else if (vm.subFilter === 'ENQUIRY') {
        vm.selectedCustomer = vm.advisoryAllCustomer.filter(function (item) {
          if (item.enquiries && item.enquiries.length > 0) {
            return item.enquiries;
          }

        });
      }
      // else if (vm.subFilter === 'POTENTIAL') {
      //   vm.selectedCustomer = vm.advisoryAllCustomer.filter(function (item) {
      //     if (item.potentialScale) {
      //       return item.potentialScale;
      //     }

      //   });
      // }

    }

    //////////////////////// Set Review Date/////////////////
    function successCbSetReviewDate(response) {
      $mdSidenav('reviewSideNav').close()
      // vm.selectedFilter(vm.filterType);
      resetData();
    }

    function errorCbSetReviewDate(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function setReviewDate(user) {
      var data = {
        "reviewPendingFlag": false,
        "reviewPendingFlagComments": user.reviewPendingFlagComments,
        "reviewPendingFlagDate": user.reviewPendingFlagDate.setHours(0, 0, 0, 0),
        "reviewPendingFlagTime": user.reviewPendingFlagTime,
        "reviewPendingCloseFlag": false
      }
      ServiceProxy.setReviewDate(user._id, data).then(successCbSetReviewDate, errorCbSetReviewDate)
    }


    ////////////////////Set Potential Scale////////////////////////////

    function sucessCbSetPotentialScale(response) {
      // vm.selectedFilter(vm.filterType);
      resetData();
    }

    function errorCbSetPotentialScale(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function setPotentialScale(user) {
      var data = {
        potentialScale: user.potentialScale
      }
      ServiceProxy.setPotentialScale(user._id, data).then(sucessCbSetPotentialScale, errorCbSetPotentialScale)
    }


    ////////////////// Function Reset priority flag///////////////////////
    function successCbResetPriority(response) {
      resetData();
      // vm.selectedFilter(vm.filterType);
    }

    function errorCbResetPriority(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function resetPriority(user) {
      var confirm = $mdDialog.confirm()
        //.title('!!Error!!')
        .title('')
        .textContent('Do you want to reset Priority of ' + user.userName + ' ?')
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function (result) {
        if (result) {
          var data = {
            "priorityFlag": false
          }
          ServiceProxy.resetPriorityFlag(user._id, data).then(successCbResetPriority, errorCbResetPriority)
        }
      });

    }


    //////review Call Record Sidenav
    function openReviewSideNav(user) {
      vm.reviewUserData = user;
      // toggleSidenav('reviewSideNav')
      $mdSidenav('reviewSideNav').toggle()
    }
    /////////////////////////////Flag Activty Method///////////////////////////////////////////
    function flagActivityDialog(evt, customer, key) {
      evt.stopPropagation();
      $mdDialog.show({
          locals: {
            data: customer,
            key: key
          },
          controller: 'FlagActivityController as vm',
          templateUrl: 'app/main/customers/flag-activity/flag-activity.html',
          parent: angular.element(document.body),
          targetEvent: evt,
          clickOutsideToClose: true,
        })
        .then(function (answer) {
          if (answer) {
            resetData();
            // vm.selectedFilter(vm.filterType);
          }
        }, function () {
          // $scope.status = 'You cancelled the dialog.';
        });
    }

    function openSidenav(user, type, review) {
      vm.activeUser = user;
      if (type === 'last') {
        if (user.callSchedules.length > 0) {
          vm.callingDetail = user.callSchedules[0];
          vm.callingDetail.scheduleId = user.callSchedules[0]._id;
          vm.callingDetail.atDate = new Date(vm.callingDetail.atDate);
          vm.callingDetail.nextAtDate = new Date(vm.callingDetail.nextAtDate);
          if (vm.commentStrings.indexOf(vm.callingDetail.comments) === -1) {
            vm.callingDetail.other = vm.callingDetail.comments
            vm.callingDetail.comments = vm.commentStrings[vm.commentStrings.length - 1];
          }
        } else {
          return;
        }

      } else if (type === 'new') {
        vm.callingDetail = {};

        vm.callingDetail.nextAtHour = 0;
        vm.callingDetail.nextAtMinute = 0;
        vm.callingDetail.atDate = new Date();
        vm.callingDetail.atHour = new Date().getHours();
        vm.callingDetail.atMinute = new Date().getMinutes();
      }
      vm.reviewClickedStatus = review;
      $mdSidenav('callingSidebar').toggle();
    }

    function closeSidenav() {
      vm.reviewClickedStatus = null;
      $mdSidenav('callingSidebar').close();
    }


    function changeHour(type, growth) {
      if (type === 'hour') {
        if (growth === 'plus' && +vm.callingDetail.atHour < 23) {
          vm.callingDetail.atHour++;
        } else if (growth === 'minus' && +vm.callingDetail.atHour > 0) {
          vm.callingDetail.atHour--;
        } else {
          return;
        }
      } else if (type === 'minute') {
        if (growth === 'plus' && +vm.callingDetail.atMinute < 59) {
          vm.callingDetail.atMinute++;
        } else if (growth === 'minus' && +vm.callingDetail.atMinute > 0) {
          vm.callingDetail.atMinute--;
        } else {
          return;
        }
      }
    }

    function changeDetect(type) {
      if (type === 'hour') {
        if (+vm.callingDetail.atHour < 0) {
          vm.callingDetail.atHour = 0
        } else if (vm.callingDetail.atHour > 23) {
          vm.callingDetail.atHour = 23;
        }
        vm.callingDetail.atHour = Math.floor(+vm.callingDetail.atHour);
      } else if (type === 'minute') {
        if (+vm.callingDetail.atMinute < 0) {
          vm.callingDetail.atMinute = 0
        } else if (vm.callingDetail.atMinute > 59) {
          vm.callingDetail.atMinute = 59;
        }
        vm.callingDetail.atMinute = Math.floor(+vm.callingDetail.atMinute);
      }
    }

    function changeNextHour(type, growth) {
      if (type === 'hour') {
        if (growth === 'plus' && +vm.callingDetail.nextAtHour < 23) {
          vm.callingDetail.nextAtHour++;
        } else if (growth === 'minus' && +vm.callingDetail.nextAtHour > 0) {
          vm.callingDetail.nextAtHour--;
        } else {
          return;
        }
      } else if (type === 'minute') {
        if (growth === 'plus' && +vm.callingDetail.nextAtMinute < 59) {
          vm.callingDetail.nextAtMinute++;
        } else if (growth === 'minus' && +vm.callingDetail.nextAtMinute > 0) {
          vm.callingDetail.nextAtMinute--;
        } else {
          return;
        }
      }
    }

    function changeNextDetect(type) {
      if (type === 'hour') {
        if (+vm.callingDetail.nextAtHour < 0) {
          vm.callingDetail.nextAtHour = 0
        } else if (vm.callingDetail.nextAtHour > 23) {
          vm.callingDetail.nextAtHour = 23;
        }
        vm.callingDetail.nextAtHour = Math.floor(+vm.callingDetail.nextAtHour);
      } else if (type === 'minute') {
        if (+vm.callingDetail.nextAtMinute < 0) {
          vm.callingDetail.nextAtMinute = 0
        } else if (vm.callingDetail.nextAtMinute > 59) {
          vm.callingDetail.nextAtMinute = 59;
        }
        vm.callingDetail.nextAtMinute = Math.floor(+vm.callingDetail.nextAtMinute);
      }
    }

    //////////////////////////Record Call Function//////////////////////
    function sucessCbCreateCall(response) {
      if (vm.reviewClickedStatus) {
        setReviewFlag(vm.activeUser._id);
      }
      vm.callingDetail = {};
      vm.callingDetail.atHour = 0;
      vm.callingDetail.atMinute = 0;
      vm.callingDetail.nextAtHour = 0;
      vm.callingDetail.nextAtMinute = 0;
      $mdSidenav('callingSidebar').close();

      if (vm.notInterested) {
        openDialogNotInterested();
      } else {
        resetData();
      }


    }

    function errorCbCreateCall(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function createCall() {
      if (vm.callingDetail.comments === 'Other') {
        vm.callingDetail.comments = vm.callingDetail.other;
      }
      vm.callingDetail.atDate = vm.callingDetail.atDate.setHours(0, 0, 0, 0);
      if (vm.callingDetail.nextAtDate) {
        vm.callingDetail.nextAtDate = vm.callingDetail.nextAtDate.setHours(0, 0, 0, 0);
      }

      if (vm.callingDetail.scheduleId) {
        ServiceProxy.updateCallSchedule(vm.activeUser._id, vm.callingDetail).then(sucessCbCreateCall, errorCbCreateCall)
      } else {
        ServiceProxy.createCall(vm.activeUser._id, vm.callingDetail).then(sucessCbCreateCall, errorCbCreateCall)
      }

    }


    ////////////////////function goto customer detail page///////////////////////

    function sucessCbUserProfile(response) {
      response.data.data.baseUrl = vm.baseUrl;
      ShareDataService.storeData('customerDetail', response.data.data);
      var advisoryState = {
        categoryFilter: vm.filterType,
        subFilter: vm.subFilter
      }
      ShareDataService.storeData('advisoryState', advisoryState);
      $state.go('app.customers.customerhome.userDetail');
    }

    function errorGetUserProfile(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function goToCustomerDetail(customer) {
      ServiceProxy.getUserProfile(customer._id).then(sucessCbUserProfile, errorGetUserProfile)
    };
    //////////////////////////API for Calendar data

    function successCbGetAdvisoryCalendarData(response) {

      // vm.calenderCallData = response.data.data;
      var tempArray = []
      angular.forEach(response.data.data, function (item, index) {
        if (item.reviewCount > 0) {
          var obj = {
            id: index + 1,
            nextAtDate: new Date(item.year, item.month - 1, item.day),
            title: item.reviewCount + ' Review Call ',
            start: new Date(item.year, item.month - 1, item.day),
            dateData: item.date,
            callType: 'review',
            end: null
          };
          tempArray.push(obj)
        }

        if (item.followUpCount > 0) {
          var objR = {
            id: index + 1,
            nextAtDate: new Date(item.year, item.month - 1, item.day),
            title: item.followUpCount + ' Followup Call',
            start: new Date(item.year, item.month - 1, item.day),
            dateData: item.date,
            callType: 'followUp',
            end: null
          };
          tempArray.push(objR)
        }
      })
      vm.events[0] = tempArray;
    }

    function errorCbGetAdvisoryCalendarData(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryCalendarData() {
      ServiceProxy.getAdvisoryCalendarData().then(successCbGetAdvisoryCalendarData, errorCbGetAdvisoryCalendarData)
    }

    //////////////////////////Review Call Data///////////////////////

    function sucessCbGetAdvisoryReviewCallData(response) {
      vm.selectedCustomer = response.data.data;
    }

    function errorCbGetAdvisoryReviewCallData(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryReviewCallData(date) {
      ServiceProxy.getAdvisoryReviewCallData(date).then(sucessCbGetAdvisoryReviewCallData, errorCbGetAdvisoryReviewCallData)
    }

    //////////////////////////FoloowUP Call Data///////////////////////

    function sucessCbGetAdvisoryFollowupCallData(response) {
      vm.selectedCustomer = response.data.data;
    }

    function errorCbGetAdvisoryFollowupCallData(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function getAdvisoryFollowupCallData(date) {
      ServiceProxy.getAdvisoryFollowupCallData(date).then(sucessCbGetAdvisoryFollowupCallData, errorCbGetAdvisoryFollowupCallData)
    }

    //// calendar data clear close
    function clearCalendarData() {
      vm.calendarText = null;
      vm.selectedFilter(vm.filterType);
    }

    // filte by potential level

    function filterCustomerByPotentialLevel() {
      vm.selectedCustomer = vm.advisoryAllCustomer.filter(function (item) {
        // if (item.potentialScale) {
        //   return item.potentialScale === vm.selectedPotential;
        // }
        return item.potentialScale === vm.selectedPotential;

      });
    }


    /////////////////////////API call to close enquiry flag///////////////////////////////////


    function sucessCbCloseEnquiryFlag(response) {
      var index = vm.userEnquiry.enquiries.findIndex(function (item) {
        return item._id === response.data.data._id;
      });
      vm.userEnquiry.enquiries[index].closeFlag = response.data.data.closeFlag
      resetData();
    }

    function errorCbCloseEnquiryFlag(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

    function closeEnquiryFlag(enquiryId) {
      var data = {
        "closeFlag": true
      };
      ServiceProxy.closeEnquiryFlag(enquiryId, data).then(sucessCbCloseEnquiryFlag, errorCbCloseEnquiryFlag)
    }

    function closeEnquiryDialog(enquiry) {
      var confirm = $mdDialog.confirm()
        //.title('!!Error!!')
        .title('')
        .textContent('Do you want to close this enquiry?')
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function (res) {
        if (res) {
          closeEnquiryFlag(enquiry._id)
        }
      })
    }
    ////////////////////ResetFunction To get ALl Data Again//////////////////////

    function resetData() {
      getAdvisoryDashboardCount();
      vm.selectedFilter(vm.filterType);
      getAdvisoryCalendarData();
    }

    ///////////////////////not interested API

    function openDialogNotInterested() {
      // if (!vm.notInterested) {
      //   return;
      // }
      var confirm = $mdDialog.confirm()
        //.title('!!Error!!')
        .title('')
        .textContent('Do You really want to set user ' + vm.activeUser.userName + ' as not Interested?')
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK')
        .cancel('Cancel');;
      $mdDialog.show(confirm).then(function (res) {
        if (res) {
          setNotInterested(vm.activeUser)
        }
      }, function () {
        vm.notInterested = false;
      });
    };

    function sucessCbSetNotInterested(response) {
      resetData();
    }

    function errorCbSetNotInterested(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function setNotInterested(user) {
      // evt.stopPropagation();
      var data = {
        "notInterestedFlag": true
      };
      ServiceProxy.setNotInterested(user._id, data).then(sucessCbSetNotInterested, errorCbSetNotInterested)
    }
    /////////////////////////Segt Review Flag/////////////////////////
    function successCbSetReviewFlag(response) {}

    function errorCbSetReviewFlag(response) {}

    function setReviewFlag(userId) {
      var data = {
        "reviewPendingFlag": false, // set false if its is true
        "reviewPendingFlagComments": "reviewed!", // do hard code "reviewed"
      };
      ServiceProxy.updateFlags(data, userId).then(successCbSetReviewFlag, errorCbSetReviewFlag)
    }

    ///////////////////////////Review Call History ///////////////////////////////////
    function successCbReviewCallHistory(response) {
      vm.callHistory.reviewCalls = response.data.data;
    }

    function errorCbReviewCallHistory(response) {
      if (response && response.data && response.data.data) {
        showDialog(response.data.responseString);
      } else {
        showDialog('Please Try Again.')
      }
    }

    function reviewCallHistory(userId) {
      ServiceProxy.reviewCallHistory(userId).then(successCbReviewCallHistory, errorCbReviewCallHistory)
    }

    /////////////////////// E-Mandate Registration ////////////////////////
    function openEMandateSideNav(component, user) {
      $mdSidenav(component).toggle();
      vm.userEnquiry = user;
      vm.ach_amount = 0;                  
      vm.bankname = user.nseData.BANK_NAME;
      vm.branchname = user.nseData.BRANCH_NAME;
      vm.ifsccode = user.nseData.IFSC_CODE; 
      vm.accno = user.nseData.AC_NO;
      vm.accounttype = user.nseData.AC_TYPE;
      vm.investor_name = user.userName;
      vm.selectedChanel = vm.chanelList[1];
      vm.selectedAccount = null;
    
      function successGetBankAccount(response) {
        vm.bankdetails = response.data.data;
      }
    
      function errorGetBankAccount(response) {
        console.log('err', response);
      }
    
      function getBankAccount(userId) {
        ServiceProxy.getBankAccount(userId).then(successGetBankAccount, errorGetBankAccount);
      }
    
      getBankAccount(user.iin);
    }    
    

    function disableEMandateSubmit(){
      //console.log(vm.bankdetails);
      // if(!vm.ach_amount || !vm.bankname || !vm.ifsccode || !vm.accno) 

      if(!vm.ach_amount || !vm.bankdetails[0].BANK_NAME || !vm.ifsccode || !vm.accno) 
        return true;      
      return false;
    }

    function registerCustMandate() {
      if(!vm.selectedAccount) {
        alert('Please select a bank account.');
        return;
      }
    
      // var data = {
      //   iin: vm.userEnquiry.iin,
      //   achAmount: vm.ach_amount,
      //   chanel: vm.selectedChanel.id,
      //   bankName: vm.selectedAccount.BANK_CODE,
      //   branchName: vm.selectedAccount.BRANCH_NAME,
      //   ifscCode: vm.selectedAccount.IFSC_CODE,
      //   accNo: vm.selectedAccount.AC_NO,
      //   accType: vm.selectedAccount.AC_TYPE,
      //   investor_name: vm.selectedAccount.BANK_HOLDER_NAME || vm.investor_name
      // };

      if(vm.ach_amount < 0) {
        alert('ACH amount should not be negative');
        return;
      }

      if(!vm.userEnquiry.email) {
        alert('Customer email address not found.');
        return;
      }

    var data = { 
      iin: vm.userEnquiry.iin,
      achAmount: vm.ach_amount,
      chanel: vm.selectedChanel.id,
      bankName: vm.selectedAccount.BANK_NAME,
      branchName: vm.selectedAccount.BRANCH_NAME,
      ifscCode: vm.selectedAccount.IFSC_CODE,
      accNo: vm.selectedAccount.AC_NO,
      accType: vm.selectedAccount.AC_TYPE,
      investor_name: vm.selectedAccount.BANK_HOLDER_NAME || vm.investor_name
    };

      ServiceProxy.registerCustomerAchMandate(data).then(sucessCbRegisterCustMandate, errorCbRegisterCustMandate)
    }
    
    function sucessCbRegisterCustMandate(response) {
      if(response && response.data) {
        showDialog(response.data.responseString);
        vm.openHistorySidenav('eMandateSideNav');
      }
    }
    
    function errorCbRegisterCustMandate(response) {
      if (response && response.data) {
        showDialog(response.data.responseString);
      }
    }

  }
})();
(function () {
    'use strict';
  
    angular
      .module('app.rmfoliodata', [
        'ui.calendar'
      ])
      .config(config);
  
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
      var fId = 'SALES::USERS::DASHBOARD';
      // State
      $stateProvider
        .state('app.rmfoliodata', {
          url: '/rmfoliodata',
          views: {
            'content@app': {
              templateUrl: 'app/main/Mf-centralExternalFolioData/rmfoliodata.html',
              controller: 'rmfoliodataController as vm'
            }
          }
          
        });
  
  
        msNavigationServiceProvider.saveItem('DASHBOARD.rmfoliodata', {
            title: 'MF Central Usage Report',
            icon: 'icon-comment-account',
            state: 'app.rmfoliodata',
            weight: 5,
      
      });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.rmfoliodata')
    .controller('rmfoliodataController', rmfoliodataController);

  /** @ngInject */
  function rmfoliodataController($window, ShareDataService, $state, $scope, $mdToast, $mdDialog, $q, $timeout, ServiceProxy, $stateParams, StorageService, $filter) {
    var vm = this;
    vm.downloadDate = new Date();
    vm.getrmsiweexternalfoliodata = getrmsiweexternalfoliodata;
    
    function init() {
      vm.getrmlist = getrmlist;
      vm.datereport = datereport;
      vm.downloadCustomerList = downloadCustomerList;
      getrmlist();
  
      // Retrieve and parse userDetail
      vm.userDetail = JSON.parse(window.sessionStorage.getItem('userDetail'));
      datereport();
    };
    init();

    function errorGetRmList(response){
      console.log('resErrorGetRmList',response);
    }

    function successGetRmList(response){
      vm.internalUser = response.data.data;
      vm.userDetail.userName = 'ALL';
      vm.internalUser.push(vm.userDetail);
    }

    function getrmlist(){
        ServiceProxy.getrmlist().then(successGetRmList, errorGetRmList);
    }

    // Helper function to format dates as 'DD-MMM-YYYY'
    function formatDate(date) {
      var day = date.getDate().toString().padStart(2, '0');
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var month = monthNames[date.getMonth()];
      var year = date.getFullYear();
      return day+'-'+month+'-'+year;
  }    

    function successFoliodata(response) {
      console.log('successFoliodata', response);
      vm.fetchreport = response;
    }

    function errorFoliodata(response) {
        console.log('errorFoliodata', response);
        showDialog(response.data.responseString);
    }

    function getrmsiweexternalfoliodata() {
      vm.fetchreport = {};
  
      // Ensure userDetail is available before proceeding
      if (vm.userDetail.type === 'SUPER::ADMIN') {
          var id = vm.selectedOption._id;
          var type = vm.selectedOption.type; 
      } else {
          var id = vm.userDetail._id;
          var type = vm.userDetail.type; 
      }
  
      var postData = { 
          "userId": id,  
          "userType": type,
          "fromdate": formatDate(vm.fromDate),
          "todate": formatDate(vm.toDate)
      };
  
      ServiceProxy.getrmsiweexternalfoliodata(postData).then(successFoliodata, errorFoliodata);
    }

    function downloadCustomerList() {
      // Check if fetchreport data exists
      if (!vm.fetchreport || !vm.fetchreport.data || vm.fetchreport.data.totalCount === 0) {
          showDialog("No Data Found...!!!");
          return;
      }
      
      var data = vm.fetchreport.data.responseString;
      
      // Create CSV header
      var csvString = 'PAN, User Name, Email, Mobile No, Total Current Market Value, Total Cost Value, Customer Type, Count\n';
      
      // Add data rows
      for (var i = 0; i < data.length; i++) {
          var row = data[i];
          var customerType = (row.isOldUser === 'YES') ? 'Old User' : 'New User';
          csvString += (row.pan || '') + ',' +
                      (row.userName || '').replace(/,/g, ' ') + ',' +
                      (row.email || '') + ',' +
                      (row.mobileNo || '') + ',' +
                      (row.totalCurrentMktValue || '0') + ',' +
                      (row.totalCostValue || '0') + ',' +
                      (customerType || '') + ',' +
                      (row.count || '') + '\n';
      }
      
      // Create and download the file
      var blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      var downloadLink = document.createElement("a");
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      
      // Generate filename with current date
      var currentDate = formatDate(new Date());
      downloadLink.setAttribute("download", 'MF-Central Customer List ' + currentDate + '.csv');

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      
      // Clean up the URL object
      URL.revokeObjectURL(url);
    }

    function datereport() {
      $scope.assign = {};
      vm.userDetail.userName = 'ALL';
      vm.selectedOption = vm.userDetail;
      var datee = new Date();
      vm.toDate = new Date();
      var fromDate = new Date(datee.setDate(datee.getDate() - 31))
      vm.fromDate = fromDate;
      vm.assign = { todate: formatDate(vm.toDate), fromdate: formatDate(vm.fromDate), userId: vm.userDetail._id, userType: vm.userDetail.type }      
      ServiceProxy.getrmsiweexternalfoliodata(vm.assign).then(successFoliodata, errorFoliodata);
    }

    vm.showDetails = function(logDetails) {
      var postData = {
        'todate': formatDate(vm.toDate),
        'fromdate': formatDate(vm.fromDate),
        'pan': logDetails.pan
      };
    
      ServiceProxy.getmfcetralusageonpan(postData).then(successgetmfcetralusageonpan, errorgetmfcetralusageonpan);
    
      function errorgetmfcetralusageonpan(response) {
        console.log('errorgetmfcetralusageonpan', response);
        showDialog("Error fetching data. Please try again."); // Show error message
      }
    
      function successgetmfcetralusageonpan(response) {
        console.log('res', response);
        var data = response.data.responseString;
    
        if (data.length === 0) {
          showDialog("No Data Found...!!!");
        } else {
          showDialogDetails(data); // Show dialog with fetched data
        }
      }
    
      function showDialogDetails(data) {
        console.log('data',data)
        $mdDialog.show({
          controller: DialogController,
          template:
          '<md-dialog aria-label="Log Details" style="max-width: 800px; width: 100%;">' +
          '<md-dialog-content>' +
          '<table style="width: 100%; border-collapse: collapse; table-layout: fixed;">' +
          '<thead>' +
          '<tr>' +
          '<th style="width: 20%; padding: 10px; text-align: left; border-bottom: 1px solid #ddd; box-sizing: border-box; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">Req ID</th>' + 
          '<th style="width: 30%; padding: 10px; text-align: left; border-bottom: 1px solid #ddd; box-sizing: border-box; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">Client Ref No</th>' + 
          '<th style="width: 50%; padding: 10px; text-align: left; border-bottom: 1px solid #ddd; box-sizing: border-box; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">Created Date</th>' + 
          '</tr>' +
          '</thead>' +
          '<tbody>' +
          '<tr ng-repeat="log in data">' +
          '<td style="width: 20%; padding: 15px; border-bottom: 1px solid #ddd; box-sizing: border-box; word-wrap: break-word; overflow: hidden;">{{log.reqId}}</td>' + 
          '<td style="width: 30%; padding: 15px; border-bottom: 1px solid #ddd; box-sizing: border-box; word-wrap: break-word; overflow: hidden;">{{log.clientRefNo}}</td>' +
          '<td style="width: 50%; padding: 15px; border-bottom: 1px solid #ddd; box-sizing: border-box; word-wrap: break-word; overflow: hidden;">{{log.createdAt | date:"mediumDate"}} at {{log.createdAt | date:"h:mm a"}}</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>' +
          '</md-dialog-content>' +
          '<md-dialog-actions layout="row">' +
          '<md-button class="md-raised md-accent" ng-click="downloadCallHistory(data)" style="color:#fff !important;">' +
          '<md-icon md-font-icon="icon-arrow-down-bold" style="color:#fff;"></md-icon> Download MF Central Usage Report' +
          '</md-button>' +
          '<md-button ng-click="closeDialog()" class="md-primary">' +
          'Close' +
          '</md-button>' +
          '</md-dialog-actions>' +
          '</md-dialog>',
          locals: {
            data: data
          },
          clickOutsideToClose: true,
          parent: angular.element(document.body),
          controllerAs: 'vm'
        });
      }
    };
    
    // Dialog Controller
    function DialogController($scope, $mdDialog, data) {
      $scope.data = data;
    
      $scope.closeDialog = function() {
        $mdDialog.hide();
      };
    
      $scope.downloadCallHistory = function(log) {
        if (!log || log.length === 0) {
          showDialog("No Data Found...!!!");
        } else {
          var csvString = 'Req ID, Client Ref No, Created Date\n';
    
          for (var i = 0; i < log.length; i++) {
            var createdAtFormatted = log[i].createdAt ? 
              $filter('date')(new Date(log[i].createdAt), 'dd-MMM-yyyy \'at\' hh:mm a') : "";


            csvString += log[i].reqId + ',' +
                (log[i].clientRefNo ? log[i].clientRefNo : "") + ',' +
                createdAtFormatted + '\n';
          }
    
          var blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
          var downloadLink = document.createElement("a");
          var url = URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.setAttribute("download", 'MFCentralUsageReport.csv');
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      };
    }    

    function showDialogSucc(response) {
      var confirm = $mdDialog
        .confirm()
        .title('Success')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () { });
    }
    
    function showDialog(response) {
      var confirm = $mdDialog
        .confirm()
        .title('!!Error!!')
        .textContent(response)
        .ariaLabel('Lucky day')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('OK');
      $mdDialog.show(confirm).then(function () {});
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
angular.module('app.core').filter('trustAsResourceUrl', ['$sce', function($sce) {

   return function(val) {
       return $sce.trustAsResourceUrl(val);
   };
}]);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: #c0392b;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function() {
	'use strict';

	/**
	 * Main module of the Fuse
	 */
	angular.module('fuse', [
		// Core
		'app.core',

		// Navigation
		'app.navigation',

		// Toolbar
		'app.toolbar',

		// Quick Panel
		// 'app.quick-panel',

		// Auth
		'app.auth',

		// Cease Request
		'app.ceaseRequest',

		// Upload Transaction
		'app.uploadTransaction',

		// Upload Navs
		'app.uploadNavs',

		//News
		'app.blogs',

		//Recommendation
		'app.recommendations',

		//Customers
		'app.customers',

		//Push Notificastion
		'app.pushNotification',

		// Common
		'app.common',

		//flow for images
		'flow',

		//logout
		'app.logout',

		// textAngular
		'textAngular',

		// recommandedPortFolio
		'app.recommendatePortFolio',

		// communication
		'app.communication',

		// communication SMS
		'app.communicationSMS',

		// new data table
		'md.data.table',

		//dashboard
		'app.dashboard',

		//service configuration
		'app.serviceConfiguration',

		//syncing
		'app.syncing',

		//internal user
		'app.internalUser',

		// change password
		'app.changepassword',

		//internal user mapping
		'app.internalUserMapping',

		// referral module
		'app.referral',

		//customer sales
		'app.customersales',

		'app.assignmentDashboard',

		//schedular for email,sms,push notification
		'app.schedular',

		/// Advisory Dashboard
		'app.advisoryDashboard',

		// Products Mapping
		'app.products',

		// no isin schems
		'app.noisinscheme',

		// sip book
		'app.sipBook',

		// minor transaction
		'app.minorTransaction',

		// aum report
		'app.aumReport',

		// ifsc code
		// 'app.ifscCode',

		// transaction Logs
		'app.transactionLogs',

		// NAV List
		'app.nav-list',

		// NAV Calculate
		'app.nav-calculate',

		//bank details
		'app.bank-details',

		// send app link
		'app.send-app-link',

		// Mark Interested
		'app.mark-interested',

		// other transaction
		'app.otherTransaction',

		// scheme Report
		//'app.schemeReport' ,

		// customer engagement
		//'app.customer-engagement' ,
	 
		// goal chart
		//'app.goalchart' ,
		
		// goal fund list
		//'app.goalfundlist',

		// goal fund list
		//'app.sub-broker-customer',

		// subbroker 
		'app.subbroker',

		//offices
		'app.offices',

		//customer
		'app.assignmentreport',
		'app.revive-wellness-upload',
		'app.revive-pdf-manager',

		// NAV Rating
		'app.nav-rating',

		'app.insurance',

		'app.quotation',
		'app.returnReport',

		//Transaction Report
		'app.send-transaction-report',

		//TransactionDetailedReport
		'app.transaction-detailed-report',

		//Fatca Retrigger Mail
		'app.fatca-retrigger-mail',

		//countries
		'app.countries',

		//create-customers
		'app.create-customers',

		'app.achMandateReport',

		'app.rmfoliodata',

		'app.rmCallingHistory'

	]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $mdToast, UserFeature, ServiceProxy) {
        var vm = this;

        if (!UserFeature.userData) {
            getUserProfile();
        } else {
            vm.userDeatail = UserFeature.userData;
            window.sessionStorage.setItem('userDetail', JSON.stringify(vm.userDeatail));
        }


        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function() {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        function sucessCbGetUserProfile(response) {
            vm.userDeatail = response.data.data;
            window.sessionStorage.setItem('userDetail', JSON.stringify(vm.userDeatail));
        }        

        function errorCbGetUserProfile(response) {
            $mdToast.show({
                template: '<h4 style="color:#c0392b; text-align:right; margin-right:15px;">' + response.data.responseString + '</h4>',
                hideDelay: 3000,
                position: 'top right',
                parent: '#content'
            });
        }

        function getUserProfile() {
            ServiceProxy.getUserProfileInfo().then(sucessCbGetUserProfile, errorCbGetUserProfile);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            $window.sessionStorage.removeItem('access_token');
            $state.go('app.auth_login');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function() {
	'use strict';

	angular.module('app.core').config(config);

	/** @ngInject */
	function config($logProvider, msScrollConfigProvider, fuseConfigProvider) {
		// console.log($ariaProvider);
		// Enable debug logging
		$logProvider.debugEnabled(true);

		/*eslint-disable */

		// ng-aria configuration
		// $ariaProvider.config({
		// 	tabindex: false
		// });

		// Fuse theme configurations
		fuseConfigProvider.config({
			disableCustomScrollbars: false,
			disableCustomScrollbarsOnMobile: true,
			disableMdInkRippleOnMobile: true
		});

		// msScroll configuration
		msScrollConfigProvider.config({
			wheelPropagation: true
		});

		/*eslint-enable */
	}
})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, StorageService, UserFeature) {
        // UserFeature.getUserProfile()
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function(event, next, current) {
            //
            if (!StorageService.getSessionStorage('access_token') && next.name !== "app.auth_login") {
                window.location.href = '/';
                $state.go('app.auth_login')
            }

            if (next.data && !next.data.access()) {

                window.sessionStorage.clear()
                window.location.href = '/';
                $state.go('app.auth_login')
            }
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function() {
            $timeout(function() {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function() {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        // $locationProvider.html5Mode(true);
        if (!window.sessionStorage.getItem('access_token')) {
            $urlRouterProvider.otherwise('/auth/login');
        }


        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    // 'quickPanel@app': {
                    //     templateUrl: 'app/quick-panel/quick-panel.html',
                    //     controller: 'QuickPanelController as vm'
                    // }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming,$http,$scope)
    {
        var vm = this;
        $scope.hasPendingRequests = function(){
          return $http.pendingRequests.length >0;
        };
        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider,$provide)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function() {
	'use strict';

	angular
		.module('app.returnReport', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		
		$stateProvider
			.state('app.returnReport', {
				url: '/returnReport',
				views: {
					'content@app': {
						templateUrl: 'app/main/returnReport/returnReport.html',
						controller: 'returnReportController as vm'
					}
				}
			})

		// msNavigationServiceProvider.saveItem('customer.returnReport', {
		// 	title: 'Return Report',
		// 	icon: 'icon-tile-four',
		// 	state: 'app.returnReport',
		// 	weight: 11
		// });
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login'
            // 'app.auth.forgot-password',
            // 'app.auth.register'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('auth', {
        //     title : 'PAGES',
        //     group : true,
        //     weight: 2
        // });
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/Mf-centralExternalFolioData/rmfoliodata.html","<style>\n/* Ensure the parent container takes full height */\r\n    .ext-content {\r\n        position: relative;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n        margin-top: -15px;\r\n    }\r\n\r\n    /* Table container with limited height and scrollable content */\r\n    .md-table-container {\r\n        overflow-x: auto; /* Enable horizontal scrolling */\r\n        overflow-y: auto; /* Enable vertical scrolling */\r\n        max-height: 75vh; /* Limit the height to prevent scrolling out of screen */\r\n        background: #fff;\r\n        width: 100%;\r\n        border: 1px solid #ddd;\r\n    }\r\n\r\n    /* Sticky table headers */\r\n    thead th {\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 2;\r\n        background: #f1f1f1;\r\n        text-align: left;\r\n        border-bottom: 2px solid #ddd;\r\n        padding: 10px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    /* Ensure table rows have proper styles */\r\n    tbody tr:hover {\r\n        background-color: #f9f9f9;\r\n    }\r\n\r\n    tbody {\r\n        background: #fff;\r\n    }\r\n\r\n    /* Table formatting */\r\n    table {\r\n        width: max-content; /* Ensures table expands based on content */\r\n        border-collapse: collapse;\r\n        table-layout: auto;\r\n        min-width: 100%; /* Ensures table doesn\'t shrink too much */\r\n    }\r\n\r\n    td, th {\r\n        padding: 8px 12px;\r\n        text-align: left;\r\n        border: 1px solid #ddd;\r\n    }\r\n\r\n    /* Prevent text wrapping inside cells */\r\n    td {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    th {\r\n        max-width: 200px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    /* Ensuring horizontal scrollbar visibility */\r\n    .md-table-container::-webkit-scrollbar {\r\n        height: 8px;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-track {\r\n        background: #f1f1f1;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-thumb {\r\n        background: #888;\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-thumb:hover {\r\n        background: #555;\r\n    }\n</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60 mb-3\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin:0px; margin-top: -5px\"><span>MF Central Usage Report</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div></div><div></div><div \nclass=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><br><div \nclass=\"col-sm-2 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>From Date</label><input type=\"date\" \nng-model=\"vm.fromDate\" required name=\"fromDate\" flex=\"33\" tabindex=\"1\"></md-input-container></div><div \nclass=\"col-sm-2 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>To Date</label><input type=\"date\" \nng-model=\"vm.toDate\" required name=\"toDate\" flex=\"33\" tabindex=\"2\"></md-input-container></div><div \nclass=\"col-sm-2 form-group\" ng-if=\"vm.userDetail.type === \'SUPER::ADMIN\'\"><md-input-container class=\"md-block\"><label>\nSelect An RM Name</label><md-select ng-model=\"vm.selectedOption\" placeholder=\"Select An RM Name\"><md-option \nng-repeat=\"val in vm.internalUser\" ng-value=\"val\">{{ val.userName }}</md-option></md-select></md-input-container></div>\n<div class=\"col-sm-2 form-group\"><h5>Total Count:{{vm.fetchreport.data.totalCount}}</h5></div><div \nclass=\"col-sm-2 form-group\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.getrmsiweexternalfoliodata()\" \ntabindex=\"6\"><b>Show</b></button></div><div class=\"col-sm-2 form-group\" \nng-if=\"vm.fetchreport.data.responseString.length > 0\"><button type=\"button\" class=\"btn btn-primary\" \nng-click=\"vm.downloadCustomerList()\" tabindex=\"6\"><b>Download List</b></button></div></div></div><div \nclass=\"ext-content\"><md-virtual-repeat-container><md-table-container class=\"md-table-container\"><table md-table><thead \nmd-head><tr md-row><th md-column>Sr&nbsp;No.</th><th md-column>Name</th><th md-column>Mobile</th><th md-column>Email\n</th><th md-column>PAN</th><th md-column>Total Invested Amount</th><th md-column>Total Current Amount</th><th \nmd-column>Customer Type</th><th md-column>COUNT</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"data in vm.fetchreport.data.responseString\" ng-mouseover=\"hover = $index\" ng-mouseleave=\"hover = null\" \nng-click=\"vm.showDetails(data)\"><td md-cell>&nbsp;{{$index+1}}</td><td md-cell>&nbsp;{{data.userName}}</td><td md-cell>\n&nbsp;{{data.mobileNo}}</td><td md-cell>&nbsp;{{data.email}}</td><td md-cell>&nbsp;{{data.pan}}</td><td md-cell>\n&nbsp;{{data.totalCostValue}}</td><td md-cell>&nbsp;{{data.totalCurrentMktValue}}</td><td md-cell>\n&nbsp;{{data.isOldUser == \'YES\' ? \'Old User\' : \'New User\'}}</td><td md-cell>&nbsp;{{data.count}}</td></tr></tbody>\n</table></md-table-container></md-virtual-repeat-container></div></md-card></div></div>");
$templateCache.put("app/main/Rm-callingHistory/rmCallingHistory.html","<style>\n/* Ensure the parent container takes full height */\r\n    .ext-content {\r\n        position: relative;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n        margin-top: -15px;\r\n    }\r\n\r\n    /* Table container with limited height and scrollable content */\r\n    .md-table-container {\r\n        overflow-x: auto; /* Enable horizontal scrolling */\r\n        overflow-y: auto; /* Enable vertical scrolling */\r\n        max-height: 75vh; /* Limit the height to prevent scrolling out of screen */\r\n        background: #fff;\r\n        width: 100%;\r\n        border: 1px solid #ddd;\r\n    }\r\n\r\n    /* Sticky table headers */\r\n    thead th {\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 2;\r\n        background: #f1f1f1;\r\n        text-align: left;\r\n        border-bottom: 2px solid #ddd;\r\n        padding: 10px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    /* Ensure table rows have proper styles */\r\n    tbody tr:hover {\r\n        background-color: #f9f9f9;\r\n    }\r\n\r\n    tbody {\r\n        background: #fff;\r\n    }\r\n\r\n    /* Table formatting */\r\n    table {\r\n        width: max-content; /* Ensures table expands based on content */\r\n        border-collapse: collapse;\r\n        table-layout: auto;\r\n        min-width: 100%; /* Ensures table doesn\'t shrink too much */\r\n    }\r\n\r\n    td, th {\r\n        padding: 8px 12px;\r\n        text-align: left;\r\n        border: 1px solid #ddd;\r\n    }\r\n\r\n    /* Prevent text wrapping inside cells */\r\n    td {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    th {\r\n        max-width: 200px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    /* Ensuring horizontal scrollbar visibility */\r\n    .md-table-container::-webkit-scrollbar {\r\n        height: 8px;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-track {\r\n        background: #f1f1f1;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-thumb {\r\n        background: #888;\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-thumb:hover {\r\n        background: #555;\r\n    }\n</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60 mb-3\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin:0px; margin-top: -5px\"><span>Calling History</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div></div><div></div><div \nclass=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><br><div \nclass=\"col-sm-2 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>From Date</label><input type=\"date\" \nng-model=\"vm.fromDate\" required name=\"fromDate\" flex=\"33\" tabindex=\"1\"></md-input-container></div><div \nclass=\"col-sm-2 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>To Date</label><input type=\"date\" \nng-model=\"vm.toDate\" required name=\"toDate\" flex=\"33\" tabindex=\"2\"></md-input-container></div><div \nclass=\"col-sm-3 form-group\" ng-if=\"vm.userDetail.type === \'SUPER::ADMIN\'\"><md-input-container class=\"md-block\"><label>\nSelect An RM Name</label><md-select ng-model=\"vm.selectedOption\" placeholder=\"Select An RM Name\"><md-option \nng-repeat=\"val in vm.internalUser\" ng-value=\"val\">{{ val.userName }}</md-option></md-select></md-input-container></div>\n<div class=\"col-sm-2 form-group\"><button type=\"button\" class=\"btn btn-primary\" \nng-click=\"vm.getrmsiweexternalfoliodata()\" tabindex=\"6\"><b>Show</b></button></div><div class=\"col-sm-3 form-group\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.downloadCallHistoryAll()\" tabindex=\"6\"><b>Download List</b>\n</button></div></div></div><div class=\"ext-content\"><md-virtual-repeat-container><md-table-container \nclass=\"md-table-container\"><table md-table><thead md-head><tr md-row><th md-column>Sr&nbsp;No.</th><th md-column>Name\n</th><th md-column>Calling Data</th><th md-column>Mobile</th><th md-column>Advisors</th><th md-column>Email</th><th \nmd-column>PAN</th><th md-column>Comments</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"data in vm.fetchreport\" \nng-style=\"hover === $index ? {\'cursor\': \'pointer\'} : {}\" ng-mouseover=\"hover = $index\" ng-mouseleave=\"hover = null\" \nng-click=\"vm.showDetails(data)\"><td md-cell>&nbsp;{{$index+1}}</td><td md-cell>&nbsp;{{data.userName}}</td><td md-cell>\n&nbsp;{{data.createdAt | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td md-cell>&nbsp;{{data.mobileNo}}</td><td md-cell>\n&nbsp;{{data.assignedUserName}}</td><td md-cell>&nbsp;{{data.email}}</td><td md-cell>&nbsp;{{data.pan}}</td><td \nmd-cell>&nbsp;{{data.comments}}</td></tr></tbody></table></md-table-container></md-virtual-repeat-container></div>\n</md-card></div></div>");
$templateCache.put("app/main/ach-mandateReport/ach-mandateReport.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Ach Mandate Report</span></div></div>\n</div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12 mt-5\">\n</div><div class=\"col-sm-12 mt-5\"></div><div class=\"col-sm-12 mt-5\"></div><div class=\"col-sm-12 mt-5\"><div \nclass=\"col-sm-4\"><div class=\"form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>IIN</label><input \ntype=\"text\" ng-model=\"vm.postData.iin\" name=\"iin\" flex=\"33\" tabindex=\"3\"></md-input-container></div></div><div \nclass=\"col-sm-4\"><div class=\"form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>Status</label>\n<md-select ng-model=\"vm.postData.status\" name=\"status\"><md-option ng-repeat=\"x in vm.statusData\" ng-value=\"x.value\">\n{{x.title}}</md-option></md-select></md-input-container></div></div></div><div class=\"col-sm-12\"><div \nclass=\"col-sm-4 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>From Date</label><input type=\"date\" \nng-model=\"vm.fromDate\" required name=\"fromDate\" max=\"{{ today | date:\'yyyy-MM-dd\' }}\" tabindex=\"1\">\n</md-input-container></div><div class=\"col-sm-4 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nTo Date</label><input type=\"date\" ng-model=\"vm.toDate\" required name=\"toDate\" max=\"{{ today | date:\'yyyy-MM-dd\' }}\" \ntabindex=\"2\"></md-input-container><button type=\"button\" class=\"btn btn-primary\" ng-click=\"postTranLogs()\" tabindex=\"6\">\n<b>Show</b></button> &nbsp; &nbsp; <button type=\"button\" class=\"btn btn-primary\" ng-click=\"clearLogs()\" tabindex=\"6\">\n<b>Clear</b></button> &nbsp; &nbsp; <button type=\"button\" class=\"btn btn-primary\" ng-click=\"downloadLogs()\" \ntabindex=\"6\"><b>Download</b></button></div></div></div><div ng-if=\"vm.logData.length > 0\" style=\"overflow-x:auto\">\n<table class=\"table\"><thead class=\"thead-light\"><tr><th scope=\"col\"><span>Sr.No.</span></th><th scope=\"col\"><span>IIN\n</span></th><th scope=\"col\"><span>Name</span></th><th scope=\"col\"><span>Scheme Amount</span></th><th scope=\"col\"><span>\nIFSC Code</span></th><th scope=\"col\"><span>UMRN No</span></th><th scope=\"col\"><span>Mandate Status</span></th><th \nscope=\"col\"><span>Process Mode</span></th></tr></thead><tbody><tr ng-repeat=\"logs in vm.logData\" \nng-style=\"hover === $index ? {\'text-decoration\': \'underline\', \'color\': \'blue\', \'cursor\': \'pointer\'} : {}\" \nng-mouseover=\"hover = $index\" ng-mouseleave=\"hover = null\" ng-click=\"vm.showDetails(logs)\"><td>{{$index + 1}}</td><td>\n{{logs.CUSTOMER_ID ? logs.CUSTOMER_ID : 0}}</td><td>{{logs.INVESTOR_NAME}}</td><td>{{logs.AMOUNT}}</td><td>\n{{logs.IFSC_CODE}}</td><td>{{logs.UMRN_NO}}</td><td>{{logs.ACH_MANDATE_STATUS}}</td><td>{{logs.PROCESS_MODE}}</td></tr>\n</tbody></table></div></md-card></div></div>");
$templateCache.put("app/main/assignment-dashboard/assignment-dashboard.html","<div id=\"assignmentDashboard\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nAssignment Dashboard</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-content id=\"mainContent\" \nlayout-padding><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-140 cursor\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'Unassigned\'}\" ng-click=\"vm.selectedFilter(\'Unassigned\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.countData.userLeadCount}}</div><div class=\"font-weight-500 secondary-text\">Sales Unassigned Customer</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" ng-class=\"{\'active\':vm.filterType === \'Document\'}\" \nng-click=\"vm.selectedFilter(\'Document\')\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex>\n<div class=\"md-display-1 pb-8\">{{vm.countData.documentsUserCount}}</div><div class=\"font-weight-500 secondary-text\">\nDocument Unverified Customer</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'Advisory\'}\" ng-click=\"vm.selectedFilter(\'Advisory\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.countData.advisoryCount}}</div><div class=\"font-weight-500 secondary-text\">Advisory Unassigned Customer</div>\n</div></ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" ng-class=\"{\'active\':vm.filterType === \'NI\'}\" layout=\"row\" \nng-click=\"vm.selectedFilter(\'NI\')\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\">{{vm.countData.notInterestedCount}}</div><div class=\"font-weight-500 secondary-text\">\nNot Interested</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'OLD\'}\" ng-click=\"vm.selectedFilter(\'OLD\')\" flex><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">{{vm.countData.oldUserCount}}</div>\n<div class=\"font-weight-500 secondary-text\">Old Sales Unassigned Customer</div></div></ms-widget-front></ms-widget>\n</div><md-button ng-hide=\"vm.filterType == \'NI\' || vm.filterType ==\'OLD\' \" ng-click=\"vm.downloadExcel()\" \nclass=\"md-raised md-accent\" style=\"color:#fff !important\">download Excel</md-button><md-virtual-repeat-container \nid=\"fixed\"><div class=\"border md-whiteframe-4dp\" md-virtual-repeat=\"user in vm.allUserForProcess | filter:search\" \nlayout=\"row\" layout-padding><div flex=\"40\"><div layout=\"row\"><span flex=\"50\" \nstyle=\"text-transform: capitalize;font-size:16px\">{{user.userName || \'NA\'}}</span> <span flex=\"50\">\nCreated Date: {{user.createdAt | date:\'mediumDate\'}}</span></div><h6 style=\"font-size:16px\">{{user.mobileNo}} <span \nclass=\"verified\" ng-if=\"user.mobileVerifiedFlag\">(Verified)</span> <span class=\"notVerified\" \nng-if=\"!user.mobileVerifiedFlag\">(Not Verified)</span></h6><h6 ng-if=\"!user.nseData.ADDRESS1\">\n{{user.referenceInfo.address}}<br>{{user.referenceInfo.city}} ,{{user.referenceInfo.state}}<br>\nINDIA - {{user.referenceInfo.pincode}}<br><span class=\"notVerified\">(Not Verified)</span></h6><h6 \nng-if=\"user.nseData.ADDRESS1\">{{user.nseData.ADDRESS1}}, {{user.nseData.ADDRESS2}}, {{user.nseData.ADDRESS3}}<br>\n{{user.nseData.CITY}},{{user.nseData.STATE_NAME}}<br>INDIA - {{user.nseData.PINCODE}}<br><span class=\"verified\">\n(Verified)</span></h6><h6>Document Status: <span \nng-class=\"{\'pending\':user.documentUploadStatus === \'PENDING\',\'partial\':user.documentUploadStatus === \'PARTIAL\',\'complete\':user.documentUploadStatus === \'COMPLETE\',\'verified\':user.documentUploadStatus === \'VERIFIED\'}\">\n{{user.documentUploadStatus || \'NA\'}}</span></h6><a \nui-sref=\"app.assignmentDashboard.documentVerification({userId:user._id})\">Go To Document</a><h6>\nReferred By: {{user.referredBy.userName || \'None\'}}</h6><h6>Onboarded From: {{user.platform || \'NA\'}}</h6></div><div \nlayouit=\"column\" flex=\"60\"><div id=\"timeline1\" layout=\"row\" flex><md-icon md-font-icon=\"icon-phone-forward\" \nng-class=\"{\'success\':user.signUpSteps > 0}\"><md-tooltip md-direction=\"bottom\">Mobile <span ng-show=\"!user.signUpSteps\">\nnot</span> Verified</md-tooltip></md-icon><div flex=\"10\" class=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=1}\">\n</div><md-icon md-font-icon=\"icon-account-check\" ng-class=\"{\'success\':user.signUpSteps >1 }\"><md-tooltip \nmd-direction=\"bottom\">Account <span ng-show=\"(!user.signUpSteps || user.signUpSteps < 2)\">not</span> created.\n</md-tooltip></md-icon><div flex=\"10\" class=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=2}\"></div><md-icon \nmd-font-icon=\"icon-briefcase-checked\" ng-class=\"{\'success\':user.signUpSteps >2 }\"><md-tooltip md-direction=\"bottom\">\nPAN and Adhar <span ng-show=\"(!user.signUpSteps || user.signUpSteps < 3)\">not</span> Verified</md-tooltip></md-icon>\n<div flex=\"10\" class=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=3}\"></div><md-icon \nmd-font-icon=\"icon-account-key\" ng-class=\"{\'success\':user.signUpSteps >3 }\"><md-tooltip md-direction=\"bottom\">IIN <span\n ng-show=\"(!user.signUpSteps || user.signUpSteps < 4)\">not</span> Created</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=4}\"></div><md-icon md-font-icon=\"icon-verified\" \nng-class=\"{\'success\':user.signUpSteps >4 }\"><md-tooltip md-direction=\"bottom\">Document <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 5)\">not</span> Verified</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=5}\"></div><md-icon md-font-icon=\"icon-check-circle\" \nng-class=\"{\'success\':user.signUpSteps >5 }\"><md-tooltip md-direction=\"bottom\">IIN <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 6)\">not</span> Activated</md-tooltip></md-icon></div><div \nlayout=\"row\"><div flex=\"50\"><h6>IIN No.: {{user.iin || \'NA\'}}</h6><h6>PAN: {{user.pan || \'NA\'}}</h6><h6>\nKYC Status: {{vm.eKyc[user.camsKycStatus] || \'NA\'}}</h6></div><div flex=\"50\"><md-switch \nng-show=\"vm.filterType === \'NI\'\" ng-change=\"vm.setUserInterested(user)\" ng-model=\"user.notInterestedFlag\" \naria-label=\"Switch 1\">Not Interested</md-switch><div layout=\"row\" \nng-show=\"(vm.filterType !== \'Unverified\' )&& (vm.filterType !== \'NI\')\" class=\"pt-20\" layout-align=\"start\" flex>\n<md-input-container flex><label for=\"\">Assign To</label><md-select ng-model=\"user.assignedUser\" \nng-change=\"vm.assignInternalUser(user)\" placeholder=\"{{vm.placeholder}}\"><md-option><em>None</em></md-option><md-option\n ng-repeat=\"user in vm.allInternalUsers\" ng-value=\"user\">{{user.userName}} &nbsp;&nbsp;({{user.type}})</md-option>\n</md-select></md-input-container></div><h6 \nng-show=\"user.assignedDetails.userType === \'SALES::USER\' || (vm.filterType === \'Unassigned\' || vm.filterType === \'OLD\')\">\nCustomer Support: {{user.assignedDetails.userName || \'None\'}}</h6><h6 \nng-show=\"user.assignedDetails.userType === \'FINANCE::USER\' || (vm.filterType === \'Document\' || vm.filterType === \'Advisory\')\">\nFinancial Advisor: {{user.assignedDetails.userName || \'None\'}}</h6></div></div></div></div>\n</md-virtual-repeat-container></md-content></div></div>");
$templateCache.put("app/main/advisory-dashboard/advisory-dashboard.html","<div id=\"advisoryDashboard\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nAdvisory Dashboard</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" \nstyle=\"height: 51px !important;margin-top: -18px !important\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.toggleCalender()\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon>Call Calender</md-button></div>\n</div><div class=\"headerFixAllPages\"><md-sidenav class=\"md-sidenav-right\" md-component-id=\"reviewSideNav\" \nmd-whiteframe=\"4\"><md-toolbar class=\"md-accent height-60\"><h1 class=\"md-toolbar-tools\">\nReview Call of {{vm.reviewUserData.userName}}</h1></md-toolbar><md-content layout-margin><md-input-container><label>\nEnter date</label><md-datepicker ng-model=\"vm.reviewUserData.reviewPendingFlagDate\"></md-datepicker>\n</md-input-container><md-input-container><label>Time</label><input type=\"time\" \nng-model=\"vm.reviewUserData.reviewPendingFlagTime\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Comment</label><input type=\"text\" ng-model=\"vm.reviewUserData.reviewPendingFlagComments\">\n</md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"vm.setReviewDate(vm.reviewUserData)\">Submit\n</md-button></md-content></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-component-id=\"right\" md-whiteframe=\"4\" \nstyle=\"max-width:800px;width:800px\"><md-toolbar class=\"md-accent height-60\"><h1 class=\"md-toolbar-tools\">Call Calender\n</h1></md-toolbar><md-content layout-margin><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.prev($event)\" aria-label=\"Previous\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.next()\" aria-label=\"Next\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.events\" calendar=\"main\"></div></div></md-content></md-sidenav><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"rightHistory\" md-whiteframe=\"4\" style=\"max-width:800px;width:800px\"><md-toolbar \nclass=\"md-accent height-60\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">\nCall History of {{vm.callHistory.userName}}</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.openHistorySidenav(\'rightHistory\')\" aria-label=\"More\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-toolbar><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Call History\"><md-content \nlayout-margin><div class=\"simple-table-container\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Calling Date\n</th><th>Comment</th><th>Next Date</th><th>Called By</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"call in vm.callHistory.callSchedules\"><td class=\"name\">\n{{call.atDate | date:\'mediumDate\'}} at {{call.atHour > 12 ? (call.atHour - 12):call.atHour }}:{{call.atMinute }} {{call.atHour > 11 ? \'PM\':\'AM\'}}\n</td><td class=\"position\">{{call.comments}}</td><td class=\"office\">\n{{call.nextAtDate | date:\'mediumDate\'}} at {{call.nextAtHour > 12 ? (call.nextAtHour - 12):call.nextAtHour }}:{{call.nextAtMinute }} {{call.nextAtHour > 11 ? \'PM\':\'AM\'}}\n</td><td class=\"office\">{{call.createdBy.userName}}</td></tr></tbody></table></div></md-content></md-tab><md-tab \nlabel=\"Old Called History\" ng-click=\"vm.reviewCallHistory(vm.callHistory._id)\"><md-content layout-margin><div \nclass=\"simple-table-container\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Calling Date</th><th>Comment\n</th><th>Called By</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"call in vm.callHistory.reviewCalls\"><td class=\"name\">{{call.date | date:\'mediumDate\'}}</td><td \nclass=\"position\">{{call.activityComment}}</td><td class=\"office\">{{call.monitorUserName}}</td></tr></tbody></table>\n</div></md-content></md-tab></md-tabs></md-sidenav><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"enquirySideNav\" md-whiteframe=\"4\" style=\"max-width:800px;width:800px\"><md-toolbar \nclass=\"md-accent height-60\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">\nEnquiries of {{vm.userEnquiry.userName}}</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.openHistorySidenav(\'enquirySideNav\')\" aria-label=\"More\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-toolbar><md-content layout-margin><div class=\"simple-table-container\"><table class=\"simple\" \nms-responsive-table><thead><tr><th>Date</th><th>Description</th><th>Status</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr ng-repeat=\"enquiry in vm.userEnquiry.enquiries | orderBy:\'-createdAt\'\"><td class=\"name\">\n{{enquiry.createdAt | date:\'mediumDate\'}}</td><td class=\"position\">{{enquiry.desc}}</td><td class=\"office\"><md-button \nng-show=\"enquiry.closeFlag\">Closed</md-button><md-button ng-click=\"vm.closeEnquiryDialog(enquiry)\" \nng-show=\"!enquiry.closeFlag\">Open<md-tooltip md-direction=\"bottom\">Cilck here to close Enquiry</md-tooltip></md-button>\n</td></tr></tbody></table></div></md-content></md-sidenav><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"callingSidebar\" md-whiteframe=\"4\" md-disable-backdrop><md-toolbar class=\"md-accent height-60\"><h1 \nclass=\"md-toolbar-tools\">{{vm.activeUser.userName}}</h1></md-toolbar><md-content layout-margin><form name=\"myForm\"><h4>\nCalled At</h4><div flex><md-datepicker ng-model=\"vm.callingDetail.atDate\" md-placeholder=\"Enter date\" required>\n</md-datepicker></div><div><h5>Time</h5><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" flex=\"48\">\n<md-icon md-font-icon=\"icon-minus\" class=\"iconSize border\" ng-click=\"vm.changeHour(\'hour\',\'minus\')\"></md-icon><input \ntype=\"text\" ng-model=\"vm.callingDetail.atHour\" class=\"border\" ng-change=\"vm.changeDetect(\'hour\')\" \nstyle=\"max-width:35px;width:30px;height:30px;text-align:center\" required><md-icon md-font-icon=\"icon-plus\" \nclass=\"iconSize border\" ng-click=\"vm.changeHour(\'hour\',\'plus\')\"></md-icon></div><span class=\"timeDot\">:</span><div \nlayout=\"row\" flex=\"48\"><md-icon md-font-icon=\"icon-minus\" class=\"iconSize border\" \nng-click=\"vm.changeHour(\'minute\',\'minus\')\"></md-icon><input type=\"text\" ng-model=\"vm.callingDetail.atMinute\" \nng-change=\"vm.changeDetect(\'minute\')\" class=\"border\" style=\"max-width:35px;width:30px;height:30px;text-align:center\" \nrequired><md-icon md-font-icon=\"icon-plus\" class=\"iconSize border\" ng-click=\"vm.changeHour(\'minute\',\'plus\')\"></md-icon>\n</div><div flex=\"50\"></div></div></div><md-checkbox ng-show=\"!vm.activeUser.investedAmt\" ng-model=\"vm.notInterested\" \naria-label=\"Checkbox 1\" class=\"mt-40\">Not Interested</md-checkbox><md-input-container class=\"md-block\" \nstyle=\"margin-top:30px !important\"><label>Comments</label><md-select name=\"reason\" \nng-model=\"vm.callingDetail.comments\" required><md-option ng-repeat=\"reason in vm.commentStrings\" ng-value=\"reason\">\n{{reason}}</md-option></md-select><div class=\"errors\" ng-messages=\"myForm.reason.$error\"><div ng-message=\"required\">\nRequired</div></div></md-input-container><md-input-container ng-if=\"vm.callingDetail.comments === \'Other\'\" \nclass=\"md-block\" style=\"margin-top:30px !important\"><label>Other Comments</label><input type=\"text\" name=\"other\" \nng-model=\"vm.callingDetail.other\" ng-required=\"vm.callingDetail.comments === \'Other\'\"><div class=\"errors\" \nng-messages=\"myForm.other.$error\"><div ng-message=\"required\">Required</div></div></md-input-container><h4>Next Call\n</h4><div flex><md-datepicker ng-model=\"vm.callingDetail.nextAtDate\" md-placeholder=\"Enter date\"></md-datepicker></div>\n<div><h5>Time</h5><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" flex=\"48\"><md-icon \nmd-font-icon=\"icon-minus\" class=\"iconSize border\" ng-click=\"vm.changeNextHour(\'hour\',\'minus\')\"></md-icon><input \ntype=\"text\" ng-model=\"vm.callingDetail.nextAtHour\" class=\"border\" ng-change=\"vm.changeNextDetect(\'hour\')\" \nstyle=\"max-width:35px;width:30px;height:30px;text-align:center\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"iconSize border\" ng-click=\"vm.changeNextHour(\'hour\',\'plus\')\"></md-icon></div><span class=\"timeDot\">:</span><div \nlayout=\"row\" flex=\"48\"><md-icon md-font-icon=\"icon-minus\" class=\"iconSize border\" \nng-click=\"vm.changeNextHour(\'minute\',\'minus\')\"></md-icon><input type=\"text\" ng-model=\"vm.callingDetail.nextAtMinute\" \nng-change=\"vm.changeNextDetect(\'minute\')\" class=\"border\" \nstyle=\"max-width:35px;width:30px;height:30px;text-align:center\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"iconSize border\" ng-click=\"vm.changeNextHour(\'minute\',\'plus\')\"></md-icon></div><div flex=\"50\"></div></div></div>\n<md-checkbox ng-model=\"vm.callingDetail.followUpReminder\" aria-label=\"Checkbox 2\" class=\"mt-40\">Follow up reminder\n</md-checkbox><label>Schedular Date</label><md-input-container class=\"md-block\" flex=\"100\"><md-datepicker flex \nng-model=\"vm.schedular.date\" name=\"date\" md-min-date=\"vm.cDate\" md-placeholder=\"Enter date\"></md-datepicker>\n</md-input-container><div class=\"md-block\" flex=\"100\"><label for=\"\" style=\"display:inline-block\">Time</label><select \nng-model=\"vm.schedular.hour\"><option ng-value=\"num\" ng-repeat=\"num in vm.numList\">{{num}}</option></select>:<select \nng-model=\"vm.schedular.minute\"><option ng-value=\"num\" ng-repeat=\"num in vm.minuteNumList\">{{num}}</option></select>\n<select ng-model=\"vm.schedular.meridian\"><option ng-value=\"AM\">AM</option><option ng-value=\"PM\">PM</option></select>\n</div><br><label>Comments</label><md-input-container class=\"md-block\" flex=\"100\"><textarea rows=\"3\" name=\"bodyContent\" \nng-model=\"vm.schedular.bodyContent\" md-select-on-focus></textarea></md-input-container></form><md-button \nng-click=\"vm.createCall()\" ng-disabled=\"myForm.$invalid\" class=\"md-raised md-primary\">Submit</md-button><md-button \nng-click=\"vm.closeSidenav()\" class=\"md-raised md-primary\">Cancel</md-button></md-content></md-sidenav><md-sidenav \nclass=\"md-sidenav-right\" md-component-id=\"eMandateSideNav\" md-whiteframe=\"4\" style=\"max-width:800px;width:800px\">\n<md-toolbar class=\"md-accent height-60\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">\nACH Details of {{vm.userEnquiry.userName}}</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.openHistorySidenav(\'eMandateSideNav\')\" aria-label=\"More\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-toolbar><md-content layout-margin><form name=\"myForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"row\" layout-gt-xs=\"row\" flex layout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"></md-input-container><div style=\"height: 500px\"><div layout=\"row\" \nflex=\"100\" layout-wrap ng-repeat=\"account in vm.bankdetails\"><md-radio-group ng-model=\"vm.selectedAccount\" flex=\"100\" \nlayout=\"row\"><md-radio-button flex=\"100\" flex-gt-xs=\"100\" style=\"height: 200px\" ng-value=\"account\"><div layout=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"customerbank\" \nng-value=\"account.BANK_NAME\" ng-disabled=\"true\" placeholder=\"Bank Name\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"customerbranch\" ng-value=\"account.BRANCH_NAME\" ng-disabled=\"true\" \nplaceholder=\"Branch Name\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"customerifsc\" ng-value=\"account.IFSC_CODE\" ng-disabled=\"true\" placeholder=\"IFSC Code\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"customeracno\" ng-value=\"account.AC_NO\" \nng-disabled=\"true\" placeholder=\"Account Number\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"text\" name=\"customeracctype\" ng-value=\"account.AC_TYPE\" ng-disabled=\"true\" placeholder=\"Account Type\">\n</md-input-container></div></md-radio-button></md-radio-group></div></div></div></form></md-content><div \nstyle=\"margin-top:32px; padding:32px 24px 32px 24px; background:#fff; border-radius:8px; box-shadow:0 1px 8px #ececec\">\n<div layout=\"row\" layout-align=\"start center\" layout-wrap><md-input-container flex=\"40\" \nstyle=\"min-width:240px; margin-right:24px\"><label>Select Channel</label><md-select name=\"chanel\" \nng-model=\"vm.selectedChanel\"><md-option ng-value=\"ch\" ng-repeat=\"ch in vm.chanelList\">{{ ch.name }}</md-option>\n</md-select></md-input-container><md-input-container flex=\"40\" style=\"min-width:180px; margin-right:24px\"><label>\nACH Amount</label><input type=\"number\" name=\"ach_amount\" ng-model=\"vm.ach_amount\" numeric-regex oncopy=\"return false\" \nondrag=\"return false\" ondrop=\"return false\" onpaste=\"return false\" autocomplete=\"off\" placeholder=\"ACH Amount\" \nrequired><div ng-messages=\"myForm.ach_amount.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nACH amount is required</span></div></div></md-input-container><md-input-container flex=\"40\" \nstyle=\"min-width:120px; margin-top:24px\"><md-button ng-disabled=\"vm.disableEMandateSubmit()\" \nclass=\"md-raised md-accent\" ng-click=\"vm.registerCustMandate()\" style=\"color:#fff !important\">Submit</md-button>\n</md-input-container></div></div></md-sidenav><md-content id=\"mainContent\" layout-padding><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" ng-class=\"{\'active\':vm.filterType === \'Assigned\'}\" \nng-click=\"vm.selectedFilter(\'Assigned\')\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex>\n<div class=\"md-display-1 pb-8\">{{vm.dashboardCount.newlyUserCount}}</div><div class=\"font-weight-500 secondary-text\">\nNewly Assigned</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'NonInvesting\'}\" ng-click=\"vm.selectedFilter(\'NonInvesting\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.dashboardCount.notInvestingUserCount}}</div><div class=\"font-weight-500 secondary-text\">Non Investing</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'Investing\'}\" ng-click=\"vm.selectedFilter(\'Investing\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.dashboardCount.investingUserCount}}</div><div class=\"font-weight-500 secondary-text\">Investing</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'ReviewToday\'}\" ng-click=\"vm.selectedFilter(\'ReviewToday\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.dashboardCount.todayReviewUserCount}}</div><div class=\"font-weight-500 secondary-text\">Review Today</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'FollowUpToday\'}\" ng-click=\"vm.selectedFilter(\'FollowUpToday\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.dashboardCount.todayFollowUpUserCount}}</div><div class=\"font-weight-500 secondary-text\">Followup Today</div>\n</div></ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"start center \" class=\"radioGroupBorder\">\n<md-radio-group layout=\"row\" layout-align=\"start center\" ng-change=\"vm.selectedCustomFilter()\" layout-margin \nng-model=\"vm.subFilter\"><md-radio-button value=\"ALL\" class=\"md-warn\">ALL</md-radio-button><md-radio-button value=\"SIP\" \nclass=\"md-warn\">SIP</md-radio-button><md-radio-button value=\"LUMPSUM\" class=\"md-warn\">LUMPSUM</md-radio-button>\n<md-radio-button value=\"BOTH\" class=\"md-warn\">SIP+LUMPSUM</md-radio-button><md-radio-button value=\"PRIORITY\" \nclass=\"md-warn\">PRIORITY</md-radio-button><md-radio-button value=\"ENQUIRY\" class=\"md-warn\">ENQUIRY</md-radio-button>\n<md-radio-button value=\"POTENTIAL\" class=\"md-warn\">POTENTIAL SCALE</md-radio-button><md-button \nclass=\"md-raised md-accent\" ng-href=\"http://partner.sipfund.com\" target=\"_blank\" ng-click=\"\" \nstyle=\"color:#fff !important;float: right;margin-left: 170px\">Commission</md-button></md-radio-group>\n<md-slider-container ng-show=\"vm.subFilter === \'POTENTIAL\'\" layout=\"column\"><span>{{vm.selectedPotential}}</span>\n<md-slider min=\"1\" max=\"10\" ng-model=\"vm.selectedPotential\" aria-label=\"red\" \nng-change=\"vm.filterCustomerByPotentialLevel()\" id=\"red-slider\" class=\"md-warn\"></md-slider></md-slider-container><div \nclass=\"cBox\" ng-show=\"vm.calendarText\">{{vm.calendarText}}<md-icon md-font-icon=\"icon-close\" class=\"iconCross\" \nng-click=\"vm.clearCalendarData()\"></md-icon></div></div><h2 ng-show=\"vm.selectedCustomer.length === 0\">\nNo user found for selected criteria.</h2><md-virtual-repeat-container id=\"fixed\"><div class=\"border md-whiteframe-4dp\" \nmd-virtual-repeat=\"user in vm.selectedCustomer | filter:search\" layout=\"row\" layout-padding><div flex=\"20\"><div \nlayout=\"row\"><span style=\"text-transform: capitalize;font-size:16px\"><md-icon md-font-icon=\"icon-eye\" \nng-click=\"vm.goToCustomerDetail(user)\"><md-tooltip md-direction=\"bottom\">View Detail</md-tooltip></md-icon>\n{{user.userName || \'NA\'}}</span></div><h6 style=\"font-size:16px\">{{user.mobileNo}} <span class=\"verified\" \nng-if=\"user.mobileVerifiedFlag\">(Verified)</span> <span class=\"notVerified\" ng-if=\"!user.mobileVerifiedFlag\">\n(Not Verified)</span></h6><h6 ng-if=\"!user.nseData.ADDRESS1\">{{user.referenceInfo.address}}<br>\n{{user.referenceInfo.city}} ,{{user.referenceInfo.state}}<br>INDIA - {{user.referenceInfo.pincode}}<br><span \nclass=\"notVerified\">(Not Verified)</span></h6><h6 ng-if=\"user.nseData.ADDRESS1\">\n{{user.nseData.ADDRESS1}}, {{user.nseData.ADDRESS2}}, {{user.nseData.ADDRESS3}}<br>\n{{user.nseData.CITY}},{{user.nseData.STATE_NAME}}<br>INDIA - {{user.nseData.PINCODE}}<br><span class=\"verified\">\n(Verified)</span></h6><a ui-sref=\"app.assignmentDashboard.documentVerification({userId:user._id})\">Go To Document</a>\n<h6>Referred By: {{user.referredBy.userName || \'None\'}}</h6><h6>Onboarded From: {{user.platform || \'NA\'}}</h6></div>\n<div layout=\"column\" layout-align=\"start center\" flex=\"20\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"pb-10\" style=\"width:100%\" layout-wrap><div ng-show=\"user.sipPurchaseFlag\" flex=\"50\" layout=\"row\" \nlayout-align=\"center center\" class=\"border\">SIP</div><div ng-show=\"user.lumpsumPurchaseFlag\" flex=\"50\" layout=\"row\" \nlayout-align=\"center center\" class=\"border\">LUMPSUM</div><div ng-show=\"user.investmentsFlag\" class=\"border\" flex=\"100\" \nlayout=\"row\" layout-align=\"center center\">Invetsed Amount: {{user.investedAmt | currency:\'&#8377; \':0}}</div></div><div\n layout=\"column\" layout-align=\"start start\" flex=\"100\"><div layout=\"row\"><md-icon md-font-icon=\"icon-phone-in-talk\" \nclass=\"s36\"></md-icon><div layout=\"column\"><a ng-click=\"vm.openSidenav(user,\'last\')\" href=\"\" \nng-disabled=\"!user.callSchedule\" style=\"color:rgba(0,0,0,.87)\">Last Call : <span ng-if=\"!user.callSchedule.atDate\">\nNot Done</span> <span ng-if=\"user.callSchedule.atDate\">\n{{user.callSchedule.atDate | date:\'mediumDate\'}} {{user.callSchedule.atHour > 12 ? (user.callSchedule.atHour - 12):user.callSchedule.atHour }}:{{user.callSchedule.atMinute }} {{user.callSchedule.atHour > 11 ? \'PM\':\'AM\'}} \n</span></a><span>Next Call : <span ng-if=\"!user.callSchedule.nextAtDate\">Not Schedule</span> <span \nng-if=\"user.callSchedule.nextAtDate\">\n{{user.callSchedule.nextAtDate | date:\'mediumDate\'}} {{user.callSchedule.nextAtHour > 12 ? (user.callSchedule.nextAtHour - 12):user.callSchedule.nextAtHour }}:{{user.callSchedule.nextAtMinute }} {{user.callSchedule.nextAtHour > 11 ? \'PM\':\'AM\'}}\n</span></span></div></div><div layout=\"row\" layout-align=\"start center\" class=\"h-50\" flex=\"100\" style=\"width:100%\"><a \nng-click=\"vm.openSidenav(user,\'new\')\" href=\"\" flex=\"50\">Record Call</a><a flex=\"50\" \nng-click=\"vm.openHistorySidenav(\'rightHistory\',user)\" href=\"\" ng-if=\"user.callSchedules.length > 0\">Call History</a>\n</div></div><div flex=\"100\" ng-show=\"user.monitoringFlags.reviewPendingFlag\"><h5>\nReview Call on : {{user.monitoringFlags.reviewPendingFlagDate | date:\'mediumDate\'}} {{user.monitoringFlags.reviewPendingFlagTime | date:\'shortTime\'}}\n</h5></div><h5 class=\"texth4\" ng-if=\"(user.achmandateRegFlag && !user.achmandateRegFlag)\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"warnIcon blink\"></md-icon>&nbsp;&nbsp;&nbsp;&nbsp;ACH Reg. Failed</h5><h5 \nclass=\"texth4\" ng-if=\"(user.fatcakycuboRegFlag && !user.fatcakycuboRegFlag)\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"warnIcon blink\"></md-icon>&nbsp;&nbsp;&nbsp;&nbsp;FATCA Reg. Failed</h5></div><div layout=\"column\" \nlayout-align=\"start center\" flex=\"20\"><ms-widget flippable=\"true\" style=\"width: 100%\"><ms-widget-front \nclass=\"p-15 md-white-bg\"><div ng-click=\"flipWidget()\" layout=\"column\" layout-align=\"start center\" class=\"potential\">\n<div layout=\"row\" layout-align=\"center center\" class=\"pCircle\"><span>{{user.potentialScale || \'NA\'}}</span></div><h6 \nclass=\"mt-0\">Potential</h6></div></ms-widget-front><ms-widget-back class=\"padding-16 md-white-bg h-100\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon ng-click=\"flipWidget()\" md-font-icon=\"icon-arrow-left\" flex=\"50\">\n</md-icon><span flex=\"50\" layout=\"row\" layout-align=\"space-between center\" style=\"font-weight: 700\"><span flex=\"50\">\n{{user.potentialScale}}</span> <a ng-click=\"vm.setPotentialScale(user);flipWidget()\" class=\"aPotential\">Set</a></span>\n</div><md-slider-container><md-slider flex min=\"1\" max=\"10\" ng-model=\"user.potentialScale\" aria-label=\"red\" \nid=\"red-slider\"></md-slider></md-slider-container></ms-widget-back></ms-widget><md-button class=\"md-primary enquiry\" \nng-show=\"user.enquiries[0].closeFlag === false\" ng-click=\"vm.openEnquirySideNav(\'enquirySideNav\',user)\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" style=\"color:#ffffff\"></md-icon>Enquiries</md-button><md-button \nclass=\"md-raised md-accent\" style=\"color:#fff !important\" ng-click=\"vm.openEMandateSideNav(\'eMandateSideNav\',user)\">\ne-Mandate</md-button></div><div layouit=\"column\" flex=\"40\"><div id=\"timeline1\" layout=\"row\" flex><md-icon \nmd-font-icon=\"icon-phone-forward\" ng-class=\"{\'success\':user.signUpSteps > 0}\"><md-tooltip md-direction=\"bottom\">Mobile \n<span ng-show=\"!user.signUpSteps\">not</span> Verified</md-tooltip></md-icon><div flex=\"10\" class=\"line\" \nng-class=\"{\'lineborder\': user.signUpSteps >=1}\"></div><md-icon md-font-icon=\"icon-account-check\" \nng-class=\"{\'success\':user.signUpSteps >1 }\"><md-tooltip md-direction=\"bottom\">Account <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 2)\">not</span> created.</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=2}\"></div><md-icon md-font-icon=\"icon-briefcase-checked\" \nng-class=\"{\'success\':user.signUpSteps >2 }\"><md-tooltip md-direction=\"bottom\">PAN and Adhar <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 3)\">not</span> Verified</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=3}\"></div><md-icon md-font-icon=\"icon-account-key\" \nng-class=\"{\'success\':user.signUpSteps >3 }\"><md-tooltip md-direction=\"bottom\">IIN <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 4)\">not</span> Created</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=4}\"></div><md-icon md-font-icon=\"icon-verified\" \nng-class=\"{\'success\':user.signUpSteps >4 }\"><md-tooltip md-direction=\"bottom\">Document <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 5)\">not</span> Verified</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=5}\"></div><md-icon md-font-icon=\"icon-check-circle\" \nng-class=\"{\'success\':user.signUpSteps >5 }\"><md-tooltip md-direction=\"bottom\">IIN <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 6)\">not</span> Activated</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=6}\"></div><md-icon md-font-icon=\"icon-cash-100\" \nng-class=\"{\'success\':user.signUpSteps >6 }\"><md-tooltip md-direction=\"bottom\"><span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 7)\">No</span> Investment</md-tooltip></md-icon></div><div \nlayout=\"row\" layout-wrap><div flex=\"100\"><h6>IIN Activation Date: {{user.activationDate | date: \'mediumDate\'}}</h6><h6>\nIIN No.: {{user.iin || \'NA\'}}</h6><h6>PAN: {{user.pan || \'NA\'}}</h6><h6>\nKYC Status: {{vm.eKyc[user.camsKycStatus] || \'NA\'}}</h6></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"max-width:90%\" layout-wrap><div ng-show=\"user.monitoringFlags.loanFlag\" \nng-click=\"vm.flagActivityDialog($event,user,\'loanFlag\')\" layout=\"row\" layout-align=\"center center\" \nclass=\"border btnBox c1\" flex=\"33\">L<md-tooltip md-direction=\"bottom\">Loan Flag</md-tooltip></div><div \nng-show=\"user.monitoringFlags.insuranceFlag\" ng-click=\"vm.flagActivityDialog($event,user,\'insuranceFlag\')\" \nlayout=\"row\" layout-align=\"center center\" class=\"border btnBox c2\" flex=\"33\">I<md-tooltip md-direction=\"bottom\">\nInsurance Flag</md-tooltip></div><div ng-show=\"user.monitoringFlags.sipFlag\" \nng-click=\"vm.flagActivityDialog($event,user,\'sipFlag\')\" layout=\"row\" layout-align=\"center center\" \nclass=\"border btnBox c3\" flex=\"33\">S<md-tooltip md-direction=\"bottom\">SIP Flag</md-tooltip></div><div \nng-show=\"user.monitoringFlags.lumpsumFlag\" ng-click=\"vm.flagActivityDialog($event,user,\'lumpsumFlag\')\" layout=\"row\" \nlayout-align=\"center center\" class=\"border btnBox c4\" flex=\"33\">LS<md-tooltip md-direction=\"bottom\">Lumpsum Flag\n</md-tooltip></div><div ng-show=\"user.monitoringFlags.externalHoldingFlag\" \nng-click=\"vm.flagActivityDialog($event,user,\'externalHoldingFlag\')\" layout=\"row\" layout-align=\"center center\" \nclass=\"border btnBox c5\" flex=\"33\">E<md-tooltip md-direction=\"bottom\">External Holding Flag</md-tooltip></div><div \nng-show=\"user.monitoringFlags.reversalFlag\" ng-click=\"vm.flagActivityDialog($event,user,\'reversalFlag\')\" layout=\"row\" \nlayout-align=\"center center\" class=\"border btnBox c6\" flex=\"33\">RL<md-tooltip md-direction=\"bottom\">Reversal Flag\n</md-tooltip></div><div ng-show=\"user.monitoringFlags.assignedFlag\" \nng-click=\"vm.flagActivityDialog($event,user,\'assignedFlag\')\" layout=\"row\" layout-align=\"center center\" \nclass=\"border btnBox c7\" flex=\"33\">A<md-tooltip md-direction=\"bottom\">Assignment Flag</md-tooltip></div><div \nng-show=\"user.monitoringFlags.redemptionFlag\" ng-click=\"vm.flagActivityDialog($event,user,\'redemptionFlag\')\" \nlayout=\"row\" layout-align=\"center center\" class=\"border btnBox c8\" flex=\"33\">RD<md-tooltip md-direction=\"bottom\">\nRedemption Flag</md-tooltip></div><div ng-show=\"user.priorityFlag\" layout=\"row\" ng-click=\"vm.resetPriority(user)\" \nlayout-align=\"center center\" class=\"border btnBox c9\" flex=\"33\">P<md-tooltip md-direction=\"bottom\">Priority Flag\n</md-tooltip></div><div ng-if=\"!user.callSchedule\" layout=\"row\" ng-click=\"vm.openSidenav(user,\'new\',\'reviewClicked\')\" \nlayout-align=\"center center\" class=\"border btnBox c10\" flex=\"33\">RV<md-tooltip md-direction=\"bottom\">Review Flag\n</md-tooltip></div><div ng-if=\"!user.callSchedule.atDate\" layout=\"row\" \nng-click=\"vm.openSidenav(user,\'new\',\'reviewClicked\')\" layout-align=\"center center\" class=\"border btnBox c10\" flex=\"33\">\nRV<md-tooltip md-direction=\"bottom\">Review Flag</md-tooltip></div><div ng-if=\"user.callSchedule.atDate\"><div \nng-if=\"user.callSchedule.autoCall\" layout=\"row\" ng-click=\"vm.openSidenav(user,\'new\',\'reviewClicked\')\" \nlayout-align=\"center center\" class=\"border btnBox c10\" flex=\"33\">RV<md-tooltip md-direction=\"bottom\">Review Flag\n</md-tooltip></div></div><div style=\"float:left; margin-left: 20px\"><md-input-container flex><label for=\"\">Assign To\n</label><md-select ng-model=\"user.assignedUser\" ng-change=\"vm.assignInternalUser(user)\" \nplaceholder=\"{{vm.placeholder}}\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"user in vm.allInternalUsers\" ng-value=\"user\">{{user.userName}} &nbsp;&nbsp;({{user.type}})</md-option>\n</md-select></md-input-container></div></div></div></div></div></md-virtual-repeat-container></md-content></div></div>");
$templateCache.put("app/main/aum-report/aum-report.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"aum-report\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>AUM Report\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-content><div flex=\"100\" \nclass=\"white-bg md-whiteframe-4dp margin-10\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"25\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-22 line-height-70\">{{vm.investmentData.totalCustomers || \'0\'}}</div></div><div \nclass=\"grey-50-bg border-top\" layout=\"row\" layout-align=\"center center\"><span class=\"h4 light-blue-fg fontMargin\">\nTotal Customers</span></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"25\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-22 line-height-70\">\n{{vm.investmentData.numberOfSchemes || \'0\'}}</div></div><div class=\"grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 red-fg fontMargin\">Schems</span></div></ms-widget-front></ms-widget>\n<ms-widget layout=\"column\" flex=\"25\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-22 line-height-70\">\n&#8377; {{vm.investmentData.netInvestedAmount | number:2}}</div></div><div class=\"grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 orange-fg fontMargin\">Invested Value</span></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"25\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-fg font-size-22 line-height-70\">\n&#8377; {{vm.investmentData.netCurrentAmount | number:2}}</div></div><div class=\"grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 blue-fg fontMargin\">Current Value</span></div></ms-widget-front>\n</ms-widget></div></div><md-tabs md-dynamic-height md-border-bottom class=\"md-padding\"><md-tab label=\"Customer Wise\"><a\n style=\"cursor: pointer; font-weight: bold; margin-left: 40px\" ng-click=\"vm.downloadCustomerData()\">Download</a>\n<md-content class=\"md-padding\"><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th md-column md-order-by=\"investorName\"><span\n class=\"text-center\">Customer Name</span></th><th md-column md-order-by=\"pan\"><span>PAN</span></th><th md-column \nmd-order-by=\"iin\"><span>IIN</span></th><th md-column md-order-by=\"numberOfSchemes\"><span>Scheme Count</span></th><th \nmd-column md-order-by=\"amount\"><span>Invested Amount (&#8377;)</span></th><th md-column md-order-by=\"currentValue\">\n<span>Current Amount (&#8377;)</span></th><th md-column md-order-by=\"absoluteReturn\"><span>Absolute Returns</span></th>\n<th md-column md-order-by=\"absoluteReturn\"><span>CAGR(in %)</span></th></tr></thead><tbody md-body><div \nclass=\"scrollable\" ms-scroll><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"item in vm.investmentDataCustomerData | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.customerWiseDetials(item)\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{item.investorName}}</td><td md-cell>{{item.pan}}</td><td md-cell>{{item.iin}}</td><td md-cell>\n{{item.numberOfSchemes}}</td><td md-cell>{{item.amount | number:2}}</td><td md-cell>{{item.currentValue | number:2}}\n</td><td md-cell>{{item.absoluteReturn | number:2}}</td><td md-cell>{{item.currentCAGR | number:2}}</td></tr></div>\n</tbody></table></md-table-container></md-virtual-repeat-container></div></md-content></md-tab><md-tab \nlabel=\"Scheme Wise\"><a style=\"cursor: pointer; font-weight: bold; margin-left: 40px\" \nng-click=\"vm.downloadSchemeData()\">Download</a><md-content class=\"md-padding\"><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th md-column \nmd-order-by=\"schemeName\"><span class=\"text-center\">Scheme Name</span></th><th md-column md-order-by=\"investors\"><span>\nCustomer</span></th><th md-column md-order-by=\"amountInvested\"><span>Invested Amount</span></th><th md-column \nmd-order-by=\"currentValue\"><span>Current Amount</span></th></tr></thead><tbody md-body><div class=\"scrollable\" \nms-scroll><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"item in vm.investmentDataSchemeWise | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.selectTableRow($index)\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{item.schemeName}}</td><td md-cell>{{item.investors.length}}</td><td md-cell>\n&#8377; {{item.amountInvested | number:2}}</td><td md-cell>&#8377; {{item.currentValue | number:2}}</td></tr></div>\n</tbody></table></md-table-container></md-virtual-repeat-container></md-content></md-tab></md-tabs></md-content></div>\n</div>");
$templateCache.put("app/main/bank-details/bank-details.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Update Bank Details</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" \nplaceholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div class=\"col-sm-12\"><div><form \nname=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" md-input-name=\"bankName\" \nlayout-align=\"space-between center\" layout-wrap flex><md-autocomplete md-input-name=\"bankName\" \nmd-menu-class=\"autocomplete-custom-template\" md-selected-item-change=\"vm.getBranchData(vm.schemes.bankName)\" \nmd-autofocus placeholder=\"BankName\" flex=\"100\" required md-floating-label=\"BankName\" \nmd-selected-item=\"vm.schemes.bankName\" md-items=\"bankname in vm.getMatches(searchText)\" md-search-text=\"searchText\" \nmd-item-text=\"bankname.bankName\" tabindex=\"1\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{bankname.bankName}}</span></md-item-template><md-not-found>\nNo Bank matching \"{{searchText}}\" were found.</md-not-found><div ng-messages=\"wizardStep1.bankname.$error\" \nng-if=\"wizardStep1.bankname.$touched\"><div ng-message=\"required\">You <b>must</b> choose a BankName</div></div>\n</md-autocomplete><div><input type=\"checkbox\" ng-model=\"chkselct\" tabindex=\"2\" ng-change=\"vm.clearFields()\">\n Tick for new Branch<br><br></div><md-autocomplete ng-hide=\"chkselct\" md-menu-class=\"autocomplete-custom-template\" \nmd-input-name=\"branch\" placeholder=\"Branch\" flex=\"100\" md-floating-label=\"Branch\" tabindex=\"3\" md-no-cache=\"true\" \nmd-selected-item=\"vm.bank.branchschemes\" md-items=\"branchname in vm.getBranchMatches(searchBranch)\" \nmd-search-text=\"searchBranch\" md-item-text=\"branchname.branch\" required><md-item-template><span \nmd-highlight-text=\"searchBranch\" md-highlight-flags=\"^i\">{{branchname.branch}}</span></md-item-template><md-not-found>\nNo Branch matching \"{{searchBranch}}\" were found.</md-not-found><div ng-messages=\"wizardStep1.branchname.$error\" \nng-if=\"wizardStep1.branchname.$touched\"><div ng-message=\"required\">You <b>must</b> choose a Branch</div></div>\n</md-autocomplete><md-input-container flex=\"100\" flex-gt-xs=\"100\" ng-show=\"chkselct\"><label>New Branch</label><input \ntype=\"text\" ng-model=\"vm.bank.Newbranchschemes\" tabindex=\"3\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ifscCode\" ng-model=\"vm.bank.branchschemes.ifscCode\" ng-change=\"checkIFSC()\" \ncapitalize ng-pattern=\"/^[A-Za-z]{4}\\d{7}$/\" ng-model-options=\"{allowInvalid: true }\" \nplaceholder=\"IFSC code Ex. ABCD1234567\" required tabindex=\"4\"><div ng-messages=\"wizardStep1.ifscCode.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>IFSC code must be a valid code</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>NSE-BankName</label><input type=\"text\" \nng-model=\"vm.bank.nseBankName\" name=\"nseBankName\" tabindex=\"5\"> <input type=\"hidden\" \nng-model=\"vm.bank.branchschemes._id\" name=\"ifscId\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>MICR Code</label><input type=\"text\" ng-model=\"vm.bank.branchschemes.micrCode\" name=\"micrCode\" tabindex=\"6\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Address</label><input type=\"text\" \nng-model=\"vm.bank.branchschemes.address\" name=\"address\" tabindex=\"7\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Contact</label><input type=\"text\" ng-model=\"vm.bank.branchschemes.contact\" \nname=\"contact\" tabindex=\"8\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>State</label>\n<input type=\"text\" ng-model=\"vm.bank.branchschemes.state\" required name=\"state\" tabindex=\"9\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>District</label><input type=\"text\" \nng-model=\"vm.bank.branchschemes.district\" name=\"district\" tabindex=\"10\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>City</label><input type=\"text\" ng-model=\"vm.bank.branchschemes.city\" required \nname=\"city\" tabindex=\"11\"></md-input-container></div></form></div><div><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<md-button ng-disabled=\"vm.disableSubmit()\" class=\"md-raised md-accent\" ng-click=\"vm.editBankDetails()\" \nstyle=\"color:#fff !important\">Update</md-button></md-input-container></div></div></div></md-card></div></div>");
$templateCache.put("app/main/blogs/blogDetail.html","<div class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg height-60\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div class=\"h3\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>{{vm.blogDetailView.title}}</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"backArrowColor\" ui-sref=\"app.blogs\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back\n</span></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.editBlog()\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"backArrowColor mr-8\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteBlog()\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"backArrowColor mr-8\"></md-icon></md-button></div></div><div \nclass=\"headerFixAllPages\"><md-content layout-padding><md-card md-theme=\"dark-white\" md-theme-watch><img \nng-if=\"vm.blogDetailView.blogImage\" class=\"md-card-image height-500 objectFit\" \nng-src=\"{{vm.blogLogoBaseUrl+vm.blogDetailView.blogImage}}\"> <span class=\"videowrapper\" \nng-if=\"vm.blogDetailView.blogVideoUrl\" ng-bind-html=\"vm.trustedHtml(vm.blogDetailView.blogVideoUrl)\"></span>\n<md-card-content><span class=\"md-headline\">Author: {{vm.blogDetailView.authorName}}</span></md-card-content>\n<md-card-content class=\"margin-left-5\"><span class=\"md-title\">Description</span><div \nng-bind-html=\"vm.blogDetailView.description\"></div></md-card-content></md-card></md-content></div></div>");
$templateCache.put("app/main/blogs/blogs.html","<div id=\"notes\" class=\"page-layout simple fullwidth doc-page element-doc-page scrollable\" ms-scroll><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\"><div \nclass=\"white-fg h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Blogs</span></div></div><div \nflex></div><div layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.createNewBlog\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\"></md-icon>New Blog\n</md-button><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.openSearchToolbar()\" \naria-label=\"open search toolbar\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon></md-button></div><div \nng-show=\"vm.searchToolbar\" class=\"md-toolbar-tools search-toolbar animate-slide-down md-accent-bg height-40\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:-1%\"><md-button class=\"md-icon-button\" \nng-click=\"vm.closeSearchToolbar()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><input \nid=\"search-notes-input\" placeholder=\"Search Blogs\" type=\"text\" ng-model=\"vm.search\" \nng-model-options=\"{\'debounce\': 200}\" flex></div></div><div class=\"headerFixAllPages\"><md-content layout-xs=\"column\" \nlayout=\"row\" layout-wrap><div flex-xs flex-gt-xs=\"33\" layout=\"column\" class=\"md-whiteframe-2dp\" \nng-click=\"vm.viewBlogDetail(blog)\" \nng-repeat=\"blog in vm.blogsData | filter:vm.search | filter:vm.filters | orderBy: \'time\':true \" style=\"cursor:pointer\">\n<md-card md-theme=\"dark-white\" md-theme-watch><img ng-if=\"!blog.blogSourceFlag\" ng-src=\"{{blog.image}}\" \nclass=\"md-card-image customHeight10\" alt=\"Washed Out\"> <span ng-if=\"blog.blogSourceFlag\" \nclass=\"videowrapper customHeight10\" ng-bind-html=\"vm.trustedHtml(blog.blogVideoUrl)\"></span><md-card-content><span \nclass=\"md-headline\">{{blog.title}}</span></md-card-content><md-card-content \nng-bind-html=\"vm.trustedHtml(blog.description)\"></md-card-content><md-card-content class=\"margin-left-5\"><span \nclass=\"md-title\">By {{blog.authorName}}</span> <span class=\"md-subhead\">on {{blog.blogDate|date : fullDate}}</span>\n</md-card-content></md-card></div></md-content></div></div>");
$templateCache.put("app/main/blogs/createNewBlog.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"center start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span ng-show=\"!vm.newBlog._id\">Create New Blog\n</span> <span ng-show=\"vm.newBlog._id\">Update Blog</span></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"backArrowColor\" ng-click=\"vm.goBack()\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div \nclass=\"headerFixAllPages\"><div class=\"content scrollable\" ms-scroll style=\"max-width:100%\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"wizardStep1\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\">Blog Information</div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex><div \nlayout=\"column\" flex=\"50\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"blogUrl\" \nng-model=\"vm.newBlog.blogUrl\" ng-pattern=\"vm.patternWild\" placeholder=\"Blog URL\" required><div \nng-messages=\"wizardStep1.blogUrl.$error\" ng-if=\"wizardStep1.blogUrl.$touched\"><div \nng-if=\"wizardStep1.blogUrl.$error.required\" ng-message=\"required\">Wild card character is not allowed!</div><div \nng-if=\"wizardStep1.blogUrl.$error.pattern\" ng-message=\"pattern\">Please Enter a <b>valid</b> Wild card character !</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"blogTitle\" \nng-model=\"vm.newBlog.title\" placeholder=\"Blog Title\" required><div ng-messages=\"wizardStep1.blogTitle.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Blog Title field is required.</span></div></div></md-input-container>\n<md-input-container></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"blogAuthor\" ng-model=\"vm.newBlog.authorName\" placeholder=\"Author Name\" required><div \nng-messages=\"wizardStep1.blogAuthor.$error\" role=\"alert\"><div ng-message=\"required\"><span>Blog Author Name is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-align=\"space-around center\" flex=\"50\" \nflow-init flow-name=\"imageFile.flowObj\" flow-files-added=\"processFile($files)\"><div \nclass=\"margin-bottom-15 objectParentBlog\" ng-show=\"!imageFile.flowObj.files.length &amp;&amp; vm.toggleImageVideoFlag\">\n<img class=\"md-card-image objectFitBlog\" ng-src=\"{{vm.dummyImage}}\"></div><div \nclass=\"margin-bottom-15 objectParentBlog\" ng-show=\"imageFile.flowObj.files.length &amp;&amp; vm.toggleImageVideoFlag\">\n<img class=\"objectFitBlog\" flow-img=\"imageFile.flowObj.files[0]\"></div><span class=\"videowrapper\" \nng-if=\"vm.newBlog.blogVideoUrl\" ng-bind-html=\"vm.showVideo(vm.newBlog.blogVideoUrl)\"></span><md-input-container \nng-show=\"!vm.toggleImageVideoFlag\" flex=\"100\" flex-gt-xs=\"50\"><input ng-show=\"!vm.toggleImageVideoFlag\" type=\"text\" \nname=\"blogVideoUrl\" ng-model=\"vm.newBlog.blogVideoUrl\" ng-change=\"vm.showVideo()\" placeholder=\"Video URL\"><div \nng-messages=\"wizardStep1.blogVideoUrl.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBlog Author Name is required.</span></div></div></md-input-container><md-button class=\"md-raised md-accent width-120\" \nng-click=\"vm.uploadVideo()\" style=\"color:#fff !important\">Upload Video</md-button><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"$flow.cancel(); showImage()\" style=\"color:#fff !important\" flow-btn>\nUpload Image</md-button></div><md-input-container class=\"md-block\" flex=\"100\"><text-angular name=\"blogDescription\" \nng-model=\"vm.newBlog.description\" md-select-on-focus required></text-angular><div \nng-messages=\"wizardStep1.blogDescription.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEnter the blog Description here!</span></div></div></md-input-container></div><md-button ng-show=\"!vm.newBlog._id\" \nclass=\"md-raised md-accent\" ng-click=\"vm.createBlog(); wizardStep1.resetForm();\" \nng-disabled=\"wizardStep1.$invalid || wizardStep1.$pristine\" style=\"color:#fff !important\">Submit</md-button><md-button \nng-show=\"vm.newBlog._id\" class=\"md-raised md-accent\" ng-click=\"vm.updateBlog(); wizardStep1.resetForm();\" \nng-disabled=\"wizardStep1.$invalid || wizardStep1.$pristine\" style=\"color:#fff !important\">Update</md-button></form>\n</div></div></div></div></div>");
$templateCache.put("app/main/change-password/change-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>S</span></div><div class=\"title\">Reset your password</div><form \nname=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"oldPassword\" ng-model=\"vm.form.oldPassword\" placeholder=\"Old Password\" required><div \nng-messages=\"resetPasswordForm.oldPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"newPassword\" ng-model=\"vm.form.newPassword\" placeholder=\"New Password \" required><div \nng-messages=\"resetPasswordForm.newPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNew Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Confirm New Password\" \nrequired><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nConfirm New Password field is required</span></div><div ng-if=\"vm.form.passwordConfirm !==vm.form.newPassword \"><span \nstyle=\"font-size:12px\">Confirm New Password field not matched</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UPDATE MY PASSWORD\" ng-click=\"vm.resetPassword()\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine || (vm.form.passwordConfirm !==vm.form.newPassword)\" \nstyle=\"color:#fff !important\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/ceaseRequest/ceaseRequest.html","<div id=\"ceaseRequest\" class=\"page-layout simple fullwidth doc-page element-doc-page scrollable\" ms-scroll><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg h3\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><span>Cease Request</span></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"e-commerce-products-search\" ng-model=\"q\" class=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div>\n</div><div class=\"headerFixAllPages\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"md-accordion\" \ndir-paginate=\"item in vm.ceaseData | filter:q | itemsPerPage: pageSize\" current-page=\"currentPage\"><md-toolbar \nclass=\"accordianHeading\" ng-click=\"vm.collapseAll(item)\"><div class=\"md-toolbar-tools\"><div class=\"col-md-6\"><h4><span>\n{{item.name}}</span></h4></div><div class=\"col-md-3\"><h4><span>{{item.iin}}</span></h4></div><div \nclass=\"col-md-2 md-toolbar-tools\"><h4><span>{{item.pan}}</span></h4></div><div class=\"col-md-1\"><span \nng-class=\"{expandCollapse:true, active:item.expanded}\"></span></div></div></md-toolbar><div \nng-class=\"{dataContent:true, activeContent:item.expanded}\"><md-table-container><table md-table><thead md-head><tr \nmd-row><th md-column style=\"min-width:300px\"><span>Scheme Name</span></th><th md-column><span>Folio Number</span></th>\n<th md-column><span>Amount</span></th><th md-column><span>Sip Start Date</span></th><th md-column><span>Sip End Date\n</span></th><th md-column><span>Payment Mechanism</span></th><th md-column><span>No. of Installment</span></th><th \nmd-column><span>Frequency</span></th><th md-column style=\"min-width:200px\"><span>Remarks</span></th><th md-column>\n<span>Cease Status</span></th><th md-column><span>Cease Initiated Date</span></th></tr></thead><tbody md-body><tr \nmd-row md-select=\"report\" ng-repeat=\"report in item.reports\" style=\"cursor:pointer\"><td md-cell><span>\n{{report.FROMSCHEME}}</span></td><td md-cell>{{report.FOLIONO}}</td><td md-cell>{{report.AMOUNT}}</td><td md-cell>\n{{report.FROMDATE}}</td><td md-cell>{{report.TODATE}}</td><td md-cell>{{report.PAYMENT_MECHANISM}}</td><td md-cell>\n{{report.NOOFINSTALL}}</td><td md-cell>{{report.FREQUENCY}}</td><td md-cell>{{report.REMARKS}}</td><td md-cell>\n{{report.CEASE_STATUS}}</td><td md-cell>{{report.CEASE_DATE}}</td></tr></tbody></table></md-table-container></div>\n</div><div class=\"other-controller\"><div class=\"text-center\"><dir-pagination-controls boundary-links=\"true\" \non-page-change=\"pageChangeHandler(newPageNumber)\" template-url=\"app/main/ceaseRequest/dirPagination.tpl.html\">\n</dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/ceaseRequest/dirPagination.tpl.html","<ul class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a></li><li \nng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" \nng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li \nng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" \nng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" \nng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" \nng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.last)\">\n&raquo;</a></li></ul>");
$templateCache.put("app/main/communicationSMS/communication-message.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"msgCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" ng-hide=\"vm.selectedCustomer.length>0\"><div class=\"h3\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><span>Customers Communication SMS</span></div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" ng-show=\"vm.selectedCustomer.length>0\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Customers Communication SMS</span></div><div \nclass=\"product-count secondary-text margin-top-10\"><span>Total Customers:</span> <span>{{vm.selectedCustomer.length}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-content layout-gt-sm=\"row\" \nclass=\"bgCustomHeader\"><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 6}\" ng-click=\"vm.customerCount(6)\" label=\"All Customer\">\nAll Customer</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 1}\" ng-click=\"vm.customerCount(1)\" label=\"Activated IIN\">\nActivated IIN</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 2}\" ng-click=\"vm.customerCount(2)\" label=\"Not Active\">Not Active\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 3}\" \nng-click=\"vm.customerCount(3)\" label=\"No IIN\">No IIN</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 4}\" ng-click=\"vm.customerCount(4)\" \nlabel=\"IIN Active But Zero Investment\">IIN Active But Zero Investment</md-button><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 5}\" ng-click=\"vm.customerCount(5)\" \nlabel=\"SIP Purchased\">SIP Purchased</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 7}\" label=\"Custom\" ui-sref=\"app.communicationSMS.custom\">Custom\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 8}\" \nlabel=\"Custom\" ui-sref=\"app.communicationSMS.prospects\">Prospects</md-button></md-content><div class=\"padding-10\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-content class=\"md-padding\" layout-gt-sm=\"row\" layout-padding><form \nname=\"sendMsg\" novalidate style=\"width:100%\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom:2%\"><span>Send a Message</span></div><md-input-container class=\"md-block\" flex=\"30\" \nstyle=\"margin-right:40px\"><label>Select Template</label><md-select name=\"reason\" ng-model=\"vm.SMSTemplate\" required \nng-change=\"vm.showTemplateDetails(vm.SMSTemplate)\"><md-option ng-repeat=\"template in vm.AllTempltate\" \nng-value=\"template.templatename\">{{template.templatename}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\"><text-angular name=\"messageDesc\" ng-model=\"vm.message\" \nmd-select-on-focus required></text-angular><div ng-messages=\"sendMsg.messageDesc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Enter the message here!</span></div></div></md-input-container><div layout=\"row\" \nlayout-sm=\"column\" ng-show=\"vm.selectedCustomer.length>0\"><h4>Message will be send to <b>{{vm.selectedCustomer.length}}\n</b> Customers</h4></div><div layout=\"row\" layout-sm=\"column\"><div flex=\"33\"><section layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\" layout-wrap><md-button class=\"md-raised md-accent width-160\" \nng-click=\"vm.createEmail(\'SMS\')\" ng-disabled=\"vm.disabledSMS()\" style=\"color:#fff !important\">Send SMS</md-button>\n</section></div></div></form></md-content></div></div><div class=\"content\" ng-show=\"vm.selectedCustomer.length>0\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div ng-cloak><md-content class=\"md-padding\"><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>S.No.</span></th><th md-column md-order-by=\"userName\">\n<span>Name</span></th><th md-column md-order-by=\"mobileNo\"><span>Contact</span></th><th md-column md-order-by=\"email\">\n<span>Email Id</span></th><th md-column md-order-by=\"pan\"><span>PAN</span></th><th md-column md-order-by=\"iin\"><span>\nIIN</span></th><th md-column><span>Action</span></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nmd-auto-select md-virtual-repeat=\"customer in vm.selectedCustomer | filter:search | orderBy: vm.query.order\" \nstyle=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell><span \nng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell>{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>\n{{(customer.email) ? (customer.email):\'NA\'}}</td><td md-cell>{{(customer.pan) ? (customer.pan):\'NA\'}}</td><td md-cell>\n{{(customer.iin) ? (customer.iin):\'NA\'}}</td><td md-cell><md-icon md-font-icon=\"icon-delete\" \nng-click=\"vm.deleteUser($index)\" class=\"s20\"></md-icon></td></tr></tbody></table></md-table-container>\n</md-virtual-repeat-container></md-content></div></div></div></div></div>");
$templateCache.put("app/main/communication/communication-message.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"msgCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" ng-hide=\"vm.selectedCustomer.length>0\"><div class=\"h3\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><span>Customers Communication</span></div></div><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\" ng-show=\"vm.selectedCustomer.length>0\"><div class=\"h3\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><span>Customers Communication</span></div><div \nclass=\"product-count secondary-text margin-top-10\"><span>Total Customers:</span> <span>{{vm.selectedCustomer.length}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-content layout-gt-sm=\"row\" \nclass=\"bgCustomHeader\"><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 6}\" ng-click=\"vm.customerCount(6)\" label=\"All Customer\">\nAll Customer</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 1}\" ng-click=\"vm.customerCount(1)\" label=\"Activated IIN\">\nActivated IIN</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 2}\" ng-click=\"vm.customerCount(2)\" label=\"Not Active\">Not Active\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 3}\" \nng-click=\"vm.customerCount(3)\" label=\"No IIN\">No IIN</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 4}\" ng-click=\"vm.customerCount(4)\" \nlabel=\"IIN Active But Zero Investment\">IIN Active But Zero Investment</md-button><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 5}\" ng-click=\"vm.customerCount(5)\" \nlabel=\"SIP Purchased\">SIP Purchased</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 7}\" label=\"Custom\" ui-sref=\"app.communication.custom\">Custom\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 8}\" \nlabel=\"Custom\" ui-sref=\"app.communication.prospects\">Prospects</md-button></md-content><div class=\"padding-10\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-content class=\"md-padding\" layout-gt-sm=\"row\" layout-padding><form \nname=\"sendMsg\" novalidate style=\"width:100%\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom:2%\"><span>Send a Message</span></div><md-input-container class=\"md-block\"><label>Subject</label>\n<input ng-model=\"vm.subject\" required></md-input-container><md-input-container class=\"md-block\" flex=\"100\">\n<text-angular name=\"messageDesc\" ng-model=\"vm.message\" md-select-on-focus required></text-angular><div \nng-messages=\"sendMsg.messageDesc.$error\" role=\"alert\"><div ng-message=\"required\"><span>Enter the message here!</span>\n</div></div></md-input-container><div layout=\"row\" layout-sm=\"column\" ng-show=\"vm.selectedCustomer.length>0\"><h4>\nMessage will be send to <b>{{vm.selectedCustomer.length}}</b> Customers</h4></div><div layout=\"row\" layout-sm=\"column\">\n<div flex=\"25\" flow-init flow-name=\"imageFile.flowObj\" flow-files-added=\"processFile($files)\"><section layout=\"row\" \nlayout-sm=\"column\" layout-align=\"start center\" layout-wrap><md-button class=\"md-raised md-accent width-160\" \nng-click=\"$flow.cancel();\" flow-btn style=\"color:#fff !important\">Add Attachment</md-button><br><p \nng-repeat=\"file in imageFile.flowObj.files\">{{$index + 1}}.&nbsp;&nbsp;{{file.name}}<md-icon class=\"logo-icon mr-8\" \nmd-font-icon=\"icon-close-circle\" ng-click=\"vm.removeAttachment($index)\" style=\"color:#fff !important\"></md-icon></p>\n</section></div><div flex=\"33\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap>\n<md-button class=\"md-raised md-accent width-160\" ng-click=\"vm.createEmail(\'EMAIL\')\" ng-disabled=\"vm.disabledEmail()\" \nstyle=\"color:#fff !important\">Send Mail</md-button></section></div></div></form></md-content></div></div><div \nclass=\"content\" ng-show=\"vm.selectedCustomer.length>0\"><div class=\"white-bg md-whiteframe-4dp\"><div ng-cloak>\n<md-content class=\"md-padding\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table \nmd-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th \nmd-column><span>S.No.</span></th><th md-column md-order-by=\"userName\"><span>Name</span></th><th md-column \nmd-order-by=\"mobileNo\"><span>Contact</span></th><th md-column md-order-by=\"email\"><span>Email Id</span></th><th \nmd-column md-order-by=\"pan\"><span>PAN</span></th><th md-column md-order-by=\"iin\"><span>IIN</span></th><th md-column>\n<span>Action</span></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"customer in vm.selectedCustomer | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\">\n<td md-cell>{{$index+1}}</td><td md-cell><span ng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">\n{{(customer.nseData.INVESTOR_NAME)}}</span> <span ng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">\n{{(customer.userName) ? (customer.userName) :\'NA\'}}</span></td><td md-cell>\n{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>{{(customer.email) ? (customer.email):\'NA\'}}</td><td\n md-cell>{{(customer.pan) ? (customer.pan):\'NA\'}}</td><td md-cell>{{(customer.iin) ? (customer.iin):\'NA\'}}</td><td \nmd-cell><md-icon md-font-icon=\"icon-delete\" ng-click=\"vm.deleteUser($index)\" class=\"s20\"></md-icon></td></tr></tbody>\n</table></md-table-container></md-virtual-repeat-container></md-content></div></div></div></div></div>");
$templateCache.put("app/main/countries/addcountries.html","<div id=\"salesCustomer\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" style=\"display: flex; justify-content: space-between\"><div class=\"white-fg\" \nstyle=\"display: flex; flex-direction: column; justify-content: flex-start\"><div class=\"h3\" \nstyle=\"display: flex; align-items: center; margin: 0\"><span>Add Countries</span></div></div></div><md-content \nlayout-padding class=\"w-500\"><h1>Add a New Country:</h1><div><label for=\"newCountryName\">Country Name:</label><input \ntype=\"text\" class=\"form-control\" id=\"newCountryName\" ng-model=\"vm.newCountryName\" required></div><div><label \nfor=\"newCountryCode\">Country Code:</label><input type=\"text\" class=\"form-control\" id=\"newCountryCode\" \nng-model=\"vm.newCountryCode\" required></div><div><label for=\"newCallingCode\">Calling Code:</label><input type=\"text\" \nclass=\"form-control\" id=\"newCallingCode\" ng-model=\"vm.newCallingCode\" required></div><div><label \nfor=\"newCountryCallingCode\">Country Calling Code:</label><input type=\"text\" class=\"form-control\" \nid=\"newCountryCallingCode\" ng-model=\"vm.newCountryCallingCode\" required></div><div><label for=\"newIsVisible\">\nVisibility:</label><input type=\"checkbox\" class=\"form-check-input\" id=\"newIsVisible\" ng-model=\"vm.newIsVisible\"></div>\n<button class=\"btn btn-primary\" ng-click=\"vm.addCountry()\">Add Country</button></md-content></div>");
$templateCache.put("app/main/countries/countries.html","<div id=\"salesCustomer\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Countries\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"searchText\" placeholder=\"Search Country.\" flex></div></div><md-content layout-padding \nlayout-align=\"end center\"><button class=\"btn btn-primary\" ng-click=\"vm.addCountry()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"ng-scope white-text md-default-theme md-font material-icons icon-plus\" aria-hidden=\"true\"></md-icon>\nAdd a New Country</button></md-content><md-content layout-padding><div><h1>Countries You Have Added:</h1></div>\n</md-content><div class=\"ext-content\"><md-table-container class=\"tablePbmSolved\"><table md-table><thead md-head><tr \nmd-row><th md-column><span>Country Name</span></th><th md-column><span>Country Code</span></th><th md-column><span>\nCalling Code</span></th><th md-column><span>Country Calling Code</span></th><th md-column><span>Is Visible</span></th>\n<th md-column><span>Show/Hide</span></th><th md-column><span>Edit</span></th></tr></thead><tbody md-body \nng-controller=\"countries as vm\"><tr md-row ng-repeat=\"country in vm.Countries | filter:searchText\"><td md-cell><span \nclass=\"country-info\">{{ country.CountryName }}</span></td><td md-cell><span class=\"country-info\">\n{{ country.CountryCode }}</span></td><td md-cell><span class=\"country-info\">{{ country.CallingCode }}</span></td><td \nmd-cell><span class=\"country-info\">{{ country.CountryCallingCode }}</span></td><td md-cell><span class=\"country-info\">\n{{ country.IsVisible }}</span></td><td md-cell><button ng-click=\"vm.toggleVisibility(country)\" \nng-class=\"{ \'btn btn-success\': country.IsVisible, \'btn btn-danger\': !country.IsVisible }\">\n{{ country.IsVisible ? \'Hide\' : \'Show\' }}</button></td><td md-cell><button ng-click=\"vm.editedCountry(country)\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"ng-scope md-font material-icons md-dark-white-theme icon-pencil\" \naria-hidden=\"true\"></md-icon></button></td></tr></tbody></table></md-table-container></div></div>");
$templateCache.put("app/main/countries/editcountries.html","<div id=\"salesCustomer\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" style=\"display: flex; justify-content: space-between\"><div class=\"white-fg\" \nstyle=\"display: flex; flex-direction: column; justify-content: flex-start\"><div class=\"h3\" \nstyle=\"display: flex; align-items: center; margin: 0\"><span>Edit Countries</span></div></div></div><md-content \nlayout-padding class=\"w-500\"><h1>Edit Country:</h1><div><label for=\"editCountryName\">Country Name:</label><input \ntype=\"text\" class=\"form-control\" id=\"editCountryName\" ng-model=\"vm.country.CountryName\" required></div><div><label \nfor=\"editCountryCode\">Country Code:</label><input type=\"text\" class=\"form-control\" id=\"editCountryCode\" \nng-model=\"vm.country.CountryCode\" required></div><div><label for=\"editCallingCode\">Calling Code:</label><input \ntype=\"text\" class=\"form-control\" id=\"editCallingCode\" ng-model=\"vm.country.CallingCode\" required></div><div><label \nfor=\"editCountryCallingCode\">Country Calling Code:</label><input type=\"text\" class=\"form-control\" \nid=\"editCountryCallingCode\" ng-model=\"vm.country.CountryCallingCode\" required></div><div><label for=\"editIsVisible\">\nVisibility:</label><input type=\"checkbox\" class=\"form-check-input\" id=\"editIsVisible\" ng-model=\"vm.country.IsVisible\">\n</div><button class=\"btn btn-primary\" ng-click=\"vm.editedCountry()\">Save</button></md-content></div>");
$templateCache.put("app/main/customers/ACHMandateDetails.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\" ng-if=\"vm.MandateDetail.length > 0\"><md-content class=\"margin-bottom-10\" \nng-repeat=\"ach in vm.MandateDetail | orderBy:\'ACH_MANDATE_STATUS\'\"><div class=\"padding-5\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" \nlayout-padding flex=\"33\"><span class=\"title\">ACH MANDATE DATE : &nbsp;&nbsp; {{ach.MANDATE_DATE || \'NA\'}}</span> <span>\nACH AMOUNT : &nbsp;&nbsp;{{ach.AMOUNT}}</span> <span>ACH FROM DATE : &nbsp;&nbsp; {{ach.FROM_DATE}}</span> <span>\nACH TO DATE : &nbsp;&nbsp; {{ach.TO_DATE}}</span> <span>ACH MANDATE ID : &nbsp;&nbsp; {{ach.MANDATE_ID}}</span></div>\n<div layout=\"column\" layout-align=\"space-around start\" layout-padding flex=\"33\"><span>\nBANK NAME : &nbsp;&nbsp; {{ach.BANK_NAME}}</span> <span>ACCOUNT NO : &nbsp;&nbsp;{{ach.ACCOUNT_NO}}</span> <span>\nACH PROCESS MODE : &nbsp;&nbsp; {{ach.PROCESS_MODE}}</span><span>UMRN NO : &nbsp;&nbsp;{{ach.UMRN_NO}}</span></div><div\n layout=\"column\" layout-align=\"space-around start\" layout-padding flex=\"33\"><span>\nACH MANDATE STATUS : &nbsp;&nbsp;{{ach.ACH_MANDATE_STATUS}} </span><span>\nACH REJECTION REMARKS : &nbsp;&nbsp;{{ach.REJECTION_REMARKS || \'NA\'}}</span> <span>\nACH REJECTION REASON : &nbsp;&nbsp;{{ach.ACH_MANDATE_REJECTION_REASON || \'NA\'}}</span></div></div></div></md-content>\n</div><div class=\"article\" ng-if=\"vm.CeaseDetail.length == 0\"><md-content class=\"md-whiteframe-4dp\"><div \nclass=\"padding-5\" layout=\"center center\"><h4 class=\"margin-left-30\">No Data</h4></div></md-content></div></div></div>\n</div>");
$templateCache.put("app/main/customers/AddBankDetail.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><h4 \nclass=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Customer Detail</h4><div \nlayout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" \nlayout-padding><span class=\"title\">Name : &nbsp;&nbsp; {{vm.customerDetail.userName}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN : &nbsp;&nbsp; {{vm.customerDetail.iin}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>Email : &nbsp;&nbsp; {{vm.customerDetail.email}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{vm.customerDetail.pan}}</span></div></div></div></div></div><div class=\"scrollable\" ms-scroll><div\n class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Add Bank Details</h4><div \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div layout=\"row\" layout-align=\"center center\"><form name=\"wizardStep1\" class=\"md-inline-form\" \nstyle=\"width: 60%\"><br><div layout=\"column\" layout-align=\"start stretch\" flex><md-input-container flex=\"100\"><label>\nAccount Number</label><input type=\"text\" numeric-regex ng-model=\"vm.acc_no\" name=\"accNo\" required></md-input-container>\n<md-input-container flex=\"100\" style=\"margin-bottom: 40px\"><label>Account Type</label><md-select ng-model=\"vm.accType\" \nname=\"accType\" required><md-option ng-repeat=\"item in vm.accTypeList\" ng-value=\"item.ACC_TYPE\">{{item.DESCRIPTION}}\n</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start center\" flex><md-input-container \nflex=\"100\"><label>IFSC</label><input type=\"text\" ng-model=\"vm.ifsc\" capitalize maxlength=\"11\" name=\"ifsc\" required><div\n ng-messages=\"myForm.ifsc.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>IFSC is required\n</span></div></div></md-input-container></div><md-input-container flex=\"100\"><label>Default Bank</label><md-switch \nng-model=\"vm.defaultBank\" aria-label=\"Default Bank\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">\n{{vm.defaultBank === \'Y\' ? \'Yes\' : \'No\'}}</md-switch></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.AddBankDetail()\" \nstyle=\"color:#fff !important\">Submit</md-button></div></div></form></div></md-card></div></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/customers/PurchaseTransactionLUMP.html","<style>\n.sticky-search {\r\n        position: sticky;\r\n        top: 0;\r\n        background: white;\r\n        z-index: 100;\r\n        padding: 10px;\r\n    }\r\n\r\n    .search-box {\r\n        width: 100%;\r\n        padding: 8px;\r\n        font-size: 16px;\r\n        border: 1px solid #ccc;\r\n        border-radius: 4px;\r\n    }\n</style><div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><h4 \nclass=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Customer Detail</h4><div \nlayout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" \nlayout-padding><span class=\"title\">Name : &nbsp;&nbsp; {{vm.customerDetail.userName}}</span> <span>\nIIN : &nbsp;&nbsp; {{vm.customerDetail.iin}}</span></div><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span>Contact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span> <span>\nEmail : &nbsp;&nbsp; {{vm.customerDetail.email}}</span></div><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span>PAN : &nbsp;&nbsp; {{vm.customerDetail.pan}}</span> <span class=\"title\">\nBank Name : &nbsp;&nbsp; {{vm.customerDetail.nseData.BANK_NAME}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nBranch Name : &nbsp;&nbsp; {{vm.customerDetail.nseData.BRANCH_NAME}}</span> <span>\nAccount Type: : &nbsp;&nbsp; {{vm.customerDetail.nseData.AC_TYPE}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nAccount No: : &nbsp;&nbsp; {{vm.customerDetail.nseData.AC_NO}}</span> <span>\nIfsc : &nbsp;&nbsp; {{vm.customerDetail.nseData.IFSC_CODE}}</span></div></div></div></div></div><div \nclass=\"scrollable\" ms-scroll ng-if=\"vm.transactions.length > 0\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Purchase List(LUMP)</h4><table\n class=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><tr><th>AMC Name</th><th>Scheme Name</th>\n<th>Folio</th><th>Amount</th><th>Delete</th></tr><tr ng-repeat=\"transaction in vm.transactions track by $index\"><td>\n{{ transaction.productAmcName || \'-\' }}</td><td>{{ transaction.schemeName || \'-\' }}</td><td>\n{{ transaction.folio_no|| \'-\' }}</td><td>{{ transaction.order_amount || \'-\' }}</td><td><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.deleteTransaction($index)\">Delete</md-button></td></tr></table>\n<md-input-container flex=\"10\" flex-gt-xs ng-if=\"vm.transactions.length > 0\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.purchaseTransaction()\" style=\"color:#fff !important\">Submit</md-button></md-input-container></div></div>\n</div><div class=\"article\"><md-content><form novalidate name=\"wizardStep1\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><div layout=\"row\" layout-align=\"center\" layout-wrap \nflex><h4 class=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Investment Detail(LUMP)</h4>\n<br><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>AMC Name</label><md-select ng-model=\"vm.selectedFund\" \nmd-on-close=\"vm.searchTextAmc = \'\'\" ng-change=\"vm.getAllScheme(vm.selectedFund.amcCode, vm.selectedFund.longName)\" \nname=\"Select a Fund\" required><md-select-header class=\"sticky-search\"><input ng-model=\"vm.searchTextAmc\" type=\"text\" \nplaceholder=\"Search AMC...\" class=\"md-input search-box\" ng-click=\"$event.stopPropagation();\" \nng-keydown=\"$event.stopPropagation();\" ng-change=\"$event.stopPropagation();\" autocomplete=\"off\"></md-select-header>\n<md-option ng-repeat=\"x in vm.allAmc | filter:{LONG_NAME: vm.searchTextAmc}\" \nng-value=\"{ amcCode: x.AMC_CODE, longName: x.LONG_NAME, productAmcName: x.productAmcName }\">\n{{x.LONG_NAME}} ({{x.AMC_CODE}})</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Folio</label><md-select ng-model=\"vm.folio\" name=\"Folio\"><md-option \nng-repeat=\"x in vm.folioList\" ng-value=\"x\">{{x}}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Scheme Name</label><md-select ng-model=\"vm.product_code\" \nmd-on-close=\"vm.searchTextSch = \'\'\" name=\"SchemeName\" required ng-change=\"vm.selectScheme(vm.product_code)\">\n<md-select-header class=\"sticky-search\"><input ng-model=\"vm.searchTextSch\" type=\"text\" placeholder=\"Search Scheme...\" \nclass=\"md-input search-box\" ng-click=\"$event.stopPropagation();\" ng-keydown=\"$event.stopPropagation();\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"x in vm.schemeList | filter:{productDisplayName: vm.searchTextSch}\" ng-value=\"x\">\n{{x.productDisplayName}} ({{x.ISIN}})</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Amount</label><input type=\"number\" ng-model=\"vm.amount\" name=\"amount\" required>\n</md-input-container><md-input-container flex=\"10\" flex-gt-xs=\"100\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addTransaction(wizardStep1)\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Add Fund</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.clearForm(wizardStep1)\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-refresh\" \nstyle=\"color:#fff\"></md-icon>Reset</md-button></md-input-container></div></div></div></md-card></div></form>\n</md-content></div></div></div></div>");
$templateCache.put("app/main/customers/PurchaseTransactionSIP.html","<style>\n.sticky-search {\r\n        position: sticky;\r\n        top: 0;\r\n        background: white;\r\n        z-index: 100;\r\n        padding: 10px;\r\n    }\r\n    .search-box {\r\n        width: 100%;\r\n        padding: 8px;\r\n        font-size: 16px;\r\n        border: 1px solid #ccc;\r\n        border-radius: 4px;\r\n    }\n</style><div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><h4 \nclass=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Customer Detail</h4><div \nlayout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" \nlayout-padding><span class=\"title\">Name : &nbsp;&nbsp; {{vm.customerDetail.userName}}</span> <span>\nIIN : &nbsp;&nbsp; {{vm.customerDetail.iin}}</span></div><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span>Contact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span> <span>\nEmail : &nbsp;&nbsp; {{vm.customerDetail.email}}</span></div><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span>PAN : &nbsp;&nbsp; {{vm.customerDetail.pan}}</span> <span class=\"title\">\nBank Name : &nbsp;&nbsp; {{vm.customerDetail.nseData.BANK_NAME}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nBranch Name : &nbsp;&nbsp; {{vm.customerDetail.nseData.BRANCH_NAME}}</span> <span>\nAccount Type: : &nbsp;&nbsp; {{vm.customerDetail.nseData.AC_TYPE}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nAccount No: : &nbsp;&nbsp; {{vm.customerDetail.nseData.AC_NO}}</span> <span>\nIfsc : &nbsp;&nbsp; {{vm.customerDetail.nseData.IFSC_CODE}}</span></div></div></div></div></div><div \nclass=\"scrollable\" ms-scroll ng-if=\"vm.transactions.length > 0\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Purchase List(SIP)</h4><table \nclass=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><tr><th>Fund Name</th><th>Scheme Name</th>\n<th>Folio</th><th>Amount</th><th>Mandate ID</th><th>Transaction Nature</th><th>Delete</th></tr><tr \nng-repeat=\"transaction in vm.transactions track by $index\"><td>{{ transaction.productAmcName || \'-\' }}</td><td>\n{{ transaction.schemeName || \'-\' }}</td><td>{{ transaction.folio || \'-\' }}</td><td>{{ transaction.amount || \'-\' }}</td>\n<td>{{ transaction.xsip_mandate_id|| \'-\' }}</td><td>\n{{ transaction.schemeNature === \'S\' ? \'SIP\' : (transaction.schemeNature === \'N\' ? \'LUMP\' : \'-\') }}</td><td><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.deleteTransaction($index)\">Delete</md-button></td></tr></table></div>\n<md-input-container flex=\"10\" flex-gt-xs ng-if=\"vm.transactions.length > 0\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.purchaseTransaction()\" style=\"color:#fff !important\">Submit</md-button></md-input-container></div></div>\n<div class=\"article\"><md-content><form novalidate name=\"wizardStep1\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><div layout=\"row\" layout-align=\"center\" layout-wrap \nflex><h4 class=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Investment Detail(SIP)</h4>\n<br><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>AMC Name</label><md-select ng-model=\"vm.selectedFund\" \nmd-on-close=\"vm.searchTextAmc = \'\'\" ng-change=\"vm.getAllScheme(vm.selectedFund.amcCode, vm.selectedFund.longName)\" \nname=\"Select a Fund\" required><md-select-header class=\"sticky-search\"><input ng-model=\"vm.searchTextAmc\" type=\"text\" \nplaceholder=\"Search AMC...\" class=\"md-input search-box\" ng-click=\"$event.stopPropagation();\" \nng-keydown=\"$event.stopPropagation();\" ng-change=\"$event.stopPropagation();\" autocomplete=\"off\"></md-select-header>\n<md-option ng-repeat=\"x in vm.allAmc | filter:{LONG_NAME: vm.searchTextAmc}\" \nng-value=\"{ amcCode: x.AMC_CODE, longName: x.LONG_NAME, productAmcName: x.productAmcName}\">\n{{x.LONG_NAME}} ({{x.AMC_CODE}})</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Folio</label><md-select ng-model=\"vm.folio\" name=\"Folio\"><md-option \nng-repeat=\"x in vm.folioList\" ng-value=\"x\">{{x}}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Scheme Name</label><md-select ng-model=\"vm.product_code\" \nmd-on-close=\"vm.searchTextSch = \'\'\" name=\"SchemeName\" required ng-change=\"vm.selectScheme(vm.product_code)\">\n<md-select-header class=\"sticky-search\"><input ng-model=\"vm.searchTextSch\" type=\"text\" placeholder=\"Search Scheme...\" \nclass=\"md-input search-box\" ng-click=\"$event.stopPropagation();\" ng-keydown=\"$event.stopPropagation();\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"x in vm.schemeList | filter:{productDisplayName: vm.searchTextSch}\" ng-value=\"x\">\n{{x.productDisplayName}} ({{x.ISIN}})</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Frequency</label><md-select ng-model=\"vm.sip_freq\" name=\"frequency\" required><md-option \nng-repeat=\"x in vm.frequencyArray\" ng-value=\"x.desc\">{{x.desc}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>SIP Date</label><md-select ng-model=\"vm.sip_period_day\" \nname=\"mobileRelation\" required ng-change=\"vm.sipStart_SipEnd(vm.sip_period_day)\"><md-option \nng-repeat=\"x in vm.sipDateArray\" ng-value=\"x\">{{x}}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Amount</label><input type=\"number\" ng-model=\"vm.amount\" name=\"amount\" required>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>First Order Today</label><md-select \nng-model=\"vm.first_order_today\" placeholder=\"First Order Today\" required><md-option ng-value=\"\'Y\'\">YES</md-option>\n<md-option ng-value=\"\'N\'\">NO</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Existing MANDATE_ID</label><md-select ng-model=\"vm.selectedUmrn\" \nng-change=\"vm.updateAchAmount()\" ng-disabled=\"vm.umrnOptions.length === 0\" placeholder=\"Select a UMRN\" required>\n<md-option ng-repeat=\"umrn in vm.umrnOptions\" ng-value=\"umrn\">{{ umrn.MANDATE_ID}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-if=\"vm.selectedUmrn\"><h4>\nACH Amount: {{ vm.selectedUmrn.AMOUNT || \'N/A\' }}</h4></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" ng-if=\"!vm.selectedUmrn\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.sip_period_day\"><h4 ng-if=\"vm.sip_period_day\">Your SIP will start <span style=\"color: red\">\n{{vm.sip_from_date}}</span> to <span style=\"color: red\">{{vm.sip_end_date}}</span></h4></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"></md-input-container><md-input-container flex=\"10\" flex-gt-xs=\"100\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.addTransaction(wizardStep1)\" style=\"color:#fff !important\"><md-icon\n md-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Add Fund</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.clearForm(wizardStep1)\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-refresh\" \nstyle=\"color:#fff\"></md-icon>Reset</md-button></md-input-container></div></div></div></md-card></div></form>\n</md-content></div></div></div></div>");
$templateCache.put("app/main/customers/RedemptionTransaction.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll \nng-if=\"(vm.transactions.length > 0 && vm.showInternalExternal === \'internal\') || (vm.externlTransactions.length > 0 && vm.showInternalExternal === \'external\')\">\n<div class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Redemption List</h4><table \nclass=\"table table-bordered\" ng-if=\"vm.showInternalExternal === \'internal\'\" \nstyle=\"margin-left: 11px; margin-right: 20px\"><thead><tr><th>Fund Name</th><th>Scheme Name</th><th>Folio</th><th>\nAmount/Unit</th><th>Redemption Type</th><th>Delete</th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.transactions track by $index\"><td>{{transaction.amcName}}</td><td>{{transaction.scheme}}\n</td><td>{{transaction.folio_no}}</td><td ng-if=\"transaction.all_units === \'N\'\">{{transaction.amt_unit}}</td><td \nng-if=\"transaction.all_units === \'Y\'\">All UNITS</td><td>{{transaction.amt_unit_type}}</td><td><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.deleteTransaction($index)\">Delete</md-button></td></tr></tbody></table><table \nclass=\"table table-bordered\" ng-if=\"vm.showInternalExternal === \'external\'\" \nstyle=\"margin-left: 11px; margin-right: 20px\"><thead><tr><th>Fund Name</th><th>Scheme Name</th><th>Folio</th><th>\nAmount/Unit</th><th>Redemption Type</th><th>Delete</th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.externlTransactions track by $index\"><td>{{transaction.amcName}}</td><td>\n{{transaction.schemeName}}</td><td>{{transaction.folio}}</td><td ng-if=\"transaction.all_units === \'N\'\">\n{{transaction.amt_unit}}</td><td ng-if=\"transaction.all_units === \'Y\'\">All UNITS</td><td>{{transaction.amt_unit_type}}\n</td><td><md-button class=\"md-raised md-warn\" ng-click=\"vm.deleteExternalTransaction($index)\">Delete</md-button></td>\n</tr></tbody></table></div></div><md-input-container flex=\"100\" style=\"margin: 20px\"><md-button \nclass=\"md-raised md-accent\" \nng-click=\"vm.showInternalExternal === \'internal\' ? vm.redemptionTransaction() : vm.redemptionExternalTransaction()\" \nstyle=\"color:#fff !important; width: 100%\">Execute Redemption Transaction</md-button></md-input-container></div><div \nclass=\"article\"><md-content><form novalidate name=\"redemptionForm\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Investment Details (Redemption)</h4><div \nstyle=\"display: flex; background-color: #FFFFFF; margin-bottom: 15px; text-align: center; border-bottom: 1px solid #E0E0E0\">\n<h5 ng-click=\"vm.showInternal()\" \nng-style=\"{\r\n                                                    \'color\': vm.showInternalExternal === \'internal\' ? \'white\' : \'#2D323E\',\r\n                                                    \'background-color\': vm.showInternalExternal === \'internal\' ? \'#2D323E\' : \'transparent\',\r\n                                                    \'display\': \'flex\',\r\n                                                    \'justify-content\': \'center\',\r\n                                                    \'align-items\': \'center\',\r\n                                                    \'height\': \'40px\',\r\n                                                    \'margin\': \'0 2px 0 0\',\r\n                                                    \'flex\': \'1\',\r\n                                                    \'cursor\': \'pointer\',\r\n                                                    \'border-radius\': \'4px 4px 0 0\',\r\n                                                    \'font-weight\': vm.showInternalExternal === \'internal\' ? \'bold\' : \'normal\'\r\n                                                }\">\nInternal Investments</h5><h5 ng-click=\"vm.showExternal()\" \nng-style=\"{\r\n                                                    \'color\': vm.showInternalExternal === \'external\' ? \'white\' : \'#2D323E\',\r\n                                                    \'background-color\': vm.showInternalExternal === \'external\' ? \'#2D323E\' : \'transparent\',\r\n                                                    \'display\': \'flex\',\r\n                                                    \'justify-content\': \'center\',\r\n                                                    \'align-items\': \'center\',\r\n                                                    \'height\': \'40px\',\r\n                                                    \'margin\': \'0\',\r\n                                                    \'flex\': \'1\',\r\n                                                    \'cursor\': \'pointer\',\r\n                                                    \'border-radius\': \'4px 4px 0 0\',\r\n                                                    \'font-weight\': vm.showInternalExternal === \'external\' ? \'bold\' : \'normal\'\r\n                                                }\">\nExternal Investments</h5></div><div ng-if=\"vm.showInternalExternal === \'internal\'\"><div \nng-repeat=\"holding in vm.allHoldings\" layout=\"column\" flex \nstyle=\"border: 1px solid #E0E0E0; margin-bottom: 15px; padding: 15px; background: #fff\"><div layout=\"row\" \nstyle=\"margin-bottom: 15px\"><div layout=\"column\" flex=\"65\" style=\"padding-right: 10px\"><div layout=\"column\" \nstyle=\"margin-bottom: 15px\"><h5 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #fa0000\">\n{{holding.nseSchemeDetails.productAmcName}}</h5><h6 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #333\">\n{{holding.scheme}}</h6><p style=\"margin: 8px 0 0 0; color: #666; font-size: 14px\"><strong>Folio:</strong>\n {{holding.folio_no}}</p></div><div layout=\"row\" layout-align=\"start center\" style=\"margin-bottom: 10px\">\n<md-radio-group ng-model=\"holding.redemptionType\" layout=\"row\" style=\"margin-right: 30px\"><md-radio-button \nvalue=\"AMOUNT\" class=\"md-primary\" style=\"margin-right: 20px\">Amount (₹)</md-radio-button><md-radio-button value=\"UNIT\" \nclass=\"md-primary\" style=\"margin-right: 20px\">Units</md-radio-button><md-radio-button value=\"All_UNIT\" \nclass=\"md-primary\">All Units</md-radio-button></md-radio-group><md-input-container \nng-if=\"holding.redemptionType === \'AMOUNT\' || holding.redemptionType === \'UNIT\'\" flex=\"30\" style=\"margin: 0\"><label \nng-if=\"holding.redemptionType === \'AMOUNT\'\">Enter Amount (₹) to Redeem</label><label \nng-if=\"holding.redemptionType === \'UNIT\'\">Enter Units to Redeem</label><input type=\"number\" \nng-model=\"holding.amount_unit\" required ng-pattern=\"/^\\d+(\\.\\d{1,3})?$/\" min=\"0.001\" step=\"0.001\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"margin-top: 10px\"><md-button class=\"md-raised\" \nng-click=\"vm.addTransaction(holding)\" \nng-disabled=\"!holding.redemptionType || \r\n                                                                                 ((holding.redemptionType === \'AMOUNT\' || holding.redemptionType === \'UNIT\') && \r\n                                                                                  (!holding.amount_unit || holding.amount_unit <= 0))\" \nstyle=\"background-color: #e0e0e0; color: #333; margin-right: 10px; min-width: 140px\">ADD TRANSACTION</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.clearForm(holding)\" \nstyle=\"background-color: #2196F3; color: #fff; min-width: 80px\"><md-icon md-font-icon=\"icon-refresh\" \nstyle=\"color:#fff; margin-right: 5px\"></md-icon>RESET</md-button></div></div><div layout=\"column\" flex=\"35\" \nstyle=\"padding-left: 20px\"><div layout=\"column\" style=\"margin-bottom: 20px\"><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 8px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Current Value</div><div \nstyle=\"color: #28a745; font-size: 18px; font-weight: bold\">₹{{holding.currentValue | number:2}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 8px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Units</div><div \nstyle=\"color: #007bff; font-size: 18px; font-weight: bold\">{{holding.units | number:3}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">NAV</div><div \nstyle=\"color: #333; font-size: 18px; font-weight: bold\">₹{{holding.nav_value | number:2}}</div></div></div></div></div>\n</div><div ng-if=\"vm.allHoldings && vm.allHoldings.length === 0\" layout=\"row\" layout-align=\"center center\" \nstyle=\"padding: 40px; background: #f5f5f5; margin: 10px 0; border-radius: 4px\"><div layout=\"column\" \nlayout-align=\"center center\"><h4 style=\"color: #666; margin: 0\">No Internal Holdings Found</h4><p \nstyle=\"color: #999; margin: 10px 0 0 0\">No internal mutual fund holdings available for redemption.</p></div></div>\n</div><div ng-if=\"vm.showInternalExternal === \'external\'\"><div ng-repeat=\"holding in vm.regularSchemes\" \nlayout=\"column\" flex style=\"border: 1px solid #E0E0E0; margin-bottom: 15px; padding: 15px; background: #fff\"><div \nlayout=\"row\" style=\"margin-bottom: 15px\"><div layout=\"column\" flex=\"65\" style=\"padding-right: 10px\"><div \nlayout=\"column\" style=\"margin-bottom: 10px\"><h5 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #fa0000\">\n{{holding.amcName}}</h5><h6 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #333\">{{holding.schemeName}}\n</h6><p style=\"margin: 8px 0 0 0; color: #666; font-size: 14px\"><strong>Folio:</strong> {{holding.folio}}</p></div><div\n layout=\"row\" layout-align=\"start center\" style=\"margin-bottom: 10px\"><md-radio-group \nng-model=\"holding.redemptionType\" layout=\"row\" style=\"margin-right: 30px\"><md-radio-button value=\"AMOUNT\" \nclass=\"md-primary\" style=\"margin-right: 20px\">Amount (₹)</md-radio-button><md-radio-button value=\"UNIT\" \nclass=\"md-primary\" style=\"margin-right: 20px\">Units</md-radio-button><md-radio-button value=\"All_UNIT\" \nclass=\"md-primary\">All Units</md-radio-button></md-radio-group><md-input-container \nng-if=\"holding.redemptionType === \'AMOUNT\' || holding.redemptionType === \'UNIT\'\" flex=\"30\" style=\"margin: 0\"><label \nng-if=\"holding.redemptionType === \'AMOUNT\'\">Enter Amount (₹) to Redeem</label><label \nng-if=\"holding.redemptionType === \'UNIT\'\">Enter Units to Redeem</label><input type=\"number\" \nng-model=\"holding.amount_unit\" required ng-pattern=\"/^\\d+(\\.\\d{1,3})?$/\" min=\"0.001\" step=\"0.001\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"margin-top: 10px\"><md-button class=\"md-raised\" \nng-click=\"vm.addExternalTransaction(holding)\" \nng-disabled=\"!holding.redemptionType || \r\n                                                                                 ((holding.redemptionType === \'AMOUNT\' || holding.redemptionType === \'UNIT\') && \r\n                                                                                  (!holding.amount_unit || holding.amount_unit <= 0))\" \nstyle=\"background-color: #e0e0e0; color: #333; margin-right: 10px; min-width: 140px\">ADD TRANSACTION</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.clearExternalForm(holding)\" \nstyle=\"background-color: #2196F3; color: #fff; min-width: 80px\"><md-icon md-font-icon=\"icon-refresh\" \nstyle=\"color:#fff; margin-right: 5px\"></md-icon>RESET</md-button></div></div><div layout=\"column\" flex=\"35\" \nstyle=\"padding-left: 10px\"><div layout=\"column\" style=\"margin-bottom: 20px\"><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 8px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Current Value</div><div \nstyle=\"color: #28a745; font-size: 18px; font-weight: bold\">₹{{holding.availableAmount | number:2}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 8px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Units</div><div \nstyle=\"color: #007bff; font-size: 18px; font-weight: bold\">{{holding.availableUnits | number:3}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">NAV Date</div><div \nstyle=\"color: #333; font-size: 14px; font-weight: bold\">{{holding.navDate | date:\'dd-MM-yyyy\'}}</div></div></div></div>\n</div></div><div ng-if=\"vm.regularSchemes && vm.regularSchemes.length === 0\" layout=\"row\" layout-align=\"center center\" \nstyle=\"padding: 40px; background: #f5f5f5; margin: 20px 0; border-radius: 4px\"><div layout=\"column\" \nlayout-align=\"center center\"><h4 style=\"color: #666; margin: 0\">No External Holdings Found</h4><p \nstyle=\"color: #999; margin: 10px 0 0 0\">No external mutual fund holdings available for redemption.</p></div></div>\n</div></div></div></md-card></div></form></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/SwitchTransaction.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll ng-if=\"vm.transactions.length > 0\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Switch Scheme List</h4><table \nclass=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><thead><tr><th>Source Scheme</th><th>\nTarget Scheme</th><th>Folio</th><th>Amount/Unit</th><th>Switch Type</th><th>Delete</th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.transactions track by $index\"><td>{{transaction.sourceSchemeName}}</td><td>\n{{transaction.targetSchemeName}}</td><td>{{transaction.folio_no}}</td><td ng-if=\"transaction.all_units === \'\'\">\n{{transaction.amount || transaction.units}}</td><td ng-if=\"transaction.all_units === \'Y\'\">All UNITS</td><td>\n{{transaction.amt_unit_type}}</td><td><md-button class=\"md-raised md-warn\" ng-click=\"vm.deleteTransaction($index)\">\nDelete</md-button></td></tr></tbody></table></div></div><md-input-container flex=\"100\" style=\"margin: 20px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.switchTransaction()\" style=\"color:#fff !important; width: 100%\">\nExecute Switch Transaction</md-button></md-input-container></div><div class=\"article\"><md-content><form novalidate \nname=\"switchTransactionForm\"><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div class=\"row\"><div \nclass=\"col-sm-12\"><h4 class=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">\nInvestment Details (Switch)</h4><div ng-repeat=\"holding in vm.allHoldings\" layout=\"column\" flex \nstyle=\"border: 1px solid #E0E0E0; margin-bottom: 10px; padding: 10px; background: #fff\"><div layout=\"row\" \nstyle=\"margin-bottom: 10px\"><div layout=\"column\" flex=\"65\" style=\"padding-right: 20px\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-bottom: 10px\"><md-checkbox ng-model=\"holding.isChecked\" \nng-change=\"vm.onCheckChange(holding)\" aria-label=\"Select Scheme\" style=\"margin-right: 15px\"></md-checkbox><div \nlayout=\"column\" flex><h5 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #fa0000\">\n{{holding.nseSchemeDetails.productAmcName}}</h5><h6 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #333\">\n{{holding.scheme}}</h6><p style=\"margin: 8px 0 0 0; color: #666; font-size: 14px\"><strong>Folio:</strong>\n {{holding.folio_no}}</p></div></div><div ng-if=\"holding.isChecked\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom: 10px\"><md-radio-group ng-model=\"holding.redemptionType\" layout=\"row\" style=\"margin-right: 30px\">\n<md-radio-button value=\"AMOUNT\" class=\"md-primary\" style=\"margin-right: 20px\">Amount (₹)</md-radio-button>\n<md-radio-button value=\"UNIT\" class=\"md-primary\" style=\"margin-right: 20px\">Units</md-radio-button><md-radio-button \nvalue=\"All_UNIT\" class=\"md-primary\">All Units</md-radio-button></md-radio-group><md-input-container \nng-if=\"holding.redemptionType === \'AMOUNT\' || holding.redemptionType === \'UNIT\'\" flex=\"30\" style=\"margin: 0\"><label \nng-if=\"holding.redemptionType === \'AMOUNT\'\">Enter Amount (₹) to Switch</label><label \nng-if=\"holding.redemptionType === \'UNIT\'\">Enter Units to Switch</label><input type=\"number\" \nng-model=\"holding.amount_unit\" required ng-pattern=\"/^\\d+(\\.\\d{1,3})?$/\" min=\"0.001\" step=\"0.001\"></md-input-container>\n</div><md-input-container ng-if=\"holding.isChecked\" style=\"margin: 10px 0\"><label>Fund Switch To *</label><md-select \nng-model=\"holding.targetScheme\" ng-change=\"vm.onTargetSchemeChange(holding.targetScheme)\" required \nstyle=\"min-width: 300px\"><md-option ng-repeat=\"scheme in holding.schemeList\" \nng-value=\"{\'productCode\': scheme.PRODUCT_CODE, \'productLongName\': scheme.PRODUCT_LONG_NAME}\">\n{{scheme.PRODUCT_LONG_NAME}}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start center\" \nng-if=\"holding.isChecked\" style=\"margin-top: 5px\"><md-button class=\"md-raised\" ng-click=\"vm.addTransaction(holding)\" \nng-disabled=\"!holding.targetScheme || \r\n                                                                             ((holding.redemptionType === \'AMOUNT\' || holding.redemptionType === \'UNIT\') && \r\n                                                                              (!holding.amount_unit || holding.amount_unit <= 0))\" \nstyle=\"background-color: #e0e0e0; color: #333; margin-right: 10px; min-width: 140px\">ADD TRANSACTION</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.clearForm(holding)\" \nstyle=\"background-color: #2196F3; color: #fff; min-width: 80px\"><md-icon md-font-icon=\"icon-refresh\" \nstyle=\"color:#fff; margin-right: 5px\"></md-icon>RESET</md-button></div></div><div layout=\"column\" flex=\"35\" \nstyle=\"padding-left: 20px\"><div layout=\"column\" style=\"margin-bottom: 10px\"><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 8px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Current Value</div><div \nstyle=\"color: #28a745; font-size: 18px; font-weight: bold\">₹{{holding.currentValue | number:2}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 8px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Units</div><div \nstyle=\"color: #007bff; font-size: 18px; font-weight: bold\">{{holding.units | number:3}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">NAV</div><div \nstyle=\"color: #333; font-size: 18px; font-weight: bold\">₹{{holding.nav_value | number:2}}</div></div></div></div></div>\n</div><div ng-if=\"vm.allHoldings && vm.allHoldings.length === 0\" layout=\"row\" layout-align=\"center center\" \nstyle=\"padding: 10px; background: #f5f5f5; margin: 20px 0; border-radius: 4px\"><div layout=\"column\" \nlayout-align=\"center center\"><h4 style=\"color: #666; margin: 0\">No Holdings Found</h4><p \nstyle=\"color: #999; margin: 10px 0 0 0\">No mutual fund holdings available for switch transactions.</p></div></div>\n</div></div></md-card></div></form></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/Transaction.html","<div id=\"syncingData\"><div><table style=\"width: 100%; margin-top: 20px\"><tr><td style=\"padding: 10px\"><md-card \nstyle=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.PurchaseTransactionSIP\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Purchase Transaction(SIP)</md-button></div></md-card></td><td \nstyle=\"padding: 10px\"><md-card style=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" \nclass=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.PurchaseTransactionLUMP\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Purchase Transaction(LUMP)</md-button></div></md-card></td><td \nstyle=\"padding: 10px\"><md-card style=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" \nclass=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.RedemptionTransaction\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Redemption Transaction</md-button></div></md-card></td><td \nstyle=\"padding: 10px\"><md-card style=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" \nclass=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.SwitchTransaction\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Switch Transaction</md-button></div></md-card></td></tr><tr><td style=\"padding: 10px\">\n<md-card style=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.stp\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>STP</md-button></div></md-card></td><td style=\"padding: 10px\"><md-card \nstyle=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.swp\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>SWP</md-button></div></md-card></td><td style=\"padding: 10px\"><md-card \nstyle=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.AddBankDetail\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Add Bank Detail</md-button></div></md-card></td><td style=\"padding: 10px\"><md-card \nstyle=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.resendLink\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Resend Link</md-button></div></md-card></td></tr><tr><td style=\"padding: 10px\"><md-card \nstyle=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.pauseSip\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Pause SIP</md-button></div></md-card></td><td style=\"padding: 10px\"><md-card \nstyle=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.ceaseSip\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Cease Sip</md-button></div></md-card></td><td style=\"padding: 10px\"><md-card \nstyle=\"padding: 20px; border-radius: 8px; border: 1px dashed #009688\" class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.editCustomers\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Edit Customer</md-button></div></md-card></td></tr></table></div></div>");
$templateCache.put("app/main/customers/amcforekyc.html","<div class=\"scrollable\" ms-scroll><div class=\"\" layout=\"column\" layout-align=\"center\"><div class=\"headerFixAllPages\" \nstyle=\"width: 100%; max-width: 600px\"><div class=\"article\"><md-content layout-padding><div layout=\"column\" \nlayout-align=\"center\" flex><div layout=\"row\" layout-align=\"center center\" layout-padding><div layout=\"column\" \nflex=\"100\" layout-padding><span><b>Email:</b> {{vm.customerDetail.email ? vm.customerDetail.email : \'NA\'}}</span></div>\n</div><div layout=\"row\" layout-align=\"center center\" layout-padding><div layout=\"column\" flex=\"100\" layout-padding>\n<span><b>PAN:</b> {{vm.customerDetail.pan ? vm.customerDetail.pan : \'NA\'}}</span></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-padding><div layout=\"column\" flex=\"100\" layout-padding><span><b>Contact No.:</b>\n {{vm.customerDetail.mobileNo ? vm.customerDetail.mobileNo : \'NA\'}}</span></div></div><div layout=\"column\" flex=\"100\" \nlayout-padding><md-input-container flex=\"100\"><label>Select AMC</label><md-select ng-model=\"vm.selectedAmc\" \nplaceholder=\"Select AMC\" required name=\"selectedAmc\"><md-option ng-repeat=\"amc in vm.amcList\" value=\"{{amc.amc_code}}\">\n{{amc.amc_name}}</md-option></md-select><div ng-messages=\"wizardStep1.selectedAmc.$error\" role=\"alert\"><div \nng-message=\"required\">AMC is required</div></div></md-input-container></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" layout-padding><md-button class=\"md-raised md-accent\" \nng-click=\"vm.amcforekyc()\" style=\"color:#fff !important\">Send E-KYC Link</md-button></div></div></md-content></div>\n</div></div></div>");
$templateCache.put("app/main/customers/ceaseSip.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll ng-if=\"vm.transactions.length > 0\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Cease SIP list</h4><table \nclass=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><tr><th>Scheme Name</th><th>Folio</th><th>\nsip_reg_no</th><th>Remarks</th><th>Delete</th></tr><tr ng-repeat=\"transaction in vm.transactions track by $index\"><td \nng-if=\"transaction.scheme_name !== \'\'\">{{transaction.scheme_name}}</td><td ng-if=\"transaction.folio_number !== \'\'\">\n{{transaction.folio_number}}</td><td ng-if=\"transaction.sip_reg_no !== \'\'\">{{transaction.sip_reg_no}}</td><td \nng-if=\"transaction.remarks !== \'\'\">{{transaction.remarks}}</td><td><md-button class=\"md-raised md-warn\" \nng-click=\"vm.deleteTransaction($index)\">Delete</md-button></td></tr></table></div></div><md-input-container flex=\"100\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.ceaseSip()\" style=\"color:#fff !important\">Cease Sip</md-button>\n</md-input-container></div><div class=\"article\"><md-content><form novalidate name=\"wizardStep1\"><div \nclass=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><h4 \nclass=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Running SIP</h4><div class=\"article\" \nng-if=\"vm.SipDetail.length > 0\"><md-content class=\"margin-bottom-10\" ng-repeat=\"sip in vm.SipDetail\"><div \nclass=\"padding-5\" layout=\"row\"><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" layout-padding flex=\"50\"><span class=\"title\">\nScheme Name : &nbsp;&nbsp; {{sip.scheme_name}}</span> <span>Sip Start Date : &nbsp;&nbsp; {{sip.start_date}}</span> \n<span>Number of Installment:&nbsp;&nbsp;{{sip.no_of_installments}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" layout-padding flex=\"24\"><span>Folio Number : &nbsp;&nbsp; {{sip.folio_number}}\n</span> <span>Sip End Date : &nbsp;&nbsp; {{sip.end_date}}</span> <span>Frequency : &nbsp;&nbsp;{{sip.frequency_type}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" layout-padding flex=\"24\"><span>\nAmount : &nbsp;&nbsp; {{sip.installments_amount}}</span> <span>\nRegistration Date : &nbsp;&nbsp; {{sip.xsip_registration_date}}</span> <span>\nRegistration No:&nbsp;&nbsp;{{sip.xsip_registration_no}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"padding-5\" style=\"gap:16px\"><div flex=\"25\" layout=\"column\" layout-align=\"center\">\n<md-input-container><label>Remarks</label><md-select ng-model=\"sip.remarksVal\" placeholder=\"Select Reason\" required>\n<md-option ng-repeat=\"reason in vm.ceaseMasterData\" ng-value=\"reason.code\">{{reason.description}}</md-option>\n</md-select></md-input-container></div><div flex=\"10\" layout=\"column\" layout-align=\"center\"><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"!sip.remarksVal\" ng-click=\"vm.addTransaction(sip)\">Add</md-button></div>\n</div></md-content></div><div class=\"article\" ng-if=\"vm.SipDetail.length == 0\"><md-content class=\"md-whiteframe-4dp\">\n<div class=\"padding-5\" layout=\"center center\"><h4 class=\"margin-left-30\">No Data</h4></div></md-content></div></div>\n</div></md-card></div></form></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/customer-index.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin:0px\"><span>Customer Detail</span></div><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor\" \nstyle=\"line-height:10px\"></md-icon><span style=\"line-height:-2%; margin-top:-14%\">Back</span></md-button></div><md-tabs\n md-selected=\"vm.selectedTab\"><md-tab ui-sref=\"app.customers.customerhome.userDetail\">User Detail</md-tab><md-tab \nui-sref=\"app.customers.customerhome.flags\">Flags</md-tab><md-tab ui-sref=\"app.customers.customerhome.activity\">Activity\n</md-tab><md-tab ui-sref=\"app.customers.customerhome.callingHistory\">Calling History</md-tab><md-tab \nui-sref=\"app.customers.customerhome.customerDetail\">Holding Detail</md-tab><md-tab \nui-sref=\"app.customers.customerhome.uploadDownloadForm\">Document</md-tab><md-tab \nui-sref=\"app.customers.customerhome.insuranceList\">Insurance</md-tab><md-tab \nui-sref=\"app.customers.customerhome.Transaction\">Transaction</md-tab><md-tab \nui-sref=\"app.customers.customerhome.loanList\">Loans</md-tab><md-tab ui-sref=\"app.customers.customerhome.nps\">NPS\n</md-tab><md-tab ui-sref=\"app.customers.customerhome.sipDetail\">SIP Details</md-tab><md-tab \nui-sref=\"app.customers.customerhome.transactionHistory\">Transaction History</md-tab><md-tab \nui-sref=\"app.customers.customerhome.sipfundTransactions\">SIP Transaction</md-tab><md-tab \nui-sref=\"app.customers.customerhome.ACHMandateDetails\">ACH Mandate Details</md-tab></md-tabs><div ui-view></div></div>");
$templateCache.put("app/main/customers/customerEdit.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"white-bg\" layout=\"column\"><div \nclass=\"headerFixAllPages\"><div class=\"article\"><md-content><div layout=\"row\"><div class=\"form-wrapper\" flex><form \nname=\"myForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\">Edit Customer</div><br><div layout=\"row\" \nlayout-gt-xs=\"row\" flex layout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" \nname=\"contactnumber\" ng-model=\"vm.contact_no\" numeric-regex ng-pattern=\"/^[1-9]{1}[0-9]{9}$/\" oncopy=\"return false\" \nondrag=\"return false\" ondrop=\"return false\" onpaste=\"return false\" autocomplete=\"off\" placeholder=\"Contact Number\" \nrequired><div ng-messages=\"myForm.contactnumber.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Contact Number is required</span></div><div ng-message=\"pattern\"><span>Contact Number must be of valid Digits\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input limit-to=\"50\" \ntype=\"email\" name=\"customeremail\" ng-model=\"vm.email\" placeholder=\"Customer Email\" \nng-pattern=\"/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/\" oncopy=\"return false\" ondrag=\"return false\" \nondrop=\"return false\" onpaste=\"return false\" autocomplete=\"off\"><div ng-messages=\"myForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"bankaccount\" \nng-model=\"vm.acc_no\" limit-to=\"30\" placeholder=\"Bank Account\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input pan-regex type=\"text\" name=\"pannumber\" ng-model=\"vm.pan_no\" \nng-pattern=\"/[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/\" capitalize ng-model-options=\"{allowInvalid: true }\" \nplaceholder=\"PAN Number Ex. ABCDE1234F\"><div ng-messages=\"myForm.pannumber.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"pattern\"><span>PAN Number must be a valid Number</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"ifsccode\" ng-model=\"vm.ifsc_no\" \nng-change=\"checkIFSC()\" placeholder=\"IFSC code Ex. ABCD1234567\"><div ng-messages=\"myForm.ifsccode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>IFSC code must be a valid code</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \nng-disabled=\"vm.customer.nseData.ACTIVATION_STATUS == \'YES\'\" type=\"text\" name=\"iinnumber\" ng-model=\"vm.iin_no\" \nplaceholder=\"IIN Number Ex. 1234567890\" ng-model-options=\"{allowInvalid: true }\"><div \nng-messages=\"myForm.iinnumber.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nIIN number must be a valid number</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><md-button ng-disabled=\"vm.disableSubmit()\" class=\"md-raised md-accent\" ng-click=\"vm.editCustomer()\" \nstyle=\"color:#fff !important\">Submit</md-button></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.syncInvestorIIN()\" style=\"color:#fff !important\">Sync IIN\n</md-button></md-input-container></div></form></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/customers.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"demoCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nList Of Customers</span></div><div class=\"product-count secondary-text margin-top-10\"><span>{{vm.currentNavItem}}:\n</span> <span>{{vm.totalCustomer}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex-60><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" \ntype=\"text\" ng-model=\"vm.search\" placeholder=\"Search\" ng-keyup=\"$event.keyCode == 13 ? vm.serchUser() : null\" flex>\n</div></div><md-tabs md-selected=\"vm.currentNavItem\" md-align-tabs=\"bottom\" aria-label=\"navigation links\"><md-tab \nmd-on-select=\"vm.customerCount(\'INVESTED_CUSTOMER\')\" label=\"Invested Customer\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'ALL_CUSTOMER\')\" label=\"All Customer\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'CAGR_L6\')\" label=\"CAGR_L6\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'ACTIVATED_IIN\')\" label=\"Activated IIN\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'NOT_ACTIVE\')\" label=\"Not Active\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'NO_IIN\')\" label=\"No IIN\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'ACTIVE_IIN_ZERO_INVESTMENT\')\" label=\"IIN Active but Zero Investment\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'SIP_PURCHASED\')\" label=\"SIP Purchased\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'ACTIVE_FLAG\')\" label=\"Active Flags\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'UNASSIGNED_CUSTOMER\')\" label=\"Unassigned Customers\"></md-tab><md-tab \nmd-on-select=\"vm.customerCount(\'NOT_INTERESTED\')\" label=\"Not Interested\"></md-tab></md-tabs><div \nng-if=\"vm.editEnable == true\" layout=\"row\" layout-align=\"end end\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.downloadUserDetails()\" style=\"float:right; color:#fff !important\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Download</md-button></div><div \nng-if=\"vm.currentNavItem != \'CAGR_L6\'\"><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\">\n<md-table-container class=\"tablePbmSolved\"><table md-table ng-model=\"vm.selected\"><thead md-head><tr md-row><th \nmd-column><span>SNo.</span></th><th md-column><span>Lead Id</span></th><th md-column><span>Name</span></th><th \nmd-column><span>Contact</span></th><th md-column><span>PAN No.</span></th><th md-column><span>IIN</span></th><th \nmd-column><span>IIN Status</span></th><th md-column><span>CAGR(in %)</span></th><th md-column><span>UMRN Status</span>\n</th><th md-column><span>Ach Mandate Status</span></th><th md-column><span>Ach Amount</span></th><th md-column><span>\nRunning SIP</span></th><th md-column><span>KYC Status</span></th><th md-column><span>Last Active Date</span></th><th \nmd-column><span>Last Calling Date</span></th></tr></thead><tbody md-body><tr md-row md-select=\"customer\" \nmd-virtual-repeat=\"customer in vm.dynamicItems \" ng-click=\"vm.customerDetailFunction(customer)\" md-on-demand=\"\" \nstyle=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell ng-bind=\"customer.custID\"></td><td md-cell><span \nng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell ng-bind=\"customer.mobileNo\"></td><td md-cell ng-bind=\"customer.pan\"></td><td md-cell \nng-bind=\"customer.iin\"></td><td md-cell><span ng-if=\"customer.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green\">\nYES</span> <span \nng-if=\"customer.nseData.ACTIVATION_STATUS == \'\' || !customer.nseData || !customer.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange;font-weight:bold;font-size:20px\">-</span> <span ng-if=\"customer.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red\">NO</span></td><td md-cell>{{customer.cagr}}</td><td md-cell><span \nng-if=\"customer.achmandateRegFlag == true\" style=\"color:green\">YES</span> <span \nng-if=\"customer.achmandateRegFlag == false\" style=\"color:red\">NO</span></td><td md-cell>{{customer.achMandateStatus}}\n</td><td md-cell>{{customer.amount}}</td><td md-cell>{{customer.sipAmount}}</td><td md-cell><span \nstyle=\"color:green; font-size:80%\" \nng-if=\"customer.camsKycStatus == \'01\' || customer.camsKycStatus == \'02\' || customer.camsKycStatus == \'07\' \">\n{{vm.eKyc[customer.camsKycStatus] }} </span><span style=\"color:red; font-size:80%\" \nng-if=\"customer.camsKycStatus != \'01\' && customer.camsKycStatus != \'02\' && customer.camsKycStatus != \'07\'\">\n{{ customer.camsKycStatus != undefined ? vm.eKyc[customer.camsKycStatus] : \'NA\'}}</span></td><td md-cell>\n{{customer.lastLoginDate | date:\'mediumDate\'}}</td><td md-cell>\n{{customer.monitoringFlags.reviewPendingFlagDate | date:\'mediumDate\'}}</td></tr></tbody></table></md-table-container>\n</md-virtual-repeat-container></div></div><div ng-if=\"vm.currentNavItem == \'CAGR_L6\'\"><div class=\"ext-content\">\n<md-virtual-repeat-container ng-style=\"listStyle\"><md-table-container class=\"tablePbmSolved\"><table md-table \nng-model=\"vm.selected\"><thead md-head><tr md-row><th md-column><span>SNo.</span></th><th md-column \nmd-order-by=\"userName\"><span>Lead Id</span></th><th md-column md-order-by=\"userName\"><span>Name</span></th><th \nmd-column md-order-by=\"mobileNo\"><span>Contact</span></th><th md-column md-order-by=\"pan\"><span>PAN No.</span></th><th \nmd-column md-order-by=\"iin\"><span>IIN</span></th><th md-column md-order-by=\"nseData.ACTIVATION_STATUS\"><span>IIN Status\n</span></th><th md-column><span>CAGR(in %)</span></th><th md-column><span>UMRN Status</span></th><th md-column><span>\nRunning SIP</span></th><th md-column md-order-by=\"camsKycStatus\"><span>KYC Status</span></th><th md-column \nmd-order-by=\"lastLoginDate\"><span>Last Active Date</span></th><th md-column \nmd-order-by=\"monitoringFlags.reviewPendingFlagDate\"><span>Last Calling Date</span></th></tr></thead><tbody md-body><tr \nmd-row md-select=\"customer\" md-virtual-repeat=\"customer in vm.dynamicItems \" \nng-click=\"vm.customerDetailFunctioncagr(customer)\" md-on-demand=\"\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td>\n<td md-cell ng-bind=\"customer.user.custID\"></td><td md-cell><span \nng-if=\"customer.user.nseData && customer.user.nseData.INVESTOR_NAME\">{{(customer.user.nseData.INVESTOR_NAME)}}</span> \n<span ng-if=\"!(customer.user.nseData && customer.user.nseData.INVESTOR_NAME)\">\n{{(customer.user.userName) ? (customer.user.userName) :\'NA\'}}</span></td><td md-cell ng-bind=\"customer.user.mobileNo\">\n</td><td md-cell ng-bind=\"customer.user.pan\"></td><td md-cell ng-bind=\"customer.user.iin\"></td><td md-cell><span \nng-if=\"customer.user.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green\">YES</span> <span \nng-if=\"customer.user.nseData.ACTIVATION_STATUS == \'\' || !customer.user.nseData || !customer.user.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange;font-weight:bold;font-size:20px\">-</span> <span \nng-if=\"customer.user.nseData.ACTIVATION_STATUS == \'NO\'\" style=\"color:red\">NO</span></td><td md-cell>\n{{customer.customers.currentCAGR}}</td><td md-cell><span ng-if=\"customer.achmandateRegFlag == true\" \nstyle=\"color:green\">YES</span> <span ng-if=\"customer.achmandateRegFlag == false\" style=\"color:red\">NO</span></td><td \nmd-cell>{{customer.sipAmount}}</td><td md-cell><span style=\"color:green; font-size:80%\" \nng-if=\"customer.user.camsKycStatus == \'01\' || customer.user.camsKycStatus == \'02\' || customer.user.camsKycStatus == \'07\'\">\n{{vm.eKyc[customer.user.camsKycStatus] }} </span><span style=\"color:red; font-size:80%\" \nng-if=\"customer.user.camsKycStatus != \'01\' && customer.user.camsKycStatus != \'02\' && customer.user.camsKycStatus != \'07\'\">\n{{ customer.user.camsKycStatus != undefined ? vm.eKyc[customer.user.camsKycStatus] : \'NA\'}}</span></td><td md-cell>\n{{customer.user.lastLoginDate | date:\'mediumDate\'}}</td><td md-cell>\n{{customer.user.monitoringFlags.reviewPendingFlagDate | date:\'mediumDate\'}}</td></tr></tbody></table>\n</md-table-container></md-virtual-repeat-container></div></div></div>");
$templateCache.put("app/main/customers/eachCustomerDetail.html","<style>\n.ten_columns {\r\n        display: flex;\r\n        justify-content: space-evenly;\r\n        flex-flow: row wrap;\r\n        text-transform: capitalize;\r\n    }\r\n\r\n    .child {\r\n        flex: 1 0 9%;\r\n        height: auto;\r\n        padding: 3rem 0;\r\n    }\r\n\r\n    .ten_columns.heading {\r\n        border-bottom: 1px solid black;\r\n        padding: 1rem 2rem 3rem 2rem;\r\n        color: gray;\r\n        background: white;\r\n        font-weight: bolder;\r\n    }\r\n\r\n    .ten_columns.heading .child {\r\n        height: 6rem;\r\n        flex: 1 0 9%;\r\n    }\r\n\r\n    .goal_type {\r\n        display: flex;\r\n        justify-content: start;\r\n        margin: 1rem;\r\n    }\r\n\r\n    .grouping {\r\n        text-transform: uppercase;\r\n        margin: 1rem;\r\n        font-weight: bolder;\r\n    }\r\n\r\n    .ten_columns.data {\r\n        margin: 1rem;\r\n    }\r\n\r\n    .eachGroup {\r\n        border: none;\r\n        margin: 1rem;\r\n        background: white;\r\n        border-radius: 20px;\r\n        box-shadow: rgb(50 50 93 / 25%) 0px 13px 27px -5px, rgb(0 0 0 / 30%) 0px 8px 16px -8px;\r\n    }\r\n\r\n    .eachGroup:hover{\r\n        background: #686767;\r\n        color: white;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .eight_columns {\r\n        display: flex;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .childT {\r\n        flex: 1 0 10%;\r\n        margin: 0 0 0 1rem;\r\n    }\r\n\r\n    .eight_columns.head {\r\n        color: black;\r\n        border-bottom: 1px solid gray;\r\n        padding:1rem 0;\r\n        font-size: 15px;\r\n    }\r\n\r\n    .eight_columns.data {\r\n        margin: 1rem 0;\r\n        color: rgb(70, 65, 65);\r\n    }\r\n\r\n    .transactions{\r\n    background-color: aquamarine;\r\n    }\n</style><div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail &nbsp;&nbsp; <a class=\"schemeLink\" \nng-click=\"vm.toggleCurVal = !vm.toggleCurVal\">\n{{vm.toggleCurVal ? \'Show Fully Redeem Scheme\' : \'Hide Fully Redeem Scheme\'}}</a></h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" class=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"30\" layout-padding><span class=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}} \n</span><span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\" ng-show=\"!vm.customerDetail.pan\"><md-content><div \nclass=\"padding-5\" layout=\"center center\"><h3>NO Data for Holdings</h3></div></md-content></div><div \nng-show=\"vm.customerDetail.pan\" class=\"simple-table-container padding-top-10\"><md-content><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"table-title\"><span>Holdings</span> <span>\nTotal Investment : {{vm.totalInvestment | number:2}}</span> <span>\nTotal Current Value : {{vm.totalCurrentValue | number:2}}</span> <span>Download Report :<md-input-container><label>\nSelect Download Option</label><md-select ng-model=\"vm.selectedOption\" ng-change=\"vm.selectValueForDialog()\" \nplaceholder=\"Select an option\"><md-option value=\"pdf\">Download PDF</md-option><md-option value=\"excel\">Download Excel\n</md-option><md-option value=\"capital-gain\">Download Capital Gain Report</md-option></md-select></md-input-container>\n</span></div><div class=\"ten_columns heading\"><div class=\"child\">AMC Name</div><div class=\"child\">Scheme Name</div><div\n class=\"child\">Total Units</div><div class=\"child\">Invested Amount</div><div class=\"child\">Current Value</div><div \nclass=\"child\">NAV Date</div><div class=\"child\">Profit/Loss</div><div class=\"child\">Absolute Return (in %)</div><div \nclass=\"child\">Booked Profit/Loss</div><div class=\"child\">CAGR (in %)</div></div><div ng-if=\"vm.toggleCurVal\"><div \nng-repeat=\"(key,value) in sortedItems\" class=\"eachArray\" ng-init=\"rowIndex = $index\"><div class=\"goal_type\" \nng-if=\"sortedItems[key][0].groupType && sortedItems[key][0].groupName\"><div class=\"grouping\">\n{{sortedItems[key][0].groupType}}</div><div class=\"grouping\">{{sortedItems[key][0].groupName}}</div></div><div \nclass=\"goal_type\" ng-if=\"!(sortedItems[key][0].groupType && sortedItems[key][0].groupName)\"><div class=\"grouping\">\nOwn Choice</div></div><div ng-switch=\"vm.dayDataCollapse[rowIndex][vm.checkPos]\"><div \nng-repeat=\"i in value | orderBy: \'amcName\'\" class=\"eachGroup\" ng-init=\"columnIndex = $index\" \nng-click=\"vm.selectTableRow(key,rowIndex,columnIndex,i.productKey)\"><div ng-if=\"i.currentValue !==0 \"><div \nclass=\"ten_columns data\"><div class=\"child\" style=\"padding-right:2px\">{{i.amcName}}</div><div class=\"child\">\n{{i.scheme}}</div><div class=\"child\">{{i.units | number:2}}</div><div class=\"child\">{{i.investedAmt}}</div><div \nclass=\"child\">{{i.currentValue}}</div><div class=\"child\"><div ng-if=\"i.nav_date != 0\">\n{{i.nav_date | date:\'dd-MMM-yyyy\'}}</div><div ng-if=\"i.nav_date == 0\">{{i.nav_date}}</div></div><div class=\"child\">\n{{i.profitLoss}}<md-icon md-font-icon=\"icon-arrow-up-bold\" ng-if=\"i.profitLoss > 0\" class=\"icon s25 green-500-fg\">\n</md-icon><md-icon md-font-icon=\"icon-arrow-down-bold\" ng-if=\"i.profitLoss < 0\" class=\"icon s25 red-500-fg\"></md-icon>\n</div><div class=\"child\">{{i.percentageProfitLoss}}</div><div class=\"child\">{{i.netProfit}}</div><div class=\"child\">\n{{i.cagr}}</div></div><div ng-switch-when=\"true\" ng-show=\"vm.dayDataCollapse[rowIndex][columnIndex]\" \nclass=\"transactions\"><div class=\"eight_columns head\"><div class=\"childT\">Folio No</div><div class=\"childT\">\nTransaction No</div><div class=\"childT\">Transaction Date</div><div class=\"childT\">Price/Unit</div><div class=\"childT\">\nUnits</div><div class=\"childT\">Amount Invested</div><div class=\"childT\">Transaction Nature</div><div class=\"childT\">\nCAGR (in %)</div></div><div class=\"eight_columns data\" ng-repeat=\"dayData in vm.txnData| orderBy:\'-traddate\'\"><div \nclass=\"childT\">{{dayData.folio_no}}</div><div class=\"childT\">{{dayData.trxnno}}</div><div class=\"childT\">\n{{dayData.traddate | date: \"dd-MMM-yyyy\"}}</div><div class=\"childT\">{{dayData.purprice}}</div><div class=\"childT\">\n{{dayData.units}}</div><div class=\"childT\">{{dayData.amount}}</div><div class=\"childT\">{{dayData.trxn_nature}}</div>\n<div class=\"childT\">{{dayData.cagr}}</div></div></div></div></div></div></div></div><div ng-if=\"!vm.toggleCurVal\"><div \nng-repeat=\"(key,value) in sortedItems\" class=\"eachArray\" ng-init=\"rowIndex = $index\"><div class=\"goal_type\" \nng-if=\"sortedItems[key][0].groupType && sortedItems[key][0].groupName\"><div class=\"grouping\">\n{{sortedItems[key][0].groupType}}</div><div class=\"grouping\">{{sortedItems[key][0].groupName}}</div></div><div \nclass=\"goal_type\" ng-if=\"!(sortedItems[key][0].groupType && sortedItems[key][0].groupName)\"><div class=\"grouping\">\nOwn Choice</div></div><div ng-switch=\"vm.dayDataCollapse[rowIndex][vm.checkPos]\"><div ng-repeat=\"i in value\" \nclass=\"eachGroup\" ng-init=\"columnIndex = $index\" ng-click=\"vm.selectTableRow(key,rowIndex,columnIndex,i.productKey)\">\n<div class=\"ten_columns data\"><div class=\"child\" style=\"padding-right:2px\">{{i.amcName}}</div><div class=\"child\">\n{{i.scheme}}</div><div class=\"child\">{{i.units | number:2}}</div><div class=\"child\">{{i.investedAmt}}</div><div \nclass=\"child\">{{i.currentValue}}</div><div class=\"child\"><div ng-if=\"i.nav_date != 0\">\n{{i.nav_date | date:\'dd-MMM-yyyy\'}}</div><div ng-if=\"i.nav_date == 0\">{{i.nav_date}}</div></div><div class=\"child\">\n{{i.profitLoss}}<md-icon md-font-icon=\"icon-arrow-up-bold\" ng-if=\"i.profitLoss > 0\" class=\"icon s25 green-500-fg\">\n</md-icon><md-icon md-font-icon=\"icon-arrow-down-bold\" ng-if=\"i.profitLoss < 0\" class=\"icon s25 red-500-fg\"></md-icon>\n</div><div class=\"child\">{{i.percentageProfitLoss}}</div><div class=\"child\">{{i.netProfit}}</div><div class=\"child\">\n{{i.cagr}}</div></div><div ng-switch-when=\"true\" ng-show=\"vm.dayDataCollapse[rowIndex][columnIndex]\" \nclass=\"transactions\"><div class=\"eight_columns head\"><div class=\"childT\">Folio No</div><div class=\"childT\">\nTransaction No</div><div class=\"childT\">Transaction Date</div><div class=\"childT\">Price/Unit</div><div class=\"childT\">\nUnits</div><div class=\"childT\">Amount Invested</div><div class=\"childT\">Transaction Nature</div><div class=\"childT\">\nCAGR (in %)</div></div><div class=\"eight_columns data\" ng-repeat=\"dayData in vm.txnData| orderBy:\'-traddate\'\"><div \nclass=\"childT\">{{dayData.folio_no}}</div><div class=\"childT\">{{dayData.trxnno}}</div><div class=\"childT\">\n{{dayData.traddate | date: \"dd-MMM-yyyy\"}}</div><div class=\"childT\">{{dayData.purprice}}</div><div class=\"childT\">\n{{dayData.units}}</div><div class=\"childT\">{{dayData.amount}}</div><div class=\"childT\">{{dayData.trxn_nature}}</div>\n<div class=\"childT\">{{dayData.cagr}}</div></div></div></div></div></div></div></md-content></div><div \nng-show=\"vm.customerDetail.pan\" class=\"simple-table-container padding-top-10\" style=\"margin-bottom: 50px\"><md-content>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"table-title\"><span>External Holdings</span> <span>\nLast Updated : {{ vm.mfCentral.data.responseString.updatedAt | date:\'dd-MM-yyyy\' }}</span> <span>\nTotal Investment : {{vm.mfCentral.data.totalCostValue | number : 2}}</span> <span>\nTotal Current Value : {{vm.mfCentral.data.totalCurrentMktValue | number : 2}}</span> <span>Download Report :\n<md-input-container><label>Select Download Option</label><md-select ng-model=\"vm.selectedOption\" \nng-change=\"vm.selectValueForDialog()\" placeholder=\"Select an option\"><md-option value=\"externalExcel\">Download Excel\n</md-option></md-select></md-input-container></span></div><table class=\"simple margin-top-10\" ms-responsive-table>\n<thead><tr><th>AMC Name</th><th>Scheme Name</th><th>Total Units</th><th>Invested Amount</th><th>Current Value</th><th>\nNAV Date</th><th>Profit/Loss</th><th>Absolute Return (in %)</th><th>Update</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody ng-repeat=\"item in vm.externalHoldingsList\" ng-switch=\"vm.externalDataCollapse[$index]\"><tr \nng-click=\"vm.selectexternalHoldingTableRow($index,item.productKey)\"><td class=\"name\">{{item.amcName || \'NA\'}}</td><td \nclass=\"position\">{{item.schemeName || \'NA\'}}</td><td class=\"office\">{{item.availableUnits | number:2}}</td><td>\n{{item.costValue | number:2}}</td><td>{{item.currentMktValue | number:2}}</td><td>{{item.navDate}}</td><td><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" ng-if=\"item.gainLoss < 0\" class=\"icon s25 red-500-fg\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-up-bold\" ng-if=\"item.gainLoss > 0\" class=\"icon s25 green-500-fg\"></md-icon>\n{{item.gainLoss | number:2}}</td><td>{{item.gainLossPercentage | number:2}}%</td><td><md-button \nclass=\"md-raised md-accent downloadbtnData\" ng-click=\"vm.updateEHolding(item)\"><span class=\"textColorDocs\">Update\n</span></md-button></td></tr></tbody></table></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/editCustomers.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><div layout=\"row\" layout-align=\" center\" layout-wrap \nflex ng-if=\"vm.showCustomerDetails\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Customer Details</h4><br><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Title</label><md-select ng-model=\"vm.title\" name=\"title\" required><md-option \nng-repeat=\"x in vm.titleData\" ng-value=\"x\">{{x}}</md-option></md-select><div ng-messages=\"wizardStep1.title.$error\" \nrole=\"alert\"><div ng-message=\"required\">Title is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Name</label><input type=\"text\" ng-model=\"vm.name\" name=\"name\" required><div \nng-messages=\"wizardStep1.name.$error\" role=\"alert\"><div ng-message=\"required\">Name is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Enter PAN No</label><input type=\"text\" \ncapitalize maxlength=\"10\" disabled=\"disabled\" ng-model=\"vm.pan\" name=\"pan\" required ng-pattern=\"vm.panRegEx\"><div \nng-messages=\"wizardStep1.pan.$error\" role=\"alert\"><div ng-message=\"required\">PAN is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Valid PAN</label><md-select \nng-model=\"vm.validPan\" name=\"validPan\" required disabled=\"disabled\"><md-option value=\"Y\">Yes</md-option><md-option \nvalue=\"N\">No</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>DOB<h5 \nstyle=\"color: black\">{{vm.showDob}}</h5></label><input type=\"date\" ng-model=\"vm.dob\" name=\"dob\" \nng-change=\"vm.onDateSelected()\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nHolding Nature</label><input ng-model=\"vm.holdingNature\" required name=\"holdingNature\" disabled=\"disabled\"><div \nng-messages=\"wizardStep1.holdingNature.$error\" role=\"alert\"><div ng-message=\"required\">holding Nature is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Tax Status</label><input \nng-model=\"vm.taxStatus\" required disabled=\"disabled\" name=\"taxStatus\"><div ng-messages=\"wizardStep1.taxStatus.$error\" \nrole=\"alert\"><div ng-message=\"required\">Tax Status is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Occupation</label><md-select ng-model=\"vm.occupation\" required name=\"occupation\">\n<md-option ng-repeat=\"x in vm.occupationData\" ng-value=\"x.OCCUPATION_CODE\">{{x.OCCUPATION_DESC}}</md-option>\n</md-select><div ng-messages=\"wizardStep1.occupation.$error\" role=\"alert\"><div ng-message=\"required\">\nOccupation is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>KYC\n</label><md-select ng-model=\"vm.kyc\" name=\"kyc\" required disabled=\"disabled\"><md-option ng-repeat=\"x in vm.kycData\" \nng-value=\"x.CODE\">{{x.DESC}}</md-option><div ng-messages=\"wizardStep1.kyc.$error\" role=\"alert\"><div \nng-message=\"required\">KYC value is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>DP ID</label><input type=\"text\" ng-model=\"vm.dpId\" name=\"spId\" required><div \nng-messages=\"wizardStep1.dpId.$error\" role=\"alert\"><div ng-message=\"required\">DP ID is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Father Name</label><input type=\"text\" \nng-model=\"vm.fatherName\" name=\"fatherName\" required><div ng-messages=\"wizardStep1.fatherName.$error\" role=\"alert\"><div \nng-message=\"required\">Father Name is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Mother Name</label><input type=\"text\" ng-model=\"vm.motherName\" name=\"motherName\" required><div \nng-messages=\"wizardStep1.motherName.$error\" role=\"alert\"><div ng-message=\"required\">Mother Name is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"></md-input-container><md-input-container flex=\"10\" \nflex-gt-xs=\"50\"><md-button class=\"md-raised width-150\" ng-click=\"vm.openContactDetails()\">Next</md-button>\n</md-input-container></div><div layout=\"row\" layout-align=\" center\" layout-wrap flex ng-if=\"vm.showContactDetails\"><h4 \nclass=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Contact Details</h4><br>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Address1</label><input type=\"text\" ng-model=\"vm.address1\" \nname=\"address1\" required><div ng-messages=\"wizardStep1.address1.$error\" role=\"alert\"><div ng-message=\"required\">\nAddress1 is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Address2\n</label><input type=\"text\" ng-model=\"vm.address2\" name=\"address2\" required><div \nng-messages=\"wizardStep1.address2.$error\" role=\"alert\"><div ng-message=\"required\">Address2 is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Address3</label><input type=\"text\" \nng-model=\"vm.address3\" name=\"address3\" required><div ng-messages=\"wizardStep1.address3.$error\" role=\"alert\"><div \nng-message=\"required\">Address3 is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Pincode</label><input type=\"text\" ng-pattern=\"/^\\d{6}$/\" numeric-regex maxlength=\"6\" \nng-model=\"vm.pinCode\" name=\"pinCode\" ng-change=\"vm.getStateCityDetailsPinCodeNew()\" required><div \nng-messages=\"wizardStep1.pinCode.$error\" role=\"alert\"><div ng-message=\"required\">Pincode is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>City</label><input type=\"text\" \nng-model=\"vm.city\" name=\"city\" required><div ng-messages=\"wizardStep1.city.$error\" role=\"alert\"><div \nng-message=\"required\">City is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>State</label><input type=\"text\" ng-model=\"vm.state\" name=\"state\" required><div \nng-messages=\"wizardStep1.state.$error\" role=\"alert\"><div ng-message=\"required\">State is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Enter Mobile No</label><input type=\"text\" \nnumeric-regex ng-model=\"vm.mobileNo\" name=\"mobileNo\" required ng-pattern=\"vm.mobileNoRegEx\"><div \nng-messages=\"wizardStep1.mobileNo.$error\" role=\"alert\"><div ng-message=\"required\">Mobile Number is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Mobile Relation</label><md-select \nng-model=\"vm.mobileRelation\" name=\"mobileRelation\" required><md-option ng-repeat=\"x in vm.rseRelationshipData\" \nng-value=\"x.RelationKey\">{{x.RelationValue}}</md-option></md-select><div \nng-messages=\"wizardStep1.mobileRelation.$error\" role=\"alert\"><div ng-message=\"required\">Mobile Relation is required\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Email ID</label><input \ntype=\"email\" ng-model=\"vm.email\" name=\"email\" required ng-pattern=\"vm.emailRegex\"><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\"><div ng-message=\"required\">Email is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Email Relation</label><md-select \nng-model=\"vm.emailRelation\" name=\"emailRelation\" required><md-option ng-repeat=\"x in vm.rseRelationshipData\" \nng-value=\"x.RelationKey\">{{x.RelationValue}}</md-option></md-select><div \nng-messages=\"wizardStep1.emailRelation.$error\" role=\"alert\"><div ng-message=\"required\">Email Relation is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-button class=\"md-raised width-150\" \nng-click=\"vm.openCustomerDetails()\">Customer Details</md-button></md-input-container><md-input-container flex=\"10\" \nflex-gt-xs=\"50\"><md-button class=\"md-raised width-150\" ng-click=\"vm.openBankDetails()\">Next</md-button>\n</md-input-container></div><div layout=\"row\" layout-align=\" center\" layout-wrap flex flex ng-if=\"vm.showBankDetails\">\n<h4 class=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Bank Details</h4><br>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Account Type</label><md-select ng-model=\"vm.accountType\" \nname=\"accountType\" required disabled=\"disabled\"><md-option ng-repeat=\"x in vm.newAccountTypeData\" \nng-value=\"x.ACC_TYPE\">{{x.DESCRIPTION}}</md-option></md-select><div ng-messages=\"wizardStep1.accountType.$error\" \nrole=\"alert\"><div ng-message=\"required\">Account Type is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Account No.</label><input type=\"text\" ng-model=\"vm.accountNo\" name=\"accountNo\" \nrequired disabled=\"disabled\"><div ng-messages=\"wizardStep1.accountNo.$error\" role=\"alert\"><div ng-message=\"required\">\nAccount No is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>IFSC Code\n</label><input type=\"text\" name=\"ifscCode\" ng-model=\"vm.ifscCode\" ng-change=\"vm.getBankDetailsFrmIFSC()\" required \ndisabled=\"disabled\"><div ng-messages=\"wizardStep1.ifscCode.$error\" role=\"alert\"><div ng-message=\"required\">\nIFSC code is required!</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Bank Name\n</label><input type=\"text\" ng-model=\"vm.bankName\" name=\"bankName\" required disabled=\"disabled\"><div \nng-messages=\"wizardStep1.bankName.$error\" role=\"alert\"><div ng-message=\"required\">Bank Name is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Branch Name</label><input type=\"text\" \nng-model=\"vm.branchName\" name=\"branchName\" required disabled=\"disabled\"><div \nng-messages=\"wizardStep1.branchName.$error\" role=\"alert\"><div ng-message=\"required\">Branch Name is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Branch Address1</label><input type=\"text\" \nng-model=\"vm.branchAddress1\" name=\"branchAddress1\" required><div ng-messages=\"wizardStep1.branchAddress.$error\" \nrole=\"alert\"><div ng-message=\"required\">Branch Address is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Branch Address2</label><input type=\"text\" ng-model=\"vm.branchAddress2\" \nname=\"branchAddress2\"><div ng-messages=\"wizardStep1.branchAddress2.$error\" role=\"alert\"><div ng-message=\"required\">\nBranch Address2 is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nBranch Address3</label><input type=\"text\" ng-model=\"vm.branchAddress3\" name=\"branchAddress3\"><div \nng-messages=\"wizardStep1.branchAddress3.$error\" role=\"alert\"><div ng-message=\"required\">Branch Address3 is required\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Branch Pincode</label><input \ntype=\"text\" ng-pattern=\"/^\\d{6}$/\" numeric-regex maxlength=\"6\" ng-model=\"vm.branchPincode\" name=\"branchPincode\" \nng-change=\"vm.getStateCityDetailsPinCodeNew()\" required><div ng-messages=\"wizardStep1.branchPincode.$error\" \nrole=\"alert\"><div ng-message=\"required\">Branch Pincode is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Branch City</label><input type=\"text\" ng-model=\"vm.branchCity\" name=\"branchCity\" \nrequired><div ng-messages=\"wizardStep1.branchCity.$error\" role=\"alert\"><div ng-message=\"required\">\nBranch City is required</div></div></md-input-container><md-input-container flex=\"10\" flex-gt-xs=\"50\"><md-button \nclass=\"md-raised width-150\" ng-click=\"vm.openContactDetails()\">Contact Details</md-button></md-input-container>\n<md-input-container flex=\"10\" flex-gt-xs=\"50\"><md-button class=\"md-raised width-150\" \nng-click=\"vm.openNomineeDetails()\">Next</md-button></md-input-container></div><div layout=\"row\" layout-align=\" center\" \nlayout-wrap flex ng-if=\"vm.showNomineeDetails\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Nominee Details</h4><br><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Want to add Nominee?</label><md-select ng-model=\"vm.wantToAddNominee\" name=\"wantToAddNominee\" \nrequired><md-option ng-repeat=\"x in vm.wantToAddNomineeData\" value=\"{{x.CODE}}\">{{x.DESC}}</md-option></md-select><div \nng-messages=\"wizardStep1.wantToAddNominee.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Number Of Nominee</label><md-select \nng-model=\"vm.no_of_nominee\" name=\"no_of_nominee\" required><md-option value=\"1\">1</md-option></md-select><div \nng-messages=\"wizardStep1.no_of_nominee.$error\" role=\"alert\"><div ng-message=\"required\">Select Number of Nominee</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Is Nominee Minor ?</label><md-select \nng-model=\"vm.nominee1_type\" name=\"isNomineeMinor\" required><md-option value=\"Y\">Yes</md-option><md-option value=\"N\">No\n</md-option></md-select><div ng-messages=\"wizardStep1.isNomineeMinor.$error\" role=\"alert\"><div ng-message=\"required\">\nThis field is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nNominee PAN</label><input type=\"text\" capitalize maxlength=\"10\" ng-model=\"vm.NOM1_PAN\" name=\"nomineePan\" required><div \nng-messages=\"wizardStep1.nomineePan.$error\" role=\"alert\"><div ng-message=\"required\">Nominee PAN is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"mt-2\"><label>Nominee Name</label><input \ntype=\"text\" ng-model=\"vm.nominee1_name\" name=\"nomineeName\" required><div ng-messages=\"wizardStep1.nomineeName.$error\" \nrole=\"alert\"><div ng-message=\"required\">Nominee Name is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\" class=\"mt-2\"><label>Nominee DOB<h5 style=\"color: black\">{{vm.nominee1_showDob}}</h5></label>\n<input type=\"date\" ng-model=\"vm.nominee1_dob\" name=\"nominee1_dob\" ng-change=\"vm.onDobNomSelected()\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Nominee Address1</label><input type=\"text\" \nng-model=\"vm.nominee1_addr1\" name=\"nominee1_addr1\" required><div ng-messages=\"wizardStep1.nominee1_addr1.$error\" \nrole=\"alert\"><div ng-message=\"required\">Nominee1 Address1 is required</div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Nominee Address2</label><input type=\"text\" \nng-model=\"vm.nominee1_addr2\" name=\"nominee1_addr2\"><div ng-messages=\"wizardStep1.nominee1_addr2.$error\" role=\"alert\">\n<div ng-message=\"required\">Nominee1 Address2 is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Nominee Address3</label><input type=\"text\" ng-model=\"vm.nominee1_addr3\" \nname=\"nominee1_addr3\"><div ng-messages=\"wizardStep1.nominee1_addr3.$error\" role=\"alert\"><div ng-message=\"required\">\nNominee1 Address3 is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nPincode</label><input type=\"text\" ng-pattern=\"/^\\d{6}$/\" numeric-regex maxlength=\"6\" ng-model=\"vm.nominee1_pincode\" \nname=\"pinCode\" ng-change=\"vm.getStateCityDetailsPinCodeNewNOM1()\" required><div \nng-messages=\"wizardStep1.pinCode.$error\" role=\"alert\"><div ng-message=\"required\">Pincode is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>City</label><input type=\"text\" \nng-model=\"vm.nominee1_city\" name=\"city\" required><div ng-messages=\"wizardStep1.city.$error\" role=\"alert\"><div \nng-message=\"required\">City is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>State</label><input type=\"text\" ng-model=\"vm.nominee1_state\" name=\"state\" required><div \nng-messages=\"wizardStep1.state.$error\" role=\"alert\"><div ng-message=\"required\">State is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Relationship</label><md-select \nng-model=\"vm.nominee1_relation\" name=\"relationship\" required><md-option ng-repeat=\"x in vm.relationData\" ng-value=\"x\">\n{{x}}</md-option></md-select><div ng-messages=\"wizardStep1.relationship.$error\" role=\"alert\"><div \nng-message=\"required\">Relationship is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Guardian Name</label><input type=\"text\" ng-model=\"vm.nominee1_guard_name\" name=\"guardianName\" \nrequired ng-disabled=\"vm.nominee1_type === \'N\'\"><div ng-messages=\"wizardStep1.guardianName.$error\" role=\"alert\"><div \nng-message=\"required\">Guardian Name is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Guardian Relationship</label><md-select ng-model=\"vm.nominee1_guard_relation\" \nname=\"nominee1_guard_relation\" required ng-disabled=\"vm.nominee1_type === \'N\'\"><md-option \nng-repeat=\"x in vm.guardianRelationData\" ng-value=\"x.MINOR_GUARD_REL_CODE\">{{x.MINOR_GUARD_REL}}</md-option>\n</md-select><div ng-messages=\"wizardStep1.nominee1_guard_relation.$error\" role=\"alert\"><div ng-message=\"required\">\nGuardian Relationship is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>Guardian PAN</label><input type=\"text\" capitalize maxlength=\"10\" ng-model=\"vm.nominee1_guard_pan\" \nname=\"guardianPan\" required ng-disabled=\"vm.nominee1_type === \'N\'\"><div ng-messages=\"wizardStep1.guardianPan.$error\" \nrole=\"alert\"><div ng-message=\"required\">Guardian PAN is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><md-button class=\"md-raised width-150\" ng-click=\"vm.openBankDetails()\">Bank Details\n</md-button></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-button \nclass=\"md-raised md-accent md-button width-150\" ng-click=\"vm.editCustomers()\" style=\"color:#fff !important\"><span \nclass=\"ng-scope\">Edit Customer</span></md-button></md-input-container></div></div></div></md-card></div></div>");
$templateCache.put("app/main/customers/fatcaKycUboReglink.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><h4 \nclass=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Customer Detail</h4><div \nlayout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" \nlayout-padding><span class=\"title\">Name : &nbsp;&nbsp; {{vm.customerDetail.userName}}</span> <span>\nIIN : &nbsp;&nbsp; {{vm.customerDetail.iin}}</span></div><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span>Contact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span> <span>\nEmail : &nbsp;&nbsp; {{vm.customerDetail.email}}</span></div><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span>PAN : &nbsp;&nbsp; {{vm.customerDetail.pan}}</span> <span class=\"title\">\nBank Name : &nbsp;&nbsp; {{vm.customerDetail.nseData.BANK_NAME}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nBranch Name : &nbsp;&nbsp; {{vm.customerDetail.nseData.BRANCH_NAME}}</span> <span>\nAccount Type: : &nbsp;&nbsp; {{vm.customerDetail.nseData.AC_TYPE}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nAccount No: : &nbsp;&nbsp; {{vm.customerDetail.nseData.AC_NO}}</span> <span>\nIfsc : &nbsp;&nbsp; {{vm.customerDetail.nseData.IFSC_CODE}}</span></div></div></div></div></div><div class=\"article\">\n<md-content><form novalidate name=\"wizardStep1\"><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div \nclass=\"row\"><div class=\"col-sm-12\"><div layout=\"row\" layout-align=\" center\" layout-wrap flex><h4 class=\"bar-heading\" \nflex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">KYC Details</h4><br><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Applicant Income(Annual)</label><md-select ng-model=\"vm.app_income\" required name=\"app_income\">\n<md-option ng-repeat=\"x in vm.applicableincomeData\" ng-value=\"x.APP_INCOME_CODE\">{{x.APP_INCOME_DESC}}</md-option>\n</md-select><div ng-messages=\"wizardStep1.app_income.$error\" role=\"alert\"><div ng-message=\"required\">\nApplicant Income(Annual) is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-sm=\"50\">\n<label>Source Of Wealth</label><md-select ng-model=\"vm.source_wealth\" name=\"source_wealth\" required><md-option \nng-repeat=\"x in vm.sourceWealthData\" ng-value=\"x.CODE\">{{x.SOURCE_OF_WEALTH}}</md-option></md-select><div \nng-messages=\"wizardStep1.source_wealth.$error\" role=\"alert\"><div ng-message=\"required\">Source Of Wealth is required\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>PEP</label><md-select \nng-model=\"vm.pep\" name=\"pep\" required><md-option ng-repeat=\"item in vm.pepData\" ng-value=\"item.value\">\n{{item.description}}</md-option></md-select><div ng-messages=\"wizardStep1.pep.$error\" role=\"alert\"><div \nng-message=\"required\">PEP is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>Occupation</label><md-select ng-model=\"vm.occupation\" required name=\"occupation\"><md-option \nng-repeat=\"x in vm.occupationData\" ng-value=\"x.OCCUPATION_CODE\">{{x.OCCUPATION_DESC}}</md-option></md-select><div \nng-messages=\"wizardStep1.occupation.$error\" role=\"alert\"><div ng-message=\"required\">Occupation is required</div></div>\n</md-input-container><h4 class=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">FATCA Details\n</h4><br><md-input-container flex=\"100\" flex-gt-xs=\"50\"><h4>DOB: {{vm.customerDetail.nseData.DATE_OF_BIRTH}}</h4>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Address Type</label><md-select \nng-model=\"vm.addr_type\" name=\"addr_type\" required><md-option ng-repeat=\"item in vm.addrTypeData\" ng-value=\"item.value\">\n{{item.description}}</md-option></md-select><div ng-messages=\"wizardStep1.addr_type.$error\" role=\"alert\"><div \nng-message=\"required\">Address Type is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Data Source</label><md-select ng-model=\"vm.data_src\" name=\"data_src\" required \nng-disabled=\"true\"><md-option ng-repeat=\"x in vm.dataSourceData\" ng-value=\"x.value\">{{x.description}}</md-option>\n</md-select><div ng-messages=\"wizardStep1.data_src.$error\" role=\"alert\"><div ng-message=\"required\">Title is required\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Email ID</label><input \ntype=\"email\" ng-model=\"vm.email\" name=\"email\" disabled=\"disabled\" ng-value=\"vm.customerDetail.email\"><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\"><div ng-message=\"required\">Email is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Country of Birth/Incor.</label><md-select \nng-model=\"vm.countryOfBirth\" name=\"countryOfBirth\" ng-disabled=\"true\"><md-option ng-repeat=\"x in vm.countryData\" \nng-value=\"x.value\">{{x.description}}</md-option></md-select><div ng-messages=\"wizardStep1.countryOfBirth.$error\" \nrole=\"alert\"><div ng-message=\"required\">Country of Birth is required</div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Select Place of Birth</label><md-select \nng-model=\"vm.placeOfBirth\" name=\"placeOfBirth\" required><md-option ng-repeat=\"x in vm.placeOfBirthData\" \nng-value=\"x.value\">{{x.description}}</md-option></md-select><div ng-messages=\"wizardStep1.placeOfBirth.$error\" \nrole=\"alert\"><div ng-message=\"required\">Place of Birth is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Tax Residency Other Then India</label><md-select ng-model=\"vm.taxResidency\" \nname=\"taxResidency\" required ng-disabled=\"true\"><md-option ng-repeat=\"x in vm.taxResidencyData\" ng-value=\"x.value\">\n{{x.description}}</md-option></md-select><div ng-messages=\"wizardStep1.taxResidency.$error\" role=\"alert\"><div \nng-message=\"required\">Select Tax Residency other then India or not.</div></div></md-input-container><md-input-container\n flex=\"100\" flex-gt-xs=\"50\"><label>Country of Tax Residency</label><md-select ng-model=\"vm.countryTaxRasidency\" \nname=\"countryTaxRasidency\" required ng-disabled=\"true\"><md-option ng-repeat=\"x in vm.countryData\" ng-value=\"x.value\">\n{{x.description}}</md-option></md-select><div ng-messages=\"wizardStep1.countryTaxRasidency.$error\" role=\"alert\"><div \nng-message=\"required\">Country of Tax Residency is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Tax Payer Identification No</label><input type=\"text\" \nng-model=\"vm.tax_payer_identityno1\" name=\"tax_payer_identityno1\" disabled=\"disabled\" ng-value=\"vm.customerDetail.pan\">\n<div ng-messages=\"wizardStep1.tax_payer_identityno1.$error\" role=\"alert\"><div ng-message=\"required\">\nIdentification No is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nIdentification Type</label><md-select ng-model=\"vm.id1_type\" name=\"id1_type\" ng-disabled=\"true\"><md-option \nng-repeat=\"item in vm.dentificationTypeData\" ng-value=\"item.value\">{{item.description}}</md-option></md-select><div \nng-messages=\"wizardStep1.id1_type.$error\" role=\"alert\"><div ng-message=\"required\">Identification Type is required</div>\n</div></md-input-container><md-input-container flex=\"10\" flex-gt-xs><button \nclass=\"md-raised md-accent md-button width-150 md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.sendfatcaKycUboReglink()\" style=\"float:right; color:#fff !important\"><span class=\"ng-scope\">Send</span>\n</button></md-input-container></div></div></div></md-card></div></form></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/pauseSip.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll ng-if=\"vm.transactions.length > 0\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">Pause SIP list</h4><table \nclass=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><tr><th>Scheme Name</th><th>Folio</th><th>\nsip_reg_no</th><th>Effective Date</th><th>Pause for</th><th>Remarks</th><th>Delete</th></tr><tr \nng-repeat=\"transaction in vm.transactions track by $index\"><td ng-if=\"transaction.scheme_name !== \'\'\">\n{{transaction.scheme_name}}</td><td ng-if=\"transaction.folio_number !== \'\'\">{{transaction.folio_number}}</td><td \nng-if=\"transaction.sip_reg_no !== \'\'\">{{transaction.sip_reg_no}}</td><td ng-if=\"transaction.effective_date !== \'\'\">\n{{transaction.effective_date}}</td><td ng-if=\"transaction.pause_flag !== \'\'\">{{transaction.pause_flag}}</td><td \nng-if=\"transaction.remarks !== \'\'\">{{transaction.remarks}}</td><td><md-button class=\"md-raised md-warn\" \nng-click=\"vm.deleteTransaction($index)\">Delete</md-button></td></tr></table></div></div><md-input-container flex=\"100\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.pauseSip()\" style=\"color:#fff !important\">Pause Sip</md-button>\n</md-input-container></div><div class=\"article\"><md-content><form novalidate name=\"wizardStep1\"><div \nclass=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><h4 \nclass=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Running SIP</h4><div class=\"article\" \nng-if=\"vm.SipDetail.length > 0\"><md-content class=\"margin-bottom-10\" ng-repeat=\"sip in vm.SipDetail\"><div \nclass=\"padding-5\" layout=\"row\"><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" layout-padding flex=\"50\"><span class=\"title\">\nScheme Name : &nbsp;&nbsp; {{sip.scheme_name}}</span> <span>Sip Start Date : &nbsp;&nbsp; {{sip.start_date}}</span> \n<span>Number of Installment:&nbsp;&nbsp;{{sip.no_of_installments}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" layout-padding flex=\"24\"><span>Folio Number : &nbsp;&nbsp; {{sip.folio_number}}\n</span> <span>Sip End Date : &nbsp;&nbsp; {{sip.end_date}}</span> <span>Frequency : &nbsp;&nbsp;{{sip.frequency_type}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" layout-padding flex=\"24\"><span>\nAmount : &nbsp;&nbsp; {{sip.installments_amount}}</span> <span>\nRegistration Date : &nbsp;&nbsp; {{sip.xsip_registration_date}}</span> <span>\nRegistration No:&nbsp;&nbsp;{{sip.xsip_registration_no}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"padding-5\" style=\"gap:16px\"><div flex=\"25\" layout=\"column\" layout-align=\"center\">\n<md-input-container><label>Effective Date (DD/MM/YYYY)</label><input type=\"date\" ng-model=\"sip.effective_date\" \nrequired></md-input-container></div><div flex=\"35\" layout=\"column\" layout-align=\"center\"><md-input-container><label>\nRemarks</label><textarea ng-model=\"sip.remarksVal\" md-maxlength=\"255\" rows=\"1\" md-select-on-focus required></textarea>\n</md-input-container></div><div flex=\"25\" layout=\"column\" layout-align=\"center\"><md-input-container><label>Pause for\n</label><md-select ng-model=\"sip.pause_flag\" placeholder=\"Select Reason\" required><md-option \nng-repeat=\"reason in vm.pauseMasterData\" ng-value=\"reason.id\">{{reason.reason}}</md-option></md-select>\n</md-input-container></div><div flex=\"10\" layout=\"column\" layout-align=\"center\"><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"!sip.effective_date\" ng-click=\"vm.addTransaction(sip)\">Add</md-button></div>\n</div></md-content></div><div class=\"article\" ng-if=\"vm.SipDetail.length == 0\"><md-content class=\"md-whiteframe-4dp\">\n<div class=\"padding-5\" layout=\"center center\"><h4 class=\"margin-left-30\">No Data</h4></div></md-content></div></div>\n</div></md-card></div></form></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/resendLink.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><div layout=\"row\" layout-align=\" center\" layout-wrap \nflex><h4 class=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Resend Link</h4><br>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Product Type</label><md-select ng-model=\"vm.productType\" \nname=\"productType\" required><md-option ng-repeat=\"x in vm.shortUrlList\" ng-value=\"x\">{{x.description}}</md-option>\n</md-select><div ng-messages=\"wizardStep1.title.$error\" role=\"alert\"><div ng-message=\"required\">Title is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Product Ref Id</label><input \ntype=\"text\" ng-model=\"vm.productRefId\" name=\"productRefId\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top: 16px\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.resendLink()\" style=\"color:#fff !important\">Resend Link</md-button></div></div></div></md-card></div>\n</div>");
$templateCache.put("app/main/customers/stp.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll ng-if=\"vm.transactions.length > 0\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">STP list</h4><table \nclass=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><thead><tr><th>Fund Name</th><th>\nSource Scheme</th><th>Transfers Scheme</th><th>Folio</th><th>Amount/Unit</th><th>Withdraw Type</th><th>Delete</th></tr>\n</thead><tbody><tr ng-repeat=\"transaction in vm.transactions track by $index\"><td \nng-if=\"transaction.productAmcName !== \'\'\">{{transaction.productAmcName}}</td><td \nng-if=\"transaction.scheme_code !== \'\'\">{{transaction.sourceSchemeName}}</td><td ng-if=\"transaction.scheme_code !== \'\'\">\n{{transaction.transfersSchemeName}}</td><td ng-if=\"transaction.folio_no !== \'\'\">{{transaction.folio_no}}</td><td \nng-if=\"transaction.installment_amount !== \'\'\">{{transaction.installment_amount}}</td><td \nng-if=\"transaction.to_scheme_code !== \'\'\">{{transaction.amt_unit_type}}</td><td><md-button class=\"md-raised md-warn\" \nng-click=\"vm.deleteTransaction($index)\">Delete</md-button></td></tr></tbody></table></div></div><md-input-container \nflex=\"100\" style=\"margin: 20px\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.stp()\" \nstyle=\"color:#fff !important; width: 100%\">Execute STP Transaction</md-button></md-input-container></div><div \nclass=\"article\"><md-content><form novalidate name=\"wizardStep1\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Investments Details(STP)</h4><div ng-repeat=\"x in vm.allHoldings\" \nlayout=\"column\" flex style=\"border: 1px solid #E0E0E0; margin-bottom: 15px; padding: 15px; background: #fff\"><div \nlayout=\"row\" style=\"margin-bottom: 5px\"><div layout=\"column\" flex=\"65\" style=\"padding-right:10px\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-bottom: 5px\"><span><md-checkbox ng-model=\"x.isChecked\" \nng-change=\"vm.onCheckChange(x)\" aria-label=\"Select Scheme\" style=\"margin-right: 15px\"></md-checkbox></span><div \nlayout=\"column\" flex><h5 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #fa0000\"><b>\n{{x.nseSchemeDetails.productAmcName}}</b></h5><h6 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #333\">\n<b>{{x.scheme}}</b></h6><p style=\"margin: 8px 0 0 0; color: #666; font-size: 14px; margin-bottom: 25px\"><b>Folio</b>\n:{{x.folio_no}}</p></div></div><div ng-if=\"x.isChecked\" layout=\"row\" layout-wrap style=\"margin-bottom: 5px\"><div \nflex=\"50\" style=\"padding-right: 10px\"><md-input-container style=\"width: 100%; margin-top: 20px\"><label>Fund Frequency\n</label><md-select ng-model=\"x.selectedFrequency\" required><md-option \nng-repeat=\"frequency in x.splitSystematicFrequencies\" ng-value=\"frequency\">\n{{{ \'OM\':\'MONTHLY\', \'Q\': \'QUARTERLY\', \'OW\': \'WEEKLY\', \'BZ\': \'DAILY\', \'SP\': \'DAILY\', \'WD\': \'DAILY\', \'SM\': \'MONTHLY\', \'D\': \'DAILY\', \'H\': \'SEMI-ANNUALLY\', \'Y\': \'ANNUALLY\', \'TW\': \'MONTHLY\' }[frequency] || frequency}}\n</md-option></md-select></md-input-container><md-input-container style=\"width: 100%; margin-top: 20px\"><label>\nFirst Order Today</label><md-select ng-model=\"x.first_order_today\" required><md-option ng-value=\"\'Y\'\">YES</md-option>\n<md-option ng-value=\"\'N\'\">NO</md-option></md-select></md-input-container><md-input-container \nstyle=\"width: 100%; margin-top: 20px\"><label>Start Date</label><input type=\"date\" ng-model=\"x.start_date\" \nname=\"start_date\" required></md-input-container></div><div flex=\"50\" style=\"padding-left: 10px\"><md-input-container \nstyle=\"width: 100%; margin-top: 20px\"><label>Transfers To</label><md-select ng-model=\"x.toProdcode\" required><md-option\n ng-repeat=\"scheme in x.schemeList\" \nng-value=\"{\'transfersProductCode\': scheme.newSchemeCode, \'transfersProductLongName\': scheme.PRODUCT_LONG_NAME}\">\n{{scheme.PRODUCT_LONG_NAME}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"width: 100%; margin-top: 20px\"><label>Date</label><md-select ng-model=\"x.selectedDate\" required><md-option \nng-repeat=\"date in x.splitStpDates\" ng-value=\"date\">{{ date }}</md-option></md-select></md-input-container></div></div>\n<div ng-if=\"x.isChecked\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom: 5px\"><md-radio-group \nng-model=\"x.redemptionType\" layout=\"row\" style=\"margin-right: 20px\"><md-radio-button value=\"AMOUNT\">Amount\n</md-radio-button></md-radio-group><md-input-container flex=\"25\" style=\"margin: 0 20px 0 0\"><input type=\"number\" \nng-model=\"x.amount_unit\" placeholder=\"Enter amount to Withdraw!\" required></md-input-container><md-button \nclass=\"md-raised\" ng-click=\"vm.addTransaction(x)\" ng-disabled=\"isButtonDisabled(x)\" \nstyle=\"background-color: #e0e0e0; color: #333; margin-right: 15px; min-width: 140px\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#333\"></md-icon>ADD TRANSACTION</md-button><md-button class=\"md-raised\" ng-click=\"vm.clearForm(x)\" \nstyle=\"background-color: #2196F3; color: #fff; min-width: 80px\"><md-icon md-font-icon=\"icon-refresh\" \nstyle=\"color:#fff\"></md-icon>RESET</md-button></div></div><div layout=\"column\" flex=\"35\" style=\"padding-left: 20px\">\n<div layout=\"column\" style=\"margin-bottom: 5px\"><div ng-if=\"!x.isChecked\" style=\"margin-bottom: 5px\"></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 10px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Current Value</div><div \nstyle=\"color: #28a745; font-size: 18px; font-weight: bold\">₹{{x.currentValue | number:2}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 10px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Unit</div><div \nstyle=\"color: #007bff; font-size: 18px; font-weight: bold\">{{x.units | number:2}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">NAV</div><div \nstyle=\"color: #333; font-size: 18px; font-weight: bold\">₹{{x.nav_value | number:2}}</div></div><div \nng-if=\"!x.isChecked\"></div></div></div></div></div><div ng-if=\"vm.allHoldings && vm.allHoldings.length === 0\" \nlayout=\"row\" layout-align=\"center center\" \nstyle=\"padding: 40px; background: #f5f5f5; margin: 20px 0; border-radius: 4px\"><div layout=\"column\" \nlayout-align=\"center center\"><h4 style=\"color: #666; margin: 0\">No Holdings Found</h4><p \nstyle=\"color: #999; margin: 10px 0 0 0\">No mutual fund holdings available for STP transactions.</p></div></div></div>\n</div></md-card></div></form></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/swp.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll ng-if=\"vm.transactions.length > 0\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">SWP list</h4><table \nclass=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><thead><tr><th>Fund Name</th><th>\nSource Scheme</th><th>Folio</th><th>Amount/Unit</th><th>Withdraw Type</th><th>Delete</th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.transactions track by $index\"><td ng-if=\"transaction.productAmcName !== \'\'\">\n{{transaction.productAmcName}}</td><td ng-if=\"transaction.scheme_code !== \'\'\">{{transaction.sourceSchemeName}}</td><td \nng-if=\"transaction.folio_no !== \'\'\">{{transaction.folio_no}}</td><td ng-if=\"transaction.installmenamount !== \'\'\">\n{{transaction.installmenamount}}</td><td ng-if=\"transaction.amt_unit_type !== \'\'\">{{transaction.amt_unit_type}}</td>\n<td><md-button class=\"md-raised md-warn\" ng-click=\"vm.deleteTransaction($index)\">Delete</md-button></td></tr></tbody>\n</table></div></div><md-input-container flex=\"100\" style=\"margin: 20px\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.swp()\" style=\"color:#fff !important; width: 100%\">Execute SWP Transaction</md-button></md-input-container>\n</div><div class=\"article\"><md-content><form novalidate name=\"wizardStep1\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Investments Details(SWP)</h4><div ng-repeat=\"x in vm.allHoldings\" \nlayout=\"column\" flex style=\"border: 1px solid #E0E0E0; margin-bottom: 15px; padding: 15px; background: #fff\"><div \nlayout=\"row\" style=\"margin-bottom: 5px\"><div layout=\"column\" flex=\"65\" style=\"padding-right:10px\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-bottom: 5px\"><span><md-checkbox ng-model=\"x.isChecked\" \nng-change=\"vm.onCheckChange(x)\" aria-label=\"Select Scheme\" style=\"margin-right: 15px\"></md-checkbox></span><div \nlayout=\"column\" flex><h5 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #fa0000\"><b>\n{{x.nseSchemeDetails.productAmcName}}</b></h5><h6 style=\"margin: 0; font-weight: bold; font-size: 16px; color: #333\">\n<b>{{x.scheme}}</b></h6><p style=\"margin: 8px 0 0 0; color: #666; font-size: 14px; margin-bottom: 25px\"><b>Folio</b>\n:{{x.folio_no}}</p></div></div><div ng-if=\"x.isChecked\" layout=\"row\" layout-wrap style=\"margin-bottom: 5px\"><div \nflex=\"50\" style=\"padding-right: 10px\"><md-input-container style=\"width: 100%; margin-top: 20px\"><label>Fund Frequency\n</label><md-select ng-model=\"x.selectedFrequency\" required><md-option \nng-repeat=\"frequency in x.splitSystematicFrequencies\" ng-value=\"frequency\">\n{{{ \'OM\':\'MONTHLY\', \'Q\': \'QUARTERLY\', \'OW\': \'WEEKLY\', \'BZ\': \'DAILY\', \'SP\': \'DAILY\', \'WD\': \'DAILY\', \'SM\': \'MONTHLY\', \'D\': \'DAILY\', \'H\': \'SEMI-ANNUALLY\', \'Y\': \'ANNUALLY\', \'TW\': \'MONTHLY\' }[frequency] || frequency}}\n</md-option></md-select></md-input-container><md-input-container style=\"width: 100%; margin-top: 20px\"><label>\nFirst Order Today</label><md-select ng-model=\"x.first_order_today\" required><md-option ng-value=\"\'Y\'\">YES</md-option>\n<md-option ng-value=\"\'N\'\">NO</md-option></md-select></md-input-container></div><div flex=\"50\" \nstyle=\"padding-left: 10px\"><md-input-container style=\"width: 100%; margin-top: 20px\"><label>Date</label><md-select \nng-model=\"x.selectedDate\" required><md-option ng-repeat=\"date in x.splitSwpDates\" ng-value=\"date\">{{ date }}\n</md-option></md-select></md-input-container><md-input-container style=\"width: 100%; margin-top: 20px\"><label>\nStart Date</label><input type=\"date\" ng-model=\"x.start_date\" name=\"start_date\" required></md-input-container></div>\n</div><div ng-if=\"x.isChecked\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom: 5px\"><md-radio-group \nng-model=\"x.redemptionType\" layout=\"row\" style=\"margin-right: 20px\"><md-radio-button value=\"AMOUNT\">Amount\n</md-radio-button></md-radio-group><md-input-container flex=\"25\" style=\"margin: 0 20px 0 0\"><input type=\"number\" \nng-model=\"x.amount_unit\" placeholder=\"Enter amount to Withdraw!\" required></md-input-container><md-button \nclass=\"md-raised\" ng-click=\"vm.addTransaction(x)\" ng-disabled=\"isButtonDisabled(x)\" \nstyle=\"background-color: #e0e0e0; color: #333; margin-right: 15px; min-width: 140px\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#333\"></md-icon>ADD TRANSACTION</md-button><md-button class=\"md-raised\" ng-click=\"vm.clearForm(x)\" \nstyle=\"background-color: #2196F3; color: #fff; min-width: 80px\"><md-icon md-font-icon=\"icon-refresh\" \nstyle=\"color:#fff\"></md-icon>RESET</md-button></div></div><div layout=\"column\" flex=\"35\" style=\"padding-left: 20px\">\n<div layout=\"column\" style=\"margin-bottom: 5px\"><div ng-if=\"!x.isChecked\" style=\"margin-bottom: 5px\"></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 10px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Current Value</div><div \nstyle=\"color: #28a745; font-size: 18px; font-weight: bold\">₹{{x.currentValue | number:2}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px; margin-bottom: 10px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">Unit</div><div \nstyle=\"color: #007bff; font-size: 18px; font-weight: bold\">{{x.units | number:2}}</div></div><div \nstyle=\"background: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 12px\"><div \nstyle=\"color: #6c757d; font-size: 12px; font-weight: 500; margin-bottom: 4px\">NAV</div><div \nstyle=\"color: #333; font-size: 18px; font-weight: bold\">₹{{x.nav_value | number:2}}</div></div><div \nng-if=\"!x.isChecked\"></div></div></div></div></div><div ng-if=\"vm.allHoldings && vm.allHoldings.length === 0\" \nlayout=\"row\" layout-align=\"center center\" \nstyle=\"padding: 40px; background: #f5f5f5; margin: 20px 0; border-radius: 4px\"><div layout=\"column\" \nlayout-align=\"center center\"><h4 style=\"color: #666; margin: 0\">No Holdings Found</h4><p \nstyle=\"color: #999; margin: 10px 0 0 0\">No mutual fund holdings available for SWP transactions.</p></div></div></div>\n</div></md-card></div></form></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/uploadDownloadForm.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" flex><div \nlayout=\"column\" layout-align=\"space-around start\" class=\"margin-left-20\" flex=\"25\" layout-padding><span class=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME ? vm.nseData.INVESTOR_NAME : (vm.userDetail.userName?vm.userDetail.userName:\'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.userDetail.jobTitle) ? (vm.userDetail.jobTitle) : \'NA\'}}</span></div>\n<div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.userDetail.iin) ? (vm.userDetail.iin):\'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.userDetail.email) ? (vm.userDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.userDetail.pan) ? (vm.userDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{(vm.userDetail.mobileNo) ? (vm.userDetail.mobileNo):\'NA\'}}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.userDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.userDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.userDetail || !vm.userDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.userDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.userDetail.camsKycStatus == \'01\' || vm.userDetail.camsKycStatus == \'02\' || vm.userDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.userDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.userDetail.camsKycStatus != \'01\' && vm.userDetail.camsKycStatus != \'02\' && vm.userDetail.camsKycStatus != \'07\'\">\n{{ vm.userDetail.camsKycStatus != undefined ? vm.eKyc[vm.userDetail.camsKycStatus] : \'NA\'}}</span></span></div></div>\n</md-content></div><div class=\"article padding-top-10\"><md-content><form novalidate name=\"wizardStep1\"><div \nlayout=\"column\" layout-align=\"space-around start\" flow-init=\"{singleFile:true}\" flow-name=\"imageFile.flowObj\" \nflow-files-added=\"processFile($files)\" style=\"margin-left:15px\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-top:30px\"><md-input-container class=\"md-block\" flex=\"30\" style=\"margin-right:40px\"><label>Select Type\n</label><md-select ng-model=\"vm.user.docType\"><md-option value=\"DL\">Driving License</md-option><md-option value=\"PC\">\nPAN Card</md-option><md-option value=\"IP\">IIN Physical Form</md-option><md-option value=\"PA\">Passport</md-option>\n<md-option value=\"AA\">AADHAR Card</md-option><md-option value=\"KF\">KRA Form</md-option><md-option value=\"CH\">Cheque\n</md-option><md-option value=\"AC\">ACH Form</md-option><md-option value=\"X\">Transaction Image</md-option><md-option \nvalue=\"B\">Bank Proof Image</md-option></md-select></md-input-container><input type=\"file\" name=\"file\" flow-btn \naccept=\"application/pdf,image/*\" ng-disabled=\"vm.user.docType == undefined\"><div style=\"text-align:center\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.uploadDocument(vm.userDetail._id); wizardStep1.resetForm();\" \nng-disabled=\"!imageFile.flowObj.files.length\" style=\"color:#fff !important\">Upload File</md-button><br><small>\nFile size should be greater than 5MB. Expected file should be in .jpeg/.jpg/.png format.</small></div></div><div><span>\n&nbsp;&nbsp;{{imageFile.flowObj.files.length}} Files to upload!</span><br><p \nng-repeat=\"file in imageFile.flowObj.files\">{{$index + 1}}.&nbsp;&nbsp;{{file.name}}</p></div></div><div layout=\"row\" \nlayout-align=\"space-around start\" style=\"margin-left:15px\"><div layout=\"column\" layout-align=\"end end\"><md-button \nclass=\"md-raised md-accent downloadbtnData\" ng-click=\"vm.downloadAll(vm.userDetail.documents);\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><span class=\"textColorDocs\">Download All</span></md-button><span \nclass=\"textDocsFile\">Click on File to download individual file.</span></div><div layout=\"column\" \nlayout-align=\"center left\"><md-button class=\"md-raised md-accent downloadbtnData\" ng-click=\"vm.SendemailToNSE();\"><span\n class=\"textColorDocs\">Send Mail to NSE</span></md-button></div></div></form></md-content></div><div class=\"article\">\n<md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><md-card>\n<div class=\"bgSubheading\"><h1 class=\"headerTextColor\">ID Proof Documents</h1></div><md-card-content class=\"padding-2\">\n<div layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div><h1 \nclass=\"headerTextColorSub float-left\">Passport</h1><md-tooltip>{{vm.getImagePath(\'PA\').comments}}</md-tooltip><md-icon \nmd-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'PA\').status===\'CANCELED\'\">\n</md-icon></div><md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'PA\').url\" \nclass=\"objectFitBlog\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'PA\').url}}\"><img ng-if=\"vm.getImagePath(\'PA\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'PA\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'PA\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedPA\" name=\"state-PA\" type=\"radio\" class=\"default\" ng-checked=\"vm.getImagePath(\'PA\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PA\').docType,\'COMPLETE\')\"><label for=\"AcceptedPA\" \nng-class=\"vm.getImagePath(\'PA\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PA\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'PA\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingPA\" name=\"state-PA\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'PA\').status===\'PENDING\'\"><label for=\"pendingPA\">Pending\n</label><input id=\"rejectedPA\" name=\"state-PA\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PA\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PA\').docType,\'CANCELED\')\"><label for=\"rejectedPA\" \nng-class=\"vm.getImagePath(\'PA\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PA\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'PA\').status===\'CANCELED\'\">Rejected</span></label><a></a></div><div \nng-if=\"vm.getImagePath(\'PA\').status===\'COMPLETE\'\"><input id=\"submittoNse\" name=\"submittoNse\" type=\"radio\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PA\').docType,\'SUBMITTONSE\')\"><label>Submit to NSE</label>\n</div></md-card-actions></md-card></div><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div><h1 \nclass=\"headerTextColorSub float-left\">Driving License</h1><md-tooltip>{{vm.getImagePath(\'DL\').comments}}</md-tooltip>\n<md-icon md-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" \nng-if=\"vm.getImagePath(\'DL\').status===\'CANCELED\'\"></md-icon></div><md-card-content class=\"cardHeightFixeds\"><img \nng-if=\"!vm.getImagePath(\'DL\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'DL\').url}}\"><img ng-if=\"vm.getImagePath(\'DL\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'DL\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'DL\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedDL\" name=\"state-DL\" type=\"radio\" ng-checked=\"vm.getImagePath(\'DL\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'DL\').docType,\'COMPLETE\')\"><label for=\"AcceptedDL\" \nng-class=\"vm.getImagePath(\'DL\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'DL\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'DL\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingDL\" name=\"state-DL\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'DL\').status===\'PENDING\'\"><label for=\"pendingDL\">Pending\n</label><input id=\"rejectedDL\" name=\"state-DL\" type=\"radio\" ng-checked=\"vm.getImagePath(\'DL\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'DL\').docType,\'CANCELED\')\"><label for=\"rejectedDL\" \nng-class=\"vm.getImagePath(\'DL\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'DL\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'DL\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</div><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div><h1 class=\"headerTextColorSub float-left\">\nAadhaar Card Front</h1><md-tooltip>{{vm.getImagePath(\'AA1\').comments}}</md-tooltip><md-icon \nmd-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'\">\n</md-icon></div><md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'AA1\').url\" \nclass=\"objectFitBlog\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'AA1\').url}}\"><img ng-if=\"vm.getImagePath(\'AA1\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'AA1\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'AA1\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input\n id=\"AcceptedAA1\" name=\"state-AA1\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA1\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA1\').docType,\'COMPLETE\')\"><label for=\"AcceptedAA1\" \nng-class=\"vm.getImagePath(\'AA1\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA1\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'AA1\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingAA1\" name=\"state-AA1\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'AA1\').status===\'PENDING\'\"><label for=\"pendingAA1\">Pending\n</label><input id=\"rejectedAA1\" name=\"state-AA1\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA1\').docType,\'CANCELED\')\"><label for=\"rejectedAA1\" \nng-class=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA1\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions>\n<md-card-actions layout=\"row\" layout-align=\"center center\" ng-if=\"vm.getImagePath(\'AA1\').url\"><div \nclass=\"switch-toggle switch-3 switch-candy\" ng-if=\"vm.getImagePath(\'AA1\').status===\'COMPLETE\'\"><input \nid=\"submittoNseAA1\" name=\"submittoNse-AA1\" type=\"button\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA1\').docType,\'SUBMITTONSE\')\"><label for=\"submittoNseAA1\">\nSubmit to NSE</label></div></md-card-actions></md-card></div><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card>\n<div><h1 class=\"headerTextColorSub float-left\">Aadhaar Card Back</h1><md-tooltip>{{vm.getImagePath(\'AA2\').comments}}\n</md-tooltip><md-icon md-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" \nng-if=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'\"></md-icon></div><md-card-content class=\"cardHeightFixeds\"><img \nng-if=\"!vm.getImagePath(\'AA2\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'AA2\').url}}\"><img ng-if=\"vm.getImagePath(\'AA2\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'AA2\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'AA2\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input\n id=\"AcceptedAA2\" name=\"state-AA2\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA2\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA2\').docType,\'COMPLETE\')\"><label for=\"AcceptedAA2\" \nng-class=\"vm.getImagePath(\'AA2\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA2\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'AA2\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingAA2\" name=\"state-AA2\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'AA2\').status===\'PENDING\'\"><label for=\"pendingAA2\">Pending\n</label><input id=\"rejectedAA2\" name=\"state-AA2\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA2\').docType,\'CANCELED\')\"><label for=\"rejectedAA2\" \nng-class=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA2\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</div></div></md-card-content></md-card></div></md-content><md-content class=\"md-padding\" layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 \nclass=\"headerTextColor\">PAN Card</h1></div><md-card-content class=\"padding-2\"><md-card><div><h1 \nclass=\"headerTextColorSub float-left\">PAN Card</h1><md-tooltip>{{vm.getImagePath(\'PC\').comments}}</md-tooltip><md-icon \nmd-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'PC\').status===\'CANCELED\'\">\n</md-icon></div><md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'PC\').url\" \nclass=\"objectFitBlog\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'PC\').url}}\"><img ng-if=\"vm.getImagePath(\'PC\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'PC\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'PC\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedPC\" name=\"state-PC\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PC\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PC\').docType,\'COMPLETE\')\"><label for=\"AcceptedPC\" \nng-class=\"vm.getImagePath(\'PC\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PC\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'PC\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingPC\" name=\"state-PC\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'PC\').status===\'PENDING\'\"><label for=\"pendingPC\">Pending\n</label><input id=\"rejectedPC\" name=\"state-PC\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PC\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PC\').docType,\'CANCELED\')\"><label for=\"rejectedPC\" \nng-class=\"vm.getImagePath(\'PC\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PC\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'PC\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions>\n<md-card-actions layout=\"row\" layout-align=\"center center\" ng-if=\"vm.getImagePath(\'PC\').url\"><div \nclass=\"switch-toggle switch-3 switch-candy\" ng-if=\"vm.getImagePath(\'PC\').status===\'COMPLETE\'\"><input \nid=\"submittoNsePC\" name=\"submittoNse-PC\" type=\"button\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PC\').docType,\'SUBMITTONSE\')\"><label for=\"submittoNsePC\">\nSubmit to NSE</label></div></md-card-actions></md-card></md-card-content></md-card></div><div flex-xs flex-gt-xs=\"50\" \nlayout=\"column\"><md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">Bank Documents</h1></div>\n<md-card-content class=\"padding-2\"><div layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"50\" layout=\"column\">\n<md-card><div><h1 class=\"headerTextColorSub float-left\">Cancel Cheque</h1><md-tooltip>\n{{vm.getImagePath(\'CH\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'CH\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'CH\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'CH\').url}}\"><img ng-if=\"vm.getImagePath(\'CH\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'CH\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'CH\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedCH\" name=\"state-CH\" type=\"radio\" ng-checked=\"vm.getImagePath(\'CH\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'CH\').docType,\'COMPLETE\')\"><label for=\"AcceptedCH\" \nng-class=\"vm.getImagePath(\'CH\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'CH\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'CH\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingCH\" name=\"state-CH\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'CH\').status===\'PENDING\'\"><label for=\"pendingCH\">Pending\n</label><input id=\"rejectedCH\" name=\"state-CH\" type=\"radio\" ng-checked=\"vm.getImagePath(\'CH\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'CH\').docType,\'CANCELED\')\"><label for=\"rejectedCH\" \nng-class=\"vm.getImagePath(\'CH\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'CH\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'CH\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions>\n<md-card-actions layout=\"row\" layout-align=\"center center\" ng-if=\"vm.getImagePath(\'CH\').url\"><div \nclass=\"switch-toggle switch-3 switch-candy\" ng-if=\"vm.getImagePath(\'CH\').status===\'COMPLETE\'\"><input \nid=\"submittoNseCH\" name=\"submittoNse-CH\" type=\"button\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'CH\').docType,\'SUBMITTONSE\')\"><label for=\"submittoNseCH\">\nSubmit to NSE</label></div></md-card-actions></md-card></div><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card>\n<div><h1 class=\"headerTextColorSub float-left\">Bank Passbook</h1><md-tooltip>{{vm.getImagePath(\'B\').comments}}\n</md-tooltip><md-icon md-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" \nng-if=\"vm.getImagePath(\'B\').status===\'CANCELED\'\"></md-icon></div><md-card-content class=\"cardHeightFixeds\"><img \nng-if=\"!vm.getImagePath(\'B\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'B\').url}}\"><img ng-if=\"vm.getImagePath(\'B\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'B\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.getImagePath(\'B\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input id=\"AcceptedB\" name=\"state-B\" \ntype=\"radio\" ng-checked=\"vm.getImagePath(\'B\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'B\').docType,\'COMPLETE\')\"><label for=\"AcceptedB\" \nng-class=\"vm.getImagePath(\'B\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'B\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'B\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingB\" name=\"state-B\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'B\').status===\'PENDING\'\"><label for=\"pendingB\">Pending\n</label><input id=\"rejectedB\" name=\"state-B\" type=\"radio\" ng-checked=\"vm.getImagePath(\'B\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'B\').docType,\'CANCELED\')\"><label for=\"rejectedB\" \nng-class=\"vm.getImagePath(\'B\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'B\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'B\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions><md-card-actions\n layout=\"row\" layout-align=\"center center\" ng-if=\"vm.getImagePath(\'B\').url\"><div \nclass=\"switch-toggle switch-3 switch-candy\" ng-if=\"vm.getImagePath(\'B\').status===\'COMPLETE\'\"><input id=\"submittoNseB\" \nname=\"submittoNse-B\" type=\"button\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'B\').docType,\'SUBMITTONSE\')\"><label for=\"submittoNseB\">\nSubmit to NSE</label></div></md-card-actions></md-card></div></div></md-card-content></md-card></div><div flex-xs \nflex-gt-xs=\"25\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">Investory Form</h1>\n</div><md-card-content class=\"padding-2\"><md-card><div><h1 class=\"headerTextColorSub float-left\">Investory Form</h1>\n<md-tooltip>{{vm.getImagePath(\'IP\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'IP\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'IP\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'IP\').url}}\"><img ng-if=\"vm.getImagePath(\'IP\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'IP\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'IP\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedIP\" name=\"state-IP\" type=\"radio\" ng-checked=\"vm.getImagePath(\'IP\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'IP\').docType,\'COMPLETE\')\"><label for=\"AcceptedIP\" \nng-class=\"vm.getImagePath(\'IP\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'IP\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'IP\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingIP\" name=\"state-IP\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'IP\').status===\'PENDING\'\"><label for=\"pendingIP\">Pending\n</label><input id=\"rejectedIP\" name=\"state-IP\" type=\"radio\" ng-checked=\"vm.getImagePath(\'IP\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'IP\').docType,\'CANCELED\')\"><label for=\"rejectedIP\" \nng-class=\"vm.getImagePath(\'IP\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'IP\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'IP\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions>\n<md-card-actions layout=\"row\" layout-align=\"center center\" ng-if=\"vm.getImagePath(\'IP\').url\"><div \nclass=\"switch-toggle switch-3 switch-candy\" ng-if=\"vm.getImagePath(\'IP\').status===\'COMPLETE\'\"><input \nid=\"submittoNseIP\" name=\"submittoNse-IP\" type=\"button\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'IP\').docType,\'SUBMITTONSE\')\"><label for=\"submittoNseIP\">\nSubmit to NSE</label></div></md-card-actions></md-card></md-card-content></md-card></div></md-content><md-content \nclass=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card><div \nclass=\"bgSubheading\"><h1 class=\"headerTextColor\">Video</h1></div><md-card-content class=\"padding-2\"><md-card><div><h1 \nclass=\"headerTextColorSub float-left\">Video</h1><md-tooltip>{{vm.getImagePath(\'VID\').comments}}</md-tooltip><md-icon \nmd-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'VID\').status===\'CANCELED\'\">\n</md-icon></div><md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'VID\').url\" \nclass=\"objectFitBlog\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'VID\').url}}\"><video ng-if=\"vm.getImagePath(\'VID\').url\" \nng-src=\"{{vm.trustSrc(vm.getImagePath(\'VID\').url)}}\" controls></video></a></md-card-content><md-card-actions \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.getImagePath(\'VID\').url\"><div \nclass=\"switch-toggle switch-3 switch-candy\"><input id=\"AcceptedVID\" name=\"state-VID\" type=\"radio\" \nng-checked=\"vm.getImagePath(\'VID\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'VID\').docType,\'COMPLETE\')\"><label for=\"AcceptedVID\" \nng-class=\"vm.getImagePath(\'VID\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'VID\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'VID\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingVID\" name=\"state-VID\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'VID\').status===\'PENDING\'\"><label for=\"pendingVID\">Pending\n</label><input id=\"rejectedVID\" name=\"state-VID\" type=\"radio\" ng-checked=\"vm.getImagePath(\'VID\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'VID\').docType,\'CANCELED\')\"><label for=\"rejectedVID\" \nng-class=\"vm.getImagePath(\'VID\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'VID\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'VID\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</md-card-content></md-card></div><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 \nclass=\"headerTextColor\">User Image</h1></div><md-card-content class=\"padding-2\"><md-card><div><h1 \nclass=\"headerTextColorSub float-left\">User Image</h1><md-tooltip>{{vm.getImagePath(\'PIC\').comments}}</md-tooltip>\n<md-icon md-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" \nng-if=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'\"></md-icon></div><md-card-content class=\"cardHeightFixeds\"><img \nng-if=\"!vm.getImagePath(\'PIC\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'PIC\').url}}\"><img ng-if=\"vm.getImagePath(\'PIC\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'PIC\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'PIC\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input\n id=\"AcceptedPIC\" name=\"state-VID\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PIC\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PIC\').docType,\'COMPLETE\')\"><label for=\"AcceptedPIC\" \nng-class=\"vm.getImagePath(\'PIC\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PIC\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'PIC\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingPIC\" name=\"state-VID\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'PIC\').status===\'PENDING\'\"><label for=\"pendingPIC\">Pending\n</label><input id=\"rejectedPIC\" name=\"state-VID\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PIC\').docType,\'CANCELED\')\"><label for=\"rejectedPIC\" \nng-class=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PIC\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</md-card-content></md-card></div></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/userDetail.html","<div class=\"scrollable\" ms-scroll fix-head><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout=\"row\" layout-align=\"end end\"><div><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.amcforekyc\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"color:#fff\"></md-icon>Send E-KYC Link</md-button></div><div ng-if=\"vm.editEnable == true\"><md-button \nclass=\"md-raised md-accent\" ui-sref=\"app.customers.customerhome.customerEdit({id:vm.customerDetail._id})\" \nstyle=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Edit Customer</md-button>\n</div><div><md-button class=\"md-raised md-accent\" ng-click=\"vm.syncInvestorIIN()\" style=\"color:#fff !important\">\n<md-icon md-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Sync UCC</md-button></div><div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.kycStatusUpdate()\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Update KYC Status</md-button></div><div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.showDetails()\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Reassign</md-button></div><div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.resetPassLink()\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Reset Password</md-button></div></div><div \nlayout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">\nCustomer Detail ({{vm.customerDetail.custID}})</h4><span ng-if=\"vm.editEnable == true\" style=\"color:transparent\">\n&nbsp;&nbsp; {{vm.customerDetail.password}}</span></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nUCC : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{(vm.customerDetail.mobileNo) ? (vm.customerDetail.mobileNo):\'NA\'}}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>UCC Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"!vm.customerDetail.nseData.ACTIVATION_STATUS\" style=\"color:orange; font-size:12px\">NA</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" style=\"color:red; font-size:12px\">NO</span> <a href=\"\" \nng-click=\"vm.openIinStatusDialog($event)\" style=\"margin-left: 10px; color: blue\">Update</a> </span><span>\nKYC Status : &nbsp;&nbsp; <span style=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\'  || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">NSE Detail</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex ng-if=\"vm.userDetail.nseData\"><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nCustomer ID: &nbsp;&nbsp;{{vm.userDetail.nseData.CUSTOMER_ID ? vm.userDetail.nseData.CUSTOMER_ID : \'NA\'}}</span> <span>\nDate Of Birth: &nbsp;&nbsp; {{vm.userDetail.nseData.DATE_OF_BIRTH ? vm.userDetail.nseData.DATE_OF_BIRTH : \'NA\'}}</span>\n <span>KYC Status:&nbsp;&nbsp;{{vm.userDetail.nseData.KYC_STATUS ? vm.userDetail.nseData.KYC_STATUS : \'-\'}} </span>\n<span>Address: &nbsp;&nbsp;{{vm.userDetail.nseData.ADDRESS1 ? vm.userDetail.nseData.ADDRESS1 : \'NA\'}}</span> <span>\nMobile:&nbsp;&nbsp;{{vm.userDetail.nseData.MOBILE_NO ? vm.userDetail.nseData.MOBILE_NO : \'NA\'}}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nInvestor Name: &nbsp;&nbsp; {{vm.userDetail.nseData.INVESTOR_NAME ? vm.userDetail.nseData.INVESTOR_NAME : \'NA\'}}</span>\n <span>\nHolding Nature: &nbsp;&nbsp; {{vm.userDetail.nseData.HOLD_NATURE_DESC ? vm.userDetail.nseData.HOLD_NATURE_DESC : \'NA\'}}\n</span> <span>\nOccupation: &nbsp;&nbsp; {{vm.userDetail.nseData.OCCUPATION_DESC ? vm.userDetail.nseData.OCCUPATION_DESC : \'NA\'}}\n</span> <span>City: &nbsp;&nbsp; {{vm.userDetail.nseData.CITY ? vm.userDetail.nseData.CITY : \'NA\'}}</span> <span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseData.EMAIL ? vm.userDetail.nseData.EMAIL : \'NA\'}}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPAN No: &nbsp;&nbsp; {{vm.userDetail.nseData.FH_PAN_NO ? vm.userDetail.nseData.FH_PAN_NO : \'NA\'}}</span> <span>\nTax Status: &nbsp;&nbsp; {{vm.userDetail.nseData.TAX_STATUS_DESC ? vm.userDetail.nseData.TAX_STATUS_DESC : \'NA\'}}\n</span> <span>\nIncome Range: &nbsp;&nbsp; {{vm.userDetail.grossAnnualIncome ? vm.incomeRange[vm.userDetail.grossAnnualIncome] : \'NA\'}}\n</span> <span>State:&nbsp;&nbsp; {{vm.userDetail.nseData.STATE_NAME ? vm.userDetail.nseData.STATE_NAME : \'NA\'}} </span>\n<span>\nPolitically Exposed Person:&nbsp;&nbsp;{{vm.userDetail.politicallyExposedPerson ? vm.userDetail.politicallyExposedPerson : \'NA\'}}\n</span></div></div><div layout-align=\"space-around center\" flex ng-if=\"vm.userDetail.nseData == undefined\"><div \nlayout=\"column\" layout-align=\"space-around start\" layout-padding><span>No Record Avaliable</span></div></div>\n</md-content></div><div class=\"article padding-top-10\" ng-if=\"vm.userDetail.nseRevampData || vm.userDetail.nseData\">\n<md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Nominee Detail</h4></div><div ng-if=\"vm.userDetail.nseRevampData\"><div \nng-if=\"vm.userDetail.nseRevampData.nominee_1_name\"><div layout=\"row\"><span class=\"title margin-left-30\" \nstyle=\"color: #2e00fc; margin-bottom:-10px; margin-top:10px\">Nominee 1</span></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" \nlayout-padding><span class=\"title\">Nominee Name:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_1_name || \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_1_email || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPhone:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_1_mobile || \'NA\'}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" \nlayout-padding><span>Relation:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_1_relationship || \'NA\'}}</span></div>\n<div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\n{{vm.userDetail.nseRevampData.nominee_1_identity_type}}:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_1_id_number || \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nAllocation:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee1_applicable || \'NA\'}}%</span></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></div><div \nng-if=\"vm.userDetail.nseRevampData.nominee_2_name && vm.userDetail.nseRevampData.nominee_2_name.trim()\"><div \nlayout=\"row\"><span class=\"title margin-left-30\" style=\"color: #2e00fc; margin-bottom:-10px; margin-top:10px\">Nominee 2\n</span></div><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nNominee Name:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_2_name || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_2_email || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPhone:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_2_mobile || \'NA\'}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" \nlayout-padding><span>Relation:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_2_relationship || \'NA\'}}</span></div>\n<div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\n{{vm.userDetail.nseRevampData.nominee_2_identity_type}}:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_2_id_number || \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nAllocation:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee2_applicable || \'NA\'}}%</span></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></div><div \nng-if=\"vm.userDetail.nseRevampData.nominee_3_name && vm.userDetail.nseRevampData.nominee_3_name.trim()\"><div \nlayout=\"row\"><span class=\"title margin-left-30\" style=\"color: #2e00fc; margin-bottom:-10px; margin-top:10px\">Nominee 3\n</span></div><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nNominee Name:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_3_name || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_3_email || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPhone:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_3_mobile || \'NA\'}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" \nlayout-padding><span>Relation:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_3_relationship || \'NA\'}}</span></div>\n<div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\n{{vm.userDetail.nseRevampData.nominee_3_identity_type}}:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee_3_id_number || \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nAllocation:&nbsp;&nbsp;{{vm.userDetail.nseRevampData.nominee3_applicable || \'NA\'}}%</span></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></div><div ng-if=\"!vm.userDetail.nseRevampData.nominee_1_name\"><div \nlayout=\"column\" layout-align=\"space-around start\" layout-padding><span>No Nominee Record Available</span></div></div>\n</div><div ng-if=\"!vm.userDetail.nseRevampData && vm.userDetail.nseData\"><div ng-if=\"vm.userDetail.nseData.NOM1_NAME\" \nclass=\"nominee-card\"><div layout=\"row\"><span class=\"title margin-left-30\" \nstyle=\"color: #2e00fc; margin-bottom:-10px; margin-top:10px\">Nominee 1</span></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" \nlayout-padding><span class=\"title\">Nominee Name:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_NAME || \'NA\'}}</span> <span>\nRelation:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_RELATION || \'NA\'}}</span> <span>\nAllocation %:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_PERCENTAGE ? vm.userDetail.nseData.NOM1_PERCENTAGE + \'%\' : \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_EMAIL || \'NA\'}}</span> <span>\nPhone:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_PHONE || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPAN:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_PAN || \'NA\'}}</span> <span>\nAadhaar:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_AADHAAR || \'NA\'}}</span></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></div><div \nng-if=\"vm.userDetail.nseData.NOM2_NAME && vm.userDetail.nseData.NOM2_NAME.length\" class=\"nominee-card\"><div \nlayout=\"row\"><span class=\"title margin-left-30\" style=\"color: #2e00fc; margin-bottom:-10px; margin-top:10px\">Nominee 2\n</span></div><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nNominee Name:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_NAME || \'NA\'}}</span> <span>\nRelation:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_RELATION || \'NA\'}}</span> <span>\nAllocation %:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_PERCENTAGE ? vm.userDetail.nseData.NOM2_PERCENTAGE + \'%\' : \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_EMAIL || \'NA\'}}</span> <span>\nPhone:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_PHONE || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPAN:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_PAN || \'NA\'}}</span> <span>\nAadhaar:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_AADHAAR || \'NA\'}}</span></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></div><div \nng-if=\"vm.userDetail.nseData.NOM3_NAME && vm.userDetail.nseData.NOM3_NAME.length\" class=\"nominee-card\"><div \nlayout=\"row\"><span class=\"title margin-left-30\" style=\"color: #2e00fc; margin-bottom:-10px; margin-top:10px\">Nominee 3\n</span></div><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nNominee Name:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_NAME || \'NA\'}}</span> <span>\nRelation:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_RELATION || \'NA\'}}</span> <span>\nAllocation %:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_PERCENTAGE ? vm.userDetail.nseData.NOM3_PERCENTAGE + \'%\' : \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_EMAIL || \'NA\'}}</span> <span>\nPhone:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_PHONE || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPAN:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_PAN || \'NA\'}}</span> <span>\nAadhaar:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_AADHAAR || \'NA\'}}</span></div></div><md-divider \nclass=\"md-default-theme\"></md-divider></div><div ng-if=\"!vm.userDetail.nseData.NOM1_NAME\"><div layout=\"column\" \nlayout-align=\"space-around start\" layout-padding><span>No Nominee Record Available</span></div></div></div><div \nng-if=\"!vm.userDetail.nseRevampData && !vm.userDetail.nseData\"><div layout=\"column\" layout-align=\"space-around start\" \nlayout-padding><span>No Nominee Record Available</span></div></div></md-content></div><div \nclass=\"article padding-top-10\" ng-if=\"vm.Bank != undefined && vm.Bank != null && vm.Bank != \'\'\"><md-content><div \nlayout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">Bank Detail\n</h4></div><div ng-repeat=\"bank in vm.Bank\"><div layout=\"row\"><span class=\"title margin-left-30\" \nstyle=\"color: #2e00fc; margin-bottom:-10px; margin-top:10px\" ng-if=\"bank.DEFAULT_BANK == \'Y\'\">&nbsp;(Default Account)\n</span></div><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nBank Name:&nbsp;&nbsp; {{bank.BANK_NAME || \'NA\'}}</span> <span>Branch Name:&nbsp;&nbsp; {{bank.BRANCH_NAME || \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nAccount No:&nbsp;&nbsp; {{bank.AC_NO || \'NA\'}}</span> <span>IFSC Code:&nbsp;&nbsp; {{bank.IFSC_CODE || \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nAccount Type:&nbsp;&nbsp; {{bank.AC_TYPE || \'NA\'}}</span> <span class=\"title\">\nBank Address:&nbsp;&nbsp; {{bank.BRANCH_ADDRESS1 || \'NA\'}} {{bank.BRANCH_CITY}} {{bank.BRANCH_PINCODE}} {{bank.BRANCH_COUNTRY}}\n</span></div></div><md-divider class=\"md-default-theme\"></md-divider></div></md-content></div><div \nclass=\"article padding-top-10\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 \nclass=\"margin-left-30\" style=\"margin-bottom:-10px\">Fatca Detail</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" \nlayout-padding><span class=\"title\">\nAadhaar Number:&nbsp;&nbsp; {{vm.userDetail.aadhaarCardNo ? vm.userDetail.aadhaarCardNo : \'NA\'}} </span><span>\nGross Annual Income Range: &nbsp;&nbsp; {{vm.userDetail.grossAnnualIncome ? vm.incomeRange[vm.userDetail.grossAnnualIncome] : \'NA\'}}\n</span> <span>\nPlace Of Birth:&nbsp;&nbsp;{{vm.userDetail.placeOfBirth ? vm.placeOfBirth[vm.userDetail.placeOfBirth] : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nAddress:&nbsp;&nbsp;{{vm.userDetail.addressType ? vm.residenceType[vm.userDetail.addressType] : \'NA\'}} </span><span>\nNet Worth Date:&nbsp;&nbsp;{{vm.userDetail.netWorthDate ? vm.userDetail.netWorthDate : \'NA\'}} </span><span>\nPolitically Exposed Person:&nbsp;&nbsp;{{vm.userDetail.politicallyExposedPerson ? vm.userDetail.politicallyExposedPerson : \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nCountry Of Birth:&nbsp;&nbsp;{{vm.userDetail.countryOfBirth ? vm.userDetail.countryOfBirth : \'NA\'}}</span> <span>\nNet WorthINR:&nbsp;&nbsp;{{vm.userDetail.netWorthINR ? vm.userDetail.netWorthINR : \'NA\'}}</span> <span>\nTax Residency:&nbsp;&nbsp;{{vm.userDetail.taxResidency ? vm.userDetail.taxResidency : \'NA\'}}</span></div></div>\n</md-content></div></div></div></div>");
$templateCache.put("app/main/customers/userDetail1.html","<div class=\"scrollable\" ms-scroll fix-head><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div ng-if=\"vm.editEnable == true\" layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-raised md-accent\" ui-sref=\"app.customers.customerhome.customerEdit({id:vm.customerDetail._id})\" \nstyle=\"float:right; color:#fff !important\"><md-icon md-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>Edit Customer\n</md-button></div><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{(vm.customerDetail.mobileNo) ? (vm.customerDetail.mobileNo):\'NA\'}}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">NSE Detail</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex ng-if=\"vm.userDetail.nseData\"><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nCustomer ID: &nbsp;&nbsp;{{vm.userDetail.nseData.CUSTOMER_ID ? vm.userDetail.nseData.CUSTOMER_ID : \'NA\'}}</span> <span>\nDate Of Birth: &nbsp;&nbsp; {{vm.userDetail.nseData.DATE_OF_BIRTH ? vm.userDetail.nseData.DATE_OF_BIRTH : \'NA\'}}</span>\n <span>KYC Status:&nbsp;&nbsp;{{vm.userDetail.nseData.KYC_STATUS ? vm.userDetail.nseData.KYC_STATUS : \'-\'}} </span>\n<span>Address: &nbsp;&nbsp;{{vm.userDetail.nseData.ADDRESS1 ? vm.userDetail.nseData.ADDRESS1 : \'NA\'}}</span> <span>\nMobile:&nbsp;&nbsp;{{vm.userDetail.nseData.MOBILE_NO ? vm.userDetail.nseData.MOBILE_NO : \'NA\'}} </span><span>\nBank Name:&nbsp;&nbsp;{{vm.userDetail.nseData.BANK_NAME ? vm.userDetail.nseData.BANK_NAME : \'NA\'}} </span><span>\nIFSC Code:&nbsp;&nbsp; {{vm.userDetail.nseData.IFSC_CODE ? vm.userDetail.nseData.IFSC_CODE : \'NA\'}}</span> <span>\nNominee Name 1:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_NAME ? vm.userDetail.nseData.NOM1_NAME : \'NA\'}}</span> <span \nng-if=\"vm.userDetail.nseData.NOM2_NAME.length\">\nNominee Name 2:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_NAME ? vm.userDetail.nseData.NOM2_NAME : \'NA\'}}</span> <span \nng-if=\"vm.userDetail.nseData.NOM3_NAME.length\">\nNominee Name 3:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_NAME ? vm.userDetail.nseData.NOM3_NAME : \'NA\'}}</span></div>\n<div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nInvestor Name: &nbsp;&nbsp; {{vm.userDetail.nseData.INVESTOR_NAME ? vm.userDetail.nseData.INVESTOR_NAME : \'NA\'}}</span>\n <span>\nHolding Nature: &nbsp;&nbsp; {{vm.userDetail.nseData.HOLD_NATURE_DESC ? vm.userDetail.nseData.HOLD_NATURE_DESC : \'NA\'}}\n</span> <span>\nOccupation: &nbsp;&nbsp; {{vm.userDetail.nseData.OCCUPATION_DESC ? vm.userDetail.nseData.OCCUPATION_DESC : \'NA\'}}\n</span> <span>City: &nbsp;&nbsp; {{vm.userDetail.nseData.CITY ? vm.userDetail.nseData.CITY : \'NA\'}}</span> <span>\nEmail:&nbsp;&nbsp;{{vm.userDetail.nseData.EMAIL ? vm.userDetail.nseData.EMAIL : \'NA\'}} </span><span>\nBank Address:&nbsp;&nbsp; {{vm.userDetail.nseData.BRANCH_ADDRESS1 ? vm.userDetail.nseData.BRANCH_ADDRESS1 : \'NA\'}}\n</span> <span>Bank Account:&nbsp;&nbsp;{{vm.userDetail.nseData.AC_NO ? vm.userDetail.nseData.AC_NO : \'NA\'}} </span>\n<span>\nNominee Relation 1:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_RELATION ? vm.userDetail.nseData.NOM1_RELATION : \'NA\'}}\n</span> <span ng-if=\"vm.userDetail.nseData.NOM2_NAME.length\">\nNominee Relation 2:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_RELATION ? vm.userDetail.nseData.NOM2_RELATION : \'NA\'}}\n</span> <span ng-if=\"vm.userDetail.nseData.NOM3_NAME.length\">\nNominee Relation 3:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_RELATION ? vm.userDetail.nseData.NOM3_RELATION : \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nPAN No: &nbsp;&nbsp; {{vm.userDetail.nseData.FH_PAN_NO ? vm.userDetail.nseData.FH_PAN_NO : \'NA\'}}</span> <span>\nTax Status: &nbsp;&nbsp; {{vm.userDetail.nseData.TAX_STATUS_DESC ? vm.userDetail.nseData.TAX_STATUS_DESC : \'NA\'}}\n</span> <span>\nIncome Range: &nbsp;&nbsp; {{vm.userDetail.grossAnnualIncome ? vm.incomeRange[vm.userDetail.grossAnnualIncome] : \'NA\'}}\n</span> <span>State:&nbsp;&nbsp; {{vm.userDetail.nseData.STATE_NAME ? vm.userDetail.nseData.STATE_NAME : \'NA\'}} </span>\n<span>\nPolitically Exposed Person:&nbsp;&nbsp;{{vm.userDetail.politicallyExposedPerson ? vm.userDetail.politicallyExposedPerson : \'NA\'}}\n</span> <span>\nBranch Name:&nbsp;&nbsp;{{vm.userDetail.nseData.BRANCH_ADDRESS1 ? vm.userDetail.nseData.BRANCH_ADDRESS1 : \'NA\'}} \n</span><span>\nAccount Type:&nbsp;&nbsp;{{vm.userDetail.nseData.AC_TYPE ? vm.accountType[vm.userDetail.nseData.AC_TYPE] : \'NA\'}} \n</span><span>\nNominee Percentage 1:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM1_PERCENTAGE ? vm.userDetail.nseData.NOM1_PERCENTAGE + \'%\' : \'NA\'}}\n</span> <span ng-if=\"vm.userDetail.nseData.NOM2_NAME.length\">\nNominee Percentage 2:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM2_PERCENTAGE ? vm.userDetail.nseData.NOM2_PERCENTAGE + \'%\' : \'NA\'}}\n</span> <span ng-if=\"vm.userDetail.nseData.NOM3_NAME.length\">\nNominee Percentage 3:&nbsp;&nbsp;{{vm.userDetail.nseData.NOM3_PERCENTAGE ? vm.userDetail.nseData.NOM3_PERCENTAGE + \'%\' : \'NA\'}}\n</span></div></div><div layout-align=\"space-around center\" flex ng-if=\"vm.userDetail.nseData == undefined\"><div \nlayout=\"column\" layout-align=\"space-around start\" layout-padding><span>No Record Avaliable</span></div></div>\n</md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">Fatca Detail</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" \nlayout-padding><span class=\"title\">\nAadhaar Number:&nbsp;&nbsp; {{vm.userDetail.aadhaarCardNo ? vm.userDetail.aadhaarCardNo : \'NA\'}} </span><span>\nGross Annual Income Range: &nbsp;&nbsp; {{vm.userDetail.grossAnnualIncome ? vm.incomeRange[vm.userDetail.grossAnnualIncome] : \'NA\'}}\n</span> <span>\nPlace Of Birth:&nbsp;&nbsp;{{vm.userDetail.placeOfBirth ? vm.placeOfBirth[vm.userDetail.placeOfBirth] : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nAddress:&nbsp;&nbsp;{{vm.userDetail.addressType ? vm.residenceType[vm.userDetail.addressType] : \'NA\'}} </span><span>\nNet Worth Date:&nbsp;&nbsp;{{vm.userDetail.netWorthDate ? vm.userDetail.netWorthDate : \'NA\'}} </span><span>\nPolitically Exposed Person:&nbsp;&nbsp;{{vm.userDetail.politicallyExposedPerson ? vm.userDetail.politicallyExposedPerson : \'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nCountry Of Birth:&nbsp;&nbsp;{{vm.userDetail.countryOfBirth ? vm.userDetail.countryOfBirth : \'NA\'}}</span> <span>\nNet WorthINR:&nbsp;&nbsp;{{vm.userDetail.netWorthINR ? vm.userDetail.netWorthINR : \'NA\'}}</span> <span>\nTax Residency:&nbsp;&nbsp;{{vm.userDetail.taxResidency ? vm.userDetail.taxResidency : \'NA\'}}</span></div></div>\n</md-content></div></div></div></div>");
$templateCache.put("app/main/customers-sales/customers-sales.html","<div id=\"salesCustomer\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nSales Customers</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" \nstyle=\"height: 51px !important;margin-top: -18px !important\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.toggleCalender()\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon>Call Calender</md-button></div>\n</div><div class=\"headerFixAllPages\"><md-sidenav class=\"md-sidenav-right\" md-component-id=\"rightHistory\" \nmd-disable-backdrop md-whiteframe=\"4\" style=\"max-width:800px;width:800px\"><md-toolbar class=\"md-accent height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">\nCall History of {{vm.callHistory.userName}}</h1><div layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-raised md-primary md-button md-default-theme\" ng-click=\"downloadCallHistory(vm.callHistory.callSchedules)\" \nstyle=\"color:#fff !important\"><md-icon md-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>\nDownload Call History</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.openHistorySidenav(\'rightHistory\')\" \naria-label=\"More\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content \nlayout-margin><div class=\"simple-table-container\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Calling Date\n</th><th>Comment</th><th>Next Date</th><th>Called By</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"call in vm.callHistory.callSchedules\"><td class=\"name\">\n{{call.atDate | date:\'mediumDate\'}} at {{call.atHour > 12 ? (call.atHour - 12):call.atHour }}:{{call.atMinute }} {{call.atHour > 11 ? \'PM\':\'AM\'}}\n</td><td class=\"position\">{{call.comments}}</td><td class=\"office\">\n{{call.nextAtDate | date:\'mediumDate\'}} at {{call.nextAtHour > 12 ? (call.nextAtHour - 12):call.nextAtHour }}:{{call.nextAtMinute }} {{call.nextAtHour > 11 ? \'PM\':\'AM\'}}\n</td><td class=\"office\">{{call.createdBy.userName}}</td></tr></tbody></table></div></md-content></md-sidenav>\n<md-sidenav class=\"md-sidenav-right\" md-component-id=\"right\" md-whiteframe=\"4\" style=\"max-width:800px;width:800px\">\n<md-toolbar class=\"md-accent height-60\"><h1 class=\"md-toolbar-tools\">Call Calender</h1></md-toolbar><md-content \nlayout-margin><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.prev()\" aria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n<div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" \ncalendar=\"main\"></div></div></md-content></md-sidenav><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"closeEventsDisabled\" md-whiteframe=\"4\" md-disable-backdrop><md-toolbar class=\"md-accent height-60\"><h1\n class=\"md-toolbar-tools\">{{vm.activeUser.userName}}</h1></md-toolbar><md-content layout-margin><form name=\"myForm\">\n<h4>Called At</h4><div flex><md-datepicker ng-model=\"vm.callingDetail.atDate\" md-placeholder=\"Enter date\" required>\n</md-datepicker></div><div><h5>Time</h5><div layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" flex=\"48\">\n<md-icon md-font-icon=\"icon-minus\" class=\"iconSize border\" ng-click=\"vm.changeHour(\'hour\',\'minus\')\"></md-icon><input \ntype=\"text\" ng-model=\"vm.callingDetail.atHour\" class=\"border\" ng-change=\"vm.changeDetect(\'hour\')\" \nstyle=\"max-width:35px;width:30px;height:30px;text-align:center\" required><md-icon md-font-icon=\"icon-plus\" \nclass=\"iconSize border\" ng-click=\"vm.changeHour(\'hour\',\'plus\')\"></md-icon></div><span class=\"timeDot\">:</span><div \nlayout=\"row\" flex=\"48\"><md-icon md-font-icon=\"icon-minus\" class=\"iconSize border\" \nng-click=\"vm.changeHour(\'minute\',\'minus\')\"></md-icon><input type=\"text\" ng-model=\"vm.callingDetail.atMinute\" \nng-change=\"vm.changeDetect(\'minute\')\" class=\"border\" style=\"max-width:35px;width:30px;height:30px;text-align:center\" \nrequired><md-icon md-font-icon=\"icon-plus\" class=\"iconSize border\" ng-click=\"vm.changeHour(\'minute\',\'plus\')\"></md-icon>\n</div><div flex=\"50\"></div></div></div><md-checkbox ng-model=\"vm.notInterested\" aria-label=\"Checkbox 1\" class=\"mt-40\">\nNot Interested</md-checkbox><md-input-container class=\"md-block\" style=\"margin-top:30px !important\"><label>Comments\n</label><md-select name=\"reason\" ng-model=\"vm.callingDetail.comments\" required><md-option \nng-repeat=\"reason in vm.commentStrings\" ng-value=\"reason\">{{reason}}</md-option></md-select><div class=\"errors\" \nng-messages=\"myForm.reason.$error\"><div ng-message=\"required\">Required</div></div></md-input-container>\n<md-input-container ng-if=\"vm.callingDetail.comments === \'Other\'\" class=\"md-block\" style=\"margin-top:30px !important\">\n<label>Other Comments</label><input type=\"text\" name=\"other\" ng-model=\"vm.callingDetail.other\" \nng-required=\"vm.callingDetail.comments === \'Other\'\"><div class=\"errors\" ng-messages=\"myForm.other.$error\"><div \nng-message=\"required\">Required</div></div></md-input-container><h4>Next Call</h4><div flex><md-datepicker \nng-model=\"vm.callingDetail.nextAtDate\" md-placeholder=\"Enter date\"></md-datepicker></div><div><h5>Time</h5><div \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\" flex=\"48\"><md-icon md-font-icon=\"icon-minus\" \nclass=\"iconSize border\" ng-click=\"vm.changeNextHour(\'hour\',\'minus\')\"></md-icon><input type=\"text\" \nng-model=\"vm.callingDetail.nextAtHour\" class=\"border\" ng-change=\"vm.changeNextDetect(\'hour\')\" \nstyle=\"max-width:35px;width:30px;height:30px;text-align:center\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"iconSize border\" ng-click=\"vm.changeNextHour(\'hour\',\'plus\')\"></md-icon></div><span class=\"timeDot\">:</span><div \nlayout=\"row\" flex=\"48\"><md-icon md-font-icon=\"icon-minus\" class=\"iconSize border\" \nng-click=\"vm.changeNextHour(\'minute\',\'minus\')\"></md-icon><input type=\"text\" ng-model=\"vm.callingDetail.nextAtMinute\" \nng-change=\"vm.changeNextDetect(\'minute\')\" class=\"border\" \nstyle=\"max-width:35px;width:30px;height:30px;text-align:center\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"iconSize border\" ng-click=\"vm.changeNextHour(\'minute\',\'plus\')\"></md-icon></div><div flex=\"50\"></div></div></div>\n</form><md-button ng-click=\"vm.createCall()\" ng-disabled=\"myForm.$invalid\" class=\"md-raised md-primary\">Submit\n</md-button><md-button ng-click=\"vm.toggleSidenav()\" class=\"md-raised md-primary\">Cancel</md-button></md-content>\n</md-sidenav><md-content layout-padding><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nclass=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\" ng-class=\"{\'active\':vm.filterType === \'All\'}\" ng-click=\"vm.selectedFilter(\'All\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.countData.userCount}}</div><div class=\"font-weight-500 secondary-text\">Customers</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front\n class=\"p-16 white-bg\" layout=\"row\" ng-class=\"{\'active\':vm.filterType === \'TodayCall\'}\" \nng-click=\"vm.selectedFilter(\'TodayCall\')\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" \nflex><div class=\"md-display-1 pb-8\">{{vm.countData.todayCallCount}}</div><div class=\"font-weight-500 secondary-text\">\nCall Due Today</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" \nng-class=\"{\'active\':vm.filterType === \'Reassign\'}\" ng-click=\"vm.selectedFilter(\'Reassign\')\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">\n{{vm.countData.reassignedCount}}</div><div class=\"font-weight-500 secondary-text\">Reassigned</div></div>\n</ms-widget-front></ms-widget></div><md-nav-bar md-no-ink-bar=\"disableInkBar\" md-selected-nav-item=\"vm.currentNavItem\" \nnav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"vm.filterData(\'ALL\')\" name=\"ALL\">ALL</md-nav-item>\n<md-nav-item md-nav-click=\"vm.filterData(\'PARTIAL\')\" name=\"PARTIAL\">Partial Document</md-nav-item><md-nav-item \nmd-nav-click=\"vm.filterData(\'PENDING\')\" name=\"PENDING\">Pending Document</md-nav-item><md-nav-item \nmd-nav-click=\"vm.filterData(\'NOCALL\')\" name=\"NOCALL\">Not Called Yet</md-nav-item><md-nav-item \nmd-nav-click=\"vm.filterData(\'NOCALLSchedule\')\" name=\"NOCALLSchedule\">Call Not Scheduled</md-nav-item><md-nav-item \nmd-nav-click=\"vm.filterData(\'TODAY\')\" name=\"TODAY\">Scheduled Call Today</md-nav-item><md-nav-item \nmd-nav-click=\"vm.clearCalendarFilter(\'Call\')\" ng-show=\"vm.calendarText\" name=\"Call\">{{vm.calendarText}}</md-nav-item>\n</md-nav-bar><md-virtual-repeat-container id=\"fixed\"><div class=\"border md-whiteframe-4dp white-bg\" \nmd-virtual-repeat=\"user in vm.filteredCustomer | filter:search\" layout=\"row\" layout-padding><div flex=\"30\"><div \nlayout=\"row\"><span flex=\"50\" style=\"text-transform: capitalize;font-size:16px\">{{user.userName || \'NA\'}}</span></div>\n<div layout=\"row\"><span flex=\"50\" style=\"text-transform: capitalize;font-size:12px\">{{user.email}}</span></div><h6 \nstyle=\"font-size: 16px\">{{user.mobileNo}} <span class=\"verified\" ng-if=\"user.mobileVerifiedFlag\">(Verified)</span> \n<span class=\"notVerified\" ng-if=\"!user.mobileVerifiedFlag\">(Not Verified)</span></h6><h6 \nng-if=\"!user.nseData.ADDRESS1\">{{user.referenceInfo.address}}<br>\n{{user.referenceInfo.city}} ,{{user.referenceInfo.state}}<br>INDIA - {{user.referenceInfo.pincode}}<br><span \nclass=\"notVerified\">(Not Verified)</span></h6><h6 ng-if=\"user.nseData.ADDRESS1\">\n{{user.nseData.ADDRESS1}}, {{user.nseData.ADDRESS2}}, {{user.nseData.ADDRESS3}}<br>\n{{user.nseData.CITY}},{{user.nseData.STATE_NAME}}<br>INDIA - {{user.nseData.PINCODE}}<br><span class=\"verified\">\n(Verified)</span></h6><h6>Document Status: <span \nng-class=\"{\'pending\':user.documentUploadStatus === \'PENDING\',\'partial\':user.documentUploadStatus === \'PARTIAL\',\'complete\':user.documentUploadStatus === \'COMPLETE\',\'verified\':user.documentUploadStatus === \'VERIFIED\'}\">\n{{user.documentUploadStatus || \'NA\'}}</span></h6><a \nui-sref=\"app.assignmentDashboard.documentVerification({userId:user._id})\">Go To Document</a></div><div layout=\"column\" \nflex=\"30\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\"><md-icon md-font-icon=\"icon-phone-in-talk\" \nclass=\"s36\" ng-click=\"vm.toggleSidenav()\"></md-icon><div layout=\"column\"><a ng-click=\"vm.openSidenav(user,\'last\')\" \nhref=\"\" style=\"color:rgba(0,0,0,.87)\">Last Call : <span ng-if=\"!user.callSchedule.atDate\">Not Done</span> <span \nng-if=\"user.callSchedule.atDate\">\n{{user.callSchedule.atDate | date:\'mediumDate\'}} {{user.callSchedule.atHour > 12 ? (user.callSchedule.atHour - 12):user.callSchedule.atHour }}:{{user.callSchedule.atMinute }} {{user.callSchedule.atHour > 11 ? \'PM\':\'AM\'}} \n</span></a><span>Next Call : <span ng-if=\"!user.callSchedule.nextAtDate\">Not Schedule</span> <span \nng-if=\"user.callSchedule.nextAtDate\">\n{{user.callSchedule.nextAtDate | date:\'mediumDate\'}} {{user.callSchedule.nextAtHour > 12 ? (user.callSchedule.nextAtHour - 12):user.callSchedule.nextAtHour }}:{{user.callSchedule.nextAtMinute }} {{user.callSchedule.nextAtHour > 11 ? \'PM\':\'AM\'}}\n</span></span></div></div></div><div layout=\"row\" layout-align=\"start\"><a ng-click=\"vm.openSidenav(user,\'new\')\" \nhref=\"\" flex=\"50\">Record Call</a><a ng-click=\"vm.openHistorySidenav(\'rightHistory\',user)\" href=\"\" \nng-if=\"user.callSchedules.length > 0\" flex=\"50\">Call History</a></div></div><div layouit=\"column\" flex=\"40\"><div \nid=\"timeline1\" layout=\"row\" flex><md-icon md-font-icon=\"icon-cellphone-android\" \nng-class=\"{\'success\':user.signUpSteps > 0}\"><md-tooltip md-direction=\"bottom\">Mobile <span ng-show=\"!user.signUpSteps\">\nnot</span> Verified</md-tooltip></md-icon><div flex=\"10\" class=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=1}\">\n</div><md-icon md-font-icon=\"icon-account-check\" ng-class=\"{\'success\':user.signUpSteps >1 }\"><md-tooltip \nmd-direction=\"bottom\">Account <span ng-show=\"(!user.signUpSteps || user.signUpSteps < 2)\">not</span> created.\n</md-tooltip></md-icon><div flex=\"10\" class=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=2}\"></div><md-icon \nmd-font-icon=\"icon-briefcase-checked\" ng-class=\"{\'success\':user.signUpSteps >2 }\"><md-tooltip md-direction=\"bottom\">\nPAN <span ng-show=\"(!user.signUpSteps || user.signUpSteps < 3)\">not</span> Verified</md-tooltip></md-icon><div \nflex=\"10\" class=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=3}\"></div><md-icon md-font-icon=\"icon-account-key\" \nng-class=\"{\'success\':user.signUpSteps >3 }\"><md-tooltip md-direction=\"bottom\">IIN <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 4)\">not</span> Created</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=4}\"></div><md-icon md-font-icon=\"icon-verified\" \nng-class=\"{\'success\':user.signUpSteps >4 }\"><md-tooltip md-direction=\"bottom\">Document <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 5)\">not</span> Verified</md-tooltip></md-icon><div flex=\"10\" \nclass=\"line\" ng-class=\"{\'lineborder\': user.signUpSteps >=5}\"></div><md-icon md-font-icon=\"icon-check-circle\" \nng-class=\"{\'success\':user.signUpSteps >5 }\"><md-tooltip md-direction=\"bottom\">IIN <span \nng-show=\"(!user.signUpSteps || user.signUpSteps < 6)\">not</span> Activated</md-tooltip></md-icon></div><div \nlayout=\"row\"><div flex=\"50\"><h6>IIN No.: {{user.iin || \'NA\'}}</h6><h6>PAN: {{user.pan || \'NA\'}}</h6><h6>\nKYC Status: {{vm.eKyc[user.camsKycStatus] || \'NA\'}}</h6><h5 class=\"texth4\" \nng-if=\"(user.achmandateRegFlag && !user.achmandateRegFlag)\"><md-icon md-font-icon=\"icon-alert\" class=\"warnIcon blink\">\n</md-icon>&nbsp;&nbsp;&nbsp;&nbsp;ACH Reg. Failed</h5><h5 class=\"texth4\" \nng-if=\"(user.fatcakycuboRegFlag && !user.fatcakycuboRegFlag)\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"warnIcon blink\"></md-icon>&nbsp;&nbsp;&nbsp;&nbsp;FATCA Reg. Failed</h5></div><div flex=\"50\"><h6>\nReferred By: {{user.referredBy.userName || \'None\'}}</h6><h6>Onboarded From: {{user.platform || \'NA\'}}</h6><h6>\nAssigned date: {{user.createdAt | date:\"dd/MM/yyyy \'at\' h:mma\"}}</h6></div></div><div layout=\"row\" \nstyle=\"margin-top: 20px\" layout-align=\"start\" flex><md-input-container flex><label for=\"\">Assign To</label><md-select \nng-model=\"user.assignedUser\" ng-change=\"vm.assignInternalUser(user)\" placeholder=\"{{vm.placeholder}}\"><md-option><em>\nNone</em></md-option><md-option ng-repeat=\"user in vm.allInternalUsers\" ng-value=\"user\">\n{{user.userName}} &nbsp;&nbsp;({{user.type}})</md-option></md-select></md-input-container></div></div></div>\n</md-virtual-repeat-container></md-content></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"dashboard\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Dashboard\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-nav-bar \nmd-selected-nav-item=\"vm.currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item \nmd-nav-click=\"vm.dashBoard(\'app.dashboard.details\')\" name=\"Details\">Details</md-nav-item><md-nav-item \nmd-nav-click=\"vm.dashBoard(\'app.dashboard.reports\')\" name=\"Reports\">Reports</md-nav-item><md-nav-item \nmd-nav-click=\"vm.dashBoard(\'app.dashboard.employee\')\" name=\"Employees_performance\">Employees Performance</md-nav-item>\n</md-nav-bar><div ui-view=\"itemdash\"></div></div></div>");
$templateCache.put("app/main/ifsc/ifsc-list.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>IFSC Code Upload</span></div></div><div \nng-if=\"vm.ifscList\" class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"Search IFSC Code\" flex></div><div layout=\"row\" layout-align=\"start center\" flex=\"10\">\n<md-button ng-click=\"vm.goBack()\" class=\"backArrowColor\" back-button layout=\"row\" layout-align=\"start center\" \nstyle=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span>\n</md-button></div></div><div class=\"ext-content\" ng-if=\"vm.ifscList\"><md-virtual-repeat-container ng-style=\"listStyle\" \nfix-head><table md-table><thead md-head fix-head><tr md-row><th md-column md-order-by=\"bankName\"><span>Bank Name</span>\n</th><th md-column md-order-by=\"ifscCode\"><span>IFSC Code</span></th><th md-column md-order-by=\"branch\"><span>Branch\n</span></th><th md-column md-order-by=\"address\"><span>Address</span></th><th md-column md-order-by=\"contact\"><span>\nContact Number</span></th><th md-column md-order-by=\"city\"><span>City</span></th></tr></thead><tbody md-body><tr \nmd-row md-select=\"customer\" md-virtual-repeat=\"ifsc in vm.ifscList | filter:{ifscCode:vm.search}\" \nstyle=\"cursor:pointer\"><td md-cell>{{ifsc.bankName}}</td><td md-cell>{{ifsc.ifscCode}}</td><td md-cell>{{ifsc.branch}}\n</td><td md-cell>{{ifsc.address}}</td><td md-cell>{{ifsc.contact}}</td><td md-cell>{{ifsc.city}}</td></tr></tbody>\n</table></md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/ifsc/ifsc.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"uploadTransaction\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nIFSC Code Upload</span></div></div><div ng-if=\"vm.ifscList\" class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex-60><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" \ntype=\"text\" ng-model=\"vm.search\" placeholder=\"Search IFSC Code\" flex></div></div><div id=\"transaction\" \nclass=\"headerFixAllPages\"><div flex=\"45\" layout=\"column\" layout-margin class=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex=\"50\"><h3>IFSC</h3><a style=\"cursor: pointer\" ng-click=\"vm.getIFSClist()\"><h4>Show IFSC List</h4>\n</a></div></div><div layout=\"row\" layout-align=\"start center\"><div><input type=\"file\" accept=\".csv\" \nstyle=\"cursor: pointer\" name=\"file\" id=\"camsFile\" onchange=\"angular.element(this).scope().checkfile(this,\'camsFile\')\">\n<label for=\"camsFile\">{{vm.camsFile}}</label></div><md-button class=\"md-accent md-raised\" ng-click=\"vm.uploadifsc()\">\nUpload</md-button></div></div></div></div>");
$templateCache.put("app/main/internalUser/internalUserList.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"userInternal\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"70\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nInternal User List</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" layout-align=\"start center\" flex=\"15\"><md-button \nclass=\"md-raised md-accent\" ui-sref=\"app.internalUser\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>Add New User</md-button></div></div><md-content><md-nav-bar md-selected-nav-item=\"vm.currentNavItem\" \nnav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"vm.internalUserCount(\'Activated_user\')\" \nname=\"Activated_user\">Activated User</md-nav-item><md-nav-item md-nav-click=\"vm.internalUserCount(\'Deactivated_user\')\" \nname=\"Deactivated_user\">Deactivated User</md-nav-item></md-nav-bar><div class=\"ext-content\">\n<md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" \nmd-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>S. No.</span></th><th \nmd-column><span>View</span></th><th md-column md-order-by=\"userName\"><span>Name</span></th><th md-column \nmd-order-by=\"mobileNo\"><span>Contact Number</span></th><th md-column md-order-by=\"email\"><span>Email Id</span></th><th \nmd-column md-order-by=\"type\"><span>Type</span></th><th md-column md-order-by=\"feature\"><span>Assign Feature</span></th>\n<th md-column><span>Action</span></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"internalUser in vm.internalUser | filter:search | orderBy: vm.query.order | limitTo:vm.query.limit\" \nstyle=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell><md-button aria-label=\"view Detail\" \nclass=\"md-icon-button\" ng-click=\"vm.viewUser(internalUser)\"><md-icon md-font-icon=\"icon-eye\" class=\"s24\"></md-icon>\n<md-tooltip md-direction=\"left\">User Detail</md-tooltip></md-button></td><td md-cell><span \nng-if=\"internalUser.nseData && internalUser.nseData.INVESTOR_NAME\">{{(internalUser.nseData.INVESTOR_NAME)}}</span> \n<span ng-if=\"!(internalUser.nseData && internalUser.nseData.INVESTOR_NAME)\">\n{{(internalUser.userName) ? (internalUser.userName) :\'NA\'}}</span></td><td md-cell>\n{{(internalUser.mobileNo) ? (internalUser.mobileNo):\'NA\'}}</td><td md-cell>\n{{(internalUser.email) ? (internalUser.email):\'NA\'}}</td><td md-cell>{{vm.typerename[internalUser.type]}}</td><td \nmd-cell><p ng-repeat=\"feature in internalUser.featuresData\">{{feature}}</p></td><td md-cell><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Edit\" \nng-click=\"vm.editUser(internalUser)\">Edit</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Activated\" \nng-click=\"vm.activated(internalUser)\"><span ng-if=\"internalUser.active== false\">Activated</span> <span \nng-if=\"internalUser.active== true\">Deactivated</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table></md-table-container></md-virtual-repeat-container></div></md-content></div>");
$templateCache.put("app/main/internalUserMapping/internalUserMapping.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"userInternalMapping\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"70\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nInternal User Mapping</span></div></div></div><div class=\"headerFixAllPages\"><div layout=\"row\" layout.xs=\"column\" \nlayout-align=\"space-around center\" flex=\"100\"><div flex=\"25\" flex.xs=\"100\"><md-card class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><h3>Step 1</h3><button mat-fab class=\"cherry-gradient\" \nng-click=\"vm.downloadsCsvFiles()\"><md-icon md-font-icon=\"icon-arrow-down-bold\" class=\"textWhite\"></md-icon>\nDownload CSV file</button></div></md-card></div><div flex=\"25\" flex.xs=\"100\"><md-card class=\"border-radius b-dash\"><div\n layout=\"column\" layout-align=\"center center\"><h3>Step 2</h3><div class=\"text\"><input type=\"file\" \nstyle=\"cursor: pointer\" accept=\".csv\" name=\"readCsvFile\" id=\"csvfile\"></div><button mat-fab class=\"cherry-gradient\" \nng-click=\"vm.uploadCsvFiles()\"><md-icon md-font-icon=\"icon-upload\" class=\"textWhite\"></md-icon>Upload CSV File</button>\n</div></md-card></div><div flex=\"25\" flex.xs=\"100\"></div><div flex=\"25\" flex.xs=\"100\"></div></div></div></div>");
$templateCache.put("app/main/insurance/insurance.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Customer Engagement Goal Chart</span>\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"backArrowColor\" ui-sref=\"app.goalchart\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon>\n<span>Back</span></md-button></div></div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div class=\"col-sm-12\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\"><br><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex><md-input-container \nflex=\"100\" flex-gt-xs=\"80\"><label>Goal</label><input type=\"text\" ng-model=\"vm.goal\" ng-disabled=\"vm.goalId\" \nname=\"goal\" tabindex=\"1\" required><div ng-messages=\"myForm.goal.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Goal is required</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"20\" ng-show=\"!vm.goalId\"><md-button class=\"md-raised md-accent\" tabindex=\"3\" ng-click=\"vm.saveGoalChart()\" \nstyle=\"color:#fff !important\">Save</md-button></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\" \nng-show=\"vm.goalId\"><md-button class=\"md-raised md-accent\" tabindex=\"3\" ng-click=\"vm.updateGoalChart()\" \nstyle=\"color:#fff !important\">Update</md-button></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-autocomplete flex=\"100\" flex-gt-xs=\"50\" tabindex=\"2\" \nmd-input-name=\"amc\" md-menu-class=\"autocomplete-custom-template\" md-autofocus placeholder=\"Category\" flex=\"100\" \nrequired md-floating-label=\"Category\" md-selected-item=\"vm.selectedItem\" \nmd-items=\"category in vm.getMatches(searchText)\" md-search-text=\"searchText\" md-item-text=\"category\"><md-item-template>\n<span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{category}}</span></md-item-template><md-not-found>\nNo Category matching \"{{searchText}}\" were found.</md-not-found><div ng-messages=\"wizardStep1.category.$error\" \nng-if=\"wizardStep1.category.$touched\"><div ng-message=\"required\">You <b>must</b> choose a category</div></div>\n</md-autocomplete><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Indicative</label><input type=\"text\" \nng-model=\"vm.indicative\" name=\"indicative\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y1</label>\n<input type=\"number\" ng-model=\"vm.y1\" name=\"y1\" tabindex=\"4\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y2</label><input type=\"number\" ng-model=\"vm.y2\" name=\"y2\" tabindex=\"5\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y3</label><input type=\"number\" ng-model=\"vm.y3\" name=\"y3\" \ntabindex=\"6\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y4</label><input type=\"number\" \nng-model=\"vm.y4\" name=\"y4\" tabindex=\"7\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y5\n</label><input type=\"number\" ng-model=\"vm.y5\" name=\"y5\" tabindex=\"8\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"10\"><label>Y6</label><input type=\"number\" ng-model=\"vm.y6\" name=\"y6\" tabindex=\"9\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y7</label><input type=\"number\" \nng-model=\"vm.y7\" name=\"y7\" tabindex=\"10\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y8\n</label><input type=\"number\" ng-model=\"vm.y8\" name=\"y8\" tabindex=\"11\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"10\"><label>Y9</label><input type=\"number\" ng-model=\"vm.y9\" name=\"y8\" tabindex=\"12\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y10</label><input type=\"number\" \nng-model=\"vm.y10\" name=\"y10\" tabindex=\"13\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y11</label>\n<input type=\"number\" ng-model=\"vm.y11\" name=\"y11\" tabindex=\"14\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y12</label><input type=\"number\" ng-model=\"vm.y12\" name=\"y12\" tabindex=\"15\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y13</label><input type=\"number\" ng-model=\"vm.y13\" name=\"y13\" \ntabindex=\"16\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y14</label><input \ntype=\"number\" ng-model=\"vm.y14\" name=\"y14\" tabindex=\"17\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y15</label><input type=\"number\" ng-model=\"vm.y15\" name=\"y15\" tabindex=\"18\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y16</label><input type=\"number\" ng-model=\"vm.y16\" name=\"y16\" \ntabindex=\"19\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y17</label><input \ntype=\"number\" ng-model=\"vm.y17\" name=\"y17\" tabindex=\"20\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y18</label><input type=\"number\" ng-model=\"vm.y18\" name=\"y18\" tabindex=\"21\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y19</label><input type=\"number\" ng-model=\"vm.y19\" name=\"y18\" \ntabindex=\"22\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y20</label><input \ntype=\"number\" ng-model=\"vm.y20\" name=\"y20\" tabindex=\"23\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y21</label>\n<input type=\"number\" ng-model=\"vm.y21\" name=\"y21\" tabindex=\"24\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y22</label><input type=\"number\" ng-model=\"vm.y22\" name=\"y22\" tabindex=\"25\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y23</label><input type=\"number\" ng-model=\"vm.y23\" name=\"y23\" \ntabindex=\"26\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y24</label><input \ntype=\"number\" ng-model=\"vm.y24\" name=\"y24\" tabindex=\"27\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y25</label><input type=\"number\" ng-model=\"vm.y25\" name=\"y25\" tabindex=\"28\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y26</label><input type=\"number\" ng-model=\"vm.y26\" name=\"y26\" \ntabindex=\"29\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y27</label><input \ntype=\"number\" ng-model=\"vm.y27\" name=\"y27\" tabindex=\"30\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y28</label><input type=\"number\" ng-model=\"vm.y28\" name=\"y28\" tabindex=\"31\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y29</label><input type=\"number\" ng-model=\"vm.y29\" name=\"y29\" \ntabindex=\"32\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y30</label><input \ntype=\"number\" ng-model=\"vm.y30\" name=\"y30\" tabindex=\"33\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y31</label>\n<input type=\"number\" ng-model=\"vm.y31\" name=\"y31\" tabindex=\"34\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y32</label><input type=\"number\" ng-model=\"vm.y32\" name=\"y32\" tabindex=\"35\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y33</label><input type=\"number\" ng-model=\"vm.y33\" name=\"y33\" \ntabindex=\"36\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y34</label><input \ntype=\"number\" ng-model=\"vm.y34\" name=\"y34\" tabindex=\"37\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y35</label><input type=\"number\" ng-model=\"vm.y35\" name=\"y35\" tabindex=\"38\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y36</label><input type=\"number\" ng-model=\"vm.y36\" name=\"y36\" \ntabindex=\"39\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y37</label><input \ntype=\"number\" ng-model=\"vm.y37\" name=\"y37\" tabindex=\"40\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y38</label><input type=\"number\" ng-model=\"vm.y38\" name=\"y38\" tabindex=\"41\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y39</label><input type=\"number\" ng-model=\"vm.y39\" name=\"y39\" \ntabindex=\"42\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y40</label><input \ntype=\"number\" ng-model=\"vm.y40\" name=\"y40\" tabindex=\"43\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y41</label>\n<input type=\"number\" ng-model=\"vm.y41\" name=\"y41\" tabindex=\"44\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y42</label><input type=\"number\" ng-model=\"vm.y42\" name=\"y42\" tabindex=\"45\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y43</label><input type=\"number\" ng-model=\"vm.y43\" name=\"y43\" \ntabindex=\"46\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y44</label><input \ntype=\"number\" ng-model=\"vm.y44\" name=\"y44\" tabindex=\"47\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y45</label><input type=\"number\" ng-model=\"vm.y45\" name=\"y45\" tabindex=\"48\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y46</label><input type=\"number\" ng-model=\"vm.y46\" name=\"y46\" \ntabindex=\"49\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y47</label><input \ntype=\"number\" ng-model=\"vm.y47\" name=\"y47\" tabindex=\"50\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"10\"><label>Y48</label><input type=\"number\" ng-model=\"vm.y48\" name=\"y48\" tabindex=\"51\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y49</label><input type=\"number\" ng-model=\"vm.y49\" name=\"y49\" \ntabindex=\"52\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"10\"><label>Y50</label><input \ntype=\"number\" ng-model=\"vm.y50\" name=\"y50\" tabindex=\"53\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"20\"><md-button \nclass=\"md-raised md-accent\" tabindex=\"3\" ng-click=\"vm.add()\" ng-disabled=\"vm.disableSubmit()\" \nstyle=\"color:#fff !important\">Add</md-button></md-input-container></div><hr><div layout=\"row\" style=\"overflow-x:auto\">\n<table id=\"customers\" class=\"table table-hover\"><tr><th style=\"width: 2%\" scope=\"col\">Sr No.</th><th \nstyle=\"width: 28%\" scope=\"col\">Goal</th><th style=\"width: 10%\" scope=\"col\">Category</th><th style=\"width: 1%\" \nscope=\"col\">Indicative</th><th style=\"width: 1%\" scope=\"col\">Y1</th><th style=\"width: 1%\" scope=\"col\">Y2</th><th \nstyle=\"width: 1%\" scope=\"col\">Y3</th><th style=\"width: 1%\" scope=\"col\">Y4</th><th style=\"width: 1%\" scope=\"col\">Y5</th>\n<th style=\"width: 1%\" scope=\"col\">Y6</th><th style=\"width: 1%\" scope=\"col\">Y7</th><th style=\"width: 1%\" scope=\"col\">Y8\n</th><th style=\"width: 1%\" scope=\"col\">Y9</th><th style=\"width: 1%\" scope=\"col\">Y10</th><th style=\"width: 1%\" \nscope=\"col\">Y11</th><th style=\"width: 1%\" scope=\"col\">Y12</th><th style=\"width: 1%\" scope=\"col\">Y13</th><th \nstyle=\"width: 1%\" scope=\"col\">Y14</th><th style=\"width: 1%\" scope=\"col\">Y15</th><th style=\"width: 1%\" scope=\"col\">Y16\n</th><th style=\"width: 1%\" scope=\"col\">Y17</th><th style=\"width: 1%\" scope=\"col\">Y18</th><th style=\"width: 1%\" \nscope=\"col\">Y19</th><th style=\"width: 1%\" scope=\"col\">Y20</th><th style=\"width: 1%\" scope=\"col\">Y21</th><th \nstyle=\"width: 1%\" scope=\"col\">Y22</th><th style=\"width: 1%\" scope=\"col\">Y23</th><th style=\"width: 1%\" scope=\"col\">Y24\n</th><th style=\"width: 1%\" scope=\"col\">Y25</th><th style=\"width: 1%\" scope=\"col\">Y26</th><th style=\"width: 1%\" \nscope=\"col\">Y27</th><th style=\"width: 1%\" scope=\"col\">Y28</th><th style=\"width: 1%\" scope=\"col\">Y29</th><th \nstyle=\"width: 1%\" scope=\"col\">Y30</th><th style=\"width: 1%\" scope=\"col\">Y31</th><th style=\"width: 1%\" scope=\"col\">Y32\n</th><th style=\"width: 1%\" scope=\"col\">Y33</th><th style=\"width: 1%\" scope=\"col\">Y34</th><th style=\"width: 1%\" \nscope=\"col\">Y35</th><th style=\"width: 1%\" scope=\"col\">Y36</th><th style=\"width: 1%\" scope=\"col\">Y37</th><th \nstyle=\"width: 1%\" scope=\"col\">Y38</th><th style=\"width: 1%\" scope=\"col\">Y39</th><th style=\"width: 1%\" scope=\"col\">Y40\n</th><th style=\"width: 1%\" scope=\"col\">Y41</th><th style=\"width: 1%\" scope=\"col\">Y42</th><th style=\"width: 1%\" \nscope=\"col\">Y43</th><th style=\"width: 1%\" scope=\"col\">Y44</th><th style=\"width: 1%\" scope=\"col\">Y45</th><th \nstyle=\"width: 1%\" scope=\"col\">Y46</th><th style=\"width: 1%\" scope=\"col\">Y47</th><th style=\"width: 1%\" scope=\"col\">Y48\n</th><th style=\"width: 1%\" scope=\"col\">Y49</th><th style=\"width: 1%\" scope=\"col\">Y50</th><th style=\"width: 10%\"></th>\n</tr><tbody><tr ng-repeat=\"customer in vm.goalChart.items track by (customer.id + $index)\"><td style=\"width: 2%\">\n{{$index+1}}</td><td style=\"width: 28%\">{{customer.goal}}</td><td style=\"width: 10%\">{{customer.category}}</td><td \nstyle=\"width: 1%\">{{customer.indicative}}</td><td style=\"width: 1%\">{{customer.y1}}</td><td style=\"width: 1%\">\n{{customer.y2}}</td><td style=\"width: 1%\">{{customer.y3}}</td><td style=\"width: 1%\">{{customer.y4}}</td><td \nstyle=\"width: 1%\">{{customer.y5}}</td><td style=\"width: 1%\">{{customer.y6}}</td><td style=\"width: 1%\">{{customer.y7}}\n</td><td style=\"width: 1%\">{{customer.y8}}</td><td style=\"width: 1%\">{{customer.y9}}</td><td style=\"width: 1%\">\n{{customer.y10}}</td><td style=\"width: 1%\">{{customer.y11}}</td><td style=\"width: 1%\">{{customer.y12}}</td><td \nstyle=\"width: 1%\">{{customer.y13}}</td><td style=\"width: 1%\">{{customer.y14}}</td><td style=\"width: 1%\">\n{{customer.y15}}</td><td style=\"width: 1%\">{{customer.y16}}</td><td style=\"width: 1%\">{{customer.y17}}</td><td \nstyle=\"width: 1%\">{{customer.y18}}</td><td style=\"width: 1%\">{{customer.y19}}</td><td style=\"width: 1%\">\n{{customer.y20}}</td><td style=\"width: 1%\">{{customer.y21}}</td><td style=\"width: 1%\">{{customer.y22}}</td><td \nstyle=\"width: 1%\">{{customer.y23}}</td><td style=\"width: 1%\">{{customer.y24}}</td><td style=\"width: 1%\">\n{{customer.y25}}</td><td style=\"width: 1%\">{{customer.y26}}</td><td style=\"width: 1%\">{{customer.y27}}</td><td \nstyle=\"width: 1%\">{{customer.y28}}</td><td style=\"width: 1%\">{{customer.y29}}</td><td style=\"width: 1%\">\n{{customer.y30}}</td><td style=\"width: 1%\">{{customer.y31}}</td><td style=\"width: 1%\">{{customer.y32}}</td><td \nstyle=\"width: 1%\">{{customer.y33}}</td><td style=\"width: 1%\">{{customer.y34}}</td><td style=\"width: 1%\">\n{{customer.y35}}</td><td style=\"width: 1%\">{{customer.y36}}</td><td style=\"width: 1%\">{{customer.y37}}</td><td \nstyle=\"width: 1%\">{{customer.y38}}</td><td style=\"width: 1%\">{{customer.y39}}</td><td style=\"width: 1%\">\n{{customer.y40}}</td><td style=\"width: 1%\">{{customer.y41}}</td><td style=\"width: 1%\">{{customer.y42}}</td><td \nstyle=\"width: 1%\">{{customer.y43}}</td><td style=\"width: 1%\">{{customer.y44}}</td><td style=\"width: 1%\">\n{{customer.y45}}</td><td style=\"width: 1%\">{{customer.y46}}</td><td style=\"width: 1%\">{{customer.y47}}</td><td \nstyle=\"width: 1%\">{{customer.y48}}</td><td style=\"width: 1%\">{{customer.y49}}</td><td style=\"width: 1%\">\n{{customer.y50}}</td><td style=\"width: 10%\"><button class=\"btn btn-danger\" ng-click=\"vm.remove(customer, $index)\" \nvalue=\"Remove\">Remove</button></td></tr></tbody></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/nav-calculate/nav-calculate.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Fund Analysis with Hurst Exponent</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" \nplaceholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div class=\"col-sm-12\"><div><form \nname=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex>\n<md-autocomplete md-input-name=\"amc\" md-menu-class=\"autocomplete-custom-template\" \nmd-selected-item-change=\"vm.getProductData(vm.selectedItem)\" md-autofocus placeholder=\"Category\" flex=\"100\" required \nmd-floating-label=\"Category\" md-selected-item=\"vm.selectedItem\" md-items=\"category in vm.getMatches(searchText)\" \nmd-search-text=\"searchText\" md-item-text=\"category\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{category}}</span></md-item-template><md-not-found>\nNo Category matching \"{{searchText}}\" were found.</md-not-found><div ng-messages=\"wizardStep1.category.$error\" \nng-if=\"wizardStep1.category.$touched\"><div ng-message=\"required\">You <b>must</b> choose a category</div></div>\n</md-autocomplete></div></form></div><br><div class=\"col-sm-4 form-group\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>As-On Date</label><input ng-disabled=\"!vm.selectedItem\" type=\"date\" \nng-change=\"vm.getDatefn(vm.selectedOption)\" ng-model=\"vm.asonDate\" required name=\"asonDate\" flex=\"33\" tabindex=\"1\">\n</md-input-container></div><div class=\"col-sm-4 form-group\"><md-input-container class=\"md-block\" flex-gt-sm>\n<md-input-container style=\"width: 100%\"><label>For Year</label><md-select ng-disabled=\"!vm.asonDate\" required \nng-model=\"vm.selectedOption\" tabindex=\"2\"><md-option ng-value=\"opt\" ng-repeat=\"opt in vm.options\" \nng-selected=\"index == 1\" ng-click=\"vm.getDatefn(opt)\">{{opt}} Year</md-option></md-select><div \nng-if=\"vm.selectedOption\"><span>Start Date - ({{vm.postData.fromDate}})</span> <span style=\"float: right\">\nEnd Date - ({{vm.postData.toDate}})</span></div></md-input-container></md-input-container><button type=\"button\" \nclass=\"btn btn-primary\" ng-disabled=\"disabtranLog() || vm.checkActRec.length <= 0\" ng-click=\"vm.getAlpha()\" \ntabindex=\"4\"><b>Process</b></button> &nbsp; &nbsp; <button type=\"button\" class=\"btn btn-primary\" \nng-disabled=\"disabtranLog()\" ng-click=\"clearLogs()\" tabindex=\"5\"><b>Clear</b></button></div><div \nclass=\"col-sm-4 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>Rolling Interval</label><input \nng-disabled=\"!vm.asonDate\" type=\"number\" ng-model=\"vm.postData.rollInt\" required name=\"rollInt\" flex=\"33\" tabindex=\"3\">\n</md-input-container></div></div></div><div id=\"exportable\" ng-if=\"vm.model.productData.length > 0\" \nstyle=\"overflow-x:auto\"><table class=\"table\"><thead class=\"thead-light\"><tr><th scope=\"col\"><input type=\"checkbox\" \nng-model=\"vm.model.allItemsSelected\" ng-change=\"vm.selectAll(vm.model.allItemsSelected)\"></th><th scope=\"col\"><span>\nSr.No.</span></th><th scope=\"col\"><span>Product ISIN</span></th><th scope=\"col\"><span>Product Amc Code</span></th><th \nscope=\"col\"><span>Product Amc Name</span></th><th scope=\"col\"><span>Product Name</span></th></tr></thead><tbody><tr \nng-repeat=\"logs in (vm.filteredItems = (vm.model.productData | filter:search))\" style=\"cursor:pointer\" \nng-class=\"{selected: logs.isChecked}\"><td><input type=\"checkbox\" ng-model=\"logs.isChecked\" \nng-change=\"vm.selectEntity(logs)\"></td><td>{{$index+1}}</td><td>{{logs.productISIN}}</td><td><span \nng-if=\"logs.productAmcCode\">{{(logs.productAmcCode)}}</span></td><td ng-bind=\"logs.productAmcName\"></td><td \nng-bind=\"logs.productName\"></td></tr></tbody></table></div></md-card></div></div>");
$templateCache.put("app/main/nav-list/nav-list.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>NAV Download</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" \nplaceholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div class=\"col-sm-12\"><div style=\"padding: 1%\">\n<md-radio-group ng-model=\"vm.schemeType\" layout=\"row\"><md-radio-button ng-value=\"1\" aria-label=\"Select All\" \nng-click=\"clearLogs()\">All</md-radio-button><md-radio-button ng-value=\"0\" aria-label=\"Active\" ng-click=\"clearLogs()\">\nActive</md-radio-button></md-radio-group></div><div><form name=\"wizardStep1\" class=\"md-inline-form\"><br><div \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap flex><md-autocomplete md-input-name=\"amc\" \nmd-menu-class=\"autocomplete-custom-template\" md-selected-item-change=\"vm.getAllScheme(vm.recommendation.amc)\" \nmd-autofocus placeholder=\"AMC\" flex=\"100\" required md-floating-label=\"AMC\" md-selected-item=\"vm.recommendation.amc\" \nmd-items=\"amc in vm.getMatches(searchText)\" md-search-text=\"searchText\" md-item-text=\"amc.LONG_NAME\"><md-item-template>\n<span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{amc.LONG_NAME}}</span></md-item-template><md-not-found>\nNo AMC matching \"{{searchText}}\" were found.</md-not-found><div ng-messages=\"wizardStep1.amc.$error\" \nng-if=\"wizardStep1.amc.$touched\"><div ng-message=\"required\">You <b>must</b> choose a AMC</div></div></md-autocomplete>\n<md-autocomplete md-menu-class=\"autocomplete-custom-template\" ng-disabled=\"!vm.recommendation.amc\" \nmd-input-name=\"scheme\" placeholder=\"Scheme\" flex=\"100\" required md-floating-label=\"Scheme\" md-no-cache=\"true\" \nmd-selected-item=\"vm.recommendation.scheme\" md-items=\"scheme in vm.getSchemeMatches(searchScheme)\" \nmd-search-text=\"searchScheme\" md-item-text=\"scheme.PRODUCT_LONG_NAME\"><md-item-template><span \nmd-highlight-text=\"searchScheme\" md-highlight-flags=\"^i\">{{scheme.PRODUCT_LONG_NAME}}</span></md-item-template>\n<md-not-found>No AMC matching \"{{searchScheme}}\" were found.</md-not-found><div \nng-messages=\"wizardStep1.scheme.$error\" ng-if=\"wizardStep1.scheme.$touched\"><div ng-message=\"required\">You <b>must</b>\n choose a Scheme</div></div></md-autocomplete></div></form></div><br><div class=\"col-sm-4 form-group\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>From Date</label><input type=\"date\" ng-model=\"vm.fromDate\" \nrequired name=\"fromDate\" flex=\"33\" tabindex=\"1\"></md-input-container></div><div class=\"col-sm-4 form-group\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>To Date</label><input type=\"date\" ng-model=\"vm.toDate\" required \nname=\"toDate\" flex=\"33\" tabindex=\"2\"></md-input-container><button type=\"button\" class=\"btn btn-primary\" \nng-disabled=\"disabtranLog()\" ng-click=\"postNavData()\" tabindex=\"6\"><b>Download Excel</b></button> &nbsp; &nbsp; <button\n type=\"button\" class=\"btn btn-primary\" ng-click=\"clearLogs()\" tabindex=\"6\"><b>Clear</b></button></div></div></div>\n</md-card></div></div>");
$templateCache.put("app/main/internaluesr-assignentreport/assignmentreport.html","<style>\n/* Ensure the parent container takes full height */\r\n    .ext-content {\r\n        position: relative;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n        margin-top: -15px;\r\n    }\r\n\r\n    /* Table container with limited height and scrollable content */\r\n    .md-table-container {\r\n        overflow-x: auto; /* Enable horizontal scrolling */\r\n        overflow-y: auto; /* Enable vertical scrolling */\r\n        max-height: 75vh; /* Limit the height to prevent scrolling out of screen */\r\n        background: #fff;\r\n        width: 100%;\r\n        border: 1px solid #ddd;\r\n    }\r\n\r\n    /* Sticky table headers */\r\n    thead th {\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 2;\r\n        background: #f1f1f1;\r\n        text-align: left;\r\n        border-bottom: 2px solid #ddd;\r\n        padding: 10px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    /* Ensure table rows have proper styles */\r\n    tbody tr:hover {\r\n        background-color: #f9f9f9;\r\n    }\r\n\r\n    tbody {\r\n        background: #fff;\r\n    }\r\n\r\n    /* Table formatting */\r\n    table {\r\n        width: max-content; /* Ensures table expands based on content */\r\n        border-collapse: collapse;\r\n        table-layout: auto;\r\n        min-width: 100%; /* Ensures table doesn\'t shrink too much */\r\n    }\r\n\r\n    td, th {\r\n        padding: 8px 12px;\r\n        text-align: left;\r\n        border: 1px solid #ddd;\r\n    }\r\n\r\n    /* Prevent text wrapping inside cells */\r\n    td {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    th {\r\n        max-width: 200px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    /* Ensuring horizontal scrollbar visibility */\r\n    .md-table-container::-webkit-scrollbar {\r\n        height: 8px;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-track {\r\n        background: #f1f1f1;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-thumb {\r\n        background: #888;\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .md-table-container::-webkit-scrollbar-thumb:hover {\r\n        background: #555;\r\n    }\n</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60 mb-3\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin:0px; margin-top: -5px\"><span>Assignment Report</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div></div><div></div><div \nclass=\"headerFixAllPages\"><md-card class=\"container-fluid\" ng-init=\"vm.datereport();\"><div class=\"row\"><div \nclass=\"col-sm-12\"><br><div class=\"col-sm-3 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>From Date\n</label><input type=\"date\" ng-model=\"assign.fromDate\" required name=\"fromDate\" flex=\"33\" tabindex=\"1\">\n</md-input-container></div><div class=\"col-sm-3 form-group\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nTo Date</label><input type=\"date\" ng-model=\"assign.toDate\" required name=\"toDate\" flex=\"33\" tabindex=\"2\">\n</md-input-container></div><div class=\"col-sm-3 form-group\" ng-if=\"vm.userDetail.type === \'SUPER::ADMIN\'\">\n<md-input-container class=\"md-block\"><label>Select An RM Name</label><md-select ng-model=\"vm.selectedOption\" \nplaceholder=\"Select An RM Name\" ng-change=\"vm.genrateassignreport()\"><md-option ng-repeat=\"val in vm.internalUser\" \nng-value=\"val\">{{ val.userName }}</md-option></md-select></md-input-container></div><div class=\"col-sm-1 form-group\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.genrateassignreport()\" tabindex=\"6\"><b>show</b></button>\n</div><div class=\"col-sm-2 form-group\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.downloadReport()\" \nstyle=\"color:#fff !important\"><md-icon md-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Download\n</md-button></div></div></div><div class=\"ext-content\"><md-virtual-repeat-container><md-table-container \nclass=\"md-table-container\"><table md-table><thead md-head><tr md-row><th md-column>Sr&nbsp;No.</th><th md-column>Name\n</th><th md-column>Mobile</th><th md-column>IIN</th><th md-column>PAN</th><th md-column>KYC&nbsp;Status</th><th \nmd-column>Address</th><th md-column>Created&nbsp;At</th><th md-column>Assigned&nbsp;Date</th><th md-column>\nFirst&nbsp;Call&nbsp;Date</th><th md-column>Assigned&nbsp;To</th><th md-column>Platform</th></tr></thead><tbody \nmd-body><tr md-row ng-repeat=\"data in vm.fetchreport | filter:search\" \nng-style=\"hover === $index ? {\'text-decoration\': \'underline\', \'color\': \'blue\', \'cursor\': \'pointer\'} : {}\" \nng-mouseover=\"hover = $index\" ng-mouseleave=\"hover = null\" ng-click=\"vm.showDetails(data)\"><td md-cell>{{$index+1}}\n</td><td md-cell>{{data.userName}}</td><td md-cell>{{data.mobileNo}}</td><td md-cell>{{data.iin}}</td><td md-cell>\n{{data.pan}}</td><td md-cell>{{data.camsKycStatus !== undefined ? vm.eKyc[data.camsKycStatus] : \"NA\"}}</td><td md-cell>\n{{data.nseData ? data.nseData.CITY : \"Not&nbsp;Available\"}}</td><td md-cell>{{data.createdAt | date:\"dd-MM-y\"}}</td><td\n md-cell>{{data.createdAt | date:\"dd/MM/yyyy\'&nbsp;at&nbsp;\'h:mma\"}}</td><td md-cell>\n{{data.callSchedule.atDate ? (data.callSchedule.atDate | date:\"dd/MM/yyyy\") : \'\'}} <span \nng-if=\"data.callSchedule.atDate\">&nbsp;at&nbsp;{{data.callSchedule.atHour}}:{{data.callSchedule.atMinute}}</span></td>\n<td md-cell>{{data.assignedDetails.userName}}</td><td md-cell>{{data.platform}}</td></tr></tbody></table>\n</md-table-container></md-virtual-repeat-container></div></md-card></div></div>");
$templateCache.put("app/main/internaluesr-assignentreport/editofc.html","<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css\">\n<style>\nmd-autocomplete[md-floating-label] {\r\n    border-radius: 0;\r\n    background: transparent;\r\n    height: 54px;\r\n  }\n</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.fetchstate();vm.editofc();\">\n<div class=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>Office Details</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"backArrowColor\" \nui-sref=\"app.offices\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div layout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div \nclass=\"col-sm-12\"><div><form name=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"100\"><label>Address\n</label><input type=\"text\" ng-model=\"vm.edit.address\" name=\"address\" tabindex=\"7\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><label>\nState</label><md-select ng-model=\"vm.edit.state\" ng-change=\"vm.city_acc_state(vm.edit.state)\"><md-option \nng-repeat=\"item in vm.statedata\" ng-value=\"item.stateName\">{{item.stateName}}</md-option></md-select>\n</md-input-container><md-autocomplete flex=\"50\" flex-gt-xs=\"50\" tabindex=\"2\" md-input-name=\"amc\" \nmd-menu-class=\"autocomplete-custom-template\" md-autofocus flex=\"100\" required md-floating-label=\"City\" \nmd-selected-item=\"vm.edit.city\" md-items=\"item in vm.citydata(searchText)\" md-search-text=\"searchText\" \nmd-item-text=\"city\" ng-disabled=\"vm.goalFundId\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>No Category city \"{{searchText}}\" were found.\n</md-not-found></md-autocomplete></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Assign state Telecalling</label><md-select \nng-model=\"vm.edit.multistate\" ng-change=\"vm.assignstate(vm.edit.multistate)\"><md-option \nng-repeat=\"item in vm.statedata\" ng-value=\"item\">{{item.stateName}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"100\"><span \nstyle=\"background-color: white; color: black; border-radius: 10px; padding: -3px\" ng-repeat=\"each_combo in vm.states\" \nng-click=\"vm.removestate($index)\">{{each_combo}}&nbsp;&nbsp;&nbsp;<i class=\"fa fa-times\" aria-hidden=\"true\"></i>&nbsp;\n</span></md-input-container></div></form></div><div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.updateofficeinfo()\" style=\"color:#fff !important\">Update</md-button>\n</md-input-container></div></div></div></md-card></div></div>");
$templateCache.put("app/main/internaluesr-assignentreport/office-chart.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Office Chart</span></div></div><div \nclass=\"white-fg h3\" layout=\"column\" layout-align=\"start start\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.officeadd\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add Office Details\n</md-button></div></div><div class=\"headerFixAllPages\" ng-init=\"vm.fetchoffice();\"><md-card class=\"container-fluid\">\n<div class=\"row\"><div class=\"col-sm-12\"><form name=\"wizardStep1\" class=\"md-inline-form\"><div layout=\"row\"><table \nid=\"customers\" class=\"table table-hover\"><tr><th>Sr No.</th><th>State</th><th>City</th><th>Address</th><th></th><th>\n</th></tr><tbody ng-repeat=\"data in vm.officedata\"><tr><td>{{$index+1}}</td><td>{{data.state}}</td><td>{{data.city}}\n</td><td>{{data.address}}</td><td style=\"width: 10%\"><button ui-sref=\"app.editofc({id:data._id})\" value=\"Edit\"><md-icon\n md-font-icon=\"icon-pencil\"></md-icon>Edit</button></td><td style=\"width: 10%\"><button \nng-click=\"vm.deleteoffice(data._id)\" value=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</button></td>\n</tr></tbody></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/no-isin-scheme/isin-dialog.html","<div layout=\"column\" layout-wrap layout-padding style=\"padding-top:50px\"><h3>{{vm.schmData.productName}}</h3>\n<md-input-container><label>ISIN</label><input ng-model=\"vm.isin\"></md-input-container><div layout=\"row\" \nlayout-align=\"space-between\" flex=\"100\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.hide(null)\">Cancel\n</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.saveData()\" ng-disabled=\"!vm.isin\">Save</md-button>\n</div></div>");
$templateCache.put("app/main/no-isin-scheme/no-isin-scheme.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"userInternal\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"70\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nNo ISIN Schems</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div></div><md-content><md-nav-bar \nmd-selected-nav-item=\"vm.currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item \nmd-nav-click=\"vm.getNOIsinSchems(\'WITHOUT_ISIN\')\" name=\"WITHOUT_ISIN\">No ISIN</md-nav-item><md-nav-item \nmd-nav-click=\"vm.getNOIsinSchems(\'MORNINGSTAR_PENDING\')\" name=\"MORNINGSTAR_PENDING\">Morning Star Pending</md-nav-item>\n<md-nav-item md-nav-click=\"vm.getNOIsinSchems(\'MORNINGSTAR_ADDED\')\" name=\"MORNINGSTAR_ADDED\">Added In Morning Star\n</md-nav-item></md-nav-bar><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>S. No.</span></th><th md-column md-order-by=\"productName\">\n<span>Scheme Name</span></th><th md-column md-order-by=\"productAmcName\"><span>AMC Name</span></th><th md-column \nmd-order-by=\"productISIN\"><span>ISIN</span></th><th md-column md-order-by=\"productDisplayName\"><span>Display Name\n</span></th><th md-column md-order-by=\"productMSCategory\"><span>MS Category</span></th><th md-column \nmd-order-by=\"productDisplayCategory\"><span>Display category</span></th><th md-column md-order-by=\"productCategory\">\n<span>OE/CE</span></th><th md-column md-order-by=\"minimumSipAmount\"><span>Min. SIP</span></th><th md-column \nmd-order-by=\"minimumLumpsumAmount\"><span>Min. Lump</span></th><th md-column \nng-if=\"vm.currentNavItem !==\'MORNINGSTAR_ADDED\'\">Edit ISIN</th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nmd-auto-select md-virtual-repeat=\"schm in vm.noIsinScheme | filter:search | orderBy: vm.query.order \" \nstyle=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>{{schm.productName}}</td><td md-cell>\n{{schm.productAmcName}}</td><td md-cell>{{schm.productISIN || \'NA\'}}</td><td md-cell>\n{{schm.productDisplayName || \'NA\'}}</td><td md-cell>{{schm.productMSCategory || \'NA\'}}</td><td md-cell>\n{{schm.productDisplayCategory || \'NA\'}}</td><td md-cell>{{schm.productCategory || \'NA\'}}</td><td md-cell>\n{{schm.minimumSipAmount || 0}}</td><td md-cell>{{schm.minimumLumpsumAmount}}</td><td md-cell \nng-if=\"vm.currentNavItem !==\'MORNINGSTAR_ADDED\'\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-if=\"vm.currentNavItem ===\'WITHOUT_ISIN\'\"><md-button aria-label=\"Edit\" \nng-click=\"vm.editISINDialog(schm)\">Edit</md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentNavItem===\'MORNINGSTAR_PENDING\'\"><md-button aria-label=\"Activated\" \nng-click=\"vm.markMorningStarDialog(schm)\">Mark Added Morning Star</md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></md-table-container></md-virtual-repeat-container></div></md-content></div>");
$templateCache.put("app/main/minor-transaction/minor-transaction-dialog.html","<div layout=\"column\" layout-wrap layout-padding style=\"padding-top:50px\"><h3>{{vm.user.investorName}}</h3>\n<md-input-container><label>PAN Number</label><input ng-model=\"vm.userPan.investorPan\"></md-input-container><div \nlayout=\"row\" layout-align=\"space-between\" flex=\"100\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.hide(null)\">\nCancel</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.saveData()\" \nng-disabled=\"!vm.userPan.investorPan\">Save</md-button></div></div>");
$templateCache.put("app/main/minor-transaction/minor-transaction.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"minorTrxn\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span class=\"text-capitalize\">Minor Transaction List</span></div><span class=\"mt-15\">Total: {{vm.allTrxns.length}}\n</span></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"Search\" ng-blur=\"vm.getAllData()\" ng-keyup=\"$event.keyCode == 13 ? vm.searchTransaction() : null\" flex>\n</div></div><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\"><md-table-container \nclass=\"tablePbmSolved\"><table md-table ng-model=\"vm.selected\"><thead md-head md-order=\"vm.query.order\" fix-head><tr \nmd-row><th md-column md-order-by=\"lastLoginDate\"><span>Actions</span></th><th md-column md-order-by=\"transactionDate\">\n<span class=\"text-center\">Date</span></th><th md-column md-order-by=\"source\"><span class=\"text-center\">Source</span>\n</th><th md-column md-order-by=\"investorName\"><span>Investor Name</span></th><th md-column md-order-by=\"investorPan\">\n<span>PAN</span></th><th md-column md-order-by=\"iin\"><span>IIN</span></th><th md-column \nmd-order-by=\"transactionNumber\"><span>Trxn No.</span></th><th md-column md-order-by=\"productName\"><span>Scheme</span>\n</th><th md-column md-order-by=\"folioNumber\"><span>Folio No.</span></th><th md-column md-order-by=\"purPrice\"><span>\nPrice/Unit</span></th><th md-column md-order-by=\"units\"><span>Units</span></th><th md-column md-order-by=\"amount\">\n<span>Amount</span></th><th md-column md-order-by=\"type\"><span>Trxn Type</span></th></tr></thead><tbody md-body><tr \nmd-row md-select=\"customer\" ng-repeat=\"transaction in vm.allTrxns | filter:vm.customFilter(vm.search)\" \nng-click=\"vm.customerDetailFunction(customer)\" style=\"cursor:pointer\"><td md-cell><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Edit\" \nng-click=\"vm.updatePanDialog(transaction)\">Update Pan</md-button></md-menu-item></md-menu-content></md-menu></td><td \nmd-cell>{{transaction.transactionDate | date:\'mediumDate\'}}</td><td md-cell>{{transaction.source || \'NA\'}}</td><td \nmd-cell>{{transaction.investorName || \'NA\'}}</td><td md-cell>{{transaction.investorPan || \'NA\'}}</td><td md-cell>\n{{transaction.iin || \'NA\'}}</td><td md-cell>{{transaction.transactionNumber || \'NA\'}}</td><td md-cell>\n{{transaction.productName || \'NA\'}}</td><td md-cell>{{transaction.folioNumber || \'NA\'}}</td><td md-cell>\n{{transaction.purPrice || \'NA\'}}</td><td md-cell>{{transaction.units || \'NA\'}}</td><td md-cell>\n{{transaction.amount || \'NA\'}}</td><td md-cell>{{transaction.type || \'NA\'}}</td></tr></tbody></table>\n</md-table-container></md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/offices/editofc.html","<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css\">\n<style>\nmd-autocomplete[md-floating-label] {\r\n    border-radius: 0;\r\n    background: transparent;\r\n    height: 54px;\r\n  }\n</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.fetchstate();vm.editofc();\">\n<div class=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>Office Details</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"backArrowColor\" \nui-sref=\"app.offices\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div layout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div \nclass=\"col-sm-12\"><div><form name=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"100\"><label>Address\n</label><input type=\"text\" ng-model=\"vm.edit.address\" name=\"address\" tabindex=\"7\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><label>\nState</label><md-select ng-model=\"vm.edit.state\" ng-change=\"vm.city_acc_state(vm.edit.state)\"><md-option \nng-repeat=\"item in vm.statedata\" ng-value=\"item.stateName\">{{item.stateName}}</md-option></md-select>\n</md-input-container><md-autocomplete flex=\"50\" flex-gt-xs=\"50\" tabindex=\"2\" md-input-name=\"amc\" \nmd-menu-class=\"autocomplete-custom-template\" md-autofocus flex=\"100\" required md-floating-label=\"City\" \nmd-selected-item=\"vm.edit.city\" md-items=\"item in vm.citydata(searchText)\" md-search-text=\"searchText\" \nmd-item-text=\"city\" ng-disabled=\"vm.goalFundId\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>No Category city \"{{searchText}}\" were found.\n</md-not-found></md-autocomplete></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Assign state Telecalling</label><md-select \nng-model=\"vm.edit.multistate\" ng-change=\"vm.assignstate(vm.edit.multistate)\"><md-option \nng-repeat=\"item in vm.statedata\" ng-value=\"item\">{{item.stateName}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"100\"><span \nstyle=\"background-color: white; color: black; border-radius: 10px; padding: -3px\" ng-repeat=\"each_combo in vm.states\" \nng-click=\"vm.removestate($index)\">{{each_combo}}&nbsp;&nbsp;&nbsp;<i class=\"fa fa-times\" aria-hidden=\"true\"></i>&nbsp;\n</span></md-input-container></div></form></div><div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.updateofficeinfo()\" style=\"color:#fff !important\">Update</md-button>\n</md-input-container></div></div></div></md-card></div></div>");
$templateCache.put("app/main/offices/office-chart.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Office Chart</span></div></div><div \nclass=\"white-fg h3\" layout=\"column\" layout-align=\"start start\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.officeadd\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add Office Details\n</md-button></div></div><div class=\"headerFixAllPages\" ng-init=\"vm.fetchoffice();\"><md-card class=\"container-fluid\">\n<div class=\"row\"><div class=\"col-sm-12\"><form name=\"wizardStep1\" class=\"md-inline-form\"><div layout=\"row\"><table \nid=\"customers\" class=\"table table-hover\"><tr><th>Sr No.</th><th>State</th><th>City</th><th>Address</th><th></th><th>\n</th></tr><tbody ng-repeat=\"data in vm.officedata\"><tr><td>{{$index+1}}</td><td>{{data.state}}</td><td>{{data.city}}\n</td><td>{{data.address}}</td><td style=\"width: 10%\"><button ui-sref=\"app.editofc({id:data._id})\" value=\"Edit\"><md-icon\n md-font-icon=\"icon-pencil\"></md-icon>Edit</button></td><td style=\"width: 10%\"><button \nng-click=\"vm.deleteoffice(data._id)\" value=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</button></td>\n</tr></tbody></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/offices/offices.html","<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css\">\n<style>md-autocomplete[md-floating-label] {\r\n  border-radius: 0;\r\n  background: transparent;\r\n  height: 54px;\r\n}\n</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-init=\"vm.fetchstate();\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nOffice Details</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"backArrowColor\" \nui-sref=\"app.offices\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div layout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div \nclass=\"col-sm-12\"><div><form name=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"100\"><label>Address\n</label><input type=\"text\" ng-model=\"vm.office.address\" name=\"address\" tabindex=\"7\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nstyle=\"margin-top: 20px\"><label>State</label><md-select ng-model=\"vm.office.state\" \nng-change=\"vm.city_acc_state(vm.office.state)\"><md-option ng-repeat=\"item in vm.statedata\" ng-value=\"item.stateName\">\n{{item.stateName}}</md-option></md-select></md-input-container><md-autocomplete flex=\"50\" flex-gt-xs=\"50\" tabindex=\"2\" \nmd-input-name=\"amc\" md-menu-class=\"autocomplete-custom-template\" md-autofocus flex=\"100\" required \nmd-floating-label=\"City\" md-selected-item=\"vm.office.city\" md-items=\"item in vm.citydata(searchText)\" \nmd-search-text=\"searchText\" md-item-text=\"item\" ng-disabled=\"vm.goalFundId\"><md-item-template><span \nmd-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>\nNo Category city \"{{searchText}}\" were found.</md-not-found></md-autocomplete></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nAssign state Telecalling</label><md-select ng-model=\"vm.office.multistate\" \nng-change=\"vm.assignstate(vm.office.multistate)\"><md-option ng-repeat=\"item in vm.statedata\" ng-value=\"item\">\n{{item.stateName}}</md-option></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"100\"><span \nstyle=\"background-color: white; color: black; border-radius: 10px; padding: -3px\" ng-repeat=\"each_combo in vm.states\" \nng-click=\"vm.removestate($index)\">{{each_combo}}&nbsp;&nbsp;&nbsp;<i class=\"fa fa-times\" aria-hidden=\"true\"></i>&nbsp;\n</span></md-input-container></div></form></div><div><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.submitofficeinfo()\" style=\"color:#fff !important\">Submit</md-button>\n</md-input-container></div></div></div></md-card></div></div>");
$templateCache.put("app/main/products/products.html","<div id=\"products\"><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nProducts</span></div><div class=\"product-count secondary-text margin-top-10\"><span>Total Products:</span> <span>\n{{vm.allAmcData.totalAmc || 0}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex=\"35\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nclass=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div></div><div \nclass=\"headerFixAllPages\"><md-content class=\"md-padding padd-Bott-zero\" layout-xs=\"column\" layout=\"row\" layout-wrap>\n<md-card class=\"shadowGradients\" md-theme-watch flex=\"100\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"padding-20\" flex=\"100\"><div flex=\"25\" layout-align=\"center center\"><h1 class=\"valueText\">\n{{vm.allAmcData.totalAmc || 0}}</h1><h1 class=\"headingText\">AMC</h1></div><div flex=\"25\" layout-align=\"center center\">\n<h1 class=\"valueText\">{{vm.allAmcData.activeSchemes || 0}}</h1><h1 class=\"headingText\">Active Scheme</h1></div><div \nflex=\"25\" layout-align=\"center center\"><h1 class=\"valueText\">{{vm.allAmcData.inActiveSchemes || 0}}</h1><h1 \nclass=\"headingText\">Inactive Scheme</h1></div><div flex=\"25\" layout-align=\"center center\"><h1 class=\"valueText\">\n{{vm.allAmcData.activeNFOSchemes || 0}}</h1><h1 class=\"headingText\">Active NFO</h1></div></div></md-card></md-content>\n<md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\" layout-wrap><div flex-xs flex-gt-xs=\"25\" \nlayout=\"column\" ng-repeat=\"amc in vm.allAmcData.allAMCs | filter:search | orderBy:\'longName\' \"><md-card \nclass=\"shadowGradients\" md-theme-watch><div class=\"padding-card-heading\"><div layout=\"row\" \nlayout-align=\"space-between\"><div flex=\"90\"><div class=\"md-subhead-head\">\n{{amc.longName.length > 15 ? amc.longName.substring(0, 15)+\'..\':amc.longName}}<md-tooltip>{{amc.longName}}</md-tooltip>\n</div></div><div flex=\"10\"><md-icon md-font-icon=\"icon-upload\" \nng-click=\"vm.uploadImageAmc(amc);$event.stopPropagation();\" class=\"colorUpload\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Upload Image</md-tooltip></div></div></div><md-card-content layout=\"row\" \nlayout-align=\"space-between\" class=\"padding-zero\"><input type=\"file\" \nonchange=\"angular.element(this).scope().fileNameChanged(this)\" id=\"file-input\" name=\"filedata\" style=\"display:none\"> \n<img ng-show=\"!amc.amcLogo\" class=\"cardHeight\" src=\"./../../../assets/images/backgrounds/prdouctPlaceHolder.jpg\" \nng-click=\"vm.showScheme(amc)\" alt=\"Amc-Image\"> <img ng-show=\"amc.amcLogo\" class=\"cardHeight\" \nng-src=\"{{vm.baseUrl+amc.amcLogo}}\" ng-click=\"vm.showScheme(amc)\" alt=\"Amc-Image\"></md-card-content><div \nclass=\"padding-card-footer\"><div layout=\"row\" layout-align=\"space-between\"><div flex=\"33\"><h1 class=\"headingSubValue\">\n{{amc.activeScheme}}</h1><h1 class=\"headingSubText\">Active_Sch</h1></div><div flex=\"33\"><h1 class=\"headingSubValue\">\n{{amc.inActiveScheme}}</h1><h1 class=\"headingSubText\">Inactive_Sch</h1></div><div flex=\"33\"><h1 \nclass=\"headingSubValue\">{{amc.activeNFOScheme}}</h1><h1 class=\"headingSubText\">NFO</h1></div></div></div></md-card>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/nav-rating/nav-rating.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Fund Rating</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" \nplaceholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div class=\"col-sm-12\"><div><form \nname=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex>\n<md-input-container flex=\"50\" flex-gt-xs=\"50\"><label>Select Category</label><md-select ng-model=\"vm.fundType\" \nng-change=\"vm.getCategory(vm.fundType)\"><md-option ng-repeat=\"item in vm.fundtypeall\" ng-value=\"item.Value\">\n{{item.Name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap flex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><label>Select Fund Type</label><md-select \nng-model=\"vm.selectedItem\"><md-option ng-repeat=\"item in vm.categories\" ng-value=\"item\">{{item}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex>\n<md-input-container class=\"md-block\" flex=\"50\" flex-gt-xs=\"20\"><label>Month</label><md-select ng-model=\"vm.shDate\" \nrequired name=\"shDate\" tabindex=\"1\"><md-option ng-repeat=\"m in vm.monthPickerOptions\" ng-value=\"m.value\">{{m.label}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap \nflex><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.getProductData()\" tabindex=\"5\"><b>Show</b></button> \n<span ng-if=\"vm.model.productData.length > 0\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.download()\" \nstyle=\"float:right; color:#fff !important\"><md-icon md-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>\nDownload</md-button></span></div><br></form></div></div></div><div ng-if=\"!vm.model.productData.length\" \nstyle=\"text-align: center;padding:10px\"><span>{{vm.NoDataFound}}</span></div><div id=\"exportable\" \nng-if=\"vm.model.productData.length > 0\" style=\"overflow-x:auto\"><table class=\"table\"><thead class=\"thead-light\"><tr><th\n scope=\"col\"><span>Sr.No.</span></th><th class=\"col-sm-4\" scope=\"col\"><span>Fund Name</span></th><th class=\"col-sm-2\" \nscope=\"col\"><span>Category</span></th><th class=\"col-sm-2\" scope=\"col\"><span>3 Yrs Return</span></th><th \nclass=\"col-sm-1\" scope=\"col\"><span>Rating</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[0]}}\n</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[1]}}</span></th><th class=\"col-sm-1\" \nscope=\"col\"><span>{{vm.monthyearArray[2]}}</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[3]}}\n</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[4]}}</span></th><th class=\"col-sm-1\" \nscope=\"col\"><span>{{vm.monthyearArray[5]}}</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[6]}}\n</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[7]}}</span></th><th class=\"col-sm-1\" \nscope=\"col\"><span>{{vm.monthyearArray[8]}}</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[9]}}\n</span></th><th class=\"col-sm-1\" scope=\"col\"><span>{{vm.monthyearArray[10]}}</span></th><th class=\"col-sm-1\" \nscope=\"col\"><span>{{vm.monthyearArray[11]}}</span></th></tr></thead><tbody><tr \nng-repeat=\"logs in (vm.filteredItems = (vm.model.productData | filter:search))\" style=\"cursor:pointer\" \nng-class=\"{selected: logs.isChecked}\"><td>{{$index+1}}</td><td class=\"col-sm-4\">\n{{logs.productData[0].productName == null ? logs[\'Fund Name\'] : logs.productData[0].productName }}</td><td \nclass=\"col-sm-2\">{{logs.Fund_Type}}</td><td class=\"col-sm-2\">\n{{ logs.productData[0].product3YearReturnValue | number:1}} %</td><td class=\"col-sm-1\">{{logs.Rating }} Star</td><td \nclass=\"col-sm-1\">{{logs.rankarray[0]}}</td><td class=\"col-sm-1\">{{logs.rankarray[1] }}</td><td class=\"col-sm-1\">\n{{logs.rankarray[2]}}</td><td class=\"col-sm-1\">{{logs.rankarray[3] }}</td><td class=\"col-sm-1\">{{logs.rankarray[4] }}\n</td><td class=\"col-sm-1\">{{logs.rankarray[5] }}</td><td class=\"col-sm-1\">{{logs.rankarray[6] }}</td><td \nclass=\"col-sm-1\">{{logs.rankarray[7] }}</td><td class=\"col-sm-1\">{{logs.rankarray[8] }}</td><td class=\"col-sm-1\">\n{{logs.rankarray[9]}}</td><td class=\"col-sm-1\">{{logs.rankarray[10] }}</td><td class=\"col-sm-1\">{{logs.rankarray[11] }}\n</td></tr></tbody></table></div></md-card></div></div>");
$templateCache.put("app/main/other-transaction/other-transaction.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"uploadTransaction\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nOther Transaction</span></div></div></div><div class=\"headerFixAllPages\"><div layout=\"row\" id=\"transaction\" \nlayout-wrap layout-margin layout-align=\"space-around \" layout-fill><div flex=\"45\" layout=\"column\" layout-margin \nclass=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><h3>SIP Transaction</h3></div><div \nlayout=\"column\" layout-align=\"center end\" flex=\"50\"><img src=\"#\" alt=\"\"></div></div><div layout=\"column\"><h4 \nclass=\"text-4a\">Last Transaction Date : {{vm.sipTrxnData.transactionDate | date: \'mediumDate\'}}</h4></div><div \nlayout=\"row\" layout-align=\"start center\"><div><input type=\"file\" accept=\".csv\" style=\"cursor: pointer\" name=\"file\" \nid=\"sipFile\" onchange=\"angular.element(this).scope().checkfile(this,\'sipFile\')\"><label for=\"sipFile\">{{vm.sipFile}}\n</label></div><md-button class=\"md-accent md-raised\" ng-click=\"vm.uploadSIPTrxn()\">Upload</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.validateSIPTrxn()\">Validate</md-button></div></div><div flex=\"45\" \nlayout=\"column\" layout-margin class=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><h3>IIN Syncing\n</h3></div><div layout=\"column\" layout-align=\"center end\" flex=\"50\"><img src=\"#\" alt=\"\"></div></div><div \nlayout=\"column\"><h4 class=\"text-4a\">Last Transaction Date : {{vm.iinSyncData.transactionDate | date: \'mediumDate\'}}\n</h4></div><div layout=\"row\" layout-align=\"start center\"><div><input type=\"file\" style=\"cursor: pointer\" accept=\".csv\" \nname=\"file\" id=\"iinsyncfile\" ng-model-instant onchange=\"angular.element(this).scope().checkfile(this, \'iinsyncfile\')\">\n<label for=\"iinsyncfile\">{{vm.iinsyncFile}}</label></div><md-button class=\"md-accent md-raised\" \nng-click=\"vm.uploadIINSyncTrxn()\">Upload</md-button></div></div><div flex=\"45\" layout=\"column\" layout-margin \nclass=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><h3>ACH Upload</h3></div><div \nlayout=\"column\" layout-align=\"center end\" flex=\"50\"><img src=\"#\" alt=\"\"></div></div><div layout=\"column\" \nstyle=\"display: block\"><h4 class=\"text-4a\">Last Transaction Date : {{vm.achcData.transactionDate | date: \'mediumDate\'}}\n</h4></div><div layout=\"row\" layout-align=\"start center\"><div><input type=\"file\" accept=\".csv\" style=\"cursor: pointer\" \nname=\"file\" id=\"achFile\" onchange=\"angular.element(this).scope().checkfile(this,\'achFile\')\"><label for=\"achfile\">\n{{vm.achFile}}</label></div><md-button class=\"md-accent md-raised\" ng-click=\"vm.uploadAchTrxn()\">Upload</md-button>\n</div></div><div flex=\"45\" class=\"xtr-bg\" style=\"display:block\"></div></div></div></div>");
$templateCache.put("app/main/pushNotification/pushNotification.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"pushNotifyList\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nPush Notification List</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"15\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" \ntype=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" layout-align=\"start center\" flex=\"10\">\n<md-button class=\"backArrowColor\" ui-sref=\"app.pushNotificationList\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span>\n</md-button></div></div><div class=\"bgCustomHeader\"><div class=\"margin-left-15\"><md-button \nclass=\"md-raised width-210 textTransform\" \nng-class=\"{\'selectCustomerColor\': vm.selectedCustomersArray.length === vm.customers.length}\" \nng-click=\"vm.customerCount()\" label=\"All Customer\">\n{{vm.selectedCustomersArray.length>0? \'Deselect All Customer\':\'Select All Customer\'}}</md-button><md-button \nclass=\"md-raised width-210 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedCustomersArray.length === vm.customers.length}\" \nng-click=\"vm.sendMessage()\" ng-disabled=\"vm.selectedCustomersArray.length< 1\"><md-icon md-font-icon=\"icon-email\" \nstyle=\"cursor:pointer\"></md-icon>Send Message</md-button></div></div><md-content class=\"white-bg md-padding\">\n<md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" \nmd-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>Select</span></th><th \nmd-column md-order-by=\"userName\"><span>Name</span></th><th md-column md-order-by=\"contactNo\"><span>Contact</span></th>\n<th md-column md-order-by=\"email\"><span>Email Id</span></th><th md-column md-order-by=\"pan\"><span>PAN No.</span></th>\n<th md-column md-order-by=\"iin\"><span>IIN</span></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nmd-auto-select md-virtual-repeat=\"customer in vm.customers | filter:search | orderBy: vm.query.order\" \nstyle=\"cursor:pointer\"><td md-cell><input type=\"checkbox\" ng-model=\"customer.isChecked\" \nng-change=\"vm.selectEntity(customer)\"></td><td md-cell><span \nng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell>{{customer.mobileNo}}</td><td md-cell>{{customer.email}}</td><td md-cell>\n{{(customer.pan) ? (customer.pan) :\'NA\'}}</td><td md-cell>{{customer.iin}}</td></tr></tbody></table>\n</md-table-container></md-virtual-repeat-container></md-content></div>");
$templateCache.put("app/main/recommendatePortFolio/addNewRecommendedPortFolio.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span ng-show=\"!vm.recommendation._id\">\nAdd New Recommended Portfolio</span> <span ng-show=\"vm.recommendation._id\">Update Recommended Portfolio</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"backArrowColor\" \nui-sref=\"app.recommendatePortFolio\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div class=\"headerFixAllPages\"><div \nclass=\"padding-10\" ms-scroll><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"vm.wizardStep1\" class=\"md-inline-form\" novalidate><div class=\"form-title\" style=\"margin-bottom:1%\">\nRecommendation Scheme Information</div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex>\n<md-input-container flex=\"60\"><label>Port Folio Name</label><input name=\"portName\" \nng-model=\"vm.recommendation.portFolioName\" required><div ng-messages=\"vm.wizardStep1.portName.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><md-radio-group \nng-model=\"vm.recommendation.schemeType\" ng-click=\"vm.chooseMode()\" flex=\"30\"><md-radio-button value=\"SIP\" \nclass=\"md-primary\" style=\"margin-left:10%\">SIP</md-radio-button></md-radio-group><md-input-container flex=\"10\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.createRecommendation(); vm.wizardStep1.resetForm();\" \nng-disabled=\"!(vm.recommendation.portFolioName && vm.recommendation.description && vm.recommendation.schemeType && (vm.allSchemes.length > 0))\" \nstyle=\"color:#fff !important\"><span ng-show=\"!vm.recommendation._id\">Create</span> <span \nng-show=\"vm.recommendation._id\">Update</span></md-button></md-input-container><md-input-container class=\"md-block\" \nflex=\"100\"><label>Description</label><textarea ng-model=\"vm.recommendation.description\" md-maxlength=\"1000\" rows=\"3\" \nmd-select-on-focus></textarea></md-input-container></div><md-card-content flex flex-layout-wrap><md-autocomplete \nmd-input-name=\"amc\" ng-disabled=\"!vm.recommendation.schemeType\" md-menu-class=\"autocomplete-custom-template\" \nmd-selected-item-change=\"vm.getAllScheme(vm.recommendation.schemeDetail.amc)\" md-autofocus placeholder=\"AMC\" \nflex=\"100\" required md-floating-label=\"AMC\" md-selected-item=\"vm.recommendation.schemeDetail.amc\" \nmd-items=\"amc in vm.getMatches(searchText)\" md-search-text=\"searchText\" md-item-text=\"amc.LONG_NAME\"><md-item-template \nstyle=\"margin-bottom:15px\"><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{amc.LONG_NAME}}</span>\n</md-item-template><div ng-messages=\"vm.wizardStep1.amc.$error\"><div ng-message=\"required\">You <b>must</b> choose a AMC\n</div></div></md-autocomplete><md-autocomplete md-menu-class=\"autocomplete-custom-template\" \nng-disabled=\"!vm.recommendation.schemeDetail.amc\" md-input-name=\"scheme\" placeholder=\"Scheme\" flex=\"100\" required \nmd-floating-label=\"Scheme\" md-no-cache=\"true\" md-selected-item=\"vm.recommendation.schemeDetail.scheme\" \nmd-items=\"scheme in vm.getSchemeMatches(searchScheme)\" md-search-text=\"searchScheme\" \nmd-item-text=\"scheme.productDisplayName\"><md-item-template><span md-highlight-text=\"searchScheme\" \nmd-highlight-flags=\"^i\">{{scheme.productDisplayName}}</span></md-item-template><div \nng-messages=\"vm.wizardStep1.scheme.$error\" ng-if=\"vm.wizardStep1.scheme.$touched\"><div ng-message=\"required\">You <b>\nmust</b> choose a Scheme</div></div></md-autocomplete><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"number\" name=\"morningstarRating\" \nng-model=\"vm.recommendation.schemeDetail.morningstarRating\" placeholder=\"Morningstar Rating\" max=\"5\" min=\"1\"><div \nng-messages=\"vm.wizardStep1.morningstarRating.$error\"><div ng-message=\"min\">Star Rating must be between 1 to 5</div>\n<div ng-message=\"max\">Star Rating must be between 1 to 5</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\"><input type=\"number\" name=\"crisilRating\" \nng-model=\"vm.recommendation.schemeDetail.crisilRating\" placeholder=\"Crisil Rating\" max=\"5\" min=\"1\"><div \nng-messages=\"vm.wizardStep1.crisilRating.$error\"><div ng-message=\"min\">Star Rating must be between 1 to 5</div><div \nng-message=\"max\">Star Rating must be between 1 to 5</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"number\" name=\"valueResearchRating\" \nng-model=\"vm.recommendation.schemeDetail.valueResearchRating\" placeholder=\"Value Research Rating\" max=\"5\" min=\"1\"><div \nng-messages=\"vm.wizardStep1.valueResearchRating.$error\"><div ng-message=\"min\">Star Rating must be between 1 to 5</div>\n<div ng-message=\"max\">Star Rating must be between 1 to 5</div></div></md-input-container></div><md-input-container \nflex=\"80\"><label>Amount <i class=\"fa fa-inr\" aria-hidden=\"true\"></i></label><input name=\"amount\" \nng-model=\"vm.recommendation.schemeDetail.amount\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" required><div \nng-messages=\"vm.wizardStep1.amount.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-button ng-click=\"vm.addSchemes()\" \nng-disabled=\"!(vm.recommendation.schemeDetail.amc && vm.recommendation.schemeDetail.amount && vm.recommendation.schemeDetail.scheme)\" \nclass=\"md-accent md-raised\" style=\"color:#fff !important\">ADD</md-button></md-card-content></form><div \nclass=\"simple-table-container\"><div class=\"table-title\">Scheme Details</div><table class=\"simple\" ms-responsive-table>\n<thead><tr><th>S.No.</th><th>AMC</th><th>Scheme</th><th>Amount</th><th>Action</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.allSchemes\"><td>{{$index+1}}</td><td>{{item.amc.LONG_NAME}}</td><td>\n{{item.scheme.PRODUCT_LONG_NAME}}{{item.scheme.product_name}}</td><td>{{item.amount}}</td><td><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-show=\"vm.recommendation._id\"><md-button \nng-click=\"vm.showDeleteDialog(item, vm.recommendation, $index)\">Delete</md-button></md-menu-item><md-menu-item \nng-show=\"!vm.recommendation._id\"><md-button ng-click=\"vm.deletScheme($index)\">Delete</md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/main/recommendatePortFolio/recommendatePortFolio.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Recommended Portfolio</span></div></div>\n<div layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.recommendatePortFolio.addNewRecommendatePortFolio\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Add New</md-button></div></div><div class=\"headerFixAllPages\"><md-content \nlayout-xs=\"column\" layout=\"row\" layout-wrap ms-scroll><div flex-xs flex-gt-xs=\"33\" layout=\"column\" \nng-repeat=\"scheme in vm.recommendedAllPortFolioSchemes\"><md-card md-theme=\"dark-white\" md-theme-watch ms-scroll><div \nclass=\"cardScrollheight\"><div layout=\"row\"><div flex=\"100\"><h4 class=\"padding-5 headingColorTitle\">\n{{scheme.portFolioName}}</h4><h5 class=\"padding-5 headingColorTitle\">{{scheme.description}}</h5></div></div><div \nlayout=\"row\"><div flex=\"100\"><h4 class=\"padding-5 headingColorTitle\"><span class=\"headingColorTitleSip\">\n&nbsp;{{scheme.totalInvestment | currency: \"&#8377;\":0}}</span></h4></div></div><div \nng-repeat=\"item in scheme.schemeDetails\" class=\"bgColorForm1\" style=\"margin-top:5px;padding:2px\"><div \nclass=\"package-type1 padding-2\" layout=\"row\" layout-wrap><div flex=\"80\"><span style=\"font-size:14px;font-weight:bold\" \nng-bind=\"item.product_name | limitTo:40\"><md-tooltip md-direction=\"top\" style=\"font-size:12px\">{{item.product_name}}\n</md-tooltip>{{item.product_name}}</span></div><div flex=\"20\"><h4 class=\"headingColorTitleSip pull-right\" \nstyle=\"margin-right:10px;margin-top:1%\"><b><i class=\"fa fa-inr\" aria-hidden=\"true\">{{item.amount}}</i></b></h4></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div flex=\"33\"><h5 class=\"padding-5 headingColor\">\n{{(item.productMoreDetails[\'DP-Return1Yr\']) ? (item.productMoreDetails[\'DP-Return1Yr\'] | number:3)+ \'%\' : \'NA\'}}</h5>\n<h5 class=\"padding-5 headingColor1\">1 Yrs</h5></div><div flex=\"33\"><h5 class=\"padding-5 headingColor\">\n{{(item.productMoreDetails[\'DP-Return3Yr\']) ? (item.productMoreDetails[\'DP-Return3Yr\'] | number:3) + \'%\' : \'NA\'}}</h5>\n<h5 class=\"padding-5 headingColor1\">3 Yrs</h5></div><div flex=\"33\"><h5 class=\"padding-5 headingColor\">\n{{(item.productMoreDetails[\'DP-Return5Yr\']) ? (item.productMoreDetails[\'DP-Return5Yr\'] | number:3) + \'%\' : \'NA\'}}</h5>\n<h5 class=\"padding-5 headingColor1\">5 Yrs</h5></div><div flex=\"33\"><h5 class=\"padding-5 headingColor\">\n{{item.morningstarRating ? item.morningstarRating : \'NA\'}}</h5><h5 class=\"padding-5 headingColor1\">MSR</h5></div><div \nflex=\"33\"><h5 class=\"padding-5 headingColor\">{{item.valueResearchRating ? item.valueResearchRating : \'NA\'}}</h5><h5 \nclass=\"padding-5 headingColor1\">VSR</h5></div><div flex=\"33\"><h5 class=\"padding-5 headingColor\">\n{{item.crisilRating ? item.crisilRating : \'NA\'}}</h5><h5 class=\"padding-5 headingColor1\">CR</h5></div></div></div>\n</div><md-card-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.editRecommendation(scheme)\" class=\"md-icon-button md-accent\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button><md-button ng-click=\"vm.showDeleteDialog(scheme)\" class=\"md-icon-button md-accent\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></md-card-actions></md-card></div></md-content></div></div>");
$templateCache.put("app/main/recommendations/createRecommendedschemes.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div cclass=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span \nng-show=\"!vm.recommendation._id\">Create New Recommendation</span> <span ng-show=\"vm.recommendation._id\">\nUpdate Recommendation</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"backArrowColor\" ui-sref=\"app.recommendations\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div \nclass=\"headerFixAllPages\"><div class=\"padding-10\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex>\n<form name=\"wizardStep1\" class=\"md-inline-form\" novalidate><div class=\"form-title\" style=\"margin-bottom: 1%\">\nRecommendation Scheme Information</div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex>\n<md-autocomplete md-input-name=\"amc\" md-menu-class=\"autocomplete-custom-template\" \nmd-selected-item-change=\"vm.getAllScheme(vm.recommendation.amc)\" md-autofocus placeholder=\"AMC\" flex=\"100\" required \nmd-floating-label=\"AMC\" md-selected-item=\"vm.recommendation.amc\" md-items=\"amc in vm.getMatches(searchText)\" \nmd-search-text=\"searchText\" md-item-text=\"amc.LONG_NAME\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{amc.LONG_NAME}}</span></md-item-template><md-not-found>\nNo AMC matching \"{{searchText}}\" were found.</md-not-found><div ng-messages=\"wizardStep1.amc.$error\" \nng-if=\"wizardStep1.amc.$touched\"><div ng-message=\"required\">You <b>must</b> choose a AMC</div></div></md-autocomplete>\n<md-autocomplete md-menu-class=\"autocomplete-custom-template\" ng-disabled=\"!vm.recommendation.amc\" \nmd-input-name=\"scheme\" placeholder=\"Scheme\" flex=\"100\" required md-floating-label=\"Scheme\" md-no-cache=\"true\" \nmd-selected-item=\"vm.recommendation.scheme\" md-items=\"scheme in vm.getSchemeMatches(searchScheme)\" \nmd-search-text=\"searchScheme\" md-item-text=\"scheme.productDisplayName\"><md-item-template><span \nmd-highlight-text=\"searchScheme\" md-highlight-flags=\"^i\">{{scheme.productDisplayName}}</span></md-item-template>\n<md-not-found>No AMC matching \"{{searchScheme}}\" were found.</md-not-found><div \nng-messages=\"wizardStep1.scheme.$error\" ng-if=\"wizardStep1.scheme.$touched\"><div ng-message=\"required\">You <b>must</b>\n choose a Scheme</div></div></md-autocomplete><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"productCustomCategory\" ng-model=\"vm.recommendation.productCustomCategory\" placeholder=\"Product Custom Category\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"morningstarRating\" \nng-model=\"vm.recommendation.morningstarRating\" placeholder=\"Morningstar Rating\" max=\"5\" min=\"1\"><div \nng-messages=\"wizardStep1.morningstarRating.$error\"><div ng-message=\"min\">Star Rating must be between 1 to 5</div><div \nng-message=\"max\">Star Rating must be between 1 to 5</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"number\" name=\"crisilRating\" ng-model=\"vm.recommendation.crisilRating\" \nplaceholder=\"Crisil Rating\" max=\"5\" min=\"1\"><div ng-messages=\"wizardStep1.crisilRating.$error\"><div ng-message=\"min\">\nStar Rating must be between 1 to 5</div><div ng-message=\"max\">Star Rating must be between 1 to 5</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"valueResearchRating\" \nng-model=\"vm.recommendation.valueResearchRating\" placeholder=\"Value Research Rating\" max=\"5\" min=\"1\"><div \nng-messages=\"wizardStep1.valueResearchRating.$error\"><div ng-message=\"min\">Star Rating must be between 1 to 5</div><div\n ng-message=\"max\">Star Rating must be between 1 to 5</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"number\" name=\"amount\" ng-model=\"vm.recommendation.amount\" step=\"500\" placeholder=\"Amount\" \nmin=\"1000\" required><div ng-messages=\"wizardStep1.amount.$error\"><div ng-message=\"min\">\nMinimum amount atleast 1000 and in multiple of 500</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Custom Category Tab</label><md-select class=\"margin-bottom-25\" name=\"customCategoryTab\" \nplaceholder=\"Custom Category\" required ng-model=\"vm.recommendation.customCategoryTab\" required><md-option \nng-repeat=\"catgry in vm.customCatagories\" ng-value=\"catgry\">{{catgry}}</md-option></md-select><div \nng-messages=\"wizardStep1.customCategoryTab.$error\"><div ng-message=\"required\">Custom Category field is required.</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label>Description</label><textarea \nng-model=\"vm.recommendation.description\" rows=\"5\" md-select-on-focus></textarea></md-input-container></div><md-button \nng-show=\"!vm.recommendation._id\" class=\"md-raised md-accent\" \nng-click=\"vm.createRecommendation(); wizardStep1.resetForm();\" ng-disabled=\"vm.validateform() || wizardStep1.$invalid\" \nstyle=\"color:#fff !important\">Create</md-button><md-button ng-show=\"vm.recommendation._id\" class=\"md-raised md-accent\" \nng-click=\"vm.createRecommendation(); wizardStep1.resetForm();\" ng-disabled=\"vm.validateform() || wizardStep1.$invalid\" \nstyle=\"color:#fff !important\">Update</md-button></form></div></div></div></div></div>");
$templateCache.put("app/main/recommendations/recommendations.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Recommendations</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.createNewRecommendations\" style=\"color:#fff !important\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\nAdd New</md-button></div></div><div class=\"headerFixAllPages\"><md-content layout-xs=\"column\" layout=\"row\" layout-wrap>\n<div flex-xs flex-gt-xs=\"33\" layout=\"column\" class=\"md-whiteframe-2dp\" ng-repeat=\"scheme in vm.recommendedSchemes\">\n<md-card md-theme=\"dark-white\" md-theme-watch><md-card-title style=\"height:220px; min-height:220px; max-height:220px\">\n<md-card-title-text layout-align=\"space-between center\" class=\"app-body\"><span class=\"md-headline\" \nstyle=\"font-size:21px\">{{scheme.productAmcName}}</span> <span class=\"md-subhead\"><b>{{scheme.productName}}</b> </span>\n<span style=\"margin-top:4%\"><b>Product Custom Category: </b>\n{{scheme.productCustomCategory ? scheme.productCustomCategory : \'NA\'}}</span> <span style=\"margin-top:4%\"><b>\nProduct Custom Category Tab: </b>{{scheme.customCategoryTab ? scheme.customCategoryTab : \'NA\'}} </span><span \nclass=\"truncate\" style=\"margin-top:3%\"><b>Description: </b>{{scheme.description ? scheme.description : \'-\'}}</span><div\n layout=\"row\" flex style=\"width:80%;margin-top:3%\" layout-align=\"center center\"><span flex=\"33\">\nMR: {{scheme.morningstarRating ? scheme.morningstarRating : \'-\'}}</span> <span flex=\"33\">\nVR: {{scheme.valueResearchRating ? scheme.valueResearchRating : \'-\'}}</span> <span flex=\"33\">\nCR: {{scheme.crisilRating ? scheme.crisilRating : \'-\'}}</span></div></md-card-title-text></md-card-title>\n<md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.editRecommendation(scheme)\" \nclass=\"md-icon-button md-accent\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nng-click=\"vm.showDeleteDialog(scheme)\" class=\"md-icon-button md-accent\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></md-card-actions></md-card></div></md-content></div></div>");
$templateCache.put("app/main/revive-pdf-manager/revive-pdf-manager.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"revivePdfManager\" \nstyle=\"overflow-y:auto; height:100%\"><div class=\"header md-accent-bg height-60\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin:0\"><md-icon md-font-icon=\"icon-file-pdf-box\" \nstyle=\"color:#fff; margin-right:10px; font-size:22px\"></md-icon><span>Revive PDF Manager</span></div><div \nclass=\"secondary-text white-fg\" style=\"font-size:12px; margin-top:4px\">\nSearch members · Download PDFs · Upload COI · Generate Wellness &amp; Merge PDFs</div></div></div><div \nng-if=\"vm.alertMsg\" \nstyle=\"margin:12px 16px 0; background:#FFEBEE; border-left:4px solid #C62828; border-radius:4px; padding:10px 16px; color:#B71C1C; font-weight:600; font-size:13px\">\n&#9888;&nbsp; {{ vm.alertMsg }}</div><md-card style=\"margin:14px 16px 0; padding:0; overflow:hidden\"><div \nclass=\"md-accent-bg\" \nstyle=\"padding:10px 18px; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:8px\">\n<span class=\"white-fg\" style=\"font-size:14px; font-weight:700\">&#128269; Search Members by SOCCODE</span><div \nng-if=\"vm.memberResult\" style=\"color:rgba(255,255,255,0.85); font-size:12px\">\n{{ vm.memberResult.societyName || vm.memberResult.SOCCODE }} &nbsp;·&nbsp; {{ vm.memberResult.total }} members</div>\n</div><div style=\"padding:14px 18px\"><div layout=\"row\" layout-align=\"start center\" style=\"gap:14px; flex-wrap:wrap\">\n<md-input-container style=\"margin:0; padding:0; min-width:220px; flex:0 0 220px\"><label style=\"font-size:12px\">\nSociety Code (SOCCODE)</label><input type=\"text\" ng-model=\"vm.socCode\" placeholder=\"e.g. SOC304\" \nng-keyup=\"$event.keyCode == 13 ? vm.searchData() : null\" style=\"font-size:13px\"></md-input-container><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.searchData()\" ng-disabled=\"vm.searching\" \nstyle=\"margin:0; font-size:13px; font-weight:700\"><md-icon md-font-icon=\"icon-magnify\" style=\"color:#fff\"></md-icon>\n{{ vm.searching ? \'Searching...\' : \'Search\' }}</md-button><div \nng-if=\"vm.memberResult && vm.memberResult.data && vm.memberResult.data.length\" \nstyle=\"display:flex; gap:8px; flex-wrap:wrap; margin-left:8px\"><md-button class=\"md-raised\" \nng-click=\"vm.downloadZip(\'life\')\" ng-disabled=\"vm.zippingType.life\" \nstyle=\"margin:0; font-size:11px; background:#1565C0; color:#fff; font-weight:600\" \nng-style=\"{\'opacity\': vm.zippingType.life ? \'0.6\' : \'1\'}\">\n&#128230; {{ vm.zippingType.life ? \'Zipping...\' : \'Life PDFs ZIP\' }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.downloadZip(\'acc\')\" ng-disabled=\"vm.zippingType.acc\" \nstyle=\"margin:0; font-size:11px; background:#2E7D32; color:#fff; font-weight:600\" \nng-style=\"{\'opacity\': vm.zippingType.acc ? \'0.6\' : \'1\'}\">\n&#128230; {{ vm.zippingType.acc ? \'Zipping...\' : \'ACC PDFs ZIP\' }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.downloadZip(\'wellness\')\" ng-disabled=\"vm.zippingType.wellness\" \nstyle=\"margin:0; font-size:11px; background:#6A1B9A; color:#fff; font-weight:600\" \nng-style=\"{\'opacity\': vm.zippingType.wellness ? \'0.6\' : \'1\'}\">\n&#128230; {{ vm.zippingType.wellness ? \'Zipping...\' : \'Wellness PDFs ZIP\' }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.downloadZip(\'final\')\" ng-disabled=\"vm.zippingType.final\" \nstyle=\"margin:0; font-size:11px; background:#E65100; color:#fff; font-weight:600\" \nng-style=\"{\'opacity\': vm.zippingType.final ? \'0.6\' : \'1\'}\">\n&#128230; {{ vm.zippingType.final ? \'Zipping...\' : \'Final PDFs ZIP\' }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.downloadExcel()\" ng-disabled=\"vm.downloadingExcel\" \nstyle=\"margin:0; font-size:11px; background:#1B5E20; color:#fff; font-weight:600\" \nng-style=\"{\'opacity\': vm.downloadingExcel ? \'0.6\' : \'1\'}\">\n&#128202; {{ vm.downloadingExcel ? \'Exporting...\' : \'Download Excel\' }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.clearList()\" style=\"margin:0; font-size:11px; background:#546E7A; color:#fff; font-weight:600\">\n&#10005; Clear List</md-button></div></div></div><div \nng-if=\"vm.memberResult && vm.memberResult.data && vm.memberResult.data.length > 0\"><div style=\"overflow-x:auto\"><table \nstyle=\"width:100%; border-collapse:collapse; font-size:13px; min-width:1000px\"><thead><tr \nstyle=\"background:#1565C0; color:#fff\"><th \nstyle=\"padding:10px 12px; text-align:left; font-weight:700; white-space:nowrap\">#</th><th \nstyle=\"padding:10px 12px; text-align:left; font-weight:700; white-space:nowrap\">Cust ID</th><th \nstyle=\"padding:10px 12px; text-align:left; font-weight:700; white-space:nowrap\">Name</th><th \nstyle=\"padding:10px 12px; text-align:left; font-weight:700; white-space:nowrap\">Mobile</th><th \nstyle=\"padding:10px 12px; text-align:left; font-weight:700; white-space:nowrap\">Password</th><th \nstyle=\"padding:10px 12px; text-align:left; font-weight:700; white-space:nowrap\">Society</th><th \nstyle=\"padding:10px 12px; text-align:center; font-weight:700; white-space:nowrap\">Life PDF</th><th \nstyle=\"padding:10px 12px; text-align:center; font-weight:700; white-space:nowrap\">ACC PDF</th><th \nstyle=\"padding:10px 12px; text-align:center; font-weight:700; white-space:nowrap\">Wellness PDF</th><th \nstyle=\"padding:10px 12px; text-align:center; font-weight:700; white-space:nowrap\">Final PDF</th></tr></thead><tbody><tr\n ng-repeat=\"m in vm.memberPageData() track by $index\" style=\"border-bottom:1px solid #ECEFF1\" \nng-style=\"{\'background\': $index % 2 === 0 ? \'#fff\' : \'#F8FAFC\'}\"><td \nstyle=\"padding:9px 12px; color:#78909C; font-size:12px\">{{ (vm.searchPg - 1) * 10 + $index + 1 }}</td><td \nstyle=\"padding:9px 12px; font-weight:700; color:#1565C0; white-space:nowrap; font-size:12px\">{{ m.custId || \'—\' }}</td>\n<td style=\"padding:9px 12px; white-space:nowrap; font-weight:500\">{{ m.customerName || \'—\' }}</td><td \nstyle=\"padding:9px 12px; white-space:nowrap\">{{ m.mobileNo || \'—\' }}</td><td \nstyle=\"padding:9px 12px; font-family:monospace; color:#546E7A; font-size:12px\">{{ m.password || \'—\' }}</td><td \nstyle=\"padding:9px 12px; font-size:11px; color:#546E7A; max-width:180px\">{{ m.societyName || \'—\' }}</td><td \nstyle=\"padding:9px 12px; text-align:center\"><a ng-if=\"m.insurancedoc_life\" ng-href=\"{{ m.insurancedoc_life }}\" \ntarget=\"_blank\" \nstyle=\"padding:3px 10px; background:#1565C0; color:#fff; border-radius:4px; font-size:11px; font-weight:700; text-decoration:none; white-space:nowrap; display:inline-block\">\n&#11015; Life </a><span ng-if=\"!m.insurancedoc_life\" style=\"color:#CFD8DC; font-size:11px\">—</span></td><td \nstyle=\"padding:9px 12px; text-align:center\"><a ng-if=\"m.insurancedoc_acc\" ng-href=\"{{ m.insurancedoc_acc }}\" \ntarget=\"_blank\" \nstyle=\"padding:3px 10px; background:#2E7D32; color:#fff; border-radius:4px; font-size:11px; font-weight:700; text-decoration:none; white-space:nowrap; display:inline-block\">\n&#11015; ACC </a><span ng-if=\"!m.insurancedoc_acc\" style=\"color:#CFD8DC; font-size:11px\">—</span></td><td \nstyle=\"padding:9px 12px; text-align:center\"><a ng-if=\"m.insurancedoc_wellness\" ng-href=\"{{ m.insurancedoc_wellness }}\" \ntarget=\"_blank\" \nstyle=\"padding:3px 10px; background:#6A1B9A; color:#fff; border-radius:4px; font-size:11px; font-weight:700; text-decoration:none; white-space:nowrap; display:inline-block\">\n&#11015; Wellness </a><span ng-if=\"!m.insurancedoc_wellness\" style=\"color:#CFD8DC; font-size:11px\">—</span></td><td \nstyle=\"padding:9px 12px; text-align:center\"><a ng-if=\"m.insurancedoc_final\" ng-href=\"{{ m.insurancedoc_final }}\" \ntarget=\"_blank\" \nstyle=\"padding:3px 10px; background:#E65100; color:#fff; border-radius:4px; font-size:11px; font-weight:700; text-decoration:none; white-space:nowrap; display:inline-block\">\n&#11015; Final </a><span ng-if=\"!m.insurancedoc_final\" style=\"color:#CFD8DC; font-size:11px\">—</span></td></tr></tbody>\n</table></div><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding:10px 16px; border-top:1px solid #ECEFF1; background:#FAFBFC; flex-wrap:wrap; gap:8px\"><span \nstyle=\"font-size:12px; color:#78909C\">{{ vm.memberShowingInfo() }}</span><div ng-if=\"vm.memberTotalPages() > 1\" \nlayout=\"row\" style=\"gap:4px\"><button ng-click=\"vm.memberGoPage(1)\" ng-disabled=\"vm.searchPg===1\" \nstyle=\"padding:4px 9px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer\" \nng-style=\"{\'opacity\':vm.searchPg===1?\'0.4\':\'1\'}\">&#171;</button> <button ng-click=\"vm.memberGoPage(vm.searchPg-1)\" \nng-disabled=\"vm.searchPg===1\" \nstyle=\"padding:4px 9px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer\" \nng-style=\"{\'opacity\':vm.searchPg===1?\'0.4\':\'1\'}\">&#8249;</button> <button \nng-repeat=\"p in vm.memberPageRange() track by p\" ng-click=\"vm.memberGoPage(p)\" \nstyle=\"padding:4px 9px; border:1px solid #CFD8DC; border-radius:4px; font-size:12px; cursor:pointer; min-width:30px\" \nng-style=\"{\'background\':vm.searchPg===p?\'#1565C0\':\'#fff\',\'color\':vm.searchPg===p?\'#fff\':\'#546E7A\',\'font-weight\':vm.searchPg===p?\'700\':\'400\'}\">\n{{ p }}</button> <button ng-click=\"vm.memberGoPage(vm.searchPg+1)\" ng-disabled=\"vm.searchPg===vm.memberTotalPages()\" \nstyle=\"padding:4px 9px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer\" \nng-style=\"{\'opacity\':vm.searchPg===vm.memberTotalPages()?\'0.4\':\'1\'}\">&#8250;</button> <button \nng-click=\"vm.memberGoPage(vm.memberTotalPages())\" ng-disabled=\"vm.searchPg===vm.memberTotalPages()\" \nstyle=\"padding:4px 9px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer\" \nng-style=\"{\'opacity\':vm.searchPg===vm.memberTotalPages()?\'0.4\':\'1\'}\">&#187;</button></div></div></div><div \nng-if=\"vm.memberResult && vm.memberResult.data && vm.memberResult.data.length === 0\" \nstyle=\"padding:28px; text-align:center; color:#90A4AE; font-size:13px\">No members found for SOCCODE <strong>\n{{ vm.memberResult.SOCCODE }}</strong>.</div></md-card><div layout=\"row\" layout-wrap \nstyle=\"margin:14px 16px 16px; gap:14px; align-items:flex-start\"><md-card \nstyle=\"flex:1; min-width:280px; padding:0; overflow:hidden; margin:0\"><div \nstyle=\"background:#37474F; padding:10px 16px; display:flex; align-items:center; justify-content:space-between\"><span \nstyle=\"color:#fff; font-size:13px; font-weight:700\">&#11014; Upload COI PDFs to Server</span> <button \nng-if=\"vm.uploadResult || vm.coiFiles.length\" ng-click=\"vm.clearUpload()\" \nstyle=\"background:rgba(255,255,255,0.18); border:1px solid rgba(255,255,255,0.4); color:#fff; border-radius:4px; padding:2px 10px; font-size:11px; font-weight:700; cursor:pointer; line-height:1.6\">\n&#10005; Clear</button></div><div style=\"padding:14px 16px\"><label for=\"coi-file-input\" \nstyle=\"display:flex; align-items:center; gap:10px; border:2px dashed #546E7A; border-radius:6px; padding:10px 14px; cursor:pointer; background:#ECEFF1; transition:background 0.2s; margin-bottom:12px\" \nonmouseover=\"this.style.background=\'#CFD8DC\'\" onmouseout=\"this.style.background=\'#ECEFF1\'\"><span \nstyle=\"font-size:1.4rem\">&#128196;</span><div><div style=\"font-size:13px; font-weight:700; color:#37474F\">\nClick to select PDF files</div><div style=\"font-size:11px; color:#78909C\">\nMultiple PDFs allowed · Duplicates auto-skipped</div></div><input type=\"file\" id=\"coi-file-input\" accept=\".pdf\" \nmultiple=\"multiple\" style=\"display:none\" onchange=\"angular.element(this).scope().vm.onCoiFileChange(this)\"></label><div\n ng-if=\"vm.coiFiles.length\" \nstyle=\"margin-bottom:10px; padding:6px 12px; background:#E8F5E9; border-radius:5px; font-size:12px; color:#2E7D32; font-weight:600\">\n&#10004; {{ vm.coiFiles.length }} PDF file(s) selected</div><md-button class=\"md-raised\" ng-click=\"vm.uploadCoiPdfs()\" \nng-disabled=\"!vm.coiFiles.length || vm.uploading\" \nstyle=\"margin:0; width:100%; font-size:13px; font-weight:700; background:#37474F; color:#fff\" \nng-style=\"{\'opacity\':(!vm.coiFiles.length||vm.uploading)?\'0.5\':\'1\'}\">\n{{ vm.uploading ? \'Uploading...\' : \'Upload to Server\' }}</md-button><div ng-if=\"vm.uploadResult\" \nstyle=\"margin-top:14px\"><div layout=\"row\" style=\"gap:8px; margin-bottom:12px; flex-wrap:wrap\"><div \nstyle=\"flex:1; text-align:center; padding:8px; border-radius:6px; background:#E3F2FD\"><div \nstyle=\"font-size:1.3rem; font-weight:800; color:#1565C0\">{{ vm.uploadResult.totalFiles }}</div><div \nstyle=\"font-size:10px; font-weight:700; color:#1565C0\">TOTAL</div></div><div \nstyle=\"flex:1; text-align:center; padding:8px; border-radius:6px; background:#E8F5E9\"><div \nstyle=\"font-size:1.3rem; font-weight:800; color:#2E7D32\">{{ vm.uploadResult.successCount }}</div><div \nstyle=\"font-size:10px; font-weight:700; color:#2E7D32\">UPLOADED</div></div><div \nstyle=\"flex:1; text-align:center; padding:8px; border-radius:6px; background:#FFF8E1\"><div \nstyle=\"font-size:1.3rem; font-weight:800; color:#E65100\">{{ vm.uploadResult.skippedCount }}</div><div \nstyle=\"font-size:10px; font-weight:700; color:#E65100\">SKIPPED</div></div><div \nstyle=\"flex:1; text-align:center; padding:8px; border-radius:6px; background:#FFEBEE\"><div \nstyle=\"font-size:1.3rem; font-weight:800; color:#C62828\">{{ vm.uploadResult.failureCount }}</div><div \nstyle=\"font-size:10px; font-weight:700; color:#C62828\">FAILED</div></div></div><div \nng-if=\"vm.uploadResult.successFileNames && vm.uploadResult.successFileNames.length\"><div \nstyle=\"font-size:11px; font-weight:700; color:#2E7D32; margin-bottom:4px; text-transform:uppercase; letter-spacing:0.5px\">\n&#10004; Uploaded ({{ vm.uploadResult.successFileNames.length }})</div><div \nstyle=\"max-height:120px; overflow-y:auto; background:#F1F8E9; border-radius:4px; padding:6px 10px\"><div \nng-repeat=\"f in vm.uploadListPage(vm.uploadResult.successFileNames, \'success\') track by $index\" \nstyle=\"font-size:11px; color:#33691E; padding:2px 0; border-bottom:1px solid #DCEDC8; font-family:monospace\">\n{{ ($index + 1 + (vm.uploadPg.success - 1) * 10) }}. {{ f }}</div></div><div \nng-if=\"vm.uploadTotalPages(vm.uploadResult.successFileNames, \'success\') > 1\" layout=\"row\" layout-align=\"end center\" \nstyle=\"margin-top:4px; gap:4px\"><button ng-click=\"vm.uploadGoPage(\'success\', vm.uploadPg.success - 1)\" \nstyle=\"padding:2px 8px; border:1px solid #CFD8DC; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\">\n&#8249;</button> <span style=\"font-size:11px; color:#78909C\">\n{{ vm.uploadPg.success }}/{{ vm.uploadTotalPages(vm.uploadResult.successFileNames,\'success\') }}</span> <button \nng-click=\"vm.uploadGoPage(\'success\', vm.uploadPg.success + 1)\" \nstyle=\"padding:2px 8px; border:1px solid #CFD8DC; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\">\n&#8250;</button></div></div><div ng-if=\"vm.uploadResult.skippedFileNames && vm.uploadResult.skippedFileNames.length\" \nstyle=\"margin-top:10px\"><div \nstyle=\"font-size:11px; font-weight:700; color:#E65100; margin-bottom:4px; text-transform:uppercase; letter-spacing:0.5px\">\n&#9889; Skipped / Duplicate ({{ vm.uploadResult.skippedFileNames.length }})</div><div \nstyle=\"background:#FFF8E1; border-radius:4px; padding:6px 10px\"><div \nng-repeat=\"f in vm.uploadListPage(vm.uploadResult.skippedFileNames, \'skipped\') track by $index\" \nstyle=\"font-size:11px; color:#BF360C; padding:2px 0; border-bottom:1px solid #FFE0B2; font-family:monospace\">\n{{ ($index + 1 + (vm.uploadPg.skipped - 1) * 10) }}. {{ f }}</div></div><div \nng-if=\"vm.uploadTotalPages(vm.uploadResult.skippedFileNames, \'skipped\') > 1\" layout=\"row\" layout-align=\"end center\" \nstyle=\"margin-top:4px; gap:4px\"><button ng-click=\"vm.uploadGoPage(\'skipped\', vm.uploadPg.skipped - 1)\" \nstyle=\"padding:2px 8px; border:1px solid #FFE0B2; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\">\n&#8249;</button> <span style=\"font-size:11px; color:#78909C\">\n{{ vm.uploadPg.skipped }}/{{ vm.uploadTotalPages(vm.uploadResult.skippedFileNames,\'skipped\') }}</span> <button \nng-click=\"vm.uploadGoPage(\'skipped\', vm.uploadPg.skipped + 1)\" \nstyle=\"padding:2px 8px; border:1px solid #FFE0B2; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\">\n&#8250;</button></div></div><div ng-if=\"vm.uploadResult.failedFileDetails && vm.uploadResult.failedFileDetails.length\" \nstyle=\"margin-top:10px\"><div \nstyle=\"font-size:11px; font-weight:700; color:#C62828; margin-bottom:4px; text-transform:uppercase; letter-spacing:0.5px\">\n&#10008; Failed ({{ vm.uploadResult.failedFileDetails.length }})</div><div \nstyle=\"background:#FFEBEE; border-radius:4px; padding:6px 10px\"><div \nng-repeat=\"f in vm.uploadListPage(vm.uploadResult.failedFileDetails, \'failed\') track by $index\" \nstyle=\"font-size:11px; color:#B71C1C; padding:2px 0; border-bottom:1px solid #FFCDD2\">\n{{ ($index + 1 + (vm.uploadPg.failed - 1) * 10) }}. {{ f.fileName }} — {{ f.error }}</div></div><div \nng-if=\"vm.uploadTotalPages(vm.uploadResult.failedFileDetails, \'failed\') > 1\" layout=\"row\" layout-align=\"end center\" \nstyle=\"margin-top:4px; gap:4px\"><button ng-click=\"vm.uploadGoPage(\'failed\', vm.uploadPg.failed - 1)\" \nstyle=\"padding:2px 8px; border:1px solid #FFCDD2; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\">\n&#8249;</button> <span style=\"font-size:11px; color:#78909C\">\n{{ vm.uploadPg.failed }}/{{ vm.uploadTotalPages(vm.uploadResult.failedFileDetails,\'failed\') }}</span> <button \nng-click=\"vm.uploadGoPage(\'failed\', vm.uploadPg.failed + 1)\" \nstyle=\"padding:2px 8px; border:1px solid #FFCDD2; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\">\n&#8250;</button></div></div></div></div></md-card><md-card \nstyle=\"flex:1; min-width:260px; padding:0; overflow:hidden; margin:0\"><div \nstyle=\"background:#6A1B9A; padding:10px 16px; display:flex; align-items:center; justify-content:space-between\"><span \nstyle=\"color:#fff; font-size:13px; font-weight:700\">&#127381; Generate Wellness PDFs</span> <button \nng-if=\"vm.wellnessResult || vm.wellnessSocCode\" ng-click=\"vm.clearWellness()\" \nstyle=\"background:rgba(255,255,255,0.18); border:1px solid rgba(255,255,255,0.4); color:#fff; border-radius:4px; padding:2px 10px; font-size:11px; font-weight:700; cursor:pointer; line-height:1.6\">\n&#10005; Clear</button></div><div style=\"padding:14px 16px\"><div \nstyle=\"font-size:12px; color:#546E7A; margin-bottom:10px; padding:8px 10px; background:#F3E5F5; border-radius:4px; border-left:3px solid #6A1B9A\">\nCreates wellness certificate PDF for each member of the society and saves URL to DB.</div><label \nstyle=\"font-size:12px; font-weight:600; color:#37474F; margin-bottom:4px; display:block\">Society Code (SOCCODE)</label>\n<md-input-container style=\"margin:0 0 12px; padding:0; width:100%\"><input type=\"text\" ng-model=\"vm.wellnessSocCode\" \nplaceholder=\"e.g. SOC304\" style=\"font-size:13px\"></md-input-container><md-button class=\"md-raised\" \nng-click=\"vm.generateWellness()\" ng-disabled=\"vm.generatingWellness\" \nstyle=\"margin:0; width:100%; font-size:13px; font-weight:700; background:#6A1B9A; color:#fff\" \nng-style=\"{\'opacity\':vm.generatingWellness?\'0.6\':\'1\'}\">\n{{ vm.generatingWellness ? \'Generating...\' : \'Generate Wellness PDFs\' }}</md-button><div ng-if=\"vm.wellnessResult\" \nstyle=\"margin-top:14px\"><div \nstyle=\"padding:8px 12px; border-radius:5px; font-size:12px; font-weight:600; margin-bottom:10px\" \nng-style=\"{\'background\': vm.wellnessResult.validFlag ? \'#E8F5E9\' : \'#FFEBEE\', \'color\': vm.wellnessResult.validFlag ? \'#2E7D32\' : \'#C62828\'}\">\n{{ vm.wellnessResult.responseString || (vm.wellnessResult.validFlag ? \'Completed\' : \'Failed\') }}</div><div \nng-if=\"vm.wellnessResult.results && vm.wellnessResult.results.length\"><div \nstyle=\"font-size:11px; color:#78909C; margin-bottom:6px\">\nShowing {{ (vm.wellnessPg-1)*10+1 }}–{{ vm.wellnessPg*10 > vm.wellnessResult.results.length ? vm.wellnessResult.results.length : vm.wellnessPg*10 }} of {{ vm.wellnessResult.results.length }} entries\n</div><div style=\"border-radius:4px; border:1px solid #ECEFF1; overflow:hidden\"><table \nstyle=\"width:100%; border-collapse:collapse; font-size:11px\"><thead><tr style=\"background:#6A1B9A; color:#fff\"><th \nstyle=\"padding:6px 10px; text-align:left; font-weight:700\">#</th><th \nstyle=\"padding:6px 10px; text-align:left; font-weight:700\">Mobile</th><th \nstyle=\"padding:6px 10px; text-align:left; font-weight:700\">Status</th></tr></thead><tbody><tr \nng-repeat=\"r in vm.wellnessPageData() track by $index\" ng-style=\"{\'background\': $index%2===0?\'#fff\':\'#F9F0FF\'}\"><td \nstyle=\"padding:5px 10px; color:#78909C\">{{ (vm.wellnessPg-1)*10 + $index + 1 }}</td><td \nstyle=\"padding:5px 10px; font-family:monospace\">{{ r.mobileNo || \'—\' }}</td><td style=\"padding:5px 10px\"><span \nstyle=\"padding:2px 8px; border-radius:10px; font-size:10px; font-weight:700; text-transform:uppercase\" \nng-style=\"{\'background\':r.status===\'success\'?\'#E8F5E9\':\'#FFEBEE\',\'color\':r.status===\'success\'?\'#2E7D32\':\'#C62828\'}\">\n{{ r.status }}</span></td></tr></tbody></table></div><div ng-if=\"vm.wellnessTotalPages() > 1\" layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top:8px; gap:4px; flex-wrap:wrap\"><button ng-click=\"vm.wellnessGoPage(1)\" \nng-disabled=\"vm.wellnessPg===1\" \nstyle=\"padding:2px 8px; border:1px solid #CE93D8; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.wellnessPg===1?\'0.4\':\'1\'}\">&#171;</button> <button \nng-click=\"vm.wellnessGoPage(vm.wellnessPg-1)\" ng-disabled=\"vm.wellnessPg===1\" \nstyle=\"padding:2px 8px; border:1px solid #CE93D8; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.wellnessPg===1?\'0.4\':\'1\'}\">&#8249;</button> <span \nstyle=\"font-size:11px; color:#6A1B9A; font-weight:700; padding:2px 10px\">\n{{ vm.wellnessPg }} / {{ vm.wellnessTotalPages() }}</span> <button ng-click=\"vm.wellnessGoPage(vm.wellnessPg+1)\" \nng-disabled=\"vm.wellnessPg===vm.wellnessTotalPages()\" \nstyle=\"padding:2px 8px; border:1px solid #CE93D8; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.wellnessPg===vm.wellnessTotalPages()?\'0.4\':\'1\'}\">&#8250;</button> <button \nng-click=\"vm.wellnessGoPage(vm.wellnessTotalPages())\" ng-disabled=\"vm.wellnessPg===vm.wellnessTotalPages()\" \nstyle=\"padding:2px 8px; border:1px solid #CE93D8; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.wellnessPg===vm.wellnessTotalPages()?\'0.4\':\'1\'}\">&#187;</button></div></div></div></div>\n</md-card><md-card style=\"flex:1; min-width:260px; padding:0; overflow:hidden; margin:0\"><div \nstyle=\"background:#E65100; padding:10px 16px; display:flex; align-items:center; justify-content:space-between\"><span \nstyle=\"color:#fff; font-size:13px; font-weight:700\">&#128209; Generate Merge PDFs</span> <button \nng-if=\"vm.mergeResult || vm.mergeSocCode\" ng-click=\"vm.clearMerge()\" \nstyle=\"background:rgba(255,255,255,0.18); border:1px solid rgba(255,255,255,0.4); color:#fff; border-radius:4px; padding:2px 10px; font-size:11px; font-weight:700; cursor:pointer; line-height:1.6\">\n&#10005; Clear</button></div><div style=\"padding:14px 16px\"><div \nstyle=\"font-size:12px; color:#546E7A; margin-bottom:10px; padding:8px 10px; background:#FBE9E7; border-radius:4px; border-left:3px solid #E65100\">\nMerges Life + ACC + Wellness PDFs into one final PDF per member and saves URL to DB. Only processes members without a final PDF.\n</div><label style=\"font-size:12px; font-weight:600; color:#37474F; margin-bottom:4px; display:block\">\nSociety Code (SOCCODE)</label><md-input-container style=\"margin:0 0 12px; padding:0; width:100%\"><input type=\"text\" \nng-model=\"vm.mergeSocCode\" placeholder=\"e.g. SOC304\" style=\"font-size:13px\"></md-input-container><md-button \nclass=\"md-raised\" ng-click=\"vm.generateMerge()\" ng-disabled=\"vm.generatingMerge\" \nstyle=\"margin:0; width:100%; font-size:13px; font-weight:700; background:#E65100; color:#fff\" \nng-style=\"{\'opacity\':vm.generatingMerge?\'0.6\':\'1\'}\">{{ vm.generatingMerge ? \'Generating...\' : \'Generate Merge PDFs\' }}\n</md-button><div ng-if=\"vm.mergeResult\" style=\"margin-top:14px\"><div \nstyle=\"padding:8px 12px; border-radius:5px; font-size:12px; font-weight:600; margin-bottom:10px\" \nng-style=\"{\'background\': vm.mergeResult.validFlag ? \'#E8F5E9\' : \'#FFEBEE\', \'color\': vm.mergeResult.validFlag ? \'#2E7D32\' : \'#C62828\'}\">\n{{ vm.mergeResult.responseString || (vm.mergeResult.validFlag ? \'Completed\' : \'Failed\') }}</div><div \nng-if=\"vm.mergeResult.results && vm.mergeResult.results.length\"><div \nstyle=\"font-size:11px; color:#78909C; margin-bottom:6px\">\nShowing {{ (vm.mergePg-1)*10+1 }}–{{ vm.mergePg*10 > vm.mergeResult.results.length ? vm.mergeResult.results.length : vm.mergePg*10 }} of {{ vm.mergeResult.results.length }} entries\n</div><div style=\"border-radius:4px; border:1px solid #ECEFF1; overflow:hidden\"><table \nstyle=\"width:100%; border-collapse:collapse; font-size:11px\"><thead><tr style=\"background:#E65100; color:#fff\"><th \nstyle=\"padding:6px 10px; text-align:left; font-weight:700\">#</th><th \nstyle=\"padding:6px 10px; text-align:left; font-weight:700\">SIP ID</th><th \nstyle=\"padding:6px 10px; text-align:left; font-weight:700\">Mobile</th><th \nstyle=\"padding:6px 10px; text-align:left; font-weight:700\">Status</th></tr></thead><tbody><tr \nng-repeat=\"r in vm.mergePageData() track by $index\" ng-style=\"{\'background\': $index%2===0?\'#fff\':\'#FBE9E7\'}\"><td \nstyle=\"padding:5px 10px; color:#78909C\">{{ (vm.mergePg-1)*10 + $index + 1 }}</td><td \nstyle=\"padding:5px 10px; font-size:10px; font-family:monospace\">{{ r.sipfundId || \'—\' }}</td><td \nstyle=\"padding:5px 10px; font-family:monospace\">{{ r.mobileNo || \'—\' }}</td><td style=\"padding:5px 10px\"><span \nstyle=\"padding:2px 8px; border-radius:10px; font-size:10px; font-weight:700; text-transform:uppercase\" \nng-style=\"{\'background\':r.status===\'success\'?\'#E8F5E9\':\'#FFEBEE\',\'color\':r.status===\'success\'?\'#2E7D32\':\'#C62828\'}\">\n{{ r.status }}</span></td></tr></tbody></table></div><div ng-if=\"vm.mergeTotalPages() > 1\" layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top:8px; gap:4px; flex-wrap:wrap\"><button ng-click=\"vm.mergeGoPage(1)\" \nng-disabled=\"vm.mergePg===1\" \nstyle=\"padding:2px 8px; border:1px solid #FFAB91; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.mergePg===1?\'0.4\':\'1\'}\">&#171;</button> <button ng-click=\"vm.mergeGoPage(vm.mergePg-1)\" \nng-disabled=\"vm.mergePg===1\" \nstyle=\"padding:2px 8px; border:1px solid #FFAB91; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.mergePg===1?\'0.4\':\'1\'}\">&#8249;</button> <span \nstyle=\"font-size:11px; color:#E65100; font-weight:700; padding:2px 10px\">{{ vm.mergePg }} / {{ vm.mergeTotalPages() }}\n</span> <button ng-click=\"vm.mergeGoPage(vm.mergePg+1)\" ng-disabled=\"vm.mergePg===vm.mergeTotalPages()\" \nstyle=\"padding:2px 8px; border:1px solid #FFAB91; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.mergePg===vm.mergeTotalPages()?\'0.4\':\'1\'}\">&#8250;</button> <button \nng-click=\"vm.mergeGoPage(vm.mergeTotalPages())\" ng-disabled=\"vm.mergePg===vm.mergeTotalPages()\" \nstyle=\"padding:2px 8px; border:1px solid #FFAB91; border-radius:3px; font-size:11px; cursor:pointer; background:#fff\" \nng-style=\"{\'opacity\':vm.mergePg===vm.mergeTotalPages()?\'0.4\':\'1\'}\">&#187;</button></div></div></div></div></md-card>\n</div><div \nstyle=\"position:fixed; bottom:24px; right:24px; z-index:9999; display:flex; flex-direction:column; gap:10px; pointer-events:none\">\n<style>\n@keyframes rpm-spin { to { transform: rotate(360deg); } }\r\n      @keyframes rpm-fadein { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }\r\n      .rpm-toast { animation: rpm-fadein 0.25s ease; }\n</style><div ng-repeat=\"t in vm.zipToasts track by t.id\" class=\"rpm-toast\" \nstyle=\"background:#fff; border-radius:8px; box-shadow:0 4px 20px rgba(0,0,0,0.18); padding:12px 18px;\r\n                min-width:270px; max-width:320px; display:flex; align-items:center; gap:14px; pointer-events:auto;\r\n                border-left:5px solid\" \nng-style=\"{\'border-left-color\': t.status===\'done\' ? \'#2E7D32\' : t.status===\'error\' ? \'#C62828\' : \'#1565C0\'}\"><span \nng-if=\"t.status===\'loading\'\" \nstyle=\"flex-shrink:0; width:20px; height:20px; border-radius:50%; border:3px solid #E3EEFA; border-top-color:#1565C0;\r\n                   animation:rpm-spin 0.75s linear infinite; display:inline-block\">\n</span><span ng-if=\"t.status===\'done\'\" \nstyle=\"flex-shrink:0; width:20px; height:20px; border-radius:50%; background:#2E7D32; display:flex; align-items:center; justify-content:center; color:#fff; font-size:12px; font-weight:700\">\n&#10003;</span><span ng-if=\"t.status===\'error\'\" \nstyle=\"flex-shrink:0; width:20px; height:20px; border-radius:50%; background:#C62828; display:flex; align-items:center; justify-content:center; color:#fff; font-size:12px; font-weight:700\">\n&#10007;</span><div style=\"flex:1; min-width:0\"><div \nstyle=\"font-size:13px; font-weight:700; white-space:nowrap; overflow:hidden; text-overflow:ellipsis\" \nng-style=\"{\'color\': t.status===\'done\' ? \'#2E7D32\' : t.status===\'error\' ? \'#C62828\' : \'#1565C0\'}\"><span \nng-if=\"t.status===\'loading\'\">Preparing {{ t.label }} ZIP&hellip;</span> <span ng-if=\"t.status===\'done\'\">\n{{ t.label }} ZIP Ready!</span> <span ng-if=\"t.status===\'error\'\">{{ t.label }} ZIP Failed</span></div><div \nstyle=\"font-size:11px; color:#78909C; margin-top:2px\">\n{{ t.count }} PDF{{ t.count !== 1 ? \'s\' : \'\' }} &nbsp;&middot;&nbsp; <span ng-if=\"t.status===\'loading\'\">\nYou can keep using the app</span> <span ng-if=\"t.status===\'done\'\">Download started automatically</span> <span \nng-if=\"t.status===\'error\'\">Please try again</span></div></div></div></div></div>");
$templateCache.put("app/main/returnReport/returnReport.html","<div><h3>Total Activated IIN Customers {{vm.numItems}}</h3><br><h3>Total Pages {{vm.pages}}</h3></div><div \nng-repeat=\"x in vm.totalpages\"><div layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.calculateReportData(x)\" style=\"float:right; color:#fff !important\">\nGenerate Summary Report for Page {{x}}</md-button></div></div><div layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.downloadReport()\" style=\"float:right; color:#fff !important\">\n<md-icon md-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Download</md-button></div><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"display: none\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.GenerateReportFromArray()\" style=\"float:right; color:#fff !important\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Generate Report</md-button></div><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 60%\"><label>Pan Number</label><input type=\"text\" required \nname=\"name\" ng-model=\"vm.userPan\" class=\"no-margin-bottom\" tabindex=\"1\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.GenerateReportForPan(vm.userPan)\" style=\"float:right; color:#fff !important\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Generate Report</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.downloadReport()\" style=\"float:right; color:#fff !important\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Download</md-button></div><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 60%\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.downloadTransactions()\" style=\"float:right; color:#fff !important\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Generate Transaction Report</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.downloadTranReport()\" style=\"float:right; color:#fff !important\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>Download</md-button></div>");
$templateCache.put("app/main/serviceConfiguration/serviceConfigurationList.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"serviceConfigurationList\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nService Configuration List</span></div></div></div><md-content><div class=\"ext-content\"><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>S. No.</span></th><th md-column \nmd-order-by=\"serviceName\"><span>Service Name</span></th><th md-column md-order-by=\"ACCESS_CODE\"><span>Access Code\n</span></th><th md-column md-order-by=\"ACCESS_EXPIARY_DATE\"><span>Expirary date</span></th><th><span>Action</span></th>\n</tr></thead><tbody md-body><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"serviceConfiguration in vm.allServiceConfiguration | filter:search | orderBy: vm.query.order | limitTo:vm.query.limit\" \nng-class=\"vm.morningStarAlert?\'activeRowColor\' : \'\'\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{serviceConfiguration.serviceName}}</td><td md-cell>{{serviceConfiguration.config.ACCESS_CODE}}</td><td md-cell>\n{{serviceConfiguration.config.ACCESS_EXPIARY_DATE | date:\"dd/MM/yyyy \'at\' h:mma\"}}</td><td md-cell><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.updateConfiguration(serviceConfiguration)\">Update</md-button></md-menu-item></md-menu-content></md-menu>\n</td></tr></tbody></table></md-table-container></md-virtual-repeat-container></div></md-content></div>");
$templateCache.put("app/main/revive-wellness-upload/revive-wellness-upload.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"reviveWellnessUpload\" \nstyle=\"overflow-y:auto; height:100%\"><div class=\"header md-accent-bg height-60\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin:0\"><md-icon md-font-icon=\"icon-file-excel\" \nstyle=\"color:#fff; margin-right:10px; font-size:22px\"></md-icon><span>Revive Wellness – Excel Upload</span></div><div \nclass=\"secondary-text white-fg\" style=\"font-size:12px; margin-top:4px\">\nUpload society Excel &nbsp;·&nbsp; Insert members &nbsp;·&nbsp; Generate wellness certs</div></div></div><div \nng-if=\"vm.alertMsg\" \nstyle=\"margin:12px 16px 0; background:#FFEBEE; border-left:4px solid #C62828; border-radius:4px; padding:10px 16px; color:#B71C1C; font-weight:600; font-size:13px\">\n&#9888;&nbsp; {{ vm.alertMsg }}</div><md-card style=\"margin:14px 16px 0; padding:0; overflow:hidden\"><div \nclass=\"md-accent-bg\" style=\"padding:10px 18px\"><span class=\"white-fg\" style=\"font-size:14px; font-weight:600\">\nUpload Excel File (.xlsx)</span></div><div style=\"padding:14px 18px\"><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap style=\"gap:16px\"><div layout=\"column\" style=\"min-width:220px; flex:0 0 220px\"><label \nstyle=\"font-size:12px; font-weight:600; color:#546E7A; margin-bottom:4px\">Society Code (SOCCODE)</label>\n<md-input-container style=\"margin:0; padding:0\"><input type=\"text\" ng-model=\"vm.socCode\" \nplaceholder=\"e.g. SOC304 (blank = all)\" style=\"font-size:13px\"></md-input-container></div><div \nstyle=\"flex:1; min-width:200px\"><label for=\"excel-file-input\" \nstyle=\"display:flex; align-items:center; gap:10px; border:2px dashed #1565C0; border-radius:6px; padding:8px 14px; cursor:pointer; background:#E8F0FE; transition:background 0.2s\" \nonmouseover=\"this.style.background=\'#D0E4FF\'\" onmouseout=\"this.style.background=\'#E8F0FE\'\"><span \nstyle=\"font-size:1.4rem; line-height:1; flex-shrink:0\">&#128202;</span><div><div \nstyle=\"color:#1565C0; font-weight:700; font-size:13px\">Click to select your <strong>.xlsx</strong> file</div><div \nstyle=\"color:#78909C; font-size:11px\">Sheet2 · Duplicates by mobileNo skipped</div></div><input type=\"file\" \nid=\"excel-file-input\" accept=\".xlsx\" style=\"display:none\" \nonchange=\"angular.element(this).scope().vm.onFileChange(this)\"></label></div><div layout=\"column\" \nlayout-align=\"center start\" style=\"gap:6px; flex-shrink:0\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.selectedFile || vm.uploading\" ng-click=\"vm.startUpload()\" \nstyle=\"margin:0; font-size:13px; font-weight:700\"><md-icon md-font-icon=\"icon-upload\" \nstyle=\"color:#fff; font-size:18px\"></md-icon>{{ vm.uploading ? \'Processing...\' : \'Upload &amp; Process\' }}</md-button>\n<div ng-if=\"vm.fileName\" \nstyle=\"color:#2E7D32; font-size:12px; font-weight:600; padding:3px 10px; background:#E8F5E9; border-radius:4px; max-width:200px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap\">\n&#10004; {{ vm.fileName }}</div></div></div></div></md-card><div ng-if=\"vm.result\" style=\"margin:14px 16px 16px\">\n<md-card style=\"margin:0 0 14px; padding:0; overflow:hidden\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding:12px 18px; border-bottom:1px solid #ECEFF1; flex-wrap:wrap; gap:10px\"><div><div \nstyle=\"font-size:11px; color:#90A4AE; font-weight:700; text-transform:uppercase; letter-spacing:0.7px\">Society</div>\n<div style=\"font-size:15px; font-weight:800; color:#1A237E; margin-top:2px\">{{ vm.result.societyName }}</div><div \nstyle=\"font-size:12px; color:#546E7A; margin-top:2px\">Code: <strong>{{ vm.result.SOCCODE || vm.result.socCode }}\n</strong></div></div><span ng-if=\"vm.result.validFlag\" \nstyle=\"padding:5px 14px; background:#E8F5E9; border-radius:20px; color:#2E7D32; font-size:12px; font-weight:700; white-space:nowrap\">\n&#10004; Valid Upload</span></div><div style=\"padding:10px 18px 14px\"><div \nstyle=\"font-size:13px; color:#455A64; padding:8px 14px; background:#F5F7FA; border-radius:5px; border-left:4px solid #1565C0; font-weight:500; margin-bottom:14px\">\n{{ vm.result.summary }}</div><div layout=\"row\" layout-wrap style=\"gap:12px\"><div \nstyle=\"text-align:center; padding:10px 22px; border-radius:8px; background:#E3F2FD\"><div \nstyle=\"font-size:1.8rem; font-weight:800; color:#1565C0; line-height:1.1\">{{ vm.result.total }}</div><div \nstyle=\"font-size:11px; font-weight:700; color:#1565C0; margin-top:3px\">TOTAL</div></div><div \nstyle=\"text-align:center; padding:10px 22px; border-radius:8px; background:#E8F5E9\"><div \nstyle=\"font-size:1.8rem; font-weight:800; color:#2E7D32; line-height:1.1\">{{ vm.result.inserted }}</div><div \nstyle=\"font-size:11px; font-weight:700; color:#2E7D32; margin-top:3px\">INSERTED</div></div><div \nstyle=\"text-align:center; padding:10px 22px; border-radius:8px; background:#FFF8E1\"><div \nstyle=\"font-size:1.8rem; font-weight:800; color:#E65100; line-height:1.1\">{{ vm.result.skipped }}</div><div \nstyle=\"font-size:11px; font-weight:700; color:#E65100; margin-top:3px\">DUPLICATES</div></div><div \nstyle=\"text-align:center; padding:10px 22px; border-radius:8px; background:#FFEBEE\"><div \nstyle=\"font-size:1.8rem; font-weight:800; color:#C62828; line-height:1.1\">{{ vm.result.errorCount }}</div><div \nstyle=\"font-size:11px; font-weight:700; color:#C62828; margin-top:3px\">ERRORS</div></div></div></div></md-card><md-card\n style=\"margin:0; padding:0; overflow:hidden\"><div layout=\"row\" \nstyle=\"border-bottom:2px solid #ECEFF1; background:#FAFBFC\"><button ng-click=\"vm.setTab(\'inserted\')\" \nstyle=\"padding:13px 22px; font-size:13px; font-weight:700; border:none; cursor:pointer; outline:none; border-bottom:3px solid transparent; margin-bottom:-2px; background:transparent; transition:all 0.15s\" \nng-style=\"{\'color\': vm.activeTab===\'inserted\' ? \'#1565C0\' : \'#90A4AE\', \'border-bottom-color\': vm.activeTab===\'inserted\' ? \'#1565C0\' : \'transparent\', \'background\': vm.activeTab===\'inserted\' ? \'#F0F7FF\' : \'transparent\'}\">\n&#10004; Inserted ({{ (vm.result.insertedList || []).length }})</button> <button ng-click=\"vm.setTab(\'duplicates\')\" \nstyle=\"padding:13px 22px; font-size:13px; font-weight:700; border:none; cursor:pointer; outline:none; border-bottom:3px solid transparent; margin-bottom:-2px; background:transparent; transition:all 0.15s\" \nng-style=\"{\'color\': vm.activeTab===\'duplicates\' ? \'#E65100\' : \'#90A4AE\', \'border-bottom-color\': vm.activeTab===\'duplicates\' ? \'#E65100\' : \'transparent\', \'background\': vm.activeTab===\'duplicates\' ? \'#FFF8F0\' : \'transparent\'}\">\n&#9889; Duplicates ({{ (vm.result.duplicateList || []).length }})</button> <button ng-click=\"vm.setTab(\'errors\')\" \nstyle=\"padding:13px 22px; font-size:13px; font-weight:700; border:none; cursor:pointer; outline:none; border-bottom:3px solid transparent; margin-bottom:-2px; background:transparent; transition:all 0.15s\" \nng-style=\"{\'color\': vm.activeTab===\'errors\' ? \'#C62828\' : \'#90A4AE\', \'border-bottom-color\': vm.activeTab===\'errors\' ? \'#C62828\' : \'transparent\', \'background\': vm.activeTab===\'errors\' ? \'#FFF5F5\' : \'transparent\'}\">\n&#10008; Errors ({{ (vm.result.errorList || []).length }})</button></div><div ng-show=\"vm.activeTab === \'inserted\'\">\n<div ng-if=\"vm.getList(\'inserted\').length === 0\" \nstyle=\"padding:36px; text-align:center; color:#90A4AE; font-size:14px\">No inserted records.</div><div \nng-if=\"vm.getList(\'inserted\').length > 0\"><div style=\"overflow-x:auto\"><table \nstyle=\"width:100%; border-collapse:collapse; font-size:13px; min-width:900px\"><thead><tr \nstyle=\"background:#1565C0; color:#fff\"><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">#</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Member ID</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Name</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Mobile</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Password</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Premium (&#8377;)</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Life URL</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">ACC URL</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Status</th></tr></thead><tbody><tr \nng-repeat=\"r in vm.pageData(\'inserted\') track by $index\" style=\"border-bottom:1px solid #ECEFF1\" \nng-style=\"{\'background\': $index % 2 === 0 ? \'#fff\' : \'#F8FAFC\'}\"><td \nstyle=\"padding:10px 14px; color:#78909C; font-size:12px\">{{ (vm.pg.inserted - 1) * 10 + $index + 1 }}</td><td \nstyle=\"padding:10px 14px; font-weight:700; color:#1565C0; white-space:nowrap\">{{ r.memberId || \'—\' }}</td><td \nstyle=\"padding:10px 14px; white-space:nowrap\">{{ r.memberName || \'—\' }}</td><td \nstyle=\"padding:10px 14px; white-space:nowrap\">{{ r.mobileNo || \'—\' }}</td><td \nstyle=\"padding:10px 14px; font-family:monospace; color:#546E7A\">{{ r.password || \'—\' }}</td><td \nstyle=\"padding:10px 14px; font-weight:600; color:#2E7D32\">{{ r.NewPremium || \'—\' }}</td><td style=\"padding:10px 14px\">\n<a ng-if=\"r.lifeUrl\" ng-href=\"{{ r.lifeUrl }}\" target=\"_blank\" class=\"md-raised md-primary md-button md-ink-ripple\" \nstyle=\"font-size:11px; padding:2px 10px; min-height:0; line-height:24px; margin:0\">&#11015; Life PDF</a> <span \nng-if=\"!r.lifeUrl\" style=\"color:#CFD8DC\">—</span></td><td style=\"padding:10px 14px\"><a ng-if=\"r.accUrl\" \nng-href=\"{{ r.accUrl }}\" target=\"_blank\" class=\"md-raised md-primary md-button md-ink-ripple\" \nstyle=\"font-size:11px; padding:2px 10px; min-height:0; line-height:24px; margin:0\">&#11015; ACC PDF</a> <span \nng-if=\"!r.accUrl\" style=\"color:#CFD8DC\">—</span></td><td style=\"padding:10px 14px\"><span \nstyle=\"padding:3px 10px; border-radius:12px; font-size:11px; font-weight:700; text-transform:uppercase; background:#E8F5E9; color:#2E7D32\">\n{{ r.status }}</span></td></tr></tbody></table></div><div ng-if=\"vm.totalPages(\'inserted\') > 1\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"padding:10px 16px; border-top:1px solid #ECEFF1; background:#FAFBFC; flex-wrap:wrap; gap:8px\"><span \nstyle=\"font-size:12px; color:#78909C\">{{ vm.showingInfo(\'inserted\') }}</span><div layout=\"row\" \nlayout-align=\"start center\" style=\"gap:4px\"><button ng-click=\"vm.goPage(\'inserted\', 1)\" \nng-disabled=\"vm.pg.inserted === 1\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.inserted === 1 ? \'0.4\' : \'1\'}\">&#171; First</button> <button \nng-click=\"vm.goPage(\'inserted\', vm.pg.inserted - 1)\" ng-disabled=\"vm.pg.inserted === 1\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.inserted === 1 ? \'0.4\' : \'1\'}\">&#8249; Prev</button> <button \nng-repeat=\"p in vm.pageRange(\'inserted\') track by p\" ng-click=\"vm.goPage(\'inserted\', p)\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; font-size:12px; cursor:pointer; min-width:32px\" \nng-style=\"{\'background\': vm.pg.inserted === p ? \'#1565C0\' : \'#fff\', \'color\': vm.pg.inserted === p ? \'#fff\' : \'#546E7A\', \'font-weight\': vm.pg.inserted === p ? \'700\' : \'400\'}\">\n{{ p }}</button> <button ng-click=\"vm.goPage(\'inserted\', vm.pg.inserted + 1)\" \nng-disabled=\"vm.pg.inserted === vm.totalPages(\'inserted\')\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.inserted === vm.totalPages(\'inserted\') ? \'0.4\' : \'1\'}\">Next &#8250;</button> <button \nng-click=\"vm.goPage(\'inserted\', vm.totalPages(\'inserted\'))\" ng-disabled=\"vm.pg.inserted === vm.totalPages(\'inserted\')\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.inserted === vm.totalPages(\'inserted\') ? \'0.4\' : \'1\'}\">Last &#187;</button></div></div><div\n ng-if=\"vm.totalPages(\'inserted\') === 1\" \nstyle=\"padding:8px 16px; font-size:12px; color:#90A4AE; border-top:1px solid #ECEFF1; background:#FAFBFC\">\n{{ vm.showingInfo(\'inserted\') }}</div></div></div><div ng-show=\"vm.activeTab === \'duplicates\'\"><div \nng-if=\"vm.getList(\'duplicates\').length === 0\" style=\"padding:36px; text-align:center; color:#90A4AE; font-size:14px\">\nNo duplicate records.</div><div ng-if=\"vm.getList(\'duplicates\').length > 0\"><div style=\"overflow-x:auto\"><table \nstyle=\"width:100%; border-collapse:collapse; font-size:13px; min-width:700px\"><thead><tr \nstyle=\"background:#E65100; color:#fff\"><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">#</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Member ID</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Name</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Mobile</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Society</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Reason</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700; white-space:nowrap\">Status</th></tr></thead><tbody><tr \nng-repeat=\"r in vm.pageData(\'duplicates\') track by $index\" style=\"border-bottom:1px solid #ECEFF1\" \nng-style=\"{\'background\': $index % 2 === 0 ? \'#fff\' : \'#FFF8F0\'}\"><td \nstyle=\"padding:10px 14px; color:#78909C; font-size:12px\">{{ (vm.pg.duplicates - 1) * 10 + $index + 1 }}</td><td \nstyle=\"padding:10px 14px; font-weight:700; color:#E65100; white-space:nowrap\">{{ r.memberId || \'—\' }}</td><td \nstyle=\"padding:10px 14px; white-space:nowrap\">{{ r.memberName || \'—\' }}</td><td \nstyle=\"padding:10px 14px; white-space:nowrap\">{{ r.mobileNo || \'—\' }}</td><td \nstyle=\"padding:10px 14px; font-size:12px; color:#546E7A; max-width:200px\">{{ r.societyName || \'—\' }}</td><td \nstyle=\"padding:10px 14px; color:#BF360C; font-weight:500\">{{ r.message || \'—\' }}</td><td style=\"padding:10px 14px\">\n<span \nstyle=\"padding:3px 10px; border-radius:12px; font-size:11px; font-weight:700; text-transform:uppercase; background:#FFF8E1; color:#E65100\">\n{{ r.status }}</span></td></tr></tbody></table></div><div ng-if=\"vm.totalPages(\'duplicates\') > 1\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"padding:10px 16px; border-top:1px solid #ECEFF1; background:#FAFBFC; flex-wrap:wrap; gap:8px\"><span \nstyle=\"font-size:12px; color:#78909C\">{{ vm.showingInfo(\'duplicates\') }}</span><div layout=\"row\" \nlayout-align=\"start center\" style=\"gap:4px\"><button ng-click=\"vm.goPage(\'duplicates\', 1)\" \nng-disabled=\"vm.pg.duplicates === 1\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.duplicates === 1 ? \'0.4\' : \'1\'}\">&#171; First</button> <button \nng-click=\"vm.goPage(\'duplicates\', vm.pg.duplicates - 1)\" ng-disabled=\"vm.pg.duplicates === 1\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.duplicates === 1 ? \'0.4\' : \'1\'}\">&#8249; Prev</button> <button \nng-repeat=\"p in vm.pageRange(\'duplicates\') track by p\" ng-click=\"vm.goPage(\'duplicates\', p)\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; font-size:12px; cursor:pointer; min-width:32px\" \nng-style=\"{\'background\': vm.pg.duplicates === p ? \'#E65100\' : \'#fff\', \'color\': vm.pg.duplicates === p ? \'#fff\' : \'#546E7A\', \'font-weight\': vm.pg.duplicates === p ? \'700\' : \'400\'}\">\n{{ p }}</button> <button ng-click=\"vm.goPage(\'duplicates\', vm.pg.duplicates + 1)\" \nng-disabled=\"vm.pg.duplicates === vm.totalPages(\'duplicates\')\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.duplicates === vm.totalPages(\'duplicates\') ? \'0.4\' : \'1\'}\">Next &#8250;</button> <button \nng-click=\"vm.goPage(\'duplicates\', vm.totalPages(\'duplicates\'))\" \nng-disabled=\"vm.pg.duplicates === vm.totalPages(\'duplicates\')\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.duplicates === vm.totalPages(\'duplicates\') ? \'0.4\' : \'1\'}\">Last &#187;</button></div></div>\n<div ng-if=\"vm.totalPages(\'duplicates\') === 1\" \nstyle=\"padding:8px 16px; font-size:12px; color:#90A4AE; border-top:1px solid #ECEFF1; background:#FAFBFC\">\n{{ vm.showingInfo(\'duplicates\') }}</div></div></div><div ng-show=\"vm.activeTab === \'errors\'\"><div \nng-if=\"vm.getList(\'errors\').length === 0\" style=\"padding:36px; text-align:center; color:#90A4AE; font-size:14px\">\n&#10004;&nbsp; No errors — all records processed cleanly.</div><div ng-if=\"vm.getList(\'errors\').length > 0\"><div \nstyle=\"overflow-x:auto\"><table style=\"width:100%; border-collapse:collapse; font-size:13px; min-width:600px\"><thead><tr\n style=\"background:#C62828; color:#fff\"><th style=\"padding:11px 14px; text-align:left; font-weight:700\">#</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700\">Member ID</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700\">Name</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700\">Mobile</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700\">Error</th><th \nstyle=\"padding:11px 14px; text-align:left; font-weight:700\">Status</th></tr></thead><tbody><tr \nng-repeat=\"r in vm.pageData(\'errors\') track by $index\" style=\"border-bottom:1px solid #ECEFF1\" \nng-style=\"{\'background\': $index % 2 === 0 ? \'#fff\' : \'#FFF5F5\'}\"><td \nstyle=\"padding:10px 14px; color:#78909C; font-size:12px\">{{ (vm.pg.errors - 1) * 10 + $index + 1 }}</td><td \nstyle=\"padding:10px 14px; font-weight:700; color:#C62828; white-space:nowrap\">{{ r.memberId || \'—\' }}</td><td \nstyle=\"padding:10px 14px; white-space:nowrap\">{{ r.memberName || \'—\' }}</td><td \nstyle=\"padding:10px 14px; white-space:nowrap\">{{ r.mobileNo || \'—\' }}</td><td \nstyle=\"padding:10px 14px; color:#B71C1C; font-weight:500\">{{ r.message || r.error || \'—\' }}</td><td \nstyle=\"padding:10px 14px\"><span \nstyle=\"padding:3px 10px; border-radius:12px; font-size:11px; font-weight:700; text-transform:uppercase; background:#FFEBEE; color:#C62828\">\n{{ r.status || \'error\' }}</span></td></tr></tbody></table></div><div ng-if=\"vm.totalPages(\'errors\') > 1\" layout=\"row\" \nlayout-align=\"space-between center\" \nstyle=\"padding:10px 16px; border-top:1px solid #ECEFF1; background:#FAFBFC; flex-wrap:wrap; gap:8px\"><span \nstyle=\"font-size:12px; color:#78909C\">{{ vm.showingInfo(\'errors\') }}</span><div layout=\"row\" \nlayout-align=\"start center\" style=\"gap:4px\"><button ng-click=\"vm.goPage(\'errors\', 1)\" ng-disabled=\"vm.pg.errors === 1\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.errors === 1 ? \'0.4\' : \'1\'}\">&#171; First</button> <button \nng-click=\"vm.goPage(\'errors\', vm.pg.errors - 1)\" ng-disabled=\"vm.pg.errors === 1\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.errors === 1 ? \'0.4\' : \'1\'}\">&#8249; Prev</button> <button \nng-repeat=\"p in vm.pageRange(\'errors\') track by p\" ng-click=\"vm.goPage(\'errors\', p)\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; font-size:12px; cursor:pointer; min-width:32px\" \nng-style=\"{\'background\': vm.pg.errors === p ? \'#C62828\' : \'#fff\', \'color\': vm.pg.errors === p ? \'#fff\' : \'#546E7A\', \'font-weight\': vm.pg.errors === p ? \'700\' : \'400\'}\">\n{{ p }}</button> <button ng-click=\"vm.goPage(\'errors\', vm.pg.errors + 1)\" \nng-disabled=\"vm.pg.errors === vm.totalPages(\'errors\')\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.errors === vm.totalPages(\'errors\') ? \'0.4\' : \'1\'}\">Next &#8250;</button> <button \nng-click=\"vm.goPage(\'errors\', vm.totalPages(\'errors\'))\" ng-disabled=\"vm.pg.errors === vm.totalPages(\'errors\')\" \nstyle=\"padding:4px 10px; border:1px solid #CFD8DC; border-radius:4px; background:#fff; font-size:12px; cursor:pointer; color:#546E7A\" \nng-style=\"{\'opacity\': vm.pg.errors === vm.totalPages(\'errors\') ? \'0.4\' : \'1\'}\">Last &#187;</button></div></div><div \nng-if=\"vm.totalPages(\'errors\') === 1\" \nstyle=\"padding:8px 16px; font-size:12px; color:#90A4AE; border-top:1px solid #ECEFF1; background:#FAFBFC\">\n{{ vm.showingInfo(\'errors\') }}</div></div></div></md-card></div></div>");
$templateCache.put("app/main/schedular/schedular.html","<div id=\"schedular\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>Schedular</span></div></div><div class=\"white-fg h3\" layout=\"column\" layout-align=\"start start\"><md-button \nclass=\"md-raised md-primary\" ui-sref=\"app.schedular.createschedular\">ADD Schedular</md-button></div></div><div \nclass=\"headerFixAllPages\"><md-content id=\"mainContent\" class=\"scrollable\" ms-scroll><md-nav-bar \nmd-no-ink-bar=\"disableInkBar\" md-selected-nav-item=\"vm.currentNavItem\" nav-bar-aria-label=\"navigation links\">\n<md-nav-item md-nav-click=\"vm.changeFilter(\'EMAIL\')\" name=\"EMAIL\">EMAIL</md-nav-item><md-nav-item \nmd-nav-click=\"vm.changeFilter(\'SMS\')\" name=\"SMS\">SMS</md-nav-item><md-nav-item \nmd-nav-click=\"vm.changeFilter(\'NOTIFICATION\')\" name=\"NOTIFICATION\">NOTIFICATION</md-nav-item></md-nav-bar><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Pending\"><md-content class=\"md-padding\"><div layout=\"row\" \nclass=\"header1\" layout-align=\"start center\" flex=\"100\"><div flex=\"10\" class=\"pl-20\">Name</div><div flex=\"20\" \nclass=\"pl-20\">Date & Time</div><div flex=\"10\" class=\"pl-20\">Channel</div><div flex=\"30\" class=\"pl-20\">Message</div><div\n flex=\"10\" class=\"pl-20\">User</div><div flex=\"10\" class=\"pl-20\">Filter</div><div flex=\"10\" class=\"pl-20\">Action</div>\n</div><div style=\"cursor:pointer\" ui-sref=\"app.schedular.detail({id:item._id})\" layout=\"row\" class=\"tabRow\" \nlayout-align=\"start center\" ng-repeat=\"item in vm.schedulars | filter:{executeFlag: false,channel:vm.pendingFilter}\" \nflex=\"100\"><div flex=\"10\" class=\"pl-20\">{{item.name}}</div><div flex=\"20\" class=\"pl-20\">\n{{item.date | date:\'mediumDate\'}} at {{item.hour}}:{{item.minute}} {{item.hour > 11 ? \'PM\': \'AM\'}}</div><div flex=\"10\" \nclass=\"pl-20\">{{item.channel}}</div><div flex=\"30\" style=\"word-break:break-all\" class=\"pl-20\">{{item.bodyContent}}\n</div><div flex=\"10\" class=\"pl-20\">{{item.users.length}}</div><div flex=\"10\" class=\"pl-20\">\n{{vm.customerType[item.filter] }}</div><div flex=\"10\" class=\"pl-20\"><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Edit\" ng-click=\"vm.editSchedular(item)\">Edit\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Activated\" ng-click=\"vm.deleteSchedularDialog(item)\">\nDelete</md-button></md-menu-item></md-menu-content></md-menu></div></div></md-content></md-tab><md-tab \nlabel=\"Completed\"><md-content class=\"md-padding\"><div layout=\"row\" class=\"header1\" layout-align=\"start center\" \nflex=\"100\"><div flex=\"10\" class=\"pl-20\">Name</div><div flex=\"20\" class=\"pl-20\">Date & Time</div><div flex=\"10\" \nclass=\"pl-20\">Channel</div><div flex=\"30\" class=\"pl-20\">Message</div><div flex=\"10\" class=\"pl-20\">User</div><div \nflex=\"10\" class=\"pl-20\">Filter</div><div flex=\"10\" class=\"pl-20\">Action</div></div><div layout=\"row\" \nstyle=\"cursor:pointer\" ui-sref=\"app.schedular.detail({id:item._id})\" class=\"tabRow\" layout-align=\"start center\" \nng-repeat=\"item in vm.schedulars | filter:{executeFlag: true,channel: vm.pendingFilter}\" flex=\"100\"><div flex=\"10\" \nclass=\"pl-20\">{{item.name}}</div><div flex=\"20\" class=\"pl-20\">\n{{item.date | date:\'mediumDate\'}} at {{item.hour}}:{{item.minute}} {{item.hour > 11 ? \'PM\': \'AM\'}}</div><div flex=\"10\" \nclass=\"pl-20\">{{item.channel}}</div><div flex=\"30\" style=\"word-break:break-all\" class=\"pl-20\">{{item.bodyContent}}\n</div><div flex=\"10\" class=\"pl-20\">{{item.notificationSchedulerHistory[0].totalCount}}</div><div flex=\"10\" \nclass=\"pl-20\">{{vm.customerType[item.filter] }}</div><div flex=\"10\" class=\"pl-20\"><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Edit\" \nng-click=\"vm.editSchedular(item,\'Retrigger\')\">Re Trigger</md-button></md-menu-item></md-menu-content></md-menu></div>\n</div></md-content></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/sub-broker/brokerDetail.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"demoCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h3\" style=\"margin:0\"><span>Broker Detail</span></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.openEditModal()\" \nstyle=\"color:#fff !important\">Edit Broker Details</md-button></div></div><md-nav-bar \nmd-selected-nav-item=\"vm.currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item \nmd-nav-click=\"vm.customerCount(\'INVESTED_CUSTOMER\')\" name=\"INVESTED_CUSTOMER\">Broker</md-nav-item></md-nav-bar><div \nclass=\"scrollable\" ms-scroll fix-head><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px; font-weight: bold\">Personal Detail</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" class=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span class=\"title\">\nFirst Name : &nbsp;&nbsp; {{vm.brokerDetail.personalDetails.firstName? vm.brokerDetail.personalDetails.firstName : \'NA\'}}\n</span> <span class=\"title\">\nLast Name : &nbsp;&nbsp; {{vm.brokerDetail.personalDetails.lastName? vm.brokerDetail.personalDetails.lastName : \'NA\'}}\n</span> <span class=\"title\">\nEmail : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.email) ? (vm.brokerDetail.personalDetails.email):\'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nGender : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.gender) ? (vm.brokerDetail.personalDetails.gender) : \'NA\'}}\n</span> <span>\nState : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.state) ? (vm.brokerDetail.personalDetails.state): \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPIN : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.pin) ? (vm.brokerDetail.personalDetails.pin): \'NA\'}}</span> \n<span>\nContact No. : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.phone)? (vm.brokerDetail.personalDetails.phone):\'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nAddress : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.address) ? (vm.brokerDetail.personalDetails.address): \'NA\'}}\n</span> <span>\nCity : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.city)? (vm.brokerDetail.personalDetails.city):\'NA\'}}</span>\n</div></div></md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px;font-weight: bold\">Skills</h4></div><div \nlayout=\"row\" layout-align=\"space-around center\" class=\"margin-left-20\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span class=\"title\">\nSkills. : &nbsp;&nbsp; {{vm.brokerDetail.skills? vm.brokerDetail.skills : \'NA\'}}</span></div></div></md-content></div>\n<div class=\"article padding-top-10\" flow-init><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 \nclass=\"margin-left-30\" style=\"margin-bottom:-10px;font-weight: bold\">Account Details</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" class=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding layout=\"column\" layout-align=\"space-around center\" flex=\"50\" flow-init \nflow-name=\"imageFile.flowObj\" flow-files-added=\"processFile($files,\'PAN\')\"><span class=\"title\">\nAccount No. : &nbsp;&nbsp; {{vm.brokerDetail.accountDetails.accountNumber? vm.brokerDetail.accountDetails.accountNumber : \'NA\'}}\n</span> <span class=\"title\">\nArn No : &nbsp;&nbsp; {{vm.brokerDetail.accountDetails.arnNo? vm.brokerDetail.accountDetails.arnNo : \'NA\'}}</span>\n<md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">PAN Card</h1></div><md-card-content><a target=\"_blank\" \nhref=\"{{(vm.brokerDetail.accountDetails.image)}}\"><img class=\"objectFitBlog\" \nng-src=\"{{(vm.brokerDetail.accountDetails.image)}}\"></a></md-card-content></md-card><form id=\"uploadForm\" \nenctype=\"multipart/form-data\"><input type=\"file\" name=\"file\" ng-click=\"$flow.cancel();\" flow-btn ng-file-model=\"files\" \naccept=\"image/*\"></form></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding \nlayout-align=\"space-around center\" flex=\"50\" flow-init flow-name=\"imageFile.flowObj\" \nflow-files-added=\"processFile($files,\'AADHAAR\')\"><span>\nBank Name : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.bankName) ? (vm.brokerDetail.accountDetails.bankName) : \'NA\'}}\n</span> <span>\nBranch : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.branch) ? (vm.brokerDetail.accountDetails.branch): \'NA\'}}\n</span><md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">Aadhar Card</h1></div><md-card-content><a \ntarget=\"_blank\" href=\"{{(vm.brokerDetail.accountDetails.aadhaarImage)}}\"><img class=\"objectFitBlog\" \nng-src=\"{{(vm.brokerDetail.accountDetails.aadhaarImage)}}\"></a></md-card-content></md-card><form id=\"uploadForm\" \nenctype=\"multipart/form-data\"><input type=\"file\" name=\"file1\" ng-click=\"$flow.cancel();\" flow-btn \nng-file-model=\"files\" accept=\"image/*\"></form></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" \nlayout-padding layout-align=\"space-around center\" flex=\"50\" flow-init flow-name=\"imageFile.flowObj\" \nflow-files-added=\"processFile($files,\'BANK\')\"><span>\nIFSC : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.ifscCode) ? (vm.brokerDetail.accountDetails.ifscCode): \'NA\'}}\n</span> <span>\nPAN No. : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.pan)? (vm.brokerDetail.accountDetails.pan):\'NA\'}}</span>\n<md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">Bank Proof</h1></div><md-card-content><a \ntarget=\"_blank\" href=\"{{(vm.brokerDetail.accountDetails.cancelCheckImage)}}\"><img class=\"objectFitBlog\" \nng-src=\"{{(vm.brokerDetail.accountDetails.cancelCheckImage)}}\"></a></md-card-content></md-card><form id=\"uploadForm\" \nenctype=\"multipart/form-data\"><input type=\"file\" name=\"file2\" ng-click=\"$flow.cancel();\" flow-btn \nng-file-model=\"files\" accept=\"image/*\"></form></div></div></md-content></div><div style=\"text-align: center\"><md-button\n class=\"md-raised md-accent\" ng-click=\"vm.brokerDetailsMail(vm.brokerDetail);\" \nstyle=\"color:#fff !important;margin-bottom: 50px\">Send Communication Mail</md-button><md-button \nclass=\"md-raised md-accent\" ui-sref=\"app.internalUser\" style=\"color:#fff !important;margin-bottom: 50px\">\nApprove & Add Partner</md-button></div></div></div></div></div><script type=\"text/ng-template\" \nid=\"edit-broker-modal.html\">\n<md-dialog aria-label=\"Edit Broker Details\" style=\"min-width: 90%; max-width: 95%; height: 90vh;\">\r\n        <form name=\"editBrokerForm\">\r\n            <md-toolbar>\r\n                <div class=\"md-toolbar-tools\">\r\n                    <h2>Edit Broker Details</h2>\r\n                    <span flex></span>\r\n                    <md-button class=\"md-icon-button\" ng-click=\"vm.closeModal()\">\r\n                        <md-icon aria-label=\"Close dialog\"><b>X</b></md-icon>\r\n                    </md-button>\r\n                </div>\r\n            </md-toolbar>\r\n            <md-dialog-content style=\"overflow-y: auto; max-height: calc(90vh - 120px);\">\r\n                <div class=\"md-dialog-content\" style=\"padding: 20px; max-width: 100%;\">\r\n                    <!-- Personal Details Section -->\r\n                    <h3 style=\"margin-bottom: 20px; color: #333;\">Personal Details</h3>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>First Name</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.firstName\" required style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Last Name</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.lastName\" required style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Email</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.email\" type=\"email\" required style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Date of Birth</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.dateOfBirth\" type=\"date\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Gender</label>\r\n                            <md-select ng-model=\"vm.editData.personalDetails.gender\" style=\"font-size: 14px;\">\r\n                                <md-option value=\"Male\">Male</md-option>\r\n                                <md-option value=\"Female\">Female</md-option>\r\n                                <md-option value=\"Other\">Other</md-option>\r\n                            </md-select>\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Phone</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.phone\" type=\"tel\" required style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Address</label>\r\n                            <textarea ng-model=\"vm.editData.personalDetails.address\" rows=\"2\" style=\"font-size: 14px; min-height: 50px;\"></textarea>\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>City</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.city\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 30px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>State</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.state\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>PIN</label>\r\n                            <input ng-model=\"vm.editData.personalDetails.pin\" type=\"number\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n\r\n                    <!-- Skills Section -->\r\n                    <h3 style=\"margin-bottom: 20px; margin-top: 30px; color: #333;\">Skills</h3>\r\n                    <md-input-container flex=\"100\" style=\"margin: 5px; min-height: 80px;\">\r\n                        <label>Skills</label>\r\n                        <textarea ng-model=\"vm.editData.skills\" rows=\"2\" style=\"font-size: 14px; min-height: 50px;\"></textarea>\r\n                    </md-input-container>\r\n\r\n                    <!-- Other Details Section -->\r\n                    <h3 style=\"margin-bottom: 20px; margin-top: 30px; color: #333;\">Other Details</h3>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Certificate Name</label>\r\n                            <input ng-model=\"vm.editData.otherDetails.certificateName\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"25\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>From Date</label>\r\n                            <input ng-model=\"vm.editData.otherDetails.from_date\" type=\"date\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"25\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>To Date</label>\r\n                            <input ng-model=\"vm.editData.otherDetails.to_date\" type=\"date\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n\r\n                    <!-- Account Details Section -->\r\n                    <h3 style=\"margin-bottom: 20px; margin-top: 30px; color: #333;\">Account Details</h3>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Account Number</label>\r\n                            <input ng-model=\"vm.editData.accountDetails.accountNumber\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>ARN No</label>\r\n                            <input ng-model=\"vm.editData.accountDetails.arnNo\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>PAN</label>\r\n                            <input ng-model=\"vm.editData.accountDetails.pan\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>GST No</label>\r\n                            <input ng-model=\"vm.editData.accountDetails.gstNo\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Bank Name</label>\r\n                            <input ng-model=\"vm.editData.accountDetails.bankName\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>Branch</label>\r\n                            <input ng-model=\"vm.editData.accountDetails.branch\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div layout=\"row\" layout-wrap style=\"margin-bottom: 20px;\">\r\n                        <md-input-container flex=\"45\" style=\"margin: 5px; min-height: 80px;\">\r\n                            <label>IFSC Code</label>\r\n                            <input ng-model=\"vm.editData.accountDetails.ifscCode\" style=\"font-size: 14px;\">\r\n                        </md-input-container>\r\n                    </div>\r\n                </div>\r\n            </md-dialog-content>\r\n            <md-dialog-actions layout=\"row\" style=\"padding: 15px; border-top: 1px solid #e0e0e0;\">\r\n                <span flex></span>\r\n                <md-button ng-click=\"vm.closeModal()\" style=\"margin-right: 10px;\">Cancel</md-button>\r\n                <md-button class=\"md-raised md-primary\" ng-click=\"vm.brokerUploadDetails()\" ng-disabled=\"editBrokerForm.$invalid\">\r\n                    Update Broker\r\n                </md-button>\r\n            </md-dialog-actions>\r\n        </form>\r\n    </md-dialog>\n</script>");
$templateCache.put("app/main/sub-broker/brokerDetail1.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"demoCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nBroker Detail</span></div></div></div><md-nav-bar md-selected-nav-item=\"vm.currentNavItem\" \nnav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"vm.customerCount(\'INVESTED_CUSTOMER\')\" \nname=\"INVESTED_CUSTOMER\">Broker</md-nav-item></md-nav-bar><div class=\"scrollable\" ms-scroll fix-head><div \nclass=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div class=\"article\"><md-content><div \nlayout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px; font-weight: bold\">Personal Detail</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" class=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span class=\"title\">\nFirst Name : &nbsp;&nbsp; {{vm.brokerDetail.personalDetails.firstName? vm.brokerDetail.personalDetails.firstName : \'NA\'}}\n</span> <span class=\"title\">\nLast Name : &nbsp;&nbsp; {{vm.brokerDetail.personalDetails.lastName? vm.brokerDetail.personalDetails.lastName : \'NA\'}}\n</span> <span class=\"title\">\nEmail : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.email) ? (vm.brokerDetail.personalDetails.email):\'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nGender : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.gender) ? (vm.brokerDetail.personalDetails.gender) : \'NA\'}}\n</span> <span>\nState : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.state) ? (vm.brokerDetail.personalDetails.state): \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPIN : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.pin) ? (vm.brokerDetail.personalDetails.pin): \'NA\'}}</span> \n<span>\nContact No. : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.phone)? (vm.brokerDetail.personalDetails.phone):\'NA\'}}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nAddress : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.address) ? (vm.brokerDetail.personalDetails.address): \'NA\'}}\n</span> <span>\nCity : &nbsp;&nbsp; {{(vm.brokerDetail.personalDetails.city)? (vm.brokerDetail.personalDetails.city):\'NA\'}}</span>\n</div></div></md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px;font-weight: bold\">Skills</h4></div><div \nlayout=\"row\" layout-align=\"space-around center\" class=\"margin-left-20\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span class=\"title\">\nSkills. : &nbsp;&nbsp; {{vm.brokerDetail.skills? vm.brokerDetail.skills : \'NA\'}}</span></div></div></md-content></div>\n<div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 \nclass=\"margin-left-30\" style=\"margin-bottom:-10px;font-weight: bold\">Account Details</h4></div><div layout=\"row\" \nlayout-align=\"space-around center\" class=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" \nflex=\"25\" layout-padding><span class=\"title\">\nAccount No. : &nbsp;&nbsp; {{vm.brokerDetail.accountDetails.accountNumber? vm.brokerDetail.accountDetails.accountNumber : \'NA\'}}\n</span> <span class=\"title\">\nArn No : &nbsp;&nbsp; {{vm.brokerDetail.accountDetails.arnNo? vm.brokerDetail.accountDetails.arnNo : \'NA\'}}</span>\n<md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">PAN Card</h1></div><md-card-content><a target=\"_blank\" \nhref=\"{{(vm.brokerDetail.accountDetails.image)}}\"><img class=\"objectFitBlog\" \nng-src=\"{{(vm.brokerDetail.accountDetails.image)}}\"></a></md-card-content></md-card><div flow-init \nflow-name=\"imageFile.flowObj\" flow-files-added=\"processPAN($files)\"><md-button class=\"md-raised md-accent\" \nstyle=\"color:#fff !important;margin-bottom: 50px\" ng-click=\"$flow.cancel();\" flow-btn>Upload PAN</md-button></div>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nBank Name : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.bankName) ? (vm.brokerDetail.accountDetails.bankName) : \'NA\'}}\n</span> <span>\nBranch : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.branch) ? (vm.brokerDetail.accountDetails.branch): \'NA\'}}\n</span><md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">Aadhar Card</h1></div><md-card-content><a \ntarget=\"_blank\" href=\"{{(vm.brokerDetail.accountDetails.aadhaarImage)}}\"><img class=\"objectFitBlog\" \nng-src=\"{{(vm.brokerDetail.accountDetails.aadhaarImage)}}\"></a></md-card-content></md-card><md-button \nclass=\"md-raised md-accent\" style=\"color:#fff !important;margin-bottom: 50px\">Upload Aadhaar</md-button></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIFSC : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.ifscCode) ? (vm.brokerDetail.accountDetails.ifscCode): \'NA\'}}\n</span> <span>\nPAN No. : &nbsp;&nbsp; {{(vm.brokerDetail.accountDetails.pan)? (vm.brokerDetail.accountDetails.pan):\'NA\'}}</span>\n<md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">Bank Proof</h1></div><md-card-content><a \ntarget=\"_blank\" href=\"{{(vm.brokerDetail.accountDetails.cancelCheckImage)}}\"><img class=\"objectFitBlog\" \nng-src=\"{{(vm.brokerDetail.accountDetails.cancelCheckImage)}}\"></a></md-card-content></md-card><md-button \nclass=\"md-raised md-accent\" style=\"color:#fff !important;margin-bottom: 50px\">Upload Bank Proof</md-button></div></div>\n</md-content></div><div style=\"text-align: center\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.brokerDetailsMail(vm.brokerDetail);\" style=\"color:#fff !important;margin-bottom: 50px\">\nSend Communication Mail</md-button><md-button class=\"md-raised md-accent\" ui-sref=\"app.internalUser\" \nstyle=\"color:#fff !important;margin-bottom: 50px\">Approve & Add Partner</md-button></div></div></div></div></div>");
$templateCache.put("app/main/sub-broker/sub-broker.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"demoCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nList Of Sub Brokers</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"Search\" ng-keyup=\"$event.keyCode == 13 ? vm.serchUser() : null\" flex></div></div>\n<md-nav-bar md-selected-nav-item=\"vm.currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item \nmd-nav-click=\"vm.customerCount(\'INVESTED_CUSTOMER\')\" name=\"INVESTED_CUSTOMER\">All Brokers</md-nav-item></md-nav-bar>\n<div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\"><md-table-container class=\"tablePbmSolved\">\n<table md-table ng-model=\"vm.selected\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.\n</span></th><th md-column md-order-by=\"firstName\"><span>First Name</span></th><th md-column md-order-by=\"lastName\">\n<span>Last Name</span></th><th md-column md-order-by=\"email\"><span>Email</span></th><th md-column md-order-by=\"phone\">\n<span>Phone</span></th><th md-column md-order-by=\"pin\"><span>Pin</span></th><th md-column md-order-by=\"state\"><span>\nState</span></th><th md-column md-order-by=\"address\"><span>Address</span></th><th md-column md-order-by=\"skills\"><span>\nSkills</span></th></tr></thead><tbody md-body><tr md-row md-select=\"broker\" \nmd-virtual-repeat=\"broker in vm.subBrokers\" ng-click=\"vm.brokerDetailFunction(broker)\" style=\"cursor:pointer\"><td \nmd-cell ng-bind=\"{{$index+1}}\"></td><td md-cell ng-bind=\"broker.personalDetails.firstName\"></td><td md-cell \nng-bind=\"broker.personalDetails.lastName\"></td><td md-cell ng-bind=\"broker.personalDetails.email\"></td><td md-cell \nng-bind=\"broker.personalDetails.phone\"></td><td md-cell ng-bind=\"broker.personalDetails.pin\"></td><td md-cell \nng-bind=\"broker.personalDetails.state\"></td><td md-cell ng-bind=\"broker.personalDetails.address\"></td><td md-cell \nng-bind=\"broker.skills\"></td></tr></tbody></table></md-table-container></md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/transaction-logs/transaction-logs.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Payment Transaction Logs</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" \nplaceholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><br><div \nlayout-gt-sm=\"row\" layout-align=\"center center\"><div class=\"col-sm-12\"><md-radio-group ng-model=\"vm.reportType\" \nlayout=\"row\"><md-radio-button tabindex=\"4\" ng-value=\"1\" aria-label=\"Select All\">Select All</md-radio-button>\n<md-radio-button tabindex=\"5\" ng-value=\"2\" aria-label=\"With IIN\">With IIN</md-radio-button></md-radio-group></div>\n</div><br><div layout-gt-sm=\"row\" layout-align=\"center center\"><div class=\"col-sm-12\"><md-radio-group \nng-if=\"vm.reportType == 1\" ng-model=\"vm.selected\" layout=\"row\"><md-radio-button tabindex=\"6\" ng-value=\"1\" \naria-label=\"Active IIN\">Active IIN</md-radio-button><md-radio-button tabindex=\"7\" ng-value=\"2\" \naria-label=\"Inactive IIN\" class=\"md-primary\">Inactive IIN</md-radio-button></md-radio-group></div></div><br><br><div \nclass=\"row\"><div ng-if=\"vm.reportType == 2\" class=\"col-sm-12\"><div class=\"col-sm-4\"><div class=\"form-group\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>IIN</label><input type=\"number\" \nng-pattern=\"/^[1-9]{1}[0-9]{9}$/\" numeric-regex ng-model=\"vm.postData.iin\" required name=\"iin\" flex=\"33\" tabindex=\"3\">\n</md-input-container></div></div></div><div class=\"col-sm-12\"><div class=\"col-sm-4 form-group\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>From Date</label><input type=\"date\" ng-model=\"vm.fromDate\" required name=\"fromDate\" \nflex=\"33\" tabindex=\"1\"></md-input-container></div><div class=\"col-sm-4 form-group\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>To Date</label><input type=\"date\" ng-model=\"vm.toDate\" required name=\"toDate\" \nflex=\"33\" tabindex=\"2\"></md-input-container><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"disabtranLog()\" \nng-click=\"postTranLogs()\" tabindex=\"6\"><b>Show</b></button> &nbsp; &nbsp; <button type=\"button\" \nclass=\"btn btn-primary\" ng-disabled=\"disabtranLog()\" ng-click=\"clearLogs()\" tabindex=\"6\"><b>Clear</b></button></div>\n</div></div><div ng-if=\"vm.logData.length > 0\" style=\"overflow-x:auto\"><table class=\"table\"><thead class=\"thead-light\">\n<tr><th scope=\"col\"><span>Sr.No.</span></th><th scope=\"col\"><span>IIN</span></th><th scope=\"col\"><span>Name</span></th>\n<th scope=\"col\" style=\"min-width:250px; padding-right:20px\"><span>Scheme Name</span></th><th scope=\"col\"><span>\nScheme Amount</span></th><th scope=\"col\" style=\"min-width:100px; padding-right:20px\"><span>Tran Date</span></th><th \nscope=\"col\"><span>Time</span></th><th scope=\"col\"><span>Pay Type</span></th><th scope=\"col\"><span>Amount</span></th><th\n scope=\"col\"><span>Bank Code</span></th><th scope=\"col\"><span>From Pay</span></th><th scope=\"col\"><span>To Pay</span>\n</th><th scope=\"col\"><span>Ref No</span></th><th scope=\"col\"><span>Transaction Status</span></th><th scope=\"col\"><span>\nTransaction Status Description</span></th><th scope=\"col\"><span>Remark</span></th></tr></thead><tbody><tr \nng-repeat=\"logs in vm.logData \" style=\"cursor:pointer\"><td>{{$index+1}}</td><td>{{logs.iin ? logs.iin : 0}}</td><td>\n<span ng-if=\"logs.invname\">{{(logs.invname)}}</span></td><td ng-bind=\"logs.scheme_Name\"></td><td \nng-bind=\"logs.scheme_Amount\"></td><td ng-bind=\"logs.trandate\"></td><td ng-bind=\"logs.time\"></td><td \nng-bind=\"logs.pay_type\"></td><td ng-bind=\"logs.tran_amount | number:2\"></td><td ng-bind=\"logs.bank_code\"></td><td \nng-bind=\"logs.from_pay\"></td><td ng-bind=\"logs.to_pay\"></td><td ng-bind=\"logs.ref_no\"></td><td \nng-bind=\"logs.trn_status\"></td><td ng-bind=\"logs.trn_status_Desc\"></td><td ng-bind=\"logs.remarks\"></td></tr></tbody>\n</table></div></md-card></div></div>");
$templateCache.put("app/main/uploadNavs/uploadNavs.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"uploadNav\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nUpload Nav</span></div></div></div><div class=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"text\"><input ng-disabled=\"loading\" accept=\".csv\" type=\"file\" \nstyle=\"cursor: pointer\" name=\"file\" id=\"navFile\" ng-model-instant \nonchange=\"angular.element(this).scope().checkfile(this)\"></div><button mat-fab class=\"cherry-gradient\" \nng-click=\"vm.navUpload()\"><md-icon md-font-icon=\"icon-upload\" class=\"textWhite\"></md-icon>Upload Navs</button></div>\n</md-card></div></div>");
$templateCache.put("app/main/syncing/exemptedUsers.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\" ng-init=\"vm.fetch_internal_users();vm.fetch_exempted_users();\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><span>Exempted Users</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"backArrowColor\" ui-sref=\"app.syncing\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back\n</span></md-button></div></div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div layout-gt-sm=\"row\" \nlayout-align=\"center center\"></div><div class=\"row\"><div class=\"col-sm-12\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\"><br><br><div class=\"white-fg\" layout=\"row\" layout-align=\"start start\" \nstyle=\"height: 51px !important; margin-top: -18px !important\"><md-input-container flex=\"30\" flex-gt-xs=\"30\"><label>\nSelect Form Date</label><input ng-model=\"vm.fromDate\" ng-change=\"vm.formatFromDate()\" name=\"fromdate\" type=\"date\" \nmin=\"{{ vm.minDate }}\"><div ng-messages=\"wizardStep1.fromdate.$error\" role=\"alert\"><div ng-message=\"required\">\nPlease Select From Date</div></div></md-input-container><md-input-container flex=\"30\" flex-gt-xs=\"30\"><label>\nSelect To Date</label><input ng-model=\"vm.toDate\" ng-change=\"vm.formatToDate()\" name=\"todate\" type=\"date\" \nmin=\"{{ vm.minDate }}\"><div ng-messages=\"wizardStep1.todate.$error\" role=\"alert\"><div ng-message=\"required\">\nPlease Select To Date</div></div></md-input-container><md-input-container flex=\"40\" flex-gt-xs=\"40\">\n</md-input-container></div><br><table class=\"table table-bordered\" style=\"margin-left: 11px; margin-right: 20px\"><tr>\n<th>UserID</th><th>User Name</th><th>Type</th><th>Email</th><th>Mobile</th><th>Office</th><th>Action</th></tr><tr \nng-repeat=\"transaction in vm.internalUser\"><td>{{transaction.userId}}</td><td>{{transaction.userName}}</td><td>\n{{transaction.type}}</td><td>{{transaction.email}}</td><td>{{transaction.mobileNo}}</td><td>{{transaction.office.city}}\n</td><td><md-button class=\"md-raised md-warn\" ng-click=\"vm.add_exempted_users(transaction)\">Add</md-button></td></tr>\n</table><div layout=\"row\"><table id=\"customers\" class=\"table table-hover\"><tr><th style=\"width: 5%\" scope=\"col\">Sr No.\n</th><th style=\"width: 10%\" scope=\"col\">User ID</th><th style=\"width: 20%\" scope=\"col\">User Name</th><th \nstyle=\"width: 15%\" scope=\"col\">User Type</th><th style=\"width: 15%\" scope=\"col\">Date</th><th style=\"width: 20%\" \nscope=\"col\">Email</th><th style=\"width: 10%\" scope=\"col\">Mobile</th><th style=\"width: 5%\"></th></tr><tbody><tr \nng-repeat=\"each_combo in vm.userinfo\"><td style=\"width: 5%\">{{$index+1}}</td><td style=\"width: 10%\">\n{{each_combo.userId}}</td><td style=\"width: 20%\">{{each_combo.userName}}</td><td style=\"width: 15%\">{{each_combo.type}}\n</td><td style=\"width: 15%\">{{each_combo.exemptedDate | date:\'dd-MM-yyyy\'}}</td><td style=\"width: 10%\">\n{{each_combo.email}}</td><td style=\"width: 5%\">{{each_combo.mobileNo}}</td><td style=\"width: 5%\"><button \nclass=\"btn btn-danger\" ng-click=\"vm.remove_exempted_user(vm.id,each_combo._id)\" value=\"Remove\">Remove</button></td>\n</tr></tbody></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/syncing/syncing.html","<div id=\"syncingData\"><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nSyncing</span></div></div></div><table><tr><td><div class=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\">\n<div layout=\"column\" layout-align=\"center center\"><h3 class=\"font-20\">Syncing NSE User</h3><button mat-fab \nclass=\"cherry-gradient\" ng-disabled=\"vm.btnDisable\" ng-click=\"vm.getSyncNseUser()\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"textWhite\"></md-icon>Enter</button></div></md-card></div></td><td><div class=\"headerFixAllPages\"><md-card \nclass=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><h3 class=\"font-20\">Generate AUM Report\n</h3><button mat-fab class=\"cherry-gradient\" ng-click=\"vm.getSyncAumReport()\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"textWhite\"></md-icon>Enter</button></div></md-card></div></td><td><div class=\"headerFixAllPages\"><md-card \nclass=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><h3 class=\"font-20\">\nGenerate SIP Book Report</h3><button mat-fab class=\"cherry-gradient\" ng-click=\"vm.getSyncSIPBookReport()\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"textWhite\"></md-icon>Enter</button></div></md-card></div></td><td><div \nclass=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><h4 \nstyle=\"text-align: center\"><a ui-sref=\"app.syncinginfo\">Exempted Users</a></h4><h3 class=\"font-20\">Auto Lead Assignment\n</h3><div class=\"row\"><button mat-fab class=\"cherry-gradient\" ng-disabled=\"vm.disableAutoLead\" \nng-click=\"vm.startAutoLeadAssignment()\"><md-icon md-font-icon=\"icon-upload\" class=\"textWhite\"></md-icon>Start</button> \n<button mat-fab class=\"cherry-gradient\" ng-disabled=\"!vm.disableAutoLead\" ng-click=\"vm.stopAutoLeadAssignment()\">\n<md-icon md-font-icon=\"icon-upload\" class=\"textWhite\"></md-icon>Stop</button></div></div></md-card></div></td></tr><tr>\n<td><div class=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\"><div layout=\"column\" \nlayout-align=\"center center\"><h3 class=\"font-20\">Update NAV</h3><button mat-fab class=\"cherry-gradient\" \nng-click=\"vm.updateNAV()\"><md-icon md-font-icon=\"icon-upload\" class=\"textWhite\"></md-icon>Enter</button></div>\n</md-card></div></td><td><div class=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\"><div layout=\"column\" \nlayout-align=\"center center\"><h3 class=\"font-20\">Upload Customer</h3><input type=\"file\" id=\"customerFile\" \naccept=\".csv\" style=\"display: none\" onchange=\"angular.element(this).scope().vm.onFileSelected(this.files[0])\"> <button \nmat-fab class=\"cherry-gradient\" ng-click=\"vm.selectFile()\"><md-icon md-font-icon=\"icon-upload\" class=\"textWhite\">\n</md-icon>Select File</button><div ng-if=\"vm.selectedFile\" class=\"margin-top-10\"><small>\nSelected: {{vm.selectedFile.name}}</small></div><button mat-fab class=\"cherry-gradient margin-top-10\" \nng-if=\"vm.selectedFile\" ng-click=\"vm.uploadCustomer()\" ng-disabled=\"vm.uploading\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"textWhite\"></md-icon>{{vm.uploading ? \'Uploading...\' : \'Upload\'}}</button></div></md-card></div></td></tr><tr>\n<td><div class=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\"><div layout=\"column\" \nlayout-align=\"center center\"><h3 class=\"font-20\">SIP Due Report</h3><button mat-fab class=\"cherry-gradient\" \nng-click=\"vm.getSIPDueReport()\"><md-icon md-font-icon=\"icon-download\" class=\"textWhite\"></md-icon>Download</button>\n</div></md-card></div></td><td><div class=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\"><div \nlayout=\"column\" layout-align=\"center center\"><h3 class=\"font-20\">On Boarding Report</h3><button mat-fab \nclass=\"cherry-gradient\" ng-click=\"vm.getOnBoardingReport()\"><md-icon md-font-icon=\"icon-download\" class=\"textWhite\">\n</md-icon>Download</button></div></md-card></div></td><td><div class=\"headerFixAllPages\"><md-card \nclass=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><h3 class=\"font-20\">Redeem Report</h3>\n<button mat-fab class=\"cherry-gradient\" ng-click=\"vm.getRedeemReport()\"><md-icon md-font-icon=\"icon-download\" \nclass=\"textWhite\"></md-icon>Download</button></div></md-card></div></td><td><div class=\"headerFixAllPages\"><md-card \nclass=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><h3 class=\"font-20\">Cease Report</h3>\n<button mat-fab class=\"cherry-gradient\" ng-click=\"vm.getCeaseReport()\"><md-icon md-font-icon=\"icon-download\" \nclass=\"textWhite\"></md-icon>Download</button></div></md-card></div></td></tr><tr><td><div class=\"headerFixAllPages\">\n<md-card class=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><h3 class=\"font-20\">\nSIPfund Newsletter</h3><button mat-fab class=\"cherry-gradient\" ng-click=\"vm.openNewsletterDialog()\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"textWhite\"></md-icon>Send</button></div></md-card></div></td><td><div \nclass=\"headerFixAllPages\"><md-card class=\"border-radius b-dash\"><div layout=\"column\" layout-align=\"center center\"><h3 \nclass=\"font-20\">Transfer Out Report</h3><button mat-fab class=\"cherry-gradient\" ng-click=\"vm.getTransferOutReport()\">\n<md-icon md-font-icon=\"icon-download\" class=\"textWhite\"></md-icon>Download</button></div></md-card></div></td></tr>\n</table></div></div>");
$templateCache.put("app/main/uploadTransaction/uploadTransaction.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"uploadTransaction\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nUpload Transaction</span></div></div></div><div class=\"headerFixAllPages\"><div layout=\"row\" id=\"transaction\" \nlayout-wrap layout-margin layout-align=\"space-around center\" layout-fill><div flex=\"45\" layout=\"column\" layout-margin \nclass=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><h3>CAMS</h3><a \nui-sref=\"app.uploadTransaction.list({type:\'cams\'})\"><h4>Show Transaction List</h4></a></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"50\"><img src=\"./../../../assets/cams.jpg\" alt=\"\"></div></div><div layout=\"column\"><h4 \nclass=\"text-4a\">Last Upload on : {{vm.camsData.transactionDate | date: \'mediumDate\'}}</h4><h4 class=\"text-4a\">\nLast Transaction Date : {{vm.camsData.uploadTime | date: \'mediumDate\'}}</h4></div><div layout=\"row\" \nlayout-align=\"start center\"><div><input type=\"file\" accept=\".csv\" style=\"cursor: pointer\" name=\"file\" id=\"camsFile\" \nonchange=\"angular.element(this).scope().checkfile(this,\'camsFile\')\"><label for=\"camsFile\">{{vm.camsFile}}</label></div>\n<md-button class=\"md-accent md-raised\" ng-click=\"vm.uploadCamsTrxn()\">Upload</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.validateCamsList()\">Validate</md-button></div></div><div flex=\"45\" \nlayout=\"column\" layout-margin class=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><h3>KARVY</h3>\n<a ui-sref=\"app.uploadTransaction.list({type:\'karvy\'})\"><h4>Show Transaction List</h4></a></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"50\"><img src=\"./../../../assets/karvy.png\" alt=\"\"></div></div><div layout=\"column\"><h4 \nclass=\"text-4a\">Last Upload on : {{vm.karvyData.transactionDate | date: \'mediumDate\'}}</h4><h4 class=\"text-4a\">\nLast Transaction Date : {{vm.karvyData.uploadTime | date: \'mediumDate\'}}</h4></div><div layout=\"row\" \nlayout-align=\"start center\"><div><input type=\"file\" style=\"cursor: pointer\" accept=\".csv\" name=\"file\" id=\"karvyfile\" \nng-model-instant onchange=\"angular.element(this).scope().checkfile(this, \'karvyFile\')\"><label for=\"karvyfile\">\n{{vm.karvyFile}}</label></div><md-button class=\"md-accent md-raised\" ng-click=\"vm.uploadKarvyTrxn()\">Upload</md-button>\n<md-button class=\"md-accent md-raised\" ng-click=\"vm.validateKarvyList()\">Validate</md-button></div></div><div \nflex=\"45\" layout=\"column\" layout-margin class=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><h3>\nFranklin</h3><a ui-sref=\"app.uploadTransaction.list({type:\'franklin\'})\"><h4>Show Transaction List</h4></a></div><div \nlayout=\"column\" layout-align=\"center end\" flex=\"50\"><img src=\"./../../../assets/frankilin.png\" alt=\"\"></div></div><div \nlayout=\"column\"><h4 class=\"text-4a\">Last Upload on : {{vm.franklinData.transactionDate | date: \'mediumDate\'}}</h4><h4 \nclass=\"text-4a\">Last Transaction Date : {{vm.franklinData.uploadTime | date: \'mediumDate\'}}</h4></div><div \nlayout=\"row\" layout-align=\"start center\"><div><input type=\"file\" name=\"file\" accept=\".csv\" style=\"cursor: pointer\" \nid=\"franklinFile\" ng-model-instant onchange=\"angular.element(this).scope().checkfile(this,\'franklinFile\')\"><label \nfor=\"franklinFile\">{{vm.franklinFile}}</label></div><md-button class=\"md-accent md-raised\" \nng-click=\"vm.uploadFranklinTrxn()\">Upload</md-button><md-button class=\"md-accent md-raised\" \nng-click=\"vm.validateFranklinList()\">Validate</md-button></div></div><div flex=\"45\" layout=\"column\" layout-margin \nclass=\"tr-bg\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\"><h3>Sundram</h3><a \nui-sref=\"app.uploadTransaction.list({type:\'sundram\'})\"><h4>Show Transaction List</h4></a></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"50\"><img src=\"./../../../assets/sundaram.png\" alt=\"\"></div></div><div layout=\"column\">\n<h4 class=\"text-4a\">Last Upload on : {{vm.sundramData.transactionDate | date: \'mediumDate\'}}</h4><h4 class=\"text-4a\">\nLast Transaction Date : {{vm.sundramData.uploadTime | date: \'mediumDate\'}}</h4></div><div layout=\"row\" \nlayout-align=\"start center\"><div><input type=\"file\" accept=\".csv\" name=\"file\" style=\"cursor: pointer\" \nid=\"sundaramFile\" ng-model-instant onchange=\"angular.element(this).scope().checkfile(this,\'sundaramFile\')\"><label \nfor=\"sundaramFile\">{{vm.sundaramFile}}</label></div><md-button class=\"md-accent md-raised\" \nng-click=\"vm.uploadSundaramTransaction()\">Upload</md-button></div></div></div></div></div>");
$templateCache.put("app/core/directives/light-box/light-box.html","<md-dialog aria-label=\"Screenshot\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"title\" ng-bind=\"title\"></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \naria-label=\"Close dialog\" class=\"icon-static\"></md-icon></md-button></div></md-toolbar><md-dialog-content><img \nng-src=\"{{image}}\" alt=\"{{title}}\" class=\"demo-image\"></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/assignment-dashboard/document-verification/document-verification.html","<div id=\"documentVerifcation\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nDocument Verification</span></div></div><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor\" \nstyle=\"line-height:10px\"></md-icon><span style=\"line-height:-2%; margin-top:-14%\">Back</span></md-button></div><div \nclass=\"headerFixAllPages\"><md-content id=\"mainContent\" layout-padding class=\"scrollable\" ms-scroll><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-140 cursor\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" layout-wrap><div class=\"font-weight-500 secondary-text\" flex=\"50\">\nName: {{vm.userData.nseData.INVESTOR_NAME ? vm.userData.nseData.INVESTOR_NAME : vm.userData.userName}}</div><div \nclass=\"font-weight-500 secondary-text\" flex=\"50\">Email: {{vm.userData.email}}</div><div \nclass=\"font-weight-500 secondary-text\" flex=\"50\">IIN: {{vm.userData.iin}}</div><div \nclass=\"font-weight-500 secondary-text\" flex=\"50\">PAN: {{vm.userData.pan}}</div><div \nclass=\"font-weight-500 secondary-text\" flex=\"50\">Mobile: {{vm.userData.mobileNo}} <span \nng-show=\"!vm.userData.mobileVerifiedFlag\" class=\"redText\">Unverified</span> <span \nng-show=\"vm.userData.mobileVerifiedFlag\" class=\"greenText\">Verified</span></div></div></ms-widget-front></ms-widget>\n</div><div class=\"article padding-top-10\"><div class=\"article\"><md-content class=\"md-padding\" layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 \nclass=\"headerTextColor\">ID Proof Documents</h1></div><md-card-content class=\"padding-2\"><div layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div><h1 class=\"headerTextColorSub float-left\">\nPassport</h1><md-tooltip>{{vm.getImagePath(\'PA\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'PA\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'PA\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'PA\').url}}\"><img ng-if=\"vm.getImagePath(\'PA\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'PA\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'PA\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedPA\" name=\"state-PA\" type=\"radio\" class=\"default\" ng-checked=\"vm.getImagePath(\'PA\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PA\').docType,\'COMPLETE\')\"><label for=\"AcceptedPA\" \nng-class=\"vm.getImagePath(\'PA\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PA\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'PA\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingPA\" name=\"state-PA\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'PA\').status===\'PENDING\'\"><label for=\"pendingPA\">Pending\n</label><input id=\"rejectedPA\" name=\"state-PA\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PA\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PA\').docType,\'CANCELED\')\"><label for=\"rejectedPA\" \nng-class=\"vm.getImagePath(\'PA\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PA\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'PA\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</div><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div><h1 class=\"headerTextColorSub float-left\">\nDriving License</h1><md-tooltip>{{vm.getImagePath(\'DL\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'DL\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'DL\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'DL\').url}}\"><img ng-if=\"vm.getImagePath(\'DL\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'DL\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'DL\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedDL\" name=\"state-DL\" type=\"radio\" ng-checked=\"vm.getImagePath(\'DL\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'DL\').docType,\'COMPLETE\')\"><label for=\"AcceptedDL\" \nng-class=\"vm.getImagePath(\'DL\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'DL\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'DL\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingDL\" name=\"state-DL\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'DL\').status===\'PENDING\'\"><label for=\"pendingDL\">Pending\n</label><input id=\"rejectedDL\" name=\"state-DL\" type=\"radio\" ng-checked=\"vm.getImagePath(\'DL\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'DL\').docType,\'CANCELED\')\"><label for=\"rejectedDL\" \nng-class=\"vm.getImagePath(\'DL\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'DL\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'DL\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</div><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div><h1 class=\"headerTextColorSub float-left\">\nAadhaar Card Front</h1><md-tooltip>{{vm.getImagePath(\'AA1\').comments}}</md-tooltip><md-icon \nmd-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'\">\n</md-icon></div><md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'AA1\').url\" \nclass=\"objectFitBlog\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'AA1\').url}}\"><img ng-if=\"vm.getImagePath(\'AA1\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'AA1\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'AA1\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input\n id=\"AcceptedAA1\" name=\"state-AA1\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA1\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA1\').docType,\'COMPLETE\')\"><label for=\"AcceptedAA1\" \nng-class=\"vm.getImagePath(\'AA1\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA1\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'AA1\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingAA1\" name=\"state-AA1\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'AA1\').status===\'PENDING\'\"><label for=\"pendingAA1\">Pending\n</label><input id=\"rejectedAA1\" name=\"state-AA1\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA1\').docType,\'CANCELED\')\"><label for=\"rejectedAA1\" \nng-class=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA1\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'AA1\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</div><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div><h1 class=\"headerTextColorSub float-left\">\nAadhaar Card Back</h1><md-tooltip>{{vm.getImagePath(\'AA2\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'AA2\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'AA2\').url}}\"><img ng-if=\"vm.getImagePath(\'AA2\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'AA2\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'AA2\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input\n id=\"AcceptedAA2\" name=\"state-AA2\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA2\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA2\').docType,\'COMPLETE\')\"><label for=\"AcceptedAA2\" \nng-class=\"vm.getImagePath(\'AA2\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA2\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'AA2\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingAA2\" name=\"state-AA2\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'AA2\').status===\'PENDING\'\"><label for=\"pendingAA2\">Pending\n</label><input id=\"rejectedAA2\" name=\"state-AA2\" type=\"radio\" ng-checked=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'AA2\').docType,\'CANCELED\')\"><label for=\"rejectedAA2\" \nng-class=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'AA2\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'AA2\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</div></div></md-card-content></md-card></div></md-content><md-content class=\"md-padding\" layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 \nclass=\"headerTextColor\">PAN Card</h1></div><md-card-content class=\"padding-2\"><md-card><div><h1 \nclass=\"headerTextColorSub float-left\">PAN Card</h1><md-tooltip>{{vm.getImagePath(\'PC\').comments}}</md-tooltip><md-icon \nmd-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'PC\').status===\'CANCELED\'\">\n</md-icon></div><md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'PC\').url\" \nclass=\"objectFitBlog\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'PC\').url}}\"><img ng-if=\"vm.getImagePath(\'PC\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'PC\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'PC\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedPC\" name=\"state-PC\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PC\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PC\').docType,\'COMPLETE\')\"><label for=\"AcceptedPC\" \nng-class=\"vm.getImagePath(\'PC\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PC\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'PC\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingPC\" name=\"state-PC\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'PC\').status===\'PENDING\'\"><label for=\"pendingPC\">Pending\n</label><input id=\"rejectedPC\" name=\"state-PC\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PC\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PC\').docType,\'CANCELED\')\"><label for=\"rejectedPC\" \nng-class=\"vm.getImagePath(\'PC\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PC\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'PC\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</md-card-content></md-card></div><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 \nclass=\"headerTextColor\">Bank Documents</h1></div><md-card-content class=\"padding-2\"><div layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card><div><h1 class=\"headerTextColorSub float-left\">\nCancel Cheque</h1><md-tooltip>{{vm.getImagePath(\'CH\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'CH\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'CH\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'CH\').url}}\"><img ng-if=\"vm.getImagePath(\'CH\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'CH\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'CH\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedCH\" name=\"state-CH\" type=\"radio\" ng-checked=\"vm.getImagePath(\'CH\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'CH\').docType,\'COMPLETE\')\"><label for=\"AcceptedCH\" \nng-class=\"vm.getImagePath(\'CH\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'CH\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'CH\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingCH\" name=\"state-CH\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'CH\').status===\'PENDING\'\"><label for=\"pendingCH\">Pending\n</label><input id=\"rejectedCH\" name=\"state-CH\" type=\"radio\" ng-checked=\"vm.getImagePath(\'CH\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'CH\').docType,\'CANCELED\')\"><label for=\"rejectedCH\" \nng-class=\"vm.getImagePath(\'CH\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'CH\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'CH\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</div><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card><div><h1 class=\"headerTextColorSub float-left\">\nBank Passbook</h1><md-tooltip>{{vm.getImagePath(\'B\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'B\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'B\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'B\').url}}\"><img ng-if=\"vm.getImagePath(\'B\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'B\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.getImagePath(\'B\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input id=\"AcceptedB\" name=\"state-B\" \ntype=\"radio\" ng-checked=\"vm.getImagePath(\'B\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'B\').docType,\'COMPLETE\')\"><label for=\"AcceptedB\" \nng-class=\"vm.getImagePath(\'B\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'B\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'B\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingB\" name=\"state-B\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'B\').status===\'PENDING\'\"><label for=\"pendingB\">Pending\n</label><input id=\"rejectedB\" name=\"state-B\" type=\"radio\" ng-checked=\"vm.getImagePath(\'B\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'B\').docType,\'CANCELED\')\"><label for=\"rejectedB\" \nng-class=\"vm.getImagePath(\'B\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'B\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'B\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card></div>\n</div></md-card-content></md-card></div><div flex-xs flex-gt-xs=\"25\" layout=\"column\"><md-card><div \nclass=\"bgSubheading\"><h1 class=\"headerTextColor\">Investor Form</h1></div><md-card-content class=\"padding-2\"><md-card>\n<div><h1 class=\"headerTextColorSub float-left\">Investor Form</h1><md-tooltip>{{vm.getImagePath(\'IP\').comments}}\n</md-tooltip><md-icon md-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" \nng-if=\"vm.getImagePath(\'IP\').status===\'CANCELED\'\"></md-icon></div><md-card-content class=\"cardHeightFixeds\"><img \nng-if=\"!vm.getImagePath(\'IP\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'IP\').url}}\"><img ng-if=\"vm.getImagePath(\'IP\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'IP\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'IP\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input \nid=\"AcceptedIP\" name=\"state-IP\" type=\"radio\" ng-checked=\"vm.getImagePath(\'IP\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'IP\').docType,\'COMPLETE\')\"><label for=\"AcceptedIP\" \nng-class=\"vm.getImagePath(\'IP\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'IP\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'IP\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingIP\" name=\"state-IP\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'IP\').status===\'PENDING\'\"><label for=\"pendingIP\">Pending\n</label><input id=\"rejectedIP\" name=\"state-IP\" type=\"radio\" ng-checked=\"vm.getImagePath(\'IP\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'IP\').docType,\'CANCELED\')\"><label for=\"rejectedIP\" \nng-class=\"vm.getImagePath(\'IP\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'IP\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'IP\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</md-card-content></md-card></div></md-content><md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\"><div \nflex-xs flex-gt-xs=\"50\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 class=\"headerTextColor\">Video</h1></div>\n<md-card-content class=\"padding-2\"><md-card><div><h1 class=\"headerTextColorSub float-left\">Video</h1><md-tooltip>\n{{vm.getImagePath(\'VID\').comments}}</md-tooltip><md-icon md-font-icon=\"icon-comment\" \nclass=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'VID\').status===\'CANCELED\'\"></md-icon></div>\n<md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'VID\').url\" class=\"objectFitBlog\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'VID\').url}}\"><video ng-if=\"vm.getImagePath(\'VID\').url\" \nng-src=\"{{vm.trustSrc(vm.getImagePath(\'VID\').url)}}\" controls></video></a></md-card-content><md-card-actions \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.getImagePath(\'VID\').url\"><div \nclass=\"switch-toggle switch-3 switch-candy\"><input id=\"AcceptedVID\" name=\"state-VID\" type=\"radio\" \nng-checked=\"vm.getImagePath(\'VID\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'VID\').docType,\'COMPLETE\')\"><label for=\"AcceptedVID\" \nng-class=\"vm.getImagePath(\'VID\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'VID\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'VID\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingVID\" name=\"state-VID\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'VID\').status===\'PENDING\'\"><label for=\"pendingVID\">Pending\n</label><input id=\"rejectedVID\" name=\"state-VID\" type=\"radio\" ng-checked=\"vm.getImagePath(\'VID\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'VID\').docType,\'CANCELED\')\"><label for=\"rejectedVID\" \nng-class=\"vm.getImagePath(\'VID\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'VID\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'VID\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</md-card-content></md-card></div><div flex-xs flex-gt-xs=\"40\" layout=\"column\"><md-card><div class=\"bgSubheading\"><h1 \nclass=\"headerTextColor\">Passport Size Image</h1></div><md-card-content class=\"padding-2\"><md-card><div><h1 \nclass=\"headerTextColorSub float-left\">Image</h1><md-tooltip>{{vm.getImagePath(\'PIC\').comments}}</md-tooltip><md-icon \nmd-font-icon=\"icon-comment\" class=\"textColorDocsFonts float-right\" ng-if=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'\">\n</md-icon></div><md-card-content class=\"cardHeightFixeds\"><img ng-if=\"!vm.getImagePath(\'PIC\').url\" \nclass=\"objectFitBlog\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\"> <a target=\"_blank\" \nhref=\"{{vm.getImagePath(\'PIC\').url}}\"><img ng-if=\"vm.getImagePath(\'PIC\').url\" class=\"objectFitBlog\" \nng-src=\"{{vm.getImagePath(\'PIC\').url}}\"></a></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.getImagePath(\'PIC\').url\"><div class=\"switch-toggle switch-3 switch-candy\"><input\n id=\"AcceptedPIC\" name=\"state-VID\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PIC\').status===\'COMPLETE\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PIC\').docType,\'COMPLETE\')\"><label for=\"AcceptedPIC\" \nng-class=\"vm.getImagePath(\'PIC\').status===\'COMPLETE\'?\'accepted\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PIC\').status===\'COMPLETE\')\">Accept</span> <span \nng-if=\"vm.getImagePath(\'PIC\').status===\'COMPLETE\'\">Accepted</span></label><input id=\"pendingPIC\" name=\"state-VID\" \ntype=\"radio\" disabled=\"disabled\" ng-checked=\"vm.getImagePath(\'PIC\').status===\'PENDING\'\"><label for=\"pendingPIC\">Pending\n</label><input id=\"rejectedPIC\" name=\"state-VID\" type=\"radio\" ng-checked=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'\" \nng-click=\"vm.documentVerificationStatus(vm.getImagePath(\'PIC\').docType,\'CANCELED\')\"><label for=\"rejectedPIC\" \nng-class=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'?\'rejected\': \'\'\"><span \nng-if=\"!(vm.getImagePath(\'PIC\').status===\'CANCELED\')\">Reject</span> <span \nng-if=\"vm.getImagePath(\'PIC\').status===\'CANCELED\'\">Rejected</span></label><a></a></div></md-card-actions></md-card>\n</md-card-content></md-card></div></md-content></div></div></md-content></div></div>");
$templateCache.put("app/main/aum-report/customerDetailsScheme/customerDetailsScheme.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"75\">\n<div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span style=\"font-size:18px\">\n{{vm.customers.schemeName}}</span></div><div class=\"product-count secondary-text margin-top-10\"><span>Total Investors:\n</span> <span>{{vm.customers.investors.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"headerFixAllPages\"><div class=\"ext-content\">\n<md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" \nmd-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th \nmd-column md-order-by=\"investorName\"><span class=\"text-center\">Name</span></th><th md-column md-order-by=\"pan\"><span>\nPAN</span></th><th md-column md-order-by=\"iin\"><span>IIN</span></th><th md-column md-order-by=\"amount\"><span>Amount\n</span></th><th md-column md-order-by=\"currentCAGR\"><span>CAGR</span></th><th md-column md-order-by=\"absoluteReturn\">\n<span>Absolute Return</span></th><th md-column md-order-by=\"profitLoss\"><span>Profit/Loss</span></th></tr></thead>\n<tbody md-body><div class=\"scrollable\" ms-scroll><tr md-row md-select=\"customer\" md-auto-select \nmd-virtual-repeat=\"customer in vm.customers.investors | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.customerDetailFunction(customer)\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{customer.investorName}}</td><td md-cell>{{customer.pan}}</td><td md-cell>{{customer.iin}}</td><td md-cell>\n{{customer.amount | number:2}}</td><td md-cell>{{customer.currentCAGR}}</td><td md-cell>\n{{customer.absoluteReturn | number:2}}</td><td md-cell>{{customer.profitLoss | number:2}}</td></tr></div></tbody>\n</table></md-table-container></md-virtual-repeat-container></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><span class=\"objectFit\">\n<img ng-src=\"/assets/images/logos/logo@2x.png\"></span></div><div class=\"title\"><span ng-show=\"!vm.resetForm\">\nLog in to your account</span> <span ng-show=\"vm.resetForm\">Recover your password</span></div><form name=\"loginForm\" \nnovalidate ng-show=\"!vm.resetForm\"><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"vm.login()\" style=\"color:#fff !important\">LOG IN\n</md-button><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><a \nclass=\"forgot-password md-accent-color\" ng-click=\"vm.resetForm = !vm.resetForm\">Forgot Password?</a></div></form><form \nname=\"forgotPasswordForm\" novalidate ng-show=\"vm.resetForm\"><md-input-container class=\"md-block\" md-no-float><input \ntype=\"email\" name=\"email\" ng-model=\"vm.resetData.email\" placeholder=\"Email address\" ng-pattern=\"/^.+@.+\\..+$/\" \nrequired><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"pattern\"><span>\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.forgotPassword()\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.email.$error.pattern || forgotPasswordForm.email.$error.type || forgotPasswordForm.email.$error.required\" \nstyle=\"color:#fff !important\">SEND OTP</md-button><md-input-container class=\"md-block\" md-no-float><input name=\"otp\" \ntype=\"password\" ng-model=\"vm.resetData.otp\" placeholder=\"OTP\" required><div \nng-messages=\"forgotPasswordForm.otp.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nOTP field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input \nname=\"resetData\" type=\"password\" ng-model=\"vm.resetData.newPassword\" placeholder=\"New Password\" required><div \nng-messages=\"forgotPasswordForm.resetData.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nNew Password field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.resetNewPassword()\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" style=\"color:#fff !important\">RESET PASSWORD\n</md-button></form><div ng-show=\"vm.resetForm\" class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nng-click=\"vm.resetForm = !vm.resetForm\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/communicationSMS/communication-custom/communication-custom.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"customCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nList Of Customers Communication SMS</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nclass=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" ui-sref=\"app.communication\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"bgCustomHeader\"><div class=\"margin-left-15\"><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.customerCount()\" \nlabel=\"All Customer\">{{vm.selected.length>0? \'Deselect All Customer\':\'Select All Customer\'}}</md-button><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.sendMessage()\" \nng-disabled=\"!vm.selected.length>0\"><md-icon md-font-icon=\"icon-email\" style=\"cursor:pointer\"></md-icon>Send Message\n</md-button></div></div><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Select</span></th><th md-column md-order-by=\"userName\"><span>\nName</span></th><th md-column md-order-by=\"contactNo\"><span>Contact</span></th><th md-column md-order-by=\"email\"><span>\nEmail Id</span></th><th md-column md-order-by=\"pan\"><span>PAN No.</span></th><th md-column md-order-by=\"iin\"><span>IIN\n</span></th></tr></thead><tbody md-body><div class=\"scrollable\" ms-scroll><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"customer in vm.customers | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\"><td \nmd-cell><input type=\"checkbox\" ng-model=\"customer.isChecked\" ng-change=\"vm.selectEntity(customer)\"></td><td md-cell>\n<span ng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell>{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>\n{{(customer.email) ? (customer.email):\'NA\'}}</td><td md-cell>{{(customer.pan) ? (customer.pan) :\'NA\'}}</td><td md-cell>\n{{(customer.iin) ? (customer.iin) :\'NA\'}}</td></tr></div></tbody></table></md-table-container>\n</md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/communication/communication-prospects/communication-prospects.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"customCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nList Of Prospects Communication</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nclass=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" ui-sref=\"app.communication\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"bgCustomHeader\"><div class=\"margin-left-15\"><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.customerCount()\" \nlabel=\"All Customer\">{{vm.selected.length>0? \'Deselect All Customer\':\'Select All Customer\'}}</md-button><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.sendMessage()\" \nng-disabled=\"!vm.selected.length>0\"><md-icon md-font-icon=\"icon-email\" style=\"cursor:pointer\"></md-icon>Send Message\n</md-button></div></div><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Select</span></th><th md-column md-order-by=\"userName\"><span>\nName</span></th><th md-column md-order-by=\"contactNo\"><span>Contact</span></th><th md-column md-order-by=\"email\"><span>\nEmail Id</span></th><th md-column md-order-by=\"pan\"><span>PAN No.</span></th></tr></thead><tbody md-body><div \nclass=\"scrollable\" ms-scroll><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"customer in vm.customers | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\"><td \nmd-cell><input type=\"checkbox\" ng-model=\"customer.isChecked\" ng-change=\"vm.selectEntity(customer)\"></td><td md-cell>\n<span ng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell>{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>\n{{(customer.email) ? (customer.email):\'NA\'}}</td><td md-cell>{{(customer.pan) ? (customer.pan) :\'NA\'}}</td></tr></div>\n</tbody></table></md-table-container></md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/communicationSMS/communication-prospects/communication-prospects.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"customCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nList Of Prospects Communication</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nclass=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" ui-sref=\"app.communication\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"bgCustomHeader\"><div class=\"margin-left-15\"><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.customerCount()\" \nlabel=\"All Customer\">{{vm.selected.length>0? \'Deselect All Customer\':\'Select All Customer\'}}</md-button><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.sendMessage()\" \nng-disabled=\"!vm.selected.length>0\"><md-icon md-font-icon=\"icon-email\" style=\"cursor:pointer\"></md-icon>Send Message\n</md-button></div></div><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Select</span></th><th md-column md-order-by=\"userName\"><span>\nName</span></th><th md-column md-order-by=\"contactNo\"><span>Contact</span></th><th md-column md-order-by=\"email\"><span>\nEmail Id</span></th><th md-column md-order-by=\"pan\"><span>PAN No.</span></th></tr></thead><tbody md-body><div \nclass=\"scrollable\" ms-scroll><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"customer in vm.customers | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\"><td \nmd-cell><input type=\"checkbox\" ng-model=\"customer.isChecked\" ng-change=\"vm.selectEntity(customer)\"></td><td md-cell>\n<span ng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell>{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>\n{{(customer.email) ? (customer.email):\'NA\'}}</td><td md-cell>{{(customer.pan) ? (customer.pan) :\'NA\'}}</td></tr></div>\n</tbody></table></md-table-container></md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/communication/create-customers/create-customers.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Create Customers</span></div></div></div>\n<div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><div \nlayout=\"row\" layout-align=\" center\" layout-wrap flex><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Sign-In Details</h4><br><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Enter Mobile No</label><input type=\"text\" numeric-regex ng-model=\"vm.mobileNo\" name=\"mobileNo\" \nrequired ng-pattern=\"vm.mobileNoRegEx\"><div ng-messages=\"wizardStep1.mobileNo.$error\" role=\"alert\"><div \nng-message=\"required\">Mobile Number is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Email ID</label><input type=\"email\" ng-model=\"vm.email\" name=\"email\" required \nng-pattern=\"vm.emailRegex\"><div ng-messages=\"wizardStep1.email.$error\" role=\"alert\"><div ng-message=\"required\">\nEmail is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Enter PAN No\n</label><input type=\"text\" capitalize maxlength=\"10\" ng-model=\"vm.pan\" name=\"pan\" required ng-pattern=\"vm.panRegEx\">\n<div ng-messages=\"wizardStep1.pan.$error\" role=\"alert\"><div ng-message=\"required\">PAN is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Enter Password</label><input type=\"text\" \nng-model=\"vm.password\" name=\"password\" required minlength=\"4\"><div ng-messages=\"wizardStep1.password.$error\" \nrole=\"alert\"><div ng-message=\"required\">Password is required</div></div></md-input-container><md-input-container \nflex=\"10\" flex-gt-xs=\"50\"><md-button class=\"md-raised width-150\" ng-click=\"vm.verifyCustomers()\">Verify Details\n</md-button></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"></md-input-container></div></div></div>\n<div class=\"row\"><div class=\"col-sm-12\"><div layout=\"row\" layout-align=\" center\" layout-wrap flex><h4 \nclass=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Customer Details</h4><br>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Title</label><md-select ng-model=\"vm.title\" name=\"title\" \nrequired><md-option ng-repeat=\"x in vm.titleData\" ng-value=\"x\">{{x}}</md-option></md-select><div \nng-messages=\"wizardStep1.title.$error\" role=\"alert\"><div ng-message=\"required\">Title is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Name</label><input type=\"text\" \nng-model=\"vm.name\" name=\"name\" required><div ng-messages=\"wizardStep1.name.$error\" role=\"alert\"><div \nng-message=\"required\">Name is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>Occupation</label><md-select ng-model=\"vm.occupation\" required name=\"occupationField\" \nng-model-options=\"{trackBy: \'$value.OCCUPATION_CODE\'}\"><md-option ng-repeat=\"x in vm.occupationData\" ng-value=\"x\">\n{{x.OCCUPATION_DESC}}</md-option></md-select><div ng-messages=\"wizardStep1.occupation.$error\" role=\"alert\"><div \nng-message=\"required\">Occupation is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Enter DOB</label><input type=\"date\" ng-model=\"vm.dob\" name=\"dob\" required><div \nng-messages=\"wizardStep1.dob.$error\" role=\"alert\"><div ng-message=\"required\">DOB is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Father Name</label><input type=\"text\" \nng-model=\"vm.fatherName\" name=\"fatherName\" required><div ng-messages=\"wizardStep1.fatherName.$error\" role=\"alert\"><div \nng-message=\"required\">Father Name is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Mother Name</label><input type=\"text\" ng-model=\"vm.motherName\" name=\"motherName\" required><div \nng-messages=\"wizardStep1.motherName.$error\" role=\"alert\"><div ng-message=\"required\">Mother Name is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Applicant Income(Annual)</label><md-select \nng-model=\"vm.app_income\" required name=\"app_income\" ng-model-options=\"{trackBy: \'$value.APP_INCOME_CODE\'}\"><md-option \nng-repeat=\"x in vm.applicableincomeData\" ng-value=\"x\">{{x.APP_INCOME_DESC}}</md-option></md-select><div \nng-messages=\"wizardStep1.app_income.$error\" role=\"alert\"><div ng-message=\"required\">\nApplicant Income(Annual) is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-sm=\"50\">\n<label>Source Of Wealth</label><md-select ng-model=\"vm.source_wealth\" name=\"source_wealth\" required \nng-model-options=\"{trackBy: \'$value.CODE\'}\"><md-option ng-repeat=\"x in vm.sourceWealthData\" ng-value=\"x\">\n{{x.SOURCE_OF_WEALTH}}</md-option></md-select><div ng-messages=\"wizardStep1.source_wealth.$error\" role=\"alert\"><div \nng-message=\"required\">Source Of Wealth is required</div></div></md-input-container><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Contact Details</h4><br><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Address</label><input type=\"text\" ng-model=\"vm.address\" name=\"address\" required><div \nng-messages=\"wizardStep1.address.$error\" role=\"alert\"><div ng-message=\"required\">Address is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Pincode</label><input type=\"text\" \nng-pattern=\"/^\\d{6}$/\" numeric-regex maxlength=\"6\" ng-model=\"vm.pinCode\" name=\"pinCode\" \nng-change=\"vm.getStateCityDetailsPinCodeNew()\" required><div ng-messages=\"wizardStep1.pinCode.$error\" role=\"alert\"><div\n ng-message=\"required\">Pincode is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>City</label><input type=\"text\" ng-model=\"vm.city\" name=\"city\" required><div \nng-messages=\"wizardStep1.city.$error\" role=\"alert\"><div ng-message=\"required\">City is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>State</label><input type=\"text\" \nng-model=\"vm.state\" name=\"state\" required><div ng-messages=\"wizardStep1.state.$error\" role=\"alert\"><div \nng-message=\"required\">State is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>Email Relation</label><md-select ng-model=\"vm.emailRelation\" name=\"emailRelation\" required \nng-model-options=\"{trackBy: \'$value.RelationKey\'}\"><md-option ng-repeat=\"x in vm.rseRelationshipData\" ng-value=\"x\">\n{{x.RelationValue}}</md-option></md-select><div ng-messages=\"wizardStep1.emailRelation.$error\" role=\"alert\"><div \nng-message=\"required\">Email Relation is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Mobile Relation</label><md-select ng-model=\"vm.mobileRelation\" name=\"mobileRelation\" required \nng-model-options=\"{trackBy: \'$value.RelationKey\'}\"><md-option ng-repeat=\"x in vm.rseRelationshipData\" ng-value=\"x\">\n{{x.RelationValue}}</md-option></md-select><div ng-messages=\"wizardStep1.mobileRelation.$error\" role=\"alert\"><div \nng-message=\"required\">Mobile Relation is required</div></div></md-input-container><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF\">Bank Details</h4><br><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>Account Type</label><md-select ng-model=\"vm.accountType\" name=\"accountType\" required \nng-model-options=\"{trackBy: \'$value.ACC_TYPE\'}\"><md-option ng-repeat=\"x in vm.newAccountTypeData\" ng-value=\"x\">\n{{x.DESCRIPTION}}</md-option></md-select><div ng-messages=\"wizardStep1.accountType.$error\" role=\"alert\"><div \nng-message=\"required\">Account Type is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Account No.</label><input type=\"number\" ng-model=\"vm.accountNo\" name=\"accountNo\" required><div \nng-messages=\"wizardStep1.accountNo.$error\" role=\"alert\"><div ng-message=\"required\">Account No is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>IFSC Code</label><input type=\"text\" \nname=\"ifscCode\" ng-model=\"vm.ifscCode\" ng-change=\"vm.getBankDetailsFrmIFSC()\" required><div \nng-messages=\"wizardStep1.ifscCode.$error\" role=\"alert\"><div ng-message=\"required\">IFSC code is required!</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Bank Name</label><input type=\"text\" \nng-model=\"vm.bankName\" name=\"bankName\" required><div ng-messages=\"wizardStep1.bankName.$error\" role=\"alert\"><div \nng-message=\"required\">Bank Name is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Branch Name</label><input type=\"text\" ng-model=\"vm.branchName\" name=\"branchName\" required><div \nng-messages=\"wizardStep1.branchName.$error\" role=\"alert\"><div ng-message=\"required\">Branch Name is required</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Branch Address</label><input type=\"text\" \nng-model=\"vm.branchAddress\" name=\"branchAddress\" required><div ng-messages=\"wizardStep1.branchAddress.$error\" \nrole=\"alert\"><div ng-message=\"required\">Branch Address is required</div></div></md-input-container><h4 \nclass=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Nominee Details</h4><br>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Wand to add Nominee ?</label><md-select \nng-model=\"vm.wantToAddNominee\" name=\"wantToAddNominee\" required><md-option value=\"yes\">Yes</md-option><md-option \nvalue=\"no\">No</md-option></md-select><div ng-messages=\"wizardStep1.wantToAddNominee.$error\" role=\"alert\"><div \nng-message=\"required\">This field is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" ng-if=\"vm.wantToAddNominee != \'yes\'\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" ng-if=\"vm.wantToAddNominee == \'yes\'\"><label>Nominee Name</label><input type=\"text\" \nng-model=\"vm.nomineeName\" name=\"nomineeName\" required><div ng-messages=\"wizardStep1.nomineeName.$error\" role=\"alert\">\n<div ng-message=\"required\">Nominee Name is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" ng-if=\"vm.wantToAddNominee == \'yes\'\"><label>Relationship</label><md-select ng-model=\"vm.relationship\" \nname=\"relationship\" required><md-option ng-repeat=\"x in vm.relationData\" ng-value=\"x.code\">{{x.nomineerelationship}}\n</md-option></md-select><div ng-messages=\"wizardStep1.relationship.$error\" role=\"alert\"><div ng-message=\"required\">\nRelationship is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\'\"><label>Select PAN or AADHAR</label><md-select ng-model=\"vm.nom1_id_type\" \nname=\"nom1_id_type\" required><md-option value=\"1\">PAN</md-option><md-option value=\"2\">AADHAR</md-option></md-select>\n<div ng-messages=\"wizardStep1.nom1_id_type.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\' && vm.nom1_id_type === \'1\'\"><label>Nominee PAN No</label><input type=\"text\" \ncapitalize maxlength=\"10\" ng-model=\"vm.nomineePan\" name=\"nom1_pan\" required ng-pattern=\"vm.panRegEx\"><div \nng-messages=\"wizardStep1.nom1_pan.$error\" role=\"alert\"><div ng-message=\"required\">Nominee PAN Number is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\' && vm.nom1_id_type === \'2\'\"><label>Nominee AADHAR No last 4 digits</label><input \ntype=\"text\" capitalize maxlength=\"4\" ng-model=\"vm.nomineeAadhar\" name=\"nom1_aadhar\" required \nng-pattern=\"vm.aadharNoRegEx\"><div ng-messages=\"wizardStep1.nom1_aadhar.$error\" role=\"alert\"><div \nng-message=\"required\">Nominee AADHAR last 4 digits is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\" ng-if=\"vm.wantToAddNominee == \'yes\'\"><label>Nominee Mobile No</label><input type=\"text\" \nnumeric-regex ng-model=\"vm.nom1_mobile\" name=\"nom1_mobile\" required ng-pattern=\"vm.mobileNoRegEx\"><div \nng-messages=\"wizardStep1.nom1_mobile.$error\" role=\"alert\"><div ng-message=\"required\">Nominee Mobile Number is required\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-if=\"vm.wantToAddNominee == \'yes\'\">\n<label>Nominee Email ID</label><input type=\"email\" ng-model=\"vm.nom1_email\" name=\"nom1_email\" required \nng-pattern=\"vm.emailRegex\"><div ng-messages=\"wizardStep1.nom1_email.$error\" role=\"alert\"><div ng-message=\"required\">\nNominee Email is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\'\"><label>Nominee DOB</label><input ng-model=\"vm.nominee1_dob\" name=\"nominee1_dob\" \ntype=\"date\" required><div ng-messages=\"wizardStep1.nominee1_dob.$error\" role=\"alert\"><div ng-message=\"required\">\nNominee dob is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\'\"><label>Is Nominee Minor ?</label><md-select ng-model=\"vm.isNomineeMinor\" \nname=\"isNomineeMinor\" required><md-option value=\"Y\">Yes</md-option><md-option value=\"N\">No</md-option></md-select><div \nng-messages=\"wizardStep1.isNomineeMinor.$error\" role=\"alert\"><div ng-message=\"required\">This field is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\' && vm.isNomineeMinor != \'Y\'\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" ng-if=\"vm.wantToAddNominee == \'yes\' && vm.isNomineeMinor == \'Y\'\"><label>Guardian Name</label><input \ntype=\"text\" ng-model=\"vm.guardianName\" name=\"guardianName\" required><div ng-messages=\"wizardStep1.guardianName.$error\" \nrole=\"alert\"><div ng-message=\"required\">Guardian Name is required</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\" ng-if=\"vm.wantToAddNominee == \'yes\' && vm.isNomineeMinor == \'Y\'\"><label>\nGuardian Relationship</label><md-select ng-model=\"vm.nominee1_guard_relation\" name=\"nominee1_guard_relation\" required>\n<md-option ng-repeat=\"x in vm.guardianRelationData\" ng-value=\"x.MINOR_GUARD_REL_CODE\">{{x.MINOR_GUARD_REL}}</md-option>\n</md-select><div ng-messages=\"wizardStep1.nominee1_guard_relation.$error\" role=\"alert\"><div ng-message=\"required\">\nGuardian Relationship is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\' && vm.isNomineeMinor == \'Y\'\"><label>Guardian PAN</label><input type=\"text\" \ncapitalize maxlength=\"10\" ng-model=\"vm.guardianPan\" name=\"guardianPan\" required><div \nng-messages=\"wizardStep1.guardianPan.$error\" role=\"alert\"><div ng-message=\"required\">Guardian PAN is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.wantToAddNominee == \'yes\' && vm.isNomineeMinor == \'Y\'\"></md-input-container><md-input-container flex=\"10\" \nflex-gt-xs><button class=\"md-raised md-accent md-button width-150 md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.createAccount()\" style=\"float:right; color:#fff !important\"><span class=\"ng-scope\">Create Customer</span>\n</button></md-input-container></div></div></div></md-card></div></div>");
$templateCache.put("app/main/communication/send-app-link/send-app-link.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Send App Link</span></div></div><div \nclass=\"white-fg h3\" layout=\"column\" layout-align=\"start start\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.communicationSmsEmail()\">Send</md-button></div></div><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div layout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div \nclass=\"col-sm-12\"><form name=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"40\"><label>\ninvestor Name</label><input type=\"text\" ng-model=\"vm.investorName\" name=\"investorName\" tabindex=\"1\" required><div \nng-messages=\"myForm.investorName.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nInvestor Name is required</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"40\"><input \ntype=\"number\" name=\"contactnumber\" tabindex=\"2\" ng-model=\"vm.contact\" numeric-regex ng-pattern=\"/^[1-9]{1}[0-9]{9}$/\" \noncopy=\"return false\" ondrag=\"return false\" ondrop=\"return false\" onpaste=\"return false\" autocomplete=\"off\" \nplaceholder=\"Contact Number\" required><div ng-messages=\"myForm.contactnumber.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Contact Number is required</span></div><div ng-message=\"pattern\"><span>\nContact Number must be of valid Digits</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"20\"><md-button class=\"md-raised md-accent\" tabindex=\"3\" ng-click=\"vm.add()\" style=\"color:#fff !important\">\nAdd</md-button></md-input-container></div><hr><div layout=\"row\"><table id=\"customers\" class=\"table table-hover\"><tr><th\n style=\"width: 10%\" scope=\"col\">Sr No.</th><th style=\"width: 50%\" scope=\"col\">Investor Name</th><th style=\"width: 25%\" \nscope=\"col\">Contact No.</th><th style=\"width: 15%\"></th></tr><tbody ng-repeat=\"customer in vm.customer.investors\"><tr>\n<td style=\"width: 10%\">{{$index+1}}</td><td style=\"width: 50%\">{{customer.userName}}</td><td style=\"width: 25%\">\n{{customer.mobileNo}}</td><td style=\"width: 15%\"><button class=\"btn btn-danger\" ng-click=\"vm.remove($index)\" \nvalue=\"Remove\">Remove</button></td></tr></tbody></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/communication/fatca-retrigger-mail/fatca-retrigger-mail.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Fatca Retrigger Mail</span></div></div>\n</div><div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><div \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div layout=\"row\" layout-align=\"center center\"><form name=\"wizardStep1\" class=\"md-inline-form\" \nstyle=\"width: 50%\"><br><div layout=\"column\" layout-align=\"start stretch\" flex><md-input-container flex=\"100\"><label>\nEnter iin</label><input type=\"text\" numeric-regex maxlength=\"10\" minlength=\"10\" ng-model=\"vm.iin\" name=\"iin\" required>\n</md-input-container><md-input-container flex=\"100\"><label>Pan</label><input type=\"text\" ng-model=\"vm.pan\" capitalize \nmaxlength=\"10\" name=\"pan\" required></md-input-container><md-input-container flex=\"100\"><label>Email</label><input \ntype=\"text\" ng-model=\"vm.email\" name=\"email\" required></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.fatcaretriggermail()\" \nstyle=\"color:#fff !important\">Send</md-button></div></div></form></div></md-card></div></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/communication/send-transaction-report/send-transaction-report.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Send Transaction Report</span></div></div>\n</div><div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div layout-gt-sm=\"row\" \nlayout-align=\"center center\"></div><div class=\"row\"><div class=\"col-sm-12\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\"><br><div layout=\"row\" layout-align=\" center\" layout-wrap flex><md-input-container flex=\"100\" \nflex-gt-xs=\"40\"><label>Enter IIN</label><input type=\"text\" ng-model=\"vm.iin\" name=\"iin\" tabindex=\"1\" required><div \nng-messages=\"myForm.iin.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>IIN is required\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\"><md-button \nclass=\"md-raised md-accent\" tabindex=\"3\" ng-click=\"vm.sendTransactionReport()\" style=\"color:#fff !important\">\nSend Transaction Report</md-button></md-input-container></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/communication/mark-interested/mark-interested.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Mark Interested</span></div></div></div>\n<div class=\"headerFixAllPages\"><md-card class=\"container-fluid\"><div layout-gt-sm=\"row\" layout-align=\"center center\">\n</div><div class=\"row\"><div class=\"col-sm-12\"><form name=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" \nlayout-align=\"center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"40\"><input type=\"number\" \nname=\"contactnumber\" tabindex=\"2\" ng-model=\"vm.contact\" numeric-regex ng-pattern=\"/^[1-9]{1}[0-9]{9}$/\" \noncopy=\"return false\" ondrag=\"return false\" ondrop=\"return false\" autocomplete=\"off\" placeholder=\"Contact Number\" \nrequired><div ng-messages=\"myForm.contactnumber.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Mobile Number is required</span></div><div ng-message=\"pattern\"><span>Mobile Number must be of valid Digits\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\"><md-button \nclass=\"md-raised md-accent\" tabindex=\"3\" ng-click=\"vm.userInfoListOnMobile()\" style=\"color:#fff !important\">Search\n</md-button></md-input-container></div><hr><div layout=\"row\" ng-show=\"vm.customerData !== \'\'\"><table \nclass=\"table table-hover\"><tr><th style=\"width: 35%\" scope=\"col\">Investor Name.</th><th style=\"width: 20%\" scope=\"col\">\nContact No.</th><th style=\"width: 20%\" scope=\"col\">IIN.</th><th style=\"width: 20%\" scope=\"col\">Pan No.</th><th \nstyle=\"width: 15%\" scope=\"col\">Status.</th></tr><tbody><tr><td style=\"width: 25%\">\n{{vm.customerData.data.data.userName}}</td><td style=\"width: 20%\">{{vm.customerData.data.data.mobileNo}}</td><td \nstyle=\"width: 20%\">{{vm.customerData.data.data.iin}}</td><td style=\"width: 20%\">{{vm.customerData.data.data.pan}}</td>\n<td style=\"width: 15%\"><button class=\"btn btn-success\" \nng-click=\"vm.userNotInterestedUpdate(vm.customerData.data.data.mobileNo)\" value=\"Remove\">Interested</button></td></tr>\n</tbody></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/communication/communication-custom/communication-custom.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"customCustomer\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nList Of Customers Communication</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nclass=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" ui-sref=\"app.communication\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"bgCustomHeader\"><div class=\"margin-left-15\"><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.customerCount()\" \nlabel=\"All Customer\">{{vm.selected.length>0? \'Deselect All Customer\':\'Select All Customer\'}}</md-button><md-button \nclass=\"md-raised width-200 textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selected.length === vm.customers.length}\" ng-click=\"vm.sendMessage()\" \nng-disabled=\"!vm.selected.length>0\"><md-icon md-font-icon=\"icon-email\" style=\"cursor:pointer\"></md-icon>Send Message\n</md-button></div></div><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Select</span></th><th md-column md-order-by=\"userName\"><span>\nName</span></th><th md-column md-order-by=\"contactNo\"><span>Contact</span></th><th md-column md-order-by=\"email\"><span>\nEmail Id</span></th><th md-column md-order-by=\"pan\"><span>PAN No.</span></th><th md-column md-order-by=\"iin\"><span>IIN\n</span></th></tr></thead><tbody md-body><div class=\"scrollable\" ms-scroll><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"customer in vm.customers | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\"><td \nmd-cell><input type=\"checkbox\" ng-model=\"customer.isChecked\" ng-change=\"vm.selectEntity(customer)\"></td><td md-cell>\n<span ng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell>{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>\n{{(customer.email) ? (customer.email):\'NA\'}}</td><td md-cell>{{(customer.pan) ? (customer.pan) :\'NA\'}}</td><td md-cell>\n{{(customer.iin) ? (customer.iin) :\'NA\'}}</td></tr></div></tbody></table></md-table-container>\n</md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/communication/transaction-detailed-report/transaction-detailed-report.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Transaction Detailed Report</span></div>\n</div></div><div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div\n class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"row\"><div class=\"col-sm-12\"><div \nlayout=\"row\" layout-align=\"center\" layout-wrap flex style=\"margin-left: 11px; margin-right: 20px\"><h4 \nclass=\"bar-heading\" flex=\"100\" style=\"background-color: #2D323E; color: #FFFFFF\">Transaction Detailed Report</h4><br>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>From Date</label><input type=\"date\" ng-model=\"vm.from_date\" \nname=\"fromDate\" max=\"{{ vm.maxDate }}\" ng-change=\"vm.validateDates()\" ng-keyup=\"vm.validateDates()\" required><div \nng-messages=\"transactionDetailedForm.fromDate.$error\" role=\"alert\"><div ng-message=\"required\">From Date is required\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>To Date</label><input \ntype=\"date\" ng-model=\"vm.to_date\" name=\"toDate\" max=\"{{ vm.maxDate }}\" min=\"{{ vm.from_date }}\" \nng-change=\"vm.validateDates()\" ng-keyup=\"vm.validateDates()\" required><div \nng-messages=\"transactionDetailedForm.toDate.$error\" role=\"alert\"><div ng-message=\"required\">To Date is required</div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Client Code</label><input type=\"text\" \nng-model=\"vm.client_code\" name=\"clientCode\"><div ng-messages=\"transactionDetailedForm.clientCode.$error\" role=\"alert\">\n<div ng-message=\"required\">Client Code is required</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Transaction Type</label><md-select ng-model=\"vm.trans_type\" name=\"transactionType\" required>\n<md-option ng-repeat=\"x in vm.transTypeArray\" ng-value=\"x.code\">{{x.desc}}</md-option></md-select><div \nng-messages=\"transactionDetailedForm.transactionType.$error\" role=\"alert\"><div ng-message=\"required\">\nTransaction Type is required</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nOrder Type</label><md-select ng-model=\"vm.order_type\" name=\"orderType\" required><md-option \nng-repeat=\"x in vm.orderTypeArray\" ng-value=\"x.code\">{{x.desc}}</md-option></md-select><div \nng-messages=\"transactionDetailedForm.orderType.$error\" role=\"alert\"><div ng-message=\"required\">Order Type is required\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Sub Order Type</label><md-select\n ng-model=\"vm.sub_order_type\" name=\"subOrderType\" required><md-option ng-repeat=\"x in vm.subOrderTypeArray\" \nng-value=\"x.code\">{{x.desc}}</md-option></md-select><div ng-messages=\"transactionDetailedForm.subOrderType.$error\" \nrole=\"alert\"><div ng-message=\"required\">Sub Order Type is required</div></div></md-input-container><md-input-container \nflex=\"10\" flex-gt-xs><md-button class=\"md-raised md-accent\" ng-click=\"vm.getTransactionDetailedReport()\" \nstyle=\"color:#fff !important\" \nng-disabled=\"!vm.from_date || !vm.to_date || !vm.trans_type || !vm.order_type || !vm.sub_order_type\">Submit</md-button>\n</md-input-container></div></div></div></div></div><div class=\"scrollable\" ms-scroll \nng-if=\"vm.transactionReport.length > 0\"><div class=\"white-bg\" layout=\"column\"><div layout=\"column\" flex=\"100\"><h4 \nclass=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">\nDetailed Report ({{vm.transactionReport.length}} Records)</h4><div flex=\"100\" layout=\"row\" layout-align=\"end end\" \nstyle=\"padding: 10px\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.downloadTransactionReport()\" \nstyle=\"float:right; color:#fff !important\"><md-icon md-font-icon=\"icon-arrow-down-bold\" style=\"color:#fff\"></md-icon>\nDownload CSV</md-button></div><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\">\n<md-table-container class=\"tablePbmSolved\"><table md-table class=\"table table-bordered\" \nstyle=\"margin-left: 10px; margin-right: 20px\"><thead><tr><th>S.No</th><th>Member&nbsp;ID</th><th>Order&nbsp;ID</th><th>\nClient&nbsp;Code</th><th>First&nbsp;Applicant&nbsp;Name</th><th>Scheme&nbsp;Name</th><th>Transaction&nbsp;Type</th><th>\nAmount</th><th>Quantity</th><th>Folio&nbsp;No</th><th>Order&nbsp;Status</th><th>Order&nbsp;Date</th><th>\nOrder&nbsp;Remark</th><th>Settlement&nbsp;ID</th><th>ISIN</th><th>Investment&nbsp;Type</th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.transactionReport track by $index\"><td>{{$index + 1}}</td><td>\n{{ vm.displayValue(transaction.member_id) }}</td><td>{{ vm.displayValue(transaction.order_id) }}</td><td>\n{{ vm.displayValue(transaction.client_code) }}</td><td>{{ vm.displayValue(transaction.first_applicant_name) }}</td><td>\n{{ vm.displayValue(transaction.scheme_name) }}</td><td>{{ vm.displayValue(transaction.transaction_type) }}</td><td>\n₹{{ transaction.amount | number:2 }}</td><td>{{ transaction.quantity | number:3 }}</td><td>\n{{ vm.displayValue(transaction.folio_no || transaction.DP_Folio_No) }}</td><td><span \nng-class=\"{\'text-success\': transaction.order_status === \'VALID\', \'text-danger\': transaction.order_status !== \'VALID\'}\" \nstyle=\"font-weight: bold\">{{ vm.displayValue(transaction.order_status) }}</span></td><td>\n{{ vm.displayValue(transaction.order_date) }}</td><td>{{ vm.displayValue(transaction.order_remark) }}</td><td>\n{{ vm.displayValue(transaction.settlement_id) }}</td><td>{{ vm.displayValue(transaction.isin) }}</td><td>\n{{ vm.displayValue(transaction.investment_type) }}</td></tr></tbody></table></md-table-container>\n</md-virtual-repeat-container></div></div></div></div><div class=\"scrollable\" ms-scroll \nng-if=\"vm.transactionReport.length === 0 && vm.searchCompleted\"><div class=\"white-bg\" layout=\"column\"><div \nlayout=\"column\" flex=\"100\"><h4 class=\"bar-heading\" flex=\"100\" \nstyle=\"background-color: #2D323E; color: #FFFFFF; margin-left: 10px; margin-right: 10px\">No Records Found</h4><div \nstyle=\"text-align: center; padding: 20px\"><p>No transaction records found for the selected criteria.</p></div></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/customers/activity/activity.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-35\"><div id=\"timeline\"><div \nclass=\"row timeline-movement timeline-movement-top\"></div><div class=\"row timeline-movement\" \nng-repeat=\"activity in vm.allActivity\"><div class=\"timeline-badge\"><md-icon \nmd-font-icon=\"iconSizeData icon-dots-vertical\"></md-icon></div><div class=\"col-sm-6 timeline-item\"><div class=\"row\">\n<div class=\"col-sm-11\"><div class=\"timeline-panel credits\" id=\"slideInLeft\"><ul class=\"timeline-panel-ul\"><li><span \nclass=\"importo\">{{activity.createdAt | date:\"dd/MM/yyyy \'at\' h:mma\"}}</span></li></ul></div></div></div></div><div \nclass=\"col-sm-6 timeline-item\"><div class=\"row\"><div class=\"col-sm-offset-1 col-sm-11\"><div \nclass=\"timeline-panel debits\" id=\"slideInRight\"><ul class=\"timeline-panel-ul\" \nng-class=\"activity.activityType === \'MONITORING_FLAG_UPDATE\'? \'importoSubColor\':\'importo\'\"><li class=\"flagHeading\">\n{{vm.allActivityFlagMapping[activity.activityName]}}</li><li><span ng-if=\"activity.activityName !== \'ASSIGNED\'\">\n{{activity.activityComment===undefined?\'Not Commented\': activity.activityComment}} </span><span \nng-if=\"activity.activityName === \'ASSIGNED\'\">{{vm.assgnedtype[activity.activityAssigned.assignedUserType]}}</span></li>\n<li ng-show=\"activity.activityName===\'REVERSAL\'\"><p \nng-repeat=\"revesarl in activity.activityReversal.reversalTransactions\" style=\"margin-bottom:0px\">{{revesarl.scheme}}\n</p></li><li ng-show=\"activity.activityName===\'EXTERNAL_HOLDING\'\">\n{{activity.activityExternalHolding.trnxDetails.prodName}}</li><li class=\"flagRemarks\" \nng-show=\"activity.activityName===\'LUMPSUM\'\"><p ng-repeat=\"lumpsum in activity.activityLumpsum.transactions\" \nstyle=\"margin-bottom:0px\">{{lumpsum.amount | currency :\'&#8377; \':0}}</p></li><li class=\"flagRemarks\" \nng-show=\"activity.activityName===\'SIP\'\"><p ng-repeat=\"sip in activity.activitySip.transactions\" \nstyle=\"margin-bottom:0px\">{{sip.amount | currency :\'&#8377; \':0}}</p></li><li class=\"flagRemarks\" \nng-show=\"activity.activityType===\'MONITORING_FLAG_UPDATE\'\">Remarks By:-{{activity.monitorUserName}}</li><li \nclass=\"flagRemarks\" ng-show=\"activity.activityLoan && activity.activityLoan.loanType\">\n{{activity.activityLoan.loanType}}</li><li class=\"flagRemarks\" \nng-show=\"activity.activityAssigned && activity.activityAssigned.assignedUserName\">\n{{activity.activityAssigned.assignedUserName}}</li><li class=\"flagRemarks\" \nng-show=\"activity.activityDocument && activity.activityDocument.docType\">\n{{vm.activityDocument[activity.activityDocument.docType]}}</li><li \nng-show=\"activity.activitySignup && activity.activitySignup.platform\">\nOnboard through {{activity.activitySignup.platform}}</li></ul></div></div></div></div></div></div><div \nclass=\"article padding-15\" ng-if=\"vm.allActivity.length == 0\"><md-content class=\"md-whiteframe-4dp\"><div \nclass=\"padding-5\" layout=\"row\" layout-align=\"center center\" padding-wrap><h3 style=\"margin:10px 0px\">\nNo Comments Available</h3></div></md-content></div></div></div></div></div>");
$templateCache.put("app/main/customers/assign-sub-broker-dialog/assign-sub-broker-dialog.html","<md-dialog aria-label=\"Mango (Fruit)\" layout-padding><h4 class=\"padding-bottom-20\">\nCustomer Name:{{vm.customer.userName}}</h4><md-input-container><label>Select Sub Broker</label><md-select \nplaceholder=\"Select Sub Broker\" ng-model=\"vm.subBroker\" style=\"min-width: 200px\"><md-option ng-value=\"broker\" \nng-repeat=\"broker in vm.internalUser\">{{broker.userName}}</md-option></md-select></md-input-container><div \nng-show=\"vm.errorMsg\" class=\"error\">{{vm.errorMsg}}</div><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.cancleDialog()\" class=\"md-raised md-accent\" style=\"color:#fff !important; text-transform:uppercase\">Cancel\n</md-button><span flex></span><md-button ng-disabled=\"!vm.subBroker\" class=\"md-raised md-accent\" \nng-click=\"vm.submitAssignedBroker()\" style=\"color:#fff !important; text-transform:uppercase\">Assign</md-button>\n</md-dialog-actions></md-dialog><style>\n.error {\r\n        color: #D8000C;\r\n        background-color: #FFBABA;\r\n        -webkit-transition: all linear 0.5s;\r\n        transition: all linear 0.5s;\r\n    }\r\n    \r\n    .error.ng-hide {\r\n        opacity: 0;\r\n    }\n</style>");
$templateCache.put("app/main/customers/calling-history/calling-history.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">Calling History</h4></div><div \nstyle=\"height:58vh\" class=\"padding-10\"><table class=\"simple\" ms-responsive-table><thead><tr><th>S.No.</th><th>Date</th>\n<th>By</th><th>Type</th><th>Remarks</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"item in vm.callingHistory\"><td class=\"name\">{{$index+1}}</td><td class=\"position\">\n{{item.date | date: \"dd-MMM-yyyy\"}}</td><td class=\"office\">{{item.monitorUserName }}</td><td class=\"office\">\n{{item.monitorUserType }}</td><td>{{item.activityComment}}</td></tr></tbody></table></div></md-content></div></div>\n</div></div>");
$templateCache.put("app/main/customers/flag-activity/flag-activity.html","<md-dialog aria-label=\"Mango (Fruit)\" flex=\"25\" layout-padding><h4 class=\"padding-bottom-20\" \nng-show=\"vm.key === \'documentFlag\'\">Document Uploaded</h4><h4 class=\"padding-bottom-20\" \nng-show=\"vm.key === \'loanFlag\'\">Loan</h4><h4 class=\"padding-bottom-20\" ng-show=\"vm.key === \'insuranceFlag\'\">Insurance\n</h4><h4 class=\"padding-bottom-20\" ng-show=\"vm.key === \'sipFlag\'\">SIP</h4><h4 class=\"padding-bottom-20\" \nng-show=\"vm.key === \'lumpsumFlag\'\">Lumpsum</h4><h4 class=\"padding-bottom-20\" ng-show=\"vm.key === \'signupFlag\'\">Signup\n</h4><h4 class=\"padding-bottom-20\" ng-show=\"vm.key === \'iinCreationFlag\'\">IIN Creation</h4><h4 \nclass=\"padding-bottom-20\" ng-show=\"vm.key === \'externalHoldingFlag\'\">External Holding</h4><h4 \nclass=\"padding-bottom-20\" ng-show=\"vm.key === \'reversalFlag\'\">Reversal</h4><h4 class=\"padding-bottom-20\" \nng-show=\"vm.key === \'assignedFlag\'\">Assigned</h4><h4 class=\"padding-bottom-20\" ng-show=\"vm.key === \'iinActiveFlag\'\">\nIIN Active Flag</h4><h4 class=\"padding-bottom-20\" ng-show=\"vm.key === \'fatcakycuboRegFlag\'\">Fatca KYC Flag</h4><h4 \nclass=\"padding-bottom-20\" ng-show=\"vm.key === \'achmandateRegFlag\'\">ACH Mandate Flag</h4><h4 class=\"padding-bottom-20\" \nng-show=\"vm.key === \'redemptionFlag\'\">Redemption Flag</h4><div ng-show=\"vm.key === \'reviewPendingFlag\'\"><md-content>\n<div layout=\"column\" layout-align=\"space-between\" padding-wrap><div flex=\"100\"><h4 class=\"no-margin\">\nLast Calling Details</h4><table class=\"simple\" ms-responsive-table ng-show=\"vm.callinglength > 0\"><thead><tr><th>Date\n</th><th>Comments</th><th>Comments By</th></tr></thead><tbody><tr><td>{{vm.callingHistory.date | date: \"dd-MMM-yyyy\"}}\n</td><td>{{vm.callingHistory.activityComment}}</td><td>{{vm.callingHistory.monitorUserName}}</td></tr></tbody></table>\n<div ng-show=\"!vm.callinglength\"><h5 style=\"color:#c0392b\">No previous calling comments available</h5></div></div>\n</div></md-content><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between\" padding-wrap><div flex=\"50\"><h4>\nCurrent Calling Date</h4><md-datepicker ng-disabled=\"true\" ng-model=\"vm.currentreviewPendingFlagDate\" \nmd-placeholder=\"Enter date\"></md-datepicker></div><div flex=\"50\"><h4>Next Calling Date</h4><md-datepicker \nmd-min-date=\"vm.currentDate\" ng-model=\"vm.reviewPendingFlagDate\" md-placeholder=\"Enter date\"></md-datepicker></div>\n</div></div><md-input-container class=\"margin-top-20\"><label>Description</label><input ng-model=\"vm.description\">\n</md-input-container><div ng-show=\"vm.errorMsg\" class=\"error\">{{vm.errorMsg}}</div><md-dialog-actions layout=\"row\" \nleyout-align=\"end\"><md-button ng-click=\"vm.cancleDialog()\" class=\"md-raised md-accent\" \nstyle=\"color:#fff !important; text-transform:uppercase\">Cancel</md-button><md-button ng-click=\"vm.reviewedData()\" \nclass=\"md-raised md-accent\" style=\"color:#fff !important; text-transform:uppercase\">OK</md-button></md-dialog-actions>\n</md-dialog><style>\n.error {\r\n        color: #D8000C;\r\n        background-color: #FFBABA;\r\n        -webkit-transition: all linear 0.5s;\r\n        transition: all linear 0.5s;\r\n    }\r\n\r\n    .error.ng-hide {\r\n        opacity: 0;\r\n    }\n</style>");
$templateCache.put("app/main/customers/flags/flags.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">Flags</h4></div><div \nclass=\"content padding-20\"><div layout=\"row\" layout-xs=\"column\" ng-show=\"vm.allFlags.document.documentFlag\" \nlayout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 class=\"margin-left-30\">Document Uploaded</h4></div>\n<md-input-container flex=\"60\"><label>Description</label><input name=\"description\" \nng-model=\"vm.allFlags.document.documentFlagComments\"><div ng-messages=\"description.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><section flex=\"20\"><md-button class=\"md-raised md-accent width-120\" \nng-click=\"vm.reviewedData(vm.allFlags.document)\" label=\"Reviewed\" style=\"color:#fff !important\">Reviewed</md-button>\n</section></div><div layout=\"row\" layout-xs=\"column\" ng-show=\"vm.allFlags.loan.loanFlag\" layout-align=\"space-between\" \npadding-wrap><div flex=\"20\"><h4 class=\"margin-left-30\">Loan</h4></div><md-input-container flex=\"60\"><label>Description\n</label><input name=\"description\" ng-model=\"vm.allFlags.loan.loanFlagComments\"><div ng-messages=\"description.$error\">\n<div ng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.loan)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.insurance.insuranceFlag\" layout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 \nclass=\"margin-left-30\">Insurance</h4></div><md-input-container flex=\"60\"><label>Description</label><input \nname=\"description\" ng-model=\"vm.allFlags.insurance.insuranceFlagComments\"><div ng-messages=\"description.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.insurance)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.sip.sipFlag\" layout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 class=\"margin-left-30\">\nSIP</h4></div><md-input-container flex=\"60\"><label>Description</label><input name=\"description\" \nng-model=\"vm.allFlags.sip.sipFlagComments\"><div ng-messages=\"description.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><section flex=\"20\"><md-button class=\"md-raised md-accent width-120\" \nng-click=\"vm.reviewedData(vm.allFlags.sip)\" label=\"Reviewed\" style=\"color:#fff !important\">Reviewed</md-button>\n</section></div><div layout=\"row\" layout-xs=\"column\" ng-show=\"vm.allFlags.lumpsum.lumpsumFlag\" \nlayout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 class=\"margin-left-30\">Lumpsum</h4></div>\n<md-input-container flex=\"60\"><label>Description</label><input name=\"description\" \nng-model=\"vm.allFlags.lumpsum.lumpsumFlagComments\"><div ng-messages=\"description.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><section flex=\"20\"><md-button class=\"md-raised md-accent width-120\" \nng-click=\"vm.reviewedData(vm.allFlags.lumpsum)\" label=\"Reviewed\" style=\"color:#fff !important\">Reviewed</md-button>\n</section></div><div layout=\"row\" layout-xs=\"column\" ng-show=\"vm.allFlags.signup.signupFlag\" \nlayout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 class=\"margin-left-30\">Signup</h4></div>\n<md-input-container flex=\"60\"><label>Description</label><input name=\"description\" \nng-model=\"vm.allFlags.signup.signupFlagComments\"><div ng-messages=\"description.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><section flex=\"20\"><md-button class=\"md-raised md-accent width-120\" \nng-click=\"vm.reviewedData(vm.allFlags.signup)\" label=\"Reviewed\" style=\"color:#fff !important\">Reviewed</md-button>\n</section></div><div layout=\"row\" layout-xs=\"column\" ng-show=\"vm.allFlags.iinCreation.iinCreationFlag\" \nlayout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 class=\"margin-left-30\">IIN Creation</h4></div>\n<md-input-container flex=\"60\"><label>Description</label><input name=\"description\" \nng-model=\"vm.allFlags.iinCreation.iinCreationComments\"><div ng-messages=\"description.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.iinCreation)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.externalHolding.externalHoldingFlag\" layout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 \nclass=\"margin-left-30\">External Holding</h4></div><md-input-container flex=\"60\"><label>Description</label><input \nname=\"description\" ng-model=\"vm.allFlags.externalHolding.externalHoldingComments\"><div \nng-messages=\"description.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container><section \nflex=\"20\"><md-button class=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.externalHolding)\" \nlabel=\"Reviewed\" style=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" \nlayout-xs=\"column\" ng-show=\"vm.allFlags.reversal.reversalFlag\" layout-align=\"space-between\" padding-wrap><div \nflex=\"20\"><h4 class=\"margin-left-30\">Reversal</h4></div><md-input-container flex=\"60\"><label>Description</label><input \nname=\"description\" ng-model=\"vm.allFlags.reversal.reversalFlagComments\"><div ng-messages=\"description.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.reversal)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.assigned.assignedFlag\" layout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 \nclass=\"margin-left-30\">Assigned</h4></div><md-input-container flex=\"60\"><label>Description</label><input \nname=\"description\" ng-model=\"vm.allFlags.assigned.assignedFlagComments\"><div ng-messages=\"description.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.assigned)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.assigned.iinActiveFlag\" layout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 \nclass=\"margin-left-30\">IIN Active</h4></div><md-input-container flex=\"60\"><label>Description</label><input \nname=\"description\" ng-model=\"vm.allFlags.assigned.iinActiveFlagComments\"><div ng-messages=\"description.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.iinActive)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.assigned.fatcakycuboRegFlag\" layout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 \nclass=\"margin-left-30\">Fatca KYC</h4></div><md-input-container flex=\"60\"><label>Description</label><input \nname=\"description\" ng-model=\"vm.allFlags.assigned.fatcakycuboRegFlagComments\"><div ng-messages=\"description.$error\">\n<div ng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.fatcaKyc)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.assigned.achmandateRegFlag\" layout-align=\"space-between\" padding-wrap><div flex=\"20\"><h4 \nclass=\"margin-left-30\">ACH Mandate</h4></div><md-input-container flex=\"60\"><label>Description</label><input \nname=\"description\" ng-model=\"vm.allFlags.assigned.achmandateRegFlagComments\"><div ng-messages=\"description.$error\"><div\n ng-message=\"required\">This is required.</div></div></md-input-container><section flex=\"20\"><md-button \nclass=\"md-raised md-accent width-120\" ng-click=\"vm.reviewedData(vm.allFlags.achMandate)\" label=\"Reviewed\" \nstyle=\"color:#fff !important\">Reviewed</md-button></section></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"vm.allFlags.length == 0\" layout-align=\"space-between\" padding-wrap><div flex=\"100\" \nlayout-align=\"center center\"><h4>No Flag Available</h4></div></div></div></md-content></div><div \nclass=\"article padding-top-10\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 \nclass=\"margin-left-30\" style=\"margin-bottom:-10px\">Calling History</h4></div><div style=\"height:58vh\" \nclass=\"padding-10\"><table class=\"simple\" ms-responsive-table><thead><tr><th>SNo</th><th>Date</th><th>By</th><th>Type\n</th><th>Remarks</th></tr></thead><tbody><tr ng-repeat=\"item in vm.callingHistory\"><td class=\"name\">{{$index+1}}</td>\n<td class=\"position\">{{item.date | date: \"dd-MMM-yyyy\"}}</td><td class=\"office\">{{item.monitorUserName }}</td><td \nclass=\"office\">{{item.monitorUserType }}</td><td>{{item.activityComment}}</td></tr></tbody></table></div></md-content>\n</div></div></div></div>");
$templateCache.put("app/main/customers/loan/loan-list.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\"><md-content><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head style=\"max-height:500px !important;height:500px !important\"><md-table-container><table \nmd-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th \nmd-column><span>S. No.</span></th><th md-column md-order-by=\"loanName\"><span>Loan Name</span></th><th md-column \nmd-order-by=\"loanType\"><span>Loan Type</span></th><th md-column md-order-by=\"loanAmount\"><span>Loan Amount</span></th>\n<th md-column md-order-by=\"loanRateOfIntrest\"><span>Rate Of Interest</span></th><th md-column md-order-by=\"loanYears\">\n<span>No. of Years</span></th><th md-column md-order-by=\"panNumber\"><span>PAN</span></th><th md-column \nmd-order-by=\"iinNumber\"><span>IIN</span></th><th md-column md-order-by=\"date\"><span>Date</span></th></tr></thead><tbody\n md-body><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"item in vm.userLoans | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\"><td md-cell>\n{{$index+1}}</td><td md-cell>{{item.loanName}}</td><td md-cell>{{item.loanType}}</td><td md-cell>{{item.loanAmount}}\n</td><td md-cell>{{item.loanRateOfIntrest }}</td><td md-cell>{{item.loanYears}}</td><td md-cell>{{item.panNumber}}</td>\n<td md-cell>{{item.iinNumber}}</td><td md-cell>{{item.date | date:\"dd/mm/yyyy\"}}</td></tr></tbody></table>\n</md-table-container></md-virtual-repeat-container></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/insurance/insurance-edit.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"white-bg\" layout=\"column\"><div \nclass=\"headerFixAllPages\"><div class=\"article\"><md-content><div layout=\"row\"><div class=\"form-wrapper\" flex><form \nname=\"myForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\">Insurance Information</div><div layout=\"row\" \nlayout-gt-xs=\"row\" flex layout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"25\"><label>Insurance Type</label>\n<md-select name=\"type\" ng-model=\"vm.insurance.typeOfInsurance\" required><md-option value=\"Health Insurance\">\nHealth Insurance</md-option><md-option value=\"Motor Insurance\">Motor Insurance</md-option><md-option \nvalue=\"Home Insurance\">Home Insurance</md-option><md-option value=\"Personal Accident Insurance\">\nPersonal Accident Insurance</md-option><md-option value=\"Travel Insurance\">Travel Insurance</md-option><md-option \nvalue=\"Commercial Insurance\">Commercial Insurance</md-option><md-option value=\"Life Insurance\">Life Insurance\n</md-option><md-option value=\"Vehicle Insurance\">Vehicle Insurance</md-option></md-select><div \nng-messages=\"myForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Insurance Type is required.</span></div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"25\"><label>Start date</label><md-datepicker \nng-model=\"vm.insurance.startDate\" md-max-date=\"vm.currentDate\" required name=\"startDate\"></md-datepicker><div \nng-messages=\"myForm.startDate.$error\" role=\"alert\"><div ng-message=\"maxDate\"><span>Date can not be future Date</span>\n</div><div ng-message=\"required\"><span>Date is required.</span></div><div ng-message=\"valid\"><span>\nInput Date is not a valid date</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"25\">\n<label>Renewal date</label><md-datepicker ng-model=\"vm.insurance.renewalDate\" md-min-date=\"vm.currentDate\" \nname=\"renewalDate\" required></md-datepicker><div ng-messages=\"myForm.renewalDate.$error\" role=\"alert\"><div \nng-message=\"minDate\"><span>Date can not be past Date</span></div><div ng-message=\"required\"><span>Date is required.\n</span></div><div ng-message=\"valid\"><span>Input Date is not a valid date</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"25\"><label>Insurance Frequency</label><md-select name=\"frequency\" required \nng-model=\"vm.insurance.insuranceFrequency\"><md-option value=\"1\">Monthly</md-option><md-option value=\"3\">Quarterly\n</md-option><md-option value=\"6\">Half Yearly</md-option><md-option value=\"12\">Yearly</md-option></md-select><div \nng-messages=\"myForm.frequency.$error\" role=\"alert\"><div ng-message=\"required\"><span>Insurance Frequency is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"policyNumber\" ng-model=\"vm.insurance.policyNumber\" placeholder=\"Policy Number\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"insuranceCompany\" \nng-model=\"vm.insurance.insuranceCompany\" placeholder=\"Insurance Company\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"productName\" ng-model=\"vm.insurance.productName\" \nplaceholder=\"Product Name\" required><div ng-messages=\"myForm.productName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Product Name field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"lifeCover\" ng-model=\"vm.insurance.lifeCover\" \nplaceholder=\"Life Cover\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" \nname=\"accidentaCover\" ng-model=\"vm.insurance.accidentaCover\" placeholder=\"Accidental Cover\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"criticalIllnessCover\" \nng-model=\"vm.insurance.criticalIllnessCover\" placeholder=\"Critical Illness Cover\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" name=\"term\" ng-model=\"vm.insurance.term\" \nplaceholder=\"Term\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"number\" \nname=\"annualPremium\" ng-model=\"vm.insurance.annualPremium\" placeholder=\"Annual Premium\"></md-input-container><h4 \nng-show=\"vm.insurancesUser.responseString.insuranceDocuments.length == 0\" style=\"width:100%\">\nPlease upload Document first to process.</h4><h4 ng-show=\"!vm.selectedDocu\" style=\"width:100%\">\nPlease Map One documnet from given below document to submit.</h4><md-button ng-disabled=\"vm.disableSubmit()\" \nclass=\"md-raised md-accent\" ng-click=\"vm.createInsurance()\" style=\"color:#fff !important\">Submit</md-button></div>\n</form><span class=\"pull-right\" style=\"font-weight:bold;font-size:16px\" ng-show=\"vm.selectedDocu\">\nSelected Document: {{vm.selectedDocu.fileName}}</span> <span class=\"pull-right\" \nstyle=\"font-weight:bold;font-size:16px\" ng-hide=\"vm.selectedDocu\">No document Mapped/document removed</span></div>\n</div></md-content><div class=\"white-bg\" layout=\"row\" layout-padding layout-align=\"space-around center\" \nstyle=\"border-bottom:2px solid rgb(3,155,229);margin-top:10px;padding-bottom:20px\" layout-wrap><div \nclass=\"margin-bottom-15 objectParentBlog\" \nng-repeat=\"docu in vm.insurancesUser.responseString.insuranceDocuments track by $index\" \nstyle=\"margin-bottom:40px;margin-top:20px\"><div class=\"text-center\" style=\"font-weight:600;font-size:14px\">\n{{docu.mapFlag ? \'Document Mapped\' : \'Not Mapped\'}}</div><img class=\"objectFitBlog\" \nng-src=\"{{vm.insurancesUser.baseUrl+docu.fileName}}\" ng-click=\"vm.selectedDocument(docu)\" \nng-class=\"{selectedImage : docu.fileName == vm.selectedDocu.fileName}\"><div class=\"text-center\"><a \nhref=\"{{vm.insurancesUser.baseUrl+docu.fileName}}\" target=\"_blank\"><b>Preview File</b></a></div></div><div \nng-show=\"vm.insurancesUser.responseString.insuranceDocuments.length == 0\"><span>No document uploaded yet.</span></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/customers/insurance/insurance-list.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\' \">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\" style=\"height:48vh\" ms-scroll><md-content><div \nlayout=\"row\" layout-align=\"end end\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.customers.customerhome.insuranceEdit({id:vm.userId})\" style=\"float:right; color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\" style=\"color:#fff\"></md-icon>New Insurance</md-button></div><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>S. No.</span></th><th md-column><span>Insurance Detail\n</span></th><th md-column md-order-by=\"startDate\"><span>Start Date</span></th><th md-column md-order-by=\"renewalDate\">\n<span>Renewal Date</span></th><th md-column md-order-by=\"lifeCover\"><span>Life Cover</span></th><th md-column \nmd-order-by=\"accidentaCover\"><span>Accidental Cover</span></th><th md-column md-order-by=\"criticalIllnessCover\"><span>\nCritical Illness Cover</span></th><th md-column><span>Term</span></th><th md-column><span>Action</span></th></tr>\n</thead><tbody md-body><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"item in vm.insurancesUser.insurances | filter:search | orderBy: vm.query.order\" \nstyle=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell><span ng-show=\"item.productName\">\nProduct Name: {{item.productName}}</span><br><span ng-show=\"item.policyNumber\">Policy Number:{{item.policyNumber}}\n</span><br><span ng-show=\"item.insuranceCompany\">Insurance Company:{{item.insuranceCompany}}</span><br></td><td \nmd-cell>{{(item.startDate) ? (item.startDate | date:\'dd/MM/yyyy\'):\'NA\'}}</td><td md-cell>\n{{(item.renewalDate) ? (item.renewalDate | date:\'dd/MM/yyyy\'):\'NA\'}}</td><td md-cell>\n{{(item.lifeCover) ? (item.lifeCover):\'NA\'}}</td><td md-cell>{{(item.accidentaCover) ? (item.accidentaCover):\'NA\'}}\n</td><td md-cell>{{(item.criticalIllnessCover) ? (item.criticalIllnessCover):\'NA\'}}</td><td md-cell>\n{{(item.term) ? (item.term):\'NA\'}}</td><td md-cell>{{(item.annualPremium) ? (item.annualPremium):\'NA\'}}</td><td \nmd-cell><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"vm.editIsurance(item)\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Update\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.showDeleteDialog(item)\" aria-label=\"Refresh widget\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table></md-table-container></md-virtual-repeat-container></md-content></div><div \nclass=\"article padding-top-10\"><md-content><div layout=\"row\" layout-align=\"space-between\" layout-padding><span \nclass=\"md-title margin-left-30\">All Insurance Documents</span><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.insurancesUser.insuranceDocuments.length ===0\" ng-click=\"vm.downloadDocs()\" \nstyle=\"padding:0px 6px; color:#fff !important\"><md-icon md-font-icon=\"icon-download\" style=\"color:#fff\"></md-icon>\nDownload All</md-button></div><div layout=\"row\" layout-wrap><md-card \nng-repeat=\"docs in vm.insurancesUser.insuranceDocuments\" flex=\"30\"><iframe ng-if=\"docs.indexOf(\'pdf\')!==-1\" \nng-src=\"{{vm.baseUrl+docs.fileName | trustAsResourceUrl}}\" class=\"image-responsive objectFit\" frameborder=\"0\" \nscrolling=\"no\" style=\"width:100%; height:420px; min-height:420px; max-height:420px\"></iframe><img \nng-if=\"docs.indexOf(\'pdf\')===-1\" class=\"image-responsive objectFit\" \nstyle=\"width:100%; height:420px; min-height:420px; max-height:420px\" \nng-src=\"{{vm.baseUrl+docs.fileName | trustAsResourceUrl}}\" alt=\"\"></md-card></div></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/nps/nps.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><div class=\"article padding-top-10\"><md-content><div layout-align=\"center center\" \nclass=\"table-title\"><h4 class=\"margin-left-30\" style=\"margin-bottom:-10px\">PRAN Number</h4></div><div \nstyle=\"padding:20px; margin-top:10px\" flex><form name=\"vm.myForm\" class=\"md-inline-form margin-left-30\" novalidate><div\n layout=\"row\" layout-gt-xs=\"row\" flex layout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \nng-disabled=\"vm.pranFlag\" type=\"text\" required name=\"pranNumber\" ng-model=\"vm.pranNumber\" placeholder=\"PRAN Number\">\n<div ng-messages=\"myForm.pranNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>This field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><md-button \nng-show=\"vm.pranFlag\" class=\"md-raised md-accent\" ng-click=\"vm.editPran()\" style=\"color:#fff !important\">Edit\n</md-button><md-button ng-show=\"vm.pranFlag\" class=\"md-raised md-accent\" ng-click=\"vm.deletePran()\" \nstyle=\"color:#fff !important\">Delete</md-button><md-button ng-show=\"!vm.pranFlag\" \nng-disabled=\"vm.myForm.$invalid || vm.myForm.$pristine\" class=\"md-raised md-accent\" ng-click=\"vm.createPran()\" \nstyle=\"color:#fff !important\">Submit</md-button></md-input-container></div></form></div></md-content></div></div></div>\n</div>");
$templateCache.put("app/main/customers/sipDetails/sipDetails.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME : (vm.customerDetail.userName?vm.customerDetail.userName: \'NA\')}}\n</span> <span>Designation : &nbsp;&nbsp; {{(vm.customerDetail.jobTitle) ? (vm.customerDetail.jobTitle) : \'NA\'}}</span>\n</div><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nIIN : &nbsp;&nbsp; {{(vm.customerDetail.iin) ? (vm.customerDetail.iin) : \'NA\'}}</span> <span>\nEmail : &nbsp;&nbsp; {{(vm.customerDetail.email) ? (vm.customerDetail.email):\'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>\nPAN : &nbsp;&nbsp; {{(vm.customerDetail.pan) ? (vm.customerDetail.pan) : \'NA\'}}</span> <span>\nContact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS== \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] }} </span><span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\'\">\n{{ vm.customerDetail.camsKycStatus != undefined ? vm.eKyc[vm.customerDetail.camsKycStatus] : \'NA\'}}</span></span></div>\n</div></md-content></div><h4 class=\"margin-left-30\">Running SIP</h4><div class=\"article\" \nng-if=\"vm.SipDetail.length > 0\"><md-content class=\"margin-bottom-10\" ng-repeat=\"sip in vm.SipDetail\"><div \nclass=\"padding-5\" layout=\"row\"><div layout=\"row\" layout-align=\"space-around center\" flex><div layout=\"column\" \nlayout-align=\"space-around start\" layout-padding flex=\"34\"><span><strong>Status :</strong> {{ sip.status }}</span> \n<span><strong>SIP Reg Date :</strong> {{ sip.xsip_registration_date }}</span> <span><strong>Installment Amt :</strong>\n {{ sip.installments_amount }}</span></div><div layout=\"column\" layout-align=\"space-around start\" layout-padding \nflex=\"33\"><span><strong>SIP Reg No :</strong> {{ sip.xsip_registration_no }}</span> <span><strong>Frequency :</strong>\n {{ sip.frequency_type }}</span> <span><strong>NSE Mandate ID :</strong> {{ sip.nse_mandate_id }}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" layout-padding flex=\"33\"><span><strong>Start Date :</strong>\n {{ sip.start_date }}</span> <span><strong>End Date :</strong> {{ sip.end_date }}</span> <span><strong>Scheme :\n</strong> {{ sip.scheme_name }}</span></div></div></div></md-content></div><div class=\"article\" \nng-if=\"vm.SipDetail.length == 0\"><md-content class=\"md-whiteframe-4dp\"><div class=\"padding-5\" layout=\"center center\">\n<h4 class=\"margin-left-30\">No Data</h4></div></md-content></div><h4 class=\"margin-left-30\">CEASE REQUEST</h4><div \nclass=\"article\" ng-if=\"vm.CeaseDetail.length > 0\"><md-content class=\"margin-bottom-10\" \nng-repeat=\"cease in vm.CeaseDetail\"><div class=\"padding-5\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-around center\" flex><div layout=\"column\" layout-align=\"space-around start\" layout-padding \nflex=\"34\"><span><strong>Status :</strong> {{ cease.status }}</span> <span><strong>SIP Reg Date :</strong>\n {{ cease.xsip_registration_date }}</span> <span><strong>Installment Amt :</strong> {{ cease.installments_amt }}</span>\n <span><strong>SIP Cancel Date :</strong> {{ cease.xsip_cancellation_date }}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" layout-padding flex=\"33\"><span><strong>SIP Reg No :</strong>\n {{ cease.xsip_registration_no }}</span> <span><strong>Frequency :</strong> {{ cease.frequency_type }}</span> <span>\n<strong>NSE Mandate ID :</strong> {{ cease.nse_mandate_id }}</span> <span><strong>Remarks :</strong> {{ cease.remark }}\n</span></div><div layout=\"column\" layout-align=\"space-around start\" layout-padding flex=\"33\"><span><strong>Start Date :\n</strong> {{ cease.start_date }}</span> <span><strong>End Date :</strong> {{ cease.end_date }}</span> <span><strong>\nScheme :</strong> {{ cease.scheme_name }}</span></div></div></div></md-content></div><div class=\"article\" \nng-if=\"vm.CeaseDetail.length == 0\"><md-content class=\"md-whiteframe-4dp\"><div class=\"padding-5\" layout=\"center center\">\n<h4 class=\"margin-left-30\">No Data</h4></div></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/sub-broker-customer/addCustomer-index.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin:0px\"><span>Add New Customer</span></div><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor\" \nstyle=\"line-height:10px\"></md-icon><span style=\"line-height:-2%; margin-top:-14%\">Back</span></md-button></div><md-tabs\n md-selected=\"vm.selectedTab\"><md-tab ui-sref=\"app.sub-broker-customer.customerhome.sub-broker-add-customer\">\nUser Details</md-tab><md-tab ui-sref=\"app.sub-broker-customer.customerhome.customer-personal-Details\">Personal Details\n</md-tab><md-tab ui-sref=\"app.sub-broker-customer.customerhome.customer-bank-Details\">Bank Details</md-tab></md-tabs>\n<div ui-view></div></div>");
$templateCache.put("app/main/customers/sub-broker-customer/sub-broker-add-customer.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"userInternalCreate\"><div ng-cloak><md-content>\n<md-content class=\"padding-10\"><div class=\"white-bg md-whiteframe-4dp\" layout-padding><h4 style=\"text-align: center\">\nCreate New Customer</h4><br><form name=\"internalUser\"><div layout=\"row\" layout-align=\"center center\" layout-wrap><div \nlayout=\"column\" layout-xs=\"column\" flex=\"50\" layout-align=\"space-between\" layout-padding><md-input-container \nclass=\"md-block\" flex-gt-sm><label>User Name</label><input required type=\"text\" name=\"userName\" \nng-model=\"vm.user.userName\" ng-pattern=\"nameRegEx\" md-maxlength=\"50\" minlength=\"2\" required></md-input-container>\n<md-input-container flex=\"50\" flex-xs=\"100\" id=\"usermobileErrorSignup\"><i class=\"fa fa-phone fontsLoginIcon\" \naria-hidden=\"true\"></i> <input type=\"text\" numeric-regex ng-pattern=\"/^[1-9]{1}[0-9]{9}$/\" \ntitle=\"Enter 10 Digit Mobile No.(i.e.9898989898)\" name=\"mobileNo\" id=\"registerformPhoneNew\" \nplaceholder=\"Contact Number\" ng-model=\"vm.user.mobileNo\" class=\"smallTextPadd loginPaddMobileView\" \nonfocus=\"this.removeAttribute(\'readonly\')\" oncopy=\"return false\" autocomplete=\"false\" readonly=\"readonly\" required \ntabindex=\"1\"></md-input-container><md-input-container flex=\"50\" flex-xs=\"100\"><input limit-to=\"50\" type=\"email\" \nname=\"customeremail\" placeholder=\"Customer Email\" ng-model=\"vm.user.email\" \nng-pattern=\"/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/\" oncopy=\"return false\" ondrag=\"return false\" \nondrop=\"return false\" onpaste=\"return false\" autocomplete=\"off\"><div ng-messages=\"myForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\"><input pan-regex type=\"text\" name=\"pannumber\" \nng-pattern=\"/[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/\" capitalize ng-model=\"vm.user.pan\" \nplaceholder=\"PAN Number Ex. ABCDE1234F\"><div ng-messages=\"myForm.pannumber.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"pattern\"><span>PAN Number must be a valid Number</span></div></div></md-input-container></div></div>\n<section layout=\"row\" layout-align=\"center center\" layout-wrap><md-button type=\"button\" \nclass=\"md-raised md-accent width-160\" ng-disabled=\"vm.disableAssignfeature()\" ng-show=\"vm.createButton\" tabindex=\"7\" \nng-click=\"vm.createCustomer()\" style=\"color:#fff !important\">Create Customer</md-button><md-button type=\"button\" \nclass=\"md-raised md-accent width-160\" ng-show=\"!vm.createButton\" tabindex=\"7\" ng-click=\"vm.updateCustomer()\" \nstyle=\"color:#fff !important\">Update Customer</md-button></section></form></div></md-content></md-content></div></div>");
$templateCache.put("app/main/customers/sub-broker-customer/sub-broker-customer.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Sub Broker Customer List</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"q\" \nplaceholder=\"Search\" ng-keyup=\"$event.keyCode == 13 ? vm.serchUser() : null\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"15\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.sub-broker-customer.customerhome.sub-broker-add-customer\" style=\"color:#fff !important\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Add Customer</md-button></div></div><div class=\"headerFixAllPages\"><md-card \nclass=\"container-fluid\"><div layout-gt-sm=\"row\" layout-align=\"center center\"></div><div class=\"row\"><div \nclass=\"col-sm-12\"><form name=\"wizardStep1\" class=\"md-inline-form\"><br><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap flex><md-input-container flex=\"100\" flex-gt-xs=\"40\"><label>From Date\n</label><input type=\"date\" ng-model=\"vm.fromDate\" name=\"fromDate\" flex=\"33\" tabindex=\"1\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label>To Date</label><input type=\"date\" ng-model=\"vm.uptoDate\" \nname=\"uptoDate\" flex=\"33\" tabindex=\"2\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\"><md-button \nclass=\"md-raised md-accent\" tabindex=\"3\" ng-click=\"vm.getCustomerList()\" style=\"color:#fff !important\">Show</md-button>\n</md-input-container></div><hr><div layout=\"row\"><table id=\"customers\" class=\"table table-hover\"><tr><th \nstyle=\"width: 5%\" scope=\"col\">Sr No.</th><th style=\"width: 20%\" scope=\"col\">Investor Name</th><th style=\"width: 15%\" \nscope=\"col\">Contact No.</th><th style=\"width: 10%\" scope=\"col\">Sign Up Date</th><th style=\"width: 20%\" scope=\"col\">\nAssigned User</th><th style=\"width: 15%\" scope=\"col\">User Role</th><th style=\"width: 15%\" scope=\"col\">Mobile No.</th>\n<th style=\"width: 15%\" scope=\"col\">Action</th></tr><tbody ng-repeat=\"customer in vm.customers | filter:q\"><tr><td \nstyle=\"width: 5%\">{{$index+1}}</td><td style=\"width: 20%\">{{customer.userName}}</td><td style=\"width: 15%\">\n{{customer.userMobile}}</td><td style=\"width: 10%\">{{customer.signupDate | date:\'mediumDate\'}}</td><td \nstyle=\"width: 20%\">{{customer.assignedUser.userName}}</td><td style=\"width: 15%\">{{customer.assignedUser.userType}}\n</td><td style=\"width: 15%\">{{customer.assignedUser.mobileNo}}</td><td style=\"width: 15%\"><div><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.editCustomer(customer)\" style=\"color:#fff !important\">Edit Customer\n</md-button></div></td></tr></tbody></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/customers/transactionHistory/sipfundTransaction.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">Name : &nbsp;&nbsp; {{vm.customerDetail.nseData.INVESTOR_NAME || vm.customerDetail.userName || \'NA\'}}\n</span> <span>Designation : &nbsp;&nbsp; {{vm.customerDetail.jobTitle || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN : &nbsp;&nbsp; {{vm.customerDetail.iin || \'NA\'}}\n</span> <span>Email : &nbsp;&nbsp; {{vm.customerDetail.email || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>PAN : &nbsp;&nbsp; {{vm.customerDetail.pan || \'NA\'}}\n</span> <span>Contact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span \nng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'\' || !vm.customerDetail.nseData.ACTIVATION_STATUS\" \nstyle=\"color:orange; font-size:12px\">NA</span> <span ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus]}}</span> <span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\' && vm.customerDetail.camsKycStatus != \'07\' && vm.customerDetail.camsKycStatus\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus]}}</span> <span ng-if=\"!vm.customerDetail.camsKycStatus\" \nstyle=\"color:green; font-size:12px\">KYC VALIDATED</span></span></div></div></md-content></div><div \nclass=\"article padding-top-10\" \nng-if=\"vm.customerDetail.nseData === undefined || vm.customerDetail.nseData.ACTIVATION_STATUS === \'NO\'\"><md-content>\n<div class=\"padding-5\"><h3 class=\"text-center\">NO Data for Transaction Details Available</h3></div></md-content></div>\n<div class=\"article padding-top-10\" ng-if=\"vm.customerDetail.nseData.ACTIVATION_STATUS !== \'NO\'\"><md-content><div \nclass=\"padding-5\"><div layout=\"row\" layout-align=\"center center\" padding-wrap><div layout=\"column\" \nstyle=\"margin-right: 20px\"><span style=\"font-weight: bold\">From Date:</span> <input type=\"date\" ng-model=\"vm.fromDate\" \nmd-placeholder=\"From Date\" md-max-date=\"vm.toDate\"></div><div layout=\"column\" style=\"margin-right: 20px\"><span \nstyle=\"font-weight: bold\">To Date:</span> <input type=\"date\" ng-model=\"vm.toDate\" md-placeholder=\"To Date\" \nmd-min-date=\"vm.fromDate\" md-max-date=\"vm.maxDate\"></div><div layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.showTransactionDetails()\" \nng-disabled=\"vm.customerDetail.nseData === undefined || vm.customerDetail.nseData.ACTIVATION_STATUS === \'NO\'\" \nstyle=\"color:#fff !important; text-transform:uppercase; margin-top: 20px\">Get Transaction Details</md-button></div>\n</div></div></md-content></div><div class=\"simple-table-container padding-top-10\" \nng-if=\"vm.transactionReport.length > 0\"><md-content><table class=\"simple\" ms-responsive-table><thead><tr><th>SNo</th>\n<th>Member ID</th><th>Order ID</th><th>Client Code</th><th>First Applicant Name</th><th>Scheme Name</th><th>\nTransaction Type</th><th>Amount</th><th>Quantity</th><th>Folio No.</th><th>Order Status</th><th>Order Date</th><th>\nOrder Remark</th><th>Settlement ID</th></tr></thead><tbody><tr ng-repeat=\"Object in vm.transactionReport\"><td>\n{{$index+1}}</td><td>{{Object.member_id || \'N/A\'}}</td><td>{{Object.order_id || \'N/A\'}}</td><td>\n{{Object.client_code || \'N/A\'}}</td><td>{{Object.first_applicant_name || \'N/A\'}}</td><td>\n{{Object.scheme_name || \'N/A\'}}</td><td>{{Object.transaction_type || \'N/A\'}}</td><td>₹{{Object.amount | number:2}}</td>\n<td>{{Object.quantity | number:3}}</td><td>{{Object.folio_no || Object.DP_Folio_No || \'N/A\'}}</td><td><span \nng-class=\"{\'text-success\': Object.order_status === \'VALID\', \'text-danger\': Object.order_status !== \'VALID\'}\" \nstyle=\"font-weight: bold\">{{Object.order_status || \'N/A\'}}</span></td><td>\n{{Object.order_date || (Object.FORMATTED_DATE | date:\'dd-MMM-yyyy\')}}</td><td>{{Object.order_remark || \'N/A\'}}</td><td>\n{{Object.settlement_id || \'N/A\'}}</td></tr></tbody></table></md-content></div><div class=\"article padding-top-10\" \nng-if=\"vm.transactionReport.length === 0 && !vm.showButton\"><md-content><div class=\"padding-5\"><h3 class=\"text-center\">\nNo Transaction Details Found for Selected Date Range</h3></div></md-content></div></div></div></div>");
$templateCache.put("app/main/customers/transactionHistory/transactionHistory.html","<div class=\"scrollable\" ms-scroll><div class=\"white-bg\" layout=\"column\"><div class=\"headerFixAllPages\"><div \nclass=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" \nclass=\"margin-left-20\" flex><div layout=\"column\" layout-align=\"space-around start\" flex=\"25\" layout-padding><span \nclass=\"title\">Name : &nbsp;&nbsp; {{vm.customerName}}</span> <span>\nDesignation : &nbsp;&nbsp; {{vm.customerDetail.jobTitle || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN : &nbsp;&nbsp; {{vm.customerDetail.iin || \'NA\'}}\n</span> <span>Email : &nbsp;&nbsp; {{vm.customerDetail.email || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>PAN : &nbsp;&nbsp; {{vm.customerDetail.pan || \'NA\'}}\n</span> <span>Contact No. : &nbsp;&nbsp; {{vm.customerDetail.mobileNo || \'NA\'}}</span></div><div layout=\"column\" \nlayout-align=\"space-around start\" flex=\"25\" layout-padding><span>IIN Status : &nbsp;&nbsp; <span \nng-if=\"vm.iinStatus == \'YES\'\" style=\"color:green; font-size:12px\">YES</span> <span ng-if=\"vm.iinStatus == \'NO\'\" \nstyle=\"color:red; font-size:12px\">NO</span> <span ng-if=\"vm.iinStatus == \'NA\' || !vm.iinStatus\" \nstyle=\"color:orange; font-size:12px\">NA</span> </span><span>KYC Status : &nbsp;&nbsp; <span \nstyle=\"color:green; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus == \'01\' || vm.customerDetail.camsKycStatus == \'02\' || vm.customerDetail.camsKycStatus == \'07\'\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus] || \'KYC VALIDATED\'}}</span> <span style=\"color:red; font-size:12px\" \nng-if=\"vm.customerDetail.camsKycStatus != \'01\' && vm.customerDetail.camsKycStatus != \'02\'  && vm.customerDetail.camsKycStatus != \'07\' && vm.customerDetail.camsKycStatus\">\n{{vm.eKyc[vm.customerDetail.camsKycStatus]}}</span> <span ng-if=\"!vm.customerDetail.camsKycStatus\" \nstyle=\"color:green; font-size:12px\">KYC VALIDATED</span></span></div></div></md-content></div><div \nclass=\"article padding-top-10\" ng-if=\"vm.iinStatus === \'NO\'\"><md-content><div class=\"padding-5\"><h3 \nclass=\"text-center\">NO Data for Transaction Details Available</h3></div></md-content></div><div class=\"padding-top-10\" \nng-show=\"vm.showButton == true && vm.iinStatus !== \'NO\'\"><md-content><div class=\"padding-5\"><div layout=\"row\" \nlayout-align=\"center center\" padding-wrap><div layout=\"column\"><span style=\"font-weight: bold\">From Date:</span> <input\n type=\"date\" ng-model=\"vm.fromDate\" md-placeholder=\"From Date\" md-max-date=\"vm.toDate\"></div><div layout=\"column\"><span\n style=\"font-weight: bold\">To Date:</span> <input type=\"date\" ng-model=\"vm.toDate\" md-placeholder=\"To Date\" \nmd-min-date=\"vm.fromDate\" md-max-date=\"vm.maxDate\"></div><div layout=\"column\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.showTransactionDetails()\" \nng-disabled=\"vm.customerDetail.nseData === undefined || vm.customerDetail.nseData.ACTIVATION_STATUS === \'NO\'\" \nstyle=\"color:#fff !important; text-transform:uppercase\">Get Transaction Details</md-button></div></div></div>\n</md-content></div><div class=\"simple-table-container padding-top-10\" ng-if=\"vm.transactionReport.length > 0\">\n<md-content><table class=\"simple\" ms-responsive-table><thead><tr><th>SNo</th><th>Product Type</th><th>Product ID</th>\n<th>Scheme Name</th><th>Primary Holder</th><th>Amount/Units</th><th>Order Status</th><th>Order Remark</th><th>\nMember Name</th><th>Date</th></tr></thead><tbody><tr ng-repeat=\"Object in vm.transactionReport\"><td>{{$index+1}}</td>\n<td>{{Object.product_type || \'N/A\'}}</td><td>{{Object.product_id || \'N/A\'}}</td><td>\n{{Object.from_scheme_name || \'N/A\'}}</td><td>{{Object.primary_holder_name || \'N/A\'}}</td><td>\n{{Object.amount_units || \'N/A\'}}</td><td><span ng-if=\"Object.order_status\" \nng-class=\"{\'text-success\': Object.order_status === \'VALID\', \'text-warning\': Object.order_status !== \'VALID\'}\">\n{{Object.order_status}} </span><span ng-if=\"!Object.order_status\">N/A</span></td><td>{{Object.order_remark || \'N/A\'}}\n</td><td>{{Object.member_name || \'N/A\'}}</td><td>{{Object.DATE_OF_TRXN_REQUEST | date:\'dd-MMM-yyyy HH:mm\'}}</td></tr>\n</tbody></table></md-content></div><div class=\"article padding-top-10\" \nng-if=\"vm.transactionReport.length === 0 && !vm.showButton\"><md-content><div class=\"padding-5\"><h3 class=\"text-center\">\nNo Transaction Details Found for Selected Date Range</h3></div></md-content></div></div></div></div>");
$templateCache.put("app/main/dashboard/comparison/comparison.html","<div class=\"padding-5\" layout=\"row\" layout-align=\"space-between\"><div flex=\"50\" class=\"white-bg md-whiteframe-4dp\" \nlayout-padding><div ng-cloak><md-content><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Date</span></th><th md-column md-order-by=\"userName\"><span>\nRange</span></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" md-auto-select style=\"cursor:pointer\"><td \nmd-cell>27/12/2017</td><td md-cell>Dilip Yadav</td></tr></tbody></table></md-table-container>\n</md-virtual-repeat-container></md-content></div></div><div flex=\"50\" class=\"white-bg md-whiteframe-4dp\" \nlayout-padding><div ng-cloak><md-content><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Date</span></th><th md-column md-order-by=\"userName\"><span>\nRange</span></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" md-auto-select style=\"cursor:pointer\"><td \nmd-cell>27/12/2017</td><td md-cell>Dilip Yadav</td></tr></tbody></table></md-table-container>\n</md-virtual-repeat-container></md-content></div></div></div>");
$templateCache.put("app/main/dashboard/details/details.html","<md-content class=\"bgdashboardHeader\" layout-gt-sm=\"row\"><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'INC\'}\" ng-click=\"vm.dashboardFilter(\'INC\')\" label=\"Inception\">\nInception</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'TOD\'}\" ng-click=\"vm.dashboardFilter(\'TOD\')\" label=\"Today\">\nToday</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'WTD\'}\" ng-click=\"vm.dashboardFilter(\'WTD\')\" label=\"WTD\">WTD\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'MTD\'}\" \nng-click=\"vm.dashboardFilter(\'MTD\')\" label=\"MTD\">MTD</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'YSD\'}\" ng-click=\"vm.dashboardFilter(\'YSD\')\" label=\"Year\">Year\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'RNG\'}\" \nng-click=\"vm.selectedFilterFlag = \'RNG\'\" label=\"Range\">Range</md-button><div flex-gt-xs \nng-show=\"vm.selectedFilterFlag === \'RNG\'\"><md-datepicker class=\"datepickerClass\" ng-model=\"vm.orderDate.fromDate\" \nmd-placeholder=\"From Date\" md-max-date=\"vm.maxDate\"></md-datepicker><md-datepicker class=\"datepickerClass\" \nng-model=\"vm.orderDate.toDate\" md-placeholder=\"To Date\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.orderDate.fromDate\">\n</md-datepicker><md-button class=\"md-primary md-raised margin-left-15\" ng-click=\"vm.dashboardFilter(\'RNG\')\" \nng-disabled=\"!(vm.orderDate.fromDate && vm.orderDate.toDate)\">Apply</md-button></div></md-content><div \nclass=\"scrollable\" ms-scroll><div class=\"padding-5\" layout=\"row\" layout-align=\"space-between\"><div flex=\"100\" \nclass=\"white-bg md-whiteframe-4dp\" style=\"padding:0px 6px\"><div><h3 style=\"margin-top:10px; margin-bottom:0px\"><b>\nCustomer Base</b></h3><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Total Customers</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.totalUsers) ? (vm.allDashboardDetails.totalUsers):0}}</div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Only Signup Customers</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.onlySignupUsers) ? (vm.allDashboardDetails.onlySignupUsers):0}}</div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Inactive IIN Customers</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.nonActiveUsers) ? (vm.allDashboardDetails.nonActiveUsers):0}}</div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Active IIN Customers</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.activeOverallUsers)?(vm.allDashboardDetails.activeOverallUsers): 0 }}</div></div>\n</ms-widget-front></ms-widget></div><br><h3 style=\"margin-top:10px; margin-bottom:0px\"><b>Active IIN Customer Base</b>\n</h3><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Floating Investor</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">{{(vm.noInvstUser) ? (vm.noInvstUser):0}}</div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" \nflex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div \nlayout=\"column\" layout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Total Invested</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.investedUsers) ? (vm.allDashboardDetails.investedUsers):0}}</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"4\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n<button ng-click=\"vm.toggleVisibilityCurrentlyInvested()\"><md-icon \nmd-font-icon=\"{{ vm.currentlyInvestedDisplay ? \'icon-minus\' : \'icon-plus\' }}\" \nclass=\"ng-scope md-default-theme md-font material-icons\" aria-hidden=\"true\" style=\"color: black\"></md-icon></button>\n</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.currentlyInvestedDisplay\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Currently Invested</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.currentlyInvested) ? (vm.allDashboardDetails.currentlyInvested):0}}</div></div>\n</ms-widget-front></ms-widget></div><br><h3 style=\"margin-top:10px; margin-bottom:0px\"><b>Investing Customer Base</b>\n</h3><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Total SIP</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.sipUsers) ? (vm.allDashboardDetails.sipUsers):0}}</div></div></ms-widget-front></ms-widget>\n<ms-widget flex=\"4\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\"><button \nng-click=\"vm.toggleVisibilityTotalSIP()\"><md-icon md-font-icon=\"{{ vm.totalSIPDisplay ? \'icon-minus\' : \'icon-plus\' }}\" \nclass=\"ng-scope md-default-theme md-font material-icons\" aria-hidden=\"true\" style=\"color: black\"></md-icon></button>\n</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.totalSIPDisplay\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Current SIP</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.currentSIP) ? (vm.allDashboardDetails.currentSIP):0}}</div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Total Lumpsum</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.lumpsumUsers) ? (vm.allDashboardDetails.lumpsumUsers):0}}</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"4\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n<button ng-click=\"vm.toggleVisibilityTotalLumpsum()\"><md-icon \nmd-font-icon=\"{{  vm.totalLumpsumDisplay ? \'icon-minus\' : \'icon-plus\' }}\" \nclass=\"ng-scope md-default-theme md-font material-icons\" aria-hidden=\"true\" style=\"color: black\"></md-icon></button>\n</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.totalLumpsumDisplay\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Current Lumpsum</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.currentLumpsum) ? (vm.allDashboardDetails.currentLumpsum):0}}</div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Total Both</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.bothUsers) ? (vm.allDashboardDetails.bothUsers):0}}</div></div></ms-widget-front></ms-widget>\n<ms-widget flex=\"4\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\"><button \nng-click=\"vm.toggleVisibilityCurrentBoth()\"><md-icon \nmd-font-icon=\"{{ vm.currentBothDisplay ? \'icon-minus\' : \'icon-plus\' }}\" \nclass=\"ng-scope md-default-theme md-font material-icons\" aria-hidden=\"true\" style=\"color: black\"></md-icon></button>\n</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.currentBothDisplay\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Current Both</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.currentBoth) ? (vm.allDashboardDetails.currentBoth):0}}</div></div></ms-widget-front>\n</ms-widget></div><br><h3 style=\"margin-top:10px; margin-bottom:0px\" ng-show=\"vm.role===\'SUPER::ADMIN\'\"><b>\nCustomer Base Assignment Summary</b></h3><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.role===\'SUPER::ADMIN\'\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Assigned Customers</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">{{(vm.assignedCustomer) ? (vm.assignedCustomer):0}}</div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.role===\'SUPER::ADMIN\'\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Unassigned Customers</div></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.allDashboardDetails.unassignedUsers) ? (vm.allDashboardDetails.unassignedUsers):0}}</div></div></ms-widget-front>\n</ms-widget></div><br><h3 style=\"margin-top:10px; margin-bottom:0px\" ng-show=\"vm.role===\'SUPER::ADMIN\'\"><b>\nInvestment Details</b></h3><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.role===\'SUPER::ADMIN\'\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Invested Amount</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.dashboardData.netInvestedAmount) ? (vm.dashboardData.netInvestedAmount | currency:\"&#8377;\":2):0}}</div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.role===\'SUPER::ADMIN\'\"><ms-widget flex=\"33\" flex-xs=\"100\" \nstyle=\"padding-right:5px; padding-left:0px; padding-bottom:0px\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center left\"><div class=\"grey-50-bg font-size-20 black-fg\">Current Value</div></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"33\" flex-xs=\"100\" style=\"padding-right:5px; padding-left:0px; padding-bottom:0px\">\n<ms-widget-front class=\"white-bg\"><div layout=\"column\" layout-align=\"center left\"><div class=\"font-size-20 black-fg\">\n{{(vm.dashboardData.netCurrentAmount) ? (vm.dashboardData.netCurrentAmount | currency:\"&#8377;\":2):0}}</div></div>\n</ms-widget-front></ms-widget></div></div></div></div></div><style>\nmd-icon.md-default-theme,\r\n    md-icon {\r\n        color: #fff;\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input,\r\n    .md-hue-2 .md-datepicker-input {\r\n        color: #fff;\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container,\r\n    .md-hue-2 .md-datepicker-input-container {\r\n        border-bottom-color: #fff;\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-triangle-button .md-datepicker-expand-triangle,\r\n    .md-hue-2 .md-datepicker-triangle-button .md-datepicker-expand-triangle {\r\n        border-top-color: #fff;\r\n    }\n</style>");
$templateCache.put("app/main/dashboard/employee/dialogMsg.html","<md-dialog aria-label=\"Mango (Fruit)\" layout-padding><h4 class=\"padding-bottom-20\">Assign Sub Broker is not available!\n</h4><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.cancleDialog()\" \nclass=\"md-raised md-accent\" style=\"color:#fff !important; text-transform:uppercase\">OK</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/dashboard/employee/dialogMsgFlag.html","<md-dialog aria-label=\"Mango (Fruit)\" layout-padding><h4 class=\"padding-bottom-20\">Flag details is not available!</h4>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.cancleDialog()\" \nclass=\"md-raised md-accent\" style=\"color:#fff !important; text-transform:uppercase\">OK</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/dashboard/employee/employee.html","<md-content class=\"bgdashboardHeader\" layout-gt-sm=\"row\"><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterEmployeeColor\':vm.selectedFilterFlag=== \'TOD\'}\" ng-click=\"vm.employeeDateFilter(\'TOD\')\" \nlabel=\"Today\">Today</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterEmployeeColor\':vm.selectedFilterFlag=== \'RNG\'}\" ng-click=\"vm.employeeDateFilter(\'RNG\')\" \nlabel=\"Range\">Range</md-button><div flex-gt-xs ng-show=\"vm.selectedFilterFlag === \'RNG\'\"><md-datepicker \nclass=\"datepickerClass\" ng-model=\"vm.emp.fromDate\" md-placeholder=\"From Date\" md-max-date=\"vm.maxDate\"></md-datepicker>\n<md-datepicker class=\"datepickerClass\" ng-model=\"vm.emp.toDate\" md-placeholder=\"To Date\" md-max-date=\"vm.maxDate\" \nmd-min-date=\"vm.emp.fromDate\"></md-datepicker><md-button class=\"md-primary md-raised margin-left-15\" \nng-click=\"vm.getRangeEmployeePerformance()\" ng-disabled=\"!(vm.emp.fromDate && vm.emp.toDate)\">Apply</md-button></div>\n</md-content><div class=\"padding-5\" layout=\"row\" layout-align=\"space-between\"><div flex=\"100\" \nclass=\"white-bg md-whiteframe-4dp\" style=\"padding:0px 6px\"><div ng-cloak><h3 style=\"margin-top:10px\">\nManagerial Distribution</h3><div class=\"ext-content\"><md-table-container ng-style=\"listStyle\" fix-head><table md-table \nng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head md-order=\"vm.query.order\" fix-head><tr md-row><th \nmd-column><span>SNo</span></th><th md-column md-order-by=\"name\"><span>Employee Name</span></th><th md-column \nmd-order-by=\"investments\"><span>Investment</span></th><th md-column md-order-by=\"assignedCustomers\"><span>\nAssigned Customer</span></th><th md-column md-order-by=\"flagClosed\"><span>Flag Closed</span></th><th md-column \nmd-order-by=\"monitoringFlags\"><span>Flag Distribution</span></th></tr></thead><tbody md-body><div class=\"scrollable\" \nms-scroll><tr md-row md-select=\"item\" md-auto-select \nng-repeat=\"item in vm.employeePerformance | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\"><td \nmd-cell><span>{{$index+1}}</span></td><td md-cell><span>{{item.name}}</span></td><td md-cell><span>\n{{item.investments | currency:\"&#8377;\":0}}</span></td><td md-cell><span \nng-click=\"vm.assignSubBrokerDetails($event,item)\">{{(item.assignedCustomers) ? (item.assignedCustomers) :0}}</span>\n</td><td md-cell><span ng-click=\"vm.goToFlagDetails($event,item)\">{{(item.flagClosed) ? (item.flagClosed) :0}}</span>\n</td><td md-cell><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-button flex=\"15\" \nng-show=\"item.monitoringFlags.documentFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.documentFlagCount)\" class=\"test-tooltip bgColorMenu1D\" \naria-label=\"Flags 1\">D - {{item.monitoringFlags.documentFlagCount.length}}<md-tooltip md-direction=\"top\">Document Flag\n</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.loanFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.loanFlagCount)\" class=\"test-tooltip bgColorMenu2D\" \naria-label=\"Flags 2\">L - {{item.monitoringFlags.loanFlagCount.length}}<md-tooltip md-direction=\"top\">Loan Flag\n</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.insuranceFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.insuranceFlagCount)\" class=\"test-tooltip bgColorMenu3D\" \naria-label=\"Flags 3\">I - {{item.monitoringFlags.insuranceFlagCount.length}}<md-tooltip md-direction=\"top\">\nInsurance Flag</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.sipFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.sipFlagCount)\" class=\"test-tooltip bgColorMenu4D\" \naria-label=\"Flags 4\">SA - {{item.monitoringFlags.sipFlagCount.length}}<md-tooltip md-direction=\"top\">SIP Flag\n</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.lumpsumpFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.lumpsumpFlagCount)\" class=\"test-tooltip bgColorMenu5D\" \naria-label=\"Flags 5\">LA - {{item.monitoringFlags.lumpsumpFlagCount.length}}<md-tooltip md-direction=\"top\">Lumpsum Flag\n</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.signupFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.signupFlagCount)\" class=\"test-tooltip bgColorMenu6D\" \naria-label=\"Flags 6\">S - {{item.monitoringFlags.signupFlagCount.length}}<md-tooltip md-direction=\"top\">Signup Flag\n</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.iinCreationFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.iinCreationFlagCount)\" class=\"test-tooltip bgColorMenu7D\" \naria-label=\"Flags 7\">IC - {{item.monitoringFlags.iinCreationFlagCount.length}}<md-tooltip md-direction=\"top\">\nIIN Creation Flag</md-tooltip></md-button><md-button flex=\"15\" \nng-show=\"item.monitoringFlags.externalHoldingFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.externalHoldingFlagCount)\" class=\"test-tooltip bgColorMenu8D\" \naria-label=\"Flags 8\">E - {{item.monitoringFlags.externalHoldingFlagCount.length}}<md-tooltip md-direction=\"top\">\nExternal Holding Flag</md-tooltip></md-button><md-button flex=\"15\" \nng-show=\"item.monitoringFlags.reversalFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.reversalFlagCount)\" class=\"test-tooltip bgColorMenu9D\" \naria-label=\"Flags 9\">R - {{item.monitoringFlags.reversalFlagCount.length}}<md-tooltip md-direction=\"top\">Reversal Flag\n</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.assinedFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.assinedFlagCount)\" class=\"test-tooltip bgColorMenu10D\" \naria-label=\"Flags 10\">A - {{item.monitoringFlags.assinedFlagCount.length}}<md-tooltip md-direction=\"top\">Assigned Flag\n</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.reviewPendingFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.reviewPendingFlagCount)\" class=\"test-tooltip bgColorMenu11D\" \naria-label=\"Flags 11\">C - {{item.monitoringFlags.reviewPendingFlagCount.length}}<md-tooltip md-direction=\"top\">\nReview Pending Flag</md-tooltip></md-button><md-button flex=\"15\" \nng-show=\"item.monitoringFlags.iinActiveFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.iinActiveFlagCount)\" class=\"test-tooltip bgColorMenu12D\" \naria-label=\"Flags 12\">IA - {{item.monitoringFlags.iinActiveFlagCount.length}}<md-tooltip md-direction=\"top\">\nIIN Active Flag</md-tooltip></md-button><md-button flex=\"15\" \nng-show=\"item.monitoringFlags.fatcaKycUboRegFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.fatcaKycUboRegFlagCount)\" class=\"test-tooltip bgColorMenu13D\" \naria-label=\"Flags 13\">FK - {{item.monitoringFlags.fatcaKycUboRegFlagCount.length}}<md-tooltip md-direction=\"top\">\nFatca KYC</md-tooltip></md-button><md-button flex=\"15\" \nng-show=\"item.monitoringFlags.achmandateRegFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.achmandateRegFlagCount)\" class=\"test-tooltip bgColorMenu14D\" \naria-label=\"Flags 14\">AM - {{item.monitoringFlags.achmandateRegFlagCount.length}}<md-tooltip md-direction=\"top\">\nACH Mandate</md-tooltip></md-button><md-button flex=\"15\" ng-show=\"item.monitoringFlags.redemptionFlagCount.length > 0\" \nng-click=\"vm.employeeFlagFilter(item.monitoringFlags.redemptionFlagCount)\" class=\"test-tooltip bgColorMenu14D\" \naria-label=\"Flags 14\">RD - {{item.monitoringFlags.redemptionFlagCount.length}}<md-tooltip md-direction=\"top\">\nRedemptione</md-tooltip></md-button></div></div></td></tr></div></tbody></table></md-table-container></div></div></div>\n</div><style>\nmd-icon.md-default-theme,\r\n    md-icon {\r\n        color: #fff;\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input,\r\n    .md-hue-2 .md-datepicker-input {\r\n        color: #fff;\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container,\r\n    .md-hue-2 .md-datepicker-input-container {\r\n        border-bottom-color: #fff;\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-triangle-button .md-datepicker-expand-triangle,\r\n    .md-hue-2 .md-datepicker-triangle-button .md-datepicker-expand-triangle {\r\n        border-top-color: #fff;\r\n    }\n</style>");
$templateCache.put("app/main/dashboard/flag-closed-detail/flag-closed-detail.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"dashboard\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"70\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nDashboard</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"20\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" layout-align=\"start center\" flex=\"10\"><md-button \nclass=\"backArrowColor\" back-button layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor\" style=\"line-height:10px\"></md-icon><span \nstyle=\"line-height:-2%; margin-top:-14%\">Back</span></md-button></div></div><div class=\"scrollable\" ms-scroll><div \nclass=\"padding-5\" layout=\"row\" layout-align=\"space-between\"><div flex=\"100\" class=\"white-bg md-whiteframe-4dp\" \nstyle=\"padding:0px 6px\"><div ng-cloak><h3 style=\"margin-top:10px\">Flag Closed Details</h3><md-table-container \nng-style=\"listStyle\" fix-head><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column md-order-by=\"userName\"><span>Name</span></th><th md-column \nmd-order-by=\"iin\"><span>IIN</span></th><th md-column md-order-by=\"email\"><span>Email</span></th><th md-column \nmd-order-by=\"pan\"><span>PAN No.</span></th><th md-column md-order-by=\"flag\"><span>Flags</span></th></tr></thead><tbody \nmd-body><tr md-row md-select=\"item\" md-auto-select \nng-repeat=\"item in vm.empPerformanceAllFlag | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.customerDetailFunction(item)\"><td md-cell><span>{{(item.userName) ? (item.userName) :\'NA\'}}</span></td><td\n md-cell><span>{{(item.iin) ? (item.iin) :\'NA\'}}</span></td><td md-cell><span>{{(item.email) ? (item.email) :\'NA\'}}\n</span></td><td md-cell><span>{{(item.pan) ? (item.pan) :\'NA\'}}</span></td><td md-cell><span \nng-repeat=\"flag in item.monitoringHistory\"><md-button ng-class=\"vm.flagClass(flag)\" class=\"test-tooltip text-center\" \naria-label=\"Flags\">{{flag.activityName[0]}}<md-tooltip md-direction=\"top\">{{flag.activityName}}</md-tooltip><p \nclass=\"textDate\">{{flag.date | date : \'dd/MM/yyyy\'}}</p></md-button></span></td></tr></tbody></table>\n</md-table-container></div></div></div></div></div>");
$templateCache.put("app/main/dashboard/reports/reports.html","<md-content class=\"bgdashboardHeader\" layout-gt-sm=\"row\"><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'INC\'}\" ng-click=\"vm.getBarGraphData(\'INC\')\" label=\"Inception\">\nInception</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'TOD\'}\" ng-click=\"vm.getBarGraphData(\'TOD\')\" label=\"Today\">\nToday</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'WTD\'}\" ng-click=\"vm.getBarGraphData(\'WTD\')\" label=\"WTD\">WTD\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'MTD\'}\" \nng-click=\"vm.getBarGraphData(\'MTD\')\" label=\"MTD\">MTD</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'YSD\'}\" ng-click=\"vm.getBarGraphData(\'YSD\')\" label=\"Year\">Year\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectFilterColor\':vm.selectedFilterFlag=== \'RNG\'}\" \nng-click=\"vm.selectedFilterFlag = \'RNG\'\" label=\"Range\">Range</md-button><div flex-gt-xs \nng-show=\"vm.selectedFilterFlag === \'RNG\'\"><md-datepicker class=\"datepickerClass\" ng-model=\"vm.fromDate\" \nmd-placeholder=\"From Date\" md-max-date=\"vm.maxDate\"></md-datepicker><md-datepicker class=\"datepickerClass\" \nng-model=\"vm.toDate\" md-placeholder=\"To Date\" md-max-date=\"vm.maxDate\" md-min-date=\"vm.fromDate\"></md-datepicker>\n<md-button class=\"md-primary md-raised margin-left-15\" ng-click=\"vm.getBarGraphData(\'RNG\')\" \nng-disabled=\"!(vm.fromDate && vm.toDate)\">Apply</md-button></div></md-content><div class=\"scrollable\" ms-scroll><div \nlayout=\"row\"><div class=\"content\" flex=\"50\"><div class=\"md-title\">Graph on Consumer Acquisition</div><div layout=\"row\" \nlayout-align=\"center center\" class=\"card md-whiteframe-4dp\" layout-padding><canvas id=\"bar\" class=\"chart chart-bar\" \nchart-options=\"vm.barChart.options\" chart-colors=\"vm.barChart.colors\" chart-data=\"vm.barChart.data\" \nchart-labels=\"vm.barChart.labels\"></canvas></div></div><div class=\"content\" flex=\"50\"><div class=\"md-title\">\nGraph on IIN Activation</div><div layout=\"row\" layout-align=\"center center\" class=\"card md-whiteframe-4dp\" \nlayout-padding><canvas id=\"bar\" class=\"chart chart-bar\" chart-options=\"vm.barChart1.options\" \nchart-colors=\"vm.barChart1.colors\" chart-data=\"vm.barChart1.data\" chart-labels=\"vm.barChart1.labels\"></canvas></div>\n</div></div></div><style>\n.simple thead,\r\n    .simple tbody tr {\r\n        display: table;\r\n        width: 100%;\r\n        table-layout: fixed;\r\n    }\r\n\r\n    .nv-series-0 rect {\r\n        fill: #c0392b !important;\r\n        fill-opacity: 1 !important;\r\n        /* width: 55px !important; */\r\n    }\r\n\r\n    .nv-series-1 rect {\r\n        fill: rgba(0, 0, 255, 1) !important;\r\n        fill-opacity: 1 !important;\r\n        /* width: 55px !important; */\r\n    }\r\n\r\n    .ng-group rect {\r\n        width: 55px !important;\r\n    }\r\n\r\n    .ng-group {\r\n        fill-opacity: 1 !important;\r\n    }\n</style>");
$templateCache.put("app/main/internalUser/internalUserCreate/internalUser.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"userInternalCreate\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\" \nng-init=\"vm.fetchoffice();vm.fetchfinanceuser();\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" \nflex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Create Internal User</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input ng-model=\"search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div layout=\"row\" layout-align=\"start center\" \nflex=\"10\"><md-button class=\"backArrowColor\" back-button layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div \nng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom ng-click=\"vm.activeFalseAssignFeature()\"><md-tab \nlabel=\"Create Internal User\"><md-content class=\"padding-10\"><div class=\"white-bg md-whiteframe-4dp\" layout-padding><h4>\nCreate Internal User</h4><form name=\"internalUser\"><div layout=\"row\"><div layout=\"column\" layout-xs=\"column\" flex=\"50\" \nlayout-align=\"space-between\" layout-padding><md-input-container flex=\"50\" flex-xs=\"100\"><label>Name</label><input \ntype=\"text\" required name=\"name\" ng-model=\"vm.userData.userName\" ng-pattern=\"vm.userNameReg\" class=\"no-margin-bottom\" \ntabindex=\"1\"><div ng-messages=\"internalUser.name.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\"><label>Contact Number</label><input type=\"number\" \nrequired name=\"mobile\" ng-model=\"vm.userData.mobileNo\" ng-pattern=\"vm.contactNumberReg\" class=\"no-margin-bottom\" \ntabindex=\"2\"><div ng-messages=\"internalUser.mobile.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\"><label>Email Id</label><input type=\"text\" required \nname=\"email\" ng-model=\"vm.userData.email\" ng-pattern=\"vm.emailReg\" class=\"no-margin-bottom\" tabindex=\"3\"><div \nng-messages=\"internalUser.email.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container flex=\"50\" flex-xs=\"100\"><label>Type</label><md-select ng-model=\"vm.userData.type\" \nng-change=\"vm.selecttype(vm.userData.type)\" name=\"type\" required tabindex=\"4\"><md-option ng-value=\"type.type\" \nng-repeat=\"type in vm.internalUserType\">{{type.name}}</md-option></md-select><div \nng-messages=\"internalUser.type.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<div flex=\"50\" flex-xs=\"100\" ng-show=\"vm.usertik\"><label for=\"vehicle1\">Map Finance User</label>\n&nbsp;&nbsp;&nbsp;&nbsp;<input type=\"checkbox\" ng-model=\"vm.financeuser\" value=\"finance\"><div ng-messages=\"\"></div>\n</div><br><md-autocomplete flex=\"50\" flex-gt-xs=\"100\" tabindex=\"2\" ng-show=\"vm.financeuser === true\" \nmd-input-name=\"amc\" md-menu-class=\"autocomplete-custom-template\" md-autofocus flex=\"100\" required \nmd-floating-label=\"Finance User Name\" md-selected-item=\"vm.userData.advisor\" \nmd-items=\"item in vm.advisordata(searchText)\" md-search-text=\"searchText\" md-item-text=\"item.userName\" \nng-disabled=\"vm.goalFundId\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.userName}}</span></md-item-template><md-not-found>No Category Finance User \"{{searchText}}\" were found.\n</md-not-found></md-autocomplete><md-input-container flex=\"50\" flex-xs=\"100\" \nng-show=\"vm.userData.type === \'SUB::BROKER\'\"><label>Broker Code</label><input type=\"text\" name=\"brokerCode\" \nng-model=\"vm.userData.brokerCode\" class=\"no-margin-bottom\" tabindex=\"5\" \nng-required=\"vm.userData.type === \'SUB::BROKER\'\"><div ng-messages=\"internalUser.brokerCode.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" \nng-show=\"vm.userData.type === \'SUB::BROKER\'\"><label>Broker ARN Code</label><input type=\"text\" name=\"arnCode\" \nng-model=\"vm.userData.arnCode\" class=\"no-margin-bottom\" tabindex=\"5\" ng-required=\"vm.userData.type === \'SUB::BROKER\'\">\n<div ng-messages=\"internalUser.arnCode.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" \nng-show=\"vm.userData.type === \'SUB::BROKER\' || vm.userData.type === \'FINANCE::USER\'\"><label>EUIN</label><input \ntype=\"text\" name=\"euin\" ng-model=\"vm.userData.euin\" class=\"no-margin-bottom\" tabindex=\"6\" \nng-required=\"vm.userData.type === \'SUB::BROKER\' || vm.userData.type === \'FINANCE::USER\'\"><div \nng-messages=\"internalUser.euin.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"mt-10\" flex=\"100\" flex-xs=\"100\"><label>Description</label><textarea \nng-model=\"vm.userData.desc\" md-maxlength=\"300\" rows=\"2\" md-select-on-focus></textarea></md-input-container>\n<md-input-container flex=\"50\" flex-xs=\"100\"><label>Offices</label><md-select ng-model=\"vm.userData.office\" name=\"type\" \nrequired tabindex=\"4\"><md-option ng-value=\"type._id\" ng-repeat=\"type in vm.fetchcitydat\">{{type.city}}</md-option>\n</md-select><div ng-messages=\"internalUser.type.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div><div layout=\"column\" layout-align=\"center center\" flex=\"50\" flow-init \nflow-name=\"vm.imageFile.flowObj\" flow-files-added=\"vm.processFile($files)\"><div \nclass=\"margin-bottom-15 objectParentCreateAmc\" ng-show=\"!vm.imageFile.flowObj.files.length\"><img \nclass=\"md-card-image objectFit\" ng-src=\"{{vm.dummyImage}}\"></div><div class=\"margin-bottom-15 objectParentCreateAmc\" \nng-show=\"vm.imageFile.flowObj.files.length\"><img class=\"md-card-image objectFit\" \nflow-img=\"vm.imageFile.flowObj.files[0]\"></div><md-button style=\"color:#ffffff\" class=\"md-raised md-accent width-120\" \nng-click=\"$flow.cancel()\" flow-btn>Upload Image</md-button></div></div><section layout=\"row\" \nlayout-align=\"center center\" layout-wrap><md-button type=\"button\" class=\"md-raised md-accent width-160\" \nng-disabled=\"vm.disableAssignfeature()\" tabindex=\"7\" ng-click=\"vm.navigateAssignFeature()\" \nstyle=\"color:#fff !important\">Next</md-button></section></form></div></md-content></md-tab><md-tab \nlabel=\"Assign Feature\" ng-disabled=\"vm.disableAssignfeature()\" md-active=\"vm.activeAssignFeature\"><md-content \nclass=\"padding-10\"><div class=\"white-bg md-whiteframe-4dp\" layout-padding><h4>Assign Feature</h4><div class=\"inset\" \nng-cloak><div layout=\"row\" layout-xs=\"column\" layout-wrap><div flex=\"50\" \nng-repeat=\"feature in vm.internalAssignFeature\"><md-switch ng-model=\"feature.assignedFeature\" value=\"{{feature.fId}}\" \nng-click=\"vm.getAssignData(feature)\">{{feature.name}}</md-switch></div></div><section layout=\"row\" \nlayout-align=\"center center\" layout-wrap><md-button type=\"submit\" class=\"md-raised md-accent width-160\" \nng-click=\"vm.setInternalUserMapping()\" ng-disabled=\"vm.disablesetInternalUserMapping()\" tabindex=\"6\" \nstyle=\"color:#fff !important\">Submit</md-button></section></div></div></md-content></md-tab></md-tabs></md-content>\n</div></div>");
$templateCache.put("app/main/internalUser/internalUserCreate/internalUser1.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"userInternalCreate\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nCreate Internal User</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"15\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input ng-model=\"search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div layout=\"row\" layout-align=\"start center\" \nflex=\"10\"><md-button class=\"backArrowColor\" back-button layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div \nng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom ng-click=\"vm.activeFalseAssignFeature()\"><md-tab \nlabel=\"Create Internal User\"><md-content class=\"padding-10\"><div class=\"white-bg md-whiteframe-4dp\" layout-padding><h4>\nCreate Internal User</h4><form name=\"internalUser\"><div layout=\"row\"><div layout=\"column\" layout-xs=\"column\" flex=\"50\" \nlayout-align=\"space-between\" layout-padding><md-input-container flex=\"50\" flex-xs=\"100\"><label>Name</label><input \ntype=\"text\" required name=\"name\" ng-model=\"vm.userData.userName\" ng-pattern=\"vm.userNameReg\" class=\"no-margin-bottom\" \ntabindex=\"1\"><div ng-messages=\"internalUser.name.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\"><label>Contact Number</label><input type=\"number\" \nrequired name=\"mobile\" ng-model=\"vm.userData.mobileNo\" ng-pattern=\"vm.contactNumberReg\" class=\"no-margin-bottom\" \ntabindex=\"2\"><div ng-messages=\"internalUser.mobile.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\"><label>Email Id</label><input type=\"text\" required \nname=\"email\" ng-model=\"vm.userData.email\" ng-pattern=\"vm.emailReg\" class=\"no-margin-bottom\" tabindex=\"3\"><div \nng-messages=\"internalUser.email.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container flex=\"50\" flex-xs=\"100\"><label>Type</label><md-select ng-model=\"vm.userData.type\" name=\"type\" \nrequired tabindex=\"4\"><md-option ng-value=\"type.type\" ng-repeat=\"type in vm.internalUserType\">{{type.name}}</md-option>\n</md-select><div ng-messages=\"internalUser.type.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" ng-show=\"vm.userData.type === \'SUB::BROKER\'\"><label>\nBroker Code</label><input type=\"text\" name=\"brokerCode\" ng-model=\"vm.userData.brokerCode\" class=\"no-margin-bottom\" \ntabindex=\"5\" ng-required=\"vm.userData.type === \'SUB::BROKER\'\"><div ng-messages=\"internalUser.brokerCode.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" \nng-show=\"vm.userData.type === \'SUB::BROKER\'\"><label>Broker ARN Code</label><input type=\"text\" name=\"arnCode\" \nng-model=\"vm.userData.arnCode\" class=\"no-margin-bottom\" tabindex=\"5\" ng-required=\"vm.userData.type === \'SUB::BROKER\'\">\n<div ng-messages=\"internalUser.arnCode.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container flex=\"50\" flex-xs=\"100\" \nng-show=\"vm.userData.type === \'SUB::BROKER\' || vm.userData.type === \'FINANCE::USER\'\"><label>EUIN</label><input \ntype=\"text\" name=\"euin\" ng-model=\"vm.userData.euin\" class=\"no-margin-bottom\" tabindex=\"6\" \nng-required=\"vm.userData.type === \'SUB::BROKER\' || vm.userData.type === \'FINANCE::USER\'\"><div \nng-messages=\"internalUser.euin.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"mt-10\" flex=\"100\" flex-xs=\"100\"><label>Description</label><textarea \nng-model=\"vm.userData.desc\" md-maxlength=\"300\" rows=\"2\" md-select-on-focus></textarea></md-input-container></div><div \nlayout=\"column\" layout-align=\"center center\" flex=\"50\" flow-init flow-name=\"vm.imageFile.flowObj\" \nflow-files-added=\"vm.processFile($files)\"><div class=\"margin-bottom-15 objectParentCreateAmc\" \nng-show=\"!vm.imageFile.flowObj.files.length\"><img class=\"md-card-image objectFit\" ng-src=\"{{vm.dummyImage}}\"></div><div\n class=\"margin-bottom-15 objectParentCreateAmc\" ng-show=\"vm.imageFile.flowObj.files.length\"><img \nclass=\"md-card-image objectFit\" flow-img=\"vm.imageFile.flowObj.files[0]\"></div><md-button style=\"color:#ffffff\" \nclass=\"md-raised md-accent width-120\" ng-click=\"$flow.cancel()\" flow-btn>Upload Image</md-button></div></div><section \nlayout=\"row\" layout-align=\"center center\" layout-wrap><md-button type=\"button\" class=\"md-raised md-accent width-160\" \nng-disabled=\"vm.disableAssignfeature()\" tabindex=\"7\" ng-click=\"vm.navigateAssignFeature()\" \nstyle=\"color:#fff !important\">Next</md-button></section></form></div></md-content></md-tab><md-tab \nlabel=\"Assign Feature\" ng-disabled=\"vm.disableAssignfeature()\" md-active=\"vm.activeAssignFeature\"><md-content \nclass=\"padding-10\"><div class=\"white-bg md-whiteframe-4dp\" layout-padding><h4>Assign Feature</h4><div class=\"inset\" \nng-cloak><div layout=\"row\" layout-xs=\"column\" layout-wrap><div flex=\"50\" \nng-repeat=\"feature in vm.internalAssignFeature\"><md-switch ng-model=\"feature.assignedFeature\" value=\"{{feature.fId}}\" \nng-click=\"vm.getAssignData(feature)\">{{feature.name}}</md-switch></div></div><section layout=\"row\" \nlayout-align=\"center center\" layout-wrap><md-button type=\"submit\" class=\"md-raised md-accent width-160\" \nng-click=\"vm.setInternalUserMapping()\" ng-disabled=\"vm.disablesetInternalUserMapping()\" tabindex=\"6\" \nstyle=\"color:#fff !important\">Submit</md-button></section></div></div></md-content></md-tab></md-tabs></md-content>\n</div></div>");
$templateCache.put("app/main/internalUser/internaluser-details/internaluserDetails.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"userInternalMapping\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nInternal User Customer Mapping</span></div><div class=\"product-count secondary-text margin-top-10\"><span>\nTotal Customers Mapping:</span> <span>{{vm.showEachDetailMapping.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex=\"15\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input ng-model=\"search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div layout=\"row\" layout-align=\"start center\" flex=\"10\"><md-button \nclass=\"backArrowColor\" back-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div class=\"white-bg\" layout=\"column\">\n<div class=\"article\"><md-content><div layout-align=\"center center\" class=\"table-title\"><h4 class=\"margin-left-30\" \nstyle=\"margin-bottom:-10px\">Customer Detail</h4></div><div layout=\"row\" layout-align=\"space-around center\" flex><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span class=\"title\">\nName : &nbsp;&nbsp; {{vm.nseData.INVESTOR_NAME? vm.nseData.INVESTOR_NAME: (vm.showEachDetail.userName?vm.showEachDetail.userName:\'NA\')}}\n</span> <span>Email : &nbsp;&nbsp; {{(vm.showEachDetail.email) ? (vm.showEachDetail.email):\'NA\'}}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><span>\nType : &nbsp;&nbsp; {{vm.typerename[vm.showEachDetail.type]}}</span> <span>\nContact No. : &nbsp;&nbsp; {{(vm.showEachDetail.mobileNo) ? (vm.showEachDetail.mobileNo):\'NA\'}}</span></div><div \nlayout=\"column\" layout-align=\"space-around start\" flex=\"30\" layout-padding><p \nng-repeat=\"feature in vm.showEachDetail.featureName\" style=\"margin-bottom:0px\">{{feature}}</p></div></div></md-content>\n</div><div class=\"article padding-top-10\"><md-content><div class=\"ext-content\"><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>S. No.</span></th><th md-column \nmd-order-by=\"userName\"><span>Flags</span></th><th md-column md-order-by=\"userName\"><span>Name</span></th><th md-column \nmd-order-by=\"mobileNo\"><span>Contact Number</span></th><th md-column md-order-by=\"email\"><span>Email Id</span></th><th \nmd-column md-order-by=\"email\"><span>IIN</span></th><th md-column><span>Action</span></th></tr></thead><tbody md-body>\n<tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"customerMapped in vm.showEachDetailMapping | filter:search | orderBy: vm.query.order | limitTo:vm.query.limit\" \nstyle=\"cursor:pointer\" ng-click=\"vm.customerDetailFunction(customerMapped)\"><td md-cell>{{$index+1}}</td><td md-cell \nng-click=\"vm.gotoFlags($event,customerMapped,\'Flag\')\"><span ng-show=\"!customerMapped.monitoringFlags\">NA</span><div \nclass=\"content\" ng-show=\"customerMapped.monitoringFlags\" ng-click=\"vm.gotoFlags($event,customerMapped,\'Flag\')\"><div \nclass=\"white-bg md-whiteframe-4dp\" ng-click=\"vm.gotoFlags($event,customerMapped,\'Flag\')\"><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between\" ng-click=\"vm.gotoFlags($event,customerMapped,\'Flag\')\" padding-wrap>\n<md-button ng-show=\"customerMapped.monitoringFlags.documentFlag\" class=\"test-tooltip bgColorMenu1\" \naria-label=\"Flags 1\">D<md-tooltip md-direction=\"top\">Document Flag</md-tooltip></md-button><md-button \nng-show=\"customerMapped.monitoringFlags.loanFlag\" class=\"test-tooltip bgColorMenu2\" aria-label=\"Flags 2\">L<md-tooltip \nmd-direction=\"top\">Loan Flag</md-tooltip></md-button><md-button ng-show=\"customerMapped.monitoringFlags.insuranceFlag\" \nclass=\"test-tooltip bgColorMenu3\" aria-label=\"Flags 3\">I<md-tooltip md-direction=\"top\">Insurance Flag</md-tooltip>\n</md-button><md-button ng-show=\"customerMapped.monitoringFlags.sipFlag\" class=\"test-tooltip bgColorMenu4\" \naria-label=\"Flags 4\">S<md-tooltip md-direction=\"top\">SIP Flag</md-tooltip></md-button><md-button \nng-show=\"customerMapped.monitoringFlags.lumpsumFlag\" class=\"test-tooltip bgColorMenu5\" aria-label=\"Flags 5\">L\n<md-tooltip md-direction=\"top\">Lumpsum Flag</md-tooltip></md-button><md-button \nng-show=\"customerMapped.monitoringFlags.signupFlag\" class=\"test-tooltip bgColorMenu6\" aria-label=\"Flags 6\">S<md-tooltip\n md-direction=\"top\">Signup Flag</md-tooltip></md-button><md-button \nng-show=\"customerMapped.monitoringFlags.iinCreationFlag\" class=\"test-tooltip bgColorMenu7\" aria-label=\"Flags 7\">I\n<md-tooltip md-direction=\"top\">IIN Creation Flag</md-tooltip></md-button><md-button \nng-show=\"customerMapped.monitoringFlags.externalHoldingFlag\" class=\"test-tooltip bgColorMenu8\" aria-label=\"Flags 8\">E\n<md-tooltip md-direction=\"top\">External Holding Flag</md-tooltip></md-button><md-button \nng-show=\"customerMapped.monitoringFlags.reversalFlag\" class=\"test-tooltip bgColorMenu9\" aria-label=\"Flags 9\">R\n<md-tooltip md-direction=\"top\">Reversal Flag</md-tooltip></md-button><md-button \nng-show=\"vm.role !== \'SUPER::ADMIN\' && customerMapped.monitoringFlags.assignedFlag\" class=\"test-tooltip bgColorMenu10\" \naria-label=\"Flags 10\">A<md-tooltip md-direction=\"top\">Assigned Flag</md-tooltip></md-button><md-button \nng-show=\"customerMapped.monitoringFlags.reviewPendingFlag\" class=\"test-tooltip bgColorMenu11\" aria-label=\"Flags 11\">C\n<md-tooltip md-direction=\"top\">Review Pending Flag</md-tooltip></md-button><md-button \nng-show=\"customer.monitoringFlags.iinActiveFlag\" ng-click=\"vm.flagActivityDialog($event,customer,\'iinActiveFlag\')\" \nclass=\"test-tooltip bgColorMenu12\" aria-label=\"Flags 12\">IA<md-tooltip md-direction=\"top\">IIN Active Flag</md-tooltip>\n</md-button><md-button ng-show=\"customer.monitoringFlags.fatcakycuboRegFlag\" \nng-click=\"vm.flagActivityDialog($event,customer,\'fatcakycuboRegFlag\')\" class=\"test-tooltip bgColorMenu13\" \naria-label=\"Flags 13\">FK<md-tooltip md-direction=\"top\">Fatca KYC Flag</md-tooltip></md-button><md-button \nng-show=\"customer.monitoringFlags.achmandateRegFlag\" \nng-click=\"vm.flagActivityDialog($event,customer,\'achmandateRegFlag\')\" class=\"test-tooltip bgColorMenu14\" \naria-label=\"Flags 14\">AM<md-tooltip md-direction=\"top\">ACH Mandate Flag</md-tooltip></md-button></div></div></div></td>\n<td md-cell><span ng-if=\"customerMapped.nseData && customerMapped.nseData.INVESTOR_NAME\">\n{{(customerMapped.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customerMapped.nseData && customerMapped.nseData.INVESTOR_NAME)\">\n{{(customerMapped.userName) ? (customerMapped.userName) :\'NA\'}}</span></td><td md-cell>{{customerMapped.mobileNo}}</td>\n<td md-cell>{{customerMapped.email}}</td><td md-cell>{{customerMapped.iin}}</td><td md-cell><md-button type=\"button\" \nclass=\"md-raised md-accent\" ng-click=\"vm.deassignedMappedCustomer(customerMapped, $index, $event)\" \nstyle=\"text-transform: capitalize; color:#fff !important\">Deassigned</md-button></td></tr></tbody></table>\n</md-table-container></md-virtual-repeat-container></div></md-content></div></div></div>");
$templateCache.put("app/main/insurance/quotation/quotation.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Quotations</span></div></div></div><br>\n<div class=\"header md-accent-bg height-30\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>HDFC Life</span></div></div></div><div><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\">\n<form name=\"wizardStep1\" class=\"md-inline-form\"><div layout=\"row\"><table id=\"customers\" class=\"table table-hover\"><tr>\n<td style=\"width: 25%; text-align: center\" scope=\"col\"><a class=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://onlineinsurance.hdfclife.com/buy-online-savings-plans/sanchay-savings-plan?source=sanchay&agentcode=01042825&journey=sh\" \ntarget=\"_blank\">HDFC Life Sanchay</a></td><td style=\"width: 25%; text-align: center\" scope=\"col\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://onlineinsurance.hdfclife.com/buy-online-savings-plans/sanchaypar-savings-plan?source=sanchay_par&agentcode=01042825&journey=sh\" \ntarget=\"_blank\">HDFC Life Sanchay Par</a></td><td style=\"width: 25%; text-align: center\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://onlineinsurance.hdfclife.com/HLifeWeb-OPS/portal.do?_pageid=ops_prodPage&_portalid=opsABnr&categcd=SVNG&prodcd=SANCHPE&source=sanchay_plus&agentcode=01042825&journey=sh\" \ntarget=\"_blank\">HDFC Life Sanchay Plus</a></td><td style=\"width: 25%; text-align: center\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://onlineinsurance.hdfclife.com/buy-online-term-insurance-plans/click-2-protect-life/basic-details?source=c2pl&agentcode=01042825&language=en\" \ntarget=\"_blank\">HDFC Life C2PL</a></td></tr></table></div></form></div></div></md-card></div><br><div \nclass=\"header md-accent-bg height-30\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>ICICI Life</span></div></div></div><div><md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\">\n<form name=\"wizardStep1\" class=\"md-inline-form\"><div layout=\"row\"><table id=\"customers\" class=\"table table-hover\"><tr>\n<td style=\"width: 25%; text-align: center\" scope=\"col\"><a class=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://buy.iciciprulife.com/buy/EBI.htm?UID=36715#/PreEBI/E28\" target=\"_blank\">\nICICI Pru Guaranteed Income for Tomorrow(GIFT)</a></td><td style=\"width: 25%; text-align: center\" scope=\"col\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://buy.iciciprulife.com/buy/EBI.htm?UID=36715#/PreEBI/E26\" target=\"_blank\">\nICICI Pru Lakshya Life Long Income</a></td><td style=\"width: 25%; text-align: center\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://buy.iciciprulife.com/buy/EBI.htm?UID=36715#/PreEBI/E25\" target=\"_blank\">ICICI Pru Lakshya Wealth</a></td>\n<td style=\"width: 25%; text-align: center\"><a class=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://buy.iciciprulife.com/buy/EBI.htm?UID=36715#/PreEBI/T50\" target=\"_blank\">ICICI Pru I-Protect Smart</a>\n</td></tr></table></div></form></div></div></md-card></div><br><div class=\"header md-accent-bg height-30\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Kotak General Insurance</span></div></div></div><div>\n<md-card class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-12\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\"><div layout=\"row\"><table id=\"customers\" class=\"table table-hover\"><tr><td \nstyle=\"width: 50%; text-align: center\" scope=\"col\"><a class=\"md-raised md-primary md-button md-ink-ripple\" \nhref=\"https://kgipass.kotakgeneralinsurance.com/KGIPASS/FrmSecuredLogin.aspx\" target=\"_blank\">Kotak GI - Quotation Only\n</a></td><td style=\"width: 50%; text-align: center\" scope=\"col\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" href=\"https://www.kotakgeneralinsurance.com/\" target=\"_blank\">\nKotak GI - For Payment</a></td></tr></table></div></form></div></div></md-card></div><br><div \nclass=\"header md-accent-bg height-30\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>Digit Insurance</span></div></div></div><div><md-card class=\"container-fluid\"><div class=\"row\"><div \nclass=\"col-sm-12\"><form name=\"wizardStep1\" class=\"md-inline-form\"><div layout=\"row\"><table id=\"customers\" \nclass=\"table table-hover\"><tr><td style=\"width: 10%\" scope=\"col\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" href=\"https://plus.godigit.com/DigitPlus/#/login\" target=\"_blank\">\nDigit General Insurance</a></td></tr></table></div></form></div></div></md-card></div><br><div \nclass=\"header md-accent-bg height-30\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>HDFCERGO General Insurance</span></div></div></div><div><md-card class=\"container-fluid\"><div class=\"row\"><div \nclass=\"col-sm-12\"><form name=\"wizardStep1\" class=\"md-inline-form\"><div layout=\"row\"><table id=\"customers\" \nclass=\"table table-hover\"><tr><td style=\"width: 10%\" scope=\"col\"><a \nclass=\"md-raised md-primary md-button md-ink-ripple\" href=\"https://pie.hdfcergo.com/\" target=\"_blank\">\nHDFC ERGO General Insurance</a></td></tr></table></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/products/products-list/products-list.html","<div id=\"productsList\"><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex=\"75\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\n{{vm.product_amc}}</span></div><div class=\"product-count secondary-text margin-top-10\"><span \nng-if=\"vm.selectedIndex === 0\">Total Active Schemes: {{vm.activeData.length}}</span> <span \nng-if=\"vm.selectedIndex === 1\">Total Inactive Schemes: {{vm.inactiveData.length}}</span> <span \nng-if=\"vm.selectedIndex === 2\">Total Active NFO: {{vm.activeNFO.length}}</span> <span ng-if=\"vm.selectedIndex === 3\">\nTotal Inactive NFO: {{vm.inActiveNFO.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex=\"25\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" ui-sref=\"app.products\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back\n</span></md-button></div></div><div class=\"headerFixAllPages\"><md-content><md-button class=\"md-raised md-accent sync\" \nng-disabled=\"vm.disableBtn\" ng-click=\"vm.startSyncing()\">Sync Scheme</md-button><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"vm.selectedIndex\" class=\"border-0\"><md-tab label=\"Active Schemes\" \nng-click=\"vm.getAllScheme(\'ACTIVE\')\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container>\n<table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th \nmd-column><span>Edit</span></th><th md-column md-order-by=\"productName\"><span>Scheme Name</span></th><th md-column \nmd-order-by=\"productISIN\"><span>ISIN</span></th><th md-column md-order-by=\"productDisplayName\"><span>Display Name\n</span></th><th md-column md-order-by=\"productMSCategory\"><span>MS Category</span></th><th md-column \nmd-order-by=\"productDisplayCategory\"><span>Display category</span></th><th md-column md-order-by=\"productCategory\">\n<span>OE/CE</span></th><th md-column md-order-by=\"minimumSIPAmount\"><span>Min. SIP</span></th><th md-column \nmd-order-by=\"minimumLumpsumAmount\"><span>Min. Lump</span></th></tr></thead><tbody md-body><div class=\"scrollable\" \nms-scroll><tr md-row md-select=\"item\" md-auto-select class=\"cursorPointer\" \nng-repeat=\"item in vm.activeData | filter:search | orderBy: vm.query.order\"><td md-cell><md-icon \nmd-font-icon=\"icon-tooltip-edit\" ng-click=\"vm.editAmcSideNav(); vm.getSchemeDetails(item);\"></md-icon></td><td md-cell>\n{{item.productName || \'NA\'}}</td><td md-cell>{{item.productISIN || \'NA\'}}</td><td md-cell>\n{{item.productDisplayName || \'NA\'}}</td><td md-cell>{{item.productMSCategory || \'NA\'}}</td><td md-cell>\n{{item.productDisplayCategory || \'NA\'}}</td><td md-cell>{{item.productCategory || \'NA\'}}</td><td md-cell>\n{{item.minimumSIPAmount || \'NA\'}}</td><td md-cell>{{item.minimumLumpsumAmount || \'NA\'}}</td></tr></div></tbody></table>\n</md-table-container></md-virtual-repeat-container></md-tab><md-tab label=\"Inactive Schemes\" \nng-click=\"vm.getAllScheme(\'IN_ACTIVE\')\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container>\n<table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th \nmd-column><span>Edit</span></th><th md-column md-order-by=\"productName\"><span>Scheme Name</span></th><th md-column \nmd-order-by=\"productISIN\"><span>ISIN</span></th><th md-column md-order-by=\"productDisplayName\"><span>Display Name\n</span></th><th md-column md-order-by=\"productMSCategory\"><span>MS Category</span></th><th md-column \nmd-order-by=\"productDisplayCategory\"><span>Display category</span></th><th md-column md-order-by=\"productCategory\">\n<span>OE/CE</span></th><th md-column md-order-by=\"minimumSIPAmount\"><span>Min. SIP</span></th><th md-column \nmd-order-by=\"minimumLumpsumAmount\"><span>Min. Lump</span></th></tr></thead><tbody md-body><div class=\"scrollable\" \nms-scroll><tr md-row md-select=\"item\" md-auto-select class=\"cursorPointer\" \nng-repeat=\"item in vm.inactiveData  | filter:search | orderBy: vm.query.order\"><td md-cell><md-icon \nmd-font-icon=\"icon-tooltip-edit\" ng-click=\"vm.editAmcSideNav(); vm.getSchemeDetails(item);\"></md-icon></td><td md-cell>\n{{item.productName || \'NA\'}}</td><td md-cell>{{item.productISIN || \'NA\'}}</td><td md-cell>\n{{item.productDisplayName || \'NA\'}}</td><td md-cell>{{item.productMSCategory || \'NA\'}}</td><td md-cell>\n{{item.productDisplayCategory || \'NA\'}}</td><td md-cell>{{item.productCategory || \'NA\'}}</td><td md-cell>\n{{item.minimumSIPAmount || \'NA\'}}</td><td md-cell>{{item.minimumLumpsumAmount || \'NA\'}}</td></tr></div></tbody></table>\n</md-table-container></md-virtual-repeat-container></md-tab><md-tab label=\"Active NFO\" \nng-click=\"vm.getAllScheme(\'ACTIVE_NFO\')\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>Edit</span></th><th md-column md-order-by=\"productName\"><span>\nScheme Name</span></th><th md-column md-order-by=\"productISIN\"><span>ISIN</span></th><th md-column \nmd-order-by=\"productDisplayName\"><span>Display Name</span></th><th md-column md-order-by=\"productMSCategory\"><span>\nMS Category</span></th><th md-column md-order-by=\"productDisplayCategory\"><span>Display category</span></th><th \nmd-column md-order-by=\"productCategory\"><span>OE/CE</span></th><th md-column md-order-by=\"minimumSIPAmount\"><span>\nMin. SIP</span></th><th md-column md-order-by=\"minimumLumpsumAmount\"><span>Min. Lump</span></th><th md-column \nmd-order-by=\"nfoCloseDate\"><span>Closing On</span></th></tr></thead><tbody md-body><div class=\"scrollable\" ms-scroll>\n<tr md-row md-select=\"item\" md-auto-select class=\"cursorPointer\" \nng-repeat=\"item in vm.activeNFO | filter:search | orderBy: vm.query.order\"><td md-cell><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Edit\" \nng-click=\"vm.editAmcSideNav(); vm.getSchemeDetails(item);\">Edit</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Activated\" ng-click=\"vm.closeNFODialog(item)\">Close NFO</md-button></md-menu-item></md-menu-content>\n</md-menu></td><td md-cell>{{item.productName || \'NA\'}}</td><td md-cell>{{item.productISIN || \'NA\'}}</td><td md-cell>\n{{item.productDisplayName || \'NA\'}}</td><td md-cell>{{item.productMSCategory || \'NA\'}}</td><td md-cell>\n{{item.productDisplayCategory || \'NA\'}}</td><td md-cell>{{item.productCategory || \'NA\'}}</td><td md-cell>\n{{item.minimumSIPAmount || \'NA\'}}</td><td md-cell>{{item.minimumLumpsumAmount || \'NA\'}}</td><td md-cell>\n{{item.nfoCloseDate | date:\'mediumDate\'}}</td></tr></div></tbody></table></md-table-container>\n</md-virtual-repeat-container></md-tab><md-tab label=\"Closed NFO\" ng-click=\"vm.getAllScheme(\'IN_ACTIVE_NFO\')\">\n<md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" \nmd-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>Edit</span></th><th \nmd-column md-order-by=\"productName\"><span>Scheme Name</span></th><th md-column md-order-by=\"productISIN\"><span>ISIN\n</span></th><th md-column md-order-by=\"productDisplayName\"><span>Display Name</span></th><th md-column \nmd-order-by=\"productMSCategory\"><span>MS Category</span></th><th md-column md-order-by=\"productDisplayCategory\"><span>\nDisplay category</span></th><th md-column md-order-by=\"productCategory\"><span>OE/CE</span></th><th md-column \nmd-order-by=\"minimumSIPAmount\"><span>Min. SIP</span></th><th md-column md-order-by=\"minimumLumpsumAmount\"><span>\nMin. Lump</span></th><th md-column md-order-by=\"nfoCloseDate\"><span>Closed On</span></th></tr></thead><tbody md-body>\n<div class=\"scrollable\" ms-scroll><tr md-row md-select=\"item\" md-auto-select class=\"cursorPointer\" \nmd-virtual-repeat=\"item in vm.inActiveNFO  | filter:search | orderBy: vm.query.order\"><td md-cell><md-icon \nmd-font-icon=\"icon-tooltip-edit\" ng-click=\"vm.editAmcSideNav(); vm.getSchemeDetails(item);\"></md-icon></td><td md-cell>\n{{item.productName || \'NA\'}}</td><td md-cell>{{item.productISIN || \'NA\'}}</td><td md-cell>\n{{item.productDisplayName || \'NA\'}}</td><td md-cell>{{item.productMSCategory || \'NA\'}}</td><td md-cell>\n{{item.productDisplayCategory || \'NA\'}}</td><td md-cell>{{item.productCategory || \'NA\'}}</td><td md-cell>\n{{item.minimumSIPAmount || \'NA\'}}</td><td md-cell>{{item.minimumLumpsumAmount || \'NA\'}}</td><td md-cell>\n{{item.nfoCloseDate | date:\'mediumDate\'}}</td></tr></div></tbody></table></md-table-container>\n</md-virtual-repeat-container></md-tab></md-tabs></md-content><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"closeEventsDisabled\" md-whiteframe=\"4\" md-disable-close-events><md-toolbar class=\"md-theme-indigo\">\n<div layout=\"row\" layout-align=\"space-between\" class=\"height-product-edit\"><div layout=\"column\" \nlayout-align=\"start start\"><h3 class=\"fontSet\">Scheme Details</h3></div><div layout=\"row\" layout-align=\"start center\" \nflex-60><md-icon md-font-icon=\"icon-window-close\" ng-click=\"vm.editAmcSideNav()\" class=\"icon-static cursorPointer\">\n</md-icon></div></div></md-toolbar><md-content layout-margin><form name=\"schemeForm\" layout=\"column\"><div layout=\"row\" \nflex=\"100\"><div flex=\"30\" layout-align=\"center center\"><img \nsrc=\"./../../../../assets/images/backgrounds/documentPlaceholder.png\" alt=\"\"></div><div flex=\"70\" class=\"pl-10\"><h4>\n{{vm.product.productName}}</h4><h5 class=\"isin\">ISIN: <input type=\"text\" ng-model=\"vm.product.productISIN\" \nclass=\"isin\" ng-class=\"{\'focus\':!vm.updateISIN}\" ng-disabled=\"vm.updateISIN\"><md-icon md-font-icon=\"icon-pencil\" \nng-click=\"vm.enableEditISIN()\" style=\"cursor:pointer\"></md-icon></h5><h5>Type: {{vm.product.productCategory || \'NA\'}}\n</h5><h5>Morning Star Category: NA</h5></div></div><div class=\"mt-25\" layout=\"row\" layout-align=\"space-between\"><div \nclass=\"toggle toggle--switch\" flex=\"25\"><input type=\"checkbox\" id=\"toggle--switch\" ng-model=\"vm.product.active\" \nng-change=\"vm.activeSchem(vm.product.active)\" class=\"toggle--checkbox\"><label class=\"toggle--btn\" for=\"toggle--switch\">\n<span class=\"toggle--feature\" data-label-on=\"Active\" data-label-off=\"Inactive\"></span></label></div></div><div \nflex=\"100\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"vm.product.productCategory === \'CE\'\"><md-switch \nng-model=\"vm.product.NFO\" aria-label=\"NFO\" class=\"margin-5\">Is NFO ? {{ vm.product.NFO ? \'Yes\':\'No\' }}</md-switch><div \nflex-gt-xs layout=\"row\" class=\"ml-25\" ng-show=\"vm.product.NFO\"><h5>Close Date</h5><md-datepicker \nng-model=\"vm.product.nfoCloseDate\" md-placeholder=\"Enter date\" ng-required=\"vm.product.NFO\"></md-datepicker></div>\n</div><div layout=\"row\" class=\"mt-25\"><md-input-container flex=\"80\" ng-show=\"!vm.toggleCat\"><label>Display Category\n</label><md-select ng-model=\"vm.product.productDisplayCategory\"><md-option ng-repeat=\"category in vm.displayCategory\" \nng-value=\"category.category\">{{category.category}}</md-option></md-select></md-input-container><md-input-container \nflex=\"80\" ng-show=\"vm.toggleCat\"><label>Enter New Display Sub Category</label><input name=\"productDisplayCategory\" \nng-model=\"vm.product.productDisplayCategory\" tabindex=\"4\"></md-input-container><div><md-button \nclass=\"md-raised w-50 md-primary\" aria-label=\"More\" \nng-click=\"vm.toggleCat = !vm.toggleCat;vm.product.productDisplayCategory = null;\"><md-icon \nmd-font-icon=\"{{!vm.toggleCat ? \'icon-plus\':\'icon-minus\'}}\"></md-icon></md-button></div></div><div layout=\"row\">\n<md-input-container flex=\"80\" ng-show=\"!vm.toggleSubCate\"><label>Display Sub Category</label><md-select \nng-model=\"vm.product.productDisplaySubCategory\"><md-option ng-repeat=\"subCategory in vm.displaySubCategory\" \nng-value=\"subCategory.subCategory\">{{subCategory.subCategory}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"80\" ng-show=\"vm.toggleSubCate\"><label>Enter New Display Sub Category</label><input \nname=\"productDisplaySubCategory\" ng-model=\"vm.product.productDisplaySubCategory\" tabindex=\"4\"></md-input-container>\n<div><md-button class=\"md-raised w-50 md-primary\" aria-label=\"More\" \nng-click=\"vm.toggleSubCate = !vm.toggleSubCate;vm.product.productDisplaySubCategory = null;\"><md-icon \nmd-font-icon=\"{{!vm.toggleSubCate ? \'icon-plus\':\'icon-minus\'}}\"></md-icon></md-button></div></div><md-input-container \nclass=\"md-block margin-bottom-zero\"><label>Display Name</label><textarea rows=\"2\" type=\"text\" \nname=\"productDisplayName\" ng-model=\"vm.product.productDisplayName\" tabindex=\"1\"></textarea></md-input-container>\n<md-input-container class=\"md-block margin-bottom-zero\"><label>Mininum SIP Amount</label><input type=\"number\" \nname=\"minimumSIPAmount\" ng-model=\"vm.product.minimumSIPAmount\" tabindex=\"4\"></md-input-container><md-input-container \nclass=\"md-block margin-bottom-zero\"><label>Mininum Lumpsum Amount</label><input type=\"number\" name=\"minLumpsumAmt\" \nng-model=\"vm.product.minimumLumpsumAmount\" tabindex=\"4\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-primary textTransform\" ng-click=\"vm.updateSchme()\" tabindex=\"5\">SAVE</md-button></form>\n</md-content></md-sidenav></div></div></div>");
$templateCache.put("app/main/other-transaction/sip-trxn-validate-list/sip-txrn-validate-list.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"75\">\n<div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span style=\"font-size:18px\">\nValidate Investor List</span></div><div class=\"product-count secondary-text margin-top-10\"><span>Total Scheme:</span> \n<span>{{vm.schemes.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"15\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" \ntype=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" layout-align=\"start center\" flex=\"10\">\n<md-button class=\"backArrowColor\" back-button layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div><div \nclass=\"headerFixAllPages\"><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head \nmd-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th md-column md-order-by=\"investor_name\">\n<span class=\"text-center\">Investor Name</span></th><th md-column md-order-by=\"customer_id\"><span class=\"text-center\">\nIIN No.</span></th><th md-column md-order-by=\"source_scheme\"><span>Source Scheme</span></th><th md-column \nmd-order-by=\"amc_name\"><span>AMC Name</span></th><th md-column md-order-by=\"auto_txrn_no\"><span>Auto Txrn No.</span>\n</th><th md-column md-order-by=\"folio_number\"><span>Folio No.</span></th><th md-column md-order-by=\"lineNumber\"><span>\nLine No.</span></th><th md-column md-order-by=\"error\"><span>Remarks</span></th></tr></thead><tbody md-body><div \nclass=\"scrollable\" ms-scroll><tr md-auto-select \nmd-virtual-repeat=\"scheme in vm.schemes | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\"><td md-cell>\n{{$index+1}}</td><td md-cell>{{scheme.investor_name}}</td><td md-cell>{{scheme.customer_id}}</td><td md-cell>\n{{scheme.source_scheme}}</td><td md-cell>{{scheme.amc_name}}</td><td md-cell>{{scheme.auto_txrn_no}}</td><td md-cell>\n{{scheme.folio_number}}</td><td md-cell>{{scheme.lineNumber}}</td><td md-cell>{{scheme.error}}</td></tr></div></tbody>\n</table></md-table-container></md-virtual-repeat-container></div></div></div>");
$templateCache.put("app/main/pushNotification/pushMsgNotification/pushMsgNotifaction.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" flow-init flow-name=\"imageFile.flowObj\" \nflow-files-added=\"processFile($files)\" id=\"pushNotify\"><div class=\"header md-accent-bg height-60\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"70\" \nng-hide=\"vm.selectedCustomer.length > 0\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>Push Notification</span></div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"70\" \nng-show=\"vm.selectedCustomer.length > 0\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span>Push Notification</span></div><div class=\"product-count secondary-text margin-top-10\"><span>Total Customers:\n</span> <span>{{vm.selectedCustomer.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nng-model=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div></div><div \nclass=\"headerFixAllPages\"><md-content class=\"bgCustomHeader\" layout-gt-sm=\"row\"><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 6}\" \nng-click=\"vm.customerCount(6,\'All Customer\')\" label=\"All Customer\">All Customer</md-button><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 1}\" \nng-click=\"vm.customerCount(1,\'Activated IIN\')\" label=\"Activated IIN\">Activated IIN</md-button><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 2}\" \nng-click=\"vm.customerCount(2,\'Not Active\')\" label=\"Not Active\">Not Active</md-button><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 3}\" \nng-click=\"vm.customerCount(3,\'No IIN\')\" label=\"No IIN\">No IIN</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 4}\" \nng-click=\"vm.customerCount(4,\'IIN Active But Zero Investment\')\" label=\"IIN Active But Zero Investment\">\nIIN Active But Zero Investment</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag=== 5}\" ng-click=\"vm.customerCount(5,\'SIP Purchased\')\" \nlabel=\"SIP Purchased\">SIP Purchased</md-button><md-button class=\"md-raised textTransform\" label=\"Custom\" \nng-class=\"{\'selectCustomerColor\':vm.selectedFlag === 7}\" ui-sref=\"app.pushNotificationList.pushNotificationMsg\">Custom\n</md-button></md-content><div class=\"padding-10\" layout=\"row\" layout-align=\"space-between\"><div flex=\"50\" \nclass=\"white-bg md-whiteframe-4dp\" layout-padding><div ng-cloak><md-content><form name=\"pushNotification\" novalidate>\n<div layout=\"row\"><md-input-container flex=\"100\" class=\"margin-top-20\"><label>Description</label><textarea type=\"text\" \nname=\"description\" ng-model=\"vm.description\" md-maxlength=\"300\" rows=\"1\" required></textarea><div \nng-messages=\"pushNotification.description.$error\" ng-show=\"pushNotification.description.$dirty\"><div \nng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">That\'s too long!</div></div>\n</md-input-container></div></form></md-content></div></div><div flex=\"50\" class=\"white-bg md-whiteframe-4dp\" \nlayout-padding><div ng-cloak><md-content><h4>Image Upload</h4><form name=\"pushNotification\" novalidate><div \nlayout=\"row\" layout-align=\"center center\" padding-wrap><md-input-container><md-button \nclass=\"md-raised md-accent width-180\" ng-click=\"$flow.cancel()\" flow-btn style=\"color:#fff !important\">Upload Image\n</md-button></md-input-container></div></form></md-content></div></div></div><div class=\"padding-10\" layout=\"row\" \nlayout-align=\"space-between\"><div flex=\"50\" class=\"white-bg md-whiteframe-4dp\" layout-padding><div ng-cloak><md-content\n layout-padding><h4 class=\"no-margin\">Preview</h4><div ng-show=\"vm.responseImage\" \nclass=\"margin-bottom-15 objectParentBlog\"><img class=\"objectFitBlog\" src=\"{{vm.responseImage}}\"></div><h5><b>Sipfund\n</b></h5><p style=\"word-break:break-all\">{{vm.description}}</p></md-content></div></div><div flex=\"50\" \nclass=\"white-bg md-whiteframe-4dp\" layout=\"row\" layout-align=\"center center\" layout-padding><div ng-cloak><md-content \nlayout-padding><section layout=\"row\" layout-align=\"center center\" padding-wrap><md-button class=\"md-raised md-accent\" \nng-click=\"vm.pushNotificationSubmit()\" style=\"color:#fff !important\">Send To {{vm.selectedFilter}} Customer</md-button>\n</section></md-content></div></div></div><div ng-show=\"vm.selectedCustomer.length > 0\" layout-padding><div \nclass=\"white-bg md-whiteframe-4dp\"><h4 class=\"heading-alignment\">Selected Customer</h4><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>S.No.</span></th><th md-column md-order-by=\"userName\">\n<span>Name</span></th><th md-column md-order-by=\"mobileNo\"><span>Contact</span></th><th md-column md-order-by=\"email\">\n<span>Email Id</span></th><th md-column md-order-by=\"pan\"><span>PAN</span></th><th md-column md-order-by=\"iin\"><span>\nIIN</span></th><th md-column><span>Action</span></th></tr></thead><tbody md-body><tr md-row md-select=\"item\" \nmd-auto-select md-virtual-repeat=\"customer in vm.selectedCustomer | filter:search | orderBy: vm.query.order\" \nstyle=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell><span \nng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">{{(customer.nseData.INVESTOR_NAME)}}</span> <span \nng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">{{(customer.userName) ? (customer.userName) :\'NA\'}}\n</span></td><td md-cell>{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>\n{{(customer.email) ? (customer.email):\'NA\'}}</td><td md-cell>{{(customer.pan) ? (customer.pan) :\'NA\'}}</td><td md-cell>\n{{(customer.iin) ? (customer.iin):\'NA\'}}</td><td md-cell><md-icon md-font-icon=\"icon-delete\" \nng-click=\"vm.deleteUser($index)\" class=\"s20\"></md-icon></td></tr></tbody></table></md-table-container>\n</md-virtual-repeat-container></div></div></div></div>");
$templateCache.put("app/main/referral/configuration/configuration.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Referral - Configuration</span></div>\n</div><label class=\"switch switch-green headerSwitchBack\"><input type=\"checkbox\" class=\"switch-input\" \nng-model=\"vm.referralConfig.active\" ng-change=\"vm.setReferralConfig()\"> <span class=\"switch-label\" data-on=\"ON\" \ndata-off=\"OFF\"></span> <span class=\"switch-handle\"></span></label></div><div class=\"headerFixAllPages\"><md-content \nlayout-padding><div class=\"card md-whiteframe-4dp\" ng-class=\"{\'disabled\': !vm.referralConfig.active}\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-warn\" ng-hide=\"vm.saveMode\" \nng-click=\"vm.saveMode = !vm.saveMode\">EDIT</md-button><md-button class=\"md-raised md-warn\" ng-show=\"vm.saveMode\" \nng-click=\"vm.setReferralConfig()\">SAVE</md-button></div><div layout=\"row\" flex=\"100\" layout-padding \nng-class=\"{\'disabled\': !vm.saveMode}\"><div layout=\"column\" flex=\"50\"><span class=\"text-top\">Condition Of Redemption\n</span><md-input-container flex=\"50\"><md-select ng-model=\"vm.referralConfig.redemptionConditions\" required><md-option \nng-repeat=\"item in vm.redemptionConditionKey\" ng-value=\"item.key\">{{item.value}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"50\"><span class=\"text-top\">Condition Of Referral Sharing</span>\n<md-input-container flex=\"50\"><md-select ng-model=\"vm.referralConfig.referralConditions\" required><md-option \nng-repeat=\"item in vm.referralConditionKey\" ng-value=\"item.key\">{{item.value}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"50\" layout-padding ng-class=\"{\'disabled\': !vm.saveMode}\" \nng-if=\"vm.referralConfig.redemptionConditions !== \'NO:CONDITION\'\"><div layout=\"column\" flex=\"50\"><label \nclass=\"labelPosition\">Minimum SIP Amount&#8377;</label><md-input-container class=\"margin-bottom-0\"><input \ntype=\"number\" class=\"margin-bottom-0\" ng-model=\"vm.referralConfig.minimumSipAmount\"></md-input-container></div><div \nlayout=\"column\" flex=\"50\"><label class=\"labelPosition\">Minimum Lumpsum Amount&#8377;</label><md-input-container \nclass=\"margin-bottom-0\"><input type=\"number\" class=\"margin-bottom-0\" ng-model=\"vm.referralConfig.minimumLumpsumAmount\">\n</md-input-container></div></div><div layout=\"column\" layout-padding ng-class=\"{\'disabled\': !vm.saveMode}\"><h4 \nclass=\"margin-0\"><label class=\"switch switch-green\"><input type=\"checkbox\" class=\"switch-input\" \nng-model=\"vm.referralConfig.signUp.active\"> <span class=\"switch-label\" \nng-class=\"{\'greyback\': !vm.referralConfig.active}\" data-on=\"ON\" data-off=\"OFF\"></span> <span class=\"switch-handle\">\n</span> <span class=\"textClass\">Benefits on Sign Up</span></label></h4><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-around center\"><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label \nclass=\"labelPosition\" for=\"signup\">Referral will get &#8377;</label><md-input-container class=\"margin-bottom-0\"><input \ntype=\"number\" class=\"margin-bottom-0\" ng-model=\"vm.referralConfig.signUp.rfdAmount\" id=\"signup\"></md-input-container>\n</div><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label class=\"labelPosition\" for=\"signupR\">\nReferrer will get &#8377;</label><md-input-container class=\"margin-bottom-0\"><input type=\"number\" \nclass=\"margin-bottom-0\" ng-model=\"vm.referralConfig.signUp.rfyAmount\" id=\"signupR\"></md-input-container></div></div>\n</div><div layout=\"column\" layout-padding ng-class=\"{\'disabled\': !vm.saveMode}\"><h4 class=\"margin-0\"><label \nclass=\"switch switch-green\"><input type=\"checkbox\" class=\"switch-input\" ng-model=\"vm.referralConfig.createdIIN.active\">\n <span class=\"switch-label\" ng-class=\"{\'greyback\': !vm.referralConfig.active}\" data-on=\"ON\" data-off=\"OFF\"></span> \n<span class=\"switch-handle\"></span> <span class=\"textClass\">Benefits on IIN Creation</span></label></h4><div \nlayout=\"row\" flex=\"100\" layout-align=\"space-around center\"><div layout=\"row\" flex=\"50\" layout-align=\"start center\">\n<label class=\"labelPosition\" for=\"iincreate\">Referral will get &#8377;</label><md-input-container \nclass=\"margin-bottom-0\"><input type=\"number\" class=\"margin-bottom-0\" ng-model=\"vm.referralConfig.createdIIN.rfdAmount\" \nid=\"iincreate\"></md-input-container></div><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label \nclass=\"labelPosition\" for=\"iincreateR\">Referrer will get &#8377;</label><md-input-container class=\"margin-bottom-0\">\n<input type=\"number\" class=\"margin-bottom-0\" ng-model=\"vm.referralConfig.createdIIN.rfyAmount\" id=\"iincreateR\">\n</md-input-container></div></div></div><div layout=\"column\" layout-padding ng-class=\"{\'disabled\': !vm.saveMode}\"><h4 \nclass=\"margin-0\"><label class=\"switch switch-green\"><input type=\"checkbox\" class=\"switch-input\" \nng-model=\"vm.referralConfig.activeIIN.active\"> <span class=\"switch-label\" \nng-class=\"{\'greyback\': !vm.referralConfig.active}\" data-on=\"ON\" data-off=\"OFF\"></span> <span class=\"switch-handle\">\n</span> <span class=\"textClass\">Benefits on IIN Activation</span></label></h4><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-around center\"><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label \nclass=\"labelPosition\" for=\"iinactivation\">Referral will get &#8377;</label><md-input-container class=\"margin-bottom-0\">\n<input type=\"number\" class=\"margin-bottom-0\" ng-model=\"vm.referralConfig.activeIIN.rfdAmount\" id=\"iinactivation\">\n</md-input-container></div><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label class=\"labelPosition\" \nfor=\"iinactivationR\">Referrer will get &#8377;</label><md-input-container class=\"margin-bottom-0\"><input type=\"number\" \nclass=\"margin-bottom-0\" ng-model=\"vm.referralConfig.activeIIN.rfyAmount\" id=\"iinactivationR\"></md-input-container>\n</div></div></div><div layout=\"column\" layout-padding ng-class=\"{\'disabled\': !vm.saveMode}\"><h4 class=\"margin-0\"><label\n class=\"switch switch-green\"><input type=\"checkbox\" class=\"switch-input\" \nng-model=\"vm.referralConfig.investment.active\"> <span class=\"switch-label\" \nng-class=\"{\'greyback\': !vm.referralConfig.active}\" data-on=\"ON\" data-off=\"OFF\"></span> <span class=\"switch-handle\">\n</span> <span class=\"textClass\">Benefits on 1st time Investment</span></label></h4><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-around center\"><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label \nclass=\"labelPosition\" for=\"invetsment\">Referral will get &#8377;</label><md-input-container class=\"margin-bottom-0\">\n<input type=\"number\" ng-model=\"vm.referralConfig.investment.rfdAmount\" class=\"margin-bottom-0\" id=\"invetsment\">\n</md-input-container></div><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label class=\"labelPosition\" \nfor=\"invetsmentR\">Referrer will get &#8377;</label><md-input-container class=\"margin-bottom-0\"><input type=\"number\" \nng-model=\"vm.referralConfig.investment.rfyAmount\" class=\"margin-bottom-0\" id=\"invetsmentR\"></md-input-container></div>\n</div></div></div></md-content></div></div><style>\nmd-input-container.md-default-theme .md-input,\r\n  md-input-container .md-input {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .success {\r\n    background-color: blueviolet;\r\n  }\r\n\r\n  .disabled {\r\n    pointer-events: none;\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .greyback {\r\n    background: grey !important;\r\n  }\n</style>");
$templateCache.put("app/main/referral/referral-detail/referral-detail.html","<div id=\"referralDetailPage\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nReferral Details : {{vm.referralData.users.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex-60><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><md-button \nclass=\"backArrowColor\" back-button layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor\" style=\"line-height:10px\"></md-icon><span style=\"line-height:-2%\">\nBack</span></md-button></div><div class=\"headerFixAllPages\"><md-content layout-padding><div layout=\"row\" class=\"\" \nlayout-align=\"space-around center\"><div class=\"h-100 md-whiteframe-8dp cursor draw\" \nng-click=\"vm.selectedFilter(\'UNPAID\')\" ng-class=\"{\'borderStyle\': vm.filterType === \'UNPAID\'}\" layout=\"column\" \nlayout-align=\"center center\" flex=\"20\"><h5>&#8377; {{vm.referralData.amountPending | number: \'2\'}}</h5><span>\nAmount Pending</span></div><div class=\"h-100 md-whiteframe-8dp cursor\" ng-click=\"vm.selectedFilter(\'PAID\')\" \nng-class=\"{\'borderStyle\': vm.filterType === \'PAID\'}\" layout=\"column\" layout-align=\"center center\" flex=\"20\"><h5>\n&#8377; {{vm.referralData.amountTransferred |number: 2}}</h5><span>Amount Transfered</span></div><div \nclass=\"h-100 md-whiteframe-8dp cursor\" ng-click=\"vm.selectedFilter(\'CANCEL\')\" \nng-class=\"{\'borderStyle\': vm.filterType === \'CANCEL\'}\" layout=\"column\" layout-align=\"center center\" flex=\"20\"><h5>\n&#8377; {{vm.referralData.amountCancelled | number:2}}</h5><span>Amount Cancled</span></div></div><div layout=\"row\" \nng-repeat=\"item in vm.allReferral  | filter:search\"><div class=\"border pl-8\" layout=\"column\" \nlayout-align=\"center start\" flex=\"20\" layout-apdding><h5>{{item.rfdName}}</h5><h6>Mob: {{item.rfdMobile}}</h6><h6>\nReferred By: {{item.rfyName}}</h6></div><div class=\"border\" layout=\"row\" flex=\"20\" layout-wrap><div flex=\"100\" \nclass=\"pt-6 pb-6 pl-8 pr-8\" ng-class=\"{sucessBack:item.signupFlag,\'pendingBack\': !item.signupFlag }\" layout=\"row\" \nlayout-align=\"space-between center\"><h5>Sign Up</h5><md-icon md-font-icon=\"icon-check\" ng-if=\"item.signupFlag\" \nclass=\"sucessTick s24 m-0\"></md-icon><md-icon md-font-icon=\"icon-alert-circle\" ng-if=\"!item.signupFlag\" \nclass=\"pendingText s24 m-0\"></md-icon></div><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"space-between\"><div \nflex=\"50\" layout-align=\"center start\" layout=\"column\"><h6>{{item.rfdName.substring(0,10)}}<md-tooltip>{{item.rfdName}}\n</md-tooltip></h6><h5>&#8377; {{item.rfdSignupAmount|number:2}}</h5><span \nng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\" ng-if=\"item.rfdSignupAmountStatus === \'PAID\'\">Paid</span> <span \nng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" ng-if=\"item.rfdSignupAmountStatus === \'UNPAID\'\">Pending</span> \n<span ng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" ng-if=\"item.rfdSignupAmountStatus === \'CANCEL\'\">Canceled\n</span> <span ng-if=\"!item.rfdSignupAmountStatus\">NA</span></div><div flex=\"50\" layout-align=\"center end\" \nlayout=\"column\"><h6>{{item.rfyName.substring(0,10)}}<md-tooltip>{{item.rfyName}}</md-tooltip></h6><h5>\n&#8377; {{item.rfySignupAmount|number:2}}</h5><span ng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\" \nng-if=\"item.rfySignupAmountStatus === \'PAID\'\">Paid</span> <span ng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" \nng-if=\"item.rfySignupAmountStatus === \'UNPAID\'\">Pending</span> <span \nng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" ng-if=\"item.rfySignupAmountStatus === \'CANCEL\'\">Canceled</span> \n<span ng-if=\"!item.rfySignupAmountStatus\">NA</span></div></div></div><div class=\"border\" layout=\"row\" flex=\"20\" \nlayout-wrap><div class=\"pt-6 pb-6 pl-8 pr-8\" \nng-class=\"{sucessBack:item.createIINFlag,\'pendingBack\': !item.createIINFlag }\" flex=\"100\" layout=\"row\" \nlayout-align=\"space-between center\"><h5>IIN</h5><md-icon md-font-icon=\"icon-check\" ng-if=\"item.createIINFlag\" \nclass=\"sucessTick s24 m-0\"></md-icon><md-icon md-font-icon=\"icon-alert-circle\" ng-if=\"!item.createIINFlag\" \nclass=\"pendingText s24 m-0\"></md-icon></div><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"space-between\"><div \nflex=\"50\" layout-align=\"center start\" layout=\"column\"><h6>{{item.rfdName.substring(0,10)}}<md-tooltip>{{item.rfdName}}\n</md-tooltip></h6><h5>&#8377; {{item.rfdIINAmount|number:2}}</h5><span \nng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\" ng-if=\"item.rfdIINAmountStatus === \'PAID\'\">Paid</span> <span \nng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" ng-if=\"item.rfdIINAmountStatus === \'UNPAID\'\">Pending</span> <span\n ng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" ng-if=\"item.rfdIINAmountStatus === \'CANCEL\'\">Canceled</span> <span \nng-if=\"!item.rfdIINAmountStatus\">NA</span></div><div flex=\"50\" layout-align=\"center end\" layout=\"column\"><h6>\n{{item.rfyName.substring(0,10)}}<md-tooltip>{{item.rfyName}}</md-tooltip></h6><h5>\n&#8377; {{item.rfyIINAmount|number:2}}</h5><span ng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\" \nng-if=\"item.rfyIINAmountStatus === \'PAID\'\">Paid</span> <span ng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" \nng-if=\"item.rfyIINAmountStatus === \'UNPAID\'\">Pending</span> <span ng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" \nng-if=\"item.rfyIINAmountStatus === \'CANCEL\'\">Canceled</span> <span ng-if=\"!item.rfyIINAmountStatus\">NA</span></div>\n</div></div><div class=\"border\" layout=\"row\" flex=\"20\" layout-wrap><div flex=\"100\" class=\"pt-6 pb-6 pl-8 pr-8\" \nng-class=\"{sucessBack:item.iinActiveFlag,\'pendingBack\': !item.iinActiveFlag }\" layout=\"row\" \nlayout-align=\"space-between center\"><h5>Activate</h5><md-icon md-font-icon=\"icon-check\" ng-if=\"item.iinActiveFlag\" \nclass=\"sucessTick s24 m-0\"></md-icon><md-icon md-font-icon=\"icon-alert-circle\" ng-if=\"!item.iinActiveFlag\" \nclass=\"pendingText s24 m-0\"></md-icon></div><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"space-between\"><div \nflex=\"50\" layout-align=\"center start\" layout=\"column\"><h6>{{item.rfdName.substring(0,10)}}<md-tooltip>{{item.rfdName}}\n</md-tooltip></h6><h5>&#8377; {{item.rfdActiveAmount|number:2}}</h5><span \nng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\" ng-if=\"item.rfdActiveAmountStatus === \'PAID\'\">Paid</span> <span \nng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" ng-if=\"item.rfdActiveAmountStatus === \'UNPAID\'\">Pending</span> \n<span ng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" ng-if=\"item.rfdActiveAmountStatus === \'CANCEL\'\">Canceled\n</span> <span ng-if=\"!item.rfdActiveAmountStatus\">NA</span></div><div flex=\"50\" layout-align=\"center end\" \nlayout=\"column\"><h6>{{item.rfyName.substring(0,10)}}<md-tooltip>{{item.rfyName}}</md-tooltip></h6><h5>\n&#8377; {{item.rfyActiveAmount|number:2}}</h5><span ng-if=\"item.rfyActiveAmountStatus === \'PAID\'\" \nng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\">Paid</span> <span \nng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" ng-if=\"item.rfyActiveAmountStatus === \'UNPAID\'\">Pending</span> \n<span ng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" ng-if=\"item.rfyActiveAmountStatus === \'CANCEL\'\">Canceled\n</span> <span ng-if=\"!item.rfyActiveAmountStatus\">NA</span></div></div></div><div class=\"border\" layout=\"row\" \nflex=\"20\" layout-wrap><div flex=\"100\" class=\"pt-6 pb-6 pl-8 pr-8\" \nng-class=\"{sucessBack:item.investmentFlag,\'pendingBack\': !item.investmentFlag }\" layout=\"row\" \nlayout-align=\"space-between center\"><h5>Investment</h5><md-icon md-font-icon=\"icon-check\" ng-if=\"item.investmentFlag\" \nclass=\"sucessTick s24 m-0\"></md-icon><md-icon md-font-icon=\"icon-alert-circle\" ng-if=\"!item.investmentFlag\" \nclass=\"pendingText s24 m-0\"></md-icon></div><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"space-between\"><div \nflex=\"50\" layout-align=\"center start\" layout=\"column\"><h6>{{item.rfdName.substring(0,10)}}<md-tooltip>{{item.rfdName}}\n</md-tooltip></h6><h5>&#8377; {{(item.rfdInvestAmount || 0)|number:2}}</h5><span \nng-if=\"item.rfdInvestAmountStatus === \'PAID\'\" ng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\">Paid</span> <span \nng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" ng-if=\"item.rfdInvestAmountStatus === \'UNPAID\'\">Pending</span> \n<span ng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" ng-if=\"item.rfdInvestAmountStatus === \'CANCEL\'\">Canceled\n</span> <span ng-if=\"!item.rfdInvestAmountStatus\">NA</span></div><div flex=\"50\" layout-align=\"center end\" \nlayout=\"column\"><h6>{{item.rfyName.substring(0,10)}}<md-tooltip>{{item.rfyName}}</md-tooltip></h6><h5>\n&#8377; {{(item.rfyInvestAmount || 0)|number:2}}</h5><span ng-if=\"item.rfyInvestAmountStatus === \'PAID\'\" \nng-class=\"{\'sucessText\':vm.filterType === \'PAID\'}\">Paid</span> <span \nng-class=\"{\'pendingText\':vm.filterType === \'UNPAID\'}\" ng-if=\"item.rfyInvestAmountStatus === \'UNPAID\'\">Pending</span> \n<span ng-class=\"{\'warnText\':vm.filterType === \'CANCEL\'}\" ng-if=\"item.rfyInvestAmountStatus === \'CANCEL\'\">Canceled\n</span> <span ng-if=\"!item.rfyInvestAmountStatus\">NA</span></div></div></div></div></md-content></div></div>");
$templateCache.put("app/main/referral/referral-transfers/referral-transfers.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Transfers</span></div></div><div \nlayout=\"row\" layout-align=\"start center\" flex=\"15\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.referraltransfers.amount.detail\" style=\"color:#fff !important\">Referral Detail</md-button></div></div><div\n class=\"headerFixAllPages\"><md-content><div layout=\"row\" layout-padding=\"16\" layout-wrap><div class=\"content\" \nflex=\"50\"><div layout=\"column\" class=\"card md-whiteframe-4dp\"><div class=\"ph-16 pv-8\" layout=\"column\" \nlayout-align=\"center center\" layout-wrap><div class=\"h3\">&#8377; {{vm.consilidatedReferralAmount.totalExpensesAmount}}\n</div><div class=\"h4\">Total Expense on Referral</div></div><md-divider></md-divider><div flex layout=\"row\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"ph-8 pv-32\"><div class=\"h4\">\n&#8377; {{vm.consilidatedReferralAmount.amountPending || 0}}</div><span class=\"no-select\">Amount Pending</span></div>\n<md-divider></md-divider><div flex layout=\"column\" layout-align=\"center center\" class=\"ph-8 pv-32\"><div class=\"h4\">\n&#8377; {{vm.consilidatedReferralAmount.amountTransferred || 0}}</div><span class=\"no-select\">Amount Transfered</span>\n</div><md-divider></md-divider><div flex layout=\"column\" layout-align=\"center center\" class=\"pv-32 ph-8\"><div \nclass=\"h4\">&#8377; {{vm.consilidatedReferralAmount.amountCancelled || 0}}</div><span class=\"no-select\">Amount Canceled\n</span></div></div></div></div><div class=\"content\" layout-align=\"center center\" flex=\"50\"><div layout=\"column\" \nclass=\"card md-whiteframe-4dp\" ng-click=\"vm.goToPendingReferral()\" style=\"cursor:pointer\"><div class=\"ph-16 pv-70\" \nlayout=\"column\" layout-align=\"center center\" layout-wrap><div class=\"h4\">\n{{vm.consilidatedReferralAmount.onRequestedPending.count}} Requests For Transfer</div><div class=\"h3\">\n&#8377; {{vm.consilidatedReferralAmount.onRequestedPending.amount}}</div></div></div><md-tooltip md-direction=\"bottom\">\nClick To Transfer Amount</md-tooltip></div></div><div layout=\"row\" layout-padding=\"16\" layout-wrap><div \nclass=\"content\" flex=\"50\"><div class=\"md-title pv-8\">Benefits on Sign UP</div><div layout=\"column\" \nclass=\"card md-whiteframe-4dp\"><div class=\"ph-16 pv-8 back1\" layout=\"row\" layout-align=\"center center\" layout-wrap><div\n class=\"h4\">Total {{vm.data.signUp.count}} Sign Up</div></div><md-divider></md-divider><div flex layout=\"row\"><div \nflex layout=\"column\" layout-align=\"center center\" class=\"ph-8 pv-24\"><span class=\"h4\">\n&#8377; {{vm.data.signUp.rfdAmount}}</span> <span class=\"no-select\">Amount Earned By Referral</span></div><md-divider>\n</md-divider><div flex layout=\"column\" layout-align=\"center center\" class=\"pv-24 ph-8\"><span class=\"h4\">\n&#8377; {{vm.data.signUp.rfyAmount}}</span> <span class=\"no-select\">Amount Earned By Referrer</span></div></div>\n<md-divider></md-divider><div class=\"ph-16 pv-8\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"h4\">\nTotal &#8377; {{vm.data.signUp.rfdAmount + vm.data.signUp.rfyAmount}}</div></div></div></div><div class=\"content\" \nflex=\"50\"><div class=\"md-title pv-8\">Benefits on IIN Creation</div><div layout=\"column\" class=\"card md-whiteframe-4dp\">\n<div class=\"ph-16 pv-8 back2\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"h4\">\nTotal {{vm.data.createdIIN.count}} IIN Creation</div></div><md-divider></md-divider><div flex layout=\"row\"><div flex \nlayout=\"column\" layout-align=\"center center\" class=\"ph-8 pv-24\"><span class=\"h4\">\n&#8377; {{vm.data.createdIIN.rfdAmount}}</span> <span class=\"no-select\">Amount Earned By Referral</span></div>\n<md-divider></md-divider><div flex layout=\"column\" layout-align=\"center center\" class=\"pv-24 ph-8\"><span class=\"h4\">\n&#8377; {{vm.data.createdIIN.rfyAmount}}</span> <span class=\"no-select\">Amount Earned By Referrer</span></div></div>\n<md-divider></md-divider><div class=\"ph-16 pv-8\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"h4\">\nTotal &#8377; {{vm.data.createdIIN.rfdAmount + vm.data.createdIIN.rfyAmount}}</div></div></div></div><div \nclass=\"content\" flex=\"50\"><div class=\"md-title pv-8\">Benefits on IIN Activation</div><div layout=\"column\" \nclass=\"card md-whiteframe-4dp\"><div class=\"ph-16 pv-8 back3\" layout=\"row\" layout-align=\"center center\" layout-wrap><div\n class=\"h4\">Total {{vm.data.activeIIN.count}} IIN Activation</div></div><md-divider></md-divider><div flex \nlayout=\"row\"><div flex layout=\"column\" layout-align=\"center center\" class=\"ph-8 pv-24\"><span class=\"h4\">\n&#8377; {{vm.data.activeIIN.rfdAmount}}</span> <span class=\"no-select\">Amount Earned By Referral</span></div>\n<md-divider></md-divider><div flex layout=\"column\" layout-align=\"center center\" class=\"pv-24 ph-8\"><span class=\"h4\">\n&#8377; {{vm.data.activeIIN.rfyAmount}}</span> <span class=\"no-select\">Amount Earned By Referrer</span></div></div>\n<md-divider></md-divider><div class=\"ph-16 pv-8\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"h4\">\nTotal &#8377; {{vm.data.activeIIN.rfdAmount + vm.data.activeIIN.rfyAmount}}</div></div></div></div><div \nclass=\"content\" flex=\"50\"><div class=\"md-title pv-8\">Benefits on 1st time Investment</div><div layout=\"column\" \nclass=\"card md-whiteframe-4dp\"><div class=\"ph-16 pv-8 back4\" layout=\"row\" layout-align=\"center center\" layout-wrap><div\n class=\"h4\">Total {{ vm.data.investment.count}} 1st time Investment</div></div><md-divider></md-divider><div flex \nlayout=\"row\"><div flex layout=\"column\" layout-align=\"center center\" class=\"ph-8 pv-24\"><span class=\"h4\">\n&#8377; {{vm.data.investment.rfdAmount}}</span> <span class=\"no-select\">Amount Earned By Referral</span></div>\n<md-divider></md-divider><div flex layout=\"column\" layout-align=\"center center\" class=\"pv-24 ph-8\"><span class=\"h4\">\n&#8377; {{vm.data.investment.rfyAmount}}</span> <span class=\"no-select\">Amount Earned By Referrer</span></div></div>\n<md-divider></md-divider><div class=\"ph-16 pv-8\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"h4\">\nTotal &#8377; {{vm.data.investment.rfdAmount + vm.data.investment.rfyAmount}}</div></div></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/referral/transfer-amount/transfer-amount.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-40><div\n class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Referral Users</span></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back\n</span></md-button></div></div><div class=\"headerFixAllPages\"><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"rightHistory\" md-whiteframe=\"4\" style=\"max-width:900px;width:900px\"><md-toolbar \nclass=\"md-accent height-60\" layout=\"row\" layout-align=\"space-between center\"><h1 class=\"md-toolbar-tools\">\nTransaction History of {{vm.activeUser.user.userName}}</h1><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'rightHistory\')\" aria-label=\"More\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-toolbar><md-content layout-margin><div class=\"simple-table-container\"><table class=\"simple\" ms-responsive-table>\n<thead><tr><th>Date</th><th>Activity</th><th>Amount</th><th>Reference Code</th><th>Type</th><th>Status</th><th>Remarks\n</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"trxn in vm.referralTransactionData\"><td \nclass=\"name\">{{trxn.date | date:\'mediumDate\'}}</td><td class=\"position\">{{trxn.activity}}</td><td class=\"office\">\n{{trxn.amount | currency :\'&#8377; \':0}}</td><td class=\"office\">{{trxn.referenceCode}}</td><td class=\"office\">\n{{trxn.type}}</td><td class=\"office\">{{trxn.status}}</td><td class=\"office\">{{trxn.remarks}}</td></tr></tbody></table>\n</div></md-content></md-sidenav><md-content><div ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Active\" ng-click=\"vm.getReferralTransactionByStatus(\'PENDING\')\"><md-content class=\"md-padding\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Date</th><th>\nName</th><th class=\"text-right\">Amount</th><th class=\"text-center\">Action</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr ng-click=\"vm.getHistory(person)\" ng-repeat=\"person in vm.usersData\"><td class=\"name\">\n{{person.date | date : \'mediumDate\'}}</td><td class=\"name\">{{person.user.userName}}</td><td class=\"age text-right\">\n{{person.amount}}</td><td class=\"text-center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.getReferenceCodeDialog(person)\" aria-label=\"More\"><md-icon md-font-icon=\"icon-check\" \nclass=\"iconClass green\"></md-icon><md-tooltip md-direction=\"bottom\">Confirmed</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.creditgReferralAmount(person._id,\'CANCELLED\')\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-close\" class=\"iconClass red\"></md-icon><md-tooltip md-direction=\"bottom\">Cancled</md-tooltip>\n</md-button></td></tr></tbody></table></div></md-content></md-tab><md-tab label=\"DONE\" \nng-click=\"vm.getCompletedReferralTransaction(\'DONE\')\"><md-content class=\"md-padding\"><md-content class=\"md-padding\">\n<div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Date\n</th><th>Name</th><th>Reference Code</th><th class=\"text-right\">Amount</th><th class=\"text-center\">Status</th></tr>\n</thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-click=\"vm.getHistory(person)\" \nng-repeat=\"person in vm.completedTransaction\"><td class=\"name\">{{person.date | date : \'mediumDate\'}}</td><td \nclass=\"name\">{{person.user.userName}}</td><td class=\"position\">{{person.referenceCode}}</td><td class=\"age text-right\">\n{{person.amount}}</td><td class=\"text-center\">{{person.status}}</td></tr></tbody></table></div></md-content>\n</md-content></md-tab></md-tabs></md-content></div></md-content></div></div>");
$templateCache.put("app/main/serviceConfiguration/serviceConfigurationUpdate/serviceConfigurationUpdate.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"serviceConfigurationUpdate\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nService Configuration Update</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"backArrowColor\" ui-sref=\"app.serviceConfiguration\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div>\n<md-content layout-padding><form name=\"updateConfiguration\" novalidate><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\" padding-wrap><md-input-container flex=\"50\" flex-xs=\"100\" class=\"margin-top-20\">\n<label>Access Code</label><input type=\"text\" name=\"accessCode\" ng-model=\"vm.userData.config.ACCESS_CODE\" \nclass=\"no-margin-bottom\" required></md-input-container><div flex=\"50\" flex-xs=\"100\"><md-datepicker name=\"accessDate\" \nng-model=\"vm.userData.config.ACCESS_EXPIARY_DATE\" md-placeholder=\"Enter date\" md-is-open=\"vm.isOpen\" \nmd-min-date=\"vm.minDate\" md-max-date=\"vm.maxDate\"></md-datepicker><md-button class=\"md-raised md-accent\" \nng-click=\"vm.isOpen = true\" style=\"color:#fff !important\">Open</md-button></div></div><section layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent width-160 margin-bottom\" \nng-click=\"vm.updateConfiguration()\" \nng-disabled=\"!(vm.userData.config.ACCESS_EXPIARY_DATE && vm.userData.config.ACCESS_CODE)\" \nstyle=\"color:#fff !important\">Update</md-button></section></form></md-content></div>");
$templateCache.put("app/main/serviceConfiguration/serviceConfigurationUpdate/serviceConfigurationUpdateAppVer.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"serviceConfigurationUpdate\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nService Configuration Update App Ver</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"backArrowColor\" ui-sref=\"app.serviceConfiguration\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div>\n<md-content layout-padding><form name=\"updateConfiguration\" novalidate><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\" padding-wrap><md-input-container flex=\"50\" flex-xs=\"100\" class=\"margin-top-20\">\n<label>APP VERSION</label><input type=\"text\" name=\"accessCode\" ng-model=\"vm.userData.config.VERSION\" \nclass=\"no-margin-bottom\" required></md-input-container></div><section layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent width-160 margin-bottom\" \nng-click=\"vm.updateConfiguration()\" ng-disabled=\"!(vm.userData.config.VERSION)\" style=\"color:#fff !important\">Update\n</md-button></section></form></md-content></div>");
$templateCache.put("app/main/serviceConfiguration/serviceConfigurationUpdate/serviceConfigurationUpdateWatti.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"serviceConfigurationUpdate\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nService Configuration Update Watti</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"backArrowColor\" ui-sref=\"app.serviceConfiguration\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back</span></md-button></div></div>\n<md-content layout-padding><form name=\"updateConfiguration\" novalidate><h4 class=\"margin-0\"><label \nclass=\"switch switch-green\"><input type=\"checkbox\" class=\"switch-input\" ng-model=\"vm.buttonStatus\" \nng-change=\"vm.updateConfiguration()\"> <span class=\"switch-label\" \nng-class=\"{\'greyback\': !vm.referralConfig.signUp.active}\" data-on=\"ON\" data-off=\"OFF\"></span> <span \nclass=\"switch-handle\"></span> <span class=\"textClass\">WATTSAPP MSG FLAG</span></label></h4></form></md-content></div>");
$templateCache.put("app/main/sip-book/customerDetailsScheme/customerDetailsScheme.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"75\">\n<div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span style=\"font-size:18px\">\n{{vm.customers.schemeName}}</span></div><div class=\"product-count secondary-text margin-top-10\"><span>Total Investors:\n</span> <span>{{vm.customers.investors.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"ext-content\"><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th md-column md-order-by=\"userName\">\n<span class=\"text-center\">Name</span></th><th md-column md-order-by=\"pan\"><span>PAN</span></th><th md-column \nmd-order-by=\"email\"><span>Email</span></th><th md-column md-order-by=\"mobileNo\"><span>Mobile</span></th><th md-column \nmd-order-by=\"sipAmount\"><span>SIP Amount</span></th><th md-column md-order-by=\"value\"><span>Amount</span></th><th \nmd-column md-order-by=\"currentValue\"><span>Current Amount</span></th><th md-column md-order-by=\"units\"><span>Units\n</span></th></tr></thead><tbody md-body><div class=\"scrollable\" ms-scroll><tr md-row md-select=\"customer\" \nmd-auto-select md-virtual-repeat=\"customer in vm.customers.investors | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.customerDetailFunction(customer)\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{customer.userName}}</td><td md-cell>{{customer.pan}}</td><td md-cell>{{customer.email}}</td><td md-cell>\n{{customer.mobileNo}}</td><td md-cell>{{customer.sipAmount | number:2}}</td><td md-cell>{{customer.value | number:2}}\n</td><td md-cell>{{customer.currentValue | number:2}}</td><td md-cell>{{customer.units | number:2}}</td></tr></div>\n</tbody></table></md-table-container></md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/sip-book/sip-book-main/sip-book-main.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"sip-book\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>SIP Book\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"search\" placeholder=\"Search\" flex></div></div><div class=\"headerFixAllPages\"><md-content><div flex=\"100\" \nclass=\"white-bg md-whiteframe-4dp margin-10\"><div class=\"h3 p-16 no-padding-margin\">Investments Details</div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"20\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-22 line-height-70\">{{vm.investmentData.totalCustomers || \'0\'}}</div></div><div \nclass=\"grey-50-bg border-top\" layout=\"row\" layout-align=\"center center\"><span class=\"h4 light-blue-fg fontMargin\">\nTotal Customers</span></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"20\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-22 line-height-70\">\n{{vm.investmentData.numberOfSip || \'0\'}}</div></div><div class=\"grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 red-fg fontMargin\">Number of SIP</span></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"20\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-22 line-height-70\">\n&#8377; {{vm.investmentData.sipAmount | number:2}}</div></div><div class=\"grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 orange-fg fontMargin\">SIP Amount</span></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"20\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-fg font-size-22 line-height-70\">\n&#8377; {{vm.investmentData.netInvestedAmount | number:2}}</div></div><div class=\"grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 blue-fg fontMargin\">Net Investment Amount</span></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"20\"><ms-widget-front class=\"white-bg\"><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"green-fg font-size-22 line-height-70\">\n&#8377; {{vm.investmentData.netCurrentAmount | number:2}}</div></div><div class=\"grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 green-fg fontMargin\">Net Current Amount</span></div></ms-widget-front>\n</ms-widget></div><md-tabs md-dynamic-height md-border-bottom class=\"md-padding\"><md-tab label=\"Customer Wise\">\n<md-content class=\"md-padding\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table \nmd-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th \nmd-column><span>SNo.</span></th><th md-column md-order-by=\"investorName\"><span class=\"text-center\">Customer Name</span>\n</th><th md-column md-order-by=\"pan\"><span>PAN</span></th><th md-column md-order-by=\"iin\"><span>IIN</span></th><th \nmd-column md-order-by=\"numberOfSchemes\"><span>Scheme Count</span></th><th md-column md-order-by=\"currentCAGR\"><span>\nSIP Amount (&#8377;)</span></th><th md-column md-order-by=\"amount\"><span>Invested Amount (&#8377;)</span></th><th \nmd-column md-order-by=\"absoluteReturn\"><span>Current Value (&#8377;)</span></th></tr></thead><tbody md-body><div \nclass=\"scrollable\" ms-scroll><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"item in vm.investmentDataCustomerData | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.customerWiseDetials(item)\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{item.investorName}}</td><td md-cell>{{item.pan}}</td><td md-cell>{{item.iin}}</td><td md-cell>{{item.sipCount || 0}}\n</td><td md-cell>{{item.sipAmount | number:2}}</td><td md-cell>{{item.investedAmount | number:2}}</td><td md-cell>\n{{item.currentValue | number:2}}</td></tr></div></tbody></table></md-table-container></md-virtual-repeat-container>\n</md-content></md-tab><md-tab label=\"Scheme Wise\"><md-content class=\"md-padding\"><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th md-column \nmd-order-by=\"schemeName\"><span class=\"text-center\">Scheme Name</span></th><th md-column md-order-by=\"investors\"><span>\nCustomer</span></th><th md-column md-order-by=\"sipAmount\"><span>SIP Amount (&#8377;)</span></th><th md-column \nmd-order-by=\"amountInvested\"><span>Invested Amount (&#8377;)</span></th><th md-column md-order-by=\"currentValue\"><span>\nCurrent Amount (&#8377;)</span></th></tr></thead><tbody md-body><div class=\"scrollable\" ms-scroll><tr md-row \nmd-select=\"item\" md-auto-select \nmd-virtual-repeat=\"item in vm.investmentDataSchemeWise | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.selectTableRow($index)\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{item.schemeName}}</td><td md-cell>{{item.investors.length}}</td><td md-cell>{{item.sipAmount | number:2}}</td><td \nmd-cell>{{item.amountInvested | number:2}}</td><td md-cell>{{item.currentValue | number:2}}</td></tr></div></tbody>\n</table></md-table-container></md-virtual-repeat-container></md-content></md-tab></md-tabs></div></md-content></div>\n</div>");
$templateCache.put("app/main/schedular/new-schedular/new-schedular.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"schedularNew\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" ng-hide=\"vm.selectedCustomer.length>0\"><div class=\"h3\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><span>Add Schedular for {{vm.schedular.channel}}</span></div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" ng-show=\"vm.selectedCustomer.length>0\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>Customers Communication</span></div><div \nclass=\"product-count secondary-text margin-top-10\"><span>Total Customers:</span> <span>{{vm.selectedCustomer.length}}\n</span></div></div><md-button class=\"backArrowColor\" style=\"min-height:50px;top:-10px\" ui-sref=\"app.schedular\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"backArrowColor\" style=\"line-height:10px\"></md-icon><span style=\"line-height:-2%; margin-top:-14%\">Back</span>\n</md-button></div><div class=\"headerFixAllPages\"><md-content layout-gt-sm=\"row\" class=\"bgCustomHeader\"><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.schedular.filter=== 6}\" \nng-click=\"vm.customerCount(6)\" label=\"All Customer\">All Customer</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.schedular.filter=== 1}\" ng-click=\"vm.customerCount(1)\" label=\"Activated IIN\">\nActivated IIN</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.schedular.filter=== 2}\" ng-click=\"vm.customerCount(2)\" label=\"Not Active\">\nNot Active</md-button><md-button class=\"md-raised textTransform\" \nng-class=\"{\'selectCustomerColor\':vm.schedular.filter=== 3}\" ng-click=\"vm.customerCount(3)\" label=\"No IIN\">No IIN\n</md-button><md-button class=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.schedular.filter=== 4}\" \nng-click=\"vm.customerCount(4)\" label=\"IIN Active But Zero Investment\">IIN Active But Zero Investment</md-button>\n<md-button class=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.schedular.filter=== 5}\" \nng-click=\"vm.customerCount(5)\" label=\"SIP Purchased\">SIP Purchased</md-button><md-button \nclass=\"md-raised textTransform\" ng-class=\"{\'selectCustomerColor\':vm.schedular.filter=== 7}\" label=\"Custom\" \nng-click=\"vm.customerCount(7)\">Custom</md-button></md-content><div class=\"padding-10\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-content class=\"md-padding\" layout-gt-sm=\"row\" layout-padding><form \nname=\"sendMsg\" layout=\"row\" layout-wrap flex=\"100\" novalidate><div class=\"h3\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom:2%\"></div><md-input-container class=\"md-block\" flex=\"25\"><md-datepicker flex \nng-model=\"vm.schedular.date\" name=\"date\" md-min-date=\"vm.cDate\" md-placeholder=\"Enter date\" required></md-datepicker>\n<div ng-messages=\"sendMsg.date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Date field is required</span>\n</div></div></md-input-container><div class=\"md-block\" flex=\"25\"><label for=\"\" style=\"display:inline-block\">Time\n</label><select ng-model=\"vm.schedular.hour\" required><option ng-value=\"num\" ng-repeat=\"num in vm.numList\">{{num}}\n</option></select>:<select ng-model=\"vm.schedular.minute\" required><option ng-value=\"num\" \nng-repeat=\"num in vm.minuteNumList\">{{num}}</option></select><select ng-model=\"vm.schedular.meridian\" required><option \nng-value=\"AM\">AM</option><option ng-value=\"PM\">PM</option></select></div><md-input-container class=\"md-block mb-20\" \nflex=\"50\"><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.schedular.channel\" required>\n<md-radio-button value=\"SMS\" class=\"md-primary\">SMS</md-radio-button><md-radio-button value=\"EMAIL\">EMAIL\n</md-radio-button><md-radio-button value=\"NOTIFICATION\">NOTIFICATION</md-radio-button></md-radio-group>\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Schedular Name</label><input \nng-model=\"vm.schedular.name\" name=\"name\" required><div ng-messages=\"sendMsg.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"50\" ng-show=\"vm.schedular.channel === \'EMAIL\'\"><label>Subject</label><input \nng-model=\"vm.schedular.subject\" name=\"email\" ng-required=\"vm.schedular.channel === \'EMAIL\'\"><div \nng-messages=\"sendMsg.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"100\"><text-angular name=\"bodyContent\" \nng-model=\"vm.schedular.bodyContent\" md-select-on-focus required></text-angular><div \nng-messages=\"sendMsg.bodyContent.$error\" role=\"alert\"><div ng-message=\"required\"><span>Message field is required</span>\n</div></div></md-input-container><div layout=\"column\" ng-show=\"vm.schedular.channel !== \'SMS\'\" flex=\"100\"><h3>\nUpload Attachments</h3><div layout=\"column\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.doc.flow\" flow-files-submitted=\"vm.uploadDoc()\" \nflow-file-added=\"vm.fileAddedDoc($file)\" flow-file-success=\"vm.fileSuccessDoc($file, $message)\" \nflow-complete=\"vm.uploadCompleteDoc()\"><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\">\n<md-button class=\"md-primary md-raised\" flow-btn>Upload</md-button></div><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div layout=\"column\" layout-align=\"center\" ng-repeat=\"image in vm.docs\"><h5>{{image.file.name}}</h5><div \nclass=\"product-image uploading\" layout=\"row\" layout-align=\"center center\" \nstyle=\"max-width:150px;width:150px;height:112.50px\"><div class=\"overlay\" layout=\"column\" layout-align=\"center center\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{image.file.progress() * 100}}\"></md-progress-linear></div><img \nng-if=\"image.format !== \'IMAGE\'\" style=\"max-width:150px\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\" alt=\"\"> <img class=\"media\" \nng-if=\"image.format === \'IMAGE\'\" flow-img=\"image.file\" style=\"max-width:150px\"></div><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.deleteDialogForAttachment(image)\">Delete</md-button></div><div layout=\"column\" \nlayout-align=\"center\" ng-repeat=\"image in vm.schedular.attachments\"><h5>{{image.file}}</h5><div \nclass=\"product-image uploading\" layout=\"row\" layout-align=\"center center\" \nstyle=\"max-width:150px;width:150px;height:112.50px\"><img ng-if=\"image.type === \'CSV\' || image.type === \'EXCEL\'\" \nstyle=\"max-width:150px\" src=\"./../../../assets/images/backgrounds/documentPlaceholder.png\" alt=\"\"> <img \nng-if=\"image.type === \'IMAGE\'\" class=\"media\" src=\"{{\'/api/notification-scheduler-image/\'+image.file}}\" \nstyle=\"max-width:150px\"><object ng-if=\"image.type === \'PDF\'\" style=\"max-width:150px;width:150px;height:112.50px\" \ndata=\"{{  \'/api/notification-scheduler-image/\' + image.file}}\" type=\"application/pdf\" width=\"300\" height=\"200\"><a \nhref=\"{{ \'/api/notification-scheduler-image/\' + image.file}}\">{{image.file}}</a></object><a target=\"_blank\" \nng-if=\"image.type === \'VIDEO\'\" href=\"{{ \'/api/notification-scheduler-image/\' + image.file}}\"><video \nng-src=\"vm.trustedHtml(image)\" style=\"max-width:150px;width:150px;height:112.50px\" controls></video></a></div>\n<md-button class=\"md-raised md-warn\" ng-click=\"vm.deleteDialogForAttachment(image)\">Delete</md-button></div></div>\n</div></div></div></div><div layout=\"row\" layout-sm=\"column\" ng-show=\"vm.selectedCustomer.length>0\"><h4>\nMessage will be send to <b>{{vm.selectedCustomer.length}}</b> Customers</h4></div><div layout=\"row\" layout-sm=\"column\">\n<div flex=\"33\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.saveSchedular()\" ng-disabled=\"sendMsg.$invalid\" \nstyle=\"color:#fff !important\">Submit</md-button></div></div></form></md-content></div></div><div \nng-show=\"vm.selectedCustomer.length>0\"><div class=\"white-bg md-whiteframe-4dp\"><div ng-cloak><md-content \nclass=\"md-padding\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table md-table \nng-model=\"vm.selected\" md-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>\nS.No.</span></th><th md-column md-order-by=\"userName\"><span>Name</span></th><th md-column md-order-by=\"mobileNo\"><span>\nContact</span></th><th md-column md-order-by=\"email\"><span>Email Id</span></th><th md-column md-order-by=\"pan\"><span>\nPAN</span></th><th md-column md-order-by=\"iin\"><span>IIN</span></th><th md-column><span>Action</span></th></tr></thead>\n<tbody md-body><tr md-row md-select=\"item\" md-auto-select \nmd-virtual-repeat=\"customer in vm.selectedCustomer | filter:search | orderBy: vm.query.order\" style=\"cursor:pointer\">\n<td md-cell>{{$index+1}}</td><td md-cell><span ng-if=\"customer.nseData && customer.nseData.INVESTOR_NAME\">\n{{(customer.nseData.INVESTOR_NAME)}}</span> <span ng-if=\"!(customer.nseData && customer.nseData.INVESTOR_NAME)\">\n{{(customer.userName) ? (customer.userName) :\'NA\'}}</span></td><td md-cell>\n{{(customer.mobileNo) ? (customer.mobileNo):\'NA\'}}</td><td md-cell>{{(customer.email) ? (customer.email):\'NA\'}}</td><td\n md-cell>{{(customer.pan) ? (customer.pan):\'NA\'}}</td><td md-cell>{{(customer.iin) ? (customer.iin):\'NA\'}}</td><td \nmd-cell><md-icon md-font-icon=\"icon-delete\" ng-click=\"vm.deleteUser($index)\" class=\"s20\"></md-icon></td></tr></tbody>\n</table></md-table-container></md-virtual-repeat-container></md-content></div></div></div></div></div>");
$templateCache.put("app/main/schedular/schedular-detail/schedular-detail.html","<div id=\"referralDetailPage\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span>\nSchedular Details</span></div></div><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor\" \nstyle=\"line-height:10px\"></md-icon><span style=\"line-height:-2%; margin-top:-14%\">Back</span></md-button></div><div \nclass=\"headerFixAllPages\"><md-content layout-padding><div class=\"card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"100\" layout-wrap><div flex=\"33\"><h5>Name: <span>{{vm.schedular.name}}</span></h5>\n</div><div flex=\"33\"><h5>Channel: <span>{{vm.schedular.channel}}</span></h5></div><div flex=\"33\"><h5>Date & Time: \n<span>\n{{vm.schedular.date | date:\'mediumDate\'}} at {{vm.schedular.hour > 12 ? vm.schedular.hour-12:vm.schedular.hour}}:{{vm.schedular.minute}} {{vm.schedular.hour > 11 ? \'PM\':\'AM\'}}\n</span></h5></div><div flex=\"33\"><h5>Filter: <span>{{vm.customerType[vm.schedular.filter]}}</span></h5></div><div \nflex=\"33\"><h5>Status: <span>{{vm.schedular.executeFlag ? \'Completed\':\'Pending\'}}</span></h5></div><div \nng-if=\"vm.schedular.channel === \'EMAIL\'\" flex=\"33\"><h5>Subject: <span>{{vm.schedular.subject}}</span></h5></div><div \nflex=\"33\" ng-if=\"vm.schedular.notificationSchedulerHistory[0].success.count\"><h5>Success:</h5><h6>\n{{vm.schedular.notificationSchedulerHistory[0].success.count}}</h6></div><div flex=\"33\" \nng-if=\"vm.schedular.notificationSchedulerHistory[0].failure.reason\"><h5>Failure:</h5><h6>\nReason: {{vm.schedular.notificationSchedulerHistory[0].failure.reason}}</h6><h6>\nCount: {{vm.schedular.notificationSchedulerHistory[0].failure.count}}</h6></div><div flex=\"100\"><h5>Message:</h5><h6>\n{{vm.schedular.bodyContent}}</h6></div></div></div><div class=\"card md-whiteframe-4dp\"><h4>Attachments</h4><div \nlayout=\"row\" layout-gap=\"10px\" layout-wrap><div flex=\"30\" ng-repeat=\"attachment in vm.schedular.attachments\"><div><img \nng-if=\"attachment.type !== \'PDF\' && attachment.type !== \'IMAGE\' && attachment.type !== \'VIDEO\'\" \nsrc=\"./../../../assets/images/backgrounds/documentPlaceholder.png\" alt=\"\"> <img ng-if=\"attachment.type === \'IMAGE\'\" \nsrc=\"{{ \'/api/notification-scheduler-image/\' + attachment.file}}\" alt=\"\" width=\"150px\"><object \nng-if=\"attachment.type === \'PDF\'\" data=\"{{ \'/api/notification-scheduler-image/\' + attachment.file}}\" \ntype=\"application/pdf\" width=\"300\" height=\"200\"><a href=\"{{  \'/api/notification-scheduler-image/\' + attachment.file}}\">\n{{attachment.file}}</a></object><a target=\"_blank\" ng-if=\"attachment.type === \'VIDEO\'\" \nhref=\"{{ \'/api/notification-scheduler-image/\' + attachment.file}}\"><video ng-src=\"vm.trustedHtml(attachment)\" controls>\n</video></a></div><a href=\"{{ \'/api/notification-scheduler-image/\' + attachment.file}}\">{{attachment.file}}</a></div>\n</div></div><div class=\"card md-whiteframe-4dp\"><md-virtual-repeat-container id=\"fixed\"><div layout=\"row\" \nclass=\"header1\" layout-align=\"start center\" flex=\"100\"><div flex=\"20\" class=\"pl-20\">Name</div><div flex=\"20\" \nclass=\"pl-20\">Email</div><div flex=\"20\" class=\"pl-20\">Mobile</div><div flex=\"20\" class=\"pl-20\">IIN</div><div flex=\"20\" \nclass=\"pl-20\">NSE Status</div></div><div style=\"cursor:pointer\" layout=\"row\" class=\"tabRow\" \nlayout-align=\"start center\" md-virtual-repeat=\"item in vm.schedular.notificationSchedulerHistory[0].users  \" \nflex=\"100\"><div flex=\"20\" class=\"pl-20\">{{item.userName}}</div><div flex=\"20\" class=\"pl-20\">{{item.email}}</div><div \nflex=\"20\" class=\"pl-20\">{{item.mobileNo}}</div><div flex=\"20\" class=\"pl-20\">{{item.iin}}</div><div flex=\"20\" \nclass=\"pl-20\">{{item.nseData ? item.nseData.ACTIVATION_STATUS : \'NA\'}}</div></div></md-virtual-repeat-container></div>\n</md-content></div></div>");
$templateCache.put("app/main/uploadTransaction/transaction-list/transaction-list.html","<div id=\"trxn-list\" class=\"page-layout simple fullwidth doc-page element-doc-page\" id=\"uploadTransaction\"><div \nclass=\"header md-accent-bg height-60\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between start\" flex-40><div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\">\n<span class=\"text-capitalize\">{{ vm.transactionType.type}} Transaction List</span></div><span class=\"mt-15\">\nTotal: {{vm.totalTrxn}}</span></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex-60><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"Search\" ng-blur=\"vm.getAllData()\" \nng-keyup=\"$event.keyCode == 13 ? vm.searchTransaction() : null\" flex></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"backArrowColor\" ui-sref=\"app.uploadTransaction\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\"></md-icon><span>Back\n</span></md-button></div></div><div class=\"ext-content\"><md-virtual-repeat-container ng-style=\"listStyle\" fix-head>\n<md-table-container class=\"tablePbmSolved\"><table md-table ng-model=\"vm.selected\"><thead md-head \nmd-order=\"vm.query.order\" fix-head><tr md-row><th md-column md-order-by=\"lastLoginDate\"><span>Actions</span></th><th \nmd-column md-order-by=\"transactionDate\"><span class=\"text-center\">Date</span></th><th md-column \nmd-order-by=\"investorName\"><span>Investor Name</span></th><th md-column md-order-by=\"investorPan\"><span>PAN</span></th>\n<th md-column md-order-by=\"iin\"><span>IIN</span></th><th md-column md-order-by=\"transactionNumber\"><span>Trxn No.\n</span></th><th md-column md-order-by=\"productName\" style=\"min-width:250px; padding-right:20px\"><span>Scheme</span>\n</th><th md-column md-order-by=\"folioNumber\"><span>Folio No.</span></th><th md-column md-order-by=\"purPrice\"><span>\nPrice/Unit</span></th><th md-column md-order-by=\"units\"><span>Units</span></th><th md-column md-order-by=\"amount\">\n<span>Amount</span></th><th md-column md-order-by=\"type\"><span>Trxn Type</span></th><th md-column \nmd-order-by=\"productISIN\"><span>Product ISIN</span></th></tr></thead><tbody md-body><tr md-row md-select=\"customer\" \nmd-virtual-repeat=\"transaction in vm.dynamicItems \" ng-click=\"vm.customerDetailFunction(customer)\" md-on-demand=\"\" \nstyle=\"cursor:pointer\"><td md-cell><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"Edit\" ng-click=\"vm.editTransaction(transaction)\">Edit</md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Activated\" ng-click=\"vm.deleteTransaction(transaction,$index)\">Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></td><td md-cell>{{transaction.transactionDate | date:\'mediumDate\'}}</td><td\n md-cell>{{transaction.investorName}}</td><td md-cell ng-bind=\"transaction.investorPan\"></td><td md-cell \nng-bind=\"transaction.iin\"></td><td md-cell ng-bind=\"transaction.transactionNumber\"></td><td md-cell>\n{{transaction.productName}}</td><td md-cell ng-bind=\"transaction.folioNumber\"></td><td md-cell \nng-bind=\"transaction.purPrice\"></td><td md-cell>{{transaction.units}}</td><td md-cell>{{transaction.amount }}</td><td \nmd-cell>{{transaction.type}}</td><td md-cell>{{transaction.productISIN}}</td></tr></tbody></table></md-table-container>\n</md-virtual-repeat-container></div></div>");
$templateCache.put("app/main/uploadTransaction/update-transaction-dialog/update-transaction-dialog.html","<div layout=\"row\" layout-wrap flex=\"100\" layout-padding style=\"padding-top:50px\"><md-input-container flex=\"50\"><label>\nPAN</label><input ng-model=\"vm.transactionData.investorPan\"></md-input-container><md-input-container flex=\"50\"><label>\nIIN</label><input ng-model=\"vm.transactionData.iin\"></md-input-container><md-input-container flex=\"50\"><label>\nFolio Number</label><input ng-model=\"vm.transactionData.folioNumber\"></md-input-container><md-input-container \nflex=\"50\"><label>Transaction Number</label><input ng-model=\"vm.transactionData.transactionNumber\"></md-input-container>\n<md-input-container flex=\"50\"><label>Transaction Type</label><md-select ng-model=\"vm.transactionData.type\"><md-option \nng-repeat=\"type in vm.transactionTypes\" value=\"{{type.code}}\">{{type.name}}</md-option></md-select>\n</md-input-container><div layout=\"row\" layout-align=\"space-between\" flex=\"100\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.saveData()\">Save\n</md-button></div></div>");
$templateCache.put("app/main/uploadTransaction/validate-list/validate-list.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"75\">\n<div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span style=\"font-size:18px\">\nValidate Investor List</span></div><div class=\"product-count secondary-text margin-top-10\"><span>Total Investors:\n</span> <span>{{vm.customers.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nclass=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"headerFixAllPages\"><div class=\"ext-content\">\n<md-virtual-repeat-container ng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" \nmd-progress=\"promise\"><thead md-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th \nmd-column md-order-by=\"investor_name\"><span class=\"text-center\">Name</span></th><th md-column \nmd-order-by=\"investor_pan\"><span>Pan Number</span></th><th md-column md-order-by=\"folio_no\"><span>Folio Number</span>\n</th><th md-column md-order-by=\"transaction_no\"><span>Transaction No.</span></th><th md-column \nmd-order-by=\"transaction_type\"><span>Transaction Type</span></th><th md-column md-order-by=\"transaction_nature\"><span>\ntransaction Nature</span></th><th md-column md-order-by=\"lineNumber\"><span>Line No.</span></th><th md-column \nmd-order-by=\"error\"><span>Remarks</span></th></tr></thead><tbody md-body><div class=\"scrollable\" ms-scroll><tr \nmd-auto-select md-virtual-repeat=\"customer in vm.customers | filter:search | orderBy: vm.query.order\" \nstyle=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>{{customer.investor_name}}</td><td md-cell>\n{{customer.investor_pan}}</td><td md-cell>{{customer.folio_no}}</td><td md-cell>{{customer.transaction_no}}</td><td \nmd-cell>{{customer.transaction_type}}</td><td md-cell>{{customer.transaction_nature}}</td><td md-cell>\n{{customer.lineNumber}}</td><td md-cell>{{customer.error}}</td></tr></div></tbody></table></md-table-container>\n</md-virtual-repeat-container></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" style=\"background-color: #fff\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"objectParent logo-image\"><img class=\"objectFit\" ng-src=\"/assets/images/logos/logo.png\"> </span><span \nclass=\"logo-text\">Admin</span></div><md-icon class=\"fold-toggle s18\" style=\"color: #000\" \nmd-font-icon=\"icon-backburger\" show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><div \nlayout=\"column\" layout-align=\"center\" style=\"background-color:#fff;color: black\" layout-padding><h4 \nclass=\"margin-top-0 margin-bottom-0\">Hi {{vm.userDeatail.userName}}</h4></div><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">S</span> <span class=\"logo-text\">SIP Admin</span>\n</div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div>\n</div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">S</span> <span class=\"logo-text\">SIP Admin</span>\n</div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">S</span> <span class=\"logo-text\">SIP Admin</span>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/blogs/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/blogs/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"Title\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\r\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\"><div id=\"image-uploader\" \nflow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" flow-files-submitted=\"MsNoteForm.upload()\" \nflow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" flow-complete=\"MsNoteForm.uploadComplete()\" \nflow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\"><md-button flow-btn \nclass=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate translate-attr-aria-label=\"NOTES.ADD_IMAGE\">\n<md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon></md-button></div><md-button class=\"md-icon-button\" \naria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\"><md-button \nclass=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Add reminder\" ms-datepicker-fix></md-datepicker>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" \nng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" translate=\"NOTES.SAVE\" \nng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button ng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" \ntranslate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>");
$templateCache.put("app/main/blogs/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text>\n<h1>{{MsNoteItem.note.title}}</h1></md-card-title-text></md-card-title><md-description \nng-if=\"MsNoteItem.note.description\"><span>{{MsNoteItem.note.description}}</span></md-description><div \nng-if=\"MsNoteItem.note.author\" class=\"checklist\"><div layout=\"row\" layout-align=\"start center\"><span class=\"label\" \nflex><strong>By {{MsNoteItem.note.author}} on {{MsNoteItem.note.date | date: \'dd/mm/yyyy\' }}</strong></span></div>\n</div></md-card-content></md-card>");
$templateCache.put("app/main/customers/sub-broker-customer/customerDetails/customer-bank-Details.html","<form role=\"form\" name=\"createRegisterForm\" novalidate><div></div><br><md-content layout-padding><form \nname=\"projectForm\"><div layout-gt-sm=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nAccount Type</label><md-select ng-model=\"postJsonData.acc_type\" required \nng-model-options=\"{trackBy: \'$value.ACC_TYPE\'}\" name=\"acc_type\"><md-option ng-repeat=\"x in accountTypeData\" \nng-value=\"x\">{{x.DESCRIPTION}}</md-option></md-select><div ng-messages=\"createRegisterForm.acc_type.$error\" \nng-if=\"createRegisterForm.acc_type.$touched\"><div ng-if=\"createRegisterForm.acc_type.$error.required\" \nng-message=\"required\">Account type is required!</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Account No.</label><input type=\"text\" name=\"acc_no\" ng-model=\"postJsonData.acc_no\" \nng-pattern=\"/^\\d+$/\" maxlength=\"18\" minlength=\"6\" required><div ng-messages=\"createRegisterForm.acc_no.$error\" \nng-if=\"createRegisterForm.acc_no.$touched\"><span ng-show=\"createRegisterForm.acc_no.$error.required\" \nng-message=\"required\">Account number is required!</span><div ng-show=\"createRegisterForm.acc_no.$error.pattern\" \nng-message=\"pattern\">Please Enter a <b>valid</b> account number!</div><div \nng-show=\"createRegisterForm.acc_no.$error.minlength\" ng-message=\"minlength\">That\'s too short account number!</div><div \nng-show=\"createRegisterForm.acc_no.$error.maxlength\" ng-message=\"maxlength\">That\'s too long account number!</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>IFSC Code</label><input type=\"text\" \nname=\"ifsc_code\" ng-model=\"postJsonData.ifsc_code\" ng-change=\"getBankDetailsByIfsc()\" required><div \nng-messages=\"createRegisterForm.ifsc_code.$error\" ng-if=\"createRegisterForm.ifsc_code.$touched\"><div \nng-if=\"createRegisterForm.ifsc_code.$error.required\" ng-message=\"required\">IFSC code is required!</div></div>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-xs=\"column\" \nng-show=\"!customJsonData.ifscFlag && customJsonData.ifscBankFlag\"><md-autocomplete class=\"md-block\" flex-gt-sm \nrequired md-input-name=\"bankName\" ng-model=\"postJsonData.bank_name\" md-selected-item=\"postJsonData.bank_name\" \nmd-floating-label=\"Bank Name\" md-items=\"item in bankSearch(customJsonData.searchBankByName)\" \nmd-item-text=\"item.BANK_NAME\" md-min-length=\"0\" md-require-match md-search-text=\"customJsonData.searchBankByName\">\n<md-item-template><span md-highlight-text=\"customJsonData.searchBankByName\" md-highlight-flags=\"^i\">\n{{ item.BANK_NAME }}</span></md-item-template><div ng-messages=\"createRegisterForm.bankName.$error\" \nng-if=\"createRegisterForm.bankName.$touched\"><div ng-if=\"createRegisterForm.bankName.$error.required\" \nng-message=\"required\">Please <b>select</b> a bank.</div><div \nng-if=\"createRegisterForm.bankName.$error.md-require-match\" ng-message=\"md-require-match\">\nPlease select an existing bank.</div></div></md-autocomplete><md-input-container class=\"md-block\" flex-gt-sm><label>\nBranch Name</label><input type=\"text\" name=\"branch_name\" ng-model=\"postJsonData.branch_name\" required><div \nng-messages=\"createRegisterForm.branch_name.$error\" ng-if=\"createRegisterForm.branch_name.$touched\"><div \nng-if=\"createRegisterForm.branch_name.$error.required\" ng-message=\"required\">Please <b>fill</b> a branch name.</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Branch Address</label><input \ntype=\"text\" name=\"branch_addr1\" ng-model=\"postJsonData.branch_addr1\" required><div \nng-messages=\"createRegisterForm.branch_addr1.$error\" ng-if=\"createRegisterForm.branch_addr1.$touched\"><div \nng-if=\"createRegisterForm.branch_addr1.$error.required\" ng-message=\"required\">Please <b>fill</b> a branch address.\n</div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-xs=\"column\" layout-align=\"center center\" \nng-show=\"customJsonData.ifscFlag && Object.keys(ifscCodeData).length!==0\"><md-card md-theme-watch><md-card-actions \nlayout=\"row\" layout-align=\"end center\"><span class=\"nomineeIcon\" ng-click=\"removeIfscDetails();\"><i \nclass=\"fa fa-times-circle fa-2x\" aria-hidden=\"true\"></i></span></md-card-actions><md-card-title \nstyle=\"padding-top:0px\"><md-card-title-text><h4 class=\"InvesterHeading\">Bank Name : {{ifscCodeData.bankName}}</h4><h4 \nclass=\"InvesterHeading\">Branch Name : {{ifscCodeData.branch}}</h4><h4 class=\"InvesterHeading\">\nBranch Address : {{ifscCodeData.address}}</h4></md-card-title-text></md-card-title></md-card></div></form></md-content>\n</form><div layout=\"column\" class=\"well CustomerBodycontent\" ng-show=\"showErrorMessage.length != undefined\"><div flex>\n<h4 class=\"headingServerColor\">Server Error</h4></div><div flex ng-repeat=\"errorMsg in showErrorMessage\"><p \nclass=\"fontError text-left\">{{errorMsg.return_msg}}</p></div></div><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\" layout-wrap><md-button type=\"button\" class=\"md-raised md-accent width-160\" tabindex=\"7\" \nng-click=\"registerNSE()\" style=\"color:#fff !important\">Submit</md-button></div>");
$templateCache.put("app/main/customers/sub-broker-customer/customerDetails/customer-personal-Details.html","<style>\nh4{\r\n        color: #C0392B !important;\r\n    }\r\n    .mainBtnDesign {\r\n    background-color: #c0392b !important;\r\n    border: 1px solid #c0392b !important;\r\n    color: #fff !important;\r\n    font-size: 15px;\r\n}\n</style><md-content class=\"padding-10\"><div class=\"white-bg md-whiteframe-4dp\" layout-padding><form role=\"form\" \nname=\"createRegisterForm\" novalidate><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><md-content layout-padding><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm><label>Occupation</label><md-select \nng-model=\"postJsonData.occupation\" required name=\"occupationField\" \nng-model-options=\"{trackBy: \'$value.OCCUPATION_CODE\'}\"><md-option ng-repeat=\"x in occupationData\" ng-value=\"x\">\n{{x.OCCUPATION_DESC}}</md-option></md-select><div ng-messages=\"createRegisterForm.occupationField.$error\" \nng-if=\"createRegisterForm.occupationField.$touched\"><div ng-if=\"createRegisterForm.occupationField.$error.required\" \nng-message=\"required\">Occupation is required!</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Investor DOB/DOI</label><input type=\"date\" ng-model=\"postJsonData.dob\" required \nname=\"dateOfBirthField\" ng-max=\"maxDate\"><div ng-messages=\"createRegisterForm.dateOfBirthField.$error\" \nng-if=\"createRegisterForm.dateOfBirthField.$touched\"><div ng-if=\"createRegisterForm.dateOfBirthField.$error.required\" \nng-message=\"required\">Date of birth is required!</div><div ng-if=\"createRegisterForm.dateOfBirthField.$error.max\" \nng-message=\"max\">Date of birth can not be future date!</div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" ng-show=\"!customJsonData.ekycIsDone\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nFather Name</label><input required type=\"text\" name=\"fatherNameField\" ng-model=\"postJsonData.father_name\" \nng-pattern=\"nameRegEx\" md-maxlength=\"50\" minlength=\"2\" required><div \nng-messages=\"createRegisterForm.fatherNameField.$error\" ng-if=\"createRegisterForm.fatherNameField.$touched\"><div \nng-if=\"createRegisterForm.fatherNameField.$error.required\" ng-message=\"required\">Father name is required!</div><div \nng-if=\"createRegisterForm.fatherNameField.$error.pattern\" ng-message=\"pattern\">Please Enter a <b>valid</b> name!</div>\n<div ng-if=\"createRegisterForm.fatherNameField.$error.minlength\" ng-message=\"minlength\">That\'s too short name!</div>\n<div ng-if=\"createRegisterForm.fatherNameField.$error.md-maxlength\" ng-message=\"md-maxlength\">That\'s too long name!\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Mother Name</label><input \nrequired type=\"text\" name=\"motherNameField\" ng-model=\"postJsonData.mother_name\" ng-pattern=\"nameRegEx\" \nmd-maxlength=\"50\" minlength=\"2\" required><div ng-messages=\"createRegisterForm.motherNameField.$error\" \nng-if=\"createRegisterForm.motherNameField.$touched\"><div ng-if=\"createRegisterForm.motherNameField.$error.required\" \nng-message=\"required\">Mother name is required!</div><div ng-if=\"createRegisterForm.motherNameField.$error.pattern\" \nng-message=\"pattern\">Please Enter a <b>valid</b> name!</div><div \nng-if=\"createRegisterForm.motherNameField.$error.minlength\" ng-message=\"minlength\">That\'s too short name!</div><div \nng-if=\"createRegisterForm.motherNameField.$error.md-maxlength\" ng-message=\"md-maxlength\">That\'s too long name!</div>\n</div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" class=\"paddingTopNo\"><h4 class=\"InvesterHeading\">\n<b>Address Details</b></h4></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Address(As per address proof)</label><input required type=\"text\" name=\"address1\" ng-model=\"postJsonData.addr1\" \nminlength=\"5\" md-maxlength=\"150\"><div ng-messages=\"createRegisterForm.address1.$error\" \nng-if=\"createRegisterForm.address1.$touched\"><div ng-if=\"createRegisterForm.address1.$error.required\" \nng-message=\"required\">Address is required!</div><div ng-if=\"createRegisterForm.address1.$error.minlength\" \nng-message=\"minlength\">That\'s too short address!</div><div ng-if=\"createRegisterForm.address1.$error.md-maxlength\" \nng-message=\"md-maxlength\">That\'s too long address!</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Pincode</label><input type=\"text\" name=\"pincode\" ng-model=\"postJsonData.pincode\" \nng-change=\"getStateCityByPincode()\" ng-pattern=\"pinRegEx\" required><div \nng-messages=\"createRegisterForm.pincode.$error\" ng-if=\"createRegisterForm.pincode.$touched\"><div \nng-if=\"createRegisterForm.pincode.$error.required\" ng-message=\"required\">Pincode is required!</div><div \nng-if=\"createRegisterForm.pincode.$error.pattern\" ng-message=\"pattern\">Please Enter a <b>valid</b> pincode!</div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nng-show=\"!customJsonData.pincodeFlag && customJsonData.pincodeDataFlag\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>Choose State</label><md-select required md-input-name=\"stateDetailsfield\" \nng-model=\"postJsonData.state\" ng-model-options=\"{trackBy: \'$value.STATE_NAME\'}\" \nng-change=\"getCityByState(postJsonData.state)\"><md-option ng-repeat=\"x in stateData\" ng-value=\"x\">{{x.STATE_NAME}}\n</md-option></md-select><div ng-messages=\"createRegisterForm.stateDetailsfield.$error\" \nng-if=\"createRegisterForm.stateDetailsfield.$touched\"><div \nng-if=\"createRegisterForm.stateDetailsfield.$error.required\" ng-message=\"required\">Please <b>select</b> a state.</div>\n<div ng-if=\"createRegisterForm.stateDetailsfield.$error.md-require-match\" ng-message=\"md-require-match\">\nPlease select an existing state.</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Choose City</label><md-select required md-input-name=\"cityDetailsfield\" ng-model=\"postJsonData.city\" \nng-model-options=\"{trackBy: \'$value.CITY\'}\" ng-disabled=\"postJsonData.state.STATE_NAME.length===0\"><md-option \nng-repeat=\"x in cityData\" ng-value=\"x\">{{x.CITY}}</md-option></md-select><div \nng-messages=\"createRegisterForm.cityDetailsfield.$error\" ng-if=\"createRegisterForm.cityDetailsfield.$touched\"><div \nng-if=\"createRegisterForm.cityDetailsfield.$error.required\" ng-message=\"required\">Please <b>select</b> a city.</div>\n<div ng-if=\"createRegisterForm.cityDetailsfield.$error.md-require-match\" ng-message=\"md-require-match\">\nPlease select an existing city.</div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\" ng-show=\"customJsonData.pincodeFlag && !customJsonData.pincodeDataFlag\"><md-card \nmd-theme-watch style=\"width:100%\"><md-card-actions layout=\"row\" layout-align=\"end center\"><span class=\"nomineeIcon\" \nng-click=\"removePincodeDetails();\"><i class=\"fa fa-times-circle fa-2x\" aria-hidden=\"true\"></i></span></md-card-actions>\n<md-card-title style=\"padding-top:0px\"><div layout=\"row\" layout-xs=\"column\" style=\"width:100%\" class=\"paddingTopNo\">\n<div flex=\"50\" flex-gt-sm><h4 class=\"InvesterHeading\">State Name : {{pincodeData.stateName}}</h4></div><div flex=\"50\" \nflex-gt-sm><h4 class=\"InvesterHeading\">City Name : {{pincodeData.cityName}}</h4></div></div></md-card-title></md-card>\n</div><div layout=\"row\" layout-xs=\"column\" class=\"paddingTopNo\"><div flex-gt-sm><h4 class=\"InvesterHeading\"><b>\nNominee Details</b></h4></div><div flex-gt-sm><md-input-container class=\"md-block\" flex-gt-sm><md-checkbox \nclass=\"green\" ng-model=\"postJsonData.no_of_nominee\" ng-change=\"nomineAvailavleCheck(postJsonData.no_of_nominee)\">\nDo you want to nominant some one?</md-checkbox></md-input-container></div><div \nng-show=\"postJsonData.no_of_nomineeShow\" flex-gt-sm><md-input-container class=\"md-block\" flex-gt-sm><md-checkbox \nclass=\"green\" ng-model=\"postJsonData.nominee1_type\" ng-change=\"nomineMinor(postJsonData.nominee1_type)\">\nIs Nominee Minor?</md-checkbox></md-input-container></div></div><div layout-gt-sm=\"row\" layout-xs=\"column\" \nng-show=\"postJsonData.no_of_nomineeShow\"><md-input-container class=\"md-block\" flex-gt-sm><label>Name</label><input \ntype=\"text\" name=\"nominee1_name\" ng-model=\"postJsonData.nominee1_name\" ng-pattern=\"nameRegEx\" md-maxlength=\"50\" \nminlength=\"2\" required><div ng-messages=\"createRegisterForm.nominee1_name.$error\" \nng-if=\"createRegisterForm.nominee1_name.$touched\"><div ng-if=\"createRegisterForm.nominee1_name.$error.required\" \nng-message=\"required\">Nominee1 name is required!</div><div ng-if=\"createRegisterForm.nominee1_name.$error.pattern\" \nng-message=\"pattern\">Please Enter a <b>valid</b> name!</div><div \nng-if=\"createRegisterForm.nominee1_name.$error.minlength\" ng-message=\"minlength\">That\'s too short name!</div><div \nng-if=\"createRegisterForm.nominee1_name.$error.md-maxlength\" ng-message=\"md-maxlength\">That\'s too long!</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Relation</label><md-select \nng-model=\"postJsonData.nominee1_relation\" required name=\"nominee1_relation\"><md-option ng-repeat=\"x in relationArray\" \nng-value=\"x\"><div ng-bind-html=\"x\"></div></md-option></md-select><div \nng-messages=\"createRegisterForm.nominee1_relation.$error\" ng-if=\"createRegisterForm.nominee1_relation.$touched\"><div \nng-if=\"createRegisterForm.nominee1_relation.$error.required\" ng-message=\"required\">Nominee1 relation is required!</div>\n</div></md-input-container></div><div ng-show=\"postJsonData.nominee1_typeShow && postJsonData.no_of_nomineeShow\"><div \nlayout-gt-sm=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex-gt-sm><label>Nominee DOB</label><input \ntype=\"date\" ng-model=\"postJsonData.nominee1_dob\" name=\"nominee1_dob\" flex=\"33\" ng-max=\"maxDate\"><div \nng-messages=\"createRegisterForm.nominee1_dob.$error\" ng-if=\"createRegisterForm.nominee1_dob.$touched\"><div \nng-if=\"createRegisterForm.nominee1_dob.$error.required\" ng-message=\"required\">Date of birth is required!</div><div \nng-if=\"createRegisterForm.nominee1_dob.$error.max\" ng-message=\"max\">Date of birth can not be future date!</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Nominee Guardian Name</label><input \ntype=\"text\" name=\"nominee1_guard_name\" ng-model=\"postJsonData.nominee1_guard_name\" ng-pattern=\"nameRegEx\" \nmd-maxlength=\"50\" minlength=\"2\" required><div ng-messages=\"createRegisterForm.nominee1_guard_name.$error\" \nng-if=\"createRegisterForm.nominee1_guard_name.$touched\"><div \nng-if=\"createRegisterForm.nominee1_guard_name.$error.required\" ng-message=\"required\">Nominee Guardian name is required!\n</div><div ng-if=\"createRegisterForm.nominee1_guard_name.$error.pattern\" ng-message=\"pattern\">Please Enter a <b>valid\n</b> name!</div><div ng-if=\"createRegisterForm.nominee1_guard_name.$error.minlength\" ng-message=\"minlength\">\nThat\'s too short name!</div><div ng-if=\"createRegisterForm.nominee1_guard_name.$error.md-maxlength\" \nng-message=\"md-maxlength\">That\'s too long!</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Nominee Guardian PAN</label><input type=\"text\" name=\"nominee1_guard_pan\" \nng-model=\"postJsonData.nominee1_guard_pan\" ng-pattern=\"panRegEx\" required><div \nng-messages=\"createRegisterForm.nominee1_guard_pan.$error\" ng-if=\"createRegisterForm.nominee1_guard_pan.$touched\"><div \nng-if=\"createRegisterForm.nominee1_guard_pan.$error.required\" ng-message=\"required\">Guardian pan is required!</div><div\n ng-if=\"createRegisterForm.nominee1_guard_pan.$error.pattern\" ng-message=\"pattern\">Please Enter A Valid PAN Number\n</div></div></md-input-container></div></div><div layout-gt-sm=\"row\" layout-xs=\"column\" class=\"paddingTopNo\"><h4 \nclass=\"InvesterHeading\"><b>KYC</b></h4></div><div layout-gt-sm=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Applicant Income(Annual)</label><md-select ng-model=\"postJsonData.app_income\" \nrequired ng-model-options=\"{trackBy: \'$value.APP_INCOME_CODE\'}\"><md-option ng-repeat=\"x in applicableIncomeData\" \nng-value=\"x\">{{x.APP_INCOME_DESC}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Source Of Wealth</label><md-select ng-model=\"postJsonData.source_wealth\" required \nng-model-options=\"{trackBy: \'$value.CODE\'}\"><md-option ng-repeat=\"x in sourceWealthData\" ng-value=\"x\">\n{{x.SOURCE_OF_WEALTH}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-wrap flex=\"100\" \nlayout-align=\"center center\" ng-show=\"customJsonData.ekycIsDone\"><div class=\"destacados\"><div class=\"box1\"><h4>\nKYC is completed</h4></div></div></div></md-content></div></form><section layout=\"row\" layout-align=\"center center\" \nlayout-wrap><md-button type=\"button\" class=\"md-raised md-accent width-160\" tabindex=\"7\" \nng-click=\"goToStep($event, \'step2\')\" style=\"color:#fff !important\">Save &amp; Continue</md-button></section></div>\n</md-content>");
$templateCache.put("app/main/dashboard/reports/customer-investment-report/customer-investment-report.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg height-60\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"75\">\n<div class=\"h3\" layout=\"row\" layout-align=\"start center\" style=\"margin:0px\"><span style=\"font-size:18px\">\n{{vm.customers.productName}}</span></div><div class=\"product-count secondary-text margin-top-10\"><span>Total Investors:\n</span> <span>{{vm.customers.investors.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex=\"15\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input class=\"search-input\" type=\"text\" ng-model=\"search\" placeholder=\"Search\" flex></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"10\"><md-button class=\"backArrowColor\" back-button layout=\"row\" \nlayout-align=\"start center\" style=\"margin:0px\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"backArrowColor mr-8\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"ext-content\"><md-virtual-repeat-container \nng-style=\"listStyle\" fix-head><md-table-container><table md-table ng-model=\"vm.selected\" md-progress=\"promise\"><thead \nmd-head md-order=\"vm.query.order\"><tr md-row><th md-column><span>SNo.</span></th><th md-column md-order-by=\"userName\">\n<span class=\"text-center\">Name</span></th><th md-column md-order-by=\"email\"><span>Email</span></th><th md-column \nmd-order-by=\"mobileNo\"><span>Mobile</span></th><th md-column md-order-by=\"pan\"><span>PAN No.</span></th><th md-column \nmd-order-by=\"sipCount\"><span>No of SIP</span></th><th md-column md-order-by=\"sipAmount\"><span>SIP Amount</span></th><th\n md-column md-order-by=\"units\"><span>Units</span></th><th md-column md-order-by=\"value\"><span>Investment</span></th><th\n md-column md-order-by=\"currentValue\"><span>Current Value</span></th></tr></thead><tbody md-body><div \nclass=\"scrollable\" ms-scroll><tr md-row md-select=\"customer\" md-auto-select \nmd-virtual-repeat=\"customer in vm.customers.investors | filter:search | orderBy: vm.query.order\" \nng-click=\"vm.customerDetailFunction(customer)\" style=\"cursor:pointer\"><td md-cell>{{$index+1}}</td><td md-cell>\n{{customer.userName}}</td><td md-cell>{{customer.email}}</td><td md-cell>{{customer.mobileNo}}</td><td md-cell>\n{{customer.pan}}</td><td md-cell>{{customer.sipCount}}</td><td md-cell>{{customer.sipAmount |number:2}}</td><td \nmd-cell>{{customer.units |number:3}}</td><td md-cell>{{customer.value |number:2}}</td><td md-cell>\n{{customer.currentValue |number:3}}</td></tr></div></tbody></table></md-table-container></md-virtual-repeat-container>\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);